var By, kt = "colors", mi = "sizes", we = "space", OA = { gap: we, gridGap: we, columnGap: we, gridColumnGap: we, rowGap: we, gridRowGap: we, inset: we, insetBlock: we, insetBlockEnd: we, insetBlockStart: we, insetInline: we, insetInlineEnd: we, insetInlineStart: we, margin: we, marginTop: we, marginRight: we, marginBottom: we, marginLeft: we, marginBlock: we, marginBlockEnd: we, marginBlockStart: we, marginInline: we, marginInlineEnd: we, marginInlineStart: we, padding: we, paddingTop: we, paddingRight: we, paddingBottom: we, paddingLeft: we, paddingBlock: we, paddingBlockEnd: we, paddingBlockStart: we, paddingInline: we, paddingInlineEnd: we, paddingInlineStart: we, top: we, right: we, bottom: we, left: we, scrollMargin: we, scrollMarginTop: we, scrollMarginRight: we, scrollMarginBottom: we, scrollMarginLeft: we, scrollMarginX: we, scrollMarginY: we, scrollMarginBlock: we, scrollMarginBlockEnd: we, scrollMarginBlockStart: we, scrollMarginInline: we, scrollMarginInlineEnd: we, scrollMarginInlineStart: we, scrollPadding: we, scrollPaddingTop: we, scrollPaddingRight: we, scrollPaddingBottom: we, scrollPaddingLeft: we, scrollPaddingX: we, scrollPaddingY: we, scrollPaddingBlock: we, scrollPaddingBlockEnd: we, scrollPaddingBlockStart: we, scrollPaddingInline: we, scrollPaddingInlineEnd: we, scrollPaddingInlineStart: we, fontSize: "fontSizes", background: kt, backgroundColor: kt, backgroundImage: kt, borderImage: kt, border: kt, borderBlock: kt, borderBlockEnd: kt, borderBlockStart: kt, borderBottom: kt, borderBottomColor: kt, borderColor: kt, borderInline: kt, borderInlineEnd: kt, borderInlineStart: kt, borderLeft: kt, borderLeftColor: kt, borderRight: kt, borderRightColor: kt, borderTop: kt, borderTopColor: kt, caretColor: kt, color: kt, columnRuleColor: kt, fill: kt, outline: kt, outlineColor: kt, stroke: kt, textDecorationColor: kt, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: mi, minBlockSize: mi, maxBlockSize: mi, inlineSize: mi, minInlineSize: mi, maxInlineSize: mi, width: mi, minWidth: mi, maxWidth: mi, height: mi, minHeight: mi, maxHeight: mi, flexBasis: mi, gridTemplateColumns: mi, gridTemplateRows: mi, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, kA = (e, t) => typeof t == "function" ? { "()": Function.prototype.toString.call(t) } : t, wu = () => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, r, ...i) => {
    const n = ((a) => JSON.stringify(a, kA))(t);
    return n in e ? e[n] : e[n] = r(t, ...i);
  };
}, jd = Symbol.for("sxs.internal"), mh = (e, t) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), Vy = (e) => {
  for (const t in e)
    return !0;
  return !1;
}, { hasOwnProperty: FA } = Object.prototype, pf = (e) => e.includes("-") ? e : e.replace(/[A-Z]/g, (t) => "-" + t.toLowerCase()), xA = /\s+(?![^()]*\))/, ys = (e) => (t) => e(...typeof t == "string" ? String(t).split(xA) : [t]), jy = { appearance: (e) => ({ WebkitAppearance: e, appearance: e }), backfaceVisibility: (e) => ({ WebkitBackfaceVisibility: e, backfaceVisibility: e }), backdropFilter: (e) => ({ WebkitBackdropFilter: e, backdropFilter: e }), backgroundClip: (e) => ({ WebkitBackgroundClip: e, backgroundClip: e }), boxDecorationBreak: (e) => ({ WebkitBoxDecorationBreak: e, boxDecorationBreak: e }), clipPath: (e) => ({ WebkitClipPath: e, clipPath: e }), content: (e) => ({ content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"` }), hyphens: (e) => ({ WebkitHyphens: e, hyphens: e }), maskImage: (e) => ({ WebkitMaskImage: e, maskImage: e }), maskSize: (e) => ({ WebkitMaskSize: e, maskSize: e }), tabSize: (e) => ({ MozTabSize: e, tabSize: e }), textSizeAdjust: (e) => ({ WebkitTextSizeAdjust: e, textSizeAdjust: e }), userSelect: (e) => ({ WebkitUserSelect: e, userSelect: e }), marginBlock: ys((e, t) => ({ marginBlockStart: e, marginBlockEnd: t || e })), marginInline: ys((e, t) => ({ marginInlineStart: e, marginInlineEnd: t || e })), maxSize: ys((e, t) => ({ maxBlockSize: e, maxInlineSize: t || e })), minSize: ys((e, t) => ({ minBlockSize: e, minInlineSize: t || e })), paddingBlock: ys((e, t) => ({ paddingBlockStart: e, paddingBlockEnd: t || e })), paddingInline: ys((e, t) => ({ paddingInlineStart: e, paddingInlineEnd: t || e })) }, qm = /([\d.]+)([^]*)/, LA = (e, t) => e.length ? e.reduce((r, i) => (r.push(...t.map((n) => n.includes("&") ? n.replace(/&/g, /[ +>|~]/.test(i) && /&.*&/.test(n) ? `:is(${i})` : i) : i + " " + n)), r), []) : t, _A = (e, t) => e in BA && typeof t == "string" ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (r, i, n, a) => i + (n === "stretch" ? `-moz-available${a};${pf(e)}:${i}-webkit-fill-available` : `-moz-fit-content${a};${pf(e)}:${i}fit-content`) + a) : String(t), BA = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, fa = (e) => e ? e + "-" : "", mv = (e, t, r) => e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (i, n, a, o, s) => o == "$" == !!a ? i : (n || o == "--" ? "calc(" : "") + "var(--" + (o === "$" ? fa(t) + (s.includes("$") ? "" : fa(r)) + s.replace(/\$/g, "-") : s) + ")" + (n || o == "--" ? "*" + (n || "") + (a || "1") + ")" : "")), VA = /\s*,\s*(?![^()]*\))/, jA = Object.prototype.toString, Ts = (e, t, r, i, n) => {
  let a, o, s;
  const c = (u, d, p) => {
    let l, m;
    const f = (h) => {
      for (l in h) {
        const y = l.charCodeAt(0) === 64, U = y && Array.isArray(h[l]) ? h[l] : [h[l]];
        for (m of U) {
          const S = /[A-Z]/.test(I = l) ? I : I.replace(/-[^]/g, (w) => w[1].toUpperCase()), D = typeof m == "object" && m && m.toString === jA && (!i.utils[S] || !d.length);
          if (S in i.utils && !D) {
            const w = i.utils[S];
            if (w !== o) {
              o = w, f(w(m)), o = null;
              continue;
            }
          } else if (S in jy) {
            const w = jy[S];
            if (w !== s) {
              s = w, f(w(m)), s = null;
              continue;
            }
          }
          if (y && (g = l.slice(1) in i.media ? "@media " + i.media[l.slice(1)] : l, l = g.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (w, v, P, b, T, R) => {
            const M = qm.test(v), E = 0.0625 * (M ? -1 : 1), [C, A] = M ? [b, v] : [v, b];
            return "(" + (P[0] === "=" ? "" : P[0] === ">" === M ? "max-" : "min-") + C + ":" + (P[0] !== "=" && P.length === 1 ? A.replace(qm, (N, O, k) => Number(O) + E * (P === ">" ? 1 : -1) + k) : A) + (T ? ") and (" + (T[0] === ">" ? "min-" : "max-") + C + ":" + (T.length === 1 ? R.replace(qm, (N, O, k) => Number(O) + E * (T === ">" ? -1 : 1) + k) : R) : "") + ")";
          })), D) {
            const w = y ? p.concat(l) : [...p], v = y ? [...d] : LA(d, l.split(VA));
            a !== void 0 && n(Gy(...a)), a = void 0, c(m, v, w);
          } else
            a === void 0 && (a = [[], d, p]), l = y || l.charCodeAt(0) !== 36 ? l : `--${fa(i.prefix)}${l.slice(1).replace(/\$/g, "-")}`, m = D ? m : typeof m == "number" ? m && S in GA ? String(m) + "px" : String(m) : mv(_A(S, m ?? ""), i.prefix, i.themeMap[S]), a[0].push(`${y ? `${l} ` : `${pf(l)}:`}${m}`);
        }
      }
      var g, I;
    };
    f(u), a !== void 0 && n(Gy(...a)), a = void 0;
  };
  c(e, t, r);
}, Gy = (e, t, r) => `${r.map((i) => `${i}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, GA = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, $y = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97)), vo = (e) => ((t) => {
  let r, i = "";
  for (r = Math.abs(t); r > 52; r = r / 52 | 0)
    i = $y(r % 52) + i;
  return $y(r % 52) + i;
})(((t, r) => {
  let i = r.length;
  for (; i; )
    t = 33 * t ^ r.charCodeAt(--i);
  return t;
})(5381, JSON.stringify(e)) >>> 0), xc = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], $A = (e) => {
  if (e.href && !e.href.startsWith(location.origin))
    return !1;
  try {
    return !!e.cssRules;
  } catch {
    return !1;
  }
}, qA = (e) => {
  let t;
  const r = () => {
    const { cssRules: n } = t.sheet;
    return [].map.call(n, (a, o) => {
      const { cssText: s } = a;
      let c = "";
      if (s.startsWith("--sxs"))
        return "";
      if (n[o - 1] && (c = n[o - 1].cssText).startsWith("--sxs")) {
        if (!a.cssRules.length)
          return "";
        for (const u in t.rules)
          if (t.rules[u].group === a)
            return `--sxs{--sxs:${[...t.rules[u].cache].join(" ")}}${s}`;
        return a.cssRules.length ? `${c}${s}` : "";
      }
      return s;
    }).join("");
  }, i = () => {
    if (t) {
      const { rules: s, sheet: c } = t;
      if (!c.deleteRule) {
        for (; Object(Object(c.cssRules)[0]).type === 3; )
          c.cssRules.splice(0, 1);
        c.cssRules = [];
      }
      for (const u in s)
        delete s[u];
    }
    const n = Object(e).styleSheets || [];
    for (const s of n)
      if ($A(s)) {
        for (let c = 0, u = s.cssRules; u[c]; ++c) {
          const d = Object(u[c]);
          if (d.type !== 1)
            continue;
          const p = Object(u[c + 1]);
          if (p.type !== 4)
            continue;
          ++c;
          const { cssText: l } = d;
          if (!l.startsWith("--sxs"))
            continue;
          const m = l.slice(14, -3).trim().split(/\s+/), f = xc[m[0]];
          f && (t || (t = { sheet: s, reset: i, rules: {}, toString: r }), t.rules[f] = { group: p, index: c, cache: new Set(m) });
        }
        if (t)
          break;
      }
    if (!t) {
      const s = (c, u) => ({ type: u, cssRules: [], insertRule(d, p) {
        this.cssRules.splice(p, 0, s(d, { import: 3, undefined: 1 }[(d.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return c === "@media{}" ? `@media{${[].map.call(this.cssRules, (d) => d.cssText).join("")}}` : c;
      } });
      t = { sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : s("", "text/css"), rules: {}, reset: i, toString: r };
    }
    const { sheet: a, rules: o } = t;
    for (let s = xc.length - 1; s >= 0; --s) {
      const c = xc[s];
      if (!o[c]) {
        const u = xc[s + 1], d = o[u] ? o[u].index : a.cssRules.length;
        a.insertRule("@media{}", d), a.insertRule(`--sxs{--sxs:${s}}`, d), o[c] = { group: a.cssRules[d + 1], index: d, cache: /* @__PURE__ */ new Set([s]) };
      }
      WA(o[c]);
    }
  };
  return i(), t;
}, WA = (e) => {
  const t = e.group;
  let r = t.cssRules.length;
  e.apply = (i) => {
    try {
      t.insertRule(i, r), ++r;
    } catch {
    }
  };
}, Fc = Symbol(), HA = wu(), zA = (e, t) => HA(e, () => (...r) => {
  let i = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const n of r)
    if (n != null)
      if (n[jd]) {
        i.type == null && (i.type = n[jd].type);
        for (const a of n[jd].composers)
          i.composers.add(a);
      } else
        n.constructor !== Object || n.$$typeof ? i.type == null && (i.type = n) : i.composers.add(YA(n, e));
  return i.type == null && (i.type = "span"), i.composers.size || i.composers.add(["PJLV", {}, [], [], {}, []]), KA(e, i, t);
}), YA = ({ variants: e, compoundVariants: t, defaultVariants: r, ...i }, n) => {
  const a = `${fa(n.prefix)}c-${vo(i)}`, o = [], s = [], c = /* @__PURE__ */ Object.create(null), u = [];
  for (const l in r)
    c[l] = String(r[l]);
  if (typeof e == "object" && e)
    for (const l in e) {
      d = c, p = l, FA.call(d, p) || (c[l] = "undefined");
      const m = e[l];
      for (const f in m) {
        const h = { [l]: String(f) };
        String(f) === "undefined" && u.push(l);
        const g = m[f], I = [h, g, !Vy(g)];
        o.push(I);
      }
    }
  var d, p;
  if (typeof t == "object" && t)
    for (const l of t) {
      let { css: m, ...f } = l;
      m = typeof m == "object" && m || {};
      for (const g in f)
        f[g] = String(f[g]);
      const h = [f, m, !Vy(m)];
      s.push(h);
    }
  return [a, i, o, s, c, u];
}, KA = (e, t, r) => {
  const [i, n, a, o] = QA(t.composers), s = typeof t.type == "function" || t.type.$$typeof ? ((p) => {
    function l() {
      for (let m = 0; m < l[Fc].length; m++) {
        const [f, h] = l[Fc][m];
        p.rules[f].apply(h);
      }
      return l[Fc] = [], null;
    }
    return l[Fc] = [], l.rules = {}, xc.forEach((m) => l.rules[m] = { apply: (f) => l[Fc].push([m, f]) }), l;
  })(r) : null, c = (s || r).rules, u = `.${i}${n.length > 1 ? `:where(.${n.slice(1).join(".")})` : ""}`, d = (p) => {
    p = typeof p == "object" && p || JA;
    const { css: l, ...m } = p, f = {};
    for (const I in a)
      if (delete m[I], I in p) {
        let y = p[I];
        typeof y == "object" && y ? f[I] = { "@initial": a[I], ...y } : (y = String(y), f[I] = y !== "undefined" || o.has(I) ? y : a[I]);
      } else
        f[I] = a[I];
    const h = /* @__PURE__ */ new Set([...n]);
    for (const [I, y, U, S] of t.composers) {
      r.rules.styled.cache.has(I) || (r.rules.styled.cache.add(I), Ts(y, [`.${I}`], [], e, (v) => {
        c.styled.apply(v);
      }));
      const D = qy(U, f, e.media), w = qy(S, f, e.media, !0);
      for (const v of D)
        if (v !== void 0)
          for (const [P, b, T] of v) {
            const R = `${I}-${vo(b)}-${P}`;
            h.add(R);
            const M = (T ? r.rules.resonevar : r.rules.onevar).cache, E = T ? c.resonevar : c.onevar;
            M.has(R) || (M.add(R), Ts(b, [`.${R}`], [], e, (C) => {
              E.apply(C);
            }));
          }
      for (const v of w)
        if (v !== void 0)
          for (const [P, b] of v) {
            const T = `${I}-${vo(b)}-${P}`;
            h.add(T), r.rules.allvar.cache.has(T) || (r.rules.allvar.cache.add(T), Ts(b, [`.${T}`], [], e, (R) => {
              c.allvar.apply(R);
            }));
          }
    }
    if (typeof l == "object" && l) {
      const I = `${i}-i${vo(l)}-css`;
      h.add(I), r.rules.inline.cache.has(I) || (r.rules.inline.cache.add(I), Ts(l, [`.${I}`], [], e, (y) => {
        c.inline.apply(y);
      }));
    }
    for (const I of String(p.className || "").trim().split(/\s+/))
      I && h.add(I);
    const g = m.className = [...h].join(" ");
    return { type: t.type, className: g, selector: u, props: m, toString: () => g, deferredInjector: s };
  };
  return mh(d, { className: i, selector: u, [jd]: t, toString: () => (r.rules.styled.cache.has(i) || d(), i) });
}, QA = (e) => {
  let t = "";
  const r = [], i = {}, n = [];
  for (const [a, , , , o, s] of e) {
    t === "" && (t = a), r.push(a), n.push(...s);
    for (const c in o) {
      const u = o[c];
      (i[c] === void 0 || u !== "undefined" || s.includes(u)) && (i[c] = u);
    }
  }
  return [t, r, i, new Set(n)];
}, qy = (e, t, r, i) => {
  const n = [];
  e:
    for (let [a, o, s] of e) {
      if (s)
        continue;
      let c, u = 0, d = !1;
      for (c in a) {
        const p = a[c];
        let l = t[c];
        if (l !== p) {
          if (typeof l != "object" || !l)
            continue e;
          {
            let m, f, h = 0;
            for (const g in l) {
              if (p === String(l[g])) {
                if (g !== "@initial") {
                  const I = g.slice(1);
                  (f = f || []).push(I in r ? r[I] : g.replace(/^@media ?/, "")), d = !0;
                }
                u += h, m = !0;
              }
              ++h;
            }
            if (f && f.length && (o = { ["@media " + f.join(", ")]: o }), !m)
              continue e;
          }
        }
      }
      (n[u] = n[u] || []).push([i ? "cv" : `${c}-${a[c]}`, o, d]);
    }
  return n;
}, JA = {}, XA = wu(), ZA = (e, t) => XA(e, () => (...r) => {
  const i = () => {
    for (let n of r) {
      n = typeof n == "object" && n || {};
      let a = vo(n);
      if (!t.rules.global.cache.has(a)) {
        if (t.rules.global.cache.add(a), "@import" in n) {
          let o = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
          for (let s of [].concat(n["@import"]))
            s = s.includes('"') || s.includes("'") ? s : `"${s}"`, t.sheet.insertRule(`@import ${s};`, o++);
          delete n["@import"];
        }
        Ts(n, [], [], e, (o) => {
          t.rules.global.apply(o);
        });
      }
    }
    return "";
  };
  return mh(i, { toString: i });
}), eE = wu(), tE = (e, t) => eE(e, () => (r) => {
  const i = `${fa(e.prefix)}k-${vo(r)}`, n = () => {
    if (!t.rules.global.cache.has(i)) {
      t.rules.global.cache.add(i);
      const a = [];
      Ts(r, [], [], e, (s) => a.push(s));
      const o = `@keyframes ${i}{${a.join("")}}`;
      t.rules.global.apply(o);
    }
    return i;
  };
  return mh(n, { get name() {
    return n();
  }, toString: n });
}), rE = class {
  constructor(e, t, r, i) {
    this.token = e == null ? "" : String(e), this.value = t == null ? "" : String(t), this.scale = r == null ? "" : String(r), this.prefix = i == null ? "" : String(i);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + fa(this.prefix) + fa(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, iE = wu(), nE = (e, t) => iE(e, () => (r, i) => {
  i = typeof r == "object" && r || Object(i);
  const n = `.${r = (r = typeof r == "string" ? r : "") || `${fa(e.prefix)}t-${vo(i)}`}`, a = {}, o = [];
  for (const c in i) {
    a[c] = {};
    for (const u in i[c]) {
      const d = `--${fa(e.prefix)}${c}-${u}`, p = mv(String(i[c][u]), e.prefix, c);
      a[c][u] = new rE(u, p, c, e.prefix), o.push(`${d}:${p}`);
    }
  }
  const s = () => {
    if (o.length && !t.rules.themed.cache.has(r)) {
      t.rules.themed.cache.add(r);
      const c = `${i === e.theme ? ":root," : ""}.${r}{${o.join(";")}}`;
      t.rules.themed.apply(c);
    }
    return r;
  };
  return { ...a, get className() {
    return s();
  }, selector: n, toString: s };
}), aE = wu(), fv = (e) => {
  let t = !1;
  const r = aE(e, (i) => {
    t = !0;
    const n = "prefix" in (i = typeof i == "object" && i || {}) ? String(i.prefix) : "", a = typeof i.media == "object" && i.media || {}, o = typeof i.root == "object" ? i.root || null : globalThis.document || null, s = typeof i.theme == "object" && i.theme || {}, c = { prefix: n, media: a, theme: s, themeMap: typeof i.themeMap == "object" && i.themeMap || { ...OA }, utils: typeof i.utils == "object" && i.utils || {} }, u = qA(o), d = { css: zA(c, u), globalCss: ZA(c, u), keyframes: tE(c, u), createTheme: nE(c, u), reset() {
      u.reset(), d.theme.toString();
    }, theme: {}, sheet: u, config: c, prefix: n, getCssText: u.toString, toString: u.toString };
    return String(d.theme = d.createTheme(s)), d;
  });
  return t || r.reset(), r;
}, oE = () => By || (By = fv()), Qe = (...e) => oE().css(...e);
function sE({ variant: e }) {
  return Qe({
    margin: "2.5px 0",
    variants: {
      variant: {
        showAddress: {
          lineHeight: "2.3em"
        }
      }
    }
  })({ variant: e });
}
const cE = Qe({
  justifyContent: "flex-start",
  alignItems: "center",
  whiteSpace: "nowrap",
  fontWeight: 500,
  display: "flex"
}), uE = Qe({
  textTransform: "$participant$textTransform",
  // marginInlineStart: "$space$2",
  // marginInlineEnd: "$space$2",
  fontSize: "0.875rem",
  fontWeight: 500,
  variants: {
    variant: {
      winner: {
        fontWeight: 700,
        color: "$winnerName"
      },
      loser: {
        fontWeight: 500
      }
    }
  }
}), dE = Qe({
  "&::WebkitScrollbar": { display: "none" },
  justifyContent: "space-between",
  flexDirection: "column",
  marginInlineEnd: "0rem",
  scrollbarWidth: "none",
  overflowX: "scroll",
  fontWeight: 500,
  display: "flex",
  width: "100%",
  variants: {
    variant: {
      doubles: {
        marginTop: "0.25rem",
        fontSize: "0.75rem",
        lineHeight: "1rem"
      }
    }
  }
});
function lE({ drawPosition: e, sideNumber: t }) {
  return Qe({
    minHeight: "$participant$minHeight",
    justifyContent: "space-between",
    paddingInlineStart: "0.75rem",
    backgroundColor: "$matchUp",
    paddingInlineEnd: "0rem",
    boxSizing: "border-box",
    paddingBottom: ".2rem",
    position: "relative",
    alignItems: "center",
    paddingTop: ".2rem",
    minWidth: "15rem",
    cursor: "pointer",
    display: "flex",
    flexGrow: 1,
    "& p": {
      fontFamily: "Sharp Sans, Arial, sans-serif",
      color: "$color"
    },
    variants: {
      sideNumber: {
        1: { borderBottom: "1px solid $internalDividers" }
      }
    }
  })({
    sideNumber: t,
    css: e && {
      "&:before": {
        backgroundColor: "$backgroundColor",
        content: `${e}`,
        justifyContent: "center",
        alignContent: "center",
        insetInlineStart: -10,
        position: "absolute",
        color: "#55AFFE",
        display: "flex",
        width: 20
      }
    }
  });
}
function pE({ winnerChevron: e, isDoubles: t }) {
  const r = (t ? 0.4 : 0.3) * 2;
  return Qe({
    variants: {
      variant: {
        winner: {
          "&::before": {
            borderTop: `${r}rem solid transparent`,
            borderBottom: `${r}rem solid transparent`,
            borderInlineStart: "8px solid #008f70",
            position: "absolute",
            insetInlineStart: 0,
            display: "block",
            content: ""
          }
        }
      }
    }
  })({ variant: e ? "winner" : void 0 });
}
const fh = Qe({
  fontSize: "smaller",
  color: "gray"
});
var mE = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function hv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gv = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var a = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (a = n(a, i(s)));
      }
      return a;
    }
    function i(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return r.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var o = "";
      for (var s in a)
        t.call(a, s) && a[s] && (o = n(o, s));
      return o;
    }
    function n(a, o) {
      return o ? a ? a + " " + o : a + o : a;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(gv);
var fE = gv.exports;
const io = /* @__PURE__ */ hv(fE);
function hE({ individualParticipant: e, className: t }) {
  var s, c;
  const { city: r, state: i, countryCode: n } = ((c = (s = e == null ? void 0 : e.person) == null ? void 0 : s.addresses) == null ? void 0 : c[0]) || {}, a = [r, i, n].filter(Boolean).join(", ") || " ", o = document.createElement("div");
  return o.className = io(fh(), t), o.innerHTML = a, o;
}
const gE = Qe({
  willChange: "opacity",
  position: "fixed",
  zIndex: 9998,
  bottom: 0,
  right: 0,
  left: 0,
  top: 0
}), IE = Qe({
  display: "block"
}), UE = Qe({
  position: "fixed",
  right: 0,
  left: 0
}), yE = Qe({
  paddingRight: "15px",
  alignItems: "center",
  margin: "30px auto",
  paddingLeft: "15px",
  position: "fixed",
  height: "100vh",
  display: "flex",
  width: "100%",
  zIndex: 9999,
  bottom: 0,
  right: 0,
  left: 0,
  top: 0
}), SE = Qe({
  boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)",
  backgroundColor: "white",
  position: "relative",
  borderRadius: "3px",
  minHeight: "auto",
  width: "100%"
}), vE = Qe({
  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  alignItems: "center",
  position: "relative",
  display: "flex"
}), wE = Qe({
  fontWeight: "600",
  fontSize: "20px"
}), Wy = Qe({
  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  justifyContent: "right",
  alignItems: "center",
  position: "relative",
  display: "flex"
}), Hy = "Nothing to see here";
function zi(e) {
  return typeof e == "function";
}
function Gd(e) {
  return typeof e == "string";
}
function zy(e) {
  return Array.isArray(e);
}
function Wm(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function PE(e) {
  if (e)
    for (; e.firstChild; )
      e.removeChild(e.firstChild);
}
const Yy = (() => {
  const e = UE(), t = {}, r = ".5";
  let i = [], n, a = [], o = [], s;
  const c = (g) => {
    if (g) {
      let I;
      o = o.filter((y) => (y.id === g && (I = y), y.id !== g)), I && document.body.removeChild(I);
    } else {
      const I = o.pop();
      I && document.body.removeChild(I);
    }
  }, u = () => {
    s && (s.style.opacity = 0, s.style.display = "none");
  }, d = (g) => {
    const I = o.length;
    if (g && t[I] === !1)
      return;
    const y = a.pop(), U = i.pop();
    zi(y) && y({ content: U }), document.body.classList.remove(e), document.body.style.top = null, window.scrollTo({
      top: n,
      behavior: "instant"
    }), u(), c();
  }, p = () => {
    s = document.createElement("div"), s.className = gE(), s.id = "cmdl-backdrop", s.onclick = () => d(!0), document.body.appendChild(s);
  }, l = ({ config: g }) => {
    n = window.scrollY, document.body.classList.add(e), document.body.style.top = `-${n}px`, s || p(), s.style.display = "", (g == null ? void 0 : g.backdrop) !== !1 && (s.style.backgroundColor = "rgba(0, 0, 0, 0.2)", s.style.transition = "opacity 0.15s linear", s.style.opacity = 1);
  }, m = ({ config: g, attr: I, attrs: y, unit: U = "em", value: S }) => {
    var w;
    let D;
    return Gd(I) ? D = mf({ element: g, attr: I }) : zy(y) && (D = (w = y.map((v) => mf({ element: g, attr: v })).filter(Boolean)) == null ? void 0 : w[0]), D !== void 0 && (S = D), isNaN(S) ? S : `${S}${U}`;
  }, f = ({ buttons: g, config: I, modalNumber: y }) => {
    var D, w;
    const U = document.createElement("div");
    U.className = Wy(), U.style.padding = m({ config: I, attrs: ["footer.padding", "padding"], value: r });
    const S = {
      label: ((D = I == null ? void 0 : I.dictionary) == null ? void 0 : D.close) || "Close",
      onClick: Yy.close,
      intent: "is-info"
    };
    for (const v of g) {
      if (v.hide)
        continue;
      const P = { ...S };
      Wm(v) && Object.assign(P, v);
      const b = document.createElement("button");
      P.disabled !== void 0 && (b.disabled = P.disabled), P.id && (b.id = P.id), b.className = ((w = P == null ? void 0 : P.footer) == null ? void 0 : w.className) || "button font-medium", b.classList.add(P.intent), b.style = "margin-right: .5em;", b.innerHTML = P.label || P.text, b.onclick = (T) => {
        T.stopPropagation(), zi(P.onClick) && P.onClick({ e: T, content: i[y] }), P.close !== !1 && (zi(P.close) && P.close(), Yy.close());
      }, U.appendChild(b);
    }
    return U;
  };
  return { close: d, open: ({ title: g = "", content: I, buttons: y, footer: U, config: S, onClose: D } = {}) => {
    l({ config: S }), a.push(D);
    const w = o.length + 1;
    t[w] = S == null ? void 0 : S.clickAway;
    const v = document.createElement("section"), P = `cmdl-${w}`;
    v.className = IE(), v.role = "dialog", v.tabIndex = -1, v.id = P;
    const b = document.createElement("div");
    b.className = yE(), b.style.maxWidth = `${(S == null ? void 0 : S.maxWidth) || 450}px`, b.onclick = () => d(!0);
    const T = document.createElement("div");
    T.className = SE(), T.onclick = (x) => x.stopPropagation();
    const R = document.createElement("div"), M = document.createElement("div");
    R.appendChild(M), T.appendChild(R);
    const E = ({ title: x, config: _ }) => {
      R.className = x ? vE() : "", R.style.padding = m({ config: _, attrs: ["title.padding", "padding"], value: r }), M.className = x ? wE() : "", M.innerHTML = x;
    };
    g && E({ title: g });
    const C = document.createElement("div");
    T.appendChild(C);
    const A = ({ content: x, config: _ }) => {
      C.style.fontSize = m({ config: _, attr: "fontSize", value: "15px" }), C.style.position = "relative", C.style.padding = m({ config: _, attrs: ["content.padding", "padding"], value: r }), zi(x) ? i[w] = x(C) : Wm(x) ? C.appendChild(x) : Gd(x) ? C.innerHTML = x : C.innerHTML = Hy;
    };
    if (A({ content: I, config: S }), zy(y))
      U = f({ buttons: y, config: S, modalNumber: w }), T.appendChild(U);
    else if (U) {
      const x = document.createElement("div");
      x.className = Wy(), x.style.padding = m({ config: S, attrs: ["footer.padding", "padding"] }), Wm(U) ? x.appendChild(U) : Gd(U) ? x.innerHTML = U : x.innerHTML = Hy, T.appendChild(x);
    }
    b.appendChild(T), v.appendChild(b), document.body.appendChild(v), o.push(v);
    const N = ({ content: x, config: _ }) => {
      i[w] = void 0, PE(C), A({ content: x, config: _ });
    }, O = ({ buttons: x, config: _ }) => {
      T.removeChild(U), U = f({ buttons: x, config: _, modalNumber: w }), T.appendChild(U);
    }, k = ({ onClose: x }) => {
      a.length = 0, a.push(x);
    };
    return { setContent: N, setButtons: O, update: ({ content: x, buttons: _, title: B, config: L, onClose: G }) => {
      S = L || S, x && N({ content: x, config: S }), _ && O({ buttons: _, config: S }), G && k({ onClose: G }), B && E({ title: B, config: S });
    } };
  } };
})();
function mf({ element: e, attr: t }) {
  if (!Gd(t))
    return;
  const r = t.split(".");
  for (const i of r)
    if (e = e == null ? void 0 : e[i], !e)
      return;
  return e;
}
function DE({ individualParticipant: e, attribute: t, className: r }) {
  const i = e == null ? void 0 : e.person, n = mf({ element: i, attr: t });
  if (!n)
    return;
  const a = document.createElement("div");
  return a.className = io(fh(), r), a.innerHTML = n, a;
}
function TE({ individualParticipant: e, className: t }) {
  var a;
  const r = (a = e == null ? void 0 : e.teams) == null ? void 0 : a[0], i = (r == null ? void 0 : r.participantName) || " ", n = document.createElement("div");
  return n.className = io(fh(), t), n.classList.add("tmx-tm"), n.setAttribute("id", r == null ? void 0 : r.participantId), n.innerHTML = i, n;
}
function bE(e) {
  var n, a, o, s;
  const t = (a = (n = e == null ? void 0 : e.composition) == null ? void 0 : n.configuration) == null ? void 0 : a.participantDetail;
  if (t === "TEAM")
    return TE(e);
  if (((s = (o = e == null ? void 0 : e.composition) == null ? void 0 : o.configuration) == null ? void 0 : s.showAddress) ?? t === "ADDRESS")
    return hE(e);
  if (t) {
    const c = DE({ ...e, attribute: t });
    if (c)
      return c;
  }
  return document.createElement("div");
}
const RE = Qe({
  color: "$participant$seed",
  marginInlineStart: ".5rem",
  textTransform: "uppercase",
  fontSize: "0.75rem",
  lineHeight: "1rem"
});
function ME({ className: e, composition: t, side: r }) {
  const i = (r == null ? void 0 : r.seedValue) === "~" ? "" : (r == null ? void 0 : r.seedValue) !== void 0 && r.seedValue || (r == null ? void 0 : r.seedNumber);
  if (!i)
    return "";
  const n = (t == null ? void 0 : t.configuration) || {}, { bracketedSeeds: a } = n, o = typeof a == "boolean" && ["(", ")"] || a === "square" && ["[", "]"] || ["", ""], s = `${o[0]}${i}${o[1]}`, c = n.seedingElement === "sup" ? "sup" : "span", u = document.createElement(c);
  return u.className = e, u.innerHTML = s, u;
}
const NE = Qe({
  WebkitBoxSizing: "border-box",
  marginInlineEnd: ".5em",
  boxSizing: "border-box",
  display: "inline-block",
  position: "relative",
  fontSize: "smaller",
  fontWeight: "bold",
  borderRadius: 2,
  // width: '1.8rem',
  color: "blue",
  variants: {
    color: {
      green: {
        color: "green"
      },
      red: {
        color: "red"
      }
    }
  }
});
function AE({ individualParticipant: e, composition: t, className: r, matchUp: i, spacer: n }) {
  var w, v, P, b, T, R, M;
  const a = t == null ? void 0 : t.configuration, o = ((w = a == null ? void 0 : a.scaleAttributes) == null ? void 0 : w.eventType) || (i == null ? void 0 : i.matchUpType) || "SINGLES", s = e == null ? void 0 : e.rankings, c = e == null ? void 0 : e.ratings, u = a == null ? void 0 : a.scaleAttributes, d = u == null ? void 0 : u.scaleType, p = u == null ? void 0 : u.scaleName, l = u == null ? void 0 : u.accessor, m = d === "RATING" ? c : s, f = (P = (v = m == null ? void 0 : m.SINGLES) == null ? void 0 : v.find((E) => (E == null ? void 0 : E.scaleName) === p)) == null ? void 0 : P.scaleValue, h = (T = (b = m == null ? void 0 : m.DOUBLES) == null ? void 0 : b.find((E) => (E == null ? void 0 : E.scaleName) === p)) == null ? void 0 : T.scaleValue, g = f && l ? f[l] : f || "", I = h && l ? h[l] : h || "", y = o === "SINGLES" ? g : I, U = (R = a == null ? void 0 : a.scaleAttributes) == null ? void 0 : R.fallback, S = !n && (y || U && (g || I)), D = document.createElement("span");
  return S && (D.className = io(r, NE({ color: (M = a == null ? void 0 : a.scaleAttributes) == null ? void 0 : M.scaleColor }))), D.innerHTML = S || "", D;
}
var EE = Object.defineProperty, Ae = (e, t) => {
  for (var r in t)
    EE(e, r, { get: t[r], enumerable: !0 });
};
function Vl() {
  return "2.1.29";
}
var Iv = {};
Ae(Iv, { competitionGovernor: () => Uv, drawsGovernor: () => pD, entriesGovernor: () => PM, eventGovernor: () => AM, generationGovernor: () => zM, matchUpFormatGovernor: () => nN, matchUpGovernor: () => aN, mocksGovernor: () => ly, participantGovernor: () => XN, policyGovernor: () => KR, publishingGovernor: () => v0, queryGovernor: () => eM, reportGovernor: () => A0, scheduleGovernor: () => E0, scoreGovernor: () => QI, tieFormatGovernor: () => $0, tournamentGovernor: () => X0, venueGovernor: () => lA });
var Uv = {};
Ae(Uv, { getLinkedTournamentIds: () => Bu, getTournamentIds: () => Lu, linkTournaments: () => cD, mutate: () => yv, query: () => lD, unlinkTournament: () => dD, unlinkTournaments: () => uD });
var yv = {};
Ae(yv, { linkTournaments: () => cD, unlinkTournament: () => dD, unlinkTournaments: () => uD });
var wo = "SINGLES", rt = "SINGLES", Ga = "DOUBLES", tt = "DOUBLES", ni = "TEAM", lt = "TEAM", CE = { SINGLES_MATCHUP: wo, SINGLES: rt, DOUBLES_MATCHUP: Ga, DOUBLES: tt, TEAM_MATCHUP: ni, TEAM: lt }, Sv = { [rt]: [rt, "S"], [tt]: [tt, "D"], [lt]: [lt, "T"], S: [rt, "S"], D: [tt, "D"], T: [lt, "T"] };
function Ft(e, t) {
  return (e ?? 0) - (t ?? 0);
}
function ye(e) {
  return typeof e == "number" ? parseInt(e.toString()) : typeof e == "string" ? parseInt(e) : 0;
}
function Qi(e) {
  return isNaN(e) ? !1 : e && (e & e - 1) === 0;
}
function Ky(e) {
  if (!e.length)
    return;
  let t = [...e].sort(Ft), r = Math.floor(t.length / 2);
  return t.length % 2 ? t[r] : (t[r - 1] + t[r]) / 2;
}
function OE(e) {
  if (!Qi(e))
    return !1;
  let t = e, r = 1;
  for (; t !== 2; )
    r += 1, t = t / 2;
  return r;
}
function hh(e) {
  return isNaN(e) ? 0 : e % 2 && e + 1 || e;
}
function gh(e) {
  return Math.pow(2, Math.round(Math.log(e) / Math.log(2)));
}
function St(e) {
  return !isNaN(parseFloat(e));
}
function vv(e) {
  let t = ye(e);
  if (!isNaN(t))
    return t === 0 ? !1 : (t & -t) === 1;
}
function tc(e) {
  if (isNaN(e))
    return !1;
  for (; !Qi(e); )
    e++;
  return e;
}
function fi(e, t) {
  return e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e;
}
function Pe(e) {
  return Number.isSafeInteger(typeof e == "string" ? +e : e);
}
function kE(e = 1, t = 3, r = !0) {
  let i = 0;
  for (let n = 0; n < t; n++)
    i += Math.random() * (e / t);
  return r && e > 1 ? Math.round(i) : i;
}
function FE(e, t) {
  t || (t = 1);
  let r = 1 / t;
  return Math.round(e * r) / r;
}
function wv(e, t, r, i, n = 2) {
  let a = 1 - Math.random(), o = 1 - Math.random(), s = Math.sqrt(-2 * Math.log(a)) * Math.cos(2 * Math.PI * o);
  return s = s / 10 + 0.5, s > 1 || s < 0 ? s = wv(e, t, r) : (s = Math.pow(s, r), s *= t - e, s += e), i && (s = FE(s, i)), parseFloat(s.toFixed(n));
}
function nl(e, t = 2) {
  return parseFloat(Number(Math.round(e * 1e3) / 1e3).toFixed(t));
}
function Te(e) {
  return Array.isArray(e) ? e == null ? void 0 : e.filter((t, r, i) => i.lastIndexOf(t) === r) : [];
}
function xE(e) {
  return Array.isArray(e) ? e == null ? void 0 : e.map((t) => t === null ? void 0 : t) : e;
}
function yr(e) {
  return Array.isArray(e) ? e.map((t) => [Math.random(), t]).sort((t, r) => t[0] - r[0]).map((t) => t[1]) : [];
}
function Es(e) {
  return Pe(e) ? e : 1 / 0;
}
function Qr(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] || (t[r] = 0), t[r]++, t), {}) : {};
}
function LE(e) {
  return Pv(Qr(e));
}
function Pv(e) {
  return Object.keys(e).reduce((t, r) => {
    let i = e[r];
    return t[i] ? t[i].push(r) : t[i] = [r], t;
  }, {});
}
function _E(e, t, r) {
  return r.indexOf(e) === t;
}
function Dv(e) {
  return e.filter(_E);
}
function zr(e) {
  return Array.isArray(e) && e.length ? e.splice(Math.floor(Math.random() * e.length), 1)[0] : void 0;
}
function Wr(e) {
  let t = Math.floor(Math.random() * e.length);
  return e[t];
}
function oe(e, t) {
  return Array.from({ length: t - e }, (r, i) => i + e);
}
function an(e, t) {
  return t.reduce((r, i, n) => (i === e && r.push(n), r), []);
}
function wt(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? [] : e.filter((r) => t.indexOf(r) !== -1).filter((r, i, n) => n.indexOf(r) === i);
}
function Qy(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? [] : e.filter((r) => !t.includes(r));
}
function wr(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? !1 : e.some((r) => t.includes(r));
}
function BE(e, t) {
  return Array.isArray(t) && t.reduce((r, i) => (r[i] = 1 + r[i] || 1, r), {})[e] || 0;
}
function VE(e, t, r, i) {
  return Array.isArray(e) ? [].concat(...e.slice(0, t), ...e.slice(t, t + r).sort(i), ...e.slice(t + r, e.length)) : [];
}
function zt(e, t) {
  return Array.isArray(e) ? e.reduce((r, i, n) => {
    let a = Math.floor(n / t);
    return r[a] = [].concat(r[a] || [], i), r;
  }, []) : [];
}
function Tv(e, [t, ...r]) {
  return e.length ? [e.slice(0, t), ...Tv(e.slice(t), [...r, t])] : [];
}
function jE(e) {
  return e.reduce((t, r) => {
    let i = t[t.length - 1];
    return (!i || i[i.length - 1] !== r - 1) && t.push([]), t[t.length - 1].push(r), t;
  }, []);
}
function bv(e) {
  return Array.isArray(e) ? e.reduce((t, r) => !isNaN(parseInt(r)) && t, !0) : !1;
}
function Rv(e) {
  return Array.isArray(e) ? e.reduce((t, r) => isNaN(parseInt(r)) && t, !0) : !1;
}
function ff(e, t, r) {
  return Array.isArray(e) ? e.reduce((i, n, a) => {
    let o = r ? !!(Math.floor(a / t) % 2) : !1, s = a % t, c = o ? t - 1 - s : s;
    return i[c] || (i[c] = []), i[c].push(n), i;
  }, []) : [];
}
function GE(e, t = 1) {
  if (!Array.isArray(e) || !e.every(Pe))
    return [];
  let r = Math.min(...e, t), i = Math.max(...e);
  return oe(r, i + 1).filter((n) => !e.includes(n));
}
function Hr(e) {
  return typeof e == "function";
}
function ht(e) {
  return typeof e == "string";
}
function Le(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function $E(e, t) {
  if (!Le(e) || !Le(t))
    return !1;
  let r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  for (let n of r)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Mv(e, t) {
  return Array.isArray(e) ? Object.assign({}, ...(e ?? []).filter(Le).map((r) => r[t] && { [r[t]]: r }).filter(Boolean)) : {};
}
var qE = (e) => (t) => Object.keys(e).every((r) => t[r] === e[r]);
function hf(e, t) {
  if (e === void 0)
    return null;
  if (!Le(e) || e === null)
    return e;
  let r = Object.keys(e), i = (n) => n === void 0 ? null : n;
  return Object.assign({}, ...r.map((n) => Array.isArray(e[n]) ? { [n]: t ? e[n] : e[n].map((a) => hf(a)) } : { [n]: t ? i(e[n]) : hf(e[n]) }));
}
function gf(e) {
  return Array.isArray(e) ? e.length + e.map(gf).reduce((t, r) => t + r, 0) : Le(e) && e !== null ? Object.keys(e).length + Object.keys(e).map((t) => gf(e[t])).reduce((t, r) => t + r, 0) : 0;
}
function WE(e) {
  if (e === null || typeof e != "object")
    return;
  let t = JSON.stringify(e), r = gf(e), i = t.split("").reduce((n, a) => n + a.charCodeAt(0), 0);
  return [t.length, r, i].map((n) => n.toString(36)).join("");
}
function jl(e, t) {
  return !Array.isArray(e) || !ht(t) ? !1 : wt(e, Sv[t]).length;
}
var V = { success: !0 }, Nv = "error", HE = { SUCCESS: V, ERROR: Nv };
function Av({ collectionValueProfiles: e, matchUpCount: t }) {
  let r = [];
  if (!Array.isArray(e))
    return r.push(`collectionValueProfiles is not an array: ${e}`), { errors: r };
  if (e.length && e.length !== t)
    return r.push("collectionValueProfiles do not align with matchUpsCount"), { errors: r };
  for (let n of e) {
    if (typeof n != "object")
      return r.push(`valueProfile is not type object: ${n}`), { errors: r };
    let { matchUpValue: a, collectionPosition: o } = n;
    if (typeof a != "number" || typeof o != "number" || o > t || o < 1)
      return r.push("Invalid value profile: value and collectionPosition must be numeric. collectionPosition cannot be greater than matchUpCount"), { errors: r };
  }
  let i = e.map((n) => n.collectionPosition);
  return i.length !== Te(i).length ? (r.push("collectionPositions are not unique"), { errors: r }) : { ...V };
}
var zE = {};
Ae(zE, { addNotice: () => De, callListener: () => bf, createInstanceState: () => MC, cycleMutationStatus: () => Wh, deepCopyEnabled: () => qh, deleteNotice: () => Hh, deleteNotices: () => Mu, disableNotifications: () => jw, enableNotifications: () => Wd, getDevContext: () => oi, getMethods: () => qw, getNotices: () => Ww, getProvider: () => Rf, getTopics: () => vi, getTournamentId: () => Yo, getTournamentRecord: () => zh, getTournamentRecords: () => Ko, globalLog: () => Yw, handleCaughtError: () => np, hasTopic: () => rp, removeTournamentRecord: () => zw, setDeepCopy: () => Qc, setDevContext: () => Kc, setGlobalLog: () => Vw, setGlobalMethods: () => Gw, setGlobalSubscriptions: () => AC, setMethods: () => $w, setStateMethods: () => Kw, setStateProvider: () => RC, setSubscriptions: () => EC, setTournamentId: () => Jc, setTournamentRecord: () => Hw, setTournamentRecords: () => ip, timeKeeper: () => NC });
var If = { message: "Chronological error; time violation.", code: "ANACHRONISM" }, zc = { message: "Duplicate entry", code: "DUPLICATE_ENTRY" }, Ev = { message: "Cannot remove main structure", code: "ERR_CANNOT_REMOVE_MAIN_STRUCTURE" }, Uf = { message: "records must be an object with tournamentId keys", code: "ERR_INVALID_TOURNAMENTS" }, yt = { message: "Missing tournamentRecords", code: "ERR_MISSING_TOURNAMENTS" }, ae = { message: "Missing tournamentRecord", code: "ERR_MISSING_TOURNAMENT" }, Pu = { message: "Invalid tournamentRecord", code: "ERR_INVALID_TOURNAMENT" }, Cs = { message: "Missing tournamentId", code: "ERR_MISSING_TOURNAMENT_ID" }, Po = { message: "Invalid drawDefinition", code: "ERR_INVALID_DRAWDEF" }, le = { message: "Missing drawDefinition", code: "ERR_MISSING_DRAWDEF" }, Cv = { message: "Existing drawDefinition(s)", code: "ERR_EXISTING_DRAWDEFS" }, ai = { message: "drawDefinition not found", code: "ERR_NOT_FOUND_DRAWDEF" }, no = { message: "Invalid structure", code: "ERR_INVALID_STRUCTURE" }, Ih = { message: "Incomplete source structure", code: "ERR_INCOMPLETE_STRUCTURE" }, Uh = { message: "Invalid drawPosition for seedAssignment", code: "ERR_INVALID_SEEDING_POSITION" }, Os = { message: "drawPosition already assigned", code: "ERR_EXISTING_POSITION_ASSIGNMENT" }, Ov = { message: "Schedule not cleared", code: "ERR_UNCHANGED_SCHEDULE_NOT_CLEARED" }, kv = { message: "drawPosition not cleared", code: "ERR_FAILURE_POSITION_NOT_CLEARED" }, YE = { message: "drawPosition not found", code: "ERR_NOT_FOUND_DRAW_POSITION" }, yh = { message: "Unrecognized drawType", code: "ERR_UNRECOGNIZED_DRAW_TYPE" }, Du = { message: "Missing drawPositions", code: "ERR_MISSING_DRAW_POSITIONS" }, Gl = { message: "drawPosition is active", code: "ERR_ACTIVE_DRAW_POSITION" }, KE = { message: "drawPosition is occupied", code: "ERR_OCCUPIED_DRAW_POSITION" }, rc = { message: "Invlid drawPosition", code: "ERR_INVALID_DRAW_POSITION" }, ic = { message: "Missing drawPosition", code: "ERR_MISSING_DRAW_POSITION" }, Sh = { message: "Invalid drawType", code: "ERR_INVALID_DRAW_TYPE" }, $l = { message: "Invalid drawSize", code: "ERR_INVALID_DRAW_SIZE" }, vh = { message: "Cannot set drawSize to be less than existing entries", code: "ERR_INVALID_DRAW_SIZE_MISMATCH" }, Tu = { message: "Missing drawSize", code: "ERR_MISSING_DRAW_SIZE" }, tn = { message: "Missing drawId", code: "ERR_MISSING_DRAW_ID" }, Fv = { message: "drawId exists", code: "ERR_EXISTING_DRAW_ID" }, xv = { message: "participantId cannot be assigned to multiple seedNumbers", code: "INVALID_PARTICIPANT_SEEDING" }, Lv = { message: "seedsCount greater than drawSize", code: "ERR_INVALID_SEED_COUNT" }, _v = { message: "Missing seedCountThresholds", code: "ERR_MISSING_SEED_COUNT_THRESHOLD" }, Bv = { message: "Invalid action", code: "ERR_INVALID_ACTION" }, yf = { message: "Invalid assignment", code: "ERR_INVALID_ASSIGNMENT" }, Vv = { message: "Missing seedAssignments", code: "ERR_MISSING_SEED_ASSIGNMENTS" }, jv = { message: "Invalid seedNumber", code: "ERR_INVALID_SEED_NUMBER" }, Gv = { message: "Invalid seedPosition", code: "ERR_INVALID_SEED_POSITION" }, wh = { message: "Missing targetLink", code: "ERR_MISSING_LINK_TARGET" }, $v = { message: "Existing round", code: "ERR_EXISTING_ROUND" }, QE = { message: "Missing roundNumber", code: "ERR_MISSING_ROUND_NUMBER" }, ui = { message: "Missing structureId", code: "ERR_MISSING_STRUCTURE_ID" }, It = { message: "structure not found", code: "ERR_NOT_FOUND_STRUCTURE" }, Ph = { message: "Missing structures", code: "ERR_MISSING_STRUCTURES" }, ao = { message: "Missing structure", code: "ERR_MISSING_STRUCTURE" }, qv = { message: "drawDefinition contains unlinked structures", code: "ERR_MISSING_STRUCTURE_LINKS" }, Mn = { message: "Invalid eventType", code: "ERR_INVALID_EVENT_TYPE" }, pt = { message: "Missing event / eventId", code: "ERR_MISSING_EVENT_ID" }, Ii = { message: "Event not found", code: "ERR_NOT_FOUND_EVENT" }, Wv = { message: "Event exists", code: "ERR_EXISTING_EVENT" }, Hv = { message: "Missing entries", code: "ERR_MISSING_ENTRIES" }, zv = { message: "Invalid entries", code: "ERR_INVALID_ENTRIES" }, Dh = { message: "Missing assignments", code: "ERR_MISSING_ASSIGNMENTS" }, Yv = { message: "Missing stage", code: "ERR_MISSING_STAGE" }, oo = { message: "Invalid stage", code: "ERR_INVALID_STAGE" }, Kv = { message: "stageSequence limit", code: "ERR_LIMIT_STAGE_SEQUENCE" }, Qv = { message: "Missing positionAssignments", code: "ERR_MISSING_POSITION_ASSIGNMENTS" }, Jv = { message: "Cannot Assign BYE status if no assignment: { bye: true }", code: "ERR_UNCHANGED_CANNOT_ASSIGN_BYE" }, Sf = { message: "Unrecognized matchUpStatus", code: "ERR_UNRECOGNIZED_MATCHUP_STATUS" }, bu = { message: "Unrecognized matchUpFormat", code: "ERR_UNRECOGNIZED_MATCHUP_FORMAT" }, $d = { message: "Incompatible matchUpStatus", code: "ERR_INCOMPATIBLE_MATCHUP_STATUS" }, nc = { message: "Invalid matchUpStatus", code: "ERR_INVALID_MATCHUP_STATUS" }, wn = { message: "Invalid tieFormat", code: "ERR_INVALID_TIE_FORMAT" }, Th = { message: "Invalid matchUpFormat", code: "ERR_INVALID_MATCHUP_FORMAT" }, bh = { message: "Missing matchUpFormat", code: "ERR_MISSING_MATCHUP_FORMAT" }, Xv = { message: "Missing collectionDefinition", code: "ERR_MISSING_COLLECTION_DEFINITION" }, ac = { message: "Missing tieFormat", code: "ERR_MISSING_TIE_FORMAT" }, Ur = { message: "Missing matchUpId", code: "ERR_MISSING_MATCHUP_ID" }, $o = { message: "Missing matchUpIds", code: "ERR_MISSING_MATCHUP_IDS" }, hr = { message: "matchUp not found", code: "ERR_NOT_FOUND_MATCHUP" }, Zn = { message: "Missing matchUps", code: "ERR_MISSING_MATCHUPS" }, Vr = { message: "Missing matchUp", code: "ERR_MISSING_MATCHUP" }, jr = { message: "Invalid matchUp", code: "ERR_INVALID_MATCHUP" }, Rh = { message: "Missing policyType", code: "ERR_MISSING_POLICY_TYPE" }, ql = { message: "Missing policyDefinitions", code: "ERR_MISSING_POLICY_DEFINITIONS" }, JE = { message: "Missing seeding policy", code: "ERR_MISSING_POLICY_SEEDING" }, Zv = { message: "Missing avoidance policy", code: "ERR_MISSING_POLICY_AVOIDANCE" }, Mh = { message: "Missing policy attributes", code: "ERR_MISSING_POLICY_ATTRIBUTES" }, ew = { message: "Invalid policyDefinitions", code: "ERR_INVALID_POLICY_DEFINITIONS" }, Nh = { message: "existing policyType", code: "ERR_EXISTING_POLICY_TYPE" }, XE = { message: "Policy not attached", code: "ERR_FAILURE_POLICY_NOT_ATTACHED" }, Do = { message: "Policy not found", code: "ERR_NOT_FOUND_POLICY" }, ZE = { message: "Missing scoring policy / matchUpFormats", code: "ERR_MISSING_POLICY_SCORING_MATCHUP_FORMATS" }, Ah = { message: "Invalid sideNumber", code: "ERR_INVALID_SIDE_NUMBER" }, eC = { message: "Invalid setNumber", code: "ERR_INVALID_SET_NUMBER" }, Wl = { message: "Missing setObject", code: "ERR_MISSING_SET_ATTRIBUTE" }, tC = { message: "Missing setNumber", code: "ERR_MISSING_SET_NUMBER" }, rC = { message: "Missing sideNumber", code: "ERR_MISSING_SIDE_NUMBER" }, qo = { message: "Missing courtId", code: "ERR_MISSING_COURT_ID" }, Ie = { message: "Missing value", code: "ERR_MISSING_VALUE" }, tw = { message: "Missing birthdate", code: "ERR_MISSING_BIRTH_DATE" }, rw = { message: "Missing date", code: "ERR_MISSING_DATE" }, iw = { message: "No valid dates", code: "ERR_NO_VALID_DATES" }, al = { message: "Invalid bookings", code: "ERR_INVALID_BOOKINGS" }, qd = { message: "Invalid dateAvailability", code: "ERR_INVALID_DATE_AVAILABILITY" }, nw = { message: "Missing dateAvailability", code: "ERR_MISSING_DATE_AVAILABILITY" }, Qt = { message: "Invalid Date", code: "ERR_INVALID_DATE" }, Ri = { message: "Invalid time", code: "ERR_INVALID_TIME" }, aw = { message: "Invalid tournament dates", code: "ERR_INVALID_DATES_TOURNAMENT" }, vf = { message: "Invalid game scores", code: "ERR_INVALID_SCORES_GAME" }, ow = { message: "Invalid score", code: "ERR_INVALID_SCORE" }, Hl = { message: "Invalid winningSide", code: "ERR_INVALID_WINNING_SIDE" }, iC = { message: "No participants generated", code: "ERR_NO_PARTICIPANTS_GENERATED" }, Eh = { message: "Cannot modify tieFormat", code: "ERR_UNCHANGED_CANNOT_MODIFY_TIEFORMAT" }, sw = { message: "Cannot modify participantType", code: "ERR_UNCHANGED_CANNOT_MODIFY_PARTICIPANT_TYPE" }, zl = { message: "Cannot remove participants", code: "ERR_UNCHANGED_CANNOT_REMOVE_PARTICIPANTS" }, wf = { message: "Participant category mismatch", code: "ERR_CATEGORY_MISMATCH" }, Yl = { message: "Cannot change winningSide", code: "ERR_UNCHANGED_CANNOT_CHANGE_WINNING_SIDE" }, Wo = { message: "Invalid participant", code: "ERR_INVALID_PARTICIPANT" }, Ji = { message: "Invalid participantId", code: "ERR_INVALID_PARTICIPANT_ID" }, Yr = { message: "Invalid participantIds", code: "ERR_INVALID_PARTICIPANT_IDS" }, cw = { message: "Invalid participantRole", code: "ERR_INVALID_PARTICIPANT_ROLE" }, Xi = { message: "Invalid participantType", code: "ERR_INVALID_PARTICIPANT_TYPE" }, uw = { message: "Missing participantRole", code: "ERR_MISSING_PARTICIPANT_ROLE" }, Ho = { message: "Missing participant", code: "ERR_MISSING_PARTICIPANT" }, Ru = { message: "Missing participants", code: "ERR_MISSING_PARTICIPANTS" }, _t = { message: "Missing participantId", code: "ERR_MISSING_PARTICIPANT_ID" }, Dt = { message: "Participant Not Found", code: "ERR_NOT_FOUND_PARTICIPANT" }, dw = { message: "participantId exists", code: "ERR_EXISTING_PARTICIPANT_ID" }, nC = { message: "participant pair exists", code: "ERR_EXISTING_PARTICIPANT_PAIR" }, lw = { message: "No participant removed", code: "ERR_UNCHANGED_NO_PARTICIPANT_REMOVED" }, Da = { message: "Missing participantIds", code: "ERR_MISSING_PARTICIPANT_IDS" }, pw = { message: "Missing participantsCount", code: "ERR_MISSING_PARTICIPANT_COUNT" }, mw = { message: "Participant not checked in", code: "ERR_UNCHANGED_PARTICIPANT_NOT_CHECKED_IN" }, fw = { message: "Missing person details", code: "ERR_MISSING_PERSON_DETAILS" }, oc = { message: "Existing participant drawPosition assignment", code: "ERR_EXISTING_PARTICIPANT_DRAW_POSITION_ASSIGNMENT" }, Kl = { message: "Existing participant", code: "ERR_EXISTING_PARTICIPANT" }, Ch = { message: "participantsCount exceeds drawSize", code: "ERR_INVALID_PARTICIPANT_COUNT" }, Pf = { message: "Invalid entry status", code: "ERR_INVALID_ENTRY_STATUS" }, hw = { message: "Participant Entry Not Found", code: "ERR_NOT_FOUND_PARTICIPANT_ENTRY" }, aC = { message: "Participant not entered in stage", code: "ERR_UNCHANGED_PARTICIPANT_NOT_ENTERED" }, oC = { message: "Participant not found in stageSequence", code: "ERR_NOT_FOUND_PARTICIPANT_IN_STAGE" }, gw = { message: "entryStatus not allowed in stage", code: "ERR_INVALID_ENTRY_STATUS_IN_STAGE" }, Iw = { message: "entryStatus not allowed for event", code: "ERR_INVALID_ENTRY_STATUS_IN_EVENT" }, Df = { message: "No stage space available for entryStatus", code: "ERR_UNCHANGED_NO_AVAILABLE_STAGE_SPACE" }, Uw = { message: "Insufficient drawPositions to accommodate qualifiers", code: "ERR_UNCHANGED_NO_DRAW_POSITIONS_FOR_QUALIFIERS" }, Oh = { message: "Insufficient drawPositions to accommodate entries", code: "ERR_INSUFFICIENT_DRAW_POSITIONS" }, yw = { message: "Missing penaltyType", code: "ERR_MISSING_PENALTY_TYPE" }, kh = { message: "Missing penaltyId", code: "ERR_MISSING_PENALTY_ID" }, ks = { message: "Penalty not found", code: "ERR_NOT_FOUND_PENALTY" }, Sw = { message: "Missing courtsCount/courtNames", code: "ERR_MISSING_COURTS_INFO" }, sc = { message: "Court not found", code: "ERR_NOT_FOUND_COURT" }, vw = { message: "Court exists", code: "ERR_EXISTING_COURT" }, ww = { message: "Venue exists", code: "ERR_EXISTING_VENUE" }, zo = { message: "Venue not found", code: "ERR_NOT_FOUND_VENUE" }, Ta = { message: "Missing venueId", code: "ERR_MISSING_VENUE_ID" }, Pw = { message: "Invalid endTime", code: "ERR_INVALID_END_TIME" }, Fh = { message: "Existing endTime", code: "ERR_EXISTING_END_TIME" }, Dw = { message: "Invalid stopTime", code: "ERR_INVALID_STOP_TIME" }, Tw = { message: "Invalid startTime", code: "ERR_INVALID_START_TIME" }, sC = { message: "Invalid resumeTime", code: "ERR_INVALID_RESUME_TIME" }, xh = { message: "Invalid timeItem", code: "ERR_INVALID_TIME_ITEMS" }, bw = { message: "Missing async state provider", code: "ERR_MISSING_ASYNC_STATE_PROVIDER" }, Lh = { message: "Missing timeItem", code: "ERR_MISSING_TIME_ITEM" }, _h = { message: "Missing timeItems", code: "ERR_MISSING_TIME_ITEMS" }, Ql = { message: "Missing context", code: "ERR_MISSING_CONTEXT" }, Rw = { message: "Missing schedule", code: "ERR_MISSING_SCHEDULE" }, Co = { message: "Invalid scaleItem", code: "ERR_INVALID_SCALE_ITEM" }, Mw = { message: "Modifications failed", code: "ERR_FAILURE_MODIFICATIONS" }, cc = { message: "No modifications applied", code: "ERR_UNCHANGED_NO_MODIFICATIONS_APPLIED" }, Nw = { message: "Unable to assign court", code: "ERR_UNCHANGED_COURT_NOT_ASSIGNED" }, Jl = { message: "No Candidates", code: "ERR_UNCHANGED_NO_CANDIDATES" }, Aw = { message: "Invalid configuration", code: "ERR_INVALID_CONFIG" }, Ew = { message: "Invalid collectionDefinition", code: "ERR_INVALID_COLLECTION_DEFINITION" }, ea = { message: "Invalid object", code: "ERR_INVALID_OBJECT" }, _c = { message: "Invalid gender", code: "ERR_INVALID_GENDER" }, Yc = { message: "Invalid category", code: "ERR_INVALID_CATEGORY" }, J = { message: "Invalid values", code: "ERR_INVALID_VALUES" }, Cw = { message: "Duplicate value", code: "ERR_DUPLICATE_VALUE" }, Bh = { message: "Team not found", code: "ERR_NOT_FOUND_TEAM" }, Ow = { message: "No valid actions", code: "ERR_NO_VALID_ACTIONS" }, Xl = { message: "No valid attributes", code: "ERR_NO_VALID_ATTRIBUTES" }, Vh = { message: "Value unchanged", code: "ABORT_UNCHANGED" }, Zt = { message: "Not found", code: "ERR_NOT_FOUND" }, Zl = { message: "Not implemented", code: "ERR_NOT_IMPLEMENTED" }, kw = { message: "Existing flight", code: "ERR_EXISTING_FLIGHT" }, jh = { message: "Existing flight profile", code: "ERR_EXISTING_FLIGHT_PROFILE" }, Fw = { message: "Existing outcome", code: "ERR_EXISTING_OUTCOME" }, xw = { message: "Existing matchUpId", code: "ERR_EXISTING_MATCHUP_ID" }, Tf = { message: "Existing stage", code: "ERR_EXISTING_STAGE" }, Gh = { message: "Existing structure", code: "ERR_EXISTING_STRUCTURE" }, ep = { message: "Method not found", code: "ERR_NOT_FOUND_METHOD" }, Lw = { message: "Scheduled matchUps", code: "ERR_SCHEDULED_MATCHUPS" }, tp = { message: "Scores present", code: "ERR_SCORES_PRESENT" }, cC = { ANACHRONISM: If, CANNOT_CHANGE_WINNING_SIDE: Yl, CANNOT_MODIFY_TIEFORMAT: Eh, CANNOT_MODIFY_PARTICIPANT_TYPE: sw, CANNOT_REMOVE_MAIN_STRUCTURE: Ev, CANNOT_REMOVE_PARTICIPANTS: zl, CATEGORY_MISMATCH: wf, COURT_EXISTS: vw, COURT_NOT_FOUND: sc, DRAW_DEFINITION_NOT_FOUND: ai, DRAW_ID_EXISTS: Fv, DRAW_POSITION_ACTIVE: Gl, DRAW_POSITION_ASSIGNED: Os, DRAW_POSITION_NOT_CLEARED: kv, DRAW_POSITION_NOT_FOUND: YE, DRAW_SIZE_MISMATCH: vh, DUPLICATE_ENTRY: zc, DUPLICATE_VALUE: Cw, ENTRY_STATUS_NOT_ALLOWED_FOR_EVENT: Iw, ENTRY_STATUS_NOT_ALLOWED_IN_STAGE: gw, EVENT_EXISTS: Wv, EVENT_NOT_FOUND: Ii, EXISTING_DRAW_DEFINITIONS: Cv, EXISTING_END_TIME: Fh, EXISTING_FLIGHT: kw, EXISTING_MATCHUP_ID: xw, EXISTING_OUTCOME: Fw, EXISTING_PARTICIPANT_DRAW_POSITION_ASSIGNMENT: oc, EXISTING_PARTICIPANT: Kl, EXISTING_POLICY_TYPE: Nh, EXISTING_PROFILE: jh, EXISTING_ROUND: $v, EXISTING_STAGE: Tf, EXISTING_STRUCTURE: Gh, INCOMPATIBLE_MATCHUP_STATUS: $d, INCOMPLETE_SOURCE_STRUCTURE: Ih, INSUFFICIENT_DRAW_POSITIONS: Oh, INVALID_ACTION: Bv, INVALID_ASSIGNMENT: yf, INVALID_BOOKINGS: al, INVALID_CATEGORY: Yc, INVALID_COLLECTION_DEFINITION: Ew, INVALID_CONFIGURATION: Aw, INVALID_DATE_AVAILABILITY: qd, INVALID_DATE: Qt, INVALID_DRAW_DEFINITION: Po, INVALID_DRAW_POSITION_FOR_SEEDING: Uh, INVALID_DRAW_POSITION: rc, INVALID_DRAW_SIZE: $l, INVALID_END_TIME: Pw, INVALID_ENTRIES: zv, INVALID_EVENT_TYPE: Mn, INVALID_GAME_SCORES: vf, INVALID_GENDER: _c, INVALID_MATCHUP_FORMAT: Th, INVALID_MATCHUP_STATUS: nc, INVALID_MATCHUP_STATUS_BYE: Jv, INVALID_MATCHUP: jr, INVALID_OBJECT: ea, INVALID_PARTICIPANT_ID: Ji, INVALID_PARTICIPANT_IDS: Yr, INVALID_PARTICIPANT_ROLE: cw, INVALID_PARTICIPANT_SEEDING: xv, INVALID_PARTICIPANT_TYPE: Xi, INVALID_PARTICIPANT: Wo, INVALID_POLICY_DEFINITION: ew, INVALID_RECORDS: Uf, INVALID_SCALE_ITEM: Co, INVALID_SEED_NUMBER: jv, INVALID_SEED_POSITION: Gv, INVALID_SET_NUMBER: eC, INVALID_SIDE_NUMBER: Ah, INVALID_SCORE: ow, INVALID_STAGE: oo, INVALID_START_TIME: Tw, INVALID_STRUCTURE: no, INVALID_STOP_TIME: Dw, INVALID_TIE_FORMAT: wn, INVALID_TIME: Ri, INVALID_TIME_ITEM: xh, INVALID_TOURNAMENT_DATES: aw, INVALID_TOURNAMENT_RECORD: Pu, INVALID_VALUES: J, INVALID_WINNING_SIDE: Hl, MATCHUP_NOT_FOUND: hr, METHOD_NOT_FOUND: ep, MISSING_ASSIGNMENTS: Dh, MISSING_ASYNC_STATE_PROVIDER: bw, MISSING_AVOIDANCE_POLICY: Zv, MISSING_BIRTH_DATE: tw, MISSING_COLLECTION_DEFINITION: Xv, MISSING_COURT_ID: qo, MISSING_COURTS_INFO: Sw, MISSING_DATE_AVAILABILITY: nw, MISSING_DATE: rw, MISSING_DRAW_DEFINITION: le, MISSING_DRAW_ID: tn, MISSING_DRAW_POSITION: ic, MISSING_DRAW_POSITIONS: Du, MISSING_DRAW_SIZE: Tu, MISSING_ENTRIES: Hv, MISSING_EVENT: pt, MISSING_MATCHUP_FORMAT: bh, MISSING_MATCHUP_ID: Ur, MISSING_MATCHUP_IDS: $o, MISSING_MATCHUP: Vr, MISSING_MATCHUPS: Zn, MISSING_PARTICIPANT_COUNT: pw, MISSING_PARTICIPANT_ID: _t, MISSING_PARTICIPANT_IDS: Da, MISSING_PARTICIPANT_ROLE: uw, MISSING_PARTICIPANT: Ho, MISSING_PARTICIPANTS: Ru, MISSING_PENALTY_ID: kh, MISSING_PENALTY_TYPE: yw, MISSING_PERSON_DETAILS: fw, MISSING_POLICY_ATTRIBUTES: Mh, MISSING_POLICY_DEFINITION: ql, MISSING_POLICY_TYPE: Rh, MISSING_POSITION_ASSIGNMENTS: Qv, MISSING_ROUND_NUMBER: QE, MISSING_SCHEDULE: Rw, MISSING_SCORING_POLICY: ZE, MISSING_SEED_ASSIGNMENTS: Vv, MISSING_SEEDCOUNT_THRESHOLDS: _v, MISSING_SEEDING_POLICY: JE, MISSING_SET_NUMBER: tC, MISSING_SET_OBJECT: Wl, MISSING_SIDE_NUMBER: rC, MISSING_STAGE: Yv, MISSING_STRUCTURE_ID: ui, MISSING_STRUCTURE: ao, MISSING_STRUCTURES: Ph, MISSING_TARGET_LINK: wh, MISSING_TIE_FORMAT: ac, MISSING_TIME_ITEM: Lh, MISSING_TIME_ITEMS: _h, MISSING_TOURNAMENT_ID: Cs, MISSING_TOURNAMENT_RECORD: ae, MISSING_TOURNAMENT_RECORDS: yt, MISSING_VALUE: Ie, MISSING_VENUE_ID: Ta, MODIFICATIONS_FAILED: Mw, NO_CANDIDATES: Jl, NO_DRAW_POSITIONS_AVAILABLE_FOR_QUALIFIERS: Uw, NO_MODIFICATIONS_APPLIED: cc, NO_STAGE_SPACE_AVAILABLE_FOR_ENTRY_STATUS: Df, NO_PARTICIPANT_REMOVED: lw, NO_VALID_ACTIONS: Ow, NO_VALID_ATTRIBUTES: Xl, NO_VALID_DATES: iw, NOT_FOUND: Zt, NOT_IMPLEMENTED: Zl, PARTICIPANT_COUNT_EXCEEDS_DRAW_SIZE: Ch, PARTICIPANT_ID_EXISTS: dw, PARTICIPANT_NOT_CHECKED_IN: mw, PARTICIPANT_NOT_FOUND: Dt, PARTICIPANT_PAIR_EXISTS: nC, PENALTY_NOT_FOUND: ks, POLICY_NOT_ATTACHED: XE, POLICY_NOT_FOUND: Do, SCHEDULE_NOT_CLEARED: Ov, SCHEDULED_MATCHUPS: Lw, SCORES_PRESENT: tp, SEEDSCOUNT_GREATER_THAN_DRAW_SIZE: Lv, STAGE_SEQUENCE_LIMIT: Kv, STRUCTURE_NOT_FOUND: It, TEAM_NOT_FOUND: Bh, UNABLE_TO_ASSIGN_COURT: Nw, UNLINKED_STRUCTURES: qv, UNRECOGNIZED_DRAW_TYPE: yh, UNRECOGNIZED_MATCHUP_FORMAT: bu, UNRECOGNIZED_MATCHUP_STATUS: Sf, VALUE_UNCHANGED: Vh, VENUE_EXISTS: ww }, gt = { disableNotifications: !1, tournamentId: void 0, tournamentRecords: {}, subscriptions: {}, modified: !1, methods: {}, notices: [] }, _w = { addNotice: SC, callListener: TC, cycleMutationStatus: yC, deleteNotice: PC, deleteNotices: wC, disableNotifications: uC, enableNotifications: dC, getMethods: $h, getNotices: vC, getTopics: DC, getTournamentId: Bw, getTournamentRecord: lC, getTournamentRecords: pC, removeTournamentRecord: gC, setMethods: UC, setSubscriptions: IC, setTournamentId: fC, setTournamentRecord: mC, setTournamentRecords: hC, handleCaughtError: bC };
function uC() {
  gt.disableNotifications = !0;
}
function dC() {
  gt.disableNotifications = !1;
}
function Bw() {
  return gt.tournamentId;
}
function lC(e) {
  return gt.tournamentRecords[e];
}
function pC() {
  return gt.tournamentRecords;
}
function mC(e) {
  let t = e == null ? void 0 : e.tournamentId;
  return t ? (gt.tournamentRecords[t] = e, { success: !0 }) : { error: Pu };
}
function fC(e) {
  return e ? gt.tournamentRecords[e] ? (gt.tournamentId = e, { success: !0 }) : { error: ae } : (gt.tournamentId = void 0, { success: !0 });
}
function hC(e) {
  gt.tournamentRecords = e;
  let t = Object.keys(e);
  t.length === 1 ? gt.tournamentId = t[0] : t.length || (gt.tournamentId = void 0);
}
function gC(e) {
  if (typeof e != "string")
    return { error: J };
  if (!gt.tournamentRecords[e])
    return { error: Zt };
  delete gt.tournamentRecords[e];
  let t = Object.keys(gt.tournamentRecords);
  return t.length === 1 ? gt.tournamentId = t[0] : t.length || (gt.tournamentId = void 0), { success: !0 };
}
function IC(e) {
  return typeof e.subscriptions != "object" ? { error: J } : (Object.keys(e.subscriptions).forEach((t) => {
    typeof e.subscriptions[t] == "function" ? gt.subscriptions[t] = e.subscriptions[t] : delete gt.subscriptions[t];
  }), { ...V });
}
function UC(e) {
  return typeof e != "object" ? { error: J } : (Object.keys(e).forEach((t) => {
    typeof e[t] == "function" && (gt.methods[t] = e[t]);
  }), { ...V });
}
function yC() {
  let e = gt.modified;
  return gt.modified = !1, e;
}
function SC({ topic: e, payload: t, key: r }, i) {
  if (!(typeof e != "string" || typeof t != "object") && (gt.disableNotifications || (gt.modified = !0), !(gt.disableNotifications || !gt.subscriptions[e] && !i)))
    return r && (gt.notices = gt.notices.filter((n) => !(n.topic === e && n.key === r))), gt.notices.push({ topic: e, payload: t, key: r }), { ...V };
}
function $h() {
  return gt.methods ?? {};
}
function vC({ topic: e }) {
  return gt.notices.filter((t) => t.topic === e).map((t) => t.payload);
}
function wC() {
  gt.notices = [];
}
function PC({ topic: e, key: t }) {
  gt.notices = gt.notices.filter((r) => (!e || r.topic === e) && r.key !== t);
}
function DC() {
  return { topics: Object.keys(gt.subscriptions) };
}
function TC({ topic: e, notices: t }, r) {
  let i = gt.subscriptions[e];
  i && typeof i == "function" && i(t);
  let n = r == null ? void 0 : r[e];
  n && typeof n == "function" && n(t);
}
function bC({ engineName: e, methodName: t, params: r, err: i }) {
  let n;
  return typeof i == "string" ? n = i.toUpperCase() : i instanceof Error && (n = i.message), console.log("ERROR", { tournamentId: Bw(), params: JSON.stringify(r), engine: e, methodName: t, error: n }), { error: n };
}
var at = { timers: { default: { elapsedTime: 0 } }, globalSubscriptions: {}, deepCopyAttributes: { stringify: [], ignore: [], toJSON: [] }, globalMethods: [], deepCopy: !0 }, er = _w, Jy = ["addNotice", "callListener", "cycleMutationStatus", "deleteNotice", "deleteNotices", "disableNotifications", "enableNotifications", "getMethods", "getNotices", "getTopics", "getTournamentId", "getTournamentRecord", "getTournamentRecords", "removeTournamentRecord", "setSubscriptions", "setTournamentId", "setTournamentRecord", "setTournamentRecords"];
function RC(e) {
  if (typeof e != "object")
    throw new Error("Global state provider can not be undefined or null");
  if (wt(Object.keys(e), Jy).length !== Jy.length)
    throw new Error("Global state provider is missing required methods");
  return er = e, { success: !0 };
}
function MC() {
  if (er.createInstanceState) {
    try {
      er.createInstanceState();
    } catch (e) {
      return { error: e };
    }
    return { success: !0 };
  } else
    return { error: bw };
}
function oi(e) {
  return !e || typeof e != "object" ? at.devContext ?? !1 : typeof at.devContext != "object" ? !1 : Object.keys(e).every((t) => {
    var r;
    return ((r = at.devContext) == null ? void 0 : r[t]) === e[t];
  }) && at.devContext;
}
function NC(e = "reset", t = "default") {
  var i, n;
  let r = Date.now();
  if (e === "report") {
    if (t === "allTimers")
      return Object.keys(at.timers).filter((a) => a !== "default" || at.timers[a].startTime).map((a) => {
        let o = at.timers[a], s = o.state === "stopped" ? 0 : (r - ((o == null ? void 0 : o.startTime) ?? 0)) / 1e3, c = o.elapsedTime + s;
        return { state: at.timers[a].state, elapsedTime: c.toFixed(2), timer: a };
      });
    {
      let a = at.timers[t].state === "stopped" ? 0 : (r - (((i = at.timers[t]) == null ? void 0 : i.startTime) ?? 0)) / 1e3, o = at.timers[t].elapsedTime + a;
      return { state: at.timers[t].state, elapsedTime: o.toFixed(2), timer: t };
    }
  }
  if (!at.timers[t] || e === "reset") {
    if (t === "allTimers")
      return at.timers = { default: { elapsedTime: 0 } }, !0;
    at.timers[t] = { startTime: r, state: "active", elapsedTime: 0 };
  }
  return at.timers[t].elapsedTime || (at.timers[t].elapsedTime = 0), e === "stop" && at.timers[t].state !== "stopped" && (at.timers[t].state = "stopped") && (at.timers[t].elapsedTime += (r - (((n = at.timers[t]) == null ? void 0 : n.startTime) ?? 0)) / 1e3), e === "start" && (at.timers[t].startTime = r) && (at.timers[t].state = "active"), at.timers[t];
}
function Vw(e) {
  Hr(e) ? at.globalLog = e : delete at.globalLog;
}
function Kc(e) {
  at.devContext = e;
}
function jw() {
  er.disableNotifications();
}
function Wd() {
  er.enableNotifications();
}
function Qc(e, t) {
  typeof e == "boolean" && (at.deepCopy = e), typeof t == "object" && (Array.isArray(t.ignore) && (at.deepCopyAttributes.ignore = t.ignore), Array.isArray(t.toJSON) && (at.deepCopyAttributes.toJSON = t.toJSON), Array.isArray(t.stringify) && (at.deepCopyAttributes.stringify = t.stringify), t.threshold && (at.deepCopyAttributes.threshold = t.threshold));
}
function qh() {
  return { enabled: at.deepCopy, ...at.deepCopyAttributes };
}
function AC(e) {
  return e != null && e.subscriptions ? (Object.keys(e.subscriptions).forEach((t) => {
    at.globalSubscriptions[t] = e.subscriptions[t];
  }), { ...V }) : { error: Ie, info: "missing subscriptions" };
}
function EC(e) {
  return e != null && e.subscriptions ? er.setSubscriptions({ subscriptions: e.subscriptions }) : { error: Ie, info: "missing subscriptions" };
}
function Gw(e) {
  return e ? typeof e != "object" ? { error: J } : (Object.keys(e).forEach((t) => {
    Hr(e[t]) && (at.globalMethods[t] = e[t]);
  }), { ...V }) : { error: Ie, info: "missing method declarations" };
}
function $w(e) {
  return e ? typeof e != "object" ? { error: J } : er.setMethods(e) : { error: Ie, info: "missing method declarations" };
}
function Wh() {
  return er.cycleMutationStatus();
}
function De(e) {
  if (typeof (e == null ? void 0 : e.topic) != "string")
    return;
  let t = at.globalSubscriptions[e.topic];
  return er.addNotice(e, t);
}
function qw() {
  return { ...at.globalMethods, ...er.getMethods() };
}
function Ww(e) {
  return er.getNotices(e);
}
function Hh({ key: e, topic: t }) {
  return er.deleteNotice({ key: e, topic: t });
}
function Mu() {
  return er.deleteNotices();
}
function vi() {
  return er.getTopics();
}
function rp(e) {
  var t, r;
  return (r = (t = vi()) == null ? void 0 : t.topics) == null ? void 0 : r.includes(e);
}
async function bf(e) {
  return er.callListener(e, at.globalSubscriptions);
}
function Yo() {
  return er.getTournamentId();
}
function zh(e) {
  return er.getTournamentRecord(e);
}
function Ko() {
  return er.getTournamentRecords();
}
function Hw(e) {
  return er.setTournamentRecord(e);
}
function ip(e) {
  return er.setTournamentRecords(e);
}
function Jc(e) {
  return er.setTournamentId(e);
}
function zw(e) {
  return er.removeTournamentRecord(e);
}
function Rf() {
  return er;
}
function np({ engineName: e, methodName: t, params: r, err: i }) {
  let n = Hr(er.handleCaughtError) && er.handleCaughtError || _w.handleCaughtError, { tournamentRecord: a, ...o } = r;
  return n({ params: o, engineName: e, methodName: t, err: i });
}
function Yw(e, t) {
  if (at.globalLog)
    try {
      at.globalLog({ log: e, engine: t });
    } catch (r) {
      console.log("globalLog error", r), console.log(t, e), Vw();
    }
  else
    console.log(t, e);
}
function Kw(e, t, r, i) {
  if (!Le(e))
    return { error: J };
  St || (r = 1);
  let n = Array.isArray(t) ? t : [], a = {}, o = (s, c = 0) => {
    Object.keys(s).forEach((u) => {
      Hr(s[u]) ? a[u] = s[u] : Le(s[u]) && (t === !0 || n != null && n.includes(u)) && (r === void 0 || c < r) && o(s[u], c + 1);
    });
  };
  return o(e), i ? Gw(a) : $w(a), { methods: a };
}
function CC(e, t, r) {
  return Object.keys(e).filter((i) => !t.includes(e[i]) && (!r || (Array.isArray(e[i]) ? e[i].length : !0)));
}
function me(e, t, r, i) {
  var o;
  if (typeof e != "object" || e === null)
    return e;
  (o = qh()) != null && o.enabled || (i = !0);
  let n = ["", void 0, null];
  t && n.push(!1);
  let a = CC(e, n, r);
  return Object.assign({}, ...a.map((s) => Array.isArray(e[s]) ? { [s]: i ? e[s] : e[s].map((c) => me(c)) } : { [s]: i ? e[s] : me(e[s]) }));
}
function j({ context: e, result: t, stack: r, info: i }) {
  return t && !Array.isArray(t == null ? void 0 : t.stack) && (t.stack = []), t && Array.isArray(t == null ? void 0 : t.stack) && typeof r == "string" && t.stack.push(r), t && i && (t.info = i), t && typeof e == "object" && Object.keys(e).length && Object.assign(t, me(e)), t && !(t != null && t.error) && !(t != null && t.success) && Object.assign(t, { ...V }), t ?? { success: !0 };
}
var Zi = "ANY", et = "MALE", Mr = "MIXED", _a = "OTHER", dt = "FEMALE", Yh = { ANY: Zi, MALE: et, FEMALE: dt, MIXED: Mr, OTHER: _a }, OC = "MIXED events can not contain mixed singles or { gender: ANY } collections", kC = "events with { gender: ANY } can not contain MIXED singles collections";
function ap(e) {
  let t = "tieFormatGenderValidityCheck", { referenceGender: r, matchUpType: i, gender: n } = e;
  return r && n && [et, dt].includes(r) && r !== n ? j({ result: { valid: !1, error: _c }, context: { gender: n }, stack: t }) : r === Mr && (n === Zi || n === Mr && i !== tt) ? j({ result: { error: _c, valid: !1 }, info: OC, stack: t }) : r === Zi && n === Mr && i !== tt ? j({ result: { error: _c, valid: !1 }, info: kC, stack: t }) : { valid: !0 };
}
var FC = "normal", Xy = "timed", xC = "final", Kh = "NOAD", Hd = "SET", LC = { S: FC, F: xC };
function op(e, t) {
  if ((e != null && e.bestOf || e != null && e.exactly) && (e != null && e.setFormat))
    return _C(e, t);
}
function Xc(e) {
  return !isNaN(Number(e)) && Number(e);
}
function Qw(e) {
  let t = `T${e.minutes}`;
  return e.based && (t += e.based), e.modifier && (t += `@${e.modifier}`), t;
}
function _C(e, t) {
  var d;
  let r = Xc(e.bestOf) || void 0, i = Xc(e.exactly) || void 0, n = r || i;
  if ((d = e.setFormat) != null && d.timed && e.simplified && n === 1)
    return Qw(e.setFormat);
  let a = n && `${Hd}${n}` || "", o = Zy(e.setFormat, t), s = o && `S:${o}` || "", c = Zy(e.finalSetFormat, t), u = n && n > 1 && c && o !== c && `F:${c}` || "";
  if (a && o)
    return [a, s, u].filter((p) => p).join("-");
}
function Zy(e, t) {
  if (typeof e == "object" && Object.keys(e).length) {
    if (e.timed)
      return Qw(e);
    if (e.tiebreakSet)
      return eS(e.tiebreakSet);
    let r = Xc(e.setTo);
    if (r) {
      let i = e.NoAD && Kh || "", n = eS(e.tiebreakFormat), a = n && `/${n}` || "", o = Xc(e.tiebreakAt), s = o && (o !== r || t) && `@${o}` || "";
      if (n !== !1)
        return `${r}${i}${a}${s}`;
    }
  }
}
function eS(e) {
  if (e) {
    if (typeof e == "object" && !e.tiebreakTo)
      return "";
    if (typeof e == "object" && Xc(e.tiebreakTo)) {
      let t = `TB${e.tiebreakTo}${e.NoAD ? Kh : ""}`;
      return e.modifier && (t += `@${e.modifier}`), t;
    } else
      return !1;
  }
}
function Tr(e) {
  if (ht(e)) {
    let t = e.startsWith("T") && Xy || e.startsWith(Hd) && Hd || "";
    if (t === Xy) {
      let r = Xw(e), i = { simplified: !0, setFormat: r, bestOf: 1 };
      if (r)
        return i;
    }
    if (t === Hd)
      return BC(e);
  }
}
function BC(e) {
  let t = e.split("-"), r = Nu(t[0].slice(3)), i = r === 1 || r % 2 !== 0 ? r : void 0, n = r !== 1 && r % 2 === 0 ? r : void 0, a = t && tS(t[1]), o = t && tS(t[2]), s = a && a.timed || o && o.timed, c = i && i < 6 || s && n, u = !t[2] || o, d = a, p = me({ setFormat: a, exactly: n, bestOf: i });
  if (o && (p.finalSetFormat = o), c && d && u)
    return p;
}
function tS(e) {
  if ((e == null ? void 0 : e[1]) === ":") {
    let t = e.split(":"), r = LC[t[0]], i = t[1];
    if (r && i) {
      if (i.startsWith("TB")) {
        let f = rS(i);
        return f === !1 ? !1 : typeof f == "object" ? { tiebreakSet: f } : void 0;
      }
      if (i.startsWith("T"))
        return Xw(i);
      let n = e.match(/^[FS]:(\d+)([A-Za-z]*)/), a = n && Zw(n[2]) || !1, o = !(n != null && n[2]) || a, s = n ? Nu(n[1]) : void 0, c = Jw(i), u = c !== !1, d = u && c || s, p = rS(i.split("/")[1]), l = p !== !1, m = { setTo: s };
      return a && (m.NoAD = !0), p ? (m.tiebreakFormat = p, m.tiebreakAt = d) : m.noTiebreak = !0, s && o && l && u && m || !1;
    }
  }
}
function Jw(e, t = !0) {
  let r = (e == null ? void 0 : e.indexOf("@")) > 0 && e.split("@");
  if (r)
    return (t ? Nu(r[1]) : r[1]) || !1;
}
function rS(e) {
  if (e)
    if (e.startsWith("TB")) {
      let t = Jw(e, !1), r = e.match(/^TB(\d+)([A-Za-z]*)/), i = r == null ? void 0 : r[1], n = r && Zw(r[2]), a = !(r != null && r[2]) || n, o = Nu(i);
      if (o && a) {
        let s = { tiebreakTo: o };
        return t && typeof t == "string" && !Pe(t) && (s.modifier = t), n && (s.NoAD = !0), s;
      } else
        return !1;
    } else
      return !1;
}
function Xw(e) {
  var s;
  let t = e.slice(1), r = t.match(/^(\d+)(@?[A-Za-z]*)/), i = Nu(r == null ? void 0 : r[1]);
  if (!i)
    return;
  let n = { timed: !0, minutes: i }, a = r == null ? void 0 : r[2], o = [void 0, "P", "G"].includes(a);
  if (a && !o) {
    let c = (s = t.match(/^(\d+)(@)([A-Za-z]+)$/)) == null ? void 0 : s[3];
    return c ? (n.modifier = c, n) : void 0;
  }
  return a && (n.based = r[2]), n;
}
function Zw(e) {
  return e && e.indexOf(Kh) >= 0;
}
function Nu(e) {
  return isNaN(Number(e)) ? 0 : Number(e);
}
function Jr({ matchUpFormat: e }) {
  if (!ht(e) || e === "")
    return !1;
  let t = Tr(e), r = e.match(/-S:([1-9])+\/TB([0-9]{1,2})@?([1-9]?)*/), i = r == null ? void 0 : r[1], n = r == null ? void 0 : r[2], a = r == null ? void 0 : r[3], o = e.match(/-F:([1-9])+\/TB([0-9]{1,2})@?([1-9]?)*/), s = o == null ? void 0 : o[1], c = o == null ? void 0 : o[2], u = o == null ? void 0 : o[3];
  return op(t, !!(r && n && i === a || o && c && s === u)) === e;
}
var ol = /^[\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1])$/, eP = /^((0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)([.,][0-9]{3})?$/, un = /^([\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1]))([ T](0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)?([.,][\d]{3})?Z?$/, Ba = /^([\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1]))?([ T]?(0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)?([.,][\d]{3})?Z?$/;
function sl(e) {
  let { scheduledDate: t } = e;
  if (!t && e.scheduledTime && (t = be(e.scheduledTime)), !t)
    return;
  let r = mt(e.scheduledTime), i = be(t);
  return i && r && (i += `T${r}`), i;
}
function VC(e) {
  return typeof e != "object" || Array.isArray(e) ? !1 : Object.prototype.toString.call(e) === "[object Date]";
}
function uc(e) {
  let t = typeof e == "string" ? e == null ? void 0 : e.split(" ") : [];
  return e && (t == null ? void 0 : t.length) > 1 && !["AM", "PM"].includes(t[1].toUpperCase()) ? !1 : !!(!e || Ba.test(Qo(e, !0, !0)));
}
function Kr(e) {
  return $a(e) || ol.test(e);
}
function jC(e) {
  let t = new Date(e), r = t.getSeconds() + 60 * t.getMinutes() + 60 * 60 * t.getHours();
  return GC(r, { displaySeconds: !1 });
}
function GC(e, t) {
  let r = parseInt(e, 10), i = Math.floor(r / 3600), n = Math.floor((r - i * 3600) / 60), a = r - i * 3600 - n * 60;
  return (!t || t != null && t.displaySeconds ? i + ":" + n + ":" + a : i + ":" + n).split(":").map(hi).join(":");
}
var Qh = (e) => {
  let t = Zc(e) || $a(e) ? new Date(e) : /* @__PURE__ */ new Date(), r = t.getUTCMonth() + 1, i = r < 10 ? `0${r}` : `${r}`;
  return `${t.getUTCFullYear()}-${hi(i)}-${hi(t.getUTCDate())}`;
};
function $C(e) {
  let t = Zc(e) || $a(e) ? new Date(e) : /* @__PURE__ */ new Date();
  return Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
}
function Ci(e, t = "-", r = "YMD") {
  if (!e)
    return "";
  typeof e == "string" && e.indexOf("T") < 0 && (e = e + "T00:00");
  let i = new Date(e), n = "" + (i.getMonth() + 1), a = "" + i.getDate(), o = i.getFullYear();
  return n.length < 2 && (n = "0" + n), a.length < 2 && (a = "0" + a), r === "DMY" ? [a, n, o].join(t) : r === "MDY" ? [n, a, o].join(t) : r === "YDM" ? [o, a, n].join(t) : r === "DYM" ? [a, o, n].join(t) : r === "MYD" ? [n, o, a].join(t) : [o, n, a].join(t);
}
function cl(e) {
  let t = e ? new Date(e) : /* @__PURE__ */ new Date(), r = t.getTimezoneOffset();
  return new Date(t.getTime() - r * 60 * 1e3);
}
function qC(e) {
  return cl(e).getTime();
}
function Zc(e) {
  if (typeof e == "boolean")
    return !1;
  let t = e instanceof Date && e || !isNaN(e) && new Date(e) || !1;
  return t && !isNaN(t.valueOf());
}
function Fs(e, t) {
  if (!Kr(e) || !Kr(t))
    return [];
  let r = be(e) + "T00:00", i = be(t) + "T00:00", n = new Date(r), a = new Date(i), o = Zc(a) && Zc(n) && u(n, a), s = [], c = 0;
  if (o) {
    let d = n, p = d.getTime();
    for (; p <= a.getTime() && c < 300; )
      c += 1, s.push(new Date(d)), p = d.setDate(d.getDate() + 1);
  }
  return s.map((d) => Ci(d));
  function u(d, p) {
    return d <= p;
  }
}
var WC = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
function $a(e) {
  return typeof e != "string" ? !1 : WC.test(e);
}
function Jh(e) {
  if (typeof e != "string")
    return !1;
  let t = e.split("Z")[0].split(":"), r = t.every((i) => !isNaN(parseInt(i)));
  return !(t.length < 2 || !r || parseInt(t[0]) > 23 || parseInt(t[1]) > 60);
}
function _e(e) {
  let t = mt(e);
  if (!t)
    return 0;
  let [r, i] = t.split(":").map((n) => parseInt(n));
  return r * 60 + i;
}
function HC(e) {
  let t = Math.floor(e / 60), r = e - t * 60;
  return t > 23 && (t = t % 24), [hi(t), hi(r)].join(":");
}
function ul(e) {
  return Jh(e) ? e.split(":").slice(0, 2).map(hi).join(":") : void 0;
}
function mt(e) {
  return $a(e) && e.indexOf("T") > 0 ? ul(e.split("T").reverse()[0]) : ul(e);
}
function be(e) {
  return $a(e) || un.test(e) ? e.split("T")[0] : void 0;
}
function Lc(e, t) {
  let r = new Date(e);
  return r.setDate(r.getDate() + t), be(r.toISOString());
}
function dl(e) {
  e = typeof e != "string" ? "00:00" : e;
  let t = {}, r = {};
  return { 0: t.time, 1: t.ampm } = e.split(" ") || [], { 0: r.hours, 1: r.minutes } = t.time.split(":") || [], r.ampm = t.ampm, isNaN(r.hours) || isNaN(r.minutes) || r.ampm && !["AM", "PM"].includes(r.ampm.toUpperCase()) ? {} : r;
}
function zC(e) {
  let t = dl(e);
  return t.ampm && t.hours && (t.ampm.toLowerCase() === "pm" && parseInt(t.hours) < 12 && (t.hours = (t.hours && parseInt(t.hours) || 0) + 12), t.ampm.toLowerCase() === "am" && t.hours === "12" && (t.hours = "00")), `${t.hours || "12"}:${t.minutes || "00"}`.split(":").map(hi).join(":");
}
function YC(e) {
  var r;
  let t = dl(e);
  if (!(typeof t == "object" && !Object.keys(t).length))
    return t.ampm ? e : (t.hours > 12 ? (t.hours -= 12, t.ampm = "PM") : t.hours === "12" ? t.ampm = "PM" : (t.hours === "00" && (t.hours = "12"), t.ampm = "AM"), ((r = t.hours) == null ? void 0 : r[0]) === "0" && (t.hours = t.hours.slice(1)), `${t.hours || "12"}:${t.minutes || "00"} ${t.ampm}`);
}
function Qo(e, t, r) {
  let i = be(e), n = mt(e), a = i ? n : e;
  return e ? t && (i && r && e || zC(a)) || YC(a) : void 0;
}
function tP(e, t) {
  let r = dl(e), i = dl(t);
  if (parseInt(r.hours) < parseInt(i.hours))
    return -1;
  if (parseInt(r.hours) > parseInt(i.hours))
    return 1;
  if (r.hours === i.hours) {
    if (parseInt(r.minutes) < parseInt(i.minutes))
      return -1;
    if (parseInt(r.minutes) > parseInt(i.minutes))
      return 1;
  }
  return 0;
}
function Xh(e, t = 7) {
  let r = be(e) + "T00:00", i = new Date(r), n = new Date(i.setDate(i.getDate() + t));
  return Ci(n);
}
function KC(e) {
  return Xh(e);
}
function QC(e, t, r, i = !1) {
  let n = new Date(t, 0, 1 + (e - 1) * 7), a = i ? 0 : 1;
  return n.setDate(n.getDate() + (a - n.getDay())), Ci(n, r);
}
function JC(e, t, r) {
  let i = new Date(e, 0);
  return Ci(new Date(i.setDate(t)), r);
}
function Ot(e, t = void 0) {
  let [r, i] = (e || "00:00").split(":").map(hi), n = cl(t).setHours(r, i, 0, 0);
  return cl(n);
}
function Au(e, t, r = !0) {
  let i = new Date(e), n = (new Date(t).getTime() - i.getTime()) / 1e3 / 60;
  return r ? Math.abs(Math.round(n)) : Math.round(n);
}
function Br(e, t) {
  let r = mt(e);
  if (!r)
    return "00:00";
  let i = isNaN(t) ? 0 : t;
  return mt(Zh(Ot(r), i).toISOString());
}
function Zh(e, t) {
  let r = new Date(e);
  return new Date(r.getTime() + t * 6e4);
}
function hi(e) {
  return e.toString()[1] ? e : "0" + e;
}
function Nn(e, t) {
  let r = new Date(e), i = new Date(t);
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth() && r.getDate() === i.getDate();
}
var rP = { addDays: Xh, addWeek: KC, addMinutesToTimeString: Br, convertTime: Qo, getIsoDateString: sl, getUTCdateString: Qh, DateHHMM: jC, extractDate: be, extractTime: mt, formatDate: Ci, getDateByWeek: QC, isISODateString: $a, isDate: Zc, isTimeString: Jh, offsetDate: cl, offsetTime: qC, sameDay: Nn, timeStringMinutes: _e, timeToDate: Ot, timeUTC: $C, validTimeValue: uc, validDateString: ol, timeValidation: Ba, dateValidation: un }, XC = (e, t) => e.filter(Boolean).every((r) => typeof r === t), ZC = (e) => e.filter(Boolean).every(St);
function Oo(e) {
  let t = e.category;
  if (typeof t != "object")
    return { error: Yc };
  let { ageCategoryCode: r, ageMaxDate: i, ageMinDate: n, ageMax: a, ageMin: o } = t, s = t.categoryName, c;
  if (!XC([r, i, n, s], "string") || !ZC([a, o]))
    return { error: Yc };
  let u = e.consideredDate ?? be((/* @__PURE__ */ new Date()).toLocaleDateString("sv"));
  if (!Kr(u))
    return { error: Qt };
  let [d] = u.split("-").slice(0, 3).map((F) => parseInt(F)), p = Lc(u, -1), [l, m] = p.split("-").slice(1, 3).map((F) => parseInt(F)), f = `${hi(l)}-${hi(m)}`, h = Lc(u, 1), [g, I] = h.split("-").slice(1, 3).map((F) => parseInt(F)), y = `${hi(g)}-${hi(I)}`, U = o && Lc(u, -1 * 365 * o), S = a && Lc(u, -1 * 365 * a), D = [], w = (F) => !D.includes(F) && D.push(F);
  r = r ?? s;
  let v = /^([UO]?)(\d{1,2})([UO]?)$/, P = /^C(\d{1,2})-(\d{1,2})$/, b = r == null ? void 0 : r.includes("-"), T = b && (r == null ? void 0 : r.match(P)), R = r == null ? void 0 : r.match(v), M = (F, x) => `${F}-${x}`, E = (F) => {
    let x = d - F, _ = M(x, y);
    t.ageMinDate && t.ageMinDate !== _ && w(`Invalid submitted ageMinDate: ${n}`), n = _, r && (t.ageMax && t.ageMax !== F - 1 && (w(`Invalid submitted ageMax: ${a}`), S = void 0), a = F - 1);
  }, C = (F) => {
    let x = d - F - 1, _ = M(x, y);
    t.ageMin && t.ageMin > F && w(`Invalid submitted ageMin: ${o}`), t.ageMax && t.ageMax > F && w(`Invalid submitted ageMax: ${a}`), t.ageMinDate && t.ageMinDate !== _ && w(`Invalid submitted ageMinDate: ${n}`), n = _, r && (t.ageMax && t.ageMax !== F && (w(`Invalid submitted ageMax: ${a}`), U = void 0), a = F);
  }, A = (F) => {
    let x = d - F, _ = M(x, f);
    t.ageMaxDate && t.ageMaxDate !== _ && w(`Invalid submitted ageMaxDate: ${i}`), i = _, r && (t.ageMin && t.ageMin !== F + 1 && (w(`Invalid submitted ageMin: ${o}`), U = void 0), o = F + 1);
  }, N = (F) => {
    let x = d - F - 1, _ = M(x, f);
    t.ageMaxDate && t.ageMaxDate !== _ && w(`Invalid submitted ageMaxDate: ${i}`), i = _, r && (t.ageMin && t.ageMin !== F && (w(`Invalid submitted ageMin: ${o}`), U = void 0), o = F);
  }, O = (F) => {
    let [x, _, B] = (F.match(v) || []).slice(1), L = parseInt(_);
    x === "U" ? (t.ageMaxDate && t.ageMaxDate !== i && w(`Invalid submitted ageMaxDate: ${t.ageMaxDate}`), E(L)) : x === "O" && A(L), B === "U" ? (t.ageMaxDate && t.ageMaxDate !== i && w(`Invalid submitted ageMaxDate: ${t.ageMaxDate}`), C(L)) : B === "O" && N(L), i = i ?? U, n = n ?? S;
  };
  if (T) {
    if (i = void 0, n = void 0, a = void 0, o = void 0, t.ageMin) {
      let _ = d - t.ageMin;
      i = M(_, f);
    }
    if (t.ageMax) {
      let _ = d - t.ageMax - 1;
      n = M(_, y);
    }
    let [F, x] = ((r == null ? void 0 : r.match(P)) ?? []).slice(1).map((_) => parseInt(_));
    F <= x ? (o = F, a = x, c = !0) : w(`Invalid combined age range ${r}`);
  } else
    b ? r == null || r.split("-").forEach(O) : R ? O(r) : (o && A(o), a && C(a));
  a && t.ageMin && t.ageMin > a && (w(`Invalid submitted ageMin: ${t.ageMin}`), o = void 0);
  let k = me({ consideredDate: u, combinedAge: c, ageMaxDate: i, ageMinDate: n, ageMax: a, ageMin: o });
  return D.length && (k.errors = D), k;
}
function eu({ category: e }) {
  if (!Le(e))
    return { error: J };
  let t = Oo({ category: e });
  if (t.error)
    return { error: t };
  let { ratingMax: r, ratingMin: i } = e;
  return r && !St(r) ? j({ result: { error: J }, context: { ratingMax: r } }) : i && !St(i) ? j({ result: { error: J }, context: { ratingMin: i } }) : { ...t };
}
function Eu({ childCategory: e, withDetails: t, category: r }) {
  let i = eu({ category: r }), n = eu({ category: e }), a = n.ageMin && (i.ageMin && n.ageMin < i.ageMin || i.ageMax && n.ageMin > i.ageMax), o = n.ageMax && (i.ageMax && n.ageMax > i.ageMax || i.ageMin && n.ageMax < i.ageMin), s = n.ageMinDate && i.ageMaxDate && new Date(n.ageMinDate) > new Date(i.ageMaxDate), c = n.ageMaxDate && i.ageMinDate && new Date(n.ageMaxDate) < new Date(i.ageMinDate), u = (r == null ? void 0 : r.ratingType) && (e == null ? void 0 : e.ratingType) && r.ratingType === e.ratingType && (r.ratingMin && e.ratingMin && e.ratingMin < r.ratingMin || r.ratingMax && e.ratingMax && e.ratingMax > r.ratingMax || r.ratingMin && e.ratingMax && e.ratingMax < r.ratingMin || r.ratingMax && e.ratingMin && e.ratingMin > r.ratingMax), d = (r == null ? void 0 : r.ballType) && (e == null ? void 0 : e.ballType) && r.ballType !== e.ballType, p = me({ invalidRatingRange: u, invalidAgeMinDate: s, invalidAgeMaxDate: c, invalidBallType: d, invalidAgeMax: o, invalidAgeMin: a, valid: !u && !s && !c && !d && !o && !a }, !0);
  return t && Object.assign(p, { categoryDetails: i, childCategoryDetails: n }), p;
}
function Cu({ checkCategory: e = !0, collectionDefinition: t, checkCollectionIds: r, checkGender: i = !0, referenceCategory: n, referenceGender: a, event: o }) {
  a = a ?? (o == null ? void 0 : o.gender);
  let s = "validateCollectionDefinition", c = [];
  if (typeof t != "object")
    return c.push(`collectionDefinition must be an object: ${t}`), j({ result: { errors: c, error: ea }, stack: s });
  let { collectionValueProfiles: u, collectionGroupNumber: d, collectionValue: p, collectionId: l, matchUpCount: m, matchUpFormat: f, matchUpValue: h, matchUpType: g, scoreValue: I, setValue: y, category: U, gender: S } = t;
  if (r && typeof l != "string" && c.push(`collectionId is not type string: ${l}`), typeof m != "number" && c.push(`matchUpCount is not type number: ${m}`), g && !jl([rt, tt], g) && c.push(`matchUpType must be SINGLES or DOUBLES: ${g}`), [!!(u != null && u.length)].concat([h, p, I, y].map(Pe)).filter(Boolean).length !== 1 && c.push("Missing value definition for matchUps: matchUpValue, collectionValue, or collectionValueProfiles"), h && typeof h != "number" && c.push(`matchUpValue is not type number: ${h}`), p && typeof p != "number" && c.push(`collectionValue is not type number: ${p}`), u && m) {
    let D = Av({ collectionValueProfiles: u, matchUpCount: m });
    D.errors && c.push(...D.errors);
  }
  if (d && typeof d != "number" && c.push(`collectionGroupNumber is not type number: ${p}`), f && !Jr({ matchUpFormat: f }) && c.push(`Invalid matchUpFormat: ${f}`), i) {
    let D = ap({ referenceGender: a, matchUpType: g, gender: S });
    if (D.error)
      return j({ context: { referenceGender: a, gender: S }, result: D, stack: s });
  }
  if (e && n && U) {
    let D = Eu({ category: n, childCategory: U });
    if (!D.valid)
      return j({ result: { error: Yc }, context: D, stack: s });
  }
  return c.length ? j({ result: { errors: c, error: Ew }, stack: s }) : { valid: !0 };
}
function Ar(e) {
  var g, I, y, U;
  let t = !!((e == null ? void 0 : e.enforceCategory) !== !1 && (e != null && e.category)), r = !!((e == null ? void 0 : e.enforceGender) !== !1 && (e != null && e.gender)), i = e == null ? void 0 : e.checkCollectionIds, n = e == null ? void 0 : e.tieFormat, a = e == null ? void 0 : e.event, o = "validateTieFormat", s = [], c = e1({ ...e, stack: o });
  if (c != null && c.error)
    return c;
  let u, d = n.collectionDefinitions.every((S) => {
    let { setValue: D, scoreValue: w, collectionValue: v } = S;
    (D || w) && !v && (u = !0);
    let { valid: P, errors: b } = Cu({ referenceCategory: e.category, referenceGender: e.gender, collectionDefinition: S, checkCollectionIds: i, checkCategory: t, checkGender: r, event: a });
    return P ? !0 : (Array.isArray(b) && s.push(...b), !1);
  }), p = typeof ((g = n.winCriteria) == null ? void 0 : g.valueGoal) == "number" && ((I = n.winCriteria) == null ? void 0 : I.valueGoal) > 0 && !u || ((y = n.winCriteria) == null ? void 0 : y.aggregateValue);
  if (!(p || (U = n.winCriteria) != null && U.aggregateValue))
    return u ? s.push("aggregateValue is required") : s.push("Either non-zero valueGoal, or { aggregateValue: true } must be specified in winCriteria"), j({ context: { tieFormat: n, errors: s, aggregateValueImperative: u }, result: { error: wn }, stack: o });
  let l = n.collectionDefinitions.map(({ collectionId: S }) => S), m = !i || l.length === Te(l).length, f = d && p && m;
  return f ? { valid: f, errors: s } : j({ result: { error: wn }, context: { tieFormat: n, errors: s }, stack: o });
}
function e1(e) {
  let { tieFormat: t, stack: r } = e;
  return !e || !t || !Le(t) ? j({ result: { error: wn }, context: { tieFormat: t, message: "tieformat must be an object" }, stack: r }) : Le(t.winCriteria) ? Array.isArray(t.collectionDefinitions) ? { ...V } : j({ result: { error: wn }, context: { tieFormat: t, message: "collectionDefinitions must be an array" }, stack: r }) : j({ result: { error: wn }, context: { tieFormat: t, message: "tieformat.winCritiera must be an object" }, stack: r });
}
var xs = "resourceSubType", Ls = "resourceType", _s = "identifier", t1 = { RESOURCE_SUB_TYPE: xs, RESOURCE_TYPE: Ls, IDENTIFIER: _s };
function ce(e, t, r, i, n = 0) {
  if (Rf().makeDeepCopy)
    return Rf().makeDeepCopy(e, t, r, i);
  let a = qh(), { stringify: o, toJSON: s, ignore: c, modulate: u } = a || {};
  if (!(a != null && a.enabled) && !r || typeof e != "object" || Hr(e) || e === null || typeof (a == null ? void 0 : a.threshold) == "number" && n >= a.threshold)
    return e;
  let d = Array.isArray(e) ? [] : {}, p = Object.keys(e).filter((m) => !r || !c || Array.isArray(c) && !c.includes(m) || Hr(c) && !c(m)), l = (m, f) => {
    d[m] = Hr(f == null ? void 0 : f.toString) ? f.toString() : JSON.stringify(f);
  };
  for (let m of p) {
    let f = e[m], h = Hr(u) ? u(f) : void 0;
    if (h !== void 0)
      d[m] = h;
    else if (t && m === "extensions" && Array.isArray(f)) {
      let g = eg(f);
      Object.assign(d, ...g);
    } else
      i && m === "extensions" ? d[m] = [] : Array.isArray(o) && o.includes(m) ? l(m, f) : Array.isArray(s) && s.includes(m) && Hr(f == null ? void 0 : f.toJSON) ? d[m] = f.toJSON() : f === null ? d[m] = void 0 : VC(f) ? d[m] = new Date(f).toISOString() : d[m] = ce(f, t, r, i, n + 1);
  }
  return d;
}
function eg(e) {
  return e == null ? void 0 : e.map((t) => {
    let { name: r, value: i } = t;
    return r && i && { [`_${r}`]: i };
  }).filter(Boolean);
}
function iP(e = 1, t) {
  return oe(0, e).map(() => ze(t));
}
function ze(e) {
  let t = [];
  for (let s = 0; s < 256; s++)
    t[s] = (s < 16 ? "0" : "") + s.toString(16);
  let r = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, a = Math.random() * 4294967295 | 0, o = t[r & 255] + t[r >> 8 & 255] + t[r >> 16 & 255] + t[r >> 24 & 255] + "-" + t[i & 255] + t[i >> 8 & 255] + "-" + t[i >> 16 & 15 | 64] + t[i >> 24 & 255] + "-" + t[n & 63 | 128] + t[n >> 8 & 255] + "-" + t[n >> 16 & 255] + t[n >> 24 & 255] + t[a & 255] + t[a >> 8 & 255] + t[a >> 16 & 255] + t[a >> 24 & 255];
  return typeof e == "string" ? `${e}_${o.replace(/-/g, "")}` : o;
}
var nP = { collectionDefinitions: [{ collectionName: "Male Singles", matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpCount: 4, matchUpValue: 1, gender: "MALE" }, { collectionName: "Female Singles", matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 4, matchUpValue: 1 }, { collectionName: "Male Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpCount: 2, matchUpValue: 1, gender: "MALE" }, { collectionName: "Female Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 2, matchUpValue: 1 }, { collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpCount: 4, matchUpValue: 1, gender: "MIXED" }], tieFormatName: "USTA_GOLD_TEAM_CHALLENGE", winCriteria: { valueGoal: 9 } }, aP = { collectionDefinitions: [{ collectionName: "Round 1", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Round 2", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Round 3", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "Doubles Shuffle", unrestrictedSelections: !0, winCriteria: { aggregateValue: !0 } }, oP = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_SOUTHERN_LEVEL_5", winCriteria: { valueGoal: 8 } }, sP = { collectionDefinitions: [{ category: { ageCategoryCode: "16U" }, collectionName: "16U Singles", matchUpCount: 4, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Singles", matchUpCount: 4, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Doubles", matchUpCount: 2, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Doubles", matchUpCount: 2, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Tiebreak Doubles", matchUpCount: 1, matchUpFormat: "SET1-S:TB10", matchUpType: "DOUBLES", matchUpValue: 1, processCodes: ["RANKING.IGNORE"] }], tieFormatName: "USTA_SECTION_BATTLE", winCriteria: { valueGoal: 9 } }, cP = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_INTERSECTIONAL", winCriteria: { valueGoal: 8 } }, uP = { collectionDefinitions: [{ scoreValue: 1, matchUpType: "SINGLES", collectionName: "Men's Singles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 1 }, { scoreValue: 1, matchUpType: "SINGLES", collectionName: "Women's Singles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:T60", gender: "MIXED", matchUpCount: 1 }], tieFormatName: "Time Tennis Pro Circuit", winCriteria: { aggregateValue: !0 } }, dP = { collectionDefinitions: [{ collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "DOMINANT_DUO_MIXED", winCriteria: { valueGoal: 2 } }, lP = { collectionDefinitions: [{ scoreValue: 1, matchUpType: "SINGLES", collectionName: "Men's Singles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 3 }, { scoreValue: 1, matchUpType: "SINGLES", collectionName: "Women's Singles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 3 }, { scoreValue: 1, matchUpType: "DOUBLES", collectionName: "Men's Doubles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Women's Doubles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:T60", gender: "MIXED", matchUpCount: 1 }], tieFormatName: "Time Tennis Dual", winCriteria: { aggregateValue: !0 } }, pP = { collectionDefinitions: [{ category: { ageCategoryCode: "14U" }, collectionName: "14U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], collectionGroups: [{ groupNumber: 1, groupName: "Doubles", groupValue: 1, winCriteria: { valueGoal: 2 } }], tieFormatName: "USTA_BREWER_CUP", winCriteria: { valueGoal: 4 } }, mP = { winCriteria: { valueGoal: 23 }, tieFormatName: "USTA_OZAKI_CUP", collectionDefinitions: [{ category: { ageCategoryCode: "18U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "18U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "18U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "18U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "16U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "16U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "16U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "14U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "14U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "14U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "12U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "12U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "12U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }] }, Oi = "SET3-S:6/TB7", r1 = "SET3-S:6NOAD", fP = "SET3-S:6/TB7-F:TB10", i1 = "SET3-S:4/TB7", n1 = "SET3-S:4/TB5@3", a1 = "SET1-S:T20", o1 = "SET1-S:8/TB7", s1 = "SET1-S:8/TB7@7", c1 = { FORMAT_STANDARD: Oi, FORMAT_STANDARD_NOAD: r1, FORMAT_ATP_DOUBLES: fP, FORMAT_SHORT_SETS: i1, FORMAT_FAST4: n1, FORMAT_PRO_SET: o1, FORMAT_COLLEGE_PRO_SET: s1, TIMED20: a1 }, hP = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "DOMINANT_DUO", winCriteria: { valueGoal: 2 } }, gP = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", collectionValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "USTA_COLLEGE", winCriteria: { valueGoal: 4 } }, IP = { collectionDefinitions: [{ collectionName: "Male Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_LEVEL_1", winCriteria: { valueGoal: 10 } }, UP = { collectionDefinitions: [{ collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Overtime", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "USTA_WTT_ITT", winCriteria: { aggregateValue: !0 } }, yP = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_ZONAL", winCriteria: { valueGoal: 10 } }, SP = { collectionDefinitions: [{ collectionGroupNumber: 1, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 1 }, { collectionGroupNumber: 1, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 1 }, { collectionGroupNumber: 2, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 2 }, { collectionGroupNumber: 2, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 2 }, { collectionGroupNumber: 3, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 3 }, { collectionGroupNumber: 3, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 3 }], collectionGroups: [{ groupNumber: 1, groupName: "Day 1" }, { groupNumber: 2, groupName: "Day 2" }, { groupNumber: 3, groupName: "Day 3" }], tieFormatName: "LAVER_CUP", winCriteria: { valueGoal: 13 } }, vP = { collectionDefinitions: [{ collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Overtime", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "USTA_TOC", winCriteria: { aggregateValue: !0 } }, ll = "COLLEGE_DEFAULT", Mf = "COLLEGE_JUCO", Nf = "COLLEGE_D3", wP = "DOMINANT_DUO", PP = "DOMINANT_DUO_MIXED", DP = "LAVER_CUP", TP = "TEAM_DOUBLES_3_AGGREGATION", bP = "TIME_TENNIS_DUAL", RP = "TIME_TENNIS_PRO_CIRCUIT", MP = "USTA_BREWER_CUP", NP = "USTA_OZAKI_CUP", AP = "USTA_COLLEGE", EP = "USTA_GOLD_TEAM_CHALLENGE", CP = "USTA_LEVEL_1", OP = "USTA_INTERSECTIONAL", kP = "USTA_SECTION_BATTLE", FP = "USTA_SOUTHERN_LEVEL_5", xP = "USTA_TOC", LP = "USTA_WTT_ITT", _P = "USTA_ZONAL", u1 = { COLLEGE_D3: Nf, COLLEGE_DEFAULT: ll, COLLEGE_JUCO: Mf, DOMINANT_DUO: wP, DOMINANT_DUO_MIXED: PP, LAVER_CUP: DP, TEAM_DOUBLES_3_AGGREGATION: TP, TIME_TENNIS_DUAL: bP, TIME_TENNIS_PRO_CIRCUIT: RP, USTA_BREWER_CUP: MP, USTA_OZAKI_CUP: NP, USTA_COLLEGE: AP, USTA_GOLD_TEAM_CHALLENGE: EP, USTA_INTERSECTIONAL: OP, USTA_LEVEL_1: CP, USTA_SECTION_BATTLE: kP, USTA_SOUTHERN_LEVEL_5: FP, USTA_TOC: xP, USTA_WTT_ITT: LP, USTA_ZONAL: _P }, BP = "STANDARD", iS = { [BP]: { hydrate: !0, doubles: { matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpCount: 6, matchUpValue: 1 }, valueGoal: 5 }, [Nf]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:8/TB7@7", matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpFormat: Oi, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: Nf, valueGoal: 5 }, [ll]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:6/TB7", collectionValue: 1, matchUpCount: 3 }, singles: { matchUpFormat: Oi, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: ll, valueGoal: 4 }, [Mf]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:8/TB7", matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpFormat: Oi, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: Mf, valueGoal: 5 }, [DP]: SP, [wP]: hP, [PP]: dP, [TP]: aP, [bP]: lP, [RP]: uP, [MP]: pP, [NP]: mP, [AP]: gP, [EP]: nP, [OP]: cP, [CP]: IP, [kP]: sP, [FP]: oP, [LP]: UP, [xP]: vP, [_P]: yP }, d1 = (e) => {
  let t = e != null && e.namedFormat && Object.keys(iS).includes(e.namedFormat) ? e.namedFormat : BP, r = Array.isArray(e == null ? void 0 : e.uuids) ? e == null ? void 0 : e.uuids : [], i, { category: n, gender: a } = (e == null ? void 0 : e.event) ?? {}, o = ce(iS[t], !1, !0), s = (c) => {
    var d, p;
    if (!(e != null && e.isMock) && !((d = e == null ? void 0 : e.event) != null && d.isMock) || !e.event)
      return (r == null ? void 0 : r.pop()) ?? ze();
    let u = (p = e == null ? void 0 : e.event) == null ? void 0 : p.eventId;
    return r.pop() ?? `${u}-COL-${c + 1}`;
  };
  return o.hydrate ? (i = { winCriteria: { valueGoal: o.valueGoal }, collectionDefinitions: [{ collectionId: s(0), matchUpFormat: fP, collectionName: "Doubles", matchUpType: tt, ...o.doubles }, { collectionId: s(1), matchUpFormat: Oi, collectionName: "Singles", matchUpType: rt, ...o.singles }] }, o.tieFormatName && (i.tieFormatName = o.tieFormatName)) : (o.collectionDefinitions.forEach((c, u) => c.collectionId = s(u)), i = o), e != null && e.hydrateCollections && i.collectionDefinitions.forEach((c) => {
    n && !c.category && (c.category = n), a && !c.gender && (c.gender = a);
  }), i;
}, $n = d1, dn = "SINGLES", ko = "SINGLES", Ui = "DOUBLES", qn = "DOUBLES", xt = "TEAM", Xr = "TEAM", l1 = "AGE", p1 = "RATING", m1 = "BOTH", f1 = { AGE: l1, BOTH: m1, DOUBLES: Ui, DOUBLES_EVENT: qn, RATING: p1, SINGLES: dn, SINGLES_EVENT: ko, TEAM_EVENT: Xr, TEAM: xt }, ue = "MAIN", ge = "QUALIFYING", lr = "CONSOLATION", Jt = "VOLUNTARY_CONSOLATION", vt = "PLAY_OFF", sp = [ue, ge, lr, vt, Jt], Fo = { [ge]: 1, [ue]: 2, [vt]: 3, [lr]: 3, [Jt]: 4 }, VP = "finishingPositions", jP = "aggregateEventStructures", GP = { [ue]: 1, [vt]: 2, [lr]: 3, [ge]: 4, [Jt]: 5 }, h1 = { [vt]: 1, [ue]: 2, [lr]: 3, [ge]: 4, [Jt]: 5 }, cp = "CLUSTER", g1 = "SEPARATE", qa = "WATERFALL", up = "ITEM", br = "CONTAINER", Ni = "DRAW", dp = "RANDOM", Ei = "TOP_DOWN", Wa = "BOTTOM_UP", Wn = "POSITION", Hn = "WINNER", An = "LOSER", ln = "FIRST_MATCHUP", si = "AD_HOC", I1 = "AD_HOC", dc = "FEED_IN", Bs = "COMPASS", Vs = "OLYMPIC", U1 = "SINGLE_ELIMINATION", on = "SINGLE_ELIMINATION", Ou = "DOUBLE_ELIMINATION", js = "FIRST_MATCH_LOSER_CONSOLATION", ku = "FIRST_ROUND_LOSER_CONSOLATION", so = "LUCKY_DRAW", lp = "CURTIS_CONSOLATION", y1 = "CURTIS_CONSOLATION", tg = "FEED_IN_CHAMPIONSHIP_TO_SF", tu = "FEED_IN_CHAMPIONSHIP_TO_SF", rg = "FEED_IN_CHAMPIONSHIP_TO_QF", ru = "FEED_IN_CHAMPIONSHIP_TO_QF", ig = "FEED_IN_CHAMPIONSHIP_TO_R16", iu = "FEED_IN_CHAMPIONSHIP_TO_R16", $P = "MODIFIED_FEED_IN_CHAMPIONSHIP", nu = "MODIFIED_FEED_IN_CHAMPIONSHIP", Fu = "FEED_IN_CHAMPIONSHIP", S1 = "DOUBLE_ROUND_ROBIN", Li = "ROUND_ROBIN", En = "ROUND_ROBIN_WITH_PLAYOFF", qP = "DECIDER", WP = "BACKDRAW", ng = { 0: { name: "East", abbreviation: "E" }, "0-1": { name: "West", abbreviation: "W" }, "0-2": { name: "North", abbreviation: "N" }, "0-3": { name: "Northeast", abbreviation: "NE" }, "0-1-1": { name: "South", abbreviation: "S" }, "0-1-2": { name: "Southwest", abbreviation: "SW" }, "0-2-1": { name: "Northwest", abbreviation: "NW" }, "0-1-1-1": { name: "Southeast", abbreviation: "SE" } }, ag = { 0: { name: "East", abbreviation: "E" }, "0-1": { name: "West", abbreviation: "W" }, "0-2": { name: "North", abbreviation: "N" }, "0-1-1": { name: "South", abbreviation: "S" } }, Ha = "WIN_RATIO", Jo = "ROUND_OUTCOME", HP = [Bs, lp, ru, iu, tu, Fu, rg, ig, tg, js, ku, so, nu, Vs, vt, En], v1 = [si, Bs, lp, Ou, ru, iu, tu, Fu, dc, js, ku, so, nu, Vs, vt, Li, En, on], zP = { MAIN: ue, QUALIFYING: ge, CONSOLATION: lr, ITEM: up, CONTAINER: br, FIRST_MATCHUP: ln, WINNER: Hn, LOSER: An, AD_HOC: si, FEED_IN: dc, FLEX_ROUNDS: I1, COMPASS: Bs, PLAY_OFF: vt, OLYMPIC: Vs, KNOCKOUT: U1, SINGLE_ELIMINATION: on, DOUBLE_ELIMINATION: Ou, CURTIS: lp, FICSF: tg, FICQF: rg, FICR16: ig, MFIC: $P, VOLUNTARY_CONSOLATION: Jt, FIRST_MATCH_LOSER_CONSOLATION: js, FIRST_ROUND_LOSER_CONSOLATION: ku, MODIFIED_FEED_IN_CHAMPIONSHIP: nu, FEED_IN_CHAMPIONSHIP_TO_R16: iu, FEED_IN_CHAMPIONSHIP_TO_QF: ru, FEED_IN_CHAMPIONSHIP_TO_SF: tu, FEED_IN_CHAMPIONSHIP: Fu, LUCKY_DRAW: so, ROUND_ROBIN_WITH_PLAYOFF: En, ROUND_ROBIN: Li, DECIDER: qP, BACKDRAW: WP, COMPASS_ATTRIBUTES: ng, OLYMPIC_ATTRIBUTES: ag, DRAW: Ni, RANDOM: dp, TOP_DOWN: Ei, BOTTOM_UP: Wa, WATERFALL: qa, WIN_RATIO: Ha, ROUND_OUTCOME: Jo, MULTI_STRUCTURE_DRAWS: HP, generatedDrawTypes: v1, stageOrder: Fo, finishOrder: GP, AGGREGATE_EVENT_STRUCTURES: jP, FINISHING_POSITIONS: VP }, w1 = zP, gr = "tournamentRecords", og = "policyDefinitions", Gt = "tournamentRecord", sg = "onlineResource", Rr = "drawDefinition", YP = "tieFormatName", cg = "matchUpFormat", Cn = "participantId", KP = "scheduleDates", P1 = "tournamentId", D1 = "scheduleDate", T1 = "roundNumber", pp = "structureId", ug = "participant", xu = "matchUpIds", QP = "entryStage", b1 = "policyType", JP = "structures", dg = "eventType", gn = "matchUpId", mp = "tieFormat", fp = "inContext", hp = "structure", gp = "courtIds", R1 = "personId", Ip = "venueIds", lg = "matchUps", XP = "courtId", ZP = "eventId", Fn = "matchUp", eD = "drawId", ki = "error", ba = "event", lc = "param", pg = "uuids", M1 = "averageMatchUpMinutes", N1 = "recoveryMinutes", A1 = "periodLength", E1 = "number", _r = "object", fr = "array", cr = "_validate", tD = "_message", ci = "_invalid", Or = "_ofType", mg = "_anyOf", Gs = "_oneOf", nS = { [sg]: (e) => wt(Object.keys(e), [xs, Ls, _s]).length === 3, [YP]: (e) => e && $n({ namedFormat: e }), [pg]: (e) => !e || Array.isArray(e) && e.every(ht), [mp]: (e) => !Ar({ tieFormat: e }).error, [dg]: (e) => [dn, Ui, xt].includes(e), [QP]: (e) => sp.includes(e) }, C1 = { [gr]: yt, [Gt]: ae, [og]: ql, [Rr]: le, [Cn]: _t, [cg]: bh, [P1]: Cs, [pp]: ui, [xu]: $o, [ug]: Ho, [sg]: ea, [dg]: Mn, [JP]: Ph, [gn]: Ur, [mp]: wn, [hp]: ao, [XP]: qo, [lg]: Zn, [ZP]: Ii, [Fn]: Vr, [gp]: Ie, [Ip]: Ie, [eD]: tn, [ba]: pt }, O1 = { [gr]: _r, [og]: _r, [Gt]: _r, [Rr]: _r, [sg]: _r, [KP]: fr, [ug]: _r, [xu]: fr, [JP]: fr, [mp]: _r, [hp]: _r, [gp]: fr, [Ip]: fr, [lg]: fr, [Fn]: _r, [ba]: _r, [pg]: fr };
function fe(e, t, r) {
  if (!e && !Le(e))
    return { error: J };
  if (!(t != null && t.length) || e != null && e._bypassParamCheck)
    return { valid: !0 };
  if (!Array.isArray(t))
    return { error: J };
  let { paramError: i, errorParam: n } = x1(e, t);
  if (!i)
    return { valid: !0 };
  let a = i[cr] && (i[ki] || i[ci]) || (e == null ? void 0 : e[n]) === void 0 && (i[ki] || i[ci] || C1[n] || J) || J, o = n ?? (i[Gs] && Object.keys(i[Gs]).join(", "));
  return j({ info: { param: o, message: i[tD] }, result: { error: a }, stack: r });
}
function rD(e, t) {
  let r = Object.keys(e), i = Object.keys(t);
  return wt(r, i);
}
function k1(e, t) {
  if (!t)
    return;
  let r = rD(e, t);
  return r.length !== 1 ? { error: J } : r.reduce((i, n) => ({ ...i, [n]: !0 }), {});
}
function F1(e, t) {
  if (!t)
    return;
  let r = rD(e, t).filter((i) => e[i]);
  return r.length < 1 ? { error: J } : r.reduce((i, n) => ({ ...i, [n]: !0 }), {});
}
function x1(e, t) {
  let r, i;
  return { paramError: t.find(({ _ofType: n, _oneOf: a, _anyOf: o, _validate: s, _info: c, ...u }) => {
    let d = a && k1(e, a);
    if (d != null && d.error)
      return d.error;
    d && Object.assign(u, d);
    let p = o && F1(e, o);
    if (p != null && p.error)
      return p.error;
    p && Object.assign(u, p);
    let l = Object.keys(u).filter((f) => typeof u[f] == "boolean"), m = l.find((f) => {
      let h = s && !Hr(s), g = e[f] !== void 0 && !s && L1(e, f, n), I = u[f] && [void 0, null].includes(e[f]), y = h || g || I || s && e[f] !== void 0 && !_1(e[f], s) || nS[f] && !nS[f](e[f]);
      return y && (r = f, i = c), y;
    });
    return !l.length || m;
  }), errorParam: r, paramInfo: i };
}
function L1(e, t, r) {
  return r = r || O1[t] || "string", r === "array" ? !Array.isArray(e[t]) : typeof e[t] !== r;
}
function _1(e, t) {
  return Hr(t) ? t(e) : !0;
}
var fg = "DYNAMIC", ha = "RANKING", la = "RATING", za = "SCALE", Pn = "SEEDING", B1 = { RANKING: ha, RATING: la, SCALE: za, SEEDING: Pn };
function pc(e) {
  var n;
  let t = fe(e, [{ [ug]: !0 }]);
  if (t.error)
    return t;
  let r = (n = e.participant.timeItems) == null ? void 0 : n.filter(({ itemType: a }) => (a == null ? void 0 : a.startsWith(za)) && [ha, la, Pn].includes(a.split(".")[1])), i = { ratings: {}, rankings: {}, seedings: {} };
  if (r != null && r.length) {
    let a = (s) => r.filter((c) => (c == null ? void 0 : c.itemType) === s).sort((c, u) => new Date(c.createdAt || void 0).getTime() - new Date(u.createdAt || void 0).getTime()).pop(), o = Te(r.map(({ itemType: s }) => s));
    for (let s of o) {
      let c = a(s);
      if (c) {
        let [, u, d, p, l] = c.itemType.split("."), m = l ? `${p}.${l}` : p, f = u === Pn && "seedings" || u === ha && "rankings" || "ratings";
        i[f][d] || (i[f][d] = []), i[f][d].push({ scaleValue: c.itemValue, scaleDate: c.itemDate, scaleName: m });
      }
    }
  }
  return { ...V, ...i };
}
function xo(e) {
  if (e === null)
    return {};
  let { source: t, template: r } = e || {};
  if (!r)
    return t;
  let i = {};
  return n(t, r, i), i;
  function n(a, o, s) {
    if (!a || !o)
      return;
    let c = Object.keys(a), u = Object.keys(o), d = Object.assign({}, ...u.filter((m) => m.indexOf("||")).map((m) => m.split("||").map((f) => ({ [f]: m }))).flat()), p = u.concat(...Object.keys(d)), l = p.includes("*");
    for (let m of c)
      if (p.indexOf(m) >= 0 || l) {
        let f = d[m] || m, h = o[f] || l, g = a[m];
        if (typeof h == "object" && typeof g != "function" && !Array.isArray(h))
          if (Array.isArray(g)) {
            let I = g.map((y) => {
              let U = {};
              return n(y, h, U) !== !1 ? U : void 0;
            }).filter(Boolean);
            s[m] = I;
          } else
            g && (s[m] = {}, n(g, h, s[m]));
        else {
          let I = a[m];
          if (Array.isArray(h) && !h.includes(I))
            return !1;
          (o[m] || l && o[m] !== !1) && (s[m] = I);
        }
      }
  }
}
var Af = "voluntaryConsolation", Bn = "competitiveBands", hg = "roundRobinTally", zn = "positionActions", Xt = "matchUpActions", zd = "rankingPoints", $s = "roundNaming", mc = "participant", au = "progression", Ra = "scheduling", ou = "avoidance", V1 = "participant", j1 = "display", yi = "scoring", Mi = "seeding", qs = "feedIn", G1 = "audit", pl = "draws", $1 = { POLICY_TYPE_VOLUNTARY_CONSOLATION: Af, POLICY_TYPE_COMPETITIVE_BANDS: Bn, POLICY_TYPE_ROUND_ROBIN_TALLY: hg, POLICY_TYPE_POSITION_ACTIONS: zn, POLICY_TYPE_MATCHUP_ACTIONS: Xt, POLICY_TYPE_RANKING_POINTS: zd, POLICY_TYPE_ROUND_NAMING: $s, POLICY_TYPE_PARTICIPANT: mc, POLICY_TYPE_PROGRESSION: au, POLICY_TYPE_SCHEDULING: Ra, POLICY_TYPE_AVOIDANCE: ou, POLICY_TYPE_DISPLAY: j1, POLICY_TYPE_PRIVACY: V1, POLICY_TYPE_FEED_IN: qs, POLICY_TYPE_SCORING: yi, POLICY_TYPE_SEEDING: Mi, POLICY_TYPE_AUDIT: G1, POLICY_TYPE_DRAWS: pl };
function ga({ tournamentParticipants: e = [], policyDefinitions: t = {}, contextProfile: r, participantId: i, internalUse: n, personId: a }) {
  let o = e.find((c) => i && c.participantId === i || a && c.person && c.person.personId === a), s = ce(o, !1, n);
  if (s) {
    let c = t == null ? void 0 : t[mc];
    if (r != null && r.withScaleValues) {
      let { ratings: u, rankings: d } = pc({ participant: s });
      s.rankings = d, s.ratings = u;
    }
    if (c != null && c.participant)
      return xo({ template: c.participant, source: s });
  }
  return s;
}
var q1 = "element required", W1 = "missing name";
function Sr(e) {
  if (!e || typeof e != "object")
    return { error: Ie };
  if (e.element && typeof (e == null ? void 0 : e.element) != "object")
    return { error: J };
  if (!(e != null && e.name))
    return { error: Ie, info: W1 };
  if (!(e != null && e.element)) {
    if (e.discover && e.tournamentRecords) {
      for (let t of Object.keys(e.tournamentRecords)) {
        let r = e.tournamentRecords[t], i = Sr({ element: r, name: e.name });
        if (i.error)
          return j({ result: i, stack: "removeExtension" });
      }
      return { ...V };
    }
    return { error: Ie, info: q1 };
  }
  return e != null && e.element.extensions ? (e.element.extensions = e.element.extensions.filter((t) => (t == null ? void 0 : t.name) !== e.name), { ...V }) : { ...V, info: Zt };
}
function pn({ requiredAttributes: e = ["name", "value"], extension: t }) {
  if (!t || typeof t != "object" || typeof t.name != "string")
    return !1;
  let r = Object.keys(t);
  return e.filter((i) => r.includes(i)).length === e.length;
}
function Ve(e) {
  if (typeof e != "object")
    return { error: Ie };
  let t = "addExtension";
  if (e != null && e.element && typeof e.element != "object")
    return j({ result: { error: J }, stack: t });
  if (!pn({ extension: e.extension }))
    return j({ result: { error: J, info: "invalid extension" }, stack: t });
  if (!e.element)
    if (e.discover && !e.tournamentId && e.tournamentRecords) {
      for (let i of Object.values(e.tournamentRecords)) {
        let n = Ve({ extension: e.extension, element: i });
        if (n.error)
          return j({ result: n, stack: t });
      }
      return { ...V };
    } else
      return j({ result: { error: Ie }, stack: t });
  if (e.element.extensions || (e.element.extensions = []), (e == null ? void 0 : e.creationTime) ?? !0) {
    let i = (/* @__PURE__ */ new Date()).toISOString();
    Object.assign(e.extension, { createdAt: i });
  }
  let r = e.element.extensions.find(({ name: i }) => i === e.extension.name);
  return r ? r.value = e.extension.value : e.extension.value && e.element.extensions.push(e.extension), { ...V };
}
function gg(e) {
  return !e || typeof e != "object" ? { error: Ie } : e.tournamentRecord ? Ve({ creationTime: e.creationTime, element: e.tournamentRecord, extension: e.extension }) : { error: ae };
}
function Up(e) {
  return !e || typeof e != "object" ? { error: Ie } : e.drawDefinition ? Ve({ creationTime: e.creationTime, element: e.drawDefinition, extension: e.extension }) : { error: ai };
}
function Ma(e) {
  return !e || typeof e != "object" ? { error: Ie } : e.event ? Ve({ creationTime: e.creationTime, extension: e.extension, element: e.event }) : { error: Ii };
}
function iD(e) {
  var i;
  if (!e || typeof e != "object")
    return { error: Ie };
  if (!e.participantId)
    return { error: _t };
  let t = ((i = e.tournamentRecord) == null ? void 0 : i.participants) || [], r = ga({ participantId: e.participantId, tournamentParticipants: t });
  return r ? Ve({ creationTime: e.creationTime, extension: e.extension, element: r }) : { error: Dt };
}
function Ig(e) {
  return !e || typeof e != "object" ? { error: Ie } : e.tournamentRecord ? Sr({ element: e.tournamentRecord, name: e.name }) : { error: ae };
}
function nD(e) {
  return !e || typeof e != "object" ? { error: Ie } : e.drawDefinition ? Sr({ element: e.drawDefinition, name: e.name }) : { error: ai };
}
function yp(e) {
  return !e || typeof e != "object" ? { error: Ie } : e != null && e.event ? Sr({ element: e.event, name: e.name }) : { error: Ii };
}
function aD(e) {
  var i;
  if (!e || typeof e != "object")
    return { error: Ie };
  if (!e.participantId)
    return { error: _t };
  let t = ((i = e.tournamentRecord) == null ? void 0 : i.participants) || [], r = ga({ participantId: e.participantId, tournamentParticipants: t });
  return r ? Sr({ element: r, name: e.name }) : { error: Dt };
}
function Lu({ tournamentRecords: e }) {
  return { tournamentIds: Le(e) ? Object.keys(e) : [], ...V };
}
var H1 = "extensionQueries";
function Ne({ discover: e, element: t, name: r, ...i }) {
  var a;
  if (!t || !r) {
    if (e && i) {
      let o = Object.keys(i).filter((u) => typeof e == "boolean" || Array.isArray(e) && e.includes(u)).find((u) => {
        var d;
        return Array.isArray((d = i[u]) == null ? void 0 : d.extensions) ? i[u].extensions.find((p) => (p == null ? void 0 : p.name) === r) : !1;
      }), s = o && i[o];
      !s && i.tournamentRecords && (s = Object.values(i.tournamentRecords).find((u) => {
        var d;
        return (d = u.extensions) == null ? void 0 : d.length;
      }));
      let c = (a = s == null ? void 0 : s.extensions) == null ? void 0 : a.find((u) => (u == null ? void 0 : u.name) === r);
      return { extension: c, info: c ? void 0 : Zt };
    }
    return j({ result: { error: Ie }, stack: H1 });
  }
  if (!Array.isArray(t.extensions))
    return { info: "no extensions" };
  let n = t.extensions.find((o) => (o == null ? void 0 : o.name) === r);
  return { extension: n, info: n ? void 0 : Zt };
}
var z1 = "activeSuspension", su = "appliedPolicies", oD = "context", Sp = "delegatedOutcome", Yi = "disabled", Lo = "disableAutoCalc", vp = "disableLinks", ml = "display", Va = "drawDeletions", Y1 = "drawProfile", fl = "entryProfile", K1 = "eventProfile", Q1 = "eventWithdrawalRequests", J1 = "factory", _i = "flightProfile", Ef = "groupingAttribute", Yn = "lineUps", Ya = "linkedTournamentsIds", wp = "matchUpHistory", Ug = "participantRepresentatives", fc = "personRequests", Ms = "positionActions", X1 = "rankingPoints", Z1 = "registration", In = "roundTarget", _u = "scheduleLimits", Kn = "scheduleTiming", _o = "schedulingProfile", eO = "statusDetail", Ws = "subOrder", Ia = "tally", Bc = "tieFormatModification", sD = { ACTIVE_SUSPENSION: z1, APPLIED_POLICIES: su, CONTEXT: oD, DELEGATED_OUTCOME: Sp, DISABLED: Yi, DISABLE_LINKS: vp, DISABLE_AUTO_CALC: Lo, DISPLAY: ml, DRAW_DELETIONS: Va, DRAW_PROFILE: Y1, ENTRY_PROFILE: fl, EVENT_PROFILE: K1, EVENT_WITHDRAWAL_REQUESTS: Q1, FLIGHT_PROFILE: _i, GROUPING_ATTRIBUTE: Ef, LINEUPS: Yn, LINKED_TOURNAMENTS: Ya, MATCHUP_HISTORY: wp, PARTICIPANT_REPRESENTATIVES: Ug, PERSON_REQUESTS: fc, POSITION_ACTIONS: Ms, RANKING_POINTS: X1, REGISTRATION: Z1, ROUND_TARGET: In, SCHEDULE_LIMITS: _u, SCHEDULE_TIMING: Kn, SCHEDULING_PROFILE: _o, STATUS_DETAIL: eO, SUB_ORDER: Ws, TALLY: Ia, TIE_FORMAT_MODIFICATIONS: Bc, FACTORY: J1 }, aS = [Sp, Yi, Lo, vp, _i, Yn, Ya, wp, Ug, fc, In, _u, Kn, _o, Ws, Ia, Bc];
function cD({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length)
    return { error: yt };
  let t = Lu({ tournamentRecords: e }), { tournamentIds: r } = t;
  return (r == null ? void 0 : r.length) > 1 ? Ve({ tournamentRecords: e, discover: !0, extension: { name: Ya, value: { tournamentIds: r } } }) : { ...V };
}
function uD({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length)
    return { error: yt };
  let t = Sr({ name: Ya, tournamentRecords: e, discover: !0 });
  return j({ result: t, stack: "unlinkTournaments" });
}
function dD({ tournamentRecords: e, tournamentId: t }) {
  if (typeof e != "object")
    return { error: J };
  if (!t)
    return { error: Cs };
  let r = Lu({ tournamentRecords: e }), { tournamentIds: i } = r;
  if (!i.includes(t))
    return { error: Cs };
  let n;
  return i.every((a) => {
    var p;
    let o = e[a], { extension: s } = Ne({ element: o, name: Ya });
    if (!s)
      return !0;
    let c = ((p = s == null ? void 0 : s.value) == null ? void 0 : p.tournamentIds) || [];
    if (!(c != null && c.length) || c.length === 1 && c.includes(t) || a === t) {
      let l = Ig({ name: Ya, tournamentRecord: o });
      return l.error && (n = l.error), l.success;
    }
    let u = c.filter((l) => l !== t);
    s.value = { tournamentIds: u };
    let d = gg({ tournamentRecord: o, extension: s });
    return d.error && (n = d.error), d.success;
  }), n ? { error: n } : { ...V };
}
var lD = {};
Ae(lD, { getLinkedTournamentIds: () => Bu, getTournamentIds: () => Lu });
function Bu({ tournamentRecords: e }) {
  return typeof e != "object" || !Object.keys(e).length ? { error: yt } : { linkedTournamentIds: Object.assign({}, ...Object.keys(e).map((t) => {
    var o;
    let r = e[t], i = r == null ? void 0 : r.tournamentId, { extension: n } = Ne({ element: r, name: Ya }), a = (((o = n == null ? void 0 : n.value) == null ? void 0 : o.tournamentIds) || []).filter((s) => s !== i);
    return { [t]: a };
  })) };
}
var pD = {};
Ae(pD, { adHocPositionSwap: () => rb, addAdHocMatchUps: () => Kp, addDrawDefinitionTimeItem: () => SI, addFinishingRounds: () => ed, addGoesTo: () => Ja, addPlayoffStructures: () => Yp, addQualifyingStructure: () => tb, addVoluntaryConsolationStage: () => KT, addVoluntaryConsolationStructure: () => cI, allPlayoffPositionsFilled: () => UI, alternateDrawPositionAssignment: () => _T, assignDrawPosition: () => Mb, assignDrawPositionBye: () => pi, attachConsolationStructures: () => Db, attachPlayoffStructures: () => LI, attachQualifyingStructure: () => yI, attachStructures: () => zp, autoSeeding: () => Z_, automatedPlayoffPositioning: () => wc, automatedPositioning: () => dd, checkValidEntries: () => Xp, deleteAdHocMatchUps: () => Ab, drawMatic: () => oU, findDrawDefinition: () => GI, generateAdHocMatchUps: () => Zp, generateAdHocRounds: () => aU, generateAndPopulatePlayoffStructures: () => FI, generateDrawDefinition: () => Md, generateDrawMaticRound: () => KI, generateDrawStructuresAndLinks: () => HI, generateDrawTypeAndModifyDrawDefinition: () => zI, generateQualifyingStructure: () => bI, generateVoluntaryConsolation: () => tR, getAssignedParticipantIds: () => ho, getAvailableMatchUpsCount: () => Qp, getAvailablePlayoffProfiles: () => pd, getDrawDefinitionTimeItem: () => Vg, getDrawParticipantRepresentativeIds: () => VI, getDrawStructures: () => Bi, getDrawTypeCoercion: () => Sd, getEligibleVoluntaryConsolationParticipants: () => BI, getMatchUpsMap: () => mr, getParticipantIdFinishingPositions: () => jI, getPositionAssignments: () => fu, getPositionsPlayedOff: () => Pc, getSeedingThresholds: () => pI, getSeedsCount: () => vd, getStructureSeedAssignments: () => Si, getTeamLineUp: () => Qa, getValidGroupSizes: () => cd, isAdHoc: () => Er, isCompletedStructure: () => wa, isValidForQualifying: () => WI, luckyLoserDrawPositionAssignment: () => ET, modifyDrawDefinition: () => Tb, modifyDrawName: () => _I, modifySeedAssignment: () => BT, mutate: () => mD, positionActions: () => qI, pruneDrawDefinition: () => Rb, qualifierDrawPositionAssignment: () => LT, query: () => Ob, removeDrawPositionAssignment: () => pu, removeRoundMatchUps: () => Eb, removeSeededParticipant: () => eb, removeStructure: () => zT, renameStructures: () => HT, resetDrawDefinition: () => bb, resetVoluntaryConsolationStructure: () => ND, setDrawParticipantRepresentativeIds: () => fD, setPositionAssignments: () => FT, setStructureOrder: () => qT, setSubOrder: () => Cb, shiftAdHocRounds: () => kT, swapAdHocRounds: () => xT, swapDrawPositionAssignments: () => XT, updateTeamLineUp: () => ps, withdrawParticipantAtDrawPosition: () => PT });
var mD = {};
Ae(mD, { adHocPositionSwap: () => rb, addAdHocMatchUps: () => Kp, addDrawDefinitionTimeItem: () => SI, addPlayoffStructures: () => Yp, addQualifyingStructure: () => tb, addVoluntaryConsolationStage: () => KT, addVoluntaryConsolationStructure: () => cI, alternateDrawPositionAssignment: () => _T, assignDrawPosition: () => Mb, assignDrawPositionBye: () => pi, attachConsolationStructures: () => Db, attachPlayoffStructures: () => LI, attachQualifyingStructure: () => yI, attachStructures: () => zp, automatedPlayoffPositioning: () => wc, automatedPositioning: () => dd, deleteAdHocMatchUps: () => Ab, luckyLoserDrawPositionAssignment: () => ET, modifyDrawDefinition: () => Tb, modifyDrawName: () => _I, modifySeedAssignment: () => BT, pruneDrawDefinition: () => Rb, qualifierDrawPositionAssignment: () => LT, removeDrawPositionAssignment: () => pu, removeRoundMatchUps: () => Eb, removeSeededParticipant: () => eb, removeStructure: () => zT, renameStructures: () => HT, resetDrawDefinition: () => bb, resetVoluntaryConsolationStructure: () => ND, setDrawParticipantRepresentativeIds: () => fD, setPositionAssignments: () => FT, setStructureOrder: () => qT, setSubOrder: () => Cb, shiftAdHocRounds: () => kT, swapAdHocRounds: () => xT, swapDrawPositionAssignments: () => XT, updateTeamLineUp: () => ps, withdrawParticipantAtDrawPosition: () => PT });
var yg = (e) => (t) => e[t], Sg = (e = []) => e.map(Ht).filter(Boolean), Cf = (e = []) => e.map(Ce).filter(Boolean), Ce = (e = {}) => yg(e)("participantId"), Ht = (e = {}) => yg(e)("matchUpId"), cu = (e = {}) => yg(e)("drawId");
function fD({ representativeParticipantIds: e, drawDefinition: t }) {
  if (!t)
    return { error: ai };
  if (!Array.isArray(e))
    return { error: J };
  let r = Cf((t == null ? void 0 : t.entries) || []);
  return e.length && wt(e, r).length < e.length ? { error: J } : Up({ drawDefinition: t, extension: { name: Ug, value: e } });
}
var Gr = "ABANDONED", Xo = "AWAITING_RESULT", $e = "BYE", Un = "CANCELLED", Tt = "COMPLETED", hc = "DEAD_RUBBER", ke = "DEFAULTED", Lt = "DOUBLE_DEFAULT", Et = "DOUBLE_WALKOVER", Gi = "IN_PROGRESS", Zr = "INCOMPLETE", vg = "NOT_PLAYED", nr = "RETIRED", Na = "SUSPENDED", Rt = "TO_BE_PLAYED", Be = "WALKOVER", tO = [Xo, Tt, ke, Gi, Zr, nr, Na], hD = [Xo, Tt, ke, Et, Lt, Gi, Zr, nr, Na, Be], gD = [Gr, Xo, $e, Un, Tt, hc, ke, Et, Lt, Gi, Zr, vg, nr, Na, Rt, Be], ID = [$e, Et, Lt, Tt, ke, nr, Be], UD = [Gr, Xo, Un, hc, Gi, Zr, vg, Na, Rt, void 0], Vt = [Un, Gr, Tt, hc, ke, Et, Lt, nr, Be], wg = [Gr, Tt, ke, Et, Lt, Gi, nr, Be], yD = [Gi, Zr, Na, Rt], SD = { ABANDONED: Gr, AWAITING_RESULT: Xo, BYE: $e, CANCELLED: Un, COMPLETED: Tt, DEAD_RUBBER: hc, DEFAULTED: ke, DOUBLE_WALKOVER: Et, DOUBLE_DEFAULT: Lt, IN_PROGRESS: Gi, INCOMPLETE: Zr, NOT_PLAYED: vg, RETIRED: nr, SUSPENDED: Na, TO_BE_PLAYED: Rt, WALKOVER: Be };
function Zo(e, t, r) {
  var p, l;
  let i = (m) => {
    var f, h;
    return (h = (f = Ne({ element: m, name: In })) == null ? void 0 : f.extension) == null ? void 0 : h.value;
  }, n = r == null ? void 0 : r.deprioritizeCompleted, a = (r == null ? void 0 : r.mode) === jP && h1, o = (r == null ? void 0 : r.mode) === VP && GP, s = o || a || Fo, c = (m) => (m == null ? void 0 : m.stage) === ue && (m == null ? void 0 : m.stageSequence) === 1, u = (m) => c(m) ? -1 : s[m == null ? void 0 : m.stage], d = (m) => m == null ? void 0 : m.matchUps.every(({ matchUpStatus: f }) => Vt.includes(f) ? 1 : -1);
  return n && d(e) - d(t) || a && u(e) - u(t) || ((e == null ? void 0 : e.stage) && s[e.stage] || 0) - ((t == null ? void 0 : t.stage) && s[t.stage] || 0) || (i(e) || 0) - (i(t) || 0) || !o && !a && (((p = t == null ? void 0 : t.positionAssignments) == null ? void 0 : p.length) ?? 1 / 0) - (((l = e == null ? void 0 : e.positionAssignments) == null ? void 0 : l.length) ?? 1 / 0) || ((e == null ? void 0 : e.stageSequence) ?? 0) - ((t == null ? void 0 : t.stageSequence) ?? 0) || (hl(e) || 0) - (hl(t) || 0);
}
function hl(e) {
  return ((e == null ? void 0 : e.matchUps) || []).reduce((t, r) => {
    var n;
    let i = (((n = r.finishingPositionRange) == null ? void 0 : n.winner) || []).reduce((a, o) => a + o, 0);
    return !t || i < t ? i : t;
  }, void 0);
}
function ve(e) {
  let t = fe(e, [{ [Rr]: !0, [pp]: !0 }]);
  if (t.error)
    return t;
  let { drawDefinition: r, structureId: i } = e, { structures: n } = Bi({ drawDefinition: r }), a = n == null ? void 0 : n.map((c) => c.structures ? [...c.structures].concat(c) : c).flat(), o = a == null ? void 0 : a.find((c) => c.structureId === i);
  if (!o)
    return { error: It };
  let s = o.structureType === up ? a == null ? void 0 : a.find((c) => {
    var u;
    return (u = c.structures) == null ? void 0 : u.some((d) => d.structureId === i);
  }) : void 0;
  return { structure: o, containingStructure: s };
}
function Bi({ withStageGrouping: e, drawDefinition: t, stageSequences: r, stageSequence: i, roundTarget: n, sortConfig: a, stages: o, stage: s }) {
  var f;
  let c = !t && le || !(t != null && t.structures) && Ph || void 0;
  if (c)
    return { error: c, structures: [], stageStructures: {} };
  let u = (h) => {
    var I, y;
    let g = (y = (I = Ne({ element: h, name: In })) == null ? void 0 : I.extension) == null ? void 0 : y.value;
    return !n || n === g;
  }, d = ((f = t == null ? void 0 : t.structures) == null ? void 0 : f.filter(l).filter(m).filter(u).sort((h, g) => Zo(h, g, a))) ?? [], p = e ? Object.assign({}, ...sp.map((h) => {
    let g = d == null ? void 0 : d.filter((I) => I.stage === h);
    return (g == null ? void 0 : g.length) && { [h]: g };
  }).filter(Boolean)) : {};
  return { structures: d, stageStructures: p };
  function l(h) {
    return !s && !Array.isArray(o) || s && h.stage === s || Array.isArray(o) && o.includes(h.stage);
  }
  function m(h) {
    return !i && !Array.isArray(r) || i && h.stageSequence === i || Array.isArray(r) && r.includes(h.stageSequence);
  }
}
function vD({ drawDefinition: e }) {
  if (!e)
    return { error: le };
  let t = {};
  return { allPositionedParticipantIds: (e.structures || []).map((r) => {
    let i = r.stage;
    t[i] || (t[i] = []);
    let { positionAssignments: n } = ot({ structure: r }), a = (n == null ? void 0 : n.map(Ce).filter(Boolean)) ?? [];
    return t[i].push(...a), a;
  }).flat(), stagePositionedParticipantIds: t };
}
function ot({ drawDefinition: e, structureId: t, structure: r }) {
  let i, n = [];
  if (!r) {
    if (!e)
      return { positionAssignments: n, error: le };
    if ({ structure: r, error: i } = ve({ drawDefinition: e, structureId: t }), i)
      return { positionAssignments: n, error: i };
  }
  return r.structures ? n = [].concat(...r.structures.map((a) => ot({ structure: a }).positionAssignments)) : r.positionAssignments ? n = r.positionAssignments : i = Qv, { positionAssignments: n, error: i };
}
function Yt({ drawDefinition: e, structureId: t, structure: r }) {
  var u;
  let i = ((u = ot({ drawDefinition: e, structureId: t, structure: r })) == null ? void 0 : u.positionAssignments) || [], n = i == null ? void 0 : i.filter((d) => d.participantId ?? d.bye ?? d.qualifier), a = i && (i == null ? void 0 : i.length) === (n == null ? void 0 : n.length), o = i == null ? void 0 : i.filter((d) => !d.participantId && !d.bye && !d.qualifier), s = i == null ? void 0 : i.filter((d) => !d.participantId && d.bye), c = i == null ? void 0 : i.filter((d) => !d.participantId && d.qualifier);
  return { allPositionsAssigned: a, positionAssignments: i, unassignedPositions: o, assignedPositions: n, qualifierPositions: c, byePositions: s };
}
var Pg = "addDrawDefinition", Pp = "addMatchUps", Ua = "addParticipants", Dg = "addScaleItems", wD = "addEvent", Tg = "addVenue", jn = "audit", bg = "dataIssue", Rg = "deleteParticipants", Mg = "deleteVenue", Ng = "deletedDrawIds", Ag = "deletedMatchUpIds", Eg = "modifyDrawDefinition", PD = "modifyDrawEntries", DD = "modifyEventEntries", Cg = "modifyMatchUp", pr = "modifyParticipants", Og = "modifyPositionAssignments", kg = "modifySeedAssignments", co = "modifyTournamentDetail", uo = "modifyVenue", Of = "mutations", kf = "publishEvent", TD = "publishEventSeeding", bD = "publishOrderOfPlay", RD = "publishParticipants", Fg = "unPublishEvent", xg = "unPublishEventSeeding", Lg = "unPublishOrderOfPlay", rO = "unPublishParticipants", Dp = "updateInContextMatchUp", iO = { ADD_DRAW_DEFINITION: Pg, ADD_MATCHUPS: Pp, ADD_PARTICIPANTS: Ua, ADD_SCALE_ITEMS: Dg, ADD_EVENT: wD, ADD_VENUE: Tg, AUDIT: jn, DATA_ISSUE: bg, DELETE_PARTICIPANTS: Rg, DELETE_VENUE: Mg, DELETED_DRAW_IDS: Ng, DELETED_MATCHUP_IDS: Ag, MODIFY_DRAW_DEFINITION: Eg, MODIFY_DRAW_ENTRIES: PD, MODIFY_EVENT_ENTRIES: DD, MODIFY_MATCHUP: Cg, MODIFY_PARTICIPANTS: pr, MODIFY_POSITION_ASSIGNMENTS: Og, MODIFY_SEED_ASSIGNMENTS: kg, MODIFY_TOURNAMENT_DETAIL: co, MODIFY_VENUE: uo, MUTATIONS: Of, PUBLISH_EVENT_SEEDING: TD, PUBLISH_EVENT: kf, PUBLISH_ORDER_OF_PLAY: bD, PUBLISH_PARTICIPANTS: RD, UNPUBLISH_EVENT_SEEDING: xg, UNPUBLISH_EVENT: Fg, UNPUBLISH_ORDER_OF_PLAY: Lg, UPDATE_INCONTEXT_MATCHUP: Dp };
function Tp(e, t) {
  var a;
  if (!e)
    return { error: le };
  let r = Date.now();
  e.updatedAt && r === new Date(e.updatedAt).getTime() && (r += 1);
  let i = new Date(r).toISOString(), n = t == null ? void 0 : t.filter(Boolean);
  return e.updatedAt = i, (a = e.structures) == null || a.filter(Boolean).forEach((o) => {
    (!(n != null && n.length) || n != null && n.includes(o.structureId)) && (o.updatedAt = i);
  }), { ...V };
}
function ya({ drawDefinition: e, tournamentId: t, matchUps: r, eventId: i }) {
  return e && Tp(e), De({ payload: { matchUps: r, tournamentId: t, eventId: i }, topic: Pp }), { ...V };
}
function ta({ drawDefinition: e, tournamentId: t, matchUpIds: r, eventId: i, action: n }) {
  e && Tp(e), De({ topic: Ag, payload: { tournamentId: t, matchUpIds: r, eventId: i, action: n } });
  for (let a of r)
    Hh({ key: a });
  return { ...V };
}
function xe({ drawDefinition: e, tournamentId: t, structureId: r, context: i, eventId: n, matchUp: a }) {
  return a ? (e && ut({ drawDefinition: e, structureIds: r ? [r] : void 0, tournamentId: t, eventId: n }), De({ topic: Cg, payload: { matchUp: a, tournamentId: t, context: i }, key: a.matchUpId }), { ...V }) : (console.log(Vr), { error: Vr });
}
function nO({ tournamentId: e, inContextMatchUp: t }) {
  return t ? (De({ payload: { inContextMatchUp: t, tournamentId: e }, topic: Dp, key: t.matchUpId }), { ...V }) : { error: Vr };
}
function Vu({ tournamentId: e, eventId: t, drawDefinition: r }) {
  return r ? (Tp(r), De({ payload: { drawDefinition: r, tournamentId: e, eventId: t }, topic: Pg, key: r.drawId }), { ...V }) : (console.log(le), { error: le });
}
function aO({ tournamentId: e, eventId: t, drawId: r }) {
  return De({ payload: { drawId: r, tournamentId: e, eventId: t }, topic: Ng, key: r }), Hh({ key: r }), { ...V };
}
function ut({ drawDefinition: e, tournamentId: t, structureIds: r, eventId: i }) {
  return e ? (Tp(e, r), De({ payload: { tournamentId: t, eventId: i, drawDefinition: e }, topic: Eg, key: e.drawId }), { ...V }) : { error: le };
}
function MD({ drawDefinition: e, tournamentId: t, structure: r, eventId: i }) {
  if (!e)
    return { error: le };
  if (!r)
    return { error: ao };
  let n = r.seedAssignments, a = r.structureId, o = e.drawId;
  return De({ payload: { tournamentId: t, eventId: i, drawId: o, structureId: a, seedAssignments: n }, topic: kg, key: e.drawId }), ut({ structureIds: [a], drawDefinition: e, tournamentId: t, eventId: i }), { ...V };
}
function Sa({ drawDefinition: e, tournamentId: t, structure: r, event: i }) {
  if (!e)
    return { error: le };
  if (!r)
    return { error: ao };
  let n = ot({ structure: r }), a = r.structureId, o = e.drawId, s = i == null ? void 0 : i.eventId;
  return De({ topic: Og, payload: { positionAssignments: n, tournamentId: t, structureId: a, eventId: s, drawId: o }, key: a }), ut({ structureIds: [a], drawDefinition: e, tournamentId: t, eventId: s }), { ...V };
}
function ND({ tournamentRecord: e, drawDefinition: t, resetEntries: r, event: i }) {
  var o, s;
  if (!t)
    return { error: le };
  let n = (o = t.structures) == null ? void 0 : o.find((c) => c.stage === Jt);
  if (!n)
    return { error: It };
  let a = ((s = n.matchUps) == null ? void 0 : s.map(({ matchUpId: c }) => c)) || [];
  return n.positionAssignments = [], n.seedAssignments = [], n.matchUps = [], ta({ tournamentId: e == null ? void 0 : e.tournamentId, action: "resetVoluntaryConsolationStructure", matchUpIds: a, drawDefinition: t }), r && (t.entries = t.entries.filter((c) => c.entryStage !== Jt)), ut({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: i == null ? void 0 : i.eventId, drawDefinition: t, structureIds: [n.structureId] }), { ...V };
}
function _g({ drawPositions: e, structure: t }) {
  var i;
  if ([ge, ue].includes(t.stage) && t.stageSequence === 1)
    return;
  let { positionAssignments: r } = ot({ structure: t });
  (i = r == null ? void 0 : r.filter(({ drawPosition: n }) => e == null ? void 0 : e.includes(n))) == null || i.forEach((n) => {
    Ve({ element: n, extension: { name: vp, value: !0 } });
  });
}
function bp(e) {
  var s, c;
  let { appliedPolicies: t, positionAction: r, drawDefinition: i } = e;
  if (((s = t == null ? void 0 : t.audit) == null ? void 0 : s[Ms]) === !1)
    return;
  let { extension: n } = Ne({ name: Ms, element: i }), a = Array.isArray(n == null ? void 0 : n.value) ? (n == null ? void 0 : n.value) ?? [] : [];
  if (!(a != null && a.length)) {
    let u = i.structures.find((d) => d.stage === ue);
    if (u) {
      let d = (c = ot({ structure: u }).positionAssignments) == null ? void 0 : c.map(({ drawPosition: p, participantId: l, bye: m, qualifier: f }) => ({ drawPosition: p, participantId: l, qualifier: f, bye: m }));
      a.push({ name: "initialMainAssignments", initialAssignments: d });
    }
  }
  let o = { value: a.concat(r), name: Ms };
  Ve({ element: i, extension: o });
}
function gc({ tournamentRecord: e, drawDefinition: t, event: r }) {
  var s;
  let i = ((s = (e == null ? void 0 : e.events) || r && [r]) == null ? void 0 : s.map((c) => c == null ? void 0 : c.drawDefinitions).flat().filter(Boolean)) || t && [t] || [], n = {}, a = {}, o = i.map((c) => {
    var u;
    return (u = c == null ? void 0 : c.structures) == null ? void 0 : u.filter((d) => d == null ? void 0 : d.structures);
  }).flat().filter(Boolean);
  for (let c of o) {
    let { structures: u, structureId: d } = c ?? {};
    u && d && (n[d] = u == null ? void 0 : u.map((p) => p.structureId)) && u.forEach((p) => a[p.structureId] = c == null ? void 0 : c.structureId);
  }
  return { containedStructures: n, containerStructures: a };
}
function Rp(e) {
  var a;
  let { sides: t, matchUpType: r } = e || {}, i = (a = e.potentialParticipants) != null && a.length ? e.potentialParticipants.flat().map((o) => r === tt ? (o == null ? void 0 : o.individualParticipantIds) || [] : o.participantId).flat() : [], n = (t || []).map((o) => {
    var s;
    return r === tt && (((s = o == null ? void 0 : o.participant) == null ? void 0 : s.individualParticipantIds) || []) || (o == null ? void 0 : o.participantId) && [o.participantId] || [];
  }).flat();
  return { individualParticipantIds: n.concat(i).flat(), enteredIndividualParticipantIds: n, potentialIndividualParticipantIds: i };
}
function wi(e) {
  return (e == null ? void 0 : e.tournamentRecords) ?? ((e == null ? void 0 : e.tournamentRecord) && { [e.tournamentRecord.tournamentId]: e.tournamentRecord }) ?? {};
}
var ju = "SIGN_IN_STATUS", AD = "SIGNED_OUT", uu = "SIGNED_IN", Nr = "TEAM", Oe = "INDIVIDUAL", di = "GROUP", Re = "PAIR", Xe = "TEAM", Vc = { TEAM_PARTICIPANT: Nr, INDIVIDUAL: Oe, GROUP: di, TEAM: Xe, PAIR: Re }, oO = { INDIVIDUAL: Oe, GROUP: di, PAIR: Re, TEAM: Xe, SIGN_IN_STATUS: ju, SIGNED_OUT: AD, SIGNED_IN: uu };
function Bg({ participantsProfile: e, participants: t = [], deepCopy: r }) {
  let i = /* @__PURE__ */ new Map(), n = r !== !1 ? ce(t, e == null ? void 0 : e.convertExtensions, !0) : t, a = n.filter((c) => c.participantType === Xe), o = n.filter((c) => c.participantType === di), s = n.filter((c) => c.participantType === Re);
  return n.forEach((c) => {
    if (c.participantType === Oe) {
      let { participantId: u } = c;
      c.groupParticipantIds = [], c.teamParticipantIds = [], c.pairParticipantIds = [], c.groups = [], c.teams = [], a.forEach((d) => {
        ((d == null ? void 0 : d.individualParticipantIds) || []).forEach((p) => {
          var l;
          p === u && !((l = c.teamParticipantIds) != null && l.includes(d.participantId)) && (c.teamParticipantIds.push(d.participantId), i.get(d.participantId) || i.set(d.participantId, { participantName: d.participantName, participantId: d.participantId }), c.teams.push({ participantRoleResponsibilities: d.participantRoleResponsibilities, participantOtherName: d.participantOtherName, participantName: d.participantName, participantId: d.participantId, teamId: d.teamId }));
        });
      }), s.forEach((d) => {
        ((d == null ? void 0 : d.individualParticipantIds) || []).forEach((p) => {
          p === u && !c.pairParticipantIds.includes(d.participantId) && c.pairParticipantIds.push(d.participantId);
        });
      }), o.forEach((d) => {
        ((d == null ? void 0 : d.individualParticipantIds) || []).forEach((p) => {
          p === u && !c.groupParticipantIds.includes(d.participantId) && (c.groupParticipantIds.push(d.participantId), c.groups.push({ participantRoleResponsibilities: d.participantRoleResponsibilities, participantOtherName: d.participantOtherName, participantName: d.participantName, participantId: d.participantId }));
        });
      });
    }
  }), { participantsWithGroupings: n, groupInfo: Object.fromEntries(i) };
}
function ED(e) {
  return e && typeof String.fromCodePoint < "u" ? e.toUpperCase().replace(/./g, (t) => String.fromCodePoint(t.charCodeAt(0) + 127397)) : e;
}
function sO(e) {
  let t = Object.assign({}, ...pa.filter((r) => r.ioc).map((r) => ({ [r.ioc]: r.iso })));
  return ED(t[e]);
}
var pa = [{ ioc: "", iso2: "", iso: "", label: "NONE", phone: "" }, { ioc: "AND", iso2: "AD", iso: "AND", label: "Andorra", phone: "376" }, { ioc: "UAE", iso2: "AE", iso: "ARE", label: "United Arab Emirates", phone: "971" }, { ioc: "AFG", iso2: "AF", iso: "AFG", label: "Afghanistan", phone: "93" }, { ioc: "ANT", iso2: "AG", iso: "ATG", label: "Antigua and Barbuda", phone: "1-268" }, { ioc: "AIA", iso2: "AI", iso: "AIA", label: "Anguilla", phone: "1-264" }, { ioc: "ALB", iso2: "AL", iso: "ALB", label: "Albania", phone: "355" }, { ioc: "ARM", iso2: "AM", iso: "ARM", label: "Armenia", phone: "374" }, { ioc: "ANG", iso2: "AO", iso: "AGO", label: "Angola", phone: "244" }, { ioc: "", iso2: "AQ", iso: "ATA", label: "Antarctica", phone: "672" }, { ioc: "ARG", iso2: "AR", iso: "ARG", label: "Argentina", phone: "54" }, { ioc: "ASA", iso2: "AS", iso: "ASM", label: "American Samoa", phone: "1-684" }, { ioc: "AUT", iso2: "AT", iso: "AUT", label: "Austria", phone: "43" }, { ioc: "AUS", iso2: "AU", iso: "AUS", label: "Australia", phone: "61", suggested: !0 }, { ioc: "ARU", iso2: "AW", iso: "ABW", label: "Aruba", phone: "297" }, { ioc: "AZE", iso2: "AZ", iso: "AZE", label: "Azerbaijan", phone: "994" }, { ioc: "BIH", iso2: "BA", iso: "BIH", label: "Bosnia and Herzegovina", phone: "387" }, { ioc: "BAR", iso2: "BB", iso: "BRB", label: "Barbados", phone: "1-246" }, { ioc: "BAN", iso2: "BD", iso: "BGD", label: "Bangladesh", phone: "880" }, { ioc: "BEL", iso2: "BE", iso: "BEL", label: "Belgium", phone: "32" }, { ioc: "BUR", iso2: "BF", iso: "BFA", label: "Burkina Faso", phone: "226" }, { ioc: "BUL", iso2: "BG", iso: "BGR", label: "Bulgaria", phone: "359" }, { ioc: "BRN", iso2: "BH", iso: "BHR", label: "Bahrain", phone: "973" }, { ioc: "BDI", iso2: "BI", iso: "BDI", label: "Burundi", phone: "257" }, { ioc: "BEN", iso2: "BJ", iso: "BEN", label: "Benin", phone: "229" }, { ioc: "", iso2: "BL", iso: "BLM", label: "Saint Barthelemy", phone: "590" }, { ioc: "BER", iso2: "BM", iso: "BMU", label: "Bermuda", phone: "1-441" }, { ioc: "BRU", iso2: "BN", iso: "BRN", label: "Brunei Darussalam", phone: "673" }, { ioc: "BOL", iso2: "BO", iso: "BOL", label: "Bolivia", phone: "591" }, { ioc: "BRA", iso2: "BR", iso: "BRA", label: "Brazil", phone: "55" }, { ioc: "BAH", iso2: "BS", iso: "BHS", label: "Bahamas", phone: "1-242" }, { ioc: "BHU", iso2: "BT", iso: "BTN", label: "Bhutan", phone: "975" }, { ioc: "", iso2: "BV", iso: "BVT", label: "Bouvet Island", phone: "47" }, { ioc: "BOT", iso2: "BW", iso: "BWA", label: "Botswana", phone: "267" }, { ioc: "BLR", iso2: "BY", iso: "BLR", label: "Belarus", phone: "375" }, { ioc: "BIZ", iso2: "BZ", iso: "BLZ", label: "Belize", phone: "501" }, { ioc: "CAN", iso2: "CA", iso: "CAN", label: "Canada", phone: "1", suggested: !0 }, { ioc: "", iso2: "CC", iso: "CCK", label: "Cocos (Keeling) Islands", phone: "61" }, { ioc: "CGO", iso2: "CD", iso: "COG", label: "Congo, Republic of the", phone: "242" }, { ioc: "CAF", iso2: "CF", iso: "CAF", label: "Central African Republic", phone: "236" }, { ioc: "COD", iso2: "CG", iso: "CGD", label: "Congo, Democratic Republic of the", phone: "243" }, { ioc: "SUI", iso2: "CH", iso: "CHE", label: "Switzerland", phone: "41" }, { ioc: "CIV", iso2: "CI", iso: "CIV", label: "Cote d'Ivoire", phone: "225" }, { ioc: "COK", iso2: "CK", iso: "COK", label: "Cook Islands", phone: "682" }, { ioc: "CHI", iso2: "CL", iso: "CHL", label: "Chile", phone: "56" }, { ioc: "CMR", iso2: "CM", iso: "CMR", label: "Cameroon", phone: "237" }, { ioc: "CHN", iso2: "CN", iso: "CHN", label: "China", phone: "86" }, { ioc: "COL", iso2: "CO", iso: "COL", label: "Colombia", phone: "57" }, { ioc: "CRC", iso2: "CR", iso: "CRI", label: "Costa Rica", phone: "506" }, { ioc: "CUB", iso2: "CU", iso: "CUB", label: "Cuba", phone: "53" }, { ioc: "CPV", iso2: "CV", iso: "CPV", label: "Cape Verde", phone: "238" }, { ioc: "CUW", iso2: "CW", iso: "CUW", label: "Curacao", phone: "599" }, { ioc: "CXR", iso2: "CX", iso: "CXR", label: "Christmas Island", phone: "61" }, { ioc: "CYP", iso2: "CY", iso: "CYP", label: "Cyprus", phone: "357" }, { ioc: "CZE", iso2: "CZ", iso: "CZE", label: "Czech Republic", phone: "420" }, { ioc: "GER", iso2: "DE", iso: "DEU", label: "Germany", phone: "49", suggested: !0 }, { ioc: "DJI", iso2: "DJ", iso: "DJI", label: "Djibouti", phone: "253" }, { ioc: "DEN", iso2: "DK", iso: "DNK", label: "Denmark", phone: "45" }, { ioc: "DMA", iso2: "DM", iso: "DMA", label: "Dominica", phone: "1-767" }, { ioc: "DOM", iso2: "DO", iso: "DOM", label: "Dominican Republic", phone: "1-809" }, { ioc: "ALG", iso2: "DZ", iso: "DZA", label: "Algeria", phone: "213" }, { ioc: "ECU", iso2: "EC", iso: "ECU", label: "Ecuador", phone: "593" }, { ioc: "EST", iso2: "EE", iso: "ESE", label: "Estonia", phone: "372" }, { ioc: "EGY", iso2: "EG", iso: "EGY", label: "Egypt", phone: "20" }, { ioc: "", iso2: "EH", iso: "ESH", label: "Western Sahara", phone: "212" }, { ioc: "ERI", iso2: "ER", iso: "ERI", label: "Eritrea", phone: "291" }, { ioc: "ESP", iso2: "ES", iso: "ESP", label: "Spain", phone: "34" }, { ioc: "ETH", iso2: "ET", iso: "ETH", label: "Ethiopia", phone: "251" }, { ioc: "FIN", iso2: "FI", iso: "FIN", label: "Finland", phone: "358" }, { ioc: "FIJ", iso2: "FJ", iso: "FJI", label: "Fiji", phone: "679" }, { ioc: "FLK", iso2: "FK", iso: "FLK", label: "Falkland Islands (Malvinas)", phone: "500" }, { ioc: "FSM", iso2: "FM", iso: "FSM", label: "Micronesia, Federated States of", phone: "691" }, { ioc: "FAR", iso2: "FO", iso: "FRO", label: "Faroe Islands", phone: "298" }, { ioc: "FRA", iso2: "FR", iso: "FRA", label: "France", phone: "33", suggested: !0 }, { ioc: "GAB", iso2: "GA", iso: "GAB", label: "Gabon", phone: "241" }, { ioc: "GBR", iso2: "GB", iso: "GBR", label: "United Kingdom", phone: "44" }, { ioc: "GRN", iso2: "GD", iso: "GRD", label: "Grenada", phone: "1-473" }, { ioc: "GEO", iso2: "GE", iso: "GEO", label: "Georgia", phone: "995" }, { ioc: "FGU", iso2: "GF", iso: "GUF", label: "French Guiana", phone: "594" }, { ioc: "", iso2: "GG", iso: "GGY", label: "Guernsey", phone: "44" }, { ioc: "", iso2: "GH", iso: "GHA", label: "Ghana", phone: "233" }, { ioc: "GIB", iso2: "GI", iso: "GIB", label: "Gibraltar", phone: "350" }, { ioc: "GRL", iso2: "GL", iso: "GRL", label: "Greenland", phone: "299" }, { ioc: "GAM", iso2: "GM", iso: "GMB", label: "Gambia", phone: "220" }, { ioc: "GUI", iso2: "GN", iso: "GIN", label: "Guinea", phone: "224" }, { ioc: "GUD", iso2: "GP", iso: "GLP", label: "Guadeloupe", phone: "590" }, { ioc: "GEQ", iso2: "GQ", iso: "GNQ", label: "Equatorial Guinea", phone: "240" }, { ioc: "GRE", iso2: "GR", iso: "GRC", label: "Greece", phone: "30" }, { ioc: "", iso2: "GS", iso: "SGS", label: "South Georgia and the South Sandwich Islands", phone: "500" }, { ioc: "GUA", iso2: "GT", iso: "GTM", label: "Guatemala", phone: "502" }, { ioc: "GUM", iso2: "GU", iso: "GUM", label: "Guam", phone: "1-671" }, { ioc: "GBS", iso2: "GW", iso: "GNB", label: "Guinea-Bissau", phone: "245" }, { ioc: "GUY", iso2: "GY", iso: "GUY", label: "Guyana", phone: "592" }, { ioc: "HKG", iso2: "HK", iso: "HKG", label: "Hong Kong", phone: "852" }, { ioc: "", iso2: "HM", iso: "HMD", label: "Heard Island and McDonald Islands", phone: "672" }, { ioc: "HON", iso2: "HN", iso: "HND", label: "Honduras", phone: "504" }, { ioc: "CRO", iso2: "HR", iso: "HRV", label: "Croatia", phone: "385" }, { ioc: "HAI", iso2: "HT", iso: "HTI", label: "Haiti", phone: "509" }, { ioc: "HUN", iso2: "HU", iso: "HUN", label: "Hungary", phone: "36" }, { ioc: "INA", iso2: "ID", iso: "IDN", label: "Indonesia", phone: "62" }, { ioc: "IRL", iso2: "IE", iso: "IRL", label: "Ireland", phone: "353" }, { ioc: "ISR", iso2: "IL", iso: "ISR", label: "Israel", phone: "972" }, { ioc: "", iso2: "IM", iso: "IMN", label: "Isle of Man", phone: "44" }, { ioc: "IND", iso2: "IN", iso: "IND", label: "India", phone: "91" }, { ioc: "", iso2: "IO", iso: "IOT", label: "British Indian Ocean Territory", phone: "246" }, { ioc: "IRQ", iso2: "IQ", iso: "IRQ", label: "Iraq", phone: "964" }, { ioc: "IRI", iso2: "IR", iso: "IRN", label: "Iran, Islamic Republic of", phone: "98" }, { ioc: "ISL", iso2: "IS", iso: "ISL", label: "Iceland", phone: "354" }, { ioc: "ITA", iso2: "IT", iso: "ITA", label: "Italy", phone: "39" }, { ioc: "", iso2: "JE", iso: "JEY", label: "Jersey", phone: "44" }, { ioc: "JAM", iso2: "JM", iso: "JAM", label: "Jamaica", phone: "1-876" }, { ioc: "JOR", iso2: "JO", iso: "JOR", label: "Jordan", phone: "962" }, { ioc: "JPN", iso2: "JP", iso: "JPN", label: "Japan", phone: "81", suggested: !0 }, { ioc: "KEN", iso2: "KE", iso: "KEN", label: "Kenya", phone: "254" }, { ioc: "KGZ", iso2: "KG", iso: "KGZ", label: "Kyrgyzstan", phone: "996" }, { ioc: "CAM", iso2: "KH", iso: "KHM", label: "Cambodia", phone: "855" }, { ioc: "KIR", iso2: "KI", iso: "KIR", label: "Kiribati", phone: "686" }, { ioc: "COM", iso2: "KM", iso: "COM", label: "Comoros", phone: "269" }, { ioc: "SKN", iso2: "KN", iso: "KNA", label: "Saint Kitts and Nevis", phone: "1-869" }, { ioc: "KOR", iso2: "KP", iso: "KOR", label: "Korea, Democratic People's Republic of", phone: "850" }, { ioc: "PRK", iso2: "KR", iso: "PRK", label: "Korea, Republic of", phone: "82" }, { ioc: "KUW", iso2: "KW", iso: "KWT", label: "Kuwait", phone: "965" }, { ioc: "CAY", iso2: "KY", iso: "CYM", label: "Cayman Islands", phone: "1-345" }, { ioc: "KAZ", iso2: "KZ", iso: "KAZ", label: "Kazakhstan", phone: "7" }, { ioc: "LAO", iso2: "LA", iso: "LAO", label: "Lao People's Democratic Republic", phone: "856" }, { ioc: "LIB", iso2: "LB", iso: "LBN", label: "Lebanon", phone: "961" }, { ioc: "LCA", iso2: "LC", iso: "LCA", label: "Saint Lucia", phone: "1-758" }, { ioc: "LIE", iso2: "LI", iso: "LIE", label: "Liechtenstein", phone: "423" }, { ioc: "SRI", iso2: "LK", iso: "LKA", label: "Sri Lanka", phone: "94" }, { ioc: "LBR", iso2: "LR", iso: "LBR", label: "Liberia", phone: "231" }, { ioc: "LES", iso2: "LS", iso: "LSO", label: "Lesotho", phone: "266" }, { ioc: "LTU", iso2: "LT", iso: "LTU", label: "Lithuania", phone: "370" }, { ioc: "LUX", iso2: "LU", iso: "LUX", label: "Luxembourg", phone: "352" }, { ioc: "LAT", iso2: "LV", iso: "LVA", label: "Latvia", phone: "371" }, { ioc: "LBA", iso2: "LY", iso: "LBY", label: "Libya", phone: "218" }, { ioc: "MAR", iso2: "MA", iso: "MAR", label: "Morocco", phone: "212" }, { ioc: "MON", iso2: "MC", iso: "MCO", label: "Monaco", phone: "377" }, { ioc: "MDA", iso2: "MD", iso: "MDA", label: "Moldova, Republic of", phone: "373" }, { ioc: "MNE", iso2: "ME", iso: "MNE", label: "Montenegro", phone: "382" }, { ioc: "", iso2: "MF", iso: "MAF", label: "Saint Martin (French part)", phone: "590" }, { ioc: "MAD", iso2: "MG", iso: "MDG", label: "Madagascar", phone: "261" }, { ioc: "MSH", iso2: "MH", iso: "MHL", label: "Marshall Islands", phone: "692" }, { ioc: "MKD", iso2: "MK", iso: "MKD", label: "Macedonia, the Former Yugoslav Republic of", phone: "389" }, { ioc: "MLI", iso2: "ML", iso: "MLI", label: "Mali", phone: "223" }, { ioc: "MYA", iso2: "MM", iso: "MMR", label: "Myanmar", phone: "95" }, { ioc: "MGL", iso2: "MN", iso: "MNG", label: "Mongolia", phone: "976" }, { ioc: "MAC", iso2: "MO", iso: "MAC", label: "Macao", phone: "853" }, { ioc: "NMA", iso2: "MP", iso: "NMP", label: "Northern Mariana Islands", phone: "1-670" }, { ioc: "MRT", iso2: "MQ", iso: "MTQ", label: "Martinique", phone: "596" }, { ioc: "MTN", iso2: "MR", iso: "MRT", label: "Mauritania", phone: "222" }, { ioc: "MNT", iso2: "MS", iso: "MSR", label: "Montserrat", phone: "1-664" }, { ioc: "MLT", iso2: "MT", iso: "MLT", label: "Malta", phone: "356" }, { ioc: "MRI", iso2: "MU", iso: "MUS", label: "Mauritius", phone: "230" }, { ioc: "MDV", iso2: "MV", iso: "MDV", label: "Maldives", phone: "960" }, { ioc: "MAW", iso2: "MW", iso: "MWI", label: "Malawi", phone: "265" }, { ioc: "MEX", iso2: "MX", iso: "MEX", label: "Mexico", phone: "52" }, { ioc: "MAS", iso2: "MY", iso: "MYS", label: "Malaysia", phone: "60" }, { ioc: "MOZ", iso2: "MZ", iso: "MOZ", label: "Mozambique", phone: "258" }, { ioc: "NAM", iso2: "NA", iso: "NAM", label: "Namibia", phone: "264" }, { ioc: "NCL", iso2: "NC", iso: "NCL", label: "New Caledonia", phone: "687" }, { ioc: "NIG", iso2: "NE", iso: "NER", label: "Niger", phone: "227" }, { ioc: "NFI", iso2: "NF", iso: "NFK", label: "Norfolk Island", phone: "672" }, { ioc: "NGR", iso2: "NG", iso: "NGA", label: "Nigeria", phone: "234" }, { ioc: "NCA", iso2: "NI", iso: "NIC", label: "Nicaragua", phone: "505" }, { ioc: "NED", iso2: "NL", iso: "NLD", label: "Netherlands", phone: "31" }, { ioc: "NOR", iso2: "NO", iso: "NOR", label: "Norway", phone: "47" }, { ioc: "NEP", iso2: "NP", iso: "NPL", label: "Nepal", phone: "977" }, { ioc: "NRU", iso2: "NR", iso: "NRU", label: "Nauru", phone: "674" }, { ioc: "NIU", iso2: "NU", iso: "NIU", label: "Niue", phone: "683" }, { ioc: "NZL", iso2: "NZ", iso: "NZL", label: "New Zealand", phone: "64" }, { ioc: "OMA", iso2: "OM", iso: "OMN", label: "Oman", phone: "968" }, { ioc: "PAN", iso2: "PA", iso: "PAN", label: "Panama", phone: "507" }, { ioc: "PER", iso2: "PE", iso: "PER", label: "Peru", phone: "51" }, { ioc: "FPO", iso2: "PF", iso: "PYF", label: "French Polynesia", phone: "689" }, { ioc: "PNG", iso2: "PG", iso: "PNG", label: "Papua New Guinea", phone: "675" }, { ioc: "PHI", iso2: "PH", iso: "PHL", label: "Philippines", phone: "63" }, { ioc: "PAK", iso2: "PK", iso: "PAK", label: "Pakistan", phone: "92" }, { ioc: "POL", iso2: "PL", iso: "POL", label: "Poland", phone: "48" }, { ioc: "SPM", iso2: "PM", iso: "SPM", label: "Saint Pierre and Miquelon", phone: "508" }, { ioc: "", iso2: "PN", iso: "PCN", label: "Pitcairn", phone: "870" }, { ioc: "PUR", iso2: "PR", iso: "PRI", label: "Puerto Rico", phone: "1" }, { ioc: "PLE", iso2: "PS", iso: "PSE", label: "Palestine, State of", phone: "970" }, { ioc: "POR", iso2: "PT", iso: "PRT", label: "Portugal", phone: "351" }, { ioc: "PLW", iso2: "PW", iso: "PLW", label: "Palau", phone: "680" }, { ioc: "PAR", iso2: "PY", iso: "PRY", label: "Paraguay", phone: "595" }, { ioc: "QAT", iso2: "QA", iso: "QAT", label: "Qatar", phone: "974" }, { ioc: "REU", iso2: "RE", iso: "REU", label: "Reunion", phone: "262" }, { ioc: "ROU", iso2: "RO", iso: "ROU", label: "Romania", phone: "40" }, { ioc: "SRB", iso2: "RS", iso: "SRB", label: "Serbia", phone: "381" }, { ioc: "RUS", iso2: "RU", iso: "RUS", label: "Russia", phone: "7" }, { ioc: "RWA", iso2: "RW", iso: "RWA", label: "Rwanda", phone: "250" }, { ioc: "KSA", iso2: "SA", iso: "SAU", label: "Saudi Arabia", phone: "966" }, { ioc: "SOL", iso2: "SB", iso: "SLB", label: "Solomon Islands", phone: "677" }, { ioc: "SEY", iso2: "SC", iso: "SYC", label: "Seychelles", phone: "248" }, { ioc: "SUD", iso2: "SD", iso: "SDN", label: "Sudan", phone: "249" }, { ioc: "SWE", iso2: "SE", iso: "SWE", label: "Sweden", phone: "46" }, { ioc: "SIN", iso2: "SG", iso: "SGP", label: "Singapore", phone: "65" }, { ioc: "HEL", iso2: "SH", iso: "SHN", label: "Saint Helena", phone: "290" }, { ioc: "SLO", iso2: "SI", iso: "SVN", label: "Slovenia", phone: "386" }, { ioc: "", iso2: "SJ", iso: "SJM", label: "Svalbard and Jan Mayen", phone: "47" }, { ioc: "SVK", iso2: "SK", iso: "SVK", label: "Slovakia", phone: "421" }, { ioc: "SLE", iso2: "SL", iso: "SLE", label: "Sierra Leone", phone: "232" }, { ioc: "SMR", iso2: "SM", iso: "SMR", label: "San Marino", phone: "378" }, { ioc: "SEN", iso2: "SN", iso: "SEN", label: "Senegal", phone: "221" }, { ioc: "SOM", iso2: "SO", iso: "SOM", label: "Somalia", phone: "252" }, { ioc: "SUR", iso2: "SR", iso: "SUR", label: "Suriname", phone: "597" }, { ioc: "", iso2: "SS", iso: "SSD", label: "South Sudan", phone: "211" }, { ioc: "STP", iso2: "ST", iso: "STP", label: "Sao Tome and Principe", phone: "239" }, { ioc: "ESA", iso2: "SV", iso: "SLV", label: "El Salvador", phone: "503" }, { ioc: "", iso2: "SX", iso: "SMX", label: "Sint Maarten", phone: "1-721" }, { ioc: "SYR", iso2: "SY", iso: "SYR", label: "Syria", phone: "963" }, { ioc: "", iso2: "SZ", iso: "SWZ", label: "Swaziland", phone: "268" }, { ioc: "TKS", iso2: "TC", iso: "TCA", label: "Turks and Caicos Islands", phone: "1-649" }, { ioc: "CHA", iso2: "TD", iso: "TCD", label: "Chad", phone: "235" }, { ioc: "", iso2: "TF", iso: "ATF", label: "French Southern Territories", phone: "262" }, { ioc: "TOG", iso2: "TG", iso: "TGO", label: "Togo", phone: "228" }, { ioc: "THA", iso2: "TH", iso: "THA", label: "Thailand", phone: "66" }, { ioc: "TJK", iso2: "TJ", iso: "TJK", label: "Tajikistan", phone: "992" }, { ioc: "", iso2: "TK", iso: "TKL", label: "Tokelau", phone: "690" }, { ioc: "TLS", iso2: "TL", iso: "TLS", label: "Timor-Leste", phone: "670" }, { ioc: "TKM", iso2: "TM", iso: "TKM", label: "Turkmenistan", phone: "993" }, { ioc: "TUN", iso2: "TN", iso: "TUN", label: "Tunisia", phone: "216" }, { ioc: "TGA", iso2: "TO", iso: "TON", label: "Tonga", phone: "676" }, { ioc: "TUR", iso2: "TR", iso: "TUR", label: "Turkey", phone: "90" }, { ioc: "TTO", iso2: "TT", iso: "TTO", label: "Trinidad and Tobago", phone: "1-868" }, { ioc: "TUV", iso2: "TV", iso: "TUV", label: "Tuvalu", phone: "688" }, { ioc: "TPE", iso2: "TW", iso: "TWN", label: "Taiwan", phone: "886" }, { ioc: "TAN", iso2: "TZ", iso: "TZA", label: "United Republic of Tanzania", phone: "255" }, { ioc: "UKR", iso2: "UA", iso: "UKR", label: "Ukraine", phone: "380" }, { ioc: "UGA", iso2: "UG", iso: "UGA", label: "Uganda", phone: "256" }, { ioc: "USA", iso2: "US", label: "United States", phone: "1", suggested: !0, iso: "USA" }, { ioc: "URU", iso2: "UY", iso: "URY", label: "Uruguay", phone: "598" }, { ioc: "UZB", iso2: "UZ", iso: "UZB", label: "Uzbekistan", phone: "998" }, { ioc: "", iso2: "VA", iso: "VAT", label: "Holy See (Vatican City State)", phone: "379" }, { ioc: "VIN", iso2: "VC", iso: "VCT", label: "Saint Vincent and the Grenadines", phone: "1-784" }, { ioc: "VEN", iso2: "VE", iso: "VEN", label: "Venezuela", phone: "58" }, { ioc: "IVB", iso2: "VG", iso: "VGB", label: "British Virgin Islands", phone: "1-284" }, { ioc: "ISV", iso2: "VI", iso: "VIR", label: "US Virgin Islands", phone: "1-340" }, { ioc: "VIE", iso2: "VN", iso: "VNM", label: "Vietnam", phone: "84" }, { ioc: "VAN", iso2: "VU", iso: "VUT", label: "Vanuatu", phone: "678" }, { ioc: "WAF", iso2: "WF", iso: "WLF", label: "Wallis and Futuna", phone: "681" }, { ioc: "SAM", iso2: "WS", iso: "WSM", label: "Samoa", phone: "685" }, { ioc: "KOS", iso2: "XK", iso: "KOS", label: "Kosovo", phone: "383" }, { ioc: "YEM", iso2: "YE", iso: "YEM", label: "Yemen", phone: "967" }, { ioc: "MAY", iso2: "YT", iso: "MYT", label: "Mayotte", phone: "262" }, { ioc: "RSA", iso2: "ZA", iso: "ZAF", label: "South Africa", phone: "27" }, { ioc: "ZAM", iso2: "ZM", iso: "ZMB", label: "Zambia", phone: "260" }, { ioc: "ZIM", iso2: "ZW", iso: "ZWE", label: "Zimbabwe", phone: "263" }];
function CD({ participant: e, withISO2: t, withIOC: r }) {
  let { person: i, individualParticipants: n } = e, a = [i, n == null ? void 0 : n.map(({ person: s }) => s)].flat().filter(Boolean);
  function o(s) {
    let { nationalityCode: c } = s || {};
    if (c) {
      let u = pa.find(({ iso: d }) => d === c);
      r && (u != null && u.ioc) && !s.iocNationalityCode && (s.iocNationalityCode = u.ioc), t && (u != null && u.iso2) && !s.iso2NationalityCode && (s.iso2NationalityCode = u.iso2), u != null && u.label && !s.countryName && (s.countryName = u.label);
    }
  }
  a.forEach(o);
}
function cO({ participantMap: e, template: t }) {
  var i;
  let r = Object.values(e);
  for (let n of r) {
    let a = n.participant;
    if ((i = a.individualParticipantIds) != null && i.length) {
      a.individualParticipants = [];
      for (let o of a.individualParticipantIds) {
        let s = e[o].participant;
        a.individualParticipants.push(t ? xo({ template: t, source: s }) : s);
      }
    }
  }
}
function Aa(e) {
  var n;
  let { tournamentRecord: t, participantId: r } = e, i = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  for (let a of Object.values(i)) {
    let o = (n = a.participants) == null ? void 0 : n.find((s) => s.participantId === r);
    if (o)
      return { participant: o, tournamentId: a.tournamentId };
  }
  return { error: Dt };
}
function OD(e) {
  let { tournamentRecord: t, participantId: r } = e;
  if (r) {
    let n = Aa({ tournamentRecord: t, participantId: r });
    return n.participant ?? n;
  }
  return e.element || e.drawDefinition || e.event || e.tournamentRecord || { error: Ie };
}
function Pi(e) {
  let { returnPreviousValues: t, itemSubTypes: r, itemType: i } = e, n = OD(e);
  if (n.error)
    return n;
  if (r && !Array.isArray(r))
    return { error: J, context: { itemSubTypes: r } };
  if (!Array.isArray(n.timeItems))
    return { error: _h };
  let a = n.timeItems.filter((s) => (s == null ? void 0 : s.itemType) === i).filter((s) => !(r != null && r.length) || r.some((c) => {
    var u;
    return (u = s == null ? void 0 : s.itemSubTypes) == null ? void 0 : u.includes(c);
  })).sort((s, c) => {
    let u = new Date(s.createdAt || void 0).getTime(), d = new Date(c.createdAt || void 0).getTime();
    return u - d;
  }), o = ce(a.pop(), !1, !0);
  if (o) {
    let s = { timeItem: o, ...V };
    return t && Object.assign(s, { previousItems: a }), s;
  } else
    return { info: Zt };
}
function Vg({ returnPreviousValues: e, drawDefinition: t, itemSubTypes: r, itemType: i }) {
  if (!t)
    return { error: tn };
  if (!t.timeItems)
    return { info: Zt };
  let { timeItem: n, previousItems: a, info: o } = Pi({ element: t, returnPreviousValues: e, itemSubTypes: r, itemType: i });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function Gu({ returnPreviousValues: e, itemSubTypes: t, itemType: r, event: i }) {
  if (!i)
    return { error: pt };
  if (!i.timeItems)
    return { info: Zt };
  let { timeItem: n, previousItems: a, info: o } = Pi({ returnPreviousValues: e, element: i, itemSubTypes: t, itemType: r });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function Mp({ returnPreviousValues: e, tournamentRecord: t, itemSubTypes: r, itemType: i }) {
  if (!t)
    return { error: ae };
  if (!t.timeItems)
    return { info: Zt };
  let { timeItem: n, previousItems: a, info: o } = Pi({ element: t, returnPreviousValues: e, itemSubTypes: r, itemType: i });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function jg({ returnPreviousValues: e, tournamentRecord: t, participantId: r, itemSubTypes: i, itemType: n }) {
  if (!t)
    return { error: ae };
  if (!r)
    return { error: _t };
  let a = Aa({ tournamentRecord: t, participantId: r });
  if (a.error)
    return a;
  let { participant: o } = a;
  if (!(o != null && o.timeItems))
    return { info: Zt };
  let { timeItem: s, previousItems: c, info: u } = Pi({ element: a.participant, returnPreviousValues: e, itemSubTypes: i, itemType: n });
  return s && { timeItem: s, previousItems: c } || { info: u };
}
var uO = { [di]: "groupParticipantIds", [Re]: "pairParticipantIds", [Xe]: "teamParticipantIds" }, dO = { [di]: "groups", [Xe]: "teams" };
function kD({ withIndividualParticipants: e, convertExtensions: t, tournamentRecord: r, withSignInStatus: i, withScaleValues: n, internalUse: a, withISO2: o, withIOC: s }) {
  let c = [], u = {};
  for (let d of r.participants ?? []) {
    let p = d == null ? void 0 : d.participantId;
    p && mO({ participantMap: u, participantId: p });
  }
  for (let d of r.participants ?? []) {
    let p = ce(d, t, a), { participantId: l, individualParticipantIds: m, participantType: f } = p;
    if (!u[l]) {
      c.push(l);
      continue;
    }
    if (Object.assign(u[l].participant, p), m) {
      let h = pO({ individualParticipantIds: m, participantCopy: p, participantMap: u, participantType: f, participantId: l });
      h.missingParticipantIds.length && c.push(...h.missingParticipantIds);
    }
    if (i && (u[l].participant.signedIn = lO(p)), n) {
      let { ratings: h, rankings: g, seedings: I } = pc({ participant: p });
      u[l].participant.seedings = I, u[l].participant.rankings = g, u[l].participant.ratings = h;
    }
    (s || o) && CD({ participant: u[l].participant, withISO2: o, withIOC: s });
  }
  if (e) {
    let d = Le(e) ? e : void 0;
    cO({ participantMap: u, template: d });
  }
  return { missingParticipantIds: c, participantMap: u };
}
function lO(e) {
  let { timeItem: t } = Pi({ itemType: ju, element: e });
  return (t == null ? void 0 : t.itemValue) === uu;
}
function pO({ individualParticipantIds: e, participantCopy: t, participantMap: r, participantType: i, participantId: n }) {
  var o;
  let a = [];
  for (let s of e) {
    let c = (o = r[s]) == null ? void 0 : o.participant;
    if (!c) {
      a.push(s);
      continue;
    }
    if (c[uO[i]].push(n), [Xe, di].includes(i)) {
      let { participantRoleResponsibilities: u, participantOtherName: d, participantName: p, participantId: l, teamId: m } = t, f = dO[i];
      c[f].push({ participantRoleResponsibilities: u, participantOtherName: d, participantName: p, participantId: l, teamId: m });
    }
    if (i === Re) {
      let u = e.find((d) => d !== s);
      r[s].pairIdMap[n] = u, r[s].pairIdMap[u] = n;
    }
  }
  return { missingParticipantIds: a };
}
function mO({ participantMap: e, participantId: t }) {
  if (e[t])
    return;
  let r = { walkoverWins: 0, defaultWins: 0, walkovers: 0, defaults: 0, losses: 0, wins: 0 };
  e[t] = { structureParticipation: {}, potentialMatchUps: {}, scheduleConflicts: {}, scheduleItems: [], participant: { groupParticipantIds: [], pairParticipantIds: [], teamParticipantIds: [], seedings: {}, rankings: {}, ratings: {}, groups: [], teams: [] }, statistics: {}, opponents: {}, pairIdMap: {}, matchUps: {}, events: {}, draws: {}, counters: { [rt]: { ...r }, [tt]: { ...r }, [Xe]: { ...r }, ...r } };
}
function es({ participantsProfile: e, useParticipantMap: t, tournamentRecord: r, contextProfile: i, inContext: n }) {
  var s;
  if (t)
    return { participantMap: (s = kD({ ...e, ...i, tournamentRecord: r })) == null ? void 0 : s.participantMap };
  let a = ce(r.participants, !1, !0) || [];
  (e != null && e.withIOC || e != null && e.withISO2) && a.forEach((c) => CD({ participant: c, ...e }));
  let o;
  if ((n || e != null && e.withGroupings) && (a != null && a.length) && ({ participantsWithGroupings: a, groupInfo: o } = Bg({ participantsProfile: e, deepCopy: !1, participants: a })), (e == null ? void 0 : e.withScaleValues) && (a == null ? void 0 : a.length))
    for (let c of a) {
      let { ratings: u, rankings: d } = pc({ participant: c });
      c.rankings = d, c.ratings = u;
    }
  return { participants: a, groupInfo: o };
}
function je({ onlySpecifiedPolicyTypes: e = !1, policyTypes: t = [], tournamentRecord: r, drawDefinition: i, structure: n, event: a }) {
  if (!Array.isArray(t))
    return { error: Rh };
  let o = {};
  return r && s(r), a && s(a), i && s(i), n && s(n), { appliedPolicies: o, ...V };
  function s(c) {
    var d, p;
    let u = (p = (d = c == null ? void 0 : c.extensions) == null ? void 0 : d.find((l) => l.name === su)) == null ? void 0 : p.value;
    if (u)
      for (let l of Object.keys(u))
        (e ? t.includes(l) : !t.length || t.includes(l)) && (o[l] = ce(u[l], !1, !0));
  }
}
function ra({ policyTypes: e = [], tournamentRecord: t, drawDefinition: r, structure: i, event: n }) {
  if (!Array.isArray(e))
    return { error: Rh };
  let { appliedPolicies: a } = je({ tournamentRecord: t, drawDefinition: r, structure: i, event: n }), o = {};
  for (let s of e) {
    let c = a == null ? void 0 : a[s];
    c && (o[s] = c);
  }
  return Object.keys(o).length ? { policyDefinitions: o } : { info: Do.message };
}
var FD = "WALKOVER", oS = "RETIRED", Gg = "COMPETITIVE", du = "ROUTINE", lu = "DECISIVE", Yd = "winRatio", fO = { [Bn]: { policyName: "Competitive Bands Default", profileBands: { [lu]: 20, [du]: 50 } } }, $g = fO;
function ia({ policyDefinitions: e, tournamentRecord: t, contextProfile: r, drawDefinition: i, event: n }) {
  let a = { policies: {} };
  if (!r)
    return a;
  let o = ra({ tournamentRecord: t, drawDefinition: i, event: n }).policyDefinitions;
  if (r.withCompetitiveness) {
    let s = (e == null ? void 0 : e[Bn]) ?? (o == null ? void 0 : o[Bn]) ?? $g[Bn];
    a.policies[Bn] = s;
  }
  return a;
}
function lo({ tournamentRecord: e, drawDefinition: t, policyType: r, structure: i, event: n }) {
  if (!e)
    return { error: ae };
  let { appliedPolicies: a } = je({ tournamentRecord: e, drawDefinition: t, structure: i, event: n });
  return a != null && a[r] ? { policy: a[r] } : { info: Do == null ? void 0 : Do.message };
}
function $u({ tournamentRecord: e, categoryName: t, categoryType: r, event: i }) {
  var s, c, u, d, p, l;
  t = t ?? ((s = i == null ? void 0 : i.category) == null ? void 0 : s.categoryName) ?? ((c = i == null ? void 0 : i.category) == null ? void 0 : c.ageCategoryCode), r = r ?? ((u = i == null ? void 0 : i.category) == null ? void 0 : u.categoryType) ?? ((d = i == null ? void 0 : i.category) == null ? void 0 : d.subType);
  let { policy: n } = lo({ policyType: Ra, tournamentRecord: e, event: i }), a = (p = e ? Ne({ element: e, name: Kn }).extension : void 0) == null ? void 0 : p.value, o = (l = i && Ne({ name: Kn, element: i }).extension) == null ? void 0 : l.value;
  return { scheduleTiming: { tournamentScheduling: a, eventScheduling: o, categoryName: t, categoryType: r, policy: n } };
}
function qg({ drawDefinition: e, attributes: t }) {
  let { extension: r } = Ne({ element: e, name: fl }), i = (r == null ? void 0 : r.value) || {};
  return t.forEach((n) => {
    Object.keys(n).forEach((a) => {
      i[a] ? Object.assign(i[a], n[a]) : i[a] = n[a];
    });
  }), r = { name: fl, value: i }, Up({ drawDefinition: e, extension: r }), { entryProfile: i };
}
function qu({ drawDefinition: e }) {
  let { extension: t } = Ne({ element: e, name: fl });
  return { entryProfile: (t == null ? void 0 : t.value) || {} };
}
var Fi = "ALTERNATE", Wu = "CONFIRMED", $r = "DIRECT_ACCEPTANCE", Hu = "FEED_IN", zu = "JUNIOR_EXEMPT", Qn = "LUCKY_LOSER", Yu = "ORGANISER_ACCEPTANCE", Ku = "QUALIFIER", hO = "REGISTERED", Qu = "SPECIAL_EXEMPT", Di = "UNGROUPED", po = "UNPAIRED", Hs = "WILDCARD", On = "WITHDRAWN", Kd = [Wu, $r, zu, Yu, Qu], xD = [Hu, Qn, Ku], mo = [Wu, $r, Hu, zu, Yu, Qu, Hs], $i = [Wu, $r, zu, Qn, Ku, Yu, Qu, Hs], LD = [Fi, Wu, $r, Hu, zu, Qn, Yu, Ku, hO, Qu, Di, po, Hs, On], gO = { ALTERNATE: Fi, CONFIRMED: Wu, DIRECT_ACCEPTANCE: $r, DIRECT_ENTRY_STATUSES: mo, DRAW_SPECIFIC_STATUSES: xD, EQUIVALENT_ACCEPTANCE_STATUSES: Kd, FEED_IN: Hu, JUNIOR_EXEMPT: zu, LUCKY_LOSER: Qn, ORGANISER_ACCEPTANCE: Yu, QUALIFIER: Ku, SPECIAL_EXEMPT: Qu, STRUCTURE_SELECTED_STATUSES: $i, UNGROUPED: Di, UNPAIRED: po, VALID_ENTRY_STATUSES: LD, WILDCARD: Hs, WITHDRAWN: On };
function Wg({ stage: e, drawDefinition: t }) {
  let { entryProfile: r } = qu({ drawDefinition: t }), i = Object.keys(r).includes(e);
  if (!i && sp.includes(e)) {
    let n = [{ [e]: { drawSize: void 0, alternates: !0 } }];
    return qg({ drawDefinition: t, attributes: n }), !0;
  }
  return i;
}
function IO({ stage: e, drawDefinition: t }) {
  var i;
  let { entryProfile: r } = qu({ drawDefinition: t });
  return ((i = r[e]) == null ? void 0 : i.alternates) || 0;
}
function UO({ stage: e, drawDefinition: t }) {
  var i;
  let { entryProfile: r } = qu({ drawDefinition: t });
  return ((i = r[e]) == null ? void 0 : i.wildcardsCount) || 0;
}
function Ff({ stage: e, drawDefinition: t, entryStatus: r }) {
  return t.entries.reduce((i, n) => n.entryStage === e && n.entryStatus === r ? i + 1 : i, 0);
}
function ts({ provisionalPositioning: e, placementGroup: t, drawDefinition: r, stageSequence: i, entryStatuses: n, structureId: a, roundTarget: o, stages: s, stage: c }) {
  var d;
  let u = ((d = r.entries) == null ? void 0 : d.reduce((p, l) => {
    var I, y;
    let m = (y = (I = Ne({ name: In, element: l })) == null ? void 0 : I.extension) == null ? void 0 : y.value, f = c && l.entryStage === c || (s == null ? void 0 : s.length) && l.entryStage && s.includes(l.entryStage), h = !n || l.entryStatus && n.includes(l.entryStatus), g = l.entryStageSequence ?? 1;
    return f && (!i || g === i) && h && (!o || !m || o === m) ? p.concat(l) : p;
  }, [])) ?? [];
  if (a && c === vt) {
    let { playoffEntries: p, error: l } = yO({ provisionalPositioning: e, drawDefinition: r, structureId: a });
    return l && console.log("playoff entries error"), (p != null && p.length ? p : u).filter((m) => !t || m.placementGroup === t);
  }
  return u;
}
function yO({ provisionalPositioning: e, drawDefinition: t, structureId: r }) {
  let i = [], n = (t.links ?? []).find((a) => a.linkType === Wn && a.target.structureId === r);
  if (n) {
    let { finishingPositions: a, structureId: o } = n.source, { structure: s } = ve({ drawDefinition: t, structureId: o });
    (s == null ? void 0 : s.structureType) === br && (s.structures ?? []).forEach((c) => {
      let u = c.positionAssignments ?? [], { structureId: d } = c, p = d, l = Object.assign({}, ...u.map((h) => {
        var y;
        let { participantId: g } = h, I = (y = Ne({ element: h, name: Ia }).extension) == null ? void 0 : y.value;
        return I && g ? { [g]: I } : void 0;
      }).filter(Boolean)), m = Object.keys(l).reduce((h, g) => {
        let I = l[g], y = I.groupOrder || e && I.provisionalOrder;
        return h.includes(y) || h.push(y), h;
      }, []).length === Object.keys(l).length, f = Object.keys(l).filter((h) => {
        let g = l[h], I = g.groupOrder || e && g.provisionalOrder;
        return a == null ? void 0 : a.includes(I);
      });
      (!e || m) && f.forEach((h) => {
        let g = l[h], { groupOrder: I, provisionalOrder: y, GEMscore: U } = g, S = I || e && y, D = [...a ?? []].sort(Ft).indexOf(S) + 1;
        i.push({ entryStage: vt, entryStatus: Hu, placementGroup: D, groupingValue: p, participantId: h, GEMscore: U });
      });
    });
  }
  return { playoffEntries: i };
}
function SO({ stage: e, drawDefinition: t }) {
  return mo.reduce((r, i) => (Ff({ drawDefinition: t, entryStatus: i, stage: e }) || 0) + r, 0);
}
function Si({ provisionalPositioning: e, returnAllProxies: t, drawDefinition: r, structureId: i, structure: n }) {
  var f;
  let a, o = [];
  n || ({ structure: n, error: a } = ve({ drawDefinition: r, structureId: i }));
  let s = ot({ structure: n }).positionAssignments;
  if (a || !n)
    return { seedAssignments: [], error: It };
  i || (i = n.structureId);
  let { stage: c, stageSequence: u } = n, d = c === vt && r && ts({ provisionalPositioning: e, drawDefinition: r, stageSequence: u, structureId: i, stage: c }), p = d ? d.filter((h) => h.placementGroup === 1).sort((h, g) => h.GEMscore < g.GEMscore && 1 || h.GEMscore > g.GEMscore && -1 || 0).map((h, g) => {
    let I = g + 1;
    return { participantId: h.participantId, seedValue: I, seedProxy: !0, seedNumber: I };
  }) : [], l = p == null ? void 0 : p.slice(0, t ? p.length : s.length / 2);
  l.length ? o = l : n.seedAssignments ? o = n.seedAssignments : a = Vv;
  let m = n.seedLimit ?? ((f = n == null ? void 0 : n.positionAssignments) == null ? void 0 : f.length);
  return { seedAssignments: o, stageSequence: u, seedLimit: m, stage: c, error: a };
}
function rn(e) {
  if (!e)
    return;
  let { tieFormatId: t, tieFormats: r } = e;
  if (e.tieFormat)
    return e.tieFormat;
  if (t && Array.isArray(r))
    return r.find((i) => i.tieFormatId === t);
}
function jc({ item: e, drawDefinition: t, structure: r, event: i }) {
  var n, a, o;
  if (e) {
    if (e.tieFormat)
      return e.tieFormat;
    if (e.tieFormatId)
      return t.tieFormat ? t.tieFormat : ((n = t.tieFormats) == null ? void 0 : n.find((c) => e.tieFormatId === c.tieFormatId)) || (i.tieFormat ? i.tieFormat : (a = i.tieFormats) == null ? void 0 : a.find((c) => e.tieFormatId === c.tieFormatId));
    if (r.tieFormat)
      return r.tieFormat;
    if (r.tieFormatId) {
      let s = (o = t.tieFormats) == null ? void 0 : o.find((c) => r.tieFormatId === c.tieFormatId);
      if (s)
        return s;
    }
  }
}
function Ir({ drawDefinition: e, structure: t, matchUp: r, event: i }) {
  return { tieFormat: jc({ item: r, drawDefinition: e, structure: t, event: i }) || jc({ item: t, drawDefinition: e, structure: t, event: i }) || rn(e) || rn(i) };
}
function vO({ matchUps: e }) {
  let t = e.reduce((r, i) => !i.collectionPosition || r.includes(i.collectionPosition) ? r : r.concat(i.collectionPosition), []).map((r) => ({ [r]: e.filter((i) => i.collectionPosition === r) }));
  return { collectionPositionMatchUps: Object.assign({}, ...t) };
}
function mr({ drawDefinition: e, structure: t }) {
  let r = {}, i = [];
  return ((e == null ? void 0 : e.structures) ?? [t]).filter((n) => n && typeof n == "object").forEach((n) => {
    if (!n)
      return;
    let { structureId: a, matchUps: o, structures: s } = n, c = Array.isArray(s);
    if (c)
      c && s.forEach((u) => {
        let { structureName: d } = u, p = u.matchUps;
        r[u.structureId] = { matchUps: p, itemStructureIds: [], structureName: d }, p && (i.push(...p), p.forEach((l) => {
          l.tieMatchUps && i.push(...l.tieMatchUps);
        })), r[a] || (r[a] = { itemStructureIds: [], matchUps: [] }), r[a].itemStructureIds || (r[a].itemStructureIds = []), r[a].itemStructureIds.push(u.structureId);
      });
    else {
      let u = o;
      r[a] = { matchUps: u, itemStructureIds: [] }, u == null || u.forEach((d) => {
        i.push(d), d.tieMatchUps && i.push(...d.tieMatchUps);
      });
    }
  }), { mappedMatchUps: r, drawMatchUps: i };
}
function Ka({ mappedMatchUps: e, matchUpsMap: t, structureId: r, inContext: i }) {
  e = (t == null ? void 0 : t.mappedMatchUps) ?? e;
  let n = e[r], a = ((n == null ? void 0 : n.itemStructureIds) || []).map((o) => {
    let { matchUps: s, structureName: c } = e[o];
    return i ? s.map((u) => Object.assign(ce(u, !0, !0), { containerStructureId: r, structureId: o, structureName: c })) : s;
  }).flat();
  return ((n == null ? void 0 : n.matchUps) || []).concat(...a);
}
function _D({ groupedOrder: e, roundPositionsCount: t }) {
  if (!e || (e == null ? void 0 : e.length) <= t)
    return e;
  let r = zt(e, e.length / t).map((n) => n.reduce((a, o) => a + o)), i = r.slice().sort(Ft);
  return r.map((n) => i.indexOf(n) + 1);
}
function Np(e) {
  if (!Le(e))
    return !1;
  let { matchUpId: t, drawPositions: r } = e, i = typeof t == "string", n = !r || Array.isArray(r) && r.length <= 2 && r.every((a) => Pe(a) || a === void 0 || a === null);
  return i && n;
}
function Ti(e) {
  return Array.isArray(e) ? e.every(Np) : !1;
}
function Pr({ matchUps: e = [], interpolate: t }) {
  var p;
  if (!Ti(e))
    return { roundMatchUps: [], error: J };
  let r = e.reduce((l, m) => {
    let f = typeof m.roundNumber == "string" ? ye(m.roundNumber) : m.roundNumber;
    return !m.roundNumber || l.includes(f) ? l : l.concat(f);
  }, []).sort(Ft).map((l) => {
    let m = e.filter((g) => g.roundNumber === l), f = m.find(({ matchUpType: g }) => g === lt) ? m.filter(({ matchUpType: g }) => g === lt) : m, h = (g) => g.sort((I, y) => Ft(I.roundPosition, y.roundPosition));
    return { [l]: h(f) };
  }), i = e.reduce((l, m) => {
    let f = typeof m.roundNumber == "string" ? ye(m.roundNumber) : m.roundNumber;
    return l[f] || (l[f] = me({ abbreviatedRoundName: m.abbreviatedRoundName, finishingRound: m.finishingRound, roundName: m.roundName })), l;
  }, {}), n = Object.assign({}, ...r);
  if (t) {
    let l = Math.max(...Object.keys(n).map((f) => ye(f)).filter((f) => !isNaN(f))), m = (p = n[l]) == null ? void 0 : p.length;
    if (m > 1 && Qi(m)) {
      let f = l + 1, h = f + m / 2;
      oe(f, h).forEach((g, I) => {
        n[g] = oe(0, m / (2 + I * 2)).map(() => ({}));
      });
    }
  }
  let a = 0, o = Object.assign({}, ...Object.keys(n).map((l) => {
    var g, I, y;
    let m = (g = n[l]) == null ? void 0 : g.length, f = (y = (I = n[l]) == null ? void 0 : I.filter((U) => {
      var S;
      return !Vt.includes(U.matchUpStatus) && !((S = U.score) != null && S.scoreStringSide1);
    })) == null ? void 0 : y.length, h = m && m === f;
    return a = Math.max(a, m), { [l]: { matchUpsCount: m, inactiveCount: f, inactiveRound: h } };
  })), s = 0, c = 0, u = Object.keys(n).map((l) => ye(l)).filter((l) => !isNaN(l));
  u.forEach((l) => {
    var h, g, I, y, U;
    let m = n[l].sort((S, D) => S.roundPosition - D.roundPosition), f = m.map((S) => (S == null ? void 0 : S.drawPositions) || []).flat();
    if (o[l].roundNumber = l, o[l].roundFactor = o[l].matchUpsCount ? a / o[l].matchUpsCount : 1, o[l].finishingRound = (h = i[l]) == null ? void 0 : h.finishingRound, o[l].roundName = (g = i[l]) == null ? void 0 : g.roundName, o[l].abbreviatedRoundName = (I = i[l]) == null ? void 0 : I.abbreviatedRoundName, o[l].finishingPositionRange = (U = (y = n[l]) == null ? void 0 : y[0]) == null ? void 0 : U.finishingPositionRange, l === 1 || !o[l - 1]) {
      let S = f.sort(Ft), D = zt(S, 2);
      o[l].drawPositions = S, o[l].pairedDrawPositions = D;
    } else {
      let S = o[l - 1], D = S.drawPositions, w = S.matchUpsCount / o[l].matchUpsCount, v = zt(D, w), P = m.map((b) => {
        let { roundPosition: T } = b, R = [...b.drawPositions || [], void 0, void 0].slice(0, 2);
        if (!T)
          return R;
        let M = (R == null ? void 0 : R.filter(Boolean)) || [];
        if (!(M != null && M.length))
          return [void 0, void 0];
        if (l < 3 && (M == null ? void 0 : M.length) === 2)
          return R == null ? void 0 : R.slice().sort(Ft);
        let E = wt(D, M).length !== (M == null ? void 0 : M.length);
        if (M != null && M.length && E)
          return (M == null ? void 0 : M.length) === 1 ? [M[0], void 0] : R == null ? void 0 : R.slice().sort(Ft);
        let C = (T - 1) * 2;
        return v.slice(C, C + 2).map((A) => M == null ? void 0 : M.find((N) => A.includes(N)));
      });
      o[l].drawPositions = P == null ? void 0 : P.flat(), o[l].pairedDrawPositions = P;
    }
    o[l + 1] && o[l + 1].matchUpsCount === o[l].matchUpsCount && (o[l + 1].feedRound = !0, o[l + 1].feedRoundIndex = c, o[l].preFeedRound = !0, c += 1), o[l] && !o[l].feedRound && (o[l].roundIndex = s, s += 1);
  });
  let d = !!Object.values(o).find(({ matchUpsCount: l }) => !Qi(l));
  return { hasNoRoundPositions: e.some((l) => !l.roundPosition), roundsNotPowerOf2: d, maxMatchUpsCount: a, roundMatchUps: n, roundNumbers: u, roundProfile: o, ...V };
}
function Qd(e) {
  if (!Array.isArray(e))
    return "";
  let t = e.filter(St);
  return t.length ? Te([Math.min(...t), Math.max(...t)]).join("-") : "";
}
function wO({ drawDefinition: e, structureId: t, matchUpsMap: r }) {
  if (!e)
    return { error: le };
  if (!t)
    return { error: ui };
  let { structure: i } = ve({ drawDefinition: e, structureId: t });
  if ((i == null ? void 0 : i.stage) !== lr)
    return { error: oo, info: "Structure is not CONSOLATION stage" };
  let { links: n } = e, a = (n == null ? void 0 : n.filter((p) => p.target.structureId === t)) || [], o = (a == null ? void 0 : a.reduce((p, l) => {
    let { structureId: m } = l.source;
    return p.includes(m) ? p : p.concat(m);
  }, [])) || [], s = Object.assign({}, ...o.map((p) => {
    let l = Ka({ structureId: p, matchUpsMap: r }), m = Pr({ matchUps: l }).roundProfile;
    return { [p]: m };
  })), c = Ka({ matchUpsMap: r, structureId: t }), { roundProfile: u } = Pr({ matchUps: c }), d = {};
  return a == null || a.forEach((p) => {
    var M, E, C;
    let { structureId: l, roundNumber: m } = p.source, { feedProfile: f, groupedOrder: h, positionInterleave: g, roundNumber: I } = p.target, y = s[l], U = (M = y[1]) == null ? void 0 : M.drawPositions, S = (E = y[m]) == null ? void 0 : E.matchUpsCount;
    if (!S)
      return;
    let D = S ? U.length / S : 0, w = U.length / D, v = U.slice(), P = _D({ roundPositionsCount: w, groupedOrder: h }), b = (P == null ? void 0 : P.length) || 1;
    if (b <= w) {
      let A = U.length / b, N = zt(v, A);
      f === Wa && N.forEach((O) => O.reverse()), v = (P == null ? void 0 : P.length) && (P == null ? void 0 : P.map((O) => N[O - 1]).flat()) || v;
    }
    let T = zt(v, D);
    if (g) {
      let A = oe(0, g.interleave).map(() => {
      }), N = oe(0, g.offset).map(() => {
      });
      T = T.map((k) => [k, ...A]), T.unshift(N), T = T.flat(1);
      let O = T.length - g.offset;
      T = T.slice(0, O);
    }
    d[I] || (d[I] = {});
    let R = (C = u == null ? void 0 : u[I]) != null && C.feedRound ? 2 : 1;
    T.forEach((A, N) => {
      let O = 1 + N * R;
      d[I][O] || (d[I][O] = Qd(A));
    });
  }), { sourceDrawPositionRanges: d };
}
function BD({ drawDefinition: e }) {
  if (typeof e != "object")
    return { error: Po };
  let t = {}, { structures: r = [], links: i = [] } = e || {}, n = r.reduce((o, s) => {
    let { stage: c } = s;
    return o[c] ? o[c].push(s) : o[c] = [s], o;
  }, {});
  for (let o of Object.keys(n)) {
    let s = n[o].find(({ stageSequence: u }) => u === 1);
    if (!s)
      continue;
    let { structureId: c } = s;
    a({ aggregator: {}, targetRound: 0, exitProfiles: t, exitProfile: "0", structureId: c, stage: o });
  }
  return { exitProfiles: t };
  function a({ exitProfiles: o, exitProfile: s, structureId: c, targetRound: u, aggregator: d, stage: p }) {
    o[c] || (o[c] = []), s === "0" && [lr, vt].includes(p) || o[c].push(s);
    let l = i.filter((m) => m.source.structureId === c && m.source.roundNumber >= u);
    for (let m of l) {
      let f = m.source.roundNumber, h = m.target.roundNumber, g = m.target.structureId, I = r.find((U) => U.structureId === g).stage, y = [I, g, h, f].join("|");
      if (d[y])
        return;
      d[y] = !0, a({ exitProfile: `${s}-${f}`, structureId: g, exitProfiles: o, targetRound: h, aggregator: d, stage: I });
    }
  }
}
function PO({ drawDefinition: e, roundProfile: t, structureId: r, matchUpsMap: i }) {
  var o;
  if (!e)
    return { error: le };
  if (!r)
    return { error: ui };
  if (!t) {
    let s = Ka({ matchUpsMap: i, structureId: r });
    if ({ roundProfile: t } = Pr({ matchUps: s }), !t)
      return { error: Ie };
  }
  let n = (Math.min(...((o = t == null ? void 0 : t[1]) == null ? void 0 : o.drawPositions) ?? []) || 1) - 1, a = Object.keys(t);
  return { drawPositionsRanges: Object.assign({}, ...(a || []).map((s) => {
    var I, y;
    let c = (I = t == null ? void 0 : t[s]) == null ? void 0 : I.matchUpsCount, u = ((y = t == null ? void 0 : t[1]) == null ? void 0 : y.drawPositions) ?? [], d = zt(u, u.length / c), p = d.map(Qd), l = d.map((U) => U.map((S) => S - n)).map(Qd), m = a.map((U) => {
      var D;
      if (U > s)
        return;
      let S = ((D = t == null ? void 0 : t[U]) == null ? void 0 : D.drawPositions) ?? [];
      return zt(S, S.length / c);
    }).filter(Boolean), f = oe(0, c).map((U) => m.map((S) => S[U]).flat().filter(Boolean).sort(Ft)).map((U) => Te(U)), h = f.map((U) => jE(U).map(Qd).join(", ")), g = Object.assign({}, ...oe(0, c).map((U) => ({ [U + 1]: { firstRoundDrawPositionsRange: p[U], firstRoundOffsetDrawPositionsRange: l[U], possibleDrawPositions: f[U], drawPositionsRange: h[U] } })));
    return { [s]: g };
  })) };
}
function Hg({ roundsNotPowerOf2: e, drawDefinition: t, structure: r, matchUps: i }) {
  var a;
  if (!r)
    return !1;
  i = i ?? r.matchUps ?? [], e = e ?? Pr({ matchUps: i }).roundsNotPowerOf2;
  let n = !!((a = r.positionAssignments) != null && a.find(({ drawPosition: o }) => o)) || !!(i != null && i.find(({ drawPositions: o }) => o == null ? void 0 : o.length));
  return (!(t != null && t.drawType) || t.drawType !== so) && !(r != null && r.structures) && e && n;
}
function Er({ structure: e }) {
  if (!e)
    return !1;
  let t = e.matchUps || e.roundMatchUps && Object.values(e.roundMatchUps).flat(), r = !!(t != null && t.find((n) => n == null ? void 0 : n.roundPosition)), i = !!(t != null && t.find((n) => {
    var a;
    return (a = n == null ? void 0 : n.drawPositions) == null ? void 0 : a.length;
  }));
  return !(e != null && e.structures) && (e == null ? void 0 : e.stage) !== Jt && (!t.length || !r && !i);
}
var zg = { [$s]: { policyName: "Round Naming Default", namingConventions: { round: "Round", pre: "Pre" }, qualifyingFinishMap: { 1: "Final" }, abbreviatedRoundNamingMap: { 1: "F", 2: "SF", 4: "QF" }, roundNamingMap: { 1: "Final", 2: "Semifinal", 4: "Quarterfinal" }, affixes: { roundNumber: "R", preFeedRound: "Q", preQualifying: "P" }, stageConstants: { [ue]: "", [vt]: "P", [ge]: "Q", [lr]: "C" } } }, DO = zg;
function TO({ roundNamingPolicy: e, drawDefinition: t, structure: r, matchUps: i }) {
  var M, E, C;
  let { roundProfile: n, roundMatchUps: a } = Pr({ matchUps: i }), { structureAbbreviation: o, stage: s } = r, c = Er({ structure: r }), u = Hg({ structure: r }), d = r.structures, p = {}, l = zg[$s], m = r.stage === ge, f = m ? Math.max(...((t == null ? void 0 : t.structures) ?? []).filter((A) => A.stage === ge).map(({ stageSequence: A }) => A ?? 1), 0) : 0, h = (r.stageSequence ?? 1) < f ? r.stageSequence ?? 1 : "", g = h && (((M = e == null ? void 0 : e.affixes) == null ? void 0 : M.preQualifying) || l.affixes.preQualifying) || "", I = (e == null ? void 0 : e.roundNamingMap) || l.roundNamingMap || {}, y = (e == null ? void 0 : e.abbreviatedRoundNamingMap) || l.abbreviatedRoundNamingMap || {}, U = ((E = e == null ? void 0 : e.affixes) == null ? void 0 : E.preFeedRound) || l.affixes.preFeedRound, S = ((C = e == null ? void 0 : e.affixes) == null ? void 0 : C.roundNumber) || l.affixes.roundNumber, D = ((e == null ? void 0 : e.namingConventions) || l.namingConventions).round, w = s && s !== ue ? s[0] : "", v = (e == null ? void 0 : e.stageConstants) || l.stageConstants, P = s && (v == null ? void 0 : v[s]) || w, b = `${g}${P}${h}`, T = n ? Object.keys(n) : [], R = m && (v != null && v[ge]) ? `${v == null ? void 0 : v[ge]}-` : "";
  if (d || c || u)
    Object.assign(p, ...T.map((A) => {
      let N = `${R}${D} ${A}`, O = `${S}${A}`;
      return { [A]: { roundName: N, abbreviatedRoundName: O } };
    }));
  else {
    let A = m && ((e == null ? void 0 : e.qualifyingFinishMap) || (l == null ? void 0 : l.qualifyingFinishMap) || {});
    Object.assign(p, ...T.map((N) => {
      if (!(n != null && n[N]))
        return;
      let { matchUpsCount: O, preFeedRound: k } = n[N], F = O * 2, x = (A == null ? void 0 : A[n == null ? void 0 : n[N].finishingRound]) || A && `${S}${F}` || I[O] || `${S}${F}`, _ = k ? `-${U}` : "", B = `${x}${_}`, L = [b, o, B].filter(Boolean).join("-"), G = `${y[O] || `${S}${F}`}${_}`, $ = [b, o, G].filter(Boolean).join("-");
      return { [N]: { abbreviatedRoundName: $, roundName: L } };
    }));
  }
  return { roundNamingProfile: p, roundProfile: n, roundMatchUps: a };
}
var bO = (e, t) => (e || 0) + (t || 0);
function VD(e, t) {
  let r = Array.isArray(e) ? e[0] : e;
  return isNaN(r) && FD || r <= t[lu] && lu || r <= t[du] && du || Gg;
}
function jD({ score: e }) {
  let t = (e == null ? void 0 : e.sets) || [], r = t.reduce((n, a) => (n[0] += a.side1Score || 0, n[1] += a.side2Score || 0, n), [0, 0]), i = t.reduce((n, a) => (n[0] += a.side1TiebreakScore || 0, n[1] += a.side2TiebreakScore || 0, n), [0, 0]);
  return i.reduce(bO) && (r[i[0] > i[1] ? 0 : 1] += 1), { sets: t, games: r, score: e };
}
function RO(e) {
  let t = Math.min(...e.games), r = Math.max(...e.games);
  return Math.round(t / r * 100);
}
function GD(e) {
  return e.map(RO).sort().map((t) => parseFloat(t.toFixed(2)));
}
function Ju({ tournamentRecord: e, profileBands: t, matchUp: r }) {
  if (!r)
    return { error: Vr };
  let { score: i, winningSide: n } = r;
  if (!n)
    return { error: J };
  let a = !t && e && lo({ policyType: Bn, tournamentRecord: e }).policy, o = t || (a == null ? void 0 : a.profileBands) || $g[Bn].profileBands, s = jD({ score: i }), c = GD([s]), u = VD(c, o), d = Array.isArray(c) ? c[0] : c;
  return { ...V, competitiveness: u, pctSpread: d };
}
function $D({ matchUp: e }) {
  var o, s, c;
  if (!e)
    return { error: Vr };
  if (e && !e.sides)
    return { error: jr };
  if (e && !e.hasContext)
    return { error: Ql };
  let t = (o = e.sides ?? []) == null ? void 0 : o.map((u) => u == null ? void 0 : u.participantId).filter(Boolean), r = ((s = e.sides) == null ? void 0 : s.filter((u) => {
    var d;
    return ((d = u.participant) == null ? void 0 : d.participantType) === Oe;
  }).map((u) => u.participantId).filter(Boolean)) ?? [], i = (((c = e.sides ?? []) == null ? void 0 : c.map((u) => {
    var d;
    return (d = u.participant) == null ? void 0 : d.individualParticipants;
  }).filter(Boolean)) ?? []).map((u) => (u ?? []).map((d) => d == null ? void 0 : d.participantId).filter(Boolean)), n = [...r, ...i.flat()].filter(Boolean) ?? [], a = Te(n.concat(t)).filter(Boolean) ?? [];
  return { nestedIndividualParticipantIds: i, allRelevantParticipantIds: a, individualParticipantIds: n, sideParticipantIds: t, ...V };
}
var gl = "CHECK_IN", Il = "CHECK_OUT", MO = "SCHEDULE", rs = "SCHEDULE.ASSIGNMENT.VENUE", kn = "SCHEDULE.ALLOCATION.COURTS", va = "SCHEDULE.ASSIGNMENT.COURT", Ap = "SCHEDULE.COURT.ORDER", is = "SCHEDULE.DATE", NO = "COMPLETED.DATE", Yg = "HOME_PARTICIPANT_ID", Kg = "SCHEDULE.ASSIGN.OFFICIAL", ns = "SCHEDULE.TIME.SCHEDULED", Hi = "SCHEDULE.TIME.START", Gn = "SCHEDULE.TIME.STOP", Dn = "SCHEDULE.TIME.RESUME", Jn = "SCHEDULE.TIME.END", Ep = "SCHEDULE.TIME.MODIFIERS", qD = "TO_BE_ANNOUNCED", WD = "NEXT_AVAILABLE", HD = "FOLLOWED_BY", zD = "AFTER_REST", YD = "RAIN_DELAY", AO = "NOT_BEFORE", xf = [qD, WD, HD, zD, YD], EO = "ELIGIBILITY", CO = "REGISTRATION", OO = "SUSPENSION", kO = "MEDICAL", FO = "PENALTY", KD = "SCALE", QD = "RATING", JD = "RANKING", Qg = "SEEDING", Ea = "PUBLISH", li = "PUBLIC", Ca = "STATUS", xO = "MODIFICATION", LO = "RETRIEVAL", _O = "other", BO = { MUTUALLY_EXCLUSIVE_TIME_MODIFIERS: xf, AFTER_REST: zD, ALLOCATE_COURTS: kn, ASSIGN_COURT: va, ASSIGN_OFFICIAL: Kg, ASSIGN_VENUE: rs, CHECK_IN: gl, CHECK_OUT: Il, COMPLETED_DATE: NO, COURT_ORDER: Ap, ELIGIBILITY: EO, END_TIME: Jn, FOLLOWED_BY: HD, MEDICAL: kO, MODIFICATION: xO, NEXT_AVAILABLE: WD, NOT_BEFORE: AO, OTHER: _O, PENALTY: FO, PUBLIC: li, PUBLISH: Ea, RANKING: JD, RATING: QD, RAIN_DELAY: YD, REGISTRATION: CO, RESUME_TIME: Dn, RETRIEVAL: LO, SCALE: KD, SCHEDULE: MO, SCHEDULED_DATE: is, SCHEDULED_TIME: ns, SEEDING: Qg, START_TIME: Hi, STATUS: Ca, STOP_TIME: Gn, SUSPENSION: OO, TIME_MODIFIERS: Ep, TO_BE_ANNOUNCED: qD };
function as({ matchUp: e }) {
  if (!e)
    return { error: Vr };
  if (!e.hasContext)
    return { error: Ql };
  if (!e.sides || e.sides.filter(Boolean).length !== 2)
    return { error: jr };
  let { nestedIndividualParticipantIds: t, allRelevantParticipantIds: r, sideParticipantIds: i } = $D({ matchUp: e }), n = (e.timeItems ?? []).filter((s) => (s == null ? void 0 : s.itemType) && [gl, Il].includes(s.itemType)).sort((s, c) => (s.createdAt ? new Date(s.createdAt).getTime() : 0) - (c.createdAt ? new Date(c.createdAt).getTime() : 0)), a = n.map((s) => s.itemValue).filter((s) => n.filter((c) => (c == null ? void 0 : c.itemValue) === s).reverse()[0].itemType === gl);
  t == null || t.forEach((s, c) => {
    let u = i == null ? void 0 : i[c], d = (s == null ? void 0 : s.length) && s.every((p) => a.includes(p));
    u && d && !a.includes(u) && a.push(u);
  }), i == null || i.forEach((s, c) => {
    a.includes(s) && ((t == null ? void 0 : t[c]) ?? []).forEach((u) => {
      u && !a.includes(u) && a.push(u);
    });
  });
  let o = i == null ? void 0 : i.reduce((s, c) => a.includes(c) && s, !0);
  return { allRelevantParticipantIds: r, allParticipantsCheckedIn: o, checkedInParticipantIds: a, ...V };
}
var bt = (e) => (t) => {
  let r = Le(t) && (t == null ? void 0 : t.matchUpType) || ht(t) && t;
  return r && Sv[e].includes(r);
};
function Gc(e) {
  var a;
  let { matchUpAverageTimes: t, matchUpFormat: r } = e || {}, i = (t == null ? void 0 : t.map(({ matchUpFormatCodes: o }) => o == null ? void 0 : o.filter((s) => s === r)).flat().filter(Boolean).sort((o, s) => ((o == null ? void 0 : o.length) || 0) - ((s == null ? void 0 : s.length) || 0))) || [], n = i.includes(r) ? r : i[0];
  return (a = t == null ? void 0 : t.find(({ matchUpFormatCodes: o, averageTimes: s }) => (o == null ? void 0 : o.find((c) => n === c)) && s)) == null ? void 0 : a.averageTimes;
}
function $c(e) {
  var n;
  let { matchUpRecoveryTimes: t, averageMinutes: r, matchUpFormat: i } = e || {};
  return (n = t == null ? void 0 : t.find(({ matchUpFormatCodes: a, averageTimes: o, recoveryTimes: s }) => {
    if (o && r) {
      let { greaterThan: c = 0, lessThan: u = 360 } = o;
      if (r > c && r < u)
        return !0;
    }
    return (a == null ? void 0 : a.find((c) => c === i)) && s;
  })) == null ? void 0 : n.recoveryTimes;
}
function XD({ timesBlockArray: e, categoryName: t, categoryType: r }) {
  return e.filter((i) => Array.isArray(i)).map((i) => i.sort((n, a) => {
    var o, s;
    return (((o = a.categoryNames) == null ? void 0 : o.length) || 0) - (((s = n.categoryNames) == null ? void 0 : s.length) || 0);
  }).find(({ categoryTypes: n, categoryNames: a }) => !(a != null && a.length) && !(n != null && n.length) || (a == null ? void 0 : a.includes(t)) || (n == null ? void 0 : n.includes(r)))).find(Boolean);
}
function VO({ tournamentScheduling: e, eventScheduling: t, averageMinutes: r, defaultTiming: i, matchUpFormat: n, categoryName: a, categoryType: o, policy: s }) {
  var l;
  let c = (t == null ? void 0 : t.matchUpRecoveryTimes) && $c({ ...t, averageMinutes: r, matchUpFormat: n }), u = (e == null ? void 0 : e.matchUpRecoveryTimes) && $c({ ...e, averageMinutes: r, matchUpFormat: n }), d = (s == null ? void 0 : s.matchUpRecoveryTimes) && $c({ ...s, averageMinutes: r, matchUpFormat: n }), p = [c, u, d, (l = s == null ? void 0 : s.defaultTimes) == null ? void 0 : l.recoveryTimes, i == null ? void 0 : i.recoveryTimes];
  return XD({ categoryName: a, categoryType: o, timesBlockArray: p });
}
function jO({ matchUpFormat: e, categoryName: t, categoryType: r, defaultTiming: i, tournamentScheduling: n, eventScheduling: a, policy: o }) {
  var p;
  let s = (a == null ? void 0 : a.matchUpAverageTimes) && Gc({ ...a, matchUpFormat: e }), c = (n == null ? void 0 : n.matchUpAverageTimes) && Gc({ ...n, matchUpFormat: e }), u = (o == null ? void 0 : o.matchUpAverageTimes) && Gc({ ...o, matchUpFormat: e }), d = [s, c, u, (p = o == null ? void 0 : o.defaultTimes) == null ? void 0 : p.averageTimes, i == null ? void 0 : i.averageTimes];
  return XD({ categoryName: t, categoryType: r, timesBlockArray: d });
}
var ZD = "DOUBLES_SINGLES", eT = "SINGLES_DOUBLES", xi = "total", Lf = "participantConflict", ca = "matchUpConflict", tT = "ISSUE_IDS", Fa = "CONFLICT", xa = "WARNING", _f = "ERROR", Bf = "ISSUE", Jd = "STATE", GO = { SINGLES_DOUBLES: eT, DOUBLES_SINGLES: ZD, TOTAL: xi, CONFLICT_MATCHUP_ORDER: ca, CONFLICT_PARTICIPANTS: Lf, SCHEDULE_ISSUE_IDS: tT, SCHEDULE_CONFLICT: Fa, SCHEDULE_WARNING: xa, SCHEDULE_ERROR: _f, SCHEDULE_ISSUE: Bf, SCHEDULE_STATE: Jd };
function Xu({ defaultAverageMinutes: e = 90, defaultRecoveryMinutes: t = 0, tournamentRecord: r, matchUpFormat: i, categoryName: n, categoryType: a, eventType: o, event: s }) {
  if (!r)
    return { error: ae };
  o = o ?? (s == null ? void 0 : s.eventType) ?? ko;
  let c = { averageTimes: [{ minutes: { default: e } }], recoveryTimes: [{ minutes: { default: t } }] }, { scheduleTiming: u } = $u({ tournamentRecord: r, categoryName: n, categoryType: a, event: s }), d = { ...u, matchUpFormat: i, categoryType: a, defaultTiming: c };
  return Cp({ eventType: o, timingDetails: d });
}
function Cp({ timingDetails: e, eventType: t }) {
  let r = jO(e), i = Object.keys((r == null ? void 0 : r.minutes) || {}), n = (r == null ? void 0 : r.minutes) && ((i == null ? void 0 : i.includes(t)) && r.minutes[t] || r.minutes.default), a = VO({ ...e, averageMinutes: n }), o = Object.keys((a == null ? void 0 : a.minutes) || {}), s = (a == null ? void 0 : a.minutes) && ((o == null ? void 0 : o.includes(t)) && a.minutes[t] || a.minutes.default), c = bt(ko)(t) ? eT : ZD, u = (a == null ? void 0 : a.minutes) && ((o == null ? void 0 : o.includes(c)) && a.minutes[c] || s);
  return { averageMinutes: n, recoveryMinutes: s, typeChangeRecoveryMinutes: u };
}
function Hm(e) {
  return e.createdAt ? new Date(e.createdAt).getTime() : 0;
}
function fo({ timeItems: e, itemType: t }) {
  let r = e.filter((n) => n && n.itemType === t).sort((n, a) => Hm(n) - Hm(a)).pop(), i = r && Hm(r);
  return { itemValue: r == null ? void 0 : r.itemValue, timeStamp: i };
}
function rT({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = fo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: ns });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { scheduledTime: i } : t;
}
function os({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = fo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: is });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { scheduledDate: i } : t;
}
function yo(e) {
  if (eP.test(e)) {
    let t = Qh();
    return /* @__PURE__ */ new Date(`${t}T${e}`);
  } else
    return new Date(e);
}
function $O({ matchUp: e }) {
  if (!e)
    return { error: Vr };
  if (!e.timeItems)
    return { error: _h };
  let t = e.timeItems.filter((i) => [Hi, Gn, Dn, Jn].includes(i == null ? void 0 : i.itemType)).sort((i, n) => yo(i.itemValue).getTime() - yo(n.itemValue).getTime()), r = t.reduce((i, n) => {
    var c, u;
    let a, o = (c = n == null ? void 0 : n.itemType) == null ? void 0 : c.split("."), s = `SCHEDULE.TIME.${((u = n == null ? void 0 : n.itemType) == null ? void 0 : u.startsWith("SCHEDULE.TIME")) && o[2]}`;
    switch (s) {
      case Hi:
        a = 0;
        break;
      case Jn:
        if (i.lastValue && [Hi, Dn].includes(i.lastType)) {
          let d = yo(n.itemValue).getTime() - yo(i.lastValue).getTime();
          a = i.milliseconds + d;
        } else
          a = i.milliseconds;
        break;
      case Gn:
        if ([Hi, "SCHECULE.TIME.RESUME"].includes(i.lastType)) {
          let d = yo(n.itemValue).getTime() - yo(i.lastValue).getTime();
          a = i.milliseconds + d;
        } else
          a = i.milliseconds;
        break;
      default:
        a = i.milliseconds;
        break;
    }
    return { milliseconds: a, lastType: s, lastValue: n.itemValue };
  }, { milliseconds: 0, lastType: void 0, lastValue: void 0 });
  if ([Hi, Dn].includes(r.lastType)) {
    let i = (/* @__PURE__ */ new Date()).getTime() - yo(r.lastValue).getTime();
    r.milliseconds += i;
  }
  return { milliseconds: r.milliseconds, time: qO(r.milliseconds), relevantTimeItems: t };
}
function qO(e) {
  let t = (r, i = 2) => ("00" + r).slice(-i);
  return t(e / 36e5 | 0) + ":" + t(e % 36e5 / 6e4 | 0) + ":" + t(e % 6e4 / 1e3 | 0);
}
function WO({ matchUp: e }) {
  var i;
  let t = (e == null ? void 0 : e.timeItems) || [], r = (n) => n.createdAt ? new Date(n.createdAt).getTime() : 0;
  return { startTime: (i = t.reduce((n, a) => {
    let o = a.itemType === Hi && a;
    return o && (!n || r(o) < r(n)) ? o : n;
  }, void 0)) == null ? void 0 : i.itemValue };
}
function Zu(e) {
  let { disableNotice: t, venue: r, context: i } = e;
  if (typeof r != "object")
    return { error: J };
  let n = wi(e);
  r.venueId || (r.venueId = ze());
  let a;
  for (let o of Object.values(n)) {
    let s = HO({ disableNotice: !0, tournamentRecord: o, context: i, venue: r });
    if (s != null && s.error)
      return s;
    a = s.venue;
  }
  return t || De({ topic: Tg, payload: { venue: r } }), me({ ...V, venue: a });
}
function HO({ tournamentRecord: e, disableNotice: t, context: r, venue: i }) {
  return e ? i ? (e.venues || (e.venues = []), i.venueId || (i.venueId = ze()), e.venues.reduce((n, a) => n || a.venueId === i.venueId, void 0) ? { error: ww } : (r && Ve({ element: i, extension: { value: r, name: oD } }), e.venues.push(i), t || De({ payload: { venue: i, tournamentId: e.tournamentId }, topic: Tg }), { ...V, venue: ce(i) })) : { error: Ie, info: "missing venue" } : { error: ae };
}
function xn({ tournamentRecords: e, tournamentRecord: t, venueId: r }) {
  if (!t)
    return { error: ae };
  if (!r)
    return { error: Ta };
  let i = (t.venues ?? []).reduce((n, a) => a.venueId === r ? a : n, void 0);
  if (!i && e) {
    let n = (Bu({ tournamentRecords: e }).linkedTournamentIds ?? [])[t.tournamentId];
    for (let a of n) {
      let o = e[a], s = xn({ tournamentRecord: o, venueId: r });
      if (s.success && s.venue)
        return Zu({ tournamentRecord: t, venue: s.venue }), { ...V, venue: i };
    }
  }
  return i ? { ...V, venue: i } : { error: zo };
}
function Jg({ convertExtensions: e, ...t }) {
  let { tournamentRecords: r, tournamentRecord: i, venueId: n } = t, a = xn({ tournamentRecords: r, tournamentRecord: i, venueId: n });
  return ce(a, e, !0);
}
function ss({ tournamentRecords: e, tournamentRecord: t, courtId: r }) {
  if (!t)
    return { error: ae };
  if (!r)
    return { error: qo };
  let i = "findCourt", n, a;
  if ((t.venues ?? []).forEach((o) => {
    (o.courts ?? []).forEach((s) => {
      s.courtId === r && (n = s, a = o);
    });
  }), n)
    return { ...V, court: n, venue: a };
  if (e) {
    let o = (Bu({ tournamentRecords: e }).linkedTournamentIds ?? [])[t.tournamentId];
    for (let s of o) {
      let c = e[s], u = ss({ tournamentRecord: c, courtId: r });
      if (u.success)
        return u.venue && Zu({ tournamentRecord: t, venue: u.venue }), { ...V, court: n, venue: a };
    }
  }
  return j({ result: { error: sc }, stack: i });
}
function Xg(e) {
  return ce(ss(e), !1, !0);
}
function Op({ tournamentRecord: e, internalUse: t, courtId: r }) {
  if (!e)
    return { error: ae };
  if (!r)
    return { error: qo };
  let i = ss({ tournamentRecord: e, courtId: r });
  if (i.error)
    return i;
  let n = i.court && (({ altitude: a, courtId: o, courtName: s, courtDimensions: c, latitude: u, longitude: d, surfaceCategory: p, surfaceType: l, surfacedDate: m, pace: f, notes: h }) => ({ altitude: a, courtId: o, courtName: s, courtDimensions: c, latitude: u, longitude: d, surfaceCategory: p, surfaceType: l, surfacedDate: m, pace: f, notes: h }))(i.court);
  return { ...V, courtInfo: ce(n, !1, t) };
}
function zs(e) {
  var c;
  let t = fe(e, [{ [Gt]: !0 }, { venueId: !0, [ki]: Ta }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, venueId: i } = e, n = xn({ tournamentRecord: r, venueId: i });
  if (n.error)
    return n;
  let a = (((c = n.venue) == null ? void 0 : c.courts) ?? []).map((u) => (({ courtInfo: d }) => ({ ...d }))(Op({ courtId: u.courtId, internalUse: !0, tournamentRecord: r }))), o = n.venue && (({ venueId: u, venueName: d, venueAbbreviation: p }) => ({ venueAbbreviation: p, venueName: d, venueId: u }))(n.venue), s = o && { ...o, courtsInfo: a };
  return { ...V, venueData: ce(s, !1, !0) };
}
function zO({ matchUp: e }) {
  var i;
  let t = (e == null ? void 0 : e.timeItems) || [], r = (n) => n.createdAt ? new Date(n.createdAt).getTime() : 0;
  return { endTime: (i = t.reduce((n, a) => {
    let o = a.itemType === Jn && a;
    return o && (!n || r(o) > r(n)) ? o : n;
  }, void 0)) == null ? void 0 : i.itemValue };
}
function Pt({ event: e, eventId: t }) {
  var n, a;
  if (!e)
    return { error: pt };
  let r = (n = Ne({ name: _i, element: e })) == null ? void 0 : n.extension, i = t ? ce(r == null ? void 0 : r.value, !1, !0) : r == null ? void 0 : r.value;
  return t && ((a = e.drawDefinitions) == null || a.forEach((o) => {
    var s;
    (s = i == null ? void 0 : i.flights) == null || s.forEach((c) => {
      c.drawId === o.drawId && Object.assign(c, { drawDefinition: o });
    });
  })), { flightProfile: i };
}
function Cr(e) {
  let { tournamentRecord: t, eventId: r, drawId: i } = e, n = "findEvent", a = {}, o = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, s = Object.values(o).map(({ events: u, tournamentId: d }) => (u && u.forEach((p) => {
    a[p.eventId] = { tournamentId: d };
  }), u ?? [])).flat(), c;
  if (i) {
    let u, d = s.find((p) => {
      var m, f, h;
      let l = ((p == null ? void 0 : p.drawDefinitions) ?? []).find((g) => g.drawId === i);
      if (l)
        u = l, c = a[p.eventId].tournamentId;
      else {
        let g = (h = (f = p && ((m = Pt({ event: p })) == null ? void 0 : m.flightProfile)) == null ? void 0 : f.flights) == null ? void 0 : h.find((I) => I.drawId === i);
        if (g)
          return c = a[p.eventId].tournamentId, { entries: g.drawEntries, drawName: g.drawName, tournamentId: c, drawId: i };
      }
      return l;
    });
    if (d)
      return { event: d, drawDefinition: u, tournamentId: c };
  }
  if (r) {
    let u = s.find((d) => (d == null ? void 0 : d.eventId) === r);
    if (u)
      c = a[u.eventId].tournamentId;
    else
      return { event: void 0, drawDefinition: void 0, ...j({ result: { error: Ii }, stack: n }) };
    return { event: u, drawDefinition: void 0, tournamentId: c };
  }
  return { event: void 0, drawDefinition: void 0, ...j({ result: { error: ai }, context: { drawId: i, eventId: r }, stack: n }) };
}
function kp(e) {
  var D, w, v, P, b, T, R, M, E, C;
  let t = e.event, r = e.matchUpType, { scheduleVisibilityFilters: i, afterRecoveryTimes: n, tournamentRecord: a, usePublishState: o, scheduleTiming: s, matchUpFormat: c, publishStatus: u, matchUp: d } = e;
  if (!d)
    return { error: Vr };
  if (n && !d.matchUpType && !e.matchUpType && (t || a) && d.drawId) {
    let A = e.drawDefinition || ((D = t == null ? void 0 : t.drawDefinitions) == null ? void 0 : D.find((O) => O.drawId === d.drawId));
    !A && a && ({ drawDefinition: A, event: t } = Cr({ drawId: d.drawId, tournamentRecord: a }));
    let N = d.structureId && ((w = A == null ? void 0 : A.structures) == null ? void 0 : w.find(({ structureId: O }) => O === d.structureId));
    r = e.matchUpType || (N == null ? void 0 : N.matchUpType) || (A == null ? void 0 : A.matchUpType) || (t == null ? void 0 : t.eventType) !== xt && (t == null ? void 0 : t.eventType);
  }
  let { milliseconds: p, time: l } = $O({ matchUp: d }), { startTime: m } = WO({ matchUp: d }), { endTime: f } = zO({ matchUp: d }), h, { eventIds: g, drawIds: I } = i ?? {};
  if ((!g || g.includes(d.eventId)) && (!I || I.includes(d.drawId))) {
    let A = (ie) => ie.createdAt ? new Date(ie.createdAt).getTime() : 0, N = /* @__PURE__ */ new Map(), O = ((v = d.timeItems) == null ? void 0 : v.toSorted((ie, he) => A(ie) - A(he))) ?? [];
    for (let ie of O)
      N.set(ie.itemType, ie.itemValue);
    let k = N.get(Yg), F = N.get(kn), x = N.get(ns), _ = N.get(Ep), B = N.get(is), L = N.get(Kg), G = N.get(Ap), $ = N.get(rs), W = N.get(va), q, K, z, Y, X, re = d.matchUpType ?? r;
    if (s && x && n && re) {
      let ie = { matchUpFormat: d.matchUpFormat ?? c, ...s };
      ({ averageMinutes: K = 0, recoveryMinutes: z = 0, typeChangeRecoveryMinutes: Y = 0 } = Cp({ timingDetails: ie, eventType: re })), (K || z) && (q = f ? Br(mt(f), z) : Br(x, K + z)), Y && (X = f ? Br(mt(f), Y) : Br(x, K + Y));
    }
    !B && x && (B = be(x));
    let Q = sl({ scheduledDate: B, scheduledTime: x }), H = {}, Z = ((P = a && $ && zs({ tournamentRecord: a, venueId: $ })) == null ? void 0 : P.venueData) || {};
    $ && (H[$] = Z);
    let { venueName: ee, venueAbbreviation: te, courtsInfo: ne } = Z, se = (b = W && (ne == null ? void 0 : ne.find((ie) => ie.courtId === W))) == null ? void 0 : b.courtName;
    for (let ie of F || []) {
      if (!a)
        break;
      ie.venueId && !H[ie.venueid] && (H[ie.venueId] = (T = zs({ venueId: ie.venueId, tournamentRecord: a })) == null ? void 0 : T.venueData);
      let he = H[ie.venueId];
      ie.venueName = he == null ? void 0 : he.venueName;
      let Ee = (R = he == null ? void 0 : he.courtsInfo) == null ? void 0 : R.find((de) => de.courtId === ie.courtId);
      ie.courtName = Ee == null ? void 0 : Ee.courtName;
    }
    h = me({ typeChangeTimeAfterRecovery: X, timeAfterRecovery: q, scheduledDate: B, scheduledTime: x, isoDateString: Q, homeParticipantId: k, venueAbbreviation: te, allocatedCourts: F, timeModifiers: _, venueName: ee, venueId: $, courtOrder: G, courtName: se, courtId: W, official: L, typeChangeRecoveryMinutes: Y, recoveryMinutes: z, averageMinutes: K, milliseconds: p, startTime: m, endTime: f, time: l });
  } else
    h = me({ milliseconds: p, startTime: m, endTime: f, time: l });
  let { scheduledDate: y } = os({ matchUp: d }), { scheduledTime: U } = rT({ matchUp: d });
  if (o && ((M = u == null ? void 0 : u.displaySettings) != null && M.draws)) {
    let A = u.displaySettings.draws, N = (E = (A == null ? void 0 : A[d.drawId]) ?? (A == null ? void 0 : A.default)) == null ? void 0 : E.scheduleDetails;
    if (N) {
      let O = (C = N.find((k) => {
        var F;
        return y && ((F = k.dates) == null ? void 0 : F.includes(y));
      }) ?? N.find((k) => {
        var F;
        return !((F = k.dates) != null && F.length);
      })) == null ? void 0 : C.attributes;
      if (O) {
        let k = Object.assign({}, ...Object.keys(h).map((F) => ({ [F]: !0 })), O);
        h = xo({ source: h, template: k });
      }
    }
  }
  let S = d.matchUpStatus && Vt.includes(d.matchUpStatus) && (be(f) || be(y) || be(U)) || void 0;
  return { schedule: h, endDate: S };
}
function YO({ drawPositions: e, roundProfile: t, roundNumber: r }) {
  var s;
  let i = [void 0, void 0];
  if (Rv(e))
    return { orderedDrawPositions: i, displayOrder: i };
  let n = t == null ? void 0 : t[r], a = ((s = n == null ? void 0 : n.pairedDrawPositions) == null ? void 0 : s.find((c) => wr(c || [], e.filter(Boolean)))) ?? i, o = n == null ? void 0 : n.feedRound;
  if (bv(e)) {
    let c = [...e].sort(Ft);
    return { orderedDrawPositions: c.length === 2 ? c : a, displayOrder: o ? c : a };
  }
  if (o) {
    let c = [e.find((u) => !isNaN(ye(u))), void 0];
    return { orderedDrawPositions: c, displayOrder: c };
  }
  return { orderedDrawPositions: a, displayOrder: a };
}
function Ul({ collectionPosition: e, collectionId: t, lineUp: r }) {
  let i = [], n = [];
  if (r) {
    let a = (s) => s === void 0 ? -1 : s, o = r.map((s) => {
      let { collectionAssignments: c, participantId: u } = s, d = c == null ? void 0 : c.find((p) => p.collectionPosition === e && p.collectionId === t);
      return d && { participantId: u, ...d };
    }).filter(Boolean).sort((s, c) => a(s.substitutionOrder) - a(c.substitutionOrder));
    for (let s of o) {
      let { participantId: c, previousParticipantId: u, substitutionOrder: d } = s;
      i.includes(c) || (u && n.push({ previousParticipantId: u, substitutionOrder: d, participantId: c }), i = i.filter((p) => p !== u), i.push(c));
    }
  }
  return { assignedParticipantIds: i, substitutions: n };
}
function Vi({ tournamentParticipants: e, tournamentRecord: t, participantIds: r }) {
  let i = "getPairedParticipant";
  if (!e && !t)
    return { error: ae };
  if (!Array.isArray(r) || r.length > 2)
    return { error: Yr };
  if (!r.length)
    return j({ result: { error: Da }, stack: i });
  e = e ?? (t == null ? void 0 : t.participants) ?? [];
  let n = e.filter((s) => s.participantType === Re && wt(r, s.individualParticipantIds).length === r.length && s.individualParticipantIds.length === r.length), a = n[0];
  if (!a)
    return j({ result: { error: Dt }, stack: i });
  let o = ce(n.slice(1), !1, !0);
  return { participant: ce(a), duplicatedPairParticipants: o, ...V };
}
function Qa({ drawDefinition: e, participantId: t }) {
  if (typeof e != "object")
    return { error: le };
  if (typeof t != "string")
    return { error: _t };
  let { extension: r } = Ne({ element: e, name: Yn });
  return { lineUp: ((r == null ? void 0 : r.value) || {})[t] };
}
function KO({ tournamentParticipants: e, positionAssignments: t, collectionPosition: r, drawPositions: i = [], participantMap: n, drawDefinition: a, collectionId: o, sideLineUps: s, matchUpType: c }) {
  if (!o || !r)
    return {};
  let u = ({ attribute: p, lineUp: l, teamParticipant: m }) => {
    var g, I, y, U;
    let { assignedParticipantIds: f, substitutions: h } = Ul({ collectionPosition: r, collectionId: o, lineUp: l });
    if (c === tt) {
      if ((f == null ? void 0 : f.length) <= 2) {
        let S = (I = (g = n == null ? void 0 : n[f[0]]) == null ? void 0 : g.pairIdMap) == null ? void 0 : I[f[1]], D = (U = S && ((y = n[S]) == null ? void 0 : y.participant) || Vi({ participantIds: f, tournamentParticipants: e }).participant) == null ? void 0 : U.participantId;
        return { [p]: { participantId: D, teamParticipant: m, substitutions: h } };
      } else if ((f == null ? void 0 : f.length) > 2)
        return { [p]: { teamParticipant: m, substitutions: h } };
    } else {
      let S = f == null ? void 0 : f[0];
      return S && { [p]: { participantId: S, teamParticipant: m, substitutions: h } };
    }
  };
  if (!(i != null && i.length)) {
    let p = (s == null ? void 0 : s.map((l) => {
      var g;
      let { teamParticipant: m, sideNumber: f } = l, h = l.lineUp || ((g = Qa({ participantId: m.teamParticipantId, drawDefinition: a })) == null ? void 0 : g.lineUp);
      return u({ attribute: f, lineUp: h, teamParticipant: m });
    }).filter(Boolean)) || {};
    return { sideNumberCollectionAssignment: Object.assign({}, ...p) };
  }
  let d = (i == null ? void 0 : i.map((p) => {
    var g, I, y;
    let l = (g = t.find((U) => U.drawPosition === p)) == null ? void 0 : g.participantId, m = s == null ? void 0 : s.find((U) => (U == null ? void 0 : U.drawPosition) === p), f = (m == null ? void 0 : m.teamParticipant) || l && ((I = n == null ? void 0 : n[l]) == null ? void 0 : I.participant) || (e == null ? void 0 : e.find(({ participantId: U }) => U === l)), h = (m == null ? void 0 : m.lineUp) || ((y = Qa({ participantId: l, drawDefinition: a })) == null ? void 0 : y.lineUp);
    return u({ attribute: p, lineUp: h, teamParticipant: f });
  }).filter(Boolean)) || {};
  return { drawPositionCollectionAssignment: Object.assign({}, ...d) };
}
function Fp(e) {
  var n, a, o;
  let t = fe(e, [{ [Fn]: !0 }]);
  if (t.error)
    return t;
  let r = e == null ? void 0 : e.matchUp, i = r == null ? void 0 : r.matchUpType;
  if (!i && ((n = r == null ? void 0 : r.sides) != null && n.length)) {
    let s = (o = (a = r.sides.find(({ participant: c }) => c)) == null ? void 0 : a.participant) == null ? void 0 : o.participantType;
    i = s === Oe && rt || s === Re && tt || s === Xe && Xe || void 0;
  }
  return { matchUpType: i };
}
function QO({ drawPositionCollectionAssignment: e, sideNumberCollectionAssignment: t, positionAssignments: r, displaySideNumber: i, seedAssignments: n, drawPosition: a, isFeedRound: o, sideNumber: s }) {
  var m, f, h, g;
  let c = r.find((I) => I.drawPosition && I.drawPosition === a), u = a && e, d = s && t, p = u ? (m = u[a]) == null ? void 0 : m.participantId : c == null ? void 0 : c.participantId, l = c ? JO({ displaySideNumber: i, seedAssignments: n, participantId: p, assignment: c, sideNumber: s }) : { ...d == null ? void 0 : d[s] };
  if (o && (s === 1 ? Object.assign(l, { participantFed: !0 }) : Object.assign(l, { participantAdvanced: !0 })), a && u) {
    let I = (f = u[a]) == null ? void 0 : f.teamParticipant, y = (h = u[a]) == null ? void 0 : h.participant, U = (g = u[a]) == null ? void 0 : g.substitutions;
    y && (l.participant = y), U && (l.substitutions = U), I && (l.teamParticipant = I);
  }
  return l;
}
function JO({ displaySideNumber: e, seedAssignments: t, participantId: r, assignment: i, sideNumber: n }) {
  let a = { drawPosition: i.drawPosition, displaySideNumber: e, sideNumber: n };
  if (r) {
    let o = XO({ seedAssignments: t, participantId: r });
    Object.assign(a, o, { participantId: r }), o != null && o.seedNumber && (o == null ? void 0 : o.seedValue) === "" && (a.seedValue = "~");
  } else
    i.bye && Object.assign(a, { bye: !0 });
  return i.qualifier && Object.assign(a, { qualifier: !0 }), a;
}
function XO({ seedAssignments: e, participantId: t }) {
  return e == null ? void 0 : e.find((r) => !r.seedProxy && r.participantId === t);
}
function iT({ scheduleVisibilityFilters: e, sourceDrawPositionRanges: t, tournamentParticipants: r, positionAssignments: i, drawPositionsRanges: n, hydrateParticipants: a, afterRecoveryTimes: o, initialRoundOfPlay: s, additionalContext: c, roundNamingProfile: u, tournamentRecord: d, tieDrawPositions: p, appliedPolicies: l, isCollectionBye: m, seedAssignments: f, usePublishState: h, participantMap: g, contextContent: I, scheduleTiming: y, contextProfile: U, drawDefinition: S, publishStatus: D, scoringActive: w, matchUpTieId: v, isRoundRobin: P, roundProfile: b, sideLineUps: T, structure: R, context: M, matchUp: E, event: C }) {
  var nt, Ze, st, qt, Ct, Mt, Ye, He, rr, Je, Nt, Wi, Kt, At, kr;
  c = c ?? {};
  let A = (nt = Ir({ drawDefinition: S, structure: R, matchUp: E, event: C })) == null ? void 0 : nt.tieFormat, { roundOffset: N, structureId: O, structureName: k, stage: F, stageSequence: x } = R, { drawId: _, drawName: B, drawType: L } = S ?? {}, G = A == null ? void 0 : A.collectionDefinitions, $ = E.collectionId && (G == null ? void 0 : G.find((Me) => Me.collectionId === E.collectionId)), W = E.collectionId ? $ == null ? void 0 : $.matchUpFormat : E.matchUpFormat ?? (R == null ? void 0 : R.matchUpFormat) ?? (S == null ? void 0 : S.matchUpFormat) ?? (C == null ? void 0 : C.matchUpFormat), q = E.matchUpType || ($ == null ? void 0 : $.matchUpType) || (R == null ? void 0 : R.matchUpType) || (S == null ? void 0 : S.matchUpType) || !bt(xt)(C == null ? void 0 : C.eventType) && (C == null ? void 0 : C.eventType), K = m ? $e : E.matchUpStatus, { schedule: z, endDate: Y } = kp({ scheduleVisibilityFilters: e, afterRecoveryTimes: o, tournamentRecord: d, usePublishState: h, scheduleTiming: y, drawDefinition: S, matchUpFormat: W, publishStatus: D, matchUpType: q, matchUp: E, event: C }), X = p ?? E.drawPositions ?? [], { collectionPosition: re, collectionId: Q, roundPosition: H } = E, Z = E.roundNumber ?? c.roundNumber, ee = Q ? KO({ tournamentParticipants: r, positionAssignments: i, collectionPosition: re, participantMap: g, drawDefinition: S, drawPositions: X, collectionId: Q, sideLineUps: T, matchUpType: q }) : void 0, te = ((Ze = u == null ? void 0 : u[Z]) == null ? void 0 : Ze.roundName) || c.roundName, ne = ((st = u == null ? void 0 : u[Z]) == null ? void 0 : st.abbreviatedRoundName) || c.abbreviatedRoundName, se = (qt = b == null ? void 0 : b[Z]) == null ? void 0 : qt.feedRound, ie = (Ct = b == null ? void 0 : b[Z]) == null ? void 0 : Ct.preFeedRound, he = (Mt = b == null ? void 0 : b[Z]) == null ? void 0 : Mt.roundFactor, Ee = n == null ? void 0 : n[Z], de = H ? Ee == null ? void 0 : Ee[H] : void 0, it = t == null ? void 0 : t[Z], qe = $ != null && $.category ? { ...(M == null ? void 0 : M.category) || {}, ...$.category } : (M == null ? void 0 : M.category) ?? (C == null ? void 0 : C.category), ar = ((Ye = E.processCodes) == null ? void 0 : Ye.length) && E.processCodes || ((He = $ == null ? void 0 : $.processCodes) == null ? void 0 : He.length) && ($ == null ? void 0 : $.processCodes) || ((rr = R == null ? void 0 : R.processCodes) == null ? void 0 : rr.length) && (R == null ? void 0 : R.processCodes) || ((Je = S == null ? void 0 : S.processCodes) == null ? void 0 : Je.length) && (S == null ? void 0 : S.processCodes) || ((Nt = C == null ? void 0 : C.processCodes) == null ? void 0 : Nt.length) && (C == null ? void 0 : C.processCodes) || (d == null ? void 0 : d.processCodes), $t = (U == null ? void 0 : U.withCompetitiveness) && Ju({ ...I, matchUp: E }), Ue = E.finishingPositionRange ?? c.finishingPositionRange, Se = (Me) => me(Me, void 0, !0), pe = { ...Se(M), ...Se({ matchUpFormat: E.matchUpType === xt ? void 0 : W, tieFormat: E.matchUpType !== xt ? void 0 : A, gender: ($ == null ? void 0 : $.gender) ?? (C == null ? void 0 : C.gender), roundOfPlay: F !== ge && Pe(s) && s + (Z || 0), endDate: E.endDate ?? Y, discipline: C == null ? void 0 : C.discipline, category: qe, finishingPositionRange: Ue, abbreviatedRoundName: ne, drawPositionsRange: de, competitiveProfile: $t, structureName: k, stageSequence: x, drawPositions: X, matchUpStatus: K, processCodes: ar, isRoundRobin: P, matchUpTieId: v, preFeedRound: ie, matchUpType: q, roundFactor: he, roundOffset: N, structureId: O, roundNumber: Z, feedRound: se, roundName: te, drawName: B, drawType: L, schedule: z, drawId: _, stage: F }), ...ce(Se(E), !0, !0) };
  if (W && ((Wi = E.score) != null && Wi.scoreStringSide1)) {
    let Me = Tr(W), { bestOf: or, finalSetFormat: Fe, setFormat: ct } = Me ?? {};
    (Fe != null && Fe.tiebreakSet || ct != null && ct.tiebreakSet || ct != null && ct.timed) && (pe.score.sets = pe.score.sets.sort((ir, ri) => ir.setNumber - ri.setNumber).map((ir, ri) => (ri + 1 === or ? (Fe != null && Fe.tiebreakSet || Fe != null && Fe.timed) && (ir.tiebreakSet = !0) : (ct != null && ct.tiebreakSet || ct != null && ct.timed) && (ir.tiebreakSet = !0), ir)));
  }
  if (Array.isArray(X)) {
    let { orderedDrawPositions: Me, displayOrder: or } = YO({ drawPositions: X, roundProfile: b, roundNumber: Z }), Fe = (Kt = b == null ? void 0 : b[Z]) == null ? void 0 : Kt.feedRound, ct = or[0] !== Me[0], ir = Me.concat(void 0, void 0).slice(0, 2).map((ri, Fr) => {
      var _y;
      let qr = Fr + 1, xr = ct ? 3 - qr : qr, _n = QO({ ...ee, positionAssignments: i, displaySideNumber: xr, seedAssignments: f, drawPosition: ri, isFeedRound: Fe, sideNumber: qr }), Sn = (_y = E.sides) == null ? void 0 : _y.find((CA) => CA.sideNumber === qr), kc = H ? (H - 1) * 2 + Fr + 1 : void 0, EA = kc ? it == null ? void 0 : it[kc] : void 0;
      return Se({ sourceDrawPositionRange: EA, ...Sn, ..._n });
    });
    Object.assign(pe, ce({ sides: ir }, !0, !0));
  }
  if (r && pe.sides && a !== !1) {
    let Me = l == null ? void 0 : l[mc], or = (Fe) => {
      var ir;
      let ct = (ir = g == null ? void 0 : g[Fe]) == null ? void 0 : ir.participant;
      return ct && xo({ template: Me == null ? void 0 : Me.participant, source: ct });
    };
    if (pe.sides.filter(Boolean).forEach((Fe) => {
      var ct, ir, ri, Fr;
      if (Fe.participantId) {
        let qr = ce(or(Fe.participantId) || (r ? ga({ policyDefinitions: l, participantId: Fe.participantId, tournamentParticipants: r, internalUse: !0, contextProfile: U }) : void 0), void 0, !0);
        if (qr) {
          if (S != null && S.entries) {
            let xr = S.entries.find((Sn) => Sn.participantId === Fe.participantId), _n = (ct = C == null ? void 0 : C.entries) == null ? void 0 : ct.find((Sn) => Sn.participantId === Fe.participantId);
            qr.entryStatus = (xr == null ? void 0 : xr.entryStatus) || (_n == null ? void 0 : _n.entryStatus), xr != null && xr.entryStage && (qr.entryStage = xr.entryStage);
          }
          Object.assign(Fe, { participant: qr });
        }
      }
      if ((ri = (ir = Fe == null ? void 0 : Fe.participant) == null ? void 0 : ir.individualParticipantIds) != null && ri.length && !((Fr = Fe.participant.individualParticipants) != null && Fr.length)) {
        let qr = Fe.participant.individualParticipantIds.map((xr) => or(xr) || (r ? ga({ policyDefinitions: l, tournamentParticipants: r, internalUse: !0, contextProfile: U, participantId: xr }) : void 0));
        Object.assign(Fe.participant, { individualParticipants: qr });
      }
    }), !pe.matchUpType) {
      let { matchUpType: Fe } = Fp({ matchUp: pe });
      Fe && Object.assign(pe, { matchUpType: Fe });
    }
    if (U != null && U.inferGender && (!pe.gender || pe.gender === Mr) && ((At = pe.sides) == null ? void 0 : At.length) === 2 && pe.matchUpType !== xt) {
      let Fe = pe.sides.map((ct) => {
        var ir, ri, Fr, qr;
        if (bt(rt)(pe.matchUpType))
          return (ri = (ir = ct.participant) == null ? void 0 : ir.person) == null ? void 0 : ri.sex;
        if (((qr = (Fr = ct.participant) == null ? void 0 : Fr.individualParticipants) == null ? void 0 : qr.length) === 2) {
          let xr = Te(ct.participant.individualParticipants.map((_n) => {
            var Sn;
            return (Sn = _n.person) == null ? void 0 : Sn.sex;
          })).filter(Boolean);
          if (xr.length === 1)
            return xr[0];
        }
      });
      if (Fe.filter(Boolean).length === 2 && Te(Fe).length === 1) {
        let ct = Fe[0];
        pe.inferredGender = ct;
      }
    }
  }
  if (pe.tieMatchUps) {
    let Me = pe.matchUpStatus === $e, or = (kr = pe.sides) == null ? void 0 : kr.map(({ participant: Fe, drawPosition: ct, sideNumber: ir, lineUp: ri }) => {
      let Fr = (Fe == null ? void 0 : Fe.participantType) === xt && Fe;
      return { teamParticipant: Fr && me({ participantRoleResponsibilities: Fr.participantRoleResponsibilities, participantOtherName: Fr.participanOthertName, participantName: Fr.participantName, participantId: Fr.participantId, teamId: Fr.teamId }), drawPosition: ct, sideNumber: ir, lineUp: ri };
    });
    pe.tieMatchUps = pe.tieMatchUps.map((Fe) => {
      let ct = pe.matchUpId, ir = { finishingPositionRange: pe.finishingPositionRange, abbreviatedRoundName: ne, roundNumber: Z, roundName: te };
      return iT({ tieDrawPositions: X, scheduleVisibilityFilters: e, sourceDrawPositionRanges: t, sideLineUps: or, drawPositionsRanges: n, initialRoundOfPlay: s, roundNamingProfile: u, additionalContext: ir, appliedPolicies: l, isCollectionBye: Me, usePublishState: h, publishStatus: D, matchUpTieId: ct, isRoundRobin: P, roundProfile: b, matchUp: Fe, event: C, tournamentParticipants: r, positionAssignments: i, tournamentRecord: d, seedAssignments: f, participantMap: g, contextContent: I, scheduleTiming: y, contextProfile: U, drawDefinition: S, scoringActive: w, structure: R, context: M });
    });
  }
  let We = pe.sides && pe.sides.filter((Me) => Me == null ? void 0 : Me.participantId).length === 2, Ge = !pe.winningSide;
  if (Object.assign(pe, { readyToScore: w && We && Ge, hasContext: !0 }), We) {
    let { allParticipantsCheckedIn: Me, checkedInParticipantIds: or } = as({ matchUp: pe });
    Object.assign(pe, { allParticipantsCheckedIn: Me, checkedInParticipantIds: or });
  }
  return Array.isArray(U == null ? void 0 : U.exclude) && (U == null || U.exclude.forEach((Me) => delete pe[Me])), pe;
}
function ZO({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = fo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: kn });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { allocatedCourts: ce(i, !1, !0) } : t;
}
function ek({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = fo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: va });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { courtId: i } : t;
}
function tk({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = fo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: rs });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { venueId: i } : t;
}
function Vn(e) {
  if (!Array.isArray(e.matchUps))
    return [];
  let { matchUps: t, excludeMatchUpStatuses: r, hasParticipantsCount: i, isCollectionMatchUp: n, matchUpStatuses: a, hasWinningSide: o, matchUpFormats: s, roundPositions: c, matchUpFormat: u, collectionIds: d, isMatchUpTie: p, roundNumbers: l, matchUpIds: m, roundNames: f, filterMatchUpTypes: h = !0, filterMatchUpIds: g = !0, stageSequences: I, scheduledDates: y, scheduledDate: U, participantIds: S, processContext: D, tournamentIds: w, matchUpTypes: v, structureIds: P, readyToScore: b, courtIds: T, eventIds: R, venueIds: M, drawIds: E, stages: C } = e, A = Array.isArray(S) ? S.filter(Boolean) : [], N = Array.isArray(a) ? a.filter(Boolean) : [], O = Array.isArray(r) ? r.filter(Boolean) : [], k = Array.isArray(C) ? C.filter(Boolean) : [], F = Array.isArray(I) ? I.filter(Boolean) : [], x = Array.isArray(d) ? d.filter(Boolean) : [], _ = Array.isArray(f) ? f.filter(Boolean) : [], B = Array.isArray(l) ? l.filter(Boolean) : [], L = Array.isArray(c) ? c.filter(Boolean) : [], G = Array.isArray(m) && g ? m.filter(Boolean) : [], $ = Array.isArray(v) && h ? v.filter(Boolean) : [], W = Array.isArray(T) ? T.filter(Boolean) : [], q = Array.isArray(M) ? M.filter(Boolean) : [], K = Array.isArray(s) && s.filter(Boolean) || typeof u == "string" && [u] || [], z = Array.isArray(y) && y.filter(Boolean) || typeof U == "string" && U.length && [U] || [], Y = Array.isArray(w) ? w.filter(Boolean) : [], X = Array.isArray(R) ? R.filter(Boolean) : [], re = Array.isArray(E) ? E.filter(Boolean) : [], Q = Array.isArray(P) ? P.filter(Boolean) : [];
  return t.filter((H) => {
    var Z;
    if (b && !bt(ni)(H) && !H.readyToScore || H.winningSide && o && ![1, 2].includes(H.winningSide) || p !== void 0 && (p && !H.tieMatchUps || !p && H.tieMatchUps) || n !== void 0 && (n && !H.collectionId || !n && H.collectionId) || k.length && !k.includes(H.stage) || F.length && !F.includes(H.stageSequence) || x.length && (!H.collectionId || !x.includes(H.collectionId)) || _.length && (!H.roundName || !_.includes(H.roundName)) || B.length && (!H.roundNumber || !B.includes(H.roundNumber)) || L.length && (!H.roundPosition || !L.includes(H.roundPosition)) || N.length && (!H.matchUpStatus || !N.includes(H.matchUpStatus)) || O.length && H.matchUpStatus && O.includes(H.matchUpStatus) || G.length && !G.includes(H.matchUpId) || $.length && (!H.matchUpType || !jl($, H.matchUpType)) || K.length && (!H.matchUpFormat || !K.includes(H.matchUpFormat)))
      return !1;
    if (z != null && z.length) {
      let { scheduledTime: ee } = rT({ matchUp: H }), { scheduledDate: te } = os({ matchUp: H }), ne = be(ee) || te;
      if (!z.find((se) => Nn(se, ne)))
        return !1;
    }
    if (W.length) {
      let { courtId: ee } = ek({ matchUp: H }), { allocatedCourts: te } = ZO({ matchUp: H }), ne = te == null ? void 0 : te.map(({ courtId: se }) => se);
      if (!W.filter(Boolean).includes(ee) || ne != null && ne.includes(ee))
        return !1;
    }
    if (q.length) {
      let { venueId: ee } = tk({ matchUp: H });
      if (!q.filter(Boolean).includes(ee))
        return !1;
    }
    if (D) {
      if (Y.length && !Y.includes(H.tournamentId) || X.length && !X.includes(H.eventId) || re.length && !re.includes(H.drawId) || Q.length && !Q.includes(H.structureId))
        return !1;
      let ee = ((Z = H.sides) == null ? void 0 : Z.map(({ participantId: te }) => te).filter(Boolean)) ?? [];
      if (i && ee.length < i || A.length && !A.some((te) => ee.includes(te)))
        return !1;
    }
    return !0;
  });
}
function Ke(e) {
  var W, q, K, z, Y, X, re;
  let { provisionalPositioning: t, tournamentRecord: r, contextFilters: i, matchUpFilters: n, contextProfile: a, drawDefinition: o, context: s = {}, structure: c, inContext: u, event: d } = e, { seedAssignments: p, contextContent: l, exitProfiles: m, matchUpsMap: f } = e, h = {}, g = {};
  if (!c)
    return { collectionPositionMatchUps: h, error: ao, roundMatchUps: g, matchUps: [] };
  let I = Array.isArray(n == null ? void 0 : n.eventIds) ? n == null ? void 0 : n.eventIds.filter(Boolean) : [], y = Array.isArray(n == null ? void 0 : n.structureIds) ? n == null ? void 0 : n.structureIds.filter(Boolean) : [], U = Array.isArray(n == null ? void 0 : n.drawIds) ? n == null ? void 0 : n.drawIds.filter(Boolean) : [], S = !(s != null && s.eventId) || !(I != null && I.length) && !((W = i == null ? void 0 : i.eventIds) != null && W.filter(Boolean).length) || (I == null ? void 0 : I.includes(s.eventId)) || ((q = i == null ? void 0 : i.eventIds) == null ? void 0 : q.includes(s.eventId)), D = !(y != null && y.length) || y.includes(c.structureId), w = !o || !(U != null && U.length) || U.includes(o.drawId);
  if (!S || !D || !w)
    return { collectionPositionMatchUps: h, roundMatchUps: g, matchUps: [] };
  a && !l && (l = ia({ tournamentRecord: r, contextProfile: a, drawDefinition: o }));
  let { appliedPolicies: v } = je({ drawDefinition: o }), P = { ...e.tournamentAppliedPolicies, ...v, ...e.policyDefinitions }, b = (K = P == null ? void 0 : P.scoring) == null ? void 0 : K.structures, T = c.stage && ((z = b == null ? void 0 : b.stage) == null ? void 0 : z[c.stage]), R = c.stageSequence && ((Y = T == null ? void 0 : T.stageSequence) == null ? void 0 : Y[c.stageSequence]), M = ((X = P == null ? void 0 : P.scoring) == null ? void 0 : X.requireAllPositionsAssigned) || (T == null ? void 0 : T.requireAllPositionsAssigned) || (R == null ? void 0 : R.requireAllPositionsAssigned);
  f || (f = mr({ drawDefinition: o, structure: c }));
  let { positionAssignments: E, allPositionsAssigned: C } = Yt({ structure: c }), A = !M || C, { seedAssignments: N } = Si({ provisionalPositioning: t, drawDefinition: o, structure: c });
  p = p ?? N;
  let { structureId: O } = c;
  m = m || o && BD({ drawDefinition: o }).exitProfiles;
  let k = m == null ? void 0 : m[O], F = (k == null ? void 0 : k.length) && (k[0].split("-").map((Q) => parseInt(Q)).reduce((Q, H) => Q + H) || 0), x = !!c.structures, _ = Ka({ matchUpsMap: f, structureId: O, inContext: u }), B = P == null ? void 0 : P[$s], L = TO({ roundNamingPolicy: B, drawDefinition: o, structure: c, matchUps: _ }), { roundNamingProfile: G, roundProfile: $ } = L;
  if (g = (L == null ? void 0 : L.roundMatchUps) ?? [], n && (_ = Vn({ matchUps: _, ...n, filterMatchUpTypes: !1, filterMatchUpIds: !1 })), u) {
    let { sourceDrawPositionRanges: Q } = wO({ drawDefinition: o, matchUpsMap: f, structureId: O }), H = o ? PO({ drawDefinition: o, roundProfile: $, matchUpsMap: f, structureId: O }).drawPositionsRanges : void 0;
    _ = _.map((Z) => iT({ tournamentParticipants: e.tournamentParticipants ?? (r == null ? void 0 : r.participants), scheduleVisibilityFilters: e.scheduleVisibilityFilters, hydrateParticipants: e.hydrateParticipants, afterRecoveryTimes: e.afterRecoveryTimes, usePublishState: e.usePublishState, participantMap: e.participantMap, scheduleTiming: e.scheduleTiming, publishStatus: e.publishStatus, sourceDrawPositionRanges: Q, positionAssignments: E, drawPositionsRanges: H, initialRoundOfPlay: F, roundNamingProfile: G, tournamentRecord: r, appliedPolicies: P, seedAssignments: p, contextContent: l, contextProfile: a, drawDefinition: o, scoringActive: A, isRoundRobin: x, roundProfile: $, structure: c, context: s, matchUp: Z, event: d })), (_ == null ? void 0 : _.filter((Z) => Array.isArray(Z.tieMatchUps))).forEach((Z) => {
      let ee = Z.tieMatchUps;
      _ = _.concat(...ee);
    }), i && (_ = Vn({ processContext: !0, ...i, matchUps: _ }));
  } else
    (_ == null ? void 0 : _.filter((Q) => Array.isArray(Q.tieMatchUps))).forEach((Q) => {
      let H = Q.tieMatchUps;
      _ = _.concat(...H);
    });
  return n && (_ = Vn({ matchUps: _, ...n, filterMatchUpTypes: !1, filterMatchUpIds: !1 })), (n != null && n.matchUpTypes || n != null && n.matchUpIds) && (_ = Vn({ matchUpTypes: n.matchUpTypes, matchUpIds: n.matchUpIds, matchUps: _ })), (n != null && n.matchUpTypes || n != null && n.matchUpIds || u) && (g = Pr({ matchUps: _ }).roundMatchUps ?? []), (re = Ir({ drawDefinition: o, structure: c, event: d })) != null && re.tieFormat && ({ collectionPositionMatchUps: h } = vO({ matchUps: _ })), { collectionPositionMatchUps: h, roundMatchUps: g, isRoundRobin: x, roundProfile: $, matchUpsMap: f, matchUps: _ };
}
function ja({ matchUp: e }) {
  return e ? Vt.includes(e == null ? void 0 : e.matchUpStatus) || (e == null ? void 0 : e.winningSide) : !1;
}
function xp({ requireParticipants: e = !0, scheduleVisibilityFilters: t, tournamentAppliedPolicies: r, tournamentParticipants: i, hydrateParticipants: n, afterRecoveryTimes: a, policyDefinitions: o, tournamentRecord: s, usePublishState: c, matchUpFilters: u, contextFilters: d, contextContent: p, participantMap: l, scheduleTiming: m, publishStatus: f, contextProfile: h, drawDefinition: g, exitProfiles: I, matchUpsMap: y, structureId: U, inContext: S, structure: D, context: w, event: v }) {
  !D && U && ({ structure: D } = ve({ drawDefinition: g, structureId: U }));
  let P = Ke({ tournamentAppliedPolicies: r, scheduleVisibilityFilters: t, tournamentParticipants: i, hydrateParticipants: n, afterRecoveryTimes: a, policyDefinitions: o, tournamentRecord: s, usePublishState: c, matchUpFilters: u, contextFilters: d, contextContent: p, participantMap: l, scheduleTiming: m, publishStatus: f, contextProfile: h, drawDefinition: g, exitProfiles: I, matchUpsMap: y, structure: D, inContext: S, context: w, event: v }), b = [], T = [], R = [], M = [], E = [];
  if (P.error)
    return P;
  let { matchUps: C } = P, { assignedPositions: A } = Yt({ structure: D }), N = A == null ? void 0 : A.filter((k) => k.participantId).map((k) => k.drawPosition), O;
  return C.filter((k) => {
    var x;
    let F = ((x = u == null ? void 0 : u.matchUpTypes) == null ? void 0 : x.length) === 1 && u.matchUpTypes[0] === lt;
    return !(k.matchUpType !== lt && F);
  }).forEach((k) => {
    var W, q, K, z;
    if (k.matchUpStatus === Gr) {
      b.push(k);
      return;
    }
    k.matchUpType === lt && (O = !0);
    let F = k.collectionId, x = F && ((W = k.sides) == null ? void 0 : W.every((Y) => Y.participantId)), _ = !F && ((q = k.drawPositions) == null ? void 0 : q.filter(Boolean).length) === 2, B = !F && ((K = k.drawPositions) == null ? void 0 : K.every((Y) => N == null ? void 0 : N.includes(Y))), L = A == null ? void 0 : A.filter((Y) => Y.bye).map((Y) => Y.drawPosition), G = !F && ((z = k.drawPositions) == null ? void 0 : z.find((Y) => L == null ? void 0 : L.includes(Y))), $ = yD.includes(k.matchUpStatus) && (x || _ && (!e || B));
    return G ? E.push(k) : ja({ matchUp: k }) ? T.push(k) : $ ? R.push(k) : M.push(k);
  }), { includesTeamMatchUps: O, abandonedMatchUps: b, completedMatchUps: T, upcomingMatchUps: R, pendingMatchUps: M, byeMatchUps: E, structure: D };
}
function rk({ drawDefinition: e, roundNumber: t, structureId: r }) {
  if (!e)
    return { error: le };
  if (!r)
    return { error: ui };
  let { links: i } = Ic({ drawDefinition: e, structureId: r }), n = i.source.reduce((o, s) => !s.source.roundNumber || s.source.roundNumber === t ? o.concat(s) : o, []), a = i.target.reduce((o, s) => !s.target.roundNumber || s.target.roundNumber === t ? o.concat(s) : o, []);
  return { links: { source: n, target: a } };
}
function zm({ finishingPositions: e, linkCondition: t, linkType: r, source: i }) {
  var a;
  let n = i.find((o) => {
    var c, u;
    let s = !((c = o.source) != null && c.finishingPositions) || !e || wr(e, (u = o.source) == null ? void 0 : u.finishingPositions);
    return t === o.linkCondition && s && o.linkType === r;
  });
  return [Hn, An].includes(n == null ? void 0 : n.linkType) && !((a = n == null ? void 0 : n.source) != null && a.roundNumber) ? j({ result: { error: J }, stack: "getTargetLink", context: n }) : n;
}
function Ic({ drawDefinition: e, structureId: t, roundNumber: r }) {
  return e ? t ? { links: (e.links || []).filter(Boolean).reduce((i, n) => {
    var a, o;
    return ((a = n.source) == null ? void 0 : a.structureId) === t && (!r || n.source.roundNumber === r) && (i.source = i.source.concat(n)), ((o = n.target) == null ? void 0 : o.structureId) === t && (!r || n.target.roundNumber === r) && (i.target = i.target.concat(n)), i;
  }, { source: [], target: [] }) } : { error: ui } : { error: le };
}
function ik({ structureMatchUps: e, matchUp: t }) {
  let { roundNumber: r, roundPosition: i } = t, n = e.filter((o) => o.roundNumber === r && !o.matchUpTieId), a = e.filter((o) => o.roundNumber === r + 1 && !o.matchUpTieId);
  if (a.length) {
    let o;
    return a.length === n.length ? o = a.find((s) => s.roundPosition === i) : a.length === n.length / 2 && (o = a.find((s) => s.roundPosition === Math.ceil(i / 2))), { matchUp: o };
  }
  return { message: "no progression found" };
}
function Ym({ sourceRoundMatchUpCount: e, inContextDrawMatchUps: t, sourceRoundPosition: r, drawDefinition: i, targetLink: n }) {
  var b;
  if (!n)
    return { error: wh };
  let { target: { structureId: a, feedProfile: o, groupedOrder: s, roundNumber: c, positionInterleave: u } } = n, { structure: d } = ve({ drawDefinition: i, structureId: a }), { positionAssignments: p } = ot({ structure: d }), l = (t == null ? void 0 : t.filter((T) => T.structureId === (d == null ? void 0 : d.structureId))).filter((T) => T.roundNumber === c && !T.matchUpTieId), m = l.length, f = oe(1, m + 1), h = m / e, g = Math.ceil(h * r), I = 1 - r % 2;
  if (u != null && u.interleave && h !== 0.5) {
    let T = u.offset + (r - 1) * u.interleave, R = r + T;
    g = Math.ceil(R / 2), I = 1 - R % 2;
  }
  let y = f, U = f[g - 1], S = _D({ roundPositionsCount: f.length, groupedOrder: s }), D = (S == null ? void 0 : S.length) || 1;
  if (D <= f.length) {
    let T = m / D, R = zt(f, T);
    o === Wa && R.forEach((M) => M.reverse()), y = (S == null ? void 0 : S.length) && (S == null ? void 0 : S.map((M) => R[M - 1]).flat()) || y;
  }
  o === Ei ? U = y[g - 1] : o === Wa ? ((!(S != null && S.length) || D > f.length) && (g = l.length + 1 - g), U = y[g - 1]) : o === dp && oi() && console.log(Zl, { feedProfile: o });
  let w = U && l.reduce((T, R) => R.roundPosition === U ? R : T, void 0), v;
  w != null && w.feedRound ? (I = 0, v = Math.min(...(w.drawPositions || []).filter(Boolean))) : v = ((b = w == null ? void 0 : w.drawPositions) == null ? void 0 : b.length) === 2 && (w == null ? void 0 : w.drawPositions[I]);
  let P = p == null ? void 0 : p.find(({ drawPosition: T }) => T === v);
  if (P) {
    let { extension: T } = Ne({ element: P, name: vp });
    if (T != null && T.value)
      return { disabledDrawPosition: v };
  }
  return { matchUp: w, targetDrawPosition: v, matchUpDrawPositionIndex: I };
}
function Dr({ inContextDrawMatchUps: e = [], useTargetMatchUpIds: t, inContextMatchUp: r, drawDefinition: i, matchUpId: n }) {
  let a = r;
  e.length && !a && (a = e.find((s) => s.matchUpId === n));
  let { structure: o } = ve({ structureId: a == null ? void 0 : a.structureId, drawDefinition: i });
  return (o == null ? void 0 : o.finishingPosition) === Jo ? nk({ inContextDrawMatchUps: e, useTargetMatchUpIds: t, drawDefinition: i, structure: o, matchUp: a }) : ak({ matchUp: a });
}
function nk({ inContextDrawMatchUps: e, useTargetMatchUpIds: t, drawDefinition: r, structure: i, matchUp: n }) {
  var M, E, C;
  let { winnerMatchUpId: a, loserMatchUpId: o } = n, { links: s } = rk({ roundNumber: n.roundNumber, structureId: i.structureId, drawDefinition: r }), c = s == null ? void 0 : s.source, u = zm({ source: c, linkType: Hn }), d = zm({ linkCondition: ln, linkType: An, source: c }), p = zm({ source: c, linkType: An }), l = d && p;
  p || (p = d);
  let m = (M = u == null ? void 0 : u.target) == null ? void 0 : M.feedProfile, f = (E = p == null ? void 0 : p.target) == null ? void 0 : E.feedProfile, h = (C = d == null ? void 0 : d.target) == null ? void 0 : C.feedProfile, g, I, y, U, S, D, w, v, P, b;
  if (t && (a || o) && (w = a && m !== Ni && e.find(({ matchUpId: A }) => A === a), U = o && f !== Ni && e.find(({ matchUpId: A }) => A === o), w || U))
    return { matchUp: n, targetLinks: { loserTargetLink: p, winnerTargetLink: u }, targetMatchUps: { loserMatchUp: U, winnerMatchUp: w } };
  let { roundPosition: T } = n;
  b = b || e.filter((A) => A.structureId === i.structureId);
  let R = b.reduce((A, N) => N.roundNumber === n.roundNumber && !N.matchUpTieId ? A + 1 : A, 0);
  return p && !U && f !== Ni && ({ matchUpDrawPositionIndex: D, targetDrawPosition: S, matchUp: U } = Ym({ targetLink: p, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: T, drawDefinition: r })), l && h !== Ni && ({ matchUpDrawPositionIndex: y, targetDrawPosition: I, matchUp: g } = Ym({ targetLink: d, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: T, drawDefinition: r })), u && !w && m !== Ni && ({ matchUpDrawPositionIndex: P, targetDrawPosition: v, matchUp: w } = Ym({ targetLink: u, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: T, drawDefinition: r })), w || (b = b || e.filter((A) => A.structureId === i.structureId), { matchUp: w } = ik({ structureMatchUps: b, matchUp: n })), me({ matchUp: n, targetLinks: { loserTargetLink: p, winnerTargetLink: u, byeTargetLink: d }, targetMatchUps: { winnerMatchUpDrawPositionIndex: P, loserMatchUpDrawPositionIndex: D, byeMatchUpDrawPositionIndex: y, winnerTargetDrawPosition: v, loserTargetDrawPosition: S, byeTargetDrawPosition: I, winnerMatchUp: w, loserMatchUp: U, byeMatchUp: g }, targetMatchUpIds: !!(a || o) });
}
function ak({ matchUp: e }) {
  return { targetLinks: { loserTargetLink: void 0, winnerTargetLink: void 0 }, targetMatchUps: { loserMatchUp: void 0, winnerMatchUp: void 0 }, matchUp: e };
}
function ok({ drawDefinition: e, inContextDrawMatchUps: t }) {
  let r = {};
  return t.forEach((i) => {
    var c, u, d, p, l, m;
    let { matchUpId: n, structureId: a, drawPositions: o = [] } = i, { structure: s } = ve({ drawDefinition: e, structureId: a });
    if ((s == null ? void 0 : s.finishingPosition) === Ha) {
      let { roundNumber: f } = i, h = f && ye(f) + 1, g = s.matchUps ?? [], { roundMatchUps: I } = Pr({ matchUps: g });
      if (h && (I != null && I[h])) {
        let y = [...o].sort(Ft).map((U, S) => {
          let D = I[h].find((w) => {
            var v;
            return (v = w.drawPositions) == null ? void 0 : v.includes(U);
          });
          return { matchUpId: D == null ? void 0 : D.matchUpId, roundNumber: h, schedule: D == null ? void 0 : D.schedule, sideNumber: S + 1, structureName: s.structureName };
        });
        Object.assign(i, { sidesTo: y });
      }
    } else {
      let f = Dr({ useTargetMatchUpIds: !0, inContextDrawMatchUps: t, inContextMatchUp: i, drawDefinition: e, matchUpId: n }), { winnerMatchUp: h } = f.targetMatchUps, { loserMatchUp: g } = f.targetMatchUps;
      !i.winnerMatchUpId && h && (i.winnerMatchUpId = h.matchUpId), !i.loserMatchUpId && g && (i.loserMatchUpId = g.matchUpId);
      let I = Km({ upcomingMatchUp: h }), y = Km({ upcomingMatchUp: g });
      if (i.matchUpStatus !== $e && (g == null ? void 0 : g.matchUpStatus) === $e) {
        let { matchUp: S } = nT({ matchUp: g, drawDefinition: e, inContextDrawMatchUps: t }) || {};
        y = S && Km({ upcomingMatchUp: S }) || y;
      }
      let U = (c = i.schedule) == null ? void 0 : c.timeAfterRecovery;
      if (U && ((u = I == null ? void 0 : I.schedule) != null && u.scheduledTime && _e(I.schedule.scheduledTime) < _e(U) && (r[I.matchUpId] = i.matchUpId, I.schedule.scheduleConflict = i.matchUpId), (d = y == null ? void 0 : y.schedule) != null && d.scheduledTime && _e(y.schedule.scheduledTime) < _e(U) && (r[y.matchUpId] = i.matchUpId, y.schedule.scheduleConflict = i.matchUpId)), Object.assign(i, { winnerTo: I, loserTo: y }), (p = i.drawPositions) == null ? void 0 : p.filter(Boolean).length) {
        let S = ((m = (l = f.targetLinks) == null ? void 0 : l.loserTargetLink) == null ? void 0 : m.linkCondition) === ln, D = sk(i);
        if (D.length) {
          let w = Cf(h == null ? void 0 : h.sides), v = Cf(g == null ? void 0 : g.sides), P = D.find(({ participantId: T }) => w.includes(T)) ? [] : D, b = D.find(({ participantId: T }) => v.includes(T)) ? [] : D;
          g && S && b.length < 2 && b.push({ bye: !0, tbd: !0 }), P != null && P.length && h && (!f.targetMatchUpIds && h && (h = t.find(({ matchUpId: T }) => T === h.matchUpId)), h.potentialParticipants || (h.potentialParticipants = []), h.potentialParticipants.push(P)), b != null && b.length && g && (f.targetMatchUpIds || (h = t.find(({ matchUpId: T }) => T === g.matchUpId)), g.potentialParticipants || (g.potentialParticipants = []), g.potentialParticipants.push(b));
        }
      }
    }
  }), Object.keys(r).length && t.forEach((i) => {
    Object.keys(r).includes(i.matchUpId) && (i.schedule.scheduleConflict = r[i.matchUpId]);
  }), { scheduleConflictMatchUpIds: r };
}
function sk(e) {
  var t;
  return ((t = e == null ? void 0 : e.sides) == null ? void 0 : t.map(({ participant: r, participantId: i, qualifier: n }) => r || i && { participantId: i } || n && { qualifier: n }).filter(Boolean)) || [];
}
function nT({ matchUp: e, drawDefinition: t, inContextDrawMatchUps: r }) {
  var o;
  let { matchUpId: i, matchUpStatus: n, structureId: a } = e || {};
  if (!e || !a || (e == null ? void 0 : e.matchUpStatus) === Rt)
    return { matchUp: e };
  if (n === $e) {
    let s;
    return e.winnerMatchUpId ? s = r.find(({ matchUpId: c }) => c === e.winnerMatchUpId) : { winnerMatchUp: s } = ((o = Dr({ inContextDrawMatchUps: r, drawDefinition: t, matchUpId: i })) == null ? void 0 : o.targetMatchUps) || {}, nT({ matchUp: s, drawDefinition: t, inContextDrawMatchUps: r });
  }
  return { matchUp: void 0 };
}
function Km(e) {
  if (e != null && e.upcomingMatchUp)
    return (({ matchUpId: t, structureId: r, schedule: i, roundNumber: n, roundPosition: a, structureName: o }) => ({ matchUpId: t, structureId: r, schedule: i, roundNumber: n, roundPosition: a, structureName: o }))(e.upcomingMatchUp);
}
function Bt(e) {
  let t = "getAllDrawMatchUps";
  Object.assign(e, { requireParticipants: !1 });
  let r = Uc(e);
  if (r.error)
    return j({ result: r, stack: t });
  let { abandonedMatchUps: i, completedMatchUps: n, upcomingMatchUps: a, pendingMatchUps: o, byeMatchUps: s, matchUpsMap: c } = r;
  return { matchUps: (i ?? []).concat(...n ?? [], ...a ?? [], ...o ?? [], ...s ?? []), matchUpsMap: c };
}
function Uc(e) {
  if (!(e != null && e.drawDefinition))
    return { error: le };
  let { tournamentParticipants: t, contextContent: r, matchUpsMap: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, requireParticipants: o, participantsProfile: s, afterRecoveryTimes: c, policyDefinitions: u, tournamentRecord: d, usePublishState: p, contextFilters: l, matchUpFilters: m, scheduleTiming: f, participantMap: h, publishStatus: g, contextProfile: I, drawDefinition: y, nextMatchUps: U, inContext: S, context: D, event: w } = e, v = [], P = [], b = [], T = [], R = [];
  I && !r && (r = ia({ policyDefinitions: u, tournamentRecord: d, contextProfile: I, event: w }));
  let M;
  !(t != null && t.length) && d && (t = d == null ? void 0 : d.participants, (S || s != null && s.withGroupings) && (t != null && t.length) && ({ participantsWithGroupings: t, groupInfo: M } = Bg({ participants: t, participantsProfile: s })));
  let { structures: E } = Bi({ drawDefinition: y });
  if (!E)
    return { error: It };
  i || (i = mr({ drawDefinition: y }));
  let C = y && BD({ drawDefinition: y }).exitProfiles;
  E.forEach((O) => {
    let { byeMatchUps: k = [], pendingMatchUps: F = [], upcomingMatchUps: x = [], completedMatchUps: _ = [], abandonedMatchUps: B = [] } = xp({ matchUpFilters: U ? void 0 : m, contextFilters: U ? void 0 : l, inContext: S || U || l, hydrateParticipants: e.hydrateParticipants, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, tournamentParticipants: t, requireParticipants: o, afterRecoveryTimes: c, policyDefinitions: u, tournamentRecord: d, usePublishState: p, contextContent: r, participantMap: h, scheduleTiming: f, publishStatus: g, contextProfile: I, drawDefinition: y, exitProfiles: C, matchUpsMap: i, structure: O, context: D, event: w });
    v = v.concat(...B), P = P.concat(..._), b = b.concat(...x), T = T.concat(...F), R = R.concat(...k);
  });
  let A = (O) => (!m && !U && !l || (m && (O = Vn({ matchUps: O, ...m })), l && (O = Vn({ matchUps: O, ...l, processContext: !0 }))), O), N = { abandonedMatchUps: A(v), completedMatchUps: A(P), upcomingMatchUps: A(b), pendingMatchUps: A(T), byeMatchUps: A(R), matchUpsMap: i, ...V, groupInfo: M };
  if (U) {
    let O = typeof U == "object" || { abandoned: !0, completed: !0, upcoming: !0, pending: !0, bye: !0 }, { abandoned: k, completed: F, upcoming: x, pending: _, bye: B } = O, L = [].concat(...k && v || [], ...F && P || [], ...x && b || [], ..._ && T || [], ...B && R || []);
    ok({ inContextDrawMatchUps: L, drawDefinition: y });
  }
  return N;
}
function Ln(e) {
  let { participants: t = [], contextContent: r, participantMap: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, contextFilters: p, contextProfile: l, matchUpFilters: m, nextMatchUps: f, inContext: h, context: g, event: I } = e;
  if (!I)
    return { error: pt };
  let { eventId: y, eventName: U, endDate: S, eventType: D, category: w, gender: v, matchUpFormat: P } = I ?? {}, b = { ...g, ...me({ indoorOutDoor: I.indoorOutdoor ?? (d == null ? void 0 : d.indoorOutdoor), surfaceCategory: I.surfaceCategory ?? (d == null ? void 0 : d.surfaceCategory), endDate: I.endDate ?? (d == null ? void 0 : d.endDate), tournamentId: d == null ? void 0 : d.tournamentId, matchUpFormat: P, eventName: U, eventType: D, category: w, eventId: y, gender: v }) };
  S && (b.endDate = S), l && !r && (r = ia({ policyDefinitions: c, tournamentRecord: d, contextProfile: l, event: I }));
  let T;
  if (!(t != null && t.length) && !i && d) {
    let E = es({ participantsProfile: o, useParticipantMap: u, policyDefinitions: c, tournamentRecord: d, contextProfile: l, inContext: h });
    i = E.participantMap, t = E.participants ?? [], T = E.groupInfo;
  }
  let R = I.drawDefinitions ?? [], M = $u({ tournamentRecord: d, event: I }).scheduleTiming;
  return { matchUps: R.flatMap((E) => {
    let { matchUps: C } = Bt({ tournamentParticipants: t, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, context: b, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: d, contextFilters: p, contextProfile: l, drawDefinition: E, contextContent: r, matchUpFilters: m, participantMap: i, scheduleTiming: M, nextMatchUps: f, inContext: h, event: I });
    return C ?? [];
  }), groupInfo: T };
}
function tr(e) {
  let t = fe(e, [{ tournamentRecord: !0 }]);
  if (t.error)
    return t;
  if (!(e != null && e.tournamentRecord))
    return { error: ae };
  let { participantMap: r, participants: i } = e, { scheduleVisibilityFilters: n, participantsProfile: a, afterRecoveryTimes: o, useParticipantMap: s, policyDefinitions: c, tournamentRecord: u, inContext: d = !0, contextProfile: p, matchUpFilters: l, contextFilters: m, nextMatchUps: f, context: h } = e, g = e.tournamentId ?? u.tournamentId, I = (u == null ? void 0 : u.events) ?? [];
  i || ({ participants: i, participantMap: r } = es({ participantsProfile: a, useParticipantMap: s, policyDefinitions: c, tournamentRecord: u, contextProfile: p, inContext: d }));
  let { appliedPolicies: y } = je({ tournamentRecord: u }), U = { ...h, tournamentId: g, indoorOutDoor: u.indoorOutdoor, surfaceCategory: u.surfaceCategory, endDate: u.endDate }, S = ia({ policyDefinitions: c, tournamentRecord: u, contextProfile: p });
  return { matchUps: I.flatMap((D) => {
    var w;
    return U.eventDrawsCount = ((w = D.drawDefinitions) == null ? void 0 : w.length) ?? 0, Ln({ context: U, scheduleVisibilityFilters: n, tournamentAppliedPolicies: y, participantsProfile: a, afterRecoveryTimes: o, policyDefinitions: c, tournamentRecord: u, contextContent: S, contextFilters: m, contextProfile: p, matchUpFilters: l, participantMap: r, nextMatchUps: f, participants: i, inContext: d, event: D }).matchUps ?? [];
  }).concat(...u.matchUps ?? []) };
}
function en({ scheduleVisibilityFilters: e, afterRecoveryTimes: t, participantsProfile: r, tournamentRecords: i, policyDefinitions: n, matchUpFilters: a, contextFilters: o, nextMatchUps: s, inContext: c }) {
  if (typeof i != "object" || !Object.keys(i).length)
    return { error: yt };
  let u = Object.keys(i).map((d) => {
    let p = i[d];
    return tr({ scheduleVisibilityFilters: e, afterRecoveryTimes: t, participantsProfile: r, policyDefinitions: n, tournamentRecord: p, matchUpFilters: a, contextFilters: o, nextMatchUps: s, inContext: c }).matchUps ?? [];
  }).flat();
  return { ...V, matchUps: u };
}
function cs(e, t) {
  return ck(e, t) || ((e == null ? void 0 : e.stageSequence) || 0) - ((t == null ? void 0 : t.stageSequence) || 0) || (e == null ? void 0 : e.roundNumber) && t.roundNumber && (e == null ? void 0 : e.roundNumber) - (t == null ? void 0 : t.roundNumber) || ((e == null ? void 0 : e.roundPosition) ?? 0) - ((t == null ? void 0 : t.roundPosition) ?? 0);
}
function ck(e, t) {
  return (Fo[e == null ? void 0 : e.stage] || 0) - (Fo[t == null ? void 0 : t.stage] || 0);
}
function vr(e) {
  let { participants: t, participantMap: r, contextContent: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, matchUpFilters: p, contextFilters: l, contextProfile: m, drawDefinition: f, nextMatchUps: h, inContext: g, context: I, event: y } = e, { eventId: U, eventName: S, endDate: D, eventType: w, category: v, gender: P, matchUpFormat: b } = y ?? {}, T = { ...I, surfaceCategory: (y == null ? void 0 : y.surfaceCategory) ?? (d == null ? void 0 : d.surfaceCategory), indoorOutDoor: (y == null ? void 0 : y.indoorOutdoor) ?? (d == null ? void 0 : d.indoorOutdoor), matchUpFormat: b, eventType: w, eventName: S, category: v, eventId: U, endDate: D, gender: P }, R;
  return !(t != null && t.length) && !r && d && ({ participants: t = [], participantMap: r, groupInfo: R } = es({ participantsProfile: o, useParticipantMap: u, policyDefinitions: c, tournamentRecord: d, contextProfile: m, inContext: g })), m && !i && (i = ia({ policyDefinitions: c, tournamentRecord: d, contextProfile: m, drawDefinition: f, event: y })), { ...Bt({ context: T, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, tournamentParticipants: t, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: d, drawDefinition: f, contextContent: i, contextFilters: l, contextProfile: m, matchUpFilters: p, participantMap: r, nextMatchUps: h, inContext: g, event: y }), groupInfo: R };
}
function To({ element: e, accessor: t }) {
  if (typeof t != "string")
    return { values: [] };
  let r = ce(e), i = t.split("."), n = [], a;
  s({ targetElement: r, attributes: i });
  let o = { value: a };
  return n.length && (o.values = n), o;
  function s({ targetElement: c, attributes: u = [], significantCharacters: d }) {
    for (let [l, m] of u.entries())
      if (c != null && c[m]) {
        let f = u.slice(l + 1);
        f.length ? Array.isArray(c[m]) ? c[m].forEach((h) => s({ targetElement: h, attributes: f })) : (c = c[m], p({ targetElement: c, index: l })) : (a || (a = c[m]), n.includes(c[m]) || n.push(c[m]));
      }
    function p({ targetElement: l, index: m }) {
      if (l && m === u.length - 1 && ["string", "number"].includes(typeof l)) {
        let f = d ? l.slice(0, d) : l;
        a ? n.includes(f) || n.push(f) : (a = f, n.push(f));
      }
    }
  }
}
var aT = (e) => (t) => {
  var r;
  return !e || typeof t != "object" ? void 0 : Array.isArray(e) && e.map((i) => {
    var n;
    return { [i]: (n = To({ element: t, accessor: i })) == null ? void 0 : n.value };
  }) || typeof e == "object" && Object.keys(e).map((i) => {
    var n;
    return { [i]: (n = To({ element: t, accessor: i })) == null ? void 0 : n.value };
  }) || ((r = typeof e == "string" && To({ element: t, accessor: e })) == null ? void 0 : r.value);
}, ei = aT;
function ed({ finishingPositionOffset: e = 0, finishingPositionLimit: t, positionsFed: r, roundsCount: i, roundLimit: n, matchUps: a, lucky: o, fmlc: s }) {
  var g;
  if (!Ti(a))
    return [];
  let { roundProfile: c, roundNumbers: u = [] } = Pr({ interpolate: !0, matchUps: a });
  i = i ?? Math.max(...u, 0);
  let d = n ? i - n : 0, p = d && ((g = c == null ? void 0 : c[i - d]) == null ? void 0 : g.matchUpsCount), l = c && Object.values(c).map(ei("matchUpsCount")), m = (I, y) => {
    let U = Math.min(...I);
    p && y && U === 1 && (U = p);
    let S = Math.max(...I);
    return t && S > t && (S = t), [U, S];
  }, f = c && Object.assign({}, ...u.map((I) => {
    let y = (i ?? 0) + 1 - I - d, U = c[I].matchUpsCount, S = { finishingPositionRange: {}, finishingRound: y }, D = l == null ? void 0 : l.slice(I - 1).reduce((E, C) => E + (C || 0), 0), w = s && I !== 1, v = 1 + e + (w ? r ?? 0 : 0), P = 1, b = oe(v, o ? v + U * 2 : D + v + P), T = D + P - U, R = m(b.slice(T)), M = m(b.slice(0, T), !0);
    return S.finishingPositionRange = { loser: R, winner: M }, { [I]: S };
  })), h = oi({ finishingRound: !0 });
  return a.filter(Boolean).forEach((I) => {
    let y = I.roundNumber && f[I.roundNumber];
    h && !y && console.log({ roundFinishingData: f, matchUp: I }), I.finishingRound = y == null ? void 0 : y.finishingRound, I.finishingPositionRange = y == null ? void 0 : y.finishingPositionRange;
  }), a;
}
function Ja({ inContextDrawMatchUps: e, drawDefinition: t, matchUpsMap: r }) {
  var n;
  if (!t)
    return { error: le };
  let i = { loserMatchUpIds: {}, winnerMatchUpIds: {} };
  if (e || ({ matchUps: e, matchUpsMap: r } = Bt({ inContext: !0, drawDefinition: t, matchUpsMap: r })), !(r != null && r.drawMatchUps.some((a) => a.finishingPositionRange)) && ((n = t == null ? void 0 : t.structures) == null ? void 0 : n.length) === 1 && !(t != null && t.structures[0].structures)) {
    let a = (r == null ? void 0 : r.drawMatchUps) ?? [];
    ed({ matchUps: a });
  }
  return (e ?? []).filter(({ collectionId: a }) => !a).forEach((a) => {
    let { matchUpId: o, structureId: s } = a, c = Dr({ inContextDrawMatchUps: e, drawDefinition: t, matchUpId: o }), { winnerMatchUp: u, loserMatchUp: d } = c.targetMatchUps, p = u == null ? void 0 : u.matchUpId, l = d == null ? void 0 : d.matchUpId, m = Ka({ matchUpsMap: r, structureId: s }).find((f) => f.matchUpId === o);
    if (m && (p && (i.winnerMatchUpIds[m.matchUpId] = p, Object.assign(m, { winnerMatchUpId: p }), Object.assign(a, { winnerMatchUpId: p })), l && (i.loserMatchUpIds[m.matchUpId] = l, a.loserMatchUpId = l, m.loserMatchUpId = l, a.finishingPositionRange))) {
      let f = d.finishingPositionRange && [...a.finishingPositionRange.loser, ...d.finishingPositionRange.loser], h = f && [Math.min(...f), Math.max(...f)];
      a.finishingPositionRange.loser = h, m.finishingPositionRange.loser = h;
    }
  }), { inContextDrawMatchUps: e, goesToMap: i };
}
function qi(e) {
  var y;
  let t = wi(e), r = e.matchUps ?? [], i = e.drawIds ?? [], { includeParticipantDependencies: n, tournamentRecord: a, drawDefinition: o } = e;
  if (!Array.isArray(r))
    return { error: Zn };
  if (!Array.isArray(i))
    return { error: tn };
  let s = (y = e.matchUpIds) != null && y.length ? e.matchUpIds : r.map((U) => U.matchUpId);
  if (!Array.isArray(s))
    return { error: $o };
  let c = {}, u = {}, d = {}, p = {};
  a && !Object.keys(t).length && (t = { [a.tournamentId]: a });
  let l = Object.values(t), m = l.reduce((U, S) => U.concat(S.events ?? []).map((D) => (D.drawDefinitions || []).map((w) => w.links || [])).flat(1 / 0), []).filter(({ linkType: U }) => U === Wn), f = r;
  if (m.length) {
    f = en({ nextMatchUps: !0, tournamentRecords: t }).matchUps;
    let U = m.reduce((S, D) => {
      var P, b;
      let w = (P = D.source) == null ? void 0 : P.structureId, v = (b = D.target) == null ? void 0 : b.structureId;
      return w && v && (d[v] = w), w && !S.includes(w) && S.push(w), S;
    }, []);
    for (let S of U)
      c[S] = [];
    for (let S of f ?? []) {
      let D = S.containerStructureId || S.structureId;
      U.includes(D) && c[D].push(S.matchUpId);
    }
  }
  let h = (U) => {
    u[U] || (u[U] = { dependentMatchUpIds: [], participantIds: [], matchUpIds: [], sources: [] }, p[U] = []);
  }, g = (U, S) => {
    u[U].matchUpIds.forEach((D) => {
      u[S].matchUpIds.push(D);
    }), u[S].matchUpIds.push(U), u[U].dependentMatchUpIds.push(S), n && u[U].participantIds.forEach((D) => u[S].participantIds.push(D));
  }, I = (U) => {
    let S = Object.keys(c).length;
    for (let D of U || []) {
      let { matchUpId: w, winnerMatchUpId: v, loserMatchUpId: P } = D;
      if (!s.length || s.includes(w)) {
        if (h(w), n) {
          let { individualParticipantIds: R } = Rp(D);
          u[w].participantIds = R;
        }
        v && (h(v), g(w, v), p[v].push(w)), P && (h(P), g(w, P), p[P].push(w)), u[w].sources.push(p[w]);
        let b = p[w].map((R) => u[R].sources[0]).flat(), T = p[w].map((R) => u[R].sources[1]).flat();
        if (u[w].sources.push(b, T), S) {
          let R = D.containerStructureId || D.structureId, M = d[R];
          if (c[M])
            for (let E of c[M])
              h(E), g(E, w), p[E].push(w);
        }
      }
    }
  };
  if (o)
    Ja({ drawDefinition: o }), f != null && f.length || (f = vr({ drawDefinition: o }).matchUps), I(f);
  else {
    if (f != null && f.length || (f = en({ nextMatchUps: !0, tournamentRecords: t }).matchUps), !i.length) {
      let U = l != null && l.length ? l.map(({ events: S = [] }) => S.map(({ drawDefinitions: D = [] }) => D.map(({ drawId: w }) => w))).flat(1 / 0) : [];
      U && (i = U);
    }
    for (let U of i) {
      let S = f == null ? void 0 : f.filter((D) => D.drawId === U).sort(cs);
      if (!(S != null && S.find(({ roundPosition: D }) => !D))) {
        let D = S == null ? void 0 : S.find(({ tournamentId: v }) => v), { drawDefinition: w } = Cr({ tournamentRecord: t[D == null ? void 0 : D.tournamentId], drawId: U });
        w && Ja({ drawDefinition: w });
      }
      I(S);
    }
  }
  return { positionDependencies: c, matchUpDependencies: u, sourceMatchUpIds: p, matchUps: f, ...V };
}
function jt(e) {
  var p, l;
  let t = e == null ? void 0 : e.matchUp, r = (e == null ? void 0 : e.score) || (t == null ? void 0 : t.score), i = (p = r == null ? void 0 : r.sets) == null ? void 0 : p[0], { side1Score: n, side2Score: a, side1TiebreakScore: o, side2TiebreakScore: s, side1PointScore: c, side2PointScore: u } = i || {}, d = n || a || o || s || c || u;
  return !!(((l = r == null ? void 0 : r.sets) == null ? void 0 : l.length) > 1 || d);
}
function td({ matchUpStatus: e }) {
  return ID.includes(e);
}
function uk({ matchUpStatus: e }) {
  return wg.includes(e);
}
function Vf({ matchUpStatus: e }) {
  return UD.includes(e);
}
function Zg({ matchUpStatus: e, winningSide: t, tieMatchUps: r, sides: i, score: n }) {
  var s;
  let a = i == null ? void 0 : i.find(({ participantId: c }) => c), o = (s = r == null ? void 0 : r.filter(Zg)) == null ? void 0 : s.length;
  return jt({ score: n }) || o || t && a || e && uk({ matchUpStatus: e }) && ![ke, Be, Gi].includes(e);
}
function rd(e) {
  var v;
  let { drawDefinition: t, findContainer: r, structureId: i, event: n } = e, a = e.structure, o = { isCollectionMatchUp: !1 }, { containedStructures: s } = gc({ drawDefinition: t }), c = i ? s[i] || [] : [];
  if (!a) {
    let P = ve({ drawDefinition: t, structureId: i });
    if (P.error)
      return P;
    a = r ? P.containingStructure ?? P.structure : P.structure;
  }
  if (Er({ structure: a }))
    return { structure: a, isAdHoc: !0, error: rc };
  let { matchUps: u } = Bt({ inContext: !0, matchUpFilters: o, drawDefinition: t, event: n }), d = u == null ? void 0 : u.filter((P) => P.structureId === i || c.includes(P.structureId)), { matchUpDependencies: p } = qi({ drawIds: [t.drawId], matchUps: u, drawDefinition: t }), l = [], m = [], f = {}, h = [];
  for (let P of u ?? []) {
    if (P.structureId === i || c.includes(P.structureId)) {
      m.push(...P.drawPositions ?? []);
      let b = P.roundNumber;
      for (let T of (P.drawPositions ?? []).filter(Boolean))
        (!f[T] || b && f[T] > b) && (f[T] = b);
    }
    Zg(P) && (h.push(P), l.push(P.matchUpId, ...((v = p == null ? void 0 : p[P == null ? void 0 : P.matchUpId]) == null ? void 0 : v.matchUpIds) || []));
  }
  let g = Te(m.filter(Boolean)).sort(Ft), I = Te(l), y = Te(d == null ? void 0 : d.map(({ matchUpId: P, drawPositions: b }) => I.includes(P) ? b : []).flat().filter(Boolean)).sort(Ft), { positionAssignments: U } = ot({ drawDefinition: t, structure: a }), S = U == null ? void 0 : U.filter((P) => P.bye).map((P) => P.drawPosition), D = U == null ? void 0 : U.filter((P) => P.qualifier).map((P) => P.drawPosition), w = (g == null ? void 0 : g.filter((P) => !y.includes(P))) || [];
  return { allDrawPositions: g, inContextStructureMatchUps: d, drawPositionInitialRounds: f, activeDependentMatchUpIds: I, qualifyingDrawPositions: D, inactiveDrawPositions: w, positionAssignments: U, activeDrawPositions: y, byeDrawPositions: S, activeMatchUps: h, structure: a };
}
function Bo({ drawPosition: e, matchUps: t = [] }) {
  return { initialRoundNumber: t.filter(({ drawPositions: r }) => e && (r == null ? void 0 : r.includes(e))).map(({ roundNumber: r }) => r).sort(Ft)[0] };
}
var sa = { reset: "\x1B[0m", bright: "\x1B[1m", dim: "\x1B[2m", red: "\x1B[31m", brightred: "\x1B[91m", green: "\x1B[32m", brightgreen: "\x1B[92m", yellow: "\x1B[33m", brightyellow: "\x1B[93m", blue: "\x1B[34m", brightblue: "\x1B[94m", lightblue: "\x1B[105m", magenta: "\x1B[35m", brightmagenta: "\x1B[95m", cyan: "\x1B[36m", brightcyan: "\x1B[96m", white: "\x1B[37m", brightwhite: "\x1B[97m" }, yl = [];
function ii(e, t) {
  ht(e) && (e = { method: e }), (t || oi()) && yl.push(e);
}
function dk(e) {
  let t = yl.slice();
  return e && (yl.length = 0), t;
}
function lk(e) {
  let t = dk(e).map((r) => {
    let { color: i, keyColors: n, method: a, newline: o } = r, s = Object.keys(sa).includes(i) ? sa[i] : sa.cyan, c = Object.keys(r).filter((d) => !["color", "keyColors", "method", "newline"].includes(d)).map((d) => {
      let p = n && Object.keys(n).includes(d) && sa[n[d]] ? sa[n[d]] : sa.brightwhite;
      return `${sa.white}${d}: ${p}${r[d]}`;
    }).join(", "), u = (a == null ? void 0 : a.length) < 15 ? "		" : "	";
    return [o ? `
` : "", s, a, u, sa.white, c, sa.reset, `
`].join("");
  });
  t != null && t.length && console.log(...t);
}
function pk() {
  yl.length = 0;
}
function pi({ provisionalPositioning: e, isPositionAction: t, tournamentRecord: r, drawDefinition: i, drawPosition: n, matchUpsMap: a, structureId: o, structure: s, event: c }) {
  var b, T, R;
  if (!i)
    return { error: le };
  if (s || ({ structure: s } = ve({ drawDefinition: i, structureId: o })), !s)
    return { error: It };
  o || ({ structureId: o } = s);
  let u = "assignDrawPositionBye";
  ii({ method: u, color: "cyan", drawPosition: n }), a || (a = mr({ drawDefinition: i }));
  let { positionAssignments: d } = ot({ structure: s }), { activeDrawPositions: p } = rd({ drawDefinition: i, structureId: o });
  if ((b = d == null ? void 0 : d.find((M) => M.drawPosition === n)) != null && b.bye)
    return { ...V };
  if (p != null && p.includes(n))
    return { error: Gl };
  let l = d == null ? void 0 : d.find((M) => M.drawPosition === n);
  if (!l)
    return { error: rc };
  let { filled: m, containsBye: f, assignedParticipantId: h } = mk(l);
  if (f)
    return { ...V };
  if (m && !f)
    return j({ result: { error: Os }, stack: u });
  let g = je({ tournamentRecord: r, drawDefinition: i, event: c }).appliedPolicies ?? {}, I = Bt({ inContext: !0, drawDefinition: i, matchUpsMap: a }).matchUps ?? [], y = { isCollectionMatchUp: !1 }, { matchUps: U } = Ke({ provisionalPositioning: e, drawDefinition: i, matchUpFilters: y, matchUpsMap: a, structure: s });
  if (d == null || d.forEach((M) => {
    M.drawPosition === n && (M.bye = !0);
  }), s.structureType === br)
    return fk({ tournamentRecord: r, drawDefinition: i, drawPosition: n, matchUps: U }), Sa({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: i, structure: s, event: c }), sS({ assignedParticipantId: h, isPositionAction: t, appliedPolicies: g, drawDefinition: i, drawPosition: n, structureId: o, stack: u });
  let { roundProfile: S, roundMatchUps: D } = Pr({ matchUps: U }), w = (T = S && Object.keys(S).map((M) => parseInt(M)).reverse()) == null ? void 0 : T.find((M) => {
    var E;
    return (E = S == null ? void 0 : S[M].drawPositions) == null ? void 0 : E.includes(n);
  }), v = w ? D == null ? void 0 : D[w].find(({ drawPositions: M }) => M == null ? void 0 : M.includes(n)) : void 0;
  v && oT({ tournamentRecord: r, drawDefinition: i, matchUp: v, event: c });
  let P = (R = v == null ? void 0 : v.drawPositions) == null ? void 0 : R.find((M) => M !== n);
  if (v && P) {
    let M = eI({ sourceDrawPositions: v.drawPositions, matchUpId: v.matchUpId, inContextDrawMatchUps: I, drawPositionToAdvance: P, tournamentRecord: r, drawDefinition: i, matchUpsMap: a });
    if (M.error)
      return M;
  }
  return Sa({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: i, structure: s, event: c }), sS({ assignedParticipantId: h, isPositionAction: t, appliedPolicies: g, drawDefinition: i, drawPosition: n, structureId: o, stack: u });
}
function sS({ assignedParticipantId: e, isPositionAction: t, appliedPolicies: r, drawDefinition: i, drawPosition: n, structureId: a, stack: o }) {
  return t && bp({ appliedPolicies: r, drawDefinition: i, positionAction: { removedParticipantId: e, drawPosition: n, structureId: a, name: o } }), j({ result: { ...V }, stack: o });
}
function mk(e) {
  let t = e.bye, r = e.qualifier, i = e.participantId;
  return { containsBye: t, containsQualifier: r, assignedParticipantId: i, filled: t || r || i };
}
function oT({ tournamentRecord: e, drawDefinition: t, eventId: r, matchUp: i, event: n }) {
  Object.assign(i, { matchUpStatus: $e, score: void 0, winningSide: void 0 }), xe({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: r ?? (n == null ? void 0 : n.eventId), context: "setMatchUpStatusBye", drawDefinition: t, matchUp: i });
}
function fk({ tournamentRecord: e, drawDefinition: t, drawPosition: r, matchUps: i, event: n }) {
  i.forEach((a) => {
    var o;
    (o = a.drawPositions) != null && o.includes(r) && oT({ eventId: n == null ? void 0 : n.eventId, tournamentRecord: e, drawDefinition: t, matchUp: a });
  });
}
function eI({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, matchUpsMap: a, matchUpId: o, event: s }) {
  var U, S;
  ii({ method: "advanceDrawPosition", color: "cyan", drawPositionToAdvance: e });
  let c = a.drawMatchUps.find((D) => D.matchUpId === o), u = (U = t.find((D) => D.matchUpId === o)) == null ? void 0 : U.structureId, { structure: d } = ve({ drawDefinition: n, structureId: u }), { positionAssignments: p } = ot({ structure: d }), l = p == null ? void 0 : p.filter((D) => D.bye).map((D) => D.drawPosition), m = (S = c == null ? void 0 : c.drawPositions) == null ? void 0 : S.find((D) => D !== e), f = m && (l == null ? void 0 : l.includes(m)), { targetLinks: { loserTargetLink: h }, targetMatchUps: { loserMatchUp: g, winnerMatchUp: I, loserTargetDrawPosition: y } } = Dr({ inContextDrawMatchUps: t, drawDefinition: n, matchUpId: o });
  if (I && I.structureId === (d == null ? void 0 : d.structureId) && hk({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, winnerMatchUp: I, matchUpsMap: a, event: s }), g && f && g.structureId !== (d == null ? void 0 : d.structureId)) {
    let { roundNumber: D } = g;
    if (D === 1) {
      let w = pi({ structureId: h.target.structureId, drawPosition: y, tournamentRecord: i, drawDefinition: n, event: s });
      if (w.error)
        return w;
    } else
      sT({ loserTargetDrawPosition: y, tournamentRecord: i, loserTargetLink: h, drawDefinition: n, loserMatchUp: g, matchUpsMap: a, event: s });
  }
  return { ...V };
}
function hk({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, winnerMatchUp: a, matchUpsMap: o, event: s }) {
  var C, A, N, O, k, F;
  let c = "advanceWinner", u = o.drawMatchUps.find((x) => x.matchUpId === a.matchUpId), d = (C = t.find((x) => x.matchUpId === a.matchUpId)) == null ? void 0 : C.structureId, { structure: p } = ve({ drawDefinition: n, structureId: d }), { positionAssignments: l } = ot({ structure: p }), m = (A = l == null ? void 0 : l.find(({ drawPosition: x }) => x === e)) == null ? void 0 : A.bye, f = (N = u.drawPositions) == null ? void 0 : N.filter(Boolean), h = l == null ? void 0 : l.filter((x) => f == null ? void 0 : f.includes(x.drawPosition)), g = l == null ? void 0 : l.find(({ drawPosition: x }) => x === e), I = r == null ? void 0 : r.find((x) => x !== e), y = (O = I && (h == null ? void 0 : h.find(({ drawPosition: x }) => x === I))) == null ? void 0 : O.bye, U = m && y;
  if (U && console.log({ isByeAdvancedBye: U }), (f == null ? void 0 : f.length) > 1 && m && !y)
    return j({ result: { error: Os }, stack: c });
  let S = f == null ? void 0 : f.find((x) => x !== e), D = U, w = [...(u.drawPositions || []).filter(Boolean), void 0, void 0].slice(0, 2), v = w.map((x) => !x && !D || x === e ? (D = !0, e) : x).sort(Ft);
  if (!D)
    return console.log("@@@@@@@", { advancingAssignmentIsBye: g, drawPositionToAdvance: e, existingAssignments: h }), j({ result: { error: Os }, stack: c });
  let P = (k = l == null ? void 0 : l.find(({ drawPosition: x }) => x === S)) == null ? void 0 : k.bye, b = (F = l == null ? void 0 : l.find(({ drawPosition: x }) => x === e)) == null ? void 0 : F.bye;
  Object.assign(u, { matchUpStatus: b || P ? $e : Rt, score: void 0, winningSide: void 0, drawPositions: v });
  let T = u.drawPositions.find((x) => !w.includes(x));
  ii({ method: c, color: "brightyellow", changedDrawPosition: T, pairedDrawPositionIsBye: P, drawPositionIsBye: b }), xe({ tournamentId: i == null ? void 0 : i.tournamentId, matchUp: u, eventId: s == null ? void 0 : s.eventId, context: c, drawDefinition: n });
  let { targetLinks: { loserTargetLink: R }, targetMatchUps: { loserMatchUp: M, loserTargetDrawPosition: E } } = Dr({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: n });
  if (P || b) {
    let x = P ? e : S;
    if (x)
      eI({ drawPositionToAdvance: x, matchUpId: a.matchUpId, inContextDrawMatchUps: t, tournamentRecord: i, drawDefinition: n, matchUpsMap: o });
    else if (b && R && M)
      if (M.feedRound)
        sT({ loserTargetDrawPosition: E, tournamentRecord: i, loserTargetLink: R, drawDefinition: n, loserMatchUp: M, matchUpsMap: o });
      else {
        let _ = 1 - a.roundPosition % 2, B = M.drawPositions[_], L = pi({ structureId: R.target.structureId, drawPosition: B, tournamentRecord: i, drawDefinition: n, event: s });
        if (L.error)
          return L;
      }
  }
}
function sT({ loserTargetDrawPosition: e, tournamentRecord: t, loserTargetLink: r, drawDefinition: i, loserMatchUp: n, matchUpsMap: a, event: o }) {
  let { roundNumber: s } = n;
  ii({ method: "assignFedDrawPositionBye", color: "cyan", loserTargetDrawPosition: e });
  let c = ((a == null ? void 0 : a.mappedMatchUps) || {})[n.structureId].matchUps, { initialRoundNumber: u } = Bo({ drawPosition: e, matchUps: c });
  if (u === s) {
    let d = pi({ structureId: r.target.structureId, drawPosition: e, tournamentRecord: t, drawDefinition: i, event: o });
    if (d.error)
      return d;
  }
}
function cT({ positionAssignments: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: i, structure: n, event: a }) {
  let { matchUps: o } = Ke({ drawDefinition: r, matchUpsMap: i, structure: n, event: a });
  o.forEach((s) => {
    let c = e.filter(({ drawPosition: u }) => {
      var d;
      return (d = s.drawPositions) == null ? void 0 : d.includes(u);
    }).filter((u) => u.bye).length;
    s.winningSide || (Object.assign(s, { matchUpStatus: c ? $e : Rt }), xe({ tournamentId: t == null ? void 0 : t.tournamentId, context: "modifyRoundRobinMatchUpsStatus", eventId: a == null ? void 0 : a.eventId, drawDefinition: r, matchUp: s }));
  });
}
function id(e) {
  let { inContextDrawMatchUps: t, participantId: r, drawPosition: i } = e, { tournamentRecord: n, drawDefinition: a, structureId: o, matchUpsMap: s, event: c } = e, { structure: u } = ve({ drawDefinition: a, structureId: o }), d = (Yt({ drawDefinition: a, structure: u }).positionAssignments || []).find((l) => r && l.participantId === r || i && l.drawPosition === i);
  if (d && r && !i && (i = d == null ? void 0 : d.drawPosition), !i)
    return { error: ic };
  r || (r = d == null ? void 0 : d.participantId);
  let { activeDrawPositions: p } = rd({ drawDefinition: a, structureId: o });
  return p.includes(i) ? { error: Gl } : (t || ({ matchUps: t } = Bt({ inContext: !0, drawDefinition: a, matchUpsMap: s })), jf({ inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, structureId: o, drawPosition: i, matchUpsMap: s, event: c }).drawPositionCleared ? (Sa({ tournamentId: n == null ? void 0 : n.tournamentId, drawDefinition: a, structure: u, event: c }), { ...V, participantId: r }) : { error: kv });
}
function jf({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, structureId: a, event: o }) {
  var I, y;
  let { structure: s } = ve({ drawDefinition: r, structureId: a });
  if (!s)
    return { error: It };
  let c = Yt({ drawDefinition: r, structure: s }).positionAssignments || [], u = c.some((U) => {
    if (U.drawPosition === i)
      return delete U.participantId, delete U.qualifier, delete U.bye, !0;
  });
  if (s.structureType === br)
    return cT({ positionAssignments: c, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, structure: s }), { drawPositionCleared: u, ...V };
  let d = { isCollectionMatchUp: !1 }, { matchUps: p } = Ke({ drawDefinition: r, matchUpFilters: d, matchUpsMap: n, structure: s, event: o }), { roundProfile: l, roundMatchUps: m } = Pr({ matchUps: p }), f = (I = l && Object.keys(l)) == null ? void 0 : I.map((U) => ye(U)), h = i, g = (y = f == null ? void 0 : f.map((U) => {
    var M, E, C, A;
    let S = (E = (M = l == null ? void 0 : l[U]) == null ? void 0 : M.pairedDrawPositions) == null ? void 0 : E.find((N) => N.includes(h)), D = S == null ? void 0 : S.find((N) => N !== h), w = c.find((N) => N.drawPosition === D), v = l == null ? void 0 : l[U + 1], P = w == null ? void 0 : w.bye, b = (C = v == null ? void 0 : v.pairedDrawPositions) == null ? void 0 : C.find((N) => N.includes(D)), T = P && b && v && ((A = v.drawPositions) == null ? void 0 : A.includes(D)), R = S && { pairedDrawPositionByeAdvancedPair: !T && b, pairedDrawPosition: D, targetDrawPosition: h, relevantPair: S, roundNumber: U };
    return T && (h = D), R;
  }).filter((U) => U == null ? void 0 : U.targetDrawPosition)) == null ? void 0 : y.reduce((U, S) => {
    let { roundNumber: D, relevantPair: w, targetDrawPosition: v, pairedDrawPosition: P, pairedDrawPositionByeAdvancedPair: b } = S, T = { roundNumber: D, targetDrawPosition: v, relevantPair: w }, R = b && { roundNumber: D + 1, targetDrawPosition: P, relevantPair: b, subsequentRoundRemoval: !0 }, M = [T, R].filter(Boolean);
    return U.concat(...M);
  }, []);
  return g == null || g.forEach(({ roundNumber: U, targetDrawPosition: S, relevantPair: D }) => {
    let w = m == null ? void 0 : m[U].find((v) => {
      var P;
      return wr((P = v.drawPositions) == null ? void 0 : P.filter(Boolean), D.filter(Boolean));
    });
    w && (gk({ inContextDrawMatchUps: e, targetDrawPosition: S, tournamentRecord: t, drawDefinition: r, structureId: a, roundNumber: U, matchUpsMap: n }), uT({ inContextDrawMatchUps: e, positionAssignments: c, tournamentRecord: t, drawDefinition: r, targetMatchUp: w, drawPosition: i, matchUpsMap: n, structure: s, event: o }));
  }), { tasks: g, drawPositionCleared: u, positionAssignments: c };
}
function gk({ inContextDrawMatchUps: e, targetDrawPosition: t, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, roundNumber: a, structureId: o }) {
  let { structure: s } = ve({ drawDefinition: i, structureId: o });
  if (!s)
    return { error: It };
  if (s.structureType === br)
    return;
  n = n || mr({ drawDefinition: i });
  let c = ((n == null ? void 0 : n.mappedMatchUps) || {})[o].matchUps, { initialRoundNumber: u } = Bo({ drawPosition: t, matchUps: c }), d = c == null ? void 0 : c.filter((l) => {
    var m;
    return l.roundNumber >= a && l.roundNumber !== u && ((m = l.drawPositions) == null ? void 0 : m.includes(t));
  }), p = ot({ drawDefinition: i, structureId: o }).positionAssignments ?? [];
  return d == null || d.forEach((l) => uT({ drawPosition: t, targetMatchUp: l, inContextDrawMatchUps: e, positionAssignments: p, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, structure: s })), { ...V };
}
function uT({ inContextDrawMatchUps: e, positionAssignments: t, tournamentRecord: r, drawDefinition: i, targetMatchUp: n, drawPosition: a, matchUpsMap: o, structure: s, event: c }) {
  var v, P, b, T, R;
  let u = "removeDrawPosition", d = (v = n.drawPositions) == null ? void 0 : v.slice(), p = n.matchUpStatus, l = n.winningSide;
  o = o ?? mr({ drawDefinition: i });
  let m = o.mappedMatchUps[s.structureId].matchUps, { initialRoundNumber: f } = Bo({ drawPosition: a, matchUps: m });
  if (n.roundNumber && f && n.roundNumber > f) {
    let M = (n.drawPositions ?? []).map((E) => E === a ? void 0 : E);
    n.drawPositions = M;
  }
  if (n.matchUpType === lt) {
    let M = (((P = e == null ? void 0 : e.find((E) => E.matchUpId === n.matchUpId)) == null ? void 0 : P.sides) ?? []).reduce((E, C, A) => C.drawPosition === a ? A : E, void 0);
    M !== void 0 && ((T = (b = n.sides) == null ? void 0 : b[M]) != null && T.lineUp) && ((R = n.sides) == null || delete R[M].lineUp, xe({ tournamentId: r == null ? void 0 : r.tournamentId, context: `${u}-TEAM`, eventId: c == null ? void 0 : c.eventId, matchUp: n, drawDefinition: i }));
  }
  let h = Dr({ matchUpId: n.matchUpId, inContextDrawMatchUps: e, drawDefinition: i }), { targetLinks: { winnerTargetLink: g }, targetMatchUps: { loserMatchUp: I, winnerMatchUp: y, loserMatchUpDrawPositionIndex: U } } = h, S = t.filter(({ drawPosition: M }) => {
    var E;
    return (E = n.drawPositions) == null ? void 0 : E.includes(M);
  }).filter((M) => M.bye).length, D = S && $e || n.matchUpStatus && [ke, Be].includes(n.matchUpStatus) && n.matcHUpStatus || Rt;
  n.matchUpStatus = D, n.matchUpStatus && [Be, ke].includes(n.matchUpStatus) && (n.winningSide = void 0);
  let w = d == null ? void 0 : d.find((M) => {
    var E;
    return !((E = n.drawPositions) != null && E.includes(M));
  });
  if (d != null && d.includes(a) && p === n.matchUpStatus && l === n.winningSide || (w && ii({ method: u, color: "brightyellow", removedDrawPosition: w }), xe({ tournamentId: r == null ? void 0 : r.tournamentId, context: `${u}-${a}`, eventId: c == null ? void 0 : c.eventId, matchUp: n, drawDefinition: i })), I && I.structureId !== h.matchUp.structureId && !S) {
    let { drawPositions: M, roundNumber: E } = I;
    if (E === 1) {
      let C = M[U];
      jf({ structureId: I.structureId, drawPosition: C, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, matchUpsMap: o });
    } else {
      let C = Math.min(...M.filter(Boolean)), A = Ik({ loserMatchUpDrawPosition: C, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, loserMatchUp: I, matchUpsMap: o, event: c });
      if (A.error)
        return j({ result: A, stack: u });
      let N = ((o == null ? void 0 : o.mappedMatchUps) || {})[I.structureId].matchUps, { initialRoundNumber: O } = Bo({ drawPosition: C, matchUps: N });
      O === 1 && (ii({ method: u, color: "brightyellow", loserMatchUpDrawPosition: C }), jf({ structureId: I.structureId, drawPosition: C, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, matchUpsMap: o }));
    }
  }
  return y && y.structureId !== h.matchUp.structureId && g.target.feedProfile, { ...V };
}
function Ik({ loserMatchUpDrawPosition: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, loserMatchUp: n, matchUpsMap: a, event: o }) {
  var u;
  let { structure: s } = ve({ structureId: n.structureId, drawDefinition: i }), { positionAssignments: c } = ot({ structure: s });
  if ((u = c == null ? void 0 : c.find((d) => d.drawPosition === e)) != null && u.bye) {
    let d = id({ drawPosition: e, structureId: n.structureId, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, matchUpsMap: a, event: o });
    if (d.error)
      return d;
  }
  return { ...V };
}
function ho({ drawDefinition: e, stages: t }) {
  if (!e)
    return { error: le };
  let r = ((e == null ? void 0 : e.structures) ?? []).filter((n) => !(t != null && t.length) || n.stage && t.includes(n.stage)), i = Te(r.map((n) => {
    let { positionAssignments: a } = ot({ structure: n });
    return a ? a.map(Ce) : [];
  }).flat().filter(Boolean));
  return { ...V, assignedParticipantIds: i };
}
function Ki(e) {
  let t = ((e == null ? void 0 : e.entries) ?? []).filter(Boolean).reduce((i, n) => {
    let { entryStage: a, entryStatus: o } = n, s = `_${a || ue}${o || ""}`;
    return i[s] || (i[s] = []), i[s].push(n), i;
  }, {}), r = (i) => isNaN(i) ? 1 / 0 : i;
  return Object.keys(t).map((i) => t[i].sort((n, a) => r(n.entryPosition) - r(a.entryPosition)).map((n, a) => {
    let o = a + 1;
    return { ...n, entryPosition: o };
  })).flat();
}
function La(e) {
  return [po, Di].includes(e);
}
function Sl({ autoEntryPositions: e = !0, ignoreAssignment: t, tournamentRecord: r, drawDefinition: i, participantIds: n, entryStatus: a, entryStage: o, extension: s, eventSync: c, drawId: u, stage: d, event: p }) {
  var b, T, R, M, E, C, A, N, O, k, F, x;
  if (!n || !Array.isArray(n))
    return { error: Ji, method: "modifyEntriesStatus", participantIds: n };
  if (!i && !p)
    return { error: pt };
  if (a && !LD.includes(a))
    return { error: Pf };
  if (o && !sp.includes(o))
    return { error: oo };
  let l = "modifyEntriesStatus", m = [];
  if (!a && !s)
    return j({ result: { error: Ie }, info: "Missing entryStatus", stack: l });
  if (s && !pn({ extension: s, requiredAttributes: ["name"] }))
    return j({ result: { error: J }, info: "Invalid extension", context: { extension: s }, stack: l });
  let f = [];
  (b = p == null ? void 0 : p.drawDefinitions) == null || b.forEach((_) => {
    let B = ho({ stages: d && [d], drawDefinition: _ }).assignedParticipantIds ?? [];
    f.push(...B);
  });
  let h = (r == null ? void 0 : r.participants) ?? [];
  if (!n.every((_) => {
    var L;
    let B = (L = ga({ tournamentParticipants: h, participantId: _ })) == null ? void 0 : L.participantType;
    return !(B && [Re, Nr].includes(B) && La(a)) && !(a && (p != null && p.eventType) && B === Oe && [Ui, Xr].includes(p.eventType) && [Fi, ...Kd].includes(a));
  }))
    return { error: Pf };
  let g = p && Pt({ event: p }).flightProfile, I = (T = g == null ? void 0 : g.flights) == null ? void 0 : T.find((_) => _.drawId === u), y = (_) => {
    let B = (_ || []).filter((G) => !d || !G.entryStage || d === G.entryStage).filter(({ participantId: G }) => n.includes(G)), L = (G) => a && f.includes(G.participantId) && !(Kd.includes(G.entryStatus) && Kd.includes(a));
    return B.every((G) => L(G) && !t ? !1 : (a && (G.entryStatus = a, delete G.entryPosition), o && (G.entryStage = o, delete G.entryPosition), s && (s.value ? Ve({ element: G, extension: s }) : Sr({ element: G, name: s.name })), !0)) ? { ...V } : { error: oc };
  }, U = ({ flight: _, drawDefinition: B }) => {
    p && (p.entries = Ki({ entries: p.entries ?? [] })), _ && (_.drawEntries = Ki({ entries: _.drawEntries })), B && (B.entries = Ki({ entries: B.entries }));
  }, S = (_) => {
    let { flight: B, drawDefinition: L } = _, G = "updateDrawEntries";
    if (B) {
      let $ = y(B.drawEntries);
      if ($.error)
        return j({ result: $, stack: G });
    }
    if (L) {
      let $ = y(L.entries);
      if ($.error)
        return j({ result: $, stack: G });
      m.includes(L.drawId) || m.push(L.drawId);
    }
    return { ...V };
  }, D = ((R = p == null ? void 0 : p.entries) == null ? void 0 : R.find(({ entryPosition: _ }) => _)) ?? (((M = I == null ? void 0 : I.drawEntries) == null ? void 0 : M.find(({ entryPosition: _ }) => _)) || ((E = i == null ? void 0 : i.entries) == null ? void 0 : E.find(({ entryPosition: _ }) => _)));
  if (e && !D && U({ flight: I, drawDefinition: i }), I || i) {
    let _ = S({ flight: I, drawDefinition: i });
    if (_.error)
      return j({ result: _, stack: l });
  }
  let w = ((C = p == null ? void 0 : p.drawDefinitions) == null ? void 0 : C.map(({ drawId: _ }) => _)) ?? [], v = ((A = g == null ? void 0 : g.flights) == null ? void 0 : A.filter((_) => !w.includes(_.drawId))) || [];
  for (let _ of v) {
    let B = _ && S({ flight: _ });
    if (B != null && B.error)
      return j({ result: B, stack: l });
  }
  let P = ((N = g == null ? void 0 : g.flights) == null ? void 0 : N.length) === 1 && (((O = p == null ? void 0 : p.drawDefinitions) == null ? void 0 : O.length) ?? 0) <= ((k = g == null ? void 0 : g.flights) == null ? void 0 : k.length);
  if (!I && !i && a && xD.includes(a))
    return { error: Iw };
  if (!I && !i || a === On || c && P) {
    let _ = y(p == null ? void 0 : p.entries);
    if (_ != null && _.error)
      return j({ result: _, stack: l });
    let B;
    if (a === On && ((F = g == null ? void 0 : g.flights) == null || F.every((L) => {
      let G = y(L.drawEntries);
      return G.error ? (B = G.error, !1) : (L.drawEntries = L.drawEntries.filter(({ participantId: $ }) => !n.includes($)), !0);
    }), (x = p == null ? void 0 : p.drawDefinitions) == null || x.every((L) => {
      var $;
      let G = y(L.entries);
      return G.error ? (B = G.error, !1) : (L.entries = ($ = L.entries) == null ? void 0 : $.filter(({ participantId: W }) => !n.includes(W)), !0);
    })), B)
      return j({ result: { error: B }, stack: l });
  }
  e && U({ flight: I, drawDefinition: i });
  for (let _ of (p == null ? void 0 : p.drawDefinitions) ?? [])
    m.length && !m.includes(_.drawId) || ut({ tournamentId: r.tournamentId, eventId: p == null ? void 0 : p.eventId, drawDefinition: _ });
  return { ...V };
}
function Tn({ requireTimeStamp: e, scaleAttributes: t, participant: r }) {
  var i, n;
  if (!r)
    return { error: Ho };
  if (!Le(t))
    return { error: J };
  if (r.timeItems || (r.timeItems = []), Array.isArray(r.timeItems)) {
    let { accessor: a, scaleType: o, eventType: s, scaleName: c } = t, u = [za, o, s, c].join("."), d = r.timeItems.filter((p) => (p == null ? void 0 : p.itemType) === u).filter((p) => !e || (p == null ? void 0 : p.itemDate)).sort((p, l) => (p.createdAt ? new Date(p.createdAt).getTime() : 0) - (l.createdAt ? new Date(l.createdAt).getTime() : 0)).pop();
    if (d) {
      let [p, l, m, f] = ((i = d.itemType) == null ? void 0 : i.split(".")) ?? [];
      if (p !== za)
        return { error: Co };
      let h = ((n = a && To({ element: d.itemValue, accessor: a })) == null ? void 0 : n.value) || d.itemValue, g = { eventType: m, scaleDate: d.itemDate, scaleValue: h, scaleName: f, scaleType: l };
      return { ...V, scaleItem: g };
    }
  }
  return { ...V, scaleItem: void 0 };
}
function Uk({ publishedSeeding: e, usePublishState: t, withSeeding: r, participant: i, event: n }) {
  var d, p, l;
  let a = {}, o = (m) => [za, Pn, n.eventType, m].join("."), s = Object.assign({}, ...(i.timeItems || []).filter(({ itemType: m }) => m.split(".")[1] === Pn).map(({ itemType: m, itemValue: f }) => ({ [m]: f }))), c = ((e == null ? void 0 : e.stageSeedingScaleNames) && Object.values(e == null ? void 0 : e.stageSeedingScaleNames) || Array.isArray(e == null ? void 0 : e.seedingScaleNames) && e.seedingScaleNames || []).map(o), u = wt(Object.keys(s), c);
  if ((!t || !Object.keys(s).length && !((d = e == null ? void 0 : e.drawIds) != null && d.length) || u.length) && u.length) {
    if (e != null && e.stageSeedingScaleNames) {
      let m = Object.keys(e.stageSeedingScaleNames).map((h) => {
        let g = o(e.stageSeedingScaleNames[h]), I = s[g];
        return [h, I];
      }).filter((h) => h[1]).map((h) => ({ [h[0]]: { seedValue: h[1] } })), f = Object.assign({}, ...m);
      a.seedAssignments = f;
    } else if (u) {
      let m = u.map((f) => s[f]);
      a.seedValue = m.pop();
    }
  } else if (!t && typeof r == "object") {
    let m = Object.keys(r).map((h) => {
      let g = o(r[h]), I = s[g];
      return [h, I];
    }).filter((h) => h[1]).map((h) => ({ [h[0]]: { seedValue: h[1] } })), f = Object.assign({}, ...m);
    a.seedAssignments = f;
  } else {
    let { categoryName: m, ageCategoryCode: f } = n.category || {}, h = [f, n.eventId, m].filter(Boolean), g;
    for (let I of h) {
      let y = { eventType: n.eventType, scaleType: Pn, scaleName: I }, U = Tn({ scaleAttributes: y, participant: i });
      if (U.scaleItem) {
        g = U.scaleItem;
        break;
      }
    }
    if (g && (!t || e != null && e.published && !((l = (p = e == null ? void 0 : e.published) == null ? void 0 : p.drawIds) != null && l.length))) {
      let I = g.scaleValue;
      a.seedValue = I;
    }
  }
  return a;
}
function yk({ convertExtensions: e, seedAssignments: t, participant: r, withSeeding: i, seedValue: n, eventId: a, ranking: o, entry: s }) {
  let { entryStatus: c, entryStage: u, entryPosition: d, extensions: p } = s, l = p != null && p.length && e ? Object.assign({}, ...eg(p ?? [])) : {}, m = Object.assign(l, { entryPosition: d, entryStatus: c, entryStage: u, ranking: o, eventId: a });
  r.events[a] = me(m, !1, !1, !0), i && (t && (r.events[a].seedAssignments = t), n && (r.events[a].seedValue = n));
}
function dT(e) {
  let { participantMap: t, participantId: r, matchUpStatus: i, roundPosition: n, structureId: a, matchUpType: o, roundNumber: s, matchUpId: c, potential: u, schedule: d, drawId: p, score: l } = e;
  !d || !Object.keys(d).length || i === $e || t[r].scheduleItems.push({ ...d, scheduledDate: be(d == null ? void 0 : d.scheduledDate), scheduledTime: mt(d == null ? void 0 : d.scheduledTime), checkScoreHasValue: jt({ score: l }), matchUpStatus: i, roundPosition: n, structureId: a, matchUpType: o, roundNumber: s, matchUpId: c, potential: u, drawId: p });
}
function nd(e) {
  var a, o, s;
  let t = fe(e, [{ [Gt]: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, status: i = li } = e, n = `${Ea}.${Ca}`;
  return ce((s = (o = (a = Mp({ tournamentRecord: r, itemType: n })) == null ? void 0 : a.timeItem) == null ? void 0 : o.itemValue) == null ? void 0 : s[i], !1, !0);
}
function Sk(e) {
  let { tournamentId: t } = e ?? {};
  return !!t;
}
function bi({ event: e, status: t = li }) {
  var i, n, a;
  let r = `${Ea}.${Ca}`;
  return (a = (n = (i = Gu({ itemType: r, event: e })) == null ? void 0 : i.timeItem) == null ? void 0 : n.itemValue) == null ? void 0 : a[t];
}
function tI({ drawDetails: e, drawId: t }) {
  var r, i;
  return (i = (r = e == null ? void 0 : e[t]) == null ? void 0 : r.publishingDetail) == null ? void 0 : i.published;
}
function us(e) {
  var p, l, m, f, h, g, I, y, U;
  let { tournamentRecord: t, drawDefinition: r, eventIds: i, eventId: n, drawIds: a, drawId: o, event: s } = e ?? {};
  if (t && !Sk(t))
    return { error: J };
  if (n && !s)
    return { error: Ii };
  if (Array.isArray(i) && (i != null && i.length)) {
    let S = {};
    for (let D of i) {
      if (!ht(D))
        return { error: J };
      let w = (p = Cr({ tournamentRecord: t, eventId: D })) == null ? void 0 : p.event;
      if (!w)
        return { error: Ii };
      let v = Qm({ event: w });
      S[D] = v;
    }
    return { ...V, publishState: S };
  }
  if (s) {
    let S = Qm({ event: s }), D = {};
    if (o)
      return r ? { publishState: { status: { published: !!((l = S.status.publishedDrawIds) != null && l.includes(o)), drawDetail: (m = S.status.drawDetails) == null ? void 0 : m[o] }, ...V } } : { error: ai };
    if (Array.isArray(a) && (a != null && a.length)) {
      let w = ((f = s.drawDefinitions) == null ? void 0 : f.map(cu)) ?? [];
      for (let v of a) {
        if (!ht(v))
          return { error: J };
        if (!w.includes(v))
          return { error: ai };
        D[v] = { status: { published: !!S.status.publishedDrawIds.includes(v), drawDetail: (h = S.status.drawDetails) == null ? void 0 : h[v] } };
      }
    } else
      D = S;
    return { ...V, publishState: D };
  }
  let c = [], u = !1, d = {};
  for (let S of (t == null ? void 0 : t.events) ?? []) {
    let D = Qm({ event: S });
    d[S.eventId] = D, D.status.published && (c.push(S.eventId), u = !0);
    for (let { drawId: w } of S.drawDefinitions ?? []) {
      let v = (I = (g = D.status) == null ? void 0 : g.publishedDrawIds) == null ? void 0 : I.includes(w);
      v && (d[w] = { status: { published: v } });
    }
  }
  if (t) {
    let S = nd({ tournamentRecord: t });
    d.tournament = S ?? {}, ((y = S == null ? void 0 : S.orderOfPlay) != null && y.published || (U = S == null ? void 0 : S.participants) != null && U.published) && (u = !0), d.tournament.status = { published: u, publishedEventIds: c };
  }
  return { ...V, publishState: d };
}
function Qm({ event: e }) {
  var s;
  let t = bi({ event: e });
  if (!t)
    return { status: { published: !1 } };
  let r = { published: void 0, seedingScaleNames: [], drawIds: [] };
  t.seeding && Object.assign(r, t.seeding);
  let i = t.drawDetails ?? {};
  for (let c of ((s = e.drawDefinitions) == null ? void 0 : s.map(cu)) || [])
    i[c] || (i[c] = { publishingDetail: { published: !1 } });
  let n = i && Object.keys(i).length && Object.keys(i).filter((c) => tI({ drawDetails: i, drawId: c })), a = n != null && n.length ? n : t.drawIds ?? [];
  if (a != null && a.length && !(n != null && n.length))
    for (let c of a)
      i[c] = { publishingDetail: { published: !0 } };
  let o = (a == null ? void 0 : a.length) > 0;
  return { status: { publishedDrawIds: a, publishedSeeding: r, drawDetails: i, published: o } };
}
function Lp(e, t) {
  return (e || "").localeCompare(t || "");
}
function vk({ finishingPositionRange: e = {}, participantMap: t, finishingRound: r, participantWon: i, matchUpStatus: n, participantId: a, stageSequence: o, roundNumber: s, structureId: c, matchUpId: u, drawId: d, stage: p }) {
  let l = t[a], m = (y) => Math.abs(y[0] - y[1]);
  l.structureParticipation[c] || (l.structureParticipation[c] = { rankingStage: p, walkoverWinCount: 0, defaultWinCount: 0, stageSequence: o, winCount: 0, structureId: c, drawId: d });
  let f = l.structureParticipation[c], { winner: h, loser: g } = e, I = i ? h : g;
  i && (f.winCount += 1, n === Be && (f.walkoverWinCount += 1), n === ke && (f.defaultWinCount += 1)), I && (!f.finishingPositionRange || m(I) < m(f.finishingPositionRange)) && (f.finishingPositionRange = I), r && ((!f.finishingRound || r < f.finishingRound) && (f.finishingMatchUpId = u, f.finishingRound = r, f.roundNumber = s), r === 1 && (f.participantWon = i));
}
function cS(e) {
  var A, N, O, k, F, x, _, B, L, G;
  let { withScheduleItems: t, scheduleAnalysis: r, withTeamMatchUps: i, participantMap: n, withOpponents: a, withMatchUps: o, withEvents: s, withDraws: c, finishingPositionRange: u, finishingRound: d, matchUpStatus: p, stageSequence: l, roundNumber: m, structureId: f, score: h, stage: g, withRankingProfile: I, tieWinningSide: y, roundPosition: U, matchUpTieId: S, matchUpSides: D, collectionId: w, matchUpType: v, winningSide: P, matchUpId: b, schedule: T, eventId: R, drawId: M, sides: E } = e, C = a && (E == null ? void 0 : E.length) === 2 && Object.assign({}, ...E.map(({ sideNumber: $ }, W) => {
    let q = E[1 - W].participantId;
    return $ && { [$]: q };
  }).filter(Boolean));
  for (let $ of E) {
    let { participantId: W, sideNumber: q, bye: K } = $;
    if (K)
      continue;
    let z = P === q, Y = (Q) => {
      var te, ne;
      let H = (te = n[Q]) == null ? void 0 : te.participant, Z = H == null ? void 0 : H.participantType, ee = [{ participantId: Q, participantType: Z }];
      if (Z !== Nr)
        for (let se of (H == null ? void 0 : H.individualParticipantIds) || []) {
          let ie = (ne = n[se]) == null ? void 0 : ne.participant;
          ee.push({ participantType: ie == null ? void 0 : ie.participantType, participantId: se });
        }
      return ee;
    }, X = (Q, H) => {
      if (o) {
        if (n[Q].matchUps[b] = { participantWon: z, matchUpType: v, structureId: f, sideNumber: q, matchUpId: b, eventId: R, drawId: M, stage: g }, a) {
          let Z = Y(H);
          n[Q].matchUps[b].opponentParticipantInfo = Z;
        }
        w && (n[Q].matchUps[b].collectionId = w);
      }
      a && H && (n[Q].opponents[H] = { participantId: H, matchUpId: b, eventId: R, drawId: M }), I && vk({ finishingPositionRange: u, participantMap: n, participantWon: z, finishingRound: d, matchUpStatus: p, participantId: Q, stageSequence: l, roundNumber: m, structureId: f, matchUpId: b, drawId: M, stage: g }), (r || t) && dT({ participantMap: n, participantId: Q, matchUpStatus: p, roundPosition: U, matchUpType: v, roundNumber: m, structureId: f, matchUpId: b, schedule: T, drawId: M, score: h });
    }, re = ({ participant: Q, partnerParticipantId: H }) => {
      var ee, te, ne;
      let Z = (se, ie) => {
        se && (se.partnerParticipantIds || (se.partnerParticipantIds = []), se.partnerParticipantIds.includes(ie) || se.partnerParticipantIds.push(ie));
      };
      c && Z((ee = Q == null ? void 0 : Q.draws) == null ? void 0 : ee[M], H), s && Z((te = Q == null ? void 0 : Q.events) == null ? void 0 : te[R], H), o && Z((ne = Q == null ? void 0 : Q.matchUps) == null ? void 0 : ne[b], H);
    };
    if (W && n[W]) {
      let Q = C == null ? void 0 : C[q];
      X(W, Q);
      let H = ((A = n[W]) == null ? void 0 : A.participant.participantType) === Re, Z = ((N = n[W]) == null ? void 0 : N.participant.individualParticipantIds) || [];
      if (S) {
        if (i) {
          let ee = (te) => n[te].matchUps[S] = { participantWon: y === q, matchUpId: S, matchUpType: lt, sideNumber: q };
          ee(W), Z.forEach(ee);
        }
        if (c && !n[W].draws[M]) {
          let ee = (k = (O = D.find((se) => se.sideNumber === q)) == null ? void 0 : O.participant) == null ? void 0 : k.participantId, te = (_ = (x = (F = n[ee]) == null ? void 0 : F.draws) == null ? void 0 : x[M]) == null ? void 0 : _.entryStatus, ne = (se) => n[se].draws[M] = { entryStatus: te, eventId: R, drawId: M };
          ne(W), Z.forEach(ne);
        }
      }
      if (H && (Z.forEach((ee) => n[ee] && X(ee, Q)), Z.forEach((ee, te) => {
        let ne = Z[1 - te], se = n[ee];
        se && re({ participant: se, partnerParticipantId: ne });
      }), s && D)) {
        let ee = (L = (B = D.find((te) => te.sideNumber === q)) == null ? void 0 : B.participant) == null ? void 0 : L.participantId;
        if (ee) {
          let te = (G = n[ee]) == null ? void 0 : G.events[R];
          te ? (n[W].events[R] = { ...te }, Z.forEach((ne) => n[ne].events[R] = { ...te })) : console.log("Missing teamEntry", { eventId: R, teamParticipantId: ee });
        }
      }
      if (P) {
        let ee = (te) => {
          z ? (n[te].counters[v].wins += 1, n[te].counters.wins += 1, p === Be && (n[te].counters[v].walkoverWins += 1, n[te].counters.walkoverWins += 1), p === ke && (n[te].counters[v].defaultWins += 1, n[te].counters.defaultWins += 1)) : (n[te].counters[v].losses += 1, n[te].counters.losses += 1, p === Be && (n[te].counters[v].walkovers += 1, n[te].counters.walkovers += 1), p === ke && (n[te].counters[v].defaults += 1, n[te].counters.defaults += 1));
        };
        ee(W), Z.forEach(ee);
      }
    }
  }
}
function wk(e) {
  var E, C, A, N, O, k, F;
  let { participantFilters: t, convertExtensions: r, policyDefinitions: i, tournamentRecord: n, usePublishState: a, participantMap: o, contextProfile: s, withPotentialMatchUps: c, withRankingProfile: u, withScheduleItems: d, scheduleAnalysis: p, withTeamMatchUps: l, withStatistics: m, withOpponents: f, withMatchUps: h, withSeeding: g, withEvents: I, withDraws: y } = e, U = t == null ? void 0 : t.participantIds, S = (x) => {
    var B, L;
    let _ = [x];
    return (L = (B = o[x]) == null ? void 0 : B.participant.individualParticipantIds) == null || L.forEach((G) => _.push(G)), _.some((G) => !(U != null && U.length) || U.includes(G)) ? _ : [];
  }, D = { withMatchUps: h || u, withEvents: I || u, withDraws: y || u, withPotentialMatchUps: c, withRankingProfile: u, withScheduleItems: d, scheduleAnalysis: p, withTeamMatchUps: l, withStatistics: m, participantMap: o, withOpponents: f, withSeeding: g }, w = [], v = {}, P = [], b = {}, T = {}, R = {}, M = ({ eventType: x, scaleNames: _, participantId: B }) => {
    var L, G, $, W, q;
    return (q = (W = ($ = (G = (L = o[B]) == null ? void 0 : L.participant) == null ? void 0 : G.rankings) == null ? void 0 : $[x]) == null ? void 0 : W.find((K) => _.includes(K.scaleName))) == null ? void 0 : q.scaleValue;
  };
  for (let x of (n == null ? void 0 : n.events) || []) {
    if (t != null && t.eventIds && !t.eventIds.includes(x.eventId))
      continue;
    let { drawDefinitions: _ = [], extensions: B = [], eventType: L, eventName: G, category: $, entries: W, eventId: q, gender: K } = x, { flightProfile: z } = Pt({ event: x }), Y = (z == null ? void 0 : z.flights) ?? [], X = us({ event: x }).publishState;
    X && (b[q] = X);
    let re = (E = X == null ? void 0 : X.status) == null ? void 0 : E.publishedSeeding;
    if (I || g || u) {
      let H = r ? Object.assign({}, ...eg(B ?? [])) : {};
      T[q] = { ...H, eventName: G, eventType: L, category: $, eventId: q, gender: K };
      let Z = [$ == null ? void 0 : $.categoryName, $ == null ? void 0 : $.ageCategoryCode].filter(Boolean);
      for (let ee of W) {
        let { participantId: te } = ee;
        if (!te || !o[te])
          continue;
        let ne = M({ eventType: L, scaleNames: Z, participantId: te }), se, ie;
        if (g) {
          let Ee = o[te].participant;
          ({ seedAssignments: se, seedValue: ie } = Uk({ publishedSeeding: re, usePublishState: a, withSeeding: g, participant: Ee, event: x }));
        }
        let he = (Ee) => {
          var it, qe;
          if ((qe = (it = o[Ee]) == null ? void 0 : it.events) != null && qe[q])
            return;
          let de = o[Ee];
          yk({ convertExtensions: r, seedAssignments: se, participant: de, withSeeding: g, seedValue: ie, eventId: q, ranking: ne, entry: ee });
        };
        he(te), (o[te].participant.individualParticipantIds || []).forEach(he);
      }
    }
    let Q = (C = b == null ? void 0 : b[q]) == null ? void 0 : C.publishedSeeding;
    if (y || u || g) {
      let H = (ee) => ee ? Object.assign({}, ...ee.map(({ participantId: te, seedValue: ne, seedNumber: se }) => ({ [te]: { seedValue: ne, seedNumber: se } }))) : void 0, Z = Te([..._.map(cu), ...Y.map(cu)]);
      for (let ee of Z) {
        let te = _.find((Ye) => Ye.drawId === ee), ne = [$ == null ? void 0 : $.categoryName, $ == null ? void 0 : $.ageCategoryCode].filter(Boolean), { structures: se = [], drawOrder: ie, drawName: he, drawType: Ee } = te ?? {}, de = Y == null ? void 0 : Y.find((Ye) => Ye.drawId === ee), it = (te == null ? void 0 : te.entries) || (de == null ? void 0 : de.drawEntries), qe = de == null ? void 0 : de.flightNumber, ar = ((te == null ? void 0 : te.structures) || []).sort((Ye, He) => Zo(Ye, He)).map(({ structureId: Ye, structures: He }) => [Ye, ...(He || []).map(({ structureId: rr }) => rr)]).flat(1 / 0), $t, Ue, Se, pe, We = 0, Ge = se.filter(({ stage: Ye, stageSequence: He }) => Ye === ue && He === 1 || Ye === ge).flatMap((Ye) => {
          let { positionAssignments: He } = ot({ structure: Ye }), { seedAssignments: rr, stageSequence: Je, stage: Nt } = Ye;
          return Nt === ue ? (We = (He == null ? void 0 : He.length) ?? 0, Se = He, pe = rr) : Je === 1 && ($t = He, Ue = rr), He;
        }).map(({ participantId: Ye }) => Ye).filter(Boolean), nt = H(pe), Ze = H(Ue), st = te ? it.filter(({ participantId: Ye }) => Ge.includes(Ye)) : it, qt = !a || (Q == null ? void 0 : Q.published) && (((A = Q == null ? void 0 : Q.drawIds) == null ? void 0 : A.length) === 0 || ((N = Q == null ? void 0 : Q.drawIds) == null ? void 0 : N.includes(ee)));
        for (let Ye of st) {
          if (!o[Ye.participantId])
            continue;
          let { entryStatus: He, entryStage: rr, entryPosition: Je, participantId: Nt } = Ye, Wi = M({ participantId: Nt, scaleNames: ne, eventType: L }), Kt = (At) => {
            var Fr, qr, xr, _n, Sn;
            if (!o[At] || (Fr = o[At].draws) != null && Fr[ee])
              return;
            let kr = g && qt, Me = kr ? {} : void 0, or = kr ? ((qr = nt == null ? void 0 : nt[Nt]) == null ? void 0 : qr.seedValue) || ((xr = nt == null ? void 0 : nt[Nt]) == null ? void 0 : xr.seedNumber) : void 0, Fe = or ? nt == null ? void 0 : nt[Nt] : void 0, ct = kr ? ((_n = Ze == null ? void 0 : Ze[Nt]) == null ? void 0 : _n.seedValue) || ((Sn = Ze == null ? void 0 : Ze[Nt]) == null ? void 0 : Sn.seedNumber) : void 0, ir = ct ? Ze == null ? void 0 : Ze[Nt] : void 0;
            Me && or && (Me[ue] = Fe), Me && ct && (Me[ge] = ir);
            let ri = or || ct;
            ri && (o[At].participant.seedings[L] || (o[At].participant.seedings[L] = []), Fe && o[At].participant.seedings[L].push({ ...Fe, scaleName: ee }), ir && o[At].participant.seedings[L].push({ ...ir, scaleName: ee }), Me && (o[At].events[q].seedAssignments || (o[At].events[q].seedAssignments = {}), Object.keys(Me).forEach((kc) => o[At].events[q].seedAssignments[kc] = Me[kc]))), (y || u) && (o[At].draws[ee] = me({ seedAssignments: Me, entryPosition: Je, entryStatus: He, entryStage: rr, seedValue: ri, eventId: q, ranking: Wi, drawId: ee }, !1, !1, !0));
          };
          [Di, po].includes(He) || (Kt(Nt), (O = o[Nt].participant.individualParticipantIds || []) == null || O.forEach(Kt));
        }
        let Ct = ((te == null ? void 0 : te.structures) ?? []).reduce((Ye, He) => (Ye.includes(He.stage) || Ye.push(He.stage), Ye), []), Mt = ((te == null ? void 0 : te.links) ?? []).length;
        R[ee] = { qualifyingPositionAssignments: $t, qualifyingSeedAssignments: Ue, mainPositionAssignments: Se, qualifyingSeedingMap: Ze, mainSeedAssignments: pe, orderedStructureIds: ar, mainSeedingMap: nt, flightNumber: qe, linksCount: Mt, drawOrder: ie, drawName: he, drawType: Ee, drawSize: We, drawId: ee, stages: Ct };
      }
    }
    if (u || p || l || m || f || h || y) {
      let H = !!p || c, Z = ((k = Ln({ afterRecoveryTimes: !!p, policyDefinitions: i, tournamentRecord: n, inContext: !0, contextProfile: s, participantMap: o, nextMatchUps: H, event: x })) == null ? void 0 : k.matchUps) ?? [];
      for (let ee of Z) {
        let { finishingPositionRange: te, potentialParticipants: ne, tieMatchUps: se = [], sides: ie = [], winningSide: he, matchUpType: Ee, matchUpId: de, eventId: it, drawId: qe, collectionId: ar, stageSequence: $t, finishingRound: Ue, matchUpStatus: Se, roundPosition: pe, roundNumber: We, structureId: Ge, schedule: nt, score: Ze, stage: st } = ee;
        v[de] = ee;
        let qt = { finishingPositionRange: te, finishingRound: Ue, stageSequence: $t, roundPosition: pe, collectionId: ar, roundNumber: We, structureId: Ge, schedule: nt, eventId: it, drawId: qe, score: Ze, stage: st };
        cS({ ...qt, ...D, matchUpStatus: Se, winningSide: he, matchUpType: Ee, matchUpId: de, sides: ie });
        for (let Ct of se) {
          let { winningSide: Mt, sides: Ye = [], matchUpId: He, matchUpStatus: rr, matchUpType: Je } = Ct;
          cS({ ...qt, ...D, winningSide: Mt, tieWinningSide: he, matchUpTieId: de, matchUpId: He, sides: Ye, matchUpSides: ie, matchUpStatus: rr, matchUpType: Je });
        }
        Array.isArray(ne) && (H || p || d) && ((F = ne.flat().map(Ce).filter(Boolean)) == null || F.forEach((Ct) => {
          var Mt;
          (Mt = S(Ct)) == null || Mt.forEach((Ye) => {
            o[Ye] && (o[Ye].potentialMatchUps[de] = me({ tournamentId: n == null ? void 0 : n.tournamentId, matchUpId: de, eventId: it, drawId: qe }));
          }), (p || d) && dT({ potential: !0, participantMap: o, participantId: Ct, matchUpStatus: Se, roundPosition: pe, structureId: Ge, matchUpType: Ee, roundNumber: We, matchUpId: de, schedule: nt, drawId: qe, score: Ze });
        }));
      }
      P.push(...Z);
    }
  }
  if (m || u || p) {
    let x = Object.values(o);
    for (let _ of x) {
      let { wins: B, losses: L, [rt]: { wins: G, losses: $ }, [tt]: { wins: W, losses: q } } = _.counters, K = (z, Y, X) => {
        let re = Y + X, Q = Y, H = re && Q / re;
        _.statistics[z] = { denominator: re, numerator: Q, statValue: H, statCode: z };
      };
      if (m && (K(Yd, B, L), K(`${Yd}.${rt}`, G, $), K(`${Yd}.${tt}`, W, q)), u) {
        let z = (Y = []) => Math.abs(Y[0] - Y[1]);
        for (let Y of Object.keys(_.draws)) {
          let { orderedStructureIds: X = [], flightNumber: re } = R[Y] || {};
          if (_.structureParticipation && X.length) {
            let Q, H = 0, Z = X.map((ee) => {
              let te = _.structureParticipation[ee];
              if (!te)
                return;
              Q || (Q = te == null ? void 0 : te.finishingPositionRange), z(Q) > z(te == null ? void 0 : te.finishingPositionRange) && (Q = te == null ? void 0 : te.finishingPositionRange);
              let ne = te.stage !== ge;
              return ne && (H += 1), me({ ...te, participationOrder: ne ? H : void 0, flightNumber: re });
            }).filter(Boolean);
            _.draws[Y] && (_.draws[Y].finishingPositionRange = Q, _.draws[Y].structureParticipation = Z);
          }
        }
      }
      if (p) {
        let z = Le(p) ? p.scheduledMinutesDifference : 0, Y = _.scheduleItems || [], X = _.potentialMatchUps || {}, re = Y.reduce((H, Z) => {
          let { scheduledDate: ee, scheduledTime: te } = Z;
          return H[ee] || (H[ee] = []), te && H[ee].push(Z), H;
        }, {});
        Object.values(re).forEach((H) => H.sort(tP));
        for (let H of Y) {
          let { typeChangeTimeAfterRecovery: Z, timeAfterRecovery: ee, scheduledDate: te, scheduledTime: ne } = H, se = re[te], ie = _e(ne);
          for (let he of se) {
            if (he.matchUpId === H.matchUpId || [Be, ke].includes(he.matchUpStatus) && !he.checkScoreHasValue)
              continue;
            let Ee = H.matchUpType !== he.matchUpType && Z || ee, de = H.drawId === he.drawId, it = X[H.matchUpId] && X[he.matchUpId], qe = _e(he.scheduledTime), ar = Math.abs(qe - ie), $t = qe >= ie;
            if ((z && !isNaN(z) ? ar <= z : $t && _e(he.scheduledTime) < _e(Ee)) && !(it && de) && $t) {
              let Ue = [H.matchUpId, he.matchUpId].sort(Lp).join("|");
              _.scheduleConflicts[Ue] = { priorScheduledMatchUpId: H.matchUpId, matchUpIdWithConflict: he.matchUpId };
            }
          }
        }
        let Q = _.participant.participantId;
        Object.keys(_.scheduleConflicts).length && w.push(Q), o[Q].scheduleConflicts = _.scheduleConflicts;
      }
    }
  }
  return { participantIdsWithConflicts: w, eventsPublishStatuses: b, derivedEventInfo: T, derivedDrawInfo: R, mappedMatchUps: v, participantMap: o, matchUps: P };
}
function ad({ participantFilters: e = {}, tournamentRecord: t, participants: r = [] }) {
  var S;
  if (!Object.keys(e).length)
    return r;
  let { accessorValues: i, drawEntryStatuses: n, positionedParticipants: a, eventEntryStatuses: o, participantRoles: s, participantRoleResponsibilities: c, participantTypes: u, participantIds: d, signInStatus: p, enableOrFiltering: l, eventIds: m, genders: f } = e, h = vn(m) && ((S = t == null ? void 0 : t.events) == null ? void 0 : S.filter((D) => m == null ? void 0 : m.includes(D.eventId))) || (t == null ? void 0 : t.events) || [], g = n && Pk({ drawEntryStatuses: n, tournamentEvents: h }), I = o && Dk({ eventEntryStatuses: o, tournamentEvents: h }), y = a !== void 0 && [!0, !1].includes(a) && h.reduce((D, w) => D.concat(...(w.drawDefinitions || []).map((v) => vD({ drawDefinition: v }).allPositionedParticipantIds).filter(Boolean)), []), U = (D) => i == null ? void 0 : i.reduce((w, v) => {
    let { accessor: P, value: b } = v, { values: T } = To({ element: D, accessor: P });
    return w && (T == null ? void 0 : T.includes(b));
  }, !0);
  if (r = r == null ? void 0 : r.filter((D) => {
    var E, C;
    let w = (C = (E = Pi({ element: D, itemType: ju })) == null ? void 0 : E.timeItem) == null ? void 0 : C.itemValue, { participantRoleResponsibilities: v, participantType: P, participantRole: b, participantId: T, person: R } = D, M = Array.isArray(f) && (f == null ? void 0 : f.length) && (R == null ? void 0 : R.sex) && f.includes(R.sex);
    return l ? f && M || a && y.includes(T) || a === !1 && !y.includes(T) || (g == null ? void 0 : g.includes(T)) || (I == null ? void 0 : I.includes(T)) || (d == null ? void 0 : d.includes(T)) || p && w === p || u && P && vn(u) && u.includes(P) || s && b && vn(s) && s.includes(b) || c && vn(v) && vn(c) && c.find((A) => v == null ? void 0 : v.includes(A)) || (i == null ? void 0 : i.length) && vn(i) && U(D) : (!f || M) && (a === void 0 || a && y.includes(T) || a === !1 && !y.includes(T)) && (!g || g.includes(T)) && (!I || I.includes(T)) && (!d || d.includes(T)) && (!p || w === p) && (!u || P && vn(u) && u.includes(P)) && (!s || b && vn(s) && s.includes(b)) && (!c || vn(v) && vn(c) && c.find((A) => v == null ? void 0 : v.includes(A))) && (!(i != null && i.length) || vn(i) && U(D));
  }), h.length && m) {
    let D = h.filter((w) => m.includes(w.eventId)).map((w) => {
      let v = (w.entries || []).map((b) => b.participantId);
      if (bt(dn)(w.eventType))
        return v;
      let P = ((t == null ? void 0 : t.participants) ?? []).filter((b) => v.includes(b.participantId)).map((b) => b.individualParticipantIds).flat(1);
      return v.concat(...P);
    }).flat(1);
    r = r == null ? void 0 : r.filter((w) => D.includes(w.participantId));
  }
  return r;
}
function vn(e) {
  return e && Array.isArray(e) && e.length;
}
function Pk({ drawEntryStatuses: e, tournamentEvents: t }) {
  let r = ({ entryStatus: i }) => Array.isArray(e) ? e.includes(i) : !0;
  return Te(t.reduce((i, n) => {
    var c, u;
    let { flightProfile: a } = Pt({ event: n }), o = ((c = a == null ? void 0 : a.flights) == null ? void 0 : c.map(({ drawEntries: d }) => Array.isArray(d) ? d.filter(r).map(Ce) : []).flat()) || [], s = ((u = n.drawDefinitions) == null ? void 0 : u.map(({ entries: d }) => d ? d.filter(r).map(Ce) : [])) || [];
    return i.concat(...o, ...s);
  }, []));
}
function Dk({ eventEntryStatuses: e, tournamentEvents: t }) {
  return Te(t.reduce((r, i) => {
    let n = (i.entries || []).filter(({ entryStatus: a }) => Array.isArray(e) ? e.includes(a) : !0).map(Ce);
    return r.concat(...n);
  }, []));
}
function Ut(e) {
  var G;
  let { withIndividualParticipants: t, participantFilters: r = {}, withPotentialMatchUps: i, withRankingProfile: n, convertExtensions: a, policyDefinitions: o, withScheduleItems: s, tournamentRecord: c, scheduleAnalysis: u, withSignInStatus: d, withTeamMatchUps: p, withScaleValues: l, usePublishState: m, contextProfile: f, withStatistics: h, withOpponents: g, withMatchUps: I, internalUse: y, withSeeding: U, withEvents: S, withDraws: D, withISO2: w, withIOC: v } = e;
  if (!c)
    return { error: ae };
  (I || n) && qi({ tournamentRecord: c });
  let P = kD({ convertExtensions: a, tournamentRecord: c, withSignInStatus: d, withScaleValues: l, internalUse: y, withISO2: w, withIOC: v }), { participantMap: b } = P, T = wk({ withMatchUps: I ?? n, withEvents: S ?? n, withDraws: D ?? n, withPotentialMatchUps: i, participantFilters: r, withRankingProfile: n, convertExtensions: a, withScheduleItems: s, policyDefinitions: o, tournamentRecord: c, scheduleAnalysis: u, withTeamMatchUps: p, usePublishState: m, withStatistics: h, participantMap: b, withOpponents: g, contextProfile: f, withSeeding: U }), { participantIdsWithConflicts: R, eventsPublishStatuses: M, derivedEventInfo: E, derivedDrawInfo: C, mappedMatchUps: A } = T, N = T.matchUps;
  b = T.participantMap;
  let O = u ?? i, k = ({ potentialMatchUps: $, scheduleConflicts: W, scheduleItems: q, participant: K, statistics: z, opponents: Y, matchUps: X, events: re, draws: Q }) => {
    let H = Object.values(Q), Z = Object.values(Y);
    return g && (H == null || H.forEach((ee) => {
      ee.opponents = Z.filter((te) => te.drawId === ee.drawId);
    })), me({ ...K, scheduleConflicts: u ? Object.values(W) : void 0, draws: D || n ? H : void 0, events: S || n ? Object.values(re) : void 0, matchUps: I || n ? Object.values(X) : void 0, opponents: g ? Z : void 0, potentialMatchUps: O ? Object.values($) : void 0, statistics: h ? Object.values(z) : void 0, scheduleItems: s ? q : void 0 }, !1, !1, !0);
  }, F = /* @__PURE__ */ new Map();
  for (let $ of Object.keys(b))
    F.set($, k(b[$]));
  let x = [...F.values()], _ = (G = o == null ? void 0 : o[mc]) == null ? void 0 : G.participant, B = ad({ participants: x, participantFilters: r, tournamentRecord: c });
  if (t) {
    let $ = Le(t) ? t : void 0;
    for (let W of B)
      for (let q of W.individualParticipantIds ?? []) {
        let K = b[W.participantId].participant;
        K != null && K.individualParticipants || (K.individualParticipants = []), W.individualParticipants || (W.individualParticipants = []);
        let z = F.get(q), Y = $ ? xo({ template: $, source: z }) : z;
        K != null && K.individualParticipants && K.individualParticipants.push(Y), W.individualParticipants.push(Y);
      }
  }
  let L = _ ? B.map(($) => xo({ source: $, template: _ })) : B;
  return { participantMap: e.returnParticipantMap !== !1 ? b : void 0, mappedMatchUps: e.returnMatchUps !== !1 ? A : void 0, matchUps: e.returnMatchUps !== !1 ? N : void 0, missingParticipantIds: P.missingParticipantIds, participantIdsWithConflicts: R, eventsPublishStatuses: M, derivedEventInfo: E, derivedDrawInfo: C, participants: L, ...V };
}
function bo({ participantId: e, drawDefinition: t, entryStatus: r, entryStage: i }) {
  var a;
  if (!t)
    return { error: le };
  let n = (a = t.entries) == null ? void 0 : a.find((o) => o.participantId === e && (!r || r === o.entryStatus) && (!i || i === o.entryStage));
  return e && n;
}
function yc(e) {
  var m, f, h, g, I, y, U, S, D;
  let { provisionalPositioning: t, drawDefinition: r, stageSequence: i, structureId: n, stage: a } = e;
  if (!r)
    return { error: le };
  let { entryProfile: o } = qu({ drawDefinition: r }), s = a && i && ((h = (f = (m = o == null ? void 0 : o[a]) == null ? void 0 : m.stageSequence) == null ? void 0 : f[i]) == null ? void 0 : h.qualifiersCount) || a && ((g = o == null ? void 0 : o[a]) == null ? void 0 : g.qualifiersCount) || 0, c = {};
  if (!n)
    return { qualifiersCount: s, roundQualifiersCounts: c };
  let { structure: u } = ve({ drawDefinition: r, structureId: n }), d = (I = r.links) == null ? void 0 : I.filter((w) => {
    var v;
    return ((v = w == null ? void 0 : w.target) == null ? void 0 : v.structureId) === (u == null ? void 0 : u.structureId);
  }), p = 0;
  if (d != null && d.length)
    for (let w of d) {
      let v = (y = ve({ structureId: w.source.structureId, drawDefinition: r })) == null ? void 0 : y.structure;
      if ((v == null ? void 0 : v.stage) === ge) {
        let P = w.source.roundNumber, b = w.target.roundNumber, T = 0;
        if (v.structureType === br) {
          let R = ((U = v.structures) == null ? void 0 : U.length) ?? 0, M = ((S = w.source.finishingPositions) == null ? void 0 : S.length) ?? 0;
          T = R * M;
        } else
          T = ((D = Ke({ matchUpFilters: { roundNumbers: [P] }, structure: v, afterRecoveryTimes: !1, provisionalPositioning: t, inContext: !1 }).matchUps) == null ? void 0 : D.length) || 0;
        c[b] || (c[b] = 0), c[b] += T, p += T;
      }
    }
  let l = Object.keys(c);
  if (l.length <= 1) {
    let w = l[0] || 1;
    c[w] = Math.max(c[w] || 0, s);
  }
  return p = Math.max(p, s), { qualifiersCount: p, roundQualifiersCounts: c };
}
function vl({ stage: e, drawDefinition: t }) {
  var i;
  let { entryProfile: r } = qu({ drawDefinition: t });
  return ((i = r == null ? void 0 : r[e]) == null ? void 0 : i.drawSize) || 0;
}
function Tk(e) {
  let { provisionalPositioning: t, drawDefinition: r, stageSequence: i, stage: n } = e, a = vl({ stage: n, drawDefinition: r }), { qualifiersCount: o } = yc({ provisionalPositioning: t, drawDefinition: r, stageSequence: i, stage: n });
  return a && a - o;
}
function lT({ stage: e, drawDefinition: t }) {
  return !!(e === Jt || Wg({ stage: e, drawDefinition: t }) && vl({ stage: e, drawDefinition: t }));
}
function pT({ entryStatus: e = $r, drawDefinition: t, stageSequence: r, stage: i }) {
  if (e === Fi)
    return IO({ stage: i, drawDefinition: t }) ? { positionsAvailable: 1 / 0, ...V } : { error: gw };
  let n = Tk({ drawDefinition: t, stageSequence: r, stage: i }), a = UO({ drawDefinition: t, stage: i }), o = Ff({ entryStatus: Hs, drawDefinition: t, stage: i }), s = Ff({ entryStatus: $r, drawDefinition: t, stage: i }), c = o + s, u = c >= n, d = n - c;
  return i !== Jt && u ? { error: Df } : e === Hs ? o < a ? { ...V } : { error: Df } : { positionsAvailable: d, ...V };
}
function rI(e) {
  let t = fe(e, [{ [Rr]: !0, [QP]: !0 }]);
  if (t.error)
    return t;
  let { suppressDuplicateEntries: r = !0, entryStatus: i = $r, entryStageSequence: n, entryStage: a = ue, ignoreStageSpace: o, drawDefinition: s, entryPosition: c, participant: u, roundTarget: d, extensions: p, extension: l, drawType: m, event: f } = e, h = "addDrawEntry";
  if (m !== si && !lT({ stage: a, drawDefinition: s }))
    return j({ result: { error: oo }, stack: h });
  let g = pT({ stageSequence: n, stage: a, drawDefinition: s, entryStatus: i });
  if (!o && !g.success && (!m || m !== si))
    return { error: g.error };
  if (l && !pn({ extension: l }))
    return j({ result: { error: J }, info: "Invalid extension", context: { extension: l }, stack: h });
  let I = e.participantId || (u == null ? void 0 : u.participantId);
  if (!I)
    return j({ result: { error: _t }, stack: h });
  let y = i === Qn && bo({ participantId: I, drawDefinition: s, entryStatus: i }), U = a === Jt && bo({ participantId: I, drawDefinition: s, entryStage: a }), S = bo({ participantId: I, drawDefinition: s }), D = i !== Qn && a !== Jt && S;
  if (D)
    return r ? (De({ payload: { drawId: s.drawId, eventId: f == null ? void 0 : f.eventId, error: zc, participantId: I }, topic: bg }), { ...V }) : j({ result: { error: zc }, context: { participantId: I }, stack: h });
  if (y || U)
    return j({ context: { invalidEntry: D, invalidLuckyLoser: y, invalidVoluntaryConsolation: U }, result: { error: Kl }, stack: h });
  let w = me({ entryStageSequence: n, participantId: I, entryPosition: c, entryStatus: i, entryStage: a, extensions: p });
  return l && Ve({ element: w, extension: l }), d && Ve({ extension: { name: "roundEntry", value: d }, element: w }), s.entries || (s.entries = []), s.entries.push(w), ut({ drawDefinition: s }), { ...V };
}
function bk(e) {
  let t = "addDrawEntries", { suppressDuplicateEntries: r = !0, entryStatus: i = $r, autoEntryPositions: n = !0, ignoreStageSpace: a, participantIds: o, drawDefinition: s, stageSequence: c, stage: u = ue, roundTarget: d, extension: p, event: l } = e;
  if (!u)
    return { error: Yv };
  if (!s)
    return { error: le };
  if (!Array.isArray(o))
    return { error: Yr };
  if (!lT({ stage: u, drawDefinition: s }))
    return { error: oo };
  if (p && !pn({ extension: p }))
    return j({ result: { error: J }, info: "Invalid extension", context: { extension: p }, stack: t });
  let m = pT({ drawDefinition: s, stageSequence: c, entryStatus: i, stage: u });
  if (!a && !m.success)
    return { error: m.error };
  let f = m.positionsAvailable ?? 0;
  if (!a && u !== Jt && f < o.length)
    return { error: Ch };
  let h = [], g = s.drawId, I = l == null ? void 0 : l.eventId, y = o.reduce((U, S) => {
    let D = i === Qn && bo({ participantId: S, drawDefinition: s, entryStatus: i }), w = u === Jt && bo({ entryStage: u, drawDefinition: s, participantId: S }), v = bo({ participantId: S, drawDefinition: s });
    return i !== Qn && u !== Jt && v && (h.push(S), r && De({ payload: { error: zc, participantId: S, eventId: I, drawId: g }, topic: bg })), D || w ? U.concat(S) : U;
  }, []);
  return h.length && !r ? j({ context: { eventId: I, drawId: g, duplicateEntries: h }, result: { error: zc }, stack: t }) : (o.filter((U) => U && !y.includes(U)).forEach((U) => {
    let S = { entryStageSequence: c, entryStage: u, participantId: U, entryStatus: i };
    p && Ve({ element: S, extension: p }), d && Ve({ extension: { name: In, value: d }, element: S }), s.entries || (s.entries = []), s.entries.push(S);
  }), n && (s.entries = Ki({ entries: s.entries })), ut({ drawDefinition: s }), y != null && y.length || h != null && h.length ? { info: "some participantIds could not be added", participantIdsNotAdded: y, duplicateEntries: h, ...V } : { ...V });
}
function iI({ suppressDuplicateEntries: e = !0, autoEntryPositions: t = !0, entryStageSequence: r, ignoreStageSpace: i, participantIds: n, drawDefinition: a, entryStatus: o, roundTarget: s, entryStage: c, extension: u, drawId: d, event: p }) {
  if (!(n != null && n.length))
    return { error: Da };
  if (!p)
    return { error: Ii };
  if (!d)
    return { error: tn };
  let l = (p.entries || []).map(Ce);
  if (n.filter((h) => !l.includes(h)).length)
    return { error: Hv };
  if (a) {
    let h = bk({ stageSequence: r, suppressDuplicateEntries: e, autoEntryPositions: t, stage: c, ignoreStageSpace: i, participantIds: n, drawDefinition: a, entryStatus: o, roundTarget: s, extension: u });
    if (h.error)
      return h;
  }
  let { flightProfile: m } = Pt({ event: p }), f = m == null ? void 0 : m.flights.find((h) => h.drawId === d);
  return f != null && f.drawEntries && (n.forEach((h) => {
    let g = o === Qn && Jm({ participantId: h, entryStatus: o, flight: f }), I = c === Jt && Jm({ participantId: h, entryStage: c, flight: f });
    !(o !== Qn && c !== Jt && Jm({ flight: f, participantId: h })) && !g && !I && f.drawEntries.push({ participantId: h, entryStatus: o, entryStage: c });
  }), t && (f.drawEntries = Ki({ entries: f.drawEntries }))), { ...V };
}
function Jm({ participantId: e, entryStatus: t, entryStage: r, flight: i }) {
  var a;
  let n = (a = i.drawEntries) == null ? void 0 : a.find((o) => o.participantId === e && (!t || t === o.entryStatus) && (!r || r === o.entryStage));
  return e && n;
}
function od({ autoEntryPositions: e = !0, participantIds: t = [], entryStatuses: r, stage: i, event: n }) {
  var p, l, m, f;
  let a = "removeEventEntries";
  if (!(n != null && n.eventId))
    return { error: pt };
  if (!Array.isArray(t) || t.some((h) => !ht(h)))
    return j({ result: { error: Ji }, stack: a });
  let o = (n.drawDefinitions ?? []).flatMap((h) => ho({ drawDefinition: h }).assignedParticipantIds ?? []), s = ((r == null ? void 0 : r.length) && ((p = n.entries) == null ? void 0 : p.filter((h) => h.entryStatus && r.includes(h.entryStatus))) || []).map(Ce).filter((h) => !o.includes(h)), c = (i && ((l = n.entries) == null ? void 0 : l.filter((h) => h.entryStage && h.entryStage === i)) || []).map(Ce).filter((h) => !o.includes(h));
  if (t.length ? t = t.filter((h) => (!(r != null && r.length) || s.includes(h)) && (!i || c.includes(h))) : s.length && c.length ? t = wt(s, c) : s.length ? t = s : c.length && (t = c), (t == null ? void 0 : t.length) && o.some((h) => t.includes(h)))
    return j({ result: { error: oc }, stack: a });
  if (!(t != null && t.length))
    return { ...V, participantIdsRemoved: [] };
  let u = [];
  n.entries = (n.entries ?? []).filter((h) => {
    let g = !t.includes(h == null ? void 0 : h.participantId);
    return g || u.push(h.participantId), g;
  }), e && (n.entries = Ki({ entries: n.entries }));
  let { flightProfile: d } = Pt({ event: n });
  return (m = d == null ? void 0 : d.flights) == null || m.forEach((h) => {
    h.drawEntries = (h.drawEntries || []).filter((g) => !t.includes(g.participantId));
  }), (f = n.drawDefinitions) == null || f.forEach((h) => {
    h.entries = (h.entries ?? []).filter((g) => !t.includes(g.participantId));
  }), { ...V, participantIdsRemoved: u };
}
var mT = { [Xt]: { policyName: "matchUpActionsDefault", enabledStructures: [{ stages: [], stageSequences: [], enabledActions: [], disabledActions: [] }], participants: { enforceCategory: !0, enforceGender: !0 }, processCodes: { substitution: ["RANKING.IGNORE", "RATING.IGNORE"] }, substituteAfterCompleted: !1, substituteWithoutScore: !1 } }, Sc = mT;
function sn(e) {
  var A, N;
  let { suppressDuplicateEntries: t = !0, entryStatus: r = $r, autoEntryPositions: i = !0, enforceGender: n = !0, entryStageSequence: a, policyDefinitions: o, entryStage: s = ue, tournamentRecord: c, ignoreStageSpace: u, drawDefinition: d, roundTarget: p, extensions: l, extension: m, drawId: f, event: h } = e, g = "addEventEntries";
  if (!Array.isArray(e.participantIds))
    return j({ result: { error: Yr }, stack: g });
  let I = Te(e.participantIds ?? []);
  if (!h)
    return { error: pt };
  if (!(I != null && I.length))
    return j({ result: { error: Da }, stack: g });
  if (!(h != null && h.eventId))
    return { error: Ii };
  let y = je({ tournamentRecord: c, event: h }).appliedPolicies ?? {}, U = (o == null ? void 0 : o[Xt]) ?? (y == null ? void 0 : y[Xt]) ?? Sc[Xt], S = (n ?? ((A = U == null ? void 0 : U.participants) == null ? void 0 : A.enforceGender)) !== !1, D = [], w = [];
  if (l && (!Array.isArray(l) || !l.every((O) => pn({ extension: O }))) || m && !pn({ extension: m }))
    return j({ context: me({ extension: m, extensions: l }), result: { error: J }, info: "Invalid extension(s)", stack: g });
  let v = !!c, P = [], b, T = ((N = c == null ? void 0 : c.participants) == null ? void 0 : N.filter((O) => {
    var x, _, B;
    if (!I.includes(O.participantId))
      return !1;
    let k = bt(rt)(h.eventType) && O.participantType === Oe && !La(r), F = h.eventType === tt && O.participantType === Re;
    return k && (!h.gender || !S || [Mr, Zi].includes(h.gender) || h.gender === ((x = O.person) == null ? void 0 : x.sex)) || F && !La(r) || h.eventType === tt && O.participantType === Oe && La(r) ? !0 : k && h.gender && S && ![Mr, Zi].includes(h.gender) && h.gender !== ((_ = O.person) == null ? void 0 : _.sex) ? (P.push({ participantId: O.participantId, sex: (B = O.person) == null ? void 0 : B.sex }), !1) : h.eventType === Xe && (O.participantType === Xe || La(r) && O.participantType === Oe);
  }).map((O) => O.participantId)) ?? [], R = I.filter((O) => !v || T.includes(O));
  h.entries || (h.entries = []);
  let M = h.entries.map((O) => {
    var k;
    return O.participantId || ((k = O.participant) == null ? void 0 : k.participantId);
  });
  if (R.forEach((O) => {
    var k;
    if (!M.includes(O)) {
      let F = me({ participantId: O, entryStatus: r, entryStage: s, extensions: l });
      m && Ve({ element: F, extension: m }), p && Ve({ extension: { name: In, value: p }, element: F }), a && (F.entryStageSequence = a), D.push(F.participantId), (k = h.entries) == null || k.push(F);
    }
  }), f && !La(s)) {
    let O = iI({ participantIds: R, suppressDuplicateEntries: t, autoEntryPositions: i, entryStageSequence: a, ignoreStageSpace: u, drawDefinition: d, entryStatus: r, roundTarget: p, entryStage: s, extension: m, drawId: f, event: h });
    O.error && (b = O.error);
  }
  if (h.eventType && [qn, Xr].includes(h.eventType)) {
    let O = (h.entries || []).map((_) => _.participantId), k = (h.entries || []).filter((_) => La(_.entryStatus)).map((_) => _.participantId), F = ((c == null ? void 0 : c.participants) ?? []).filter((_) => O.includes(_.participantId) && _.participantType && [Re, Xe].includes(_.participantType)).map((_) => _.individualParticipantIds).flat(1 / 0), x = k.filter((_) => F.includes(_));
    x.length && (w.push(...x), od({ participantIds: x, autoEntryPositions: !1, event: h }));
  }
  if (R.length !== I.length)
    return j({ context: { mismatchedGender: P, gender: h.gender }, result: { error: Yr }, stack: g });
  i && (h.entries = Ki({ entries: h.entries || [] }));
  let E = D.length, C = w.length;
  return j({ result: { ...V, addedEntriesCount: E, removedEntriesCount: C }, stack: g, info: b });
}
var fT = "ADMINISTRATION", Rk = "CAPTAIN", Mk = "COACH", ur = "COMPETITOR", hT = "MEDIA", gT = "MEDICAL", nI = "OFFICIAL", IT = "OTHER", UT = "SECURITY", aI = { ADMINISTRATION: fT, CAPTAIN: Rk, COACH: Mk, COMPETITOR: ur, MEDIA: hT, MEDICAL: gT, OFFICIAL: nI, OTHER: IT, SECURITY: UT };
function oI({ addIndividualParticipantsToEvents: e, individualParticipantIds: t, groupingParticipantId: r, tournamentRecord: i, suppressErrors: n }) {
  let a = "removeIndividualParticipantIds";
  if (!i)
    return j({ result: { error: ae }, stack: a });
  if (!r || !t)
    return j({ result: { error: Ie }, stack: a });
  let o = (i.participants ?? []).find((d) => d.participantId === r);
  if (!o)
    return j({ result: { error: Dt }, stack: a });
  if (![Xe, di].includes(o.participantType))
    return j({ result: { participantType: o.participantType, error: Xi }, stack: a });
  let s = yT({ individualParticipantIds: t, groupingParticipant: o, tournamentRecord: i, suppressErrors: n }), { removed: c, error: u } = s;
  if (u)
    return j({ result: s, stack: a });
  if (e)
    for (let d of i.events ?? []) {
      let p = (d.entries ?? []).map(({ participantId: l }) => l).filter(Boolean);
      if (p.includes(r)) {
        let l = c == null ? void 0 : c.filter((m) => !p.includes(m));
        sn({ participantIds: l, entryStatus: Di, tournamentRecord: i, event: d });
      }
    }
  return c && De({ topic: pr, payload: { tournamentId: i.tournamentId, participants: [o] } }), { ...V, ...s };
}
function yT({ individualParticipantIds: e = [], groupingParticipant: t, tournamentRecord: r, suppressErrors: i, mappedMatchUps: n, participants: a }) {
  var l, m;
  let o = [];
  if (!t)
    return { removed: o };
  let s = [], c = [];
  a || ({ participants: a, mappedMatchUps: n } = Ut({ withMatchUps: !0, tournamentRecord: r, withEvents: !0 }));
  let u = (m = (l = a == null ? void 0 : a.find(({ participantId: f }) => f === t.participantId)) == null ? void 0 : l.events) == null ? void 0 : m.map(({ eventId: f }) => f), d = (t.individualParticipantIds ?? []).filter((f) => {
    var y;
    let h = e == null ? void 0 : e.includes(f), g = h && ((y = a == null ? void 0 : a.find((U) => U.participantId === f)) == null ? void 0 : y.matchUps.filter(({ eventId: U }) => u.includes(U)).map(({ matchUpId: U }) => n == null ? void 0 : n[U]).filter(({ winningSide: U, score: S }) => U || jt({ score: S }))), I = h && !(g != null && g.length);
    if (h && !I && c.push(f), I) {
      o.push(f);
      for (let U of r.events ?? [])
        for (let S of U.drawDefinitions ?? []) {
          let { extension: D } = Ne({ element: S, name: Yn }), w = D == null ? void 0 : D.value[t.participantId];
          D && w && (D.value[t.participantId] = w.filter((P) => P.participantId !== f), Ve({ element: S, extension: D }), Vu({ drawDefinition: S }));
          let v = vr({ drawDefinition: S, inContext: !1 }).matchUps ?? [];
          for (let P of v) {
            let b = P.sides ?? [];
            for (let T of b) {
              let R = T.lineUp ?? [];
              R.find((M) => M.participantId === f) && (T.lineUp = R.filter((M) => M.participantId !== f), xe({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: S, matchUp: P }));
            }
          }
        }
    } else
      s.push(f);
    return !I;
  });
  t.individualParticipantIds = d;
  let p = { groupingParticipantId: t.participantId, cannotRemove: c, notRemoved: s, removed: o };
  return c.length && !i && { ...p, cannotRemove: c, error: zl } || p;
}
function _p({ participantRole: e = ur, individualParticipantIds: t = [], groupingTypes: r = [Nr, di], tournamentRecord: i }) {
  if (!i)
    return { error: ae };
  let n = i.participants ?? [], { participants: a, mappedMatchUps: o } = Ut({ withMatchUps: !0, tournamentRecord: i, withEvents: !0 }), s = 0;
  return n.filter((c) => (c.participantRole === e || !c.participantRole) && c.participantType && r.includes(c.participantType)).forEach((c) => {
    let { removed: u } = yT({ groupingParticipant: c, individualParticipantIds: t, tournamentRecord: i, mappedMatchUps: o, participants: a });
    u && s++;
  }), s ? V : { error: lw };
}
function ds(e) {
  var f, h;
  let t = fe(e, [{ [Gt]: !0 }, { participantIds: !0, [Or]: fr, [ki]: Da }]);
  if (t.error)
    return t;
  let { addIndividualParticipantsToEvents: r, tournamentRecord: i, participantIds: n } = e, a = ((f = i.participants) == null ? void 0 : f.length) || 0;
  if (!a)
    return { ...V };
  let o = (h = i.events || []) == null ? void 0 : h.filter(({ eventType: g }) => g === xt).map((g) => {
    var I;
    return (I = g == null ? void 0 : g.drawDefinitions) == null ? void 0 : I.map(({ drawId: y }) => y);
  }).flat(1 / 0), s = Ut({ participantFilters: { participantIds: n }, tournamentRecord: i, withDraws: !0 }).participants ?? [], c = (g) => {
    let I = (tr({ matchUpFilters: { drawIds: g, matchUpTypes: [tt] }, tournamentRecord: i }).matchUps ?? []).flatMap(({ sides: y }) => y == null ? void 0 : y.map(({ participantId: U }) => U || [])).filter(Boolean);
    return wt(I, n);
  }, u = o != null && o.length ? c(o) : [], d = s.filter((g) => {
    var I;
    return (I = g.draws) == null ? void 0 : I.filter((y) => (!(o != null && o.length) || !(o != null && o.includes(y.drawId))) && y.positionAssignments).length;
  });
  if (u != null && u.length || d.length)
    return { error: oc };
  let p = {}, l = {};
  for (let g of i.events || []) {
    let I = od({ participantIds: n, event: g });
    if (I.error)
      return I;
    p[g.eventId] = I.participantIdsRemoved;
  }
  i.participants = (i.participants ?? []).filter((g) => {
    var y, U;
    let I = n.includes(g.participantId) || g.participantType === Re && ((y = g.individualParticipantIds) == null ? void 0 : y.some((S) => n.includes(S)));
    if (!I && g.participantType === xt && ((U = g.individualParticipantIds) != null && U.some((S) => n.includes(S))) && (g.individualParticipantIds = g.individualParticipantIds.filter((S) => !n.includes(S))), I && r && g.participantType && [Re, Xe].includes(g.participantType))
      for (let S of g.individualParticipantIds || [])
        n.includes(S) || (l[g.participantId] || (l[g.participantId] = []), l[g.participantId].push(S));
    return !I;
  });
  let m = a - i.participants.length;
  if (_p({ individualParticipantIds: n, tournamentRecord: i }), r)
    for (let g of i.events || []) {
      let I = p[g.eventId].map((y) => l[y] || []).flat();
      sn({ participantIds: I, entryStatus: Di, tournamentRecord: i, event: g });
    }
  return m && De({ payload: { participantIds: n, tournamentId: i.tournamentId }, topic: Rg }), m ? { ...V, participantsRemovedCount: m } : { error: zl };
}
function ST({ selected: e = !0, drawDefinition: t, entryStatuses: r, drawId: i, event: n, stage: a }) {
  var c;
  let o = n.entries ?? [];
  if (i) {
    let { flightProfile: u } = Pt({ event: n }), d = (c = u == null ? void 0 : u.flights) == null ? void 0 : c.find((p) => p.drawId === i);
    d ? o = d.drawEntries : t.entries && (o = t == null ? void 0 : t.entries);
  }
  let s = o.filter((u) => (!(r != null && r.length) || !u.entryStatus || r.includes(u.entryStatus)) && (!a || !u.entryStage || u.entryStage === a) && (!e || u.entryStatus && $i.includes(u.entryStatus)));
  return { entries: o, stageEntries: s };
}
function vT({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, stage: a, event: o }) {
  var I;
  let s = "destroyGroupEntry";
  if (!t)
    return { error: ae };
  if (!i)
    return j({ result: { error: _t }, stack: s });
  if (!o)
    return { error: pt };
  if (!o.eventType || ![qn, Xr].includes(o.eventType))
    return j({ result: { error: Mn }, stack: s });
  let c = t.participants ?? [], u = c.find((y) => y.participantId === i);
  if (!u)
    return j({ result: { error: Dt }, stack: s });
  if (!u.participantType || ![Re, Nr].includes(u.participantType) || u.participantType === Nr && o.eventType !== Xr || u.participantType === Re && o.eventType !== qn)
    return { error: Xi };
  let d = (o.entries ?? []).find((y) => y.participantId === i);
  if (!d)
    return { error: hw };
  let { stageEntries: p } = ST({ selected: !1, drawDefinition: r, drawId: n, event: o, stage: a }), l = p.map(Ce), m = c.filter(({ participantId: y }) => l.includes(y)).map(({ individualParticipantIds: y }) => y).flat().filter(Boolean), f = (I = u.individualParticipantIds) == null ? void 0 : I.filter((y) => an(y, m).length === 1), h = od({ participantIds: [i], event: o });
  if (h.error || f != null && f.length && (h = sn({ participantIds: f, entryStatus: Di, entryStage: d.entryStage, tournamentRecord: t, drawDefinition: r, drawId: n, event: o }), h.error))
    return h;
  let g;
  return e && ds({ participantIds: [i], tournamentRecord: t }).success && (g = !0), { ...V, participantRemoved: g };
}
function sI({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, event: a }) {
  return vT({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, event: a });
}
function wT(e) {
  if (!e.tournamentRecord)
    return { error: ae };
  let { participantIds: t, ...r } = e, i = 0, n = [];
  for (let a of t) {
    let o = vT({ participantId: a, ...r });
    o.success && (i += 1), o.error && n.push(o.error);
  }
  return i ? { destroyedCount: i, ...V } : { error: n };
}
function pu(e) {
  let { tournamentRecord: t, replaceWithBye: r, drawDefinition: i, destroyPair: n, entryStatus: a, matchUpsMap: o, drawId: s } = e, c = "removeDrawPositionAssignment", u = id(e);
  if (u.error)
    return j({ result: u, stack: c });
  let { participantId: d } = u, { drawPosition: p, event: l, structureId: m } = e, f = je({ tournamentRecord: t, drawDefinition: i, event: l }).appliedPolicies ?? {};
  if ([Fi, On].includes(a) && d) {
    let { tournamentRecord: g } = e, { participant: I } = Aa({ tournamentRecord: g, participantId: d }), { participantType: y, individualParticipantIds: U } = I ?? {};
    if (n && y === Re) {
      let S = sI({ tournamentRecord: g, drawDefinition: i, participantId: d, event: l });
      if (S.error)
        return j({ result: S, stack: c });
      U && Sl({ participantIds: U, tournamentRecord: g, drawDefinition: i, entryStatus: a, drawId: s, event: l });
    } else
      Sl({ participantIds: [d], tournamentRecord: g, drawDefinition: i, entryStatus: a, drawId: s, event: l });
  }
  if (r) {
    let g = pi({ tournamentRecord: t, drawDefinition: i, drawPosition: p, structureId: m, matchUpsMap: o, event: l });
    if (g.error)
      return j({ result: g, stack: c });
  }
  let { structure: h } = ve({ drawDefinition: i, structureId: m });
  return _g({ structure: h, drawPositions: [p] }), bp({ appliedPolicies: f, drawDefinition: i, positionAction: { name: "removeDrawPositionAssignment", replaceWithBye: r, drawPosition: p, entryStatus: a, structureId: m } }), u;
}
function PT(e) {
  return Object.assign(e, { entryStatus: On }), pu(e);
}
function Gf(e) {
  return ht(e) ? e.split(" ").map((t) => t.split("").map((r, i) => i ? r.toLowerCase() : r.toUpperCase()).join("")).join(" ") : e;
}
function dr(e) {
  return ht(e) ? Gf(e.replace(/_/g, " ")) : "";
}
var ma = ({ finishingPosition: e = Jo, qualifyingRoundNumber: t, structureAbbreviation: r, seedAssignments: i = [], stageSequence: n = 1, structureOrder: a, seedingProfile: o, matchUpFormat: s, structureType: c, structureName: u, matchUpType: d, matchUps: p = [], structureId: l, roundOffset: m, roundLimit: f, stageOrder: h, structures: g, stage: I }) => {
  let y = { structureId: l ?? ze(), structureAbbreviation: r, finishingPosition: e, seedAssignments: i, matchUpFormat: s, stageSequence: n, structureName: u };
  a && (y.structureOrder = a), c && (y.structureType = c), o && (typeof o == "string" ? y.seedingProfile = o : typeof o == "object" && typeof o.positioning == "string" && (y.seedingProfile = o.positioning)), d && (y.matchUpType = d), m && (y.roundOffset = m), h && (y.stageOrder = h), f && (y.roundLimit = f), I && (y.stage = I), t && (y.qualifyingRoundNumber = t);
  let U = p.flatMap(({ drawPositions: S }) => S).filter(Boolean);
  return g ? y.structures = g : (y.matchUps = p, y.positionAssignments = Te(U).sort((S, D) => S - D).map((S) => ({ drawPosition: S }))), y;
}, gi = ma;
function cI({ structureName: e = dr(Jt), structureAbbreviation: t, drawDefinition: r, matchUpType: i, structureId: n }) {
  if (!r)
    return { error: le };
  let a = gi({ stage: Jt, structureAbbreviation: t, structureName: e, matchUps: [], structureId: n, matchUpType: i });
  return r.structures || (r.structures = []), r.structures.push(a), ut({ drawDefinition: r, structureIds: [a.structureId] }), { ...V };
}
function uI({ drawPositions: e }) {
  if (!(e != null && e.length))
    return { error: Du };
  let t = (n) => e.filter((a) => a !== n).map((a) => [n, a]), r = [].concat(...(e ?? []).map(t)), i = Te(r.map(Bp)).map((n) => n.split("|").map((a) => +a));
  return { groupMatchUps: r, uniqueMatchUpGroupings: i };
}
function Bp(e = []) {
  return !Array.isArray(e) || !e.length ? "" : [...e].sort(Ft).join("|");
}
function DT({ groupSize: e, drawPositionOffset: t }) {
  if (!e)
    return [];
  let r = (p) => [...Array(p)].map((l, m) => m), i = r(2 * Math.round(e / 2) + 1).slice(1), n = r(i.length - 1).map(() => []), a = i.slice(0, i.length / 2), o = i.slice(i.length / 2);
  i.slice(1).forEach((p, l) => {
    a.forEach((g, I) => {
      n[l].push([a[I], o[I]]);
    });
    let m = a.shift(), f = a.pop(), h = o.shift();
    a = [m, h, ...a].filter(Boolean), o = [...o, f].filter(Boolean);
  });
  let s = a.shift(), c = a.pop(), u = o.shift();
  a = [s, u, ...a].filter(Boolean), o = [...o, c].filter(Boolean);
  let d = (p) => p[0].reduce((l, m) => l + m);
  return [...n].reverse().sort((p, l) => d(p) - d(l)).map((p) => p.filter((l) => l.every((m) => m <= e)).map((l) => {
    let m = l.map((f) => f + t);
    return Bp(m);
  }));
}
function Nk({ rounds: e, hash: t }) {
  return e != null && e.length ? e == null ? void 0 : e.reduce((r, i, n) => i.includes(t) ? n + 1 : r, void 0) : { error: Ie };
}
var Ak = { getRoundRobinGroupMatchUps: uI, determineRoundNumber: Nk, drawPositionsHash: Bp, groupRounds: DT };
function sd(e) {
  var v;
  let { groupNameBase: t = "Group", playoffAttributes: r, stageSequence: i = 1, structureOptions: n, appliedPolicies: a, seedingProfile: o, stage: s = ue, matchUpType: c, roundTarget: u, structureId: d, groupNames: p, drawSize: l, idPrefix: m, isMock: f, uuids: h } = e, g = e.structureName ?? ((v = r == null ? void 0 : r["0"]) == null ? void 0 : v.name) ?? dr(ue), { groupCount: I, groupSize: y } = Ek({ structureOptions: n, appliedPolicies: a, drawSize: l }), U = Ha, S, D = oe(1, I + 1).map((P) => {
    let b = Ck({ groupSize: y, structureOrder: P, matchUpType: c, drawSize: l, idPrefix: m, isMock: f });
    S = Array.isArray(b) ? Math.max(...b.map(({ roundNumber: R }) => R ?? 0)) : 0;
    let T = (p == null ? void 0 : p[P - 1]) ?? `${t} ${P}`;
    return ma({ structureId: h == null ? void 0 : h.pop(), structureType: up, finishingPosition: U, structureOrder: P, structureName: T, matchUps: b });
  }), w = ma({ structureId: d ?? (h == null ? void 0 : h.pop()), structureType: br, finishingPosition: U, seedingProfile: o, structureName: g, stageSequence: i, structures: D, stage: s });
  return u && Ve({ extension: { name: In, value: u }, element: w }), { structures: [w], maxRoundNumber: S, groupCount: I, links: [], groupSize: y, ...V };
}
function Ek({ appliedPolicies: e, structureOptions: t, drawSize: r }) {
  let i = t == null ? void 0 : t.groupSize, n = (t == null ? void 0 : t.groupSizeLimit) || 8, { validGroupSizes: a } = cd({ groupSizeLimit: n, drawSize: r }), o = a && Math.max(...a);
  i && (a != null && a.includes(i)) || (i && i > 4 || !(a != null && a.includes(4)) ? i = o : i = 4);
  let s = Math.ceil(r / i);
  return { groupSize: i, groupCount: s };
}
function cd(e) {
  let { groupSizeLimit: t = 10, drawSize: r = 0 } = e ?? {}, i = oe(3, t + 1).filter((n) => {
    let a = Math.ceil(r / n), o = a * n - r, s = Math.ceil(r / a), c = Math.ceil(o / a);
    return (!o || o < n) && s === n && s >= 3 && c < 2;
  });
  return { ...V, validGroupSizes: i };
}
function Ck({ structureOrder: e, matchUpType: t, groupSize: r, drawSize: i, idPrefix: n, isMock: a, uuids: o }) {
  let s = (e - 1) * r, c = oe(1 + s, r + 1 + s), u = uI({ drawPositions: c }).uniqueMatchUpGroupings ?? [], d = DT({ groupSize: r, drawPositionOffset: s });
  return u.map(l).sort((m, f) => (m.roundNumber ?? 1 / 0) - (f.roundNumber ?? 1 / 0));
  function p(m) {
    return d.reduce((f, h, g) => h.includes(m) ? g + 1 : f, void 0);
  }
  function l(m) {
    let f = Bp(m), h = p(f), g = [1, i], I = Ok({ structureOrder: e, drawPositions: m, roundNumber: h, idPrefix: n, uuids: o }), y = { matchUpStatus: h ? Rt : $e, matchUpType: t, finishingPositionRange: { winner: g, loser: g }, drawPositions: m, roundNumber: h, matchUpId: I };
    return a && (y.isMock = !0), y;
  }
}
function Ok({ structureOrder: e, drawPositions: t, roundNumber: r, idPrefix: i, uuids: n }) {
  return i ? `${i}-${e}-${r}-DP-${t.join("-")}` : (n == null ? void 0 : n.pop()) || ze();
}
function dI(e) {
  let { roundRobinGroupsCount: t, participantsCount: r, cluster: i } = e;
  if (!Pe(r))
    return { seedBlocks: void 0, ...j({ result: { error: J }, context: { participantsCount: r }, stack: "getSeedBlocks" }) };
  let n = tc(r);
  if (t) {
    let m = Math.min(t, n), f = [], h = 1;
    for (oe(0, m).forEach(() => {
      f.push([h]), h++;
    }); h < n; ) {
      let g = oe(h, h + m);
      h += m, f.push(g);
    }
    return { ...V, seedBlocks: f };
  }
  let a = oe(1, n + 1), o = [], s = n / 2;
  for (; s > 1; ) {
    let m = zt(a, s), f = m.length;
    m.forEach((h, g) => {
      let I, y = g < f / 2, U = g % 2 === 0, S = h[0], D = h[h.length - 1];
      i && f > 4 ? f === 8 ? I = y ? D : S : I = U ? S : D : I = y ? S : D, wr(h, o) || o.push(I);
    }), s = s / 2;
  }
  let c = a.filter((m) => !o.includes(m));
  for (; c.length; )
    c.length % 2 === 0 ? o.push(c.pop()) : o.push(c.shift());
  let u = oe(0, 20).map((m) => Math.pow(2, m));
  u.unshift(1);
  let d = u.indexOf(n), p = 0, l = [];
  return oe(0, d).forEach((m) => {
    l.push(o.slice(p, p + u[m])), p += u[m];
  }), { ...V, seedBlocks: l };
}
function lI({ roundRobinGroupsCount: e, drawSize: t }) {
  let r = "getSeedGroups";
  if (!Pe(t))
    return { seedGroups: void 0, ...j({ result: { error: J }, context: { drawSize: t }, stack: r }) };
  if (e) {
    if (!Pe(e))
      return { seedGroups: void 0, ...j({ context: { roundRobinGroupsCount: e }, result: { error: J }, stack: r }) };
    let i = 1, n = Math.floor(t / e);
    return { seedGroups: oe(0, n).map(() => {
      let a = oe(i, i + e);
      return i += e, a;
    }) };
  } else {
    let { seedBlocks: i } = dI({ participantsCount: t, roundRobinGroupsCount: e }), n = 0;
    return { seedGroups: (i || []).map((a) => (a || []).map(() => (n += 1, n))) };
  }
}
function pI({ roundRobinGroupsCount: e, participantsCount: t }) {
  var n;
  if (e) {
    let { validGroupSizes: a } = cd({ drawSize: t });
    if (!((n = a == null ? void 0 : a.map((o) => Math.ceil(t / o))) != null && n.includes(e)))
      return j({ context: { roundRobinGroupsCount: e }, result: { error: J } });
  }
  let { seedGroups: r } = lI({ drawSize: t, roundRobinGroupsCount: e }), i = (r == null ? void 0 : r.map((a) => Math.min(...a))) || [];
  return { ...V, seedingThresholds: i };
}
function Ys(e) {
  if (!e)
    return 1 / 0;
  if (Pe(e))
    return ye(e);
  let t = e.split("-")[0];
  return Pe(t) ? ye(t) : 1 / 0;
}
function kk({ size: e }) {
  let t = [e], r = e;
  for (; r / 2 === Math.floor(r / 2); )
    r = r / 2, t.push(r);
  return t.includes(1) || t.push(1), t.sort(Ft), t.reverse(), t;
}
function Fk({ blockPattern: e, index: t }) {
  let r = 0;
  for (let i of e) {
    if (r === t)
      return i;
    let n = 0;
    for (; n < i.length; ) {
      if (r === t)
        return i;
      r += 1, n++;
    }
  }
}
function xk({ positioning: e, size: t }) {
  let r = kk({ size: t }), i = [], n = [], a = (l) => l[0], o = (l) => l[l.length - 1], s = (l, m) => (e && [cp, qa].includes(e) && m % 2 ? o(l) : a(l)) || a(l), c = (l, m) => {
    if (l.every((f) => !n.includes(f))) {
      let f = s(l, m);
      return n.push(f), f;
    }
  }, u = (l) => {
    let m = l.filter((f) => !n.includes(f));
    if (m.length)
      return n.push(...m), m;
  }, d = (l, m) => {
    let f = s(l, m);
    if (!n.includes(f))
      return n.push(f), f;
  }, p = oe(1, t + 1);
  for (let l of r)
    if (l === 1) {
      let m = zt(p, 2), f = m.map(c).filter(Boolean);
      f.length && i.push(f);
      let h = m.flatMap(u).filter(Boolean);
      h.length && i.push(h);
    } else {
      let m = zt(p, l).map(d).filter(Boolean);
      m.length && i.push(m);
    }
  return { divisions: r, divisionGroupings: i };
}
function ls({ provisionalPositioning: e, returnAllProxies: t, appliedPolicies: r, seedingProfile: i, drawDefinition: n, allPositions: a, structure: o }) {
  var N;
  let s = [];
  if (!o)
    return { error: ao };
  let { matchUps: c, roundMatchUps: u } = Ke({ matchUpFilters: { roundNumbers: [1] }, provisionalPositioning: e, structure: o }), { seedAssignments: d } = Si({ provisionalPositioning: e, returnAllProxies: t, drawDefinition: n, structure: o }), { positionAssignments: p } = Yt({ structure: o }), l = p == null ? void 0 : p.length, m = (d == null ? void 0 : d.length) ?? 0, f = [], h = Object.keys(u).map((O) => parseInt(O)).sort((O, k) => O - k).map((O) => {
    let k = u[O].map((x) => x.drawPositions).flat(1 / 0).filter(Boolean), F = k.filter((x) => !f.includes(x));
    return f = f.concat(...k), F;
  }).filter((O) => O.length).reverse(), g = h.pop() ?? [], I = g && Math.min(...g) - 1 || 0;
  i = i ?? ((N = r == null ? void 0 : r.seeding) == null ? void 0 : N.seedingProfile);
  let y = (g == null ? void 0 : g.length) || 0, U = h.filter((O) => O.filter((k) => k <= m).length), { stage: S, structureType: D, roundLimit: w } = o, v = D === br, P = !v && (h == null ? void 0 : h.length), b = !v && S === ge && w, T = U.flat(1 / 0), R = P ? T == null ? void 0 : T.length : 0, M = a ? l : m, E = Hg({ drawDefinition: n, structure: o, matchUps: c }), C = E ? 0 : !P && M || M && T.length < M && M - T.length || 0;
  if (b) {
    let O = o != null && o.matchUps ? o.matchUps.filter(({ roundNumber: F }) => F === o.roundLimit).length : 0, k = g.length / O;
    if (!P) {
      let F = ud(i), x = zt(g, k), _ = 1, B = oe(0, x[0].length).map(() => {
        let L = oe(_, _ + x.length);
        return _ += x.length, L;
      });
      ({ validSeedBlocks: s } = TT({ drawPositionBlocks: x, nonRandom: i == null ? void 0 : i.nonRandom, positioning: F, seedGroups: B }));
    }
  } else
    v ? { validSeedBlocks: s } = Lk({ nonRandom: i == null ? void 0 : i.nonRandom, seedingProfile: i, structure: o }) : P ? s = U.map((O) => ({ seedNumbers: O, drawPositions: O })) : E && zt(g, 2).map((O, k) => ({ drawPositions: [O[0]], seedNumbers: [k + 1] })).forEach((O) => s.push(O));
  if (!v && !E && !b) {
    let { blocks: O } = _k({ drawPositionOffset: I, seedNumberOffset: R, seedCountGoal: C, seedingProfile: i, baseDrawSize: y });
    O.forEach((k) => s.push(k));
  }
  let A = s.flatMap((O) => O.drawPositions).reduce((O, k) => (g == null ? void 0 : g.includes(k)) && O, !0);
  return !E && !P && !v && !A ? { error: Gv, validSeedBlocks: [], isContainer: v, isFeedIn: P } : { isLuckyStructure: E, validSeedBlocks: s, isContainer: v, isFeedIn: P };
}
function Lk({ seedingProfile: e, structure: t, nonRandom: r }) {
  var d;
  let i = t.structures || [], n = i.length, a = (d = ot({ structure: t })) == null ? void 0 : d.positionAssignments, o = ud(e), s = (a == null ? void 0 : a.length) ?? 0, { seedGroups: c } = lI({ roundRobinGroupsCount: n, drawSize: s }), u = i.map((p) => {
    var l;
    return (l = ot({ structure: p }).positionAssignments) == null ? void 0 : l.map((m) => m.drawPosition);
  });
  return TT({ drawPositionBlocks: u, positioning: o, seedGroups: c, nonRandom: r });
}
function TT({ drawPositionBlocks: e, positioning: t, seedGroups: r, nonRandom: i }) {
  let n = [], { divisionGroupings: a } = xk({ size: r.length, positioning: t }), o = [];
  return r.forEach((s, c) => {
    let u = Fk({ blockPattern: a, index: c });
    s.forEach((d, p) => {
      let l = c % 2 ? e.length - p - 1 : p, m = e[l].slice().filter((h, g) => u.includes(g + 1) && h);
      t !== qa ? m = i ? m : yr(m) : c % 2 && m.reverse();
      let f = m.find((h) => !o.includes(h));
      f && (o.push(f), n.push({ drawPositions: [f], seedNumbers: [d] }));
    });
  }), { validSeedBlocks: n };
}
function _k(e) {
  let { drawPositionOffset: t = 0, roundRobinGroupsCount: r, seedNumberOffset: i = 0, seedingProfile: n, seedCountGoal: a, baseDrawSize: o } = e, s = 1, c = [], { seedBlocks: u } = dI({ cluster: ud(n) === cp, participantsCount: o, roundRobinGroupsCount: r });
  s = 0;
  for (let p of u) {
    if (s + 1 > a)
      break;
    let l = p.map((f) => f + t), m = d(s + 1, p.length).map((f) => +f + i);
    s += p.length, c.push({ drawPositions: l, seedNumbers: m });
  }
  return { blocks: c };
  function d(p, l) {
    return Array.from(new Array(l), (m, f) => f + p);
  }
}
function wl({ appliedPolicies: e, drawDefinition: t, seedBlockInfo: r, drawPosition: i, structureId: n, seedNumber: a }) {
  var c, u, d, p, l, m;
  let { structure: o } = ve({ drawDefinition: t, structureId: n });
  e || (e = je({ drawDefinition: t }).appliedPolicies);
  let s = r == null ? void 0 : r.validSeedBlocks;
  return !s && o && (s = (c = ls({ appliedPolicies: e, drawDefinition: t, structure: o })) == null ? void 0 : c.validSeedBlocks), (d = (u = e == null ? void 0 : e.seeding) == null ? void 0 : u.validSeedPositions) != null && d.ignore ? !0 : (l = (p = e == null ? void 0 : e.seeding) == null ? void 0 : p.validSeedPositions) != null && l.strict ? (((m = s.find((f) => f.seedNumbers.includes(a))) == null ? void 0 : m.drawPositions) || []).includes(i) : [].concat(...s.map((f) => f.drawPositions)).includes(i);
}
function bT(e) {
  var M, E, C;
  let { provisionalPositioning: t, drawDefinition: r, seedingProfile: i, seedBlockInfo: n, structureId: a, randomize: o } = e, { structure: s } = ve({ drawDefinition: r, structureId: a }), { seedAssignments: c } = Si({ returnAllProxies: e.returnAllProxies, provisionalPositioning: t, drawDefinition: r, structure: s }), { positionAssignments: u } = Yt({ structure: s }), d = (M = u == null ? void 0 : u.filter((A) => A.participantId ?? A.bye ?? A.qualifier)) == null ? void 0 : M.map((A) => A.drawPosition).filter(Boolean), { appliedPolicies: p } = je({ drawDefinition: r }), l = ((n == null ? void 0 : n.validSeedBlocks) || s && ((E = ls({ returnAllProxies: e.returnAllProxies, provisionalPositioning: t, appliedPolicies: p, drawDefinition: r, seedingProfile: i, structure: s })) == null ? void 0 : E.validSeedBlocks) || []).filter((A) => A.drawPositions.filter((N) => !(d != null && d.includes(N))).length)[0], m = c == null ? void 0 : c.map((A) => A.participantId).filter(Boolean), f = u == null ? void 0 : u.map((A) => A.participantId).filter(Boolean), h = m == null ? void 0 : m.filter((A) => f == null ? void 0 : f.includes(A)), g = m == null ? void 0 : m.filter((A) => !(f != null && f.includes(A))), I = c == null ? void 0 : c.filter((A) => g == null ? void 0 : g.includes(A.participantId)), y = c == null ? void 0 : c.filter((A) => !A.participantId), U = (I != null && I.length && I.length > 0 ? I.length : (y == null ? void 0 : y.length) ?? 0) && (l == null ? void 0 : l.drawPositions.filter((A) => !(d != null && d.includes(A)))) || [], S = o ? yr(U) : U, D = [], w = S.map(() => {
    var N;
    let A = (N = R(I, D)) == null ? void 0 : N.participantId;
    return A && D.push(A), A;
  }).filter(Boolean), v = c == null ? void 0 : c.filter((A) => h == null ? void 0 : h.includes(A.participantId)).map((A) => A.seedNumber), P = ((l == null ? void 0 : l.seedNumbers) || []).filter((A) => !(v != null && v.includes(A))), b = c == null ? void 0 : c.filter((A) => P.includes(A.seedNumber)).map((A) => A.participantId), T = (C = p == null ? void 0 : p.seeding) == null ? void 0 : C.duplicateSeedNumbers;
  return { nextSeedBlock: l, unplacedSeedParticipantIds: T === void 0 || T ? w : b, unplacedSeedNumbers: P, unfilledPositions: S, unplacedSeedAssignments: I };
  function R(A, N) {
    let O = A.filter((x) => !N.includes(x.participantId)), k = Math.min(...O.map((x) => Ys(x.seedValue))), F = O.filter((x) => Ys(x.seedValue) === k);
    return yr(F).pop();
  }
}
function ud(e) {
  if (typeof e == "string")
    return e;
  if (typeof e == "object")
    return e.positioning;
}
function vc({ provisionalPositioning: e, tournamentRecord: t, drawDefinition: r, seedingProfile: i, participantId: n, seedBlockInfo: a, structureId: o, seedNumber: s, seedValue: c, eventId: u, event: d }) {
  var D, w, v;
  let p = "assignSeed", { structure: l } = ve({ drawDefinition: r, structureId: o }), { positionAssignments: m } = Yt({ structure: l }), f = Si({ provisionalPositioning: e, drawDefinition: r, structure: l }).seedAssignments, h = f.map((P) => P.seedNumber), g = bo({ drawDefinition: r, participantId: n });
  if (n && !g)
    return j({ result: { error: Ji }, context: { participantId: n }, stack: p });
  let I = d ? (w = (D = Pt({ event: d }).flightProfile) == null ? void 0 : D.flights) == null ? void 0 : w.length : 0, y = I && I > 1, U = (v = m == null ? void 0 : m.find((P) => P.participantId === n)) == null ? void 0 : v.drawPosition;
  if (U && !wl({ drawPosition: U, drawDefinition: r, seedBlockInfo: a, structureId: o, seedNumber: s }))
    return j({ result: { error: Uh }, context: { assignedDrawPosition: U }, info: "invalid seed position", stack: p });
  h.includes(s) || f.push({ seedNumber: s, seedValue: c });
  let S;
  return f.forEach((P) => {
    P.participantId === n && P.seedNumber !== s && (P.participantId = void 0), P.seedNumber === s && (P.participantId = n, !(i != null && i.groupSeedingThreshold) && !y && (P.seedValue = c ?? s), S = !0);
  }), S ? (MD({ tournamentId: t == null ? void 0 : t.tournamentId, drawDefinition: r, structure: l, eventId: u }), { ...V }) : j({ result: { error: jv }, stack: p });
}
function mI({ inContextTargetMatchUp: e, drawPositionSideIndex: t, teamParticipantId: r, tournamentRecord: i, drawDefinition: n, matchUp: a, event: o }) {
  var l, m, f, h;
  let s = (m = (l = e == null ? void 0 : e.sides) == null ? void 0 : l[t]) == null ? void 0 : m.sideNumber, c = s && ((f = a.sides) == null ? void 0 : f.find((g) => g.sideNumber === s)), { extension: u } = Ne({ element: n, name: Yn }), d = (u == null ? void 0 : u.value) || {}, p = ce(d[r], !1, !0);
  if (c)
    (h = a == null ? void 0 : a.sides) == null || h.forEach((g) => {
      g.sideNumber === s && (g.lineUp = p);
    });
  else {
    a.sides = [1, 2].map((I) => {
      var y;
      return { ...((y = a.sides) == null ? void 0 : y.find((U) => U.sideNumber === I)) ?? {}, sideNumber: I };
    });
    let g = a.sides.find((I) => I.sideNumber === s);
    g && (g.lineUp = p);
  }
  xe({ tournamentId: i == null ? void 0 : i.tournamentId, context: "updateSidLineUp", eventId: o == null ? void 0 : o.eventId, drawDefinition: n, matchUp: a });
}
function RT(e) {
  let { sourceMatchUp: t } = e, { targetMatchUp: r, structure: i, matchUpsMap: n, drawPosition: a } = e, o = r.roundNumber > 1 && r.roundNumber - 1, s = Ka({ structureId: i.structureId, matchUpsMap: n });
  !t && a && (t = s.find(({ drawPositions: f, roundNumber: h }) => h === o && (f == null ? void 0 : f.includes(a))));
  let c = t == null ? void 0 : t.roundPosition, u = c % 2 ? 1 : -1, d = c + u, p = o && s.find(({ roundNumber: f, roundPosition: h }) => f === o && h === d), l = p == null ? void 0 : p.matchUpStatus, m = [Et, Lt].includes(l);
  return { pairedPreviousMatchUp: p, pairedPreviousMatchUpIsDoubleExit: m };
}
function Bk({ drawPosition: e, drawPositions: t }) {
  let r = !1, i = !!(t != null && t.includes(e));
  return { updatedDrawPositions: i ? t || [] : [...t, void 0, void 0].slice(0, 2).map((n) => !n && !i ? (i = !0, r = !0, e) : n).sort(Ft).filter(Boolean), positionAdded: r, positionAssigned: i };
}
function MT({ structureId: e, matchUpsMap: t, matchUp: r }) {
  let i = r == null ? void 0 : r.roundPosition, n = i % 2 ? 1 : -1, a = i + n;
  return { pairedPreviousMatchUp: Ka({ matchUpsMap: t, structureId: e }).find(({ roundNumber: o, roundPosition: s }) => o === (r == null ? void 0 : r.roundNumber) && s === a) };
}
function NT({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, sourceMatchUpId: r, matchUpsMap: i, matchUp: n }) {
  let a = e.find((s) => s.matchUpId === r), { pairedPreviousMatchUp: o } = MT({ structureId: a == null ? void 0 : a.structureId, matchUp: a, matchUpsMap: i });
  if (a && o) {
    let s = o == null ? void 0 : o.matchUpId, c = e.find((d) => d.matchUpId === s), u = (a == null ? void 0 : a.structureId) === (c == null ? void 0 : c.structureId) ? (a == null ? void 0 : a.roundPosition) < (c == null ? void 0 : c.roundPosition) && 1 || 2 : a.structureId === (c == null ? void 0 : c.structureId) && 2 || 1;
    n.matchUpStatusCodes = (n.matchUpStatusCodes ?? []).map((d) => {
      let p = ht(d) || !isNaN(d) ? { code: d } : d;
      return p.sideNumber === u ? { ...p, previousMatchUpStatus: t } : p;
    });
  }
}
function Xd({ inContextDrawMatchUps: e, drawPosition: t, matchUpId: r }) {
  let i = e.filter(({ winnerMatchUpId: n, loserMatchUpId: a }) => a === r || n === r).sort((n, a) => n.roundPosition - a.roundPosition);
  return e.find((n) => n.matchUpId === r).feedRound ? 1 : i.reduce((n, a, o) => {
    var s;
    return (s = a.drawPositions) != null && s.includes(t) ? o + 1 : n;
  }, void 0);
}
function Ks({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, tournamentRecord: r, sourceMatchUpId: i, drawDefinition: n, matchUpStatus: a, drawPosition: o, matchUpsMap: s, matchUpId: c, event: u }) {
  var M, E, C, A;
  let d = "assignMatchUpDrawPosition";
  s || (s = mr({ drawDefinition: n })), e || (e = Bt({ inContext: !0, drawDefinition: n, matchUpsMap: s }).matchUps ?? []);
  let p = e.find((N) => N.matchUpId === c), l = p == null ? void 0 : p.structureId, m = (M = n == null ? void 0 : n.structures) == null ? void 0 : M.find((N) => N.structureId === l);
  if (!m)
    return { error: It };
  let f = (E = s == null ? void 0 : s.drawMatchUps) == null ? void 0 : E.find((N) => N.matchUpId === c), h = (f == null ? void 0 : f.drawPositions) ?? [], { positionAdded: g, positionAssigned: I, updatedDrawPositions: y } = Bk({ drawPositions: h, drawPosition: o }), { positionAssignments: U } = ot({ drawDefinition: n, structure: m }), S = (C = U == null ? void 0 : U.filter((N) => y.includes(N.drawPosition))) == null ? void 0 : C.find(({ bye: N }) => N), D = (f == null ? void 0 : f.matchUpStatus) && [Be, ke].includes(f.matchUpStatus) && y.filter(Boolean).length < 2;
  if (a = S && $e || a || D && f.matchUpStatus || (f == null ? void 0 : f.matchUpStatus) && [Et, Lt].includes(f.matchUpStatus) && f.matchUpStatus || Rt, f && g) {
    e = Bt({ inContext: !0, drawDefinition: n, matchUpsMap: s }).matchUps ?? [];
    let N = D && Xd({ inContextDrawMatchUps: e, drawPosition: o, matchUpId: c }) || void 0;
    f != null && f.matchUpStatusCodes && NT({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, sourceMatchUpId: i, matchUpsMap: s, matchUp: f }), Object.assign(f, { drawPositions: y, winningSide: N, matchUpStatus: a }), xe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: p == null ? void 0 : p.eventId, context: d, drawDefinition: n, matchUp: f });
  }
  let w = Dr({ inContextDrawMatchUps: e, inContextMatchUp: p, drawDefinition: n, matchUpId: c }), { targetMatchUps: { winnerMatchUp: v, loserMatchUp: P, loserTargetDrawPosition: b }, targetLinks: { loserTargetLink: T } } = w, R = Ka({ structureId: m.structureId, matchUpsMap: s });
  if (I && S) {
    if (v)
      if ([$e, Et, Lt].includes(a)) {
        let N = Ks({ matchUpId: v.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
        if (N.error)
          return N;
      } else {
        let { structureId: N } = v;
        N !== m.structureId && console.log("winnerMatchUp in different structure... participant is in different targetDrawPosition");
      }
  } else if (v && p && !p.feedRound) {
    let { pairedPreviousMatchUpIsDoubleExit: N } = RT({ targetMatchUp: f, drawPosition: o, matchUpsMap: s, structure: m });
    if (N) {
      let O = Ks({ matchUpId: v.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
      if (O.error)
        return O;
    }
  }
  if ((f == null ? void 0 : f.matchUpType) === lt) {
    let N = e == null ? void 0 : e.find(({ matchUpId: F }) => F === f.matchUpId), O = ((N == null ? void 0 : N.sides) ?? []).reduce((F, x, _) => x.drawPosition === o ? _ : F, void 0), k = (A = U == null ? void 0 : U.find((F) => F.drawPosition === o)) == null ? void 0 : A.participantId;
    k && O !== void 0 && mI({ inContextTargetMatchUp: N, drawPositionSideIndex: O, teamParticipantId: k, tournamentRecord: r, drawDefinition: n, matchUp: f });
  }
  if ((T == null ? void 0 : T.linkCondition) === ln && y.filter(Boolean).length === 2 && !S && R.filter(({ drawPositions: N, roundNumber: O }) => O === 1 && wr(N, y)).every(({ matchUpStatus: N }) => [Tt, nr].includes(N)) && P) {
    let { structureId: N } = P, O = pi({ drawPosition: b, tournamentRecord: r, drawDefinition: n, structureId: N, matchUpsMap: s, event: u });
    if (O.error)
      return O;
  }
  return I ? { ...V } : j({ result: { error: Os }, context: { drawPosition: o }, stack: d });
}
function AT({ inContextDrawMatchUps: e, drawDefinition: t, assignments: r, matchUpsMap: i, structure: n }) {
  var d, p, l, m;
  let a = ((l = (p = (d = gc({ drawDefinition: t })) == null ? void 0 : d.containedStructures) == null ? void 0 : p[n.structureId]) == null ? void 0 : l.map(({ structureId: f }) => f)) || [];
  a.push(n == null ? void 0 : n.structureId);
  let o = (r == null ? void 0 : r.map(({ drawPosition: f }) => f)) || [], s = (e == null ? void 0 : e.filter((f) => a.includes(f.structureId) && wt(f.drawPositions ?? [], o).length)) ?? [], c = s.map(({ matchUpId: f }) => f), u = ((m = i == null ? void 0 : i.drawMatchUps) == null ? void 0 : m.filter((f) => c.includes(f.matchUpId))) ?? [];
  return { drawPositions: o, matchUps: u, targetMatchUps: s };
}
function fI({ lineUp: e }) {
  if (!Array.isArray(e))
    return;
  let t = {};
  return Te(e.flatMap(({ collectionAssignments: r }) => r == null ? void 0 : r.map(({ collectionId: i, collectionPosition: n }) => [i, n].join("|"))).filter(Boolean)).forEach((r) => {
    let [i, n] = r.split("|"), a = parseInt(n), { assignedParticipantIds: o } = Ul({ collectionPosition: a, collectionId: i, lineUp: e });
    o.forEach((s) => {
      t[s] || (t[s] = []), t[s].push({ collectionId: i, collectionPosition: a });
    });
  }), Object.keys(t).map((r) => ({ participantId: r, collectionAssignments: t[r] }));
}
function Xa(e) {
  return `${e} must be an array`;
}
function Vp({ lineUp: e, tieFormat: t }) {
  let r = [];
  if (!Array.isArray(e))
    return r.push(Xa("lineUp")), { valid: !1, errors: r, error: J };
  let i = e.every((a) => {
    if (typeof a != "object")
      return r.push("lineUp entries must be objects"), !1;
    let { participantId: o, collectionAssignments: s } = a;
    return o ? typeof o != "string" ? (r.push("participantIds must be strings"), !1) : Array.isArray(s) ? s.every((c) => {
      if (typeof c != "object")
        return r.push("collectionAssignments must be objects"), !1;
      let { collectionPosition: u } = c;
      return typeof u != "number" ? (r.push("collectionPosition must be a number"), !1) : !0;
    }) : (r.push(Xa("collectionAssignments")), !1) : (r.push("Missing participantId"), !1);
  }), n = Te(e.map(Ce)).length === e.length;
  return n || r.push("Duplicated participantId(s)"), { valid: i && n, errors: r, error: r.length ? J : void 0 };
}
function ps({ drawDefinition: e, participantId: t, tieFormat: r, lineUp: i }) {
  if (typeof e != "object")
    return { error: le };
  if (typeof t != "string")
    return { error: _t };
  let n = Vp({ lineUp: i, tieFormat: r });
  if (!n.valid)
    return n;
  let { extension: a } = Ne({ element: e, name: Yn }), o = (a == null ? void 0 : a.value) || {};
  return o[t] = fI({ lineUp: i }), Ve({ element: e, extension: { name: Yn, value: o } }), Vu({ drawDefinition: e }), { ...V };
}
function hI({ inContextDrawMatchUps: e, inheritance: t = !0, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, assignments: a, structure: o, event: s }) {
  if (!i)
    return { error: le };
  let { drawPositions: c, matchUps: u, targetMatchUps: d } = AT({ inContextDrawMatchUps: e, matchUpsMap: n, assignments: a, structure: o });
  for (let p of d)
    p.matchUpType === ni && (p.sides ?? []).forEach((l, m) => {
      var f;
      if (l != null && l.drawPosition && (c != null && c.includes(l.drawPosition))) {
        let h = u.find(({ matchUpId: g }) => g === p.matchUpId);
        if ((f = h == null ? void 0 : h.sides) != null && f[m]) {
          if (delete h.sides[m].lineUp, t === !1) {
            let g = p.tieFormat, I = l.participantId;
            g && I && ps({ drawDefinition: i, participantId: I, lineUp: [], tieFormat: g });
          }
          xe({ tournamentId: r == null ? void 0 : r.tournamentId, context: "resetLineUps", eventId: s == null ? void 0 : s.eventId, drawDefinition: i, matchUp: h });
        }
      }
    });
  return { ...V };
}
function mn({ provisionalPositioning: e, inContextDrawMatchUps: t, isQualifierPosition: r, sourceMatchUpStatus: i, tournamentRecord: n, drawDefinition: a, seedingProfile: o, participantId: s, seedBlockInfo: c, drawPosition: u, matchUpsMap: d, structureId: p, event: l }) {
  var T, R, M, E, C;
  let m = "assignDrawPosition";
  if (!s && !r)
    return j({ result: { error: _t }, stack: m });
  d = d ?? mr({ drawDefinition: a }), t || ({ matchUps: t } = Bt({ inContext: !0, drawDefinition: a, matchUpsMap: d }));
  let f = ve({ drawDefinition: a, structureId: p });
  if (f.error)
    return j({ result: f, stack: m });
  let { structure: h } = f;
  if (!h)
    return { error: It };
  if (Er({ structure: h }))
    return j({ result: { error: jr }, stack: m });
  let { seedAssignments: g } = Si({ provisionalPositioning: e, drawDefinition: a, structure: h }), I = (T = g == null ? void 0 : g.find((A) => A.participantId === s)) == null ? void 0 : T.seedNumber, { appliedPolicies: y } = je({ tournamentRecord: n, drawDefinition: a, structure: h, event: l });
  if (I && !wl({ seedNumber: I, appliedPolicies: y, drawDefinition: a, seedBlockInfo: c, drawPosition: u, structureId: p }))
    return j({ result: { error: Uh }, context: { drawPosition: u }, stack: m });
  let U = Yt({ structure: h }).positionAssignments || [], S = U == null ? void 0 : U.find((A) => A.drawPosition === u);
  if (!S)
    return j({ result: { error: rc }, context: { drawPosition: u }, stack: m });
  if (U != null && U.map(Ce).includes(s))
    return j({ result: { error: oc }, context: { drawPosition: u }, stack: m });
  let { containsParticipant: D, containsBye: w } = b(S);
  if (w) {
    let A = id({ inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, drawPosition: u, structureId: p, matchUpsMap: d, event: l });
    if (A.error)
      return j({ result: A, stack: m });
  }
  if (D && S.participantId !== s) {
    let { activeDrawPositions: A } = rd({ drawDefinition: a, structureId: p });
    if (A.includes(u))
      return j({ result: { error: Gl }, stack: m });
    hI({ assignments: [S], inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, matchUpsMap: d, structure: h });
  }
  if (S.participantId = s, r && (S.qualifier = !0), h.stage === ue && (!h.stageSequence || h.stageSequence > 1) || h.stage && [lr, vt].includes(h.stage)) {
    let A = h.stage === ge ? ge : ue, N = (((M = (R = a.structures) == null ? void 0 : R.find((O) => (O == null ? void 0 : O.stage) === A && (O == null ? void 0 : O.stageSequence) === 1)) == null ? void 0 : M.seedAssignments) ?? []).find((O) => O.participantId === s);
    if (N != null && N.participantId) {
      let { participantId: O, seedNumber: k, seedValue: F } = N;
      vc({ eventId: l == null ? void 0 : l.eventId, provisionalPositioning: e, tournamentRecord: n, drawDefinition: a, seedingProfile: o, participantId: O, seedNumber: k, seedValue: F, structureId: p, event: l });
    }
  }
  if (h.structureType !== br)
    Vk({ provisionalPositioning: e, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: n, drawDefinition: a, drawPosition: u, matchUpsMap: d, structure: h, event: l });
  else {
    cT({ positionAssignments: U, tournamentRecord: n, drawDefinition: a, matchUpsMap: d, structure: h });
    let { drawPositions: A, matchUps: N, targetMatchUps: O } = AT({ assignments: [S], inContextDrawMatchUps: t, drawDefinition: a, matchUpsMap: d, structure: h });
    if (A && (N == null ? void 0 : N.length) === 1 && N[0].matchUpType === lt) {
      let k = ((O == null ? void 0 : O[0].sides) ?? []).reduce((F, x, _) => A != null && A.includes(x.drawPosition) ? _ : F, void 0);
      mI({ inContextTargetMatchUp: O[0], teamParticipantId: s, matchUp: N[0], drawPositionSideIndex: k, tournamentRecord: n, drawDefinition: a });
    }
  }
  let v = (E = a.entries) == null ? void 0 : E.find((A) => A.participantId === s), P = (C = l == null ? void 0 : l.entries) == null ? void 0 : C.find((A) => A.participantId === s);
  return !v && P && rI({ entryStatus: P.entryStatus, entryStage: h.stage, ignoreStageSpace: !0, drawDefinition: a, participantId: s, event: l }), Sa({ tournamentId: n == null ? void 0 : n.tournamentId, drawDefinition: a, structure: h, event: l }), { positionAssignments: U, ...V };
  function b(A) {
    let N = A.bye, O = A.qualifier, k = A.participantId;
    return { containsBye: N, containsQualifier: O, containsParticipant: k, filled: N || O || k };
  }
}
function Vk({ provisionalPositioning: e, inContextDrawMatchUps: t, sourceMatchUpStatus: r, tournamentRecord: i, drawDefinition: n, drawPosition: a, matchUpsMap: o, structure: s, event: c }) {
  let u = { isCollectionMatchUp: !1 }, { matchUps: d } = Ke({ provisionalPositioning: e, matchUpFilters: u, drawDefinition: n, matchUpsMap: o, structure: s, event: c }), { roundMatchUps: p } = Pr({ matchUps: d }), { initialRoundNumber: l } = Bo({ drawPosition: a, matchUps: d }), m = l && (p == null ? void 0 : p[l].find((f) => {
    var h;
    return (h = f.drawPositions) == null ? void 0 : h.includes(a);
  }));
  if (m) {
    let f = Ks({ matchUpId: m.matchUpId, inContextDrawMatchUps: t, sourceMatchUpStatus: r, tournamentRecord: i, drawDefinition: n, drawPosition: a, matchUpsMap: o });
    if (f.error)
      return j({ stack: "assignDrawPositionToMatchUps", context: { drawPosition: a }, result: f });
  }
  return { ...V };
}
function gI(e) {
  let { participantIdAttributeName: t = "participantId", isQualifierPosition: r, positionActionName: i, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, event: u } = e, d = "positionParticipantAction";
  if (!a)
    return { error: le };
  let p = je({ tournamentRecord: n, drawDefinition: a, event: u }).appliedPolicies ?? {}, { inContextDrawMatchUps: l, matchUpsMap: m } = e;
  m || (m = mr({ drawDefinition: a }), Object.assign(e, { matchUpsMap: m })), l || ({ matchUps: l } = Bt({ inContext: !0, drawDefinition: a, matchUpsMap: m }), Object.assign(e, { inContextDrawMatchUps: l }));
  let { positionAssignments: f } = ot({ drawDefinition: a, structureId: c }), h = f == null ? void 0 : f.find((S) => S.drawPosition === s);
  if (h != null && h.participantId) {
    let S = h.participantId, D = mn({ inContextDrawMatchUps: l, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, matchUpsMap: m, event: u });
    return D.success ? U({ appliedPolicies: p, removedParticipantId: S }) : j({ result: D, stack: d });
  }
  let g = id({ inContextDrawMatchUps: l, tournamentRecord: n, drawDefinition: a, drawPosition: s, structureId: c, matchUpsMap: m, event: u });
  if (g.error)
    return j({ result: g, stack: d });
  let I = g.participantId, y = mn({ inContextDrawMatchUps: l, isQualifierPosition: r, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, matchUpsMap: m, event: u });
  if (!y.success)
    return j({ result: y, stack: d });
  return U({ appliedPolicies: p, removedParticipantId: I });
  function U({ appliedPolicies: S, removedParticipantId: D }) {
    let { structure: w } = ve({ drawDefinition: a, structureId: c });
    _g({ drawPositions: [s], structure: w });
    let v = { [t]: o, name: i, drawPosition: s, structureId: c };
    return bp({ appliedPolicies: S, drawDefinition: a, positionAction: v }), j({ context: { removedParticipantId: D }, result: { ...V }, stack: d });
  }
}
function jk({ luckyLoserParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n }) {
  return gI({ positionActionName: "luckyLoserDrawPositionAssignment", participantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n });
}
function ET(e) {
  return jk(e);
}
function CT({ params: e, modMap: t, structure: r }) {
  let { tournamentRecord: i, drawDefinition: n, event: a } = e;
  for (let o of r.matchUps)
    t[o.matchUpId] && (o.roundNumber = t[o.matchUpId], xe({ tournamentId: i == null ? void 0 : i.tournamentId, eventId: a == null ? void 0 : a.eventId, drawDefinition: n, matchUp: o }));
}
function OT(e, t) {
  let r = [{ drawDefinition: !0, structureId: !0 }];
  Array.isArray(t) && r.push(...t);
  let i = fe(e, r);
  if (i.error)
    return i;
  let n = ve(e);
  if (n.error)
    return n;
  let a = n.structure;
  if (!Er({ structure: a }))
    return j({ result: { error: no, message: "structure must be adHoc" } });
  let { roundMatchUps: o = [], roundNumbers: s } = Pr({ matchUps: a == null ? void 0 : a.matchUps });
  return s != null && s.length ? { valid: !0, structure: a, roundMatchUps: o, roundNumbers: s } : { error: Zn };
}
function kT(e) {
  var d;
  let t = OT(e, [{ targetRoundNumber: !0, roundNumber: !0, [Or]: E1 }]);
  if (t.error)
    return t;
  let { structure: r, roundMatchUps: i, roundNumbers: n } = t, { targetRoundNumber: a, roundNumber: o } = e;
  if (!(n != null && n.includes(o)) || !(n != null && n.includes(a)))
    return j({ result: { error: J }, info: "roundNumbers must be valid rounds" });
  let s = a > o, c = s ? oe(o + 1, a + 1) : oe(a, o), u = {};
  return c.forEach((p) => ((i == null ? void 0 : i[p]) ?? []).forEach(({ matchUpId: l }) => {
    u[l] = p - (s ? 1 : -1);
  })), (d = i == null ? void 0 : i[o]) == null || d.forEach(({ matchUpId: p }) => u[p] = a), CT({ params: e, modMap: u, structure: r }), { ...V };
}
function FT({ structurePositionAssignments: e, provisionalPositioning: t, tournamentRecord: r, drawDefinition: i, event: n }) {
  var s;
  if (!i)
    return { error: le };
  if (!Array.isArray(e))
    return { error: J };
  let a = "setPositionAssignments";
  for (let c of e) {
    let { structureId: u, positionAssignments: d } = c;
    if (!d)
      continue;
    let p = ve({ drawDefinition: i, structureId: u });
    if (p.error)
      return p;
    let l = p.structure;
    if (!l)
      return { error: It };
    let m = (s = ot({ structure: l }).positionAssignments) == null ? void 0 : s.map(({ drawPosition: I }) => I), f = d == null ? void 0 : d.map(({ drawPosition: I }) => I);
    if (wt(m, f).length !== (m == null ? void 0 : m.length))
      return j({ result: { error: J }, info: "drawPositions do not match", stack: a });
    let h = mr({ drawDefinition: i }), { matchUps: g } = Bt({ inContext: !0, drawDefinition: i, matchUpsMap: h });
    for (let I of d || []) {
      let { drawPosition: y, participantId: U, bye: S, qualifier: D } = I;
      if (S) {
        let w = pi({ tournamentRecord: r, drawDefinition: i, drawPosition: y, matchUpsMap: h, structureId: u, structure: l, event: n });
        if (w != null && w.error)
          return w;
      } else if (D)
        d.forEach((w) => {
          w.drawPosition === y && (w.qualifier = !0, delete w.participantId, delete w.bye);
        });
      else if (U) {
        let w = mn({ provisionalPositioning: t, inContextDrawMatchUps: g, tournamentRecord: r, drawDefinition: i, participantId: U, drawPosition: y, matchUpsMap: h, structureId: u, event: n });
        if (w != null && w.error)
          return w;
      }
    }
    Sa({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: i, structure: l, event: n });
  }
  let o = e.map(({ structureId: c }) => c);
  return ut({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: n == null ? void 0 : n.eventId, drawDefinition: i, structureIds: o }), { ...V };
}
function xT(e) {
  let t = OT(e, [{ roundNumbers: !0, [Or]: fr, [cr]: (o) => o.length === 2 && o.every(St) }]);
  if (t.error)
    return t;
  let { structure: r, roundMatchUps: i, roundNumbers: n } = t;
  if (!e.roundNumbers.every((o) => n == null ? void 0 : n.includes(o)))
    return j({ result: { error: J, message: "roundNumbers must be valid rounds" } });
  let a = {};
  return e.roundNumbers.forEach((o, s) => ((i == null ? void 0 : i[o]) ?? []).forEach(({ matchUpId: c }) => {
    a[c] = e.roundNumbers[1 - s];
  })), CT({ params: e, modMap: a, structure: r }), { ...V };
}
function Gk({ qualifyingParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n }) {
  return gI({ positionActionName: "qualifierDrawPositionAssignment", participantId: e, isQualifierPosition: !0, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n });
}
function LT(e) {
  return Gk(e);
}
function _T({ alternateParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n, event: a }) {
  return gI({ positionActionName: "alternateDrawPositionAssignment", participantIdAttributeName: "alternateParticipantid", participantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n, event: a });
}
function BT({ validation: e = !0, tournamentRecord: t, drawDefinition: r, participantId: i, structureId: n, seedValue: a, event: o }) {
  if (!r)
    return { error: le };
  if (!n)
    return { error: ui };
  let s = ((t == null ? void 0 : t.participants) ?? []).find((l) => l.participantId === i);
  if (t && !s)
    return { error: Ji };
  let { structure: c } = ve({ drawDefinition: r, structureId: n });
  if (!c)
    return { error: It };
  if (!(!e || St(a) || a === void 0 || a === "" || typeof a == "string" && a.split("-").every((l) => St(l) && ye(l) > 0)))
    return { error: J };
  let { seedAssignments: u } = Si({ drawDefinition: r, structure: c }), d = u == null ? void 0 : u.map((l) => l.seedNumber), p = u == null ? void 0 : u.find((l) => l.participantId === i);
  if (p) {
    let l = typeof a == "string" ? a.includes("-") && a.split("-").map((m) => parseInt(m)).join("-") || parseInt(a) > 0 && parseInt(a) || "" : a && a > 0 && a || "";
    p.seedValue = l;
  } else {
    let l = { seedNumber: Math.max(0, ...d || []) + 1, participantId: i };
    a && (l.seedValue = a), c.seedAssignments || (c.seedAssignments = []), c.seedAssignments.push(l);
  }
  return MD({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: o == null ? void 0 : o.eventId, drawDefinition: r, structure: c }), { ...V };
}
function VT({ drawDefinition: e, structureId: t }) {
  if (!e)
    return { error: le };
  let { structure: r } = ve({ drawDefinition: e, structureId: t }), i = ((e == null ? void 0 : e.links) || []).filter((n) => {
    var a;
    return ((a = n.source) == null ? void 0 : a.structureId) === t;
  }).map((n) => {
    var a;
    return (a = n.target) == null ? void 0 : a.structureId;
  });
  return { playoffStructures: ((e == null ? void 0 : e.structures) || []).filter((n) => i.includes(n.structureId)), structure: r };
}
function jp({ withStageGrouping: e, stageSequences: t, stageSequence: r, roundTarget: i, stages: n, event: a, stage: o }) {
  if (!a)
    return { error: pt };
  let s = {}, c = [];
  for (let u of a.drawDefinitions || []) {
    let { structures: d, stageStructures: p } = Bi({ withStageGrouping: e, stageSequences: t, drawDefinition: u, stageSequence: r, roundTarget: i, stages: n, stage: o });
    if (c.push(...d), p)
      for (let l of Object.keys(p))
        s[l] || (s[l] = []), s[l].push(...p[l]);
  }
  return { structures: c, stageStructures: s };
}
function II({ withStageGrouping: e, tournamentRecord: t, stageSequences: r, stageSequence: i, roundTarget: n, stages: a, stage: o }) {
  if (!t)
    return { error: ae };
  let s = {}, c = [];
  for (let u of t.events || []) {
    let { structures: d, stageStructures: p } = jp({ withStageGrouping: e, stageSequences: r, stageSequence: i, roundTarget: n, stages: a, event: u, stage: o });
    if (d && c.push(...d), p)
      for (let l of Object.keys(p))
        s[l] || (s[l] = []), s[l].push(...p[l]);
  }
  return { structures: c, stageStructures: s };
}
function wa(e) {
  if (!(e != null && e.drawDefinition))
    return !1;
  let t = xp(e), r = t == null ? void 0 : t.includesTeamMatchUps, { completedMatchUps: i, pendingMatchUps: n, upcomingMatchUps: a } = t || {};
  return r && (i = i == null ? void 0 : i.filter(({ matchUpType: o }) => o === lt), n = n == null ? void 0 : n.filter(({ matchUpType: o }) => o === lt), a = a == null ? void 0 : a.filter(({ matchUpType: o }) => o === lt)), !!(i != null && i.length && !(n != null && n.length) && !(a != null && a.length));
}
function UI(e) {
  var o, s;
  let { drawDefinition: t, structureId: r } = e;
  if (!t)
    return { error: le };
  let { playoffStructures: i } = VT({ drawDefinition: t, structureId: r });
  if (!(i != null && i.length))
    return !1;
  let n = ((s = (o = t == null ? void 0 : t.entries) == null ? void 0 : o.filter((c) => (c == null ? void 0 : c.entryStatus) && $i.includes(c.entryStatus))) == null ? void 0 : s.length) ?? 0, a = 0;
  return (i || []).reduce((c, u) => {
    var d;
    return !!((d = ot({ structure: u }).positionAssignments ?? []) != null && d.filter((p) => (p.participantId && a++, (p == null ? void 0 : p.bye) ?? (p == null ? void 0 : p.participantId))).length && c);
  }, !!i.length) || a === n;
}
function $f({ significantCharacters: e, accessors: t = [], value: r }) {
  let i = [], n = t[0];
  if (r != null && r[n]) {
    let o = t.slice(1);
    if (Array.isArray(r[n]))
      r[n].forEach((s) => {
        let c = $f({ accessors: o, significantCharacters: e, value: s });
        i.push(...c);
      });
    else if (r = r[n], o.length) {
      let s = $f({ accessors: o, significantCharacters: e, value: r });
      i.push(...s);
    } else
      a({ value: r });
  }
  function a({ value: o }) {
    if (o && ["string", "number"].includes(typeof o)) {
      let s = e ? o.slice(0, e) : o;
      i.push(s);
    }
  }
  return i;
}
function $k({ targetParticipantIds: e, policyAttributes: t, idCollections: r, participants: i }) {
  if (!Array.isArray(t))
    return { error: Mh };
  if (!Array.isArray(i))
    return { error: Ru };
  let n = {};
  return e.forEach((a) => {
    let o = i.find((c) => c.participantId === a), { values: s } = jT({ policyAttributes: t, idCollections: r, participants: i, participant: o });
    s && s.forEach((c) => {
      n[c] || (n[c] = []), n[c].includes(a) || n[c].push(a);
    });
  }), n;
}
function jT({ policyAttributes: e, idCollections: t, participants: r, participant: i }) {
  if (!Array.isArray(e))
    return { error: Mh };
  if (!i)
    return { error: Ho };
  let n = [];
  return e.forEach((a) => {
    let { directive: o, groupings: s, key: c, significantCharacters: u } = a || {};
    if (c) {
      let d = c.split(".");
      n.push(...$f({ significantCharacters: u, value: i, accessors: d }));
    } else if (o) {
      let d = a == null ? void 0 : a.includeIds, p = ((t == null ? void 0 : t[o]) || []).filter((l) => !d || d.includes(l));
      p != null && p.length && (r != null && r.length) && p.forEach((l) => {
        var f;
        let m = r.find((h) => h.participantId === l);
        if ((f = m == null ? void 0 : m.individualParticipantIds) != null && f.includes(i.participantId)) {
          let h = m == null ? void 0 : m.participantId;
          n.push(h);
        }
      });
    } else
      s && Object.keys(s).forEach((d) => {
        s[d].includes(i.participantId) && n.push(d);
      });
  }), { values: Te(n) };
}
function uS({ candidatePositionAssignments: e, participantsWithGroupings: t, policyAttributes: r, idCollections: i }) {
  let n = Object.assign({}, ...t.map((a) => ({ [a.participantId]: a })));
  return e.map((a) => {
    let o = n[a.participantId], { values: s } = jT({ participants: t, policyAttributes: r, idCollections: i, participant: o });
    return { ...a, values: s };
  });
}
function GT({ participantIdGroups: e, positionAssignments: t, groupsToAvoid: r }) {
  return Object.assign({}, ...t.filter((i) => i == null ? void 0 : i.participantId).map((i) => {
    let { drawPosition: n, participantId: a } = i, o = e ? e[a] || [] : [], s = !!r.some((c) => o.includes(c));
    return { [n]: { participantGroups: o, includesGroupsToAvoid: s } };
  }));
}
function qk(e) {
  let { unfilledPositions: t, chunkedDrawPositions: r } = e, i = GT(e);
  return r.map((a) => {
    let o = t.filter((u) => a.includes(u)), s = n(o), c = o.filter((u) => !s.includes(u)).filter((u) => {
      var p;
      let d = dS(u);
      return !((p = i[d]) != null && p.includesGroupsToAvoid);
    });
    return { unassigned: o, unpaired: s, pairedNoConflict: c };
  });
  function n(a) {
    return a.filter((s) => !o(s));
    function o(s) {
      let c = dS(s);
      return !a.includes(c);
    }
  }
}
function Wk(e) {
  let { unfilledPositions: t, chunkedDrawPositions: r } = e, i = GT(e);
  return r.map((n) => {
    let a = t.filter((c) => n.includes(c)), o = a.length === n.length ? a : [], s = n.filter((c) => {
      var u;
      return (u = i[c]) == null ? void 0 : u.includesGroupsToAvoid;
    }).length;
    return { unassigned: a, unpaired: o, pairedNoConflict: s ? [] : a, conflictsCount: s };
  });
}
function dS(e) {
  return Number(e % 2 ? e + 1 : e - 1);
}
function Hk({ allGroups: e, participantId: t }) {
  return Object.keys(e).filter((r) => e[r].includes(t));
}
function zk({ selectedParticipantGroups: e, participantIdGroups: t, positionAssignments: r, drawPositionChunks: i, unfilledPositions: n, isRoundRobin: a }) {
  let o = i.map((s) => a ? Wk({ groupsToAvoid: e, chunkedDrawPositions: s, participantIdGroups: t, positionAssignments: r, unfilledPositions: n }) : qk({ groupsToAvoid: e, chunkedDrawPositions: s, participantIdGroups: t, positionAssignments: r, unfilledPositions: n }));
  if (a) {
    let s = o.map((d) => d.map((p) => p.unassigned).filter((p) => p == null ? void 0 : p.length)).filter((d) => d == null ? void 0 : d.length).sort((d, p) => (p.length || 0) - (d.length || 0)), c = o.map((d) => d.map((p) => p.unpaired).filter((p) => p == null ? void 0 : p.length)).filter((d) => d == null ? void 0 : d.length), u = o.map((d) => d.map((p) => p.pairedNoConflict).filter((p) => p == null ? void 0 : p.length)).filter((d) => d == null ? void 0 : d.length).sort((d, p) => (p.length || 0) - (d.length || 0));
    return { unassigned: s, unpaired: c, pairedNoConflict: u };
  } else {
    let s = o.map((d) => d.map((p) => p.unassigned).filter((p) => p == null ? void 0 : p.length)).filter((d) => d == null ? void 0 : d.length), c = o.map((d) => d.map((p) => p.unpaired).filter((p) => p == null ? void 0 : p.length)).filter((d) => d == null ? void 0 : d.length), u = o.map((d) => d.map((p) => p.pairedNoConflict).filter((p) => p == null ? void 0 : p.length)).filter((d) => d == null ? void 0 : d.length);
    return { unassigned: s, unpaired: c, pairedNoConflict: u };
  }
}
function $T({ positionAssignments: e, participantIds: t }) {
  let r = e.map((i) => i.participantId);
  return t.filter((i) => !r.includes(i));
}
function Yk({ useSpecifiedGroupKey: e = !1, targetParticipantIds: t, largestFirst: r = !0, allGroups: i, groupKey: n }) {
  var u;
  let a = Object.assign({}, ...Object.keys(i).map((d) => [d, i[d].filter((p) => t.includes(p))]).filter((d) => d[1].length).map(([d, p]) => ({ [d]: p }))), o = Object.keys(a).reduce((d, p) => a[p].length > d ? a[p].length : d, 0), s = Object.keys(a).filter((d) => a[d].length === o), c = Wr(r ? s : Object.keys(a));
  return n = e && ((u = a[n]) != null && u.length) ? n : c, { participantId: n && a[n] ? Wr(a[n]) : Wr(t), groupKey: n };
}
function Kk({ drawPositionGroups: e, positionAssignments: t }) {
  let r = Object.assign({}, ...t.map((i) => ({ [i.drawPosition]: i })));
  return e.map((i) => i.filter(Boolean).map((n) => r[n]).filter(Boolean).filter((n) => !n.participantId && !n.bye).map((n) => n.drawPosition)).flat().filter(Boolean);
}
function Qk({ candidatePositionAssignments: e, unseededParticipantIds: t, participantIdGroups: r, drawPositionChunks: i, drawPositionGroups: n, pairedPriority: a, allGroups: o, groupKey: s }) {
  let c = n.reduce((P, b) => b.length > P ? b.length : P, 0) <= 2, u = $T({ positionAssignments: e, participantIds: t }), d = Kk({ positionAssignments: e, drawPositionGroups: n }), { participantId: p, groupKey: l } = Yk({ targetParticipantIds: u, useSpecifiedGroupKey: c, allGroups: o, groupKey: s }), m = Hk({ participantId: p, allGroups: o }), f = zk({ positionAssignments: e, isRoundRobin: c, selectedParticipantGroups: m, participantIdGroups: r, drawPositionChunks: i, unfilledPositions: d }), { unassigned: h, unpaired: g, pairedNoConflict: I } = f, y = (I == null ? void 0 : I.length) && I[0], U = (g == null ? void 0 : g.length) && g[0], S = a && y ? y : U, D = a ? U : y, w = (S == null ? void 0 : S.length) && S || (D == null ? void 0 : D.length) && D, v;
  if (w != null && w.length) {
    let P = zr(w);
    v = zr(P);
  } else {
    let P = zr(h[0]);
    v = zr(P);
  }
  return { newGroupKey: l, selectedParticipantId: p, targetDrawPosition: v };
}
function Pl({ isRoundRobin: e, groupedParticipants: t }) {
  let r = [];
  return e ? t.forEach((i) => {
    let n = i.map((s) => s.drawPosition), a = uI({ drawPositions: n }).uniqueMatchUpGroupings ?? [], o = Object.assign({}, ...i.map((s) => ({ [s.drawPosition]: s })));
    a.forEach((s) => {
      wr(o[s[0]].values || [], o[s[1]].values || []) && (r.push(s), i.conflict = !0);
    });
  }) : t.forEach((i) => {
    var n, a;
    wr(((n = i[0]) == null ? void 0 : n.values) || [], ((a = i[1]) == null ? void 0 : a.values) || []) && (r.push(i), i.conflict = !0);
  }), r;
}
function Jk({ positionedParticipants: e, potentialDrawPositions: t, drawPositionGroups: r, avoidanceConflicts: i, isRoundRobin: n }) {
  return i.map((a) => {
    let o = a.map((s) => s.drawPosition);
    return a.filter((s) => t.includes(s.drawPosition)).map((s) => {
      let c = t.filter((u) => !(o != null && o.includes(u))).filter((u) => {
        let d = r.find((h) => h.includes(u)).find((h) => h !== u), p = e.find((h) => h.drawPosition === d), l = Pl({ isRoundRobin: n, groupedParticipants: [[s, p]] }), m = [e.find((h) => h.drawPosition === u), p], f = Pl({ isRoundRobin: n, groupedParticipants: [m] });
        return !l.length && !f.length;
      });
      if (c.length)
        return { drawPosition: s.drawPosition, possibleDrawPositions: c };
    }).filter(Boolean);
  }).flat(1);
}
function lS(e) {
  let { initialPositionAssignments: t, participantsWithGroupings: r, opponentsToPlaceCount: i, unseededByePositions: n, drawPositionGroups: a, policyAttributes: o, idCollections: s, allGroups: c } = e, u = [], d, p = Math.min(...(a || []).map((U) => U == null ? void 0 : U.length).filter(Boolean)), l = p > 2, m = ce(t, !1, !0).filter((U) => !U.qualifier), f = t.filter((U) => !U.participantId && (!U.bye || (n == null ? void 0 : n.includes(U.drawPosition)))).map((U) => U.drawPosition);
  oe(0, i).forEach(() => {
    let { newGroupKey: U, selectedParticipantId: S, targetDrawPosition: D } = Qk({ ...e, candidatePositionAssignments: m, allGroups: c, groupKey: d });
    d = U, m.forEach((w) => {
      w.drawPosition === D && (w.participantId = S);
    });
  });
  let h = uS({ candidatePositionAssignments: m, participantsWithGroupings: r, policyAttributes: o, idCollections: s }), g = zt(h, p), I = Pl({ groupedParticipants: g, isRoundRobin: l }), y = 0;
  for (; y < 20 && I.length; ) {
    let U = Jk({ positionedParticipants: h, potentialDrawPositions: f, avoidanceConflicts: I, drawPositionGroups: a, isRoundRobin: l });
    if (U.length) {
      let S = Xk({ candidatePositionAssignments: m, swapOptions: U });
      S.error && console.log({ result: S }), h = uS({ candidatePositionAssignments: m, participantsWithGroupings: r, policyAttributes: o, idCollections: s }), g = zt(h, p), I = Pl({ groupedParticipants: g, isRoundRobin: l }), y++;
    } else
      y = 20;
  }
  return m.forEach((U) => {
    if (U.bye && U.participantId) {
      let S = yf;
      u.push(S);
    }
    if (U.qualifier && U.participantId) {
      let S = yf;
      u.push(S);
    }
  }), { positionAssignments: m, conflicts: I.length, groupedParticipants: g, errors: u };
}
function Xk({ candidatePositionAssignments: e, swapOptions: t }) {
  let r = zr(t);
  if (!r)
    return { error: { message: "No swap options" } };
  let i = r.drawPosition, n = zr(r.possibleDrawPositions), a = e.find((u) => u.drawPosition === i), o = e.find((u) => u.drawPosition === n) ?? {}, s = { participantId: o == null ? void 0 : o.participantId, qualifier: o == null ? void 0 : o.qualifier, bye: o == null ? void 0 : o.bye }, c = { participantId: a.participantId, qualifier: a.qualifier, bye: a.bye };
  return Object.assign(a, s), Object.assign(o, c), { ...V };
}
function Zk({ provisionalPositioning: e, unseededParticipantIds: t, inContextDrawMatchUps: r, unseededByePositions: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, avoidance: d, drawSize: p, event: l }) {
  var _;
  if (!d)
    return { error: Zv };
  let { candidatesCount: m = 1, policyAttributes: f, targetDivisions: h } = d, { roundsToSeparate: g } = d, I = "randomUnseededSeparation", { structure: y } = ve({ drawDefinition: a, structureId: u }), { matchUps: U } = Ke({ provisionalPositioning: e, matchUpsMap: c, structure: y, event: l });
  if (h && Qi(h) && !g) {
    let B = OE(h) || 0, L = U.reduce((G, $) => $.roundNumber > G ? $.roundNumber : G, 0);
    g = L < B ? 1 : L - B + 1;
  }
  let { positionAssignments: S } = Yt({ structure: y }), D = Bg({ participantsProfile: { convertExtensions: !0 }, deepCopy: !1, participants: s }).participantsWithGroupings, w = S == null ? void 0 : S.filter((B) => !B.participantId), v = S == null ? void 0 : S.map((B) => B.drawPosition), P = (y == null ? void 0 : y.structureType) === br, b = P ? { structure: y, matchUps: U, allDrawPositions: v, roundsToSeparate: g } : { matchUps: U, allDrawPositions: v, roundsToSeparate: g }, { drawPositionGroups: T, drawPositionChunks: R } = P ? eF(b) : tF(b), M = { groupParticipants: s.filter((B) => B.participantType === di).map((B) => B.participantId), teamParticipants: s.filter((B) => B.participantType === Xe).map((B) => B.participantId), pairParticipants: s.filter((B) => B.participantType === Re).map((B) => B.participantId) }, E = $k({ targetParticipantIds: t, policyAttributes: f, idCollections: M, participants: s });
  if (E.error)
    return j({ result: E, stack: I });
  let C = Object.assign({}, ...t.map((B) => {
    let L = Object.keys(E).filter((G) => (E[G] ?? []).includes(B));
    return { [B]: L };
  })), A = $T({ participantIds: t, positionAssignments: S });
  if (A.length > ((w == null ? void 0 : w.length) || 0))
    return { error: Oh };
  let N, O = A.length, k = oe(0, m).map(() => lS({ initialPositionAssignments: S, participantsWithGroupings: D, unseededParticipantIds: t, opponentsToPlaceCount: O, pairedPriority: !1, unseededByePositions: i, participantIdGroups: C, drawPositionChunks: R, drawPositionGroups: T, policyAttributes: f, idCollections: M, allGroups: E, drawSize: p }));
  if (N = k.reduce((B, L) => !B || (L.conflicts || 0) < (B.conflicts || 0) ? L : B, void 0), !N || N.conflicts) {
    let B = oe(0, m).map(() => lS({ initialPositionAssignments: S, participantsWithGroupings: D, unseededParticipantIds: t, opponentsToPlaceCount: O, pairedPriority: !0, unseededByePositions: i, participantIdGroups: C, drawPositionChunks: R, drawPositionGroups: T, policyAttributes: f, idCollections: M, allGroups: E, drawSize: p }));
    N = k.concat(...B).filter((L) => {
      var G;
      return !((G = L.errors) != null && G.length);
    }).reduce((L, G) => !L || (G.conflicts || 0) < (L.conflicts || 0) ? G : L, void 0);
  }
  if (!N)
    return { error: Jl };
  let F = (((_ = ot({ structure: y })) == null ? void 0 : _.positionAssignments) ?? []).filter((B) => B.participantId).map((B) => B.participantId), x = N.positionAssignments.filter((B) => !F.includes(B.participantId));
  for (let B of x)
    if (B.bye) {
      let L = pi({ tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, event: l, ...B });
      if (L.error)
        return j({ result: L, stack: I });
    } else if (B.participantId) {
      let L = mn({ automaticPlacement: !0, inContextDrawMatchUps: r, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, event: l, ...B });
      if (L.error)
        return j({ result: L, stack: I, context: { assignment: B } });
    }
  return { ...V };
}
function eF(e) {
  let { structure: { structures: t } } = e, r = t.map((i) => i.positionAssignments.map((n) => n.drawPosition));
  return { drawPositionGroups: r, drawPositionChunks: [r] };
}
function tF({ allDrawPositions: e, roundsToSeparate: t, matchUps: r }) {
  let i = r.filter((d) => d.roundNumber === 1).map((d) => d.drawPositions), n = i.flat().sort(Ft), a = Math.max(...n), o = e.filter((d) => d > a), s = n.length, c = oe(s === 2 ? 1 : 2, s).filter((d) => d === gh(d)), u = c.slice(0, t || c.length).reverse().map((d) => zt(n, d));
  return o.length && console.log({ fedDrawPositions: o }), { drawPositionGroups: i, drawPositionChunks: u };
}
function rF({ provisionalPositioning: e, inContextDrawMatchUps: t, unseededByePositions: r, multipleStructures: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, structure: d, drawSize: p, event: l }) {
  var b, T;
  let m = "positionUnseededParticipants";
  d || ({ structure: d } = ve({ drawDefinition: a, structureId: u })), u || ({ structureId: u } = d);
  let { positionAssignments: f } = Yt({ structure: d }), { seedAssignments: h } = Si({ provisionalPositioning: e, drawDefinition: a, structure: d }), g = h == null ? void 0 : h.map((R) => R.participantId).filter(Boolean), { stage: I, stageSequence: y } = d, U = I === ge ? (T = (b = Ne({ element: d, name: In })) == null ? void 0 : b.extension) == null ? void 0 : T.value : void 0, S = ts({ provisionalPositioning: e, drawDefinition: a, stageSequence: y, entryStatuses: mo, structureId: u, roundTarget: U, stage: I }), D = S.filter((R) => !(g != null && g.includes(R.participantId))).map((R) => R.participantId), w = f == null ? void 0 : f.filter((R) => !R.participantId && !R.bye && !R.qualifier).map((R) => R.drawPosition);
  if (!i && D.length > ((w == null ? void 0 : w.length) || 0))
    return j({ result: { error: Oh }, context: { unseededParticipantsCount: D.length, unfilledDrawPositionsCount: w == null ? void 0 : w.length }, stack: m });
  let { appliedPolicies: v } = je({ tournamentRecord: n, drawDefinition: a, event: l }), P = v == null ? void 0 : v[ou];
  if (d.stage === vt) {
    let R = S.reduce((M, E) => (M[E.groupingValue] || (M[E.groupingValue] = []), M[E.groupingValue].push(E.participantId), M), {});
    Object.keys(R).length && (P || (P = { policyName: "Playoff Avoidance" }), P.policyAttributes || (P.policyAttributes = []), P.policyAttributes.push({ groupings: R }));
  }
  return P && s ? Zk({ provisionalPositioning: e, unseededParticipantIds: D, inContextDrawMatchUps: t, unseededByePositions: r, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, avoidance: P, drawSize: p, entries: S }) : iF({ provisionalPositioning: e, unseededParticipantIds: D, inContextDrawMatchUps: t, unfilledDrawPositions: w, multipleStructures: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, drawSize: p, event: l });
}
function iF({ provisionalPositioning: e, unseededParticipantIds: t, inContextDrawMatchUps: r, unfilledDrawPositions: i, multipleStructures: n, tournamentRecord: a, drawDefinition: o, seedBlockInfo: s, matchUpsMap: c, structureId: u, drawSize: d, event: p }) {
  let l = d > 2 ? yr(i) : i.reverse();
  for (let m of t) {
    let f = l.pop();
    if (!n || f) {
      let h = mn({ provisionalPositioning: e, inContextDrawMatchUps: r, tournamentRecord: a, drawDefinition: o, seedBlockInfo: s, participantId: m, drawPosition: f, matchUpsMap: c, structureId: u, event: p });
      if (h != null && h.error && console.log("!!!!!", { result: h }), h == null ? void 0 : h.error)
        return j({ result: h, stack: "randomUnseededDistribution" });
    }
  }
  return { ...V };
}
function nF(e) {
  let t = e.structure ?? ve(e).structure, r = "positionQualifiers", i = [];
  if (t.stage === lr)
    return j({ result: { error: oo }, stack: r });
  let { unplacedRoundQualifierCounts: n, positionAssignments: a, roundDrawPositions: o } = aF(e);
  for (let s of Object.keys(n)) {
    let c = a == null ? void 0 : a.filter((u) => o[s].includes(u.drawPosition) && !u.participantId && !u.qualifier && !u.bye).map((u) => u.drawPosition);
    if (n[s] > (c || 0))
      return j({ result: { error: Uw }, context: { unfilledDrawPositions: c }, stack: r });
    oe(0, n[s]).forEach(() => {
      let u = zr(c);
      i.push(u), a == null || a.forEach((d) => {
        d.drawPosition === u && (d.qualifier = !0, delete d.participantId, delete d.bye);
      });
    });
  }
  return { ...V, qualifierDrawPositions: i };
}
function aF({ drawDefinition: e, structure: t, structureId: r }) {
  t || ({ structure: t } = ve({ drawDefinition: e, structureId: r })), r || ({ structureId: r } = t);
  let { positionAssignments: i } = Yt({ structure: t }), { stage: n, stageSequence: a } = t, { qualifiersCount: o, roundQualifiersCounts: s } = yc({ drawDefinition: e, stageSequence: a, structureId: r, stage: n }), c = (s ? Object.keys(s) : []).map((h) => ye(h)), { matchUps: u } = Ke({ structure: t }), { roundProfile: d } = Pr({ matchUps: u }), p = Object.assign({}, ...c.filter((h) => d == null ? void 0 : d[h]).map((h) => {
    var g, I;
    return { [h]: ((I = (g = d == null ? void 0 : d[h]) == null ? void 0 : g.drawPositions) == null ? void 0 : I.filter(Boolean)) ?? [] };
  })), l = i == null ? void 0 : i.filter((h) => h.qualifier).map((h) => h.drawPosition), m = o - ((l == null ? void 0 : l.length) ?? 0), f = l == null ? void 0 : l.length;
  return { unplacedRoundQualifierCounts: Object.assign({}, ...c.map((h) => {
    let g = i == null ? void 0 : i.filter((I) => {
      var y, U;
      return I.qualifier && ((U = (y = p[h]) == null ? void 0 : y.drawPositions) == null ? void 0 : U.includes(I.drawPosition));
    }).map((I) => I.drawPosition);
    return { [h]: ((s == null ? void 0 : s[h]) ?? 0) - ((g == null ? void 0 : g.length) ?? 0) };
  })), unplacedQualifiersCount: m, placedQualifiersCount: f, roundQualifiersCounts: s, positionAssignments: i, roundDrawPositions: p, qualifiersCount: o };
}
function pS({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, appliedPolicies: i, validSeedBlocks: n, drawDefinition: a, seedingProfile: o, seedBlockInfo: s, participants: c, groupsCount: u, structureId: d, matchUpsMap: p, structure: l, event: m }) {
  let f = [], h = [], g = 0;
  if (l || ({ structure: l } = ve({ drawDefinition: a, structureId: d })), d || (d = l == null ? void 0 : l.structureId), i || (i = je({ drawDefinition: a }).appliedPolicies), !n) {
    let I = l && ls({ provisionalPositioning: e, appliedPolicies: i, drawDefinition: a, seedingProfile: o, structure: l });
    I != null && I.error && h.push(I.error), n = I == null ? void 0 : I.validSeedBlocks;
  }
  return u = u ?? (n == null ? void 0 : n.length) ?? 0, oe(0, u).forEach(() => {
    if (g < (u || 0)) {
      let I = oF({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: a, seedingProfile: o, seedBlockInfo: s, participants: c, structureId: d, matchUpsMap: p, event: m });
      I != null && I.success && (g++, f.push(...I.seedPositions ?? [])), I.error && h.push({ seedPositionError: I.error });
    }
  }), h.length ? { error: h } : { ...V, seedPositions: f };
}
function oF({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, participants: o, structureId: s, matchUpsMap: c, event: u }) {
  let { unplacedSeedParticipantIds: d, unfilledPositions: p } = bT({ provisionalPositioning: e, randomize: !0, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, structureId: s, event: u }), { appliedPolicies: l } = je({ drawDefinition: i }), { avoidance: m } = l ?? {};
  m && o && (d == null ? void 0 : d.length) > 2;
  let f = [];
  for (let h of d) {
    let g = p.pop();
    if (!g)
      return { error: ic };
    f.push(g);
    let I = mn({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, seedingProfile: n, participantId: h, seedBlockInfo: a, drawPosition: g, matchUpsMap: c, structureId: s, event: u });
    if (!I.success)
      return I;
  }
  return { ...V, seedPositions: f };
}
function sF({ provisionalPositioning: e, drawDefinition: t, structure: r }) {
  let { positionAssignments: i } = Yt({ structure: r }), { seedAssignments: n } = Si({ provisionalPositioning: e, drawDefinition: t, structure: r }), a = Object.assign({}, ...(n || []).filter((o) => o.participantId).map((o) => ({ [o.participantId]: o })));
  return i == null ? void 0 : i.map((o) => a[o.participantId] ? { ...o, seedNumber: a[o.participantId].seedNumber, seedValue: a[o.participantId].seedValue } : "").filter(Boolean);
}
function cF({ orderedSortedFirstRoundSeededDrawPositions: e, validSeedBlocks: t, byesToPlace: r }) {
  let i = [];
  t.forEach((a) => {
    if (r - i.length > a.drawPositions.length)
      i.push(...a.drawPositions);
    else {
      let o = qf(zt(a.drawPositions, 2)), s, c = e[i.length];
      for (; s = Zd(o, c); )
        i.push(s), c = e[i.length];
    }
  });
  let n = i.map((a) => Array.isArray(a) ? yr(a) : a).flat(1 / 0);
  return vv(r) && t.map((a) => a.seedNumbers[0]).includes(r) ? e : n;
}
function Zd(e, t) {
  if (Array.isArray(e) && e.length !== 2)
    return e.pop();
  if (!Array.isArray(e[0]))
    return e.includes(t) ? e.indexOf(t) ? e.pop() : e.shift() : Math.round(Math.random()) ? e.pop() : e.shift();
  let r = e[0].flat(1 / 0).length, i = e[1].flat(1 / 0).length;
  if (r === i) {
    let n = e[0].flat(1 / 0).includes(t) ? e[0] : e[1];
    return Zd(t ? n : e[Math.round(Math.random())], t);
  }
  return r < i ? Zd(e[1], t) : Zd(e[0], t);
}
function qf(e) {
  let t = Math.floor(e.length / 2);
  return e.length > 2 ? [qf(e.slice(0, t)), qf(e.slice(t))] : e;
}
function uF({ provisionalPositioning: e, relevantMatchUps: t, appliedPolicies: r, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, byesToPlace: o, structure: s }) {
  var S;
  a || (a = ls({ provisionalPositioning: e, appliedPolicies: r, drawDefinition: i, seedingProfile: n, structure: s }));
  let { isFeedIn: c, isLuckyStructure: u, isContainer: d } = a, { validSeedBlocks: p } = a;
  (S = r == null ? void 0 : r.seeding) != null && S.containerByesIgnoreSeeding && (p = []);
  let l = sF({ provisionalPositioning: e, drawDefinition: i, structure: s }) ?? [], m = Te([].concat(...t.map((D) => D.drawPositions))), f = l.filter((D) => m.includes(D.drawPosition)), h = (D, w) => Ys(D.seedValue) - Ys(w.seedValue), g = p.reduce((D, w) => {
    let v = f.filter((P) => {
      var b;
      return (b = w.drawPositions) == null ? void 0 : b.includes(P.drawPosition);
    }).sort(h);
    return D.concat(...v);
  }, []).map((D) => D.drawPosition), I = cF({ orderedSortedFirstRoundSeededDrawPositions: g, validSeedBlocks: p, byesToPlace: o }), y = mS({ orderedSeedDrawPositions: g, relevantMatchUps: t }).slice(0, o), U = mS({ orderedSeedDrawPositions: I, relevantMatchUps: t }).slice(0, o);
  return { strictSeedOrderByePositions: y, blockSeedOrderByePositions: U, isLuckyStructure: u, positionedSeeds: l, isContainer: d, isFeedIn: c };
}
function mS({ orderedSeedDrawPositions: e, relevantMatchUps: t }) {
  let r = t.map((i) => i.drawPositions).map((i) => i == null ? void 0 : i.sort((n, a) => n - a)).filter((i) => (i == null ? void 0 : i[0]) + 1 === (i == null ? void 0 : i[1]));
  return e.map((i) => r.find((n) => n == null ? void 0 : n.includes(i))).filter(Boolean).map((i) => i == null ? void 0 : i.reduce((n, a) => e.includes(a) ? n : a, void 0)).filter(Boolean);
}
function dF({ provisionalPositioning: e, seedOrderByePositions: t, isLuckyStructure: r, appliedPolicies: i, drawDefinition: n, seedLimit: a, structure: o, isFeedIn: s }) {
  var A, N;
  let c = (A = i == null ? void 0 : i.seeding) == null ? void 0 : A.seedingProfile, u = o.stage === ge, { positionAssignments: d } = Yt({ structure: o }), p = d == null ? void 0 : d.filter((O) => O.participantId).map((O) => O.drawPosition), l = { isCollectionMatchUp: !1 }, { matchUps: m, roundMatchUps: f } = Ke({ provisionalPositioning: e, matchUpFilters: l, structure: o }), h = (f == null ? void 0 : f[1]) || [], g = o.structureType === br ? m : h, I = Te([].concat(...g.map((O) => O.drawPositions))), y = Math.min(...I) - 1, U = p == null ? void 0 : p.filter((O) => I.includes(O)), S = (O) => {
    let k = Math.ceil(O.length / 2), F = [O.slice(0, k), O.slice(k)], x = F.map((K) => [].concat(...K.flat(1 / 0)).length), _ = Math.min(...x.flat(1 / 0)), B = Math.max(...x.flat(1 / 0)), L = x.indexOf(B), G = _ !== B, $ = yr(F), [W, q] = !_ || G ? [F[L], F[1 - L]] : [$[0], $[1]];
    return { greaterHalf: W, lesserHalf: q };
  }, D = (O) => {
    let { greaterHalf: k, lesserHalf: F } = S(O), { greaterHalf: x, lesserHalf: _ } = S(k), B = yr(x.flat(1 / 0)).pop(), L = x.flat().filter((G) => G !== B);
    return { newlyFilteredChunks: [...F, ..._, L], drawPosition: B };
  }, w = (O) => !t.includes(O), v = (O) => !(U != null && U.includes(O)), P = (O) => {
    let k = zt(O.sort(Ft), Math.ceil(O.length / 4)).map((_) => _.filter(v)), F = [].concat(...k.flat(1 / 0)).length, x = [];
    for (let _ = 0; _ < F; _++) {
      let { newlyFilteredChunks: B, drawPosition: L } = D(k);
      x.push(L), k = B;
    }
    return x;
  }, { validSeedBlocks: b } = ls({ provisionalPositioning: e, allPositions: !0, appliedPolicies: i, drawDefinition: n, structure: o }), T = b == null ? void 0 : b.map((O) => {
    var k;
    return (k = O.drawPositions) == null ? void 0 : k.map((F) => F + y);
  }), R;
  if (s) {
    let O = I.length, { seedBlocks: k } = dI({ cluster: ud(c) === cp, participantsCount: O });
    R = k.map((F) => F.map((x) => x + y)).map(P).filter((F) => F.length);
  } else
    u ? R = T == null ? void 0 : T.map((O) => O.filter(v)) : R = T == null ? void 0 : T.map(P).filter((O) => O.length);
  let M = g.map((O) => O.drawPositions).map((O) => O == null ? void 0 : O.sort((k, F) => k - F)).filter((O) => (O == null ? void 0 : O[0]) + 1 === (O == null ? void 0 : O[1])), E = (O) => M.reduce((k, F) => F.includes(O) ? F.reduce((x, _) => _ !== O ? _ : x, void 0) : k, void 0), C = R.map((O) => O.map(E)).flat(1 / 0).filter(v).filter(w).filter(Boolean);
  if (u && !o.structures) {
    let O = a % 4, k = C.slice(0, O), F = (N = f[o.roundLimit]) == null ? void 0 : N.length, x = zt(C.slice(O), F).map(yr).flat();
    C = k.concat(x);
  }
  return { unseededByePositions: C };
}
function lF({ provisionalPositioning: e, drawDefinition: t, matchUpsMap: r, structure: i, event: n }) {
  var T;
  let a = { isCollectionMatchUp: !1 }, { matchUps: o, roundMatchUps: s } = Ke({ afterRecoveryTimes: !1, provisionalPositioning: e, drawDefinition: t, matchUpFilters: a, matchUpsMap: r, structure: i, event: n }), c = (s == null ? void 0 : s[1]) || [], u = (i == null ? void 0 : i.structureType) === br, d = u ? o : c, p = u ? ((T = i == null ? void 0 : i.structures) == null ? void 0 : T.length) || 0 : o.length, { structureId: l, stage: m, stageSequence: f } = i, h = ts({ entryStatuses: $i, provisionalPositioning: e, drawDefinition: t, stageSequence: f, structureId: l, stage: m }), { qualifiersCount: g } = yc({ provisionalPositioning: e, drawDefinition: t, stageSequence: f, structureId: l, stage: m }), I = h.length + g, { positionAssignments: y, unassignedPositions: U } = Yt({ structure: i }), S = U == null ? void 0 : U.map((R) => R.drawPosition), D = y == null ? void 0 : y.filter((R) => R.bye).length, w = y == null ? void 0 : y.filter((R) => R.bye).map((R) => R.drawPosition), v = d.map((R) => R.drawPositions).filter((R) => R == null ? void 0 : R.reduce((M, E) => !(w != null && w.includes(E)) && M, !0)).flat(1 / 0).filter((R) => S == null ? void 0 : S.includes(R)), P = y == null ? void 0 : y.length, b = P ? P - I : 0;
  return b > p && i.stageSequence === 1 && i.stage !== lr && (b = p), { placedByes: D, byesCount: b, relevantMatchUps: d, placedByePositions: w, roundMatchUps: s, positionsToAvoidDoubleBye: v };
}
function fS({ provisionalPositioning: e, tournamentRecord: t, appliedPolicies: r, drawDefinition: i, seedBlockInfo: n, seedingProfile: a, matchUpsMap: o, structureId: s, structure: c, seedLimit: u, seedsOnly: d, event: p }) {
  var M;
  c || ({ structure: c } = ve({ drawDefinition: i, structureId: s })), s || (s = c == null ? void 0 : c.structureId);
  let l = !((c == null ? void 0 : c.structures) ?? (c == null ? void 0 : c.stage) === ge), { byesCount: m, placedByes: f, relevantMatchUps: h } = lF({ provisionalPositioning: e, drawDefinition: i, matchUpsMap: o, structure: c, event: p }), g = m - (f || 0);
  if (g <= 0)
    return { ...V };
  let { strictSeedOrderByePositions: I, blockSeedOrderByePositions: y, isLuckyStructure: U, isFeedIn: S } = uF({ provisionalPositioning: e, relevantMatchUps: h, appliedPolicies: r, drawDefinition: i, seedingProfile: a, seedBlockInfo: n, byesToPlace: g, structure: c }), D = (c == null ? void 0 : c.structureType) && [br, up].includes(c.structureType) && ((M = r == null ? void 0 : r.seeding) == null ? void 0 : M.containerByesIgnoreSeeding), w = l && (y != null && y.length) ? y : I, { unseededByePositions: v } = dF({ provisionalPositioning: e, seedOrderByePositions: w, isLuckyStructure: U, appliedPolicies: r, drawDefinition: i, seedLimit: u, structure: c, isFeedIn: S }), P = (E) => E % 2, b = (E, C) => (E || []).every((A) => P(A) ? C !== A + 1 : C !== A - 1), T = [].concat(...w);
  if (!d)
    for (; v.length; ) {
      let E = v.find((C) => b(T, C));
      E ? (T.push(E), v = v.filter((C) => C !== E)) : (T.push(...v), v = []);
    }
  D && (T = yr(T), oi({ ignoreSeededByes: D }) && console.log({ byePositions: T }));
  let R = T.slice(0, g);
  for (let E of R) {
    let C = pi({ provisionalPositioning: e, tournamentRecord: t, drawDefinition: i, drawPosition: E, matchUpsMap: o, structureId: s, structure: c, event: p });
    if (C != null && C.error)
      return C;
  }
  return { ...V, unseededByePositions: v, byeDrawPositions: R };
}
function dd(e) {
  var A, N, O, k;
  let { drawDefinition: t } = e, { applyPositioning: r = !0, provisionalPositioning: i, multipleStructures: n, placeByes: a = !0, tournamentRecord: o, placementGroup: s, seedingProfile: c, structureId: u, seedLimit: d, seedsOnly: p, drawType: l, drawSize: m, event: f } = e, h = [];
  r || (jw(), t = ce(t, !1, !0));
  let g = (F) => (r || Wd(), j({ result: F, stack: "automatedPositioning" })), I = (F) => (r || Wd(), F), y = ve({ drawDefinition: t, structureId: u });
  if (y.error)
    return g(y);
  let U = y.structure;
  if (!U)
    return { error: It };
  let S = e.appliedPolicies || ((A = je({ drawDefinition: t, structure: U, event: f })) == null ? void 0 : A.appliedPolicies), { qualifiersCount: D } = yc({ stageSequence: U.stageSequence, provisionalPositioning: i, stage: U.stage, drawDefinition: t, structureId: u }), w = mo;
  if (!((N = ts({ stageSequence: U.stageSequence, provisionalPositioning: i, stage: U.stage, placementGroup: s, drawDefinition: t, entryStatuses: w, structureId: u })) != null && N.length) && !D)
    return I({ ...V });
  let v = e.matchUpsMap ?? mr({ drawDefinition: t }), P = e.inContextDrawMatchUps ?? ((O = Bt({ inContext: !0, drawDefinition: t, matchUpsMap: v })) == null ? void 0 : O.matchUps), b = [], T = ls({ provisionalPositioning: i, appliedPolicies: S, drawDefinition: t, seedingProfile: c, structure: U });
  if (T.error)
    return T;
  let { validSeedBlocks: R } = T;
  h.push({ validSeedBlocks: R });
  let M = e.participants || (o ? (k = Ut({ withIndividualParticipants: !0, convertExtensions: !0, tournamentRecord: o })) == null ? void 0 : k.participants : []);
  if (ud(U.seedingProfile || c) === qa) {
    let F = a ? fS({ provisionalPositioning: i, tournamentRecord: o, appliedPolicies: S, drawDefinition: t, seedBlockInfo: T, matchUpsMap: v, structure: U, seedLimit: d, seedsOnly: p, event: f }) : void 0;
    if (F != null && F.error)
      return g(F);
    b = F.unseededByePositions, h.push({ action: "positionByes", unseededByePositions: b });
    let x = U.seedingProfile ? { positioning: U.seedingProfile } : c;
    if (F = pS({ seedingProfile: x, provisionalPositioning: i, inContextDrawMatchUps: P, tournamentRecord: o, appliedPolicies: S, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: v, structure: U, event: f }), F.error)
      return g(F);
    h.push({ seedPositions: F.seedPositions, action: "positionSeedBlocks" });
  } else {
    if (l !== so) {
      let x = U.seedingProfile ? { positioning: U.seedingProfile } : c, _ = pS({ seedingProfile: x, provisionalPositioning: i, inContextDrawMatchUps: P, tournamentRecord: o, appliedPolicies: S, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: v, structure: U, event: f });
      if (_.error)
        return g(_);
      h.push({ action: "positionSeedBlocks", seedPositions: _.seedPositions });
    }
    let F = a ? fS({ provisionalPositioning: i, tournamentRecord: o, appliedPolicies: S, drawDefinition: t, seedBlockInfo: T, matchUpsMap: v, structure: U, seedLimit: d, seedsOnly: p, event: f }) : void 0;
    if (F != null && F.error)
      return g(F);
    b = F == null ? void 0 : F.unseededByePositions, h.push({ action: "positionByes", byeDrawPositions: F == null ? void 0 : F.byeDrawPositions, unseededByePositions: b });
  }
  let E = {};
  if (!p) {
    let F = nF({ inContextDrawMatchUps: P, tournamentRecord: o, appliedPolicies: S, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: v, structure: U });
    if (F.error || (F.conflicts && (E.qualifierConflicts = F.conflicts), h.push({ action: "positionQualifiers", qualifierDrawPositions: F.qualifierDrawPositions }), F = rF({ provisionalPositioning: i, inContextDrawMatchUps: P, unseededByePositions: b, multipleStructures: n, tournamentRecord: o, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: v, structureId: u, structure: U, drawSize: m, event: f }), F.error))
      return g(F);
    F.conflicts && (E.unseededConflicts = F.conflicts), h.push({ action: "positionUnseededParticipants" });
  }
  let { positionAssignments: C } = ot({ drawDefinition: t, structure: U });
  return ut({ drawDefinition: t, structureIds: [u] }), r || Wd(), { positionAssignments: C, conflicts: E, ...V, positioningReport: h };
}
function wc(e) {
  var l;
  let { applyPositioning: t = !0, provisionalPositioning: r, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, placeByes: s, seedsOnly: c } = e;
  if (!n)
    return { error: ai };
  if (!wa({ drawDefinition: n, structureId: o }) && !r)
    return { error: Ih };
  let u = (l = VT({ drawDefinition: n, structureId: o }).playoffStructures) == null ? void 0 : l.sort((m, f) => hl(m) - hl(f)), d = [], p = [];
  if (u)
    for (let m of u) {
      let { structureId: f } = m, h = dd({ structureId: f, provisionalPositioning: r, applyPositioning: t, tournamentRecord: i, drawDefinition: n, seedingProfile: a, placeByes: s, seedsOnly: c });
      if (h.error)
        return h;
      h.positionAssignments && d.push({ positionAssignments: h.positionAssignments, structureId: f }), h.positioningReport && p.push(h.positioningReport);
    }
  return { ...V, structurePositionAssignments: d, positioningReports: p };
}
function qT({ drawDefinition: e, orderMap: t }) {
  return e ? ((typeof t != "object" || !Object.values(t).every((r) => Pe(r))) && j({ result: { error: J }, context: { orderMap: t } }), e.structures || (e.structures = []), e.structures.forEach((r) => {
    let i = t[r.structureId];
    i && (r.structureOrder = i);
  }), e.structures.sort((r, i) => Es(r.structureOrder) - Es(i.structureOrder)), { ...V }) : { error: le };
}
function Gp({ drawDefinition: e }) {
  var g, I, y, U, S, D, w;
  let t = e.structures ?? [], r = e.links ?? [], i = /* @__PURE__ */ new Map(), n = (v) => {
    let P = i.get(v) || i.set(v, { drawSources: [], drawTargets: [], progeny: [], sources: [], targets: [] }) && i.get(v);
    if (P && !(P != null && P.stage)) {
      let b = t.find((T) => T.structureId === v);
      P.stage = b == null ? void 0 : b.stage;
    }
    return P;
  }, a = {}, o = {}, s = r.map((v) => {
    let P = v.source.structureId, b = v.target.structureId, T = n(P), R = n(b);
    return [Wa, Ei, dp, qa].includes(v.target.feedProfile) ? (T == null || T.targets.push(b), R == null || R.sources.push(P)) : v.target.feedProfile === Ni && (R == null || R.drawSources.push(P), T == null || T.drawTargets.push(b)), o[b] = o[b] || v.target.feedProfile === Ni, a[b] = Te([...a[b] || [], P]).filter(Boolean), [v.source.structureId, v.target.structureId];
  });
  for (let v of i.keys()) {
    let P = i.get(v);
    if (P) {
      let b = P.targets ?? [];
      for (; b.length; ) {
        let T = b.pop(), R = T && i[T];
        (g = R == null ? void 0 : R.targets) != null && g.length ? b.push(...R.targets) : R && (P.rootStage = R.stage);
      }
      if (P.rootStage || (P.rootStage = P.stage), !((I = P.targets) != null && I.length)) {
        let T = P.sources ?? [];
        for (; T.length; ) {
          let R = T.pop(), M = R && i[R];
          if ((y = M == null ? void 0 : M.sources) != null && y.length) {
            for (let E of M.sources)
              (U = P.progeny) != null && U.includes(E) || ((S = P.progeny) == null || S.push(E));
            T.push(...M.sources);
          }
        }
      }
    }
  }
  let c = 0;
  for (let v of i.keys()) {
    let P = i.get(v);
    if (P && P.rootStage === ge) {
      let b = [(D = P.drawTargets) == null ? void 0 : D[0]], T = 0;
      for (; b.length; ) {
        T += 1;
        let R = b.pop(), M = R ? i.get(R) : void 0;
        (w = M == null ? void 0 : M.drawTargets) != null && w.length && b.push(M.drawTargets[0]);
      }
      P.distanceFromMain = T, T > c && (c = T);
    }
  }
  let u = s.length;
  oe(0, Math.ceil(u / 2)).forEach(() => {
    s = oe(0, u).map((v) => {
      let P = s[v], b = s.reduce((T, R) => wr(P, R) ? T.concat(...R) : T, []) || [];
      return Te(P.concat(...b));
    });
  });
  let d = s[0], p = (v, P) => wt(v, P).length === v.length, l = s.slice(1).reduce((v, P) => v && p(P, d), !0), m = [d].filter(Boolean), f = [d].filter(Boolean);
  t.forEach((v) => {
    let { structureId: P, stage: b } = v;
    m.find((T) => T.includes(P)) || (m.push([P]), b !== Jt && f.push([P]));
  });
  let h = l && f.length === 1;
  return !(r != null && r.length) && t.length === 1 && n(t[0].structureId), { structureProfiles: Object.fromEntries(i), allStructuresLinked: h, maxQualifyingDepth: c, sourceStructureIds: a, hasDrawFeedProfile: o, structureGroups: m };
}
function WT({ drawDefinition: e }) {
  let { maxQualifyingDepth: t, structureProfiles: r } = Gp({ drawDefinition: e });
  for (let i of e.structures) {
    let n = r[i.structureId];
    n.distanceFromMain && (i.stageSequence = t + 1 - n.distanceFromMain);
  }
  return { ...V };
}
function yI(e) {
  let t = fe(e, [{ [Gt]: !0, [Rr]: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, drawDefinition: i, structure: n, link: a } = e;
  return pF({ tournamentId: r.tournamentId, drawDefinition: i, structure: n, link: a });
}
function pF(e) {
  var d;
  let t = fe(e, [{ [Rr]: !0, [hp]: !0 }, { link: !0, [Or]: _r, [Nv]: wh }]);
  if (t.error)
    return t;
  let { drawDefinition: r, tournamentId: i, structure: n, eventId: a, link: o } = e, s = o.target.structureId, c = ve({ drawDefinition: r, structureId: s });
  if (c.error)
    return j({ stack: "attachQualifyingStructure", context: { targetStructureId: s }, result: c });
  r.structures || (r.structures = []), r.links || (r.links = []), r.structures.push(n), r.links.push(o), WT({ drawDefinition: r });
  let u = ((d = Ke({ structure: n })) == null ? void 0 : d.matchUps) || [];
  return ya({ drawDefinition: r, tournamentId: i, matchUps: u, eventId: a }), ut({ drawDefinition: r, structureIds: [n.structureId] }), { ...V };
}
function HT({ drawDefinition: e, structureDetails: t }) {
  if (!Array.isArray(t))
    return { error: J };
  if (!e)
    return { error: le };
  let r = Object.assign({}, ...t.map((i) => {
    if (!Le(i))
      return;
    let { structureId: n, structureName: a } = i || {};
    if (!(!n || !a))
      return { [n]: a };
  }).filter(Boolean));
  if (!Object.values(r).length)
    return { error: Ie };
  for (let i of e.structures || []) {
    let n = r[i.structureId];
    if (n && (i.structureName = n), i.structures)
      for (let a of i.structures) {
        let o = r[a.structureId];
        o && (a.structureName = o);
      }
  }
  return { ...V };
}
function SI({ drawDefinition: e, timeItem: t }) {
  if (!e)
    return { error: ai };
  if (!t)
    return { error: Lh };
  let r = t && Object.keys(t), i = ["itemType", "itemValue"];
  if (i.filter((a) => r.includes(a)).length !== i.length)
    return { error: xh };
  e.timeItems || (e.timeItems = []);
  let n = (/* @__PURE__ */ new Date()).toISOString();
  return Object.assign(t, { createdAt: n }), e.timeItems.push(t), Vu({ drawDefinition: e }), { ...V };
}
function zT(e) {
  var I;
  let { tournamentRecord: t, drawDefinition: r, structureId: i, event: n } = e, a = fe(e, [{ drawDefinition: !0, structureId: !0 }]);
  if (a.error)
    return a;
  let o = r.structures ?? [], s = o.find((y) => y.structureId === i);
  if (!s)
    return { error: It };
  let c = o.find(({ stage: y, stageSequence: U }) => y === ue && U === 1), u = i === (c == null ? void 0 : c.structureId), d = o.filter(({ stage: y }) => y === ge).map(ei("structureId"));
  if (u && !d.length)
    return { error: Ev };
  let p = d.includes(i), l = mF({ isQualifyingStructure: p, structure: s, ...e });
  if (l != null && l.error)
    return l;
  let { structureIdsToRemove: m, relatedStructureIdsMap: f } = hF({ qualifyingStructureIds: d, isQualifyingStructure: p, isMainStageSequence1: u, mainStageSequence1: c, drawDefinition: r, structureId: i }), { removedMatchUpIds: h, removedStructureIds: g } = gF({ relatedStructureIdsMap: f, qualifyingStructureIds: d, isMainStageSequence1: u, mainStageSequence1: c, drawDefinition: r, structureIdsToRemove: m, structureId: i });
  if (fF({ removedMatchUpIds: h, drawDefinition: r }), u) {
    let y = (I = c.matchUps ?? []) == null ? void 0 : I.map(ei("matchUpId"));
    h.push(...y), c.positionAssignments = [], c.seedAssignments = [], c.matchUps = [], c.extensions && (c.extensions = []);
  }
  return p && WT({ drawDefinition: r }), ta({ tournamentId: t == null ? void 0 : t.tournamentId, matchUpIds: h, action: "removeStructure", eventId: n == null ? void 0 : n.eventId, drawDefinition: r }), ut({ drawDefinition: r, eventId: n == null ? void 0 : n.eventId }), { ...V, removedMatchUpIds: h, removedStructureIds: g };
}
function mF({ isQualifyingStructure: e, tournamentRecord: t, drawDefinition: r, structureId: i, structure: n, event: a, force: o }) {
  var c, u, d, p, l, m;
  let s = [i];
  if (e) {
    let f = (g) => {
      var I;
      return (I = r.links) == null ? void 0 : I.find((y) => y.target.structureId === g);
    }, h = (c = f(i)) == null ? void 0 : c.source.structureId;
    for (; h; )
      s.push(h), h = (u = f(h)) == null ? void 0 : u.source.structureId;
  }
  if ((d = Bt({ matchUpFilters: { structureIds: s }, drawDefinition: r }).matchUps) != null && d.some(({ score: f }) => jt({ score: f }))) {
    let f = (p = je({ tournamentRecord: t, drawDefinition: r, structure: n, event: a })) == null ? void 0 : p.appliedPolicies;
    if (!(o ?? ((m = (l = f == null ? void 0 : f[yi]) == null ? void 0 : l.allowDeletionWithScoresPresent) == null ? void 0 : m.structures)))
      return { error: tp };
  }
  return { ...V };
}
function fF({ removedMatchUpIds: e, drawDefinition: t }) {
  let { matchUps: r } = Bt({ drawDefinition: t });
  r == null || r.forEach((i) => {
    i.winnerMatchUpId && e.includes(i.winnerMatchUpId) && delete i.winnerMatchUpId, i.loserMatchUpId && e.includes(i.loserMatchUpId) && delete i.loserMatchUpId;
  });
}
function hF({ qualifyingStructureIds: e, isQualifyingStructure: t, isMainStageSequence1: r, mainStageSequence1: i, drawDefinition: n, structureId: a }) {
  let o = (n.structures ?? []).map(ei("structureId")), s = (d) => {
    var p;
    return ((p = n.links) == null ? void 0 : p.map((l) => l.source.structureId === d && l.target.structureId !== (i == null ? void 0 : i.structureId) && l.target.structureId).filter(Boolean)) ?? [];
  }, c = (d) => {
    var p;
    return ((p = n.links) == null ? void 0 : p.map((l) => e.includes(l.source.structureId) && l.target.structureId === d && l.source.structureId).filter(Boolean)) ?? [];
  }, u = /* @__PURE__ */ new Map();
  return o.forEach((d) => u.set(d, t ? c(d) : s(d))), { structureIdsToRemove: r ? u.get(a) : [a], relatedStructureIdsMap: u };
}
function gF({ relatedStructureIdsMap: e, qualifyingStructureIds: t, isMainStageSequence1: r, mainStageSequence1: i, drawDefinition: n, structureIdsToRemove: a, structureId: o }) {
  let s = [], c = [];
  for (; a != null && a.length; ) {
    let u = a.pop();
    c.push(...yF({ idBeingRemoved: u, drawDefinition: n }));
    let d = UF({ qualifyingStructureIds: t, isMainStageSequence1: r, idBeingRemoved: u, drawDefinition: n, structureId: o });
    s.push(...d.removedStructureIds);
    let p = IF({ relatedStructureIdsMap: e, mainStageSequence1: i, idBeingRemoved: u, structureId: o });
    p != null && p.length && a.push(...p);
  }
  return { removedMatchUpIds: c, removedStructureIds: s };
}
function IF({ idBeingRemoved: e, relatedStructureIdsMap: t, mainStageSequence1: r, structureId: i }) {
  var n;
  return e && ((n = t.get(e)) == null ? void 0 : n.filter((a) => a !== (r == null ? void 0 : r.structureId) || i === r.structureId));
}
function UF({ qualifyingStructureIds: e, isMainStageSequence1: t, idBeingRemoved: r, drawDefinition: i, structureId: n }) {
  var o;
  let a = [];
  return i.links = ((o = i.links) == null ? void 0 : o.filter((s) => s.source.structureId !== r && s.target.structureId !== r)) ?? [], (!t || t && e.length || r !== n) && (i.structures = (i.structures ?? []).filter((s) => (r && r === s.structureId && a.push(r), s.structureId !== r))), { removedStructureIds: a };
}
function yF({ idBeingRemoved: e, drawDefinition: t }) {
  let { structure: r } = ve({ structureId: e, drawDefinition: t }), i = Ke({ structure: r }).matchUps;
  return Sg(i);
}
function Dl({ stageSequence: e = 1, drawDefinition: t, drawSize: r, stage: i }) {
  if (!t)
    return { error: le };
  if (!Wg({ drawDefinition: t, stage: i }))
    return { error: oo };
  let n = SO({ drawDefinition: t, stage: i }), { qualifiersCount: a } = yc({ drawDefinition: t, stageSequence: e, stage: i }), o = n + a;
  if (r < o)
    return { error: vh };
  let { entryProfile: s } = qg({ attributes: [{ [i]: { drawSize: r } }], drawDefinition: t });
  return ut({ drawDefinition: t }), { ...V, entryProfile: s };
}
function YT({ qualifiersCount: e = 0, drawDefinition: t, stage: r }) {
  return t ? Wg({ drawDefinition: t, stage: r }) ? r !== ue ? { error: vh, info: "qualifiersCount can only be set for main stage" } : (qg({ attributes: [{ [r]: { qualifiersCount: e } }], drawDefinition: t }), ut({ drawDefinition: t }), { ...V }) : { error: oo } : { error: le };
}
function SF({ drawDefinition: e, drawSize: t }) {
  if (!e)
    return { error: le };
  let r = Dl({ stage: Jt, stageSequence: 1, drawDefinition: e, drawSize: t });
  return r.error ? r : (ut({ drawDefinition: e }), { ...V });
}
function KT(e) {
  return SF(e);
}
var vF = "qualifierDrawPositionAssignment", wF = "withdrawParticipantAtDrawPosition", PF = "alternateDrawPositionAssignment", DF = "luckyLoserDrawPositionAssignment", hS = "removeDrawPositionAssignment", QT = "swapDrawPositionAssignments", TF = "modifyPairAssignment", bF = "adHocPositionSwap", RF = "modifyParticipantOtherName", gS = "assignDrawPosition", MF = "removeSeededParticipant", NF = "assignDrawPositionBye", AF = "modifySeedAssignment", JT = "addPenalty", vI = "MODIFY_PAIR", $p = "QUALIFIER", wI = "ALTERNATE", PI = "WITHDRAW", Vo = "ASSIGN", Wf = "REMOVE", DI = "LUCKY", qc = "REMOVE_SEED", qp = "SWAP", mu = "NICKNAME", Ro = "SEED_VALUE", jo = "PENALTY", Tl = "BYE", EF = { MODIFY_PAIR_ASSIGNMENT: vI, QUALIFYING_PARTICIPANT: $p, ALTERNATE_PARTICIPANT: wI, WITHDRAW_PARTICIPANT: PI, ASSIGN_PARTICIPANT: Vo, LUCKY_PARTICIPANT: DI, REMOVE_ASSIGNMENT: Wf, SWAP_PARTICIPANTS: qp, ADD_NICKNAME: mu, REMOVE_SEED: qc, ADD_PENALTY: jo, ASSIGN_BYE: Tl, SEED_VALUE: Ro };
function XT({ tournamentRecord: e, drawDefinition: t, drawPositions: r, structureId: i, event: n }) {
  if (!t)
    return { error: le };
  if (!i)
    return { error: ui };
  if ((r == null ? void 0 : r.length) !== 2)
    return { error: J, drawPositions: r };
  let a = mr({ drawDefinition: t }), { matchUps: o } = Bt({ inContext: !0, drawDefinition: t, matchUpsMap: a }), { structure: s } = ve({ drawDefinition: t, structureId: i });
  if (!s)
    return { error: It };
  let c = je({ tournamentRecord: e, drawDefinition: t, event: n }).appliedPolicies ?? {}, u;
  if (s.structureType === br ? u = kF({ inContextDrawMatchUps: o, tournamentRecord: e, drawDefinition: t, drawPositions: r, matchUpsMap: a, structure: s, event: n }) : u = CF({ inContextDrawMatchUps: o, tournamentRecord: e, drawDefinition: t, drawPositions: r, matchUpsMap: a, structure: s, event: n }), u.error)
    return u;
  if (_g({ structure: s, drawPositions: r }), bp({ appliedPolicies: c, drawDefinition: t, positionAction: { name: QT, drawPositions: r, structureId: i } }), Sa({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t, structure: s, event: n }), n.eventType === Xr) {
    let d = Ke({ matchUpFilters: { matchUpTypes: [ni] }, inContext: !0, structure: s }).matchUps.filter((l) => {
      var m;
      return (m = l.drawPositions) == null ? void 0 : m.some((f) => r.includes(f));
    }), p = Ke({ matchUpFilters: { matchUpTypes: [ni] }, structure: s }).matchUps;
    d.forEach((l) => {
      (l.sides || []).forEach((m) => {
        var h;
        let f = m == null ? void 0 : m.drawPosition;
        if (r.includes(f)) {
          let g = m.participantId, I = p.find(({ matchUpId: U }) => U === l.matchUpId), y = (h = l == null ? void 0 : l.sides) == null ? void 0 : h.reduce((U, S, D) => S.drawPosition === f ? D : U, void 0);
          mI({ inContextTargetMatchUp: l, drawPositionSideIndex: y, teamParticipantId: g, tournamentRecord: e, drawDefinition: t, matchUp: I, event: n });
        }
      });
    });
  }
  return ut({ drawDefinition: t, structureIds: [i] }), { ...V };
}
function CF({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPositions: i, matchUpsMap: n, structure: a, event: o }) {
  let s = a == null ? void 0 : a.positionAssignments.filter((u) => i == null ? void 0 : i.includes(u.drawPosition));
  if (!s)
    return { error: J, structure: a, info: "Missing positionAssignments" };
  if (s.filter(({ bye: u }) => u).length === 2)
    return { ...V };
  if (s.filter(({ qualifier: u }) => u).length === 2)
    return { ...V };
  let c = s.some(({ qualifier: u }) => u);
  return s.some(({ bye: u }) => u) && !c ? ZT({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o }) : OF({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o });
}
function ZT({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: i, matchUpsMap: n, structure: a, event: o }) {
  let s = i.find(({ bye: f }) => f), c = i.find(({ participantId: f }) => f), u = s.drawPosition, { participantId: d, drawPosition: p } = c, { structureId: l } = a, m = pu({ drawPosition: u, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: l, matchUpsMap: n });
  return m.error || (m = pu({ drawPosition: p, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: l, matchUpsMap: n }), m.error) || (pi({ drawPosition: p, tournamentRecord: t, drawDefinition: r, structureId: l, matchUpsMap: n, event: o }), m = mn({ drawPosition: u, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: l, participantId: d, matchUpsMap: n, event: o }), m.error) ? m : { ...V };
}
function OF({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: i, matchUpsMap: n, structure: a, event: o }) {
  let s = Object.assign({}, ...i.map((c, u) => {
    let { drawPosition: d } = c, p = { ...i[1 - u], drawPosition: d };
    return { [d]: p };
  }));
  return a.positionAssignments = a.positionAssignments.map((c) => s[c.drawPosition] || c), hI({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, assignments: i, structure: a, event: o }), { ...V };
}
function kF({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPositions: i, matchUpsMap: n, structure: a, event: o }) {
  var u;
  let s = (u = a.structures) == null ? void 0 : u.reduce((d, p) => {
    let l = p == null ? void 0 : p.positionAssignments.filter((m) => i == null ? void 0 : i.includes(m.drawPosition));
    return l && d.push(...l), d;
  }, []);
  if (s.filter(({ bye: d }) => d).length === 2)
    return { ...V };
  if (s.filter(({ qualifier: d }) => d).length === 2)
    return { ...V };
  hI({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, assignments: s, structure: a, event: o });
  let c = s.some(({ qualifier: d }) => d);
  if (s.some(({ bye: d }) => d) && !c)
    ZT({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o });
  else {
    let d = ce(s, !1, !0);
    s.forEach((p, l) => {
      let m = d[1 - l].participantId;
      p.qualifier = d[1 - l].qualifier, p.participantId = m;
    });
  }
  return { ...V };
}
function eb({ tournamentRecord: e, drawDefinition: t, participantId: r, structureId: i }) {
  var o;
  let n = "removeSeededParticipant";
  if (!e)
    return { error: ae };
  if (!t)
    return { error: le };
  let a = (t.structures ?? []).find((s) => s.structureId === i);
  return a ? !a.stage || ![ue, ge].includes(a.stage) || a.stage === ue && a.stageSequence !== 1 ? j({ result: { error: no }, stack: n }) : (o = a.seedAssignments) != null && o.find((s) => s.participantId === r) ? { ...V } : j({ info: "participant not seeded", result: { error: Zt }, context: { participantId: r } }) : j({ result: { error: It }, stack: n });
}
function ld({ targetEntryRound: e = 1, finishingPositions: t, sourceRoundNumber: r, sourceStructureId: i, targetStructureId: n, linkType: a = Hn }) {
  return !i || !n ? { error: ui } : { link: me({ linkType: a, source: { roundNumber: r, structureId: i, finishingPositions: t }, target: { feedProfile: Ni, roundNumber: e, structureId: n } }) };
}
function TI({ roundPosition: e, roundNumber: t, idPrefix: r, uuids: i }) {
  return r ? `${r}-${t}-${e}` : (i == null ? void 0 : i.pop()) || ze();
}
function bl({ includeMatchUpType: e, matchUpType: t, roundNumber: r, matchUps: i, idPrefix: n, isMock: a, uuids: o, nodes: s }) {
  let c = 0, u = [], d = 1, p = r - 1, l = s == null ? void 0 : s.length;
  for (; c < (l || 0); ) {
    let m = s == null ? void 0 : s[c], f = s == null ? void 0 : s[c + 1];
    p && (m.roundNumber = p), f && p && (f.roundNumber = p);
    let h = TI({ roundPosition: d, roundNumber: r, idPrefix: n, uuids: o }), g = { roundPosition: d, children: [m, f], matchUpId: h };
    u.push(g);
    let I = { drawPositions: g.children.map((y) => y == null ? void 0 : y.drawPosition).filter(Boolean), matchUpStatus: Rt, matchUpId: g.matchUpId, roundPosition: d, roundNumber: r };
    e && t && (I.matchUpType = t), a && (I.isMock = !0), i.push(I), d++, c += 2;
  }
  return { roundNodes: u, matchUps: i };
}
function fn({ finishingPositionOffset: e, finishingPositionLimit: t, qualifyingRoundNumber: r, qualifyingPositions: i, matchUpType: n, roundLimit: a, idPrefix: o, drawSize: s, isMock: c, uuids: u }) {
  if (isNaN(s) || s < 2 || i && s <= i)
    return { matchUps: [], roundsCount: 0 };
  if (i && (!Qi(s) || s % i)) {
    let g = i;
    for (; g < s; )
      g = 2 * g;
    s = g;
  }
  let d = i && !(s % 2) && (!isNaN(i) || r && !isNaN(r)) && (s / i === Math.round(s / i) || r && s / r === Math.round(s / r));
  if (!Qi(s) && !d)
    return { matchUps: [], roundsCount: 0 };
  let p = oe(1, s + 1).map((g) => ({ drawPosition: g })), l, m = [], f = 1;
  for ({ roundNodes: l, matchUps: m } = bl({ matchUpType: n, roundNumber: f, idPrefix: o, matchUps: m, isMock: c, nodes: p, uuids: u }), f++, a = a ?? r; l.length > 1; )
    i && l.length === i && (a = f - 1), { roundNodes: l, matchUps: m } = bl({ nodes: l, matchUpType: n, roundNumber: f, idPrefix: o, matchUps: m, isMock: c, uuids: u }), f++;
  let h = f - 1;
  return m = ed({ finishingPositionOffset: e, finishingPositionLimit: t, roundsCount: h, roundLimit: a, matchUps: m }), a ? m = m.filter((g) => a && (g.roundNumber ?? 0) <= a) : a = f - 1, { drawSize: s, matchUps: m, roundsCount: h, roundLimit: a };
}
function bI(e) {
  var k, F, x, _, B, L;
  let t = "generateQualifyingStructure";
  if (!e.drawDefinition)
    return j({ result: { error: le }, stack: t });
  if (e.drawSize && !Pe(e.drawSize) || e.participantsCount && !Pe(e.participantsCount) || e.qualifyingPositions && !Pe(e.qualifyingPositions))
    return j({ result: { error: J }, stack: t });
  let r = e.drawSize ?? hh(e.participantsCount), { qualifyingRoundNumber: i, qualifyingPositions: n, targetStructureId: a, structureOptions: o, appliedPolicies: s, drawDefinition: c, matchUpFormat: u, structureName: d, structureId: p, roundTarget: l, drawType: m, idPrefix: f, isMock: h, uuids: g } = e;
  if (!e.drawSize)
    return j({ result: { error: Tu }, context: { drawSize: r }, stack: t });
  if (n && n >= e.drawSize)
    return j({ result: { error: J }, context: { drawSize: r, qualifyingPositions: n }, stack: t });
  let I, y, U, S, D = 0, w, v = 1, { structureProfiles: P } = Gp({ drawDefinition: c }), b = P[a];
  if (!b)
    return j({ result: { error: It }, context: { targetStructureId: a }, stack: t });
  let T = c.matchUpType, R = l ? `${l}-` : "", M = b.stage === ge, E = ((F = (k = s == null ? void 0 : s[$s]) == null ? void 0 : k.namingConventions) == null ? void 0 : F.pre) ?? ((_ = (x = DO[$s]) == null ? void 0 : x.namingConventions) == null ? void 0 : _.pre), C = M && E ? `${E}-` : "", A = d ?? (R ? `${C}${dr(ge)} ${R}` : `${C}${dr(ge)}`);
  if (m === Li) {
    let { maxRoundNumber: G, structures: $, groupCount: W } = sd({ structureName: d ?? A, structureId: p ?? (g == null ? void 0 : g.pop()), stage: ge, structureOptions: o, appliedPolicies: s, stageSequence: v, matchUpType: T, roundTarget: l, idPrefix: f, drawSize: r, isMock: h, uuids: g });
    D = W, I = G, U = $[0], w = [1];
  } else
    ({ drawSize: r, matchUps: S, roundLimit: I, roundsCount: y } = fn({ qualifyingRoundNumber: i, qualifyingPositions: n, matchUpType: T, idPrefix: f, drawSize: r, isMock: h, uuids: g })), I || (I = y), U = gi({ structureName: d ?? A, structureId: p ?? (g == null ? void 0 : g.pop()), qualifyingRoundNumber: I, stage: ge, matchUpFormat: u, stageSequence: v, matchUpType: T, roundLimit: I, matchUps: S }), l && Ve({ extension: { name: In, value: l }, element: U }), D = (B = S == null ? void 0 : S.filter((G) => G.roundNumber === I)) == null ? void 0 : B.length;
  let N = m === Li ? Wn : Hn, O = U && I && ((L = ld({ sourceStructureId: U.structureId, sourceRoundNumber: I, targetStructureId: a, finishingPositions: w, linkType: N })) == null ? void 0 : L.link);
  return { qualifyingDrawPositionsCount: r, qualifiersCount: D, ...V, structure: U, link: O };
}
function tb(e) {
  if (!e.tournamentRecord)
    return { error: ae };
  let t = FF(e);
  return t.error, t;
}
function FF(e) {
  if (!e.drawDefinition)
    return { error: le };
  if (!e.targetStructureId)
    return { error: ui };
  let t = bI(e);
  if (t.error)
    return t;
  let { structure: r, link: i } = t;
  return !r || !i ? { error: J } : yI({ tournamentRecord: e.tournamentRecord, drawDefinition: e.drawDefinition, structure: r, link: i });
}
function rb(e) {
  var p;
  let t = fe(e, [{ [Rr]: !0, [pp]: !0, [gn]: !0 }, { [T1]: !0, [cr]: (l) => Number.isInteger(l) && l > 0 }, { [cr]: (l) => Array.isArray(l) && l.length === 2 && l.every(ht), [ci]: Yr, participantIds: !0 }]);
  if (t.error)
    return t;
  let { drawDefinition: r, structureId: i, tournamentRecord: n, event: a } = e, { structure: o } = ve({ drawDefinition: r, structureId: i });
  if (!o)
    return { error: It };
  if (!Er({ structure: o }))
    return { error: no };
  let s = (l) => {
    var m;
    return (m = l.sides) == null ? void 0 : m.map((f) => f.participantId).some((f) => e.participantIds.includes(f));
  }, c = (l) => l.roundNumber === e.roundNumber, u = (l) => !jt(l), d = ((o == null ? void 0 : o.matchUps) ?? []).filter(c).filter(u).filter(s);
  if (d.length !== 2)
    return { error: Yr };
  for (let l of d) {
    let m = (p = l == null ? void 0 : l.sides) == null ? void 0 : p.find((f) => e.participantIds.includes(f == null ? void 0 : f.participantId));
    if (m) {
      let f = e.participantIds.find((h) => h !== (m == null ? void 0 : m.participantId));
      m.participantId = f, xe({ tournamentId: n == null ? void 0 : n.tournamentId, eventId: a == null ? void 0 : a.eventId, drawDefinition: r, matchUp: l });
    }
  }
  return ut({ drawDefinition: r, structureIds: [i] }), { ...V };
}
function xF({ includeMatchUpType: e, drawPosition: t, roundNumber: r, matchUpType: i, idPrefix: n, matchUps: a, isMock: o, uuids: s, nodes: c, fed: u }) {
  let d = c.length, p = t ? t - d : void 0, l = oe(0, d).map((h) => p ? p + h : void 0), m = [];
  for (let h = 0; h < d; h++) {
    let g = l.shift(), I = { drawPosition: g, fed: u + 1, feed: !0 }, y = c[h];
    y.roundNumber = r - 1;
    let U = TI({ roundPosition: y.roundPosition, roundNumber: r, idPrefix: n, uuids: s }), S = { roundPosition: y.roundPosition, drawPositions: [g], matchUpStatus: Rt, roundNumber: r, matchUpId: U };
    e && (S.matchUpType = i), o && (S.isMock = !0), a.push(S);
    let D = { children: [y, I] };
    m.push(D);
  }
  let f = t ? t - d : void 0;
  return { roundNodes: m, matchUps: a, drawPosition: f };
}
function Pa(e) {
  let t = e.drawSize, { feedRoundsProfile: r, feedRounds: i = 0, skipRounds: n = 0, baseDrawSize: a } = e, { linkFedFinishingRoundNumbers: o, finishingPositionOffset: s, linkFedRoundNumbers: c, feedsFromFinal: u, isConsolation: d, matchUpType: p, idPrefix: l, isMock: m, uuids: f, fmlc: h } = e;
  a = a ?? C(t);
  let g = LF({ drawSize: a }), I = g.length, y = 0;
  if (r != null && r.length)
    y = r.reduce((A, N) => A + N, 0);
  else if (t) {
    let A = t - a;
    r = g.filter((N) => N <= A ? (A -= N, !0) : !1), y = r.reduce((N, O) => N + O, 0), i = r.length;
  } else
    n >= I ? i = 0 : u && (i = I - u, n = 0), r = g.filter((A, N) => u && !i || i && N >= n + i || N < n ? 0 : A), y = r.reduce((A, N) => A + N, 0), i = r.length;
  let U = [...g, ...r].sort((A, N) => N - A), S = U.length, D = [...(c ?? []).map((A) => A - 1), ...(o ?? []).map((A) => S - A)].map((A) => U[A]).reduce((A, N) => A + N, 0);
  y = y - D;
  let w = 0, v = [], P, b = 1, T = oe(0, a).map((A, N) => ({ drawPosition: N + 1 + y })), R = y + 1;
  for (let A of g) {
    if ({ roundNodes: P, matchUps: v } = bl({ matchUpType: p, roundNumber: b, idPrefix: l, matchUps: v, isMock: m, nodes: T, uuids: f }), b++, r.includes(A)) {
      let N = Qr(r)[A], O = oe(0, N), k = S + 1 - b, F = (o == null ? void 0 : o.includes(k)) ?? (c == null ? void 0 : c.includes(b));
      O.forEach(() => {
        ({ roundNodes: P, matchUps: v, drawPosition: R } = xF({ drawPosition: !F && R || void 0, nodes: P, matchUpType: p, roundNumber: b, idPrefix: l, matchUps: v, isMock: m, uuids: f, fed: w })), b++, w += 1;
      });
    }
    T = P;
  }
  S !== b - 1 && console.log("ERROR");
  let M = a - y;
  v = ed({ finishingPositionOffset: d ? M : s, positionsFed: y, roundsCount: S, matchUps: v, fmlc: h });
  let E = P != null && P.length ? P[0] : P;
  return E && (E.roundNumber = b - 1, E.matchUps = v), { draw: E, matchUps: v, roundsCount: S };
  function C(A) {
    let N = gh(A);
    return N > A ? N / 2 : N;
  }
}
function LF({ drawSize: e }) {
  let t = Math.ceil(Math.log(e) / Math.log(2));
  return oe(0, t).reverse().map((r) => Math.pow(2, r));
}
function Ns(e) {
  let { finishingPositionOffset: t = 0, addNameBaseToAttributeName: r, playoffStructureNameBase: i, finishingPositionNaming: n, finishingPositionLimit: a, playoffAttributes: o, stageSequence: s = 1, exitProfile: c = "0", exitProfileLimit: u, roundOffsetLimit: d, roundOffset: p = 0, drawDefinition: l, staggeredEntry: m, sequenceLimit: f, stage: h = ue, drawSize: g, idPrefix: I, isMock: y, uuids: U } = e;
  if (!(!o || !u || o != null && o[c]) || g < 2 || f && s > f)
    return {};
  let S = [], D = [], w = [], v = e.matchUpType ?? (l == null ? void 0 : l.matchUpType), P = t + 1, b = t + g, T = `${P}-${b}`, R = o == null ? void 0 : o[c], M = i && `${i} ` || "", E = (o == null ? void 0 : o[T]) ?? (n == null ? void 0 : n[T]), C = e.structureName || (E == null ? void 0 : E.name) || (R == null ? void 0 : R.name) && (r ? `${M}${R == null ? void 0 : R.name}` : R.name) || `${M}${T}`, A = (E == null ? void 0 : E.abbreviation) ?? (R == null ? void 0 : R.abbreviation), N = e.structureId ?? (R == null ? void 0 : R.structureId) ?? (U == null ? void 0 : U.pop()), O = { idPrefix: I && `${I}-${C}-RP`, finishingPositionOffset: t, matchUpType: v, drawSize: g, isMock: y, uuids: U }, { matchUps: k } = m ? Pa(O) : fn(O), F = gi({ structureAbbreviation: A, stageSequence: s, structureName: C, matchUpType: v, roundOffset: p, structureId: N, matchUps: k, stage: h });
  S.push(...k), D.push(F);
  let x = Math.ceil(Math.log(g) / Math.log(2)), _ = d ? Math.min(d - p, x) : (!a || P < a) && x || 0;
  return g > 2 && oe(1, _ + 1).forEach((L) => B(L)), { structureId: F.structureId, matchUps: S, structureName: C, structures: D, links: w, ...V };
  function B(L) {
    let G = g / Math.pow(2, L);
    if (G < 2)
      return;
    let $ = g / Math.pow(2, L) + t;
    if (a && $ + 1 > a)
      return;
    let { structures: W, structureId: q, matchUps: K, links: z } = Ns({ finishingPositionOffset: $, exitProfile: `${c}-${L}`, roundOffset: p + L, stageSequence: s + 1, drawSize: G, addNameBaseToAttributeName: r, playoffStructureNameBase: i, finishingPositionNaming: n, finishingPositionLimit: a, playoffAttributes: o, exitProfileLimit: u, roundOffsetLimit: d, drawDefinition: l, sequenceLimit: f, matchUpType: v, idPrefix: I, uuids: U, stage: h });
    if (F.structureId && q) {
      let Y = { linkType: An, source: { roundNumber: L, structureId: F.structureId }, target: { roundNumber: 1, feedProfile: Ei, structureId: q } };
      z && F && z.push(Y), z != null && z.length && w.push(...z);
    }
    return W != null && W.length && D.push(...W), K != null && K.length && S.push(...K), { structureId: q, childLinks: z, structures: D };
  }
}
function RI({ drawDefinition: e, matchUpsMap: t, structureId: r }) {
  let i = ve({ drawDefinition: e, structureId: r });
  if (i.error)
    return j({ result: i });
  let { matchUps: n } = Ke({ structure: i.structure, matchUpsMap: t });
  return { ...Pr({ matchUps: n }), matchUps: n, matchUpsMap: t };
}
function IS({ finishingPositions: e, drawDefinition: t, structureId: r }) {
  var n;
  let { roundProfile: i } = RI({ drawDefinition: t, structureId: r });
  return (n = i && Object.keys(i)) == null ? void 0 : n.reduce((a, o) => (ib(i == null ? void 0 : i[o]).forEach((s) => {
    e.forEach((c) => {
      _F({ position: c, rangeDefinition: s }) && (a[c] = { roundNumber: o });
    });
  }), a), {});
}
function _F({ position: e, rangeDefinition: t }) {
  if (!Array.isArray(t) || t.reduce((n, a) => n || isNaN(a), !1))
    return !1;
  let [r, i] = t;
  return oe(r, (i || r) + 1).includes(e);
}
function ib(e) {
  var t, r;
  return [Te(((t = e == null ? void 0 : e.finishingPositionRange) == null ? void 0 : t.loser) || []), Te(((r = e == null ? void 0 : e.finishingPositionRange) == null ? void 0 : r.winner) || [])];
}
function BF(e) {
  return ib(e).map((t) => oe(t[0], t[1] && t[1] + 1 || t[0] + 1));
}
function Pc({ drawDefinition: e, structureIds: t, matchUpsMap: r }) {
  if (t && !Array.isArray(t))
    return { error: J, context: { structureIds: t } };
  if (!e)
    return { error: le };
  t = t ?? (e.structures ?? []).filter((a) => a.stage !== ge).map(({ structureId: a }) => a);
  let i = t.map((a) => {
    var s;
    let { roundProfile: o } = RI({ drawDefinition: e, matchUpsMap: r, structureId: a });
    return (s = o && Object.values(o)) == null ? void 0 : s.map(BF).flat();
  }).flat(), n = i.filter((a) => (a == null ? void 0 : a.length) === 1).sort(Ft).flat();
  return { positionsNotPlayedOff: Te(i.flat()).filter((a) => !n.includes(a)), positionsPlayedOff: n };
}
function nb({ excludeRoundNumbers: e = [], playoffPositions: t = [], drawDefinition: r, structureId: i }) {
  if (!r)
    return { error: le };
  if (!i)
    return { error: ui };
  if (!t)
    return { error: Ie, info: "missing playoffPositions" };
  let n = Pc({ drawDefinition: r });
  if (n.error)
    return n;
  let a = n.positionsPlayedOff, o = t.filter((I) => !a.includes(I)), s = IS({ finishingPositions: o, drawDefinition: r, structureId: i }), c = Object.values(s).reduce((I, y) => I.includes(y.roundNumber) ? I : I.concat(y.roundNumber), []).map((I) => ye(I)).filter((I) => !e.includes(I)), u = IS({ finishingPositions: a, drawDefinition: r, structureId: i }), d = u ? Object.values(u) : [], p = u ? d.reduce((I, y) => I.includes(y.roundNumber) ? I : I.concat(y.roundNumber), []).map((I) => ye(I)) : [], l = c.filter((I) => !p.includes(I)).sort(Ft), { roundProfile: m } = RI({ drawDefinition: r, structureId: i }), f = l.map((I) => {
    let y = m == null ? void 0 : m[I].finishingPositionRange.loser, [U, S] = y ?? [0, 0];
    return oe(U, (S || U) + 1);
  }).flat().sort(Ft), { playoffRoundsRanges: h } = VF({ playoffSourceRounds: l, roundProfile: m }), g = [...l, ...p];
  return { playoffPositionsReturned: f, playedOffSourceRounds: p, playoffRoundsRanges: h, playoffSourceRounds: l, sourceRounds: g, roundProfile: m };
}
function VF({ playoffSourceRounds: e, roundProfile: t }) {
  return { playoffRoundsRanges: e.map((r) => {
    let i = t[r].finishingPositionRange.loser, [n, a] = i, o = oe(n, (a || n) + 1);
    return { finishingPositionRange: i.join("-"), finishingPositions: o, roundNumber: r };
  }) };
}
function pd({ drawDefinition: e, structureId: t }) {
  if (!e)
    return { error: le };
  let { matchUps: r, matchUpsMap: i } = vr({ inContext: !0, drawDefinition: e }), { positionsNotPlayedOff: n, positionsPlayedOff: a } = Pc({ drawDefinition: e, matchUpsMap: i }), { structures: o } = Bi({ drawDefinition: e }), s = o.filter((u) => !t && u.stage !== Jt || u.structureId === t), c = {};
  for (let u of s) {
    let d = u == null ? void 0 : u.structureId, p = jF({ playoffPositions: n, drawDefinition: e, structure: u, matchUps: r }), { error: l, ...m } = p;
    if (l)
      return p;
    c[d] = { structureId: d, ...m };
  }
  return t ? { positionsPlayedOff: a, ...c[t] } : { availablePlayoffProfiles: Object.values(c), availablePlayoffRounds: Object.values(c), positionsPlayedOff: a };
}
function jF({ playoffPositions: e, drawDefinition: t, structure: r, matchUps: i }) {
  var m, f, h, g, I, y, U, S, D;
  let n = r == null ? void 0 : r.structureId, { links: a } = Ic({ drawDefinition: t, structureId: n });
  if (r.structureType === br || r.structures) {
    let w = (f = (m = ot({ structure: r })) == null ? void 0 : m.positionAssignments) == null ? void 0 : f.length, v = r.structures.length, P = (w ?? 0) / v, b = ((h = a.source) == null ? void 0 : h.flatMap(({ source: F }) => (F == null ? void 0 : F.finishingPositions) || [])) || [], T = oe(1, P + 1).filter((F) => !b.includes(F)), R = ((I = (g = i.find((F) => F.containerStructureId === n && F.finishingPositionRange)) == null ? void 0 : g.finishingPositionRange) == null ? void 0 : I.winner) || [0, 1], M = a == null ? void 0 : a.source.map(({ target: F }) => F.structureId), { positionsPlayedOff: E = [], positionsNotPlayedOff: C = [] } = Pc({ structureIds: M, drawDefinition: t }), A = [...E, ...C], N = oe(R[0], R[1] + 1).filter((F) => !A.includes(F)), O = zt(N, N.length / T.length), k = T.map((F, x) => {
      let _ = O[x], B = [Math.min(..._ || []), Math.max(..._ || [])].join("-");
      return { finishingPosition: F, finishingPositions: _, finishingPositionRange: B };
    });
    return { positionsNotPlayedOff: N, playoffFinishingPositionRanges: k, finishingPositionsAvailable: T, finishingPositionsPlayedOff: b, positionsPlayedOff: E, groupCount: v, groupSize: P };
  }
  let o = ((y = a == null ? void 0 : a.source) == null ? void 0 : y.filter((w) => w.linkCondition !== ln).map((w) => {
    var v;
    return (v = w.source) == null ? void 0 : v.roundNumber;
  })) || [], s = ((U = a == null ? void 0 : a.source) == null ? void 0 : U.filter((w) => w.linkCondition === ln).map((w) => {
    var v;
    return (v = w.source) == null ? void 0 : v.roundNumber;
  })) || [], c = nb({ excludeRoundNumbers: o, playoffPositions: e, drawDefinition: t, structureId: n }), u = c != null && c.playoffSourceRounds ? [...(c == null ? void 0 : c.playoffSourceRounds) || []] : void 0, d = [...(c == null ? void 0 : c.playoffRoundsRanges) || []], { roundProfile: p, error: l } = c;
  for (let w of s) {
    let v = a == null ? void 0 : a.source.find((M) => M.source.roundNumber === w), P = v == null ? void 0 : v.target.roundNumber, b = v == null ? void 0 : v.target.structureId, T = i.filter(({ roundNumber: M, structureId: E }) => E === b && M === P), R = T.filter(({ sides: M }) => M.find((E) => E.participantFed && !E.participantId)).length;
    if (u && R === T.length) {
      u.push(w);
      let M = (D = (S = p == null ? void 0 : p[w]) == null ? void 0 : S.finishingPositionRange) == null ? void 0 : D.loser;
      if (M) {
        let E = Math.min(...M), C = E + R, A = oe(E, C), N = { finishingPositionRange: [E, C - 1].join("-"), finishingPositions: A, roundNumber: w };
        d.push(N);
      }
    }
  }
  return u && u.sort(Ft), d.sort((w, v) => w.roundNumber - v.roundNumber), { playoffRounds: u, playoffRoundsRanges: d, error: l };
}
function GF({ playoffGroups: e, drawDefinition: t, structureId: r }) {
  var n, a;
  if (!t)
    return { error: le };
  if (!ht(r) || !Array.isArray(e))
    return { error: J };
  let i = e.map(({ finishingPositions: o }) => o).flat();
  return { positionRangeMap: (a = (n = pd({ drawDefinition: t, structureId: r }).playoffFinishingPositionRanges) == null ? void 0 : n.filter((o) => i.includes(o.finishingPosition))) == null ? void 0 : a.reduce((o, s) => (o[s.finishingPosition] = s, o), {}) };
}
function ab(e) {
  var y, U;
  let { finishingPositionOffset: t = 0, playoffAttributes: r, stageSequence: i = 1, staggeredEntry: n, structureName: a, stage: o = ue, matchUpType: s, structureId: c, idPrefix: u, drawSize: d, isMock: p, uuids: l } = e, m = { finishingPositionOffset: t, matchUpType: s, drawSize: d, idPrefix: u, isMock: p, uuids: l }, { matchUps: f } = n ? Pa(m) : fn(m), h = gi({ structureName: a || ((y = r == null ? void 0 : r["0"]) == null ? void 0 : y.name) || dr(ue), structureId: c || (l == null ? void 0 : l.pop()), stageSequence: i, matchUpType: s, matchUps: f, stage: o }), g = [h], I = [];
  if (d > 2) {
    let S = d / 2, { matchUps: D } = fn({ finishingPositionOffset: t + S, idPrefix: u && `${u}-c`, drawSize: S, matchUpType: s, isMock: p }), w = dr(lr), v = ((U = r == null ? void 0 : r["0-1"]) == null ? void 0 : U.name) ?? e.consolationStructureName ?? (a ? `${a} ${w}` : w), P = gi({ structureName: v, matchUps: D, structureId: l == null ? void 0 : l.pop(), stage: lr, stageSequence: 1, matchUpType: s });
    g.push(P);
    let b = { linkType: An, source: { roundNumber: 1, structureId: h.structureId }, target: { roundNumber: 1, feedProfile: Ei, structureId: P.structureId } };
    I.push(b);
  }
  return { ...V, structures: g, links: I };
}
function ob({ consolationStructure: e, roundOffset: t = 0, mainStructure: r, roundsCount: i, feedPolicy: n, fmlc: a }) {
  let o = e.matchUps.reduce((u, d) => (d.drawPositions || []).filter(Boolean).length && !u.includes(d.roundNumber) ? u.concat(d.roundNumber) : u, []), s = (n == null ? void 0 : n.roundGroupedOrder) || [], c = n == null ? void 0 : n.roundFeedProfiles;
  return oe(1 + t, i + 1 + t).map((u) => {
    let d = c != null && c[u - 1] ? c[u - 1] : u % 2 && Ei || Wa, p = u - t <= 2 ? u - t : (u - t - 2) * 2 + 2, l = { linkType: An, source: { roundNumber: u, structureId: r.structureId }, target: { feedProfile: d, roundNumber: p, structureId: e.structureId } }, m = s[u - 1];
    return m && (l.target.groupedOrder = m), oi() && (l.source.structureName = r.structureName, l.target.structureName = e.structureName), u === 2 && a && (l.linkCondition = ln, l.target.feedProfile = Ei), o.includes(p) ? l : void 0;
  }).filter(Boolean);
}
function sb(e) {
  var D, w;
  let { playoffStructureNameBase: t, finishingPositionOffset: r, stageSequence: i = 1, playoffAttributes: n, structureNameMap: a, staggeredEntry: o, stage: s = ue, matchUpType: c, structureId: u, drawSize: d, idPrefix: p, isMock: l, uuids: m } = e, f = { finishingPositionOffset: r, matchUpType: c, drawSize: d, idPrefix: p, isMock: l, uuids: m }, { matchUps: h, roundsCount: g } = o ? Pa(f) : fn(f), I = e.structureName ?? ((D = n == null ? void 0 : n["0"]) == null ? void 0 : D.name) ?? dr(ue), y = ma({ structureId: u || (m == null ? void 0 : m.pop()), structureName: I, stageSequence: i, matchUpType: c, matchUps: h, stage: s }), U = [y], S = [];
  if (d > 2) {
    let v = [0, 2].slice(0, d / 16).map((P, b) => {
      let T = b + 1, { consolationStructure: R } = $F({ idPrefix: p && `${p}-c${b}`, structureId: m == null ? void 0 : m.pop(), playoffStructureNameBase: t, playoffAttributes: n, structureNameMap: a, stageSequence: T, roundOffset: P, matchUpType: c, drawSize: d, isMock: l, index: b, uuids: m });
      U.push(R);
      let M = ob({ consolationStructure: R, roundsCount: 2, mainStructure: y, roundOffset: P });
      return { consolationStructure: R, links: M };
    }).map((P) => P.links).flat();
    if (S.push(...v), d >= 4 && d <= 16 || d > 32) {
      let { matchUps: P } = fn({ idPrefix: p && `${p}-p3t4`, finishingPositionOffset: 2, drawSize: 2, matchUpType: c, isMock: l }), b = ((w = n == null ? void 0 : n["3-4"]) == null ? void 0 : w.name) ?? dr(vt), T = (a == null ? void 0 : a[b]) || b, R = t ? `${t} ${T}` : T, M = ma({ structureId: m == null ? void 0 : m.pop(), matchUps: P, stageSequence: 2, stage: vt, structureName: R, matchUpType: c }), E = { linkType: An, source: { roundNumber: g - 1, structureId: y.structureId }, target: { structureId: M.structureId, feedProfile: Ei, roundNumber: 1 } };
      U.push(M), S.push(E);
    }
  }
  return { structures: U, links: S, ...V };
}
function $F({ playoffStructureNameBase: e, stageSequence: t = 1, playoffAttributes: r, structureNameMap: i, roundOffset: n = 0, matchUpType: a, structureId: o, idPrefix: s, drawSize: c, isMock: u, index: d, uuids: p }) {
  var y, U;
  let l = c / (2 * Math.pow(2, n)), { matchUps: m, roundsCount: f } = Pa({ finishingPositionOffset: l, baseDrawSize: l, isConsolation: !0, feedRounds: 1, matchUpType: a, idPrefix: s, isMock: u, uuids: p }), h = d === 0 && ((y = r == null ? void 0 : r["0-1"]) == null ? void 0 : y.name) || d === 1 && ((U = r == null ? void 0 : r["0-3"]) == null ? void 0 : U.name) || `${dr(lr)} ${d + 1}`, g = (i == null ? void 0 : i[h]) || h, I = e ? `${e} ${g}` : g;
  return { consolationStructure: ma({ matchUps: m, stage: lr, structureName: I, stageSequence: t, matchUpType: a, structureId: o }), consolationRoundsCount: f };
}
function So(e) {
  var T, R, M, E;
  let { finishingPositionOffset: t, stageSequence: r = 1, playoffAttributes: i, feedsFromFinal: n, staggeredEntry: a, structureName: o, stage: s = ue, structureId: c, matchUpType: u, skipRounds: d, feedRounds: p, idPrefix: l, drawSize: m, isMock: f, uuids: h, fmlc: g } = e, I = e.feedPolicy || ((T = e.policyDefinitions) == null ? void 0 : T[qs]) || ((R = e.appliedPolicies) == null ? void 0 : R[qs]), y = { finishingPositionOffset: t, matchUpType: u, skipRounds: d, drawSize: m, idPrefix: l, isMock: f, uuids: h }, { matchUps: U } = a ? Pa(y) : fn(y), S = gi({ structureName: o || ((M = i == null ? void 0 : i["0"]) == null ? void 0 : M.name) || dr(ue), structureId: c || (h == null ? void 0 : h.pop()), stageSequence: r, matchUpType: u, matchUps: U, stage: s }), D = [S], w = [], v = m / 2, { matchUps: P, roundsCount: b } = Pa({ finishingPositionOffset: v, idPrefix: l && `${l}-c`, isConsolation: !0, feedsFromFinal: n, baseDrawSize: v, matchUpType: u, feedRounds: p, skipRounds: d, isMock: f, uuids: h, fmlc: g });
  if (m > 2) {
    let C = ((E = i == null ? void 0 : i["0-1"]) == null ? void 0 : E.name) ?? dr(lr), A = e.playoffStructureNameBase ? `${e.playoffStructureNameBase} ${C}` : C, N = gi({ matchUps: P, structureId: h == null ? void 0 : h.pop(), stage: lr, stageSequence: 1, structureName: A, matchUpType: u });
    D.push(N);
    let O = ob({ consolationStructure: N, mainStructure: S, roundsCount: b, feedPolicy: I, fmlc: g });
    w.push(...O);
  }
  return { ...V, structures: D, links: w };
}
function cb({ requireSequential: e = !0, playoffMatchUpFormat: t, playoffAttributes: r, sourceStructureId: i, policyDefinitions: n, stageSequence: a, drawDefinition: o, playoffGroups: s, matchUpType: c, feedPolicy: u, groupCount: d, idPrefix: p, isMock: l, uuids: m }) {
  var D, w, v, P, b, T;
  u = u || (n == null ? void 0 : n[qs]);
  let f = "processPlayoffGroups", h = 0, g = [], I = [], y = [], { error: U, positionRangeMap: S } = GF({ structureId: i, drawDefinition: o, playoffGroups: s });
  if (U)
    return j({ result: { error: U }, stack: f });
  if (!(!S || s != null && s.every((R) => {
    let { finishingPositions: M = [] } = R;
    if (!M.length)
      return !1;
    let E = [...M].sort(Ft).map((C, A) => (M[A + 1] || C) - C).every((C) => C < 2);
    return (!e || E) && M.every((C) => S[C]);
  })))
    return j({ context: { validFinishingPositions: Object.values(S) }, result: { error: J }, stack: f });
  for (let R of s) {
    let M = R.finishingPositions, E = S && M.map((_) => {
      var B;
      return (B = S[_]) == null ? void 0 : B.finishingPositions;
    }).flat(), C = d * M.length, A = tc(C), N = A === 2 && on || R.drawType || on;
    E && (h = Math.min(...E) - 1);
    let O = E && `${Math.min(...E)}-${Math.max(...E)}`, k = R.structureName || O && ((w = (D = R.playoffAttributes) == null ? void 0 : D[O]) == null ? void 0 : w.name) || ((P = (v = R.playoffAttributes) == null ? void 0 : v["0"]) == null ? void 0 : P.name), F = { addNameBaseToAttributeName: R.addNameBaseToAttributeName, playoffStructureNameBase: R.playoffStructureNameBase, finishingPositionNaming: R.finishingPositionNaming, finishingPositionLimit: R.finishingPositionLimit, structureId: R.structureId ?? (m == null ? void 0 : m.pop()), playoffAttributes: R.playoffAttributes, structureNameMap: R.structureNameMap, sequenceLimit: R.sequenceLimit, structureName: k, idPrefix: p && `${p}-po`, appliedPolicies: n, finishingPositionOffset: h, stage: vt, stageSequence: a, matchUpType: c, drawSize: A, isMock: l, uuids: m }, x = ({ playoffStructures: _, playoffLinks: B }) => {
      let [L] = _, G = xd({ playoffStructureId: L.structureId, finishingPositions: M, sourceStructureId: i });
      y.push(G), y.push(...B), I.push(..._), g.push({ structureId: L.structureId, finishingPositions: M }), h += C;
    };
    if (N === on) {
      let { matchUps: _ } = fn({ finishingPositionLimit: h + C, idPrefix: p && `${p}-po`, finishingPositionOffset: h, matchUpType: c, drawSize: A, isMock: l, uuids: m }), B = gi({ structureId: R.structureId ?? (m == null ? void 0 : m.pop()), matchUpFormat: t, stage: vt, structureName: k, stageSequence: a, matchUps: _ });
      I.push(B);
      let L = xd({ playoffStructureId: B.structureId, finishingPositions: M, sourceStructureId: i });
      y.push(L), h += C, g.push({ structureId: B.structureId, finishingPositions: M });
    } else if ([Bs, Vs, vt].includes(N)) {
      let _ = { playoffAttributes: R.playoffAttributes ?? r, playoffStructureNameBase: R.playoffStructureNameBase, structureId: R.structureId ?? (m == null ? void 0 : m.pop()), structureName: R.structureName, idPrefix: p && `${p}-po`, addNameBaseToAttributeName: !0, finishingPositionOffset: h, stage: vt, roundOffset: 0, stageSequence: a, drawSize: A, isMock: l, uuids: m };
      N === Bs ? Object.assign(_, { playoffAttributes: (R == null ? void 0 : R.playoffAttributes) ?? r ?? ng, roundOffsetLimit: 3 }) : N === Vs && Object.assign(_, { playoffAttributes: (R == null ? void 0 : R.playoffAttributes) ?? r ?? ag, roundOffsetLimit: 2 });
      let B = Ns(_);
      if (B.error)
        return B;
      if ((b = B.links) != null && b.length && y.push(...B.links), (T = B.structures) != null && T.length && I.push(...B.structures), I.sort(Zo), B.structureId) {
        let L = xd({ playoffStructureId: B.structureId, finishingPositions: M, sourceStructureId: i });
        y.push(L), g.push({ structureId: B.structureId, finishingPositions: M });
      }
      h += C;
    } else if ([js, Fu, iu, ru, tu, nu].includes(N)) {
      let _ = [m == null ? void 0 : m.pop(), m == null ? void 0 : m.pop()], B = { playoffStructureNameBase: R.playoffStructureNameBase, structureId: R.structureId ?? (m == null ? void 0 : m.pop()), playoffAttributes: R.playoffAttributes, idPrefix: p && `${p}-po`, finishingPositionOffset: h, uuids: _, stage: vt, structureName: k, matchUpType: c, feedPolicy: u, drawSize: A, isMock: l }, L = { [js]: { fmlc: !0, feedRounds: 1 }, [nu]: { feedRounds: 1 }, [iu]: { feedsFromFinal: 3 }, [ru]: { feedsFromFinal: 2 }, [tu]: { feedsFromFinal: 1 } };
      Object.assign(B, L[N] || {});
      let { structures: G, links: $ } = So(B), [W] = G, q = xd({ playoffStructureId: W.structureId, finishingPositions: M, sourceStructureId: i });
      y.push(q), y.push(...$), I.push(...G), g.push({ structureId: W.structureId, finishingPositions: M }), h += C;
    } else if ([Li].includes(N)) {
      let { structures: _, links: B } = sd({ ...F, structureOptions: R.structureOptions || { groupSize: 4 } });
      x({ playoffStructures: _, playoffLinks: B });
    } else if ([ku].includes(N)) {
      let { structures: _, links: B } = ab(F);
      x({ playoffStructures: _, playoffLinks: B });
    } else if ([y1].includes(N)) {
      let { structures: _, links: B } = sb(F);
      x({ playoffStructures: _, playoffLinks: B });
    } else if ([si].includes(N)) {
      let _ = gi({ structureId: R.structureId ?? (m == null ? void 0 : m.pop()), structureName: R.structureName, finishingPosition: Yd, stage: vt, stageSequence: a, matchUps: [] });
      x({ playoffStructures: [_], playoffLinks: [] });
    }
  }
  return { finishingPositionTargets: g, positionRangeMap: S, structures: I, links: y };
}
function xd({ playoffStructureId: e, finishingPositions: t, sourceStructureId: r }) {
  return { linkType: Wn, source: { structureId: r, finishingPositions: t }, target: { structureId: e, feedProfile: Ni, roundNumber: 1 } };
}
function md({ matchUp: e, tieFormat: t, isMock: r, uuids: i }) {
  let { collectionDefinitions: n } = t ?? {};
  return { tieMatchUps: (n ?? []).map((a) => fd({ matchUp: e, collectionDefinition: a, uuids: i, isMock: r })).filter(Boolean).flat() };
}
function fd({ collectionPositionOffset: e = 0, collectionDefinition: t, matchUpsLimit: r, matchUp: i, isMock: n, uuids: a }) {
  let { matchUpCount: o, matchUpType: s, collectionId: c, processCodes: u } = t || {}, d = r ?? o ?? 0, p = (l) => {
    if (!n && !(i != null && i.isMock))
      return (a == null ? void 0 : a.pop()) ?? ze();
    let m = t == null ? void 0 : t.collectionId;
    return (a == null ? void 0 : a.pop()) ?? `${i == null ? void 0 : i.matchUpId}-${m}-TMU-${l + 1}`;
  };
  return oe(0, d).map((l) => {
    let m = e + l + 1;
    return { sides: [{ sideNumber: 1 }, { sideNumber: 2 }], matchUpId: p(l), matchUpStatus: Rt, collectionPosition: m, collectionId: c, processCodes: u, matchUpType: s, isMock: n };
  });
}
function qF(e) {
  var P, b, T;
  let t = "generateAndPopulateRRplayoffStructures";
  if (!e.playoffGroups)
    return j({ result: { error: Ie }, info: "playoffGroups required", stack: t });
  let { sourceStructureId: r, requireSequential: i, tournamentRecord: n, drawDefinition: a, playoffGroups: o, groupCount: s, groupSize: c, event: u } = e, d = cb({ requireSequential: i, sourceStructureId: r, playoffGroups: o, groupCount: s, groupSize: c, ...e });
  if (d.error)
    return j({ result: d, stack: t });
  let { structures: p = [], links: l = [], finishingPositionTargets: m, positionRangeMap: f } = d, h = m == null ? void 0 : m.map(({ finishingPositions: R }) => R).flat().map((R) => f[R].finishingPositions).flat();
  a.structures.push(...p), a.links.push(...l);
  let { matchUps: g, matchUpsMap: I } = Bt({ inContext: !0, drawDefinition: a }), y = p.map(({ structureId: R }) => R), U = g == null ? void 0 : g.filter(({ structureId: R }) => y.includes(R)).map(Ht), S = (P = I == null ? void 0 : I.drawMatchUps) == null ? void 0 : P.filter(({ matchUpId: R }) => U == null ? void 0 : U.includes(R));
  if (S != null && S.length) {
    let R = (b = Ir({ drawDefinition: a, event: u })) == null ? void 0 : b.tieFormat;
    R && S.forEach((M) => {
      let { tieMatchUps: E } = md({ isMock: e.isMock, tieFormat: R, matchUp: M });
      Object.assign(M, { tieMatchUps: E, matchUpType: ni });
    });
  }
  let { positionAssignments: D } = ot({ structureId: r, drawDefinition: a }), w = {};
  D == null || D.forEach((R) => {
    var E, C, A;
    let M = (A = (C = (E = Ne({ element: R, name: Ia })) == null ? void 0 : E.extension) == null ? void 0 : C.value) == null ? void 0 : A.groupOrder;
    M && (w[M] || (w[M] = []), w[M].push(R.participantId));
  });
  let v = wc({ provisionalPositioning: e.provisionalPositioning, structureId: r, applyPositioning: !0, event: e.event, tournamentRecord: n, drawDefinition: a });
  return v.error && ((T = v.error) == null ? void 0 : T.code) !== Ih.code ? j({ result: v, stack: t }) : { structures: p, links: l, positionsPlayedOff: h, drawDefinition: a, ...V };
}
function bs({ value: e, sourceRange: t, targetRange: r }) {
  let i = Math.min(...t), n = Math.max(...t), a = Math.min(...r), o = Math.max(...r);
  return (e - i) * (o - a) / (n - i) + a;
}
var Ai = "ELO", ub = "NTRP", WF = "TRN", db = "UTR", MI = "WTN", HF = { ELO: Ai, NTRP: ub, TRN: WF, UTR: db, WTN: MI }, zF = { [Ai]: { defaultInitialization: 1500, decimalsCount: 0, range: [0, 3e3], ascending: !0 }, [ub]: { accessors: ["ntrpRating", "dntrpRatingHundredths"], attributes: { ustaRatingType: "" }, accessor: "dntrpRatingHundredths", defaultInitialization: 3, decimalsCount: 1, ascending: !0, range: [1, 7] }, [db]: { defaultInitialization: 6, accessors: ["utrRating"], accessor: "utrRating", decimalsCount: 2, ascending: !0, range: [1, 16] }, [MI]: { attributes: { confidence: { generator: !0, range: [60, 100] } }, accessors: ["wtnRating", "confidence"], defaultInitialization: 23, accessor: "wtnRating", ascending: !1, decimalsCount: 2, range: [40, 1] } }, Wt = zF;
function YF({ sourceRatingType: e, sourceRating: t }) {
  let r = Wt[e].range, i = r[0] > r[1], n = Wt[Ai].range;
  return bs({ value: i ? r[0] - t : t, sourceRange: r, targetRange: n });
}
function KF({ targetRatingType: e, sourceRating: t }) {
  let r = Wt[e].decimalsCount || 0, i = Wt[e].range, n = i[0] > i[1], a = Math.max(...i), o = Wt[Ai].range, s = bs({ targetRange: i, sourceRange: o, value: t }), c = parseFloat(s.toFixed(r));
  return n ? a - c : c;
}
function US(e) {
  var p;
  let t = fe(e, [{ ratings: !0, [Or]: _r }]);
  if (t.error)
    return t;
  let r = e.matchUpType && [rt, tt].includes(e.matchUpType) ? e.matchUpType : rt, i = Object.keys(Wt), n = e.targetRatingType && i.includes(e.targetRatingType) ? e.targetRatingType : Ai, a = e.ratings[r] ? e.ratings[r].reduce((l, m) => l.includes(m.scaleName) ? l : l.concat(m.scaleName), []) : [];
  if (!a)
    return { error: Zt };
  let o = ((p = e.ratings[r]) == null ? void 0 : p.find((l) => l.scaleName === n)) ?? e.ratings[r][0];
  if (a[0] === n)
    return o;
  let s = o.scaleName, c = Wt[o.scaleName].accessor, u = c ? o.scaleValue[c] : o.scaleValue, d = YF({ sourceRatingType: s, sourceRating: u });
  return { convertedRating: KF({ targetRatingType: n, sourceRating: d }), sourceRating: u };
}
function QF({ participantResults: e, sides: t, score: r }) {
  var s, c;
  let i = t.find(({ sideNumber: u }) => u === 1), n = t.find(({ sideNumber: u }) => u === 2), a = (s = i == null ? void 0 : i.participant) == null ? void 0 : s.ratings, o = (c = n == null ? void 0 : n.participant) == null ? void 0 : c.ratings;
  if (a != null && a[rt] && (o != null && o[rt])) {
    let u = Ai, { convertedRating: d } = US({ ratings: a, targetRatingType: u }), { convertedRating: p } = US({ ratings: o, targetRatingType: u }), { side1pressure: l, side2pressure: m } = JF({ side1ConvertedRating: d, side2ConvertedRating: p, score: r });
    l && e[i == null ? void 0 : i.participantId].pressureScores.push(l), m && e[n == null ? void 0 : n.participantId].pressureScores.push(m);
    let f = Math.max(...Wt[Ai].range), h = nl((p - d) / f), g = nl((d - p) / f);
    e[i == null ? void 0 : i.participantId].ratingVariation.push(h), e[n == null ? void 0 : n.participantId].ratingVariation.push(g);
  }
}
function JF({ side1ConvertedRating: e, side2ConvertedRating: t, score: r }) {
  var y, U;
  let i = e > t ? e : t, n = e > t ? t : e, a = Math.abs(e - t), o = Wt[Ai].range, s = Math.max(...o), c = (s - i) * 0, u = (i + c) / s * a, d = (y = r == null ? void 0 : r.sets) == null ? void 0 : y.reduce((S, D) => S + ((D == null ? void 0 : D.side1Score) ?? 0), 0), p = (U = r == null ? void 0 : r.sets) == null ? void 0 : U.reduce((S, D) => S + (D.side2Score ?? 0), 0), l = e > t ? 2 : 1, m = (d || 0) * (n + (l === 1 ? u : 0)), f = (p || 0) * (n + (l === 2 ? u : 0)), h = m + f, g = h ? nl(m / h) : 0, I = h ? nl(f / h) : 0;
  return { side1pressure: g, side2pressure: I };
}
function NI({ winningSide: e, matchUpFormat: t = Oi, matchUpStatus: r, tallyPolicy: i, score: n }) {
  let a = [0, 0], o = n == null ? void 0 : n.sets, s = typeof e == "number" && e - 1, c = Tr(t), u = AI((c == null ? void 0 : c.bestOf) ?? 1);
  if (typeof s == "number" && (r === ke && (i != null && i.setsCreditForDefaults) || r === Be && (i != null && i.setsCreditForWalkovers)))
    a[s] = u;
  else
    for (let d of o || []) {
      let { winningSide: p } = d;
      p && (a[p - 1] += 1);
    }
  return typeof s == "number" && r === nr && (+a[1 - s] === u && (a[1 - s] -= 1), i != null && i.setsCreditForRetirements && (a[s] = u)), a;
}
function lb({ matchUpFormat: e = Oi, winningSide: t, matchUpStatus: r, tallyPolicy: i, score: n }) {
  var l, m;
  let { sets: a } = n || {};
  if (!a)
    return [0, 0];
  let o = typeof t == "number" && t - 1, s = Tr(e), c = (s == null ? void 0 : s.bestOf) ?? 1, u = AI(c), d = ((l = s == null ? void 0 : s.setFormat) == null ? void 0 : l.tiebreakAt) || 0, p = [[], []];
  if (typeof o == "number" && (r === ke && (i != null && i.gamesCreditForDefaults) || r === Be && (i != null && i.gamesCreditForWalkovers))) {
    let f = ((m = s == null ? void 0 : s.setFormat) == null ? void 0 : m.setTo) || 0, h = u * f;
    p[o].push(h);
  } else
    a.forEach((f, h) => {
      var D;
      let g = (f.setNumber || h + 1) > u && (s != null && s.finalSetFormat) ? "finalSetFormat" : "setFormat", I = (D = s == null ? void 0 : s[g]) == null ? void 0 : D.based, y = s == null ? void 0 : s[g].tiebreakSet, { side1Score: U, side2Score: S } = f;
      yS(I) && (p[0].push(ye(U || 0)), p[1].push(ye(S || 0))), y && f.winningSide && (i == null ? void 0 : i.gamesCreditForTiebreakSets) !== !1 && p[f.winningSide - 1].push(1);
    });
  if (r === nr && typeof o == "number") {
    let f = a.length > u && (s != null && s.finalSetFormat) ? "finalSetFormat" : "setFormat", h = s == null ? void 0 : s[f];
    if (yS(h.based)) {
      let g = (h == null ? void 0 : h.setTo) || 0, I = (U) => {
        if (!(!s || U === ""))
          return +U === d - 1 || +U === d ? ye(d || 0) + 1 : +U < d ? g : d;
      }, y = NI({ winningSide: t, score: { sets: a }, matchUpStatus: r, matchUpFormat: e, tallyPolicy: i });
      if (p.map((U) => U[o] <= U[1 - o]).reduce((U, S) => U + (S ? 1 : 0), 0) > y[1 - o]) {
        let U = p[o].length, S = I(p[1 - o][U - 1]);
        S && (p[o][U - 1] = S);
      }
      u > p[o].length && (i != null && i.gamesCreditForRetirements) && p[o].push(g);
    }
  }
  return [p[0].reduce((f, h) => f + h, 0), p[1].reduce((f, h) => f + h, 0)];
}
function pb({ matchUpFormat: e, score: t }) {
  var s;
  let r = e ? Tr(e) : void 0, i = (r == null ? void 0 : r.bestOf) ?? 1, n = AI(i), a = [0, 0], o = [0, 0];
  return (s = t == null ? void 0 : t.sets) == null || s.forEach((c, u) => {
    var l;
    let d = (c.setNumber || u + 1) > n && (r != null && r.finalSetFormat) ? "finalSetFormat" : "setFormat", p = (l = r == null ? void 0 : r[d]) == null ? void 0 : l.based;
    if (mb(p)) {
      let { side1Score: m, side2Score: f } = c;
      m && (o[0] += ye(m || 0)), f && (o[1] += ye(f || 0));
    } else
      c.side1TiebreakScore && (o[0] += ye(c.side1TiebreakScore || 0)), c.side2TiebreakScore && (o[1] += ye(c.side2TiebreakScore || 0)), (c.side1TiebreakScore || c.side2TiebreakScore) && c.winningSide && (a[c.winningSide - 1] += 1);
  }), { pointsTally: o, tiebreaksTally: a };
}
function AI(e) {
  return e && Math.ceil(e / 2) || 1;
}
function mb(e) {
  return e === "P";
}
function yS(e) {
  return !mb(e);
}
function XF({ participantResults: e, matchUpFormat: t, tallyPolicy: r, perPlayer: i, totalSets: n }) {
  var u;
  let a = t && Tr(t) || {}, o = a.bestOf, s = o && Math.ceil(o / 2) || 1, c = (u = a.setFormat) == null ? void 0 : u.setTo;
  Object.keys(e).forEach((d) => {
    let p = e[d].setsWon, l = e[d].setsLost, m = r != null && r.groupTotalSetsPlayed ? n : i * (s || 0) || p + l, f = Math.round(p / m * 1e3) / 1e3;
    (f === 1 / 0 || isNaN(f)) && (f = m);
    let h = e[d].tieMatchUpsWon, g = e[d].tieMatchUpsLost, I = h + g, y = Math.round(h / I * 1e3) / 1e3;
    (y === 1 / 0 || isNaN(y)) && (y = h);
    let U = e[d].matchUpsWon, S = e[d].matchUpsLost, D = U + S, w = Math.round(U / D * 1e3) / 1e3;
    (w === 1 / 0 || isNaN(w)) && (w = U);
    let v = e[d].gamesWon || 0, P = e[d].gamesLost || 0, b = (i || 0) * (s || 0) * (c || 0), T = Math.max(b, v + P), R = Math.round(v / T * 1e3) / 1e3;
    (R === 1 / 0 || isNaN(R)) && (R = 0);
    let M = e[d].pointsWon + e[d].pointsLost, E = Math.round(e[d].pointsWon / M * 1e3) / 1e3;
    (E === 1 / 0 || isNaN(E)) && (E = 0), e[d].setsWon = p, e[d].setsLost = l, e[d].setsPct = f, e[d].tieMatchUpsWon = h, e[d].tieMatchUpsPct = y, e[d].matchUpsPct = w, e[d].gamesWon = v, e[d].gamesLost = P, e[d].gamesPct = R, e[d].pointsPct = E, e[d].result = `${e[d].matchUpsWon}/${e[d].matchUpsLost}`;
  });
}
function hd({ participantIds: e, pressureRating: t, matchUpFormat: r, tallyPolicy: i, perPlayer: n, matchUps: a }) {
  var d, p, l, m, f, h, g;
  let o = {}, s = (i == null ? void 0 : i.excludeMatchUpStatuses) || [], c = a == null ? void 0 : a.filter((I) => (I.tieMatchUps || !s.includes(I.matchUpStatus)) && (!(e != null && e.length) || wt(e, [Rs(I, 0), Rs(I, 1)]).length === 2)), u = (d = c == null ? void 0 : c.flatMap(({ score: I, tieMatchUps: y }) => {
    var U;
    return y ? y.filter(({ matchUpStatus: S }) => !s.includes(S)).flatMap(({ score: S }) => {
      var D;
      return ((D = S == null ? void 0 : S.sets) == null ? void 0 : D.length) ?? 0;
    }) : ((U = I == null ? void 0 : I.sets) == null ? void 0 : U.length) ?? 0;
  })) == null ? void 0 : d.reduce((I, y) => I + y, 0);
  for (let I of c ?? []) {
    let { matchUpStatus: y, tieMatchUps: U, tieFormat: S, score: D, winningSide: w, sides: v } = I, P = S && I._disableAutoCalc && S.collectionDefinitions.every(({ scoreValue: E }) => E), b = w && ZF(I), T = w && ex(I);
    if (!b && !T)
      if (y && Vt.includes(y)) {
        let E = Rs(I, 0), C = Rs(I, 1);
        E && (ua(o, E), o[E].matchUpsCancelled += 1), C && (ua(o, C), o[C].matchUpsCancelled += 1);
      } else if (U != null && U.length) {
        n = 0;
        for (let E of U) {
          if (E.winningSide) {
            let C = (p = v == null ? void 0 : v.find(({ sideNumber: N }) => N === E.winningSide)) == null ? void 0 : p.participantId, A = (l = v == null ? void 0 : v.find(({ sideNumber: N }) => N === E.winningSide)) == null ? void 0 : l.participantId;
            C && A && (ua(o, C), ua(o, A), o[C].tieMatchUpsWon += 1, o[A].tieMatchUpsLost += 1, bt(rt)(E.matchUpType) ? (o[C].tieSinglesWon += 1, o[A].tieSinglesLost += 1) : bt(tt)(E.matchUpType) && (o[C].tieDoublesWon += 1, o[A].tieDoublesLost += 1));
          }
          SS({ score: E.score, manualGamesOverride: P, participantResults: o, sides: v });
        }
      } else
        SS({ manualGamesOverride: P, participantResults: o, score: D, sides: v });
    else if (ua(o, b), ua(o, T), U == null ? void 0 : U.length) {
      n = 0;
      for (let E of U) {
        let { matchUpType: C } = E, A = bt(tt)(C), N = bt(rt)(C);
        E.winningSide && (E.winningSide === w ? (b && (o[b].tieMatchUpsWon += 1, N && (o[b].tieSinglesWon += 1), A && (o[b].tieDoublesWon += 1)), T && (o[T].tieMatchUpsLost += 1, N && (o[T].tieSinglesLost += 1), A && (o[T].tieDoublesLost += 1))) : E.winningSide !== w && (T && (o[T].tieMatchUpsWon += 1, N && (o[T].tieSinglesWon += 1), A && (o[T].tieDoublesWon += 1)), b && (o[b].tieMatchUpsLost += 1, N && (o[b].tieSinglesLost += 1), A && (o[b].tieDoublesLost += 1)))), vS({ matchUpFormat: E.matchUpFormat, matchUpStatus: E.matchUpStatus, matchUpType: E.matchUpType, score: E.score, sides: E.sides, winningParticipantId: b, losingParticipantId: T, manualGamesOverride: P, participantResults: o, isTieMatchUp: !0, pressureRating: t, tallyPolicy: i, winningSide: w });
      }
      fb({ winningParticipantId: b, losingParticipantId: T, participantResults: o, matchUpStatus: y });
    } else
      vS({ matchUpFormat: I.matchUpFormat ?? r, matchUpType: I.matchUpType, isTieMatchUp: void 0, winningParticipantId: b, manualGamesOverride: P, losingParticipantId: T, participantResults: o, pressureRating: t, matchUpStatus: y, tallyPolicy: i, winningSide: w, score: D, sides: v });
    let R = (m = D == null ? void 0 : D.sets) == null ? void 0 : m.reduce((E, C) => E + ((C == null ? void 0 : C.side1Score) ?? 0), 0), M = (f = D == null ? void 0 : D.sets) == null ? void 0 : f.reduce((E, C) => E + (C.side2Score ?? 0), 0);
    if (P) {
      let E = (h = v == null ? void 0 : v.find(({ sideNumber: A }) => A === 1)) == null ? void 0 : h.participantId, C = (g = v == null ? void 0 : v.find(({ sideNumber: A }) => A === 2)) == null ? void 0 : g.participantId;
      ua(o, E), ua(o, C), E && (o[E].gamesWon += R, o[E].gamesLost += M), C && (o[C].gamesWon += M, o[C].gamesLost += R);
    }
  }
  return XF({ participantResults: o, matchUpFormat: r, tallyPolicy: i, perPlayer: n, totalSets: u }), { participantResults: o };
}
function ZF(e) {
  let t = e.winningSide - 1;
  return Rs(e, t);
}
function ex(e) {
  let t = 1 - (e.winningSide - 1);
  return Rs(e, t);
}
function Rs(e, t) {
  if (!(e != null && e.sides))
    return console.log("no sides:", { matchUp: e }), "foo";
  let r = e.sides[t];
  return r ? r.participantId : (console.log("No Side", { matchUp: e, index: t }), "foo");
}
function ua(e, t) {
  t && !e[t] && (e[t] = { allDefaults: 0, defaults: 0, defeats: [], gamesLost: 0, gamesWon: 0, matchUpsCancelled: 0, matchUpsLost: 0, matchUpsWon: 0, pointsLost: 0, pointsWon: 0, pressureScores: [], ratingVariation: [], retirements: 0, setsLost: 0, setsWon: 0, tieSinglesWon: 0, tieSinglesLost: 0, tieDoublesWon: 0, tieDoublesLost: 0, tieMatchUpsLost: 0, tieMatchUpsWon: 0, victories: [], walkovers: 0 });
}
function SS({ manualGamesOverride: e, participantResults: t, score: r, sides: i }) {
  let { sets: n } = r || {}, a = [[], []], o = [0, 0];
  for (let c of n || []) {
    let { winningSide: u, side1Score: d, side2Score: p } = c;
    u && (o[u - 1] += 1), a[0].push(ye(d || 0)), a[1].push(ye(p || 0));
  }
  let s = [a[0].reduce((c, u) => c + u, 0), a[1].reduce((c, u) => c + u, 0)];
  i.forEach((c, u) => {
    let { participantId: d } = c;
    d && (ua(t, d), t[d].setsWon += o[u], t[d].setsLost += o[1 - u], e || (t[d].gamesWon += s[u], t[d].gamesLost += s[1 - u]));
  });
}
function vS({ winningParticipantId: e, manualGamesOverride: t, losingParticipantId: r, participantResults: i, pressureRating: n, matchUpFormat: a, matchUpStatus: o, isTieMatchUp: s, matchUpType: c, tallyPolicy: u, winningSide: d, score: p, sides: l }) {
  let m = d && d - 1, f = 1 - m;
  n && c === rt && QF({ participantResults: i, sides: l, score: p }), s || fb({ winningParticipantId: e, losingParticipantId: r, participantResults: i, matchUpStatus: o });
  let h = NI({ matchUpStatus: o, matchUpFormat: a, tallyPolicy: u, winningSide: d, score: p }), g = lb({ matchUpStatus: o, matchUpFormat: a, tallyPolicy: u, winningSide: d, score: p }), { pointsTally: I } = pb({ score: p, matchUpFormat: a });
  e && (i[e].setsWon += h[m], i[e].setsLost += h[f], t || (i[e].gamesWon += g[m], i[e].gamesLost += g[f]), i[e].pointsWon += I[m], i[e].pointsLost += I[f]), r && (i[r].setsWon += h[f], i[r].setsLost += h[m], t || (i[r].gamesWon += g[f], i[r].gamesLost += g[m]), i[r].pointsWon += I[f], i[r].pointsLost += I[m]);
}
function fb({ winningParticipantId: e, losingParticipantId: t, participantResults: r, matchUpStatus: i }) {
  t && (i === Be && (r[t].walkovers += 1), i === ke && (r[t].defaults += 1), i === nr && (r[t].retirements += 1), [ke, nr, Be].includes(i) && (r[t].allDefaults += 1), r[t].matchUpsLost += 1), e && (r[e].matchUpsWon += 1), t && e && (r[t].defeats.push(e), r[e].victories.push(t));
}
function tx({ matchUps: e, order: t, report: r }) {
  let i = {};
  e.forEach(({ sides: a }) => {
    a.forEach((o) => {
      o.participantId && o.participant && (i[o.participantId] = o.participant.participantName);
    });
  });
  let n = [];
  return Array.isArray(r) && r.forEach((a, o) => {
    var s, c;
    if ((s = a.excludedDirectives) != null && s.length) {
      let u = a.excludedDirectives.map(({ attribute: l }) => l).join(", "), d = `${u.length} directives were excluded due to participants limit}`;
      n.push(d);
      let p = `Excluded: ${u}`;
      n.push(p);
    } else {
      let u = (h, g) => parseFloat(a.reversed ? h : g) - parseFloat(a.reversed ? g : h), d = a.groups ? Object.values(a.groups).flat(1 / 0).length : ((c = a.participantIds) == null ? void 0 : c.length) ?? 0, p = (h) => {
        h.groups && Object.keys(h.groups).sort(u).forEach((g) => {
          let I = h.groups[g].map((U) => i[U]).join(", "), y = `${g} ${h.attribute}: ${I}`;
          n.push(y);
        });
      }, l = a.reversed ? " in reverse order" : "", m = a.groups ? "grouped" : "separated", f = `Step ${o + 1}: ${d} particiants were ${m}${l} by ${a.attribute}`;
      if (n.push(f), a.idsFilter) {
        let h = `${a.attribute} was calculated considering ONLY TIED PARTICIPANTS`;
        n.push(h);
      }
      p(a);
    }
    n.push("----------------------");
  }), n.push("Final Order:"), t.forEach((a) => {
    let { participantId: o, resolved: s } = a, c = a.groupOrder || a.provisionalOrder;
    n.push(`${c}: ${i[o]} => resolved: ${!!s}`);
  }), n.join(`\r
`);
}
function hb({ participantResults: e, participantIds: t, attribute: r }) {
  return gb({ participantResults: e, participantIds: t }).reduce((i, n) => {
    let { participantId: a, results: o } = n, s = o == null ? void 0 : o[r];
    return !isNaN(s) && a && (i[s] ? i[s].push(a) : i[s] = [a]), i;
  }, {});
}
function gb(e) {
  return (e.participantIds || Object.keys(e.participantResults)).reduce((t, r, i) => (t.push({ participantId: r, i, results: e.participantResults[r] }), t), []);
}
var rx = [{ attribute: "matchUpsPct", idsFilter: !1 }, { attribute: "allDefaults", reversed: !0, idsFilter: !1 }, { attribute: "defaults", reversed: !0, idsFilter: !1 }, { attribute: "walkovers", reversed: !0, idsFilter: !1 }, { attribute: "retirements", reversed: !0, idsFilter: !1 }, { attribute: "setsPct", idsFilter: !1 }, { attribute: "gamesPct", idsFilter: !1 }, { attribute: "pointsPct", idsFilter: !1 }, { attribute: "matchUpsPct", idsFilter: !0 }, { attribute: "setsPct", idsFilter: !0 }, { attribute: "gamesPct", idsFilter: !0 }, { attribute: "pointsPct", idsFilter: !0 }], Xm = { matchUpsPct: 20, tieMatchUpsPct: 16, pointsPct: 4, gamesPct: 8, setsPct: 12 };
function wS(e) {
  let { requireCompletion: t = !0, participantResults: r, subOrderMap: i, tallyPolicy: n } = e, a = [];
  if (t && !ix(e))
    return {};
  let o = ["tieMatchUpsWon", "tieSinglesWon", "tieDoublesWon", "matchUpsWon", "pointsWon", "gamesWon", "setsWon", "gamesPct", "setsPct", "pointsPct", "matchUpsPct"].includes(n == null ? void 0 : n.groupOrderKey) ? n.groupOrderKey : "matchUpsWon", s = hb({ participantResults: r, attribute: o });
  a.push({ attribute: o, groups: s });
  let c = Object.keys(s).map((g) => parseFloat(g)).sort((g, I) => I - g).map((g) => s[g]).map((g) => {
    let I = Ib({ participantIds: g, ...e });
    return a.push(...I.report ?? []), I.order;
  }).map((g, I) => g.map((y) => y.resolved ? y : { ...y, subGroup: [I].concat(...y.subGroup ?? []) })).flat(), u, d = 0, p = 1, l;
  c.forEach((g, I) => {
    var U;
    I && (g.resolved || l && !g.resolved) && (p += 1), l = g.resolved;
    let y = parseInt(((U = g.subGroup) == null ? void 0 : U.join("")) || 0);
    g.resolved ? (g.position = I + 1, p = g.position) : (u && y > u && (p += d, d = 0), g.position = p, d += 1), u = y;
  });
  let m = c.map(({ position: g }) => g), f = Qr(m);
  return c.forEach((g) => {
    let { participantId: I, position: y } = g || {}, U = r[I];
    g.GEMscore = h(U);
    let S = f[y];
    (g == null ? void 0 : g.position) !== void 0 && (S > 1 && (g.ties = S, i && (g.subOrder = i[I])), g.rankOrder = y, g.groupOrder = y + (g.subOrder || 1) - 1);
  }), { groupOrder: c, report: a.flat(1 / 0).filter(Boolean) };
  function h(g) {
    return (Array.isArray(n == null ? void 0 : n.GEMscore) ? Object.keys(Xm).filter((I) => n.GEMscore.includes(I)) : Object.keys(Xm)).map((I) => (g[I] || 0) * Math.pow(10, Xm[I].toFixed(3))).reduce((I, y) => I + y, 0);
  }
}
function ix({ participantResults: e, participantsCount: t }) {
  let r = gb({ participantResults: e }).filter((i) => t - 1 === i.results.matchUpsWon + i.results.matchUpsLost + i.results.matchUpsCancelled);
  return t === r.length;
}
function nx({ disableHeadToHead: e, participantIds: t, matchUpFormat: r, tallyPolicy: i, attribute: n, idsFilter: a, matchUps: o, reversed: s }) {
  let { participantResults: c } = hd({ participantIds: a && t, matchUpFormat: r, tallyPolicy: i, matchUps: o }), u = hb({ participantResults: c, participantIds: t, attribute: n }), d = [{ attribute: n, reversed: s, groups: u, idsFilter: a }], p;
  return Object.keys(u).length > 1 && t.length && (p = Object.keys(u).map((l) => parseFloat(l)).sort((l, m) => s ? l - m : m - l).map((l) => u[l]).map((l) => {
    let m = Ib({ participantResults: c, disableHeadToHead: e, participantIds: l, matchUpFormat: r, tallyPolicy: i, matchUps: o });
    return d.push(...m.report ?? []), m.order;
  }).map((l, m) => l.map((f) => f.resolved ? f : { ...f, subGroup: [m].concat(...f.subGroup ?? []) })).flat()), { order: p, report: d };
}
function Ib({ participantResults: e, disableHeadToHead: t, participantIds: r, matchUpFormat: i, tallyPolicy: n, matchUps: a }) {
  let o = [], s = [], c;
  if ((r == null ? void 0 : r.length) === 1)
    return { order: [{ resolved: !0, participantId: r[0] }] };
  if ((r == null ? void 0 : r.length) === 2 && (!(n != null && n.headToHead) || !n.headToHead.disabled && !t)) {
    let d = ax({ participantIds: r, participantResults: e });
    if (d) {
      let p = d[0].participantId;
      return s.push({ attribute: "head2Head", participantIds: r, headToHeadWinner: p }), { order: d, headToHeadWinner: p, report: s };
    }
  }
  let u = ((n == null ? void 0 : n.tallyDirectives) || rx).filter((d) => {
    let p = !(St(d.maxParticipants) && (r == null ? void 0 : r.length) > d.maxParticipants);
    return p || o.push(d), p;
  });
  return o.length && s.push({ excludedDirectives: o, participantIds: r }), u.every(({ attribute: d, reversed: p, idsFilter: l, disableHeadToHead: m }) => (c = nx({ disableHeadToHead: m, participantIds: r, matchUpFormat: i, tallyPolicy: n, attribute: d, idsFilter: l, matchUps: a, reversed: p }), s.push(c.report), !c.order)), c.order ? { order: c.order, report: s } : { order: r == null ? void 0 : r.map((d) => ({ participantId: d })), report: s };
}
function ax({ participantIds: e, participantResults: t }) {
  if (e) {
    if (t[e[0]].victories.includes(e[1]))
      return e.map((r) => ({ resolved: !0, participantId: r }));
    if (t[e[1]].victories.includes(e[0]))
      return e.reverse().map((r) => ({ resolved: !0, participantId: r }));
  }
}
function Dc({ policyDefinitions: e, generateReport: t, pressureRating: r, matchUpFormat: i, matchUps: n = [], subOrderMap: a, perPlayer: o }) {
  if (!(n != null && n.length) || !Ti(n))
    return { error: Zn };
  let s = Te(n.map(({ structureId: S }) => S));
  if (s.length !== 1)
    return j({ result: { error: J, info: "Maximum one structureId" }, stack: "tallyParticipantResults", context: { structureIds: s } });
  let c = n.filter((S) => S && S.matchUpStatus !== $e), u = c.length && Te(c.map(({ drawPositions: S }) => S).flat()).length, d = c.filter((S) => ja({ matchUp: S })).length === c.length;
  d || (o = 0);
  let p = n.every(({ matchUpType: S, tieMatchUps: D }) => S === lt && (D == null ? void 0 : D.every((w) => ja({ matchUp: w })))), l = e == null ? void 0 : e[hg], m = n.filter((S) => ja({ matchUp: S }) || S.matchUpType === lt), { participantResults: f } = hd({ matchUps: m, pressureRating: r, matchUpFormat: i, tallyPolicy: l, perPlayer: o }), h, g, { groupOrder: I, report: y } = wS({ matchUps: m, participantResults: f, participantsCount: u, matchUpFormat: i, tallyPolicy: l, subOrderMap: a });
  if (r && ox({ participantResults: f }), d && I)
    h = y, g = I, I.forEach((S) => {
      let { participantId: D, groupOrder: w, rankOrder: v, subOrder: P, ties: b, GEMscore: T } = S, R = f[D];
      Object.assign(R, { groupOrder: w, rankOrder: v, GEMscore: T, subOrder: P, ties: b });
    });
  else {
    let { groupOrder: S, report: D } = wS({ requireCompletion: !1, participantResults: f, participantsCount: u, matchUpFormat: i, tallyPolicy: l, subOrderMap: a, matchUps: n });
    h = D, g = S, S && S.forEach((w) => {
      let { participantId: v, groupOrder: P, GEMscore: b } = w, T = f[v];
      Object.assign(T, { provisionalOrder: P, GEMscore: b });
    });
  }
  let U = { completedTieMatchUps: p, readableReport: "", participantResults: f, bracketComplete: d, order: [], report: h };
  if ((d || p) && (U.order = g), t || oi({ tally: !0 })) {
    let S = tx({ matchUps: n, report: h, order: g });
    oi({ tally: !0 }) && console.log(S), U.readableReport = S;
  }
  return U;
}
function ox({ participantResults: e }) {
  let t = (n) => n.reduce((a, o) => a + parseFloat(o), 0), r = (n) => parseFloat((t(n) / n.length).toFixed(2)), i = Object.keys(e).map((n) => {
    let a = e[n], { pressureScores: o } = a, s = o != null && o.length ? r(o) : 0;
    return { participantId: n, averagePressure: s };
  }).sort((n, a) => (a.averagePressure || 0) - (n.averagePressure || 0)).map((n, a) => ({ ...n, order: a + 1 }));
  for (let n of i)
    e[n.participantId].pressureOrder = n.order;
}
function Ub({ positionAssignments: e }) {
  let t = (e || []).filter(ei(Cn)).map((n) => {
    let { extension: a } = Ne({ element: n, name: Ws }), o = ye(a == null ? void 0 : a.value), s = !isNaN(o) && o;
    return s && { participantId: n.participantId, subOrder: s };
  }).filter(Boolean), r = t.map(({ subOrder: n }) => n), i = Qr(r);
  return { subOrderMap: Object.assign({}, ...t.filter(({ subOrder: n }) => i[n] === 1).map(({ participantId: n, subOrder: a }) => ({ [n]: a }))) };
}
function EI({ positionAssignments: e, tournamentRecord: t, drawDefinition: r, matchUpFormat: i, matchUps: n, event: a }) {
  if (!Ti(n))
    return { error: J };
  if (!e)
    return { error: J };
  let { policyDefinitions: o } = ra({ policyTypes: [hg], tournamentRecord: t, drawDefinition: r, event: a }), { subOrderMap: s } = Ub({ positionAssignments: e }), c = n.length ? Dc({ policyDefinitions: o, matchUpFormat: i, subOrderMap: s, matchUps: n }) : void 0;
  if (c != null && c.error)
    return c;
  let { participantResults: u = {}, bracketComplete: d, report: p } = c ?? {}, l = Object.keys(u);
  return e.forEach((m) => {
    let { participantId: f } = m;
    if (l.includes(f)) {
      let h = { value: u[f], name: Ia };
      Ve({ element: m, extension: h }), u[f].ties || Sr({ element: m, name: Ws });
    } else
      Sr({ element: m, name: Ia }), Sr({ element: m, name: Ws });
  }), ut({ drawDefinition: r }), { ...V, participantResults: u, bracketComplete: d, report: p };
}
function yb({ matchUps: e, matchUpId: t }) {
  return { matchUp: (e || []).find((r) => r.matchUpId === t) };
}
function ft(e) {
  let t = fe(e, [{ [Rr]: !0, [gn]: !0 }]);
  if (t.error)
    return t;
  let { tournamentParticipants: r, afterRecoveryTimes: i, contextProfile: n, drawDefinition: a, matchUpsMap: o, matchUpId: s, inContext: c, context: u, event: d } = e, { structures: p = [] } = Bi({ drawDefinition: a }), l = e.contextContent || n && ia({ contextProfile: n, drawDefinition: a });
  for (let m of p) {
    let { matchUps: f } = Ke({ tournamentParticipants: r, afterRecoveryTimes: i, contextContent: l, drawDefinition: a, contextProfile: n, matchUpsMap: o, inContext: c, structure: m, context: u, event: d }), { matchUp: h } = yb({ matchUps: f, matchUpId: s });
    if (h)
      return { matchUp: h, structure: m };
  }
  return { error: hr };
}
function Wp(e) {
  var t;
  return !Le(e) || !e.notes ? { error: Ie } : Le(e.element) ? !ht(e.notes) && !((t = e.notes) != null && t.testing) ? { error: J } : (Object.assign(e.element, { notes: e.notes }), { ...V }) : { error: J };
}
function CI(e) {
  return Le(e) ? Le(e.element) ? (e.element.notes && delete e.element.notes, { ...V }) : { error: J } : { error: Ie };
}
var Hp = { matchUpStatus: Rt, matchUpStatusCodes: [], score: { scoreStringSide1: "", scoreStringSide2: "", sets: void 0 }, matchUpFormat: void 0, winningSide: void 0 };
function cn(e) {
  var v, P, b, T, R, M, E, C;
  let t = "modifyMatchUpScore", r = e.matchUpFormat, i = e.matchUp, n, { matchUpStatusCodes: a, tournamentRecord: o, drawDefinition: s, matchUpStatus: c, removeScore: u, winningSide: d, matchUpId: p, event: l, notes: m, score: f } = e, h = e.appliedPolicies && Object.keys(e.appliedPolicies).length ? e.appliedPolicies : (v = je({ policyTypes: [yi], tournamentRecord: o, drawDefinition: s, structure: n, event: l })) == null ? void 0 : v.appliedPolicies, g = i.matchUpType === lt;
  if (g && s) {
    if (p && i.matchUpId !== p) {
      let A = ft({ drawDefinition: s, matchUpId: p, event: l });
      if (!A.matchUp)
        return { error: hr };
      ({ matchUp: i, structure: n } = A);
    }
  } else
    i.matchUpId !== p && console.log("!!!!!");
  c && [Be, Et].includes(c) || u ? Object.assign(i, { ...Hp }) : f && (i.score = f);
  let I = c && (i == null ? void 0 : i.matchUpStatus) === ke && c !== ke;
  c && (i.matchUpStatus = c), r && (i.matchUpFormat = r), a && (i.matchUpStatusCodes = a), d && (i.winningSide = d), e.removeWinningSide && (i.winningSide = void 0), !n && s && ({ structure: n } = ft({ drawDefinition: s, matchUpId: p, event: l })), c && !i.winningSide && jt(i) && !Vt.includes(c) && ![Xo, Na, Zr].includes(c) && (i.matchUpStatus = Gi);
  let y;
  if ((I && ((P = i == null ? void 0 : i.processCodes) != null && P.length) || c === ke) && (y = (T = (b = h == null ? void 0 : h[yi]) == null ? void 0 : b.processCodes) == null ? void 0 : T.incompleteAssignmentsOnDefault), !i.collectionId) {
    let A = (n == null ? void 0 : n.structureType) === br, N = Er({ structure: n });
    if (Hg({ drawDefinition: s, structure: n }) || N || A) {
      let O = (x) => {
        r = g ? "SET1-S:T100" : r ?? i.matchUpFormat ?? (x == null ? void 0 : x.matchUpFormat) ?? (s == null ? void 0 : s.matchUpFormat) ?? (l == null ? void 0 : l.matchUpFormat);
        let _ = g ? { matchUpTypes: [lt] } : void 0, { matchUps: B } = Ke({ afterRecoveryTimes: !1, tournamentRecord: o, inContext: !0, matchUpFilters: _, drawDefinition: s, structure: x, event: l });
        return N && (x.positionAssignments = Te(B.flatMap((L) => (L.sides ?? []).map((G) => G.participantId)).filter(Boolean)).map((L) => ({ participantId: L }))), EI({ positionAssignments: x.positionAssignments, tournamentRecord: o, drawDefinition: s, matchUpFormat: r, matchUps: B, event: l });
      }, k = A && n.structures.find((x) => x == null ? void 0 : x.matchUps.find((_) => _.matchUpId === p)), F = O(k || n);
      if (F.error)
        return j({ result: F, stack: t });
    }
  }
  if (m) {
    let A = Wp({ element: i, notes: m });
    if (A.error)
      return j({ result: A, stack: t });
  }
  let U = o == null ? void 0 : o.tournamentId, S = vi().topics.includes(Dp), D = (S || y) && mr({ drawDefinition: s }), w = D && ((R = Bt({ matchUpFilters: { matchUpIds: [p] }, nextMatchUps: !0, tournamentRecord: o, inContext: !0, drawDefinition: s, matchUpsMap: D }).matchUps) == null ? void 0 : R[0]);
  if (S && w && nO({ tournamentId: U, inContextMatchUp: w }), Array.isArray(y) && w && !((M = w.sides) != null && M.every(({ participantId: A }) => A)))
    if (c === ke)
      i.processCodes = Te([...i.processCodes ?? [], ...y]);
    else
      for (let A of y || []) {
        let N = A && ((E = i == null ? void 0 : i.processCodes) == null ? void 0 : E.lastIndexOf(A));
        (C = i == null ? void 0 : i.processCodes) == null || C.splice(N, 1);
      }
  return xe({ eventId: l == null ? void 0 : l.eventId, context: t, drawDefinition: s, tournamentId: U, matchUp: i }), { ...V };
}
function OI(e) {
  var f, h, g, I;
  let { matchUpStatusCodes: t, matchUpStatus: r, structure: i, matchUp: n, dualMatchUp: a, inContextMatchUp: o, autoCalcDisabled: s } = e, c = td({ matchUpStatus: r }) || [Un, Gr].includes(r) && a || s, u = ((f = n == null ? void 0 : n.sides) == null ? void 0 : f.map((y) => y.participantId).filter(Boolean).length) || ((h = o == null ? void 0 : o.sides) == null ? void 0 : h.map((y) => y.participantId).filter(Boolean).length), d = "attemptToModifyScore";
  if (!(Er({ structure: i }) && u === 1 || r === ke && u || sx({ structure: i, matchUp: n, inContextMatchUp: o }) || ((I = (g = e.appliedPolicies) == null ? void 0 : g[yi]) == null ? void 0 : I.requireParticipantsForScoring) === !1))
    return j({ result: { error: Dh }, stack: d });
  let p = [Be].includes(r), l = c ? r : e.winningSide && Tt || Zr, m = cn({ ...e, matchUpStatusCodes: c && t || [], matchUpStatus: l, context: d, removeScore: p });
  return j({ result: m, stack: d });
}
function sx({ structure: e, matchUp: t, inContextMatchUp: r }) {
  var s;
  let { drawPositions: i } = t, { positionAssignments: n } = Yt({ structure: e }), a = n == null ? void 0 : n.filter((c) => (i == null ? void 0 : i.includes(c.drawPosition)) && c.participantId), o = (s = r == null ? void 0 : r.sides) == null ? void 0 : s.every((c) => c.participantId);
  return (a == null ? void 0 : a.length) === 2 || o;
}
function Sb({ collectionGroups: e = [] }) {
  let t = Object.assign({}, ...e.filter((i) => Pe(i == null ? void 0 : i.groupValue) && (i == null ? void 0 : i.groupNumber)).map((i) => ({ [i.groupNumber]: { ...i, allGroupMatchUpsCompleted: !0, matchUpsCount: 0, sideWins: [0, 0], values: [0, 0] } }))), r = Object.keys(t).map((i) => ye(i));
  return { groupValueGroups: t, groupValueNumbers: r };
}
function cx({ collectionDefinition: e, groupValueNumbers: t, groupValueGroups: r, sideTieValues: i, tieMatchUps: n }) {
  let a = n.filter((y) => y.collectionId === e.collectionId), o = [0, 0], s = [0, 0], c = a.every((y) => Vt.includes(y.matchUpStatus)), { collectionValueProfiles: u, collectionGroupNumber: d, collectionValue: p, matchUpValue: l, winCriteria: m, scoreValue: f, setValue: h } = e, g = d && t.includes(d), I = [0, 0];
  if (a.forEach((y) => {
    y.winningSide && (I[y.winningSide - 1] += 1);
  }), Pe(l) ? a.forEach((y) => {
    y.winningSide && (o[y.winningSide - 1] += l);
  }) : Pe(h) ? a.forEach((y) => {
    var U, S;
    (S = (U = y.score) == null ? void 0 : U.sets) == null || S.forEach((D) => {
      D.winningSide && (o[D.winningSide - 1] += h);
    });
  }) : Pe(f) ? a.forEach((y) => {
    var U, S;
    (S = (U = y.score) == null ? void 0 : U.sets) == null || S.forEach((D) => {
      let { side1TiebreakScore: w = 0, side2TiebreakScore: v = 0, side1Score: P = 0, side2Score: b = 0 } = D;
      (y.matchUpStatus === Tt || y.winningSide || D.winningSide) && (P || b ? (o[0] += P, o[1] += b) : (w || v) && D.winningSide && (o[D.winningSide - 1] += 1));
    });
  }) : Array.isArray(u) && a.forEach((y) => {
    if (y.winningSide) {
      let U = y.collectionPosition, S = ux({ collectionDefinition: e, collectionPosition: U });
      Pe(S) && (o[y.winningSide - 1] += S);
    }
  }), Pe(p)) {
    let y;
    if (m != null && m.aggregateValue)
      c && (Pe(l || h || f) && o[0] !== o[1] ? y = o[0] > o[1] ? 1 : 2 : I[0] !== I[1] && (y = I[0] > I[1] ? 1 : 2));
    else if (m != null && m.valueGoal)
      y = o.reduce((U, S, D) => S >= m.valueGoal ? D + 1 : U, 0);
    else {
      let U = Math.floor(e.matchUpCount / 2) + 1;
      y = I.reduce((S, D, w) => D >= U ? w + 1 : S, 0);
    }
    y && (g ? r[d].values[y - 1] += p : s[y - 1] += p);
  } else
    g ? (r[d].values[0] += o[0] || 0, r[d].values[1] += o[1] || 0) : s = o;
  g ? (r[d].sideWins[0] += I[0] || 0, r[d].sideWins[1] += I[1] || 0, r[d].allGroupMatchUpsCompleted = r[d].allGroupMatchUpsCompleted && c, r[d].matchUpsCount += a.length) : s.forEach((y, U) => i[U] += y || 0);
}
function ux({ collectionDefinition: e, collectionPosition: t }) {
  var r, i;
  return (i = (r = e.collectionValueProfiles || []) == null ? void 0 : r.find((n) => n.collectionPosition === t)) == null ? void 0 : i.matchUpValue;
}
function gd(e) {
  var S, D, w, v, P;
  let { sideAdjustments: t = [0, 0], separator: r = "-", drawDefinition: i, matchUpsMap: n, structure: a, matchUp: o, event: s } = e;
  if (!Array.isArray(t) || t.length !== 2 || isNaN(t.reduce((b, T) => b + T)))
    return { error: J };
  if (!o)
    return { error: Vr };
  let c = ((S = Ir({ matchUp: o, drawDefinition: i, structure: a, event: s })) == null ? void 0 : S.tieFormat) || (e == null ? void 0 : e.tieFormat);
  if (!c)
    return { error: ac };
  let u = Ar({ tieFormat: c });
  if (u.error)
    return u;
  let d = (c == null ? void 0 : c.collectionDefinitions) || [], p = (o == null ? void 0 : o.tieMatchUps) ?? [], l = [0, 0], { groupValueGroups: m, groupValueNumbers: f } = Sb(c);
  for (let b of d)
    cx({ collectionDefinition: b, groupValueNumbers: f, groupValueGroups: m, sideTieValues: l, tieMatchUps: p });
  for (let b of f) {
    let T = m[b], { allGroupMatchUpsCompleted: R, matchUpCount: M, winCriteria: E, groupValue: C, sideWins: A, values: N } = T, O;
    if (E != null && E.aggregateValue)
      R && N[0] !== N[1] && (O = N[0] > N[1] ? 1 : 2);
    else if (E != null && E.valueGoal)
      O = N.reduce((k, F, x) => F >= E.valueGoal ? x + 1 : k, void 0);
    else {
      let k = Math.floor(M / 2) + 1;
      O = A.reduce((F, x, _) => x >= k ? _ + 1 : F, void 0);
    }
    O && (l[O - 1] += C || 0);
  }
  let h = l.map((b, T) => (b || 0) + t[T]), g = { side1Score: h[0], side2Score: h[1], winningSide: void 0 }, I = h.join(r), y = h.slice().reverse().join(r), U;
  if (c != null && c.winCriteria) {
    let { valueGoal: b, aggregateValue: T, tallyDirectives: R } = c.winCriteria;
    if (b ? U = (D = h.map((M, E) => ({ sideNumber: E + 1, points: M })).find(({ points: M }) => M >= b)) == null ? void 0 : D.sideNumber : T && p.every((M) => M.matchUpStatus && Vt.includes(M.matchUpStatus) || M.winningSide) && h[0] !== h[1] && (U = h[0] > h[1] ? 1 : 2), !U && R) {
      let M = o.matchUpId, E = o.hasContext ? o : ((w = n == null ? void 0 : n.drawMatchUps) == null ? void 0 : w[M]) || i && ((v = ft({ inContext: !0, drawDefinition: i, matchUpId: M })) == null ? void 0 : v.matchUp);
      if (E) {
        let { completedTieMatchUps: C, order: A } = Dc({ matchUps: [E] });
        if (C && (A != null && A.length)) {
          let N = A[0].participantId;
          U = (P = E.sides.find(({ participantId: O }) => O === N)) == null ? void 0 : P.sideNumber;
        }
      }
    }
  }
  return U && (g.winningSide = U), { scoreStringSide1: I, scoreStringSide2: y, winningSide: U, set: g };
}
function Id({ inContextDualMatchUp: e, drawDefinition: t, tournamentId: r, dualMatchUp: i, eventId: n }) {
  var a, o;
  if (i) {
    e || (e = (a = ft({ matchUpId: i.matchUpId, inContext: !0, drawDefinition: t })) == null ? void 0 : a.matchUp);
    let { extension: s } = Ne({ element: t, name: Yn }), c = ce((s == null ? void 0 : s.value) || {}, !1, !0), u = ({ displaySideNumber: d, drawPosition: p, sideNumber: l }) => ({ drawPosition: p, sideNumber: l, displaySideNumber: d });
    i.sides = (o = e == null ? void 0 : e.sides) == null ? void 0 : o.map((d) => {
      var g;
      let p = d.participantId, l = p && c[p] || void 0, { lineUp: m, ...f } = ((g = i.sides) == null ? void 0 : g.find(({ sideNumber: I }) => I === d.sideNumber)) ?? {}, h = m != null && m.length ? m : l;
      return { ...u(d), ...f, lineUp: h };
    }), xe({ context: "ensureSidLineUps", matchUp: i, drawDefinition: t, tournamentId: r, eventId: n });
  }
}
function sr(e) {
  if (e)
    return ce(e, !1, !0);
}
function kI(e) {
  let t = fe(e, [{ [gr]: !0 }]);
  return t.error ? t : Object.keys(e.tournamentRecords).reduce((r, i) => {
    r.tournamentIdMap[i] = [];
    let n = e.tournamentRecords[i].events ?? [], a = n.map(({ eventId: s }) => s), o = n.map((s) => (s.drawDefinitions ?? []).map(({ drawId: c }) => c)).flat();
    return r.tournamentIdMap[i].push(...a, ...o), r.eventIds.push(...a), r.drawIds.push(...o), r;
  }, { eventIds: [], drawIds: [], tournamentIdMap: {} });
}
function vb({ tournamentRecords: e, eventId: t, drawId: r }) {
  let { tournamentIdMap: i } = kI({ tournamentRecords: e });
  return (i ? Object.keys(i) : []).find((n) => t && (i == null ? void 0 : i[n].includes(t)) || r && (i == null ? void 0 : i[n].includes(r)));
}
function na(e) {
  var M, E, C, A;
  let { exitWhenNoValues: t, drawDefinition: r, matchUpStatus: i, removeScore: n, matchUpsMap: a, matchUpId: o, event: s } = e, c = e.tournamentRecords || e.tournamentRecord && { [(M = e.tournamentRecord) == null ? void 0 : M.tournamentId]: e.tournamentRecord } || {}, u = e.tournamentId || ((E = e.tournamentRecord) == null ? void 0 : E.tournamentId);
  c && vb({ tournamentRecords: c, ...e });
  let d = u && c[u];
  if (!d)
    return { error: ae };
  let p = ft({ drawDefinition: r, event: s, matchUpId: o });
  if (p.error)
    return p;
  if (!p.matchUp)
    return { error: hr };
  let { matchUp: l, structure: m } = p;
  if (!l.tieMatchUps)
    return { error: jr };
  Id({ tournamentId: d == null ? void 0 : d.tournamentId, eventId: s == null ? void 0 : s.eventId, dualMatchUp: l, drawDefinition: r });
  let { extension: f } = Ne({ name: Lo, element: l });
  if (f != null && f.value)
    if (n)
      Sr({ element: l, name: Lo });
    else
      return { ...V, score: l.score };
  let h = (C = Ir({ drawDefinition: r, structure: m, matchUp: l, event: s })) == null ? void 0 : C.tieFormat;
  l.tieFormat = sr(h);
  let g = gd({ drawDefinition: r, matchUpsMap: a, structure: m, matchUp: l, event: s }), { winningSide: I, set: y, scoreStringSide1: U, scoreStringSide2: S } = g, D = (y == null ? void 0 : y.side1Score) || (y == null ? void 0 : y.side2Score);
  if (t && !l.score && !D)
    return { ...V };
  let w = { scoreStringSide1: U, scoreStringSide2: S, sets: y ? [y] : [] }, v = I && [1, 2].includes(I), P = v && Tt || Zg({ matchUpStatus: i ?? l.matchUpStatus, tieMatchUps: l.tieMatchUps, winningSide: l.winningSide, score: w }) && Gi || Rt, b = !!(l.winningSide && !v), T = l.tieMatchUps.find(({ score: N, winningSide: O, matchUpStatus: k }) => {
    var F;
    return ((F = N == null ? void 0 : N.sets) == null ? void 0 : F.length) && (N.sets[0].side1Score || N.sets[0].side2Score) || k && Vt.includes(k) || O;
  }), R;
  if (l.tieFormat && !v && !T) {
    let N = (A = Ir({ drawDefinition: r, structure: m, event: s })) == null ? void 0 : A.tieFormat;
    N && JSON.stringify(h) === JSON.stringify(N) && (l.tieFormatId = void 0, l.tieFormat = void 0, R = !0);
  }
  return cn({ appliedPolicies: e.appliedPolicies, matchUpStatus: P, score: w, removeWinningSide: b, tournamentRecord: d, drawDefinition: r, removeScore: n, winningSide: I, matchUpId: o, matchUp: l, event: s }), { ...V, score: w, removeWinningSide: b, tieFormatRemoved: R, winningSide: I };
}
function dx({ winnerMatchUpDrawPositionIndex: e, inContextDrawMatchUps: t, projectedWinningSide: r, sourceMatchUpStatus: i, winningDrawPosition: n, tournamentRecord: a, winnerTargetLink: o, sourceMatchUpId: s, drawDefinition: c, winnerMatchUp: u, dualMatchUp: d, matchUpsMap: p, event: l }) {
  var f, h, g, I, y;
  let m = "directWinner";
  if (o) {
    let U = u.drawPositions || [], S = U[e], D = o.source.structureId, w = ve({ structureId: D, drawDefinition: c });
    if (w.error)
      return w;
    let { structure: v } = w, { positionAssignments: P } = Yt({ structureId: D, drawDefinition: c }), b = (f = P == null ? void 0 : P.find((A) => A.drawPosition === n)) == null ? void 0 : f.participantId, T = o.target.structureId, { positionAssignments: R } = Yt({ structureId: T, drawDefinition: c }), M = (h = R == null ? void 0 : R.find((A) => A.participantId === b)) == null ? void 0 : h.drawPosition, E = R == null ? void 0 : R.filter((A) => {
      let N = U.includes(A.drawPosition), O = !A.participantId && !A.bye && !A.qualifier;
      return N && O;
    }).map((A) => A.drawPosition), C = E == null ? void 0 : E.includes(S);
    if (b && o.target.roundNumber === 1 && C)
      mn({ drawPosition: S, participantId: b, structureId: T, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, drawDefinition: c, matchUpsMap: p, event: l });
    else if (b && (E != null && E.length)) {
      let A = E.pop();
      A && mn({ participantId: b, structureId: T, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, drawDefinition: c, drawPosition: A, matchUpsMap: p, event: l });
    } else if (M) {
      let A = Ks({ drawPosition: M, matchUpId: u.matchUpId, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, sourceMatchUpId: s, drawDefinition: c, matchUpsMap: p });
      if (A.error)
        return j({ result: A, stack: m });
    } else if ((v == null ? void 0 : v.stage) !== ge) {
      let A = "winner target position unavaiallble";
      return console.log(A), { error: A };
    }
    if (v != null && v.seedAssignments && v.structureId !== T) {
      let A = v.seedAssignments.find(({ participantId: O }) => O === b), N = A == null ? void 0 : A.participantId;
      A && N && vc({ eventId: u == null ? void 0 : u.eventId, structureId: T, ...A, tournamentRecord: a, drawDefinition: c, participantId: N });
    }
  } else {
    let U = Ks({ matchUpId: u.matchUpId, drawPosition: n, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, sourceMatchUpId: s, drawDefinition: c, matchUpsMap: p });
    if (U.error)
      return U;
  }
  if (d && r) {
    let U = (g = d.sides) == null ? void 0 : g.find((S) => S.sideNumber === r);
    if (U != null && U.lineUp) {
      let S = d.roundPosition, D = u.roundPosition, w = S === D && S !== 1 || Math.floor(S / 2) === D ? 2 : 1, v = (I = p == null ? void 0 : p.drawMatchUps) == null ? void 0 : I.find(({ matchUpId: T }) => T === u.matchUpId), P = [1, 2].map((T) => {
        var R;
        return { ...((R = v.sides) == null ? void 0 : R.find((M) => M.sideNumber === T)) || {}, sideNumber: T };
      });
      v.sides = P;
      let b = v.sides.find((T) => T.sideNumber === w);
      if (b) {
        let T = (y = U.lineUp) == null ? void 0 : y.filter((R) => R == null ? void 0 : R.participantId);
        b.lineUp = fI({ lineUp: T }), xe({ tournamentId: a == null ? void 0 : a.tournamentId, eventId: u == null ? void 0 : u.eventId, matchUp: v, context: m, drawDefinition: c });
      }
    }
  }
  return { ...V };
}
function lx(e) {
  var x, _, B;
  let { loserMatchUpDrawPositionIndex: t, inContextDrawMatchUps: r, projectedWinningSide: i, sourceMatchUpStatus: n, loserDrawPosition: a, tournamentRecord: o, loserTargetLink: s, drawDefinition: c, loserMatchUp: u, dualMatchUp: d, matchUpsMap: p, event: l } = e, m = "directLoser", f = s.linkCondition, h = u.drawPositions || [], g = f === ln && u.roundNumber === 2 && Math.min(...h.filter(Boolean)), I = g || h[t], y = g || h[1 - t], U = s.source.structureId, { structure: S } = ve({ structureId: U, drawDefinition: c }), { matchUps: D } = Ke({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: c, structure: S, event: l }), w = D.filter((L) => {
    var G;
    return (G = L.drawPositions) == null ? void 0 : G.includes(a);
  }).filter((L) => {
    let G = L.sides.find((W) => W.drawPosition === a), $ = L.matchUpStatus === Be || L.matchUpStatus === ke && !jt(L);
    return (G == null ? void 0 : G.sideNumber) === L.winningSide && !$;
  }), v = f === ln && w.length === 0, { positionAssignments: P } = Yt({ structureId: U, drawDefinition: c }), b = (x = P == null ? void 0 : P.find((L) => L.drawPosition === a)) == null ? void 0 : x.participantId, T = s.target.structureId, { positionAssignments: R } = Yt({ structureId: T, drawDefinition: c }), M = R == null ? void 0 : R.filter(({ drawPosition: L }) => h.includes(L));
  if (M != null && M.some((L) => L.participantId === b))
    return { ...V };
  let E = M == null ? void 0 : M.filter((L) => {
    let G = h.includes(L.drawPosition), $ = !L.participantId && !L.bye && !L.qualifier;
    return G && $;
  }).map((L) => L.drawPosition), C = E == null ? void 0 : E.includes(I), A = s.target.roundNumber > 1 && (E == null ? void 0 : E.length), N = s.target.roundNumber === 1 && C;
  if (g) {
    let L = O();
    if (L.error)
      return j({ result: L, stack: m });
  } else if (N) {
    let L = F();
    if (L.error)
      return j({ result: L, stack: m });
  } else if (b && A) {
    E.sort(Ft);
    let L = E[0], G = mn({ participantId: b, structureId: T, drawPosition: L, inContextDrawMatchUps: r, sourceMatchUpStatus: n, tournamentRecord: o, drawDefinition: c, matchUpsMap: p, event: l });
    if (G.error)
      return j({ result: G, stack: m });
  } else
    return j({ context: { loserDrawPosition: a, loserTargetLink: s, targetDrawPositionIsUnfilled: C }, result: { error: C ? rc : KE }, stack: m });
  if (S != null && S.seedAssignments && S.structureId !== T) {
    let L = S.seedAssignments.find(({ participantId: $ }) => $ === b), G = L == null ? void 0 : L.participantId;
    L && G && vc({ eventId: u == null ? void 0 : u.eventId, structureId: T, ...L, tournamentRecord: o, drawDefinition: c, participantId: G });
  }
  if (d && i) {
    let L = (_ = d.sides) == null ? void 0 : _.find((G) => G.sideNumber === 3 - i);
    if (L != null && L.lineUp) {
      let { roundNumber: G, eventId: $ } = u, { roundPosition: W } = d, q = G === 1 ? 2 - W % 2 : 1, K = (B = p == null ? void 0 : p.drawMatchUps) == null ? void 0 : B.find(({ matchUpId: X }) => X === u.matchUpId), z = [1, 2].map((X) => {
        var re;
        return { ...((re = K.sides) == null ? void 0 : re.find((Q) => Q.sideNumber === X)) || {}, sideNumber: X };
      });
      K.sides = z;
      let Y = K.sides.find((X) => X.sideNumber === q);
      Y && (Y.lineUp = fI({ lineUp: L.lineUp }), xe({ tournamentId: o == null ? void 0 : o.tournamentId, matchUp: K, context: m, drawDefinition: c, eventId: $ }));
    }
  }
  return { ...V };
  function O() {
    let L = "loserLinkFedFMLC";
    return j(v ? { result: F(), stack: L } : { result: k(), stack: L });
  }
  function k() {
    let L = pi({ drawPosition: y, structureId: T, tournamentRecord: o, drawDefinition: c, event: l });
    return j({ result: L, stack: "assignLoserPositionBye" });
  }
  function F() {
    let L = b ? mn({ drawPosition: I, participantId: b, structureId: T, inContextDrawMatchUps: r, sourceMatchUpStatus: n, tournamentRecord: o, drawDefinition: c, matchUpsMap: p, event: l }) : { error: _t };
    return j({ result: L, stack: "assignLoserDrawPosition" });
  }
}
function wb(e) {
  var w;
  let t = "directParticipants", r = OI(e);
  if (r.error)
    return j({ result: r, stack: t });
  let i = td({ matchUpStatus: e.matchUpStatus }), { dualWinningSideChange: n, projectedWinningSide: a, inContextDrawMatchUps: o, tournamentRecord: s, drawDefinition: c, matchUpStatus: u, dualMatchUp: d, matchUpsMap: p, winningSide: l, targetData: m, matchUpId: f, structure: h, matchUp: g, event: I } = e, y = !!g.collectionId, U = Er({ structure: h }), S = g.drawPositions, D;
  if (y) {
    let { matchUpTieId: v, matchUpsMap: P } = e, b = na({ appliedPolicies: e.appliedPolicies, matchUpId: v, tournamentRecord: s, drawDefinition: c, matchUpsMap: P, event: I });
    if (D = b && { tieMatchUpResult: b }, S = (w = o.find(({ matchUpId: T }) => T === v)) == null ? void 0 : w.drawPositions, !n)
      return j({ result: { ...V, ...D }, stack: t });
  }
  if (U)
    return j({ result: { ...V, ...D }, stack: t });
  if (S) {
    let v = a ? a - 1 : l - 1, P = 1 - v, b = S[v], T = S[P], { targetLinks: { loserTargetLink: R, winnerTargetLink: M, byeTargetLink: E }, targetMatchUps: { winnerMatchUpDrawPositionIndex: C, loserMatchUpDrawPositionIndex: A, winnerMatchUp: N, loserMatchUp: O, byeMatchUp: k } } = m;
    if (N) {
      let F = dx({ sourceMatchUpStatus: i && u || Tt, winnerMatchUpDrawPositionIndex: C, sourceMatchUpId: f, inContextDrawMatchUps: o, projectedWinningSide: a, winningDrawPosition: b, tournamentRecord: s, winnerTargetLink: M, drawDefinition: c, winnerMatchUp: N, dualMatchUp: d, matchUpsMap: p, event: I });
      if (F.error)
        return j({ result: F, stack: t });
    }
    if (O) {
      let F = lx({ sourceMatchUpStatus: i && u || Tt, loserMatchUpDrawPositionIndex: A, sourceMatchUpId: f, inContextDrawMatchUps: o, projectedWinningSide: a, loserDrawPosition: T, tournamentRecord: s, loserTargetLink: R, drawDefinition: c, loserMatchUp: O, winningSide: l, matchUpsMap: p, dualMatchUp: d, event: I });
      if (F.error)
        return j({ result: F, stack: t });
    }
    if (k) {
      let F = k.drawPositions || [], x = Math.min(...F.filter(Boolean)), _ = E.target.structureId, B = pi({ drawPosition: x, structureId: _, tournamentRecord: s, drawDefinition: c, event: I });
      if (B.error)
        return j({ result: B, stack: t });
    }
  } else
    return j({ result: { error: Du }, stack: t });
  return j({ result: { ...V, ...D }, stack: t });
}
function FI(e) {
  var q, K, z, Y;
  let t = "genPlayoffStructure";
  if (!e.drawDefinition)
    return j({ result: { error: le }, stack: t });
  let r = pd(e);
  if (r.error)
    return j({ result: r, stack: t });
  let { structureId: i, addNameBaseToAttributeName: n, playoffStructureNameBase: a, finishingPositionNaming: o, finishingPositionLimit: s, playoffAttributes: c, playoffPositions: u, roundOffsetLimit: d, tournamentRecord: p, exitProfileLimit: l, roundProfiles: m, roundNumbers: f, idPrefix: h, isMock: g, event: I, uuids: y } = e, U = ce(e.drawDefinition, !1, !0), { structure: S } = ve({ structureId: i, drawDefinition: U });
  if (!S)
    return j({ result: { error: It }, stack: t });
  if (S.structureType === br || S.structures)
    return qF({ sourceStructureId: S.structureId, ...e, ...r, drawDefinition: U });
  let { playoffRoundsRanges: D, playoffRounds: w } = r, { playoffPositionsReturned: v, error: P, playoffSourceRounds: b, playoffRoundsRanges: T } = nb(e);
  if (P)
    return j({ result: { error: P }, stack: t });
  let R = (m == null ? void 0 : m.length) && Object.assign({}, ...m), M = f || typeof m == "object" && m.map((X) => Object.keys(X)).flat(), E = Array.isArray(M) && M.map((X) => !isNaN(X) && ye(X)).filter(Boolean);
  if (E) {
    if (!Array.isArray(E))
      return j({ result: { error: J }, context: { validRoundNumbers: E }, stack: t });
    E.forEach((X) => {
      if (!(w != null && w.includes(X)))
        return j({ result: { error: J }, context: { roundNumber: X }, stack: t });
    });
  }
  u && u.forEach((X) => {
    if (!(v != null && v.includes(X)))
      return j({ result: { error: J }, context: { playoffPosition: X }, stack: t });
  });
  let C = E || b, A = E ? D : T, N = [], O = [];
  for (let X of C ?? []) {
    let re = A == null ? void 0 : A.find((ie) => ie.roundNumber === X);
    if (!re)
      return j({ result: { error: J }, context: { roundNumber: X }, stack: t });
    let Q = re.finishingPositions.length, H = Math.min(...re.finishingPositions) - 1, Z = 2, ee = X && (R == null ? void 0 : R[X]) && Z + R[X] - 1, te = Ns({ exitProfile: `0-${X}`, addNameBaseToAttributeName: n, playoffStructureNameBase: a, finishingPositionOffset: H, playoffAttributes: c, exitProfileLimit: l, stage: vt, roundOffset: 0, drawDefinition: U, sequenceLimit: ee, stageSequence: Z, drawSize: Q, idPrefix: h, isMock: g, uuids: y, finishingPositionNaming: o, finishingPositionLimit: s, roundOffsetLimit: d });
    if (te.error)
      return j({ result: te, stack: t });
    let { structures: ne, links: se } = te;
    if (ne != null && ne.length && N.push(...ne), se != null && se.length && O.push(...se), te.structureId && X) {
      let ie = { linkType: An, source: { structureId: i, roundNumber: X }, target: { structureId: te.structureId, feedProfile: Ei, roundNumber: 1 } };
      O.push(ie);
    }
  }
  if (!N.length)
    return j({ result: { error: J }, info: "No structures generated", stack: t });
  U.structures.push(...N), U.links.push(...O);
  let { matchUps: k, matchUpsMap: F } = Bt({ inContext: !0, drawDefinition: U }), x = N.map(({ structureId: X }) => X), _ = k == null ? void 0 : k.filter(({ structureId: X }) => x.includes(X)).map(Ht), B = (q = F == null ? void 0 : F.drawMatchUps) == null ? void 0 : q.filter(({ matchUpId: X }) => _ == null ? void 0 : _.includes(X));
  if (B != null && B.length) {
    let X = (K = Ir({ drawDefinition: U, event: I })) == null ? void 0 : K.tieFormat;
    X && B.forEach((re) => {
      let { tieMatchUps: Q } = md({ matchUp: re, tieFormat: X, isMock: g });
      Object.assign(re, { tieMatchUps: Q, matchUpType: lt });
    });
  }
  (z = k == null ? void 0 : k.filter((X) => ja({ matchUp: X }) && X.structureId === i)) == null || z.forEach((X) => {
    let { matchUpId: re, score: Q, winningSide: H } = X, Z = Dr({ inContextDrawMatchUps: k, drawDefinition: U, matchUpId: re }), ee = wb({ inContextDrawMatchUps: k, tournamentRecord: p, drawDefinition: U, matchUpsMap: F, winningSide: H, targetData: Z, matchUpId: re, structure: S, matchUp: X, score: Q, event: I });
    ee.error && console.log(ee.error);
  }), (Y = k == null ? void 0 : k.filter((X) => X.matchUpStatus === $e && X.structureId === i)) == null || Y.forEach((X) => {
    let { matchUpId: re } = X, Q = Dr({ inContextDrawMatchUps: k, drawDefinition: U, matchUpId: re }), { targetLinks: { loserTargetLink: H }, targetMatchUps: { loserMatchUpDrawPositionIndex: Z, loserMatchUp: ee } } = Q;
    if (H && ee) {
      let te = H.target.structureId, ne = ee.drawPositions[Z], se = pi({ drawPosition: ne, structureId: te, tournamentRecord: p, drawDefinition: U, event: I });
      se.error && console.log(se.error);
    }
  });
  let L = [], G = Ja({ inContextDrawMatchUps: k, drawDefinition: U, matchUpsMap: F }).goesToMap, { structure: $ } = ve({ drawDefinition: e.drawDefinition, structureId: i }), { matchUps: W } = Ke({ structure: $ });
  return W.forEach((X) => {
    var H, Z;
    let re = G == null ? void 0 : G.loserMatchUpIds[X.matchUpId];
    if (re && X.loserMatchUpId !== re) {
      X.loserMatchUpId = re;
      let ee = { tournamentId: p == null ? void 0 : p.tournamentId, eventId: (H = e.event) == null ? void 0 : H.eventId, context: t, matchUp: X };
      L.push(ee);
    }
    let Q = G == null ? void 0 : G.winnerMatchUpIds[X.matchUpId];
    if (Q && X.winnerMatchUpId !== Q) {
      X.winnerMatchUpId = Q;
      let ee = { tournamentId: p == null ? void 0 : p.tournamentId, eventId: (Z = e.event) == null ? void 0 : Z.eventId, context: t, matchUp: X };
      L.push(ee);
    }
  }), { structures: N, matchUpModifications: L, links: O, drawDefinition: U, ...V };
}
function Pb({ element: e }) {
  if (!e)
    return { error: J };
  if (!e.timeItems)
    return {};
  if (!Array.isArray(e.timeItems))
    return { error: J };
  let t = (r, i) => (n, a) => (a[r] && (n[a[r]] = a[i]), n);
  return e.timeItems.reduce(t("itemType", "itemValue"), {});
}
function yn(e) {
  let { duplicateValues: t = !0, creationTime: r = !0, removePriorValues: i, timeItem: n } = e;
  if (!n)
    return { error: Lh };
  let a = OD(e);
  if (a.error)
    return a;
  if (!(Le(n) && ht(n.itemType) && Object.keys(n).includes("itemValue")))
    return { error: xh };
  if (!a.timeItems)
    a.timeItems = [];
  else if (px({ element: a, duplicateValues: t, timeItem: n }))
    return { ...V };
  if (n.itemSubTypes && !n.itemSubTypes.length && delete n.itemSubTypes, r) {
    let o = (/* @__PURE__ */ new Date()).toISOString();
    Object.assign(n, { createdAt: o });
  }
  return i && (a.timeItems = a.timeItems.filter(({ itemType: o }) => n.itemType !== o)), i && !n.itemValue || a.timeItems.push(n), { ...V };
}
function px({ element: e, duplicateValues: t, timeItem: r }) {
  var s;
  let { itemType: i, itemSubTypes: n, itemValue: a } = r, o = i && ((s = Pi({ itemSubTypes: n, itemType: i, element: e })) == null ? void 0 : s.timeItem);
  return o && JSON.stringify(o == null ? void 0 : o.itemValue) === JSON.stringify(a) && !t;
}
function xI({ creationTime: e = !0, removePriorValues: t, tournamentRecord: r, duplicateValues: i, participantId: n, timeItem: a }) {
  if (!r)
    return { error: ae };
  if (!n)
    return { error: _t };
  let o = Aa({ tournamentRecord: r, participantId: n });
  return o.error ? o : yn({ element: o.participant, removePriorValues: t, duplicateValues: i, creationTime: e, timeItem: a });
}
function Ud(e) {
  let { removePriorValues: t, tournamentRecord: r, duplicateValues: i, creationTime: n, timeItem: a } = e;
  if (!r)
    return { error: ae };
  let o = yn({ element: r, removePriorValues: t, duplicateValues: i, creationTime: n, timeItem: a });
  if (o.error)
    return o;
  let s = Pb({ element: r });
  return De({ payload: { parentOrganisation: r.parentOrganisation, tournamentId: r.tournamentId, timeItemValues: s }, topic: co }), o;
}
function ms(e) {
  let { removePriorValues: t, duplicateValues: r, creationTime: i, timeItem: n, event: a } = e;
  return a ? yn({ removePriorValues: t, duplicateValues: r, element: a, creationTime: i, timeItem: n }) : { error: Ii };
}
function Db(e) {
  return zp({ ...e, itemType: "attachConsolationStructures" });
}
function LI(e) {
  return zp({ ...e, itemType: "attachPlayoffStructures" });
}
function zp({ itemType: e = "attachStructures", matchUpModifications: t, tournamentRecord: r, drawDefinition: i, structures: n, links: a = [], event: o }) {
  var g, I, y;
  let s = "attachStructures";
  if (!i)
    return { error: le };
  if (!Array.isArray(n) || !Array.isArray(a))
    return j({ result: { error: J }, stack: s });
  let c = (U) => {
    var S;
    return [U.source.structureId, U.source.roundNumber || ((S = U.source.finishingPositions) == null ? void 0 : S.join("|")), U.target.roundNumber].join("|");
  }, u = (g = i.links) == null ? void 0 : g.map(c);
  if (a.some((U) => {
    let S = c(U);
    return u == null ? void 0 : u.includes(S);
  }))
    return j({ result: { error: Gh }, info: "playoff structure exists", stack: s });
  a.length && ((I = i.links) == null || I.push(...a));
  let d = n.map(({ structureId: U }) => U), p = (y = i.structures) == null ? void 0 : y.map(({ structureId: U }) => U);
  i.structures = (i.structures ?? []).map((U) => d.includes(U.structureId) ? n.find(({ structureId: S }) => S === U.structureId) : U);
  let l = n == null ? void 0 : n.filter(({ structureId: U }) => !(p != null && p.includes(U)));
  l.length && i.structures.push(...l), Ja({ drawDefinition: i });
  let m = n.map((U) => {
    var S;
    return ((S = Ke({ structure: U })) == null ? void 0 : S.matchUps) || [];
  }).flat();
  ya({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: o == null ? void 0 : o.eventId, drawDefinition: i, matchUps: m });
  let f = n.map(({ structureId: U }) => U);
  if (ut({ drawDefinition: i, structureIds: f }), t == null ? void 0 : t.length) {
    let U = {};
    t.forEach((D) => {
      var v;
      let w = (v = D.matchUp) == null ? void 0 : v.matchUpId;
      w && (U[w] = D);
    });
    let S = (D) => {
      D.matchUps.forEach((w) => {
        if (U[w.matchUpId]) {
          let { tieMatchUps: v, ...P } = U[w.matchUpId].matchUp;
          if (Object.assign(w, P), v == null ? void 0 : v.length) {
            let b = {};
            v.forEach((T) => U[T.matchUpId] = T), w.tieMatchUps.forEach((T) => Object.assign(T, b[T.matchUpId]));
          }
          U[w.matchUpId].matchUp = w, xe(U[w.matchUpId]);
        }
      });
    };
    i.structures.forEach((D) => {
      if (p != null && p.includes(D.structureId))
        if (D.structures)
          for (let w of D.structures)
            S(w);
        else
          S(D);
    });
  }
  let h = l.map(ei("structureId"));
  if (r) {
    let U = { itemValue: { structureIds: f, drawId: i.drawId }, itemType: e };
    yn({ element: r, timeItem: U });
  }
  return { ...V, addedStructureIds: h };
}
function Yp(e) {
  var o, s;
  let { structures: t, links: r, matchUpModifications: i, error: n } = FI(e);
  if (n)
    return { error: n };
  let a = e.drawDefinition;
  return LI({ tournamentId: (o = e.tournamentRecord) == null ? void 0 : o.tournamentId, eventId: ((s = e.event) == null ? void 0 : s.eventId) || e.eventId, matchUpModifications: i, drawDefinition: a, structures: t, links: r });
}
function Za(e) {
  let t = fe(e, [{ _anyOf: { [gr]: !1, [Gt]: !1, [Rr]: !1, [ba]: !1 }, [og]: !0 }]);
  if (t.error)
    return t;
  let r = [], i = e.drawDefinition ?? e.event ?? ((e.tournamentId || !e.tournamentRecords) && e.tournamentRecord);
  if (i) {
    let n = PS(e, i);
    if (n.error)
      return n;
    r.push(...(n == null ? void 0 : n.applied) ?? []), e.drawDefinition && ut({ drawDefinition: e.drawDefinition, tournamentId: e.tournamentId });
  } else if (e.tournamentRecords) {
    let n = Object.keys(e.tournamentRecords);
    if (!n.length)
      return { error: ae };
    for (let a of n) {
      let o = e.tournamentRecords[a], s = PS(e, o);
      if (s.error)
        return s;
      r.push(...(s == null ? void 0 : s.applied) ?? []);
    }
  } else
    return { error: ae };
  return r.length ? { ...V, applied: r } : { error: Nh };
}
function PS(e, t) {
  let r = je(e).appliedPolicies ?? {};
  t.extensions || (t.extensions = []);
  let i = [], n = Object.keys(e.policyDefinitions);
  if (!n.length)
    return { error: ql };
  for (let a of n)
    if (!r[a] || e.allowReplacement) {
      let o = e.policyDefinitions[a];
      if (!o)
        continue;
      if (!Le(o))
        return { error: J };
      let { policyName: s, ...c } = o;
      if (!c || !Object.keys(c).length || s && !ht(s))
        return { error: J };
      r[a] = e.policyDefinitions[a], i.push(a);
    }
  return i != null && i.length ? { ...Ve({ element: t, extension: { name: su, value: r } }), applied: i } : { applied: i, error: Nh };
}
function _I({ tournamentRecord: e, drawDefinition: t, flightProfile: r, drawName: i, drawId: n, event: a }) {
  var s;
  if (!i || typeof i != "string")
    return j({ result: { error: J }, context: { drawName: i } });
  r || (r = Pt({ event: a }).flightProfile);
  let o = (s = r == null ? void 0 : r.flights) == null ? void 0 : s.find((c) => c.drawId === n);
  if (o) {
    o.drawName = i;
    let c = { name: _i, value: { ...r, flights: r.flights } };
    Ma({ event: a, extension: c });
  }
  return t && (t.drawName = i, ut({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t })), !o && !t ? { error: le } : { ...V, flight: o };
}
function Tb({ tournamentRecord: e, drawDefinition: t, drawUpdates: r, drawId: i, event: n }) {
  var c;
  if (!Le(r))
    return { error: J };
  let a = Pt({ event: n }).flightProfile, o = r.drawName && _I({ drawName: r.drawName, tournamentRecord: e, drawDefinition: t, flightProfile: a, drawId: i, event: n });
  if (o != null && o.error)
    return o == null ? void 0 : o.error;
  let s = (o == null ? void 0 : o.flight) || ((c = a == null ? void 0 : a.flights) == null ? void 0 : c.find((u) => u.drawId === i));
  if (!s && !t)
    return { error: le };
  if (s) {
    let u = { name: _i, value: { ...a, flights: a.flights } };
    Ma({ event: n, extension: u });
  }
  return t && (r.policyDefinitions && Za({ policyDefinitions: r.policyDefinitions, drawDefinition: t }), ut({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t })), { ...V };
}
function bb({ tournamentRecord: e, removeScheduling: t, drawDefinition: r }) {
  var o, s;
  if (!r)
    return { error: le };
  let i = mr({ drawDefinition: r }), n = (c) => {
    var u;
    return (u = i == null ? void 0 : i.drawMatchUps) == null ? void 0 : u.find((d) => d.matchUpId === c);
  };
  for (let c of r.structures || []) {
    let { positionAssignments: u, stage: d, stageSequence: p } = c;
    u && (p !== 1 || ![ge, ue].includes(d)) && (c.positionAssignments = u.map((f) => (delete f.participantId, f)), c.seedAssignments = []);
    let { matchUps: l, isRoundRobin: m } = Ke({ afterRecoveryTimes: !1, inContext: !0, matchUpsMap: i, structure: c });
    for (let f of l) {
      let { matchUpId: h, roundNumber: g } = f, I = f.sides || [], y = n(h);
      if (y) {
        if (delete y.extensions, delete y.notes, y.matchUpStatus !== $e && Object.assign(y, Hp), g && g > 1 && ((o = y.drawPositions) == null ? void 0 : o.length) && !m) {
          let U = I == null ? void 0 : I.map(({ drawPosition: D, participantFed: w }) => !w && D).filter(Boolean), S = y.drawPositions.map((D) => U.includes(D) ? void 0 : D);
          y.drawPositions = S;
        }
        t ? delete y.timeItems : (s = y.timeItems) != null && s.length && (y.timeItems = y.timeItems.filter((U) => U.itemType && ![kn, va, rs, Kg, is, ns].includes(U.itemType))), xe({ tournamentId: e == null ? void 0 : e.tournamentId, context: "resetDrawDefiniton", drawDefinition: r, matchUp: y });
      }
    }
  }
  r.extensions = r.extensions.filter((c) => c.name !== Ms);
  let a = (r.structures || []).map(({ structureId: c }) => c);
  return ut({ drawDefinition: r, structureIds: a }), { ...V };
}
function yd({ tournamentRecord: e }) {
  var i;
  if (!e)
    return { error: ae };
  let t = { positionsNoOutcomes: [], canBePruned: [], matchPlay: [], inactive: [], drawAnalysis: {} }, r = {};
  return ((i = e.events) == null ? void 0 : i.map((n) => {
    let a = n.eventId;
    return r[a] = n, ((n == null ? void 0 : n.drawDefinitions) || []).map((o) => ({ drawDefinition: o, eventId: a }));
  }).flat().filter(Boolean)).forEach(({ drawDefinition: n, eventId: a }) => {
    let o = 0, s = 0, c = 0, { allStructuresLinked: u } = Gp({ drawDefinition: n }), d = r[a], p = ((n == null ? void 0 : n.structures) || []).map((S) => {
      let { stage: D, stageSequence: w, structureId: v } = S, P = Fo[D], { inContextStructureMatchUps: b } = rd({ drawDefinition: n, structure: S, event: d }), T = b == null ? void 0 : b.filter(({ winningSide: L }) => L), R = T.filter(Boolean).length || 0;
      s += R, c += b.length - s;
      let M = Math.max(T.filter(({ roundNumber: L }) => L === 1).map(({ roundPosition: L }) => L)), { positionAssignments: E } = ot({ structure: S }), C = E == null ? void 0 : E.filter(({ participantId: L }) => L);
      o += (C == null ? void 0 : C.length) ?? 0;
      let A = ((E == null ? void 0 : E.length) ?? 0) - ((C == null ? void 0 : C.length) ?? 0), { roundMatchUps: N, roundProfile: O, roundNumbers: k, maxMatchUpsCount: F } = Pr({ matchUps: b }), x = O && Object.keys(O).filter((L) => !O[L].inactiveRound).map((L) => parseInt(L)), _ = O && Object.keys(O).filter((L) => O[L].inactiveRound).map((L) => parseInt(L)), B = O && Object.values(O).every((L) => L.inactiveRound);
      return { positionsAssignedCount: (C == null ? void 0 : C.length) ?? 0, maxWinningSideFirstRoundPosition: M, unassignedPositionsCount: A, inactiveStructure: B, maxMatchUpsCount: F, inactiveRounds: _, roundMatchUps: N, activeRounds: x, roundNumbers: k, roundProfile: O, structureId: v, stageSequence: w, orderNumber: P, stage: D };
    }), l = p.find((S) => S.orderNumber === 2 && S.stageSequence === 1), m = p.filter(({ inactiveStructure: S }) => !S).length, { links: f } = Ic({ structureId: l.structureId, drawDefinition: n }), h = ye(l.activeRounds[0]) === 1 && l.activeRounds.length === 1 && m === 1, g = p == null ? void 0 : p.every(({ inactiveStructure: S }) => S), I = !f.length && l.activeRounds.length && (l.roundProfile[1].inactiveCount || l.inactiveRounds.length), y = n.drawId;
    o && !s && t.positionsNoOutcomes.push(y), g && t.inactive.push(y), h && t.matchPlay.push(y), I && t.canBePruned.push(y);
    let U = { matchUpsWithWinningSideCount: s, matchUpsNoOutcomeCount: c, positionsAssignedCount: o, allStructuresLinked: u, structuresData: p, inactiveDraw: g, isMatchPlay: h, drawId: y };
    t.drawAnalysis[y] = U;
  }), { ...V, drawsAnalysis: t };
}
function Rb({ matchPlayDrawPositions: e = !0, tournamentRecord: t, drawDefinition: r, drawId: i }) {
  var o;
  if (!t)
    return { error: ae };
  if (!r)
    return { error: le };
  let n = [], { drawsAnalysis: a } = yd({ tournamentRecord: t });
  if (a.canBePruned.includes(i)) {
    let s = a.matchPlay.includes(i), c = a.drawAnalysis[i], { structures: [u] } = Bi({ stageSequence: 1, drawDefinition: r, stage: ue }), d = c.structuresData.find(({ structureId: f }) => u.structureId === f), p = (u.matchUps ?? []).sort((f, h) => f.roundPosition - h.roundPosition);
    n = p.filter(({ roundNumber: f }) => !d.inactiveRounds.includes(f));
    let l = n.map(Ht), m = p.map(Ht).filter((f) => !l.includes(f));
    if (s) {
      let f = n.filter(({ roundNumber: U }) => !d.inactiveRounds.includes(U)).filter(({ winningSide: U }) => U), h = f.map(Ht), g = l.filter((U) => !h.includes(U));
      m.push(...g);
      let I = f.flatMap((U) => U.drawPositions ?? []).filter(Boolean).flat(), y = Object.assign({}, ...I.map((U, S) => ({ [U]: S + 1 })));
      if (f.forEach((U) => {
        e ? U.drawPositions = U.drawPositions.map((S) => y[S]) : delete U.drawPositions;
      }), e) {
        let U = (o = u == null ? void 0 : u.positionAssignments) == null ? void 0 : o.filter((S) => I.includes(S.drawPosition)).map((S) => (S.drawPosition = y[S.drawPosition], S));
        u.positionAssignments = U;
      } else
        u.positionAssignments = [];
      u.matchUps = f, n = f;
    }
    ta({ tournamentId: t == null ? void 0 : t.tournamentId, matchUpIds: m, drawDefinition: r }), ut({ drawDefinition: r });
  }
  return { ...V, matchUps: n };
}
function Mb({ tournamentRecord: e, drawDefinition: t, participantId: r, drawPosition: i, structureId: n, qualifier: a, event: o, bye: s }) {
  if (!t)
    return { error: le };
  if (!i)
    return { error: ic };
  if (!n)
    return { error: ui };
  if (s) {
    let c = pi({ tournamentRecord: e, drawDefinition: t, drawPosition: i, structureId: n, event: o });
    if (c.error)
      return c;
  } else {
    if (a)
      return { error: Zl };
    {
      let c = mn({ tournamentRecord: e, drawDefinition: t, participantId: r, drawPosition: i, structureId: n, event: o });
      if (c.error)
        return c;
    }
  }
  return { ...V };
}
function Nb(e) {
  var c, u, d, p, l;
  let t = e.matchUpIds ?? [], { drawDefinition: r } = e, i = e.structureId ?? ((u = (c = r == null ? void 0 : r.structures) == null ? void 0 : c.find((m) => {
    var f;
    return (f = m.matchUps) == null ? void 0 : f.some(({ matchUpId: h }) => t.includes(h));
  })) == null ? void 0 : u.structureId) ?? ((p = (d = r == null ? void 0 : r.structures) == null ? void 0 : d[0]) == null ? void 0 : p.structureId);
  if (!i)
    return { error: It };
  let n = (l = r.structures) == null ? void 0 : l.find((m) => m.structureId === i);
  if (!n)
    return { error: It };
  let a = n == null ? void 0 : n.matchUps, o = a == null ? void 0 : a.find((m) => !!m.roundPosition);
  if (n.structures || o || n.finishingPosition === Jo)
    return { error: no };
  let s = a.filter(({ roundNumber: m }) => {
    var f;
    return (f = e.roundNumbers) == null ? void 0 : f.includes(m);
  }).map(Ht);
  return t = t.filter((m) => !s.includes(m)), e.roundNumbers && !t.length && (t = s), { existingMatchUps: a, matchUpIds: t, structureId: i, structure: n };
}
function Ab(e) {
  let t = fe(e, [{ [Rr]: !0 }, { [Gs]: { [xu]: !1, roundNumbers: !1 }, [ci]: J, [Or]: fr }]);
  if (t.error)
    return t;
  let { removeIncomplete: r = !1, removeUnAssigned: i = !0, removeCompleted: n = !1, tournamentRecord: a, drawDefinition: o, event: s } = e, c = Nb(e);
  if (c.error)
    return c;
  let { structure: u, structureId: d, existingMatchUps: p, matchUpIds: l } = c, m = [], f = (p == null ? void 0 : p.filter(({ matchUpId: I, score: y, winningSide: U }) => {
    if (U && !n)
      return !1;
    if (U || jt({ score: y })) {
      if (!U && !r)
        return !1;
      m.push(I);
    } else if (!i)
      return !1;
    return l == null ? void 0 : l.includes(I);
  })) ?? [], h = f.map(Ht), g = f.map(({ tieMatchUps: I }) => I == null ? void 0 : I.map(Ht)).filter(Boolean).flat();
  if (h.length) {
    u.matchUps = (u.matchUps ?? []).filter(({ matchUpId: U }) => !h.includes(U)), ta({ tournamentId: a == null ? void 0 : a.tournamentId, matchUpIds: [...g, ...h], action: "deleteAdHocMatchUps", eventId: s == null ? void 0 : s.eventId, drawDefinition: o });
    let I = Te(u.matchUps.map(ei("roundNumber"))), y = GE(I);
    if (y.length) {
      y.reverse();
      for (let U of y)
        u.matchUps.forEach((S) => {
          S.roundNumber && S.roundNumber > U && (S.roundNumber -= 1, xe({ tournamentId: a == null ? void 0 : a.tournamentId, context: ["adHoc round deletion"], eventId: s == null ? void 0 : s.eventId, drawDefinition: o, matchUp: S }));
        });
    }
    if (m.length) {
      u.positionAssignments = Te(u.matchUps.flatMap((v) => (v.sides ?? []).map((P) => P.participantId)).filter(Boolean)).map((v) => ({ participantId: v }));
      let U = (u == null ? void 0 : u.matchUpFormat) ?? (o == null ? void 0 : o.matchUpFormat) ?? (s == null ? void 0 : s.matchUpFormat), S = c.existingMatchUps.some((v) => v.matchUpType === ni) ? { matchUpTypes: [ni] } : void 0, { matchUps: D } = Ke({ afterRecoveryTimes: !1, inContext: !0, matchUpFilters: S, structure: u, event: s });
      Er({ structure: u }) && (u.positionAssignments = Te(D.flatMap((v) => (v.sides ?? []).map((P) => P.participantId)).filter(Boolean)).map((v) => ({ participantId: v })));
      let w = EI({ positionAssignments: u.positionAssignments, tournamentRecord: a, drawDefinition: o, matchUpFormat: U, matchUps: D, event: s });
      w.error && console.log(w);
    }
    ut({ structureIds: [d], eventId: s == null ? void 0 : s.eventId, drawDefinition: o });
  }
  return !h.length && l.length ? { error: tp } : { ...V, deletedMatchUpsCount: [...h, ...g].length };
}
function Eb({ removeCompletedMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: i, roundNumber: n, event: a }) {
  if (!t)
    return { error: ae };
  if (!r)
    return { error: le };
  if (!n)
    return j({ result: { error: Ie }, info: "roundNumber required" });
  let o = ve({ drawDefinition: r, structureId: i });
  if (o.error)
    return o;
  let s = o.structure;
  return s != null && s.structures ? { error: no } : Er({ structure: s }) ? mx({ tournamentId: t.tournamentId, removeCompletedMatchUps: e, eventId: a.eventId, drawDefinition: r, roundNumber: n, structure: s }) : (console.log("not implemented"), { ...V });
}
function mx({ removeCompletedMatchUps: e, drawDefinition: t, tournamentId: r, roundNumber: i, structure: n, eventId: a }) {
  let o = (n == null ? void 0 : n.matchUps) ?? [], s = [], c = [], u = !1;
  if (o.reduce((d, p) => {
    let l = p == null ? void 0 : p.roundNumber;
    return l ? d.includes(l) ? d : d.concat(l) : d;
  }, []).sort(Ft).includes(i)) {
    let d = o.filter((p) => {
      let l = p.roundNumber === i && (!Vt.includes(p.matchUpStatus) || e);
      return l && (c.push(p.matchUpId), p.tieMatchUps && s.push(...p.tieMatchUps.map(Ht))), !l;
    });
    c.length && (ta({ matchUpIds: [...s, ...c], drawDefinition: t, tournamentId: r, eventId: a }), d.some((p) => p.roundNumber === i) || (d.forEach((p) => {
      p.roundNumber > i && (p.roundNumber -= 1, xe({ drawDefinition: t, tournamentId: r, eventId: a, matchUp: p }));
    }), u = !0), n.matchUps = d);
  }
  return { deletedMatchUpsCount: c.length, roundRemoved: u, ...V };
}
function Kp(e) {
  var l, m, f, h, g, I;
  let { suppressNotifications: t, tournamentRecord: r, drawDefinition: i, matchUps: n, event: a } = e;
  if (typeof i != "object")
    return { error: le };
  let o = e == null ? void 0 : e.structureId;
  if (!o && ((l = i.structures) == null ? void 0 : l.length) === 1 && (o = (f = (m = i.structures) == null ? void 0 : m[0]) == null ? void 0 : f.structureId), typeof o != "string")
    return { error: ui };
  if (!Ti(n))
    return { error: J, info: Xa("matchUps") };
  let s = (h = i.structures) == null ? void 0 : h.find((y) => y.structureId === o);
  if (!s)
    return { error: It };
  let c = (s == null ? void 0 : s.matchUps).find((y) => !!y.roundPosition);
  if (s.structures || c || s.finishingPosition === Jo)
    return { error: no };
  let u = ((I = (g = tr({ tournamentRecord: r, inContext: !1 })) == null ? void 0 : g.matchUps) == null ? void 0 : I.map(Ht)) ?? [], d = n.map(Ht);
  if (wr(u, d))
    return { error: xw, info: "One or more matchUpIds already present in tournamentRecord" };
  s.matchUps.push(...n);
  let p = n.map(({ tieMatchUps: y }) => y).filter(Boolean).flat();
  return t || (ya({ tournamentId: r == null ? void 0 : r.tournamentId, matchUps: [...p, ...n], eventId: a == null ? void 0 : a.eventId, drawDefinition: i }), ut({ drawDefinition: i, structureIds: [o] })), { ...V };
}
function Cb({ tournamentRecord: e, drawDefinition: t, drawPosition: r, structureId: i, subOrder: n, event: a }) {
  var m;
  if (!t)
    return { error: le };
  if (!i)
    return { error: ui };
  if (!r)
    return { error: ic };
  let { structure: o } = ve({ drawDefinition: t, structureId: i });
  if (!o)
    return { error: It };
  let s = o;
  o.structures && o.structureType === br && (s = (m = o.structures) == null ? void 0 : m.find((f) => {
    var h;
    return (h = f.positionAssignments) == null ? void 0 : h.find((g) => g.drawPosition === r);
  }));
  let c = s == null ? void 0 : s.positionAssignments, u = c == null ? void 0 : c.find((f) => f.drawPosition === r);
  u && Ve({ element: u, extension: { name: Ws, value: n } });
  let d = ((a == null ? void 0 : a.eventType) === lt || t.matchUpType === lt || ((a == null ? void 0 : a.tieFormat) ?? (t == null ? void 0 : t.tieFormat) ?? (o == null ? void 0 : o.tieFormat))) && { matchUpTypes: [lt] }, { matchUps: p } = Ke({ structure: s, afterRecoveryTimes: !1, inContext: !0, matchUpFilters: d, event: a }), l = (o == null ? void 0 : o.matchUpFormat) ?? t.matchUpFormat;
  return EI({ positionAssignments: c, tournamentRecord: e, drawDefinition: t, matchUpFormat: l, matchUps: p, event: a }), ut({ drawDefinition: t, structureIds: [i] }), { ...V };
}
var Ob = {};
Ae(Ob, { addGoesTo: () => Ja, allPlayoffPositionsFilled: () => UI, checkValidEntries: () => Xp, findDrawDefinition: () => GI, getAssignedParticipantIds: () => ho, getAvailableMatchUpsCount: () => Qp, getAvailablePlayoffProfiles: () => pd, getDrawDefinitionTimeItem: () => Vg, getDrawParticipantRepresentativeIds: () => VI, getDrawStructures: () => Bi, getDrawTypeCoercion: () => Sd, getEligibleVoluntaryConsolationParticipants: () => BI, getMatchUpsMap: () => mr, getParticipantIdFinishingPositions: () => jI, getPositionAssignments: () => fu, getPositionsPlayedOff: () => Pc, getSeedingThresholds: () => pI, getSeedsCount: () => vd, getStructureSeedAssignments: () => Si, getTeamLineUp: () => Qa, getValidGroupSizes: () => cd, isAdHoc: () => Er, isCompletedStructure: () => wa, isValidForQualifying: () => WI, positionActions: () => qI });
function BI({ excludedMatchUpStatuses: e = [], includeEventParticipants: t, includeQualifyingStage: r, finishingRoundLimit: i, policyDefinitions: n, roundNumberLimit: a, tournamentRecord: o, drawDefinition: s, matchUpsLimit: c, requirePlay: u, requireLoss: d, allEntries: p, winsLimit: l, event: m }) {
  var O, k, F, x, _;
  if (!s)
    return { error: le };
  let f = [ue, vt];
  r && f.push(ge);
  let h = m != null && m.eventType ? { matchUpTypes: [m.eventType] } : void 0, g = s != null && s.matchUpType ? { matchUpTypes: [s.matchUpType] } : void 0, I = t && m ? ((O = Ln({ contextFilters: { stages: f }, matchUpFilters: h, tournamentRecord: o, inContext: !0, event: m })) == null ? void 0 : O.matchUps) ?? [] : ((k = vr({ contextFilters: { stages: f }, matchUpFilters: g, tournamentRecord: o, inContext: !0, drawDefinition: s })) == null ? void 0 : k.matchUps) ?? [], y = ts({ stage: Jt, drawDefinition: s }).map(({ participantId: B }) => B), U = {}, S = {}, D = {}, w = {};
  n || (n = ra({ policyTypes: [Af], tournamentRecord: o, drawDefinition: s, event: m }).policyDefinitions);
  let v = n == null ? void 0 : n[Af];
  e = e.length && e || (v == null ? void 0 : v.excludedMatchUpStatuses) || [], t = t ?? (v == null ? void 0 : v.includeEventParticipants), p = p ?? (v == null ? void 0 : v.allEntries), i = i ?? (v == null ? void 0 : v.finishingRoundLimit), a = a ?? (v == null ? void 0 : v.roundNumberLimit), c = c ?? (v == null ? void 0 : v.matchUpsLimit), u === void 0 && (u = (v == null ? void 0 : v.requirePlay) !== void 0 ? v.requirePlay : !0), d === void 0 && (d = (v == null ? void 0 : v.requireLoss) !== void 0 ? v.requireLoss : !0), l = l ?? (v == null ? void 0 : v.winsLimit);
  for (let B of I) {
    if (u && B.winningSide && ![1, 2].includes(B.winningSide) && B.matchUpStatus !== Et || B.finishingRound && i && B.finishingRound >= i || B.finishingRound && a && B.finishingRound <= a)
      continue;
    let L = (F = B.sides) == null ? void 0 : F.find(({ sideNumber: $ }) => B.winningSide && $ === 3 - B.winningSide), G = (x = B.sides) == null ? void 0 : x.find(({ sideNumber: $ }) => B.winningSide && $ === B.winningSide);
    if ((_ = B.sides) == null || _.forEach(($) => {
      var q;
      let W = (q = $ == null ? void 0 : $.participant) == null ? void 0 : q.participantId;
      W && (D[W] = $.participant, B.matchUpStatus === Et && !u && (S[W] = $.participant, U[W] || (U[W] = 0), (!B.matchUpStatus || !e.includes(B.matchUpStatus)) && (U[W] += 1)));
    }), L == null ? void 0 : L.participant) {
      let $ = L.participant.participantId;
      S[$] = L.participant, U[$] || (U[$] = 0), B.matchUpStatus && !e.includes(B.matchUpStatus) && (U[$] += 1);
    }
    if (G != null && G.participant) {
      let $ = G.participant.participantId;
      w[$] || (w[$] = 0), w[$] += 1, U[$] || (U[$] = 0), B.matchUpStatus && !e.includes(B.matchUpStatus) && (U[$] += 1);
    }
  }
  let P = (o == null ? void 0 : o.participants) && !u && !d && p, b = P ? ((t && m ? m.entries : s.entries) ?? []).filter((B) => ![On, Di].includes(B.entryStatus)).map(({ participantId: B }) => B) : [], T = Object.keys(S), R = P ? ((o == null ? void 0 : o.participants) ?? []).filter(({ participantId: B }) => b.includes(B)) : d && Object.values(S) || Object.values(D), M = (B) => !d || T.includes(B), E = (B) => !u || (U[B] || 0) >= 0, C = (B) => !l || (w[B] || 0) <= l, A = (B) => !c || U[B] <= c, N = (B) => !y.includes(B);
  return { eligibleParticipants: R.filter((B) => M(B.participantId) && E(B.participantId) && C(B.participantId) && A(B.participantId) && N(B.participantId)).map((B) => {
    var L;
    return { ...B, individualParticipants: (L = B.individualParticipantIds) == null ? void 0 : L.map((G) => {
      var $;
      return ($ = o == null ? void 0 : o.participants) == null ? void 0 : $.find((W) => W.participantId === G);
    }) };
  }), losingParticipantIds: T, ...V };
}
function Qp(e) {
  var f, h, g, I, y, U, S, D;
  let t = fe(e, [{ drawDefinition: !0 }]);
  if (t.error)
    return t;
  let { drawDefinition: r, roundNumber: i } = e, n = e.structureId ?? (((f = r.structures) == null ? void 0 : f.length) === 1 && ((g = (h = r.structures) == null ? void 0 : h[0]) == null ? void 0 : g.structureId));
  if (typeof n != "string")
    return { error: ui };
  let a = (I = r.structures) == null ? void 0 : I.find((w) => w.structureId === n);
  if (!a)
    return { error: It };
  let o, s = (y = a.matchUps ?? []) == null ? void 0 : y.reduce((w, v) => (v.roundPosition && (o = !0), ((v == null ? void 0 : v.roundNumber) || 0) > w ? v.roundNumber : w), 0);
  if (a.structures || o || a.finishingPosition === Jo)
    return { error: no };
  let c = ((U = r == null ? void 0 : r.entries) == null ? void 0 : U.filter((w) => {
    let v = w.entryStatus;
    return $i.includes(v);
  })) ?? [], u = Math.floor((c == null ? void 0 : c.length) / 2) || 1, d = i ?? s ?? 1, p = ((D = (S = a.matchUps) == null ? void 0 : S.filter((w) => w.roundNumber === d)) == null ? void 0 : D.length) ?? 0, l = u - p, m = l > 0 ? l : 0;
  return { ...V, availableMatchUpsCount: m, lastRoundNumber: s, roundMatchUpsCount: u };
}
function VI({ drawDefinition: e }) {
  var r;
  let t = Ne({ name: "participantRepresentatives", element: e });
  return t.error ? t : { representativeParticipantIds: ((r = t.extension) == null ? void 0 : r.value) || [] };
}
function fx({ tournamentParticipants: e, drawDefinition: t, event: r }) {
  if (!t)
    return { error: le };
  let i = Bt({ tournamentParticipants: e, inContext: !0, drawDefinition: t, event: r }), n = ce(i.matchUps, !1, !0), a = Te(n.reduce((s, c) => s.concat(...c.sides.map((u) => u.participantId).filter(Boolean)), [])), o = Object.assign({}, ...a.map((s) => {
    let c = n.filter((u) => u.sides.map((d) => d.participantId).filter(Boolean).includes(s));
    return { [s]: c };
  }));
  return { participantIds: a, participantIdMatchUps: o };
}
function jI({ byeAdvancements: e = !1, tournamentRecord: t, drawDefinition: r }) {
  if (!r)
    return { error: le };
  let { participantIds: i, participantIdMatchUps: n } = fx({ tournamentParticipants: t == null ? void 0 : t.participants, drawDefinition: r }), a = (i == null ? void 0 : i.map((o) => {
    let s = n[o].filter((p) => [Tt, $e].includes(p.matchUpStatus) || p.winningSide), c = s.map((p) => {
      let l = p.sides.find((f) => f.bye), m = p.sides.find((f) => f.participantId === o).sideNumber;
      return (p.winningSide || e && l && m) === m ? p.finishingPositionRange.winner : p.finishingPositionRange.loser;
    }), u = (p) => Math.abs(p[0] - p[1]), d = c.reduce((p, l) => p && u(p) < u(l) ? p : l, void 0);
    return { [o]: { relevantMatchUps: s, finishingPositionRanges: c, finishingPositionRange: d } };
  })) || [];
  return Object.assign({}, ...a);
}
function Oa({ tournamentRecords: e, tournamentRecord: t, tournamentId: r, drawId: i }) {
  if (!t && !e)
    return { error: ae };
  if (!i)
    return { error: tn };
  if (!t && e) {
    if (typeof r != "string" && (r = vb({ tournamentRecords: e, drawId: i }), !r))
      return { error: Cs };
    if (t = e[r], !t)
      return { error: ae };
  }
  let n = t && Cr({ tournamentRecord: t, drawId: i });
  return n != null && n.drawDefinition ? { drawDefinition: n.drawDefinition, event: n.event, tournamentRecord: t, ...V } : j({ result: { error: ai }, stack: "findDrawDefinition" });
}
function GI(e) {
  let { drawDefinition: t, error: r } = Oa(e);
  return r ? { error: r } : { drawDefinition: ce(t) };
}
function Hf({ targetRoundNumber: e, finishingPosition: t, drawDefinition: r, structureId: i, linkType: n }) {
  let { links: a } = Ic({ drawDefinition: r, structureId: i }) || {}, o = ((a == null ? void 0 : a.target) || []).filter(({ linkType: s }) => s === n).filter(({ target: s }) => !e || e === s.roundNumber).map((s) => {
    let c = s.source.structureId, { structure: u } = ve({ structureId: c, drawDefinition: r });
    if (!(t && (u == null ? void 0 : u.finishingPosition) !== t))
      return s;
  }).filter(Boolean);
  return { sourceStructureIds: o.map(({ source: s }) => s.structureId), relevantLinks: o };
}
function hx({ tournamentParticipants: e, returnParticipants: t, drawPosition: r, participant: i, drawId: n, event: a }) {
  var s;
  let o = ((s = a == null ? void 0 : a.entries) == null ? void 0 : s.filter(({ entryStatus: c }) => [Di, po].includes(c)).map(({ participantId: c }) => c)) || [];
  if (o.length) {
    let c = i.individualParticipantIds, u = t ? e.filter(({ participantId: p }) => o.includes(p)) : void 0, d = t ? e.filter(({ participantId: p }) => c.includes(p)) : void 0;
    return { validModifyAssignedPairAction: me({ payload: { participantId: i.participantId, replacementIndividualParticipantId: void 0, existingIndividualParticipantId: void 0, drawPosition: r, drawId: n }, method: TF, availableIndividualParticipantIds: o, availableIndividualParticipants: u, existingIndividualParticipantIds: c, existingIndividualParticipants: d, type: vI }, !1, !1, !0) };
  }
  return {};
}
function eo(e) {
  var g, I, y, U, S;
  let { inContextDrawMatchUps: t, targetData: r, drawDefinition: i, relevantLink: n } = e;
  if ((n == null ? void 0 : n.linkCondition) === ln && ((g = r == null ? void 0 : r.matchUp) == null ? void 0 : g.matchUpStatus) === $e)
    return !1;
  let { targetMatchUps: { loserMatchUp: a, winnerMatchUp: o }, targetLinks: s } = r, c = a && Dr({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), u = (I = c == null ? void 0 : c.targetMatchUps) == null ? void 0 : I.loserMatchUp, d = (y = c == null ? void 0 : c.targetMatchUps) == null ? void 0 : y.loserMatchUpDrawPositionIndex, p = (U = u == null ? void 0 : u.sides[d]) == null ? void 0 : U.participant, l = [ke, Be].includes(a == null ? void 0 : a.matchUpStatus) && !p, m = ((S = o == null ? void 0 : o.drawPositions) == null ? void 0 : S.filter(Boolean).length) || 0;
  if (a != null && a.winningSide && !l || o != null && o.winningSide && m === 2 && (!o.feedRound || ![Be, ke].includes(o == null ? void 0 : o.matchUpStatus)))
    return !0;
  let f = o && Dr({ matchUpId: o.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), h = c && eo({ relevantLink: s == null ? void 0 : s.loserTargetLink, targetData: c, inContextDrawMatchUps: t, drawDefinition: i });
  return !!(f && eo({ targetData: f, inContextDrawMatchUps: t, drawDefinition: i }) || h);
}
var kb = { [zn]: { policyName: "positionActionsDefault", enabledStructures: [{ stages: [ge, ue], stageSequences: [1], enabledActions: [], disabledActions: [] }, { stages: [], stageSequences: [], enabledActions: [mu, jo, $p, Ro], disabledActions: [] }], disbledStructures: [], otherFlightEntries: !1, activePositionOverrides: [] } }, el = "positionAction", zf = "matchUpAction";
function Fb({ actionType: e = el, appliedPolicies: t, drawDefinition: r, structure: i }) {
  var p, l;
  let n = e === el && zn || e === zf && Xt, a = e === el && kb || e === zf && mT, o = n && ((t == null ? void 0 : t[n]) || (a == null ? void 0 : a[n])), s = ((l = (p = r.links) == null ? void 0 : p.filter((m) => {
    var f;
    return ((f = m == null ? void 0 : m.target) == null ? void 0 : f.structureId) === (i == null ? void 0 : i.structureId);
  })) == null ? void 0 : l.map(({ target: m }) => m.feedProfile)) ?? [], { enabledStructures: c, disabledStructures: u } = o || {}, d = u == null ? void 0 : u.find((m) => {
    let { stages: f, stageSequences: h, structureTypes: g, feedProfiles: I } = m;
    return (!(I != null && I.length) || Array.isArray(I) && I.some((y) => s.includes(y))) && (!(f != null && f.length) || Array.isArray(f) && (f == null ? void 0 : f.includes(i == null ? void 0 : i.stage))) && (!(g != null && g.length) || Array.isArray(g) && (g == null ? void 0 : g.includes(i == null ? void 0 : i.structureType))) && (!(h != null && h.length) || Array.isArray(h) && h.includes(i == null ? void 0 : i.stageSequence));
  });
  return { enabledStructures: c, actionsDisabled: d, actionsPolicy: o };
}
function DS({ activePositionOverrides: e, activeDrawPositions: t, action: r }) {
  return r && e.includes(r) ? !0 : !t.length;
}
function xb({ enabledStructures: e, drawDefinition: t, structure: r }) {
  var s, c;
  if (e === !1)
    return {};
  if (!(e != null && e.length))
    return { policyActions: { enabledActions: [], disabledActions: [] } };
  let { stage: i, stageSequence: n, structureType: a } = r || {}, o = ((c = (s = t.links) == null ? void 0 : s.filter((u) => {
    var d;
    return ((d = u == null ? void 0 : u.target) == null ? void 0 : d.structureId) === (r == null ? void 0 : r.structureId);
  })) == null ? void 0 : c.map(({ target: u }) => u.feedProfile)) || [];
  return { policyActions: e.find((u) => {
    let { stages: d, stageSequences: p, structureTypes: l, feedProfiles: m } = u || {}, f = !(d != null && d.length) || Array.isArray(d) && d.includes(i), h = !(p != null && p.length) || Array.isArray(p) && p.includes(n), g = !(l != null && l.length) || Array.isArray(l) && l.includes(a), I = !(m != null && m.length) || Array.isArray(m) && m.some((y) => o.includes(y));
    return h && g && I && u && f;
  }) };
}
function Lr({ action: e, policyActions: t }) {
  var i;
  let r = !(t != null && t.enabledActions) || ((i = t == null ? void 0 : t.disabledActions) == null ? void 0 : i.length) && t.disabledActions.includes(e);
  return r ? !1 : ((t == null ? void 0 : t.enabledActions.length) === 0 || (t == null ? void 0 : t.enabledActions.includes(e))) && !r;
}
var Lb = "replaceTieMatchUpParticipantId", _b = "assignTieMatchUpParticipantId", Yf = "removeTieMatchUpParticipantId", TS = "assignMatchUpSideParticipant", gx = "removeMatchUpSideParticipant", Bb = "substituteParticipant", Kf = "REMOVE_SUBSTITUTION", Vb = "REPLACE_PARTICIPANT", $I = "REMOVE_PARTICIPANT", Qf = "setMatchUpStatus", Jf = "SUBSTITUTION", jb = "SCHEDULE", Ix = "PENALTY", Xf = "REFEREE", Gb = "STATUS", Zf = "START", $b = "SCORE", eh = "END", Ux = { REPLACE_TEAM_POSITION_METHOD: Lb, ASSIGN_TEAM_POSITION_METHOD: _b, REMOVE_TEAM_POSITION_METHOD: Yf, REPLACE_PARTICIPANT: Vb, SUBSTITUTION_METHOD: Bb, REMOVE_SUBSTITUTION: Kf, REMOVE_PARTICIPANT: $I, SCHEDULE_METHOD: Qf, SUBSTITUTION: Jf, SCHEDULE: jb, PENALTY: Ix, REFEREE: Xf, STATUS: Gb, SCORE: $b, START: Zf, END: eh };
function yx({ specifiedPolicyDefinitions: e, inContextDrawMatchUps: t, matchUpParticipantIds: r, matchUpActionsPolicy: i, inContextMatchUp: n, policyActions: a, enforceGender: o, participantId: s, sideNumber: c, matchUpId: u, matchUp: d, drawId: p, side: l }) {
  var C, A, N, O, k, F, x, _, B, L, G, $, W, q, K;
  let m = [], f = (C = n.sides) == null ? void 0 : C.find((z) => z.participant), h = n.gender === Mr && n.sideNumber && ((A = n.sides) == null ? void 0 : A.filter((z) => z.particiapntId).length) === 1 && ((O = (N = f == null ? void 0 : f.participant) == null ? void 0 : N.person) == null ? void 0 : O.sex), g = n.matchUpType, I = (o ?? ((k = i == null ? void 0 : i.participants) == null ? void 0 : k.enforceGender)) !== !1 ? n.gender : void 0, y = (x = (F = n.sides) == null ? void 0 : F.flatMap((z) => {
    var Y;
    return ((Y = z.participant) == null ? void 0 : Y.individualParticipants) || z.participant;
  }).filter(Boolean)) == null ? void 0 : x.map(Ce), U = (_ = n.sides) == null ? void 0 : _.filter((z) => !c || z.sideNumber === c).flatMap((z) => {
    var Y;
    return ((Y = z.participant) == null ? void 0 : Y.individualParticipants) || z.participant;
  }).filter(Boolean), S = U == null ? void 0 : U.map(Ce), D = (L = (B = t == null ? void 0 : t.find((z) => z.matchUpId === n.matchUpTieId)) == null ? void 0 : B.sides) == null ? void 0 : L.map((z) => {
    var Y, X;
    return (X = (Y = z == null ? void 0 : z.participant) == null ? void 0 : Y.individualParticipants) == null ? void 0 : X.filter(({ participantId: re, person: Q }) => !(S != null && S.includes(re)) && (!I || I === Zi || Q.sex === I || I === Mr && !h || h && Q.sex !== h));
  }), w = c ? D == null ? void 0 : D[c - 1] : D == null ? void 0 : D.map((z, Y) => ({ participants: z, sideNumber: Y + 1 })), v = c ? (G = D == null ? void 0 : D[c - 1]) == null ? void 0 : G.map(Ce) : D == null ? void 0 : D.map((z, Y) => ({ participants: z == null ? void 0 : z.map(Ce), sideNumber: Y + 1 })), P = c && (bt(wo)(g) && !(S != null && S.length) || bt(Ga)(g) && ((S == null ? void 0 : S.length) ?? 0) < 2) || !c && (bt(wo)(g) && ((S == null ? void 0 : S.length) ?? 0) < 2 || bt(Ga)(g) && ((S == null ? void 0 : S.length) ?? 0) < 4), b = v == null ? void 0 : v.filter((z) => !(y != null && y.includes(z))), T = w == null ? void 0 : w.filter(({ participantId: z }) => b.includes(z));
  if (P && (b != null && b.length) && m.push({ availableParticipantIds: b, method: _b, availableParticipants: T, type: Vo, payload: { participantId: void 0, tieMatchUpId: u, sideNumber: c, drawId: p } }), S != null && S.length && (!jt(d) || ($ = l == null ? void 0 : l.substitutions) != null && $.length) && m.push({ method: Yf, type: $I, existingParticipantIds: S, payload: { participantId: void 0, tieMatchUpId: u, drawId: p } }), T != null && T.length && (!c && (S != null && S.length) || c && (l != null && l.participant)) && m.push({ availableParticipantIds: b, method: Lb, availableParticipants: T, type: Vb, existingParticipantIds: S, payload: { existingParticipantId: void 0, participantId: void 0, tieMatchUpId: u, drawId: p } }), Lr({ policyActions: a, action: Kf }) && ((W = l == null ? void 0 : l.substitutions) == null ? void 0 : W.length)) {
    let z = ((q = l.participant) == null ? void 0 : q.participantType) === Oe && [l.participantId] || ((K = l.participant) == null ? void 0 : K.participantType) === Re && l.participant.individualParticipantIds || [], Y = l.substitutions.map((X) => X.participantId).filter((X) => z.includes(X));
    (!s || Y.includes(s)) && m.push({ method: Yf, type: Kf, substitutedParticipantIds: Y, payload: { participantId: void 0, tieMatchUpId: u, drawId: p } });
  }
  let R = e == null ? void 0 : e[Xt], M = R == null ? void 0 : R.substituteWithoutScore, E = R == null ? void 0 : R.substituteAfterCompleted;
  if (Lr({ policyActions: a, action: Jf }) && r.length === 2 && (!c && (S != null && S.length) || c && (l != null && l.participant)) && (M || jt(d)) && (E || d.matchUpStatus && !Vt.includes(d.matchUpStatus)) && (U != null && U.length) && w.length) {
    let z = U.map(Ce);
    m.push({ info: "list of team players available for substitution", method: Bb, availableParticipantIds: v, existingParticipantIds: z, availableParticipants: w, existingParticipants: U, type: Jf, payload: { substituteParticipantId: void 0, existingParticipantId: void 0, sideNumber: c, matchUpId: u, drawId: p } });
  }
  return m;
}
function Sx({ tournamentParticipants: e = [], possiblyDisablingAction: t, activeDrawPositions: r, positionAssignments: i, returnParticipants: n, appliedPolicies: a, drawDefinition: o, drawPosition: s, validActions: c, structureId: u, structure: d, drawId: p, event: l }) {
  var v, P, b, T, R;
  if (r.includes(s))
    return {};
  let m = (v = c.find((M) => M.type === Vo)) == null ? void 0 : v.availableParticipantIds, f = (P = a == null ? void 0 : a[zn]) == null ? void 0 : P.otherFlightEntries, h = (b = a == null ? void 0 : a[zn]) == null ? void 0 : b.restrictQualifyingAlternates, g = (o.entries ?? []).filter(({ entryStage: M }) => !h || (d.stage === ge ? M === ge : M !== ge)).sort((M, E) => (M.entryPosition ?? 1 / 0) - (E.entryPosition ?? 1 / 0)).map(({ participantId: M }) => M).filter(Boolean), { allPositionedParticipantIds: I } = vD({ drawDefinition: o }), y = i.map((M) => M.participantId).filter(Boolean), U = g.filter((M) => d.stage && [ge, ue, vt].includes(d.stage) ? !(I != null && I.includes(M)) : !y.includes(M)), S = ((l == null ? void 0 : l.entries) ?? []).filter((M) => M.entryStatus === Fi && qb({ restrictQualifyingAlternates: h, structure: d, entry: M }) && (d.stage && [ge, ue, vt].includes(d.stage) ? !(I != null && I.includes(M.participantId)) : !y.includes(M.participantId))).sort((M, E) => (M.entryPosition ?? 1 / 0) - (E.entryPosition ?? 1 / 0)).map((M) => M.participantId), D = Te(U.concat(S));
  if (f) {
    let M = (R = (T = l ? Pt({ event: l }).flightProfile : void 0) == null ? void 0 : T.flights) == null ? void 0 : R.filter((E) => E.drawId !== p).map((E) => E.drawEntries.filter((C) => C.participantId && ![On, Di, po].includes(C.entryStatus) && !g.includes(C.participantId)).map(({ participantId: C }) => C)).flat().filter(Boolean);
    M != null && M.length && D.push(...M);
  }
  m != null && m.length && (D = D.filter((M) => !m.includes(M)));
  let w = n ? e == null ? void 0 : e.filter((M) => D.includes(M.participantId)) : void 0;
  return w == null || w.forEach((M) => {
    let E = (o.entries ?? []).find((C) => C.participantId === M.participantId);
    M.entryPosition = E == null ? void 0 : E.entryPosition;
  }), w == null || w.sort((M, E) => (M.entryPosition || 1 / 0) - (E.entryPosition || 1 / 0)), D.length ? { validAlternatesAction: me({ payload: { drawId: p, structureId: u, drawPosition: s }, willDisableLinks: t, method: PF, availableAlternatesParticipantIds: D, type: wI, availableAlternates: w }) } : {};
}
function qb({ restrictQualifyingAlternates: e, structure: t, entry: r }) {
  let { stage: i } = t;
  if (!r.entryStage || r.entryStage === i || i === ge && !e || r.entryStage === ue && i === lr)
    return !0;
}
function vx({ eventEntries: e, structure: t }) {
  let r = (n) => n.entryStatus === Fi && qb({ structure: t, entry: n }), i = (n, a) => (n.entryPosition || 1 / 0) - (a.entryPosition || 1 / 0);
  return e.filter(r).sort(i).map(Ce);
}
function wx({ restrictAdHocRoundParticipants: e, tournamentParticipants: t, matchUpParticipantIds: r, otherFlightEntries: i, drawDefinition: n, structureId: a, sideNumber: o, matchUpId: s, structure: c, matchUp: u, drawId: d, event: p }) {
  var P, b, T, R, M, E, C;
  let l = [], m = (c == null ? void 0 : c.matchUps) ?? [], f = (b = (P = u.sides) == null ? void 0 : P.find((A) => A.sideNumber === o)) == null ? void 0 : b.participantId, h = m.filter(({ roundNumber: A }) => A === u.roundNumber), g = ((T = n == null ? void 0 : n.entries) == null ? void 0 : T.filter(({ entryStatus: A }) => A && mo.includes(A)).map(Ce)) ?? [], I = h.map((A) => (A.sides ?? []).flatMap(Ce)).flat().filter(Boolean), y = g.filter((A) => !r.includes(A) && (!e || !I.includes(A))), U = t == null ? void 0 : t.filter((A) => y == null ? void 0 : y.includes(A.participantId)).map((A) => ce(A, void 0, !0));
  U == null || U.forEach((A) => {
    let N = (n.entries ?? []).find((O) => O.participantId === A.participantId);
    A.entryPosition = N == null ? void 0 : N.entryPosition;
  }), y.length && l.push({ payload: { drawId: d, matchUpId: s, structureId: a, sideNumber: o }, method: TS, type: Vo, availableParticipantIds: y, participantsAvailable: U });
  let S = (p == null ? void 0 : p.entries) ?? [], D = vx({ eventEntries: S, structure: c }), w = Te(g.concat(D));
  if (i) {
    let A = (M = (R = p ? Pt({ event: p }) : void 0) == null ? void 0 : R.flights) == null ? void 0 : M.filter((N) => N.drawId !== d).flatMap((N) => N.drawEntries.filter((O) => O.participantId && ![On, Di, po].includes(O.entryStatus)).map(({ participantId: O }) => O)).filter(Boolean);
    A != null && A.length && w.push(...A);
  }
  w = w.filter((A) => !r.includes(A) && !y.includes(A) && (!e || !I.includes(A)));
  let v = t == null ? void 0 : t.filter((A) => w.includes(A.participantId)).map((A) => ce(A, void 0, !0));
  if (v == null || v.forEach((A) => {
    let N = (n.entries ?? []).find((O) => O.participantId === A.participantId);
    A.entryPosition = N == null ? void 0 : N.entryPosition;
  }), v == null || v.sort((A, N) => (A.entryPosition || 1 / 0) - (N.entryPosition || 1 / 0)), w.length && l.push({ payload: { drawId: d, matchUpId: s, structureId: a, sideNumber: o }, availableParticipantIds: w, participantsAvailable: v, method: TS, type: Fi }), !jt(u) && o && f) {
    l.push({ payload: { drawId: d, matchUpId: s, structureId: a, sideNumber: o }, method: gx, type: $I });
    let A = (L) => L.sides.map(Ce), N = ({ matchUpId: L }) => L !== u.matchUpId, O = (L) => !jt(L), k = (C = (E = u.sides) == null ? void 0 : E.find((L) => L.sideNumber !== o)) == null ? void 0 : C.participantId, F = m.filter(({ roundNumber: L }) => L !== u.roundNumber).filter(N).map(A), x = [k, ...F.filter((L) => L.includes(f)).flat()].filter(Boolean), _ = (L) => !x.flat().includes(L), B = h.filter(O).filter(N).map(A).flat().filter(_);
    if (B.length) {
      let L = t == null ? void 0 : t.filter((G) => B.includes(G.participantId)).map((G) => ce(G, void 0, !0));
      l.push({ payload: { participantIds: [f], roundNumber: u.roundNumber, structureId: a, sideNumber: o, matchUpId: s, drawId: d }, swappableParticipantIds: B, method: bF, type: qp, swappableParticipants: L });
    }
  }
  return l;
}
function Jp(e) {
  var z, Y, X, re, Q, H, Z, ee, te;
  if (!e)
    return { error: J };
  let { drawDefinition: t, event: r } = e, { restrictAdHocRoundParticipants: i = !0, policyDefinitions: n, enforceGender: a, participantId: o, sideNumber: s, matchUpId: c } = e, u = e.tournamentRecord ?? (e.tournamentId && ht(e.tournamentId) && ((z = e.tournamentRecords) == null ? void 0 : z[e.tournamentId]));
  if (!u)
    return { error: ae };
  if (!c || !ht(c))
    return { error: Ur };
  if (s && ![1, 2].includes(s))
    return j({ result: { error: J }, context: { sideNumber: s } });
  if (!t) {
    let ne = (tr({ tournamentRecord: u }).matchUps ?? []).find((ie) => ie.matchUpId === c);
    r = ((u == null ? void 0 : u.events) ?? []).find((ie) => ie.eventId === (ne == null ? void 0 : ne.eventId));
    let se = ((r == null ? void 0 : r.drawDefinitions) ?? []).find((ie) => ie.drawId === (ne == null ? void 0 : ne.drawId));
    se && (t = se);
  }
  if (!t)
    return { error: le };
  let d = Ut({ withIndividualParticipants: !0, tournamentRecord: u }).participants, { drawId: p } = t, { matchUp: l, structure: m } = ft({ drawDefinition: t, matchUpId: c, event: r });
  if (!l)
    return { error: hr };
  let f = je({ tournamentRecord: u, drawDefinition: t, structure: m, event: r }).appliedPolicies ?? {};
  Object.assign(f, n ?? {});
  let h = (Y = f == null ? void 0 : f[zn]) == null ? void 0 : Y.otherFlightEntries, g = (f == null ? void 0 : f[Xt]) ?? Sc[Xt], { enabledStructures: I } = Fb({ actionType: zf, appliedPolicies: f, drawDefinition: t, structure: m }), { policyActions: y } = xb({ enabledStructures: I, drawDefinition: t, structure: m }), U = e.matchUpsMap ?? mr({ drawDefinition: t }), S = e.inContextDrawMatchUps ?? Bt({ tournamentParticipants: d, inContext: !0, drawDefinition: t, matchUpsMap: U, event: r }).matchUps, D = S == null ? void 0 : S.find((ne) => ne.matchUpId === c), w = s && ((X = D == null ? void 0 : D.sides) == null ? void 0 : X.find((ne) => ne.sideNumber === s)), v = ((re = D == null ? void 0 : D.sides) == null ? void 0 : re.map((ne) => {
    var se;
    return ne.participantId || ((se = ne.participant) == null ? void 0 : se.participantid);
  }).filter(Boolean)) ?? [], { assignedPositions: P, allPositionsAssigned: b } = Yt({ structure: m }), { structureId: T } = m ?? {}, R = [];
  if (!T)
    return { validActions: R };
  let M = Er({ structure: m }), E = l.collectionId;
  if (M && !E) {
    let ne = wx({ restrictAdHocRoundParticipants: i, tournamentParticipants: d, matchUpParticipantIds: v, otherFlightEntries: h, drawDefinition: t, structureId: T, sideNumber: s, matchUpId: c, structure: m, matchUp: l, drawId: p, event: r });
    R.push(...ne);
  }
  let C = wa({ drawDefinition: t, structure: m }), A = P == null ? void 0 : P.filter((ne) => ne.participantId).map((ne) => ne.drawPosition), N = P == null ? void 0 : P.filter((ne) => ne.bye).map((ne) => ne.drawPosition), O = l.matchUpStatus === $e || !E && ((Q = l.drawPositions) == null ? void 0 : Q.reduce((ne, se) => (N == null ? void 0 : N.includes(se)) || ne, !1));
  if (O)
    return { validActions: R, isByeMatchUp: O };
  Lr({ policyActions: y, action: Xf }) && R.push({ type: Xf, payload: { matchUpId: c } });
  let k = !td({ matchUpStatus: l.matchUpStatus }), F = (H = f == null ? void 0 : f.scoring) == null ? void 0 : H.structures, x = (m == null ? void 0 : m.stage) && (F == null ? void 0 : F.stage) && (F == null ? void 0 : F.stage[m.stage]), _ = (m == null ? void 0 : m.stageSequence) && (x == null ? void 0 : x.stageSequence) && x.stageSequence[m.stageSequence], B = !((Z = f == null ? void 0 : f.scoring) != null && Z.requireAllPositionsAssigned || x != null && x.requireAllPositionsAssigned || _ != null && _.requireAllPositionsAssigned) || b, L = l.sides && l.sides.filter((ne) => ne == null ? void 0 : ne.participantId).length === 2, G = l.matchUpStatus && [Et, Lt].includes(l.matchUpStatus), $ = Dr({ inContextDrawMatchUps: S, drawDefinition: t, matchUpId: c }), W = eo({ inContextDrawMatchUps: S, drawDefinition: t, targetData: $ }), q = (((ee = D == null ? void 0 : D.drawPositions) == null ? void 0 : ee.length) === 2 && D.drawPositions.every((ne) => A == null ? void 0 : A.includes(ne)) && ((te = D == null ? void 0 : D.sides) == null ? void 0 : te.length) === 2 && D.sides.every(({ participantId: ne }) => ne) || L) && !(G && W), K = { method: JT, type: jo, payload: { drawId: p, matchUpId: c, penaltyCode: void 0, penaltyType: void 0, participantIds: [], notes: void 0 } };
  if (k && R.push({ payload: { drawId: p, matchUpId: c, schedule: {} }, method: Qf, type: jb }), Lr({ policyActions: y, action: jo }) && (w != null && w.participant || !s && (v != null && v.length)) && R.push(K), k && q && R.push({ type: Gb }), B && q) {
    let { matchUpId: ne, matchUpFormat: se } = l, ie = { drawId: p, matchUpId: ne, matchUpFormat: se, outcome: { scoreStringSide1: void 0, scoreStringSide2: void 0, sets: [] }, winningSide: void 0 };
    R.push({ info: "set outcome and winningSide", method: Qf, type: $b, payload: ie }), Lr({ policyActions: y, action: Zf }) && R.push({ type: Zf }), Lr({ policyActions: y, action: eh }) && R.push({ type: eh });
  }
  if (E && D) {
    let ne = yx({ specifiedPolicyDefinitions: n, inContextDrawMatchUps: S, matchUpParticipantIds: v, matchUpActionsPolicy: g, inContextMatchUp: D, policyActions: y, enforceGender: a, participantId: o, sideNumber: s, matchUpId: c, matchUp: l, drawId: p, side: w });
    R.push(...ne);
  }
  return { structureIsComplete: C, validActions: R, isDoubleExit: G, ...V };
}
function Px({ tournamentParticipants: e = [], sourceStructuresComplete: t, possiblyDisablingAction: r, isWinRatioFedStructure: i, activeDrawPositions: n, positionAssignments: a, drawDefinition: o, drawPosition: s, structureId: c, structure: u, drawId: d, event: p }) {
  var I, y, U, S, D, w, v;
  if (n.includes(s) || i && !t)
    return {};
  let { sourceStructureIds: l, targetStructureIds: m } = ((I = o.links) == null ? void 0 : I.reduce((P, b) => {
    var M, E;
    let T = (M = b.source) == null ? void 0 : M.structureId, R = (E = b.target) == null ? void 0 : E.structureId;
    return P.sourceStructureIds.includes(T) || P.sourceStructureIds.push(T), P.targetStructureIds.includes(R) || P.targetStructureIds.push(R), P;
  }, { sourceStructureIds: [], targetStructureIds: [] })) || {}, f = [], h = ((y = o.links) == null ? void 0 : y.filter((P) => {
    var b;
    return ((b = P.target) == null ? void 0 : b.structureId) === u.structureId;
  })) ?? [];
  for (let P of h) {
    let b = (U = P == null ? void 0 : P.source) == null ? void 0 : U.structureId, { structure: T } = ve({ structureId: b, drawDefinition: o }), R = (T == null ? void 0 : T.finishingPosition) === Jo && ((l == null ? void 0 : l.length) !== 1 || (m == null ? void 0 : m.length) !== 1), M = {};
    if (R) {
      let { matchUps: A } = Ke({ drawDefinition: o, structure: u, event: p }), { initialRoundNumber: N } = Bo({ drawPosition: s, matchUps: A }), O = (w = (D = (S = o.links) == null ? void 0 : S.find((k) => {
        var F;
        return ((F = k.target) == null ? void 0 : F.structureId) === (u == null ? void 0 : u.structureId) && k.target.roundNumber === N;
      })) == null ? void 0 : D.source) == null ? void 0 : w.roundNumber;
      M.roundNumbers = [O];
    }
    let { completedMatchUps: E } = xp({ structureId: b, inContext: !0, matchUpFilters: M, drawDefinition: o }), C = a.map((A) => A.participantId).filter(Boolean);
    (v = E == null ? void 0 : E.filter(({ matchUpType: A, winningSide: N }) => N && ((p == null ? void 0 : p.eventType) !== xt || A === xt)).map(({ winningSide: A, sides: N }) => A && (N == null ? void 0 : N[1 - (A - 1)])).map(Ce).filter((A) => A && !C.includes(A))) == null || v.forEach((A) => {
      f.includes(A) || f.push(A);
    });
  }
  let g = e == null ? void 0 : e.filter((P) => f == null ? void 0 : f.includes(P.participantId));
  return g == null || g.forEach((P) => {
    let b = (o.entries ?? []).find((T) => T.participantId === P.participantId);
    P.entryPosition = b == null ? void 0 : b.entryPosition;
  }), f != null && f.length ? { validLuckyLosersAction: { type: DI, method: DF, availableLuckyLosers: g, availableLuckyLoserParticipantIds: f, willDisableLinks: r, payload: { drawId: d, structureId: c, drawPosition: s } } } : {};
}
function Dx({ positionSourceStructureIds: e, unassignedParticipantIds: t, possiblyDisablingAction: r, provisionalPositioning: i, tournamentParticipants: n, isWinRatioFedStructure: a, positionAssignments: o, returnParticipants: s, appliedPolicies: c, drawDefinition: u, seedingProfile: d, isByePosition: p, drawPosition: l, structureId: m, event: f }) {
  var D, w, v;
  let { drawId: h } = u, g = [], I, y, U = [], S = (w = (D = c == null ? void 0 : c[Mi]) == null ? void 0 : D.validSeedPositions) == null ? void 0 : w.ignore;
  if (S || ({ unplacedSeedParticipantIds: I, unplacedSeedAssignments: y, unfilledPositions: U } = bT({ provisionalPositioning: i, returnAllProxies: !0, randomize: !0, drawDefinition: u, seedingProfile: d, structureId: m, event: f })), U != null && U.length || (U = o.filter((P) => !P.participantId && !P.bye && !P.qualifier).map((P) => P.drawPosition)), p || g.push({ payload: { drawId: h, structureId: m, drawPosition: l, isPositionAction: !0 }, willDisableLinks: r, method: NF, type: Tl }), a && S) {
    let P = o.map((E) => E.participantId).filter(Boolean), b = { structureIds: e }, { completedMatchUps: T } = Uc({ inContext: !0, matchUpFilters: b, drawDefinition: u }), R = Te((v = (T ?? []).filter(({ matchUpType: E }) => (f == null ? void 0 : f.eventType) !== xt || E === xt)) == null ? void 0 : v.map(({ sides: E }) => E == null ? void 0 : E.map(Ce)).flat().filter((E) => E && !P.includes(E))), M = s ? n == null ? void 0 : n.filter((E) => R == null ? void 0 : R.includes(E.participantId)).map((E) => ce(E, void 0, !0)) : void 0;
    return M == null || M.forEach((E) => {
      let C = (u.entries ?? []).find((A) => A.participantId === E.participantId);
      E.entryPosition = C == null ? void 0 : C.entryPosition;
    }), M != null && M.length && g.push(me({ payload: { drawId: h, structureId: m, drawPosition: l }, willDisableLinks: r, method: gS, type: Vo, availableParticipantIds: R, participantsAvailable: M })), { validAssignmentActions: g };
  }
  if (U.includes(l) || p) {
    let P;
    if (y != null && y.length) {
      let T = y.filter((R) => I == null ? void 0 : I.includes(R.participantId));
      T.sort(Tx), P = T.map((R) => R.participantId);
    } else
      P = t;
    let b = s ? n == null ? void 0 : n.filter((T) => P.includes(T.participantId)).map((T) => ce(T, void 0, !0)) : void 0;
    b != null && b.length && g.push(me({ payload: { drawId: h, structureId: m, drawPosition: l }, willDisableLinks: r, method: gS, type: Vo, availableParticipantIds: P, participantsAvailable: b }));
  }
  return { validAssignmentActions: g };
}
function Tx(e, t) {
  return e.bye || Ys(e.seedValue) < Ys(t.seedValue) || e.seedValue && !t.seedValue ? -1 : (e.seedNumber || 0) - (t.seedNumber || 0);
}
function bx({ drawPositionInitialRounds: e, tournamentParticipants: t, positionAssignments: r, returnParticipants: i, appliedPolicies: n, drawDefinition: a, drawPosition: o, structureId: s, drawId: c }) {
  var D, w, v;
  let u = [], d = [], p = [], l = [], m = r.map((P) => P.participantId).filter(Boolean), f = n == null ? void 0 : n[zn], h = !(f != null && f.disableRoundRestrictions) && e[o], g = f == null ? void 0 : f.requireCompletedStructures, { sourceStructureIds: I, relevantLinks: y } = Hf({ targetRoundNumber: h, linkType: Hn, drawDefinition: a, structureId: s }) || {};
  I != null && I.length && l.push(...I);
  let { sourceStructureIds: U, relevantLinks: S } = Hf({ targetRoundNumber: h, linkType: Wn, drawDefinition: a, structureId: s }) || {};
  U != null && U.length && l.push(...U);
  for (let P of y) {
    let b = (D = a.structures) == null ? void 0 : D.find((R) => R.structureId === P.source.structureId);
    if ((b == null ? void 0 : b.stage) !== ge)
      continue;
    let T = wa({ structureId: P.source.structureId, drawDefinition: a });
    if (!g || T) {
      let R = b.qualifyingRoundNumber, { matchUps: M } = Ke({ matchUpFilters: { roundNumbers: [R], hasWinningSide: !0 }, afterRecoveryTimes: !1, tournamentParticipants: t, inContext: !0, structure: b });
      for (let E of M) {
        let C = E.sides.find((N) => (N == null ? void 0 : N.sideNumber) === E.winningSide), A = E.matchUpStatus === $e && ((w = E.sides) == null ? void 0 : w.find(({ participantId: N }) => N));
        if (C || A) {
          let { participantId: N, participant: O } = C || A || {};
          N && !m.includes(N) && (O && i && u.push(O), d.push(N));
        }
      }
    }
  }
  for (let P of S) {
    let b = (v = a.structures) == null ? void 0 : v.find((R) => R.structureId === P.source.structureId);
    if ((b == null ? void 0 : b.stage) !== ge)
      continue;
    let T = wa({ structureId: P.source.structureId, drawDefinition: a });
    if (!g || T) {
      let { positionAssignments: R } = ot({ structure: b }), M = (R == null ? void 0 : R.map((E) => {
        var N;
        let C = E.participantId, A = (N = Ne({ element: E, name: Ia }).extension) == null ? void 0 : N.value;
        return A ? { participantId: C, groupOrder: A == null ? void 0 : A.groupOrder } : {};
      }).filter(({ groupOrder: E, participantId: C }) => E === 1 && !m.includes(C)).map(({ participantId: E }) => E)) ?? [];
      if (M && d.push(...M), i) {
        let E = t.filter(({ participantId: C }) => M.includes(C));
        u.push(...E);
      }
    }
  }
  return d.length && p.push(me({ qualifyingParticipants: i ? u : void 0, method: vF, type: $p, qualifyingParticipantIds: d, payload: { qualifyingParticipantId: void 0, drawPosition: o, structureId: s, drawId: c } })), { validAssignmentActions: p, sourceStructureIds: l };
}
function Rx({ onlyAssignedPositions: e = !0, possiblyDisablingAction: t, tournamentParticipants: r, inactiveDrawPositions: i, activeDrawPositions: n, positionAssignments: a, returnParticipants: o, byeDrawPositions: s, drawDefinition: c, isByePosition: u, drawPosition: d, structureId: p, structure: l, drawId: m, event: f }) {
  if (n.includes(d))
    return {};
  let h = (T) => !e || T.participantId || T.qualifier || T.bye, g = i == null ? void 0 : i.filter((T) => T !== d && !(u && s.includes(T))), I = (a == null ? void 0 : a.filter((T) => h(T) && (g == null ? void 0 : g.includes(T.drawPosition)))) ?? [], y = I.map(({ drawPosition: T }) => T), { matchUps: U } = Ke({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: c, structure: l, event: f }), S = U.filter(({ drawPositions: T }) => wr(T, y)), D = Object.assign({}, ...S.map((T) => {
    var R;
    return (R = T.sides) == null ? void 0 : R.filter(({ sourceDrawPositionRange: M }) => M).map(({ drawPosition: M, sourceDrawPositionRange: E }) => ({ [M]: E }));
  }).flat()), w = I.map((T) => T.participantId).filter(Boolean), v = (r ?? []).filter((T) => w.includes(T.participantId)), P = Object.assign({}, ...v.map((T) => ({ [T.participantId]: T }))), b = I.map((T) => {
    let R = P == null ? void 0 : P[T.participantId], M = D[T.drawPosition];
    return me({ ...T, participant: o ? ce(R, !1, !0) : void 0, sourceDrawPositionRange: M });
  });
  return b.length ? { validSwapAction: { payload: { drawId: m, structureId: p, drawPositions: [d] }, willDisableLinks: t, method: QT, type: qp, availableAssignments: b } } : {};
}
function qI(e) {
  var K;
  let t = fe(e, [{ event: !0, drawDefinition: !0, structureId: !0 }]);
  if (t.error)
    return t;
  let { policyDefinitions: r, returnParticipants: i = !0, provisionalPositioning: n, tournamentRecord: a, drawDefinition: o, drawPosition: s, event: c } = e, u = e.tournamentParticipants ?? (a && Ut({ withIndividualParticipants: !0, tournamentRecord: a }).participants) ?? [], d = ve({ structureId: e.structureId, drawDefinition: o });
  if (d.error)
    return d;
  let p = d.containingStructure || d.structure;
  if (!p)
    return { error: It };
  let l = p.structureId;
  if (d = rd({ drawDefinition: o, structureId: l }), s === void 0 && !d.isAdHoc)
    return { error: ic };
  if (d.isAdHoc)
    return Jp(e);
  if (d.error)
    return d;
  let { drawPositionInitialRounds: m, inactiveDrawPositions: f, activeDrawPositions: h, byeDrawPositions: g } = d, I = je({ tournamentRecord: a, drawDefinition: o, structure: p, event: c }).appliedPolicies ?? {};
  Object.assign(I, r ?? {});
  let { actionsPolicy: y, enabledStructures: U, actionsDisabled: S } = Fb({ actionType: el, appliedPolicies: I, drawDefinition: o, structure: p }), D = (y == null ? void 0 : y.activePositionOverrides) || [], { sourceStructureIds: w } = Hf({ finishingPosition: Ha, targetRoundNumber: 1, linkType: Wn, drawDefinition: o, structureId: l }) || {}, v;
  w != null && w.length && (v = w.every((z) => wa({ structureId: z, drawDefinition: o })));
  let P = w.length, b = w.length && !v, { policyActions: T } = xb({ enabledStructures: U, drawDefinition: o, structure: p }), R = ![ge, ue].includes(p.stage) || p.stageSequence !== 1, { drawId: M } = o, E = [], { assignedPositions: C, positionAssignments: A } = Yt({ structure: p }), N = C == null ? void 0 : C.find((z) => z.drawPosition === s), O = !!N;
  if (!((K = A == null ? void 0 : A.map((z) => z.drawPosition)) != null && K.includes(s)))
    return { error: rc };
  let { stage: k, stageSequence: F } = p, x = [k];
  k === lr && x.push(ue), k === ue && x.push(lr);
  let _ = ts({ entryStatuses: mo, provisionalPositioning: n, drawDefinition: o, stageSequence: F, structureId: l, stages: x }), B = ho({ drawDefinition: o, stages: x }).assignedParticipantIds ?? [], L = _.filter((z) => !B.includes(z.participantId)).map((z) => z.participantId), G = g.includes(s), $ = h.includes(s);
  if (S)
    return { info: "Actions Disabled for structure", isActiveDrawPosition: $, isDrawPosition: !0, hasPositionAssigned: O, validActions: [], isByePosition: G };
  if (Lr({ policyActions: T, action: Vo }) && !$ && A && !b && (!N || G)) {
    let { validAssignmentActions: z } = Dx({ positionSourceStructureIds: w, unassignedParticipantIds: L, possiblyDisablingAction: R, isWinRatioFedStructure: P, tournamentParticipants: u, positionAssignments: A, returnParticipants: i, appliedPolicies: I, drawDefinition: o, isByePosition: G, drawPosition: s, structureId: l, event: c });
    z == null || z.forEach((Y) => E.push(Y));
  }
  if (Lr({ policyActions: T, action: $p }) && !$) {
    let { validAssignmentActions: z } = bx({ drawPositionInitialRounds: m, tournamentParticipants: u, positionAssignments: A, returnParticipants: i, appliedPolicies: I, drawDefinition: o, drawPosition: s, structureId: l, drawId: M });
    z == null || z.forEach((Y) => E.push(Y));
  }
  let { participantId: W } = N || {}, q = W && u.find((z) => z.participantId === W);
  if (N) {
    Lr({ policyActions: T, action: Wf }) && !$ && (E.push({ type: Wf, method: hS, payload: { drawId: M, structureId: l, drawPosition: s }, willDisableLinks: R }), G || E.push({ type: PI, method: wF, payload: { drawId: M, structureId: l, drawPosition: s }, willDisableLinks: R }), Lr({ policyActions: T, action: Tl }) && !G && E.push({ type: Tl, method: hS, payload: { drawId: M, structureId: l, drawPosition: s, replaceWithBye: !0 }, willDisableLinks: R }));
    let z = p.stage === ge || p.stage === ue && p.stageSequence === 1;
    if (!G && DS({ activePositionOverrides: D, activeDrawPositions: h, action: Ro }) && Lr({ policyActions: T, action: Ro }) && wl({ drawDefinition: o, structureId: l, drawPosition: s }) && z) {
      let { seedAssignments: Y } = Si({ returnAllProxies: !0, drawDefinition: o, structure: p }), { seedNumber: X, seedValue: re } = (Y == null ? void 0 : Y.find((Q) => Q.participantId === W)) ?? {};
      E.push({ type: Ro, method: AF, participant: q, seedNumber: X, payload: { drawId: M, structureId: l, participantId: W, seedValue: re } });
    }
    if (!G && DS({ activePositionOverrides: D, activeDrawPositions: h, action: qc }) && Lr({ policyActions: T, action: qc }) && wl({ drawDefinition: o, structureId: l, drawPosition: s }) && z) {
      let { seedAssignments: Y } = Si({ returnAllProxies: !0, drawDefinition: o, structure: p }), { seedNumber: X } = (Y == null ? void 0 : Y.find((re) => re.participantId === W)) ?? {};
      E.push({ method: MF, type: qc, participant: q, seedNumber: X, payload: { participantId: W, structureId: l, drawId: M } });
    }
    if (!G && W) {
      if (Lr({ policyActions: T, action: jo })) {
        let Y = { type: jo, method: JT, participant: q, payload: { penaltyCode: void 0, penaltyType: void 0, participantIds: [], notes: void 0, drawId: M } };
        E.push(Y);
      }
      if (Lr({ policyActions: T, action: mu })) {
        let Y = { type: mu, method: RF, participant: q, payload: { participantId: W, otherName: void 0 } };
        E.push(Y);
      }
    }
    if (Lr({ policyActions: T, action: qp })) {
      let { validSwapAction: Y } = Rx({ possiblyDisablingAction: R, tournamentParticipants: u, inactiveDrawPositions: f, activeDrawPositions: h, positionAssignments: A, returnParticipants: i, byeDrawPositions: g, drawDefinition: o, isByePosition: G, drawPosition: s, structureId: l, structure: p, drawId: M });
      Y && E.push(Y);
    }
  }
  if (Lr({ policyActions: T, action: wI }) && !b) {
    let { validAlternatesAction: z } = Sx({ possiblyDisablingAction: R, tournamentParticipants: u, positionAssignments: A, activeDrawPositions: h, returnParticipants: i, appliedPolicies: I, drawDefinition: o, drawPosition: s, validActions: E, structureId: l, structure: p, drawId: M, event: c });
    z && E.push(z);
  }
  if (Lr({ policyActions: T, action: DI }) && !b && !$ && A) {
    let { validLuckyLosersAction: z } = Px({ sourceStructuresComplete: v, possiblyDisablingAction: R, isWinRatioFedStructure: P, tournamentParticipants: u, activeDrawPositions: h, positionAssignments: A, drawDefinition: o, drawPosition: s, structureId: l, structure: p, drawId: M });
    z && E.push(z);
  }
  if ((q == null ? void 0 : q.participantType) === Re && Lr({ policyActions: T, action: vI })) {
    let { validModifyAssignedPairAction: z } = hx({ tournamentParticipants: u, returnParticipants: i, drawPosition: s, participant: q, drawId: M, event: c });
    z && E.push(z);
  }
  return { isActiveDrawPosition: $, isDrawPosition: !0, hasPositionAssigned: O, isByePosition: G, validActions: E, ...V };
}
function Sd({ policyDefinitions: e, appliedPolicies: t, drawType: r }) {
  var a, o;
  let i = (a = e == null ? void 0 : e[pl]) == null ? void 0 : a.drawTypeCoercion, n = (o = t == null ? void 0 : t[pl]) == null ? void 0 : o.drawTypeCoercion;
  return (typeof i == "boolean" ? i : void 0) ?? (r && (i == null ? void 0 : i[r])) ?? (typeof n == "boolean" ? n : void 0) ?? (r && (n == null ? void 0 : n[r])) ?? !0;
}
function fu({ tournamentRecord: e, drawDefinition: t, stage: r = ue, structureId: i, structure: n }) {
  var s;
  if (!e)
    return { error: ae };
  if (!n && !t)
    return { error: le };
  if (!n && !i && ((s = t == null ? void 0 : t.structures) == null ? void 0 : s.filter((c) => c.stage === r).length) === 1 && (n = t.structures.find((c) => c.stage === r)), !n && !i)
    return { error: ui };
  let { error: a, positionAssignments: o } = ot({ drawDefinition: t, structureId: i, structure: n });
  return { positionAssignments: o ?? [], structureId: n == null ? void 0 : n.structureId, error: a };
}
function WI({ structureId: e, drawDefinition: t }) {
  if (!t)
    return { error: le };
  if (!ht(e))
    return { error: J };
  let r = Ic({ drawDefinition: t, structureId: e });
  if (r.error)
    return r;
  let i = r.links.target.flatMap((a) => a.target.feedProfile).filter(Boolean), n = !wt([Wa, Ei, dp, qa], i).length;
  return { ...V, valid: n };
}
function Wb({ participantsCount: e, participantCount: t }) {
  if (e = e ?? t, !e)
    return { error: J };
  let r = tc(e);
  return r ? { drawSize: r } : j({ result: { error: J }, stack: "getEliminationDrawSize", context: { participantsCount: e } });
}
function vd(e) {
  let { drawSizeProgression: t = !1, policyDefinitions: r, drawSize: i } = e || {}, { requireParticipantCount: n = !0, tournamentRecord: a, drawDefinition: o, event: s } = e || {}, c = "getSeedsCount", u = (e == null ? void 0 : e.participantsCount) ?? (e == null ? void 0 : e.participantCount);
  if (!r) {
    let f = ra({ tournamentRecord: a, drawDefinition: o, event: s });
    if (f.error)
      return j({ result: f, stack: c });
    r = f.policyDefinitions;
  }
  let d = Pe(u);
  if (u && !d)
    return j({ result: { error: J }, context: { participantsCount: u }, stack: c });
  if (n && !d)
    return j({ result: { error: pw }, stack: c });
  if (isNaN(i))
    if (u)
      ({ drawSize: i } = Wb({ participantsCount: u }));
    else
      return j({ result: { error: Tu }, stack: c });
  let p = n && u || i;
  if (p && p > i)
    return { error: Ch };
  let l = r == null ? void 0 : r[Mi];
  if (!l)
    return { error: ew };
  let m = l.seedsCountThresholds;
  return m ? (l.drawSizeProgression !== void 0 && (t = l.drawSizeProgression), { seedsCount: m.filter((f) => t ? f.drawSize <= i : i === f.drawSize).reduce((f, h) => u && u >= h.minimumParticipantCount ? h.seedsCount : f, 0) }) : { error: _v };
}
function Xp({ consideredEntries: e, policyDefinitions: t, tournamentRecord: r, appliedPolicies: i, participantMap: n, enforceGender: a, participants: o, event: s }) {
  var I;
  if ((!o || !n) && r && ({ participants: o, participantMap: n } = Ut({ tournamentRecord: r })), !o)
    return { error: Ru };
  if (!Array.isArray(o))
    return { error: J };
  if (!s)
    return { error: pt };
  let c = (t == null ? void 0 : t[Xt]) ?? (i == null ? void 0 : i[Xt]) ?? Sc[Xt], u = (a ?? ((I = c == null ? void 0 : c.participants) == null ? void 0 : I.enforceGender)) !== !1, { eventType: d, gender: p } = s, l = d === qn, m = d === Xr && Xe || l && Re || Oe, f = Object.assign({}, ...(e ?? s.entries ?? []).map((y) => ({ [y.participantId]: y.entryStatus }))), h = Object.keys(f), g = o.filter((y) => h.includes(y.participantId)).filter((y) => {
    let U = Mx({ participant: y, participantType: m, eventType: d, entryStatusMap: f }), S = Nx({ genderEnforced: u, participantMap: n, eventGender: p, participant: y, isDoubles: l, mismatch: U });
    return U || !S;
  });
  if (g.length) {
    let y = g.map((U) => U.participantId);
    return { error: zv, invalidParticipantIds: y };
  }
  return { ...V, valid: !0 };
}
function Mx({ participant: e, participantType: t, eventType: r, entryStatusMap: i }) {
  let n = i[e.participantId], a = r && [qn, Xr].includes(r) && e.participantType === Oe && (La(n) || n === On);
  return e.participantType !== t && !a;
}
function Nx(e) {
  var p, l, m;
  let { participant: t, participantMap: r, eventGender: i, mismatch: n, isDoubles: a, genderEnforced: o } = e, s = !n && a && Te(((p = t == null ? void 0 : t.individualParticipantIds) == null ? void 0 : p.map((f) => {
    var h, g, I;
    return (I = (g = (h = r == null ? void 0 : r[f]) == null ? void 0 : h.participant) == null ? void 0 : g.person) == null ? void 0 : I.sex;
  }).filter(Boolean)) ?? []) || [], c = !i || !(s != null && s.length) || Zi === i || [et, dt].includes(i) && s[0] === i || Mr === i && (s.length === 1 && ((l = t.individualParticipantIds) == null ? void 0 : l.length) === 1 || s.length === 2), u = (m = t == null ? void 0 : t.person) == null ? void 0 : m.sex, d = !(t != null && t.person) || !i || [Zi, Mr].includes(i) || [et, dt].includes(i) && u === i;
  return !o || c && d;
}
function Hb({ qualifyingProfiles: e, appliedPolicies: t, idPrefix: r, isMock: i, uuids: n }) {
  var h;
  let a = "generateQualifyingSTructures", o = [], s = [], c = [], u = (g, I) => g.stageSequence - I.stageSequence, d = (g, I) => g.roundTarget - I.roundTarget, p = 0, l = 0, m, f = 1;
  for (let g of e.sort(d)) {
    let I = g.structureProfiles || [];
    f = g.roundTarget || f;
    let y = 1, U = 0, S, D, w;
    for (let v of (I || []).sort(u)) {
      let P = hh(v.drawSize || v.participantsCount), { qualifyingRoundNumber: b, structureOptions: T, matchUpFormat: R, structureName: M, structureId: E, drawType: C } = v, A = v.matchUpType, N = v.qualifyingPositions || Ax({ drawSize: P, qualifyingRoundNumber: b }), O, k, F;
      if (!Pe(P))
        return j({ result: { error: Tu }, stack: a });
      let x = e.length > 1 ? `${f}-` : "", _ = I.length > 1 || x ? y : "", B = M || (x || _ ? `${dr(ge)} ${x}${_}` : dr(ge));
      if (C === Li) {
        let { structures: L, groupCount: G, maxRoundNumber: $ } = sd({ structureName: v.structureName || B, structureId: E || (n == null ? void 0 : n.pop()), stage: ge, structureOptions: T, appliedPolicies: t, stageSequence: y, matchUpType: A, roundTarget: f, drawSize: P, idPrefix: r, isMock: i, uuids: n });
        U = G, O = $, k = L[0], m = [1];
      } else
        ({ drawSize: P, matchUps: F, roundLimit: O } = fn({ qualifyingRoundNumber: b, qualifyingPositions: N, matchUpType: A, drawSize: P, idPrefix: r, isMock: i, uuids: n })), k = gi({ structureName: v.structureName || B, structureId: E || (n == null ? void 0 : n.pop()), qualifyingRoundNumber: O, stage: ge, matchUpFormat: R, stageSequence: y, matchUpType: A, roundLimit: O, matchUps: F }), f && Ve({ extension: { name: In, value: f }, element: k }), U = ((h = F == null ? void 0 : F.filter((L) => L.roundNumber === O)) == null ? void 0 : h.length) || 0;
      if (y > 1) {
        let { link: L } = ld({ sourceStructureId: D, sourceRoundNumber: S, targetStructureId: k.structureId, finishingPositions: w === Wn ? [1] : void 0, linkType: w });
        c.push(L), p += (P || 0) - U;
      } else
        p += P || 0;
      w = C === Li ? Wn : Hn, D = k.structureId, S = O, s.push(k), y += 1;
    }
    l += U, o.push({ qualifiersCount: U, finalQualifyingRoundNumber: S, finalQualifyingStructureId: D, finishingPositions: m, roundTarget: f, linkType: w }), f += 1;
  }
  return { qualifiersCount: l, qualifyingDrawPositionsCount: p, qualifyingDetails: o, structures: s, ...V, links: c };
}
function Ax({ drawSize: e, qualifyingRoundNumber: t }) {
  let r = e, i = 0;
  for (; i < t; )
    r = Math.floor(r / 2), i += 1;
  return r;
}
function zb(e) {
  let { drawTypeCoercion: t, enforceMinimumDrawSize: r } = e, i = ye(e.drawSize), n = t && e.drawType !== si && (typeof t == "boolean" || t <= 2) && i === 2 && on || e.drawType || on, a = HP.includes(n);
  if (i && a) {
    if (t && (typeof t == "boolean" && i < 4 || i <= t))
      n = on;
    else if (i < 4 && r)
      return { ...j({ context: { enforceMinimumDrawSize: r, drawSize: i, drawType: n }, result: { error: $l }, stack: "getCoercedDrawType" }), drawType: n };
  }
  return { drawType: n };
}
function Ex(e) {
  let { drawDefinition: t, structureOptions: r, requireSequential: i } = e, n = { structureName: dr(ue), ...e, stage: ue }, { structures: a, groupCount: o, groupSize: s } = sd(n);
  if (o < 1)
    return { error: Aw };
  let c = (r == null ? void 0 : r.playoffGroups) || [{ finishingPositions: [1], structureName: dr(vt) }], [u] = a, { structures: d, links: p } = cb({ sourceStructureId: u.structureId, requireSequential: i, drawDefinition: t, playoffGroups: c, groupCount: o, groupSize: s, ...e });
  return d && a.push(...d), { ...V, structures: a, links: p };
}
function Cx({ mainStructure: e, consolationStructure: t, deciderStructure: r }) {
  let i = t.matchUps.reduce((u, d) => (d.drawPositions || []).filter(Boolean).length && !u.includes(d.roundNumber) ? u.concat(d.roundNumber) : u, []), n = e.matchUps.reduce((u, d) => !u || d.roundNumber > u ? d.roundNumber : u, void 0), a = t.matchUps.reduce((u, d) => !u || d.roundNumber > u ? d.roundNumber : u, void 0), o = i.map((u, d) => {
    let p = i.indexOf(u) % 2 ? Ei : Wa, l = 1 + d;
    return { linkType: An, source: { roundNumber: l, structureId: e.structureId }, target: { feedProfile: p, roundNumber: u, structureId: t.structureId } };
  }), s = { linkType: Hn, source: { roundNumber: a, structureId: t.structureId }, target: { feedProfile: Ei, roundNumber: n, structureId: e.structureId } }, c = [{ linkType: Hn, source: { roundNumber: n, structureId: e.structureId }, target: { feedProfile: Ei, roundNumber: 1, structureId: r.structureId } }, { linkType: An, source: { roundNumber: n, structureId: e.structureId }, target: { feedProfile: Ei, roundNumber: 1, structureId: r.structureId } }];
  return [...o, s, ...c];
}
function Ox({ structureName: e, matchUpType: t, idPrefix: r, drawSize: i, isMock: n, uuids: a }) {
  let o = [], { matchUps: s } = Pa({ linkFedFinishingRoundNumbers: [1], drawSize: i + 1, matchUpType: t, idPrefix: r, isMock: n }), c = ma({ structureName: e || dr(ue), structureId: a == null ? void 0 : a.pop(), stageSequence: 1, stage: ue, matchUpType: t, matchUps: s });
  o.push(c);
  let u = i / 2, { matchUps: d } = Pa({ finishingPositionOffset: u, idPrefix: r && `${r}-c`, drawSize: i - 1, isConsolation: !0, matchUpType: t, isMock: n, uuids: a }), p = ma({ structureName: dr(WP), matchUps: d, structureId: a == null ? void 0 : a.pop(), stage: lr, stageSequence: 2, matchUpType: t });
  o.push(p);
  let { matchUps: l } = fn({ idPrefix: r && `${r}-p1t2`, drawSize: 2, matchUpType: t, isMock: n }), m = ma({ structureName: dr(qP), matchUps: l, structureId: a == null ? void 0 : a.pop(), stageSequence: 3, stage: vt, matchUpType: t });
  o.push(m);
  let f = Cx({ mainStructure: c, consolationStructure: p, deciderStructure: m });
  return { structures: o, links: f, ...V };
}
function kx(e) {
  let { qualifyingRoundNumber: t, finishingPositionOffset: r, qualifyingPositions: i, matchUpType: n, idPrefix: a, drawSize: o, isMock: s, uuids: c } = e;
  if (!Pe(o) || o < 2)
    return { matchUps: [], roundsCount: 0 };
  if (Qi(o))
    return fn(e);
  let u = Fx(o), d = u.shift(), p = oe(1, ((d == null ? void 0 : d.participantsCount) || 0) + 1).map((g) => ({ drawPosition: g })), l = [], m = 1;
  ({ matchUps: l } = bl({ roundNumber: m, matchUpType: n, idPrefix: a, matchUps: l, isMock: s, nodes: p, uuids: c })), m++;
  let f = e.roundLimit || t;
  for (let g of u) {
    let I = g.participantsCount / 2, y = oe(1, I + 1);
    i && I === i && (f = m - 1);
    let U = y.map((S) => {
      let D = TI({ roundPosition: S, roundNumber: m, idPrefix: a, uuids: c });
      return { roundPosition: S, roundNumber: m, matchUpId: D };
    });
    l.push(...U), m++;
  }
  let h = m - 1;
  return l = ed({ finishingPositionOffset: r, lucky: !0, roundsCount: h, roundLimit: f, matchUps: l }), f && (l = l.filter((g) => g.roundNumber <= f)), { matchUps: l, roundsCount: h, roundLimit: f };
}
function Fx(e) {
  let t = ye(e), r = t % 2 ? t + 1 : t, i = !!(Math.ceil(r / 2) % 2), n = [{ participantsCount: r, preFeedRound: i }];
  for (; r > 2; ) {
    let a = Math.ceil(r / 2), o = a === 1, s = !!(!o && a % 2);
    r = !o && s ? a + 1 : a;
    let c = !!(r !== 2 && Math.ceil(r / 2) % 2);
    n.push({ participantsCount: r, preFeedRound: c, feedRound: s });
  }
  return n;
}
function Yb(e) {
  var m, f;
  let { playoffAttributes: t, stageSequence: r = 1, stage: i = ue, matchUpType: n, drawSize: a, uuids: o } = e, s = () => !e.isMock && !e.idPrefix ? void 0 : `${e.drawDefinition.drawId}-s-0`, c = e.structureId || s() || (o == null ? void 0 : o.pop()), u = e.appliedPolicies ?? je(e), d = ((m = e.policyDefinitions) == null ? void 0 : m[qs]) || (u == null ? void 0 : u[qs]);
  e.skipRounds = e.skipRounds || a <= 4 && (d != null && d.feedFromMainFinal ? 0 : 1) || 0;
  let p = e.structureName ?? ((f = t == null ? void 0 : t["0"]) == null ? void 0 : f.name) ?? dr(ue), l = () => {
    let { matchUps: h } = fn(e);
    return { structures: [gi({ stageSequence: r, structureName: p, matchUpType: n, structureId: c, matchUps: h, stage: i })], links: [], ...V };
  };
  return { generators: { [si]: () => ({ structures: [gi({ finishingPosition: Ha, stageSequence: r, structureName: p, matchUps: [], matchUpType: n, structureId: c, stage: i })], links: [], ...V }), [so]: () => {
    let { matchUps: h } = kx(e);
    return { structures: [gi({ stageSequence: r, structureName: p, matchUpType: n, structureId: c, matchUps: h, stage: i })], links: [], ...V };
  }, [on]: () => l(), [Ou]: () => Ox(e), [Bs]: () => Ns({ ...e, roundOffsetLimit: 3, playoffAttributes: t ?? ng }), [Vs]: () => Ns({ ...e, roundOffsetLimit: 2, playoffAttributes: t ?? ag }), [vt]: () => Ns(e), [dc]: () => {
    let { matchUps: h } = Pa({ drawSize: a, uuids: o, matchUpType: n });
    return { structures: [gi({ stageSequence: r, structureName: p, matchUpType: n, structureId: c, stage: ue, matchUps: h })], links: [], ...V };
  }, [ku]: () => ab(e), [js]: () => So({ ...e, feedRounds: 1, fmlc: !0 }), [$P]: () => So({ ...e, feedRounds: 1 }), [tg]: () => So({ ...e, feedsFromFinal: 1 }), [rg]: () => So({ ...e, feedsFromFinal: 2 }), [ig]: () => So({ ...e, feedsFromFinal: 3 }), [Fu]: () => So(e), [lp]: () => sb(e), [Li]: () => sd(e), [En]: () => Ex(e) } };
}
function HI(e) {
  var B, L, G, $, W;
  let { enforceMinimumDrawSize: t = !0, overwriteExisting: r, appliedPolicies: i, staggeredEntry: n, drawDefinition: a, tieFormat: o, isMock: s, uuids: c } = e || {}, u = ye(e.drawSize), d = e.drawTypeCoercion ?? Sd({ appliedPolicies: i, drawType: e.drawType }), p = "generateDrawStructuresAndLinks", l = zb({ drawType: e.drawType, enforceMinimumDrawSize: t, drawTypeCoercion: d, drawSize: u });
  if (l.error)
    return l;
  let m = l.drawType, f = [], h = [], g = (e == null ? void 0 : e.matchUpType) ?? rt, I = (B = a == null ? void 0 : a.structures) == null ? void 0 : B.filter(({ stage: q }) => q === ge);
  I && f.push(...I);
  let y = I == null ? void 0 : I.map(({ structureId: q }) => q), U = (L = a == null ? void 0 : a.structures) == null ? void 0 : L.find(({ stage: q, stageSequence: K }) => q === ue && K === 1), S = (G = a == null ? void 0 : a.links) == null ? void 0 : G.filter((q) => q.target.structureId === (U == null ? void 0 : U.structureId) && (y == null ? void 0 : y.includes(q.source.structureId))), D = (q, K) => {
    var z;
    if (q.linkType === Wn && (K != null && K.structures)) {
      let Y = q.source.finishingPositions || [];
      return K.structures.length * Y.length;
    } else if (q.linkType === Hn && ((z = K == null ? void 0 : K.matchUps) != null && z.length)) {
      let Y = q.source.roundNumber;
      return K.matchUps.filter(({ roundNumber: X }) => X === Y).length;
    }
  }, w = I == null ? void 0 : I.map((q) => {
    var Q, H, Z;
    let K = S == null ? void 0 : S.find((ee) => ee.target.structureId === q.structureId), z = ((H = (Q = ot({ structure: q })) == null ? void 0 : Q.positionAssignments) == null ? void 0 : H.length) ?? 0;
    if (!K)
      return z;
    let Y = K == null ? void 0 : K.source.structureId, X = (Z = a.structures) == null ? void 0 : Z.find((ee) => ee.structureId === Y), re = D(K, X) || 0;
    return z - re;
  }).filter(Boolean).reduce((q, K) => q + K, 0), v = S == null ? void 0 : S.map((q) => {
    let K = q.source.structureId, z = I == null ? void 0 : I.find((Y) => Y.structureId === K);
    return D(q, z);
  }).filter(Boolean).reduce((q, K) => q + K, 0), P = !!(U && !(($ = U == null ? void 0 : U.matchUps) != null && $.length));
  if (I != null && I.length && !P)
    return { error: Tf };
  let b = !(I != null && I.length) && e.qualifyingProfiles, T = (b == null ? void 0 : b.length) && Hb({ idPrefix: e.idPrefix, qualifyingProfiles: b, appliedPolicies: i, isMock: s, uuids: c });
  if (T != null && T.error)
    return T;
  let { qualifyingDrawPositionsCount: R, qualifyingDetails: M, qualifiersCount: E } = T || { qualifyingDrawPositionsCount: w, qualifiersCount: v };
  R && (T != null && T.structures && f.push(...T.structures), T != null && T.links && h.push(...T.links)), Object.assign(e, me({ drawSize: u, matchUpType: g, tieFormat: o }));
  let C = m !== si && (!u || u < 2 || !n && ![dc, so].includes(m) && ([En, Li].includes(m) && u < 3 || ![Li, En].includes(m) && !Qi(u)));
  if (C && !R)
    return j({ context: { drawSize: u, invalidDrawSize: C }, result: { error: $l }, stack: p });
  let { generators: A, error: N } = Yb(e);
  if (N)
    return { error: N };
  let O = A[m];
  if (!O)
    return { error: yh };
  let k = O == null ? void 0 : O();
  if (k.error)
    return k;
  let { structures: F, links: x } = k;
  if (F != null && F.length) {
    let q = F.find(({ stage: K, stageSequence: z }) => K === ue && z === 1);
    if (U && q) {
      if (P) {
        let K = q.structureId;
        if (q.structureId = U.structureId, x == null ? void 0 : x.length)
          for (let z of x)
            z.source.structureId === K && (z.source.structureId = U.structureId), z.target.structureId === K && (z.target.structureId = U.structureId);
      } else if (!r)
        return { error: Tf };
    }
    f.push(...F);
  }
  f.sort(Zo), x != null && x.length && h.push(...x);
  let _ = k.structures.find(({ stage: q, stageSequence: K }) => q === ue && K === 1);
  for (let q of M || []) {
    let { finalQualifyingRoundNumber: K, finalQualifyingStructureId: z, roundTarget: Y, finishingPositions: X, linkType: re } = q, Q = _ && ((W = ld({ targetStructureId: _.structureId, sourceStructureId: z, sourceRoundNumber: K, finishingPositions: X, targetEntryRound: Y, linkType: re })) == null ? void 0 : W.link);
    if (Q != null && Q.error)
      return Q;
    Q && h.push(Q);
  }
  return S && h.push(...S), { ...V, qualifyingResult: { qualifyingDrawPositionsCount: R, qualifiersCount: E }, structures: f, links: h };
}
function zI(e) {
  var U, S;
  let { modifyOriginal: t = !0, stageSequence: r = 1, isMock: i } = e || {}, n = "generateDrawTypeAndModifyDrawDefinition";
  if (!e.drawDefinition)
    return j({ result: { error: le }, stack: n });
  let a = t ? e.drawDefinition : ce(e.drawDefinition, !1, !0), { tieFormat: o, matchUpType: s } = e;
  if (o) {
    let D = Ar({ tieFormat: o });
    if (D.error)
      return D;
  }
  o = sr(o ?? ((U = Ir({ drawDefinition: a })) == null ? void 0 : U.tieFormat)), s = s ?? (a.matchUpType || rt), e.tieFormat = o, e.matchUpType = s;
  let c = vl({ drawDefinition: a, stage: ue });
  e.drawSize = e.drawSize ?? c, !c && e.drawSize && Dl({ drawSize: e.drawSize, drawDefinition: a, stageSequence: r, stage: ue });
  let u = mr({ drawDefinition: a }).drawMatchUps.map(Ht), d = HI(e);
  if (d.error)
    return j({ result: d, stack: n });
  let { structures: p, links: l, qualifyingResult: m } = d;
  a.structures = p, a.links = l;
  let f = Math.max(e.qualifiersCount ?? 0, (m == null ? void 0 : m.qualifiersCount) || 0);
  if (m != null && m.qualifyingDrawPositionsCount && !vl({ stage: ge, drawDefinition: a })) {
    let D = Dl({ drawSize: m.qualifyingDrawPositionsCount, stage: ge, drawDefinition: a });
    if (D.error)
      return D;
  }
  if (f) {
    let D = YT({ qualifiersCount: f, drawDefinition: a, stage: ue });
    if (D.error)
      return D;
  }
  let h = e.drawSize ?? c;
  Object.assign(e, me({ drawSize: h, matchUpType: s, tieFormat: o }));
  let { matchUps: g, matchUpsMap: I } = Bt({ drawDefinition: a });
  o && (g == null || g.forEach((D) => {
    if (!u.includes(D.matchUpId)) {
      let { tieMatchUps: w } = md({ tieFormat: o, matchUp: D, isMock: i });
      Object.assign(D, { tieMatchUps: w, matchUpType: s });
    }
  }));
  let { inContextDrawMatchUps: y } = Ja({ drawDefinition: a, matchUpsMap: I });
  return ut({ tournamentId: (S = e.tournamentRecord) == null ? void 0 : S.tournamentId, drawDefinition: a }), { inContextDrawMatchUps: y, drawDefinition: a, matchUpsMap: I, ...V, structures: p, matchUps: g, links: l };
}
function wd(e) {
  let { removePriorValues: t, tournamentRecord: r, participantId: i, scaleItem: n } = e, a, o;
  if (!Qb({ scaleItem: n }))
    return { error: Co };
  if (i && Array.isArray(r.participants) && (o = r.participants.find((s) => s.participantId === i), o)) {
    if (o.participantType === Nr && (n == null ? void 0 : n.eventType) !== Xr)
      return { error: Co };
    let s = Jb({ removePriorValues: t, participant: o, scaleItem: n });
    if (s.error)
      return s;
    a = !s.valueChanged;
    let { topics: c } = vi();
    c.includes(pr) && De({ topic: pr, payload: { tournamentId: r.tournamentId, participants: [o] } });
  }
  return a && { ...V, info: Vh, existingValue: n == null ? void 0 : n.scaleValue } || o && { ...V, newValue: n == null ? void 0 : n.scaleValue } || { error: Dt };
}
function Kb(e) {
  var p;
  let { scaleItemsWithParticipantIds: t = [], removePriorValues: r, tournamentRecord: i, auditData: n, context: a } = e;
  if (!i)
    return { error: ae };
  if (!i.participants)
    return { error: Ru };
  let o = 0, s = {}, c = [];
  for (let l of t) {
    let m = l == null ? void 0 : l.participantId;
    if (Array.isArray(l == null ? void 0 : l.scaleItems))
      for (let f of l.scaleItems)
        if (Qb({ scaleItem: f }))
          Array.isArray(s[m]) || (s[m] = []), s[m].push(f);
        else
          return { error: Co };
  }
  for (let l of i.participants) {
    let { participantId: m } = l || {};
    if (Array.isArray(s[m]))
      for (let f of s[m]) {
        if (l.participantType === Nr && (f == null ? void 0 : f.eventType) !== Xr)
          return j({ context: { participantId: m, scaleItem: f, participantType: l.participantType }, info: "Invalid participantType for eventType", result: { error: Co } });
        Jb({ participant: l, scaleItem: f, removePriorValues: r }), c.push(l), o++;
      }
  }
  let u = o ? void 0 : cc, { topics: d } = vi();
  if (d.includes(pr) && o && De({ topic: pr, payload: { tournamentId: i.tournamentId, participants: c } }), a) {
    let { eventId: l, drawId: m, ...f } = a, h = ((p = f.scaleAttributes) == null ? void 0 : p.scaleType) && [f.scaleAttributes.scaleType];
    if (Object.keys(f).length) {
      let g = { itemType: Dg, itemValue: f };
      if (h && (g.itemSubTypes = h), m || l) {
        let { drawDefinition: I, event: y } = Cr({ tournamentRecord: i, eventId: l, drawId: m });
        m && SI({ drawDefinition: I, timeItem: g }), l && ms({ event: y, timeItem: g });
      } else
        Ud({ tournamentRecord: i, timeItem: g });
    }
  }
  return n && d.includes(jn) && De({ topic: jn, payload: n }), me({ ...V, modificationsApplied: o, info: u });
}
function Qb({ scaleItem: e }) {
  let t = e && Object.keys(e), r = ["scaleType", "eventType", "scaleName"];
  return r.filter((i) => t == null ? void 0 : t.includes(i)).length === r.length;
}
function Jb({ removePriorValues: e, participant: t, scaleItem: r }) {
  if (!t)
    return { error: Ho };
  let i = r && Object.keys(r), n = ["scaleType", "eventType", "scaleName"];
  if (n.filter((u) => i.includes(u) && r[u]).length !== n.length)
    return { error: Co };
  let a = (/* @__PURE__ */ new Date()).toISOString();
  t.timeItems || (t.timeItems = []);
  let { scaleItem: o } = Tn({ scaleAttributes: r, participant: t }), s = (u) => [void 0, null, ""].includes(u), c = !(s(o == null ? void 0 : o.scaleValue) && s(r.scaleValue)) && JSON.stringify(o == null ? void 0 : o.scaleValue) !== JSON.stringify(r.scaleValue);
  if (c) {
    let { scaleType: u, eventType: d, scaleName: p } = r, l = [za, u, d, p].join("."), m = me({ itemValue: r.scaleValue, itemDate: r.scaleDate, createdAt: a, itemType: l });
    r.scaleId && (m.itemSubTypes = [r.scaleId]), e && (t.timeItems = t.timeItems.filter((f) => f.itemType !== l)), t.timeItems.push(m);
  }
  return { ...V, valueChanged: c, newValue: r.scaleValue };
}
function YI(e) {
  let { tournamentRecord: t, modifiedScaleValues: r, removePriorValues: i } = e, n = fe(e, [{ [Gt]: !0 }, { modifiedScaleValues: !0, [Or]: _r }]);
  if (n.error)
    return n;
  for (let a in r) {
    let o = wd({ scaleItem: r[a], removePriorValues: i, tournamentRecord: t, participantId: a });
    if (o.error)
      return o;
  }
  return { ...V };
}
function Qs(e) {
  let { tournamentRecord: t, scaleAttributes: r, participantId: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!i)
    return { error: _t };
  let { participant: a, tournamentId: o } = Aa({ tournamentRecords: n, tournamentRecord: t, participantId: i });
  return a ? { ...Tn({ participant: a, scaleAttributes: r }), tournamentId: o } : { error: Dt };
}
var xx = (e = 0) => 250 / Math.pow(e + 5, 0.4), Lx = () => 1;
function _x(e = 3, t = 2) {
  let r = e / t;
  return isNaN(r) ? Ds.kDefault() : r;
}
var Ds = { nSpread: 400, diffThreshold: 0.125, kCalc: xx, kMultiplier: _x, kDefault: Lx };
function Xb(e) {
  let { winnerRating: t, loserRating: r } = e, { ratings: i = Wt, winnerCountables: n = 1, loserCountables: a = 0, ratingType: o = Ai, maxCountables: s, countables: c } = e || {}, u = i == null ? void 0 : i[o];
  if (!u)
    return { error: Ie };
  let d = u.range || e.ratingRange;
  t = t || u.defaultInitialization, r = r || u.defaultInitialization;
  let p = d[0] > d[1], l = u.decimalsCount || 0, m = p ? d.slice().reverse() : d, f = (N, O) => parseFloat(O) >= Math.min(...N) && parseFloat(O) <= Math.max(...N);
  (!f(d, t) || !f(d, r)) && (f(d, t) || (t = u.defaultInitialization), f(d, r) || (r = u.defaultInitialization));
  let h = bs({ targetRange: Wt[Ai].range, sourceRange: m, value: p ? d[0] - t : t }), g = bs({ targetRange: Wt[Ai].range, sourceRange: m, value: p ? d[0] - r : r }), I = (N, O) => 1 / (1 + Math.pow(10, (O - N) / Ds.nSpread)), y = I(h, g), U = I(g, h), S = Ds.kCalc(n), D = Ds.kCalc(a), w = Ds.kMultiplier(s, c), v = h + w * S * (1 - y), P = g + w * D * (0 - U), b = bs({ sourceRange: Wt[Ai].range, value: v, targetRange: m }), T = bs({ sourceRange: Wt[Ai].range, value: P, targetRange: m }), R = p ? d[0] - b : b, M = parseFloat(R.toFixed(l)), E = p ? d[0] - T : T, C = parseFloat(E.toFixed(l)), A = Math.max(...d) ? Math.abs(t - r) / Math.max(...d) : 0;
  return (b > T && A > Ds.diffThreshold || M < 0 || C < 0) && (M = t, C = r), { newWinnerRating: M, newLoserRating: C };
}
var Bx = (e) => (e == null ? void 0 : e.reduce((t, r) => (r.winningSide && (t[r.winningSide - 1] += 1), t), [0, 0])) || [0, 0];
function Zb(e) {
  var y, U;
  let t = fe(e, [{ [Gt]: !0 }, { matchUpIds: !0, [Or]: fr, [ki]: $o }, { ratingType: !1, [cr]: (S) => Wt[S] }]);
  if (t.error)
    return t;
  let { updateParticipantRatings: r, removePriorValues: i = !0, tournamentRecord: n, ratingType: a = Ai, refreshDynamic: o, considerGames: s, drawDefinition: c, matchUpIds: u, asDynamic: d } = e, p = Wt[a], { accessor: l } = p, m = {}, f = (e.matchUps || o && vr({ drawDefinition: c, tournamentRecord: n, inContext: !0, matchUpFilters: { matchUpStatuses: Vt } }).matchUps || tr({ matchUpFilters: { matchUpIds: u, matchUpStatuses: Vt }, tournamentRecord: n, inContext: !0 }).matchUps) ?? [], h = `${a}.${fg}`, g = d ? h : a;
  f.sort(cs);
  for (let S of f) {
    let { endDate: D, matchUpFormat: w, score: v, sides: P, winningSide: b } = S, T = S.matchUpType, R = { eventType: T, scaleName: a, scaleType: la }, M = { scaleName: h, eventType: T, scaleType: la }, E = Object.assign({}, ...(P ?? []).map((B) => {
      let { sideNumber: L, participant: G } = B;
      return L && { [L]: [G == null ? void 0 : G.participantId, ...(G == null ? void 0 : G.individualParticipantIds) ?? []].filter(Boolean).flat() };
    })), C = Object.assign({}, ...Object.values(E).flat().map((B) => {
      let L = m[B], G = !o || L ? Qs({ scaleAttributes: M, tournamentRecord: n, participantId: B }).scaleItem : void 0, $ = Qs({ tournamentRecord: n, scaleAttributes: R, participantId: B }).scaleItem, W = l ? { [l]: void 0 } : void 0;
      return B && { [B]: G ?? $ ?? { scaleName: g, eventType: T, scaleDate: D, scaleType: la, scaleValue: W } };
    })), A = w ? Tr(w) : {}, N = (A == null ? void 0 : A.bestOf) || 1, O = (A == null ? void 0 : A.setsTo) || 1, k = s ? N & O : N, F = (v == null ? void 0 : v.sets) && Bx(v.sets) || b === 1 && [1, 0] || [0, 1], x = b ? E[b] : [], _ = b ? E[3 - b] : [];
    for (let B of x) {
      let L = (y = C[B]) == null ? void 0 : y.scaleValue, G = typeof L == "object" ? L[l] : L;
      for (let $ of _) {
        let W = (U = C[$]) == null ? void 0 : U.scaleValue, q = typeof W == "object" ? W[l] : W, K = b ? F[b] : [0, 0], z = b ? F[3 - b] : [0, 0], { newWinnerRating: Y, newLoserRating: X } = Xb({ winnerCountables: K, loserCountables: z, maxCountables: k, winnerRating: G, loserRating: q, ratingType: a }), re = l ? { ...L, [l]: Y } : Y, Q = l ? { ...W, [l]: X } : X;
        C[B].scaleValue = re, C[$].scaleValue = Q, C[B].scaleName = g, C[$].scaleName = g;
      }
    }
    Object.assign(m, C), r && YI({ tournamentRecord: n, modifiedScaleValues: m, removePriorValues: i });
  }
  let I = f.map(({ matchUpId: S }) => S);
  return { ...V, modifiedScaleValues: m, outputScaleName: g, processedMatchUpIds: I };
}
function Zp(e) {
  var g;
  let { matchUpIds: t = [], drawDefinition: r, roundNumber: i, newRound: n, isMock: a, event: o } = e;
  if (typeof r != "object")
    return { error: le };
  let { participantIdPairings: s, matchUpsCount: c } = e, u = Qp(e);
  if (u.error)
    return j({ result: u });
  let { lastRoundNumber: d, availableMatchUpsCount: p = 0, roundMatchUpsCount: l = 0 } = u;
  if (!c)
    n ? c = l : p > 0 && (c = p);
  else if (c > l && e.restrictMatchUpsCount !== !1)
    return j({ result: { error: J, info: "matchUpsCount error", context: { roundMatchUpsCount: l } } });
  if (s && !Array.isArray(s) || c && !Pe(c) || t && !Array.isArray(t) || !s && !c)
    return { error: J, info: "matchUpsCount or pairings error" };
  if (c && e.restrictMatchUpsCount !== !1 && c > 32)
    return { error: J, info: "matchUpsCount must be less than 33" };
  if (i && !e.ignoreLastRoundNumber && i - 1 > (d || 0))
    return { error: J, info: "roundNumber error" };
  let m = i ?? (n && (d ?? 0) + 1 || d || 1);
  s = s ?? oe(0, c).map(() => ({ participantIds: [void 0, void 0] }));
  let f = (I) => {
    if (!e.idPrefix)
      return;
    let y = r.drawId, U = e.idPrefix ?? "ah";
    return `${y}-${U}-${m}-${I}`;
  }, h = s == null ? void 0 : s.map((I, y) => {
    let U = (I == null ? void 0 : I.participantIds) ?? [void 0, void 0];
    U.push(void 0, void 0);
    let S = U.slice(0, 2).map((w, v) => me({ sideNumber: v + 1, participantId: w })), D = t[y] ?? f(y) ?? ze();
    return { roundNumber: m, matchUpStatus: Rt, matchUpId: D, sides: S };
  });
  if (h != null && h.length) {
    let I = (g = Ir({ drawDefinition: r, event: o })) == null ? void 0 : g.tieFormat;
    I && h.forEach((y) => {
      let { tieMatchUps: U } = md({ tieFormat: I, matchUp: y, isMock: a });
      Object.assign(y, { tieMatchUps: U, matchUpType: lt });
    });
  }
  return { roundNumber: m, matchUpsCount: (h == null ? void 0 : h.length) ?? 0, matchUps: h, ...V };
}
function Vx({ maxIterations: e = 4e3, valueSortedPairings: t, pairingValues: r, valueObjects: i, deltaObjects: n }) {
  let a = Object.assign({}, ...t.map((y) => ({ [y.pairing]: y.value }))), o = Object.keys(r), s = [], c = bS({ actorsCount: o.length, valueSortedPairings: t, pairingValueMap: a, deltaObjects: n, valueObjects: i }), u = [Zm(c)];
  s.push(c);
  let d = c.value, p = c, l = 1, m = 0, f = o.length, h;
  do
    f -= 1, h = o.length * r[o[0]].length;
  while (h > e && f > 5);
  let g = [];
  o.forEach((y) => {
    r[y].slice(0, f).forEach((U) => {
      m += 1;
      let S = Mo(y, U.opponent);
      if (!g.includes(S)) {
        let D = bS({ stipulated: [[y, U.opponent]], actorsCount: o.length, valueSortedPairings: t, pairingValueMap: a, deltaObjects: n, valueObjects: i });
        if (!u.includes(Zm(D))) {
          u.push(Zm(D)), s.push(D);
          let { maxDelta: w, value: v } = D;
          w < p.maxDelta && (p = D), (v < d || v === d && Math.round(Math.random())) && (d = v), g.push(S), l += 1;
        }
      }
    }), s = s.filter((U) => Math.abs(U.value - d) < 5);
  }), s.sort((y, U) => y.maxDiff - U.maxDiff);
  let I = zr(s);
  return { candidatesCount: l, deltaCandidate: p, maxIterations: e, iterations: m, candidate: I };
}
function Zm(e) {
  return e.participantIdPairings.map(({ participantIds: t }) => t.sort().join("|")).sort().join("/");
}
function bS({ valueSortedPairings: e, stipulated: t = [], pairingValueMap: r, deltaObjects: i, valueObjects: n, actorsCount: a }) {
  let o = [].concat(...t), s = [], c = 0;
  t.filter(Boolean).forEach((p) => {
    let [l, m] = p, f = Mo(l, m), h = r[f];
    s.push({ participantIds: p, value: h }), c += r[f];
  }), zt(e, a).map((p) => yr(p).map((l) => ({ ...l, value: l.value + Math.random() * Math.round(Math.random()) }))).flat().forEach((p) => {
    let l = p.pairing.split("|");
    if (!l.reduce((m, f) => o.includes(f) || m, !1)) {
      o.push(...l);
      let m = p.value;
      c += m, s.push({ participantIds: l, value: m });
    }
  }), s.sort((p, l) => p.value - l.value);
  let u = s.reduce((p, l) => {
    let [m, f] = l.participantIds, h = Mo(m, f), g = i[h];
    return g > p ? g : p;
  }, 0), d = s.reduce((p, l) => {
    let [m, f] = l.participantIds, h = Mo(m, f), g = n[h];
    return g > p ? g : p;
  }, 0);
  return { value: c, participantIdPairings: s, maxDelta: u, maxDiff: d };
}
function Mo(e, t) {
  return [e, t].sort(Lp).join("|");
}
function eR({ participantIds: e }) {
  let t = {}, r = [];
  e.forEach((n) => {
    t[n] = e.filter((a) => a !== n), t[n].forEach((a) => {
      let o = Mo(a, n);
      r.includes(o) || r.push(o);
    });
  });
  let i = Object.assign({}, ...r.map((n) => ({ [n]: 0 })));
  return { uniquePairings: r, possiblePairings: t, deltaObjects: i };
}
function jx({ matchUps: e }) {
  let t = [];
  for (let r of e) {
    let i = r.sides.map(Ce);
    if (i.length === 2) {
      let [n, a] = i, o = Mo(n, a);
      t.includes(o) || t.push(o);
    }
  }
  return { encounters: t };
}
function Gx({ possiblePairings: e, valueObjects: t }) {
  let r = {};
  for (let n of Object.keys(e)) {
    let a = e[n].map((o) => i(n, o));
    r[n] = a.sort((o, s) => o.value - s.value);
  }
  function i(n, a) {
    let o = Mo(n, a);
    return { opponent: a, value: t[o] };
  }
  return { pairingValues: r };
}
var $x = 0;
function qx({ tournamentParticipants: e, adHocRatings: t, eventType: r, scaleName: i, pairing: n }) {
  var o;
  let a = ((o = Wt[i]) == null ? void 0 : o.defaultInitialization) ?? $x;
  return n.split("|").map((s) => {
    var c;
    if (r === Ui) {
      let u = (c = e == null ? void 0 : e.find((d) => d.participantId === s)) == null ? void 0 : c.individualParticipantIds;
      return u ? u == null ? void 0 : u.map((d) => t[d] || a) : a * 2;
    } else
      return t[s] || a;
  });
}
function Wx(e) {
  let { tournamentParticipants: t, adHocRatings: r = {}, possiblePairings: i, uniquePairings: n, maxIterations: a, minimizeDelta: o, deltaObjects: s, valueObjects: c, eventType: u, scaleName: d, salted: p } = e;
  n.forEach((U) => {
    let S = qx({ tournamentParticipants: t, adHocRatings: r, scaleName: d, eventType: u, pairing: U }), D = typeof p == "number" && p || 0.5, w = p && (Math.round(Math.random()) ? D : D * -1) || 0, v = Math.abs(S[0] - S[1]) + w, P = Math.abs(S[0] - S[1]);
    s[U] = P, c[U] || (c[U] = 0), c[U] += v ? Math.pow(v, 2) : 0;
  });
  let l = n.map((U) => ({ pairing: U, value: c[U] })).sort((U, S) => U.value - S.value), { pairingValues: m } = Gx({ possiblePairings: i, valueObjects: c }), { candidate: f, candidatesCount: h, deltaCandidate: g, iterations: I } = Vx({ valueSortedPairings: l, maxIterations: a, pairingValues: m, deltaObjects: s, valueObjects: c }), { participantIdPairings: y } = o ? g : f;
  return { participantIdPairings: y, candidatesCount: h, deltaCandidate: g, iterations: I, candidate: f };
}
var Hx = 100, zx = 100, Yx = 4e3;
function KI(e) {
  var W, q;
  let { encounterValue: t = Hx, sameTeamValue: r = zx, maxIterations: i = Yx, updateParticipantRatings: n, generateMatchUps: a = !0, ignoreLastRoundNumber: o, iterationMatchUps: s, tournamentRecord: c, dynamicRatings: u, refreshDynamic: d, participantIds: p, drawDefinition: l, roundNumber: m, structureId: f, matchUpIds: h, eventType: g, scaleName: I, idPrefix: y, isMock: U, salted: S, event: D } = e;
  if (!l)
    return { error: le };
  if (!e.structure && !f)
    return { error: It };
  let w = e.structure || ve({ drawDefinition: l, structureId: f }).structure;
  if (!Le(w))
    return { error: ao };
  if (!(p != null && p.length))
    return { error: Da };
  let v = [...s ?? [], ...(w == null ? void 0 : w.matchUps) ?? []], { encounters: P } = jx({ matchUps: v }), b = (c == null ? void 0 : c.participants) ?? [], T = {};
  if (u) {
    let K = Te(w != null && w.matchUps ? w.matchUps.map(({ roundNumber: Y }) => Y) : []), z = Math.max(...K, 0);
    if (z) {
      let Y = (W = w == null ? void 0 : w.matchUps) == null ? void 0 : W.filter(({ roundNumber: re }) => re === z).map(({ matchUpId: re }) => re), X = Zb({ ratingType: I ?? ((q = D == null ? void 0 : D.category) == null ? void 0 : q.ratingType), updateParticipantRatings: n, tournamentRecord: c, asDynamic: !0, refreshDynamic: d, drawDefinition: l, matchUpIds: Y });
      if (X.error)
        return X;
      X.modifiedScaleValues && (T = X.modifiedScaleValues);
    }
  }
  let { valueObjects: R } = Kx({ tournamentParticipants: b, encounterValue: t, sameTeamValue: r, encounters: P }), { uniquePairings: M, possiblePairings: E, deltaObjects: C } = eR({ participantIds: p }), A = Object.values(T).length ? T : e.adHocRatings, N = { tournamentParticipants: b, possiblePairings: E, participantIds: p, uniquePairings: M, drawDefinition: l, maxIterations: i, adHocRatings: A, deltaObjects: C, valueObjects: R, eventType: g, scaleName: I, structure: w, salted: S }, { candidatesCount: O, participantIdPairings: k, deltaCandidate: F, iterations: x, candidate: _ } = Wx(N);
  if (!O)
    return { error: Jl };
  let B, L;
  if (a) {
    let K = Zp({ structureId: w == null ? void 0 : w.structureId, ignoreLastRoundNumber: o, participantIdPairings: k, newRound: !0, drawDefinition: l, roundNumber: m, matchUpIds: h, idPrefix: y, isMock: U, event: D });
    if (K.error)
      return K;
    B = K.roundNumber, L = K.matchUps;
  }
  let { maxDelta: G, maxDiff: $ } = _;
  return { roundNumber: B, participantIdPairings: k, modifiedScaleValues: T, candidatesCount: O, deltaCandidate: F, ...V, iterations: x, matchUps: L, maxDelta: G, maxDiff: $ };
}
function Kx({ encounters: e, tournamentParticipants: t, encounterValue: r, sameTeamValue: i }) {
  let n = {};
  for (let o of e)
    n[o] || (n[o] = 0), n[o] += r;
  let a = t == null ? void 0 : t.filter(({ participantType: o }) => o === Xe);
  if (a)
    for (let o of a) {
      let s = o.individualParticipantIds ?? [], { uniquePairings: c } = eR({ participantIds: s });
      for (let u of c)
        n[u] || (n[u] = 0), n[u] += i;
    }
  return { valueObjects: n };
}
function tR(e) {
  var R, M, E, C;
  let { drawType: t = on, attachConsolation: r = !0, applyPositioning: i = !0, tournamentRecord: n, staggeredEntry: a, automated: o, placeByes: s, isMock: c, event: u } = e, d = e == null ? void 0 : e.drawDefinition;
  if (!d)
    return { error: le };
  let p = Jt, l = ts({ stageSequence: 1, drawDefinition: d, stage: p }), m = [Li, Ou, En].includes(t) ? l.length : tc(l.length);
  if (!a && t === dc && l.length < 2 || t === Li && l.length < 3)
    return { error: $l };
  let { tieFormat: f, matchUpType: h } = e;
  if (f) {
    let A = Ar({ tieFormat: f });
    if (A.error)
      return A;
  }
  f = sr(f ?? ((R = Ir({ drawDefinition: d })) == null ? void 0 : R.tieFormat)), h = h ?? d.matchUpType ?? rt;
  let { structures: g } = Bi({ stageSequence: 1, drawDefinition: d, stage: p });
  if (g.length > 1)
    return { error: Kv };
  if ((E = (M = g == null ? void 0 : g[0]) == null ? void 0 : M.matchUps) != null && E.length)
    return { error: Gh };
  let I = (C = g == null ? void 0 : g[0]) == null ? void 0 : C.structureId;
  Object.assign(e, me({ structureName: e.structureName ?? dr(Jt), structureId: I, matchUpType: h, tieFormat: f, drawSize: m, stage: p }));
  let y = Yb(e);
  if (y.error)
    return y;
  let U = y.generators[t];
  if (!U)
    return { error: yh };
  let S = U == null ? void 0 : U();
  if (S.error)
    return S;
  let { structures: D, links: w } = S, v = D.map((A) => Ke({ structure: A }).matchUps).flat();
  f && v.forEach((A) => {
    let { tieMatchUps: N } = md({ matchUp: A, tieFormat: f, isMock: c });
    Object.assign(A, { tieMatchUps: N, matchUpType: h });
  }), (!i || !r) && (d = ce(d, !1, !0)), d.links || (d.links = []), w.length && d.links.push(...w);
  let P = D.map(({ structureId: A }) => A);
  d.structures || (d.structures = []);
  let b = d.structures.map(({ structureId: A }) => A);
  d.structures = d.structures.map((A) => P.includes(A.structureId) ? D.find(({ structureId: N }) => N === A.structureId) : A);
  let T = D.filter(({ structureId: A }) => !b.includes(A));
  return T.length && d.structures.push(...T), o && dd({ seedingProfile: e.seedingProfile, applyPositioning: i, tournamentRecord: n, drawDefinition: d, structureId: I, placeByes: s, drawSize: m, event: u }), r && ut({ drawDefinition: d }), { links: w, structures: D, ...V };
}
var QI = {};
Ae(QI, { addGame: () => uR, addPoint: () => cR, addSet: () => lR, addShot: () => dR, analyzeScore: () => rU, analyzeSet: () => gu, calculateHistoryScore: () => aR, checkScoreHasValue: () => jt, checkSetIsComplete: () => rm, clearHistory: () => sR, generate: () => rR, generateScoreString: () => bn, generateTieMatchUpScore: () => gd, getSetComplement: () => nU, getTiebreakComplement: () => om, helpers: () => hR, isValidMatchUpFormat: () => Jr, keyValueScore: () => jR, mutate: () => nR, parseMatchUpFormat: () => Tr, parseScoreString: () => Al, query: () => HR, redo: () => pR, reverseScore: () => iR, setServingSide: () => oR, stringifyMatchUpFormat: () => op, tidyScore: () => WR, umo: () => fR, undo: () => mR, validateScore: () => iU, validateTieFormat: () => Ar });
var rR = {};
Ae(rR, { generateScoreString: () => bn, generateTieMatchUpScore: () => gd, reverseScore: () => iR });
function bn(e) {
  let { winnerFirst: t = !0, addOutcomeString: r, reversed: i = !1, matchUpStatus: n, matchUpFormat: a, autoComplete: o, winningSide: s, sets: c } = e;
  if (!c)
    return { error: Ie, info: "missing sets" };
  let u = a && Tr(a), { bestOf: d, finalSetFormat: p, setFormat: l } = u ?? {}, m = i || !(!t || !s || s === 1), f = r ? Qx({ matchUpStatus: n }) : "", h = (c == null ? void 0 : c.sort(Jx).map(g).filter(Boolean).join(" ")) || "";
  if (!f)
    return h;
  if (s === 2)
    return `${f} ${h}`;
  return `${h} ${f}`;
  function g(I) {
    let y = d && I.setNumber === d && p ? p : l, U = (_) => St(_ == null ? void 0 : _.side1Score) || St(_ == null ? void 0 : _.side2Score), S = (_) => St(_ == null ? void 0 : _.side1TiebreakScore) || St(_ == null ? void 0 : _.side2TiebreakScore), D = (y == null ? void 0 : y.tiebreakSet) || !U(I) && S(I), { side1Score: w, side2Score: v, side1TiebreakScore: P, side2TiebreakScore: b } = I, T = P || (St(P) || o ? 0 : ""), R = b || (St(b) || o ? 0 : "");
    if (D)
      return `[${(m ? [R, T] : [T, R]).join("-")}]`;
    let M = Math.min(T, R), E = M === T ? 1 : 2, C = M ? `(${M})` : "", A = w || (St(w) || o ? 0 : ""), N = v || (St(v) || o ? 0 : ""), O = (_) => E === _ ? C : "", k = `${A}${O(1)}`, F = `${N}${O(2)}`, x = m ? `${[F, k].join("-")}` : `${[k, F].join("-")}`;
    return ["-", " "].includes(x) && (x = ""), x;
  }
}
function Qx({ matchUpStatus: e }) {
  let t = { [nr]: "RET", [Be]: "WO", [Lt]: "DF/DF", [Et]: "WO/WO", [Na]: "SUS", [Gr]: "ABN", [ke]: "DEF", [hc]: "DR" };
  return e && t[e] || "";
}
function Jx(e, t) {
  return e.setNumber - t.setNumber;
}
function iR(e) {
  if (!(e != null && e.score))
    return { error: Ie };
  let { sets: t } = e.score, r = t.map((a) => {
    let { side1TiebreakScore: o, side2TiebreakScore: s, winningSide: c, side1Score: u, side2Score: d, setNumber: p } = a;
    return me({ winningSide: c ? 3 - c : void 0, side1TiebreakScore: s, side2TiebreakScore: o, side1Score: d, side2Score: u, setNumber: p });
  }), i = bn({ sets: r }), n = bn({ sets: r, reversed: !0 });
  return { reversedScore: { sets: r, scoreStringSide1: i, scoreStringSide2: n }, ...V };
}
var nR = {};
Ae(nR, { addGame: () => uR, addPoint: () => cR, addSet: () => lR, addShot: () => dR, calculateHistoryScore: () => aR, clearHistory: () => sR, redo: () => pR, setServingSide: () => oR, umo: () => fR, undo: () => mR });
function go({ matchUp: e }) {
  let { extension: t } = Ne({ name: wp, element: e });
  if (!t)
    return { error: Zt };
  let { history: r = [], undoHistory: i = [] } = t.value;
  return { history: r, undoHistory: i, ...V };
}
function aR(e) {
  var T, R;
  if (!e)
    return { error: Ie };
  let { matchUp: t, updateScore: r } = e;
  if (!t)
    return { error: Vr };
  let i = ((T = go({ matchUp: t })) == null ? void 0 : T.history) || [];
  if (!Array.isArray(i))
    return { error: J, info: "history is not an array" };
  let { matchUpFormat: n } = t;
  if (!n)
    return { error: bh };
  if (!Jr({ matchUpFormat: n }))
    return { error: Th };
  let a = Tr(n), { bestOf: o, finalSetFormat: s, setFormat: c } = a, u = ["0", "15", "30", "40", "A", "G"], d = { sets: [] }, p = [], l, m = [0, 0], f = 1, h = 0, g, I = 0, y = (M) => [1, 2].includes(M), U = () => (h += 1, { winningSide: void 0, side1Score: 0, side2Score: 0, setNumber: h, games: [] }), S = () => ({ winningSide: void 0, points: [] }), D = () => ({ winningSide: void 0, side1Score: "", side2Score: "", shots: [] }), w = D(), v = S(), P = U(), b = 0;
  for (let M of i) {
    b += 1, g = d.sets.length + 1 === o;
    let E = g && s ? s : c, { tiebreakAt: C, setTo: A, NoAD: N, tiebbreakFormat: O } = E, k = P.side1Score === C && P.side1Score === P.side2Score, F = !!E.tiebreakSet, x = F ? E.tiebreakSet : O, { tiebreakTo: _, NoAD: B } = x || {}, L = () => {
      l = void 0, m = [0, 0], f = 3 - f, P.side1TiebreakScore = 0, P.side2TiebreakScore = 0, P.side1PointScore = "", P.side2PointScore = "", I = 0;
    }, G = (q) => {
      P.winningSide = q;
      let { s: K, ...z } = P;
      d.sets.push(z), w = D(), v = S(), P = U(), L();
    }, $ = (q) => {
      v.winningSide = q;
      let { g: K, ...z } = v;
      P.games.push(z), w = D(), v = S(), L();
      let Y = `side${q}Score`;
      P[Y] += 1;
    }, W = (q) => {
      w.winningSide = q;
      let { p: K, ...z } = w;
      v.points.push(z), w = D(), I = 0;
      let Y = () => m.reduce((re, Q) => re + Q) % 4 / 4 > 0.5 ? f : 3 - f, X = q - 1;
      if (k || F) {
        m[X] += 1, l = Y(), P[`side${q}TiebreakScore`] = m[X], P[`side${3 - q}TiebreakScore`] = m[1 - X];
        let re = B ? 1 : 2;
        if (m[X] >= _ && m[X] >= m[1 - X] + re)
          return $(q), { gameCompleted: !0 };
      } else if (m[1 - X] === 4 && m[X] === 3 ? m[1 - X] -= 1 : m[X] += 1, P.side1PointScore = u[m[0]], P.side2PointScore = u[m[1]], m[X] === 5 || m[X] === 4 && m[1 - X] < 3 || N && m[X] === 4)
        return $(q), { gameCompleted: !0 };
    };
    if (y(M.srv) && (f = M.srv), ["p", "s", "g", "o"].includes(M.u) && p.push(M.u), M.shotOutcome && (w.shots.push(M), M.shotType === "SERVE" && ["OUT", "NET"].includes(M.shotOutcome) && (I += 1), I === 2)) {
      let q = 3 - f;
      W(q);
    }
    if (y(M.p) || Pe(M.pointNumber)) {
      let q = M.winningSide || M.p;
      if ((R = W(q)) != null && R.gameCompleted)
        continue;
    }
    if (y(M.g) || Pe(M.gameNumber)) {
      let q = M.winningSide || M.g;
      v.winningSide = q;
      let K = `side${q}Score`, z = `side${3 - q}Score`;
      if (p.length && (p.includes("p"), p = []), $(q), P[K] === A && P[K] - P[z] >= (N ? 1 : 2) && (G(q), g))
        break;
    }
    if (y(M.s) || Pe(M.setNumber)) {
      let q = M.winningSide || M.s;
      if (G(q), p.length && (p.includes("p"), p.includes("g"), p = []), g)
        break;
    }
  }
  return b !== i.length && console.log({ error: "Match completed with excess history" }), (P.side1Score || P.side2Score || P.games.length || P.side1TiebreakScore || P.side2TiebreakScore) && d.sets.push(P), d.scoreStringSide1 = bn({ ...d, matchUpFormat: n }), d.scoreStringSide2 = bn({ ...d, matchUpFormat: n, reversed: !0 }), f = l || f, r && (t.score = d), { ...V, servingSide: f, score: d };
}
function Io({ undoHistory: e, history: t, matchUp: r }) {
  return Ve({ element: r, extension: { value: { history: t, undoHistory: e }, name: wp } });
}
function oR({ matchUp: e, sideNumber: t }) {
  if (![1, 2].includes(t))
    return { error: Ah };
  let { history: r = [] } = go({ matchUp: e });
  return r.push({ srv: t }), Io({ matchUp: e, history: r });
}
function sR({ matchUp: e }) {
  return Io({ matchUp: e });
}
function cR({ matchUp: e, point: t }) {
  if (!t || !e)
    return { error: Ie };
  if (typeof t != "object")
    return { error: J, context: { point: t } };
  let { history: r = [] } = go({ matchUp: e });
  return r.push(t), Io({ matchUp: e, history: r });
}
function uR({ matchUp: e, game: t }) {
  if (typeof t != "object")
    return { error: J, context: { game: t } };
  let { history: r = [] } = go({ matchUp: e });
  return r.push(t), Io({ matchUp: e, history: r });
}
function dR({ matchUp: e, shot: t }) {
  if (typeof t != "object")
    return { error: Ie };
  let { history: r = [] } = go({ matchUp: e });
  return r.push(t), Io({ matchUp: e, history: r });
}
function lR({ matchUp: e, set: t }) {
  if (typeof t != "object")
    return { error: Ie };
  let { history: r = [] } = go({ matchUp: e });
  return r.push(t), Io({ matchUp: e, history: r });
}
function pR({ matchUp: e }) {
  let { history: t = [], undoHistory: r = [] } = go({ matchUp: e });
  return r.length && t.push(r.pop()), Io({ matchUp: e, history: t, undoHistory: r });
}
function mR({ matchUp: e }) {
  let { history: t = [], undoHistory: r = [] } = go({ matchUp: e });
  return r.push(t.pop()), Io({ matchUp: e, history: t, undoHistory: r });
}
var fR = {}, hR = {};
Ae(hR, { keyValueScore: () => jR, parseMatchUpFormat: () => Tr, stringifyMatchUpFormat: () => op, tidyScore: () => WR });
var No = " ", th = "DEF", Xx = "COMPLETED", gR = "WO", Zx = "WO/WO", IR = "ABN", UR = "SUS", yR = "RET", SR = "INT", vR = [yR, th, gR, Zx, IR, UR, SR], rh = "DEFAULTED", wR = "WALKOVER", PR = "ABANDONED", DR = "SUSPENDED", TR = "RETIRED", bR = "INTERRUPTED", eL = [TR, rh, wR], tL = "Enter Score", Go = "()", to = "[]", JI = ["up", "left", "shift+tab"], XI = ["enter", "down", "tab", "right"], Rl = "backspace", RR = "r", MR = "s", NR = "a", AR = "d", ER = "w", CR = "i", em = [RR, AR, ER, NR, MR, CR], tm = "space", ef = ["[", "("], Ml = [...JI, ...XI, tm, "]"], OR = "-", rL = "/", Ao = OR, Rn = OR, kR = [rL], iL = 0, nL = ["=", "+", "num_1", "num_2", "shift+=", "shift+-"], ZI = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].concat(em), FR = ZI.map((e) => `shift+${e}`), xR = [Ao, Rl].concat(Ml, kR), LR = [ZI, FR, xR].join(","), aL = [LR, JI, XI, nL].join(","), oL = { OUTCOMEKEYS: em, SIDE1KEYS: ZI, SIDE2KEYS: FR, MODIFIERS: xR, PROMPT: tL, MOVEUP: JI, MOVEDOWN: XI, HOTKEYS: aL };
function Ss({ scoreString: e, lowSide: t, outcome: r }) {
  if ({ scoreString: e } = _R({ scoreString: e }), t === 2) {
    let i = (e && e[e.length - 1]) !== No ? No : "";
    return e + i + r;
  } else
    return r + No + e;
}
function _R({ scoreString: e }) {
  if (!e)
    return { scoreString: "" };
  let t = !1;
  for (let r of vR) {
    let i = e == null ? void 0 : e.indexOf(r);
    i === 0 ? e = e.slice(r.length + 1).trim() + No : i > 0 && (e = e.slice(0, i)), i >= 0 && (t = !0);
  }
  return e != null && e.trim() || (e = ""), { scoreString: e, removed: t };
}
function ih({ analysis: e, scoreString: t, sets: r, lowSide: i }) {
  var h, g, I;
  let n, a;
  if (!t)
    return { scoreString: t, sets: r };
  let { scoreString: o, removed: s } = _R({ scoreString: t });
  if (t = o, s)
    return { scoreString: t, sets: r, outcomeRemoved: !0 };
  let c = r[r.length - 1] || {}, u = Object.values(c).filter((y) => y !== void 0).length;
  c.setNumber && u === 1 && (r = r.slice(0, r.length - 1), c = r[r.length - 1] || {});
  let { tiebreakSet: d } = e.setFormat, { tiebreakTo: p, NoAD: l } = d || {}, { isTiebreakEntry: m } = As({ brackets: to, scoreString: t }), f = cL(t);
  if (f >= 0) {
    n = t.slice(0, f);
    let { isTiebreakEntry: y } = As({ brackets: Go, scoreString: n }), { lastOpenBracketIndex: U, isTiebreakEntry: S } = As({ brackets: to, scoreString: n }), D = n && n[n.length - 1].trim(), w = n && !isNaN(D), v = e.isIncompleteSetScore;
    if (m && S) {
      let P = n.slice(U + 1).split(Rn), b = (P == null ? void 0 : P.length) > 0 && P[0] !== void 0 && !isNaN(parseInt(P[0])) && parseInt(P[0]) || void 0, T = (P == null ? void 0 : P.length) > 1 && P[1] !== void 0 && parseInt(P[1]) || void 0, R = [b, T];
      if (T) {
        let M = i === 1 ? 1 : 0;
        R[M] = ((R == null ? void 0 : R[1 - M]) || 0) + (l ? 1 : 2), (R[M] || 0) < p && (R[M] = p), n = t.slice(0, U + 1), n += R.join(Rn);
      } else
        b !== void 0 ? (n = t.slice(0, U + 1), n += b) : (n = t.slice(0, U), v = !0);
      c.side1TiebreakScore = R[0] || 0, c.side2TiebreakScore = R[1] || 0;
    }
    if (n.length || (n = void 0), v) {
      let P = (h = c.side1Score) == null ? void 0 : h.toString();
      if (P) {
        let b = P == null ? void 0 : P.slice(0, P.length - 1);
        c.side1Score = !isNaN(b) && parseInt(b) || void 0, c.side1Score === void 0 && (c.side2Score = void 0);
      }
      e.isTimedSet ? (a = c.side1Score ? r : (r == null ? void 0 : r.slice(0, r.length - 1)) || [], a[r.length - 1] = c) : a = (r == null ? void 0 : r.slice(0, r.length - 1)) || [];
    } else if (w) {
      let P = (g = c.side2Score) == null ? void 0 : g.toString(), b = (I = c.side1Score) == null ? void 0 : I.toString();
      if (!e.isTiebreakEntry && !e.isMatchTiebreak)
        if (c.side2Score) {
          let T = P == null ? void 0 : P.slice(0, P.length - 1);
          c.side2Score = !isNaN(T) && parseInt(T) || void 0;
        } else {
          let T = b == null ? void 0 : b.slice(0, b.length - 1);
          c.side1Score = !isNaN(T) && parseInt(T) || void 0;
        }
      e.isTimedSet ? c.side1Score ? (a = r || [], a[r.length - 1] = c) : a = (r == null ? void 0 : r.slice(0, r.length - 1)) || [] : (a = r || [], a[r.length - 1] = c), a[a.length - 1] && Object.assign(a[a.length - 1], { winningSide: void 0 });
    } else
      y ? (a = r || [], Object.assign(a[a.length - 1] || {}, { winningSide: void 0, side1TiebreakScore: void 0, side2TiebreakScore: void 0 })) : (m && !S ? a = (r == null ? void 0 : r.slice(0, r.length - 1)) || [] : (a = r, a[r.length - 1] = c), m || (a[a.length - 1].side2Score = 0, a[a.length - 1].winningSide = void 0));
    return { scoreString: n, sets: a };
  }
  return { scoreString: t, sets: r };
}
function As({ brackets: e = Go, scoreString: t }) {
  if (!t)
    return {};
  let [r, i] = e.split(""), n = t.split(""), a = Math.max(...an(r, n)), o = Math.max(...an(i, n));
  return { isTiebreakEntry: a > o, lastOpenBracketIndex: a };
}
function sL({ scoreString: e }) {
  if (!e)
    return !1;
  let t = e && e[e.length - 1].trim(), r = e && !isNaN(t), [i, n] = to.split(""), a = e.split(""), o = Math.max(...an(i, a)), s = Math.max(...an(n, a)), c = Math.max(...an(Rn, a));
  return r && o > s && c > o;
}
function cL(e) {
  return e.split("").reduce((t, r, i) => (r.match(/\d+/g) && t.push(i), t), []).pop();
}
function BR(e) {
  let { lowValue: t = 0, NoAD: r = !1, tiebreakTo: i } = e || {}, n = r ? 1 : 2;
  return t + 1 >= i ? t + n : parseInt(i);
}
function RS({ matchUpFormat: e, matchUpStatus: t, winningSide: r, sets: i }) {
  var c;
  let n = Tr(e), { bestOf: a } = n, o = Math.ceil(a / 2), s = ((c = i == null ? void 0 : i.reduce((u, d) => {
    let { winningSide: p } = d;
    return p && u[p - 1]++, u;
  }, [0, 0])) == null ? void 0 : c.indexOf(o)) + 1 || void 0;
  return eL.includes(t) && r && (s = r), { matchUpWinningSide: s };
}
function rm({ ignoreTiebreak: e = !1, matchUpScoringFormat: t, matchUpFormat: r, isTiebreakSet: i, isDecidingSet: n, isTimedSet: a, set: o }) {
  var S;
  if (!o)
    return { error: Ie, info: "missing set" };
  t = t || r && Tr(r);
  let s = n && t.finalSetFormat || (t == null ? void 0 : t.setFormat) || {}, { side1Score: c, side2Score: u } = o, { setTo: d, tiebreakAt: p } = s, l = c || u, m = im({ set: o }), f = Math.abs(c - u), h = c >= d || u >= d, g = i || c >= d && u >= d || p && p < d && (c === p || u === p), I = e || g && (m === 1 && o.side1TiebreakScore > o.side2TiebreakScore || m === 2 && o.side2TiebreakScore > o.side1TiebreakScore), y = !g && s.NoAD || g || i && ((S = s.tiebreakFormat) != null && S.NoAD) ? 1 : 2, U = f >= y;
  return !!((a && l || h && (U || g) || i) && (!g || I));
}
function im({ set: e }) {
  if (e.side1Score || e.side2Score) {
    if (e.side1Score > e.side2Score)
      return 1;
    if (e.side2Score > e.side1Score)
      return 2;
  } else if (e.side1TiebreakScore || e.side2TiebreakScore) {
    if (e.side1TiebreakScore > e.side2TiebreakScore)
      return 1;
    if (e.side2TiebreakScore > e.side1TiebreakScore)
      return 2;
  }
}
function eU({ analysis: e, set: t }) {
  let r = im({ set: t }), { isDecidingSet: i, isTiebreakSet: n, matchUpScoringFormat: a } = e;
  return rm({ matchUpScoringFormat: a, isDecidingSet: i, isTiebreakSet: n, set: t }) && r;
}
function uL({ analysis: e, scoreString: t, sets: r, value: i }) {
  let n;
  if (!(r != null && r.length))
    return { sets: [] };
  let a = r[r.length - 1];
  i = ye(i);
  let { validSide2Score: o, requiresTiebreak: s } = dL({ analysis: e, set: a, value: i });
  if (o) {
    n = !0, t = (t || "") + i, a.side2Score = i;
    let c = eU({ analysis: e, set: r[r.length - 1] });
    if (a.winningSide = c || void 0, s) {
      let u = Go.split("")[0];
      t += u;
    } else
      e.isDecidingSet || (t += No);
  }
  return { sets: r, scoreString: t, updated: n };
}
function dL({ analysis: e, set: t = {}, value: r }) {
  let i = e.isDecidingSet && e.matchUpScoringFormat.finalSetFormat || e.matchUpScoringFormat.setFormat, { tiebreakAt: n, setTo: a, NoAD: o } = i, { side1Score: s } = t, c, u;
  return n && n < a ? s === n ? c = r <= a : c = r <= n : s === a ? o ? c = r < a : c = r <= a + 1 : s === a - 1 ? o ? c = r <= a : c = r <= a + 1 : s === a + 1 ? c = r === a || r === a - 1 : c = r <= a, c && (n && n < a ? u = s === a && r === n || s === n && r === a : u = s >= a && r >= a && s !== r), { validSide2Score: c, requiresTiebreak: u };
}
function VR({ lowSide: e, value: t, sets: r, scoreString: i, winningSide: n, matchUpStatus: a }) {
  let o;
  return t === RR ? i ? (o = !0, i = Ss({ scoreString: i, lowSide: e, outcome: yR }), n = e === 2 ? 1 : 2, a = TR) : (o = !0, i = Ss({ scoreString: i, lowSide: e, outcome: th }), n = e === 2 ? 1 : 2, a = rh) : t === AR ? (o = !0, i = Ss({ scoreString: i, lowSide: e, outcome: th }), n = e === 2 ? 1 : 2, a = rh) : t === ER ? (o = !0, r = [], i = gR, n = e === 2 ? 1 : 2, a = wR) : t === MR && i ? (o = !0, i = Ss({ scoreString: i, lowSide: e, outcome: UR }), a = DR, n = void 0) : t === NR ? (o = !0, i = Ss({ scoreString: i, lowSide: e, outcome: IR }), a = PR, n = void 0) : t === CR && i && (o = !0, i = Ss({ scoreString: i, lowSide: e, outcome: SR }), a = bR, n = void 0), { updated: o, sets: r, scoreString: i, matchUpStatus: a, winningSide: n };
}
function lL(e) {
  let { sets: t, info: r, scoreString: i, winningSide: n, matchUpStatus: a } = e, { analysis: o, lowSide: s, value: c } = e, u, d;
  !(t != null && t.length) && c !== Rl && (t = [{ setNumber: 1 }]);
  let p = t.length - 1;
  if (em.includes(c)) {
    let l = t[t.length - 1] || {}, { side1Score: m, side2Score: f } = l;
    m && !f ? r = "missing side2Score" : o.finalSetIsComplete || n ? r = "final set is already complete" : o.isIncompleteSetScore ? r = "incomplete set scoreString" : o.isIncompleteSetScore || ({ sets: t, scoreString: i, winningSide: n, matchUpStatus: a, updated: u } = VR({ lowSide: s, value: c, sets: t, scoreString: i, matchUpStatus: a, winningSide: n }));
  } else if (c === Rl) {
    if ({ scoreString: i, sets: t, outcomeRemoved: d } = ih({ analysis: o, scoreString: i, sets: t }), (i == null ? void 0 : i.trim()) === "" && (i = i.trim()), i || (t = []), d) {
      let l = t[t.length - 1] || {}, { side1Score: m, side2Score: f } = l;
      if (m && f) {
        let h = m > f && 1 || f > m && 2 || void 0;
        h && (l.winningSide = h, t.push({ setNumber: t.length + 1 }));
      }
    }
    a = void 0, n = void 0, u = !0;
  } else if (o.hasOutcome)
    r = "has outcome";
  else {
    if (n)
      return { sets: t, scoreString: i, winningSide: n, matchUpStatus: a, updated: !1, info: "matchUp is complete" };
    if (c === tm) {
      let l = t[t.length - 1] || {}, { side1Score: m, side2Score: f } = l, h = m > f && 1 || f > m && 2 || void 0;
      h && !n && !o.isIncompleteSetScore && (t[t.length - 1].winningSide = h, t.push({ setNumber: t.length + 1 }), i += " ", u = !0);
    } else if (c === Ao && t[p].side1Score !== void 0 && t[p].side2Score === void 0 && i && o.isNumericEnding)
      i += "-", t[p].side2Score = 0, a = void 0, n = void 0, u = !0;
    else if (!isNaN(c)) {
      let l;
      if (t[p].side2Score === void 0) {
        let m = ye((t[p].side1Score || 0).toString() + c).toString().slice(0, 2);
        t[p].side1Score = ye(m), l = t[p].side1Score.toString(), u = !0;
      } else {
        let m = ye((t[p].side2Score || 0).toString() + c).toString().slice(0, 2);
        t[p].side2Score = ye(m), l = [t[p].side1Score, t[p].side2Score].join("-"), u = !0;
      }
      if (u) {
        let m = (t.slice(0, p) || []).filter((f) => f).map((f) => {
          let { side1Score: h, side2Score: g } = f;
          return [h, g].join("-");
        }).join(" ");
        m ? i = m + " " + l : i = l;
      }
    }
  }
  return { sets: t, scoreString: i, winningSide: n, matchUpStatus: a, info: r, updated: u };
}
function pL({ analysis: e, auto: t, lowSide: r, scoreString: i = "", sets: n, value: a }) {
  var p;
  let o, s, { tiebreakSet: { tiebreakTo: c, NoAD: u } } = e.setFormat, [d] = to.split("");
  if (e.isMatchTiebreakEntry || (i += d), n[e.setNumber - 1]) {
    let { lastOpenBracketIndex: l } = As({ brackets: to, scoreString: i }), m = (i.slice((l ?? 0) + 1) + (t ? "" : a)).split(Rn);
    if ((((p = m[r - 1]) == null ? void 0 : p.length) || 0) >= 2)
      s = "tiebreak digit limit";
    else if (t) {
      r === 1 && (m[0] = (m[0] || "") + a), r === 2 && (m[1] = (m[1] || "") + a);
      let f = [m[0] || 0, m[1] || 0].map((I) => ye(I)), h = r === 1 ? 1 : 0;
      f[h] = f[1 - h] + (u ? 1 : 2), f[h] < c && (f[h] = c);
      let g = n[n.length - 1];
      g.side1TiebreakScore = f[0], g.side2TiebreakScore = f[1], i = i.slice(0, (l ?? 0) + 1), i += f.join(Rn), o = !0;
    } else {
      let f = [m[0] || 0, m[1] || 0].map((g) => ye(g)), h = n[n.length - 1];
      h.side1TiebreakScore = f[0], h.side2TiebreakScore = f[1], i += a, o = !0;
    }
  } else {
    let l = BR({ lowValue: ye(a || 0), tiebreakTo: c, NoAD: u }), m = [ye(a), l];
    r === 2 && m.reverse();
    let f = { side1TiebreakScore: m[0], side2TiebreakScore: m[1], setNumber: (n == null ? void 0 : n.length) + 1 || 1 };
    n.push(f), i += m.join(Rn), o = !0;
  }
  return { info: s, scoreString: i, sets: n, updated: o };
}
function mL({ analysis: e, lowSide: t, scoreString: r, value: i }) {
  let { setTo: n, tiebreakAt: a, NoAD: o } = (e == null ? void 0 : e.setFormat) || {}, s = i === parseInt(a || n);
  if (a && a < n && i > a)
    return { scoreString: r };
  if (o && i === n || i > n)
    return { scoreString: r };
  let c = f(), u = [i, c];
  t === 2 && u.reverse();
  let d = Go.split("")[0], p = u.join(Ao) + (s ? d : No);
  r = (r || "") + p;
  let l = { side1Score: u[0], side2Score: u[1] }, m = eU({ analysis: e, set: l });
  return l.winningSide = m || void 0, { scoreString: r, set: l };
  function f() {
    return s ? i + 1 : i + 1 === n ? i + (o ? 1 : 2) : n;
  }
}
function fL({ matchUpFormat: e, scoreString: t, winningSide: r, value: i, sets: n }) {
  var F, x, _;
  let a = (((F = n == null ? void 0 : n.filter((B) => B == null ? void 0 : B.winningSide)) == null ? void 0 : F.length) || 0) + (r ? 0 : 1), o = Tr(e), s = a === (o == null ? void 0 : o.bestOf), c = s && (o == null ? void 0 : o.finalSetFormat) || (o == null ? void 0 : o.setFormat) || {}, u = c == null ? void 0 : c.timed, d = s && n[(o == null ? void 0 : o.bestOf) - 1], p = d == null ? void 0 : d.winningSide, { isTiebreakEntry: l } = As({ brackets: Go, scoreString: t }), { isTiebreakEntry: m } = As({ brackets: to, scoreString: t }), f = l || m, h = !!c.tiebreakSet, g = (x = t == null ? void 0 : t[t.length - 1]) == null ? void 0 : x.trim(), I = t && !isNaN(g), y = !f && g === Ao, U = l && ef.includes(g), S = m && ef.includes(g), D = m && g === Rn, w = t == null ? void 0 : t.split(""), [v] = to.split(""), P = w && Math.max(...an(v, w)), b = w && Math.max(...an(Rn, w)), T = w && b > P, R = (_ = n[n.length - 1]) == null ? void 0 : _.winningSide, M = (n == null ? void 0 : n.length) && !R, E = vR.find((B) => (t == null ? void 0 : t.indexOf(B)) >= 0), C = !isNaN(i), A = i === tm, N = Ml.includes(i), O = t == null ? void 0 : t.split("").find((B) => ef.includes(B)), k = N && m && !S && (D || !sL({ scoreString: t }));
  return { isTiebreakSetValue: h && C, matchUpScoringFormat: o, setNumber: a, setFormat: c, matchTiebreakHasJoiner: T, isGameScoreEntry: M, isSpace: A, isCloser: N, isTiebreakCloser: N && O && f && I, isDecidingSet: s, isTiebreakSet: h, isTimedSet: u, isNumericEnding: I, isNumericValue: C, hasOpener: O, hasOutcome: E, finalSet: d, finalSetIsComplete: p, lastSetIsComplete: R, isInvalidSetTiebreakValue: A && f && U, isInvalidMatchTiebreakValue: k, isTiebreakEntry: f, isSetTiebreakEntry: l, isMatchTiebreakEntry: m, isIncompleteSetScore: y, isIncompleteSetTiebreak: U, isIncompleteMatchTiebreak: S, isPartialMatchTiebreakValue: D };
}
function jR(e) {
  let { lowSide: t = 1, value: r } = e, { scoreString: i, sets: n, winningSide: a, matchUpStatus: o } = e, { matchUpFormat: s, shiftFirst: c, auto: u = !0 } = e, d, p, l = c && t === 2 || !c && t === 1;
  if (!LR.includes(r))
    return { updated: !1, info: "invalid key" };
  c && (t = 3 - t);
  let { matchUpWinningSide: m } = RS({ sets: n, winningSide: a, matchUpStatus: o, matchUpFormat: s });
  a = m;
  let f = fL({ value: r, winningSide: a, scoreString: i, sets: n, matchUpFormat: s });
  if (kR.includes(r) && (r = Ao), f.hasOpener && f.isTiebreakEntry && !f.isTiebreakSet && l && ye(r) === 0 && (f.isTiebreakCloser = !0), Ml.includes(r) && f.hasOpener && (r = ""), Ml.includes(r) && (r = tm), f.lastSetIsComplete) {
    let h = (i == null ? void 0 : i.length) && i[i.length - 1];
    i && h !== " " && (i += " ");
  }
  if (f.isTimedSet)
    ({ info: p, sets: n, scoreString: i, updated: d, matchUpStatus: o, winningSide: a } = lL({ analysis: f, lowSide: t, scoreString: i, sets: n, matchUpStatus: o, winningSide: a, value: r }));
  else if (em.includes(r))
    f.finalSetIsComplete || a ? p = "final set is already complete" : !f.isTiebreakEntry && !f.isIncompleteSetScore ? { sets: n, scoreString: i, matchUpStatus: o, winningSide: a, updated: d } = VR({ lowSide: t, sets: n, scoreString: i, matchUpStatus: o, winningSide: a, value: r }) : f.isTiebreakEntry || f.isIncompleteSetScore ? p = "incomplete set scoreString or tiebreak entry" : console.log("handle case", { value: r });
  else if (r === Rl)
    d = !0, { scoreString: i, sets: n } = ih({ analysis: f, scoreString: i, sets: n, lowSide: t }), i || (n = []), o = void 0, a = void 0;
  else if (f.hasOutcome)
    p = "has outcome";
  else if (r === Ao && !f.isMatchTiebreakEntry)
    (!f.isSetTiebreakEntry || f.isSetTiebreakEntry && !f.isNumericEnding) && (d = !0, { scoreString: i, sets: n } = ih({ analysis: f, scoreString: i, sets: n, lowSide: t }), o = void 0);
  else if (r === Rn && f.isMatchTiebreakEntry && !f.isSetTiebreakEntry)
    f.matchTiebreakHasJoiner ? p = "existing joiner" : f.isNumericEnding && (d = !0, i += Rn);
  else if ([Ao, Rn].includes(r))
    p = "invalid location for joiner";
  else {
    if (a)
      return { updated: !1, info: "matchUp is complete" };
    if (f.isIncompleteSetScore)
      f.isNumericValue && ({ sets: n, scoreString: i, updated: d } = uL({ analysis: f, scoreString: i, sets: n, value: r }));
    else if (f.isInvalidMatchTiebreakValue)
      p = "invalid matchUp tiebreak character";
    else if (f.isInvalidSetTiebreakValue)
      p = "invalid set tiebreak character";
    else if (f.isTiebreakCloser) {
      let h = f.isSetTiebreakEntry ? Go : to, g = h.split("").reverse()[0], I = h.split("")[0], y = n[n.length - 1], { tiebreakFormat: U } = f.setFormat, { tiebreakTo: S, NoAD: D } = U || {}, w = im({ set: y });
      if (!f.isTiebreakSet) {
        let P = parseInt(i.split(I).reverse()[0]), b = BR({ lowValue: P, tiebreakTo: S, NoAD: D });
        w === 1 ? (y.side1TiebreakScore = b, y.side2TiebreakScore = P) : (y.side1TiebreakScore = P, y.side2TiebreakScore = b);
      }
      i = (i || "") + g, f.isDecidingSet || (i += No);
      let v = eU({ analysis: f, set: y });
      y.winningSide = v || void 0, d = !0;
    } else if (f.isTiebreakSetValue)
      ({ info: p, scoreString: i, sets: n, updated: d } = pL({ analysis: f, auto: u, lowSide: t, scoreString: i, sets: n, value: r }));
    else if (f.isSetTiebreakEntry) {
      let [h] = Go.split(""), g = Math.max(...an(h, i.split(""))), I = i.slice(g + 1), y = I && ye(I) === iL, U = ye(I ? I + r : r), { tiebreakFormat: S } = f.setFormat, { tiebreakTo: D, NoAD: w } = S || {};
      !y && I.length < 2 ? w && U > D - 1 ? p = "invalid low value for NoAD tiebreak" : (d = !0, i = (i || "") + r) : p = y ? "tiebreak begins with zero" : "tiebreak digit limit";
    } else if (f.isCloser)
      p = `invalid key: ${r}`;
    else if (f.isGameScoreEntry)
      p = "game scoreString entry";
    else if (f.lastSetIsComplete || !n.length) {
      d = !0;
      let { scoreString: h, set: g } = mL({ analysis: f, lowSide: t, scoreString: i, value: ye(r) });
      g && (g.setNumber = (n == null ? void 0 : n.length) + 1 || 1), n = (n == null ? void 0 : n.concat(g).filter(Boolean)) || [g], i = h || void 0;
    } else
      console.log("error: unknown outcome");
  }
  if (d) {
    n = n == null ? void 0 : n.filter(Boolean);
    let { matchUpWinningSide: h } = RS({ sets: n, winningSide: a, matchUpStatus: o, matchUpFormat: s });
    return a = h, h && (!o || [Rt, Zr].includes(o)) ? (o = Xx, n = n.filter((g) => {
      let { side1Score: I, side2Score: y, side1TiebreakScore: U, side2TiebreakScore: S } = g;
      return I || y || U || S;
    })) : i && !a && ![DR, PR, bR].includes(o) && (o = void 0), { updated: d, scoreString: i, sets: n, winningSide: a, matchUpStatus: o, info: p };
  }
  return { updated: d, scoreString: i, sets: n, winningSide: a, matchUpStatus: o, info: p };
}
var nm = "\\d+-\\d+", hu = "\\d+-\\d+\\(\\d+\\)", tU = "\\[\\d+-\\d+\\]", hL = "\\d+-\\d+\\(\\d+-\\d+\\)", gL = new RegExp(`(${nm}),`, "g"), IL = new RegExp(`(${hu}),`, "g"), UL = [nm, hu, tU, hL], yL = ["0", "1", "2", "00", "01", "10", "11", "002", "012", "102", "112", "000", "001", "010", "100", "011", "101", "110", "111", "002", "012", "102", "112", "0002", "0012", "0102", "1002", "0112", "1012", "1102", "1112", "3", "03", "13", "013", "103"], SL = yL.map((e) => {
  let t = e.split("").map((r) => UL[r]).join(" ");
  return new RegExp(`^${t}$`);
});
function MS(e) {
  return !e || SL.some((t) => t.test(e));
}
function vL(e) {
  let t = "[];", r = "()", i = t + r, n = [t[0], r[0]], a = Object.assign({}, ...i.split("").map((c) => ({ [c]: 0 }))), o = "", s = e.split("").map((c) => {
    let u = i.includes(c) && c, d = n.includes(u);
    if (d && u)
      return a[u] += 1, o = u, c;
    if (!d && u && o && u !== o) {
      a[o] -= 1;
      let p = t.includes(o) && t || r.includes(o) && r || "", l = p.split("").find((m) => m !== o);
      if (p.includes(u))
        a[o] || (o = "");
      else
        return a[u] || (o = ""), l;
    }
    return c;
  }).join("");
  return e !== s ? s : e;
}
function tl(e) {
  return /^\(\d+\)$/.test(e) || /^\(\d+$/.test(e);
}
function wL(e) {
  return /^\(\d+-\d+\)$/.test(e) || /^\[\d+-\d+\]$/.test(e);
}
function Js(e) {
  let t = ((r) => r == null ? void 0 : r.split("-").join("").split("/").join(""))(e);
  if (/^\d+$/.test(t) && t.length === 2) {
    let r = t.split("");
    return Math.abs(r.reduce((i, n) => +i - +n)) === 1;
  }
  return !1;
}
function Nl(e, t) {
  let r = [e.slice(t, t + 2), t ? e.slice(0, 1) : e.slice(2)].map((n) => parseInt(n.join("")));
  t && r.reverse();
  let i = r;
  if (Math.abs(i.reduce((n, a) => +n - +a)) >= 2)
    return i.join("-");
}
function NS(e) {
  return e.length === 2 ? e.split("").join("-") : ([", ", ",", "/", " "].forEach((t) => e = e.split(t).join("-")), e = e.replace(/-{2,}/, "-"), e);
}
function PL(e) {
  return e.startsWith("(") && e.endsWith(")");
}
function DL({ score: e, applied: t }) {
  e = vL(e);
  let r = /\)(\d+)/g;
  if (r.test(e))
    for (let w of e.match(r)) {
      let v = w.replace(")", ") ");
      e = e.replace(w, v);
    }
  e = e.replace(/\)\//g, ") / "), e = e.replace(/\/\)/g, ")");
  let i = /\(([\d- ]+)\)/g, n = /\(([\d- ]+)\)/, a = e.match(i);
  for (let w of a || []) {
    let [v] = w.match(n).slice(1), P = v.replace(/ /g, "");
    e = e.replace(w, `(${P})`);
  }
  let o = /\(\(\d-\d\)\)/g;
  if (o.test(e)) {
    let w = e.match(o);
    w.length && w.forEach((v) => {
      let P = v.match(/\((\(\d-\d\))\)/).slice(1)[0];
      e = e.replace(v, P);
    });
  }
  if (o = /\(\((\d)\)\)/g, o.test(e)) {
    let w = e.match(o);
    w.length && w.forEach((v) => {
      let P = v.match(/\((\(\d\))\)/).slice(1)[0];
      e = e.replace(v, P);
    });
  }
  /(^|\s)6-,/.test(e) && (e = e.replace(/(^|\s)6-,/g, "6-0,"));
  let s = new RegExp(/[-,]{2,}/g);
  e = e.replace(s, "-"), ["- ", " -"].forEach((w) => {
    let v = new RegExp(`(\\d+)${w}(\\d+)`, "g"), P = e.match(v);
    P && P.forEach((b) => e = e.replace(b, b.split(w).join("-")));
  }), /^[(-/,]+$/.test(e) && (e = ""), /\)[-/,]+$/.test(e) && (e = e.slice(0, e.length - 1)), /\d \/\d/.test(e) && (e = e.replace(/ \//g, "/")), e.includes(" /") && (e = e.replace(/ \//g, " "));
  let c = /\(\d+, \)/g;
  c.test(e) && e.match(c).forEach((w) => {
    let [v] = w.match(/\((\d+), \)/).slice(1);
    v.length === 2 ? e = e.replace(w, `(${v})`) : v.length === 1 && v === "6" && (e = e.replace(w, "(6-0)"));
  });
  let u = /\((\d+)\/\)/g;
  u.test(e) && e.match(u).forEach((w) => {
    let [v] = w.match(/\((\d+)\/\)/).slice(1);
    v.length === 2 ? e = e.replace(w, `(${v})`) : v.length === 1 && v === "6" ? e = e.replace(w, "(6-0)") : e = e.replace(w, `(${v})`);
  });
  let d = /\d\/\d\/,/g;
  d.test(e) && e.match(d).forEach((w) => {
    let [v] = w.match(/(\d\/\d)\/,/).slice(1);
    e = e.replace(w, `${v},`), t.push("slashComma");
  });
  let p = /\(\/(\d+)\)/g;
  p.test(e) && e.match(p).forEach((w) => {
    let [v] = w.match(/\(\/(\d+)\)/).slice(1);
    v.length === 2 ? e = e.replace(w, `(${v})`) : v.length === 1 && parseInt(v) < 6 ? e = e.replace(w, `(6-${v})`) : e = e.replace(w, `(${v})`);
  });
  let l, m, f, h, g, I = () => {
    g = Qr(e.split("")), m = g["("] === (g[")"] || 0) + 1, l = (g["("] || 0) + 1 === g[")"], f = g["["] === g["]"] + 1, h = m && !f;
  };
  I();
  let y = /(\d+-\d+\(\d+)0,/;
  if (y.test(e)) {
    let [w] = e.match(y).slice(1);
    e = e.replace(y, w + ")");
  }
  if (g["("] === g[")"] && g["("] > 1) {
    let w = e.split(")(").join(") (").split(" ");
    w.every(PL) ? e = w.map((v) => {
      let P = v.slice(1, v.length - 1);
      return P.length > 2 ? P : v;
    }).join(" ") : e = w.join(" ");
  }
  I();
  let U = /[A-Za-z]+/.test(e), S = /\d+/.test(e);
  if (!U && !S)
    return { score: "" };
  if (/^\[.+\]$/.test(e) && "()/,- ".split("").some((w) => g[w]) && (e = e.slice(1, e.length - 1)), /^\(.+\)$/.test(e) && g["("] === 1 && g[")"] === 1 && "[]/,".split("").some((w) => g[w] > 1) && (e = e.slice(1, e.length - 1)), e.startsWith("(") && e.endsWith("))") && (e = e.slice(1, e.length - 1)), g["("] > (g[")"] || 0) && e[e.length - 1] === "(" && (e = e.slice(0, e.length - 1) + ")", I()), g["("] === 1 && !g[")"] && e[0] === "(" && (e = e + ")", I()), g["("] > (g[")"] || 0) && e.slice(0, 2) === "((" && (e = e.slice(1)), l) {
    if (/^9\d/.test(e))
      e = "(" + e.slice(1);
    else if (e[0] !== "(")
      e = "(" + e;
    else {
      let w = [], v = 0;
      for (let P of e.split("").reverse())
        P === ")" && (v ? w.push("(") : v += 1), P === "(" && (v -= 1), w.push(P);
      w.reverse(), e = w.join("");
    }
    I();
  }
  if (g[")"] > (g["("] || 0) && e[0] === ")" && (e = "(" + e.slice(1), I()), h && (e.endsWith(9) || /\d+0$/.test(e)) && (e = e.slice(0, e.length - 1) + ")", I()), h && (!e.endsWith(")") || e.startsWith("((")) && (e = e + ")", I()), h) {
    let w = "", v = 0;
    for (let P of e.split(""))
      P === "(" && (v ? w += ")" : v += 1), P === ")" && (v -= 1), w += P;
    e = w;
  }
  I(), f && !m && (e = e + "]"), e.includes("([") && e.includes("])") && (e = e.split("([").join("[").split("])").join("]"), I()), /\(\d+0$/.test(e) && (e = e.slice(0, e.length - 1) + ")"), I(), g[")"] === 1 && !g["("] && e.endsWith(")") && (e = e.slice(0, e.length - 1)), e.startsWith("(") && e.endsWith(")") && g["("] === 1 && g[")"] === 1 && (e = e.slice(1, e.length - 1), I());
  let D = (w) => {
    let v = w.indexOf("("), P = w.indexOf(")");
    return v >= 0 && P >= 0 && v < P;
  };
  if (/^\([\d ]+.*[\d ]+\)$/.test(e) && g["("] === g[")"]) {
    let w = e.slice(1, e.length - 1);
    D(w) && (e = w, I());
  }
  return { score: e, applied: t };
}
function am(e) {
  if (!/^[\d-]+(\(\d\))*$/.test(e))
    return e;
  let t = an("-", e.split(""));
  if (!t.length)
    return e;
  let r = e.split("-"), i = !(r.length % 2), n = !!(t.length % 2);
  return i && n && t.length > r.length / 2 && t.filter((a, o) => o % 2).forEach((a) => {
    e = e.substring(0, a) + " " + e.substring(a + 1);
  }), e;
}
function TL({ score: e, applied: t }) {
  return e.includes("( ") && (t.push("removeParenSpacingAfterOpen"), e = e.split("( ").map((r) => r.trim()).join("(")), e.includes(" )") && (t.push("removeParenSpacingBeforeClose"), e = e.split(" )").map((r) => r.trim()).join(")")), [gL, IL].forEach((r) => {
    let i = e.match(r);
    i != null && i.length && (i.forEach((n) => {
      e = e.replace(n, n.slice(0, n.length - 1) + " ");
    }), t.push("setsEndComma"));
  }), e = e.split(" ").filter(Boolean).map(am).join(" "), { score: e, applied: t };
}
function bL({ score: e }) {
  if (typeof e != "string")
    return { score: e };
  let t = (l) => l == null ? void 0 : l.split("-").join("").split("/").join(""), r = (l) => l.split("[").join("(").split("]").join(")");
  e = e.split(", ").join(" ");
  let i = e.split(" ");
  e = i.map((l) => {
    let m = /^-(\d+)$/;
    if (m.test(l)) {
      let [f] = l.match(m).slice(1);
      if (f.length === 2)
        return f.split("").join("-");
    }
    return l;
  }).join(" "), i = e.split(" ");
  let n = i.filter(tl), a = 0, o = "";
  for (let l of n) {
    let m = an(l, i).filter((I) => !a || I > a)[0], f = i.slice(a, m - 1), h = i[m - 1], g = t(h);
    if (/^\d+$/.test(g) && g.length === 2) {
      let I = g.split(""), y = Math.abs(I.reduce((U, S) => +U - +S));
      if (y === 1) {
        let U = [f.join(" "), [h, l].join("")].join(" ");
        o += U, a = m + 1;
      } else if (y === 0) {
        let U = Math.max(...I);
        if ([4, 5, 6, 7, 8, 9].includes(U)) {
          let S = [6, 4].includes(U) ? U + 1 : U - 1, D = [U, S].sort().reverse().join("-"), w = [f.join(" "), [D, l].join("")].join(" ");
          o += w, a = m + 1;
        }
      }
    }
  }
  if (n.length && o.length) {
    let l = i.slice(a).join(" ");
    return o = [o, l].join(" "), { score: o.trim() };
  }
  if (i.length === 2 && ["(", "["].some((l) => i[1].includes(l))) {
    let l = t(i[0]).split("");
    if (Math.abs(l.reduce((m, f) => +m - +f, 0)) === 1)
      return i[1] = r(i[1]), { score: i.join("") };
  }
  let s = i.map((l) => wL(l) && "bracket" || Js(l) && "set");
  if (s.includes("set") && s.includes("bracket")) {
    let l, m = "";
    return i.forEach((f, h) => {
      s[h] === "bracket" && l === "set" ? (f = r(f), m += f) : m += ` ${f}`, l = s[h];
    }), { score: m.trim() };
  }
  i = e.split(" ");
  let c, u = i.map((l) => {
    let m = new RegExp(/^(\d+)-(\d+)$/);
    if (m.test(l)) {
      let [f, h] = l.match(m).slice(1), g = Math.abs([f, h].reduce((y, U) => +y - +U)), I = Math.max(f, h);
      if (g === 1)
        return c = "tiebreakSet", c;
      if (g >= 2 && I >= 7 && c === "tiebreakSet")
        return c = "tiebreak", c;
    }
  }), d = an("tiebreak", u);
  if (d.length) {
    let l = "";
    i.forEach((m, f) => {
      d.includes(f) ? l += `(${m}) ` : d.includes(f + 1) ? l += `${m}` : l += `${m} `;
    }), e = l.trim();
  }
  let p = /(\d+-\d+)\((\d+)-(\d+)\)$/;
  if (p.test(e)) {
    let [l, m, f] = e.match(p).slice(1), h = Math.max(m, f) >= 10;
    !Js(l) && h && (e = e.replace(p, `${l} [${m}-${f}]`));
  }
  return u = [], e = e.split(" ").map((l) => {
    let m = /^\((.*)\)$/, f = m.test(l), h = new RegExp(tU).test(l) && "super" || new RegExp(hu).test(l) && "tiebreak" || new RegExp(nm).test(l) && "standard" || "unknown";
    return u.push(h), h === "standard" && f ? l.match(m)[1] : l;
  }).join(" "), { score: e };
}
function RL({ score: e, applied: t }) {
  for (let P of [".", ",", " ", "/"]) {
    let b = new RegExp(`^(\\d+)\\${P}(\\d+)$`);
    if (b.test(e)) {
      let T = e.match(b).slice(1).map((M) => parseInt(M)), R = Math.abs(T[0] - T[1]);
      R <= 10 && R >= 2 && (e = e.split(P).join("-"), t.push("variedJoinerPattern"));
    }
  }
  e.includes(";") && (e = e.split(";").join(" "), t.push("semicolon set separation"));
  let r = /(^|\s)(\d)\/(\d)(\d)\/(\d)(\(|$)/;
  if (r.test(e)) {
    let [P, b, T, R, M, E] = e.match(r).slice(1);
    e = e.replace(r, `${P}${b}-${T} ${R}-${M}${E}`), t.push("smashSlashPattern");
  }
  /.*\s6[/-]+$/.test(e) && (e += "0", t.push("incompleteFinalSetPattern"));
  let i = /\(6,\)/g;
  i.test(e) && (e = e.replace(i, "(6, 0)"), t.push("missingZeroPattern1"));
  let n = /^\d{3,}\(/, a = /\(\d+\)\d+/;
  [n, a].forEach(() => {
    e = e.split(" ").map((P) => (n.test(P) && (P = P.replace("(", " (")), a.test(P) && (P = P.replace(")", ") ")), P)).join(" "), t.push("spaceConsiderationPatterns");
  });
  let o = am(e);
  o !== e && (e = o, t.push("deDashMash"));
  let s = /^(\d)[-/,]+(\d{2})[-/,]+(\d)$/;
  if (s.test(e)) {
    let [P, b, T] = e.match(s).slice(1), [R, M] = b.split("");
    e = `${P}-${R} ${M}-${T}`, t.push("smashSetPattern");
  }
  let c = /^(\d+)[ -](\d+)$/, u = /^([\d -]+)\/([\d -]+)$/;
  if (u.test(e)) {
    let [P, b] = e.match(u).slice(1), T = P.trim(), R = b.trim();
    if (c.test(T) && c.test(R)) {
      let M = T.match(c).slice(1, 3).join("-"), E = R.match(c).slice(1, 3).join("-");
      e = `${M} ${E}`, t.push("slashSeparationPattern");
    }
  }
  let d = /^([\d -]+),([\d -]+)$/;
  if (d.test(e)) {
    let [P, b] = e.match(d).slice(1), T = P.trim(), R = b.trim();
    if (c.test(T) && c.test(R)) {
      let M = T.match(c).slice(1, 3).join("-"), E = R.match(c).slice(1, 3).join("-");
      e = `${M} ${E}`, t.push("commaSeparationPattern");
    }
  }
  let p = /^\d \d,/;
  if (p.test(e)) {
    let P = e.match(p)[0], b = P.slice(0, P.length - 1).split(" ").join("-");
    e = e.replace(P, b), t.push("singleSetCommaSeparationPattern");
  }
  let l = 0, m = /(\d+)-(\d{2})-(\d+)/;
  for (; m.test(e) && l < 3; ) {
    let [P, b, T] = e.match(m).slice(1), R = b.split(""), M = `${P}-${R[0]} ${R[1]}-${T}`;
    e = e.replace(m, M), t.push("noSetSeparationPattern"), l += 1;
  }
  let f = /(^|\s)7-6\s(\d+)\s/g, h = e.match(f);
  if (h != null && h.length) {
    let P = /(^|\s)7-6\s(\d+)\s/;
    h.forEach((b) => {
      let T = b.match(P).slice(2)[0];
      e = e.replace(b, `7-6(${T}) `), t.push("floatingTiebreakPattern1");
    });
  }
  let g = e.match(/\d \d /);
  g == null || g.forEach((P) => {
    let b = P.slice(0, P.length - 1).split(" ").join("-");
    e = e.replace(P, b), t.push("spaceSeparatedSetPattern1");
  }), g = e.match(/ \d \d$/), g == null || g.forEach((P) => {
    let b = " " + P.slice(1).split(" ").join("-");
    e = e.replace(P, b), t.push("spaceSeparatedSetPattern2");
  });
  let I = /^\d, *\d\/\d, *\d/;
  if (I.test(e)) {
    let P = e.match(I)[0], b = P.split("/").map((T) => `(${T})`).join(" ") + " ";
    e = e.replace(P, b), t.push("slashCommaSetPattern");
  }
  let y = /\(6-\)/g;
  y.test(e) && (e = e.replace(y, "(6-0)"), t.push("missingZeroPattern2"));
  let U = new RegExp("(?<!-)(\\d+)\\/(\\d+)(?!-)", "g");
  if (U.test(e)) {
    let P = e.match(U), b = new RegExp("(?<!-)(\\d+)\\/(\\d+)(?!-)"), T = e;
    P.forEach((R) => {
      let [M, E] = R.match(b).slice(1), C = `${M}-${E}`;
      T = T.replace(R, C);
    }), e = T, t.push("slashSetPattern");
  }
  let S = /(.*)\s(1\d)\s(\d+)$/;
  if (S.test(e)) {
    let [P, b, T] = e.match(S).slice(1);
    P.replace(/\D/g, "").length >= 4 && (e = P + ` ${b}${T}`, t.push("spaceSeparatedSuperPattern"));
  }
  let D = /(^|\s)(\d+-\d+)\s(\d+)(\s|$)/g;
  for (let P of e.match(D) || []) {
    let [b, T, R, M] = P.match(/(^|\s)(\d+-\d+)\s(\d+)(\s|$)/).slice(1), [E, C] = T.split("-").map((A) => parseInt(A));
    Math.abs(E - C) === 1 && (e = e.replace(P, `${b}${T}(${R})${M}`), t.push("spaceSeparatedSetPattern"));
  }
  let w = /\d-\d \(\d{1,2}\)(\s|$|,)/g;
  for (let P of e.match(w) || []) {
    let b = /(\d-\d) \((\d{1,2})\)(\s|$|,)/, [T, R, M] = P.match(b).slice(1), [E, C] = T.split("-").map((A) => parseInt(A));
    Math.abs(E - C) === 1 && (e = e.replace(P, `${T}(${R})${M}`), t.push("floatingTiebreakPattern2"));
  }
  let v = /(^|\s)(\d \d)\(/g;
  for (let P of e.match(v) || []) {
    let b = /(^|\s)(\d \d)\(/, [T, R] = P.match(b).slice(1);
    e = e.replace(P, `${T}${R.split(" ").join("-")}(`), t.push("spacedTiebreakPattern");
  }
  return { score: e, applied: t };
}
function ML({ score: e, matchUpStatus: t }) {
  var s;
  let r = e == null ? void 0 : e.split(" ");
  e = r.map((c) => {
    if (c.endsWith("]")) {
      let u = c.split("[");
      if (Js(u[0]))
        return u[0] + `(${u[1].slice(0, u[1].length - 1)})`;
    }
    return c;
  }).join(" ");
  let i = new RegExp(/(\([\d ]+\))/g);
  if (i.test(e))
    for (let c of e.match(i)) {
      let u = (s = c.replace(" ", "-").match(/\((.*)\)/)) == null ? void 0 : s[1];
      if (St(u) && (u == null ? void 0 : u[0]) > 2) {
        if ([2, 4].includes(u.length))
          u = u.split("").join("-");
        else if (u.length === 3) {
          let d = u.indexOf("1");
          u = Nl(u.split(""), d);
        }
      }
      e = e.replace(c, `(${u})`);
    }
  r = e == null ? void 0 : e.split(" ");
  let n = new RegExp(/^(\d[-/]+\d)\((\d+)[-/]+(\d+)\)$/), a = r.length - 1;
  e = r.map((c, u) => {
    let d = [void 0, "", "COMPLETED"].includes(t) || u !== a;
    if (n.test(c) && d) {
      let [p, l, m] = Array.from(c.match(n)).slice(1), f = Math.min(l, m);
      return `${p}(${f})`;
    }
    return c;
  }).join(" "), r = e == null ? void 0 : e.split(" "), n = new RegExp(/^(\d{2})\((\d+)\)$/), e = r.map((c) => {
    if (n.test(c)) {
      let [u, d] = Array.from(c.match(n)).slice(1), p = u.split("");
      return `${p[0]}-${p[1]}(${d})`;
    }
    return c;
  }).join(" "), r = e == null ? void 0 : e.split(" "), n = new RegExp(/^\((\d[-/]+\d)\)(\d+)$/), e = r.map((c) => {
    if (n.test(c)) {
      let [u, d] = Array.from(c.match(n)).slice(1);
      return Js(u) ? `${u}(${d})` : u;
    }
    return c;
  }).join(" "), r = e == null ? void 0 : e.split(" "), n = new RegExp(/^1-0\((\d+)\)$/), e = r.map((c) => {
    if (n.test(c)) {
      let [u] = c.match(n).slice(1);
      return `[${u < 9 ? 10 : parseInt(u) + 2}-${u}]`;
    }
    return c;
  }).join(" ");
  let o = /\((\d)+0 /;
  if (o.test(e)) {
    let c = e.match(o)[1];
    e = e.replace(o, `(${c}) `);
  }
  return { score: e };
}
function NL({ score: e, attributes: t, identifier: r }) {
  var d, p, l;
  if (typeof e != "string")
    return { score: e, identifier: r };
  let i = new RegExp(/\([\d,/ ]+\)/g), n = e.match(i);
  for (let m of n || []) {
    let f = (p = (d = m.match(/^\((.*)\)$/)) == null ? void 0 : d.slice(1)) == null ? void 0 : p[0], h = e.split(m)[0].split(")").reverse()[0].replace(/\D/g, "");
    if ((f == null ? void 0 : f.length) === 2 && (h == null ? void 0 : h.length) >= 2) {
      let y = h.slice(h.length - 2).split("").map((U) => parseInt(U));
      if (Math.abs(y[0] - y[1]) === 1)
        continue;
    }
    let g = NS(f), I = am(g);
    e = e.replace(m, `(${I})`).trim();
  }
  let a = new RegExp(/\[[\d,/ ]+\]/g);
  (l = e.match(a)) == null || l.forEach((m) => {
    let f = NS(m.match(/^\[(.*)\]$/)[1]);
    e = e.replace(m, `(${f}) `).trim();
  });
  let o = [")", "]"], s = [")(", "), (", ") (", ")[", ") [", "](", "] ("];
  if (e.startsWith("(") && o.some((m) => e.endsWith(m)) && s.some((m) => e.includes(m))) {
    let m = "", f = e.split(/[)\]]/).filter(Boolean).map((U) => (U.startsWith(",") && (U = U.slice(1)), U.trim())), h = f.every((U) => U.includes(",") || tl(U)), g = f.every((U) => U.includes("/") || tl(U)), I = f.every((U) => U.includes("-") || tl(U)), y = h && "," || I && "-" || g && "/";
    if (y) {
      let U;
      f.forEach((S) => {
        if (S.startsWith("("))
          if (U === "set" && (m += " "), S.includes(y))
            m += S.slice(1).split(y).map((D) => D.trim()).join("-"), U = "set";
          else {
            let D = S.slice(1);
            m += `(${D}) `, U = "tiebreak";
          }
        else if (S.startsWith("[")) {
          let D = S.slice(1).split(y).map((v) => parseInt(v.trim())), w = Math.min(...D);
          U === "set" ? m += `(${w}) ` : m += `[${D.join("-")}] `, U = "tiebreak";
        }
      }), e = m.trim();
    }
  }
  let c = Qr(e.split(""));
  c["("] === 1 && c[")"] === 1 && e.startsWith("(") && e.endsWith(")") && (e = e.slice(1, e.length - 1), c["-"] === 1 && Js(e) && St(t == null ? void 0 : t.removed) && (e = e + `(${t.removed})`, t.removed = void 0));
  let u = /\(\)/g;
  return u.test(e) && (e = e.replace(u, "").trim()), { score: e };
}
function GR({ score: e }) {
  let t = e.split(""), r = [], i, n = () => i = [void 0, void 0, void 0], a = () => {
    let s = `${i[0]}-${i[1]}`;
    return i[2] && (s += ` (${i[2]})`), n(), i.push(i), s;
  };
  n();
  let o = () => i[0] !== void 0 && i[1] !== void 0 && Math.abs(parseInt(i[0]) - parseInt(i[1]));
  for (; t.length; ) {
    let s = t.shift(), c = St(s) && parseInt(s), u = i[0] !== void 0 && i[1] !== void 0;
    if (St(c)) {
      if (i[0] === void 0) {
        i[0] = c;
        continue;
      }
      if (i[1] === void 0 && (i[1] = c, o())) {
        r.push(a()), i = [void 0, void 0];
        continue;
      }
      if (u && t.length === 1 && St(t[0])) {
        let d = t.pop();
        i[0] = i[0].toString() + i[1].toString(), i[1] = d, r.push(a()), i = [void 0, void 0];
      }
      u && o();
    }
  }
  return { sets: r };
}
function nh(e) {
  let t = e.indexOf("1"), r = e.split(""), i = r.every((n) => !isNaN(n));
  if (i && e.length === 3 && t === 0) {
    let n = Nl(r, t);
    if (n)
      return n;
  }
  if (i && e.length === 7 && t > 3) {
    let n = r.slice(4), a = Nl(n, t - 4);
    if (a)
      return `${r[0]}-${r[1]} ${r[2]}-${r[3]} ${a}`;
  }
}
function $R(e) {
  let { score: t } = e, { applied: r, matchUpStatus: i } = e, n = t == null ? void 0 : t.toString().split(""), a = n == null ? void 0 : n.every((s) => St(s)), o = (s) => Math.abs(s[0] - s[1]);
  if (typeof t == "number" || a) {
    t = t.toString().toLowerCase(), a && (t = n.join(""));
    let s = a ? n.map((c) => parseInt(c)) : t.split("").map((c) => parseInt(c));
    if (GR({ score: t }), s.length, t.length === 3 && o(s.slice(0, 2)) === 1) {
      let [c, u, d] = s;
      t = `${c}-${u}(${d})`, r.push("numericTiebreakPattern1");
    } else if (t.length === 3 && s[0] === 1) {
      let [c, u, d] = s;
      t = `[${c}${u}-${d}]`, r.push("numericTiebreakPattern2");
    } else if (t.length === 4 && o(s.slice(0, 2)) === 1 && "987654".split("").includes(s[0].toString())) {
      let [c, u, d, p] = s, l = Math.min(d, p);
      t = `${c}-${u}(${l})`, r.push("numericTiebreakPattern3");
    } else if (t.length === 4 && s[0] === 1 && s[2] === 1) {
      let [c, u, d, p] = s;
      t = `[${c}${u}-${d}${p}]`, r.push("bigSuper");
    } else if (t.length === 4) {
      let [c, u, d, p] = s;
      t = `${c}${u} ${d}${p}`, r.push("split4");
    } else if (t.length === 5 && o(s.slice(0, 2)) === 1) {
      let [c, u, d, p, l] = s;
      t = `${c}-${u}(${d}) ${p}-${l}`, r.push("numericTiebreakPattern4");
    } else if (t.length === 5 && o(s.slice(3)) === 1) {
      let [c, u, d, p, l] = s;
      t = `${c}-${u} ${d}-${p}(${l})`, r.push("numericTiebreakPattern5");
    } else if (s.length === 7)
      if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) > 1 && s[4] === 1) {
        let [c, u, d, p, l, m, f] = s;
        t = `${c}-${u} ${d}-${p} [${l}${m}-${f}]`, r.push("numericTiebreakPattern6");
      } else if (o(s.slice(0, 2)) === 1 && o(s.slice(3, 5)) > 1 && o(s.slice(5, 7)) > 1) {
        let [c, u, d, p, l, m, f] = s;
        t = `${c}-${u}(${d}) ${p}-${l} ${m}-${f}`, r.push("numericTiebreakPattern7");
      } else if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) === 1 && o(s.slice(5, 7)) > 1) {
        let [c, u, d, p, l, m, f] = s;
        t = `${c}-${u} ${d}-${p}(${l}) ${m}-${f}`, r.push("numericTiebreakPattern8");
      } else if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) > 1 && o(s.slice(4, 6)) === 1) {
        let [c, u, d, p, l, m, f] = s;
        t = `${c}-${u} ${d}-${p} ${l}-${m}(${f})`, r.push("numericTiebreakPattern9");
      } else
        t = t.slice(0, 2) + " " + t.slice(2, 4) + " " + t.slice(4), r.push("numericMatchTiebreakPattern");
    else if (t.length % 2) {
      let c = nh(t);
      c && t !== c && r.push("parsedSuperPattern"), t = c ?? t;
    } else {
      let c = zt(t.split(""), 2).map((g) => g.join("")), u = c.map((g) => {
        let [I, y] = g.split("").map((D) => parseInt(D)), U = Math.abs(I - y), S = I > y ? 1 : 2;
        return U > 1 && S || S * -1;
      }), d = u.reduce((g, I) => g > 0 && I > 0, 1), p = Qr(u), l = u.map((g) => Math.abs(g)), m = Qr(l), f = u[0] < 0, h = !f && u[1] < 0;
      if (u[0] > 0 && u[1] > 0 && u[0] !== u[1])
        t = [c.slice(0, 2).join(" "), c.slice(2).join("-")].join(" "), r.push("numeric3rdSetTiebreakPattern");
      else if (d)
        t = c.join(" "), r.push("chunkSplit");
      else if (s.length === 6) {
        if (p[1] === 2 || p[2] === 2)
          if (!Object.values(m).includes(3))
            t = c.join(" "), r.push("chunkSplit");
          else {
            let [g, I, y, U, S, D] = s, w = u.reduce((v, P, b) => P < 0 ? b : v, void 0);
            if (w === 0) {
              let v = Math.min(y, U);
              t = `${g}-${I}(${v}) ${S}-${D}`, r.push("chunkSplitTiebreak1");
            } else if (w === 1) {
              let v = Math.min(S, D);
              t = `${g}-${I} ${y}-${U}(${v})`, r.push("chunkSplitTiebreak2");
            } else
              t = `${g}-${I} ${y}-${U}`, r.push("chunkSplitTrimExtraneous");
          }
      } else if (s.length === 8) {
        let [g, I, y, U, S, D, w, v] = s;
        f || h ? s[5] === 1 && (f ? t = `${g}-${I}(${y}) ${U}-${S} [${D}${w}-${v}]` : t = `${g}-${I} ${y}-${U}(${S}) [${D}${w}-${v}]`) : (u[0], u[1]);
      }
    }
  }
  return { score: t, applied: r, matchUpStatus: i };
}
function qR(e) {
  let t = [0, 0], r = [], i = e.split(" "), n = /(\d+)-(\d+)/;
  i.forEach((c) => {
    if (n.test(c)) {
      let u = c.match(n).slice(1).map((p) => parseInt(p)), d = u[0] > u[1] && 1 || u[1] > u[0] && 2;
      d && (t[d - 1] += 1, r.push(d));
    }
  });
  let a = t[0] > t[1] && 1 || t[1] > t[0] && 2, o = t[0] > 0 && t[0] === t[1], s = t.reduce((c, u) => c + u, 0);
  return { setsWon: t, setsTied: o, setWinners: r, totalSets: s, winningSide: a };
}
function AL({ score: e, matchUpStatus: t, attributes: r }) {
  let i = [], n, a = e.split(" "), o = a.length;
  e = a.map((d, p) => {
    if (new RegExp(hu).test(d)) {
      let m = d.slice(3), f = d.slice(0, 3), h = f.split("-");
      if (!Js(f) && !t) {
        let g = Math.max(...h), I = f.indexOf(g), y = [g, g - 1];
        return I && y.reverse(), y.join("-") + m;
      }
    } else if (d.length === 2 && St(d))
      return d.split("").join("-");
    d = am(d);
    let l = new RegExp(`^${tU}$`).test(d) && "super" || new RegExp(`^${hu}$`).test(d) && "tiebreak" || new RegExp(`^${nm}$`).test(d) && "standard" || "unknown";
    if (i.push(l), o > 1 && l === "standard" && p < 2) {
      let [m, f] = d.split("-"), h = Math.abs(parseInt(m) - parseInt(f)), g = Math.max(m, f), I = Math.min(m, f), y = [parseInt(m), parseInt(f)].indexOf(I);
      if (g > 9 && h > 2) {
        let U = g.toString().split(""), S = U.find((D) => parseInt(D) > I || p && parseInt(D) <= n) ?? U[0];
        S && (d = y ? [S, I].join("-") : [I, S].join("-"));
      }
      g > (n || 0) && (n = g);
    }
    if (l === "standard") {
      let [m, f] = d.split("-");
      if (!Math.abs(parseInt(m) - parseInt(f)) && t !== "RETIRED")
        return "";
    }
    return d;
  }).filter(Boolean).join(" ");
  let { setsWon: s, setWinners: c, totalSets: u } = qR(e);
  if (u === 1 && (r == null ? void 0 : r.removed) === "6" && (e += " 6-0"), e.split(" ").length > 2 && Math.max(...s) >= 2 && c[0] === c[1] && (e = e.split(" ").slice(0, 2).join(" ")), Math.max(...s) > 2) {
    let d = [0, 0];
    e = e.split(" ").map((p, l) => (d[c[l]] += 1, Math.max(...d) > 2 ? void 0 : p)).filter(Boolean).join(" ");
  }
  return { score: e, profile: i };
}
function EL({ score: e }) {
  let { setsTied: t, winningSide: r } = qR(e), i = /\s\((\d+)\)$/;
  if (!r && t && i.test(e)) {
    let s = e.match(i).slice(1)[0], c = s <= 8 ? 10 : s + 2;
    e = e.replace(i, ` [${c}-${s}]`);
  }
  let n = e.split(" "), a = n[n.length - 1];
  if (!a.includes("-") || a.indexOf("(") > 0)
    return { score: e };
  let o = a.split("(").join("").split(")").join("").split("-");
  if (!o.every((s) => St(s)))
    return { score: e };
  if (o[0] === "76") {
    let s = o[1].length === 2 ? Math.min(...o[1].split("").map((c) => parseInt(c))) : o[1];
    e = [...n.slice(0, n.length - 1), `7-6(${s})`].join(" ");
  } else {
    o = o.map((u) => parseInt(u));
    let s = Math.max(...o), c = Math.abs(o[0] - o[1]);
    if (s >= 10) {
      if (c > 2 && o.every((u) => +u >= 10)) {
        let u = o.map((d) => d === s ? d - 10 : 10).sort();
        c = Math.abs(u[0] - u[1]), c > 2 && (o = u);
      }
      e = [...n.slice(0, n.length - 1), `[${o.join("-")}]`].join(" ");
    } else
      n.length === 3 && s >= 7 && c > 2 && (e = [...n.slice(0, n.length - 1), `[${o.join("-")}]`].join(" "));
  }
  return { score: e };
}
function CL({ score: e }) {
  return e = (e == null ? void 0 : e.toString().toLowerCase()) || "", { score: e };
}
function OL({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : (e.toLowerCase().includes("o") && (e = e.toLowerCase().split(" ").map((r) => r.split("o").join("0")).join(" "), t.push("replaceOh")), { score: e, applied: t });
}
function kL({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : (e = e.toLowerCase().split(" ").map((r) => {
    if (/^\d+$/.test(r) && r.length > 2) {
      let i = r.indexOf("1");
      if (r.length % 2) {
        if (r.length === 3 && i === 0) {
          let n = Nl(r.split(""), i);
          return t.push("getSuper"), n;
        }
      } else {
        let { score: n, applied: a } = $R({ score: r, applied: [] });
        n !== r && (r = n, t.push(...a));
      }
    }
    return r;
  }).join(" "), { score: e, applied: t });
}
function FL({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : [3, 4].includes(e.length) && nh(e) ? { score: nh(e) } : (e = e.toLowerCase().split(" ").map((r) => {
    if (/^\d+$/.test(r) && r.length === 1) {
      t.push("removeErroneous1");
      return;
    }
    return r;
  }).filter(Boolean).join(" "), { score: e, applied: t });
}
function xL({ score: e, applied: t }) {
  return ["walkover", "wo", "w/o", "w-o"].includes(e == null ? void 0 : e.toString().toLowerCase()) ? (t.push("handleWalkover"), { matchUpStatus: "walkover", score: "", applied: t }) : { score: e };
}
function LL({ score: e, profile: t, applied: r }) {
  var o;
  e = e == null ? void 0 : e.toString().toLowerCase();
  let i = /^(.*\d+.*)(ret|con)+[A-Za-z ]*$/;
  if (i.test(e)) {
    let [s] = e.match(i).slice(1);
    return r.push("handleRetired"), { score: s.trim(), matchUpStatus: "retired", applied: r };
  }
  let n = (o = t == null ? void 0 : t.matchUpStatuses) == null ? void 0 : o.retired, a = ["rtd", ...Array.isArray(n) ? n : [n].filter(Boolean)].find((s) => e == null ? void 0 : e.endsWith(s));
  return a ? (r.push("handleRetired"), { matchUpStatus: "retired", score: e == null ? void 0 : e.replace(a, "").trim(), applied: r }) : { score: e };
}
function _L({ score: e, attributes: t }) {
  (e.endsWith(" am") || e.endsWith(" pm")) && (e = ""), e = e.replace(/[A-Za-z]+/g, "").trim(), [".", ","].some((n) => e.endsWith(n)) && (e = e.slice(0, e.length - 1));
  let r = "()/-".split("").some((n) => e.includes(n));
  / \d$/.test(e) && r && (t = { removed: e.slice(e.length - 2).trim() }, e = e.slice(0, e.length - 2));
  let i = /(.*)[A-Za-z]+$/;
  return i.test(e) && (e = e.match(i).slice(1)[0].trim()), { score: e, attributes: t };
}
function BL({ score: e }) {
  return new RegExp(/-\d+\/\d+-/).test(e) && (e = e.split("/").join(" ")), { score: e };
}
function VL({ score: e }) {
  let t = new RegExp(/^\d+\/\d+/), r = e.split(" ");
  r.some((n) => t.test(n)) && (e = r.map((n) => t.test(n) ? n.replace("/", "-") : n).join(" "));
  let i = /^(\d+), *(\d+)$/;
  if (i.test(e)) {
    let [n, a] = e.match(i).slice(1);
    e = [n, a].join("-");
  }
  return { score: e };
}
function jL({ score: e }) {
  let t = new RegExp(/\(\d+\/\d+\)/g), r = e.match(t);
  for (let i of r || []) {
    let n = i.replace("/", "-");
    e = e.replace(i, n);
  }
  return { score: e };
}
function GL({ score: e }) {
  if (e.includes(",")) {
    let t = e.split(",").map((i) => i.trim()), r = (i) => /\d \d/.test(i);
    t.every(r) && (e = t.map((i) => {
      let n = /\d+ \d+/g;
      for (let a of i.match(n)) {
        let [o, s] = a.match(/(\d+) (\d+)/).slice(1);
        i = i.replace(a, `${o}-${s}`);
      }
      return i;
    }).join(" "));
  }
  if (e.includes(" ")) {
    let t = e.replace(/[ ,]/g, "");
    t.split("").every((r) => St(r)) && t.length === 4 && (e = t);
  }
  return { score: e };
}
function $L({ score: e }) {
  let t = new RegExp(/^\[\d+\](.*)$/);
  t.test(e) && (e = e.match(t).slice(1)[0].trim());
  let r = /\(,/g;
  return r.test(e) && (e = e.replace(r, "(")), { score: e };
}
var qL = { handleTiebreakSlashSeparation: jL, handleSetSlashSeparation: BL, punctuationAdjustments: DL, handleGameSeparation: VL, joinFloatingTiebreak: bL, handleBracketSpacing: TL, handleSpaceSeparator: GL, separateScoreBlocks: kL, matchKnownPatterns: RL, removeDanglingBits: _L, removeErroneous: FL, handleWalkover: xL, properTiebreak: ML, handleNumeric: $R, handleRetired: LL, containedSets: NL, sensibleSets: AL, stringScore: CL, superSquare: EL, setBuilder: GR, excisions: $L, replaceOh: OL }, tf = {}, WL = ["handleNumeric", "handleWalkover", "handleRetired", "replaceOh", "stringScore", "punctuationAdjustments", "excisions", "handleSpaceSeparator", "matchKnownPatterns", "removeDanglingBits", "handleBracketSpacing", "matchKnownPatterns", "containedSets", "separateScoreBlocks", "handleGameSeparation", "removeErroneous", "joinFloatingTiebreak", "handleSetSlashSeparation", "handleTiebreakSlashSeparation", "properTiebreak", "sensibleSets", "superSquare"], HL = ["handleNumeric", "separateScoreBlocks", "sensibleSets", "superSquare"];
function WR(e) {
  if (!e.score)
    return { error: J };
  let { score: t, sheetName: r, identifier: i, fileName: n, stepLog: a, fullLog: o, profile: s } = e, c = [], u, d = [], p, l, m = t, f = (g) => {
    g.forEach((I) => {
      l = qL[I]({ profile: s, identifier: i, matchUpStatus: u, attributes: p, applied: d, score: m });
      let y = l.score !== m;
      y && c.push({ method: I, score: l.score }), a && (o || y || l.matchUpStatus !== u) && console.log(u ? { score: l.score, matchUpStatus: u } : { score: l.score }, I), l.matchUpStatus && (u = l.matchUpStatus), l.attributes && (p = l.attributes), l.applied && (d = l.applied), m = l.score;
    });
  };
  f(WL);
  let h = MS(m);
  return h || (m = t.toString().replace(/\D/g, ""), p != null && p.removed && (p.removed = void 0), f(HL), h = MS(m), h || (m = "")), d.forEach((g) => {
    tf[g] || (tf[g] = 0), tf[g] += 1;
  }), { matchUpStatus: u == null ? void 0 : u.toUpperCase(), modifications: c, attributes: p, isValid: h, score: m };
}
var HR = {};
Ae(HR, { analyzeScore: () => rU, analyzeSet: () => gu, checkScoreHasValue: () => jt, checkSetIsComplete: () => rm, getSetComplement: () => nU, getTiebreakComplement: () => om, isValidMatchUpFormat: () => Jr, parseScoreString: () => Al, validateScore: () => iU, validateTieFormat: () => Ar });
function rU({ existingMatchUpStatus: e, matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n }) {
  var D, w;
  let a = (n == null ? void 0 : n.sets) ?? [], o = ((a == null ? void 0 : a.filter((v) => v == null ? void 0 : v.winningSide)) || []).reduce((v, P) => {
    let { winningSide: b } = P;
    if (!b)
      return v;
    let T = b - 1;
    return v[T]++, v;
  }, [0, 0]), s = i ? i - 1 : void 0, c = s !== void 0 ? 1 - s : void 0, u = s !== void 0 && o[s], d = c !== void 0 && o[c], p = t ? Tr(t) : void 0, l = Math.max(...o), m = Qr(o)[l], f = ((D = p == null ? void 0 : p.setFormat) == null ? void 0 : D.timed) || ((w = p == null ? void 0 : p.finalSetFormat) == null ? void 0 : w.timed), h = p == null ? void 0 : p.bestOf, g = h && Math.ceil(h / 2) || 1, I = r ?? e, y = I && [ke, nr, Be].includes(I), U = !p || !a.length || a.every((v, P) => {
    let b = P + 1, T = b === h, R = b === a.length, { side1Score: M, side2Score: E, side1TiebreakScore: C, side2TiebreakScore: A, winningSide: N } = v, O = Math.max(M ?? 0, E ?? 0), k = C ?? A, { finalSetFormat: F, setFormat: x } = p, _ = T && F || x;
    if (k) {
      let { tiebreakTo: B, NoAD: L } = (_ == null ? void 0 : _.tiebreakFormat) || {}, G = Math.max(C ?? 0, A ?? 0);
      if (L && G > B || G < B && N && (R && !y || !R))
        return !1;
    }
    return _.setTo ? !(!_.noTiebreak && O > _.setTo + 1) : !0;
  }), S = (!t || l === g) && m === 1 && o.indexOf(l) + 1 || void 0;
  return { valid: !!(U && (i && u > d && i === S || i && y || !i && !S && (![Tt, ke, nr, Be].includes(I) || f && I === Tt))) };
}
function iU({ existingMatchUpStatus: e, matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n }) {
  if (typeof n != "object")
    return { error: J };
  let { sets: a, scoreStringSide1: o, scoreStringSide2: s } = n, c = "scoreString must be a string!";
  if (o !== void 0 && typeof o != "string")
    return { error: J, info: c };
  if (s !== void 0 && typeof s != "string")
    return { error: J, info: c };
  if (a !== void 0 && !Array.isArray(a))
    return { error: J, info: Xa("sets") };
  if (a != null && a.length) {
    let u = a.map((p) => p == null ? void 0 : p.setNumber).filter(Boolean);
    if (u.length !== Te(u).length)
      return { error: J, info: "setNumbers not unique" };
    for (let p of a) {
      let { side1Score: l, side2Score: m, side1TiebreakScore: f, side2TiebreakScore: h, side1PointScore: g, side2PointScore: I, winningSide: y, setNumber: U } = p;
      if (![[l, m], [f, h], [g, I]].filter((S) => S.some((D) => ![void 0, null].includes(D))).every((S) => S.every((D) => Pe(D))))
        return { error: J, info: "non-numeric values" };
      if (![U, y].filter((S) => ![void 0, null].includes(S)).every((S) => Pe(S)))
        return { error: J, info: "non-numeric values" };
      if (y && ![1, 2].includes(y))
        return { error: J, info: "winningSide must be 1 or 2" };
    }
    let { valid: d } = rU({ existingMatchUpStatus: e, matchUpStatus: r, matchUpFormat: t, winningSide: i, score: n });
    if (!d)
      return { error: ow, info: "score is invalid for matchUpFormat or winningSide does not match calculated winningSide" };
  }
  return { valid: !0 };
}
var nU = (e) => {
  let { isSide1: t, lowValue: r, setTo: i, tiebreakAt: n, NoAD: a } = e;
  if (r === void 0)
    return !1;
  let o = ye(r);
  (o == null ? void 0 : o.toString().length) > 2 && (o = parseInt(o.toString().slice(0, 2))), n && n < i && o > n && (o = n);
  let s;
  return a && !n ? (o > i && (s = i), s = o < i ? i : i - 1) : s = o + 1 < i && i || n && n < i && o === n && i || !n && o + 2 || i + 1, [t ? o : s, t ? s : o];
}, om = (e) => {
  let { isSide1: t, lowValue: r, tiebreakTo: i, tiebreakNoAd: n } = e;
  if (r === void 0)
    return !1;
  let a = typeof r == "string" ? parseInt(r) : r;
  (a == null ? void 0 : a.toString().length) > 2 && (a = parseInt(a.toString().slice(0, 2))), n && a > i - 1 && (a = i - 1);
  let o = zL({ lowValue: a, NoAD: n, tiebreakTo: i });
  return [t ? a : o, t ? o : a];
};
function zL(e) {
  let { lowValue: t, NoAD: r, tiebreakTo: i } = e, n = r ? 1 : 2;
  return t + 1 >= i ? t + n : i;
}
function Al({ tiebreakTo: e = 7, scoreString: t = "" }) {
  return t == null ? void 0 : t.split(" ").filter(Boolean).map((i, n) => r({ set: i, setNumber: n + 1 }));
  function r({ set: i, setNumber: n }) {
    let a = /\(([^)]+)\)/, o = /\[([^)]+)\]/, s = a.exec(i), c = o.exec(i), u = (i == null ? void 0 : i.startsWith("[")) && c && c[1].split("-").map((U) => parseInt(U)), d = s && i.replace(s[0], "") || c && i.replace(c[0], "") || i, p = !u && d.split("-").map((U) => parseInt(U)), l = u ? u[0] > u[1] && 1 || u[0] < u[1] && 2 || void 0 : p[0] > p[1] && 1 || p[0] < p[1] && 2 || void 0, m = s ? s[1] : void 0, f = (m && om({ lowValue: m, isSide1: l === 2, tiebreakTo: e })) ?? [], [h, g] = p || [], [I, y] = u || f || [];
    return { side1Score: h, side2Score: g, side1TiebreakScore: I, side2TiebreakScore: y, winningSide: l, setNumber: n };
  }
}
function YL({ matchUpScoringFormat: e, isDecidingSet: t, isTiebreakSet: r, isTimedSet: i, setObject: n }) {
  if (!n)
    return;
  let a = im({ set: n });
  return rm({ matchUpScoringFormat: e, set: n, isDecidingSet: t, isTiebreakSet: r, isTimedSet: i }) && a || void 0;
}
function gu(e) {
  let { setObject: t, matchUpScoringFormat: r } = e;
  if (!t)
    return { error: Wl };
  let { setNumber: i } = t || {}, { bestOf: n, exactly: a } = r || {}, o = n || a, s = !!(i && o && i === o), c = s && (r == null ? void 0 : r.finalSetFormat) || (r == null ? void 0 : r.setFormat), u = !!(c != null && c.tiebreakSet), d = !!(c != null && c.timed), p = !u && !d, l = !!(i && o && i <= o), m = [t == null ? void 0 : t.side1Score, t == null ? void 0 : t.side2Score], f = [t == null ? void 0 : t.side1PointScore, t == null ? void 0 : t.side2PointScore], h = [t == null ? void 0 : t.side1TiebreakScore, t == null ? void 0 : t.side2TiebreakScore], g = m.filter((k) => k !== void 0).length, I = f.filter((k) => k !== void 0).length, y = h.filter((k) => k !== void 0).length, U = m == null ? void 0 : m.filter((k) => !isNaN(k)).length, S = h == null ? void 0 : h.filter((k) => !isNaN(k)).length, { tiebreakAt: D } = c || {}, w = D && m.filter((k) => k >= D).length === 2, v = w && (m[0] > m[1] && 1 || m[1] > m[0] && 2 || void 0), P = !!(S && !U), b = !!(t != null && t.winningSide), { error: T, result: R } = KL({ sideTiebreakScores: h, sideGameScores: m, setFormat: c, setObject: t }), { error: M, result: E } = QL({ sideTiebreakScores: h, setObject: t, setFormat: c }), C = p && !P && R || u && P && E || d, A = l && !(u && !P) && !(p && P) && (!b || C), N = YL({ isTimedSet: d, matchUpScoringFormat: r, isDecidingSet: s, isTiebreakSet: P, setObject: t }), O = { expectTiebreakSet: u, expectTimedSet: d, hasTiebreakCondition: w, isCompletedSet: b, isDecidingSet: s, isTiebreakSet: P, isValidSet: A, isValidSetNumber: l, isValidSetOutcome: C, leadingSide: v, setFormat: c, sideGameScores: m, sideGameScoresCount: g, sidePointScores: f, sidePointScoresCount: I, sideTiebreakScores: h, sideTiebreakScoresCount: y, winningSide: N };
  return (t == null ? void 0 : t.winningSide) !== void 0 && (P ? (O.isValidTiebreakSetOutcome = E, E || (O.tiebreakSetError = M)) : (O.isValidStandardSetOutcome = R, R || (O.standardSetError = T))), O;
}
function KL({ setObject: e, setFormat: t, sideGameScores: r, sideTiebreakScores: i }) {
  if (!e)
    return { result: !1, error: Wl };
  let n = !!(t != null && t.tiebreakSet), a = !!(t != null && t.timed);
  if (!t || n || a)
    return { result: !1, error: J };
  if ((r == null ? void 0 : r.filter((v) => !isNaN(v)).length) !== 2)
    return { result: !1, error: vf };
  let { setTo: o, tiebreakAt: s, tiebreakFormat: c, NoAD: u } = t || {};
  if (!(o && (r != null && r.find((v) => v >= o))))
    return { result: !1, error: vf };
  let d = [1, 2].includes(e == null ? void 0 : e.winningSide);
  if (!e || !d)
    return { result: !1, error: Hl };
  let p = (e == null ? void 0 : e.winningSide) - 1, l = 1 - p, m = r[p], f = r[l], h = m - f;
  if (!(m > f))
    return { result: !1, error: { message: "winningSide game scoreString is not high" } };
  let g = s && c, I = (i == null ? void 0 : i.filter((v) => !isNaN(v)).length) === 2, y = i == null ? void 0 : i[p], U = i == null ? void 0 : i[l], S = s && r.filter((v) => v >= s).length === 2;
  if (g) {
    let { NoAD: v, tiebreakTo: P } = c;
    if (S) {
      if (h > 1)
        return { result: !1, error: { message: "invalid winning game scoreString (5)" } };
      if (!I)
        return { result: !1, error: { message: "invalid tiebreak scores (1)" } };
      if (isNaN(P))
        return { result: !1, error: { message: "tiebreakTo error" } };
      if (!(P && (i != null && i.find((E) => E >= P))))
        return { result: !1, error: { message: "invalid tiebreak scores (2)" } };
      let b = s < o ? o : o + 1;
      if (m > b)
        return { result: !1, error: { message: "invalid winning game scoreString (1)" } };
      if (!y || !U || y < U)
        return { result: !1, error: { message: "winningSide tiebreak value is not high" } };
      let T = v ? 1 : 2, R = y - U, M = U >= P - 1;
      if (R && M && R < T)
        return { result: !1, error: { message: "invalid tiebreak scores (3)" } };
    }
    if (m > o && !S)
      return { result: !1, error: { message: "invalid winning game scoreString (2)" } };
  }
  let D = u ? 1 : 2, w = f >= o - 1;
  return h && w && !S && h < D ? { result: !1, error: { message: "invalid winning game scoreString (3)" } } : h > D && m > o ? { result: !1, error: { message: "invalid winning game scoreString (4)" } } : { result: !0 };
}
function QL({ setObject: e, setFormat: t, sideTiebreakScores: r }) {
  if (!e)
    return { result: !1, error: Wl };
  let i = !!(t != null && t.tiebreakSet), n = !!(t != null && t.timed);
  if (!t || !i || n)
    return { result: !1, error: { message: "not tiebreak set" } };
  let a = [1, 2].includes(e == null ? void 0 : e.winningSide);
  if (!e || !a)
    return { result: !1, error: Hl };
  let { tiebreakSet: o } = t || {}, { NoAD: s, tiebreakTo: c } = o || {};
  if ((r == null ? void 0 : r.filter((g) => !isNaN(g)).length) !== 2)
    return { result: !1, error: { message: "invalid tiebreak scores (1)" } };
  if (isNaN(c))
    return { result: !1, error: { message: "tiebreakTo error" } };
  if (!(r != null && r.find((g) => g >= c)))
    return { result: !1, error: { message: "invalid tiebreak scores (2)" } };
  let u = (e == null ? void 0 : e.winningSide) - 1, d = 1 - u, p = r[u], l = r[d];
  if (!p || !l || p < l)
    return { result: !1, error: { message: "winningSide tiebreak value is not high" } };
  let m = s ? 1 : 2, f = p - l, h = l >= c - 1;
  return f && h && f < m ? { result: !1, error: { message: "invalid tiebreak scores (3)" } } : { result: !0 };
}
function JL(e) {
  var p, l, m;
  let { existingDrawDefinition: t, hydrateCollections: r, enforceGender: i, tieFormatName: n, matchUpType: a, eventType: o, isMock: s, event: c } = e, { tieFormat: u, matchUpFormat: d } = e;
  if (a === xt && o === xt) {
    let f = (l = (p = t == null ? void 0 : t.structures) == null ? void 0 : p.find(({ stage: h }) => h === ue)) == null ? void 0 : l.tieFormat;
    u = u || f || n && ((m = c == null ? void 0 : c.tieFormat) == null ? void 0 : m.tieFormatName) === n && c.tieFormat || n && $n({ namedFormat: n, hydrateCollections: r, isMock: s, event: c }) || (c == null ? void 0 : c.tieFormat) || $n({ event: c, isMock: s, hydrateCollections: r }), d = void 0;
  } else
    d || (u = void 0, c != null && c.matchUpFormat || (d = Oi));
  if (u) {
    let f = Ar({ gender: c == null ? void 0 : c.gender, enforceGender: i, tieFormat: u });
    if (f.error)
      return f;
  }
  return { tieFormat: u, matchUpFormat: d };
}
function XL(e) {
  var U, S, D, w, v;
  let t = e.drawDefinition, { existingQualifyingPlaceholderStructureId: r, appliedPolicies: i, drawEntries: n, structureId: a, idPrefix: o, isMock: s, event: c } = e, u = e.qualifyingProfiles, d = u != null && u.length ? Hb({ uuids: e.uuids, qualifyingProfiles: u, appliedPolicies: i, idPrefix: o, isMock: s }) : void 0;
  if (d != null && d.error)
    return d;
  t.structures = (U = t.structures) == null ? void 0 : U.filter(({ structureId: P }) => P !== r), t.links = (S = t.links) == null ? void 0 : S.filter(({ source: P }) => P.structureId !== r);
  let { qualifiersCount: p, qualifyingDrawPositionsCount: l, qualifyingDetails: m } = d ?? {};
  l && (d != null && d.structures && ((D = t.structures) == null || D.push(...d.structures)), d != null && d.links && ((w = t.links) == null || w.push(...d.links)));
  let f = (v = t.structures) == null ? void 0 : v.find(({ stage: P, stageSequence: b }) => P === ue && b === 1), { qualifiersCount: h } = yc({ stageSequence: 1, drawDefinition: t, structureId: a, stage: ue }), g = Math.max(p ?? 0, h ?? 0), I = YT({ qualifiersCount: g, drawDefinition: t, stage: ue });
  if (I.error || (I = Dl({ drawSize: l, stage: ge, drawDefinition: t }), I.error))
    return I;
  ZL({ drawDefinition: t, drawEntries: n, event: c });
  let y = e_({ mainStructure: f, qualifyingDetails: m, drawDefinition: t });
  return y.error ? y : { drawDefinition: t, structureId: a };
}
function ZL({ drawDefinition: e, drawEntries: t, event: r }) {
  for (let i of (t ?? []).filter(({ entryStage: n }) => n === ge)) {
    let n = { ...i, entryStage: i.entryStage ?? ue, drawDefinition: e, event: r };
    rI(n);
  }
}
function e_({ mainStructure: e, qualifyingDetails: t, drawDefinition: r }) {
  var i;
  for (let n of t || []) {
    let { finalQualifyingRoundNumber: a, finalQualifyingStructureId: o, roundTarget: s, finishingPositions: c, linkType: u } = n, d = e && ((i = ld({ targetStructureId: e.structureId, sourceStructureId: o, sourceRoundNumber: a, finishingPositions: c, targetEntryRound: s, linkType: u })) == null ? void 0 : i.link);
    if (d != null && d.error)
      return d;
    d && (r.links || (r.links = []), r.links.push(d));
  }
  return { error: void 0 };
}
function zR(e) {
  var i, n;
  let { participantIds: t } = e, r = ((n = (i = e.drawDefinition) == null ? void 0 : i.entries) == null ? void 0 : n.filter((a) => {
    let o = a.entryStatus;
    return !e.restrictEntryStatus || $i.includes(o);
  }).map(Ce)) ?? [];
  if (t) {
    let a = t.filter((o) => !(r != null && r.includes(o)));
    if (a != null && a.length)
      return j({ result: { error: Ji }, info: { invalidParticipantIds: a } });
  } else
    t = r;
  return e.roundsCount && e.restrictRoundsCount !== !1 && e.roundsCount > t.length - 1 && (!e.enableDoubleRobin || e.roundsCount > (t.length - 1) * 2) ? { error: J, info: "Not enough participants for roundsCount" } : e.roundsCount && e.restrictRoundsCount !== !1 && e.roundsCount > 31 ? { error: J, info: "roundsCount must be less than 32" } : { participantIds: t };
}
function aU(e) {
  var p;
  let t = [], { roundsCount: r = 1, drawDefinition: i, matchUpsCount: n, structureId: a, idPrefix: o, isMock: s, event: c } = e, u, d = zR(e);
  if (d.error)
    return d;
  for (let l of oe(1, r + 1)) {
    let m = Zp({ restrictMatchUpsCount: e.restrictMatchUpsCount, ignoreLastRoundNumber: !!u, newRound: !u, drawDefinition: i, matchUpsCount: n, structureId: a, roundNumber: u, idPrefix: o, isMock: s, event: c });
    if (m.error)
      return j({ result: m, info: { iteration: l } });
    (p = m.matchUps) != null && p.length && t.push(...m.matchUps), u = ((m == null ? void 0 : m.roundNumber) ?? 1) + 1;
  }
  return { matchUps: t };
}
function t_(e) {
  var c;
  let { tournamentRecord: t, participantIds: r, scaleName: i, eventType: n, adHocRatings: a = {} } = e, o = e.scaleAccessor ?? ((c = Wt[i]) == null ? void 0 : c.accessor), s = t.participants ?? [];
  for (let u of r ?? []) {
    let d = s == null ? void 0 : s.find((l) => l.participantId === u), p = AS({ scaleName: `${i}.${fg}`, participant: d, eventType: n });
    !p && i && (p = AS({ scaleAccessor: o, participant: d, scaleName: i, eventType: n })), p && !a[u] && (a[u] = p);
  }
  return a;
}
function AS({ scaleType: e = la, scaleAccessor: t, participant: r, scaleName: i, eventType: n }) {
  var o, s;
  let a = (s = (o = r && Tn({ scaleAttributes: { eventType: n ?? ko, scaleType: e, scaleName: i }, participant: r })) == null ? void 0 : o.scaleItem) == null ? void 0 : s.scaleValue;
  return t && Le(a) ? a[t] : a;
}
function oU(e) {
  var d, p;
  let t = i_(e);
  if (t != null && t.error)
    return t;
  let r = zR(e);
  if (r.error)
    return r;
  let i = r_(e);
  if (i.error)
    return i;
  let n = t_(e), a = ((d = e.tournamentRecord) == null ? void 0 : d.isMock) ?? e.isMock, o = e.eventType ?? ((p = e.event) == null ? void 0 : p.eventType), s = [], c = [], u;
  for (let l of oe(1, (e.roundsCount ?? 1) + 1)) {
    let m = KI({ ...e, participantIds: r.participantIds, structure: i.structure, ignoreLastRoundNumber: !0, iterationMatchUps: s, adHocRatings: n, roundNumber: u, eventType: o, isMock: a });
    if (m.error)
      return m;
    let { matchUps: f, ...h } = m;
    h.modifiedScaleValues && (n = h.modifiedScaleValues), c.push({ ...h, iteration: l, matchUpsCount: f == null ? void 0 : f.length }), u = ((h == null ? void 0 : h.roundNumber) ?? 1) + 1, f != null && f.length && s.push(...f);
  }
  return { ...V, matchUps: s, roundResults: c };
}
function r_(e) {
  var n, a, o;
  if (e.structureId)
    return e.structureId;
  let t = e.drawDefinition, r = (a = (n = t == null ? void 0 : t.structures) == null ? void 0 : n.filter((s) => s.stageSequence === 1)) == null ? void 0 : a.reduce((s, c) => {
    let u = c.stage && Fo[c.stage];
    return Er({ structure: c }) && u > (Fo[s == null ? void 0 : s.stage] || 1) ? c : s;
  }, void 0), i = (o = t == null ? void 0 : t.structures) == null ? void 0 : o.find((s) => s.structureId === (r == null ? void 0 : r.structureId));
  return i ? Er({ structure: i }) ? { structure: i } : { error: Po } : { error: It };
}
function i_(e) {
  var t;
  return e.roundsCount && typeof e.roundsCount != "number" ? { error: J, info: "roundsCount must be a number" } : typeof e.drawDefinition != "object" || e.drawDefinition.drawType && e.drawDefinition.drawType !== si ? { error: Po } : !Array.isArray((t = e.drawDefinition) == null ? void 0 : t.entries) && e.participantIds && !Array.isArray(e.participantIds) ? { error: J, info: "Missing Entries" } : { error: void 0 };
}
function n_(e) {
  var d, p;
  let { tournamentRecord: t, drawDefinition: r, structureId: i, idPrefix: n, isMock: a, event: o } = e, s = (d = o == null ? void 0 : o.entries) == null ? void 0 : d.filter(({ entryStage: l, entryStatus: m }) => (!l || l === ue) && m && $i.includes(m)), c = s == null ? void 0 : s.map(Ce), u = s ? Math.floor(s.length / 2) : 0;
  if (e.automated)
    return a_({ ...e, participantIds: c });
  {
    let l = aU({ roundsCount: e.roundsCount, drawDefinition: r, matchUpsCount: u, idPrefix: n, isMock: a, event: o });
    if (l.error)
      return l;
    (p = l.matchUps) != null && p.length && Kp({ matchUps: l.matchUps, suppressNotifications: !0, tournamentRecord: t, drawDefinition: r, structureId: i, event: o });
  }
  return { ...V };
}
function a_(e) {
  var c, u;
  let { restrictEntryStatus: t, generateMatchUps: r, structureId: i, matchUpIds: n, scaleName: a, scaleAccessor: o } = e.drawMatic ?? {}, s = oU({ ...e, eventType: ((c = e.drawMatic) == null ? void 0 : c.eventType) ?? e.matchUpType, generateMatchUps: r ?? !0, scaleAccessor: o ?? e.scaleAccessor, scaleName: a ?? e.scaleName, participantIds: e.participantIds, roundsCount: e.roundsCount, restrictEntryStatus: t, structureId: i, matchUpIds: n });
  return s.error ? s : ((u = s == null ? void 0 : s.matchUps) != null && u.length && Kp({ tournamentRecord: e.tournamentRecord, drawDefinition: e.drawDefinition, suppressNotifications: !0, matchUps: s.matchUps, event: e.event, structureId: i }), { ...V });
}
function o_({ requireParticipantCount: e = !0, enforcePolicyLimits: t = !0, drawSizeProgression: r, participantsCount: i, participantCount: n, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structureId: c, seedsCount: u }) {
  var y, U;
  i = i ?? n;
  let d = ve({ drawDefinition: o, structureId: c });
  if (d.error)
    return d;
  let p = d.structure;
  if (!p)
    return { error: It };
  let { positionAssignments: l } = Yt({ structure: p }), m = (l == null ? void 0 : l.length) || 0;
  if (u > m)
    return { error: Lv };
  let f = (y = p.structures) == null ? void 0 : y.length, h = Pe(s == null ? void 0 : s.groupSeedingThreshold) && (s == null ? void 0 : s.groupSeedingThreshold), g = (U = lI({ roundRobinGroupsCount: f, drawSize: m })) == null ? void 0 : U.seedGroups, { seedsCount: I } = vd({ policyDefinitions: a, requireParticipantCount: e, drawSizeProgression: r, participantsCount: i, drawSize: m });
  return I && (a != null && a[Mi]) && u > I && t && (u = I), p.seedLimit = u, p.seedAssignments = oe(1, u + 1).map((S) => {
    let D = g == null ? void 0 : g.find((P) => P.includes(S)), w = D && Math.min(...D), v = h && S >= h ? w : S;
    return { participantId: void 0, seedNumber: S, seedValue: v };
  }), ut({ drawDefinition: o, structureIds: [c] }), { ...V, seedLimit: u };
}
function fs({ sortDescending: e = !1, tournamentRecord: t, scaleAttributes: r, scaleSortMethod: i, stageSequence: n, entries: a, event: o, stage: s }) {
  if (!t)
    return { error: ae };
  return a = a ?? (o == null ? void 0 : o.entries) ?? [], { scaledEntries: a.filter((d) => (!s || !d.entryStage || d.entryStage === s) && (!n || !d.entryStageSequence || d.entryStageSequence === n) && $i.includes(d.entryStatus)).map((d) => {
    let { participantId: p } = d, { scaleItem: l } = Qs({ tournamentRecord: t, scaleAttributes: r, participantId: p });
    return { ...d, ...l };
  }).filter((d) => {
    let p = d.scaleValue;
    return !i && (isNaN(p) || !parseFloat(p)) ? !1 : p;
  }).sort(i || c) };
  function c(d, p) {
    return e ? u(p) - u(d) : u(d) - u(p);
  }
  function u(d) {
    return parseFloat(d.scaleValue || (e ? -1 : 1e5));
  }
}
function YR(e) {
  let t = "prepareStage", { drawDefinition: r } = e, { structures: i } = Bi({ stageSequence: e.stageSequence || 1, roundTarget: e.roundTarget, stage: e.stage, drawDefinition: r }), n = e.preparedStructureIds || [], a = i == null ? void 0 : i.find(({ structureId: m }) => !n.includes(m));
  if (!a)
    return j({ result: { error: It }, stack: t });
  let o = a == null ? void 0 : a.structureId, { seedsCount: s, stageEntries: c, seedLimit: u } = f_({ ...e, structureId: o });
  (e.seededParticipants || e.event || e.seedingScaleName) && u_({ ...e, seedsCount: s, structure: a, structureId: o });
  let d = e.automated !== !1 && e.drawType !== si && !(e.qualifyingOnly && e.stage !== ge), p = ((i == null ? void 0 : i.length) || 0) > 1, l = d ? c_({ ...e, multipleStructures: p, seedLimit: u, structureId: o }) : {};
  return l != null && l.error ? j({ result: l, stack: t }) : { ...l, stageEntries: c, structureId: o, seedsCount: s };
}
function s_({ entries: e, stage: t, stageSequence: r, roundTarget: i }) {
  return e.filter((n) => {
    var o, s;
    let a = (s = (o = Ne({ name: In, element: n })) == null ? void 0 : o.extension) == null ? void 0 : s.value;
    return (!n.entryStage || n.entryStage === t) && (!r || !n.entryStageSequence || n.entryStageSequence === r) && (!i || !a || a === i) && mo.includes(n.entryStatus);
  });
}
function c_(e) {
  let t = typeof e.automated == "object" && e.automated.seedsOnly, r = dd({ ...e, seedsOnly: t });
  if (r.error)
    return r;
  let i = r == null ? void 0 : r.positionAssignments, n = r == null ? void 0 : r.positioningReport;
  return { conflicts: r.conflicts, positionAssignments: i, positioningReport: n };
}
function u_(e) {
  let { seededParticipants: t, seedingScaleName: r, entries: i, event: n } = e, a = i.map(Ce);
  t ? d_({ ...e, enteredParticipantIds: a }) : (n || r) && l_({ ...e, enteredParticipantIds: a });
}
function d_(e) {
  let { provisionalPositioning: t, enteredParticipantIds: r, seededParticipants: i, tournamentRecord: n, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structureId: c, structure: u, event: d } = e, p = u ? ls({ provisionalPositioning: t, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structure: u }) : void 0;
  i.filter(({ participantId: l }) => r.includes(l)).filter((l) => !l.seedNumber || l.seedNumber <= i.length).sort((l, m) => l.seedNumber < m.seedNumber ? -1 : l.seedNumber < m.seedNumber ? 1 : 0).forEach((l) => {
    let { participantId: m, seedNumber: f, seedValue: h } = l;
    vc({ provisionalPositioning: t, tournamentRecord: n, drawDefinition: o, seedingProfile: s, participantId: m, seedBlockInfo: p, structureId: c, seedNumber: f, seedValue: h, event: d });
  });
}
function l_(e) {
  let t = e.seedsCount, { provisionalPositioning: r, enteredParticipantIds: i, seedAssignmentProfile: n, assignSeedsCount: a, tournamentRecord: o, drawDefinition: s, seedByRanking: c, seedingProfile: u, structureId: d, event: p } = e, { categoryName: l, ageCategoryCode: m } = (p == null ? void 0 : p.category) || {}, f = p == null ? void 0 : p.eventType, h = p_({ ...e, ageCategoryCode: m, categoryName: l, eventType: f }) || c && m_({ ...e, ageCategoryCode: m, categoryName: l, eventType: f }), g = (h == null ? void 0 : h.length) ?? 0;
  g < t && (t = g), h == null || h.filter(({ participantId: I }) => i.includes(I)).slice(0, a || t).forEach((I, y) => {
    let U = y + 1, { participantId: S, scaleValue: D } = I, w = (n == null ? void 0 : n[U]) || D || U;
    vc({ provisionalPositioning: r, tournamentRecord: o, drawDefinition: s, seedingProfile: u, participantId: S, structureId: d, seedNumber: U, seedValue: w, event: p });
  });
}
function p_(e) {
  let { tournamentRecord: t, seedingScaleName: r, stageSequence: i, entries: n, stage: a, event: o } = e, { categoryName: s, ageCategoryCode: c } = (o == null ? void 0 : o.category) || {}, u = o == null ? void 0 : o.eventType, d = { scaleName: r || s || c || o.eventId, scaleType: Pn, eventType: u };
  return fs({ scaleAttributes: d, tournamentRecord: t, stageSequence: i, entries: n, stage: a }).scaledEntries;
}
function m_(e) {
  let { tournamentRecord: t, stageSequence: r, event: i, entries: n, stage: a } = e, { categoryName: o, ageCategoryCode: s } = (i == null ? void 0 : i.category) || {}, c = i == null ? void 0 : i.eventType;
  return fs({ scaleAttributes: { scaleName: o || s, scaleType: ha, eventType: c }, tournamentRecord: t, stageSequence: r, entries: n, stage: a }).scaledEntries;
}
function f_(e) {
  let { seedsCount: t } = e;
  e.seededParticipants && (t = e.seededParticipants.length), t > e.drawSize && (t = e.drawSize);
  let r = s_(e);
  t > r.length && (t = r.length);
  let { seedLimit: i } = o_({ enforcePolicyLimits: e.enforcePolicyLimits ?? !0, appliedPolicies: e.appliedPolicies, participantsCount: r.length, seedingProfile: e.seedingProfile, drawDefinition: e.drawDefinition, structureId: e.structureId, seedsCount: t });
  return i && i < t && (t = i), { seedsCount: t, stageEntries: r, seedLimit: i };
}
function h_(e) {
  var S;
  let t = zI({ ...e, modifyOriginal: !1 });
  if (t.error)
    return t;
  let r = t.drawDefinition, { suppressDuplicateEntries: i = !0, ignoreStageSpace: n, appliedPolicies: a, qualifyingOnly: o, seedingProfile: s, participants: c, drawEntries: u, placeByes: d, drawSize: p, drawType: l, entries: m } = e, f = [], h = [], g = g_({ suppressDuplicateEntries: i, ignoreStageSpace: n, drawDefinition: r, drawEntries: u, drawType: l, entries: m });
  if (g.error)
    return g;
  let I = l === so ? 0 : ye(e.seedsCount ?? 0), y = YR({ ...e, qualifyingOnly: !p || o, appliedPolicies: a, drawDefinition: r, seedingProfile: s, participants: c, stage: ue, seedsCount: I, placeByes: d, drawSize: p, entries: m });
  if (y.error && !y.conflicts)
    return y;
  (S = y.positioningReport) != null && S.length && f.push({ [ue]: y.positioningReport });
  let U = y.structureId;
  return y.conflicts && (h = y.conflicts), l === si && e.roundsCount && n_({ ...e, drawDefinition: r, structureId: U }), { drawDefinition: r, positioningReports: f, conflicts: h, structureId: U };
}
function g_(e) {
  let { ignoreStageSpace: t, drawDefinition: r, drawEntries: i, drawType: n, entries: a } = e;
  for (let o of a) {
    if (i && o.entryStage && o.entryStage !== ue)
      continue;
    let s = { ...o, ignoreStageSpace: t ?? n === si, entryStage: o.entryStage ?? ue, event: e.event, drawDefinition: r, drawType: n }, c = rI(s);
    if (i && c.error)
      return c;
  }
  return { error: void 0 };
}
var I_ = () => ({ matchUpType: void 0, drawName: void 0, drawId: void 0, structures: [], entries: [], links: [] }), U_ = I_;
function y_(e) {
  let { drawId: t = ze(), processCodes: r, matchUpType: i, drawType: n } = e ?? {}, a = U_();
  return Object.assign(a, { processCodes: r, matchUpType: i, drawType: n, drawId: t });
}
function sU(e) {
  let t = e.structureIds, { tournamentRecord: r, drawDefinition: i, matchUpFormat: n, structureId: a, matchUpId: o, event: s } = e, c = fe(e, [{ [Rr]: !0, [cg]: !0 }]);
  if (c.error)
    return c;
  if (!Jr({ matchUpFormat: n }))
    return { error: bu };
  let u = "setMatchUpFormat";
  if (o) {
    let d = ft({ drawDefinition: i, matchUpId: o, event: s });
    if (d.error)
      return d;
    let p = d.matchUp;
    if ((p == null ? void 0 : p.matchUpType) === xt)
      return { info: "Cannot set matchUpFormat when { matchUpType: TEAM }", error: jr };
    p && (p.matchUpFormat = n, xe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: s == null ? void 0 : s.eventId, context: u, drawDefinition: i, matchUp: p }));
  } else if (Array.isArray(t)) {
    if ((s == null ? void 0 : s.eventType) === xt)
      return { error: Mn };
    for (let d of t) {
      let p = ve({ drawDefinition: i, structureId: d });
      if (p.error)
        return p;
      p.structure && (p.structure.matchUpFormat = n);
    }
  } else if (a) {
    if ((s == null ? void 0 : s.eventType) === xt)
      return { error: Mn };
    let d = ve({ drawDefinition: i, structureId: a });
    if (d.error)
      return d;
    d.structure && (d.structure.matchUpFormat = n);
  } else
    i && (i.matchUpFormat = n);
  return t = t ?? (a ? [a] : void 0), ut({ drawDefinition: i, structureIds: t }), { ...V };
}
function S_({ tieFormat: e }) {
  let t = Ar({ checkCollectionIds: !1, tieFormat: e });
  if (t.error)
    return t;
  for (let r of e.collectionDefinitions)
    r.collectionId || (r.collectionId = ze());
  return { tieFormat: e };
}
function v_({ tournamentRecord: e, drawDefinition: t, matchUpFormat: r, matchUpType: i, tieFormat: n, event: a }) {
  if ((r || n) && !(r && (a == null ? void 0 : a.matchUpFormat) === r || a != null && a.tieFormat && n && JSON.stringify(a.tieFormat) === JSON.stringify(n))) {
    if (n) {
      let o = S_({ tieFormat: n });
      if (o.error)
        return o;
      t.tieFormat = o.tieFormat ?? n;
    } else if (r) {
      let o = sU({ tournamentRecord: e, drawDefinition: t, matchUpFormat: r, event: a });
      if (o.error)
        return { info: "matchUpFormat or tieFormat error", error: o.error };
    }
    i && (t.matchUpType = i);
  }
  return { error: void 0 };
}
var KR = {};
Ae(KR, { attachPolicies: () => Za, findPolicy: () => lo, getAppliedPolicies: () => je, getPolicyDefinitions: () => ra, mutate: () => QR, query: () => XR, removePolicy: () => JR });
var QR = {};
Ae(QR, { attachPolicies: () => Za, removePolicy: () => JR });
function JR(e) {
  let t = fe(e, [{ [b1]: !0, _anyOf: { [gr]: !1, [Gt]: !1, [Rr]: !1, [ba]: !1 } }]);
  if (t.error)
    return t;
  let r, i = e.drawDefinition ?? e.event ?? ((e.tournamentId || !e.tournamentRecords) && e.tournamentRecord);
  if (i)
    return ES(e, i);
  if (e.tournamentRecords) {
    let n = Object.keys(e.tournamentRecords);
    if (!n.length)
      return { error: ae };
    for (let a of n) {
      let o = e.tournamentRecords[a], s = ES(e, o);
      if (s.error)
        return s;
      r = !0;
    }
  } else
    return { error: ae };
  return r ? { ...V } : { error: Do };
}
function ES(e, t) {
  let r = je(e).appliedPolicies ?? {};
  return r[e.policyType] ? (delete r[e.policyType], Object.keys(r).length ? Ve({ element: t, extension: { name: su, value: r } }) : Sr({ element: t, name: su }), { ...V }) : { error: Do };
}
var XR = {};
Ae(XR, { findPolicy: () => lo, getAppliedPolicies: () => je, getPolicyDefinitions: () => ra });
var ZR = { [Mi]: { validSeedPositions: { ignore: !0 }, duplicateSeedNumbers: !0, drawSizeProgression: !0, seedingProfile: { drawTypes: { [En]: { positioning: qa }, [Li]: { positioning: qa } }, positioning: g1 }, policyName: "USTA SEEDING", seedsCountThresholds: [{ drawSize: 4, minimumParticipantCount: 3, seedsCount: 2 }, { drawSize: 16, minimumParticipantCount: 12, seedsCount: 4 }, { drawSize: 32, minimumParticipantCount: 24, seedsCount: 8 }, { drawSize: 64, minimumParticipantCount: 48, seedsCount: 16 }, { drawSize: 128, minimumParticipantCount: 96, seedsCount: 32 }, { drawSize: 256, minimumParticipantCount: 192, seedsCount: 64 }] } }, ah = ZR;
function w_({ appliedPolicies: e, policyDefinitions: t, drawDefinition: r, stack: i }) {
  if (t && typeof t != "object")
    return j({ info: "policyDefinitions must be an object", result: { error: J }, stack: i });
  let n = { [ou]: e == null ? void 0 : e[ou] };
  return t ? P_({ policyDefinitions: t, appliedPolicies: e, policiesToAttach: n, drawDefinition: r }) : n.avoidance && Za({ drawDefinition: r, policyDefinitions: n }), !(e != null && e[Mi]) && !(t != null && t[Mi]) && (Za({ policyDefinitions: ah, drawDefinition: r }), e && Object.assign(e, ah)), { error: void 0 };
}
function P_({ policyDefinitions: e, appliedPolicies: t, policiesToAttach: r, drawDefinition: i }) {
  for (let n of Object.keys(e))
    JSON.stringify(t == null ? void 0 : t[n]) !== JSON.stringify(e[n]) && (r[n] = e[n]);
  Object.keys(r).length && (Za({ policyDefinitions: r, drawDefinition: i }), t && Object.assign(t, r));
}
function D_(e) {
  var I, y, U, S, D;
  let { tournamentRecord: t, matchUpFormat: r, appliedPolicies: i, policyDefinitions: n, matchUpType: a, tieFormat: o, drawType: s, stack: c, event: u } = e, d = e.drawId ? (I = u == null ? void 0 : u.drawDefinitions) == null ? void 0 : I.find((w) => w.drawId === e.drawId) : void 0;
  d && s !== d.drawType && (d.drawType = s);
  let p = d ?? y_({ processCodes: e.processCodes, drawId: e.drawId, drawType: s }), l = v_({ tournamentRecord: t, drawDefinition: p, matchUpFormat: r, matchUpType: a, tieFormat: o, event: u });
  if (l.error)
    return j({ result: l, stack: c });
  let m = w_({ appliedPolicies: i, policyDefinitions: n, drawDefinition: p, stack: c });
  if (m.error)
    return m;
  let f = (U = (y = d == null ? void 0 : d.structures) == null ? void 0 : y.find((w) => w.stage === ue && w.stageSequence === 1)) == null ? void 0 : U.structureId, h = d ? (S = d.structures) == null ? void 0 : S.filter((w) => w.stage === ge) : [], g = (h == null ? void 0 : h.length) === 1 && !((D = h[0].matchUps) != null && D.length) && h[0].structureId;
  return { drawDefinition: p, structureId: f, existingDrawDefinition: d, existingQualifyingPlaceholderStructureId: g };
}
function T_(e) {
  var d, p;
  let t = "generateOrGetExisting", r = [], i = [], n = D_(e);
  if (n.error)
    return j({ result: n, stack: t });
  let a = n.existingDrawDefinition, o = n.drawDefinition ?? {}, s = n.structureId, c = e.drawEntries ?? e.eventEntries ?? [], u = n.existingQualifyingPlaceholderStructureId && XL({ ...e, ...n }) || h_({ ...e, ...n, entries: c });
  return u.error ? j({ result: u, stack: t }) : ((d = u.positioningReports) != null && d.length && r.push(...u.positioningReports ?? []), (p = u.conflicts) != null && p.length && i.push(...u.conflicts ?? []), o = u.drawDefinition, s = u.structureId, { existingDrawDefinition: a, positioningReports: r, drawDefinition: o, structureId: s, conflicts: i, entries: c });
}
function b_(e) {
  var h, g, I;
  let { qualifyingPlaceholder: t, qualifyingProfiles: r, existingDrawDefinition: i, positioningReports: n, appliedPolicies: a, qualifyingOnly: o, drawDefinition: s, seedingProfile: c, participants: u, structureId: d, entries: p, stack: l } = e, m = t && !(r != null && r.length) && !i, f = [];
  if (r) {
    let y = (w, v) => w.stageSequence - v.stageSequence, U = (w, v) => w.roundTarget - v.roundTarget, S = [], D = 1;
    r.sort(U);
    for (let w of r) {
      if (!Array.isArray(w.structureProfiles))
        return j({ info: Xa("structureProfiles"), result: { error: Ie }, stack: l });
      D = w.roundTarget || D;
      let v = ((h = w.structureProfiles) == null ? void 0 : h.sort(y)) || [], P = 1;
      for (let b of v) {
        let { qualifyingRoundNumber: T, qualifyingPositions: R, seededParticipants: M, seedingScaleName: E, seedsCount: C = 0, seedByRanking: A, placeByes: N, drawSize: O } = b, k = YR({ ...e, seedingProfile: b.seedingProfile ?? c, stageSequence: P, qualifyingRoundNumber: T, preparedStructureIds: S, qualifyingPositions: R, seededParticipants: M, stage: ge, seedingScaleName: E, appliedPolicies: a, drawDefinition: s, qualifyingOnly: o, seedByRanking: A, participants: u, roundTarget: D, seedsCount: C, placeByes: N, drawSize: O, entries: p });
        if (k.error)
          return k;
        k.structureId && S.push(k.structureId), P += 1, (g = k.conflicts) != null && g.length && f.push(...k.conflicts), (I = k.positioningReport) != null && I.length && n.push({ [ge]: k.positioningReport });
      }
      D += 1;
    }
  } else if (d && m) {
    let y = gi({ structureName: dr(ge), stage: ge }), { link: U } = ld({ sourceStructureId: y.structureId, targetStructureId: d, sourceRoundNumber: 0, linkType: Wn });
    s.structures || (s.structures = []), s.structures.push(y), s.links || (s.links = []), s.links.push(U);
  }
  return { qualifyingConflicts: f, error: void 0 };
}
var eM = {};
Ae(eM, { addGoesTo: () => Ja, allCompetitionMatchUps: () => en, allDrawMatchUps: () => vr, allEventMatchUps: () => Ln, allPlayoffPositionsFilled: () => UI, allTournamentMatchUps: () => tr, analyzeDraws: () => yd, analyzeMatchUp: () => Uu, analyzeTournament: () => IU, bulkUpdatePublishedEventIds: () => SU, calculateWinCriteria: () => gs, categoryCanContain: () => Eu, checkMatchUpIsComplete: () => ja, checkValidEntries: () => Xp, compareTieFormats: () => Xn, competitionScheduleMatchUps: () => Rd, courtGridRows: () => Im, credits: () => R_, drawMatchUps: () => kU, eventMatchUps: () => Sm, filterMatchUps: () => Vn, filterParticipants: () => ad, findDrawDefinition: () => GI, findExtension: () => Ne, findVenue: () => xn, getAggregateTeamResults: () => gU, getAllDrawMatchUps: () => Bt, getAllEventData: () => vU, getAllStructureMatchUps: () => Ke, getAllowedDrawTypes: () => sm, getAllowedMatchUpFormats: () => mU, getAppliedPolicies: () => je, getAssignedParticipantIds: () => ho, getAvailableMatchUpsCount: () => Qp, getAvailablePlayoffProfiles: () => pd, getCategoryAgeDetails: () => Oo, getCheckedInParticipantIds: () => as, getCompetitionDateRange: () => um, getCompetitionMatchUps: () => Iu, getCompetitionParticipants: () => cU, getCompetitionPenalties: () => fU, getCompetitionVenues: () => Pd, getCourtInfo: () => Op, getCourts: () => FU, getDrawData: () => lm, getDrawDefinitionTimeItem: () => Vg, getDrawParticipantRepresentativeIds: () => VI, getDrawStructures: () => Bi, getDrawTypeCoercion: () => Sd, getEligibleVoluntaryConsolationParticipants: () => BI, getEntriesAndSeedsCount: () => Um, getEvent: () => _U, getEventData: () => pm, getEventMatchUpFormatTiming: () => TU, getEventProperties: () => xU, getEventPublishStatus: () => bi, getEventStructures: () => jp, getEventTimeItem: () => Gu, getEvents: () => LU, getFlightProfile: () => Pt, getHomeParticipantId: () => NU, getLinkedTournamentIds: () => Bu, getMatchUpCompetitiveProfile: () => Ju, getMatchUpContextIds: () => AU, getMatchUpDailyLimits: () => wm, getMatchUpDailyLimitsUpdate: () => bU, getMatchUpDependencies: () => qi, getMatchUpFormat: () => EU, getMatchUpFormatTiming: () => Xu, getMatchUpFormatTimingUpdate: () => DU, getMatchUpScheduleDetails: () => kp, getMatchUpType: () => Fp, getMatchUpsMap: () => mr, getMatchUpsStats: () => CU, getMatchUpsToSchedule: () => mm, getMaxEntryPosition: () => PU, getModifiedMatchUpFormatTiming: () => ym, getPairedParticipant: () => Vi, getParticipantEventDetails: () => uU, getParticipantIdFinishingPositions: () => jI, getParticipantMembership: () => dU, getParticipantResults: () => hd, getParticipantScaleItem: () => Qs, getParticipantSchedules: () => lU, getParticipantSignInStatus: () => pU, getParticipantTimeItem: () => jg, getParticipants: () => Ut, getPersonRequests: () => Uo, getPolicyDefinitions: () => ra, getPositionAssignments: () => fu, getPositionsPlayedOff: () => Pc, getPredictiveAccuracy: () => MU, getProfileRounds: () => gm, getPublishState: () => us, getRoundMatchUps: () => Pr, getRounds: () => OU, getScaleValues: () => pc, getScaledEntries: () => fs, getScheduledRoundsDetails: () => Dd, getSchedulingProfile: () => oa, getSchedulingProfileIssues: () => wU, getSeedingThresholds: () => pI, getSeedsCount: () => vd, getStructureSeedAssignments: () => Si, getTeamLineUp: () => Qa, getTieFormat: () => yU, getTimeItem: () => Pi, getTournamentIds: () => Lu, getTournamentInfo: () => hs, getTournamentPenalties: () => cm, getTournamentPersons: () => hU, getTournamentPoints: () => dm, getTournamentPublishStatus: () => nd, getTournamentStructures: () => II, getTournamentTimeItem: () => Mp, getValidGroupSizes: () => cd, getVenueData: () => zs, getVenuesAndCourts: () => aa, isAdHoc: () => Er, isCompletedStructure: () => wa, isValidForQualifying: () => WI, isValidMatchUpFormat: () => Jr, matchUpActions: () => Jp, participantScaleItem: () => Tn, participantScheduledMatchUps: () => RU, positionActions: () => qI, publicFindCourt: () => Xg, publicFindVenue: () => Jg, tallyParticipantResults: () => Dc, tieFormatGenderValidityCheck: () => ap, tournamentMatchUps: () => vm, validMatchUp: () => Np, validMatchUps: () => Ti, validateCollectionDefinition: () => Cu, validateLineUp: () => Vp });
function R_() {
  return `
    This project would not have been possible without the generous input and patience
    of tournament organizers and directors who worked with early versions of CourtHive/TMX.

    Thanks to Pavel, Ivan, Mladen, Zdenko, Antonia, Jakov, Kreso, Barry, Jeff, Bobby... to name just a few. 

    The project would not have even begun without the support of Miro, or the introduction by Sretchko.
    The project would not have succeeded without the enthusiasm of Randy and Bruce.
    Thanks to serendipity and Luca and the ensuing TODS conversations with ITF.
    Thanks to Scott and Jake for sanity checks, suggestions, and camaraderie.
    Thanks to Zoran for inspiring the async support and getting into the weeds with subscriptions.
    Thanks to Dave for backing the conversion of TMX 1.x source into the factory repository.
    Thanks to Vuk and Pavle and Rich and Chris and Deepa for the direct engagement with the APIs.
    Thanks to Joe for repeatedly challenging me and the many pointers to useful tooling.
    Thanks to Shannon for the validation of the approach from his deep domain experience.
    Thanks to Nikola for the ongoing camaraderie and explorations of what we can do with TODS.

    And a special thanks to my family for putting up with the long days and weeks and months of coding
    and conversations at all hours.
  `;
}
var tM = {};
Ae(tM, { filterParticipants: () => ad, getCompetitionParticipants: () => cU, getPairedParticipant: () => Vi, getParticipantEventDetails: () => uU, getParticipantMembership: () => dU, getParticipantScaleItem: () => Qs, getParticipantSchedules: () => lU, getParticipantSignInStatus: () => pU, getParticipantTimeItem: () => jg, getParticipants: () => Ut, getScaleValues: () => pc, participantScaleItem: () => Tn, validateLineUp: () => Vp });
function cU(e) {
  let { tournamentRecords: t } = e || {};
  if (typeof t != "object" || !Object.keys(t).length)
    return { error: yt };
  let r = [], i = {}, n = {}, a = {}, o = [], s = {}, c = [];
  for (let u of Object.values(t)) {
    let { participantIdsWithConflicts: d, mappedMatchUps: p, participantMap: l, participants: m, matchUps: f, derivedEventInfo: h, derivedDrawInfo: g } = Ut({ ...e, tournamentRecord: u });
    Object.assign(s, p), Object.assign(i, l), Object.assign(n, h), Object.assign(a, g), r.push(...m ?? []), o.push(...f ?? []), d == null || d.forEach((I) => {
      c.includes(I) || c.push(I);
    });
  }
  return { participantIdsWithConflicts: c, derivedEventInfo: n, derivedDrawInfo: a, participantMap: i, mappedMatchUps: s, participants: r, ...V, matchUps: o };
}
function uU({ tournamentRecord: e, participantId: t }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: _t };
  let r = [t].concat((e.participants ?? []).filter((i) => {
    var n;
    return (i == null ? void 0 : i.participantType) && [Xe, Re].includes(i.participantType) && ((n = i.individualParticipantIds) == null ? void 0 : n.includes(t));
  }).map((i) => i.participantId));
  return { eventDetails: (e.events ?? []).filter((i) => {
    let n = ((i == null ? void 0 : i.entries) ?? []).map((a) => a.participantId);
    return wr(n, r);
  }).map((i) => ({ eventName: i.eventName, eventId: i.eventId })) };
}
function dU({ tournamentRecord: e, participantId: t }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: _t };
  let { participants: r } = Ut({ participantFilters: { participantTypes: [Xe, Re, di] }, tournamentRecord: e });
  return (r ?? []).filter((i) => {
    var n;
    return (n = i.individualParticipantIds) == null ? void 0 : n.includes(t);
  }).reduce((i, n) => {
    let a = n.participantType;
    return a && (i[a] || (i[a] = []), i[a].push(n)), i;
  }, {});
}
function lU({ participantFilters: e = {}, tournamentRecord: t }) {
  if (!t)
    return { error: ae };
  if (typeof e != "object")
    return { error: ea, context: { participantFilters: e } };
  let r = { eventIds: e.eventIds }, i = tr({ tournamentRecord: t, contextFilters: r }).matchUps ?? [], n = Object.assign({}, ...i.map((c) => ({ [c.matchUpId]: c }))), a = i.filter(({ schedule: c }) => c && Object.keys(c).length), o = qi({ tournamentRecord: t, matchUps: i }).sourceMatchUpIds ?? [], s = {};
  for (let c of a) {
    let { sides: u } = c, d, p = (u == null ? void 0 : u.map((m) => {
      if (m.participant)
        return [m.participant].concat(...m.participant.individualParticipants || []);
      o[c.matchUpId] && !d && (d = (o[c.matchUpId] || []).map((f) => n[f]).filter(({ winningSide: f, bye: h }) => !f && !h));
    }).filter(Boolean).flat()) ?? [];
    for (let m of p) {
      let { participantId: f } = m;
      s[f] || (s[f] = { potentialMatchUps: [], participant: m, matchUps: [] }), s[f].matchUps.push(c);
    }
    let l = (d == null ? void 0 : d.map(({ sides: m }) => m).flat().map(({ participant: m }) => m && [m].concat(...m.individualParticipants || [])).filter(Boolean).flat()) || [];
    for (let m of l) {
      let { participantId: f } = m;
      s[f] || (s[f] = { potentialMatchUps: [], participant: m, matchUps: [] }), s[f].potentialMatchUps.push(c);
    }
  }
  return { participantSchedules: Object.values(s).filter(({ participant: c }) => !(e.participantIds && !e.participantIds.includes(c.participantId) || e.participantTypes && !e.participantTypes.includes(c.participantType))), ...V };
}
function pU({ tournamentRecord: e, participantId: t }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: _t };
  let { participant: r } = Aa({ tournamentRecord: e, participantId: t });
  if (!r)
    return { error: Dt };
  let { timeItem: i } = Pi({ itemType: ju, element: r });
  return i && i.itemValue === uu && uu;
}
var rM = {};
Ae(rM, { analyzeDraws: () => yd, analyzeTournament: () => IU, getAggregateTeamResults: () => gU, getAllowedDrawTypes: () => sm, getAllowedMatchUpFormats: () => mU, getAppliedPolicies: () => je, getCompetitionDateRange: () => um, getCompetitionPenalties: () => fU, getPolicyDefinitions: () => ra, getTournamentInfo: () => hs, getTournamentPenalties: () => cm, getTournamentPersons: () => hU, getTournamentPoints: () => dm, getTournamentStructures: () => II, getTournamentTimeItem: () => Mp });
function mU({ tournamentRecord: e, categoryName: t, categoryType: r }) {
  var n;
  if (!e)
    return { error: ae };
  let { appliedPolicies: i } = je({ tournamentRecord: e });
  return (((n = i == null ? void 0 : i[yi]) == null ? void 0 : n.matchUpFormats) || []).filter(({ categoryNames: a, categoryTypes: o }) => !t && !o || t && (a == null ? void 0 : a.includes(t)) || r && (o == null ? void 0 : o.includes(r)));
}
function sm({ tournamentRecord: e, categoryName: t, categoryType: r }) {
  var n;
  if (!e)
    return { error: ae };
  let { appliedPolicies: i } = je({ tournamentRecord: e });
  return (((n = i == null ? void 0 : i[pl]) == null ? void 0 : n.allowedDrawTypes) || []).filter(({ categoryNames: a, categoryTypes: o }) => !t && !o || t && (a == null ? void 0 : a.includes(t)) || r && (o == null ? void 0 : o.includes(r)));
}
function cm({ tournamentRecord: e }) {
  if (!e)
    return { error: ae };
  let t = ((e == null ? void 0 : e.participants) ?? []).reduce((r, i) => {
    let { participantId: n } = i;
    return (i.penalties ?? []).forEach((a) => {
      let { penaltyId: o } = a || {};
      r[o] ? r[o].participants.push(n) : r[o] = { ...a, participantIds: [n] };
    }), r;
  }, {});
  return { penalties: Object.values(t) };
}
function fU({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length)
    return { error: yt };
  let t = [];
  for (let r of Object.values(e)) {
    let { penalties: i } = cm({ tournamentRecord: r });
    t.push(...i ?? []);
  }
  return { penalties: t };
}
function iM({ event: e }) {
  return { eventInfo: (({ eventId: t, eventName: r, eventType: i, eventLevel: n, surfaceCategory: a, matchUpFormat: o, category: s, gender: c, startDate: u, endDate: d, ballType: p, discipline: l, onlineResources: m, notes: f }) => ({ eventId: t, eventName: r, eventType: i, eventLevel: n, surfaceCategory: a, matchUpFormat: o, category: s, gender: c, startDate: u, endDate: d, ballType: p, discipline: l, onlineResources: m, notes: f }))(e) };
}
var M_ = { [mc]: { policyName: "Staff Privacy Policy", participant: { contacts: !1, individualParticipants: !1, individualParticipantIds: !1, onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantRoleResponsibilities: !0, participantStatus: !0, penalties: !1, representing: !0, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } } } }, N_ = M_;
function hs(e) {
  var s, c, u, d;
  let { tournamentRecord: t } = e ?? {};
  if (!t)
    return { error: ae };
  let r = (({ tournamentId: p, tournamentRank: l, tournamentStatus: m, formalName: f, tournamentName: h, promotionalName: g, onlineResources: I, localTimeZone: y, activeDates: U, startDate: S, endDate: D, hostCountryCode: w, venues: v, notes: P, updatedAt: b }) => ({ tournamentId: p, tournamentRank: l, tournamentStatus: m, formalName: f, tournamentName: h, promotionalName: g, onlineResources: I, localTimeZone: y, activeDates: U, startDate: S, endDate: D, hostCountryCode: w, venues: v, notes: P, updatedAt: b }))(t), i = ((s = Ut({ participantFilters: { participantRoles: [fT, nI, hT, gT, UT] }, policyDefinitions: N_, tournamentRecord: t })) == null ? void 0 : s.participants) ?? [];
  i && (r.tournamentContacts = i);
  let n = (c = us({ tournamentRecord: t })) == null ? void 0 : c.publishState, a = ((d = (u = n == null ? void 0 : n.tournament) == null ? void 0 : u.status) == null ? void 0 : d.publishedEventIds) || [], o = [];
  for (let p of t.events ?? [])
    if (!(e != null && e.usePublishState) || a.includes(p.eventId)) {
      let l = iM({ event: p }).eventInfo;
      l && o.push(l);
    }
  return r.timeItemValues = Pb({ element: t }), r.publishState = n == null ? void 0 : n.tournament, r.eventInfo = o, { tournamentInfo: ce(me(r), !1, !0), ...V };
}
function um({ tournamentRecords: e }) {
  if (!Le(e))
    return { error: yt };
  let t = Object.keys(e ?? {}).reduce((n, a) => {
    let o = e[a], { tournamentInfo: { startDate: s, endDate: c } } = hs({ tournamentRecord: o }), u = s && new Date(be(s));
    (!n.startDate || u && u < n.startDate) && (n.startDate = u);
    let d = c && new Date(be(c));
    return (!n.endDate || d && d > n.endDate) && (n.endDate = d), n;
  }, { startDate: void 0, endDate: void 0 }), r = t.startDate && be(t.startDate.toISOString()), i = t.endDate && be(t.endDate.toISOString());
  return !r || !i ? { error: rw } : { startDate: r, endDate: i };
}
function hU({ tournamentRecord: e, participantFilters: t }) {
  if (!e)
    return { error: ae };
  let r = e.participants || [];
  t && (r = ad({ participants: r, participantFilters: t, tournamentRecord: e }));
  let i = {}, n = (a) => {
    if (a.person) {
      let { personId: o } = a.person;
      i[o] ? i[o].participantIds.push(a.participantId) : i[o] = { ...a.person, participantIds: [a.participantId] };
    }
  };
  return r.forEach((a) => {
    a.person && n(a);
  }), { tournamentPersons: Object.values(i) };
}
function gU(e) {
  var p, l, m, f, h, g, I, y;
  let t = fe(e, [{ [Gt]: !0 }]);
  if (t.error)
    return t;
  let r = e.finishingPositionRangeBounsPoints || {}, i = {}, n = (U) => {
    var D, w, v;
    let S = (D = U == null ? void 0 : U.individualParticipants) == null ? void 0 : D.map((P) => {
      var b;
      return ((b = P.teams) == null ? void 0 : b.length) === 1 && P.teams[0];
    });
    return ((w = U == null ? void 0 : U.teams) == null ? void 0 : w.length) === 1 && ((v = U == null ? void 0 : U.teams) == null ? void 0 : v[0]) || (S == null ? void 0 : S[0].participantId) === (S == null ? void 0 : S[1].participantId) && (S == null ? void 0 : S[0]);
  }, { matchUps: a, participants: o } = Ut({ participantFilters: { participantTypes: [Oe] }, withRankingProfile: !0, withStatistics: !0, ...e });
  for (let U of o ?? []) {
    if (U.participantType === Nr)
      continue;
    ((l = (p = U.draws) == null ? void 0 : p[0]) == null ? void 0 : l.drawId) === "draw-0-3" && console.log(U.participantType, U.draws[0].finishingPositionRange);
    let S = n(U);
    if (S)
      for (let D of (U == null ? void 0 : U.draws) ?? []) {
        let w = (m = D == null ? void 0 : D.finishingPositionRange) == null ? void 0 : m.join("-");
        if (w && (r != null && r[w])) {
          let v = S == null ? void 0 : S.participantId, P = D == null ? void 0 : D.drawId, b = `${v}|${P}|${w}`;
          i[b] = r[w];
        }
      }
  }
  let s = (U) => ({ teamName: U, standingPoints: 0, pointsPlayed: 0, pointsPct: 0, points: 0, bonus: 0, diff: 0, loss: 0, win: 0 }), c = (U, S, D) => {
    U[S] === void 0 && (U[S] = 0), U[S] += D;
  }, u = {}, d = {};
  for (let U of a ?? []) {
    let { sides: S, matchUpFormat: D } = U, w = D && Tr(D);
    if ((S == null ? void 0 : S.length) === 2 && ((f = w.setFormat) != null && f.timed) && (!w.finalSetFormat || (h = w.finalSetFormat) != null && h.timed))
      for (let v of S) {
        let P = n(v.participant), b = P == null ? void 0 : P.participantId, T = (g = v.participant) == null ? void 0 : g.participantId, R = P == null ? void 0 : P.participantName, M = v.sideNumber, E = ((I = v.participant) == null ? void 0 : I.individualParticipantIds) || T && [T] || [];
        if (E.forEach((C) => {
          C && !u[C] && (u[C] = s(R));
        }), b && M) {
          d[b] || (d[b] = s(R));
          let C = [...E.map((N) => u[N]), d[b]];
          U.winningSide && (M === U.winningSide ? C.forEach((N) => c(N, "win", 1)) : C.forEach((N) => c(N, "loss", 1)));
          let A = ((y = U.score) == null ? void 0 : y.sets) || [];
          for (let N of A) {
            let O = (N == null ? void 0 : N[`side${3 - M}Score`]) || 0, k = (N == null ? void 0 : N[`side${M}Score`]) || 0, F = k - O;
            C.forEach((x) => c(x, "pointsPlayed", k + O)), C.forEach((x) => c(x, "points", k)), C.forEach((x) => c(x, "diff", F));
          }
        }
      }
  }
  for (let U of Object.keys(i)) {
    let [S] = U.split("|");
    d[S] && (d[S].bonus += i[U], d[S].pointsPct = parseFloat((d[S].points / d[S].pointsPlayed).toFixed(2)), d[S].standingPoints = d[S].win + d[S].bonus);
  }
  for (let U of Object.keys(u))
    u[U].pointsPct = parseFloat((u[U].points / u[U].pointsPlayed).toFixed(2));
  return { ...V, individualResults: u, teamResults: d };
}
function A_(e) {
  var a, o, s, c, u, d, p;
  let t = ((o = (a = e.participants) == null ? void 0 : a.filter(({ participantType: l }) => l === Xe)) == null ? void 0 : o.length) === 2, r = ((s = e.events) == null ? void 0 : s.length) === 1 && e.events[0], i = ((c = r == null ? void 0 : r.drawDefinitions) == null ? void 0 : c.length) === 1 && r.drawDefinitions[0], n = ((p = (d = ((u = i == null ? void 0 : i.structures) == null ? void 0 : u.length) === 1 && i.structures[0]) == null ? void 0 : d.positionAssignments) == null ? void 0 : p.length) === 2;
  return !!(r.tieFormat && t && n);
}
function IU({ tournamentRecord: e }) {
  var n;
  if (!e)
    return { error: ae };
  let { drawsAnalysis: t } = yd({ tournamentRecord: e }), r = { isDual: A_(e), drawsAnalysis: t }, i = Ut({ tournamentRecord: e });
  return (n = i.missingParticipantIds) != null && n.length && (r.missingParticipantIds = i.missingParticipantIds), { ...V, analysis: r };
}
function nM(e, t) {
  return e && t && Array.isArray(t) && t[e - 1] || typeof t == "object" && t[e];
}
function E_(e) {
  let { participation: t = {}, awardProfiles: r, startDate: i, eventType: n, drawSize: a, drawType: o, category: s, endDate: c, level: u } = e, { participationOrder: d, flightNumber: p, rankingStage: l } = t, m = (f) => !i && !c || !f.dateRanges ? !0 : f.dateRanges.some((h) => {
    let g = !i || !h.startDate || new Date(i) > new Date(h.startDate), I = !c || !h.endDate || new Date(c) <= new Date(h.endDate);
    return g && I;
  });
  return { awardProfile: r.find((f) => {
    var h, g, I, y, U, S, D, w, v, P;
    return m(f) && (!f.maxFlightNumber || p <= f.maxFlightNumber) && (!((h = f.drawTypes) != null && h.length) || ((g = f.drawTypes) == null ? void 0 : g.includes(o))) && (!((I = f.drawSizes) != null && I.length) || f.drawSizes.includes(a)) && (!((y = f.stages) != null && y.length) || f.stages.includes(l)) && (!((U = f.levels) != null && U.length) || f.levels.includes(u)) && (!f.maxDrawSize || a <= f.maxDrawSize) && (!f.drawSize || f.drawSize === a) && (!f.maxLevel || u <= f.maxLevel) && (!p || !((D = (S = f.flights) == null ? void 0 : S.flightNumbers) != null && D.length) || f.flights.flightNumbers.includes(p)) && (!f.participationOrder || f.participationOrder === d) && (!((w = f.category) != null && w.ageCategoryCodes) || f.category.ageCategoryCodes.includes(s == null ? void 0 : s.ageCategoryCode)) && (!((v = f.eventTypes) != null && v.length) || ((P = f.eventTypes) == null ? void 0 : P.includes(n)));
  }) };
}
function CS({ participantWon: e, flightNumber: t, valueObj: r, drawSize: i, flights: n, level: a }) {
  var f, h;
  let o = (g, I) => {
    if (g) {
      if (Array.isArray(I)) {
        let y = I.find((U) => U.flight === g || U.f === g);
        return y.value || y.v;
      }
      if (typeof I == "object") {
        let y = I.flights || I.f;
        if (Array.isArray(y))
          return y[g - 1];
      }
    }
  }, s = (g, I) => {
    let y = (g == null ? void 0 : g.value) || (g == null ? void 0 : g.v) || (Pe(g) ? g : 0), U = nM(a, g == null ? void 0 : g.level);
    return { value: o(I, U) || Pe(U) && U || y };
  }, c = 0, u, d, p, l, m = e && "won" || e === !1 && "lost" || void 0;
  if (Array.isArray(r)) {
    let g = r.find((U) => {
      var S;
      return U.drawSize === i || ((S = U.drawSizes) == null ? void 0 : S.includes(i));
    }), I = r.find((U) => U.drawSize && U.threshold && i > U.drawSize), y = r.find((U) => {
      var S;
      return !U.drawSize && !((S = U.drawSizes) != null && S.length);
    });
    m !== void 0 && (g = g == null ? void 0 : g[m], I = I == null ? void 0 : I[m], y = y == null ? void 0 : y[m]), d = s(g, t).value, p = s(I, t).value, l = s(y, t).value, c = d || p || l, u = d && g.requireWin || p && I.requireWin || (y == null ? void 0 : y.requireWin);
  } else if (typeof r == "object") {
    let g = (f = r == null ? void 0 : r.drawSizes) == null ? void 0 : f[i], I = r;
    m !== void 0 && (g = g == null ? void 0 : g[m], I = I == null ? void 0 : I[m]), d = s(g, t).value, l = s(I, t).value, c = d || l, u = d ? g.requireWin : I == null ? void 0 : I.requireWin;
  } else
    Pe(r) && m === void 0 && (c = r);
  return t && ((h = n == null ? void 0 : n.pct) != null && h[t]) && (c = Math.round(c * n.pct[t])), { awardPoints: c, requireWin: u };
}
function dm({ participantFilters: e, policyDefinitions: t, tournamentRecord: r, level: i }) {
  var I;
  if (!r)
    return { error: ae };
  let { policyDefinitions: n } = ra({ policyTypes: [zd], tournamentRecord: r }), a = (t == null ? void 0 : t[zd]) ?? (n == null ? void 0 : n[zd]);
  if (!a)
    return { error: ql };
  let o = a.awardProfiles, s = a.requireWinFirstRound, c = a.requireWinForPoints, { participants: u, derivedEventInfo: d, derivedDrawInfo: p, mappedMatchUps: l } = Ut({ withRankingProfile: !0, participantFilters: e, tournamentRecord: r }), m = u == null ? void 0 : u.filter((y) => {
    var U;
    return (U = y.draws) == null ? void 0 : U.length;
  }), f = {}, h = {}, g = {};
  for (let y of m ?? []) {
    let { participantType: U, participantId: S, person: D, draws: w } = y;
    for (let v of w) {
      let { drawId: P, structureParticipation: b, eventId: T } = v, R = d[T], M = p[P], E = M == null ? void 0 : M.drawType, { category: C, eventType: A } = R || {}, N = v.startDate || R.startDate || r.startDate, O = v.endDate || R.endDate || r.endDate;
      if (A === Xr && S !== Nr)
        continue;
      let k;
      if (o) {
        let F = c, x = 0, _ = 0, B = 0, L;
        for (let G of b) {
          let { finishingPositionRange: $, participationOrder: W, participantWon: q, flightNumber: K, rankingStage: z, winCount: Y } = G;
          x += Y || 0;
          let X = M == null ? void 0 : M.drawSize, { awardProfile: re } = E_({ awardProfiles: o, participation: G, eventType: A, startDate: N, category: C, drawSize: X, drawType: E, endDate: O, level: i });
          if (re) {
            if (!X)
              continue;
            let Q = Array.isArray($) && Math.max(...$), H = Te($ || []).join("-"), Z = Q && z !== ge && ($ == null ? void 0 : $.includes(X));
            re.requireWinForPoints !== void 0 && (F = re.requireWinForPoints), re.requireWinFirstRound !== void 0 && (s = re.requireWinFirstRound);
            let { finishingPositionPoints: ee = {}, finishingPositionRanges: te, finishingRound: ne, pointsPerWin: se, flights: ie } = re, he = Array.isArray(re.perWinPoints) ? (I = re.perWinPoints) == null ? void 0 : I.find((qe) => {
              var ar;
              return (ar = qe.participationOrders) == null ? void 0 : ar.includes(W);
            }) : re.perWinPoints, Ee = ee.participationOrders, de = 0, it;
            if ((!Ee || Ee.includes(W)) && te && Q) {
              let qe = te[Q];
              qe && ({ awardPoints: de, requireWin: it } = CS({ flightNumber: K, valueObj: qe, drawSize: X, flights: ie, level: i }));
            }
            if (!de && ne && W === 1 && Q) {
              let qe = ne[Q];
              qe && ({ awardPoints: de, requireWin: it } = CS({ participantWon: q, flightNumber: K, valueObj: qe, drawSize: X, flights: ie, level: i }));
            }
            if (Z && s !== void 0 && (F = s), it !== void 0 && (F = it), de > _ && (!F || Y) && (_ = de, L = Q), !de && se && Y && (B += Y * se, L = H), !de && Y && he) {
              let qe = nM(i, he == null ? void 0 : he.level);
              qe ? B += Y * qe : he.value && (B += Y * he.value);
            }
          }
          if (k = _ + B, U === Nr) {
            let Q = (y.matchUps || []).filter(({ structureId: H }) => H === G.structureId);
            for (let { matchUpId: H } of Q) {
              let Z = l[H], ee = Z.sides.find((te) => te.participantId === S).sideNumber;
              if (Z.winningSice === ee)
                for (let te of Z.tieMatchUps)
                  te.winningSide;
            }
          }
        }
        if (B || _) {
          let G = { winCount: x, positionPoints: _, rangeAccessor: L, perWinPoints: B, eventType: A, drawId: P, points: k }, $ = D == null ? void 0 : D.personId;
          $ ? (f[$] || (f[$] = []), f[$].push(G)) : U === Re ? (g[S] || (g[S] = []), g[S].push(G)) : U === Nr && (h[S] || (h[S] = []), h[S].push(G));
        }
      }
    }
  }
  return { participantsWithOutcomes: m, personPoints: f, pairPoints: g, teamPoints: h, ...V };
}
var aM = {};
Ae(aM, { compareTieFormats: () => Xn, getTieFormat: () => yU, tieFormatGenderValidityCheck: () => ap, validateCollectionDefinition: () => Cu });
function El(e) {
  var n;
  if (!e)
    return {};
  let t = [], r = e.tieFormatName, i = (n = e.collectionDefinitions) == null ? void 0 : n.map((a) => {
    let { matchUpType: o, matchUpFormat: s, matchUpCount: c, category: u, gender: d } = a;
    t.includes(s) || t.push(s);
    let p = u == null ? void 0 : u.ageCategoryCode;
    return [c, o === Ga ? "D" : "S", p, s, d].join(";");
  }).join("|");
  return { tieFormatName: e && r || "UNNAMED", matchUpFormats: t, tieFormatDesc: i };
}
function Xn({ considerations: e = {}, descendant: t, ancestor: r }) {
  var D, w;
  let i = {}, n = {}, { matchUpFormats: a, tieFormatDesc: o } = El(t), { matchUpFormats: s, tieFormatDesc: c } = El(r), u = Te((a ?? []).filter((v) => !(s ?? []).includes(v)).concat((s ?? []).filter((v) => !(a ?? []).includes(v)))), d = !!(e != null && e.collectionName && t.collectionDefinitions.map(({ collectionName: v }) => v).join("|") !== r.collectionDefinitions.map(({ collectionName: v }) => v).join("|")), p = !!(e != null && e.collectionOrder && t.collectionDefinitions.map(({ collectionOrder: v }) => v).join("|") !== r.collectionDefinitions.map(({ collectionOrder: v }) => v).join("|")), l = Object.assign({}, ...((t == null ? void 0 : t.collectionDefinitions) || []).map((v) => ({ [v.collectionId]: v }))), m = Object.assign({}, ...((r == null ? void 0 : r.collectionDefinitions) || []).map((v) => ({ [v.collectionId]: v })));
  i.collectionIds = Qy(Object.keys(l), Object.keys(m)), n.collectionIds = Qy(Object.keys(m), Object.keys(l)), i.collectionsValue = OS(l), n.collectionsValue = OS(m), i.groupsCount = ((D = r == null ? void 0 : r.collectionGroups) == null ? void 0 : D.length) ?? (0 - (((w = t == null ? void 0 : t.collectionGroups) == null ? void 0 : w.length) ?? 0) || 0), n.groupsCount = i.groupsCount ? -1 * i.groupsCount : 0;
  let f = i.collectionsValue.totalValue - n.collectionsValue.totalValue, h = i.collectionsValue.totalMatchUps - n.collectionsValue.totalMatchUps, g = n.collectionsValue.assignmentValues.length !== i.collectionsValue.assignmentValues.length, I = n.collectionsValue.assignmentValues.some((v, P) => {
    let b = i.collectionsValue.assignmentValues[P];
    return !b || v.valueKey !== b.valueKey || v.value !== b.value ? !0 : Array.isArray(v.value) ? v.value.every((T, R) => b.value[R] === T) : !1;
  }), y = d || p || c !== o || g || I || f !== 0, U = [...n.collectionsValue.invalidValues, ...i.collectionsValue.invalidValues], S = U.length && U;
  return { matchUpFormatDifferences: u, matchUpCountDifference: h, descendantDifferences: i, ancestorDifferences: n, orderDifference: p, valueDifference: f, nameDifference: d, descendantDesc: o, ancestorDesc: c, ...V, different: y, invalid: S };
}
function OS(e) {
  let t = [], r = [], i = 0;
  return { totalValue: Object.keys(e).sort(Lp).reduce((n, a) => {
    let o = e[a], { collectionValueProfiles: s, collectionValue: c, matchUpCount: u, matchUpValue: d, scoreValue: p, setValue: l } = o, m = { collectionValueProfiles: s, collectionValue: c, matchUpValue: d, scoreValue: p, setValue: l }, f = Object.keys(m).filter((g) => ![void 0, null].includes(m[g]) && (!Array.isArray(m[g]) || m[g].length > 0));
    f.length !== 1 && t.push({ collectionId: a });
    let h = f[0];
    if (h) {
      let g = h === "collectionValueProfiles" ? Object.values(s) : m[h];
      r.push({ valueKey: h, value: g });
    }
    return i += u, s != null && s.length ? n + s.reduce((g, I) => g + I.value, 0) : u ? Pe(d) ? n + d * u : Pe(p) ? n + p * u : Pe(l) ? n + l * u : n + c : n;
  }, 0), totalMatchUps: i, invalidValues: t, assignmentValues: r };
}
function UU(e) {
  Object.assign(e, { inContext: !0 });
  let { matchUp: t, error: r } = oM(e);
  return { matchUp: ce(t, !0, !0), error: r };
}
function oM({ participantsProfile: e, afterRecoveryTimes: t, tournamentRecord: r, contextContent: i, contextProfile: n, drawDefinition: a, nextMatchUps: o, matchUpId: s, inContext: c, eventId: u, drawId: d, event: p }) {
  var f;
  if (!r)
    return { error: ae };
  if (typeof s != "string")
    return { error: Ur };
  if (!a || !p) {
    let h = (tr({ tournamentRecord: r, nextMatchUps: o }).matchUps ?? []).find((g) => g.matchUpId === s);
    if (!h)
      return { error: hr };
    ({ eventId: u, drawId: d } = h), { event: p, drawDefinition: a } = Cr({ tournamentRecord: r, eventId: u, drawId: d });
  }
  if (!a)
    return { error: ai };
  n && !i && (i = ia({ tournamentRecord: r, contextProfile: n }));
  let l = { surfaceCategory: (p == null ? void 0 : p.surfaceCategory) ?? r.surfaceCategory, indoorOutDoor: (p == null ? void 0 : p.indoorOutdoor) ?? r.indoorOutdoor, endDate: (p == null ? void 0 : p.endDate) ?? r.endDate, tournamentId: r.tournamentId, eventId: u ?? (p == null ? void 0 : p.eventId), drawId: d }, { participants: m = [] } = es({ participantsProfile: e, tournamentRecord: r, contextProfile: n, inContext: c });
  if (o) {
    let h = (vr({ context: c ? l : void 0, participants: m, afterRecoveryTimes: t, contextContent: i, contextProfile: n, drawDefinition: a, nextMatchUps: o, inContext: c, event: p }).matchUps ?? []).find((I) => I.matchUpId === s);
    if (!h)
      return { error: hr };
    let g = (f = a == null ? void 0 : a.structures) == null ? void 0 : f.find((I) => I.structureId === h.structureId);
    return { drawDefinition: a, structure: g, matchUp: h };
  } else {
    let { matchUp: h, structure: g } = ft({ context: c ? l : void 0, tournamentParticipants: m, afterRecoveryTimes: t, contextContent: i, drawDefinition: a, contextProfile: n, matchUpId: s, inContext: c, event: p });
    return { matchUp: h, structure: g, drawDefinition: a };
  }
}
function yU({ tournamentRecord: e, drawDefinition: t, structureId: r, matchUpId: i, structure: n, eventId: a, drawId: o, event: s }) {
  var m, f, h, g, I;
  if (!e)
    return { error: ae };
  if (!o && !s && !r && !i)
    return j({ result: { error: Ie }, stack: "getTieFormat" });
  a && !s && (s = (m = e.events) == null ? void 0 : m.find((y) => y.eventId === a));
  let c = UU({ tournamentRecord: e, drawDefinition: t, matchUpId: i, drawId: o, event: s });
  if (i && (c != null && c.error))
    return c;
  if (!t && (c != null && c.drawDefinition) && (t = c == null ? void 0 : c.drawDefinition), n = n ?? (c == null ? void 0 : c.structure), !n && r && !i) {
    if (!t)
      return { error: tn };
    let y = ve({ drawDefinition: t, structureId: r });
    if (y.error)
      return y;
    n = y.structure;
  }
  let u = ((n == null ? void 0 : n.tieFormat) || (n == null ? void 0 : n.tieFormatId)) && ((f = Ir({ structure: n, drawDefinition: t, event: s })) == null ? void 0 : f.tieFormat), d = ((t == null ? void 0 : t.tieFormat) || (t == null ? void 0 : t.tieFormatId)) && ((h = Ir({ drawDefinition: t, event: s })) == null ? void 0 : h.tieFormat), p = (g = Ir({ event: s })) == null ? void 0 : g.tieFormat, l = (I = Ir({ matchUp: c == null ? void 0 : c.matchUp, drawDefinition: t, structure: n, event: s })) == null ? void 0 : I.tieFormat;
  return { ...V, matchUp: c == null ? void 0 : c.matchUp, structureDefaultTieFormat: sr(u), eventDefaultTieFormat: sr(p), drawDefaultTieFormat: sr(d), tieFormat: sr(l), structure: n };
}
var sM = {};
Ae(sM, { bulkUpdatePublishedEventIds: () => SU, getAllEventData: () => vU, getCourtInfo: () => Op, getDrawData: () => lm, getEventData: () => pm, getEventPublishStatus: () => bi, getPublishState: () => us, getTournamentPublishStatus: () => nd, getVenueData: () => zs });
function SU({ tournamentRecord: e, outcomes: t }) {
  var n;
  if (!e)
    return { error: ae };
  if (!(t != null && t.length))
    return { error: Ie, info: "Missing outcomes" };
  let r = t.reduce((a, o) => {
    let { drawId: s, eventId: c } = o;
    return c && s && (a[c] ? a[c].includes(s) || a[c].push(s) : a[c] = [s]), a;
  }, {}), i = Object.keys(r);
  return { publishedEventIds: ((n = e.events) == null ? void 0 : n.filter((a) => i.includes(a.eventId))).filter((a) => {
    let o = bi({ event: a }), { drawDetails: s, drawIds: c } = o ?? {}, { eventId: u } = a;
    return r[u].filter((d) => {
      let p = s ? Object.keys(o.drawDetails).filter((l) => tI({ drawId: l, drawDetails: s })) : [];
      return (c == null ? void 0 : c.includes(d)) || p.includes(d);
    }).length;
  }).map((a) => a.eventId), eventIdPublishedDrawIdsMap: r };
}
function cM({ dates: e = [], extension: t }) {
  var i;
  if (!t)
    return !1;
  if (typeof t.value == "boolean" && t.value)
    return !0;
  if (!e.length)
    return !1;
  let r = Le(t.value) ? (i = t.value) == null ? void 0 : i.dates : void 0;
  if (Array.isArray(r))
    return r != null && r.length ? !!r.filter((n) => !e.length || e.includes(n)).length : !1;
}
function uM({ convertExtensions: e, ignoreDisabled: t, venue: r, court: i }) {
  var o;
  let n = { ...ce(i, e, !0), venueId: r.venueId }, { extension: a } = Ne({ name: Yi, element: i });
  if (t && a) {
    let s = Le(a.value) ? (o = a.value) == null ? void 0 : o.dates : void 0, c = (a == null ? void 0 : a.value) === !0 ? [] : n.dateAvailability.map((u) => {
      let d = u.date;
      if (!(!d || s.includes(d)))
        return u;
    }).filter(Boolean);
    n.dateAvailability = c;
  }
  return { inContextCourt: n };
}
function aa(e) {
  let { convertExtensions: t, ignoreDisabled: r, venueIds: i = [], dates: n } = e, a = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {}, o = [], s = [], c = [], u = [];
  return Object.keys(a).filter((d) => !e.tournamentId || d === e.tournamentId).forEach((d) => {
    let p = a[d];
    for (let l of p.venues ?? [])
      if (!(i.length && !i.includes(l.venueId))) {
        if (r) {
          let { extension: m } = Ne({ name: Yi, element: l });
          if (m != null && m.value)
            continue;
        }
        o.includes(l.venueId) || (u.push(ce(l, t, !0)), o.push(l.venueId));
        for (let m of l.courts ?? [])
          if (!s.includes(m.courtId)) {
            if (r) {
              let { extension: h } = Ne({ name: Yi, element: m });
              if (cM({ extension: h, dates: n }))
                continue;
            }
            let { inContextCourt: f } = uM({ convertExtensions: t, ignoreDisabled: r, venue: l, court: m });
            c.push(f), s.push(m.courtId);
          }
      }
  }), { courts: c, venues: u, ...V };
}
function C_({ convertExtensions: e, tournamentRecord: t, ignoreDisabled: r, dates: i }) {
  if (!t)
    return { error: yt };
  let n = ce(t.venues ?? [], e).filter((o) => {
    if (!r)
      return o;
    let { extension: s } = Ne({ name: Yi, element: o });
    return !(s != null && s.value) && o;
  }).filter(Boolean), a = n.reduce((o, s) => {
    let c = ((s == null ? void 0 : s.courts) || []).filter((u) => {
      if (!r && !(i != null && i.length))
        return u;
      let { extension: d } = Ne({ name: Yi, element: u });
      return cM({ extension: d, dates: i });
    }).filter(Boolean).map((u) => {
      let { inContextCourt: d } = uM({ convertExtensions: e, ignoreDisabled: r, venue: s, court: u });
      return d;
    });
    return c.length ? o.concat(c) : o;
  }, []);
  return { venues: n, courts: a };
}
function Pd({ tournamentRecords: e, requireCourts: t, dates: r }) {
  return typeof e != "object" || !Object.keys(e).length ? { error: yt } : Object.keys(e).reduce((i, n) => {
    let a = e[n], { venues: o } = C_({ tournamentRecord: a, dates: r });
    return o == null || o.forEach((s) => {
      let { venueId: c, courts: u } = s;
      (!t || u != null && u.length) && !i.venueIds.includes(c) && (i.venues.push(s), i.venueIds.push(c));
    }), i;
  }, { venues: [], venueIds: [] });
}
function vU({ tournamentRecord: e, policyDefinitions: t }) {
  if (!e)
    return { error: ae };
  let r = e.events || [], i = (e == null ? void 0 : e.participants) || [], { tournamentInfo: n } = hs({ tournamentRecord: e }), { venues: a } = aa({ tournamentRecord: e }), o = r.map((s) => {
    let { eventId: c } = s, u = iM({ event: s }).eventInfo, d = $u({ tournamentRecord: e, event: s }).scheduleTiming, p = (s.drawDefinitions || []).map((m) => {
      let f = (({ drawId: U, drawName: S, matchUpFormat: D, updatedAt: w }) => ({ matchUpFormat: D, updatedAt: w, drawName: S, drawId: U }))(m), { abandonedMatchUps: h, completedMatchUps: g, upcomingMatchUps: I, pendingMatchUps: y } = Uc({ requireParticipants: !0, tournamentParticipants: i, context: { eventId: c }, policyDefinitions: t, tournamentRecord: e, inContext: !0, scheduleTiming: d, drawDefinition: m, event: s });
      return { drawInfo: f, matchUps: { abandonedMatchUps: h, completedMatchUps: g, upcomingMatchUps: I, pendingMatchUps: y } };
    }), l = bi({ event: s });
    return Object.assign(u, { drawsData: p, publish: l }), u;
  });
  return { allEventData: { tournamentInfo: n, venuesData: a, eventsData: o } };
}
function dM({ publishStatus: e, drawId: t }) {
  var r, i, n;
  return e != null && e.drawDetails ? (n = (i = (r = e.drawDetails) == null ? void 0 : r[t]) == null ? void 0 : i.publishingDetail) == null ? void 0 : n.published : e != null && e.drawIds ? e.drawIds.includes(t) : !0;
}
var lM = "PUBLIC", O_ = "ADMIN", k_ = { PUBLIC_DISPLAY: lM, ADMIN_DISPLAY: O_ };
function lm(e) {
  var R, M, E;
  let { tournamentParticipants: t = [], includePositionAssignments: r, policyDefinitions: i, tournamentRecord: n, inContext: a = !0, usePublishState: o, status: s = li, pressureRating: c, refreshResults: u, drawDefinition: d, noDeepCopy: p, sortConfig: l, context: m, event: f } = e;
  if (!d)
    return { error: le };
  let h = (({ matchUpFormat: C, updatedAt: A, drawType: N, drawName: O, drawId: k }) => ({ matchUpFormat: C, updatedAt: A, drawName: O, drawType: N, drawId: k }))(d);
  h.display = (R = Ne({ element: d, name: ml }).extension) == null ? void 0 : R.value;
  let g = {}, I, { allStructuresLinked: y, sourceStructureIds: U, hasDrawFeedProfile: S, structureGroups: D } = Gp({ drawDefinition: d });
  if (!y)
    return { error: qv };
  let w = (e == null ? void 0 : e.publishStatus) ?? bi({ event: f, status: s }), v = e.eventPublished ?? !!((E = (M = us({ event: f }).publishState) == null ? void 0 : M.status) != null && E.published), P = !1, b = !1, T = D.map((C) => {
    let A = {}, N = C.map((O) => {
      let { structure: k } = ve({ drawDefinition: d, structureId: O }), { seedAssignments: F } = Si({ drawDefinition: d, structure: k });
      return (k == null ? void 0 : k.stage) === ue && k.stageSequence === 1 && (I = F), (k == null ? void 0 : k.stage) === ge && (g[k.stageSequence ?? 0] = F), k;
    }).sort((O, k) => Zo(O, k, l)).map((O) => {
      var K, z;
      if (!O)
        return;
      let k = O == null ? void 0 : O.structureId, F = [];
      O.stage && [ue, lr, vt].includes(O.stage) && (F = I), (O == null ? void 0 : O.stage) === ge && (F = g[O.stageSequence ?? 0]);
      let { matchUps: x, roundMatchUps: _, roundProfile: B } = Ke({ seedAssignments: (K = O == null ? void 0 : O.seedAssignments) != null && K.length ? void 0 : F, context: { drawId: h.drawId, ...m }, tournamentParticipants: t, policyDefinitions: i, tournamentRecord: n, usePublishState: o, publishStatus: w, drawDefinition: d, inContext: a, structure: O, event: f }), { positionAssignments: L } = ot({ structure: O }), G = L == null ? void 0 : L.filter(ei(Cn)).map((Y) => {
        var H, Z;
        let X = (Z = (H = Ne({ element: Y, name: Ia })) == null ? void 0 : H.extension) == null ? void 0 : Z.value, { drawPosition: re, participantId: Q } = Y;
        return b = !0, { participantResult: X, participantId: Q, drawPosition: re };
      });
      if (x.length && (!(G != null && G.length) && e.allParticipantResults || u && !O.structures)) {
        let { subOrderMap: Y } = Ub({ positionAssignments: L }), X = x.some((Q) => Q.matchUpType === ni) ? x.filter((Q) => Q.matchUpType === ni) : x, re = Dc({ matchUpFormat: O.matchUpFormat, matchUps: X, policyDefinitions: i, pressureRating: c, subOrderMap: Y });
        G = L == null ? void 0 : L.filter(ei(Cn)).map((Q) => {
          var ee;
          let { drawPosition: H, participantId: Z } = Q;
          return b = !0, { participantResult: Z && ((ee = re == null ? void 0 : re.participantResults) == null ? void 0 : ee[Z]), participantId: Z, drawPosition: H };
        });
      }
      let $ = O ? (({ stageSequence: Y, structureName: X, structureType: re, matchUpFormat: Q, stage: H }) => ({ stageSequence: Y, structureName: X, structureType: re, matchUpFormat: Q, stage: H }))(O) : {}, W = (z = Ne({ element: O, name: ml }).extension) == null ? void 0 : z.value;
      $.display = (W == null ? void 0 : W[lM]) ?? W, $.sourceStructureIds = U[k], $.hasDrawFeedProfile = S[k], $.positionAssignments = L, $.structureActive = x.reduce((Y, X) => {
        var Q;
        let re = [Et, Lt, Gi, Tt, Un, ke, nr, Be].includes(X.matchUpStatus);
        return Y || re || !!X.winningSide || !!((Q = X.score) != null && Q.scoreStringSide1);
      }, !1);
      let q = x.reduce((Y, X) => Y && [$e, Tt, nr, Be, ke, Gr].includes(X.matchUpStatus), !!x.length);
      return $.structureCompleted = q, A[k] = q, $.structureActive && (P = !0), { ...$, participantResults: G, seedAssignments: F, roundMatchUps: _, roundProfile: B, structureId: k };
    });
    return N.forEach((O) => {
      var k;
      r || delete O.positionAssignments, O.sourceStructuresComplete = (k = O.sourceStructureIds) == null ? void 0 : k.every((F) => A[F]);
    }), N;
  }).flat();
  return h.drawActive = P, h.participantPlacements = b, h.drawGenerated = T == null ? void 0 : T.reduce((C, A) => C || !!(A != null && A.roundMatchUps), !1), h.drawCompleted = T == null ? void 0 : T.reduce((C, A) => C && A.structureCompleted, !0), h.drawPublished = o ? v && dM({ publishStatus: w, drawId: h.drawId }) : void 0, { structures: !o || h.drawPublished ? p && T || ce(T, !1, !0) : void 0, drawInfo: p ? h : ce(h, !1, !0), ...V };
}
function pm(e) {
  var M, E, C;
  let { includePositionAssignments: t, participantsProfile: r, policyDefinitions: i, usePublishState: n, status: a = li, sortConfig: o } = e, s = fe(e, [{ tournamentRecord: !0 }, { [mg]: { event: !1, eventId: !1 } }]);
  if (s.error)
    return s;
  let c = ce(e.tournamentRecord, !1, !0), u = e.event ? void 0 : Cr({ tournamentRecord: c, eventId: e.eventId }).event, d = e.event ? ce(e.event, !1, !0) : u && ce(u, !1, !0) || void 0;
  if (!d)
    return { error: Ii };
  let { eventId: p } = d, { tournamentId: l, endDate: m } = c, f = bi({ event: d, status: a }), h = us({ event: d }).publishState ?? {}, g = !!((M = h == null ? void 0 : h.status) != null && M.published), { participants: I } = Ut({ withGroupings: !0, withEvents: !1, withDraws: !1, policyDefinitions: i, ...r, tournamentRecord: c }), y = ({ stage: A, drawId: N }) => {
    var k, F, x;
    if (!n)
      return !0;
    let O = (F = (k = f == null ? void 0 : f.drawDetails) == null ? void 0 : k[N]) == null ? void 0 : F.stageDetails;
    return !O || !Object.keys(O).length ? !0 : (x = O[A]) == null ? void 0 : x.published;
  }, U = ({ structureId: A, drawId: N }) => {
    var k, F, x;
    if (!n)
      return !0;
    let O = (F = (k = f == null ? void 0 : f.drawDetails) == null ? void 0 : k[N]) == null ? void 0 : F.structureDetails;
    return !O || !Object.keys(O).length ? !0 : (x = O[A]) == null ? void 0 : x.published;
  }, S = ({ drawId: A }) => n ? dM({ publishStatus: f, drawId: A }) : !0, D = ({ drawId: A, structure: N }) => {
    var k, F, x, _;
    if (!n)
      return N;
    let O = (_ = (x = (F = (k = f == null ? void 0 : f.drawDetails) == null ? void 0 : k[A]) == null ? void 0 : F.structureDetails) == null ? void 0 : x[N.structureId]) == null ? void 0 : _.roundLimit;
    if (Pe(O)) {
      let B = oe(1, O + 1), L = {}, G = {};
      for (let $ of B)
        N.roundMatchUps[$] && (L[$] = N.roundMatchUps[$], G[$] = N.roundProfile[$]);
      N.roundMatchUps = L, N.roundProfile = G;
    }
    return N;
  }, w = d.drawDefinitions || [], v = !n || g ? w.filter(S).map((A) => (({ drawInfo: N, structures: O }) => ({ ...N, structures: O }))(lm({ allParticipantResults: e.allParticipantResults, context: { eventId: p, tournamentId: l, endDate: m }, pressureRating: e.pressureRating, refreshResults: e.refreshResults, includePositionAssignments: t, tournamentParticipants: I, noDeepCopy: !0, policyDefinitions: i, tournamentRecord: c, usePublishState: n, drawDefinition: A, publishStatus: f, sortConfig: o, event: d }))).map(({ structures: A, ...N }) => {
    let O = A == null ? void 0 : A.filter(({ stage: k, structureId: F }) => U({ structureId: F, drawId: N.drawId }) && y({ stage: k, drawId: N.drawId })).map((k) => D({ drawId: N.drawId, structure: k }));
    return { ...N, structures: O };
  }).filter((A) => {
    var N;
    return (N = A.structures) == null ? void 0 : N.length;
  }) : void 0, P = (Array.isArray(c.venues) ? c.venues : []).map((A) => (({ venueData: N }) => ({ ...N }))(zs({ venueId: A.venueId, tournamentRecord: c }))), b = (({ eventId: A, eventName: N, eventType: O, eventLevel: k, surfaceCategory: F, matchUpFormat: x, category: _, gender: B, startDate: L, endDate: G, ballType: $, discipline: W }) => ({ eventId: A, eventName: N, eventType: O, eventLevel: k, surfaceCategory: F, matchUpFormat: x, category: _, gender: B, startDate: L, endDate: G, ballType: $, discipline: W }))(d);
  b.display = (E = Ne({ element: d, name: ml }).extension) == null ? void 0 : E.value;
  let { tournamentInfo: T } = hs({ tournamentRecord: c }), R = { tournamentInfo: T, venuesData: P, eventInfo: b, drawsData: v };
  return R.eventInfo.publishState = h, R.eventInfo.published = (C = h == null ? void 0 : h.status) == null ? void 0 : C.published, { ...V, eventData: R, participants: I };
}
var pM = {};
Ae(pM, { courtGridRows: () => Im, findVenue: () => xn, getMatchUpsToSchedule: () => mm, getPersonRequests: () => Uo, getProfileRounds: () => gm, getScheduledRoundsDetails: () => Dd, getSchedulingProfile: () => oa, getSchedulingProfileIssues: () => wU, publicFindCourt: () => Xg });
function Xs({ matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: t, timeAfterRecovery: r, matchUp: i }) {
  var u, d, p, l;
  let { individualParticipantIds: n } = Rp(i);
  r = r ?? ((u = i.schedule) == null ? void 0 : u.timeAfterRecovery);
  let a = (m) => {
    e[m] || (e[m] = []), e[m] = Te(e[m].concat(...n));
  }, o = (m) => {
    r && (!t[m] || r > t[m]) && (t[m] = r);
  }, s = ((d = i.winnerTo) == null ? void 0 : d.matchUpId) || i.winnerMatchUpId;
  s && (r && o(s), a(s));
  let c = ((p = i.loserTo) == null ? void 0 : p.matchUpId) || i.loserMatchUpId;
  c && (r && o(c), a(c)), (l = i.sidesTo) != null && l.length && i.sidesTo.forEach(({ matchUpId: m }) => {
    m && (r && o(m), a(m));
  });
}
function mm(e) {
  let t = fe(e, [{ [lg]: !0 }]);
  if (t.error)
    return t;
  let { matchUpPotentialParticipantIds: r, dateScheduledMatchUpIds: i = [], scheduleCompletedMatchUps: n, matchUpNotBeforeTimes: a, matchUpScheduleTimes: o, orderedMatchUpIds: s, clearDate: c, matchUps: u } = e, d = o ? Object.keys(o) : [], p = (s ?? []).map((m) => u.find((f) => f.matchUpId === m)).filter(Boolean).filter((m) => {
    let f = !c && (i.includes(m.matchUpId) || d.includes(m.matchUpId)), h = [$e, ke, Tt, Gr, nr, Be, Et, Lt].includes(m == null ? void 0 : m.matchUpStatus);
    return n || !f && !m.winningSide && !h;
  }), l = r && a ? p.reduce((m, f) => {
    let { drawId: h, tournamentId: g } = f;
    return m.matchUpMap[g] || (m.matchUpMap[g] = {}), m.matchUpMap[g][h] ? m.matchUpMap[g][h].push(f) : m.matchUpMap[g][h] = [f], Xs({ matchUpPotentialParticipantIds: r, matchUpNotBeforeTimes: a, matchUp: f }), m;
  }, { matchUpMap: {} }).matchUpMap : {};
  return { matchUpsToSchedule: p, matchUpMap: l };
}
function fm({ defaultRecoveryMinutes: e = 0, defaultAverageMinutes: t, tournamentRecords: r, matchUpFormat: i, categoryName: n, categoryType: a, tournamentId: o, eventType: s, eventId: c }) {
  if (!Jr({ matchUpFormat: i }))
    return { error: bu };
  let u = Object.keys(r).filter((p) => !o || p === o), d;
  return u.forEach((p) => {
    var f;
    if (d)
      return;
    let l = r[p], m = c ? (f = Cr({ tournamentRecord: l, eventId: c })) == null ? void 0 : f.event : void 0;
    return d = Xu({ tournamentRecord: l, matchUpFormat: i, categoryName: n, categoryType: a, eventType: s, event: m }), (d == null ? void 0 : d.averageMinutes) || (d == null ? void 0 : d.recoveryMinutes);
  }), { recoveryMinutes: (d == null ? void 0 : d.recoveryMinutes) || e, averageMinutes: (d == null ? void 0 : d.averageMinutes) || t, typeChangeRecoveryMinutes: (d == null ? void 0 : d.typeChangeRecoveryMinutes) || (d == null ? void 0 : d.recoveryMinutes) || e };
}
function Dd(e) {
  let t = fe(e, [{ [mg]: { tournamentRecords: !1, tournamentRecord: !1 } }, { rounds: !0, [Or]: fr }]);
  if (t.error)
    return t;
  let { scheduleCompletedMatchUps: r, periodLength: i = 30 } = e, n = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {};
  if (typeof n != "object")
    return { error: yt };
  let a = {}, o = [], s = e.rounds.toSorted((f, h) => (f.sortOrder ?? 0) - (h.sortOrder ?? 0)), c = e.containedStructureIds ?? Object.assign({}, ...Object.values(n).map((f) => gc({ tournamentRecord: f }).containedStructures)), u = e.matchUps ?? en({ nextMatchUps: !0, tournamentRecords: n }).matchUps, d = 0, p = {}, l = {}, m = {};
  return { scheduledRoundsDetails: s.flatMap((f) => {
    var v;
    let h = f.periodLength || i, g = [];
    c != null && c[f.structureId] ? g.push(...c[f.structureId]) : g.push(f.structureId);
    let I = u ? Vn({ tournamentIds: [f.tournamentId], roundNumbers: [f.roundNumber], matchUpIds: f.matchUpIds, eventIds: [f.eventId], drawIds: [f.drawId], processContext: !0, structureIds: g, matchUps: u }).sort(cs) : [], { segmentNumber: y, segmentsCount: U } = f.roundSegment || {};
    if (Pe(y) && Qi(I == null ? void 0 : I.length) && Qi(U) && y > 0 && y <= U && U < (I == null ? void 0 : I.length) && !((v = f.matchUpIds) != null && v.length)) {
      let P = I.length / U, b = P * (y - 1);
      I = I.slice(b, b + P);
    }
    let S = n[f.tournamentId], D = Cr({ drawId: f.drawId, tournamentRecord: S }).event, w = [];
    for (let P of I) {
      let b = P.matchUpFormat;
      b && (a[b] || (a[b] = [], a[b].push(P)), w.push(b));
    }
    for (let P of w) {
      let { eventType: b, category: T } = D ?? {}, { categoryName: R, ageCategoryCode: M } = T ?? {}, { typeChangeRecoveryMinutes: E, recoveryMinutes: C, averageMinutes: A, error: N } = fm({ categoryName: R ?? M, categoryType: T == null ? void 0 : T.categoryType, tournamentId: f.tournamentId, eventId: f.eventId, tournamentRecords: n, matchUpFormat: P, eventType: b });
      if (N)
        return { error: N, round: f };
      let O = I.filter((F) => (r || !Vt.includes(F.matchUpStatus)) && F.matchUpStatus !== $e).map(Ht);
      O.forEach((F) => {
        m[F] = { typeChangeRecoveryMinutes: E, recoveryMinutes: C, averageMinutes: A }, p[F] = C, l[F] = A;
      }), o.push(...O), d = Math.max(A || 0, d);
      let k = `${A}|${h}`;
      return { roundPeriodLength: h, recoveryMinutes: C, averageMinutes: A, matchUpIds: O, hash: k };
    }
  }), greatestAverageMinutes: d, matchUpFormatCohorts: a, recoveryMinutesMap: p, averageMinutesMap: l, orderedMatchUpIds: o, minutesMap: m, ...V };
}
function mM({ schedulingProfile: e, venueIds: t, eventIds: r, drawIds: i }) {
  let n = [], a = e == null ? void 0 : e.map((s) => {
    let c = be(s == null ? void 0 : s.scheduleDate);
    if (!c) {
      n.push(`Invalid date: ${s == null ? void 0 : s.scheduledDate}`);
      return;
    }
    let u = ((s == null ? void 0 : s.venues) || []).map((d) => {
      let { rounds: p, venueId: l } = d;
      if (!(t != null && t.includes(l))) {
        n.push(`Missing venueId: ${l}`);
        return;
      }
      let m = p.filter((f) => {
        let h = r.includes(f.eventId) && i.includes(f.drawId);
        return h || n.push(`Invalid eventId: ${f.eventId} or drawId: ${f.drawId}`), h;
      });
      if (m.length)
        return { venueId: l, rounds: m };
    }).filter(Boolean);
    return u.length && c && { ...s, venues: u };
  }).filter(Boolean), o = n.length;
  return { updatedSchedulingProfile: a, modifications: o, issues: n };
}
function hm({ tournamentRecords: e, schedulingProfile: t }) {
  if (!t)
    return { valid: !0 };
  if (!Array.isArray(t))
    return { valid: !1, error: J };
  let { venueIds: r, tournamentsMap: i } = x_({ tournamentRecords: e }), n, a, o = t.every((s) => {
    let { scheduleDate: c, venues: u } = s;
    return Kr(c) ? u.every((d) => {
      let { venueId: p, rounds: l } = d;
      return typeof p != "string" ? (a = "venueId should be a string", !1) : Array.isArray(l) ? r.includes(p) ? !!l.every((m) => {
        var P, b, T, R;
        if (!m)
          return a = "empty round", !1;
        let { roundSegment: f, tournamentId: h, structureId: g, roundNumber: I, eventId: y, drawId: U } = m, S = (R = (T = (b = (P = i == null ? void 0 : i[h]) == null ? void 0 : P[y]) == null ? void 0 : b[U]) == null ? void 0 : T[g]) == null ? void 0 : R.includes(I);
        S || (a = "Invalid rounds");
        let { segmentNumber: D, segmentsCount: w } = f || {}, v = !f || Pe(D) && Qi(w) && D <= w;
        return v || (a = "Invalid segment"), S && v;
      }) : (n = zo, !1) : (a = "rounds should be an array", !1);
    }) : !1;
  });
  return !o && !n && (n = J), { valid: !!o, error: n, info: a };
}
function F_(e) {
  let { tournamentRecord: t = {}, tournamentMap: r = {}, requireCourts: i } = e, n = [], a = [], o = [], s = [], c = ((t == null ? void 0 : t.venues) || []).map(({ venueId: d, courts: p }) => (!i || (p == null ? void 0 : p.length)) && d), u = t == null ? void 0 : t.tournamentId;
  return u && (n.push(u), r[u] = {}, ((t == null ? void 0 : t.events) || []).forEach((d) => {
    let p = d.eventId;
    o.push(p), r[u][p] = {}, (d.drawDefinitions || []).forEach((l) => {
      let m = l.drawId;
      s.push(m), r[u][p][m] = {};
      let { structures: f } = Bi({ drawDefinition: l });
      (f || []).forEach((h) => {
        var S;
        let g = h.structureId, { matchUps: I } = Ke({ structure: h }), { roundMatchUps: y } = Pr({ matchUps: I }), U = y && Object.keys(y).map((D) => parseInt(D));
        r[u][p][m][g] = U, a.push(g), (S = h.structures) != null && S.length && h.structures.forEach((D) => {
          a.push(D.structureId), r[u][p][m][D.structureId] = U;
        });
      });
    });
  })), { tournamentMap: r, tournamentIds: n, structureIds: a, venueIds: c, eventIds: o, drawIds: s };
}
function x_(e) {
  let t = (e == null ? void 0 : e.tournamentRecords) && Object.values(e == null ? void 0 : e.tournamentRecords) || [], r = {}, { venueIds: i, eventIds: n, drawIds: a, structureIds: o, tournamentIds: s } = t.reduce((c, u) => {
    let { tournamentIds: d, tournamentMap: p, structureIds: l, venueIds: m, eventIds: f, drawIds: h } = F_({ tournamentRecord: u });
    return m.forEach((g) => {
      c.venueIds.includes(g) || c.venueIds.push(g);
    }), c.tournamentIds.push(...d), c.structureIds.push(...l), c.eventIds.push(...f), c.drawIds.push(...h), Object.assign(r, p), c;
  }, { tournamentIds: [], structureIds: [], venueIds: [], eventIds: [], drawIds: [] });
  return { tournamentsMap: r, tournamentIds: s, structureIds: o, venueIds: i, eventIds: n, drawIds: a };
}
function oa({ tournamentRecords: e, tournamentRecord: t }) {
  if (typeof e != "object" || !Object.keys(e).length)
    return { error: yt };
  let { extension: r } = Ne({ element: t, name: _o, tournamentRecords: e, discover: !0 }), i = (r == null ? void 0 : r.value) || [];
  if (i.length) {
    let { venueIds: n } = Pd({ requireCourts: !0, tournamentRecords: e }), { eventIds: a, drawIds: o } = kI({ tournamentRecords: e }), { updatedSchedulingProfile: s, modifications: c, issues: u } = mM({ schedulingProfile: i, venueIds: n, eventIds: a, drawIds: o });
    if (c) {
      i = s;
      let d = Tc({ tournamentRecords: e, tournamentRecord: t, schedulingProfile: i });
      return d.error ? d : { schedulingProfile: i, modifications: c, issues: u };
    }
  }
  return { schedulingProfile: i, modifications: 0 };
}
function Tc({ tournamentRecords: e, tournamentRecord: t, schedulingProfile: r }) {
  let i = hm({ tournamentRecords: e, schedulingProfile: r });
  return i.error ? i : r ? Ve({ tournamentRecords: e, discover: !0, extension: { name: _o, value: r } }) : Sr({ element: t, name: _o, tournamentRecords: e, discover: !0 });
}
function Td(e) {
  let { tournamentRecord: t } = e, r = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!e.schedulingProfile) {
    let { modifications: u, issues: d } = oa({ tournamentRecords: r, tournamentRecord: t });
    return { success: !u, modifications: u, issues: d };
  }
  let { venueIds: i } = Pd({ tournamentRecords: r }), { eventIds: n, drawIds: a } = kI({ tournamentRecords: r }), { updatedSchedulingProfile: o, modifications: s, issues: c } = mM({ schedulingProfile: e.schedulingProfile, venueIds: i, eventIds: n, drawIds: a });
  return s ? { ...Tc({ schedulingProfile: o, tournamentRecords: r }), modifications: s, issues: c } : { ...V, modifications: s, issues: c };
}
function wU(e) {
  let { scheduleDates: t = [], tournamentRecords: r, periodLength: i = 30 } = e ?? {};
  if (typeof r != "object")
    return { error: Pu };
  if (!Array.isArray(t))
    return { error: J };
  if (!t.every(Kr))
    return { error: Qt };
  let n = [], a = 0, o = {}, { schedulingProfile: s } = oa({ tournamentRecords: r });
  if (!s)
    return { issues: n, ...V };
  let { matchUps: c } = en({ nextMatchUps: !0, tournamentRecords: r });
  for (let d of s) {
    let { scheduleDate: p, venues: l = [] } = d;
    if (!(t != null && t.length) || t.includes(p)) {
      for (let m of l || [])
        if (m) {
          let { rounds: f } = m, h = [], { orderedMatchUpIds: g, scheduledRoundsDetails: I } = Dd({ tournamentRecords: r, periodLength: i, matchUps: c, rounds: f }), { matchUpDependencies: y } = qi({ tournamentRecords: r, matchUps: c }), U = (S) => {
            let D;
            return I == null || I.find((w, v) => {
              let P = w.matchUpIds.includes(S);
              return P && (D = v), P;
            }), D;
          };
          if (g == null || g.forEach((S, D) => {
            var P;
            let w = g.slice(D + 1), v = wt(w, ((P = y == null ? void 0 : y[S]) == null ? void 0 : P.matchUpIds) || []);
            v.length && h.push({ matchUpId: S, shouldBeAfter: v });
          }), h.length) {
            a += h.length;
            let S = h.map(({ matchUpId: D, shouldBeAfter: w }) => {
              let v = U(D), P = Te(w.map(U));
              return o[p] || (o[p] = {}), o[p][v] || (o[p][v] = []), P.forEach((b) => {
                o[p][v].includes(b) || o[p][v].push(b);
              }), { matchUpId: D, matchUpRoundIndex: v, earlierRoundIndices: P, shouldBeAfter: w };
            });
            n.push(...S);
          }
        }
    }
  }
  let u = { matchUpIdShouldBeAfter: Object.assign({}, ...n.map((d) => {
    let { matchUpId: p, shouldBeAfter: l, earlierRoundIndices: m } = d;
    return { [p]: { earlierRoundIndices: m, shouldBeAfter: l } };
  })) };
  return { issuesCount: a, profileIssues: u, roundIndexShouldBeAfter: o, ...V };
}
function Uo(e) {
  let { tournamentRecords: t, requestType: r } = e, i = fe(e, [{ [gr]: !0 }]);
  if (i.error)
    return i;
  let n = {};
  for (let a of Object.values(t)) {
    let { extension: o } = Ne({ element: a, name: fc }), s = (o == null ? void 0 : o.value) || [];
    for (let c of s) {
      let { personId: u, requests: d } = c || {};
      n[u] || (n[u] = []);
      for (let p of d)
        r && p.requestType !== r || n[u].push(p);
    }
  }
  return { personRequests: n, ...V };
}
function oh(e) {
  let { containerStructureId: t, roundSegment: r, isRoundRobin: i, tournamentId: n, roundNumber: a, structureId: o, eventId: s, drawId: c } = e, u = i ? t : o, d = [n, s, c, u, a].join("|");
  return me({ structureId: u, roundSegment: r, tournamentId: n, roundNumber: a, eventId: s, drawId: c, id: d });
}
function kS({ round: e, matchUps: t, events: r, tournamentRecords: i }) {
  let n = r.find((l) => l.eventId === e.eventId), { eventType: a, category: o, categoryType: s } = n || {}, { categoryName: c, ageCategoryCode: u } = o || {}, d = Qr(t.map(({ matchUpFormat: l }) => l)), p = 0;
  return Object.keys(d).forEach((l) => {
    let m = d[l], f = fm({ categoryName: c || u, tournamentId: e.tournamentId, eventId: e.eventId, tournamentRecords: i, matchUpFormat: l, categoryType: s, eventType: a });
    if (f.error)
      return f;
    let h = f.averageMinutes * m;
    isNaN(p) || (p += h);
  }), { roundMinutes: p };
}
function L_(e) {
  return (e || []).reduce((t, r) => {
    var a, o;
    let i = (((a = r.finishingPositionRange) == null ? void 0 : a.winner) || []).reduce((s, c) => s + c, 0), n = (((o = r.finishingPositionRange) == null ? void 0 : o.winner) || []).join("-") || "";
    return !t.minFinishingSum || i < t.minFinishingSum ? { minFinishingSum: i, winnerFinishingPositionRange: n } : t;
  }, { minFinishingSum: 0, winnerFinishingPositionRange: "" });
}
function FS(e) {
  let t = e.length, r = e.filter(({ sides: u }) => u == null ? void 0 : u.some(({ bye: d }) => d)).length || 0, i = e.filter(({ winningSide: u, matchUpStatus: d }) => u || Vt.includes(d)).length || 0, n = e.filter(({ schedule: u, matchUpStatus: d }) => (u == null ? void 0 : u.scheduledDate) && (u == null ? void 0 : u.scheduledTime) && d !== $e).length || 0, a = t - r, o = a === i, s = a - n, c = a - n;
  return { unscheduledCount: s, incompleteCount: c, scheduledCount: n, completedCount: i, matchUpsCount: t, isScheduled: a === n, isComplete: o, byeCount: r };
}
function gm({ tournamentRecords: e, schedulingProfile: t, tournamentRecord: r, withRoundId: i }) {
  if (r && !e) {
    if (typeof r != "object")
      return { error: Pu };
    e = { [r.tournamentId]: r };
  }
  if (t) {
    let a = hm({ tournamentRecords: e, schedulingProfile: t });
    if (a.error)
      return a;
  }
  if (!t && e) {
    let a = oa({ tournamentRecords: e });
    if (a.error)
      return a;
    t = a.schedulingProfile;
  }
  if (!t)
    return { error: Zt };
  let n = {};
  return { profileRounds: t.map(({ venues: a, scheduleDate: o }) => a.map(({ rounds: s }) => s.map((c) => {
    var d;
    let u = oh(c);
    return (d = u.roundSegment) != null && d.segmentsCount && (n[u.id] = u.roundSegment.segmentsCount), me({ id: i ? u.id : void 0, scheduleDate: o, ...u });
  }))).flat(1 / 0), segmentedRounds: n };
}
function Im({ courtPrefix: e = "C|", minRowsCount: t, courtsData: r }) {
  if (!Array.isArray(r))
    return { error: J };
  let i = r == null ? void 0 : r.reduce((o, s) => {
    let c = s.matchUps || [], u = Math.max(0, ...c.map((d) => d.schedule.courtOrder || 0));
    return u > o ? u : o;
  }, 1), n = t ? Math.max(t, i) : i, a = oe(0, n).map((o) => ({ matchUps: oe(0, r.length).map((s) => {
    let c = r[s], { courtId: u, venueId: d } = c;
    return { schedule: { courtOrder: o + 1, venueId: d, courtId: u } };
  }) }));
  return r.forEach((o, s) => {
    var c;
    for (let u of o.matchUps) {
      let d = (c = u.schedule) == null ? void 0 : c.courtOrder;
      d && (a[d - 1].matchUps[s] = u);
    }
  }), { courtPrefix: e, rows: a.map((o, s) => Object.assign({ rowId: `rowId-${s + 1}` }, ...o.matchUps.map((c, u) => ({ [`${e}${u}`]: c })))) };
}
var fM = {};
Ae(fM, { getEntriesAndSeedsCount: () => Um, getMaxEntryPosition: () => PU });
function Um({ policyDefinitions: e, drawDefinition: t, drawSize: r, drawId: i, event: n, stage: a }) {
  if (!n)
    return { error: pt };
  let { entries: o, stageEntries: s } = ST({ drawDefinition: t, drawId: i, stage: a, event: n }), c = s.length, { drawSize: u } = Wb({ participantsCount: c }), d = vd({ drawSize: r ?? u, participantsCount: c, policyDefinitions: e });
  if (d.error)
    return j({ result: d, stack: "getEntriesAndSeedsCount" });
  let { seedsCount: p } = d;
  return { entries: o, seedsCount: p, stageEntries: s };
}
function PU(e) {
  let { entries: t = [], entryStatus: r, stage: i } = e;
  return Math.max(...t.filter((n) => (!i || i === n.entryStage) && (!r || n.entryStatus === r) && !isNaN(n.entryPosition)).map(({ entryPosition: n }) => ye(n || 0)), 0);
}
var hM = {};
Ae(hM, { allCompetitionMatchUps: () => en, allDrawMatchUps: () => vr, allEventMatchUps: () => Ln, allTournamentMatchUps: () => tr, analyzeMatchUp: () => Uu, calculateWinCriteria: () => gs, checkMatchUpIsComplete: () => ja, competitionScheduleMatchUps: () => Rd, drawMatchUps: () => kU, eventMatchUps: () => Sm, filterMatchUps: () => Vn, getAllDrawMatchUps: () => Bt, getAllStructureMatchUps: () => Ke, getCheckedInParticipantIds: () => as, getCompetitionMatchUps: () => Iu, getEventMatchUpFormatTiming: () => TU, getHomeParticipantId: () => NU, getMatchUpCompetitiveProfile: () => Ju, getMatchUpContextIds: () => AU, getMatchUpDailyLimits: () => wm, getMatchUpDailyLimitsUpdate: () => bU, getMatchUpDependencies: () => qi, getMatchUpFormat: () => EU, getMatchUpFormatTiming: () => Xu, getMatchUpFormatTimingUpdate: () => DU, getMatchUpScheduleDetails: () => kp, getMatchUpType: () => Fp, getMatchUpsStats: () => CU, getModifiedMatchUpFormatTiming: () => ym, getParticipantResults: () => hd, getPredictiveAccuracy: () => MU, getRoundMatchUps: () => Pr, getRounds: () => OU, isValidMatchUpFormat: () => Jr, matchUpActions: () => Jp, participantScheduledMatchUps: () => RU, tallyParticipantResults: () => Dc, tournamentMatchUps: () => vm, validMatchUp: () => Np, validMatchUps: () => Ti });
function gM({ tournamentRecords: e, extensionName: t }) {
  if (typeof e != "object" || !Object.keys(e).length)
    return { error: yt };
  let r = [], i;
  for (let n of Object.values(e)) {
    let { extension: a } = Ne({ element: n, name: t });
    a && !i && (r.push({ params: { extension: a, discover: !0 }, method: "addExtension" }), i = !0);
    let o = n.events ?? [];
    for (let s of o) {
      let { eventId: c } = s, { extension: u } = Ne({ name: t, element: s });
      u && r.push({ params: { eventId: c, extension: u }, method: "addEventExtension" });
    }
  }
  return { methods: r };
}
function DU({ tournamentRecords: e }) {
  return gM({ extensionName: Kn, tournamentRecords: e });
}
var rf = "ADULT", nf = "JUNIOR", Ld = "WHEELCHAIR", IM = { [Ra]: { allowModificationWhenMatchUpsScheduled: { courts: !1, venues: !1 }, defaultTimes: { averageTimes: [{ categoryNames: [], minutes: { default: 90 } }], recoveryTimes: [{ minutes: { [tt]: 30, default: 60 } }] }, defaultDailyLimits: { [rt]: 2, [tt]: 2, total: 3 }, matchUpAverageTimes: [{ matchUpFormatCodes: [Oi], averageTimes: [{ categoryNames: [], minutes: { default: 90 } }, { categoryTypes: [Ld], minutes: { default: 120 } }] }, { matchUpFormatCodes: ["SET3-S:6/TB7-F:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 85 } }] }, { matchUpFormatCodes: ["SET3-S:6/TB7-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 70 } }] }, { matchUpFormatCodes: ["SET3-S:4NOAD-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 55 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 60 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 50 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 55 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB5@3"], averageTimes: [{ categoryNames: [], minutes: { default: 45 } }] }, { matchUpFormatCodes: ["SET1-S:8/TB7", "SET1-S:8/TB7@7"], averageTimes: [{ categoryNames: [], minutes: { default: 40 } }] }, { matchUpFormatCodes: ["SET1-S:5/TB9@4"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:6/TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:6NOAD"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:4/TB7", "SET1-S:4/TB5@3", "SET3-S:TB10", "SET1-S:T20"], averageTimes: [{ categoryNames: [], minutes: { default: 20 } }] }, { matchUpFormatCodes: ["SET1-S:4NOAD"], averageTimes: [{ categoryNames: [], minutes: { default: 20 } }] }, { matchUpFormatCodes: ["SET1-S:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 10 } }] }], matchUpRecoveryTimes: [{ matchUpFormatCodes: ["SET3-S:6/TB7", "SET3-S:6/TB7-F:TB10", "SET3-S:6/TB7-F:TB7"], recoveryTimes: [{ categoryTypes: [rf, Ld], minutes: { default: 60, [tt]: 30 } }, { categoryTypes: [nf], minutes: { default: 60, [tt]: 60 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB7", "SET3-S:4/TB7-F:TB10", "SET3-S:4NOAD-F:TB7", "SET3-S:4/TB7", "SET3-S:4/TB5@3"], recoveryTimes: [{ categoryTypes: [rf, Ld], minutes: { default: 30 } }, { categoryTypes: [nf], minutes: { default: 60 } }] }, { matchUpFormatCodes: ["SET1-S:8/TB7", "SET1-S:8/TB7@7", "SET1-S:5/TB9@4", "SET1-S:6/TB7", "SET1-S:6NOAD", "SET1-S:4/TB7", "SET1-S:4NOAD", "SET3-S:TB10", "SET1-S:T20"], recoveryTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:4/TB5@3"], recoveryTimes: [{ categoryTypes: [rf, nf], minutes: { default: 30 } }, { categoryTypes: [Ld], minutes: { default: 15 } }] }, { matchUpFormatCodes: ["SET1-S:TB10"], recoveryTimes: [{ categoryNames: [], minutes: { default: 15 } }] }], matchUpDailyLimits: [] } }, __ = IM;
function TU({ tournamentRecord: e, matchUpFormats: t, categoryType: r, event: i }) {
  if (!i)
    return { error: pt };
  let n = [], a;
  if (t != null && t.length) {
    let p = [];
    n = t.map((l) => {
      let m = typeof l == "string" ? { matchUpFormat: l } : l;
      if (!p.includes(m == null ? void 0 : m.matchUpFormat) && Jr({ matchUpFormat: m == null ? void 0 : m.matchUpFormat }))
        return p.push(m.matchUpFormat), m;
    }).filter(Boolean);
  } else {
    let { policy: p } = lo({ policyType: yi, tournamentRecord: e, event: i });
    if (p != null && p.matchUpFormats)
      n = p == null ? void 0 : p.matchUpFormats;
    else {
      let { extension: l } = Ne({ name: Kn, element: i }), m, f;
      l != null && l.value ? { matchUpAverageTimes: m, matchUpRecoveryTimes: f } = l.value : { matchUpAverageTimes: m, matchUpRecoveryTimes: f } = __[Ra], n = Te([...(m || []).map((h) => h.matchUpFormatCodes), ...(f || []).map((h) => h.matchUpFormatCodes)].flat()).map((h) => ({ matchUpFormat: h })), a = "default scheduling policy in use";
    }
  }
  let { eventType: o, eventId: s, category: c } = i, u = (c == null ? void 0 : c.categoryName) ?? (c == null ? void 0 : c.ageCategoryCode) ?? s;
  if (!s)
    return { error: pt };
  let d = n.map(({ matchUpFormat: p, description: l }) => {
    let m = Xu({ tournamentRecord: e, matchUpFormat: p, categoryName: u, categoryType: r, eventType: o, event: i });
    return { matchUpFormat: p, description: l, ...m };
  });
  return me({ eventMatchUpFormatTiming: d, info: a });
}
function ym(e) {
  let t = fe(e, [{ [Gt]: !0 }, { [cr]: (h) => Jr({ matchUpFormat: h }), [ci]: bu, [cg]: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, matchUpFormat: i, event: n } = e, { extension: a } = Ne({ name: Kn, element: n }), o = a == null ? void 0 : a.value, { extension: s } = Ne({ element: r, name: Kn }), c = s == null ? void 0 : s.value, u = (o == null ? void 0 : o.matchUpAverageTimes) && Gc({ ...o, matchUpFormat: i }), d = (c == null ? void 0 : c.matchUpAverageTimes) && Gc({ ...c, matchUpFormat: i }), p = [u, d].find((h) => h), l = (o == null ? void 0 : o.matchUpRecoveryTimes) && $c({ ...o, matchUpFormat: i }), m = (c == null ? void 0 : c.matchUpRecoveryTimes) && $c({ ...c, matchUpFormat: i }), f = [l, m].find((h) => h);
  return { matchUpFormat: i, recoveryTimes: f, averageTimes: p };
}
function bU({ tournamentRecords: e }) {
  return gM({ extensionName: _u, tournamentRecords: e });
}
var bd = ({ scheduleAttributes: e = ["scheduledDate", "scheduledTime"], schedule: t = {} }) => !!Object.keys(t).filter((r) => e.includes(r)).filter((r) => t[r]).length;
function RU({ scheduleAttributes: e = ["scheduledDate", "scheduledTime"], matchUps: t = [] }) {
  if (!Ti(t))
    return { error: Zn };
  if (!Array.isArray(e))
    return { error: J };
  let r = t.filter(Boolean).filter(({ schedule: i }) => bd({ schedule: i, scheduleAttributes: e })).reduce((i, n) => {
    let { schedule: a } = n, o = be(a == null ? void 0 : a.scheduledDate), s = mt(a == null ? void 0 : a.scheduledTime);
    return o && s && (i[o] ? i[o].push(n) : i[o] = [n]), i;
  }, {});
  return Object.keys(r).forEach((i) => {
    r[i].sort((n, a) => {
      var o, s;
      return tP(mt((o = n.schedule) == null ? void 0 : o.scheduledTime), mt((s = a.schedule) == null ? void 0 : s.scheduledTime));
    });
  }), { ...V, scheduledMatchUps: r };
}
function B_({ tournamentRecords: e }) {
  var i;
  let t = {}, r = [];
  for (let n of Object.values(e))
    for (let a of n.events ?? []) {
      let o = bi({ event: a }), s = o == null ? void 0 : o.drawDetails;
      Le(s) ? (Object.assign(t, s), r.push(...Object.keys(s).filter((c) => tI({ drawId: c, drawDetails: s })))) : (i = o == null ? void 0 : o.drawIds) != null && i.length && r.push(...o.drawIds);
    }
  return { drawIds: r, detailsMap: t };
}
function Cl({ schedulingProfile: e, matchUps: t = [] }) {
  let r = {}, i = ({ eventId: s, drawId: c, structureId: u, roundNumber: d }) => `${s}|${c}|${u}${d}`;
  e != null && e.length && e.map(({ venues: s }) => s.map(({ rounds: c }) => c)).flat().forEach((s) => {
    s.sort((c, u) => (c.sortOrder || 0) - (u.sortOrder || 0)).forEach(({ eventId: c, drawId: u, structureId: d, roundNumber: p }, l) => {
      let m = i({ eventId: c, drawId: u, structureId: d, roundNumber: p });
      r[m] = l;
    });
  });
  let n = [], a = { noScheduledDate: [] };
  for (let s of t) {
    let c = s.schedule || {}, u = c.scheduledDate && be(c.scheduledDate) || c.scheduledTime && be(c.scheduledTime) || "noScheduledDate";
    a[u] || (a[u] = []), a[u].push(s);
  }
  let o = Object.keys(a).sort();
  for (let s of o) {
    let c = a[s], u = { noScheduledTime: [] };
    for (let p of c) {
      let l = p.schedule || {}, m = l.scheduledTime && mt(l.scheduledTime) || "noScheduledTime";
      u[m] || (u[m] = []), u[m].push(p);
    }
    let d = Object.keys(u).sort();
    for (let p of d) {
      let l = u[p];
      l.sort((m, f) => {
        let h = r[i(m)] || 0, g = r[i(f)] || 0;
        return h - g;
      }), n.push(...l);
    }
  }
  return n;
}
function Sm(e) {
  let { participants: t, contextContent: r, participantMap: i } = e, { tournamentAppliedPolicies: n, scheduleVisibilityFilters: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, usePublishState: p, contextFilters: l, matchUpFilters: m, contextProfile: f, nextMatchUps: h, tournamentId: g, inContext: I, context: y, event: U } = e;
  if (!U)
    return { error: pt };
  let { eventId: S, eventName: D, endDate: w, eventType: v, category: P, gender: b } = U ?? {}, T = { ...y, ...me({ surfaceCategory: U.surfaceCategory ?? (d == null ? void 0 : d.surfaceCategory), indoorOutDoor: U.indoorOutdoor ?? (d == null ? void 0 : d.indoorOutdoor), tournamentId: g ?? (d == null ? void 0 : d.tournamentId), endDate: w ?? (d == null ? void 0 : d.endDate), eventName: D, eventType: v, category: P, eventId: S, gender: b }) }, R;
  !t && d && ({ participants: t, participantMap: i, groupInfo: R } = es({ participantsProfile: o, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, contextProfile: f, inContext: I })), f && !r && (r = ia({ policyDefinitions: c, tournamentRecord: d, contextProfile: f, event: U }));
  let M = bi({ event: U });
  return { ...(U.drawDefinitions ?? []).reduce((E, C) => {
    var N;
    let A = Uc({ hydrateParticipants: e.hydrateParticipants, context: T, tournamentAppliedPolicies: n, scheduleVisibilityFilters: a, tournamentParticipants: t, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: d, usePublishState: p, contextContent: r, contextFilters: l, matchUpFilters: m, participantMap: i, publishStatus: M, contextProfile: f, drawDefinition: C, nextMatchUps: h, inContext: I, event: U });
    return (N = Object.keys(A)) == null || N.forEach((O) => {
      Array.isArray(A[O]) && (E[O] || (E[O] = []), E[O] = E[O].concat(A[O]));
    }), E;
  }, {}), ...V, groupInfo: R };
}
function vm(e) {
  if (!(e != null && e.tournamentRecord))
    return { error: ae };
  let t = e.contextContent, { scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, inContext: c = !0, usePublishState: u, contextFilters: d, matchUpFilters: p, contextProfile: l, nextMatchUps: m, context: f } = e, h = e.tournamentId ?? s.tournamentId, g = (s == null ? void 0 : s.events) ?? [], { participants: I, participantMap: y, groupInfo: U } = es({ participantsProfile: i, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, contextProfile: l, inContext: c });
  l && !t && (t = ia({ policyDefinitions: a, tournamentRecord: s, contextProfile: l }));
  let { appliedPolicies: S } = je({ tournamentRecord: s }), D = (d == null ? void 0 : d.eventIds) ?? [];
  return { ...g.filter((w) => !D.includes(w.eventId)).map((w) => {
    var P, b, T;
    let v = { eventDrawsCount: ((b = (P = Pt({ event: w }).flightProfile) == null ? void 0 : P.flights) == null ? void 0 : b.length) || ((T = w.drawDefinitions) == null ? void 0 : T.length) || 0, ...f };
    return Sm({ hydrateParticipants: e.hydrateParticipants, context: v, tournamentAppliedPolicies: S, scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: s, usePublishState: u, contextFilters: d, contextProfile: l, contextContent: t, matchUpFilters: p, participantMap: y, participants: I, tournamentId: h, nextMatchUps: m, inContext: c, event: w });
  }).reduce((w, v) => {
    var P;
    return (P = v && Object.keys(v).filter((b) => !["success", "matchUpsMap"].includes(b))) == null || P.forEach((b) => {
      Array.isArray(v[b]) && (w[b] || (w[b] = []), w[b] = w[b].concat(v[b]), w.matchUpsCount += v[b].length);
    }), w;
  }, { matchUpsCount: 0 }), groupInfo: U };
}
function Iu({ scheduleVisibilityFilters: e, hydrateParticipants: t, participantsProfile: r, tournamentRecords: i, policyDefinitions: n, usePublishState: a, matchUpFilters: o, contextFilters: s, nextMatchUps: c, inContext: u }) {
  if (typeof i != "object" || !Object.keys(i).length)
    return { error: yt };
  let d = Object.keys(i).map((l) => {
    let m = i[l];
    return vm({ scheduleVisibilityFilters: e, hydrateParticipants: t, participantsProfile: r, policyDefinitions: n, tournamentRecord: m, usePublishState: a, matchUpFilters: o, contextFilters: s, nextMatchUps: c, inContext: u });
  }), p = {};
  return { ...d.reduce((l, m) => (Object.keys(m).forEach((f) => {
    Array.isArray(m[f]) && (l[f] || (l[f] = []), l[f] = l[f].concat(m[f])), f === "groupInfo" && Object.assign(p, m[f]);
  }), l), {}), groupInfo: p };
}
function Rd(e) {
  var M, E, C, A, N, O, k;
  if (typeof (e == null ? void 0 : e.tournamentRecords) != "object" || !Object.keys(e == null ? void 0 : e.tournamentRecords).length)
    return { error: yt };
  let { courts: t, venues: r } = aa(e), i = oa(e).schedulingProfile, { sortDateMatchUps: n = !0, courtCompletedMatchUps: a, alwaysReturnCompleted: o, activeTournamentId: s, tournamentRecords: c, withCourtGridRows: u, minCourtGridRows: d, usePublishState: p, status: l = li, sortCourtsData: m } = e, f = s ?? Yo() ?? Object.keys(c)[0], h = p ? nd({ tournamentRecord: c[f], status: l }) : void 0, g = o ? Iu({ ...e, matchUpFilters: { ...e.matchUpFilters, matchUpStatuses: [Tt] }, contextFilters: e.contextFilters }).completedMatchUps : [];
  if (p && !((M = h == null ? void 0 : h.orderOfPlay) != null && M.published))
    return { completedMatchUps: g, dateMatchUps: [], courtsData: [], venues: r };
  let I, y;
  p && ({ drawIds: I, detailsMap: y } = B_({ tournamentRecords: c })), I != null && I.length && (e.contextFilters || (e.contextFilters = {}), (E = e.contextFilters) != null && E.drawIds ? e.contextFilters.drawIds = e.contextFilters.drawIds.filter((F) => I.includes(F)) : e.contextFilters.drawIds = I), (C = h == null ? void 0 : h.eventIds) != null && C.length && (e.matchUpFilters || (e.matchUpFilters = {}), (A = e.matchUpFilters) != null && A.eventIds && e.matchUpFilters.eventIds.length ? e.matchUpFilters.eventIds = e.matchUpFilters.eventIds.filter((F) => h.eventIds.includes(F)) : e.matchUpFilters.eventIds = h.eventIds), (N = h == null ? void 0 : h.scheduledDates) != null && N.length && (e.matchUpFilters || (e.matchUpFilters = {}), e.matchUpFilters.scheduledDates && e.matchUpFilters.scheduledDates.length ? e.matchUpFilters.scheduledDates = e.matchUpFilters.scheduledDates.filter((F) => h.scheduledDates.includes(F)) : e.matchUpFilters.scheduledDates = h.scheduledDates), o && (e.matchUpFilters || (e.matchUpFilters = {}), (k = (O = e.matchUpFilters) == null ? void 0 : O.excludeMatchUpStatuses) != null && k.length ? e.matchUpFilters.excludeMatchUpStatuses.includes(Tt) || e.matchUpFilters.excludeMatchUpStatuses.push(Tt) : e.matchUpFilters.excludeMatchUpStatuses = [Tt]);
  let { completedMatchUps: U, upcomingMatchUps: S, pendingMatchUps: D, groupInfo: w } = Iu({ ...e, matchUpFilters: e.matchUpFilters, contextFilters: e.contextFilters }), v = [...S ?? [], ...D ?? []];
  y && (!(I != null && I.length) || Object.keys(y).length) && (v = v.filter((F) => {
    var L, G;
    let { drawId: x, structureId: _, stage: B } = F;
    if (!((G = (L = y == null ? void 0 : y[x]) == null ? void 0 : L.publishingDetail) != null && G.published))
      return !1;
    if (y[x].stageDetails) {
      let $ = Object.keys(y[x].stageDetails), W = $.filter((K) => !y[x].stageDetails[K].published), q = $.filter((K) => y[x].stageDetails[K].published);
      return W.length && W.includes(B) ? !1 : q.length && q.includes(B) ? !0 : W.length && !W.includes(B) && !q.length;
    }
    if (y[x].structureDetails) {
      let $ = Object.keys(y[x].structureDetails), W = $.filter((K) => !y[x].structureDetails[K].published), q = $.filter((K) => y[x].structureDetails[K].published);
      return W.length && W.includes(_) ? !1 : q.length && q.includes(_) ? !0 : W.length && !W.includes(_) && !q.length;
    }
    return !0;
  }));
  let P = n ? Cl({ matchUps: v, schedulingProfile: i }) : v, b = t == null ? void 0 : t.map((F) => {
    let x = R(F);
    return { surfaceCategory: (F == null ? void 0 : F.surfaceCategory) ?? "", matchUps: x, ...F };
  }), T = { completedMatchUps: o ? g : U, dateMatchUps: P, courtsData: b, groupInfo: w, venues: r };
  if (u) {
    let { rows: F, courtPrefix: x } = Im({ minRowsCount: d, courtsData: b });
    T.courtPrefix = x, T.rows = F;
  }
  return { ...T, ...V };
  function R({ courtId: F }) {
    let x = (a ? P.concat(U ?? []) : P).filter((_) => {
      var B, L, G;
      return ((B = _.schedule) == null ? void 0 : B.courtId) === F || ((G = (L = _.schedule) == null ? void 0 : L.allocatedCourts) == null ? void 0 : G.map(({ courtId: $ }) => $).includes(F));
    });
    return m ? Cl({ matchUps: x, schedulingProfile: i }) : x;
  }
}
function wm({ tournamentRecords: e, tournamentId: t }) {
  if (typeof e != "object" || !Object.keys(e).length)
    return { error: yt };
  let r = Object.keys(e).filter((n) => !t || n === t), i;
  return r.forEach((n) => {
    let a = e[n], { matchUpDailyLimits: o } = V_({ tournamentRecord: a });
    i = o;
  }), { matchUpDailyLimits: i };
}
function V_(e) {
  var s;
  let t = fe(e, [{ [Gt]: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r } = e, { policy: i } = lo({ policyType: Ra, tournamentRecord: r }), { extension: n } = Ne({ element: r, name: _u }), a = (s = n == null ? void 0 : n.value) == null ? void 0 : s.dailyLimits, o = i == null ? void 0 : i.defaultDailyLimits;
  return { matchUpDailyLimits: a || o };
}
function MU(e) {
  var C, A, N, O;
  let { matchUps: t } = e, { singlesForDoubles: r, tournamentRecord: i, drawDefinition: n, excludeMargin: a, exclusionRule: o, zoneDoubling: s, matchUpType: c, scaleName: u, eventId: d, zonePct: p, drawId: l, event: m } = e;
  if (!i && !t)
    return { error: ae };
  if (c && ![rt, tt].includes(c))
    return { error: J, info: { matchUpType: c } };
  if (t && !Ti(t))
    return { error: J, context: { matchUps: t } };
  let f = Wt[u], h = (f == null ? void 0 : f.ascending) ?? e.ascending ?? !1, g = (f == null ? void 0 : f.accessor) ?? e.valueAccessor, I = Array.isArray(f == null ? void 0 : f.range) ? Math.abs(f.range[0] - f.range[1]) : 0, y = Pe(p) && I ? (p ?? 0 / 100) * I : e.zoneMargin ?? I, U = { withScaleValues: !0, withCompetitiveness: !0 }, S = { matchUpTypes: c ? [c] : [rt, tt] }, D = i == null ? void 0 : i.participants;
  (C = t == null ? void 0 : t[0]) != null && C.hasContext ? l ? t = t.filter((k) => k.drawId === l) : d && (t = t.filter((k) => k.eventId === d)) : t === void 0 && (t = l && !n && [] || !l && d && !m && [] || l && ((A = vr({ inContext: !0, drawDefinition: n, contextFilters: S, contextProfile: U, participants: D })) == null ? void 0 : A.matchUps) || !l && d && ((N = Ln({ inContext: !0, contextFilters: S, contextProfile: U, participants: D, event: m })) == null ? void 0 : N.matchUps) || ((O = tr({ tournamentRecord: i, contextFilters: S, contextProfile: U })) == null ? void 0 : O.matchUps) || []), c && (t = t.filter((k) => k.matchUpType === c));
  let w = t.filter(({ winningSide: k, score: F, sides: x, matchUpStatus: _ }) => ![nr, ke, Be, hc, Gr].includes(_ ?? "") && jt({ score: F }) && (x == null ? void 0 : x.length) === 2 && k), v = G_({ matchUps: w, excludeMargin: a, exclusionRule: o, valueAccessor: g, ascending: h, scaleName: u }), P = !s || bt(rt)(c) ? y : (y || 0) * 2, b = y ? w.map(({ competitiveProfile: k, matchUpType: F, score: x, sides: _ }) => {
    let B = UM({ singlesForDoubles: r, valueAccessor: g, matchUpType: F, scaleName: u, sides: _ }), L = Math.abs(B[0].value - B[1].value);
    return { competitiveness: k == null ? void 0 : k.competitiveness, valuesGap: L, score: x };
  }).filter(({ valuesGap: k }) => k <= P) : [], T = j_({ zoneData: b }), R = T && [].concat(Object.values(T)).flat().length, M = R && Object.assign({}, ...Object.keys(T).map((k) => ({ [k]: Math.round(1e4 * T[k].length / R) / 100 }))), E = w.length - ((b == null ? void 0 : b.length) || 0);
  return { ...V, relevantMatchUps: w, zoneDistribution: M, zoneData: b, accuracy: v, nonZone: E };
}
function j_({ zoneData: e }) {
  let t = { [Gg]: [], [du]: [], [lu]: [] };
  for (let r of e) {
    let { competitiveness: i, score: n, valuesGap: a } = r;
    t[i] && t[i].push({ score: n, valuesGap: a });
  }
  return t;
}
function UM({ singlesForDoubles: e, exclusionRule: t, valueAccessor: r, matchUpType: i, scaleName: n, sides: a }) {
  let o = t == null ? void 0 : t.range.sort(), s = (c) => {
    let u = c == null ? void 0 : c[t == null ? void 0 : t.valueAccessor];
    return { exclude: t && u >= o[0] && u <= o[1], exclusionValue: u };
  };
  return a.sort((c, u) => c.sideNumber - u.sideNumber).map(({ participant: c }) => {
    let u = [], d = c == null ? void 0 : c.individualParticipants;
    if (d != null && d.length) {
      let p = [], l = 0;
      for (let m of d) {
        let { scaleValue: f, value: h } = xS({ singlesForDoubles: e, valueAccessor: r, participant: m, matchUpType: i, scaleName: n }), { exclude: g, exclusionValue: I } = s(f);
        g && u.push(I), p.push(f), h && !isNaN(l) ? l += h : l = void 0;
      }
      return { participantName: c.participantName, exclusionValues: u, scaleValues: p, value: l };
    } else if (c) {
      let { scaleValue: p, value: l } = xS({ singlesForDoubles: e, valueAccessor: r, matchUpType: i, participant: c, scaleName: n }), { exclude: m, exclusionValue: f } = s(p);
      return m && u.push(f), { participantName: c.participantName, exclusionValues: u, scaleValue: p, value: l };
    } else
      return {};
  });
}
function xS({ singlesForDoubles: e, valueAccessor: t, matchUpType: r, participant: i, scaleName: n }) {
  var u, d, p, l, m;
  let a = e ? rt : r, o = (d = (u = i == null ? void 0 : i.rankings) == null ? void 0 : u[a]) == null ? void 0 : d.find((f) => f.scaleName === n), s = (m = ((l = (p = i == null ? void 0 : i.ratings) == null ? void 0 : p[a]) == null ? void 0 : l.find((f) => f.scaleName === n)) || o) == null ? void 0 : m.scaleValue, c = t ? s == null ? void 0 : s[t] : s;
  return { scaleValue: s, value: c };
}
function G_({ excludeMargin: e, exclusionRule: t, valueAccessor: r, ascending: i, scaleName: n, matchUps: a }) {
  let o = { affirmative: [], negative: [], excluded: [] };
  for (let u of a) {
    let { matchUpType: d, sides: p, score: l, winningSide: m } = u;
    if (!m)
      continue;
    if (t && (!t.valueAccessor || !t.range))
      return { info: "exclusionRule requires valueAccessor and range", error: Ie };
    let f = m - 1, h = UM({ exclusionRule: t, valueAccessor: r, matchUpType: d, scaleName: n, sides: p });
    if (t) {
      let D = h.map(({ exclusionValues: w }) => w).flat();
      if (D.length) {
        o.excluded.push({ scoreString: l == null ? void 0 : l.scoreStringSide1, exclusionValues: D, winningSide: m, sideValues: h });
        continue;
      }
    }
    if (h.filter((D) => ![void 0, "", null].includes(D.value)).length < 2) {
      o.excluded.push({ scoreString: l == null ? void 0 : l.scoreStringSide1, missingValues: !0, winningSide: m, sideValues: h });
      continue;
    }
    let g = h[f].value - h[1 - f].value, I = parseFloat(e || 0), y = I && Math.abs(g) < I;
    if (y) {
      o.excluded.push({ scoreString: l == null ? void 0 : l.scoreStringSide1, excludeMargin: e, winningSide: m, excludeGap: y, sideValues: h, valuesGap: g });
      continue;
    }
    let U = i ? g : g * -1, S = m === 1 ? l == null ? void 0 : l.scoreStringSide1 : l == null ? void 0 : l.scoreStringSide2;
    U > 0 ? o.affirmative.push({ winningScoreString: S, winningSide: m, sideValues: h, valuesGap: g, score: l }) : o.negative.push({ winningScoreString: S, winningSide: m, sideValues: h, valuesGap: g, score: l });
  }
  let s = o.affirmative.length + o.negative.length, c = s && o.affirmative.length / s * 100;
  return o.percent = c ? Math.round(100 * c) / 100 : 0, o;
}
function gs({ collectionDefinitions: e = [], collectionGroups: t = [] }) {
  let r = 0, { groupValueNumbers: i } = Sb({ collectionGroups: t }), n;
  for (let a of e || []) {
    let { collectionValueProfiles: o, collectionGroupNumber: s, collectionValue: c, matchUpCount: u, matchUpValue: d, scoreValue: p, setValue: l } = a, m = s && i.includes(s);
    if (Pe(l || p))
      n = !0;
    else {
      if (m)
        continue;
      if (typeof c == "number" && Pe(c))
        r += c;
      else if (Array.isArray(o) && (o != null && o.length))
        for (let f of o)
          r += f.matchUpValue;
      else
        typeof d == "number" && Pe(d) && (r += (u ?? 0) * d);
    }
  }
  for (let a of t)
    r += a.groupValue ?? 0;
  return n || !r ? { aggregateValue: !0, ...V } : { valueGoal: Math.floor(r / 2) + 1, ...V };
}
function NU(e) {
  let { timeStamp: t, schedule: r, matchUp: i } = e, n = fe(e, [{ [Fn]: !0 }]);
  if (n.error)
    return n;
  let { itemValue: a, timeStamp: o } = fo({ timeItems: (i == null ? void 0 : i.timeItems) || [], itemType: Yg });
  return !r || o && t && new Date(o).getTime() > new Date(t).getTime() ? { homeParticipantId: a } : r;
}
function AU({ matchUps: e, matchUpId: t }) {
  if (!Ti(e))
    return { error: J };
  let r = e.find((s) => s.matchUpId === t), { drawId: i, eventId: n, structureId: a, tournamentId: o } = r || {};
  return { matchUpId: t, drawId: i, eventId: n, structureId: a, tournamentId: o };
}
function bc(e, t) {
  if (!Le(e))
    return { error: J };
  if (!Array.isArray(t))
    return { error: J };
  let r = {};
  for (let { param: i, error: n, attr: a } of t) {
    let o = $_({ params: e, param: i, attr: a, error: n });
    if (o != null && o.error)
      return o;
    r[i] = o;
  }
  return r;
}
function $_({ params: e, param: t, attr: r, error: i }) {
  if (t === hp && Le(e.drawDefinition) && ht(e.structureId)) {
    let n = (e.drawDefinition.structures ?? []).find(({ structureId: a }) => a === e.structureId);
    return !n.length && i ? { error: i } : { structure: n };
  }
  if (t === Fn) {
    let n = oM({ ...e, ...r });
    return n.error && i ? { ...n, error: i } : n;
  }
  return { error: Zt, info: { param: t } };
}
function EU(e) {
  var l, m;
  let { structureId: t, matchUpId: r, event: i } = e, n = e.drawDefinition, a = fe(e, [{ [Gt]: !0 }, { [mg]: { [pp]: !1, [gn]: !1, [eD]: !1, [ba]: !1 } }]);
  if (a[ki])
    return a;
  let o = (l = bc(e, [{ [lc]: Fn, [ki]: Ie }])) == null ? void 0 : l.matchUp;
  if (r && (o != null && o.error))
    return o;
  !n && (o != null && o.drawDefinition) && (n = o == null ? void 0 : o.drawDefinition);
  let s = o == null ? void 0 : o.structure;
  if (!s && t && !r) {
    if (!n)
      return { error: tn };
    let f = ve({ drawDefinition: n, structureId: t });
    if (f.error)
      return f;
    s = f.structure;
  }
  let c = s == null ? void 0 : s.matchUpFormat, u = n == null ? void 0 : n.matchUpFormat, d = i == null ? void 0 : i.matchUpFormat, p = ((m = o == null ? void 0 : o.matchUp) == null ? void 0 : m.matchUpFormat) || c || u || d;
  return { structureDefaultMatchUpFormat: c, eventDefaultMatchUpFormat: d, drawDefaultMatchUpFormat: u, matchUpFormat: p };
}
function CU({ profileBands: e, tournamentRecord: t, matchUps: r }) {
  if (!Ti(r))
    return { error: Zn };
  let i = !e && lo({ policyType: Bn, tournamentRecord: t }).policy, n = e || (i == null ? void 0 : i.profileBands) || $g[Bn].profileBands, a = r.filter(({ winningSide: l }) => l), o = a.map(jD), s = (l, m) => {
    let f = VD(m, n);
    return l[f] += 1, l;
  }, c = GD(o).reduce((l, m) => s(l, m), { [Gg]: 0, [du]: 0, [lu]: 0, [FD]: 0 }), u = Object.keys(c).reduce((l, m) => (c[m] || 0) + l, 0), d = Object.keys(c).map((l) => {
    let m = parseFloat((c[l] / u).toFixed(4));
    return { [l]: m * 100 };
  }), p = a.filter(({ matchUpStatus: l }) => l === oS).length;
  return d.push({ [oS]: parseFloat((p / u).toFixed(4)) * 100 }), { competitiveBands: Object.assign({}, ...d), ...V };
}
var { stageOrder: LS } = w1;
function q_(e, t) {
  return e.eventName.localeCompare(t.eventName) || e.eventId.localeCompare(t.eventId) || (LS[e == null ? void 0 : e.stage] || 0) - (LS[t == null ? void 0 : t.stage] || 0) || t.matchUpsCount - e.matchUpsCount || `${e.stageSequence}-${e.roundNumber}-${e.minFinishingSum}`.localeCompare(`${t.stageSequence}-${t.roundNumber}-${t.minFinishingSum}`);
}
function OU({ excludeScheduleDateProfileRounds: e, excludeScheduledRounds: t, excludeCompletedRounds: r, inContextMatchUps: i, tournamentRecords: n, schedulingProfile: a, tournamentRecord: o, withSplitRounds: s, matchUpFilters: c, scheduleDate: u, withRoundId: d, venueId: p, context: l }) {
  var w;
  if (i && !Array.isArray(i || typeof i[0] != "object"))
    return { error: J, inContextMatchUps: i };
  if (o && !n) {
    if (typeof o != "object")
      return { error: Pu };
    n = { [o.tournamentId]: o };
  }
  let m = typeof n != "object" || !Object.keys(n).length;
  if ((p || u || !i || !a && (e || r || a || s)) && m)
    return { error: yt };
  let f = Object.assign({}, ...Object.values(n ?? {}).map(({ venues: v = [], tournamentId: P }) => ({ [P]: v == null ? void 0 : v.map(({ venueId: b }) => b) }))), h = Object.values(n ?? {}).map(({ events: v = [], tournamentId: P, startDate: b, endDate: T }) => v.map((R) => ({ ...R, validVenueIds: f[P], startDate: R.startDate ?? b, endDate: R.endDate ?? T }))).flat(), { segmentedRounds: g, profileRounds: I } = n && (e || r || a || s) && gm({ tournamentRecords: n, schedulingProfile: a }) || {}, y = e && Object.assign({}, ...I.map((v) => ({ [v.id]: v }))), U = i || n && ((w = en({ tournamentRecords: n, matchUpFilters: c })) == null ? void 0 : w.matchUps) || [], S = [], D = U && Object.values(U.reduce((v, P) => {
    var q;
    let b = oh(P).id, T = g == null ? void 0 : g[b], R = [...((q = v[b]) == null ? void 0 : q.matchUps) ?? [], P], { containerStructureId: M, stageSequence: E, structureName: C, tournamentId: A, isRoundRobin: N, matchUpType: O, roundNumber: k, roundOffset: F, structureId: x, eventName: _, roundName: B, drawName: L, eventId: G, drawId: $ } = P, W = N ? M : x;
    return { ...v, [b]: { id: d ? b : void 0, structureId: W, stageSequence: E, segmentsCount: T, structureName: C, tournamentId: A, matchUpType: O, roundNumber: k, roundOffset: F, eventName: _, roundName: B, drawName: L, matchUps: R, eventId: G, drawId: $ } };
  }, {})).map((v) => {
    let { minFinishingSum: P, winnerFinishingPositionRange: b } = L_(v.matchUps), T = v.segmentsCount;
    if (T) {
      let k = v.matchUps.length / T;
      return zt(v.matchUps.sort((F, x) => F.roundPosition - x.roundPosition), k).map((F, x) => {
        let { unscheduledCount: _, incompleteCount: B, matchUpsCount: L, isScheduled: G, isComplete: $, byeCount: W } = FS(F), q = kS({ matchUps: v.matchUps, tournamentRecords: n, events: h, round: v });
        return me({ ...v, ...l, roundSegment: { segmentsCount: T, segmentNumber: x + 1 }, winnerFinishingPositionRange: b, unscheduledCount: _, incompleteCount: B, minFinishingSum: P, matchUpsCount: L, isScheduled: G, roundTiming: q, isComplete: $, byeCount: W, matchUps: F });
      });
    }
    let { unscheduledCount: R, incompleteCount: M, matchUpsCount: E, isScheduled: C, isComplete: A, byeCount: N } = FS(v.matchUps), O = kS({ matchUps: v.matchUps, tournamentRecords: n, events: h, round: v });
    return me({ ...v, ...l, winnerFinishingPositionRange: b, unscheduledCount: R, incompleteCount: M, minFinishingSum: P, matchUpsCount: E, isScheduled: C, roundTiming: O, isComplete: A, byeCount: N });
  }).flat().filter((v) => {
    if (e) {
      let x = be(e), _ = d ? v.id : oh(v).id;
      if (x && y[_] && be(y[_].scheduleDate) === x)
        return !1;
    }
    let { isComplete: P, isScheduled: b } = v, T = !r || !P, R = !t || !b, M = p || u ? h == null ? void 0 : h.find(({ eventId: x }) => x === v.eventId) : void 0, E = (M == null ? void 0 : M.startDate) ?? (o == null ? void 0 : o.startDate), C = (M == null ? void 0 : M.endDate) ?? (o == null ? void 0 : o.endDate), A = !u || !E || new Date(u) >= new Date(E), N = !u || !C || new Date(u) <= new Date(C), O = A && N, k = !p || (M == null ? void 0 : M.validVenueIds.includes(p)), F = T && R && k && O;
    return F || S.push(v), F;
  }).sort(q_) || [];
  return { ...V, rounds: D, excludedRounds: S };
}
function Uu(e) {
  var $;
  let { matchUp: t, sideNumber: r, setNumber: i, isTiebreakValue: n, isPointValue: a } = e || {}, { matchUpFormat: o } = e || {};
  if (!t)
    return { error: Vr };
  o = o || (t == null ? void 0 : t.matchUpFormat);
  let s = Tr(o), c = !!(t != null && t.winningSide), u = ($ = t.score) == null ? void 0 : $.sets, d = u == null ? void 0 : u.length, p = i && i - 1, l = !!(u != null && u.find((W, q) => W.setNumber === i && q === p)), m = (u == null ? void 0 : u.filter((W) => W == null ? void 0 : W.winningSide)) || [], f = (m == null ? void 0 : m.length) || 0, h = i && (u == null ? void 0 : u.slice(i)) || [], g = !!(d && i && (h != null && h.reduce((W, q) => (!q || !q.side1Score && !q.side2Score && !q.side1TiebreakScore && !q.side2TiebreakScore && !q.side1PointScore && !q.side2PointScore) && W, !0))), I = i <= d && u.find((W) => W.setNumber === i), y = I && gu({ setObject: I, matchUpScoringFormat: s }), { isCompletedSet: U, sideGameScores: S, sideTiebreakScores: D } = y || {}, w = !!(I && !U && g || i && i === d + 1 && !c), v = [1, 2].includes(r), P = v ? r - 1 : 0, b = I && v && (!n && !a && S[P] !== void 0 && S[P] || n && D[P] !== void 0 && D[P]), T = !!b, R = m == null ? void 0 : m.map((W) => gu({ setObject: W, matchUpScoringFormat: s }).isValidSetOutcome).reduce((W, q) => W && q, !0), M = m.reduce((W, q) => {
    let { winningSide: K } = q, z = K - 1;
    return W[z]++, W;
  }, [0, 0]), E = t == null ? void 0 : t.winningSide, C = E && E - 1, A = 1 - C, N = M[C], O = M[A], k = Math.max(...M), F = Qr(M)[k], { bestOf: x, exactly: _ } = s ?? {}, B = x && Math.ceil(x / 2) || _ || 1, L = k === B && F === 1 && M.indexOf(k) + 1 || void 0, G = N > O && E === L;
  return { completedSetsHaveValidOutcomes: R, validMatchUpWinningSide: G, calculatedWinningSide: L, matchUpScoringFormat: s, validMatchUpOutcome: L && R && G, isLastSetWithValues: g, completedSetsCount: f, isCompletedMatchUp: c, isValidSideNumber: v, hasExistingValue: T, existingValue: b, isExistingSet: l, isActiveSet: w, ...y };
}
function kU({ participants: e, tournamentAppliedPolicies: t, scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, usePublishState: c, contextFilters: u, contextContent: d, matchUpFilters: p, participantMap: l, publishStatus: m, contextProfile: f, drawDefinition: h, nextMatchUps: g, tournamentId: I, inContext: y, context: U, event: S }) {
  let { eventId: D, eventName: w, endDate: v, eventType: P, category: b, gender: T } = S ?? {}, R = { ...U, ...me({ surfaceCategory: (S == null ? void 0 : S.surfaceCategory) ?? (s == null ? void 0 : s.surfaceCategory), indoorOutDoor: (S == null ? void 0 : S.indoorOutdoor) ?? (s == null ? void 0 : s.indoorOutdoor), endDate: v ?? (S == null ? void 0 : S.endDate) ?? (s == null ? void 0 : s.endDate), tournamentId: I ?? (s == null ? void 0 : s.tournamentId), eventName: w, eventType: P, category: b, eventId: D, gender: T }) }, M;
  return !(e != null && e.length) && s && ({ participants: e, participantMap: l, groupInfo: M } = es({ participantsProfile: i, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, contextProfile: f, inContext: y })), S && f && !d && (d = ia({ policyDefinitions: a, tournamentRecord: s, contextProfile: f, drawDefinition: h, event: S })), { ...Uc({ context: R, tournamentAppliedPolicies: t, scheduleVisibilityFilters: r, tournamentParticipants: e, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: s, usePublishState: c, participantMap: l, contextContent: d, contextFilters: u, matchUpFilters: p, publishStatus: m, contextProfile: f, drawDefinition: h, nextMatchUps: g, inContext: y, event: S }), groupInfo: M };
}
var yM = {};
Ae(yM, { getCompetitionVenues: () => Pd, getCourts: () => FU, getVenuesAndCourts: () => aa, publicFindVenue: () => Jg });
function FU({ tournamentRecord: e, venueId: t, venueIds: r }) {
  return e ? { courts: (e.venues || []).filter((i) => t ? i.venueId === t : r ? r.includes(i.venueId) : !0).map((i) => {
    let { venueId: n } = i, a = ce(i.courts || []);
    return a.forEach((o) => Object.assign(o, { venueId: n })), a;
  }).flat() } : { error: ae };
}
var SM = {};
Ae(SM, { categoryCanContain: () => Eu, getCategoryAgeDetails: () => Oo, getEvent: () => _U, getEventProperties: () => xU, getEventStructures: () => jp, getEventTimeItem: () => Gu, getEvents: () => LU, getFlightProfile: () => Pt, getScaledEntries: () => fs });
function xU({ tournamentRecord: e, event: t }) {
  var p, l;
  if (!e)
    return { error: ae };
  if (!t)
    return { error: pt };
  let r = t.entries || [], i = e.participants || [], n = ((p = t.category) == null ? void 0 : p.categoryName) || ((l = t.category) == null ? void 0 : l.ageCategoryCode), { eventType: a } = t, o = r.map((m) => m.participantId), s = i.filter((m) => o.includes(m.participantId)), c, u, d;
  return { entryScaleAttributes: s.map((m) => {
    var D, w, v, P, b, T;
    let { participantId: f, participantName: h, name: g } = m, I = { scaleType: Qg, eventType: a, scaleName: n }, y = (w = (D = Tn({ participant: m, scaleAttributes: I })) == null ? void 0 : D.scaleItem) == null ? void 0 : w.scaleValue;
    I = { scaleType: JD, eventType: a, scaleName: n };
    let U = (P = (v = Tn({ participant: m, scaleAttributes: I })) == null ? void 0 : v.scaleItem) == null ? void 0 : P.scaleValue;
    I = { scaleType: QD, eventType: a, scaleName: n };
    let S = (T = (b = Tn({ participant: m, scaleAttributes: I })) == null ? void 0 : b.scaleItem) == null ? void 0 : T.scaleValue;
    return c = !!(c || y), u = !!(u || U), d = !!(d || S), { participantId: f, participantName: h || g, seed: y, ranking: U, rating: S };
  }), hasSeededParticipants: c, hasRankedParticipants: u, hasRatedParticipants: d };
}
function LU({ tournamentRecord: e, withScaleValues: t, scaleEventType: r, inContext: i, eventIds: n, drawIds: a, context: o }) {
  var d, p, l, m;
  if (!e)
    return { error: ae };
  let { tournamentId: s } = e, c = (e.events ?? []).filter(({ eventId: f }) => !n || Array.isArray(n) && n.includes(f)).map((f) => {
    var I;
    let h = (I = f.drawDefinitions) == null ? void 0 : I.map(cu);
    if (a != null && a.length && !wt(a, h).length)
      return;
    let g = ce(f);
    return i && Object.assign(g, { tournamentId: s }), o && Object.assign(g, o), g;
  }).filter(Boolean), u = {};
  if (t) {
    let f = Ut({ withScaleValues: !0, tournamentRecord: e }).participantMap, h = (g) => g.reduce((I, y) => I + parseFloat(y), 0);
    for (let g of c) {
      let I = r ?? g.eventType, y = g.eventId;
      u[y] || (u[y] = { ratingsStats: {}, ratings: {}, ranking: {}, draws: {} });
      let U = (g.entries ?? []).filter(({ entryStatus: T }) => $i.includes(T)).map(Ce), S = (T) => {
        var R, M, E, C, A, N;
        if ((R = T == null ? void 0 : T.ratings) != null && R[I])
          for (let O of ((M = T == null ? void 0 : T.ratings) == null ? void 0 : M[I]) ?? []) {
            let k = O.scaleName;
            u[y].ratings[k] || (u[y].ratings[k] = []);
            let F = (E = Wt[k]) == null ? void 0 : E.accessor;
            if (F) {
              let x = parseFloat((C = O.scaleValue) == null ? void 0 : C[F]);
              x && u[y].ratings[k].push(x);
            }
          }
        if ((A = T == null ? void 0 : T.rankings) != null && A[I])
          for (let O of ((N = T == null ? void 0 : T.rankings) == null ? void 0 : N[I]) ?? []) {
            let k = O.scaleName;
            u[y].ranking[k] || (u[y].ranking[k] = []), O.scaleValue && u[y].ranking[k].push(O.scaleValue);
          }
      };
      for (let T of U) {
        let R = (d = f == null ? void 0 : f[T]) == null ? void 0 : d.participant;
        if ((R == null ? void 0 : R.participantType) !== Oe)
          for (let M of (R == null ? void 0 : R.individualParticipantIds) ?? []) {
            let E = (p = f == null ? void 0 : f[M]) == null ? void 0 : p.participant;
            S(E);
          }
        else
          S(R);
      }
      let D = u[y].ratings;
      for (let T of Object.keys(D)) {
        let R = D[T];
        if (!R.length)
          continue;
        let M = (l = Ky(R)) == null ? void 0 : l.toFixed(2);
        u[y].ratingsStats[T] = { avg: parseFloat((h(R) / R.length).toFixed(2)), median: M ? parseFloat(M) : void 0, max: Math.max(...R), min: Math.min(...R) };
      }
      let w = (T, R) => {
        var E, C;
        let M = (A) => {
          var N, O, k, F, x, _, B, L, G, $;
          if ((N = u[y].draws) != null && N[T] && ((O = A == null ? void 0 : A.ratings) != null && O[I]))
            for (let W of ((k = A == null ? void 0 : A.ratings) == null ? void 0 : k[I]) ?? []) {
              let q = W.scaleName;
              (F = u[y].draws[T]) != null && F.ratings[q] || (u[y].draws[T].ratings[q] = []);
              let K = (x = Wt[q]) == null ? void 0 : x.accessor;
              if (K) {
                let z = parseFloat((_ = W.scaleValue) == null ? void 0 : _[K]);
                z && u[y].draws[T].ratings[q].push(z);
              }
            }
          if ((B = u[y].draws) != null && B[T] && ((L = A == null ? void 0 : A.rankings) != null && L[I]))
            for (let W of ((G = A == null ? void 0 : A.rankings) == null ? void 0 : G[I]) ?? []) {
              let q = W.scaleName;
              ($ = u[y].draws[T]) != null && $.ranking[q] || (u[y].draws[T].ranking[q] = []);
              let K = W.scaleValue;
              K && u[y].draws[T].ranking[q].push(K);
            }
        };
        for (let A of R.filter(Boolean)) {
          let N = (E = f == null ? void 0 : f[A]) == null ? void 0 : E.participant;
          if ((N == null ? void 0 : N.participantType) !== Oe)
            for (let O of (N == null ? void 0 : N.individualParticipantIds) ?? []) {
              let k = (C = f == null ? void 0 : f[O]) == null ? void 0 : C.participant;
              M(k);
            }
          else
            M(N);
        }
      }, v = [], P = (T) => (a == null ? void 0 : a.length) && a.includes(T) || v.includes(T);
      for (let T of g.drawDefinitions ?? []) {
        let R = T.drawId;
        if (P(R))
          continue;
        let M = ho({ drawDefinition: T }).assignedParticipantIds ?? [];
        u[y].draws[R] || (u[y].draws[R] = { ratingsStats: {}, ratings: {}, ranking: {} }), v.push(R), w(R, M);
      }
      let b = Pt({ event: g }).flightProfile;
      for (let T of (b == null ? void 0 : b.flights) ?? []) {
        let R = T.drawId;
        if (P(R))
          continue;
        let M = T.drawEntries.map(Ce);
        w(R, M);
      }
      for (let T of v) {
        let R = u[y].draws[T].ratings;
        for (let M of Object.keys(R)) {
          let E = R[M];
          if (!E.length)
            continue;
          let C = (m = Ky(E)) == null ? void 0 : m.toFixed(2);
          u[y].draws[T].ratingsStats[M] = { avg: parseFloat((h(E) / E.length).toFixed(2)), median: C ? parseFloat(C) : void 0, max: Math.max(...E), min: Math.min(...E) };
        }
      }
    }
  }
  return me({ eventScaleValues: u, events: c, ...V });
}
function _U({ tournamentRecord: e, drawDefinition: t, context: r, event: i }) {
  var o;
  if (!e)
    return { error: ae };
  if (!i)
    return { error: pt };
  let n = ce(i);
  r && Object.assign(n, r);
  let a = t && ((o = n.drawDefinitions) == null ? void 0 : o.find(({ drawId: s }) => t.drawId === s));
  return me({ drawDefinition: a, event: n });
}
function W_(e) {
  var m, f;
  let t = "validateAndDeriveDrawValues", { appliedPolicies: r, policyDefinitions: i } = Y_(e), n = K_({ ...e, policyDefinitions: i, appliedPolicies: r }), a = z_(e), o = Q_({ ...e, consideredEntries: a, appliedPolicies: r });
  if (o != null && o.error)
    return j({ result: o, stack: t });
  let s = J_({ ...e, consideredEntries: a }), c = H_({ ...e, appliedPolicies: r, policyDefinitions: i, drawSize: s });
  if (c.error)
    return j({ result: c, stack: t });
  let u = c.drawType;
  if (isNaN(s) && u !== si)
    return j({ result: { error: Tu }, stack: t });
  let d = (i == null ? void 0 : i[Mi]) ?? (r == null ? void 0 : r[Mi]), p = e.seedingProfile ?? ((f = (m = d == null ? void 0 : d.seedingProfile) == null ? void 0 : m.drawTypes) == null ? void 0 : f[u ?? ""]) ?? (d == null ? void 0 : d.seedingProfile);
  e.seedingProfile && (i[Mi] || (i[Mi] = { ...ah[Mi] }), i[Mi].seedingProfile = p);
  let l = X_({ ...e, drawType: u });
  return l != null && l.error ? j({ result: l, stack: t }) : { drawSize: s, drawType: u, enforceGender: n, seedingProfile: p, appliedPolicies: r, policyDefinitions: i };
}
function H_(e) {
  let { policyDefinitions: t, appliedPolicies: r, enforceMinimumDrawSize: i = !0, drawSize: n } = e, a = e.drawTypeCoercion ?? Sd({ drawType: e.drawType, policyDefinitions: t, appliedPolicies: r }), o = zb({ drawType: e.drawType, enforceMinimumDrawSize: i, drawTypeCoercion: a, drawSize: n });
  return o.error ? o : { drawType: o.drawType };
}
function vM(e) {
  return e == null ? void 0 : e.filter((t) => t.entryStatus && [...$i, Ku].includes(t.entryStatus));
}
function z_({ considerEventEntries: e = !0, drawEntries: t, eventEntries: r, qualifyingOnly: i }) {
  return (i && [] || vM(t) || (e ? r : [])).filter(({ entryStage: n }) => !n || n === ue);
}
function Y_(e) {
  let { tournamentRecord: t, event: r } = e, i = je({ tournamentRecord: t, event: r }).appliedPolicies ?? {}, n = ce(e.policyDefinitions ?? {}, !1, !0);
  return { appliedPolicies: i, policyDefinitions: n };
}
function K_({ enforceGender: e, policyDefinitions: t, appliedPolicies: r }) {
  var i, n, a, o;
  return e ?? ((n = (i = t == null ? void 0 : t[Xt]) == null ? void 0 : i.participants) == null ? void 0 : n.enforceGender) ?? ((o = (a = r == null ? void 0 : r[Xt]) == null ? void 0 : a.participants) == null ? void 0 : o.enforceGender);
}
function Q_(e) {
  let { consideredEntries: t, appliedPolicies: r, policyDefinitions: i, enforceGender: n, participantMap: a, participants: o, event: s } = e;
  return s && o && Xp({ consideredEntries: t, policyDefinitions: i, appliedPolicies: r, participantMap: a, enforceGender: n, participants: o, event: s });
}
function J_(e) {
  return !e.drawSize && e.consideredEntries.length && ![si, Ou, dc, Li, En].includes(e.drawType ?? "") && tc(e.consideredEntries.length) || e.drawSize && ye(e.drawSize) || !1;
}
function X_(e) {
  var o, s;
  let { tournamentRecord: t, event: r, ignoreAllowedDrawTypes: i, drawType: n } = e, a = !i && t && sm({ tournamentRecord: t, categoryType: (o = r == null ? void 0 : r.category) == null ? void 0 : o.categoryType, categoryName: (s = r == null ? void 0 : r.category) == null ? void 0 : s.categoryName });
  return a != null && a.length && !a.includes(n) ? { error: Sh } : { ...V };
}
function Md(e) {
  let { voluntaryConsolation: t, tournamentRecord: r, event: i } = e, n = "generateDrawDefinition", { participants: a, participantMap: o } = Ut({ withIndividualParticipants: !0, convertExtensions: !0, internalUse: !0, tournamentRecord: r }), s = vM(i == null ? void 0 : i.entries) ?? [], c = W_({ ...e, participantMap: o, participants: a, eventEntries: s });
  if (c.error)
    return j({ result: c, stack: n });
  let { appliedPolicies: u, policyDefinitions: d, drawSize: p, drawType: l, enforceGender: m, seedingProfile: f } = c, h = i == null ? void 0 : i.eventType, g = e.matchUpType ?? h, I = JL({ ...e, enforceGender: m, eventType: h, matchUpType: g });
  if (I.error)
    return j({ result: I, stack: n });
  let { matchUpFormat: y, tieFormat: U } = I;
  if (e.drawId && typeof e.drawId != "string")
    return j({ result: { error: J }, stack: n });
  let S = T_({ ...e, policyDefinitions: d, tournamentRecord: r, appliedPolicies: u, matchUpFormat: y, seedingProfile: f, participants: a, eventEntries: s, matchUpType: g, tieFormat: U, drawSize: p, drawType: l, event: i });
  if (S.error)
    return j({ result: S, stack: n });
  let { existingDrawDefinition: D, positioningReports: w, drawDefinition: v, structureId: P, conflicts: b, entries: T } = S;
  if (!v)
    return j({ result: { error: J }, stack: n });
  let R = b_({ ...e, existingDrawDefinition: D, positioningReports: w, appliedPolicies: u, drawDefinition: v, seedingProfile: f, participants: a, structureId: P, entries: T, params: e, stack: n });
  if (R.error)
    return R;
  let { qualifyingConflicts: M } = R;
  return v.drawName = e.drawName ?? (l && dr(l)), p && typeof t == "object" && p >= 4 && cI({ ...t, drawDefinition: v, matchUpType: g }), { existingDrawDefinition: !!D, qualifyingConflicts: M, positioningReports: w, drawDefinition: v, structureId: P, ...V, conflicts: b };
}
function wM({ scaleAttributes: e, scaledEntries: t, stageEntries: r, seedsCount: i, scaleName: n }) {
  if (!e)
    return { error: Ie, info: "missing scaleAttributes" };
  let a = Object.assign({}, ...(t || []).slice(0, i).map(({ participantId: s }, c) => ({ [s]: c + 1 })));
  n = n || e.scaleName;
  let o = (/* @__PURE__ */ new Date()).toISOString();
  return { scaleItemsWithParticipantIds: r.map(({ participantId: s }) => ({ scaleItems: [{ scaleValue: a[s], eventType: e.eventType, scaleType: Pn, scaleName: n, scaleDate: o }], participantId: s })) };
}
function Z_({ tournamentRecord: e, drawDefinition: t, policyDefinitions: r, scaleAttributes: i, scaleName: n, drawSize: a, drawId: o, event: s, stage: c, sortDescending: u, scaleSortMethod: d }) {
  let p = Um({ policyDefinitions: r, drawDefinition: t, drawSize: a, drawId: o, event: s, stage: c });
  if (p.error)
    return p;
  let { entries: l, seedsCount: m, stageEntries: f } = p;
  if (!f || !m)
    return { error: J };
  let h = fs({ tournamentRecord: e, scaleAttributes: i, scaleSortMethod: d, sortDescending: u, entries: l, stage: c }).scaledEntries ?? [], { scaleItemsWithParticipantIds: g } = wM({ scaleAttributes: i, scaledEntries: h, stageEntries: f, seedsCount: m, scaleName: n });
  return { scaleItemsWithParticipantIds: g };
}
var PM = {};
Ae(PM, { addDrawEntries: () => iI, addEventEntries: () => sn, addEventEntryPairs: () => MM, destroyPairEntries: () => wT, destroyPairEntry: () => sI, getEntriesAndSeedsCount: () => Um, getMaxEntryPosition: () => PU, modifyEntriesStatus: () => Sl, modifyEventEntries: () => NM, mutate: () => DM, promoteAlternate: () => bM, promoteAlternates: () => VU, query: () => fM, removeDrawEntries: () => RM, removeEventEntries: () => od, setEntryPosition: () => BU, setEntryPositions: () => TM });
var DM = {};
Ae(DM, { addDrawEntries: () => iI, addEventEntries: () => sn, addEventEntryPairs: () => MM, destroyPairEntries: () => wT, destroyPairEntry: () => sI, modifyEntriesStatus: () => Sl, modifyEventEntries: () => NM, promoteAlternate: () => bM, promoteAlternates: () => VU, removeDrawEntries: () => RM, removeEventEntries: () => od, setEntryPosition: () => BU, setEntryPositions: () => TM });
function BU({ tournamentRecord: e, drawDefinition: t, participantId: r, entryPosition: i, skipRefresh: n, event: a }) {
  let o = "setEntryPositions";
  if (!e)
    return { error: ae };
  if (!r)
    return j({ result: { error: _t }, stack: o });
  if (i !== void 0 && !Number.isSafeInteger(i))
    return { error: J, entryPosition: i };
  ((a == null ? void 0 : a.entries) || []).forEach((c) => {
    c.participantId === r && (c.entryPosition = i);
  }), ((t == null ? void 0 : t.entries) || []).forEach((c) => {
    c.participantId === r && (c.entryPosition = i);
  });
  let s = (c) => {
    c.entries.forEach((u) => {
      u.entryPosition === i && u.participantId !== r && (u.entryPosition += 0.1);
    });
  };
  return n || (a != null && a.entries && (s(a), a.entries = Ki({ entries: a.entries })), t != null && t.entries && (s(t), t.entries = Ki({ entries: t.entries }))), { ...V };
}
function TM({ tournamentRecord: e, entryPositions: t, drawDefinition: r, event: i }) {
  if (!e)
    return { error: ae };
  if (!Array.isArray(t))
    return { error: J };
  for (let n of t) {
    let { participantId: a, entryPosition: o } = n, s = BU({ skipRefresh: !0, tournamentRecord: e, drawDefinition: r, participantId: a, entryPosition: o, event: i });
    if (s.error)
      return s;
  }
  return i != null && i.entries && (i.entries = Ki({ entries: i.entries })), r != null && r.entries && (r.entries = Ki({ entries: r.entries })), { ...V };
}
function bM(e) {
  let { participantId: t } = e;
  return t && typeof t != "string" ? { error: J, participantId: t } : VU({ ...e, participantIds: [t].filter(Boolean) });
}
function VU({ tournamentRecord: e, drawDefinition: t, participantIds: r, stageSequence: i, stage: n = ue, eventId: a, event: o }) {
  if (!e)
    return { error: ae };
  if (!Array.isArray(r))
    return { error: J, participantIds: r };
  if (!o)
    return { error: pt };
  let s = "promoteAlternates";
  if (o) {
    let c = _S({ element: o, participantIds: r, stageSequence: i, stage: n });
    if (c.error)
      return c;
  }
  if (t) {
    let c = _S({ element: t, participantIds: r, stageSequence: i, stage: n });
    if (c.error)
      return a ? j({ context: { drawPromotionError: c.error, drawId: t.drawId }, result: { ...V }, stack: s }) : c;
  }
  return { ...V };
}
function _S({ participantIds: e, stageSequence: t, element: r, stage: i }) {
  let n = (r.entries || []).filter((p) => p.entryStatus === Fi), a = (r.entries || []).filter((p) => e.includes(p.participantId)), o = n.reduce((p, l) => {
    let { entryPosition: m } = l;
    return isNaN(m) && p || (!p || m < p.entryPosition) && l || p;
  }, void 0), s = a.length ? a : [o].filter(Boolean);
  if (!(s != null && s.length))
    return { error: hw };
  let c = s.filter(({ entryStatus: p }) => p !== Fi);
  if (c.length)
    return { error: Pf, invalidEntryStatus: c };
  let u = s.filter(({ entryStage: p }) => p && p !== i);
  if (u.length)
    return { error: aC, invalidStage: u };
  let d = t && s.filter((p) => p.stageSequence !== t);
  if (d != null && d.length)
    return { error: oC, invalidStageSequence: d };
  for (let p of s) {
    p.entryStatus = $r;
    let l = p == null ? void 0 : p.entryPosition;
    isNaN(l) || r.entries.forEach((f) => {
      f.entryStatus === Fi && f.entryPosition > l && (f.entryPosition = f.entryPosition - 1);
    });
    let m = Math.max(...r.entries.filter((f) => f.entryStatus === $r && !isNaN(f.entryPosition)).map(({ entryPosition: f }) => ye(f || 0)), 0);
    p.entryPosition = m || 0;
  }
  return { ...V };
}
function RM({ autoEntryPositions: e = !0, participantIds: t, drawDefinition: r, drawId: i, stages: n, event: a }) {
  var d;
  if (!a)
    return { error: pt };
  if (!i)
    return { error: tn };
  if (!(t != null && t.length))
    return { error: Da };
  let o = ho({ drawDefinition: r, stages: n }).assignedParticipantIds ?? [];
  if (wr(o, t))
    return { error: oc };
  let s = (p) => {
    let l = p.participantId;
    return !t.includes(l);
  }, { flightProfile: c } = Pt({ event: a }), u = (d = c == null ? void 0 : c.flights) == null ? void 0 : d.find((p) => p.drawId === i);
  return u != null && u.drawEntries && (u.drawEntries = u.drawEntries.filter(s), e && (u.drawEntries = Ki({ entries: u.drawEntries }))), r != null && r.entries && (r.entries = r.entries.filter(s), e && (r.entries = Ki({ entries: r.entries }))), { ...V };
}
function hn(e) {
  var h, g, I, y, U;
  let t = "addParticipant", { allowDuplicateParticipantIdPairs: r, returnParticipant: i, disableNotice: n, pairOverride: a, participant: o } = e, s = e.tournamentId ? (h = e.tournamentRecords) == null ? void 0 : h[e.tournamentId] : e.tournamentRecord ?? (e.activeTournamentId && ((g = e.tournamentRecords) == null ? void 0 : g[e.activeTournamentId]));
  if (!s)
    return { error: ae };
  if (!o)
    return j({ result: { error: Ho }, stack: t });
  o.participantId || (o.participantId = ze()), s.participants || (s.participants = []);
  let { participantId: c, individualParticipantIds: u } = o;
  if (s.participants.reduce((S, D) => D.participantId === c || S, !1))
    return { error: dw };
  let { participantType: d, participantRole: p } = o;
  if (!d || !Object.keys(Vc).includes(d))
    return { error: Xi, participantType: d };
  if (!p)
    return { error: uw };
  let l = s.participants || [], m = l.filter((S) => S.participantType === Oe).map((S) => S.participantId);
  if (d !== Oe && o.person)
    return { error: J, person: o.person };
  if (u && !Array.isArray(u))
    return { error: J, individualParticipantIds: u };
  if (d === Re) {
    if (o.person)
      return { error: J, person: o.person };
    if (o.individualParticipantIds) {
      if (o.individualParticipantIds.length !== 2 && !a)
        return j({ info: "PAIR must be 2 individualParticipantIds", result: { error: Yr }, stack: t });
      {
        let w = l.filter((v) => v.participantType === Oe).map((v) => v.participantId);
        if (!Array.isArray(o.individualParticipantIds))
          return j({ result: { error: Yr }, stack: t });
        if (!o.individualParticipantIds.reduce((v, P) => w.includes(P) && v, !0))
          return j({ result: { error: Yr }, stack: t });
      }
    } else
      return j({ result: { error: Da }, stack: t });
    let S = l.filter((w) => w.participantType === Re).map((w) => ({ individualParticipantIds: w.individualParticipantIds, participant: w })), D = o.participantType === Re && S.find((w) => wt(w.individualParticipantIds, o.individualParticipantIds).length === 2);
    if (D && !r)
      return { ...V, existingParticipant: !0, participant: i && ce(D.participant) };
    if (!o.participantName) {
      let w = l.filter((P) => {
        var b;
        return (b = o.individualParticipantIds) == null ? void 0 : b.includes(P.participantId);
      }), v = w.map((P) => {
        var b;
        return (b = P.person) == null ? void 0 : b.standardFamilyName;
      }).filter(Boolean).join("/");
      w.length === 1 && (v += "/Unknown"), o.participantName = v;
    }
  } else if (d === Oe) {
    if (!((I = o.person) != null && I.standardFamilyName) || !((y = o.person) != null && y.standardGivenName))
      return { error: fw };
    if (!o.participantName) {
      let S = `${o.person.standardFamilyName.toUpperCase()}, ${o.person.standardGivenName}`;
      o.participantName = S;
    }
  } else if (d && [Xe, di].includes(d)) {
    if (u || (o.individualParticipantIds = []), (U = o.individualParticipantIds) == null ? void 0 : U.length)
      for (let S of o.individualParticipantIds) {
        if (typeof S != "string")
          return j({ result: { participantId: S, error: J }, stack: t });
        if (!m.includes(S))
          return j({ result: { participantId: S, error: Dt }, stack: t });
      }
  } else
    return { error: Xi };
  s.participants.push(o), n || De({ payload: { tournamentId: s.tournamentId, participants: [o] }, topic: Ua });
  let f = { participant: i && ce(o), ...V };
  return me(f);
}
function ji({ allowDuplicateParticipantIdPairs: e, returnParticipants: t, tournamentRecord: r, participants: i = [] }) {
  if (!r)
    return { error: ae };
  r.participants || (r.participants = []);
  let n = r.participants.map((p) => p.participantId) || [];
  i.forEach((p) => {
    p.participantId || (p.participantId = ze());
  });
  let a = i.filter((p) => !n.includes(p.participantId)), o = i.filter((p) => n.includes(p.participantId)), s = a.filter((p) => p.participantType === Oe), c = a.filter((p) => p.participantType !== Oe), u = s.concat(...c), d = [];
  if (u.length) {
    for (let l of u) {
      let m = hn({ allowDuplicateParticipantIdPairs: e, returnParticipant: !0, disableNotice: !0, tournamentRecord: r, participant: l });
      if (m.error)
        return m;
      m.success && !m.existingParticipant && d.push(m.participant);
    }
    d.length && De({ topic: Ua, payload: { tournamentId: r.tournamentId, participants: d } });
    let p = { participants: t && ce(d), addedCount: d.length, ...V };
    return o.length && Object.assign(p, { notAdded: o, info: Kl }), me(p);
  } else
    return { info: "No new participants to add", addedCount: 0, ...V };
}
function MM(e) {
  let t = fe(e, [{ [Gt]: !0, [ba]: !0 }]);
  if (t.error)
    return t;
  let { allowDuplicateParticipantIdPairs: r, entryStatus: i = Fi, participantIdPairs: n = [], entryStage: a = ue, tournamentRecord: o, drawDefinition: s, event: c, uuids: u } = e;
  if (c.eventType !== tt)
    return { error: Mn };
  let d = [], p = /* @__PURE__ */ new Map();
  for (let S of o.participants ?? []) {
    let { participantType: D, participantId: w, person: v, individualParticipantIds: P } = S;
    D === Oe && (v != null && v.sex) ? p.set(w, v.sex) : D === Re && P && d.push(P);
  }
  let l = n.filter((S) => {
    if (S.length !== 2)
      return !0;
    if (!c.gender || c.gender === Zi)
      return !1;
    if (!p.has(S[0]) || !p.has(S[1]))
      return !0;
    let D = S.map((v) => p.get(v)), w = c.gender === et && (D[0] !== et || D[1] !== et) || c.gender === dt && (D[0] !== dt || D[1] !== dt);
    return c.gender === Mr && (D.sort(Lp), (D[0] !== dt || D[1] !== et) && (w = !0)), w;
  });
  if (l.length)
    return { error: Yr, invalidParticipantIdPairs: l };
  let m = n.map((S) => ({ participantId: (u == null ? void 0 : u.pop()) ?? ze(), participantRole: ur, individualParticipantIds: S, participantType: Re })), f = r ? m : m.filter((S) => !d.find((D) => wt(D, S.individualParticipantIds).length === 2)), h, g = [];
  if (f) {
    let S = ji({ allowDuplicateParticipantIdPairs: r, participants: f, returnParticipants: !0, tournamentRecord: o });
    if (S.error)
      return S;
    g = S.participants || [], h = S.info;
  }
  let I = n.map((S) => {
    let D = g.find((v) => wt(v.individualParticipantIds, S).length === 2);
    if (D)
      return D;
    let { participant: w } = Vi({ tournamentRecord: o, participantIds: S });
    return w;
  }).map((S) => S.participantId), y = sn({ participantIds: I, tournamentRecord: o, drawDefinition: s, entryStatus: i, entryStage: a, event: c });
  f.length && De({ payload: { participants: f }, topic: Ua });
  let U = f.map(Ce);
  return { ...y, info: h, newParticipantIds: U };
}
function NM({ entryStatus: e = $r, unpairedParticipantIds: t = [], participantIdPairs: r = [], entryStage: i = ue, tournamentRecord: n, event: a }) {
  if (!n)
    return { error: ae };
  if (!a)
    return { error: pt };
  let o = n.participants ?? [], s = o.filter((h) => h.participantType === Oe).map((h) => h.participantId), c = t.concat(...r).flat(1 / 0).filter((h) => !s.includes(h));
  if (c.length)
    return { error: Yr, invalidParticipantIds: c };
  let u = r.filter((h) => h.length !== 2);
  if (u.length)
    return { error: Yr, invalidParticipantIdPairs: u };
  let d = o.filter((h) => h.participantType === Re).map((h) => h.individualParticipantIds), p = r.filter((h) => !d.find((g) => wt(g, h).length === 2)).map((h) => ({ participantType: Re, participantRole: ur, individualParticipantIds: h })), l = ji({ participants: p, tournamentRecord: n });
  if (l.error)
    return l;
  let m = r.map((h) => {
    let { participant: g } = Vi({ tournamentRecord: n, participantIds: h });
    return g;
  }).map((h) => ({ participantId: h, entryStatus: e, entryStage: i })), f = t.map((h) => ({ entryStatus: Di, participantId: h, entryStage: i }));
  return a.entries = (a.entries ?? []).filter((h) => h.entryStage === i), a.entries = a.entries.concat(...m, ...f), { ...V };
}
var AM = {};
Ae(AM, { addDrawDefinition: () => Nd, addEvent: () => Rc, addFlight: () => bm, assignSeedPositions: () => $M, attachFlightProfile: () => zU, categoryCanContain: () => Eu, deleteDrawDefinitions: () => Pm, deleteEvents: () => WM, deleteFlightAndFlightDraw: () => jM, deleteFlightProfileAndFlightDraws: () => xM, generate: () => EM, generateEventsFromTieFormat: () => OM, getCategoryAgeDetails: () => Oo, getEvent: () => _U, getEventProperties: () => xU, getEventStructures: () => jp, getEventTimeItem: () => Gu, getEvents: () => LU, getFlightProfile: () => Pt, getScaledEntries: () => fs, modifyEvent: () => HM, modifyEventMatchUpFormatTiming: () => LM, modifyPairAssignment: () => GM, mutate: () => kM, query: () => SM, refreshEventDrawOrder: () => HU, removeEventMatchUpFormatTiming: () => Dm, removeScaleValues: () => YU, removeSeeding: () => qM, setEventDates: () => qU, setEventDisplay: () => Tm, setEventEndDate: () => $U, setEventStartDate: () => GU, updateDrawIdsOrder: () => WU, validateCategory: () => eu });
var EM = {};
Ae(EM, { generateEventsFromTieFormat: () => OM });
function eB({ tournamentId: e, event: t }) {
  return t ? (De({ payload: { tournamentId: e, event: t }, key: t.eventId, topic: wD }), { ...V }) : { error: pt };
}
var tB = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_D3", winCriteria: { valueGoal: 5 } }, rB = { collectionDefinitions: [{ collectionName: "Doubles", collectionValue: 1, matchUpCount: 3, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES" }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_DEFAULT", winCriteria: { valueGoal: 5 } }, iB = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_JUCO", winCriteria: { valueGoal: 5 } }, CM = { COLLEGE_D3: tB, COLLEGE_DEFAULT: rB, COLLEGE_JUCO: iB, DOMINANT_DUO: hP, DOMINANT_DUO_MIXED: dP, LAVER_CUP: SP, TEAM_DOUBLES_3_AGGREGATION: aP, TIME_TENNIS_DUAL: lP, TIME_TENNIS_PRO_CIRCUIT: uP, USTA_BREWER_CUP: pP, USTA_OZAKI_CUP: mP, USTA_COLLEGE: gP, USTA_GOLD_TEAM_CHALLENGE: nP, USTA_INTERSECTIONAL: cP, USTA_LEVEL_1: IP, USTA_SECTION_BATTLE: sP, USTA_SOUTHERN_LEVEL_5: oP, USTA_TOC: vP, USTA_WTT_ITT: UP, USTA_ZONAL: yP };
function Rc({ suppressNotifications: e, tournamentRecord: t, internalUse: r, event: i }) {
  var s, c, u, d;
  if (!t)
    return { error: ae };
  if (t.events || (t.events = []), !i)
    return { error: pt };
  let { startDate: n, endDate: a } = t;
  if (!r && ((s = i.entries) != null && s.length || (c = i.drawDefinitions) != null && c.length)) {
    let p = me({ drawDefinitions: !!((u = i.drawDefinitions) != null && u.length), entries: !!((d = i.entries) != null && d.length) });
    return { info: "entries/drawDefinitions cannot exist", error: J, context: p };
  }
  let o = { eventType: ko, drawDefinitions: [], entries: [], startDate: n, endDate: a, ...i };
  if (i.eventType === Xr) {
    if (i.tieFormat) {
      let p = Ar({ tieFormat: i.tieFormat });
      if (p.error)
        return p;
    } else if (i.tieFormatName) {
      if (!CM[i.tieFormatName])
        return { context: { tieFormatName: i.tieFormatName }, error: J };
      let p = $n({ isMock: t == null ? void 0 : t.isMock, namedFormat: i.tieFormatName, event: i });
      o.tieFormat = p;
    }
  }
  if (o.eventId || (o.eventId = ze()), t.events.reduce((p, l) => p || l.eventId === o.eventId, void 0))
    return { error: Wv };
  {
    let p = o;
    if (t.events.push(p), !e) {
      let { topics: l } = vi();
      if (l.includes(Pp)) {
        let h = Ln({ event: i }).matchUps ?? [];
        ya({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: i.eventId, matchUps: h });
      }
      let { drawDefinitions: m, ...f } = i;
      for (let h of m || [])
        Vu({ drawDefinition: h });
      eB({ tournamentId: t == null ? void 0 : t.tournamentId, event: f });
    }
    return { ...V, event: o };
  }
}
function OM(e) {
  var o, s, c, u;
  let t = fe(e, [{ [Gs]: { [mp]: !0, [YP]: !0 } }, { [Gt]: !0 }]);
  if (t.error)
    return t;
  let r = e.tieFormat || $n({ namedFormat: e.tieFormatName }), i = e.uuids || [iP(r.collectionDefinitions.length)], n = { [et]: [], [dt]: [] };
  if (e.addEntriesFromTeams) {
    let d = (s = (o = e.tournamentRecord.participants) == null ? void 0 : o.filter((p) => p.participantType === Nr)) == null ? void 0 : s.flatMap((p) => p.individualParticipantIds ?? []);
    for (let p of e.tournamentRecord.participants ?? [])
      if (d != null && d.includes(p.participantId)) {
        let l = (c = p.person) == null ? void 0 : c.sex;
        l && [et, dt].includes(l) && n[l].push(p.participantId);
      }
  }
  let a = [];
  for (let d of r.collectionDefinitions ?? []) {
    let p = ((u = i == null ? void 0 : i.pop()) == null ? void 0 : u.toString()) || ze(), l = d.matchUpType, m = d.gender, f = { matchUpFormat: d.matchUpFormat, eventName: d.collectionName, category: d.category, gender: m, eventType: l, eventId: p };
    if (e.addEntriesFromTeams) {
      let h = l === qn ? Di : e.entryStatus || $r, g = m === Mr ? [...n[et], ...n[dt]] : n[m] ?? [];
      if (g.length) {
        let I = sn({ participantIds: g, entryStatus: h, event: f });
        if (I.error)
          return I;
      }
    }
    if (a.push(f), e.addEvents !== !1) {
      let h = Rc({ internalUse: !0, tournamentRecord: e.tournamentRecord, event: f });
      if (h.error)
        return h;
    }
  }
  return { ...V, events: a };
}
var kM = {};
Ae(kM, { addDrawDefinition: () => Nd, addEvent: () => Rc, addFlight: () => bm, assignSeedPositions: () => $M, attachFlightProfile: () => zU, deleteDrawDefinitions: () => Pm, deleteEvents: () => WM, deleteFlightAndFlightDraw: () => jM, deleteFlightProfileAndFlightDraws: () => xM, modifyEvent: () => HM, modifyEventMatchUpFormatTiming: () => LM, modifyPairAssignment: () => GM, refreshEventDrawOrder: () => HU, removeEventMatchUpFormatTiming: () => Dm, removeScaleValues: () => YU, removeSeeding: () => qM, setEventDates: () => qU, setEventDisplay: () => Tm, setEventEndDate: () => $U, setEventStartDate: () => GU, updateDrawIdsOrder: () => WU, validateCategory: () => eu });
function Mc({ removePriorValues: e = !0, status: t = li, statusObject: r, event: i }) {
  if (!Le(r))
    return { error: J };
  let n = bi({ event: i, status: t }), a = `${Ea}.${Ca}`, o = { itemValue: { [t]: { ...n, ...r } }, itemType: a };
  return ms({ timeItem: o, removePriorValues: e, event: i });
}
function Nc(e) {
  var D, w, v, P, b, T, R;
  let t = fe(e, [{ [Gt]: !0, [ba]: !0 }, { eventDataParams: !1, [Or]: _r }]);
  if (t.error)
    return t;
  let { includePositionAssignments: r, removePriorValues: i, tournamentRecord: n, status: a = li, event: o, drawIdsToRemove: s, drawIdsToAdd: c } = e, { appliedPolicies: u } = je({ tournamentRecord: n, event: o }), d = { ...u, ...e.policyDefinitions }, p = ((D = o == null ? void 0 : o.drawDefinitions) == null ? void 0 : D.map(({ drawId: M }) => M)) ?? [], l = e.drawDetails ? Object.keys(e.drawDetails) : [], m = l.length ? [] : e.drawIds, f = (c ?? []).concat(...s ?? [], ...m ?? [], ...l), h = f.filter((M) => !p.includes(M));
  if (h.length)
    return j({ result: { error: ai }, context: { invalidDrawIds: h } });
  let g = bi({ event: o, status: a }), I = Object.keys((g == null ? void 0 : g.drawDetails) || {}).filter((M) => p.includes(M)).reduce((M, E) => (M[E] = g.drawDetails[E], M), {});
  for (let M of p)
    if ((!f.length || f.includes(M)) && (s != null && s.includes(M) || m != null && m.length && !m.includes(M) ? I[M] = { ...I[M], publishingDetail: { published: !1 } } : (c != null && c.includes(M) || m != null && m.includes(M) || !(m != null && m.length)) && (I[M] = { ...I[M], publishingDetail: { published: !0 } })), (w = e.drawDetails) == null ? void 0 : w[M]) {
      let E = e.drawDetails[M], C = E.structureDetails ?? I[M].structureDetails, A = E.stageDetails ?? I[M].stageDetails ?? {}, { structureIdsToRemove: N = [], structureIdsToAdd: O = [], publishingDetail: k = {}, stagesToRemove: F = [], stagesToAdd: x = [] } = E;
      if ((O || x) && (k.published = !0), I[M] = { publishingDetail: k, structureDetails: C, stageDetails: A }, O.length || N.length) {
        let B = (((P = (v = o == null ? void 0 : o.drawDefinitions) == null ? void 0 : v.find((G) => G.drawId === M)) == null ? void 0 : P.structures) ?? []).map(({ structureId: G }) => G), L = (O ?? []).concat(N ?? []).filter((G) => !B.includes(G));
        if (L.length)
          return j({ result: { error: It }, context: { invalidStructureIds: L } });
        C = C ?? {};
        for (let G of B)
          N.includes(G) ? C[G] = { published: !1 } : C[G] = { published: !0 };
        I[M].structureDetails = C;
      }
      let _ = (((T = (b = o == null ? void 0 : o.drawDefinitions) == null ? void 0 : b.find((B) => B.drawId === M)) == null ? void 0 : T.structures) ?? []).map(({ stage: B }) => B);
      if (x.length) {
        for (let B of x)
          A[B] = { published: !0 };
        for (let B of _)
          A[B] || (A[B] = { published: !1 });
      }
      if (x.length || F.length) {
        for (let B of F)
          A[B] = { published: !1 };
        for (let B of _)
          A[B] || (A[B] = { published: !0 });
      }
      (x.length || F.length) && (I[M].stageDetails = A);
    }
  Mc({ statusObject: { drawDetails: I }, removePriorValues: i, status: a, event: o });
  let { topics: y } = vi(), U = y.includes(kf), S = U || e.returnEventData ? (R = pm({ includePositionAssignments: r, ...e.eventDataParams, usePublishState: !0, tournamentRecord: n, policyDefinitions: d, event: o })) == null ? void 0 : R.eventData : void 0;
  return U && De({ payload: { eventData: S, tournamentId: n.tournamentId }, topic: kf }), { ...V, eventData: S };
}
var FM = "deleteDrawDefinitions", sh = "autoSchedulingAudit", rl = "deleteEvents", nB = { AUTO_SCHEDULING_AUDIT: sh, DELETE_EVENTS: rl, DELETE_DRAW_DEFINITIONS: FM };
function Pm(e) {
  var P, b, T, R, M;
  if (!e.tournamentRecord)
    return { error: ae };
  let t = "deleteDrawDefinitions", r = e.drawIds ?? [], i = e.event, { autoPublish: n = !0, tournamentRecord: a, auditData: o, eventId: s, force: c } = e, { appliedPolicies: u } = je({ tournamentRecord: a, event: i }), d = { ...u, ...e.policyDefinitions }, p = Array.isArray(r) ? r[0] : void 0;
  if (!i) {
    let E = Cr({ tournamentRecord: a, eventId: s, drawId: p });
    if (E.error)
      return E;
    i = E.event;
  }
  let l = [], m = [], f = [];
  if (!(i != null && i.drawDefinitions))
    return j({ info: "event has no drawDefinition", result: { ...V }, stack: t });
  let h = i.drawDefinitions.map(({ drawId: E }) => E);
  if (r.length || (r = h), r = r.filter((E) => h.includes(E)), !r.length)
    return j({ info: "nothing to do; no matching drawIds in event.", result: { ...V }, stack: t });
  let g = ce(Pt({ event: i }).flightProfile, !1, !0), I = ({ participantId: E, drawPosition: C, qualifier: A, bye: N }) => ({ bye: N, qualifier: A, drawPosition: C, participantId: E }), y = c ?? ((b = (P = u == null ? void 0 : u[yi]) == null ? void 0 : P.allowDeletionWithScoresPresent) == null ? void 0 : b.drawDefinitions), U = bi({ event: i }) ?? {}, S = U.drawIds ?? (U.drawDetails && Object.keys(U.drawDetails)) ?? [], D, w = [], v = i.drawDefinitions.filter((E) => {
    var C, A, N, O, k, F, x, _;
    if (r.includes(E.drawId)) {
      let B = ((C = vr({ event: i, drawDefinition: E })) == null ? void 0 : C.matchUps) ?? [];
      if (B.some(({ score: re }) => jt({ score: re })) && !y)
        return w.push(E.drawId), !0;
      let { drawId: L, drawType: G, drawName: $ } = E, W = (A = g == null ? void 0 : g.flights) == null ? void 0 : A.find((re) => re.drawId === E.drawId);
      W && (W.drawEntries = (N = W.drawEntries) == null ? void 0 : N.filter((re) => $i.includes(re.entryStatus))), S.includes(L) && (S = S.filter((re) => re !== L), D = !0);
      let q = (k = (O = Bi({ stageSequence: 1, drawDefinition: E, stage: ue })) == null ? void 0 : O.structures) == null ? void 0 : k[0], K = (x = (F = q ? fu({ structureId: q.structureId, tournamentRecord: a, drawDefinition: E }) : void 0) == null ? void 0 : F.positionAssignments) == null ? void 0 : x.map(I), z = (_ = Bi({ stage: ge, drawDefinition: E })) == null ? void 0 : _.structures, Y = z != null && z.length ? z.map((re) => {
        var H;
        let Q = re.stageSequence;
        return { positionAssignments: (H = fu({ structureId: re.structureId, tournamentRecord: a, drawDefinition: E })) == null ? void 0 : H.positionAssignments.map(I), stageSequence: Q };
      }) : void 0, X = { action: FM, payload: { drawDefinitions: [E], eventId: s ?? (i == null ? void 0 : i.eventId), auditData: o } };
      f.push(X), l.push(me({ tournamentId: a.tournamentId, eventId: s ?? (i == null ? void 0 : i.eventId), qualifyingPositionAssignments: Y, positionAssignments: K, auditData: o, drawType: G, drawName: $, drawId: L })), B == null || B.forEach(({ matchUpId: re }) => m.push(re));
    }
    return !r.includes(E.drawId);
  });
  if (w.length && !c)
    return j({ context: { drawIdsWithScoresPresent: w }, result: { error: tp }, stack: t });
  if (i.drawDefinitions = v, g && Ma({ event: i, extension: { name: _i, value: g } }), Td({ tournamentRecord: a }), D) {
    let E = {};
    for (let A of S)
      E[A] = ((T = U.drawDetails) == null ? void 0 : T[A]) ?? { published: !0 };
    let C = Mc({ statusObject: { drawDetails: E }, event: i });
    if (C.error)
      return { error: C.error };
  }
  if (f.length)
    if (rp(jn)) {
      let E = a.tournamentId;
      De({ topic: jn, payload: { tournamentId: E, detail: f } });
      let C = (((M = (R = Pi({ element: i, itemType: Va })) == null ? void 0 : R.timeItem) == null ? void 0 : M.itemValue) || 0) + 1;
      yn({ element: i, timeItem: { itemType: Va, itemValue: C }, removePriorValues: !0 });
    } else
      aB({ appliedPolicies: u, event: i, deletedDrawsDetail: l, auditData: o });
  if (m.length && ta({ tournamentId: a == null ? void 0 : a.tournamentId, matchUpIds: m }), r.forEach((E) => aO({ drawId: E })), n && D) {
    let E = Nc({ ...e.eventDataParams, drawIdsToRemove: r, policyDefinitions: d, tournamentRecord: a, event: i });
    if (E.error)
      return { ...V, info: E.error };
  }
  return { ...V };
}
function aB({ appliedPolicies: e, event: t, deletedDrawsDetail: r, auditData: i }) {
  var s;
  if (((s = e == null ? void 0 : e.audit) == null ? void 0 : s[Va]) === !1)
    return;
  let { extension: n } = Ne({ name: Va, element: t }), a = { ...i, deletedDrawsDetail: r }, o = { value: Array.isArray(n == null ? void 0 : n.value) ? n == null ? void 0 : n.value.concat(a) : [a], name: Va };
  Ve({ element: t, extension: o });
}
function xM({ autoPublish: e = !0, tournamentRecord: t, auditData: r, event: i, force: n }) {
  var o;
  if (!t)
    return { error: ae };
  if (!i)
    return { error: pt };
  let { flightProfile: a } = Pt({ event: i });
  if (a) {
    let s = (o = a.flights) == null ? void 0 : o.map(({ drawId: u }) => u).filter(Boolean), c = Pm({ eventId: i.eventId, tournamentRecord: t, autoPublish: e, auditData: r, drawIds: s, event: i, force: n });
    return c.error ? c : yp({ event: i, name: _i });
  }
  return { ...V };
}
function jU(e) {
  let { matchUpFormat: t, recoveryTimes: r, averageTimes: i, tournamentId: n, eventId: a } = e, o = (e == null ? void 0 : e.tournamentRecords) ?? ((e == null ? void 0 : e.tournamentRecord) && { [e.tournamentRecord.tournamentId]: e.tournamentRecord }) ?? {};
  if (!Object.keys(o).length)
    return { error: yt };
  let s = Object.keys(o).filter((u) => !n || n === u);
  if (n && !s.includes(n))
    return { error: J };
  let c;
  for (let u of s) {
    let d = o[u], { event: p } = Cr({ tournamentRecord: d, eventId: a });
    a && p && (c = !0);
    let l = oB({ tournamentRecord: d, event: p, matchUpFormat: t, averageTimes: i, recoveryTimes: r });
    if (l.error)
      return l;
  }
  return !a || c ? { ...V } : { error: Ii };
}
function oB({ tournamentRecord: e, recoveryTimes: t, matchUpFormat: r, averageTimes: i, event: n }) {
  if (!e)
    return { error: ae };
  if (i && !Array.isArray(i))
    return { error: J };
  if (t && !Array.isArray(t))
    return { error: J };
  let a = Kn;
  if (n) {
    let { extension: o } = Ne({ element: n, name: a }), s = (o == null ? void 0 : o.value) || {}, c = BS({ ...s, matchUpFormat: r, averageTimes: i, recoveryTimes: t });
    Ve({ element: n, extension: { name: a, value: c } });
  } else {
    let { extension: o } = Ne({ element: e, name: a }), s = (o == null ? void 0 : o.value) || {}, c = BS({ ...s, matchUpFormat: r, averageTimes: i, recoveryTimes: t });
    Ve({ extension: { name: a, value: c }, element: e });
  }
  return { ...V };
}
function BS(e) {
  let { matchUpRecoveryTimes: t = [], matchUpAverageTimes: r = [], matchUpFormat: i } = e, { averageTimes: n, recoveryTimes: a } = e;
  n = (n || []).filter((c) => {
    var u, d;
    return ((u = c == null ? void 0 : c.categoryNames) == null ? void 0 : u.length) || ((d = c == null ? void 0 : c.categoryTypes) == null ? void 0 : d.length);
  });
  let o = (n == null ? void 0 : n.length) && r.map((c) => {
    var u;
    return c != null && c.matchUpFormatCodes.includes(i) ? { ...c, matchUpFormatCodes: (u = c.matchUpFormatCodes) == null ? void 0 : u.filter((d) => d !== i) } : c;
  }).filter(({ matchUpFormatCodes: c }) => c == null ? void 0 : c.length).concat({ matchUpFormatCodes: [i], averageTimes: n });
  a = (a || []).filter((c) => {
    var u, d;
    return ((u = c == null ? void 0 : c.categoryNames) == null ? void 0 : u.length) || ((d = c == null ? void 0 : c.categoryTypes) == null ? void 0 : d.length);
  });
  let s = (a == null ? void 0 : a.length) && t.map((c) => {
    var u;
    return c != null && c.matchUpFormatCodes.includes(i) ? { ...c, matchUpFormatCodes: (u = c.matchUpFormatCodes) == null ? void 0 : u.filter((d) => d !== i) } : c;
  }).filter(({ matchUpFormatCodes: c, averageTimes: u }) => (c == null ? void 0 : c.length) || u).concat({ matchUpFormatCodes: [i], recoveryTimes: a });
  return { matchUpAverageTimes: (o == null ? void 0 : o.length) && o || r, matchUpRecoveryTimes: (s == null ? void 0 : s.length) && s || t };
}
function LM(e) {
  let { tournamentRecord: t, recoveryMinutes: r, averageMinutes: i, matchUpFormat: n, categoryType: a, eventId: o, event: s } = e;
  if (!t)
    return { error: ae };
  if (!Jr({ matchUpFormat: n }))
    return { error: J };
  if (!s)
    return { error: pt };
  let { averageTimes: c = [], recoveryTimes: u = [] } = ym({ tournamentRecord: t, matchUpFormat: n, event: s }), d = s.category, p = (d == null ? void 0 : d.categoryName) || (d == null ? void 0 : d.ageCategoryCode) || (s == null ? void 0 : s.eventId), l = { categoryNames: [p], minutes: {} }, m = { categoryNames: [p], minutes: {} }, f = (U) => {
    var S, D;
    if ((S = U.categoryTypes) != null && S.includes(a) && console.log("encountered:", { categoryType: a }), !((D = U.categoryNames) != null && D.includes(p) && (U.categoryNames = U.categoryNames.filter((w) => w !== p), l = { minutes: U.minutes, categoryNames: [p] }, !U.categoryNames.length)))
      return U;
  }, h = i && !isNaN(ye(i)), g = r && !isNaN(ye(r)), I = c.map(f).filter((U) => {
    var S;
    return (S = U == null ? void 0 : U.categoryNames) == null ? void 0 : S.length;
  }), y = u.map(f).filter((U) => {
    var S;
    return (S = U == null ? void 0 : U.categoryNames) == null ? void 0 : S.length;
  });
  return h && (Object.assign(l.minutes, { [(s == null ? void 0 : s.eventType) || rt]: i }), I.push(l)), g && (Object.assign(m.minutes, { [(s == null ? void 0 : s.eventType) || rt]: r }), y.push(m)), !h && !g ? { error: J } : jU({ averageTimes: h && I, recoveryTimes: g && y, tournamentRecord: t, matchUpFormat: n, eventId: o, event: s });
}
function Dm(e) {
  if (e.event)
    return VS({ event: e.event });
  {
    e.tournamentRecord && !e.tournamentRecords && (e.tournamentRecords = { [e.tournamentRecord.tournamentId]: e.tournamentRecord });
    let t = fe(e, [{ [gr]: !0, [ZP]: !0 }]);
    if (t.error)
      return t;
    let { tournamentRecords: r, eventId: i } = e;
    for (let n of Object.values(r ?? {})) {
      let { event: a } = Cr({ tournamentRecord: n, eventId: i });
      if (a)
        return VS({ event: a });
    }
  }
  return { error: Ii };
}
function VS({ event: e }) {
  return yp({ event: e, name: Kn });
}
var sB = "MON", cB = "TUE", uB = "WED", dB = "THU", lB = "FRI", pB = "SAT", mB = "SUN", _M = { MON: sB, TUE: cB, WED: uB, THU: dB, FRI: lB, SAT: pB, SUN: mB };
function BM(e) {
  return !Array.isArray(e) || Te(e).length !== e.length ? !1 : e.every((t) => Object.keys(_M).includes(t));
}
function GU({ tournamentRecord: e, event: t, startDate: r }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: pt };
  if (!un.test(r))
    return { error: Qt };
  let i = VM(e);
  if (i.error)
    return i;
  let { tournamentStartDate: n, tournamentEndDate: a } = i, o = new Date(be(r)).getTime();
  if (!n || !a || o < n || o > a)
    return { error: Qt };
  let s = t.endDate && new Date(be(t.endDate)).getTime();
  return s && o > s && (t.endDate = r), t.startDate = r, { ...V };
}
function $U(e) {
  let { tournamentRecord: t, event: r, endDate: i } = e;
  if (!t)
    return { error: ae };
  if (!r)
    return { error: pt };
  if (!un.test(i))
    return { error: Qt };
  let n = VM(t);
  if (n.error)
    return n;
  let { tournamentStartDate: a, tournamentEndDate: o } = n, s = new Date(be(i)).getTime();
  if (!a || !o || s < a || s > o)
    return { error: Qt };
  let c = r.startDate && new Date(be(r.startDate)).getTime();
  return c && s < c && (r.startDate = i), r.endDate = i, { ...V };
}
function qU(e) {
  var c;
  let t = fe(e, [{ tournamentRecord: !0, event: !0 }, { [cr]: (u) => un.test(u), [ci]: Qt, startDate: !1, endDate: !1 }, { [cr]: (u) => u.filter(Boolean).every((d) => un.test(d)), [ci]: Qt, activeDates: !1 }, { [cr]: BM, weekdays: !1 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, weekdays: i, event: n, startDate: a, endDate: o } = e, s = (c = e.activeDates) == null ? void 0 : c.filter(Boolean);
  if (a && o) {
    let u = new Date(be(a)).getTime(), d = new Date(be(o)).getTime();
    if (u > d)
      return { error: J };
  }
  if (s) {
    let u = a || r.startDate, d = o || r.endDate, p = !u || s.every((m) => new Date(m) >= new Date(u)), l = !d || s.every((m) => new Date(m) <= new Date(d));
    if (!p || !l)
      return { error: Qt };
  }
  if (a) {
    let u = GU({ tournamentRecord: r, event: n, startDate: a });
    if (u.error)
      return u;
  }
  if (o) {
    let u = $U({ tournamentRecord: r, event: n, endDate: o });
    if (u.error)
      return u;
  }
  return s && (n.activeDates = s), i && (n.weekdays = i), { ...V };
}
function VM(e) {
  let { startDate: t, endDate: r } = e;
  return !un.test(t) || !un.test(r) ? j({ result: { error: aw }, context: { startDate: t, endDate: r } }) : { tournamentStartDate: new Date(be(t)).getTime(), tournamentEndDate: new Date(be(r)).getTime() };
}
function WU({ event: e, orderedDrawIdsMap: t }) {
  var n, a;
  if (typeof e != "object")
    return { error: pt };
  if (!t)
    return { error: Ie, info: "Missing drawIdsOrderMap" };
  if (typeof t != "object")
    return { error: J, info: "orderedDrawIdsMap must be an object" };
  let r = Object.values(t);
  if (!r.every((o) => !isNaN(o)))
    return { error: J, info: "drawOrder must be numeric" };
  if (Te(r).length !== r.length)
    return { error: J, info: "drawOrder values must be unique" };
  if ((n = e.drawDefinitions) != null && n.length) {
    let o = (e.drawDefinitions || []).map(({ drawId: c }) => c), s = Object.keys(t);
    if (s != null && s.length && wt(o, s).length !== o.length)
      return { error: J, info: "Missing drawIds" };
    e.drawDefinitions.forEach((c) => {
      c.drawOrder = t[c.drawId];
    });
  }
  let { flightProfile: i } = Pt({ event: e });
  return (a = i == null ? void 0 : i.flights) == null || a.forEach((o) => {
    o.flightNumber = t[o.drawId];
  }), { ...V };
}
function HU({ tournamentRecord: e, event: t }) {
  var n;
  if (!e)
    return { error: ae };
  if (!t)
    return { error: pt };
  let { flightProfile: r } = Pt({ event: t }), i = (r == null ? void 0 : r.flights) && Object.assign({}, ...r.flights.sort((a, o) => a.flightNumber - o.flightNumber).map((a, o) => ({ [a.drawId]: o + 1 }))) || ((n = t.drawDefinitions) == null ? void 0 : n.length) && Object.assign({}, ...t.drawDefinitions.sort((a, o) => a.drawOrder - o.drawOrder).map((a, o) => ({ [a.drawId]: o + 1 }))) || void 0;
  return i ? WU({ event: t, orderedDrawIdsMap: i }) : { ...V };
}
function jM({ autoPublish: e = !0, tournamentRecord: t, auditData: r, drawId: i, event: n, force: a }) {
  var s, c;
  if (!t)
    return { error: ae };
  if (!i)
    return { error: tn };
  if (!n)
    return { error: pt };
  let { flightProfile: o } = Pt({ event: n });
  if (o && ((s = o.flights) != null && s.find((u) => u.drawId === i))) {
    let u = o.flights.filter((p) => p.drawId !== i), d = { name: _i, value: { ...o, flights: u } };
    Ma({ event: n, extension: d });
  }
  if ((c = n.drawDefinitions) != null && c.find((u) => u.drawId === i)) {
    let u = Pm({ drawIds: [i], eventId: n.eventId, tournamentRecord: t, autoPublish: e, auditData: r, event: n, force: a });
    if (u.error)
      return u;
  }
  return HU({ tournamentRecord: t, event: n });
}
function GM(e) {
  var g, I;
  let t = fe(e, [{ [ba]: !0, [Gt]: !0, [pg]: !1 }, { replacementIndividualParticipantId: !0, [cr]: (y) => ht(y), existingIndividualParticipantId: !0, [ki]: _t, participantId: !0 }]), { replacementIndividualParticipantId: r, existingIndividualParticipantId: i, tournamentRecord: n, drawDefinition: a, participantId: o, event: s, uuids: c } = e;
  if (t.error)
    return t;
  if ((s == null ? void 0 : s.eventType) !== Ui)
    return { error: Mn };
  if (!(((g = s == null ? void 0 : s.entries) == null ? void 0 : g.filter(({ entryStatus: y }) => [Di, po].includes(y)).map(({ participantId: y }) => y)) || []).includes(r))
    return { error: Ji };
  let u = (n.participants || []).find((y) => y.participantId === o);
  if ((u == null ? void 0 : u.participantType) !== Re)
    return { error: Wo, participant: u };
  let d = u.individualParticipantIds, p = [r, ...d.filter((y) => y !== i)], { participant: l } = Vi({ participantIds: p, tournamentRecord: n }), m;
  if (l)
    m = l.participantId;
  else {
    let y = { participantId: c == null ? void 0 : c.pop(), participantRole: ur, individualParticipantIds: p, participantType: Re }, U = hn({ participant: y, returnParticipant: !0, tournamentRecord: n });
    if (U.error)
      return U;
    m = U.participant.participantId;
  }
  let { flightProfile: f } = Pt({ event: s });
  if (a) {
    let y = (I = f == null ? void 0 : f.flights) == null ? void 0 : I.find(({ drawId: U }) => U === a.drawId);
    y && (y.drawEntries = y.drawEntries.map((U) => U.participantId === o ? { ...U, participantId: m } : U)), a.entries = a.entries.map((U) => U.participantId === o ? { ...U, participantId: m } : U);
    for (let U of a.structures || [])
      if (U.structures) {
        U.positionAssignments = void 0;
        for (let S of U.structures)
          S.positionAssignments = S.positionAssignments.map((D) => D.participantId === o ? { ...D, participantId: m } : D);
      } else
        U.positionAssignments && (U.positionAssignments = U.positionAssignments.map((S) => S.participantId === o ? { ...S, participantId: m } : S));
  }
  s.entries = s.entries.map((y) => y.participantId === o && { ...y, participantId: m } || y.participantId === r && { ...y, participantId: i } || y);
  let h = n.events.some(({ entries: y, eventId: U, drawDefinitions: S }) => s.eventId === U ? S.some(({ drawId: D, entries: w }) => D === (a == null ? void 0 : a.drawId) ? !1 : w == null ? void 0 : w.find((v) => v.participantId === o)) : y == null ? void 0 : y.find((D) => D.participantId === o));
  if (!h) {
    let y = ds({ addIndividualParticipantsToEvents: !1, participantIds: [o], tournamentRecord: n });
    if (y.error)
      return y;
  }
  return { ...V, participantOtherEntries: h, newPairParticipantId: m };
}
function Nd(e) {
  var M, E, C, A, N, O, k, F, x, _, B, L;
  let { flight: t, suppressNotifications: r, modifyEventEntries: i, existingDrawCount: n, allowReplacement: a, checkEntryStatus: o, tournamentRecord: s, drawDefinition: c, event: u } = e;
  if (!c)
    return { error: le };
  if (!u)
    return { error: pt };
  u.drawDefinitions || (u.drawDefinitions = []);
  let { drawId: d, drawName: p, entries: l } = c, { entries: m } = u, f = 0;
  if (n !== void 0 && n !== u.drawDefinitions.length)
    return { error: J, info: "drawDefintions count mismatch" };
  let { flightProfile: h } = Pt({ event: u }), g = t && ((M = h == null ? void 0 : h.flights) == null ? void 0 : M.find((G) => G.flightNumber === t.flightNumber)), I = (A = (C = (E = h == null ? void 0 : h.links) == null ? void 0 : E.find((G) => {
    var $;
    return (($ = G == null ? void 0 : G.target) == null ? void 0 : $.drawId) === d;
  })) == null ? void 0 : C.source) == null ? void 0 : A.drawId;
  if (I && !u.drawDefinitions.find((G) => G.drawId === I))
    return j({ result: { error: le }, info: { sourceDrawId: I } });
  if (g && g.drawId !== c.drawId)
    return j({ result: { error: Po }, info: { relevantFlight: g } });
  let y = l == null ? void 0 : l.every(({ participantId: G, entryStatus: $ }) => {
    let W = g == null ? void 0 : g.drawEntries.find((q) => q.participantId === G);
    return !$ || (W == null ? void 0 : W.entryStatus) === $;
  }), U = !o || m && (l == null ? void 0 : l.every(({ participantId: G, entryStatus: $, entryStage: W }) => {
    var q;
    return ((q = m.find((K) => K.participantId === G && (!K.entryStage || K.entryStage === W))) == null ? void 0 : q.entryStatus) === $;
  }));
  if (g && !y)
    return j({ result: { error: Po }, context: { drawEntriesPresentInFlight: y, matchingEventEntries: U, relevantFlight: g }, info: "Draw entries are not present in flight or do not match entryStatuses" });
  if (i && (l == null || l.filter(Boolean).forEach((G) => {
    if (G != null && G.entryStatus && $i.includes(G == null ? void 0 : G.entryStatus)) {
      let $ = m == null ? void 0 : m.filter(Boolean).find((W) => W.participantId === G.participantId);
      $ && G.entryStatus && ($ == null ? void 0 : $.entryStatus) !== G.entryStatus && ($.entryStatus = G.entryStatus, f += 1);
    }
  })), m && !U)
    return j({ result: { info: "Draw entries do not match event entryStatuses", context: { matchingEventEntries: U, eventEntries: m }, error: Po } });
  let S = ((O = (N = h == null ? void 0 : h.flights) == null ? void 0 : N.map(({ flightNumber: G }) => !isNaN(G) && ye(G))) == null ? void 0 : O.filter(Boolean)) || [], D = ((k = u.drawDefinitions.map(({ drawOrder: G }) => G && ye(G))) == null ? void 0 : k.filter(Boolean)) || [], w = Math.max(0, ...D, ...S) + 1, v = (F = h == null ? void 0 : h.flights) == null ? void 0 : F.find((G) => G.drawId === d), P;
  if (v) {
    v.drawName = c.drawName, P = { name: _i, value: { ...h, flights: h.flights } };
    let G = v.flightNumber;
    G && !D.includes(G) ? w = G : v.flightNumber = w;
  } else {
    let G = (h == null ? void 0 : h.flights) || [];
    G.push({ manuallyAdded: !0, flightNumber: w, drawEntries: l, drawName: p, drawId: d }), P = { name: _i, value: { ...h || {}, flights: G } };
  }
  Ma({ event: u, extension: P }), Object.assign(c, { drawOrder: w });
  let b = u.drawDefinitions.find((G) => G.drawId === d), T = s == null ? void 0 : s.tournamentId, R = u.eventId;
  if (b) {
    if (!a)
      return { error: Fv };
    let G = ((_ = (x = vr({ drawDefinition: b })) == null ? void 0 : x.matchUps) == null ? void 0 : _.map(Ht)) ?? [], $ = (B = vr({ drawDefinition: c })) == null ? void 0 : B.matchUps;
    if (!r) {
      G != null && G.length && ta({ matchUpIds: G, action: "modifyDrawDefinition", tournamentId: T, eventId: R }), $ != null && $.length && ya({ matchUps: $, tournamentId: T, eventId: R }), u.drawDefinitions = u.drawDefinitions.map((q) => q.drawId === d ? c : q);
      let W = (L = c.structures) == null ? void 0 : L.map(({ structureId: q }) => q);
      ut({ drawDefinition: c, tournamentId: T, structureIds: W, eventId: R });
    }
  } else if (u.drawDefinitions.push(c), !r) {
    let { matchUps: G } = vr({ drawDefinition: c, event: u });
    G && ya({ tournamentId: s == null ? void 0 : s.tournamentId, matchUps: G }), Vu({ drawDefinition: c, tournamentId: T, eventId: R });
  }
  return { ...V, modifiedEventEntryStatusCount: f };
}
function $M(e) {
  let { provisionalPositioning: t, useExistingSeedLimit: r, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, assignments: s, drawId: c, event: u } = e, d = 0;
  if (!(s != null && s.length))
    return { error: Dh };
  if (!i)
    return { error: ae };
  if (!c)
    return { error: tn };
  let p = Si({ provisionalPositioning: t, drawDefinition: n, structureId: o });
  if (p.error)
    return p;
  let { seedAssignments: l, seedLimit: m } = p, f = Object.assign({}, ...(l ?? []).filter((I) => I.seedNumber).map((I) => ({ [I.seedNumber]: I })));
  s.forEach((I) => {
    let { seedNumber: y } = I;
    m && y <= m && (!r || f[y]) && (f[y] = I);
  });
  let h = Object.values(f), g = h.map((I) => I == null ? void 0 : I.participantId).filter(Boolean);
  if (g.length !== Dv(g).length)
    return { error: xv };
  for (let I of h) {
    let y = vc({ ...I, provisionalPositioning: t, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, event: u });
    if (y != null && y.error)
      return y;
    y != null && y.success && d++;
  }
  return d ? { ...V, modifications: d } : { error: cc };
}
function zU({ deleteExisting: e, event: t, flightProfile: r }) {
  var a;
  let i = "attachFlightProfile";
  if (!r)
    return j({ result: { error: Ie }, stack: i });
  if (!t)
    return j({ result: { error: pt }, stack: i });
  let { flightProfile: n } = Pt({ event: t });
  return n && !e ? j({ result: { error: jh }, stack: i }) : (a = t.drawDefinitions) != null && a.length ? j({ result: { error: Cv }, stack: i }) : (Ma({ event: t, extension: { name: _i, value: r } }), { flightProfile: ce(r, !1, !0), ...V });
}
function fB({ tournamentRecord: e, scaleAttributes: t, participantIds: r }) {
  var s;
  if (!e)
    return { error: ae };
  if (!r)
    return { error: Da };
  if (!t)
    return { error: Ie, info: "scaleAttributes required" };
  let { scaleType: i, eventType: n, scaleName: a } = t, o = [KD, i, n, a].join(".");
  return (s = e.participants) == null || s.forEach((c) => {
    r.includes(c.participantId) && c.timeItems && (c.timeItems = c.timeItems.filter((u) => u && (u == null ? void 0 : u.itemType) !== o));
  }), { ...V };
}
function YU({ tournamentRecord: e, scaleAttributes: t, drawDefinition: r, entryStatuses: i, drawId: n, event: a, stage: o }) {
  var u;
  if (!a)
    return { error: pt };
  if (i && !Array.isArray(i))
    return j({ result: { error: J }, info: Xa("entryStatus"), stack: "removeScaleValues" });
  let s = a.entries;
  if (n) {
    let { flightProfile: d } = Pt({ event: a }), p = (u = d == null ? void 0 : d.flights) == null ? void 0 : u.find((l) => l.drawId === n);
    p ? s = p.drawEntries : s = r == null ? void 0 : r.entries;
  }
  let c = (s || []).filter((d) => (!o || !d.entryStage || d.entryStage === o) && (!i || i.includes(d.entryStatus))).map(Ce);
  return fB({ tournamentRecord: e, scaleAttributes: t, participantIds: c });
}
function Tm({ removePriorValues: e, tournamentRecord: t, displaySettings: r, status: i = li, event: n }) {
  if (!t)
    return j({ result: { error: ae } });
  if (!n)
    return j({ result: { error: pt } });
  if (!Le(r))
    return j({ result: { error: Ie } });
  if (Le(r.draws))
    for (let o of Object.keys(r.draws)) {
      let s = r.draws[o].scheduleDetails ?? [];
      if (s.length) {
        let c = [];
        for (let u of s) {
          let d = c.find((p) => $E(p.attributes, u.attributes));
          d != null && d.dates && u.dates ? d.dates.push(...u.dates) : c.push(u);
        }
        r.draws[o].scheduleDetails = c;
      }
    }
  let a = Mc({ statusObject: { displaySettings: r }, removePriorValues: e, status: i, event: n });
  return a.error ? a : { ...V };
}
function qM({ tournamentRecord: e, drawDefinition: t, entryStatuses: r, scaleName: i, drawId: n, event: a, stage: o }) {
  var c, u;
  if (!e)
    return { error: ae };
  if (!a)
    return { error: pt };
  i = i || ((c = a.category) == null ? void 0 : c.categoryName) || ((u = a.category) == null ? void 0 : u.ageCategoryCode);
  let s = { eventType: a.eventType, scaleType: Pn, scaleName: i };
  return YU({ tournamentRecord: e, scaleAttributes: s, drawDefinition: t, entryStatuses: r, drawId: n, event: a, stage: o });
}
function WM(e) {
  let t = fe(e, [{ [Gt]: !0 }, { eventIds: !0, [Or]: fr }]);
  if (t.error)
    return t;
  let { removePairParticipants: r, tournamentRecord: i, eventIds: n } = e, a = [], o = [], s = [], c = [];
  if (i.events = (i.events || []).filter((u) => {
    if (n.includes(u.eventId)) {
      let l = { action: rl, payload: { events: [u] } };
      a.push(l), o.push({ tournamentId: i.tournamentId, eventName: u.eventName, eventType: u.eventType, category: u.category, eventId: u.eventId, gender: u.gender });
    }
    let d = u.eventType === Ui ? (u.entries || []).map(({ entryStatus: l, participantId: m }) => l !== Di && m).filter(Boolean) : [], p = n.includes(u.eventId);
    return p ? c.push(...d) : s.push(...d), !p;
  }), r) {
    let u = c.filter((d) => !s.includes(d));
    i.participants = i.participants.filter(({ participantId: d }) => !u.includes(d));
  }
  if (Td({ tournamentRecord: i }), a.length)
    if (rp(jn)) {
      let u = i.tournamentId;
      De({ topic: jn, payload: { type: rl, tournamentId: u, detail: a } });
    } else
      Ud({ tournamentRecord: i, timeItem: { itemValue: o, itemType: rl } });
  return { ...V };
}
function HM(e) {
  var h, g, I;
  let t = fe(e, [{ tournamentRecord: !0, eventId: !0, event: !0 }, { eventUpdates: !0, _ofType: _r }]);
  if (t.error)
    return t;
  let { eventUpdates: r, event: i } = e, n = "modifyEvent", a = IB(e), o = UB({ enteredParticipants: a }), { enteredParticipantGenders: s, enteredParticipantTypes: c } = o, u = (g = (h = Pt({ event: i })) == null ? void 0 : h.flightProfile) == null ? void 0 : g.flights, d = !((I = i.drawDefinitions) != null && I.length) && !(u != null && u.length), p = yB({ noFlightsNoDraws: d, enteredParticipantGenders: s, eventUpdates: r, stack: n });
  if (p.error)
    return p;
  let l = SB({ enteredParticipantTypes: c, eventUpdates: r, stack: n });
  if (l.error)
    return l;
  let m = hB({ ...e, ...o, enteredParticipants: a, stack: n });
  if (m.error)
    return m;
  let f = gB({ ...e, stack: n });
  return f.error ? f : (r.eventType && (i.eventType = r.eventType), r.eventName && (i.eventName = r.eventName), r.gender && (i.gender = r.gender), { ...V });
}
function hB(e) {
  var i, n, a, o, s, c;
  let t = (i = e.eventUpdates) == null ? void 0 : i.category;
  if (!t)
    return { ...V };
  let r = eu({ category: t });
  if (r.error)
    return r;
  if (e.event.eventType === xt) {
    let u = ((a = (n = e.event) == null ? void 0 : n.drawDefinitions) == null ? void 0 : a.map((l) => rn(l))) ?? [], d = rn(e.event), p = (((o = Ln(e)) == null ? void 0 : o.matchUps) ?? []).map((l) => rn(l)) ?? [];
    if (![d, ...u, ...p].filter(Boolean).every((l) => l.collectionDefinitions.every((m) => !m.category || Eu({ category: e.eventUpdates.category, childCategory: m.category }))))
      return j({ result: { error: Yc }, stack: e.stack });
  }
  if ((s = e.enteredParticipants) != null && s.length) {
    let u = e.eventUpdates.startDate || e.event.startDate || e.tournamentRecord.startDate, d = e.eventUpdates.endDate || e.event.endDate || e.tournamentRecord.endDate, p = e.enteredParticipants.map((f) => f.participantType === Oe ? f : f.individualParticpants ?? []).flat(), l = Oo({ category: t, consideredDate: u }), m = Oo({ category: t, consideredDate: d });
    if (l != null && l.ageMinDate || l != null && l.ageMaxDate || m != null && m.ageMinDate || m != null && m.ageMaxDate)
      for (let f of p) {
        let h = (c = f.person) == null ? void 0 : c.birthDate;
        if (!h)
          return j({ result: { error: tw }, stack: e.stack });
        let g = new Date(h).getTime();
        if (l.ageMinDate || l.ageMaxDate) {
          let I = new Date(l.ageMinDate).getTime(), y = new Date(l.ageMaxDate).getTime();
          if (g < I || g > y)
            return j({ result: { error: wf }, stack: e.stack });
        }
        if (m.ageMin || m.ageMax) {
          let I = new Date(m.ageMinDate).getTime(), y = new Date(m.ageMaxDate).getTime();
          if (g < I || g > y)
            return j({ result: { error: wf }, stack: e.stack });
        }
      }
  }
  return { ...V };
}
function gB(e) {
  let { tournamentRecord: t, eventUpdates: r, event: i, stack: n } = e;
  if (r.startDate || r.endDate) {
    let a = qU({ startDate: r.startDate, endDate: r.endDate, tournamentRecord: t, event: i });
    if (a.error)
      return j({ result: a, stack: n });
  }
  return { ...V };
}
function IB(e) {
  var n;
  let { tournamentRecord: t, event: r } = e, i = ((n = r == null ? void 0 : r.entries) == null ? void 0 : n.filter(({ entryStatus: a }) => {
    let o = a;
    return [...$i, Fi].includes(o);
  }).map(({ participantId: a }) => a)) ?? [];
  return i ? Ut({ participantFilters: { participantIds: i }, withIndividualParticipants: !0, tournamentRecord: t }).participants ?? [] : [];
}
function UB({ enteredParticipants: e }) {
  let t = [], r = e.reduce((n, a) => {
    var s, c;
    let o = (s = a.person) != null && s.sex ? [a.person.sex] : ((c = a.individualParticpants) == null ? void 0 : c.map((u) => {
      var d;
      return (d = u.person) == null ? void 0 : d.sex;
    })) || [];
    return t.push(...o), n.includes(a.participantType) ? n : n.concat(a.participantType);
  }, []), i = Te(t);
  return { enteredParticipantTypes: r, enteredParticipantGenders: i };
}
function yB({ noFlightsNoDraws: e, enteredParticipantGenders: t, eventUpdates: r, stack: i }) {
  let n = !t.length || !r.gender || r.gender === Zi || t.length === 1 && t[0] === r.gender || e && r.gender === Mr;
  return r.gender && !n ? j({ context: { gender: r.gender, validGender: n }, result: { error: _c }, stack: i }) : { ...V };
}
function SB({ enteredParticipantTypes: e, eventUpdates: t, stack: r }) {
  let i = (e.includes(xt) && [xt] || e.includes(Oe) && [dn] || e.includes(Re) && [Ui] || [Ui, dn, xt]).includes(t.eventType ?? "");
  return t.eventType && !i ? j({ context: { participantType: t.eventType, validEventType: i }, result: { error: Mn }, stack: r }) : { ...V };
}
function bm({ qualifyingPositions: e, drawEntries: t = [], drawName: r, drawId: i, event: n, stage: a }) {
  var m, f, h;
  let o = "addFlight";
  if (!n)
    return j({ result: { error: pt }, stack: o });
  if (!r)
    return j({ result: { error: Ie }, stack: o });
  if (t != null && t.length) {
    let g = (n.entries ?? []).map(Ce), I = t.map(Ce);
    if (wt(I, g).length !== I.length)
      return j({ result: { error: J }, stack: o });
  }
  let s = (m = Pt({ event: n })) == null ? void 0 : m.flightProfile, c = ((h = (f = s == null ? void 0 : s.flights) == null ? void 0 : f.map(({ flightNumber: g }) => !isNaN(g) && ye(g))) == null ? void 0 : h.filter(Boolean)) || [], u = Math.max(0, ...c) + 1, d = { drawId: i || ze(), flightNumber: u, drawEntries: t, drawName: r };
  if (a && (d.stage = a), e && (d.qualifyingPositions = e), ((s == null ? void 0 : s.flights) || []).find(({ drawId: g }) => g === d.drawId))
    return j({ result: { error: kw }, stack: o });
  let p = ((s == null ? void 0 : s.flights) || []).concat(d), l = { name: _i, value: { ...s || {}, flights: p } };
  return Ma({ event: n, extension: l });
}
var zM = {};
Ae(zM, { drawMatic: () => oU, garman: () => eN, generateAdHocMatchUps: () => Zp, generateAdHocRounds: () => aU, generateAndPopulatePlayoffStructures: () => FI, generateCourts: () => KU, generateDrawDefinition: () => Md, generateDrawMaticRound: () => KI, generateDrawStructuresAndLinks: () => HI, generateDrawTypeAndModifyDrawDefinition: () => zI, generateFlightProfile: () => PB, generateLineUps: () => ZM, generateQualifyingStructure: () => bI, generateSeedingScaleItems: () => wM, generateStatCrew: () => DB, generateVoluntaryConsolation: () => tR, roundRobinGroups: () => Ak });
var vB = "splitLevelBased", YM = "splitWaterfall", KM = "splitShuttle", wB = { SPLIT_LEVEL_BASED: vB, SPLIT_WATERFALL: YM, SPLIT_SHUTTLE: KM };
function PB(e) {
  let { drawNameRoot: t = "Flight", attachFlightProfile: r, tournamentRecord: i, scaleAttributes: n, scaleSortMethod: a, deleteExisting: o, sortDescending: s, drawNames: c = [], flightsCount: u, splitMethod: d, uuids: p = [], event: l, stage: m } = e;
  if (!l)
    return { error: pt };
  let f = l.entries ?? [], { flightProfile: h } = Pt({ event: l });
  if (h && r && !o)
    return { error: jh };
  let g = e.scaledEntries ?? fs({ tournamentRecord: i, scaleAttributes: n, scaleSortMethod: a, sortDescending: s, event: l, stage: m }).scaledEntries, I = g.map(Ce), y = yr(f.filter(({ participantId: T }) => !I.includes(T)).filter((T) => (!m || !T.entryStage || T.entryStage === m) && (!T.entryStatus || mo.includes(T.entryStatus)))), U = g.concat(...y), S = U.length, D = Math.ceil(S / u), w = zt(U, D);
  d === YM ? w = ff(U, u) : d === KM && (w = ff(U, u, !0));
  function v(T) {
    return (T || []).map(({ participantId: R, scaleValue: M }) => {
      let E = f.find((C) => C.participantId === R);
      return E != null && E.scaleValue && M && (E.scaleValue = M), E;
    }).sort((R, M) => R.scaleValue - M.scaleValue).map((R, M) => (R.scaleValue && (R.seedNumber = M + 1), R));
  }
  let P = oe(0, u).map((T) => {
    let R = T + 1;
    return { flightNumber: R, drawId: (p == null ? void 0 : p.pop()) ?? ze(), drawEntries: v(w[T]), drawName: (c == null ? void 0 : c.length) && c[T] || `${t} ${R}` };
  }), b = { scaleAttributes: n, splitMethod: d, flights: P };
  if (r) {
    let T = zU({ flightProfile: b, deleteExisting: o, event: l });
    return { splitEntries: oi() && w || void 0, ...T };
  } else
    return { flightProfile: b, ...V };
}
function QM({ json: e, tagName: t }) {
  let r = Object.keys(e).filter((a) => Array.isArray(e[a])).map((a) => ({ key: a, value: e[a].filter((o) => typeof o == "object" && Object.keys(o).length === 1) })), i = Object.keys(e).filter((a) => typeof e[a] == "object" && !Array.isArray(e[a])).map((a) => ({ key: a, value: e[a] })), n = Object.keys(e).filter((a) => ["string", "number"].includes(typeof e[a])).map((a) => ({ key: a, value: e[a] }));
  return JM({ tagName: t, attributes: n, childArrays: r, childObjects: i });
}
function JM(e) {
  let { tagName: t, attributes: r = [], childArrays: i = [], childObjects: n } = e, a = `\r
`, o = (m) => {
    let f = Object.keys(m)[0], h = m[f];
    return { key: f, value: h };
  }, s = i == null ? void 0 : i.map(({ key: m, value: f }) => JM({ tagName: m, childObjects: f.map(o) })).join(`\r
`), c = n == null ? void 0 : n.map(({ key: m, value: f }) => QM({ tagName: m, json: f ?? [] })).join(`\r
`), u = r == null ? void 0 : r.map(({ key: m, value: f }) => `${m}="${f}"`).join(" "), d = u ? ` ${u}` : "";
  if (t === "childArray")
    return c;
  let p = c != null && c.length ? `${a}${c}${a}` : "", l = s != null && s.length ? `${a}${s}${a}` : "";
  return `<${t}${d}>${p}${l}</${t}>`;
}
function DB(e) {
  var U, S, D;
  let t = fe(e, [{ [Gt]: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r } = e, { startDate: i, tournamentId: n, tournamentName: a } = r, { participantMap: o, matchUps: s, mappedMatchUps: c } = Ut({ withMatchUps: !0, withEvents: !0, tournamentRecord: r }), u = r.participants.filter((w) => w.participantType === Xe), d = (s == null ? void 0 : s.filter((w) => w.matchUpType === Xe)) ?? [], p = (d == null ? void 0 : d.reduce((w, v) => {
    let P = (v == null ? void 0 : v.tieMatchUps) ?? [];
    return P && [...w, ...P];
  }, [])) ?? [], l = (s == null ? void 0 : s.filter((w) => w.matchUpType === rt)) ?? [], m = (s == null ? void 0 : s.filter((w) => w.matchUpType === tt)) ?? [], f = p.length === l.length + m.length, h = d.length === 1 && f, g = { mappedMatchUps: c, participantMap: o, tournamentName: a, tournamentId: n, tournament: f ? "N" : "Y", startDate: i }, I = [], y = [];
  if (h) {
    let w = d[0], { json: v, xml: P } = jS({ teamParticipants: u, teamMatchUp: w, ...g, doubles: m, singles: l });
    y.push(v), I.push(P);
  } else
    for (let w of d) {
      let v = (U = w == null ? void 0 : w.sides) == null ? void 0 : U.map(({ participant: R }) => R == null ? void 0 : R.participantId).filter(Boolean);
      if ((v == null ? void 0 : v.length) !== 2)
        continue;
      let P = v.map((R) => {
        var M;
        return R && ((M = o == null ? void 0 : o[R]) == null ? void 0 : M.participant);
      }), { xml: b, json: T } = jS({ doubles: (S = w.tieMatchUps) == null ? void 0 : S.filter((R) => R.matchUpType === tt), singles: (D = w.tieMatchUps) == null ? void 0 : D.filter((R) => R.matchUpType === rt), teamParticipants: P, teamMatchUp: w, ...g });
      y.push(T), I.push(b);
    }
  return { json: y, xml: I, ...V };
}
function jS({ teamParticipants: e, mappedMatchUps: t, participantMap: r, tournamentName: i, tournamentId: n, teamMatchUp: a, tournament: o, startDate: s, doubles: c, singles: u }) {
  var S, D, w, v;
  let d = e == null ? void 0 : e.find((P) => {
    var b;
    return (b = P.participantRoleResponsibilities) == null ? void 0 : b.includes("Home");
  }), p = e == null ? void 0 : e.filter((P) => P.participantId !== (d == null ? void 0 : d.participantId)), l = Ci(s, "/", "MDY"), m = (d == null ? void 0 : d.participantName) || ((S = p == null ? void 0 : p[1]) == null ? void 0 : S.participantName), f = (d == null ? void 0 : d.participantId) || ((D = p == null ? void 0 : p[1]) == null ? void 0 : D.participantId), h = (w = p == null ? void 0 : p[0]) == null ? void 0 : w.participantName, g = (v = p == null ? void 0 : p[0]) == null ? void 0 : v.participantId, I = {}, y = e.map((P) => ({ team: { ...RB({ teamParticipant: P, teamMatchUp: a, uniValues: I, participantMap: r, mappedMatchUps: t, homeid: f }) } })), U = me({ venue: { tournamentname: o ? i : void 0, neutralgame: d ? "N" : "Y", gameid: n, officials: {}, tournament: o, rules: {}, homename: m, visname: h, homeid: f, visid: g, date: l }, childArray: y, singles_matches: u == null ? void 0 : u.map((P) => GS({ matchUp: P, homeid: f, uniValues: I })), doubles_matches: c == null ? void 0 : c.map((P) => GS({ matchUp: P, homeid: f, uniValues: I })) });
  return { json: U, xml: QM({ json: U, tagName: "tngame" }) };
}
function TB({ homeid: e, uniValues: t, participant: r }) {
  var h, g, I, y, U, S, D, w, v, P, b, T, R, M, E;
  if (!r)
    return {};
  let i = ((h = r.individualParticipants) == null ? void 0 : h.length) === 2, n = i ? Te((g = r.individualParticipants) == null ? void 0 : g.map((C) => {
    var A, N;
    return (N = (A = C.teams) == null ? void 0 : A[0]) == null ? void 0 : N.participantId;
  })) : [], a = i ? Te((I = r.individualParticipants) == null ? void 0 : I.map((C) => {
    var A, N;
    return (N = (A = C.teams) == null ? void 0 : A[0]) == null ? void 0 : N.teamId;
  })) : [], o = !i && ((U = (y = r.teams) == null ? void 0 : y[0]) == null ? void 0 : U.participantId) || (n == null ? void 0 : n.length) === 1 && n[0] || void 0, s = !i && ((D = (S = r.teams) == null ? void 0 : S[0]) == null ? void 0 : D.teamId) || (a == null ? void 0 : a.length) === 1 && a[0] || o, c = i ? void 0 : r.participantName, u = (v = (w = r.individualParticipants) == null ? void 0 : w[0]) == null ? void 0 : v.participantName, d = (b = (P = r.individualParticipants) == null ? void 0 : P[1]) == null ? void 0 : b.participantName, p = e && (o === e ? "H" : "V") || "", l = i ? void 0 : t[o][r.participantId], m = t[o][(R = (T = r.individualParticipants) == null ? void 0 : T[0]) == null ? void 0 : R.participantId], f = t[o][(E = (M = r.individualParticipants) == null ? void 0 : M[1]) == null ? void 0 : E.participantId];
  return me({ vh: p, uni: l, uni_1: m, uni_2: f, team: s, name: c, name_1: u, name_2: d });
}
function bB({ sets: e, sideNumber: t }) {
  return Object.assign({}, ...(e == null ? void 0 : e.map((r) => {
    let { setNumber: i, side1Score: n, side2Score: a, side1TiebreakScore: o, side2TiebreakScore: s } = r, c = `set_${i}`, u = `tie_${i}`, d = t === 1 ? n : a, p = t === 1 ? o : s;
    return { [c]: d, [u]: p };
  })) ?? []);
}
function RB({ teamParticipant: e, teamMatchUp: t, participantMap: r, mappedMatchUps: i, homeid: n, uniValues: a }) {
  var S, D, w, v, P, b, T, R, M, E, C, A, N, O;
  let { participantId: o, participantName: s } = e, c = n && (o === n ? "H" : "V") || "", u = (S = r == null ? void 0 : r[o]) == null ? void 0 : S.matchUps, d = u && Object.keys(u), p = (w = (D = t == null ? void 0 : t.sides) == null ? void 0 : D.find(({ participant: k }) => k.participantId === o)) == null ? void 0 : w.sideNumber, l = ((b = (P = (v = t == null ? void 0 : t.score) == null ? void 0 : v.sets) == null ? void 0 : P[0]) == null ? void 0 : b[`side${p}Score`]) ?? 0;
  a[o] = {};
  let m = { SINGLES: { w: 0, l: 0 }, DOUBLES: { w: 0, l: 0 } }, f = [], h = [], g = 0;
  for (let k of d ?? []) {
    let F = i == null ? void 0 : i[k], x = (T = F.sides.find(({ participant: B }) => B.participantId === o)) == null ? void 0 : T.sideNumber, _ = ((E = (M = (R = F.score) == null ? void 0 : R.sets) == null ? void 0 : M[0]) == null ? void 0 : E[`side${x}Score`]) ?? 0;
    g += _;
    for (let B of F.tieMatchUps ?? []) {
      let { matchUpType: L, winningSide: G } = B, $ = G && (G === x ? "w" : "l") || "";
      $ && (m[L][$] += 1);
      let W = $ === "w" ? "1" : "0", q = $ === "l" ? "1" : "0";
      if (L === rt) {
        let K = h.length + 1;
        h.push({ singles_pair: { pair: K, won: W, lost: q, tied: "0" } });
      } else if (L === tt) {
        let K = f.length + 1;
        f.push({ doubles_pair: { pair: K, won: W, lost: q, tied: "0" } });
      }
    }
  }
  let I = [{ singles: { childArray: h, won: m.SINGLES.w, lost: m.SINGLES.l } }, { doubles: { childArray: f, won: m.DOUBLES.w, lost: m.DOUBLES.l } }], y = [], U = 1;
  for (let k of e.individualParticipantIds) {
    let F = r == null ? void 0 : r[k];
    if (F) {
      let { participant: x, counters: _ } = F, B = { won: ((C = _ == null ? void 0 : _.DOUBLES) == null ? void 0 : C.wins) || 0, lost: ((A = _ == null ? void 0 : _.DOUBLES) == null ? void 0 : A.losses) || 0 }, L = { won: ((N = _ == null ? void 0 : _.SINGLES) == null ? void 0 : N.wins) || 0, lost: ((O = _ == null ? void 0 : _.SINGLES) == null ? void 0 : O.losses) || 0 }, { participantName: G, participantId: $ } = x;
      a[o][$] = U, y.push({ player: { name: G, uni: U, singles: L, doubles: B } });
    }
    U += 1;
  }
  return { vh: c, id: o, name: s, score: l || g, totals: I, childArray: y };
}
function GS({ matchUp: e, homeid: t, uniValues: r }) {
  let { collectionPosition: i, orderOfFinish: n, matchUpType: a, sides: o } = e ?? {}, s = o == null ? void 0 : o.map((c) => {
    var l;
    let { sideNumber: u, participant: d } = c, p = bB({ sets: (l = e.score) == null ? void 0 : l.sets, sideNumber: u });
    return { [a === rt ? "singles_score" : "doubles_score"]: { ...TB({ homeid: t, uniValues: r, participant: d }), ...p } };
  });
  return { [a === rt ? "singles_match" : "doubles_match"]: { match: i, order: n, childArray: s } };
}
var MB = "ASC", XM = "ASC", NB = "DESC", ch = "DESC", AB = { ASC: MB, ASCENDING: XM, DESC: NB, DESCENDING: ch };
function ZM(e) {
  var R, M, E, C, A;
  let { tieFormat: t } = e, { useDefaultEventRanking: r, tournamentRecord: i, drawDefinition: n, scaleAccessor: a, singlesOnly: o, attach: s, event: c } = e;
  if ((c == null ? void 0 : c.eventType) !== Xr)
    return { error: Mn };
  if (!i)
    return { error: ae };
  if (!t && !n)
    return { error: ai };
  if (t = t ?? ((R = Ir({ drawDefinition: n, event: c })) == null ? void 0 : R.tieFormat), Ar({ tieFormat: t }).error)
    return { error: wn };
  if (typeof a != "object" && !r)
    return { error: J, context: { scaleAccessor: a } };
  let u = {}, d = ((n == null ? void 0 : n.entries) ?? (c == null ? void 0 : c.entries) ?? []).filter((N) => (N == null ? void 0 : N.entryStatus) === $r).map(Ce), { participants: p = [] } = Ut({ withIndividualParticipants: !0, withScaleValues: !0, tournamentRecord: i }), l = p.filter(({ participantId: N }) => d.includes(N)), m = (N) => N === ha ? "rankings" : "ratings", f = ((M = c == null ? void 0 : c.category) == null ? void 0 : M.categoryName) ?? ((E = c == null ? void 0 : c.category) == null ? void 0 : E.ageCategoryCode), { scaleName: h = f, scaleType: g = ha, sortOrder: I, accessor: y } = a || {}, U = m(g), S = (N, O) => {
    var F, x, _;
    let k = (F = N[U]) == null ? void 0 : F[O];
    if (!k && r && (k = (x = N[U]) == null ? void 0 : x[wo]), Array.isArray(k)) {
      let B = (_ = k.find((L) => L.scaleName === h)) == null ? void 0 : _.scaleValue;
      if (St(B))
        return B;
      if (y && typeof B == "object")
        return B[y];
    }
    return 0;
  }, D = (N, O, k) => {
    let F = I === ch ? O : N, x = I === ch ? N : O;
    return S(F, k) - S(x, k);
  }, w = (N, O) => D(N, O, wo), v = (N, O) => D(N, O, Ga), P = [], b = (t == null ? void 0 : t.collectionDefinitions) ?? [];
  for (let N of l) {
    let O = ((C = N.individualParticipants) == null ? void 0 : C.sort(w)) ?? [], k = o ? O : ((A = N.individualParticipants) == null ? void 0 : A.sort(v)) ?? [], F = {};
    for (let _ of b) {
      let B = [], { collectionId: L, matchUpCount: G, matchUpType: $, gender: W } = _, q = bt(wo)($);
      oe(0, G).forEach((K) => {
        let z = q ? O : k ?? [], Y = K + 1, X = [];
        oe(0, q ? 1 : 2).forEach((re) => {
          var H;
          let Q = (H = z == null ? void 0 : z.find((Z) => {
            var te;
            let ee = W && ([et, dt].includes(W) && W || W === Mr && [et, dt][re]);
            return (!ee || ee === ((te = Z.person) == null ? void 0 : te.sex)) && !B.includes(Z.participantId);
          })) == null ? void 0 : H.participantId;
          Q && (X.push(Q), B.push(Q), F[Q] || (F[Q] = []), F[Q].push({ collectionPosition: Y, collectionId: L }));
        }), q || P.push(X);
      });
    }
    let x = Object.keys(F).map((_) => ({ collectionAssignments: F[_], participantId: _ }));
    u[N.participantId] = x;
  }
  let T = [];
  for (let N of P) {
    let { participant: O } = Vi({ tournamentParticipants: p, participantIds: N });
    if (!O) {
      let k = { individualParticipantIds: N, participantRole: ur, participantType: Re };
      T.push(k);
    }
  }
  if (s) {
    for (; T.length; )
      hn({ participant: T.pop(), tournamentRecord: i });
    Ve({ element: n, extension: { name: Yn, value: u } });
  }
  return { ...V, lineUps: u, participantsToAdd: T };
}
function KU(e) {
  if (!e)
    return { error: Ie };
  let t = fe(e, [{ dates: !1, [cr]: (o) => Array.isArray(o) && o.every(Kr) }, { uuids: !1, [cr]: (o) => Array.isArray(o) && o.every(ht) }, { startTime: !1, endTime: !1, [cr]: Jh }, { idPrefix: !1, namePrefix: !1, [cr]: ht }, { count: !0, [cr]: St }]);
  if (t.error)
    return t;
  let { startDate: r, endDate: i } = e.tournamentRecord ?? {}, n = e.dates || r && i && Fs(r, i) || [], a = oe(1, e.count + 1).map((o) => {
    var s, c;
    return me({ courtId: ((s = e.uuids) == null ? void 0 : s.pop()) ?? (e.idPrefix && `${e.idPrefix}-${o}`) ?? ze(), courtName: ((c = e.courtNames) == null ? void 0 : c.pop()) ?? (e.namePrefix && `${e.namePrefix} ${o}`), dateAvailability: n.map((u) => ({ startTime: e.startTime ?? "08:00", endTime: e.endTime ?? "20:00", date: u })) });
  });
  return { ...V, courts: a };
}
var eN = {};
Ae(eN, { default: () => OB, garman: () => iN });
function Ad({ court: e, date: t }) {
  let r = t && e.dateAvailability.find((n) => Nn(n.date, t)), i = e.dateAvailability.find((n) => !n.date);
  return r || i;
}
function Ac(e) {
  let t = fe(e, [{ courtDate: !0, _ofType: _r }]);
  if (t.error)
    return t;
  let { includeBookingTypes: r = [], courtDate: i } = e, n = [], a = Ot(i.startTime);
  (i.bookings || []).filter((s) => !s.bookingType || !r.includes(s.bookingType)).sort((s, c) => ul(s.startTime).localeCompare(ul(c.startTime))).forEach((s) => {
    let c = { startTime: mt(a.toISOString()), endTime: s.startTime };
    Ot(s.startTime) > a && n.push(c), Ot(s.endTime) > a && (a = Ot(s.endTime));
  });
  let o = { startTime: mt(a.toISOString()), endTime: i.endTime };
  return Ot(i.endTime) > a && n.push(o), { timeSlots: n };
}
function EB({ averageMatchUpMinutes: e, includeBookingTypes: t, periodStartTime: r, periodEndTime: i }) {
  let n = (o) => {
    var c;
    let { timeSlots: s } = Ac({ includeBookingTypes: t, courtDate: o });
    return !!((c = s == null ? void 0 : s.filter(a)) != null && c.length);
  };
  function a(o) {
    let s = Ot(o.startTime), c = Ot(o.endTime);
    return s > r || c < i ? !1 : Au(r, c) >= e;
  }
  return { enoughTime: n };
}
function tN(e) {
  let t = fe(e, [{ periodStart: !0, date: !0 }, { courts: !0, _ofType: fr }]);
  if (t.error)
    return t;
  let { averageMatchUpMinutes: r, includeBookingTypes: i, periodStart: n, date: a } = e, o = e.courts, s = Ot(n), c = Zh(s, r), { enoughTime: u } = EB({ averageMatchUpMinutes: r, includeBookingTypes: i, periodStartTime: s, periodEndTime: c });
  return { availableToScheduleCount: ((o == null ? void 0 : o.filter((d) => {
    if (!Array.isArray(d.dateAvailability))
      return !1;
    let p = Ad({ date: a, court: d });
    return !!(p && u(p));
  })) || []).length, ...V };
}
function Rm(e) {
  var l;
  let { remainingScheduleTimes: t = [], clearScheduleDates: r, periodLength: i = 30, scheduleDate: n, courts: a = [] } = e, { bookings: o = [] } = e;
  if (!Array.isArray(a) || !a.length)
    return { error: J, courts: a };
  if (!Array.isArray(o))
    return { error: al };
  if (!Kr(n))
    return { error: Qt };
  r && (Array.isArray(r) ? r.includes(n) && (o = []) : o = []);
  let { courtBookings: s, unassignedBookings: c } = o.reduce((m, f) => {
    let { courtId: h } = f;
    return h ? m.courtBookings[h] ? m.courtBookings[h].push(f) : m.courtBookings[h] = [f] : m.unassignedBookings.push(f), m;
  }, { courtBookings: {}, unassignedBookings: [] }), u = a.map((m, f) => {
    let { courtId: h, courtName: g } = m, I = s[h] || [], y = Ad({ date: n, court: m }) || {}, { bookings: U = [], startTime: S, endTime: D, date: w } = y, v = [t[f] && { startTime: S, endTime: t[f] }, ...ce(U, !1, !0), ...I].filter(Boolean);
    return { courtId: h, courtName: g, dateAvailability: { bookings: v, startTime: S, endTime: D, date: w } };
  });
  c.sort((m, f) => _e(m.startTime) - _e(f.startTime));
  let d = () => u.map((m) => {
    let f = m.dateAvailability, { timeSlots: h = [] } = Ac({ courtDate: f });
    return { courtName: m.courtName, courtId: m.courtId, timeSlots: h };
  }).flat(), p = [];
  for (let m of c) {
    let { startTime: f, endTime: h, averageMinutes: g, recoveryMinutes: I, matchUpId: y } = m, U = _e(f), S = _e(h), D = d().reduce((w, { courtId: v, courtName: P, timeSlots: b }) => {
      let T;
      return b.find(({ startTime: R, endTime: M }) => {
        T = _e(R) - U;
        let E = U >= _e(R);
        return S <= _e(M) && w.startDifference !== 0 && ((T === 0 || T + i >= 0) && (w.startDifference === void 0 || T < w.startDifference) || E);
      }) ? { courtName: P, courtId: v, startDifference: T } : w;
    }, {});
    if (D.courtId) {
      let w = { averageMinutes: g, recoveryMinutes: I, matchUpId: y, startTime: f, endTime: h };
      p.push(w), (l = u.find(({ courtId: v }) => v === D.courtId)) == null || l.dateAvailability.bookings.push(w);
    } else
      console.log({ unassignedBooking: m });
  }
  return { virtualCourts: u.map(({ courtId: m, courtName: f, dateAvailability: h }) => ({ dateAvailability: [h], courtName: f, courtId: m })), assignedBookings: p };
}
function Mm({ averageMatchUpMinutes: e, periodLength: t = 30, recoveryMinutes: r }) {
  let i = (e || 90) + (r || 0);
  return t > i ? i : t || 30;
}
function rN(e) {
  let { startTime: t = "8:00", endTime: r = "20:30", count: i = 10, date: n } = e ?? {};
  return oe(0, i).map(() => ({ dateAvailability: [{ date: n, startTime: t, endTime: r }] }));
}
function Zs({ scheduleDate: e, startTime: t, endTime: r, courts: i }) {
  let n = t && "startTime" || r && "endTime" || void 0;
  return i.reduce((a, o) => {
    let s = Ad({ date: e, court: o }), c = n && ((s == null ? void 0 : s[n]) || o[n]);
    return c && (!a || t && _e(c) < _e(a) || r && _e(c) > _e(a)) ? c : a;
  }, void 0);
}
function CB({ averageMinutes: e, startTime: t, endTime: r, courts: i, date: n }) {
  t = t || Zs({ courts: i, scheduleDate: n, startTime: !0 }), r = r || Zs({ courts: i, scheduleDate: n, endTime: !0 });
  let a;
  if (t && r) {
    let o = Ot(t), s = Ot(r);
    for (let c of i || []) {
      if (!Array.isArray(c.dateAvailability))
        continue;
      let u = Ad({ court: c, date: n }), { timeSlots: d } = Ac({ courtDate: u });
      d == null || d.forEach((p) => {
        let l = Ot(p.startTime), m = Ot(p.endTime);
        if (l > s || l < o || m < o)
          return !1;
        if (Au(l, m) >= e) {
          let f = mt(l.toISOString());
          (!a || f < a) && (a = f);
        }
      });
    }
  }
  return { firstTimeSlotStartTime: a };
}
function QU(e) {
  let t = fe(e, [{ courts: !0, _ofType: fr }]);
  if (t.error)
    return t;
  let { date: r = Qh(), startTime: i = "08:00", endTime: n = "19:00", periodLength: a, courts: o } = e, { calculateStartTimeFromCourts: s = !0, remainingScheduleTimes: c, averageMatchUpMinutes: u, clearScheduleDates: d, courtsCount: p, bookings: l } = e;
  a = a || Mm({ averageMatchUpMinutes: u }), r = be(r), i = mt(i), n = mt(n);
  let m = 0, f = 0, h = 0, g = 0, I = 0;
  !o && p && (o = rN({ startTime: i, endTime: n, count: p, date: r }));
  let { virtualCourts: y } = Rm({ remainingScheduleTimes: c, clearScheduleDates: d, scheduleDate: r, periodLength: a, bookings: l, courts: o }), { firstTimeSlotStartTime: U } = CB({ averageMinutes: u, courts: y, startTime: i, endTime: n, date: r });
  s && U && (i = U || i);
  let S = _e(i), D = _e(n) - S, w = Math.floor(D / a), v = oe(0, w + 1).map((P) => {
    let b = S + P * a, T = HC(b), R = tN({ courts: y ?? [], averageMatchUpMinutes: u, periodStart: T, date: r });
    if (R.error)
      return { error: R.error };
    let { availableToScheduleCount: M = 0 } = R, E = M > f ? M - f : 0;
    I += P ? M : 0;
    let C = P ? I / P : M, A = a * C / u, N = P ? A * (P - 1) + C : C, O = M ? f && N - m || E : 0;
    m = N, f = M, h += O;
    let k = ye(h) - g;
    return g += k, { periodStart: T, add: k, availableToScheduleCount: M, newCourts: E, totalMatchUps: g };
  });
  return { scheduleTimes: v.reduce((P, b) => {
    let T = oe(0, b.add).map(() => ({ scheduleTime: b.periodStart }));
    return P.concat(...T);
  }, []).flat(), timingProfile: v, totalMatchUps: g };
}
var iN = { getCourtsAvailableAtPeriodStart: tN, generateTimeSlots: Ac, getScheduleTimes: QU, courtGenerator: rN }, OB = iN, nN = {};
Ae(nN, { isValid: () => Jr, isValidMatchUpFormat: () => Jr, parse: () => Tr, stringify: () => op });
var aN = {};
Ae(aN, { allCompetitionMatchUps: () => en, allDrawMatchUps: () => vr, allEventMatchUps: () => Ln, allTournamentMatchUps: () => tr, analyzeMatchUp: () => Uu, applyLineUps: () => MN, assignMatchUpSideParticipant: () => sN, assignTieMatchUpParticipantId: () => Ol, bulkMatchUpStatusUpdate: () => DN, calculateWinCriteria: () => gs, checkInParticipant: () => XU, checkMatchUpIsComplete: () => ja, checkOutParticipant: () => JU, competitionScheduleMatchUps: () => Rd, disableTieAutoCalc: () => vN, drawMatchUps: () => kU, enableTieAutoCalc: () => UN, eventMatchUps: () => Sm, filterMatchUps: () => Vn, findMatchUp: () => UU, getAllDrawMatchUps: () => Bt, getAllStructureMatchUps: () => Ke, getCheckedInParticipantIds: () => as, getCompetitionMatchUps: () => Iu, getEventMatchUpFormatTiming: () => TU, getHomeParticipantId: () => NU, getMatchUpCompetitiveProfile: () => Ju, getMatchUpContextIds: () => AU, getMatchUpDailyLimits: () => wm, getMatchUpDailyLimitsUpdate: () => bU, getMatchUpDependencies: () => qi, getMatchUpFormat: () => EU, getMatchUpFormatTiming: () => Xu, getMatchUpFormatTimingUpdate: () => DU, getMatchUpScheduleDetails: () => kp, getMatchUpType: () => Fp, getMatchUpsStats: () => CU, getModifiedMatchUpFormatTiming: () => ym, getParticipantResults: () => hd, getPredictiveAccuracy: () => MU, getRoundMatchUps: () => Pr, getRounds: () => OU, isValidMatchUpFormat: () => Jr, matchUpActions: () => Jp, mutate: () => oN, participantScheduledMatchUps: () => RU, query: () => hM, removeDelegatedOutcome: () => yN, removeMatchUpSideParticipant: () => ty, removeTieMatchUpParticipantId: () => uN, replaceTieMatchUpParticipantId: () => ey, resetAdHocMatchUps: () => bN, resetMatchUpLineUps: () => cy, resetScorecard: () => dy, resetTieFormat: () => uy, setDelegatedOutcome: () => TN, setMatchUpFormat: () => wN, setMatchUpStatus: () => Cd, setOrderOfFinish: () => RN, substituteParticipant: () => SN, tallyParticipantResults: () => Dc, toggleParticipantCheckInState: () => Nm, tournamentMatchUps: () => vm, updateTieMatchUpScore: () => na, validMatchUp: () => Np, validMatchUps: () => Ti });
var oN = {};
Ae(oN, { applyLineUps: () => MN, assignMatchUpSideParticipant: () => sN, assignTieMatchUpParticipantId: () => Ol, bulkMatchUpStatusUpdate: () => DN, checkInParticipant: () => XU, checkOutParticipant: () => JU, disableTieAutoCalc: () => vN, enableTieAutoCalc: () => UN, findMatchUp: () => UU, removeDelegatedOutcome: () => yN, removeMatchUpSideParticipant: () => ty, removeTieMatchUpParticipantId: () => uN, replaceTieMatchUpParticipantId: () => ey, resetAdHocMatchUps: () => bN, resetMatchUpLineUps: () => cy, resetScorecard: () => dy, resetTieFormat: () => uy, setDelegatedOutcome: () => TN, setMatchUpFormat: () => wN, setMatchUpStatus: () => Cd, setOrderOfFinish: () => RN, substituteParticipant: () => SN, toggleParticipantCheckInState: () => Nm, updateTieMatchUpScore: () => na });
function sN({ tournamentRecord: e, drawDefinition: t, participantId: r, sideNumber: i, matchUpId: n, event: a }) {
  var u, d;
  if (r && typeof r != "string")
    return { error: Ji };
  if (!t)
    return { error: le };
  if (!n)
    return { error: Ur };
  let o = i === void 0;
  if (o && (i = 1), ![1, 2].includes(i))
    return j({ result: { error: J, context: { sideNumber: i } } });
  let { matchUp: s, structure: c } = ft({ drawDefinition: t, matchUpId: n, event: a });
  if (!s)
    return { error: hr };
  if (!(!(c != null && c.structures) && !(t.drawType && t.drawType !== si) && !((u = c == null ? void 0 : c.matchUps) != null && u.find(({ roundPosition: p }) => !!p))))
    return { error: Sh };
  if (!r && ((d = s == null ? void 0 : s.score) != null && d.scoreStringSide1 || Vt.includes(s == null ? void 0 : s.matchUpstatus) || s != null && s.matchUpStatus && [Et, Lt].includes(s.matchUpStatus)))
    return { error: zl, info: "matchUp has completed status or score" };
  if (s) {
    if (s.sides = [1, 2].map((p) => {
      var m;
      let l = ((m = s.sides) == null ? void 0 : m.find((f) => f.sideNumber === p)) ?? { sideNumber: p };
      return i === p ? { ...l, participantId: r } : l;
    }), o)
      for (let p of s.sides)
        p.sideNumber && (p.sideNumber = 3 - p.sideNumber);
    xe({ tournamentId: e == null ? void 0 : e.tournamentId, context: "assignSideParticipant", drawDefinition: t, matchUp: s });
  }
  return { ...V, sidesSwapped: o };
}
function ti({ removePriorValues: e, tournamentRecord: t, duplicateValues: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: o, event: s }) {
  let { matchUp: c } = ft({ drawDefinition: i, event: s, matchUpId: a });
  if (!c)
    return { error: hr };
  let u = yn({ removePriorValues: e, element: c, duplicateValues: r, timeItem: o });
  return n || xe({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: s == null ? void 0 : s.eventId, context: "addTimeItem", drawDefinition: i, matchUp: c }), u;
}
function JU(e) {
  var y;
  let t = [{ [Gt]: !0 }, { [Rr]: !0 }, { [Cn]: !0 }, { [gn]: !0 }], r = fe(e, t);
  if (r.error)
    return r;
  let i = bc(e, [{ [lc]: Fn, attr: { [fp]: !0 } }]);
  if (i.error)
    return i;
  let { tournamentRecord: n, drawDefinition: a, participantId: o, matchUpId: s } = e, c = (y = i == null ? void 0 : i.matchUp) == null ? void 0 : y.matchUp, { matchUpStatus: u, score: d } = c ?? {};
  if (u && wg.includes(u) || u && Vt.includes(u) || jt({ score: d }))
    return { error: Bv };
  let p = as({ matchUp: c });
  if (p != null && p.error)
    return p;
  let { checkedInParticipantIds: l, allRelevantParticipantIds: m } = p ?? {};
  if (!(m != null && m.includes(o)))
    return { error: Ji };
  if (!(l != null && l.includes(o)))
    return { error: mw };
  let f = $D({ matchUp: c });
  if (f != null && f.error)
    return f;
  let { sideParticipantIds: h, nestedIndividualParticipantIds: g } = f ?? {}, I = h == null ? void 0 : h.indexOf(o);
  return I !== void 0 && [0, 1].includes(I) && ((g == null ? void 0 : g[I]) ?? []).forEach((U) => {
    ti({ drawDefinition: a, matchUpId: s, timeItem: { itemType: Il, itemValue: U } });
  }), ti({ tournamentRecord: n, drawDefinition: a, matchUpId: s, timeItem: { itemValue: o, itemType: Il } }), { ...V, checkedOut: !0 };
}
function XU(e) {
  var l;
  let t = [{ [Gt]: !0 }, { [Rr]: !0 }, { [Cn]: !0 }, { [gn]: !0 }], r = fe(e, t);
  if (r[ki])
    return r;
  let i = bc(e, [{ [lc]: Fn, attr: { [fp]: !0 } }]);
  if (i[ki])
    return i;
  let { tournamentRecord: n, drawDefinition: a, participantId: o, matchUpId: s } = e, c = as({ matchUp: (l = i == null ? void 0 : i.matchUp) == null ? void 0 : l.matchUp });
  if (c != null && c.error)
    return c;
  let { checkedInParticipantIds: u, allRelevantParticipantIds: d } = c ?? {};
  if (!(d != null && d.includes(o)))
    return { [ki]: Ji };
  let p = { ...V, checkedIn: !0 };
  return u != null && u.includes(o) || ti({ tournamentRecord: n, drawDefinition: a, matchUpId: s, timeItem: { itemValue: o, itemType: gl } }), p;
}
function Nm(e) {
  var u, d;
  let t = fe(e, [{ [Cn]: !0, [Rr]: !0, [gn]: !0 }]);
  if (t.error)
    return t;
  let r = e.tournamentId ?? e.activeTournamentId, i = e.tournamentRecord ?? (r && ((u = e.tournamentRecords) == null ? void 0 : u[r]));
  if (!i)
    return { error: ae };
  let n = (d = bc(e, [{ [lc]: Fn, attr: { [fp]: !0 }, [ki]: hr }]).matchUp) == null ? void 0 : d.matchUp;
  if (!n)
    return { error: hr };
  let { checkedInParticipantIds: a = [] } = as({ matchUp: n }), { participantId: o, matchUpId: s, drawDefinition: c } = e;
  return o && a.includes(o) ? JU({ tournamentRecord: i, drawDefinition: c, participantId: o, matchUpId: s, matchUp: n }) : XU({ tournamentRecord: i, drawDefinition: c, participantId: o, matchUpId: s, matchUp: n });
}
function ZU({ tournamentRecord: e, drawDefinition: t, tieMatchUpId: r, event: i }) {
  var w, v;
  if (!e)
    return { error: ae };
  if (!t)
    return { error: tn };
  if (!i)
    return { error: Ii };
  let n = mr({ drawDefinition: t }), { matchUp: a } = ft({ matchUpId: r, drawDefinition: t, matchUpsMap: n });
  if (!a)
    return { error: hr };
  let { matchUp: o, structure: s } = ft({ tournamentParticipants: e.participants, matchUpId: r, inContext: !0, drawDefinition: t, matchUpsMap: n, event: i });
  if (!o)
    return { error: hr };
  let { collectionPosition: c, drawPositions: u, collectionId: d, matchUpTieId: p, matchUpType: l } = o;
  if (l && !jl([rt, tt], l))
    return { error: jr };
  let { positionAssignments: m } = ot({ structure: s }), f = m == null ? void 0 : m.filter((P) => u == null ? void 0 : u.includes(P.drawPosition)), { matchUp: h } = ft({ matchUpId: p, drawDefinition: t, matchUpsMap: n }), g = ((w = h == null ? void 0 : h.sides) == null ? void 0 : w.map(Ce)) ?? [], I = (f == null ? void 0 : f.map(Ce)) ?? [], y = [...g, ...I], { participants: U } = Ut({ tournamentRecord: e, participantFilters: { participantTypes: [Xe], participantIds: y } }), { matchUp: S } = ft({ matchUpId: p, inContext: !0, drawDefinition: t, matchUpsMap: n }), D = (v = Ir({ matchUp: h, drawDefinition: t, structure: s, event: i })) == null ? void 0 : v.tieFormat;
  return { inContextDualMatchUp: S, inContextTieMatchUp: o, relevantAssignments: f, collectionPosition: c, teamParticipants: U, collectionId: d, matchUpType: l, dualMatchUp: h, tieMatchUp: a, tieFormat: D, structure: s, ...V };
}
function ey(e) {
  var k, F, x, _, B, L, G, $, W, q, K, z, Y, X, re, Q;
  let t = ZU(e);
  if (t.error)
    return t;
  let r = "replaceTieMatchUpParticipantid", { existingParticipantId: i, tournamentRecord: n, newParticipantId: a, drawDefinition: o, substitution: s, event: c } = e;
  if (!i || !a)
    return j({ result: { error: _t }, stack: r });
  if (i === a)
    return { ...V };
  let { inContextDualMatchUp: u, inContextTieMatchUp: d, collectionPosition: p, collectionId: l, dualMatchUp: m, tieMatchUp: f, tieFormat: h } = t, g = d == null ? void 0 : d.matchUpType, I = (k = d == null ? void 0 : d.sides) == null ? void 0 : k.find((H) => {
    var Z, ee, te;
    return ((Z = H.participant) == null ? void 0 : Z.participantId) === i || ((te = (ee = H.participant) == null ? void 0 : ee.individualParticipantIds) == null ? void 0 : te.includes(i));
  });
  if (!I)
    return { error: Dt };
  let y = ((F = Ut({ tournamentRecord: n, participantFilters: { participantIds: [i, a] } })) == null ? void 0 : F.participants) ?? [];
  if (y.length !== 2)
    return j({ result: { error: _t }, stack: r });
  if (y[0].participantType !== y[1].participantType)
    return j({ result: { error: Xi }, stack: r });
  let { appliedPolicies: U } = je({ tournamentRecord: n, drawDefinition: o, event: c }), S = ((x = e.policyDefinitions) == null ? void 0 : x[Xt]) ?? (U == null ? void 0 : U[Xt]) ?? Sc[Xt], D = y.find(({ participantId: H }) => H === a);
  if ((e.enforceGender ?? ((_ = S == null ? void 0 : S.participants) == null ? void 0 : _.enforceGender)) !== !1 && [et, dt].includes(d == null ? void 0 : d.gender) && (d == null ? void 0 : d.gender) !== ((B = D == null ? void 0 : D.person) == null ? void 0 : B.sex))
    return { error: Wo, info: "Gender mismatch" };
  let w = (L = S == null ? void 0 : S.processCodes) == null ? void 0 : L.substitution;
  Id({ tournamentId: n.tournamentId, eventId: c.eventId, inContextDualMatchUp: u, drawDefinition: o, dualMatchUp: m });
  let v = (G = m == null ? void 0 : m.sides) == null ? void 0 : G.find(({ sideNumber: H }) => H === I.sideNumber);
  if (!v)
    return j({ result: { sideNumber: I.sideNumber, existingParticipantId: i, error: Zt }, stack: r });
  if ((W = ($ = d == null ? void 0 : d.sides) == null ? void 0 : $.flatMap((H) => {
    var Z, ee;
    return ((Z = H.participant) == null ? void 0 : Z.individualParticipantIds) || ((ee = H.participant) == null ? void 0 : ee.participantId) || [];
  })) != null && W.includes(a))
    return j({ result: { error: Kl }, stack: r });
  let P = (K = (q = u == null ? void 0 : u.sides) == null ? void 0 : q.find(({ sideNumber: H }) => H === I.sideNumber)) == null ? void 0 : K.participantId, b = v.lineUp, T = b == null ? void 0 : b.find(({ participantId: H }) => a === H), R = b == null ? void 0 : b.reduce((H, Z) => Z.substitutionOrder > H ? Z.substitutionOrder : H, 0), M = (b == null ? void 0 : b.map((H) => {
    var ee;
    let Z = ce(H, !1, !0);
    if (![i, a].includes(Z.participantId))
      return Z;
    if (!s && [i, a].includes(Z.participantId) && (Z.collectionAssignments = (ee = Z.collectionAssignments) == null ? void 0 : ee.filter((te) => !(te.collectionPosition === p && te.collectionId === l))), s && i === Z.participantId && (Z.collectionAssignments = Z.collectionAssignments.map((te) => te.collectionPosition === p && te.collectionId === l && te.substitutionOrder === void 0 ? { ...te, substitutionOrder: R } : te)), Z.participantId === a) {
      Z.collectionAssignments || (Z.collectionAssignments = []);
      let te = { collectionId: l, collectionPosition: p };
      s && (te.previousParticipantId = i, te.substitutionOrder = (R ?? 0) + 1), Z.collectionAssignments.push(te);
    }
    return Z;
  })) ?? [];
  if (!T) {
    let H = { collectionId: l, collectionPosition: p };
    s && (H.substitutionOrder = (R ?? 0) + 1, H.previousParticipantId = i);
    let Z = { collectionAssignments: [H], participantId: a };
    M.push(Z);
  }
  let E = g === tt, { assignedParticipantIds: C } = Ul({ lineUp: b, collectionPosition: p, collectionId: l }), { assignedParticipantIds: A } = Ul({ lineUp: M, collectionPosition: p, collectionId: l });
  if (v.lineUp = M, P && h) {
    let H = ps({ participantId: P, lineUp: M, drawDefinition: o, tieFormat: h });
    if (H.error)
      return j({ result: H, stack: r });
  } else
    console.log("team participantId not found");
  let N, O;
  if (E) {
    let { tournamentRecord: H } = e, Z = Vi({ participantIds: A, tournamentRecord: H });
    if (!Z.participant) {
      let te = hn({ returnParticipant: !0, pairOverride: !0, tournamentRecord: H, participant: { participantRole: ur, individualParticipantIds: A, participantType: Re } });
      if (te.error)
        return j({ result: te, stack: r });
      N = (z = te.participant) == null ? void 0 : z.participantId;
    }
    Z = Vi({ participantIds: C, tournamentRecord: H });
    let ee = (Y = Z.participant) == null ? void 0 : Y.participantId;
    ee && ds({ participantIds: [ee], tournamentRecord: H }).success && (O = ee);
  }
  if (s || ((X = I.substitutions) == null ? void 0 : X.length) === 1) {
    if (s)
      w && f && (f.processCodes = Te([...(f == null ? void 0 : f.processCodes) ?? [], ...w]));
    else
      for (let H of w || []) {
        let Z = (re = f == null ? void 0 : f.processCodes) == null ? void 0 : re.lastIndexOf(H);
        Z !== void 0 && ((Q = f == null ? void 0 : f.processCodes) == null || Q.splice(Z, 1));
      }
    f && xe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: f, context: r, drawDefinition: o });
  }
  return m && xe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: m, context: r, drawDefinition: o }), { ...V, modifiedLineUp: M, participantRemoved: O, participantAdded: N };
}
function cN({ collectionPosition: e, teamParticipantId: t, dualMatchUpSide: r, drawDefinition: i, participantIds: n, collectionId: a }) {
  var u;
  if (!a || !e || !Array.isArray(n))
    return { modifiedLineUp: (r == null ? void 0 : r.lineUp) || [], error: J };
  let o = (r == null ? void 0 : r.lineUp) || ((u = Qa({ participantId: t, drawDefinition: i })) == null ? void 0 : u.lineUp), s = [], c = [];
  return { modifiedLineUp: (o == null ? void 0 : o.map((d) => {
    var l;
    if (!n.includes(d.participantId))
      return d;
    let p = (l = d.collectionAssignments) == null ? void 0 : l.filter((m) => {
      let f = m.collectionId === a && m.collectionPosition === e;
      return f && (m.previousParticipantId && s.push(m.previousParticipantId), c.push({ participantId: d.participantId, ...m })), !f;
    });
    return { participantId: d.participantId, collectionAssignments: p };
  }).filter(Boolean)) || [], assignmentsRemoved: c, previousParticipantIds: s };
}
function kB({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: r }) {
  var a, o;
  let i = (r.events || []).filter((s) => {
    var c;
    return (s == null ? void 0 : s.eventType) === xt && ((c = s == null ? void 0 : s.entries) == null ? void 0 : c.some((u) => u.participantId === t));
  }), n = (s) => !e.includes(s.participantId);
  for (let s of i) {
    s.entries = (s.entries || []).filter(n);
    let { flightProfile: c } = Pt({ event: s });
    (a = c == null ? void 0 : c.flights) == null || a.forEach((u) => {
      u.drawEntries = (u.drawEntries || []).filter(n);
    }), (o = s == null ? void 0 : s.drawDefinitions) == null || o.forEach((u) => {
      u.entries = (u.entries || []).filter(n);
    });
  }
  return { ...V };
}
function Am({ individualParticipantIds: e, groupingParticipantId: t, removeFromOtherTeams: r, tournamentRecord: i }) {
  let n = "addIndividualParticipantIds";
  if (!i)
    return j({ result: { error: ae }, stack: n });
  if (!t || !e)
    return j({ result: { error: Ie }, stack: n });
  let a = i.participants ?? [], o = a.find((p) => p.participantId === t);
  if (!o)
    return j({ result: { error: Dt }, stack: n });
  if (o != null && o.participantType && ![Xe, di].includes(o.participantType))
    return j({ context: { participantType: o.participantType }, result: { error: Xi }, stack: n });
  let s = e.filter((p) => {
    var l;
    return ((l = a.find((m) => m.participantId === p)) == null ? void 0 : l.participantType) !== Oe;
  });
  if (s.length)
    return j({ result: { error: Yr, invalidParticipantIds: s }, stack: n });
  o.individualParticipantIds || (o.individualParticipantIds = []);
  let c = o.individualParticipantIds, u = e.filter((p) => !c.includes(p));
  u.length && (r && _p({ individualParticipantIds: u, tournamentRecord: i }), o.individualParticipantIds = o.individualParticipantIds.concat(...u));
  let { topics: d } = vi();
  if (d.includes(pr)) {
    let p = a.find(({ participantId: l }) => l === t);
    De({ topic: pr, payload: { participants: [p] } });
  }
  return kB({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: i }), { groupingParticipant: ce(o, !1, !0), added: u.length, ...V };
}
function Em(e) {
  let { updateParticipantName: t = !0, groupingParticipantId: r, removeFromOtherTeams: i, tournamentRecord: n, pairOverride: a, participant: o } = e;
  if (!n)
    return { error: ae };
  if (!o)
    return { error: Ho };
  if (!o.participantId)
    return hn({ tournamentRecord: n, participant: o });
  let { participant: s } = Aa({ participantId: o.participantId, tournamentRecord: n });
  if (!s)
    return hn({ tournamentRecord: n, participant: o });
  let { participantRoleResponsibilties: c, individualParticipantIds: u, participantOtherName: d, participantName: p, participantRole: l, participantType: m, onlineResources: f, contacts: h, person: g } = o;
  if (m && s.participantType !== m)
    return { error: sw };
  let I = {};
  if (h && (I.contacts = h), f && (I.onlineResources = f), d && ht(d) && (I.participantOtherName = d), p && ht(p) && (I.participantName = p), Array.isArray(u)) {
    let { participants: y } = Ut({ participantFilters: { participantTypes: [Oe] }, tournamentRecord: n }), U = y == null ? void 0 : y.map(Ce);
    if (U) {
      let S = u.filter((D) => ht(D) && U.includes(D));
      ([di, lt].includes(m || s.participantType) || m === Re && (S.length === 2 || a)) && (I.individualParticipantIds = S), s.participantType === Vc.PAIR && t && (I.participantName = FB({ individualParticipants: y, newValues: I }));
    }
  }
  return Object.keys(aI).includes(l) && (I.participantRole = l), Object.keys(Vc).includes(m) && (I.participantType = m), Array.isArray(c) && (I.participantRoleResponsibilties = c), s.participantType === Vc.INDIVIDUAL && g && xB({ updateParticipantName: t, existingParticipant: s, newValues: I, person: g }), Object.assign(s, me(I)), r && Am({ individualParticipantIds: [s.participantId], groupingParticipantId: r, removeFromOtherTeams: i, tournamentRecord: n }), De({ topic: pr, payload: { tournamentId: n.tournamentId, participants: [s] } }), { participant: ce(s), ...V };
}
function FB({ individualParticipants: e, newValues: t }) {
  let r = t.individualParticipantIds, i = e.filter(({ participantId: n }) => r.includes(n)).map(({ person: n }) => n == null ? void 0 : n.standardFamilyName).filter(Boolean).sort().join("/");
  return r.length === 1 && (i += "/Unknown"), i;
}
function xB({ updateParticipantName: e, existingParticipant: t, newValues: r, person: i }) {
  let n = {}, { standardFamilyName: a, standardGivenName: o, nationalityCode: s, personId: c, birthdate: u, tennisId: d, sex: p } = i;
  p && Object.keys(Yh).includes(p) && (n.sex = p);
  let l;
  if (ht(c) && (n.personId = c), s && ht(s) && (LB(s) || s === "") && (n.nationalityCode = s), a && typeof ht(a) && a.length > 1 && (n.standardFamilyName = a, l = !0), o && typeof ht(o) && o.length > 1 && (n.standardGivenName = o, l = !0), l && e) {
    let m = `${n.standardGivenName} ${n.standardFamilyName}`;
    r.participantName = m;
  }
  u && Kr(u) && (n.birthdate = u), d && ht(d) && (n.tennisId = d), Object.assign(t.person, n);
}
function LB(e) {
  return pa.flatMap(({ iso: t, ioc: r }) => [t, r]).filter(Boolean).includes(e);
}
function Ol(e) {
  var x, _, B, L, G, $, W, q, K, z, Y, X, re, Q, H, Z, ee, te, ne, se;
  let t = ZU(e);
  if (t.error)
    return t;
  let r = "assignTieMatchUpParticipantId", i = e.teamParticipantId, { tournamentRecord: n, drawDefinition: a, participantId: o, event: s } = e;
  if (!o)
    return j({ result: { error: _t }, stack: r });
  if (e.sideNumber && ![1, 2].includes(e.sideNumber))
    return j({ result: { error: Ah }, stack: r });
  let { inContextDualMatchUp: c, inContextTieMatchUp: u, relevantAssignments: d, collectionPosition: p, teamParticipants: l, collectionId: m, matchUpType: f, dualMatchUp: h, tieFormat: g } = t;
  if ((_ = (x = u == null ? void 0 : u.sides) == null ? void 0 : x.flatMap((ie) => {
    var he, Ee;
    return ((he = ie.participant) == null ? void 0 : he.individualParticipantIds) || ((Ee = ie.participant) == null ? void 0 : Ee.participantId) || [];
  })) != null && _.includes(o))
    return j({ result: { ...V }, stack: r });
  i = i ?? (e.sideNumber ? (L = (B = c == null ? void 0 : c.sides) == null ? void 0 : B.find((ie) => ie.sideNumber === e.sideNumber)) == null ? void 0 : L.participantId : void 0);
  let I = ($ = (G = Ut({ participantFilters: { participantIds: [o] }, tournamentRecord: n })) == null ? void 0 : G.participants) == null ? void 0 : $[0];
  if (!I)
    return j({ result: { error: Dt }, stack: r });
  let { appliedPolicies: y } = je({ tournamentRecord: n, drawDefinition: a, event: s }), U = ((W = e.policyDefinitions) == null ? void 0 : W[Xt]) ?? (y == null ? void 0 : y[Xt]) ?? Sc[Xt];
  if ((e.enforceGender ?? ((q = U == null ? void 0 : U.participants) == null ? void 0 : q.enforceGender)) !== !1 && [et, dt].includes(u == null ? void 0 : u.gender) && (u == null ? void 0 : u.gender) !== ((K = I.person) == null ? void 0 : K.sex))
    return { error: Wo, info: "Gender mismatch" };
  let { individualParticipantIds: S, participantType: D } = I;
  if (bt(rt)(f) && D !== Oe)
    return { error: Xi };
  let w = D === Oe ? [o] : S, v = i && (l == null ? void 0 : l.find(({ participantId: ie }) => ie === i)) || (l == null ? void 0 : l.find(({ individualParticipantIds: ie }) => wr(w, ie)));
  if (!v)
    return { error: Bh };
  if (i || (i = v.participantId), !i)
    return { error: Dt };
  let P = (z = d == null ? void 0 : d.find((ie) => ie.participantId === (v == null ? void 0 : v.participantId))) == null ? void 0 : z.drawPosition, b = (X = (Y = h == null ? void 0 : h.sides) == null ? void 0 : Y.find((ie) => ie.participantId === i)) == null ? void 0 : X.sideNumber, T = (Q = (re = u == null ? void 0 : u.sides) == null ? void 0 : re.find((ie) => P && ie.drawPosition === P)) == null ? void 0 : Q.sideNumber, R = b ?? T ?? e.sideNumber;
  if (!g)
    return { error: ac };
  if (!((H = g.collectionDefinitions) != null && H.find((ie) => ie.collectionId === m)))
    return { error: Xv };
  Id({ tournamentId: n.tournamentId, eventId: s.eventId, inContextDualMatchUp: c, drawDefinition: a, dualMatchUp: h });
  let M = (Z = h == null ? void 0 : h.sides) == null ? void 0 : Z.find((ie) => ie.sideNumber === R), E = (ee = u == null ? void 0 : u.sides) == null ? void 0 : ee.find((ie) => ie.sideNumber === R), C = (se = (ne = (M == null ? void 0 : M.lineUp) ?? ((te = Qa({ participantId: i, drawDefinition: a })) == null ? void 0 : te.lineUp)) == null ? void 0 : ne.filter((ie) => {
    var he;
    return (he = ie.collectionAssignments) == null ? void 0 : he.find((Ee) => Ee.collectionPosition === p && Ee.collectionId === m && !Ee.previousParticipantId);
  })) == null ? void 0 : se.map((ie) => ie == null ? void 0 : ie.participantId), A = (C == null ? void 0 : C.length) > 1 && C || (D === Re ? I.individualParticipantIds : [o]), N = cN({ collectionPosition: p, teamParticipantId: i, dualMatchUpSide: M, drawDefinition: a, participantIds: A, collectionId: m });
  if (N.error)
    return j({ result: N, stack: r });
  let { modifiedLineUp: O } = N, k;
  if (f === tt) {
    if (D !== Re) {
      let ie = af({ collectionPosition: p, teamParticipantId: i, drawDefinition: a, modifiedLineUp: O, participantId: o, collectionId: m, tieFormat: g });
      if (ie != null && ie.error)
        return j({ result: ie, stack: r });
      if (ie = F({ side: E }), ie.error)
        return ie;
      k = ie.deletedParticipantId, M && (M.lineUp = O), h && xe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: h, context: r, drawDefinition: a });
    } else if (D === Re)
      for (let ie of A)
        af({ collectionPosition: p, teamParticipantId: i, drawDefinition: a, modifiedLineUp: O, participantId: ie, collectionId: m, tieFormat: g });
  } else {
    let ie = af({ collectionPosition: p, teamParticipantId: i, drawDefinition: a, modifiedLineUp: O, participantId: o, collectionId: m, tieFormat: g });
    if (ie != null && ie.error)
      return ie;
  }
  if (M && (M.lineUp = O), h && xe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: h, context: r, drawDefinition: a }), k) {
    let { error: ie } = ds({ participantIds: [k], tournamentRecord: n });
    ie && console.log("cleanup");
  }
  return { ...V, modifiedLineUp: O };
  function F({ side: ie }) {
    let he;
    if (ie.participant) {
      let Ee = ie.participant.individualParticipantIds || [];
      if (Ee.filter(Boolean).length === 1) {
        let { participant: de } = Vi({ participantIds: Ee, tournamentRecord: n });
        Ee.push(o);
        let { participant: it } = Vi({ participantIds: Ee, tournamentRecord: n });
        if (!it && de) {
          de.individualParticipantIds = Ee;
          let qe = Em({ pairOverride: !0, tournamentRecord: n, participant: de });
          if (qe.error)
            return qe;
        } else
          he = de == null ? void 0 : de.participantId;
      }
    } else {
      let Ee = hn({ participant: { individualParticipantIds: [o], participantRole: ur, participantType: Re }, pairOverride: !0, tournamentRecord: n });
      if (Ee.error)
        return Ee;
    }
    return { ...V, deletedParticipantId: he };
  }
}
function af({ collectionPosition: e, teamParticipantId: t, drawDefinition: r, modifiedLineUp: i, participantId: n, collectionId: a, tieFormat: o }) {
  var d, p;
  let s = (d = Qa({ participantId: t, drawDefinition: r })) == null ? void 0 : d.lineUp, c = (p = i || s) == null ? void 0 : p.find((l) => (l == null ? void 0 : l.participantId) === n), u = { collectionId: a, collectionPosition: e };
  if (c)
    c.collectionAssignments.push(u);
  else {
    let l = { collectionAssignments: [u], participantId: n };
    i.push(l);
  }
  return ps({ participantId: t, lineUp: i, drawDefinition: r, tieFormat: o });
}
function uN(e) {
  var R, M, E, C, A, N, O, k, F, x, _, B, L, G, $, W, q, K, z, Y, X, re, Q;
  let { tournamentRecord: t, drawDefinition: r, participantId: i, event: n } = e, a = "removeTieMatchUpParticiapantId";
  if (!i)
    return j({ result: { error: _t }, stack: a });
  let o = ZU(e);
  if (o.error)
    return o;
  let { appliedPolicies: s } = je({ tournamentRecord: t, drawDefinition: r, event: n }), c = (E = (M = ((R = e.policyDefinitions) == null ? void 0 : R[Xt]) ?? (s == null ? void 0 : s[Xt]) ?? Sc[Xt]) == null ? void 0 : M.processCodes) == null ? void 0 : E.substitution, { inContextDualMatchUp: u, inContextTieMatchUp: d, relevantAssignments: p, collectionPosition: l, teamParticipants: m, collectionId: f, matchUpType: h, dualMatchUp: g, tieMatchUp: I, tieFormat: y } = o;
  if (!g)
    return j({ result: { error: Vr }, stack: a });
  let U = (C = d == null ? void 0 : d.sides) == null ? void 0 : C.find((H) => {
    var Z, ee, te;
    return ((Z = H.participant) == null ? void 0 : Z.participantId) === i || ((te = (ee = H.participant) == null ? void 0 : ee.individualParticipantIds) == null ? void 0 : te.includes(i));
  });
  if (!U)
    return j({ result: { error: Dt }, stack: a });
  let S = ((A = e.policyDefinitions) == null ? void 0 : A[yi]) ?? (s == null ? void 0 : s[yi]);
  if (!((N = U.substitutions) != null && N.length) && (jt({ score: d == null ? void 0 : d.score }) || d != null && d.winningSide) && (S == null ? void 0 : S.requireParticipantsForScoring) !== !1)
    return j({ result: { error: Fw }, stack: a });
  let D = (k = (O = u == null ? void 0 : u.sides) == null ? void 0 : O.find(({ sideNumber: H }) => H === U.sideNumber)) == null ? void 0 : k.participantId;
  if (!D)
    return j({ result: { error: Dt }, stack: a });
  let w = (x = (F = Ut({ participantFilters: { participantIds: [i] }, tournamentRecord: t })) == null ? void 0 : F.participants) == null ? void 0 : x[0];
  if (!w)
    return j({ result: { error: Dt }, stack: a });
  if (h === rt && w.participantType === Re)
    return j({ result: { error: Wo }, stack: a });
  let v = w.participantType === Oe ? [i] : w.individualParticipantIds;
  Id({ tournamentId: t.tournamentId, eventId: n.eventId, inContextDualMatchUp: u, drawDefinition: r, dualMatchUp: g });
  let P = (_ = g.sides) == null ? void 0 : _.find(({ sideNumber: H }) => H === U.sideNumber);
  if (!P && (((B = g.sides) == null ? void 0 : B.filter(({ lineUp: H }) => !H).length) || 0) < 2) {
    let H = m == null ? void 0 : m.map(({ participantId: Z }) => {
      var ee;
      return { drawPosition: (ee = p == null ? void 0 : p.find((te) => te.participantId === Z)) == null ? void 0 : ee.drawPosition, teamParticipantId: Z };
    });
    P = (L = g.sides) == null ? void 0 : L.find((Z) => {
      var ee;
      return ((ee = H == null ? void 0 : H.find(({ drawPosition: te }) => te === Z.drawPosition)) == null ? void 0 : ee.teamParticipantId) === D;
    });
  }
  if (!P)
    return j({ result: { error: Dt, context: { participantId: i } } });
  let { modifiedLineUp: b, previousParticipantIds: T } = cN({ collectionPosition: l, teamParticipantId: D, dualMatchUpSide: P, participantIds: v, drawDefinition: r, collectionId: f });
  if (P.lineUp = b, D && y && ps({ participantId: D, lineUp: b, drawDefinition: r, tieFormat: y }), h === tt && w.participantType === Oe) {
    let H = (G = d == null ? void 0 : d.sides) == null ? void 0 : G.find((te) => te.sideNumber === (P == null ? void 0 : P.sideNumber)), { participantId: Z } = H ?? {}, ee = Z && ((W = ($ = Ut({ participantFilters: { participantIds: [Z] }, tournamentRecord: t, withDraws: !0 })) == null ? void 0 : $.participants) == null ? void 0 : W[0]);
    if (ee) {
      let te = ((q = ee == null ? void 0 : ee.individualParticipantIds) == null ? void 0 : q.filter((ne) => ne !== i)) ?? [];
      if (T && te.push(...T), te.length > 2)
        return j({ result: { error: Yr }, stack: a });
      if ((K = ee.draws) != null && K.length) {
        if (te.length === 1) {
          let { participant: ne } = Vi({ participantIds: te, tournamentRecord: t });
          if (!ne) {
            let se = hn({ participant: { participantRole: ur, individualParticipantIds: te, participantType: Re }, pairOverride: !0, tournamentRecord: t });
            if (se.error)
              return j({ result: se, stack: a });
          }
        }
      } else if (te.length) {
        ee.individualParticipantIds = te;
        let ne = Em({ participant: ee, pairOverride: !0, tournamentRecord: t });
        if (ne.error)
          return j({ result: ne, stack: a });
      } else {
        let ne = ds({ participantIds: [Z], tournamentRecord: t });
        ne.error && console.log("cleanup", { result: ne });
      }
    } else
      return j({ result: { error: Dt }, stack: a });
  }
  if (((z = U.substitutions) == null ? void 0 : z.length) === 1 && !((re = (X = (Y = d == null ? void 0 : d.sides) == null ? void 0 : Y.find((H) => H.sideNumber !== U.sideNumber)) == null ? void 0 : X.substitutions) != null && re.length) && ((Q = I == null ? void 0 : I.processCodes) != null && Q.length)) {
    for (let H of c || []) {
      let Z = I.processCodes.lastIndexOf(H);
      I.processCodes.splice(Z, 1);
    }
    xe({ tournamentId: t == null ? void 0 : t.tournamentId, matchUp: I, context: a, drawDefinition: r });
  }
  return xe({ tournamentId: t == null ? void 0 : t.tournamentId, matchUp: g, context: a, drawDefinition: r }), { ...V, modifiedLineUp: b };
}
function ty(e) {
  var c, u;
  let t = fe(e, [{ [Gt]: !0, [Rr]: !0, [gn]: !0 }]);
  if (t.error)
    return t;
  let { drawDefinition: r, sideNumber: i, matchUpId: n, event: a } = e;
  if (i && ![1, 2].includes(i))
    return { error: J, sideNumber: i };
  let { matchUp: o, structure: s } = ft({ drawDefinition: r, matchUpId: n, event: a });
  return o ? Er({ structure: s }) ? ((c = o.sides) == null || c.forEach((d) => {
    (!i || d.sideNumber === i) && delete d.participantId;
  }), xe({ tournamentId: (u = e.tournamentRecord) == null ? void 0 : u.tournamentId, context: "assignSideParticipant", drawDefinition: r, matchUp: o }), { ...V }) : { error: Sh } : { error: hr };
}
function _B({ matchUpStatuses: e = [$e, Be, ke], drawPositionMatchUps: t, loserDrawPosition: r, sourceMatchUps: i }) {
  var d;
  let n = t == null ? void 0 : t.reduce((p, l) => !p || l.roundNumber > p.roundNumber ? l : p, void 0), a = (d = n == null ? void 0 : n.drawPositions) == null ? void 0 : d.find((p) => p !== r), o = i.filter((p) => {
    var l;
    return (l = p == null ? void 0 : p.drawPositions) == null ? void 0 : l.includes(a);
  }).map((p) => p.matchUpStatus), s = i.filter((p) => {
    var l;
    return (l = p == null ? void 0 : p.drawPositions) == null ? void 0 : l.includes(r);
  }).map((p) => p.matchUpStatus), c = wr(o || [], e), u = wr(s || [], e);
  return { sourceMatchUp: n, winnerHadMatchUpStatus: c, winnerMatchUpStatuses: o, loserHadMatchUpStatus: u, loserMatchUpStatuses: s };
}
function BB({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, targetDrawPosition: r, tournamentRecord: i, sourceMatchUpId: n, drawDefinition: a, structureId: o, dualMatchUp: s, roundNumber: c, matchUpsMap: u, event: d }) {
  let { structure: p } = ve({ drawDefinition: a, structureId: o });
  if ((p == null ? void 0 : p.structureType) === br)
    return { ...V };
  u = u ?? mr({ drawDefinition: a });
  let l = ((u == null ? void 0 : u.mappedMatchUps) || {})[o].matchUps, { initialRoundNumber: m } = Bo({ drawPosition: r, matchUps: l }), f = l == null ? void 0 : l.filter((g) => {
    var I;
    return g.roundNumber >= c && g.roundNumber !== m && ((I = g.drawPositions) == null ? void 0 : I.includes(r));
  }), { positionAssignments: h } = ot({ drawDefinition: a, structureId: o });
  for (let g of f ?? [])
    VB({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, positionAssignments: h, targetDrawPosition: r, tournamentRecord: i, sourceMatchUpId: n, drawDefinition: a, dualMatchUp: s, matchUpsMap: u, matchUp: g, event: d });
  return { ...V };
}
function VB({ inContextDrawMatchUps: e, positionAssignments: t, sourceMatchUpStatus: r, targetDrawPosition: i, tournamentRecord: n, sourceMatchUpId: a, drawDefinition: o, dualMatchUp: s, matchUpsMap: c, matchUp: u, event: d }) {
  var m, f, h;
  let p = "removeSubsequentDrawPosition";
  if (s) {
    let g = (f = (m = e.find(({ matchUpId: y }) => u.matchUpId === y).sides) == null ? void 0 : m.find((y) => y.drawPosition === i)) == null ? void 0 : f.sideNumber, I = (h = u.sides) == null ? void 0 : h.find((y) => y.sideNumber === g);
    I && delete I.lineUp;
  }
  u.drawPositions = (u.drawPositions || []).map((g) => g === i ? void 0 : g).filter(Boolean);
  let l = t.filter(({ drawPosition: g }) => {
    var I;
    return (I = u.drawPositions) == null ? void 0 : I.includes(g);
  }).filter((g) => g.bye).length;
  return u.matchUpStatus = l && $e || [ke, Be].includes(u.matchUpStatus) && u.matchUpStatus || Rt, [Be, ke].includes(u.matchUpStatus) && (u.winningSide = void 0), u.matchUpStatusCodes && NT({ inContextDrawMatchUps: e, sourceMatchUpStatus: r, sourceMatchUpId: a, matchUpsMap: c, matchUp: u }), xe({ tournamentId: n == null ? void 0 : n.tournamentId, eventId: d == null ? void 0 : d.eventId, context: `${p}-${i}`, drawDefinition: o, matchUp: u }), { ...V };
}
function Ec(e) {
  let { dualWinningSideChange: t, inContextDrawMatchUps: r, tournamentRecord: i, drawDefinition: n, matchUpStatus: a, matchUpsMap: o, dualMatchUp: s, targetData: c, matchUpId: u, structure: d, event: p } = e, l = !!e.matchUp.collectionId, m = Er({ structure: d }), { drawPositions: f, winningSide: h } = c.matchUp || {};
  if (!m && !f)
    return { error: Du };
  let { targetLinks: { loserTargetLink: g, winnerTargetLink: I, byeTargetLink: y }, targetMatchUps: { loserMatchUp: U, winnerMatchUp: S, byeMatchUp: D } } = c, w = cn({ ...e, matchUpStatus: a || Rt, removeWinningSide: !0 });
  if (w.error)
    return w;
  let v;
  if (l) {
    let { matchUpTieId: O, matchUpsMap: k } = e;
    if (v = na({ appliedPolicies: e.appliedPolicies, matchUpId: O, tournamentRecord: i, drawDefinition: n, matchUpsMap: k, event: p }), !t && !v.removeWinningSide)
      return { ...V };
  }
  if (m)
    return { ...V };
  let { matchUps: P } = Ke({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: n, matchUpsMap: o, structure: d }), { positionAssignments: b } = Yt({ structure: d }), T = h - 1, R = 1 - T, M = f[T], E = f[R], { winnerParticipantId: C, loserParticipantId: A } = (b == null ? void 0 : b.reduce((O, k) => (k.drawPosition === E && (O.loserParticipantId = k.participantId), k.drawPosition === M && (O.winnerParticipantId = k.participantId), O), { winnerParticipantId: void 0, loserParticipantId: void 0 })) || {}, N = P.filter((O) => {
    var k;
    return (k = O.drawPositions) == null ? void 0 : k.includes(E);
  });
  if (S && dN({ sourceMatchUpStatus: a, sourceMatchUpId: u, inContextDrawMatchUps: r, winningDrawPosition: M, winnerParticipantId: C, tournamentRecord: i, winnerTargetLink: I, drawDefinition: n, winnerMatchUp: S, dualMatchUp: s, matchUpsMap: o }), U) {
    let { winnerHadMatchUpStatus: O } = _B({ drawPositionMatchUps: N, loserDrawPosition: E, sourceMatchUps: P }), k = g.linkCondition === ln;
    if (O && k) {
      let x = Math.min(...U.drawPositions);
      uh({ targetLink: g, inContextDrawMatchUps: r, drawDefinition: n, drawPosition: x, matchUpsMap: o, event: p });
    }
    let F = jB({ sourceMatchUpStatus: a, sourceMatchUpId: u, loserParticipantId: A, tournamentRecord: i, loserTargetLink: g, drawDefinition: n, loserMatchUp: U, dualMatchUp: s, matchUpsMap: o, event: p });
    if (F.error)
      return F;
  }
  if (D) {
    let O = Math.min(...D.drawPositions);
    uh({ sourceMatchUpId: u, targetLink: y, inContextDrawMatchUps: r, drawDefinition: n, drawPosition: O, matchUpsMap: o, event: p });
  }
  return { ...V, ...v && { tieMatchUpResult: v } };
}
function dN({ inContextDrawMatchUps: e, winningDrawPosition: t, sourceMatchUpStatus: r, winnerParticipantId: i, tournamentRecord: n, winnerTargetLink: a, sourceMatchUpId: o, drawDefinition: s, winnerMatchUp: c, matchUpsMap: u, dualMatchUp: d, event: p }) {
  var h, g;
  let { structureId: l, roundNumber: m } = c, f = "removeDirectedWinner";
  if (a) {
    let I = a.target.structureId, { structure: y } = ve({ drawDefinition: s, structureId: I });
    if (!y)
      return { error: It };
    let { positionAssignments: U } = Yt({ structure: y });
    y.seedAssignments = (y.seedAssignments ?? []).filter((b) => b.participantId !== i);
    let S = (h = U == null ? void 0 : U.find((b) => b.participantId === i)) == null ? void 0 : h.drawPosition, { matchUps: D } = Ke({ drawDefinition: s, structure: y, event: p }), w = D.map((b) => b.drawPositions).flat(1 / 0).filter(Boolean), v = Qr(w);
    if ((S ? v[S] : void 0) === 1)
      U == null || U.forEach((b) => {
        b.participantId === i && delete b.participantId;
      });
    else {
      let b = D.filter(({ drawPositions: T }) => T.includes(S));
      console.log("not removing from position assignments since instances > 1", { drawPositionMatchUps: b, winnerTargetLink: a });
    }
    let P = (g = u == null ? void 0 : u.drawMatchUps) == null ? void 0 : g.find(({ matchUpId: b }) => b === c.matchUpId);
    P && xe({ tournamentId: n == null ? void 0 : n.tournamentId, eventId: p == null ? void 0 : p.eventId, matchUp: P, context: f, drawDefinition: s });
  }
  return m && BB({ targetDrawPosition: t, inContextDrawMatchUps: e, sourceMatchUpStatus: r, tournamentRecord: n, sourceMatchUpId: o, drawDefinition: s, dualMatchUp: d, matchUpsMap: u, roundNumber: m, structureId: l }), { ...V };
}
function jB({ sourceMatchUpStatus: e, loserParticipantId: t, tournamentRecord: r, loserTargetLink: i, sourceMatchUpId: n, drawDefinition: a, loserMatchUp: o, matchUpsMap: s, dualMatchUp: c, event: u }) {
  var h, g, I;
  let d = "removeDirectedLoser", p = i.target.structureId, { structure: l } = ve({ drawDefinition: a, structureId: p });
  if (!l)
    return { error: It };
  let { positionAssignments: m } = Yt({ structure: l }), f = (h = m == null ? void 0 : m.find((y) => y.participantId === t)) == null ? void 0 : h.drawPosition;
  if (m == null || m.forEach((y) => {
    y.participantId === t && delete y.participantId;
  }), l.seedAssignments = (l.seedAssignments ?? []).filter((y) => y.participantId !== t), c) {
    let y = o == null ? void 0 : o.sides.reduce((D, w, v) => w.drawPosition === f ? v : D, void 0), U = (g = s == null ? void 0 : s.drawMatchUps) == null ? void 0 : g.find(({ matchUpId: D }) => D === o.matchUpId), S = (I = U == null ? void 0 : U.sides) == null ? void 0 : I[y];
    S && (delete S.lineUp, xe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: u == null ? void 0 : u.eventId, matchUp: U, context: d, drawDefinition: a }));
  }
  return { ...V };
}
function uh({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, targetLink: a, event: o }) {
  let s = a.target.structureId, c = "removeDirectedBye";
  ii({ color: "brightyellow", method: c, drawPosition: i });
  let u = id({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, structureId: s, event: o });
  return j({ result: u, stack: c });
}
function GB(e) {
  var c, u;
  let { matchUpFormat: t, score: r } = e, i = (c = r == null ? void 0 : r.sets) == null ? void 0 : c.length, n = t && Tr(t), { setFormat: a, finalSetFormat: o, bestOf: s } = n ?? {};
  return ((u = s && i === s && o || a) == null ? void 0 : u.timed) || !1;
}
function $B({ tournamentRecord: e, drawDefinition: t, structure: r, matchUp: i }) {
  var s;
  let n = "attemptToSetMatchUpStatusBYE";
  if (i != null && i.winningSide)
    return j({ result: { error: nc }, context: { matchUpStatus: $e }, stack: n });
  let { positionAssignments: a } = Yt({ structure: r }), o = a == null ? void 0 : a.filter((c) => c.bye).map((c) => c.drawPosition);
  return (s = i.drawPositions) != null && s.some((c) => o == null ? void 0 : o.includes(c)) ? (i.matchUpStatus = $e, i.matchUpStatusCodes = [], xe({ tournamentId: e == null ? void 0 : e.tournamentId, context: n, drawDefinition: t, matchUp: i }), { ...V }) : j({ result: { error: Jv }, info: "matchUp does not include BYE", stack: n });
}
function Wc(e) {
  var g, I;
  let { tournamentRecord: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: n, targetData: a, structure: o, event: s } = e, c = "doubleExitAdvancement";
  if (o.structureType === br)
    return j({ result: { ...V }, stack: c });
  let { matchUp: u, targetMatchUps: d, targetLinks: p } = a, { loserMatchUp: l, winnerMatchUp: m, loserTargetDrawPosition: f } = d, h = [Be, ke].includes(l == null ? void 0 : l.matchUpStatus) && !((g = l.sides) != null && g.map((y) => y.participantId ?? y.participant).filter(Boolean).length);
  if (l && l.matchUpStatus !== $e) {
    let { loserTargetLink: y } = p;
    if ((I = r == null ? void 0 : r.progression) != null && I.doubleExitPropagateBye) {
      let U = lN({ loserTargetDrawPosition: f, tournamentRecord: t, loserTargetLink: y, drawDefinition: i, loserMatchUp: l, matchUpsMap: n, event: s });
      if (U.error)
        return j({ result: U, stack: c });
    } else if (!h) {
      let { feedRound: U, drawPositions: S, matchUpId: D } = l, w = U ? 2 : 2 - S.indexOf(f), v = $S({ ...e, targetMatchUp: l, walkoverWinningSide: w, tournamentRecord: t, sourceMatchUp: u, matchUpId: D });
      if (v.error)
        return j({ result: v, stack: c });
    }
  }
  if (m) {
    let y = $S({ ...e, matchUpId: m.matchUpId, targetMatchUp: m, tournamentRecord: t, sourceMatchUp: u });
    if (y.error)
      return j({ result: y, stack: c });
  }
  return j({ result: { ...V }, stack: c });
}
function $S(e) {
  var $, W, q;
  let { inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, sourceMatchUp: n, targetMatchUp: a, matchUpsMap: o } = e, s = i.structures.find(({ structureId: K }) => K === a.structureId), c = e.matchUpStatus === Lt ? Lt : Et, u = e.matchUpStatus === Lt ? ke : Be, d = "conditionallyAdvanceDrawPosition", p = o.drawMatchUps.find((K) => K.matchUpId === a.matchUpId);
  if (!p)
    return { error: Vr };
  let l = (n == null ? void 0 : n.drawPositions) || [], m = ($ = p.drawPositions) == null ? void 0 : $.filter(Boolean), f = (n == null ? void 0 : n.structureId) === a.structureId;
  if (f && wr(l, m) && (m = m.filter((K) => !l.includes(K))), f && m.length > 1)
    return j({ result: { error: Os }, stack: d });
  let { pairedPreviousMatchUpIsDoubleExit: h, pairedPreviousMatchUp: g } = RT(e), I = Dr({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), { targetMatchUps: y, targetLinks: U } = I, { loserTargetDrawPosition: S, winnerMatchUp: D, loserMatchUp: w } = y;
  if (w) {
    let { loserTargetLink: K } = U, z = lN({ loserTargetDrawPosition: S, loserMatchUp: w, tournamentRecord: r, loserTargetLink: K, drawDefinition: i, matchUpsMap: o });
    if (z.error)
      return j({ result: z, stack: d });
  }
  let v = ((W = p.drawPositions) == null ? void 0 : W.filter(Boolean)) || [], P = v.length === 1, b = e.walkoverWinningSide || P && Xd({ drawPosition: v[0], matchUpId: a.matchUpId, inContextDrawMatchUps: t }) || void 0, T = [Be, ke].includes(p.matchUpStatus) && !v.length, R = p.finishingRound === 1, M = T && !R ? c : u, E = t.find((K) => K.matchUpId === g.matchUpId), C = [], A;
  n && ((n == null ? void 0 : n.structureId) === (E == null ? void 0 : E.structureId) ? n.roundPosition < (g == null ? void 0 : g.roundPosition) ? A = 1 : A = 2 : a.feedRound ? n.structureId === a.structureId ? A = 2 : A = 1 : b && (A = 3 - b));
  let N = e.matchUpStatus, O = g == null ? void 0 : g.matchUpStatus;
  A === 1 ? C = [{ matchUpStatus: _d(N), previousMatchUpStatus: N, sideNumber: 1 }, { matchUpStatus: _d(O), previousMatchUpStatus: O, sideNumber: 2 }] : A === 2 && (C = [{ matchUpStatus: _d(O), previousMatchUpStatus: O, sideNumber: 1 }, { matchUpStatus: _d(N), previousMatchUpStatus: N, sideNumber: 2 }]), C.length && (C = C.map((K) => me(K)));
  let k = cn({ ...e, winningSide: b, matchUp: p, matchUpStatusCodes: C, context: d, matchUpStatus: M });
  if (k.error)
    return j({ result: k, stack: d });
  if (T)
    return Wc({ ...e, matchUpStatus: M, targetData: I });
  if (!D)
    return j({ result: { ...V }, stack: d });
  let F = m.length === 2 ? m[b - 1] : m[0], { positionAssignments: x } = ot({ structure: s }), _ = x == null ? void 0 : x.find((K) => K.drawPosition === F), B = o.drawMatchUps.find((K) => K.matchUpId === D.matchUpId), L = (q = B == null ? void 0 : B.drawPositions) == null ? void 0 : q.filter(Boolean), G = L.length === 1;
  if (F) {
    if (_ != null && _.bye) {
      let K = Dr({ matchUpId: B.matchUpId, inContextDrawMatchUps: t, drawDefinition: i });
      if (G) {
        let z = L.filter(Boolean)[0], Y = Xd({ drawPosition: z, matchUpId: B.matchUpId, inContextDrawMatchUps: t }), X = cn({ appliedPolicies: e.appliedPolicies, matchUpId: B.matchUpId, matchUp: B, matchUpStatus: u, matchUpStatusCodes: [], removeScore: !0, context: d, drawDefinition: i, winningSide: Y });
        return X.error ? j({ result: X, stack: d }) : eI({ drawPositionToAdvance: z, matchUpId: B.matchUpId, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: o });
      } else if ([Be, ke].includes(D.matchUpStatus)) {
        let z = Wc({ ...e, matchUpId: B.matchUpId, matchUpStatus: M, targetData: K });
        if (z.error)
          return j({ result: z, stack: d });
      }
      return j({ result: { ...V }, stack: d });
    }
    return Ks({ matchUpId: D.matchUpId, drawPosition: F, inContextDrawMatchUps: t, drawDefinition: i });
  } else if (h) {
    if (!B)
      return { error: Vr };
    if (G) {
      let Y = L[0], X = Xd({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawPosition: Y });
      console.log("existing drawPosition is winningSide", { walkoverWinningSide: X });
    }
    let K = [Be, ke].includes(B.matchUpStatus) ? u : c, z = cn({ matchUpId: B.matchUpId, appliedPolicies: e.appliedPolicies, matchUp: B, matchUpStatusCodes: [], removeScore: !0, context: d, drawDefinition: i, matchUpStatus: K });
    if (z.error)
      return j({ result: z, stack: d });
    if (K === c) {
      let Y = Wc({ ...e, matchUpId: a.matchUpId, matchUpStatus: K, targetData: I });
      if (Y.error)
        return Y;
    }
  }
  return j({ result: { ...V }, stack: d });
}
function lN(e) {
  var u;
  let { loserTargetDrawPosition: t, tournamentRecord: r, loserTargetLink: i, drawDefinition: n, matchUpsMap: a, event: o } = e, s = (u = i == null ? void 0 : i.target) == null ? void 0 : u.structureId, { structure: c } = ve({ drawDefinition: n, structureId: s });
  return c ? pi({ drawPosition: t, tournamentRecord: r, drawDefinition: n, structureId: s, matchUpsMap: a, event: o }) : { error: ao };
}
function _d(e) {
  return e === Et ? Be : e === Lt ? ke : e;
}
function qB(e) {
  let { tournamentRecord: t, drawDefinition: r, matchUpStatus: i, structure: n, matchUp: a } = e, o = !!(a.tieMatchUps && !a.rondPosition && e.inContextDrawMatchUps.find((I) => I.matchUpId === a.matchUpId).containerStructureId), s = "attemptToSetMatchUpStatus", c = i === $e, u = a.winningSide, d = [Et, Lt].includes(i), p = td({ matchUpStatus: i }), l = Vf({ matchUpStatus: i }), m = !p && !l, f = e.matchUpTieId || u && p && !d, h = u && d, g = () => cn({ ...e, removeScore: [Un, Be].includes(i), matchUpStatus: i || Rt });
  return m && { error: Sf } || f && dh(e) || h && WB(e) || u && Ec(e) || l && g() || c && $B({ tournamentRecord: t, drawDefinition: r, structure: n, matchUp: a }) || !p && { error: Sf } || d && HB(e) || o && dh(e) || j({ result: { error: nc }, stack: s });
}
function WB(e) {
  let t = Ec(e);
  return t.error ? t : Wc(e);
}
function HB(e) {
  let t = dh({ ...e, removeScore: !0 });
  return t.error ? t : Wc(e);
}
function dh(e) {
  var n;
  let t = "scoreModification";
  if (e.isCollectionMatchUp && ((n = e.dualMatchUp) != null && n.winningSide) && !e.projectedWinningSide) {
    let a = Ec(e);
    if (a.error)
      return j({ result: a, stack: t });
  }
  let r = !!e.matchUp.collectionId, i = cn({ ...e, context: t });
  if (r) {
    let { matchUpTieId: a, drawDefinition: o, matchUpsMap: s } = e, c = na({ tournamentRecord: e.tournamentRecord, appliedPolicies: e.appliedPolicies, matchUpId: a, event: e.event, drawDefinition: o, matchUpsMap: s });
    if (c.error)
      return j({ result: c, stack: t });
    Object.assign(i, { tieMatchUpResult: c });
  }
  return j({ result: i, stack: t });
}
function zB({ drawDefinition: e, structure: t, matchUp: r }) {
  var c, u, d, p;
  let { drawPositions: i } = r, { positionAssignments: n } = ot({ drawDefinition: e, structure: t }), a = (c = n == null ? void 0 : n.filter(({ drawPosition: l }) => i == null ? void 0 : i.includes(l))) == null ? void 0 : c.map((l) => {
    var f;
    let { extension: m } = Ne({ element: l, name: Ia });
    return (f = m == null ? void 0 : m.value) == null ? void 0 : f.groupOrder;
  }), { containerStructures: o } = gc({ drawDefinition: e }), s = o[t.structureId];
  return { structureIds: (p = (d = (u = Ic({ drawDefinition: e, structureId: s })) == null ? void 0 : u.links) == null ? void 0 : d.source) == null ? void 0 : p.filter((l) => {
    var m;
    return wr(a, ((m = l.source) == null ? void 0 : m.finishingPositions) || []);
  }).map((l) => l.source.structureId) };
}
function pN({ drawDefinition: e, structure: t, matchUp: r }) {
  let i = [];
  if (t.finishingPosition === Ha && wa({ drawDefinition: e, structure: t })) {
    let { structureIds: n } = zB({ drawDefinition: e, structure: t, matchUp: r });
    n != null && n.length && i.push(...n);
  }
  return { connectedStructureIds: i };
}
function YB(e) {
  var s, c, u;
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n, winningSide: a } = e, o = (s = e.targetData.targetLinks) == null ? void 0 : s.winnerTargetLink;
  if (o.target.feedProfile === Ni) {
    let d = i.sides.find(({ sideNumber: l }) => l !== a).participantId, p = r.find((l) => l.structureId === o.target.structureId && l.roundNumber === o.target.roundNumber && l.sides.some(({ participantId: m }) => m === d));
    if ((p == null ? void 0 : p.matchUpStatus) === Rt) {
      let l = Dr({ matchUpId: p.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!eo({ inContextDrawMatchUps: r, drawDefinition: n, targetData: l })) {
        let { structure: m } = ve({ structureId: p.structureId, drawDefinition: n }), f = ot({ structure: m }).positionAssignments;
        for (let h of f || [])
          if (h.participantId === d) {
            let g = i.sides.find(({ sideNumber: I }) => I === a).participantId;
            if (h.participantId = g, m == null ? void 0 : m.positionAssignments)
              m.positionAssignments = f;
            else if (m != null && m.structures) {
              let I = Object.assign({}, ...(f || []).map((y) => ({ [y.drawPosition]: y.participantId })));
              for (let y of m.structures)
                (c = y.positionAssignments) == null || c.forEach((U) => U.participantId = I[U.drawPosition]);
            }
            Sa({ tournamentId: (u = e.tournamentRecord) == null ? void 0 : u.tournamentId, event: e.event, drawDefinition: n, structure: m }), t = !0;
          }
      }
    }
  }
  return { ...V, qualifierReplaced: t };
}
function KB(e) {
  var s, c, u, d, p;
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n, winningSide: a } = e, o = (s = e.targetData.targetLinks) == null ? void 0 : s.winnerTargetLink;
  if (o.target.feedProfile === Ni) {
    let l = (c = i.sides.find(({ sideNumber: h }) => h === a)) == null ? void 0 : c.participantId, m = r.filter((h) => h.structureId === o.target.structureId && h.roundNumber === o.target.roundNumber && h.sides.some(({ participantId: g, qualifier: I }) => I && !g)), f = Wr(m);
    if ((f == null ? void 0 : f.matchUpStatus) === Rt) {
      let h = Dr({ matchUpId: f.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!eo({ inContextDrawMatchUps: r, drawDefinition: n, targetData: h })) {
        let g = (u = f.sides.find((U) => U.qualifier && !U.participantId)) == null ? void 0 : u.drawPosition, { structure: I } = ve({ structureId: f.structureId, drawDefinition: n });
        if (!I)
          return { error: It };
        let y = ot({ structure: I }).positionAssignments;
        for (let U of y || [])
          if (U.drawPosition === g && !U.participantId) {
            if (U.participantId = l, I.positionAssignments)
              I.positionAssignments = y;
            else if (I.structures) {
              let S = Object.assign({}, ...(y || []).map((D) => ({ [D.drawPosition]: D.participantId })));
              for (let D of I.structures)
                (d = D.positionAssignments) == null || d.forEach((w) => w.participantId = S[w.drawPosition]);
            }
            Sa({ tournamentId: (p = e.tournamentRecord) == null ? void 0 : p.tournamentId, event: e.event, drawDefinition: n, structure: I }), t = !0;
          }
      }
    }
  }
  return { ...V, qualifierPlaced: t };
}
function QB(e) {
  var m, f;
  let t = "attemptToSetWinningSide", r, { appliedPolicies: i, disableAutoCalc: n, drawDefinition: a, dualMatchUp: o, winningSide: s, structure: c, matchUp: u } = e;
  if (o != null && o._disableAutoCalc && n !== !1)
    return OI(e);
  if (u.winningSide && u.winningSide !== s) {
    let { connectedStructureIds: h } = pN({ drawDefinition: a, structure: c, matchUp: u });
    h.length && (console.log({ connectedStructureIds: h }), r = !0);
    let g = Ec(e);
    if (g.error)
      return g;
  }
  let d = wb(e);
  if (d.error)
    return j({ result: d, stack: t });
  let p, l;
  return e.qualifierChanging && ((m = i == null ? void 0 : i[au]) != null && m.autoReplaceQualifiers) && (p = YB(e).qualifierReplaced), e.qualifierAdvancing && ((f = i == null ? void 0 : i[au]) != null && f.autoPlaceQualifiers) && (l = KB(e).qualifierPlaced), j({ result: me({ ...V, ...d, connectedStructures: r, qualifierReplaced: p, qualifierPlaced: l }), stack: t });
}
var il = { drawPositionToRemove: "green", iteration: "brightred", winner: "green", loser: "brightred" };
function mN(e) {
  var g, I, y, U;
  let { inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: n, targetData: a, matchUp: o } = e, { matchUpId: s } = o, { iteration: c = 0 } = e;
  c += 1;
  let u = "removeDoubleExit";
  ii({ color: "brightyellow", method: u, matchUpId: s, iteration: c, keyColors: il });
  let { targetMatchUps: { loserMatchUp: d, winnerMatchUp: p, loserTargetDrawPosition: l }, targetLinks: { loserTargetLink: m } } = a;
  if (p && p.matchUpStatus !== $e) {
    let { stage: S, roundNumber: D, roundPosition: w, structureName: v } = p;
    ii({ winner: "winner", roundPosition: w, structureName: v, roundNumber: D, keyColors: il, stage: S }), qS({ ...e, targetMatchUp: p, sourceMatchUp: o, iteration: c });
  }
  let f = (d == null ? void 0 : d.matchUpStatus) === $e && ((d == null ? void 0 : d.feedRound) || (d == null ? void 0 : d.roundNumber) === 1), h = ((I = (g = a == null ? void 0 : a.targetLinks) == null ? void 0 : g.loserTargetLink) == null ? void 0 : I.linkCondition) === ln;
  if (f && h) {
    let S = t.filter(({ roundNumber: v, structureId: P }) => P === o.structureId && v === 1), D = S.map(({ roundPosition: v }) => v), w = zt(D.sort(), 2).find((v) => v.includes(o.roundPosition));
    if (((y = S.filter(({ roundPosition: v }) => w.includes(v))) == null ? void 0 : y.map(({ matchUpStatus: v }) => v)).every((v) => [Lt, Et].includes(v)))
      return j({ result: { ...V }, stack: u });
  }
  if (d && (d.matchUpStatus !== $e || f)) {
    let S = t.find(({ matchUpId: R }) => R === d.matchUpId), { structure: D } = ve({ drawDefinition: i, structureId: S.structureId }), { stage: w, roundNumber: v, roundPosition: P, feedRound: b, structureName: T } = d;
    if (ii({ loser: "loser", roundPosition: P, structureName: T, roundNumber: v, keyColors: il, feedRound: b, stage: w }), ((U = r == null ? void 0 : r.progression) == null ? void 0 : U.doubleExitPropagateBye) || f)
      uh({ drawPosition: l, targetLink: m, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: n });
    else {
      let R = qS({ ...e, targetMatchUp: d, structure: D, iteration: c });
      if (R.error)
        return j({ result: R, stack: u });
    }
  }
  return j({ result: { ...V }, stack: u });
}
function qS(e) {
  var S, D, w, v, P, b;
  let { inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, sourceMatchUp: n, targetMatchUp: a, matchUpsMap: o, structure: s, iteration: c } = e, u = "conditionallyRemoveDrawPosition";
  ii({ method: u, structureName: s == null ? void 0 : s.structureName, iteration: c });
  let d = Dr({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), { targetMatchUps: { winnerMatchUp: p } } = d, l = o == null ? void 0 : o.drawMatchUps.find((T) => T.matchUpId === a.matchUpId), m = [], f, h, g;
  if (a.feedRound)
    g = (D = (S = p == null ? void 0 : p.drawPositions) == null ? void 0 : S.filter(Boolean)) == null ? void 0 : D.find((T) => a.drawPositions.includes(T));
  else if (!n)
    g = (w = wt((a == null ? void 0 : a.drawPositions) || [], (p == null ? void 0 : p.drawPositions) || [])) == null ? void 0 : w[0];
  else if (h = (v = MT({ structureId: s.structureId, matchUp: n, matchUpsMap: o })) == null ? void 0 : v.pairedPreviousMatchUp, f = [Et, Lt].includes(h == null ? void 0 : h.matchUpStatus), m = ((P = h == null ? void 0 : h.drawPositions) == null ? void 0 : P.filter(Boolean)) || [], [...Vt, $e].includes(h == null ? void 0 : h.matchUpStatus) || (h == null ? void 0 : h.winningSide)) {
    let T = n.drawPositions || [], R = (b = a.drawPositions) == null ? void 0 : b.filter(Boolean);
    wr(T, R) && (R = R == null ? void 0 : R.filter((M) => !T.includes(M))), g = T.concat(m).find((M) => R == null ? void 0 : R.includes(M));
  }
  if (p && g) {
    let { stage: T, roundNumber: R, roundPosition: M, structureName: E } = p;
    ii({ method: "removeDirectedWinner", drawPositionToRemove: g, color: "brightgreen", roundPosition: M, structureName: E, roundNumber: R, keyColors: il, stage: T }), dN({ winningDrawPosition: g, winnerMatchUp: p, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: o });
  }
  let I = mN({ targetData: d, matchUp: a, inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: o, structure: s, iteration: c });
  if (I.error)
    return j({ result: I, stack: u });
  let y = JB({ pairedPreviousDoubleExit: f, noContextTargetMatchUp: l }), U = !f;
  return I = cn({ ...e, matchUpId: a.matchUpId, matchUp: l, removeWinningSide: !0, matchUpStatusCodes: [], context: u, matchUpStatus: y, removeScore: U, score: { scoreStringSide1: "", scoreStringSide2: "", sets: void 0 } }), I.error ? j({ result: I, stack: u }) : { ...V };
}
function JB({ pairedPreviousDoubleExit: e, noContextTargetMatchUp: t }) {
  return t.matchUpStatus === $e ? $e : e ? [Lt, ke].includes(t == null ? void 0 : t.matchUpStatus) ? ke : Be : Rt;
}
function XB(e) {
  var o, s, c, u, d;
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n } = e, a = (o = e.targetData.targetLinks) == null ? void 0 : o.winnerTargetLink;
  if (a.target.feedProfile === Ni) {
    let p = (c = (s = i.sides) == null ? void 0 : s.find(({ sideNumber: m }) => m === i.winningSide)) == null ? void 0 : c.participantId, l = r.find((m) => {
      var f;
      return m.structureId === a.target.structureId && m.roundNumber === a.target.roundNumber && ((f = m.sides) == null ? void 0 : f.some(({ participantId: h }) => h === p));
    });
    if (l && l.matchUpStatus === Rt) {
      let m = Dr({ matchUpId: l.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!eo({ inContextDrawMatchUps: r, drawDefinition: n, targetData: m })) {
        let { structure: f } = ve({ structureId: l.structureId, drawDefinition: n }), h = ot({ structure: f }).positionAssignments;
        for (let g of h || [])
          if (g.participantId === p) {
            if (g.participantId = void 0, f == null ? void 0 : f.positionAssignments)
              f.positionAssignments = h;
            else if (f != null && f.structures) {
              let I = Object.assign({}, ...(h || []).map((y) => ({ [y.drawPosition]: y.participantId })));
              for (let y of (f == null ? void 0 : f.structures) || [])
                (u = y.positionAssignments) == null || u.forEach((U) => U.participantId = I[U.drawPosition]);
            }
            Sa({ tournamentId: (d = e.tournamentRecord) == null ? void 0 : d.tournamentId, event: e.event, drawDefinition: n, structure: f }), t = !0;
          }
      }
    }
  }
  return { qualifierRemoved: t };
}
function ZB(e) {
  var h;
  let { matchUp: t, matchUpStatus: r, score: i, winningSide: n } = e, a = "noDownStreamDependencies";
  if ([Et, Lt].includes(t == null ? void 0 : t.matchUpStatus) && ![Et, Lt].includes(r)) {
    let g = mN(e);
    if (g.error)
      return j({ result: g, stack: a });
  }
  let o = r === Et, s = jt({ score: i }) && !o && (e.isCollectionMatchUp && !e.projectedWinningSide || !n), c = ((h = e == null ? void 0 : e.inContextMatchUp) == null ? void 0 : h.collectionId) && GB(e.inContextMatchUp), u = e.removeScore || !c && ![Zr, Gr].includes(r || Zr), d = e.isCollectionMatchUp && e.dualMatchUp.winningSide && !e.projectedWinningSide || t.winningSide && !n && !jt({ score: i }), p = r && r !== Rt, l = (g) => {
    var P, b;
    let I, { structure: y, drawDefinition: U, dualMatchUp: S, disableAutoCalc: D } = e;
    if (S != null && S._disableAutoCalc && D !== !1)
      return OI({ ...e, removeWinningSide: d });
    let { connectedStructureIds: w } = pN({ drawDefinition: U, structure: y, matchUp: t });
    w.length && (console.log({ connectedStructureIds: w }), I = !0), Object.assign(e, { removeScore: g });
    let v = Ec(e);
    if (v.error)
      return v;
    if (e.removingQualifier && ((b = (P = e.appliedPolicies) == null ? void 0 : P[au]) != null && b.autoRemoveQualifiers)) {
      let T = XB(e);
      return { ...V, connectedStructures: I, ...T };
    }
    return { ...V, connectedStructures: I };
  };
  if (d && n && e.isCollectionMatchUp)
    return WS(e);
  let m = [Un, Gr].includes(r) && e.dualWinningSideChange, f = (n || m) && QB(e) || s && l(u) || p && qB(e) || d && l(u) || t && WS({ ...e, removeScore: !0 }) || { ...V };
  return j({ result: f, stack: a });
}
function WS(e) {
  var i;
  let t = "ndd:scoreModification";
  if (e.isCollectionMatchUp && ((i = e.dualMatchUp) != null && i.winningSide) && !e.projectedWinningSide && !e.autoCalcDisabled) {
    let n = Ec(e);
    if (n.error)
      return n;
  }
  let r = cn({ ...e, context: t });
  if (e.isCollectionMatchUp) {
    let { matchUpTieId: n, drawDefinition: a, event: o, matchUpsMap: s } = e, { removeWinningSide: c } = na({ tournamentRecord: e.tournamentRecord, appliedPolicies: e.appliedPolicies, matchUpId: n, drawDefinition: a, matchUpsMap: s, event: o });
    c && console.log("REMOVE WINNING SIDE");
  }
  return j({ result: r, stack: t });
}
function ry(e) {
  var d, p, l;
  let t = fe(e, [{ [Gt]: !0, [Rr]: !0, [gn]: !0 }, { homeParticipantId: !0, [ki]: _t }]);
  if (t.error)
    return t;
  let r = bc(e, [{ [lc]: Fn, attr: { [fp]: !0 } }]);
  if (r.error)
    return r;
  let i = (l = (p = (d = r == null ? void 0 : r.matchUp) == null ? void 0 : d.matchUp) == null ? void 0 : p.sides) == null ? void 0 : l.map((m) => m == null ? void 0 : m.participantId);
  if (e.homeParticipantId && !(i != null && i.includes(e.homeParticipantId)))
    return { error: Ji };
  let { disableNotice: n = !0, homeParticipantId: a, removePriorValues: o, tournamentRecord: s, drawDefinition: c, matchUpId: u } = e;
  return ti({ duplicateValues: !1, removePriorValues: o, tournamentRecord: s, drawDefinition: c, disableNotice: n, matchUpId: u, timeItem: { itemType: Yg, itemValue: a } });
}
function fN({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = fo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: Ep });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { timeModifiers: i } : t;
}
function ka(e) {
  var m;
  let t = "addMatchUpScheduledTime", r = e.matchUp, { removePriorValues: i, tournamentRecord: n, drawDefinition: a, disableNotice: o, scheduledTime: s, matchUpId: c } = e;
  if (!c)
    return j({ result: { error: Ur }, stack: t });
  if (!uc(s))
    return j({ result: { error: Ri }, stack: t });
  if (!r) {
    let f = ft({ drawDefinition: a, matchUpId: c });
    if (f.error)
      return j({ result: f, stack: t });
    r = f.matchUp;
  }
  let u = be(s), d = os({ matchUp: r }).scheduledDate, p = u && !d;
  if ((m = fN({ matchUp: r }).timeModifiers || []) != null && m.length) {
    let f = hN({ disableNotice: !0, removePriorValues: i, tournamentRecord: n, timeModifiers: [], drawDefinition: a, matchUpId: c, matchUp: r });
    if (f != null && f.error)
      return j({ result: f, stack: t });
  }
  let l = Qo(s, !0, p);
  return ti({ duplicateValues: !1, removePriorValues: i, tournamentRecord: n, drawDefinition: a, disableNotice: o, matchUpId: c, timeItem: { itemType: ns, itemValue: l } });
}
function hN({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, timeModifiers: n, matchUpId: a, matchUp: o }) {
  let s = "addMatchUpTimeModifiers";
  if (!a)
    return j({ result: { error: Ur }, stack: s });
  if (n !== void 0 && !Array.isArray(n))
    return j({ info: Xa("timeModifiers"), result: { error: J }, stack: s });
  if (!o) {
    let p = ft({ drawDefinition: r, matchUpId: a });
    if (p.error)
      return j({ result: p, stack: s });
    o = p.matchUp;
  }
  let c = fN({ matchUp: o }).timeModifiers || [], u = n.filter((p) => !c.includes(p));
  if (n.length && !u.length)
    return { ...V };
  if (u.some((p) => xf.includes(p))) {
    c = c.filter((l) => !xf.includes(l));
    let p = ka({ disableNotice: !0, removePriorValues: e, scheduledTime: "", tournamentRecord: t, drawDefinition: r, matchUpId: a });
    if (p.error)
      return j({ result: p, stack: s });
  }
  let d = n != null && n.length ? [...u, ...c] : void 0;
  return ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: { itemType: Ep, itemValue: d } });
}
function Cm({ scheduledDate: e, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a }) {
  if (!a)
    return { error: Ur };
  let o = e && un.test(e);
  if (e && !o)
    return { error: Qt };
  let s = { itemValue: be(e), itemType: is };
  return ti({ duplicateValues: !1, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: s });
}
function Om({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, courtDayDate: a, matchUpId: o, courtIds: s }) {
  var d, p;
  if (!r && !t)
    return { error: ae };
  if (!o)
    return { error: Ur };
  let c = ft({ drawDefinition: i, matchUpId: o });
  if (c.error)
    return c;
  if (((d = c == null ? void 0 : c.matchUp) == null ? void 0 : d.matchUpType) !== ni)
    return { error: jr };
  if (!(s === void 0 || Array.isArray(s) && s.length && s.every((l) => typeof l == "string")))
    return { error: J, context: { courtIds: s } };
  let u;
  if (s) {
    let l = t || r && { [r.tournamentId]: r }, m = aa({ tournamentRecords: l });
    if (m.error)
      return m;
    let f = (p = m.courts) == null ? void 0 : p.filter((h) => s.includes(h.courtId));
    if ((f == null ? void 0 : f.length) !== s.length)
      return { error: J, context: { courtIds: s } };
    u = f == null ? void 0 : f.map((h) => ({ venueId: h.venueId, courtId: h.courtId }));
  }
  return ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, timeItem: { itemType: kn, itemDate: a, itemValue: u } });
}
function Cc({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, venueId: o }) {
  if (!r)
    return { error: ae };
  if (!a)
    return { error: Ur };
  if (o) {
    let s = xn({ tournamentRecords: t, tournamentRecord: r, venueId: o });
    if (s.error)
      return s;
  }
  return ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: { itemType: rs, itemValue: o } });
}
function Is({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, courtDayDate: a, matchUpId: o, courtId: s }) {
  var c;
  if (!r && !t)
    return { error: ae };
  if (!o)
    return { error: Ur };
  if (s) {
    let u = ss({ tournamentRecords: t, tournamentRecord: r, courtId: s });
    if (u.error)
      return u;
    let d = (c = u.venue) == null ? void 0 : c.venueId;
    Cc({ tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, venueId: d });
  }
  return ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, timeItem: { itemType: va, itemDate: a, itemValue: s } });
}
function nn(e, t) {
  let r = eP.test(e) ? e : mt(e), i = be(e) || be(t) || Ci(/* @__PURE__ */ new Date());
  return (/* @__PURE__ */ new Date(`${i}T${r}`)).getTime();
}
function km(e) {
  var A;
  let t = "addMatchUpScheduleItems", r = fe(e, [{ drawDefinition: !0, matchUpId: !0 }, { schedule: !0, [Or]: _r }], t);
  if (r.error)
    return r;
  let { matchUpDependencies: i, inContextMatchUps: n } = e, { errorOnAnachronism: a = !1, checkChronology: o = !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: d, disableNotice: p, drawMatchUps: l, matchUpId: m, schedule: f, event: h } = e, g, I;
  if (l)
    g = l.find((N) => N.matchUpId === m);
  else {
    let N = ft({ drawDefinition: d, event: h, matchUpId: m });
    if (N.error)
      return N;
    g = N.matchUp;
  }
  let { endTime: y, courtId: U, courtIds: S, courtOrder: D, resumeTime: w, homeParticipantId: v, scheduledDate: P, scheduledTime: b, startTime: T, stopTime: R, timeModifiers: M, venueId: E } = f;
  o && (!i || !n) && ({ matchUpDependencies: i, matchUps: n } = qi({ drawDefinition: d }));
  let C = (A = i == null ? void 0 : i[m]) == null ? void 0 : A.matchUpIds;
  if (f.scheduledDate && o && C) {
    let N = n == null ? void 0 : n.filter((O) => {
      var k, F;
      return (((k = O.schedule) == null ? void 0 : k.scheduledDate) || be((F = O.schedule) == null ? void 0 : F.scheduledTime)) && C.includes(O.matchUpId);
    }).map(({ schedule: O }) => {
      let k = sl(O);
      return new Date(k).getTime();
    });
    if (N != null && N.length) {
      let O = sl(f), k = new Date(O).getTime();
      if (Math.max(...N) >= k) {
        if (a)
          return j({ result: { error: If }, stack: t });
        I = If;
      }
    }
  }
  if (P !== void 0) {
    let N = Cm({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, scheduledDate: P, matchUpId: m });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { scheduledDate: P } });
  }
  if (b !== void 0) {
    let N = ka({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, scheduledTime: b, matchUpId: m, matchUp: g });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { scheduledTime: b } });
  }
  if (T !== void 0) {
    let N = ny({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: m, startTime: T, event: h });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { startTime: T } });
  }
  if (R !== void 0) {
    let N = oy({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: m, stopTime: R, event: h });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { stopTime: R } });
  }
  if (w !== void 0) {
    let N = sy({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, resumeTime: w, matchUpId: m, event: h });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { resumeTime: w } });
  }
  if (y !== void 0) {
    let N = ay({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: m, endTime: y, event: h });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { endTime: y } });
  }
  if (S !== void 0) {
    let N = Om({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: m, courtIds: S });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { courtIds: S } });
  }
  if (U !== void 0 && P !== void 0) {
    let N = Is({ courtDayDate: P, disableNotice: !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: d, matchUpId: m, courtId: U });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { courtId: U } });
  }
  if (E !== void 0) {
    let N = Cc({ disableNotice: !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: d, matchUpId: m, venueId: E });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { venueId: E } });
  }
  if (D !== void 0 && Pe(D)) {
    let N = iy({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, courtOrder: D, matchUpId: m });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { courtOrder: D } });
  }
  if (M !== void 0) {
    let N = hN({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, timeModifiers: M, matchUpId: m, matchUp: g });
    if (N != null && N.error)
      return j({ result: N, stack: t, context: { timeModifiers: M } });
  }
  return ht(v) && ry({ disableNotice: !0, homeParticipantId: v, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: m }), p || xe({ tournamentId: u == null ? void 0 : u.tournamentId, eventId: h == null ? void 0 : h.eventId, context: t, drawDefinition: d, matchUp: g }), I ? { ...V, warnings: [I] } : { ...V };
}
function iy({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, courtOrder: n, matchUpId: a }) {
  if (!a)
    return { error: Ur };
  if (n && !Pe(n))
    return { error: J, info: "courtOrder must be numeric" };
  let o = n && ye(n);
  return ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: { itemType: Ap, itemValue: o } });
}
function gN({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, participantId: n, officialType: a, matchUpId: o }) {
  if (!o)
    return { error: Ur };
  if (!n)
    return { error: _t };
  if (t) {
    let c = Ut({ tournamentRecord: t, participantFilters: { participantTypes: [Oe], participantRoles: [nI] } }).participants ?? [];
    if (!ga({ tournamentParticipants: c, participantId: n }))
      return { error: Dt };
  }
  let s = { itemType: "SCHEDULE.ASSIGNMENT.OFFICIAL", itemValue: n };
  return a && (s.itemSubTypes = [a]), ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: o, timeItem: s });
}
function ny({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, startTime: a, event: o }) {
  if (!n)
    return { error: Ur };
  if (!uc(a))
    return { error: Ri };
  let { matchUp: s } = ft({ drawDefinition: r, event: o, matchUpId: n }), { scheduledDate: c } = os({ matchUp: s }), u = ((s == null ? void 0 : s.timeItems) ?? []).filter((d) => [Gn, Dn, Jn].includes(d == null ? void 0 : d.itemType)).map((d) => nn(d.itemValue, c)).reduce((d, p) => !d || p < d ? p : d, void 0);
  if (!u || nn(a, c) < u) {
    s != null && s.timeItems && (s.timeItems = s.timeItems.filter((p) => p.itemType !== Hi));
    let d = Qo(a, !0, !0);
    return ti({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, timeItem: { itemType: Hi, itemValue: d } });
  } else
    return { error: Tw };
}
function ay({ validateTimeSeries: e = !0, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, endTime: o, event: s }) {
  if (!a)
    return { error: Ur };
  if (!uc(o))
    return { error: Ri };
  let { matchUp: c } = ft({ drawDefinition: i, event: s, matchUpId: a }), { scheduledDate: u } = os({ matchUp: c }), d = ((c == null ? void 0 : c.timeItems) ?? []).filter((p) => [Hi, Dn, Gn].includes(p == null ? void 0 : p.itemType)).map((p) => nn(p.itemValue, u)).reduce((p, l) => !p || l > p ? l : p, void 0);
  if (!e || !d || nn(o, u) > d) {
    c != null && c.timeItems && (c.timeItems = c.timeItems.filter((l) => l.itemType !== Jn));
    let p = Qo(o, !0, !0);
    return ti({ duplicateValues: !1, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: { itemType: Jn, itemValue: p } });
  } else
    return { error: Pw };
}
function oy({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, stopTime: a, event: o }) {
  if (!n)
    return { error: Ur };
  if (!uc(a))
    return { error: Ri };
  let { matchUp: s } = ft({ drawDefinition: r, event: o, matchUpId: n }), { scheduledDate: c } = os({ matchUp: s }), u = (s == null ? void 0 : s.timeItems) ?? [];
  if (u.reduce((f, h) => h.itemType === Jn || f, void 0))
    return { error: Fh };
  let d = u.filter((f) => [Hi, Dn, Gn].includes(f == null ? void 0 : f.itemType)).sort((f, h) => nn(f.itemValue, c) - nn(h.itemValue, c)), p = d[d.length - 1], l = p && p.itemType === Gn, m = d.filter((f) => !l || f.createdAt !== p.createdAt).map((f) => nn(f.itemValue, c)).reduce((f, h) => !f || h > f ? h : f, void 0);
  if (nn(a, c) > m) {
    if (s != null && s.timeItems && l) {
      let h = p.createdAt;
      s.timeItems = s.timeItems.filter((g) => g.createdAt !== h);
    }
    let f = { itemValue: Qo(a, !0, !0), itemType: Gn };
    return ti({ duplicateValues: !0, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, timeItem: f });
  } else
    return { error: Dw };
}
function sy({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, resumeTime: n, matchUpId: a, event: o }) {
  if (!a)
    return { error: Ur };
  if (!uc(n))
    return { error: Ri };
  let { matchUp: s } = ft({ drawDefinition: r, event: o, matchUpId: a }), { scheduledDate: c } = os({ matchUp: s }), u = (s == null ? void 0 : s.timeItems) ?? [];
  if (u.reduce((f, h) => h.itemType === Jn || f, void 0))
    return { error: Fh };
  let d = u.filter((f) => [Hi, Dn, Gn].includes(f == null ? void 0 : f.itemType)).sort((f, h) => nn(f.itemValue, c) - nn(h.itemValue, c)), p = d[d.length - 1], l = p && p.itemType === Dn, m = d.filter((f) => !l || f.createdAt !== p.createdAt).map((f) => nn(f.itemValue, c)).reduce((f, h) => !f || h > f ? h : f, void 0);
  if (nn(n, c) > m) {
    if (s != null && s.timeItems && l) {
      let h = p.createdAt;
      s.timeItems = s.timeItems.filter((g) => g.createdAt !== h);
    }
    let f = { itemValue: Qo(n, !0, !0), itemType: Dn };
    return ti({ duplicateValues: !0, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: f });
  } else
    return { error: sC };
}
function eV({ drawDefinition: e, matchUpStatus: t, matchUpsMap: r, winningSide: i, dualMatchUp: n, tieFormat: a, structure: o, matchUp: s, event: c, score: u }) {
  var l;
  let d = ce(n, void 0, !0);
  for (let m of (d == null ? void 0 : d.tieMatchUps) || [])
    m.matchUpId === s.matchUpId && (m.winningSide = i, m.score = u, !jt({ score: u }) && !t ? Object.assign(m, { ...Hp }) : t && (m.matchUpStatus = t));
  a = a ?? ((l = Ir({ matchUp: s, structure: o, drawDefinition: e, event: c })) == null ? void 0 : l.tieFormat);
  let { winningSide: p } = gd({ matchUp: d, drawDefinition: e, matchUpsMap: r, structure: o, tieFormat: a, event: c });
  return { projectedWinningSide: p };
}
function tV(e) {
  var D;
  let { tournamentRecord: t, inContextMatchUp: r, structure: i, drawDefinition: n } = e, a = r.roundNumber, o = r.sides.find((w) => w.sideNumber === r.winningSide), s = r.sides.find((w) => w.sideNumber !== r.winningSide), { drawPosition: c, participantId: u } = o, { drawPosition: d, participantId: p } = s, l = "swapWinnerLoser", { matchUps: m } = Ke(e), f = m.filter(({ drawPositions: w, roundNumber: v }) => (w == null ? void 0 : w.includes(c)) && v > a);
  oi({ changeWinner: !0 }) && console.log({ existingWinnerSubsequentMatchUps: f }), f.forEach((w) => {
    var v, P;
    w.drawPositions = ((v = w.drawPositions) == null ? void 0 : v.map((b) => b === c ? d : b)) || [], xe({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: (P = e.event) == null ? void 0 : P.eventId, context: l, drawDefinition: n, matchUp: w });
  });
  let { stage: h, stageSequence: g } = i, I = n.structures.filter(({ stage: w, stageSequence: v }) => w === h && v > g).map(({ structureId: w }) => w), { targetLinks: { loserTargetLink: y, winnerTargetLink: U } } = e.targetData, S = [y == null ? void 0 : y.target.structureId, (D = U == null ? void 0 : U.target) == null ? void 0 : D.structureId].filter(Boolean);
  return n.structures.filter(({ stage: w, structureId: v }) => w !== h && S.includes(v)).forEach(({ stage: w, stageSequence: v, structureId: P }) => {
    I.includes(P) || I.push(P), n.structures.filter(({ stage: b, stageSequence: T }) => b === w && T > v).forEach(({ structureId: b }) => {
      I.includes(b) || I.push(b);
    });
  }), n.structures.filter(({ structureId: w }) => I.includes(w)).forEach((w) => {
    let { positionAssignments: v } = ot({ structure: w }), P = v == null ? void 0 : v.find(({ participantId: T }) => T === u), b = v == null ? void 0 : v.find(({ participantId: T }) => T === p);
    P && (P.participantId = p), b && (b.participantId = u);
  }), cn({ ...e, context: l });
}
function Ed(e) {
  var _, B, L;
  let t = "setMatchUpStatus";
  e.matchUpStatus && [Be, Et].includes(e.matchUpStatus) && (e.score = void 0);
  let { allowChangePropagation: r, disableScoreValidation: i, tournamentRecords: n, tournamentRecord: a, disableAutoCalc: o, enableAutoCalc: s, drawDefinition: c, matchUpStatus: u, winningSide: d, matchUpId: p, event: l, score: m } = e;
  if (!c)
    return { error: le };
  if (u && [Un, Zr, Gr, Rt].includes(u) && d)
    return { error: J, winningSide: d, matchUpStatus: u };
  if (![void 0, ...gD].includes(u))
    return j({ result: { error: nc }, info: "matchUpStatus does not exist", stack: "setMatchUpStatus" });
  let f = mr({ drawDefinition: c }), { matchUps: h } = Bt({ nextMatchUps: !0, tournamentRecord: a, inContext: !0, drawDefinition: c, matchUpsMap: f, event: l }), g = f.drawMatchUps.find((G) => G.matchUpId === p), I = h == null ? void 0 : h.find((G) => G.matchUpId === p);
  if (!g || !h)
    return { error: hr };
  if ((g.winningSide || d) && u === $e)
    return { context: "Cannot have Bye with winningSide", error: $d, matchUpStatus: u };
  let y = I == null ? void 0 : I.structureId, { structure: U } = ve({ drawDefinition: c, structureId: y }), S = bt(lt)(g.matchUpType), D = (_ = I == null ? void 0 : I.drawPositions) == null ? void 0 : _.filter(Boolean), w = I == null ? void 0 : I.matchUpTieId, v = Dr({ matchUpId: w || p, inContextDrawMatchUps: h, drawDefinition: c });
  Object.assign(e, { inContextDrawMatchUps: h, inContextMatchUp: I, matchUpTieId: w, matchUpsMap: f, targetData: v, structure: U, matchUp: g });
  let P = eo(e), b;
  if (S) {
    if (o)
      Ve({ extension: { name: Lo, value: !0 }, element: g });
    else if (s) {
      let G = g.winningSide, { winningSide: $, scoreStringSide1: W, scoreStringSide2: q, set: K } = gd({ drawDefinition: c, matchUpsMap: f, structure: U, matchUp: g, event: l }), z = { scoreStringSide1: W, scoreStringSide2: q, sets: K ? [K] : [] };
      if (b = $ !== G, P && b)
        return j({ stack: "winningSideWithDownstreamDependencies", result: { error: Yl }, context: { winningSide: d, matchUp: g } });
      Sr({ name: Lo, element: g }), Object.assign(e, { winningSide: $, dualWinningSideChange: b, projectedWinningSide: $, score: z });
    }
    Id({ tournamentId: a == null ? void 0 : a.tournamentId, inContextDualMatchUp: I, eventId: l == null ? void 0 : l.eventId, dualMatchUp: g, drawDefinition: c });
  }
  if (S && u && [Xo].includes(u))
    return { info: "Not supported for matchUpType: TEAM", error: J };
  if (m && !S && !i) {
    let G = g.matchUpFormat ?? (U == null ? void 0 : U.matchUpFormat) ?? (c == null ? void 0 : c.matchUpFormat) ?? (l == null ? void 0 : l.matchUpFormat), $ = iU({ existingMatchUpStatus: g.matchUpStatus, matchUpFormat: G, matchUpStatus: u, winningSide: d, score: m });
    if ($.error)
      return $;
  }
  let T = ((B = je({ policyTypes: [au, yi], tournamentRecord: a, drawDefinition: c, event: l })) == null ? void 0 : B.appliedPolicies) ?? {};
  Le(e.policyDefinitions) && Object.assign(T, e.policyDefinitions);
  let R = iV({ assignedDrawPositions: D, inContextMatchUp: I, appliedPolicies: T, drawDefinition: c, matchUpStatus: u, structure: U, matchUp: g });
  if (R != null && R.error)
    return R;
  let M = (I == null ? void 0 : I.stage) === ge && I.finishingRound === 1, E = M && d, C = M && g.winningSide && !d && (!e.matchUpStatus || e.matchUpStatus && Vf({ matchUpStatus: e.matchUpStatus })) && (!e.outcome || !jt({ outcome: e.outcome })), A = E && d !== g.winningSide && g.winningSide;
  if (Object.assign(e, { qualifierAdvancing: E, qualifierChanging: A, removingQualifier: C, appliedPolicies: T }), w) {
    let { matchUp: G } = ft({ matchUpId: w, inContext: !0, drawDefinition: c, matchUpsMap: f, event: l });
    if (G) {
      let $ = (L = Ir({ matchUp: G, drawDefinition: c, structure: U, event: l })) == null ? void 0 : L.tieFormat, { projectedWinningSide: W } = eV({ drawDefinition: c, matchUpStatus: u, dualMatchUp: G, matchUpsMap: f, winningSide: d, tieFormat: $, structure: U, matchUp: g, event: l, score: m }), q = G.winningSide;
      b = W !== q;
      let K = G._disableAutoCalc;
      Object.assign(e, { isCollectionMatchUp: !0, dualWinningSideChange: b, projectedWinningSide: W, autoCalcDisabled: K, matchUpTieId: w, dualMatchUp: G, tieFormat: $ });
    }
  }
  let N = td({ matchUpStatus: u });
  if (!w) {
    if (P && !d && (u && Vf({ matchUpStatus: u }) || u && [Et, Lt].includes(u)))
      return { error: $d, activeDownstream: P, winningSide: d };
    if (d && d === g.winningSide && u && !N)
      return { context: "winningSide must include directing matchUpStatus", error: $d, directingMatchUpStatus: N, matchUpStatus: u };
  }
  let { schedule: O } = e;
  if (O) {
    let G = km({ disableNotice: !0, tournamentRecords: n, tournamentRecord: a, drawDefinition: c, matchUpId: p, schedule: O });
    if (G.error)
      return G;
  }
  let k = !S && !b && d && g.winningSide && g.winningSide !== d;
  if (r && k && g.roundPosition)
    return tV(e);
  let F = d && !w || e.projectedWinningSide;
  ii({ activeDownstream: P, matchUpWinner: F, method: t, winningSide: d });
  let x = !P && ZB(e) || F && rV(e) || (N || e.autoCalcDisabled) && IN(e) || { error: Ow };
  return j({ result: x, stack: t });
}
function rV(e) {
  let { matchUp: t, winningSide: r, matchUpTieId: i, dualWinningSideChange: n } = e;
  return r === t.winningSide || i && !n ? IN(e) : j({ stack: "winningSideWithDownstreamDependencies", result: { error: Yl }, context: { winningSide: r, matchUp: t } });
}
function IN(e) {
  let { tournamentRecord: t, matchUp: r, event: i } = e, n = e.isCollectionMatchUp && r.winningSide && !e.winningSide && !jt({ score: e.score }), a = e.isCollectionMatchUp ? e.matchUpStatus || n && Rt || e.winningSide && Tt || Zr : e.matchUpStatus || Tt, o = e.removeScore || [Un, Be].includes(a) && ![Zr, Gr].includes(a), s = cn({ ...e, matchUpStatus: a, removeWinningSide: n, context: "sms", removeScore: o });
  if (s.error)
    return s;
  if (e.isCollectionMatchUp) {
    let { matchUpTieId: c, drawDefinition: u, matchUpsMap: d } = e, p = na({ appliedPolicies: e.appliedPolicies, matchUpId: c, tournamentRecord: t, drawDefinition: u, matchUpsMap: d, event: i });
    if (p.error)
      return p;
    Object.assign(s, { tieMatchUpResult: p });
  }
  return s;
}
function iV({ assignedDrawPositions: e, inContextMatchUp: t, appliedPolicies: r, drawDefinition: i, matchUpStatus: n, structure: a, matchUp: o }) {
  var d, p;
  if (((d = r == null ? void 0 : r[yi]) == null ? void 0 : d.requireParticipantsForScoring) === !1)
    return { ...V };
  let s = (p = t == null ? void 0 : t.sides) == null ? void 0 : p.map((l) => l.participantId).filter(Boolean).length, c = o != null && o.sides ? [] : ot({ structureId: a == null ? void 0 : a.structureId, drawDefinition: i }).positionAssignments, u = s && s === 2 || o.collectionId && Er({ structure: a }) && s && s >= 1 || (e == null ? void 0 : e.length) === 2 && (c == null ? void 0 : c.filter((l) => e.includes(l.drawPosition)).every((l) => l.participantId));
  return n && hD.includes(n) && !u ? j({ info: "matchUpStatus requires assigned participants", context: { matchUpStatus: n, requiredParticipants: u }, result: { error: nc } }) : { ...V };
}
function UN({ tournamentRecord: e, drawDefinition: t, matchUpId: r, event: i }) {
  if (!t)
    return { error: le };
  let { matchUp: n } = ft({ drawDefinition: t, matchUpId: r, event: i });
  return (n == null ? void 0 : n.matchUpType) !== ni ? { error: jr } : Ed({ enableAutoCalc: !0, tournamentRecord: e, drawDefinition: t, matchUpId: r, event: i });
}
function yN({ drawDefinition: e, event: t, matchUpId: r }) {
  if (!e)
    return { error: le };
  if (!r)
    return { error: Ur };
  let { matchUp: i } = ft({ drawDefinition: e, event: t, matchUpId: r });
  return i ? Sr({ name: Sp, element: i }) : { error: hr };
}
function nV({ substituteParticipantId: e, existingParticipantId: t, tournamentRecord: r, drawDefinition: i, sideNumber: n, matchUpId: a, event: o }) {
  var m, f, h, g, I;
  let s = "substituteParticipant";
  if (!i)
    return { error: le };
  if (!a)
    return { error: Ur };
  if (!t || !e)
    return j({ result: { error: _t }, stack: s });
  let { matchUp: c } = ft({ drawDefinition: i, matchUpId: a, event: o });
  if (!c)
    return { error: hr };
  if (!c.collectionId)
    return j({ result: { error: jr }, stack: s });
  let u = mr({ drawDefinition: i }), { matchUps: d } = Bt({ tournamentParticipants: r == null ? void 0 : r.participants, inContext: !0, drawDefinition: i, matchUpsMap: u }), p = d == null ? void 0 : d.find((y) => y.matchUpId === a), l = (f = (m = d == null ? void 0 : d.find((y) => y.matchUpId === (p == null ? void 0 : p.matchUpTieId))) == null ? void 0 : m.sides) == null ? void 0 : f.find((y) => y.participant.individualParticipants.some(({ participantId: U }) => U === t));
  return !l || n && l.sideNumber !== n ? { error: Ji } : (I = (g = (h = l.participant) == null ? void 0 : h.individualParticipants) == null ? void 0 : g.map(Ce).filter((y) => y !== t)) != null && I.includes(e) ? ey({ newParticipantId: e, tieMatchUpId: a, existingParticipantId: t, substitution: !0, tournamentRecord: r, drawDefinition: i, event: o }) : j({ result: { error: Ji }, stack: s });
}
function SN(e) {
  return nV(e);
}
function vN({ drawDefinition: e, matchUpId: t, event: r }) {
  if (!e)
    return { error: le };
  let { matchUp: i } = ft({ drawDefinition: e, matchUpId: t, event: r });
  return Ve({ extension: { name: Lo, value: !0 }, element: i });
}
function wN(e) {
  let t = "setMatchUpFormat", r = fe(e, [{ tournamentRecord: !0 }, { [cr]: (D) => Jr({ matchUpFormat: D }), [ci]: bu, matchUpFormat: !0 }]);
  if (r.error)
    return j({ result: r, stack: t });
  let { tournamentRecord: i, drawDefinition: n, scheduledDates: a, stageSequences: o, matchUpFormat: s, structureId: c, eventType: u, matchUpId: d, eventId: p, stages: l, drawId: m, event: f, force: h } = e;
  if (a && !Array.isArray(a))
    return j({ result: { error: J, scheduledDates: a }, stack: t });
  if (u && !jl([dn, Ui], u))
    return j({ result: { error: Mn }, stack: t });
  let g = 0, I = e.structureIds || c && [c].filter(Boolean) || [], y = e.eventIds || p && [p].filter(Boolean) || [], U = e.drawIds || m && [m].filter(Boolean) || [];
  if ((c || I != null && I.length) && !n)
    return j({ result: { error: le }, stack: t });
  if (m && d && n) {
    let D = sU({ tournamentRecord: i, drawDefinition: n, matchUpFormat: s, structureIds: I, structureId: c, matchUpId: d });
    if (D.error)
      return D;
    g += 1;
  }
  let S = (D) => {
    let w = [];
    for (let v of D.structures || []) {
      if (Array.isArray(l) && !l.includes(v.stage) || Array.isArray(o) && !o.includes(v.stageSequence) || I != null && I.length && !I.includes(v.structureId))
        continue;
      I != null && I.length && v.matchUpFormat !== s && (v.matchUpFormat = s, w.push(v.structureId), g += 1);
      let P = ((h || a) && Ke({ matchUpFilters: { matchUpStatuses: [Rt] }, structure: v }).matchUps) ?? [], b = (a && Ke({ matchUpFilters: { matchUpStatuses: [Rt] }, contextFilters: { scheduledDates: a }, afterRecoveryTimes: !1, inContext: !0, structure: v }).matchUps) ?? [];
      if (P != null && P.length) {
        let T = b ? b.map(Ht) : P.map(Ht);
        for (let R of P)
          T.includes(R.matchUpId) && (R.matchUpFormat = a != null && a.length ? s : void 0, xe({ tournamentId: i == null ? void 0 : i.tournamentId, eventId: f == null ? void 0 : f.eventId, context: t, drawDefinition: D, matchUp: R }));
      }
    }
    return !w.length && D.matchUpFormat !== s && (D.matchUpFormat = s, g += 1), w;
  };
  for (let D of (i == null ? void 0 : i.events) || [])
    if (!(y != null && y.length && !y.includes(D.eventId) || u && u !== D.eventType || u === xt))
      if (Array.isArray(o) || Array.isArray(l) || I != null && I.length || U != null && U.length)
        for (let w of D.drawDefinitions || []) {
          if (Array.isArray(U) && !U.includes(w.drawId))
            continue;
          let v = S(w);
          ut({ structureIds: v, drawDefinition: w });
        }
      else
        D.matchUpFormat !== s && (D.matchUpFormat = s, g += 1);
  return g ? { ...V, modificationsCount: g } : { ...V, info: cc };
}
function cy({ inheritance: e = !0, tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n }) {
  var c, u;
  if (!r)
    return { error: le };
  let a = (c = ft({ drawDefinition: r, matchUpId: i })) == null ? void 0 : c.matchUp;
  if (!(a != null && a.tieMatchUps))
    return { error: jr };
  let o = (u = ft({ inContext: !0, drawDefinition: r, matchUpId: i, event: n })) == null ? void 0 : u.matchUp, s = 0;
  return ((a == null ? void 0 : a.sides) || []).forEach((d) => {
    d.lineUp && delete d.lineUp;
  }), ((o == null ? void 0 : o.sides) || []).forEach((d) => {
    if (s += 1, e === !1) {
      let p = o == null ? void 0 : o.tieFormat, l = d.participantId;
      p && l && ps({ drawDefinition: r, participantId: l, lineUp: [], tieFormat: p });
    }
    xe({ tournamentId: t == null ? void 0 : t.tournamentId, context: "resetMatchUpLineUps", eventId: n == null ? void 0 : n.eventId, drawDefinition: r, matchUp: a });
  }), { ...V, modificationsCount: s };
}
function PN(e) {
  let { matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n } = e;
  if (!n)
    return { sets: [] };
  let a = n.sets || [], o = bn({ winnerFirst: !1, matchUpFormat: t, matchUpStatus: r, sets: a }), s = bn({ winnerFirst: !1, reversed: !0, matchUpFormat: t, matchUpStatus: r, sets: a }), c = bn({ matchUpFormat: t, matchUpStatus: r, winningSide: i, sets: a }), u = o === c ? s : o;
  return i && (o = i === 1 ? c : u, s = i === 2 ? c : u), { score: { sets: a, scoreStringSide1: o, scoreStringSide2: s } };
}
function Cd(e) {
  var I, y;
  let t = fe(e, [{ [gn]: !0, [Rr]: !0 }]);
  if (t.error)
    return t;
  let r = wi(e);
  if (!e.drawDefinition) {
    let U = e.tournamentRecord ?? (e.tournamentId && r[e.tournamentId]);
    e.tournamentRecord || (e.tournamentRecord = U);
    let S = Cr({ eventId: e.eventId, drawId: e.drawId, tournamentRecord: U });
    if (S.error)
      return S;
    S.drawDefinition && (e.drawDefinition = S.drawDefinition), e.event = S.event;
  }
  let { disableScoreValidation: i, policyDefinitions: n, tournamentRecord: a, disableAutoCalc: o, enableAutoCalc: s, drawDefinition: c, matchUpId: u, schedule: d, event: p, notes: l } = e, m = e.matchUpFormat || ((I = e.outcome) == null ? void 0 : I.matchUpFormat), { policy: f } = lo({ policyType: yi, tournamentRecord: a, event: p }), h = e.allowChangePropagation !== void 0 && e.allowChangePropagation || (f == null ? void 0 : f.allowChangePropagation) !== void 0 && f.allowChangePropagation || void 0, { outcome: g } = e;
  if (g != null && g.winningSide && ![1, 2].includes(g.winningSide))
    return { error: Hl };
  if (m) {
    let U = sU({ tournamentRecord: a, drawDefinition: c, matchUpFormat: m, matchUpId: u, event: p });
    if (U.error)
      return U;
  }
  if ((y = g == null ? void 0 : g.score) != null && y.sets && !g.score.scoreStringSide1) {
    let { score: U } = PN(g);
    g.score = U, g.score.sets = g.score.sets.filter((S) => S.side1Score || S.side2Score || S.side1TiebreakScore || S.side2TiebreakScore);
  }
  return Ed({ matchUpStatusCodes: g == null ? void 0 : g.matchUpStatusCodes, matchUpStatus: g == null ? void 0 : g.matchUpStatus, winningSide: g == null ? void 0 : g.winningSide, allowChangePropagation: h, disableScoreValidation: i, score: g == null ? void 0 : g.score, tournamentRecords: r, policyDefinitions: n, tournamentRecord: a, disableAutoCalc: o, enableAutoCalc: s, drawDefinition: c, matchUpFormat: m, matchUpId: u, schedule: d, event: p, notes: l });
}
function DN(e) {
  if (!(e != null && e.outcomes))
    return { error: Ie };
  if (!Array.isArray(e.outcomes))
    return { error: Ie, info: { outcomes: e.outcomes } };
  let t = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {}, r = e.outcomes ?? [], i = r.reduce((n, a) => n.includes(a.tournamentId) ? n : n.concat(a.tournamentId), []);
  for (let n of i) {
    let a = t[n];
    if (!a)
      return { error: ae };
    let o = r.filter((s) => s.tournamentId === n);
    if (o.length) {
      let s = aV({ outcomes: o, tournamentRecord: a });
      if (s.error)
        return s;
    }
  }
  return { ...V };
}
function aV(e) {
  var o;
  let { tournamentRecords: t, tournamentRecord: r, outcomes: i, policyDefinitions: n } = e, a = {};
  i.forEach((s) => {
    let { eventId: c } = s;
    a[c] || (a[c] = []), a[c].push(s);
  });
  for (let s of Object.keys(a)) {
    let { event: c } = Cr({ tournamentRecord: r, eventId: s });
    for (let u of a[s]) {
      let { drawId: d } = u, p = (o = c == null ? void 0 : c.drawDefinitions) == null ? void 0 : o.find((l) => l.drawId === d);
      if (p && d) {
        let { matchUpFormat: l, matchUpId: m } = u, f = Cd({ schedule: u == null ? void 0 : u.schedule, tournamentRecords: t, policyDefinitions: n, tournamentRecord: r, drawDefinition: p, matchUpFormat: l, matchUpId: m, outcome: u, drawId: d, event: c });
        if (f.error)
          return f;
      }
    }
  }
  return { ...V };
}
function oV({ drawDefinition: e, matchUpId: t, outcome: r, matchUp: i }) {
  var n, a;
  if (!i && !e)
    return { error: le };
  if (!r)
    return { error: Ie, info: "missing outcome" };
  if (!i && !t)
    return { error: Vr };
  if (!i) {
    let o = ft({ drawDefinition: e, matchUpId: t });
    if (o.error)
      return o;
    i = o.matchUp;
  }
  return typeof r != "object" || !((n = r.score) != null && n.scoreStringSide1) || !((a = r.score) != null && a.scoreStringSide2) ? { error: J } : Ve({ element: i, extension: { name: Sp, value: r } });
}
function TN(e) {
  return oV(e);
}
function uy(e) {
  var h, g;
  let t = "resetTieFormat", { drawDefinition: r, event: i, uuids: n } = e, a = fe(e, [{ [Gt]: !0, [gn]: !0 }], t);
  if (a.error)
    return a;
  let o = bc(e, [{ [lc]: Fn }]);
  if (o[ki])
    return o;
  let s = (h = e.tournamentRecord) == null ? void 0 : h.tournamentId, { matchUp: c, structure: u } = (o == null ? void 0 : o.matchUp) ?? {};
  if (!(c != null && c.tieMatchUps))
    return j({ result: { error: jr }, info: "Must be a TEAM matchUp", stack: t });
  if (!c.tieFormat)
    return { ...V };
  let d = (g = Ir({ structure: u, drawDefinition: r, event: i })) == null ? void 0 : g.tieFormat;
  if (!d)
    return j({ result: { error: Zt }, info: "No inherited tieFormat", stack: t });
  let p = [], l = [], m = [], f = [];
  for (let I of d.collectionDefinitions) {
    let { matchUpCount: y, collectionId: U } = I;
    l.push(U);
    let S = (c.tieMatchUps || []).filter((D) => D.collectionId === U);
    if (S.length > y)
      S.sort((D, w) => (D.matchUpStatus === Rt ? 1 : 0) - (w.matchUpStatus === Rt ? 1 : 0)), m.push(...S.slice(0, y)), p.push(...S.slice(3).map(Ht));
    else if (m.push(...S), S.length < y) {
      let D = y - S.length, w = fd({ collectionDefinition: I, matchUpsLimit: D, matchUp: c, uuids: n });
      f.push(...w);
    }
  }
  for (let I of (c == null ? void 0 : c.tieMatchUps) || [])
    I.collectionId && !l.includes(I.collectionId) && p.push(I.matchUpId);
  return f.length && (m.push(...f), ya({ eventId: i == null ? void 0 : i.eventId, matchUps: f, drawDefinition: r, tournamentId: s })), p.length && ta({ matchUpIds: p, eventId: i == null ? void 0 : i.eventId, drawDefinition: r, tournamentId: s }), c && (c.tieMatchUps = m, c.tieFormatId = void 0, c.tieFormat = void 0, xe({ structureId: u == null ? void 0 : u.structureId, eventId: i == null ? void 0 : i.eventId, context: t, drawDefinition: r, tournamentId: s, matchUp: c })), { ...V, newMatchUps: f, deletedMatchUpIds: p };
}
function dy(e) {
  var h, g, I;
  let { tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n } = e, a = "resetScorecard";
  if (!r)
    return j({ result: { error: le }, stack: a });
  if (!i)
    return j({ result: { error: Ur }, stack: a });
  if (!ht(i))
    return j({ result: { error: J, matchUpId: i }, stack: a });
  let o = mr({ drawDefinition: r }), { matchUps: s } = Bt({ nextMatchUps: !0, inContext: !0, drawDefinition: r, matchUpsMap: o }), c = o.drawMatchUps.find((y) => y.matchUpId === i), u = s == null ? void 0 : s.find((y) => y.matchUpId === i);
  if (!c || !s)
    return { error: hr };
  if (c.matchUpType !== Xr)
    return { error: jr };
  let d = Dr({ inContextDrawMatchUps: s, drawDefinition: r, matchUpId: i }), p = u == null ? void 0 : u.structureId, { structure: l } = ve({ drawDefinition: r, structureId: p });
  if (Object.assign(e, { inContextDrawMatchUps: s, inContextMatchUp: u, matchUpsMap: o, targetData: d, structure: l, matchUp: c }), eo(e))
    return { error: Yl };
  if ((h = c.tieMatchUps) != null && h.length)
    for (let y of c.tieMatchUps) {
      let U = Ed({ matchUpId: y.matchUpId, matchUpTieId: i, winningSide: void 0, removeScore: !0, tournamentRecord: t, drawDefinition: r, event: n });
      if (U.error)
        return j({ result: U, stack: a });
    }
  let m = (g = je({ tournamentRecord: t, drawDefinition: r, event: n })) == null ? void 0 : g.appliedPolicies, f = na({ event: e.event, removeScore: !0, tournamentRecord: t, appliedPolicies: m, drawDefinition: r, matchUpsMap: o, matchUpId: i });
  if (f.error)
    return j({ result: f, stack: a });
  if (e.tiebreakReset && !f.tieFormatRemoved) {
    let y = (I = Ir({ drawDefinition: r, structure: l, event: n })) == null ? void 0 : I.tieFormat;
    if (c.tieFormat && y) {
      let { matchUpCountDifference: U, descendantDifferences: S, ancestorDifferences: D, valueDifference: w } = Xn({ descendant: c.tieFormat, ancestor: y });
      if (S.collectionIds.length === 1 && !D.collectionIds.length && !D.groupsCount && U === 1 && w === 1) {
        let v = uy({ tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n });
        if (v.error)
          return v;
      }
    }
  }
  return { ...V };
}
function bN(e) {
  let t = fe(e, [{ [Rr]: !0, [ba]: !0 }, { [Gs]: { [xu]: !1, roundNumbers: !1 }, [tD]: "At least one must be provided", [Or]: fr }]);
  if (t.error)
    return t;
  let r = Nb(e);
  if (r.error)
    return r;
  let { matchUpIds: i } = r, n = bt(Xr)(e.event.eventType), { tournamentRecord: a, drawDefinition: o, event: s } = e;
  for (let c of i) {
    if (n) {
      let d = dy({ tiebreakReset: !0, tournamentRecord: a, drawDefinition: o, matchUpId: c, event: s });
      if (d.error || e.removeAssignments && cy({ inheritance: !1, drawDefinition: o, matchUpId: c }).error)
        return d;
    }
    let u = Ed({ winningSide: void 0, removeScore: !0, tournamentRecord: a, drawDefinition: o, matchUpId: c, event: s });
    if (u.error)
      return u;
    if (e.removeAssignments) {
      let d = ty({ ...e, matchUpId: c });
      if (d.error)
        return d;
    }
  }
  return { ...V };
}
function sV({ tournamentRecord: e, drawDefinition: t, finishingOrder: r }) {
  var y;
  if (!t)
    return { error: le };
  let i = "setOrderOfFinish";
  if (!Array.isArray(r))
    return j({ info: Xa("finishingOrder"), result: { error: J }, stack: i });
  let { completedMatchUps: n, matchUpsMap: a } = Uc({ inContext: !0, drawDefinition: t }), o = (n == null ? void 0 : n.map(Ht)) ?? [], s = r.map(Ht), { matchUpTypes: c, roundNumbers: u, structureIds: d, matchUpTieIds: p } = (n ?? []).filter(({ matchUpId: U }) => s.includes(U)).reduce((U, S) => {
    let { matchUpTieId: D, matchUpType: w, roundNumber: v, structureId: P } = S;
    return U.matchUpTypes.includes(w) || U.matchUpTypes.push(w), U.roundNumbers.includes(v) || U.roundNumbers.push(v), U.structureIds.includes(P) || U.structureIds.push(P), U.matchUpTieIds.includes(D) || U.matchUpTieIds.push(D), U;
  }, { matchUpTypes: [], roundNumbers: [], structureIds: [], matchUpTieIds: [] });
  if (c.length > 1 || p.length > 1 || u.length > 1 || d.length > 1)
    return j({ info: "matchUpType, structureId and roundNumber must be equivalent", result: { error: J }, stack: i });
  let l, m, f = {}, h = [], g = [];
  if (!r.every(({ orderOfFinish: U, matchUpId: S }) => (h.push(S), U && g.push(U), f[S] = U, l = o.includes(S), m = U === void 0 || Pe(U) && Math.floor(U) > 0, l && m)))
    return j({ result: { error: l ? J : nc }, info: !l && "matchUps must be completed" || !m && "orderOfFinish must be integer > 0 or undefined" || void 0, stack: i });
  let I = n == null ? void 0 : n.filter((U) => U.structureId === d[0] && U.roundNumber === u[0] && U.matchUpType === c[0] && U.matchUpTieId === p[0] && !h.includes(U.matchUpId));
  for (let U of I ?? []) {
    let { orderOfFinish: S } = U || {};
    if (S) {
      if (!Pe(S))
        return j({ context: { orderOfFinish: S, matchUp: U }, result: { error: J }, stack: i });
      g.push(S);
    }
  }
  if (Dv(g).length !== g.length || Math.max(...g) > g.length)
    return j({ info: "Values not unique or greater than expected number of values", result: { error: J }, stack: i });
  if (d.length) {
    let U = xp({ matchUpFilters: { matchUpIds: s }, structureId: d[0], drawDefinition: t, matchUpsMap: a });
    if (U.error)
      return j({ result: U, stack: i });
    (y = U.completedMatchUps) == null || y.forEach((S) => {
      S.orderOfFinish = f[S.matchUpId], xe({ tournamentId: e.tournamentId, context: "setOrderOfFinish", drawDefinition: t, matchUp: S });
    });
  }
  return { ...V };
}
function RN(e) {
  return sV(e);
}
function MN(e) {
  var I, y, U, S;
  let { tournamentRecord: t, drawDefinition: r, matchUpId: i, lineUps: n, event: a } = e, o = "applyLineUps", s = fe(e, [{ [Gt]: !0, [Rr]: !0, [gn]: !0 }, { lineUps: !0, [Or]: fr }], o);
  if (s.error)
    return s;
  let c = t.participants || [], u = ft({ tournamentParticipants: c, inContext: !0, drawDefinition: r, matchUpId: i });
  if (u.error)
    return u;
  if (!u.matchUp)
    return { error: hr };
  let { matchUp: d, structure: p } = u, { drawPositions: l, matchUpType: m } = d;
  if (m !== lt)
    return { error: jr };
  if (!(l != null && l.length))
    return { error: Du };
  let f = (I = Ir({ matchUp: d, drawDefinition: r, structure: p, event: a })) == null ? void 0 : I.tieFormat, h = {};
  for (let D of n) {
    if (!Array.isArray(D))
      return { error: J, lineUp: D };
    let w = {}, v = [];
    for (let M of D) {
      if (typeof M != "object")
        return { error: J, lineUpAssignment: M };
      let { participantId: E, collectionAssignments: C = [] } = M;
      if (!Array.isArray(C))
        return { error: J, collectionAssignments: C };
      let A = c.find((O) => O.participantId === E);
      if (!A)
        return { error: Dt };
      if (A.participantType !== Oe)
        return { error: Xi };
      let N = (U = (y = d.sides) == null ? void 0 : y.find((O) => {
        var k, F;
        return (F = (k = O.participant) == null ? void 0 : k.individualParticipantIds) == null ? void 0 : F.includes(E);
      })) == null ? void 0 : U.sideNumber;
      N && v.push(N);
      for (let O of C) {
        if (typeof O != "object")
          return { error: J, collectionAssignment: O };
        let { collectionId: k, collectionPosition: F } = O, x = (S = f == null ? void 0 : f.collectionDefinitions) == null ? void 0 : S.find((L) => L.collectionId === k);
        if (!x)
          return { error: J, collectionId: k };
        let _ = `${k}-${F}`;
        w[_] || (w[_] = []);
        let B = w[_].length;
        if (bt(rt)(x.matchUpType) && B || x.matchUpType === tt && B > 1)
          return { info: "Excessive collectionPosition assignments", error: J };
        w[_].push(E);
      }
    }
    let P = Object.values(w);
    for (let M of P)
      if (M.length === 2) {
        let { participant: E } = Vi({ tournamentParticipants: c, participantIds: M });
        if (!E) {
          let C = hn({ participant: { participantType: Re, participantRole: ur, individualParticipantIds: M }, pairOverride: !0, tournamentRecord: t });
          if (C.error)
            return C;
        }
      }
    let b = Qr(v), T = (b[1] || 0) > (b[2] || 0) && 1 || (b[2] || 0) > (b[1] || 0) && 2 || void 0, R = Object.keys(h).map((M) => parseInt(M));
    T && !R.includes(T) && (h[T] = D);
  }
  if (!Object.keys(h).length)
    return { error: Vh };
  if (u = ft({ drawDefinition: r, matchUpId: i }), u.error)
    return u;
  if (!u.matchUp)
    return { error: hr };
  let { matchUp: g } = u;
  g.sides || (g.sides = []);
  for (let D of [1, 2]) {
    let w = g.sides.find((P) => P.sideNumber === D), v = h[D];
    if (v)
      w ? w.lineUp = v : g.sides.push({ lineUp: v, sideNumber: D });
    else
      continue;
  }
  return xe({ tournamentId: t == null ? void 0 : t.tournamentId, context: o, drawDefinition: r, matchUp: g }), { ...V };
}
var ly = {};
Ae(ly, { anonymizeTournamentRecord: () => QN, generate: () => NN, generateEventWithDraw: () => Bm, generateOutcome: () => yy, generateOutcomeFromScoreString: () => py, generateParticipants: () => Oc, generateTournamentRecord: () => YN, modifyTournamentRecord: () => JN, mutate: () => KN });
var NN = {};
Ae(NN, { generateEventWithDraw: () => Bm, generateOutcome: () => yy, generateOutcomeFromScoreString: () => py, generateParticipants: () => Oc, generateTournamentRecord: () => YN });
function py(e) {
  let { matchUpFormat: t, matchUpStatus: r, winningSide: i, scoreString: n } = e;
  if (!n)
    return { outcome: { ...Hp, winningSide: i, matchUpStatus: r } };
  if (i && ![1, 2, void 0].includes(i))
    return { error: J, winningSide: i };
  let a = n && Al({ scoreString: n }), o = {}, s = bn({ sets: a, matchUpFormat: t }), c = bn({ sets: a, reversed: !0, matchUpFormat: t });
  return i === 2 ? (o.scoreStringSide1 = c, o.scoreStringSide2 = s) : (o.scoreStringSide1 = s, o.scoreStringSide2 = c), o.sets = Al({ scoreString: o.scoreStringSide1 }), me({ outcome: { matchUpStatus: r, winningSide: i, score: o } });
}
function my({ matchUpScheduleTimes: e, matchUpDependencies: t, allDateMatchUpIds: r, matchUp: i }) {
  var a;
  let n = (((a = t == null ? void 0 : t[i.matchUpId]) == null ? void 0 : a.matchUpIds) || []).filter((o) => r.includes(o)).filter((o) => !e[o]);
  return { dependenciesScheduled: !(n != null && n.length), remainingDependencies: n };
}
function Od({ individualParticipantProfiles: e, participantId: t }) {
  e[t] || (e[t] = { typeChangeTimeAfterRecovery: void 0, timeAfterRecovery: void 0, priorMatchUpType: void 0, potentialRecovery: {}, potentialCounted: {}, potentialBookings: {}, bookings: [], counters: {} });
}
function cV({ individualParticipantProfiles: e, recoveryValue: t, participantId: r, scheduleTime: i, drawId: n }) {
  e[r].potentialRecovery[n] || (e[r].potentialRecovery[n] = []), e[r].potentialRecovery[n].push(t), e[r].potentialBookings[n] || (e[r].potentialBookings[n] = []), e[r].potentialBookings[n].push({ timeAfterRecovery: t, scheduleTime: i });
}
function yu({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, typeChangeRecoveryMinutes: r, averageMatchUpMinutes: i = 0, matchUpNotBeforeTimes: n, matchUpDependencies: a, recoveryMinutes: o = 0, scheduleTime: s, matchUp: c }) {
  var f, h;
  let u = mt((f = c == null ? void 0 : c.schedule) == null ? void 0 : f.endTime), d = u ? Br(u, ye(o)) : Br(s, ye(i) + ye(o)), p = r && (u ? Br(mt(u), r) : Br(s, ye(i) + ye(r))), l = ((h = a == null ? void 0 : a[c.matchUpId]) == null ? void 0 : h.participantIds) || [], m = (c.roundPosition && e[c.matchUpId] || []).flat();
  l.forEach((g) => {
    Od({ individualParticipantProfiles: t, participantId: g });
    let I = t[g].priorMatchUpType !== c.matchUpType && p || d;
    m.includes(g) ? cV({ individualParticipantProfiles: t, drawId: c.drawId, recoveryValue: I, participantId: g, scheduleTime: s }) : (t[g].timeAfterRecovery = I, t[g].bookings.push({ scheduleTime: s, timeAfterRecovery: I }));
  }), Xs({ matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: n, timeAfterRecovery: d, matchUp: c });
}
function AN({ matchUpScheduleTimes: e, matchUpDependencies: t, scheduleTime: r, matchUpId: i, details: n }) {
  var d, p, l, m, f;
  let a, o = (p = (d = n.minutesMap) == null ? void 0 : d[i]) == null ? void 0 : p.recoveryMinutes, s = (((m = (l = n.minutesMap) == null ? void 0 : l[i]) == null ? void 0 : m.averageMinutes) || 0) + (o || 0), c = Br(r, s), u = ((f = t == null ? void 0 : t[i]) == null ? void 0 : f.dependentMatchUpIds) || [];
  if (u.length) {
    let h = u.reduce((g, I) => {
      let y = e[I];
      if (!y)
        return g;
      let U = { scheduleTime: y, matchUpId: I };
      return y && !g.matchUpId || _e(y) < _e(g.scheduleTime) ? U : g;
    }, {});
    h.scheduleTime && _e(c) > _e(h.scheduleTime) && (a = h);
  }
  return { scheduledDependent: a };
}
function uV(e) {
  let { sides: t, matchUpType: r } = e || {};
  return (t || []).map((i) => {
    var n;
    return r === tt && (((n = i == null ? void 0 : i.participant) == null ? void 0 : n.individualParticipants) || []) || (i == null ? void 0 : i.participant) && [i.participant] || [];
  }).flat();
}
var kd = "DO_NOT_SCHEDULE", dV = { DO_NOT_SCHEDULE: kd };
function fy({ averageMatchUpMinutes: e = 90, requestConflicts: t = {}, potentials: r = !0, personRequests: i, scheduleTime: n, scheduleDate: a, matchUp: o }) {
  let s = uV(o).map(({ person: m }) => m == null ? void 0 : m.personId);
  if (r) {
    let m = ((o == null ? void 0 : o.potentialParticipants) || []).flat().map(({ person: f }) => f == null ? void 0 : f.personId);
    s.push(...m);
  }
  let c = s.map((m) => {
    var f;
    return (f = i[m]) == null ? void 0 : f.map((h) => ({ ...h, personId: m }));
  }).filter(Boolean).flat().filter((m) => m.requestType === kd && Nn(a, m.date)), u = [], d = o == null ? void 0 : o.matchUpId, p = Ot(mt(n), be(a)), l = mt(Zh(p, e).toISOString());
  for (let m of c) {
    let { requestId: f, startTime: h, endTime: g } = m;
    (n > h && n < g || l > h && l < g) && (u.push({ matchUpId: d, request: m, scheduleTime: n }), t[f] ? (t[f].scheduleTimes.includes(n) || t[f].scheduleTimes.push(n), t[f].matchUpIds.includes(d) || t[f].matchUpIds.push(d)) : t[f] = { request: m, scheduleTimes: [n], matchUpIds: [d] });
  }
  return { conflicts: u };
}
function lh({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, matchUp: r, value: i }) {
  let { matchUpType: n } = r, { individualParticipantIds: a } = Rp(r), o = (e[r.matchUpId] || []).filter((s) => !wr(s, a)).flat();
  [...a, ...o].forEach((s) => {
    if (Od({ individualParticipantProfiles: t, participantId: s }), !t[s].potentialCounted[r.drawId]) {
      let c = t[s].counters;
      c[n] ? c[n] += i : i > 0 && (c[n] = i), c[xi] ? c[xi] += i : i > 0 && (c[xi] = i), o.includes(s) && (t[s].potentialCounted[r.drawId] = !0);
    }
  });
}
function lV({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, dateScheduledMatchUpIds: r, greatestAverageMinutes: i, dateScheduledMatchUps: n, matchUpNotBeforeTimes: a, matchUpScheduleTimes: o, matchUpDependencies: s, clearScheduleDates: c, scheduleDate: u, minutesMap: d, matchUps: p }) {
  var h, g;
  let l = [];
  r || (n = p == null ? void 0 : p.filter((I) => {
    let y = I.schedule || {}, U = I.matchUpStatus === $e;
    return U && l.push({ tournamentId: I.tournamentId, matchUpId: I.matchUpId }), !U && bd({ schedule: y }) && (!u || I.schedule.scheduledDate === u);
  }), r = n.map(Ht));
  let m = Array.isArray(c) ? c.includes(u) : c, f = m ? [] : p.filter(({ matchUpId: I }) => r.includes(I));
  for (let I of f) {
    lh({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, value: 1, matchUp: I });
    let y = (h = I.schedule) == null ? void 0 : h.scheduledTime;
    if (y) {
      o[I.matchUpId] = y;
      let U = (g = d == null ? void 0 : d[I.matchUpId]) == null ? void 0 : g.recoveryMinutes;
      yu({ individualParticipantProfiles: t, matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: a, matchUpDependencies: s, averageMatchUpMinutes: i, recoveryMinutes: U, scheduleTime: y, matchUp: I });
    }
  }
  return { dateScheduledMatchUpIds: r, byeScheduledMatchUpDetails: l, dateScheduledMatchUps: n, clearDate: m };
}
function Fm({ defaultRecoveryMinutes: e = 0, averageMatchUpMinutes: t = 90, dateScheduledMatchUps: r, tournamentRecords: i, venueIds: n = [], periodLength: a, scheduleDate: o, matchUps: s }) {
  if (typeof i != "object")
    return { error: yt };
  if (!Ti(s) && !Array.isArray(r))
    return { error: Zn };
  a = a ?? Mm({ recoveryMinutes: e, averageMatchUpMinutes: t });
  let c = Object.assign({}, ...Object.values(i).map((p) => (p.events ?? []).map((l) => {
    let { scheduleTiming: m } = $u({ tournamentRecord: p, event: l });
    return { [l.eventId]: { event: l, scheduleTiming: m } };
  })).flat()), u = { averageTimes: [{ minutes: { default: t } }], recoveryTimes: [{ minutes: { default: e } }] };
  r || (r = s == null ? void 0 : s.filter((p) => {
    let l = p.schedule;
    return bd({ schedule: l }) && (!o || p.schedule.scheduledDate === o);
  }));
  let d = r == null ? void 0 : r.filter((p) => (!n.length || n.includes(p.schedule.venueId)) && p.matchUpStatus !== $e);
  return { bookings: d == null ? void 0 : d.map(({ eventId: p, schedule: l, matchUpFormat: m }) => {
    let { event: f, scheduleTiming: h } = c[p], g = f == null ? void 0 : f.eventType, I = { ...h, defaultTiming: u, matchUpFormat: m }, { averageMinutes: y, recoveryMinutes: U } = Cp({ timingDetails: I, eventType: g }), { courtId: S, venueId: D } = l, w = mt(l.scheduledTime), v = Br(w, y);
    return { recoveryMinutes: U, averageMinutes: y, periodLength: a, startTime: w, courtId: S, endTime: v, venueId: D };
  }).filter(Boolean), relevantMatchUps: d, dateScheduledMatchUps: r };
}
function pV({ calculateStartTimeFromCourts: e = !0, remainingScheduleTimes: t, defaultRecoveryMinutes: r, averageMatchUpMinutes: i, clearScheduleDates: n, tournamentRecords: a, tournamentRecord: o, periodLength: s, scheduleDate: c, startTime: u, venueIds: d, matchUps: p, endTime: l }) {
  if (o && !a && (a = { [o.tournamentId]: o }), typeof a != "object" || !Object.keys(a).length)
    return { error: yt };
  s = s ?? Mm({ recoveryMinutes: r, averageMatchUpMinutes: i });
  let { courts: m, venues: f } = aa({ dates: [c], ignoreDisabled: !0, tournamentRecords: a }), h = (m == null ? void 0 : m.filter((D) => !d || d.includes(D.venueId))) ?? [];
  u = u ?? Zs({ courts: h, scheduleDate: c, startTime: !0 }), l = l ?? Zs({ courts: h, scheduleDate: c, endTime: !0 });
  let { bookings: g, dateScheduledMatchUps: I } = Fm({ defaultRecoveryMinutes: r, averageMatchUpMinutes: i, tournamentRecords: a, scheduleDate: c, periodLength: s, venueIds: d, matchUps: p }), y = { calculateStartTimeFromCourts: e, remainingScheduleTimes: t, averageMatchUpMinutes: i, clearScheduleDates: n, date: c, periodLength: s, startTime: u, bookings: g, endTime: l, courts: h }, { scheduleTimes: U } = QU(y), S = (d == null ? void 0 : d.length) === 1 && d[0] || (f == null ? void 0 : f.length) === 1 && f[0].venueId || void 0;
  return { dateScheduledMatchUpIds: I == null ? void 0 : I.map(ei("matchUpId")), dateScheduledMatchUps: I, scheduleTimes: U, venueId: S };
}
function mV({ scheduledRoundsDetails: e, greatestAverageMinutes: t, garmanSinglePass: r }) {
  let i = [], n = [], a, o, s, c;
  for (let u of e.filter(Boolean))
    c || (c = u.hash), (u.hash === c || r) && (n = n.concat(u.matchUpIds)), u.hash !== c && !r && (c = u.hash, i.push({ averageMinutes: s, recoveryMinutes: o, roundPeriodLength: a, matchUpIds: n }), n = u.matchUpIds), s = r ? t : u.averageMinutes, o = u.recoveryMinutes, a = u.roundPeriodLength;
  return n.length && i.push({ matchUpIds: n, roundPeriodLength: a, recoveryMinutes: o, averageMinutes: s }), { groupedRounds: i };
}
function EN({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, scheduleCompletedMatchUps: r, containedStructureIds: i, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, matchUpDependencies: o, clearScheduleDates: s, tournamentRecords: c, periodLength: u, scheduleDate: d, useGarman: p, matchUps: l, courts: m, venues: f }) {
  var U;
  let h = {}, g = [], I = [], y = [];
  for (let S of f) {
    let { rounds: D = [], venueId: w } = S, { scheduledRoundsDetails: v, greatestAverageMinutes: P, orderedMatchUpIds: b, minutesMap: T } = Dd({ scheduleCompletedMatchUps: r, containedStructureIds: i, tournamentRecords: c, periodLength: u, matchUps: l, rounds: D });
    y.push(...b ?? []);
    let { groupedRounds: R } = mV({ scheduledRoundsDetails: v, greatestAverageMinutes: P, garmanSinglePass: !0 }), M, E = [];
    p && ({ scheduleTimes: E, dateScheduledMatchUpIds: M } = pV({ averageMatchUpMinutes: (U = R[0]) == null ? void 0 : U.averageMinutes, scheduleDate: be(d), venueIds: [S.venueId], clearScheduleDates: s, tournamentRecords: c, periodLength: u, matchUps: l }));
    let C = lV({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, dateScheduledMatchUpIds: M, greatestAverageMinutes: P, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, matchUpDependencies: o, clearScheduleDates: s, scheduleDate: d, minutesMap: T, matchUps: l });
    ({ dateScheduledMatchUpIds: M } = C);
    let A = C, { byeScheduledMatchUpDetails: N, clearDate: O } = C;
    N != null && N.length && I.push(...N);
    let { matchUpsToSchedule: k, matchUpMap: F } = mm({ matchUpPotentialParticipantIds: e, scheduleCompletedMatchUps: r, dateScheduledMatchUpIds: M, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, orderedMatchUpIds: b, clearDate: O, matchUps: l }), x = m.filter((_) => _.venueId === w);
    h[w] = { previousRemainingScheduleTimes: [], courtsCount: x.length, greatestAverageMinutes: P, scheduledRoundsDetails: v, dateScheduledMatchUps: A, matchUpsToSchedule: k, scheduleTimes: E, groupedRounds: R, venueCourts: x, minutesMap: T, matchUpMap: F }, s || g.push(...M);
  }
  return { allDateScheduledByeMatchUpDetails: I, allDateScheduledMatchUpIds: g, venueScheduledRoundDetails: h, allDateMatchUpIds: y };
}
function fV(e, t) {
  let r = _e(e.scheduleTime), i = _e(e.timeAfterRecovery), n = _e(t.scheduleTime), a = _e(t.timeAfterRecovery), o = r === n || i === a, s = r > n && r < a, c = n > r && n < i, u = i > n && i < a, d = a > r && a < i;
  return me({ hasOverlap: o || s || u || c || d, startAisContained: s, endAisContained: u, startBisContained: c, endBisContained: d }, !0);
}
function hy({ individualParticipantProfiles: e, matchUpNotBeforeTimes: t, matchUpDependencies: r, scheduleTime: i, matchUp: n, details: a }) {
  var l, m, f, h, g;
  let o = (((l = r == null ? void 0 : r[n.matchUpId]) == null ? void 0 : l.participantIds) || []).flat(), s = ((f = (m = a == null ? void 0 : a.minutesMap) == null ? void 0 : m[n.matchUpId]) == null ? void 0 : f.averageMinutes) || 0, c = ((g = (h = a == null ? void 0 : a.minutesMap) == null ? void 0 : h[n.matchUpId]) == null ? void 0 : g.recoveryMinutes) || 0, u = o.every((I) => {
    var D;
    Od({ individualParticipantProfiles: e, participantId: I });
    let y = e[I];
    if (!y.timeAfterRecovery)
      return !0;
    let U = mt((D = n == null ? void 0 : n.schedule) == null ? void 0 : D.endTime), S = U ? Br(U, ye(c)) : Br(i, ye(s) + ye(c));
    return ![...Object.keys(y.potentialBookings).filter((w) => w !== n.drawId).map((w) => y.potentialBookings[w]).flat(), ...y.bookings].find((w) => fV({ scheduleTime: i, timeAfterRecovery: S }, w).hasOverlap);
  }), d = t[n.matchUpId], p = (d ? Au(Ot(d), Ot(i), !1) : 0) >= 0;
  return { enoughTime: u && p };
}
function CN({ autoSchedulingAudit: e, tournamentRecords: t }) {
  var o;
  De({ topic: jn, payload: e });
  let r = (s) => s ? Object.values(s).reduce((c, u) => c + u.length || 0, 0) : 0, i = ((e == null ? void 0 : e.schedulingProfile) || []).reduce((s, c) => s + c.venues.reduce((u, d) => u + d.rounds.length, 0), 0), n = { scheduledDatesCount: (o = e.scheduledDates) == null ? void 0 : o.length, noTimeMatchUpIdsCount: r(e == null ? void 0 : e.noTimeMatchUpIds), scheduledMatchUpIdsCount: r(e == null ? void 0 : e.scheduledMatchUpIds), overLimitMatchUpIdsCount: r(e == null ? void 0 : e.overLimitMatchUpIds), requestConflictsCount: r(e == null ? void 0 : e.requestConflicts), profileRoundsCount: i }, a = { itemType: sh, itemValue: n };
  for (let s of Object.values(t)) {
    let c = s.tournamentId;
    rp(jn) ? De({ payload: { type: sh, tournamentId: c, detail: n }, topic: jn }) : Ud({ tournamentRecord: s, timeItem: a });
  }
}
function gy({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, matchUpDailyLimits: r = {}, matchUp: i }) {
  let { enteredIndividualParticipantIds: n } = Rp(i), { matchUpId: a, matchUpType: o } = i, s = (i.roundPosition && e[a] || []).flat(), c = Te(n.concat(...s));
  return c.forEach((u) => {
    Od({ individualParticipantProfiles: t, participantId: u });
  }), { participantIdsAtLimit: c.filter((u) => {
    let d = t[u];
    if (d)
      return [o, xi].find((p) => {
        var f;
        let l = ((f = d.counters) == null ? void 0 : f[p]) || 0, m = r[p] || 0;
        return l && m && l >= m;
      });
  }), relevantParticipantIds: c };
}
function Su({ scheduleCompletedMatchUps: e = !1, scheduleByeMatchUps: t = !1, errorOnAnachronism: r = !1, checkChronology: i = !0, matchUpDependencies: n, removePriorValues: a, tournamentRecords: o, tournamentRecord: s, matchUpDetails: c, matchUpIds: u, schedule: d }) {
  var g, I, y;
  if (!s)
    return { error: ae };
  if (!c && (!u || !Array.isArray(u)))
    return { error: $o };
  if (!c && (!d || typeof d != "object"))
    return { error: Rw };
  let p, l = [], m = 0;
  if (i && !n) {
    let U = qi({ tournamentRecords: o, tournamentRecord: s });
    n = U.matchUpDependencies, p = U.matchUps;
  }
  p || (p = ((g = tr({ tournamentRecord: s })) == null ? void 0 : g.matchUps) ?? []);
  let f = p.reduce((U, S) => {
    let { matchUpId: D, drawId: w, matchUpStatus: v } = S;
    return (t || v !== $e) && (e || !Vt.includes(v)) && (U[w] ? U[w].push(D) : U[w] = [D]), U;
  }, {}), h = c == null ? void 0 : c.map((U) => U.matchUpId);
  for (let U of Object.keys(f)) {
    let { drawDefinition: S } = Oa({ tournamentRecord: s, drawId: U });
    if (!S)
      continue;
    let D = f[U].filter((v) => (u == null ? void 0 : u.includes(v)) ?? (h == null ? void 0 : h.includes(v))), w = vr({ inContext: !1, drawDefinition: S }).matchUps;
    for (let v of D) {
      let P = ((I = c == null ? void 0 : c.find((T) => T.matchUpId === v)) == null ? void 0 : I.schedule) || d, b = km({ schedule: P, matchUpDependencies: n, errorOnAnachronism: r, removePriorValues: a, inContextMatchUps: p, tournamentRecords: o, tournamentRecord: s, checkChronology: i, drawDefinition: S, drawMatchUps: w, matchUpId: v });
      if ((y = b == null ? void 0 : b.warnings) != null && y.length && l.push(...b.warnings), b != null && b.success && (m += 1), b.error)
        return b;
    }
  }
  return l.length ? { ...V, scheduled: m, warnings: l } : { ...V, scheduled: m };
}
function Fd(e) {
  var f;
  let { scheduleCompletedMatchUps: t = !1, scheduleByeMatchUps: r = !1, errorOnAnachronism: i, matchUpContextIds: n, removePriorValues: a, tournamentRecords: o, checkChronology: s, matchUpDetails: c, schedule: u } = e;
  if (e.matchUpIds && !n)
    return Su(e);
  let d = fe(e, [{ [gr]: !0 }, { [Gs]: { matchUpContextIds: !1, matchUpDetails: !1 }, [ci]: J, [Or]: fr }]);
  if (d.error)
    return d;
  if ((!c || n) && !u)
    return { error: Ie, info: "schedule is required" };
  let p = [], l = 0, { matchUpDependencies: m } = qi({ tournamentRecords: o });
  for (let h of Object.values(o)) {
    let { tournamentId: g } = h, I = n == null ? void 0 : n.filter((U) => U.tournamentId === g).map(Ht), y = c == null ? void 0 : c.filter((U) => (U == null ? void 0 : U.tournamentId) === g);
    if (I != null && I.length || y != null && y.length) {
      let U = Su({ matchUpDetails: y, scheduleCompletedMatchUps: t, scheduleByeMatchUps: r, matchUpDependencies: m, errorOnAnachronism: i, removePriorValues: a, tournamentRecords: o, tournamentRecord: h, checkChronology: s, matchUpIds: I, schedule: u });
      if ((f = U.warnings) != null && f.length && p.push(...U.warnings), U.scheduled && (l += U.scheduled), U.error)
        return U;
    }
  }
  return p.length ? { ...V, scheduled: l, warnings: p } : { ...V, scheduled: l };
}
function hV({ schedulingProfileModifications: e, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: i, dateSchedulingProfiles: n, containedStructureIds: a, matchUpDependencies: o, matchUpDailyLimits: s, clearScheduleDates: c, tournamentRecords: u, schedulingProfile: d, personRequests: p, periodLength: l, matchUps: m, courts: f, dryRun: h }) {
  var M, E, C, A, N, O, k;
  let g = {}, I = {}, y = {}, U = {}, S = {}, D = {}, w = {}, v = {}, P = {}, b = {};
  for (let F of n) {
    let x = be(F == null ? void 0 : F.scheduleDate), _ = (F == null ? void 0 : F.venues) || [], B = {}, L = {}, G = (Q, H) => {
      Q.forEach((Z) => {
        let ee = L[Z].counters;
        ee[H] ? ee[H] += 1 : ee[H] = 1, ee[xi] ? ee[xi] += 1 : ee[xi] = 1;
      });
    };
    y[x] = {}, U[x] = {}, g[x] = {}, I[x] = {}, w[x] = [], v[x] = [], P[x] = [], b[x] = [];
    let $ = {};
    m.forEach((Q) => {
      var H;
      (H = Q.schedule) != null && H.scheduledDate && Nn(x, be(Q.schedule.scheduledDate)) && Xs({ matchUpPotentialParticipantIds: B, matchUpNotBeforeTimes: $, matchUp: Q });
    });
    let { allDateScheduledByeMatchUpDetails: W, venueScheduledRoundDetails: q, allDateMatchUpIds: K } = EN({ matchUpPotentialParticipantIds: B, individualParticipantProfiles: L, scheduleCompletedMatchUps: r, containedStructureIds: a, matchUpNotBeforeTimes: $, matchUpScheduleTimes: D, matchUpDependencies: o, clearScheduleDates: c, tournamentRecords: u, useGarman: !0, periodLength: l, scheduleDate: x, matchUps: m, courts: f, venues: _ }), z = 10, Y = 0, X, re = 10;
    for (; !X; ) {
      for (let { venueId: Q } of _) {
        let H = 0, Z = q[Q];
        for (; Z.courtsCount && ((M = Z.scheduleTimes) != null && M.length) && ((E = Z.matchUpsToSchedule) != null && E.length) && H <= Z.courtsCount; ) {
          let { scheduleTime: ee, attempts: te = 0 } = Z.scheduleTimes.shift(), ne = Z.matchUpsToSchedule.find((se) => {
            var We, Ge;
            let { matchUpId: ie, matchUpType: he } = se, { participantIdsAtLimit: Ee, relevantParticipantIds: de } = gy({ matchUpPotentialParticipantIds: B, individualParticipantProfiles: L, matchUpDailyLimits: s, matchUp: se });
            if (Ee.length)
              return v[x].includes(ie) || v[x].push(ie), !1;
            let { scheduledDependent: it } = AN({ matchUpScheduleTimes: D, matchUpDependencies: o, scheduleTime: ee, matchUpId: ie, details: Z });
            if (it)
              return !1;
            let { dependenciesScheduled: qe, remainingDependencies: ar } = my({ matchUpScheduleTimes: D, matchUpDependencies: o, allDateMatchUpIds: K, matchUp: se });
            if (!qe)
              return U[x][ie] || (U[x][ie] = []), U[x][ie].push({ scheduleTime: ee, remainingDependencies: ar }), !1;
            let { enoughTime: $t } = hy({ individualParticipantProfiles: L, matchUpNotBeforeTimes: $, matchUpDependencies: o, scheduleTime: ee, details: Z, matchUp: se });
            if (!$t)
              return y[x][ie] || (y[x][ie] = []), y[x][ie].push({ scheduleTime: ee }), !1;
            let Ue = Z.greatestAverageMinutes, { conflicts: Se } = fy({ potentials: t, averageMatchUpMinutes: Ue, requestConflicts: b, personRequests: p, scheduleTime: ee, scheduleDate: x, matchUp: se });
            if (Se != null && Se.length)
              return S[x] || (S[x] = []), S[x].push(...Se), !1;
            G(de, he);
            let pe = (Ge = (We = Z.minutesMap) == null ? void 0 : We[ie]) == null ? void 0 : Ge.recoveryMinutes;
            return yu({ matchUpPotentialParticipantIds: B, individualParticipantProfiles: L, matchUpNotBeforeTimes: $, averageMatchUpMinutes: Ue, matchUpDependencies: o, recoveryMinutes: pe, scheduleTime: ee, matchUp: se }), D[ie] = ee, !0;
          });
          Z.matchUpsToSchedule = Z.matchUpsToSchedule.filter(({ matchUpId: se }) => se !== (ne == null ? void 0 : ne.matchUpId)), ne ? H += 1 : (I[x][Q] || (I[x][Q] = []), I[x][Q].push({ scheduleTime: ee, attempts: te + 1 }));
        }
        (C = Z.matchUpsToSchedule) != null && C.length && (I[x][Q] = (A = I[x][Q]) == null ? void 0 : A.filter((ee) => {
          let te = ee.attempts < z;
          return te && Z.scheduleTimes.push(ee), !te;
        })), (!((N = Z.scheduleTimes) != null && N.length) || !((O = Z.matchUpsToSchedule) != null && O.length)) && (Z.complete = !0);
      }
      Y += 1, X = _.every(({ venueId: Q }) => q[Q].complete) || Y === re;
    }
    for (let { venueId: Q } of _) {
      let H = q[Q].matchUpMap;
      Object.keys(H).forEach((Z) => {
        let ee = u[Z];
        ee && Object.keys(H[Z]).forEach((te) => {
          let { drawDefinition: ne } = Oa({ tournamentRecord: ee, drawId: te });
          ne && H[Z][te].forEach(({ matchUpId: se }) => {
            let ie = D[se];
            if (ie) {
              let he = ie.split(":").map(hi).join(":"), Ee = `${be(x)}T${he}`;
              h ? w[x].push(se) : (ka({ drawDefinition: ne, scheduledTime: Ee, matchUpId: se }).success && w[x].push(se), Q && Cc({ tournamentRecord: ee, drawDefinition: ne, matchUpId: se, venueId: Q }));
            }
          });
        });
      }), P[x] = q[Q].matchUpsToSchedule.map(Ht), g[x][Q] = q[Q].scheduleTimes.sort((Z, ee) => _e(Z.scheduleTime) - _e(ee.scheduleTime));
    }
    !h && (W != null && W.length) && Fd({ matchUpDetails: W, scheduleByeMatchUps: !0, removePriorValues: !0, tournamentRecords: u, schedule: { scheduledDate: "", scheduledTime: "", courtOrder: "", courtId: "", venueId: "" } });
    for (let Q of F.venues)
      for (let H of Q.rounds) {
        let Z = (((k = H.matchUps) == null ? void 0 : k.map(({ matchUpId: te }) => te)) || []).filter((te) => w[x].includes(te));
        H.canScheduledMatchUpIds = Z;
        let ee = Math.round(Z.length / H.matchUpsCount * 1e4) / 100;
        (ee === 1 / 0 || isNaN(ee)) && (ee = 0), H.possibleToSchedulePct = ee, H.matchUpsCount === Z.length && (H.possibleToSchedule = !0);
      }
  }
  let T = n.map(({ scheduleDate: F }) => F), R = { timeStamp: Date.now(), overLimitMatchUpIds: v, scheduledMatchUpIds: w, schedulingProfile: d, noTimeMatchUpIds: P, requestConflicts: b, scheduledDates: T };
  return CN({ tournamentRecords: u, autoSchedulingAudit: R }), { ...V, schedulingProfileModifications: e, schedulingProfileIssues: i, scheduleTimesRemaining: g, dateSchedulingProfiles: n, skippedScheduleTimes: I, recoveryTimeDeferredMatchUpIds: y, dependencyDeferredMatchUpIds: U, matchUpScheduleTimes: D, overLimitMatchUpIds: v, scheduledMatchUpIds: w, noTimeMatchUpIds: P, requestConflicts: b, scheduledDates: T };
}
function HS({ averageMinutes: e, startTime: t, endTime: r, court: i, date: n }) {
  if (!Array.isArray(i.dateAvailability))
    return { error: Ie, stack: "getEarliestCourtTime" };
  let a = Zs({ scheduleDate: n, courts: [i], startTime: !0 }), o = Zs({ scheduleDate: n, courts: [i], endTime: !0 });
  t = t || a, r = r || o;
  let s = Ad({ court: i, date: n }), { timeSlots: c } = Ac({ courtDate: s }), u = Ot(t), d = Ot(r);
  return { earliestCourtTime: c == null ? void 0 : c.reduce((p, l) => {
    let m = Ot(l.startTime), f = Ot(l.endTime);
    if (m > d || f < u)
      return p;
    let h = u > m ? u : m;
    if (Au(h, f) >= e) {
      let g = mt(h.toISOString());
      (!p || g < p) && (p = g);
    }
    return p;
  }, void 0), courtStartTime: a, courtEndTime: o };
}
function gV({ schedulingProfileModifications: e, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: i, dateSchedulingProfiles: n, containedStructureIds: a, matchUpDependencies: o, matchUpDailyLimits: s, clearScheduleDates: c, tournamentRecords: u, periodLength: d = 30, schedulingProfile: p, personRequests: l, matchUps: m = [], courts: f, dryRun: h }) {
  var R, M;
  let g = {}, I = {}, y = {}, U = {}, S = {}, D = {}, w = {}, v = {}, P = {};
  for (let E of n ?? []) {
    let C = be(E == null ? void 0 : E.scheduleDate), A = (E == null ? void 0 : E.venues) || [], N = {}, O = {}, k = (Q, H) => {
      Q.forEach((Z) => {
        let ee = O[Z].counters;
        ee[H] ? ee[H] += 1 : ee[H] = 1, ee[xi] ? ee[xi] += 1 : ee[xi] = 1;
      });
    };
    g[C] = {}, I[C] = {}, D[C] = [], w[C] = [], v[C] = [], P[C] = [];
    let F = {};
    m == null || m.forEach((Q) => {
      var H;
      (H = Q.schedule) != null && H.scheduledDate && Nn(C, be(Q.schedule.scheduledDate)) && Xs({ matchUpPotentialParticipantIds: N, matchUpNotBeforeTimes: F, matchUp: Q });
    });
    let { allDateScheduledByeMatchUpDetails: x, allDateScheduledMatchUpIds: _, venueScheduledRoundDetails: B, allDateMatchUpIds: L } = EN({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: O, scheduleCompletedMatchUps: r, containedStructureIds: a, matchUpNotBeforeTimes: F, matchUpScheduleTimes: S, matchUpDependencies: o, clearScheduleDates: c, tournamentRecords: u, periodLength: d, scheduleDate: C, matchUps: m, courts: f, venues: A }), G = m == null ? void 0 : m.filter(({ matchUpId: Q }) => _.includes(Q)), { bookings: $ } = Fm({ dateScheduledMatchUps: G, tournamentRecords: u, scheduleDate: C, periodLength: d }), { virtualCourts: W } = Rm({ scheduleDate: C, periodLength: d, bookings: $, courts: f }), q = W == null ? void 0 : W.reduce((Q, H) => {
      let { earliestCourtTime: Z, courtEndTime: ee } = HS({ date: C, averageMinutes: 0, court: H });
      return (!Q.startTime || Ot(Z) < Ot(Q.startTime)) && (Q.startTime = Z), (!Q.endTime || Ot(ee) > Ot(Q.endTime)) && (Q.endTime = ee), Q;
    }, {}), K = q.startTime, z = ({ courtId: Q, booking: H }) => {
      var Z;
      return (Z = W == null ? void 0 : W.find((ee) => ee.courtId === Q)) == null ? void 0 : Z.dateAvailability[0].bookings.push(H);
    }, Y = 10, X = 0, re;
    for (; !re; ) {
      for (let { venueId: Q } of A) {
        let H = B[Q], Z = H.matchUpsToSchedule.length, ee = [], te = [], ne, se = 0;
        for (; !ne; ) {
          for (let ie of H.matchUpsToSchedule) {
            if (te.length === H.courtsCount || ee.length === H.courtsCount) {
              ne = !0;
              break;
            }
            let { matchUpId: he, matchUpType: Ee } = ie, { participantIdsAtLimit: de, relevantParticipantIds: it } = gy({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: O, matchUpDailyLimits: s, matchUp: ie });
            if (de.length) {
              w[C].includes(he) || w[C].push(he);
              continue;
            }
            let { dependenciesScheduled: qe, remainingDependencies: ar } = my({ matchUpScheduleTimes: S, matchUpDependencies: o, allDateMatchUpIds: L, matchUp: ie });
            if (!qe) {
              I[C][he] || (I[C][he] = []), I[C][he].push({ remainingDependencies: ar });
              continue;
            }
            let $t = [], Ue = W == null ? void 0 : W.reduce((Se, pe) => {
              var Ct, Mt, Ye, He;
              if (te.includes(pe.courtId))
                return Se;
              let { earliestCourtTime: We } = HS({ averageMinutes: H.greatestAverageMinutes, startTime: K, date: C, court: pe });
              if (Se.scheduleTime && _e(We) >= _e(Se.scheduleTime))
                return Se;
              let { scheduledDependent: Ge } = AN({ matchUpScheduleTimes: S, matchUpDependencies: o, scheduleTime: We, matchUpId: he, details: H });
              if (Ge)
                return Se;
              let { enoughTime: nt } = hy({ individualParticipantProfiles: O, matchUpNotBeforeTimes: F, matchUpDependencies: o, scheduleTime: We, details: H, matchUp: ie });
              if (!nt)
                return g[C][he] || (g[C][he] = []), g[C][he].includes(We) || g[C][he].push(We), Se;
              let Ze = ((Mt = (Ct = H.minutesMap) == null ? void 0 : Ct[he]) == null ? void 0 : Mt.averageMinutes) || H.greatestAverageMinutes, { conflicts: st } = fy({ potentials: t, averageMatchUpMinutes: Ze, requestConflicts: P, personRequests: l, scheduleTime: We, scheduleDate: C, matchUp: ie });
              if (st != null && st.length)
                return $t.push(...st), !1;
              k(it, Ee);
              let qt = (He = (Ye = H.minutesMap) == null ? void 0 : Ye[he]) == null ? void 0 : He.recoveryMinutes;
              return yu({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: O, matchUpNotBeforeTimes: F, averageMatchUpMinutes: Ze, matchUpDependencies: o, recoveryMinutes: qt, scheduleTime: We, matchUp: ie }), (!Se.scheduleTime || _e(We) < _e(Se.scheduleTime)) && (Se.averageMatchUpMinutes = Ze, Se.recoveryMinutes = qt, Se.scheduleTime = We, Se.courtName = pe.courtName, Se.courtId = pe.courtId), Se;
            }, {});
            if (Ue.scheduleTime) {
              let { averageMatchUpMinutes: Se, recoveryMinutes: pe, scheduleTime: We, courtId: Ge } = Ue;
              S[he] = We, U[he] = Ge, ee.push(he), te.push(Ge);
              let nt = We, Ze = Br(nt, Se);
              z({ courtId: Ge, booking: { averageMatchUpMinutes: Se, recoveryMinutes: pe, periodLength: d, matchUpId: he, startTime: nt, courtId: Ge, endTime: Ze, venueId: Q } }), H.matchUpsToSchedule = H.matchUpsToSchedule.filter((st) => st.matchUpId !== he);
            } else
              $t != null && $t.length && (y[C] || (y[C] = []), y[C].push(...$t));
          }
          (te.length === H.courtsCount || ee.length === H.courtsCount || !H.matchUpsToSchedule.length) && (ne = !0), H.matchUpsToSchedule.length && ee < H.courtsCount && (Ot(K) < Ot(q.endTime) ? K = Br(K, d) : (ne = !0, H.complete = !0)), se += 1, !ne && se >= Z && (ne = !0);
        }
        (R = H.matchUpsToSchedule) != null && R.length || (H.complete = !0);
      }
      X += 1, re = A.every(({ venueId: Q }) => B[Q].complete) || X === Y;
    }
    for (let { venueId: Q } of A) {
      let H = B[Q].matchUpMap;
      Object.keys(H).forEach((Z) => {
        let ee = u[Z];
        ee && Object.keys(H[Z]).forEach((te) => {
          let { drawDefinition: ne } = Oa({ tournamentRecord: ee, drawId: te });
          ne && H[Z][te].forEach(({ matchUpId: se }) => {
            let ie = S[se], he = U[se];
            if (ie) {
              let Ee = ie.split(":").map(hi).join(":"), de = `${be(C)}T${Ee}`;
              h || (ka({ drawDefinition: ne, scheduledTime: de, matchUpId: se }), Is({ courtDayDate: C, tournamentRecords: u, tournamentRecord: ee, drawDefinition: ne, matchUpId: se, courtId: he })), D[C].push(se);
            }
          });
        });
      }), v[C] = B[Q].matchUpsToSchedule.map(Ht);
    }
    !h && (x != null && x.length) && Fd({ matchUpDetails: x, scheduleByeMatchUps: !0, removePriorValues: !0, tournamentRecords: u, schedule: { scheduledDate: "", scheduledTime: "", courtOrder: "", courtId: "", venueId: "" } });
    for (let Q of E.venues)
      for (let H of Q.rounds) {
        let Z = (M = (H.matchUps ?? []).map(({ matchUpId: te }) => te)) == null ? void 0 : M.filter((te) => D[C].includes(te));
        H.canScheduledMatchUpIds = Z;
        let ee = Math.round(((Z == null ? void 0 : Z.length) || 0) / H.matchUpsCount * 1e4) / 100;
        (ee === 1 / 0 || isNaN(ee)) && (ee = void 0), H.possibleToSchedulePct = ee, H.matchUpsCount === (Z == null ? void 0 : Z.length) && (H.possibleToSchedule = !0);
      }
  }
  let b = (n ?? []).map(({ scheduleDate: E }) => E), T = { timeStamp: Date.now(), overLimitMatchUpIds: w, scheduledMatchUpIds: D, schedulingProfile: p, noTimeMatchUpIds: v, requestConflicts: P, scheduledDates: b };
  return CN({ tournamentRecords: u, autoSchedulingAudit: T }), { ...V, schedulingProfileModifications: e, schedulingProfileIssues: i, dateSchedulingProfiles: n, recoveryTimeDeferredMatchUpIds: g, dependencyDeferredMatchUpIds: I, matchUpScheduleTimes: S, overLimitMatchUpIds: w, scheduledMatchUpIds: D, noTimeMatchUpIds: v, requestConflicts: P, scheduledDates: b };
}
function xm(e) {
  let { scheduleAttributes: t = ["scheduledDate", "scheduledTime", "courtOrder"], ignoreMatchUpStatuses: r = Vt, scheduledDates: i, venueIds: n } = e, a = wi(e), o = Le(a) ? Object.values(a).map(({ tournamentId: c }) => c).filter(Boolean) : [];
  if (!(o != null && o.length))
    return { error: yt };
  let s = 0;
  for (let c of o) {
    let u = a[c], d = IV({ ignoreMatchUpStatuses: r, scheduleAttributes: t, tournamentRecord: u, scheduledDates: i, venueIds: n });
    if (d.error)
      return d;
    s += d.clearedScheduleCount ?? 0;
  }
  return { ...V, clearedScheduleCount: s };
}
function IV({ scheduleAttributes: e = ["scheduledDate", "scheduledTime", "courtOrder"], ignoreMatchUpStatuses: t = Vt, tournamentRecord: r, scheduledDates: i, venueIds: n = [] }) {
  if (typeof r != "object")
    return { error: ae };
  if (!Array.isArray(t) || !Array.isArray(n))
    return { error: J };
  n.length && e.push("venueId");
  let a = tr({ matchUpFilters: { scheduledDates: i }, tournamentRecord: r }).matchUps ?? [], o = {};
  a.forEach(({ matchUpStatus: u, schedule: d, drawId: p, matchUpId: l }) => {
    (!u || !t.includes(u)) && bd({ schedule: d, scheduleAttributes: e }) && (!(n != null && n.length) || n.includes(d.venueId)) && (o[p] || (o[p] = []), o[p].push(l));
  });
  let s = r.tournamentId, c = 0;
  for (let u in o) {
    let { event: d, drawDefinition: p } = Cr({ tournamentRecord: r, drawId: u }), l = vr({ drawDefinition: p, matchUpFilters: { matchUpIds: o[u] } }).matchUps ?? [];
    for (let m of l) {
      let f = !1;
      m.timeItems = (m.timeItems ?? []).filter((h) => {
        let g = (h == null ? void 0 : h.itemType) && ![kn, va, rs, Ap, is, ns].includes(h == null ? void 0 : h.itemType);
        return g || (f = !0), g;
      }), f && (xe({ context: "clear schedules", eventId: d == null ? void 0 : d.eventId, drawDefinition: p, tournamentId: s, matchUp: m }), c += 1);
    }
  }
  return { ...V, clearedScheduleCount: c };
}
function Lm(e) {
  let { checkPotentialRequestConflicts: t = !0, scheduleCompletedMatchUps: r, clearScheduleDates: i, scheduleDates: n = [], tournamentRecords: a, periodLength: o, useGarman: s, dryRun: c, pro: u } = e, d = fe(e, [{ [gr]: !0 }, { [cr]: (b) => !b || Array.isArray(b) && b.every(Kr), [KP]: !1, [Or]: fr }]);
  if (d.error)
    return d;
  let p = oa({ tournamentRecords: a });
  if (p.error)
    return p;
  if (!p.schedulingProfile.length)
    return { ...V };
  let { modifications: l, issues: m = [], schedulingProfile: f = [] } = p, h = Object.assign({}, ...Object.values(a).map((b) => gc({ tournamentRecord: b }).containedStructures)), g = n.map((b) => {
    if (Kr(b))
      return be(b);
  }).filter(Boolean), I = f.map((b) => b.scheduleDate).map((b) => Kr(b) && be(b)).filter((b) => b && (!n.length || g.includes(b)));
  if (!I.length)
    return { error: iw };
  if (i && !c) {
    let b = Array.isArray(i) ? i : [];
    xm({ tournamentRecords: a, scheduledDates: b });
  }
  let y = aa({ ignoreDisabled: !1, tournamentRecords: a }).courts, { matchUps: U } = en({ matchUpFilters: { matchUpTypes: [rt, tt] }, afterRecoveryTimes: !0, nextMatchUps: !0, tournamentRecords: a }), { matchUpDependencies: S } = qi({ includeParticipantDependencies: !0, tournamentRecords: a, matchUps: U }), { matchUpDailyLimits: D } = wm({ tournamentRecords: a }), { personRequests: w } = Uo({ requestType: kd, tournamentRecords: a }), v = f.filter((b) => {
    let T = be(b == null ? void 0 : b.scheduleDate);
    return I.includes(T);
  }).sort((b, T) => new Date(b.scheduleDate).getTime() - new Date(T.scheduleDate).getTime()), P = { schedulingProfileModifications: l, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: m, dateSchedulingProfiles: v, containedStructureIds: h, matchUpDependencies: S, matchUpDailyLimits: D, clearScheduleDates: i, tournamentRecords: a, schedulingProfile: f, personRequests: w, periodLength: o, useGarman: s, matchUps: U, dryRun: c, courts: y };
  return u ? gV(P) : hV(P);
}
function _m(e) {
  let { tournamentRecord: t, tournamentRecords: r, activeTournamentId: i, ...n } = e || {};
  return n.tournamentId || (n.tournamentId = ze()), n.startDate && !$a(n.startDate) && !ol.test(n.startDate) ? { error: Qt } : n.endDate && !$a(n.endDate) && !ol.test(n.endDate) ? { error: Qt } : (n.extensions && (n.extensions = n.extensions.filter(pn)), { ...n });
}
function Iy({ addParticipants: e = !0, participantAttribute: t, tournamentRecord: r, personAttribute: i, teamNames: n, accessor: a, uuids: o }) {
  var f, h;
  if (!r)
    return { error: ae };
  let s = {}, c = (r.participants ?? []).filter(({ participantType: g, participantRole: I }) => g === Oe && I === ur), u = 0;
  for (let g of c) {
    let I = a && ((f = To({ element: g, accessor: a })) == null ? void 0 : f.value) || i && ((h = g.person) == null ? void 0 : h[i]) || t && g[t];
    if (I) {
      if (!Object.keys(s).includes(I)) {
        s[I] = { participantName: (n == null ? void 0 : n[u]) ?? I, participantId: (o == null ? void 0 : o.pop()) ?? ze(), individualParticipantIds: [], participantRole: ur, participantType: Xe };
        let y = { value: i ?? t, name: Ef };
        Ve({ element: s[I], extension: y }), u += 1;
      }
      s[I].individualParticipantIds.push(g.participantId);
    }
  }
  let d = Object.keys(s), p = (r.participants ?? []).map((g) => {
    if (g.participantType !== Xe || g.participantRole !== ur)
      return;
    let { extension: I } = Ne({ name: Ef, element: g }), y = I == null ? void 0 : I.value;
    if (d.includes(y))
      return g.participantId;
  }).filter(Boolean), l = 0, m = [];
  return Object.keys(s).forEach((g) => {
    let I = s[g], { participantId: y } = I;
    p.includes(y) || (r.participants || (r.participants = []), e && r.participants.push(I), m.push(I), l++);
  }), e && l ? (De({ payload: { tournamentId: r.tournamentId, participants: m }, topic: Ua }), { ...V, participantsAdded: l }) : m.length ? { ...V, newParticipants: m } : { error: iC };
}
var UV = [{ AA: "Annexia" }, { BA: "Bacteria" }, { BO: "Borduria" }, { BM: "Bensalem" }, { BS: "Basenji" }, { BI: "Balnibarbi" }, { BV: "Bartovia" }, { BZ: "Berzerkistan" }, { CA: "Caldonia" }, { CC: "Concordia" }, { CH: "Chula" }, { DA: "Deltora" }, { DW: "Discworld" }, { EA: "Eastasia" }, { EP: "Ecotopia" }, { ER: "Erewhon" }, { FA: "Freedonia" }, { FN: "Florin" }, { FG: "Fogg" }, { FK: "Fourecks" }, { GA: "Genovia" }, { GL: "Gilead" }, { GD: "Gilead" }, { GL: "Gondal" }, { GO: "Gondor" }, { GR: "Gruzinia" }, { GT: "Goritania" }, { GU: "Guilder" }, { HA: "Heldscalla" }, { HO: "Hidalgo" }, { IL: "Illyria" }, { KA: "Kinakuta" }, { KG: "Kangan" }, { KN: "Kreplachistan" }, { KS: "Kallipolis" }, { LH: "Lugash" }, { LI: "Listenbourg" }, { LT: "Lilliput" }, { LU: "Luggnagg" }, { LV: "Lichtenslava" }, { MR: "Moher" }, { NA: "Narnia" }, { NV: "Novaria" }, { OA: "Oceania" }, { OS: "Orsinia" }, { OV: "Octavia" }, { PA: "Palombia" }, { PG: "Penguina" }, { QA: "Qasha" }, { PM: "Panem" }, { SA: "Solymbria" }, { SD: "Syldavia" }, { SG: "San Glucose" }, { SL: "San Lorenzo" }, { SR: "Sontar" }, { SY: "Sylvania" }, { TF: "Tralfamadore" }, { TH: "Themyscira" }, { UA: "Utopia" }, { VA: "Vespugia" }, { WA: "Wakanda" }, { WX: "Wessex" }, { ZA: "Zamunda" }, { ZK: "Zubrowka" }], yV = ["Amber", "Ansul", "Atlantis", "Braavos", "Busytown", "Castle Rock", "Centralia", "Coober Pedy", "Chefchaouen", "Chronopolis", "Damanhur", "Diaspar", "Dictionopolis", "Diomira", "El Dorado", "Elista", "Ephesus", "Gotham", "Hadleyburg", "Hallstatt", "Hierusalem", "Ilium", "Inverness", "Kowloon", "Laputa", "Longyearbyen", "Lys", "Matmata", "Maycomb", "Metropolis", "Miyake-jima", "Monowi", "Nagoro", "Navarre", "New New York", "Nimbin", "Pemberley", "Pseudopolis", "Rivendell", "Roswell", "Shangri-La", "Springfield", "Supilinn", "Thneedville", "Trantor", "Wobegon", "Yonwood", "Xanadu", "Xylar", "Zion"];
function ON({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = yr(yV), i = r.slice(0, e);
  return { cities: oe(0, t).map((n) => n < Math.min(e, r.length) ? i[n] : Wr(i)) };
}
function kN({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = yr(UV), i = r.slice(0, e).map((n) => Object.keys(n)).flat();
  return { states: oe(0, t).map((n) => n < Math.min(e, r.length) ? i[n] : Wr(i)) };
}
function FN({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = oe(0, e).map(() => oe(0, 5).map(() => fi(0, 9)).join(""));
  return { postalCodes: oe(0, t).map((i) => i < e ? r[i] : Wr(r)) };
}
function kl({ idPrefix: e, participantType: t, index: r, uuids: i }) {
  let n = ht(t) ? t[0] : "X";
  return e ? `${e}-${n}-${r}` : (i == null ? void 0 : i.pop()) || ze();
}
function xN(e) {
  let { cities: t, states: r, postalCodes: i, nationalityCode: n, participantIndex: a } = e;
  return { postalCode: i == null ? void 0 : i[a], state: r == null ? void 0 : r[a], city: t == null ? void 0 : t[a], countryCode: n };
}
var SV = { lastNames: ["Abbey", "Ahern", "Ampleforth", "Ananiadis", "Andelic", "Assange", "Atreides", "Austen", "Bach", "Banks", "Barrington", "Batty", "Bauers", "Beals", "Beer", "Bennett", "Berry", "Bonaparte", "Brewer", "Brockovich", "Bukowski", "Cassidy", "Catton", "Calvino", "Carlin", "Carson", "Chip", "Constant", "Crane", "Crowne", "Cummings", "Curie", "Dallas", "Diamond", "Deckard", "Drazic", "Dunbar", "Earhart", "Eisenstein", "Eldritch", "Elliot", "Ellul", "Escher", "Eyre", "Faulkner", "Fulcher", "Fukuoka", "Godel", "Goldstein", "Greer", "Hedges", "Herbert", "Holmgren", "Humperdinck", "Huxley", "Illich", "Jeffers", "Jensen", "Jevons", "Johnson", "Johnstone", "Jovovich", "Kingsnorth", "Langer", "Fernwright", "Fuller", "Le Guin", "Lem", "Lovelace", "Mander", "McLuhan", "Midgely", "Mond", "Montoya", "Moore", "Murry", "Nagle", "Nearing", "Ogden", "Ophuls", "Parks", "Paz", "Peet", "Perfect", "Pendejo", "Pevensie", "Postman", "Ripley", "Rodda", "Rumfoord", "Runciter", "Rugen", "Sale", "Schumacher", "Shaftoe", "Shelley", "Shepard", "Smith", "Stratton", "Stewart", "Swift", "Tillich", "Turing", "Tyrell", "Twain", "Yeats", "Veblen", "Yates", "Vonnegut", "Waterhouse", "Watson", "Wolin", "Wirt", "Waschuk", "Wormwood"], firstFemale: ["Ada", "Amelia", "Amelie", "America", "Anne", "Antonia", "Aravis", "Astrid", "Beatrice", "Brienne", "Buttercup", "Caitlin", "Cimorene", "Cordelia", "Desdemona", "Ellen", "Elizabeth", "Emily", "Emmie", "Erin", "Eva", "Evelyn", "Heather", "Helen", "Hermia", "Hypatia", "Imogen", "Jane", "Jasmine", "Juliana", "Juliet", "Katniss", "Leeloo", "Lenina", "Lilith", "Linda", "Lizzie", "Louise", "Lucy", "Marie", "Mary", "Martha", "Matilda", "Milla", "Miranda", "Meg", "Melba", "Nicole", "Ola", "Portia", "Pris", "Rachael", "Rachel", "Rebecca", "River", "Rosa", "Rosalind", "Scout", "Sharn", "Susanne", "Titania", "Uhura", "Ursula", "Valentina", "Viola", "Virginia", "Xena", "Zoe"], firstMale: ["Alan", "Aldous", "August", "Axel", "Barda", "Barry", "Bill", "Bruce", "Charles", "Chris", "Constantine", "Darwin", "David", "Derrick", "Edward", "Emmanuel", "Ernst", "Estlin", "Fezzik", "Filby", "Frank", "Frito", "George", "Glen", "Helmholtz", "Inigo", "Italo", "Ivan", "Jacques", "James", "Jared", "Jerry", "Joe", "Johann", "Julian", "John Michael", "Jonathan", "Korben", "Kirkpatrick", "Kurt", "Lief", "Malachi", "Mark", "Marhsall", "Masanobu", "Maurits", "Michael", "Mustapha", "Neil", "Nikola", "Octavio", "Palmer", "Paul", "Pierre", "Robinson", "Rick", "Rincewind", "Roy", "Shannon", "Sheldon", "Stafford", "Stanislaw", "Stanley", "Syme", "Thorstein", "Thomas", "Tyrone", "Vizzini", "Walton", "Walker", "Warren", "Wendell", "Westley", "William", "Winston", "Zoran"] };
function of(e) {
  let { count: t = 100, sex: r } = e || {};
  if (!t || r && ![et, dt].includes(r))
    return { personData: [], error: J };
  let i = Math.ceil(t * 1.3), { lastNames: n, firstFemale: a, firstMale: o } = SV, s = pa.map(({ iso: h }) => h).filter(Boolean), c = Math.ceil(i / n.length), u = Math.ceil(i / a.length), d = Math.ceil(i / o.length), p = oe(0, c).flatMap(() => {
    let h = ce(n, !1, !0);
    return oe(0, n.length).map(() => zr(h));
  }), l = oe(0, u).flatMap(() => {
    let h = ce(a, !1, !0);
    return oe(0, a.length).map(() => zr(h));
  }), m = oe(0, d).flatMap(() => {
    let h = ce(o, !1, !0);
    return oe(0, o.length).map(() => zr(h));
  }), f = {};
  for (let h = 0; h < i; h++) {
    let g = p.pop(), I = r || Wr([et, dt]), y = I === et ? m.pop() : l.pop(), U = Wr(s);
    f[`${y}${g}`] = { nationalityCode: U, sex: I, firstName: y, lastName: g };
  }
  return { personData: Object.values(f).slice(0, t) };
}
function LN(e) {
  let t = (e == null ? void 0 : e.count) || 1, { personExtensions: r, consideredDate: i, isMock: n = !0, gendersCount: a, personData: o, category: s, sex: c } = e || {};
  if (isNaN(t))
    return { error: J };
  let u = (a == null ? void 0 : a[et]) || c === et && t || 0, d = (a == null ? void 0 : a[dt]) || c === dt && t || 0;
  t = Math.max(t, u + d);
  let p = t - (u + d), l = u && of({ count: u, sex: et }).personData || [], m = d && of({ count: d, sex: dt }).personData || [], f = [...l, ...m, ...p && of({ count: p }).personData || []], h = f.filter((P) => !c || u && d || P.sex === c), g = [];
  if (Array.isArray(o)) {
    let P = o.filter((b) => typeof b.firstName != "string" || typeof b.lastName != "string" || b.sex && ![et, dt].includes(b.sex) || b.nationalityCode && (typeof b.nationalityCode != "string" || b.nationalityCode.length > 3 || !pa.find(({ iso: T, ioc: R }) => [T, R].includes(b.nationalityCode))) ? !1 : (b.nationalityCode && g.push(b.nationalityCode), !0));
    if (P.length)
      h = P;
    else
      return { error: J };
  }
  let I = o ? h : yr(h);
  if (I.length < t) {
    let { maleFirstNames: P, maleLastNames: b, femaleFirstNames: T, femaleLastNames: R, nationalityCodes: M } = f.reduce((E, C) => {
      let { firstName: A, lastName: N, nationalityCode: O } = C;
      return C.sex === et ? (E.maleFirstNames.includes(A) || E.maleFirstNames.push(A), E.maleLastNames.includes(N) || E.maleLastNames.push(N)) : (E.femaleFirstNames.includes(A) || E.femaleFirstNames.push(A), E.femaleLastNames.includes(N) || E.femaleLastNames.push(N)), E.nationalityCodes.includes(O) || E.nationalityCodes.push(O), E;
    }, { maleFirstNames: [], maleLastNames: [], femaleFirstNames: [], femaleLastNames: [], nationalityCodes: [] });
    oe(0, t - I.length).forEach(() => {
      let E = c || Wr([et, dt]), C = Wr(M), A = Wr(E === et ? P : T), N = Wr(E === et ? b : R), O = { firstName: A, lastName: N, sex: E, nationalityCode: C };
      I.push(O);
    });
  }
  let { ageMinDate: y, ageMaxDate: U } = Oo({ consideredDate: i, category: s }), S = ye((y == null ? void 0 : y.slice(0, 4)) || 0) || ye((U == null ? void 0 : U.slice(0, 4)) || 0) - 3, D = ye((U == null ? void 0 : U.slice(0, 4)) || 0) || ye((y == null ? void 0 : y.slice(0, 4)) || 0) + 3, w = (y || U) && [S, D], v = I.slice(0, t).map((P, b) => {
    let [T, R] = w || [], M = w && zr(oe(T, R)), E = zr(oe(0, 365)), C = M && JC(M, E);
    return Object.assign(me({ extensions: r || [{ name: "regionCode", value: b + 1 }], birthDate: C, isMock: n }), P);
  });
  return { persons: v.length && v || I[0], nationalityCodes: g };
}
var vV = ["Ace Academy", "Avengers", "Ball Bouncers", "Baseliners", "Captivators", "Civil Disobedients", "Continentals", "Court Royal", "Court Sharks", "Diamond Dogs", "Danger Zone", "Doubles Dominators", "Double Faults", "Tricksters", "Eliminators", "Court Crusaders", "Fuzz Busters", "Game Changers", "Goal Gurus", "Good Volley", "Green Machine", "Hawk Eyes", "Inside Outers", "Killer Instinct", "Line Toers", "Masters of Mayhem", "Matter Catchers", "Cheap Shot", "Mean Machines", "Mindspace Invaders", "Net Centric", "Net Positive", "Smash Mullet", "Over Your Head", "Spin Meisters", "Aggressors", "Racket Machine", "Slice Happy", "Refs Nightmare", "Sandeaters", "Sun Seekers", "Slicer Dicers", "Stacked Deck", "Cross Stringers", "The Emergence", "Total Demolition", "Touch and Go", "Unreturnables", "Upside Downers", "Vertically Challenged", "Visual Spectacle"];
function Fl({ nameRoot: e = "TEAM", count: t = 1 } = {}) {
  let r = yr(vV).slice(0, t);
  return r.length < t && oe(0, t - r.length).forEach((i) => r.push(`${e} ${i + 1}`)), { names: r };
}
function Oc(e) {
  let { scaledParticipantsCount: t, rankingRange: r } = e, { ratingsParameters: i = Wt, valuesInstanceLimit: n, ratingsValues: a = [], consideredDate: o, categories: s, category: c, nationalityCodesCount: u, nationalityCodeType: d, nationalityCodes: p, participantsCount: l = 32, participantType: m, teamSize: f = 8, personIds: h, idPrefix: g, uuids: I, personExtensions: y, addressProps: U, gendersCount: S, matchUpType: D, personData: w, sex: v, inContext: P, withISO2: b, withIOC: T, scaleAllParticipants: R } = e, M = m === Re || D === Ga, E = m === Xe || D === Xe;
  r && (!Array.isArray(r) || !r.every((de) => St(de)) || r.length !== 2) && (r = void 0), t = R ? l : t;
  let C = 1e3, A = t && t > C ? t : C;
  r = r || [1, A], r[1] += 1;
  let N = l * (M && 2 || E && (f ?? 8) || 1), O = LN({ count: N, personExtensions: y, consideredDate: o, gendersCount: S, personData: w, category: c, sex: v });
  if (O.error)
    return O;
  let { nationalityCodes: k, persons: F } = O, x = {}, _ = {}, B = {}, L = {}, G = (de) => {
    Object.assign(x, de.doublesRankings), Object.assign(_, de.singlesRankings), Object.assign(L, de.doublesRatings), Object.assign(B, de.singlesRatings);
  };
  if (Le(c)) {
    let de = zS({ scaledParticipantsCount: t, ratingsParameters: i, participantType: m, ratingsValues: a, rankingRange: r, category: c });
    G(de);
  }
  Array.isArray(s) && s.forEach((de) => {
    let it = zS({ scaledParticipantsCount: t, ratingsParameters: i, participantType: m, ratingsValues: a, rankingRange: r, category: de });
    G(it);
  });
  let $ = pa.filter((de) => d === "IOC" && de.ioc || de.iso);
  function W(de) {
    let it = Math.ceil(N / de);
    return n && it > n ? Math.ceil(N / n) : de;
  }
  let { postalCodesProfile: q, postalCodesCount: K, statesProfile: z, citiesProfile: Y, citiesCount: X, statesCount: re } = U || {}, Q = (de) => Object.keys(de).map((it) => oe(0, z[it]).map(() => it)).flat(), H = Y && Q(Y) || (U == null ? void 0 : U.cities) || ON({ count: X || N, participantsCount: N }).cities, Z = z && Q(z) || (U == null ? void 0 : U.states) || kN({ count: re || N, participantsCount: N }).states, ee = q && Q(q) || (U == null ? void 0 : U.postalCodes) || FN({ count: K || N, participantsCount: N }).postalCodes, te = { cities: H, states: Z, postalCodes: ee }, ne = W(u), se = ne ? yr($).slice(0, u) : p && $.filter((de) => p.includes(de.iso)) || $, ie = yr(oe(0, Math.ceil(N / (ne || 1))).map(() => se).flat(1 / 0)), he = Fl({ count: l }).names;
  return { participants: oe(0, l).map((de) => {
    let it = M && 2 || E && (f ?? 8) || 1, qe = oe(0, it).map((pe) => {
      let We = de * it + pe;
      return Ee(We);
    }), ar = qe.map((pe) => pe.participantId), $t = qe.map((pe) => pe.person.standardFamilyName).join("/"), Ue = M ? Re : Xe, Se = { participantId: kl({ participantType: Ue, index: de, idPrefix: g, uuids: I }), participantName: M ? $t : he[de], participantRole: ur, individualParticipantIds: ar, participantType: Ue };
    return P && (Se.individualParticipants = qe), M || E ? [Se, ...qe] : qe;
  }).flat(), ...V };
  function Ee(de) {
    let it = F[de], { nationalityCode: qe, participantExtensions: ar, participantTimeItems: $t, extensions: Ue, firstName: Se, birthDate: pe, lastName: We, personId: Ge, sex: nt } = it || {}, Ze = Se || "GivenName", st = We || "FamilyName", qt = `${Ze} ${st}`, Ct = ie[de], Mt = (k == null ? void 0 : k.length) && qe || Ct && (d === "IOC" ? Ct.ioc || Ct.iso : Ct.iso || Ct.ioc) || qe;
    ie != null && ie.length && !Mt && !qe && console.log("%c Invalid Nationality Code", { participantIndex: de, country: Ct });
    let Ye = xN({ ...te, participantIndex: de, nationalityCode: Mt }), He = me({ participantId: kl({ participantType: Oe, index: de, idPrefix: g, uuids: I }), extensions: ar, timeItems: $t, participantRole: ur, participantType: Oe, participantName: qt, person: { personId: Ge || (h == null ? void 0 : h.length) && h[de] || ze(), birthDate: Kr(pe) ? pe : void 0, addresses: [Ye], standardFamilyName: st, standardGivenName: Ze, nationalityCode: Mt, extensions: Ue, sex: nt } });
    if (T && Mt) {
      let Je = pa.find(({ iso: Nt }) => Nt === Mt);
      Je != null && Je.ioc && (He.person.iocNationalityCode = Je.ioc), Je != null && Je.label && (He.person.countryName = Je.label);
    }
    if (b && Mt) {
      let Je = pa.find(({ iso: Nt }) => Nt === Mt);
      Je != null && Je.iso2 && (He.person.iso2NationalityCode = Je.iso2), Je != null && Je.label && (He.person.countryName = Je.label);
    }
    let rr = (Je) => {
      var Me, or, Fe, ct;
      let Nt = Je.categoryName || Je.ratingType || Je.ageCategoryCode, Wi = (Me = _[Nt]) == null ? void 0 : Me[de], Kt = (or = x[Nt]) == null ? void 0 : or[de];
      Bd({ scaleValue: Wi, eventType: ko, scaleType: ha, participant: He, category: Je }), Bd({ scaleValue: Kt, eventType: qn, scaleType: ha, participant: He, category: Je });
      let At = (Fe = B[Nt]) == null ? void 0 : Fe[de], kr = (ct = L[Nt]) == null ? void 0 : ct[de];
      Bd({ scaleValue: At, eventType: ko, scaleType: la, participant: He, category: Je }), Bd({ scaleValue: kr, eventType: qn, scaleType: la, participant: He, category: Je });
    };
    return Array.isArray(s) ? s.forEach((Je) => rr(Je)) : c && rr(c), He;
  }
}
function Bd({ scaleValue: e, participant: t, eventType: r, scaleType: i, category: n }) {
  let a = n.categoryName || n.ratingType || n.ageCategoryCode, o = [za, i, r, a].join("."), s = { itemValue: e, itemType: o };
  a && e && (t.timeItems || (t.timeItems = []), t.timeItems.push(s));
}
function zS(e) {
  let { category: t, scaledParticipantsCount: r, ratingsParameters: i, participantType: n, ratingsValues: a = [] } = e, o = t.rankingRange || e.rankingRange || [1, 1e3], s = {}, c = {}, u = {}, d = {}, { categoryName: p, ageCategoryCode: l, ratingType: m } = t, f = t.categoryName || t.ratingType || t.ageCategoryCode;
  if ((p || l) && !m) {
    let [h, g] = o || [];
    if (c[f] = yr(oe(h, g)).slice(0, r || fi(20, 30)), [Re, Xe].includes(n)) {
      let [I, y] = o || [];
      s[f] = yr(oe(I, y)).slice(0, r || fi(20, 30));
    }
  }
  if (m && i[m]) {
    let { ratingMax: h, ratingMin: g, ratingAttributes: I } = t, y = { ...i[m], ...I || {} }, { attributes: U = {}, decimalsCount: S, accessors: D, range: w, step: v } = y, P = (E) => {
      let C = {}, A = Object.keys(E || {});
      for (let N of A) {
        let O = E[N];
        if (typeof O == "object" && O.generator) {
          let { range: k } = O, [F, x] = k.slice().sort();
          C[N] = fi(F, x);
        } else
          C[N] = O;
      }
      return C;
    }, b = w[0] > w[1] ? 2 : 0.7, [T, R] = w.slice().sort(), M = oe(0, 2e3).map(() => wv(T, R, b, v, S)).filter((E) => (!h || E <= h) && (!g || E >= g)).slice(0, r || fi(20, 30)).map((E) => D ? Object.assign({}, ...D.map((C) => ({ [C]: E })), P(U)) : E);
    u[f] = [...a, ...M], [Re, Xe].includes(n) && (d[f] = [...a, ...M]);
  }
  return { singlesRankings: c, doublesRankings: s, singlesRatings: u, doublesRatings: d };
}
function Uy(e) {
  var m, f;
  let { alternatesCount: t = 0, tieFormatName: r, drawSize: i } = e, n = 0, a = 0, o = 0, s = 0, c = {}, u = { [et]: 0, [dt]: 0, [Mr]: 0, [_a]: 0, [Zi]: 0 };
  (f = (m = Le(e.tieFormat) ? e.tieFormat : $n({ namedFormat: r })) == null ? void 0 : m.collectionDefinitions) == null || f.filter(Boolean).forEach((h) => {
    let { category: g, collectionId: I, matchUpType: y, matchUpCount: U, gender: S } = h;
    if ([et, dt].includes(S)) {
      let D = U * (y === tt ? 2 : 1);
      u[S] < D && (u[S] = D);
    } else
      S === Mr && (u[et] < U && (u[et] = U), u[dt] < U && (u[dt] = U));
    if (g) {
      let D = JSON.stringify(g);
      c[D] = g;
    }
    if (I || (h.collectionId = ze()), bt(tt)(y)) {
      let D = U;
      s += U, n = Math.max(n, D);
    }
    if (bt(rt)(y)) {
      let D = U;
      o += U, a = Math.max(a, D);
    }
  });
  let d = Object.keys(c).length ? Math.max(o, s * 2) : Math.max(a, n * 2), p = n * (i + t), l = a * (i + t);
  return { maxDoublesDraw: p, maxSinglesDraw: l, teamSize: d, genders: u };
}
function wV({ participantsProfile: e, eventProfiles: t, drawProfiles: r }) {
  let { participantsCount: i, participantType: n = Oe } = e || {}, a = i || 0, o = { [dt]: 0, [Mr]: 0, [_a]: 0, [et]: 0, [Zi]: 0 }, s = 0, c = 0, u = 0, d = 0, p = 0, l = ({ alternatesCount: f = 0, uniqueParticipants: h, tieFormatName: g, drawSize: I = 0, eventType: y, tieFormat: U, category: S, gender: D, stage: w }) => {
    let v = y === Ui, P = y === xt, b = !!(h || w === ge || S || D);
    if (P) {
      d = Math.max(d, I + f), U = typeof U == "object" ? U : $n({ namedFormat: g });
      let { teamSize: T, maxDoublesDraw: R, maxSinglesDraw: M, genders: E } = Uy({ alternatesCount: f, tieFormatName: g, tieFormat: U, drawSize: I });
      u = Math.max(u, T), c = Math.max(c, M), b || (s = Math.max(s, R)), Object.keys(E).forEach((C) => o[C] += E[C]);
    } else if (v)
      if (b) {
        let T = (I + f) * 2;
        p += T, D && (o[D] += T);
      } else
        I + f && I + f > s && (s = I + f);
    else if (b) {
      let T = I + f;
      D && (o[D] += T), p += T;
    } else
      I && I > c && (c = I + f);
  };
  if (t == null || t.forEach((f) => {
    let { tieFormatName: h, tieFormat: g, drawProfiles: I, eventType: y, category: U, gender: S } = f;
    if (I)
      for (let D of I) {
        let { tieFormatName: w, tieFormat: v } = D;
        l({ ...D, tieFormatName: w || h, tieFormat: v || g, eventType: y, category: U, gender: S });
      }
  }), Array.isArray(r))
    for (let f of r)
      l(f);
  let m = Math.max(d * u, s * 2, c);
  return s && (n = Re), (i || a) < m && (i = m), i && s && [Re, xt].includes(n) && (c && Math.floor(c / 2) > s ? i = Math.floor(c / 2) : (!c || s * 2 >= c) && (i = Math.ceil(i / 2))), i === void 0 && (i = !(t != null && t.length) && !(r != null && r.length) ? 32 : 0), i < a && (i = a), { uniqueParticipantsCount: p, participantsCount: i, largestTeamDraw: d, largestTeamSize: u, participantType: n, gendersCount: o };
}
function _N({ participantsProfile: e, tournamentRecord: t, eventProfiles: r, drawProfiles: i, startDate: n, uuids: a }) {
  if ((e == null ? void 0 : e.participantsCount) === 0)
    return { addedCount: 0, ...V };
  let { participantsCount: o, participantType: s, largestTeamDraw: c, largestTeamSize: u, gendersCount: d } = wV({ participantsProfile: e, eventProfiles: r, drawProfiles: i }), p = e == null ? void 0 : e.teamKey, l = Oc({ consideredDate: n, ...e, participantsCount: o, participantType: s, gendersCount: d, uuids: a }).participants, m = 0, f = ji({ tournamentRecord: t, participants: l });
  if (f.error)
    return f;
  if (m += f.addedCount, p) {
    let y = Iy({ tournamentRecord: t, ...p });
    if (y.error)
      return y;
  }
  let h = l.filter(({ participantType: y }) => y === Oe).map(Ce), g = e != null && e.idPrefix ? `${Xe}-${e.idPrefix}` : void 0, I = oe(0, c).map((y) => {
    let U = h.slice(y * u, (y + 1) * u), S = kl({ index: y, participantType: s, idPrefix: g, uuids: a });
    return { participantName: `Team ${y + 1}`, participantRole: ur, individualParticipantIds: U, participantType: Xe, participantId: S };
  });
  return f = ji({ participants: I, tournamentRecord: t }), f.error ? f : (m += f.addedCount, { addedCount: m, ...V });
}
function BN({ drawProfiles: e, category: t, gender: r }) {
  let i = {}, n = e == null ? void 0 : e.reduce((o, s) => {
    let { qualifyingPositions: c = 0, participantsCount: u = 0, uniqueParticipants: d, stage: p = ue, drawSize: l = 0 } = s || {};
    Object.keys(o).includes(p) || (o[p] = 0);
    let m = (u || l) - c;
    return d || r || t || p === ge ? (Object.keys(i).includes(p) || (i[p] = 0), i[p] += m) : o[p] = Math.max(o[p], m), o;
  }, {}), a = Object.keys(i);
  return a.forEach((o) => n[o] += i[o]), { stageParticipantsCount: n, uniqueParticipantsCount: i, uniqueParticipantStages: a };
}
function VN({ allUniqueParticipantIds: e, stageParticipantsCount: t, eventParticipantType: r, targetParticipants: i }) {
  let n = t[ue] || 0, a = t[ge] || 0;
  return { stageParticipants: { QUALIFYING: i == null ? void 0 : i.filter(({ participantType: o }) => o === r).filter(({ participantId: o }) => !e.includes(o)).slice(0, a), MAIN: i == null ? void 0 : i.filter(({ participantType: o }) => o === r).filter(({ participantId: o }) => !e.includes(o)).slice(a, a + n) } };
}
var PV = { [Be]: 2, [Et]: 1, [Lt]: 1, [nr]: 1, [ke]: 4 };
function yy(e) {
  let { defaultWithScorePercent: t = 2, winningSide: r } = e, { matchUpStatusProfile: i = PV, matchUpFormat: n = Oi, pointsPerMinute: a = 1, sideWeight: o = 4 } = e;
  if (!Jr({ matchUpFormat: n }))
    return { error: Th };
  if (typeof i != "object")
    return { error: J };
  if (t > 100 && (t = 100), isNaN(t) || isNaN(a) || isNaN(o))
    return { error: J };
  let s = Object.keys(i).filter((T) => Object.keys(SD).includes(T) && T !== Tt);
  if (Object.keys(s).reduce((T, R) => T + i[R], 0) > 100)
    return { error: J, matchUpStatusProfile: i };
  let c = s.reduce((T, R) => (T.pointer = T.pointer + i[R], T.valueMap.push([T.pointer, R]), T), { pointer: 0, valueMap: [] }), u = fi(1, 100), d = (c.valueMap.find((T) => u <= T[0]) ?? [100, Tt])[1], p = { sets: [], scoreStringSide1: "", side2ScoreString: "" };
  if ([Be, ke].includes(d)) {
    r = r || fi(1, 2);
    let T = { score: p, matchUpStatus: d, winningSide: r };
    if (!(d === ke && fi(1, 100) > 100 - t))
      return { outcome: T };
  } else if ([Et, Lt].includes(d))
    return { outcome: { score: p, matchUpStatus: d } };
  let l = Tr(n), { bestOf: m = 1, exactly: f, setFormat: h, finalSetFormat: g } = l ?? {}, I = [], y = fi(0, 1), U = r ? [r - 1] : [...oe(0, o).map(() => y), 1 - y], S = [nr, ke, Zr, Na].includes(d) && (zr(oe(1, f || m)) || 1), D, w = oe(1, (f ?? m) + 1);
  for (let T of w) {
    let R = T === (f ?? m), { set: M, incomplete: E, winningSideNumber: C } = DV({ setFormat: R && g || h, incomplete: S === T, pointsPerMinute: a, matchUpStatus: d, weightedRange: U, setNumber: T });
    if (I.push(M), E) {
      D = C;
      break;
    }
    if (Uu({ matchUp: { score: { sets: I }, matchUpFormat: n } }).calculatedWinningSide)
      break;
  }
  let v = Uu({ matchUp: { score: { sets: I }, matchUpFormat: n, winningSide: r } }), P = D ? r || D : v.calculatedWinningSide, { score: b } = PN({ winningSide: P, score: { sets: I }, matchUpStatus: d });
  return { outcome: { winningSide: P, matchUpStatus: d, score: b } };
}
function DV({ weightedRange: e = [0, 1], pointsPerMinute: t, matchUpStatus: r, incomplete: i, setFormat: n, setNumber: a }) {
  let o = { setNumber: a }, { setTo: s, tiebreakFormat: c, tiebreakAt: u, tiebreakSet: d, timed: p, minutes: l } = n, m = fi(0, e.length - 1), f = e[m], h;
  if (p) {
    let g = l * t, I = Math.round(g * 0.2), y = g + zr([1, -1]) * I, U = kE(y, 2), S = [U, y - U];
    f && S.reverse(), h = e[m] + 1;
    let D = S[0] > S[1] && 1 || S[1] > S[0] && 2 || 0;
    if (i) {
      let [P, b] = S;
      return Object.assign(o, { side1Score: P, side2Score: b }), Vt.includes(r) ? { set: o, incomplete: i, winningSideNumber: h } : { set: o, incomplete: i };
    }
    D || (S[fi(0, 1)] += 1), D = S[0] > S[1] ? 1 : 2, D !== h && S.reverse();
    let [w, v] = S;
    return Object.assign(o, { side1Score: w, side2Score: v, winningSide: h }), { set: o };
  } else {
    if (i)
      return o.side1Score = fi(0, u), o.side2Score = fi(0, u), Vt.includes(r) && (h = e[m] + 1), { set: o, incomplete: i, winningSideNumber: h };
    {
      let g = oe(1, s + 1).map((v) => oe(0, s + 2 - v).map(() => v)).flat(), I = g[fi(0, g.length - 1)], y = s && nU({ isSide1: !0, tiebreakAt: u, lowValue: I, setTo: s }), U = !y, S = e.length === 1 && e[m] + 1;
      if (!U) {
        S ? (y[0] > y[1] ? 1 : 2) !== S && y.reverse() : f && y.reverse();
        let [v, P] = y;
        Object.assign(o, { side1Score: v, side2Score: P });
      }
      let D = gu({ matchUpScoringFormat: { setFormat: n }, setObject: o }), w;
      if (D.hasTiebreakCondition || U) {
        let { NoAD: v, tiebreakTo: P } = c || d || {}, b = oe(1, P + 1).map((M) => oe(0, P + 2 - M).map(() => M)).flat(), T = b[fi(0, b.length - 1)], R = om({ isSide1: !0, tiebreakNoAd: v, tiebreakTo: P, lowValue: T });
        if (R)
          if (U) {
            let M = R[0] > R[1] ? 1 : 2;
            S ? M !== S && R.reverse() : f && R.reverse(), [o.side1TiebreakScore, o.side2TiebreakScore] = R, w = R[0] > R[1] && 1 || R[1] > R[0] && 2 || void 0;
          } else
            D.leadingSide === 2 ? [o.side1TiebreakScore, o.side2TiebreakScore] = R : [o.side2TiebreakScore, o.side1TiebreakScore] = R;
      }
      o.winningSide = D.winningSide || D.leadingSide || S || w;
    }
  }
  return { set: o };
}
function xl(e) {
  var I, y, U;
  let { matchUpStatusProfile: t, completeAllMatchUps: r, randomWinningSide: i, tournamentRecord: n, completionGoal: a, drawDefinition: o, event: s } = e;
  if (!o)
    return { error: le };
  let c = e.matchUpFormat || o.matchUpFormat || (s == null ? void 0 : s.matchUpFormat), u = o.structures.slice().sort(Zo), d = 0, { matchUps: p, matchUpsMap: l } = Bt({ matchUpFilters: { matchUpTypes: [lt], roundNumbers: [1] }, contextFilters: { stages: [ue, ge] }, inContext: !0, drawDefinition: o });
  if (p != null && p.length) {
    let S = ((I = s == null ? void 0 : s.category) == null ? void 0 : I.ageCategoryCode) || ((y = s == null ? void 0 : s.category) == null ? void 0 : y.categoryName);
    if (S) {
      let D = ZM({ singlesOnly: !0, tournamentRecord: n, drawDefinition: o, scaleAccessor: { scaleName: S, sortOrder: XM, scaleType: ha }, event: s });
      if (D.error)
        return D;
      let { lineUps: w, participantsToAdd: v } = D;
      ji({ tournamentRecord: n, participants: v }), Ve({ element: o, extension: { name: Yn, value: w } });
    } else {
      let D = (U = p[0]) == null ? void 0 : U.structureId, { positionAssignments: w } = ot({ drawDefinition: o, structureId: D });
      if (w != null && w.length) {
        let { participants: v } = Ut({ participantFilters: { participantTypes: [lt] }, tournamentRecord: n }), P = (b) => {
          let T = b.tieMatchUps.filter(bt(rt)), R = b.tieMatchUps.filter(bt(tt));
          T.forEach((M, E) => {
            let C = M.matchUpId;
            M.sides.forEach((A) => {
              var k;
              let { drawPosition: N } = A, O = v == null ? void 0 : v.find((F) => {
                var _;
                let { participantId: x } = F;
                return ((_ = w.find((B) => B.participantId === x)) == null ? void 0 : _.drawPosition) === N;
              });
              if (O) {
                let F = (k = O.individualParticipantIds) == null ? void 0 : k[E];
                F && Ol({ teamParticipantId: O.participantId, participantId: F, tournamentRecord: n, drawDefinition: o, tieMatchUpId: C, event: s });
              }
            });
          }), R.forEach((M, E) => {
            let C = M.matchUpId;
            M.sides.forEach((A) => {
              var k, F;
              let { drawPosition: N } = A, O = v == null ? void 0 : v.find((x) => {
                var B;
                let { participantId: _ } = x;
                return ((B = w.find((L) => L.participantId === _)) == null ? void 0 : B.drawPosition) === N;
              });
              O && ((F = (k = O.individualParticipantIds) == null ? void 0 : k.slice(E * 2, E * 2 + 2)) == null || F.forEach((x) => {
                Ol({ teamParticipantId: O.participantId, participantId: x, tournamentRecord: n, drawDefinition: o, tieMatchUpId: C, event: s });
              }));
            });
          });
        };
        p.forEach(P);
      }
    }
  }
  let m = typeof r == "string" && r, f = m && Tt, h = u.length === 2 && u[0].finishingPosition === Ha && wt(u.map(({ stage: S }) => S), [ue, vt]).length === 2, g = u.map(({ structureId: S }) => S);
  for (let S of g) {
    if (d >= a)
      break;
    let D = o.structures.find((P) => P.structureId === S), w = Ke({ contextFilters: { matchUpTypes: [tt, rt] }, afterRecoveryTimes: !1, tournamentRecord: n, inContext: !0, drawDefinition: o, matchUpsMap: l, structure: D, event: s }).matchUps;
    w.length;
    let v = w.filter(({ winningSide: P }) => !P).sort(cs).map(Ht);
    for (let P of v) {
      if (!isNaN(a) && d >= a)
        break;
      let { matchUps: b } = Ke({ matchUpFilters: { matchUpTypes: [tt, rt] }, afterRecoveryTimes: !1, tournamentRecord: n, inContext: !0, drawDefinition: o, matchUpsMap: l, structure: D, event: s }), T = b.find((M) => M.matchUpId === P), R = [Et, Lt].includes(T.matchUpStatus);
      if (T != null && T.readyToScore && !R) {
        let M = TV({ matchUpStatusProfile: t, tournamentRecord: n, drawDefinition: o, targetMatchUp: T, matchUpFormat: c, matchUpStatus: f, scoreString: m, winningSide: !i && 1, event: s });
        if (M != null && M.error)
          return M;
        d += 1;
      }
    }
    h && D.finishingPosition === Ha && e.completeRoundRobinPlayoffs && wc({ structureId: D.structureId, applyPositioning: !0, drawDefinition: o });
  }
  return { ...V, completedCount: d };
}
function jN(e) {
  let { matchUpStatusCodes: t, policyDefinitions: r, tournamentRecord: i, drawDefinition: n, targetMatchUp: a, matchUpStatus: o, matchUpFormat: s, scoreString: c, winningSide: u, event: d } = e;
  if (!a || a.matchUpStatus === $e)
    return;
  let { matchUpId: p } = a || {}, { outcome: l } = py({ matchUpFormat: s, matchUpStatus: o, scoreString: c, winningSide: u });
  return t && (l.matchUpStatusCodes = t), Cd({ tournamentRecord: i, policyDefinitions: r, drawDefinition: n, matchUpFormat: s, matchUpId: p, outcome: l, event: d });
}
function TV(e) {
  let { matchUpStatusProfile: t = {}, tournamentRecord: r, policyDefinitions: i, drawDefinition: n, matchUpStatus: a, matchUpFormat: o, targetMatchUp: s, scoreString: c, winningSide: u, event: d } = e;
  if (c || a)
    return jN(e);
  let { matchUpId: p } = s || {}, { outcome: l } = yy({ matchUpStatusProfile: t, matchUpFormat: o, winningSide: u });
  return Cd({ policyDefinitions: i, tournamentRecord: r, drawDefinition: n, matchUpFormat: o, matchUpId: p, outcome: l, event: d });
}
function GN({ matchUpStatusProfile: e, completeAllMatchUps: t, randomWinningSide: r, tournamentRecord: i, drawProfiles: n, isMock: a, event: o }) {
  var h, g, I, y;
  let s = Pt({ event: o }).flightProfile, { eventName: c, eventType: u, category: d } = o, { startDate: p } = i, l = [], m = (d == null ? void 0 : d.categoryName) || (d == null ? void 0 : d.ageCategoryCode) || (d == null ? void 0 : d.ratingType), f = (h = o.drawDefinitions) == null ? void 0 : h.map(({ drawId: U }) => U);
  if (Array.isArray(s == null ? void 0 : s.flights))
    for (let [U, S] of s.flights.entries()) {
      let { drawId: D, stage: w, drawName: v, drawEntries: P } = S;
      l.push(S.drawId);
      let b = n[U], { seedsCount: T, generate: R = !0 } = b || {};
      if (R) {
        let M = P.filter(ei(Cn)).map(ei(Cn)), E = m || c;
        if (i && T && T <= M.length && oe(1, T + 1).forEach((k, F) => {
          let x = { scaleValue: k, scaleName: E, scaleType: Pn, eventType: u, scaleDate: p }, _ = M[F];
          wd({ tournamentRecord: i, participantId: _, scaleItem: x });
        }), f == null ? void 0 : f.includes(D))
          break;
        let C = Md({ ...b, matchUpType: u, seedingScaleName: E, tournamentRecord: i, drawEntries: P, drawName: v, drawId: D, isMock: a, event: o, stage: w });
        if (C.error)
          return { error: C.error, drawIds: [] };
        let { drawDefinition: A } = C;
        if (!A)
          return { error: ai };
        let N = (g = n[U]) == null ? void 0 : g.drawExtensions;
        if (Array.isArray(N) && N.filter(pn).forEach((k) => Ve({ element: A, extension: k })), C = Nd({ suppressNotifications: !0, tournamentRecord: i, drawDefinition: A, event: o }), C.error)
          return { error: C.error, drawIds: [] };
        if (b != null && b.withPlayoffs) {
          let k = (I = A.structures) == null ? void 0 : I[0].structureId, F = Yp({ idPrefix: b.idPrefix, ...b.withPlayoffs, tournamentRecord: i, drawDefinition: A, structureId: k, isMock: a, event: o });
          if (F != null && F.error)
            return F;
        }
        let O = b == null ? void 0 : b.completionGoal;
        if ((b == null ? void 0 : b.automated) !== !1 && (t || O)) {
          let k = b == null ? void 0 : b.matchUpFormat, F = xl({ completeAllMatchUps: !O && t, matchUpStatusProfile: e, randomWinningSide: r, tournamentRecord: i, completionGoal: O, drawDefinition: A, matchUpFormat: k, event: o });
          if (F.error)
            return { error: F.error, drawIds: [] };
          let x = F.completedCount;
          if ((b == null ? void 0 : b.drawType) === En) {
            let _ = (y = A.structures) == null ? void 0 : y.find((G) => G.stage === ue);
            if (!_)
              return { error: It };
            let B = wc({ structureId: _.structureId, tournamentRecord: i, drawDefinition: A, event: o });
            if (B.error)
              return { error: B.error, drawIds: [] };
            let L = O ? O - (x ?? 0) : void 0;
            if (B = xl({ completeAllMatchUps: !O && t, completionGoal: O ? L : void 0, matchUpStatusProfile: e, randomWinningSide: r, tournamentRecord: i, drawDefinition: A, matchUpFormat: k, event: o }), B.error)
              return { error: B.error, drawIds: [] };
          }
        }
      }
    }
  return { ...V, drawIds: l };
}
function $N(e) {
  var w, v;
  let { participantsProfile: t = {}, uniqueParticipantsCount: r, ratingsParameters: i, tournamentRecord: n, eventProfile: a, eventIndex: o, event: s, uuids: c } = e, { category: u, gender: d, eventType: p } = s, l = bt(dn)(p) && Oe || bt(Ui)(p) && Re || p, m = r[ue] || 0, f = r[ge] || 0, h = (w = a.drawProfiles) != null && w.length ? m + f : ((v = a.participantsProfile) == null ? void 0 : v.participantsCount) ?? 0, g = [et, dt].includes(d) ? d : void 0, I = t != null && t.idPrefix ? `E-${o}-${t == null ? void 0 : t.idPrefix}` : void 0, { participants: y } = Oc({ uuids: a.uuids || c, ...t, scaledParticipantsCount: a.scaledParticipantsCount, consideredDate: n == null ? void 0 : n.startDate, rankingRange: a.rankingRange, participantType: l, participantsCount: h, ratingsParameters: i, category: u, idPrefix: I, sex: g }), U = ji({ tournamentRecord: n, participants: y });
  if (U.error)
    return U;
  let S = y == null ? void 0 : y.filter(({ participantType: P }) => P === l), D = y == null ? void 0 : y.map(Ce);
  return { uniqueDrawParticipants: S, uniqueParticipantIds: D };
}
function bV({ autoEntryPositions: e, tournamentRecord: t, drawParticipants: r, drawProfile: i, event: n }) {
  let { drawType: a = on, qualifyingPositions: o = 0, stage: s = ue, drawSize: c = 0, drawName: u, drawId: d } = i, p = c - o, l = r.slice(0, p).map(Ce);
  if (l.length) {
    let h = sn({ participantIds: l, autoEntryPositions: e, entryStage: s, tournamentRecord: t, event: n });
    if (h.error)
      return h;
  }
  let m = l.map((h) => ({ entryStatus: $r, entryStage: s, participantId: h })), f = bm({ drawName: u || a, qualifyingPositions: o, drawEntries: m, drawId: d, event: n, stage: s });
  return f.error ? f : { ...V };
}
function qN({ uniqueDrawParticipants: e, autoEntryPositions: t, stageParticipants: r, tournamentRecord: i, drawProfiles: n, category: a, gender: o, event: s }) {
  let c = 0;
  for (let u of n) {
    let { qualifyingPositions: d = 0, uniqueParticipants: p, stage: l = ue, drawSize: m = 0 } = u, f = m - d, h = p || o || a || l === ge, g = h ? e.slice(c, c + f) : r[l || ue] || [];
    h && (c += f);
    let I = bV({ autoEntryPositions: t, drawParticipants: g, tournamentRecord: i, drawProfile: u, event: s });
    if (I.error)
      return I;
  }
  return { ...V };
}
function WN(e) {
  var z;
  let { allUniqueParticipantIds: t, matchUpStatusProfile: r, participantsProfile: i, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, ratingsParameters: c, tournamentRecord: u, eventProfile: d, eventIndex: p, publish: l, isMock: m, uuids: f } = e, h = d.gender, g = d.eventName, { eventType: I = dn, policyDefinitions: y, drawProfiles: U = [], eventExtensions: S, surfaceCategory: D, tieFormatName: w, processCodes: v, discipline: P, eventLevel: b, timeItems: T, ballType: R, category: M } = d, E = d.eventId || ze(), C = d.tieFormat || (I === xt ? $n({ namedFormat: w, event: { eventId: E, category: M, gender: h }, hydrateCollections: o, isMock: m }) : void 0), A = u.participants;
  for (let Y of U)
    !h && Y.gender && (h = Y == null ? void 0 : Y.gender);
  let { stageParticipantsCount: N, uniqueParticipantsCount: O, uniqueParticipantStages: k } = BN({ drawProfiles: U, category: M, gender: h }), F = bt(dn)(I) && Oe || bt(Ui)(I) && Re || I, { uniqueDrawParticipants: x = [], uniqueParticipantIds: _ = [] } = k ? $N({ event: { eventType: I, category: M, gender: h }, uniqueParticipantsCount: O, participantsProfile: i, ratingsParameters: c, tournamentRecord: u, eventProfile: d, eventIndex: p, uuids: f }) : {}, { eventAttributes: B } = d;
  typeof B != "object" && (B = {});
  let L = (M == null ? void 0 : M.categoryName) || (M == null ? void 0 : M.ageCategoryCode) || (M == null ? void 0 : M.ratingType);
  g = g || L || "Generated Event";
  let G = { ...B, surfaceCategory: D, processCodes: v, discipline: P, eventLevel: b, eventName: g, eventType: I, tieFormat: C, ballType: R, category: M, eventId: E, gender: h };
  if (S != null && S.length && Array.isArray(S)) {
    let Y = S.filter(pn);
    Y != null && Y.length && Object.assign(G, { extensions: Y });
  }
  if (Array.isArray(T) && T.forEach((Y) => ms({ event: q, timeItem: Y })), typeof y == "object")
    for (let Y of Object.keys(y))
      Za({ policyDefinitions: { [Y]: y[Y] }, event: G });
  G.category && (G.category.categoryName = L);
  let $, W = Rc({ suppressNotifications: !1, internalUse: !0, tournamentRecord: u, event: G });
  if (W.error)
    return W;
  let q = W == null ? void 0 : W.event, { stageParticipants: K } = VN({ allUniqueParticipantIds: t, stageParticipantsCount: N, eventParticipantType: F, targetParticipants: A });
  if (U != null && U.length) {
    let Y = qN({ uniqueDrawParticipants: x, autoEntryPositions: a, stageParticipants: K, tournamentRecord: u, drawProfiles: U, category: M, gender: h, event: q });
    if (Y.error)
      return Y;
    let X = GN({ matchUpStatusProfile: r, completeAllMatchUps: n, randomWinningSide: s, tournamentRecord: u, drawProfiles: U, isMock: m, event: q });
    if (X.error)
      return X;
    $ = X.drawIds;
  } else if ((z = d == null ? void 0 : d.participantsProfile) != null && z.participantsCount) {
    let Y = x.map(Ce);
    if (Y.length) {
      let X = sn({ participantIds: Y, autoEntryPositions: a, tournamentRecord: u, entryStage: ue, event: q });
      if (X.error)
        return X;
    }
  }
  return l && Nc({ tournamentRecord: u, event: q }), { drawIds: $, eventId: E, uniqueParticipantIds: _ };
}
function Sy({ tournamentRecords: e, scheduleDate: t, venueId: r, round: i }) {
  if (!Kr(t))
    return { error: Qt };
  let n = "addSchedulingProfileRound", { extension: a } = Ne({ name: _o, tournamentRecords: e, discover: !0 }), o = (a == null ? void 0 : a.value) || [], s = o.find((l) => Nn(t, l.scheduleDate));
  if (!s) {
    let { startDate: l, endDate: m } = um({ tournamentRecords: e }), f = new Date(t);
    if (l && f < new Date(l) || m && f > new Date(m))
      return { error: Qt };
    s = { scheduleDate: t, venues: [] }, o.push(s);
  }
  let c = s.venues.find((l) => l.venueId === r);
  c || (c = { venueId: r, rounds: [] }, s.venues.push(c));
  let u = ["notBeforeTime"], d = (l) => Object.keys(l).filter((m) => !u.includes(m)).sort().map((m) => Le(l[m]) ? d(l[m]) : l[m]).flat().join("|");
  if (c.rounds.find((l) => d(l) === d(i)))
    return j({ result: { error: $v }, stack: n });
  c.rounds.push(i);
  let p = Tc({ tournamentRecords: e, schedulingProfile: o });
  return p.error ? p : { ...V };
}
function RV({ schedulingProfile: e, tournamentRecord: t }) {
  if (typeof e != "object")
    return { error: J };
  let r = gc({ tournamentRecord: t }).containedStructures, i = tr({ tournamentRecord: t }).matchUps ?? [], { tournamentId: n } = t, a = [];
  for (let o of e) {
    let { scheduleDate: s, venues: c = [] } = o;
    for (let u of c) {
      let { rounds: d, venueId: p } = u;
      for (let l of d) {
        let { drawId: m, winnerFinishingPositionRange: f, roundSegment: h } = l, g = i.filter((I) => {
          var S;
          let y = (f == null ? void 0 : f.indexOf("-")) > 0 && f.split("-").map((D) => +D), U = (S = I.finishingPositionRange) == null ? void 0 : S.winner;
          return I.drawId === m && (!l.roundNumber || I.roundNumber === l.roundNumber) && (!U || !y || wt(U, y).length === 2 || Te(U).length === Te(y).length && wt(U, y).length === Te(U).length);
        })[0];
        if (g) {
          let { eventId: I, roundNumber: y, drawName: U, structureName: S, roundName: D } = g, w = g.structureId;
          y && !f && (w = Object.keys(r).find((b) => r[b].includes(w)) ?? w);
          let v = { tournamentId: n, structureId: w, roundNumber: y, roundSegment: h, eventId: I, drawId: m }, P = Sy({ tournamentRecords: { [n]: t }, round: v, scheduleDate: s, venueId: p });
          if (P.error)
            return P;
          a.push({ structureName: S, roundName: D, drawName: U, ...v });
        }
      }
    }
  }
  return { scheduledRounds: a };
}
function Bm(e) {
  var qe, ar, $t;
  let t = fe(e, [{ drawProfile: !0, _ofType: _r }]);
  if (t.error)
    return t;
  let { allUniqueParticipantIds: r = [], participantsProfile: i = {}, matchUpStatusProfile: n, completeAllMatchUps: a, autoEntryPositions: o, hydrateCollections: s, randomWinningSide: c, ratingsParameters: u, tournamentRecord: d, isMock: p = !0, drawProfile: l, startDate: m, drawIndex: f, uuids: h } = e, g = ce(l, !1, !0), { excessParticipantAlternates: I = !0, matchUpFormat: y = Oi, drawType: U = on, tournamentAlternates: S = 0, alternatesCount: D = 0, qualifyingPositions: w, qualifyingProfiles: v, generate: P = !0, eventExtensions: b, drawExtensions: T, completionGoal: R, tieFormatName: M, buildTeams: E, seedsCount: C, timeItems: A, drawName: N, category: O, idPrefix: k, publish: F, gender: x, stage: _ } = g, B = g.drawSize || (g.ignoreDefaults ? void 0 : 32), L = g.eventId || ze(), G = l.eventType || l.matchUpType || dn, $ = G === Ui ? Re : Oe, W = Le(l.tieFormat) && l.tieFormat || G === Xe && $n({ event: { eventId: L, category: O, gender: x }, namedFormat: M, hydrateCollections: s, isMock: p }) || void 0, q = (O == null ? void 0 : O.categoryName) || (O == null ? void 0 : O.ageCategoryCode) || (O == null ? void 0 : O.ratingType), K = l.eventName || q || `Generated ${G}`, z = (d == null ? void 0 : d.participants) || [], Y = ((v == null ? void 0 : v.map((Ue) => Ue.structureProfiles || []).flat().reduce((Ue, Se) => {
    let pe = !Se.participantsCount || Se.participantsCount > Se.drawSize ? Se.drawSize : Se.participantsCount || 0;
    return Ue + pe;
  }, 0)) || 0) * ($ === Re ? 2 : 1), X = (!l.participantsCount || l.participantsCount > B ? B : l.participantsCount) || 0, re = { eventName: K, eventType: G, tieFormat: W, category: O, eventId: L, gender: x };
  Array.isArray(A) && A.forEach((Ue) => ms({ event: re, timeItem: Ue }));
  let { eventAttributes: Q } = l;
  if (typeof Q != "object" && (Q = {}), Object.assign(re, Q), (b == null ? void 0 : b.length) && Array.isArray(b)) {
    let Ue = b.filter(pn);
    Ue != null && Ue.length && Object.assign(re, { extensions: Ue });
  }
  let H = [];
  if ((i == null ? void 0 : i.participantsCount) === 0 || l.uniqueParticipants || Y || !d || x || O) {
    let Ue = (X || 0) + D + Y, Se = Ue, pe = { [et]: 0, [dt]: 0 }, We, Ge;
    G === Xe && ({ teamSize: We, genders: Ge } = Uy({ alternatesCount: D, tieFormatName: M, tieFormat: W, drawSize: B }), Object.keys(Ge).forEach((st) => {
      [et, dt].includes(st) && Ge[st] && (pe[st] = B * Ge[st]);
    }), Se = We * ((B || 0) + Y));
    let nt = i != null && i.idPrefix ? `D-${f}-${i == null ? void 0 : i.idPrefix}` : void 0, Ze = Oc({ ...i, scaledParticipantsCount: l.scaledParticipantsCount || i.scaledParticipantsCount, participantsCount: Se, consideredDate: d == null ? void 0 : d.startDate, sex: x || (i == null ? void 0 : i.sex), rankingRange: l.rankingRange, uuids: l.uuids || h, ratingsParameters: u, participantType: $, gendersCount: pe, idPrefix: nt, category: O }).participants;
    if (re.category && (re.category.categoryName = q), d) {
      let st = ji({ participants: Ze, tournamentRecord: d });
      if (st.error)
        return st;
    }
    if (Ze.forEach(({ participantId: st }) => H.push(st)), z = Ze, G === Xe) {
      let st = Ge[et] ? Ze.filter(({ participantType: Kt, person: At }) => Kt === Oe && (At == null ? void 0 : At.sex) === et).map(Ce) : [], qt = Ge[dt] ? Ze.filter(({ participantType: Kt, person: At }) => Kt === Oe && (At == null ? void 0 : At.sex) === dt).map(Ce) : [], Ct = Ze.filter(({ participantType: Kt }) => Kt === Oe).map(Ce).filter((Kt) => !st.includes(Kt) && !qt.includes(Kt)), Mt = [...g.teamNames ?? [], ...Fl({ count: Ue }).names], Ye = We - (Ge[et] + Ge[dt]), He = 0, rr = 0, Je = 0, Nt = oe(0, Ue).map((Kt) => {
        let At = qt.slice(He, He + Ge[dt]), kr = st.slice(rr, rr + Ge[et]), Me = Ct.slice(Je, Je + Ye);
        He += Ge[dt], rr += Ge[et], Je += Ye;
        let or = E !== !1 ? [...At, ...kr, ...Me] : [];
        return { participantName: Mt[Kt] || `Team ${Kt + 1}`, participantOtherName: `TM${Kt + 1}`, participantRole: ur, individualParticipantIds: or, participantType: Xe, participantId: ze() };
      }), Wi = ji({ participants: Nt, tournamentRecord: d });
      if (!Wi.success)
        return Wi;
      z = Nt;
    }
  }
  let Z = (Ue) => {
    let { participantType: Se } = Ue;
    return bt(dn)(G) && Se === Oe || bt(Ui)(G) && Se === Re ? !0 : G === Xe && Se === Xe;
  }, ee = (Ue) => {
    var Se, pe;
    return !l.gender || ((Se = Ue.person) == null ? void 0 : Se.sex) === l.gender ? !0 : (pe = Ue.individualParticipantIds) == null ? void 0 : pe.some((We) => {
      let Ge = z.find((nt) => nt.participantId === We);
      return Ge && ee(Ge);
    });
  }, te = z.filter(Z).filter(ee).filter(({ participantId: Ue }) => !r.includes(Ue)), ne = te.slice(0, X).map((Ue) => Ue.participantId);
  if (p && (ne != null && ne.length)) {
    let Ue = sn({ autoEntryPositions: o, entryStage: _, tournamentRecord: d, participantIds: ne, event: re });
    if (Ue.error)
      return Ue;
  }
  let se = Y ? te.slice(X, X + Y).map((Ue) => Ue.participantId) : 0;
  if (p && (se != null && se.length)) {
    let Ue = 0, Se = 1, pe = (Ge, nt) => Ge.stageSequence - nt.stageSequence, We = (Ge, nt) => Ge.roundTarget - nt.roundTarget;
    for (let Ge of v.sort(We)) {
      Se = Ge.roundTarget || Se;
      let nt = 1, Ze;
      for (let st of Ge.structureProfiles.sort(pe)) {
        let qt = (st.drawSize || hh(st.participantsCount)) - (Ze || 0), Ct = se.slice(Ue, Ue + qt), Mt = sn({ entryStage: ge, entryStageSequence: nt, autoEntryPositions: o, tournamentRecord: d, participantIds: Ct, roundTarget: Se, event: re });
        if (Mt.error)
          return Mt;
        Ze = st.qualifyingPositions, Ue += qt, nt += 1;
      }
      Se += 1;
    }
  }
  let ie = I && ((qe = d == null ? void 0 : d.participants) == null ? void 0 : qe.filter(({ participantId: Ue }) => !ne.includes(Ue)).filter(Z).filter(ee).slice(0, D || B - X || S).map((Ue) => Ue.participantId));
  if (p && (ie != null && ie.length)) {
    let Ue = sn({ participantIds: ie, autoEntryPositions: !1, entryStatus: Fi, tournamentRecord: d, event: re });
    if (Ue.error)
      return Ue.error;
  }
  let he = q || K;
  d && C && C <= ne.length && oe(1, C + 1).forEach((Ue, Se) => {
    let pe = { scaleName: he, scaleDate: m, scaleType: Qg, scaleValue: Ue, eventType: G }, We = ne[Se];
    wd({ tournamentRecord: d, participantId: We, scaleItem: pe });
  });
  let Ee = Md({ ...ce(l, !1, !0), tournamentRecord: d, seedingScaleName: he, matchUpFormat: y, eventId: L, isMock: p, event: re });
  if (Ee.error)
    return Ee;
  if (!Ee.drawDefinition)
    return { error: ai };
  let { drawDefinition: de } = Ee, it = de.drawId;
  if (Array.isArray(T) && T.filter(pn).forEach((Ue) => Ve({ element: de, extension: Ue })), P) {
    if (Nd({ drawDefinition: de, event: re, suppressNotifications: !0 }), l.withPlayoffs) {
      let Se = (ar = de.structures) == null ? void 0 : ar[0].structureId, pe = Yp({ ...l.withPlayoffs, tournamentRecord: d, drawDefinition: de, structureId: Se, idPrefix: k, isMock: p, event: re });
      if (pe != null && pe.error)
        return pe;
    }
    let Ue = l.automated === !1;
    if (p && !Ue) {
      let Se = (pe) => {
        var nt;
        let We = xl({ completeAllMatchUps: pe.completeAllMatchUps, completionGoal: pe.completionGoal, matchUpStatusProfile: n, randomWinningSide: c, tournamentRecord: d, drawDefinition: de, matchUpFormat: y, event: re });
        if (We.error)
          return We;
        let Ge = We.completedCount;
        if (U === En) {
          let Ze = (nt = de.structures) == null ? void 0 : nt.find((Ct) => Ct.stage === ue);
          if (!Ze)
            return { error: It };
          wc({ structureId: Ze.structureId, tournamentRecord: d, drawDefinition: de, event: re });
          let st = R ? R - (Ge ?? 0) : void 0, qt = xl({ completionGoal: R ? st : void 0, matchUpStatusProfile: n, completeAllMatchUps: a, randomWinningSide: c, tournamentRecord: d, drawDefinition: de, matchUpFormat: y, event: re });
          if (qt.error)
            return qt;
        }
      };
      if (R && Se({ completionGoal: R }), l.outcomes) {
        let { matchUps: pe } = vr({ inContext: !0, drawDefinition: de, event: re });
        for (let We of l.outcomes) {
          let { matchUpStatus: Ge = Tt, matchUpStatusCodes: nt, stageSequence: Ze = 1, matchUpIndex: st = 0, structureOrder: qt, matchUpFormat: Ct, drawPositions: Mt, roundPosition: Ye, stage: He = ue, roundNumber: rr, winningSide: Je, scoreString: Nt } = We, Wi = (pe == null ? void 0 : pe.reduce((Me, or) => {
            let { structureId: Fe, matchUpId: ct } = or;
            return Me[Fe] ? Me[Fe].push(ct) : Me[Fe] = [ct], Me;
          }, {})) ?? [], Kt = Object.assign({}, ...Object.keys(Wi).map((Me, or) => ({ [Me]: or + 1 }))), At = ($t = pe == null ? void 0 : pe.filter((Me) => (!He || Me.stage === He) && (!Ze || Me.stageSequence === Ze) && (!rr || Me.roundNumber === rr) && (!Ye || Me.roundPosition === Ye) && (!qt || Kt[Me.structureId] === qt) && (!Mt || wt(Mt, Me.drawPositions).length === 2))) == null ? void 0 : $t[st], kr = jN({ matchUpStatusCodes: nt, tournamentRecord: d, drawDefinition: de, targetMatchUp: At, matchUpFormat: Ct, matchUpStatus: Ge, scoreString: Nt, winningSide: Je });
          if (kr != null && kr.error)
            return kr;
        }
      }
      a && Se({ completeAllMatchUps: a });
    }
    F && Nc({ tournamentRecord: d, event: re });
  } else {
    let Ue = bm({ drawEntries: de.entries, drawName: N || U, qualifyingPositions: w, drawId: it, event: re, stage: _ });
    if (Ue.error)
      return Ue;
  }
  return { ...V, event: me(re), uniqueParticipantIds: H, targetParticipants: z, drawDefinition: de, eventId: L, drawId: it };
}
var HN = () => ({ altitude: void 0, courtId: void 0, courtName: "", courtDimensions: void 0, latitude: void 0, longitude: void 0, surfaceCategory: void 0, surfaceType: void 0, surfacedDate: void 0, dateAvailability: [], onlineResources: [], pace: void 0, notes: void 0 }), MV = HN;
function Ll(e) {
  return parseInt(e);
}
function YS({ startTime: e = "", endTime: t = "" } = {}) {
  if (!e || !t || !Ba.test(e) || !Ba.test(t))
    return !1;
  let [r, i] = e.split(":").map(Ll), [n, a] = t.split(":").map(Ll);
  return n < r ? !1 : !(r === n && a < i);
}
function NV(e, t) {
  let [r, i] = e.startTime.split(":").map(Ll), [n, a] = t.startTime.split(":").map(Ll);
  return r < n ? -1 : r > n ? 1 : i < a ? -1 : i > a ? 1 : 0;
}
function zN({ dateAvailability: e }) {
  if (!e)
    return { error: nw };
  if (!Array.isArray(e))
    return { error: qd };
  let t = "Dates must be formated => YYYY-MM-DD", r = "Times must be 24 hour => 00:00";
  for (let i of e) {
    if (typeof i != "object")
      return { error: qd };
    let { date: n, startTime: a, endTime: o, bookings: s = [] } = i;
    if (!a || !o)
      return { error: qd };
    if (n && !un.test(n))
      return { error: Qt, dateAvailability: { date: n }, info: t };
    if (!Ba.test(a))
      return { error: Ri, dateAvailability: { startTime: a }, info: r };
    if (!Ba.test(o))
      return { error: Ri, dateAvailability: { endTime: o }, info: r };
    if (a === o)
      return { error: Ri, dateAvailability: { startTime: a, endTime: o }, info: "startTime and endTime are equivalent" };
    if (!YS({ startTime: a, endTime: o }))
      return { error: Ri, dateAvailability: { startTime: a, endTime: o }, info: "endTime must be after startTime" };
    if (s) {
      if (!Array.isArray(s))
        return { error: al };
      for (let c of s) {
        if (typeof c != "object")
          return { error: al };
        let { startTime: u, endTime: d } = c;
        if (!Ba.test(u))
          return { error: Ri, booking: { startTime: u }, info: r };
        if (!Ba.test(d))
          return { error: Ri, booking: { endTime: d }, info: r };
        if (u === d)
          return { error: Ri, dateAvailability: { startTime: u, endTime: d }, info: "startTime and endTime are equivalent" };
        if (!YS({ startTime: u, endTime: d }))
          return { error: Ri, dateAvailability: { startTime: u, endTime: d }, info: "endTime must be after startTime" };
      }
    }
  }
  return { valid: !0 };
}
function Vm({ tournamentRecord: e, disableNotice: t, venueId: r, courtId: i, court: n }) {
  let { venue: a } = xn({ tournamentRecord: e, venueId: r });
  if (!a)
    return { error: zo };
  a.courts || (a.courts = []);
  let o = { ...HN(), venueId: r, courtId: i };
  if (o.courtId || (o.courtId = ze()), a.courts.some((s) => s.courtId === o.courtId))
    return { error: vw };
  {
    let s = ((n == null ? void 0 : n.dateAvailability) || []).map((d) => {
      var p;
      return { ...d, date: be(d.date), startTime: mt(d.startTime), endTime: mt(d.endTime), bookings: (p = d.bookings) == null ? void 0 : p.map(({ startTime: l, endTime: m, bookingType: f }) => ({ startTime: mt(l), endTime: mt(m), bookingType: f })) };
    }), c = Object.keys(o);
    for (let d of c)
      if (n != null && n[d])
        if (d === "dateAvailability") {
          let p = zN({ dateAvailability: s });
          if (!p.valid && p.error)
            return p;
          o.dateAvailability = s;
        } else
          o[d] = n[d];
    let u = o;
    return a.courts.push(u), t || De({ payload: { venue: a, tournamentId: e.tournamentId }, topic: uo, key: a.venueId }), { ...V, court: ce(o), venueId: r };
  }
}
function vy(e) {
  let { tournamentRecord: t, venueId: r } = e;
  if (typeof r != "string" || !r)
    return { error: Ta };
  let i = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, n = [], a;
  for (let o of Object.values(i)) {
    let { venue: s } = xn({ tournamentRecord: o, venueId: r });
    if (s) {
      let c = AV({ ...e, tournamentRecord: o });
      for (let u of (c == null ? void 0 : c.courts) ?? [])
        n.push(u == null ? void 0 : u.courtId);
      if (c.error)
        return c;
      a = !0;
    }
  }
  return a ? { ...V, courtIds: n } : { error: zo };
}
function AV({ courtNameRoot: e = "Court", dateAvailability: t = [], venueAbbreviationRoot: r, tournamentRecord: i, courtNames: n = [], courtTimings: a, courtsCount: o, startTime: s, courtIds: c, endTime: u, idPrefix: d, venueId: p, dates: l }) {
  if (!p)
    return { error: Ta };
  let m = xn({ tournamentRecord: i, venueId: p });
  if (m.error)
    return m;
  let { venue: f } = m;
  if (!St(o) || !n)
    return { error: Sw };
  o = o ?? n.length;
  let h = oe(0, o).map((g) => {
    let I = a == null ? void 0 : a[g], y = I ? l.map((U) => ({ date: Ci(U), startTime: s, endTime: u, ...I })) : t;
    return I && s && u && y.push({ startTime: s, endTime: u }), { courtName: n[g] || r && (f == null ? void 0 : f.venueAbbreviation) && `${f == null ? void 0 : f.venueAbbreviation} ${g + 1}` || `${e} ${g + 1}`, dateAvailability: y };
  }).map((g, I) => {
    let y = (c == null ? void 0 : c.pop()) || d && `${d}-${I + 1}`;
    return Vm({ disableNotice: !0, tournamentRecord: i, courtId: y, venueId: p, court: g });
  }).map((g) => g.court).filter(Boolean);
  return h.length !== o ? j({ info: "not all courts could be generated", result: { error: J } }) : (f && De({ payload: { venue: f, tournamentId: i.tournamentId }, topic: uo, key: f.venueId }), { ...V, courts: ce(h) });
}
function wy({ tournamentRecord: e, ignoreExistingVenues: t, venueProfiles: r, uuids: i }) {
  let { startDate: n, endDate: a } = e, o = [];
  for (let [s, c] of r.entries()) {
    let { venueAbbreviation: u, venueId: d = (i == null ? void 0 : i.pop()) ?? ze(), dateAvailability: p, startTime: l = "07:00", endTime: m = "19:00", courtTimings: f, courtsCount: h, courtNames: g, venueName: I, idPrefix: y, courtIds: U } = c, S = { venueName: I || `Venue ${s + 1}`, venueAbbreviation: u, venueId: d }, D = Zu({ tournamentRecord: e, venue: S });
    if (D.error) {
      if (t)
        continue;
      return D;
    }
    o.push(d);
    let w = Fs(n, a), v = !Array.isArray(p) && [{ startTime: l, endTime: m }].concat(w.map((P) => ({ date: Ci(P), startTime: l, endTime: m })));
    if (h || g) {
      let P = vy({ dateAvailability: p || v, tournamentRecord: e, courtTimings: f, courtsCount: h, courtNames: g, startTime: l, idPrefix: y, courtIds: U, endTime: m, venueId: d, dates: w });
      if (P.error)
        return P;
    }
  }
  return o;
}
function EV(e) {
  var d, p, l;
  let { tournamentRecord: t, leagueProfiles: r, eventIds: i, venueIds: n, drawIds: a, allUniqueParticipantIds: o, uuids: s } = e, c = 0;
  for (let m of r) {
    let f = [], { tieFormatName: h = ll, teamProfiles: g = [], teamsCount: I = 0, category: y, idPrefix: U, gender: S } = m, D = m.leagueName ?? m.eventName ?? `League ${c + 1}`, w = m.leagueId ?? m.eventId ?? (s == null ? void 0 : s.pop()) ?? ze();
    i.push(w);
    let v = Le(m.tieFormat) && m.tieFormat || $n({ event: { eventId: w, category: y, gender: S }, namedFormat: h, isMock: e.isMock }) || void 0;
    if (!v)
      return { error: ac };
    let P = Math.max(I, g.length), b = oe(0, P), { genders: T, teamSize: R } = Uy({ tieFormat: v, drawSize: P }), M = { [dt]: 0, [Mr]: 0, [_a]: 0, [et]: 0, [Zi]: 0 };
    Object.keys(T).forEach((C) => M[C] += T[C]);
    for (let C of b) {
      let A = ((d = g == null ? void 0 : g[C]) == null ? void 0 : d.teamName) ?? `Team ${C + 1}`, N = ((p = g == null ? void 0 : g[C]) == null ? void 0 : p.teamId) || (s == null ? void 0 : s.pop()) || ze(), O = m.startDate ?? e.startDate, k = Oc({ ...m == null ? void 0 : m.participantsProfile, participantsCount: R, consideredDate: O, gendersCount: M, category: y, gender: S, uuids: s }).participants, F = k.map(($) => $.participantId), x = Xe, _ = N ?? kl({ participantType: x, idPrefix: U, index: C, uuids: s });
      f.push({ participantId: _, entryStatus: $r, entryStage: ue });
      let B = ((l = g == null ? void 0 : g[C]) == null ? void 0 : l.venueIds) ?? [], L = { participantId: _, participantRole: ur, participantName: A, individualParticipantIds: F, participantType: x, homeVenueIds: B };
      B.forEach(($) => !n.includes($) && n.push($)), o.push(...F), o.push(_);
      let G = ji({ participants: [L, ...k], tournamentRecord: t });
      if (G.error)
        return G;
    }
    let E = { eventName: D, entries: f, eventType: Xe, tieFormat: v, category: y, eventId: w, gender: S };
    if (t.events || (t.events = []), t.events.push(E), f.length) {
      let C = (St(m.roundsCount) && m.roundsCount) ?? m.roundsCount === S1 ? (P - 1) * 2 : P - 1, A = Md({ automated: m.automated, tournamentRecord: t, drawType: si, roundsCount: C, drawSize: P, event: E });
      if (A.error)
        return A;
      let { drawDefinition: N } = A;
      if (N) {
        let O = N == null ? void 0 : N.drawId;
        Nd({ drawDefinition: N, event: E, suppressNotifications: !0 }), a.push(O);
      }
    }
    c++;
  }
  let u = n.map((m) => ({ venueId: m }));
  wy({ tournamentRecord: t, ignoreExistingVenues: !0, venueProfiles: u, uuids: s });
}
var CV = ["Generated Tournament", "CourtHive Challenge", "Replication Crisis", "Open Competition", "Factory Follies", "Mock Tournament", "Atomic Culture", "Racket Rally", "Stats Fail"];
function YN(e) {
  var y, U, S;
  let { startDate: t, endDate: r } = e ?? {}, { tournamentName: i = zr(CV), ratingsParameters: n = Wt, tournamentExtensions: a, policyDefinitions: o, schedulingProfile: s, venueProfiles: c, uuids: u } = e ?? {}, d = (e == null ? void 0 : e.isMock) === !1 ? void 0 : !0;
  if (t && !Kr(t) || r && !Kr(r))
    return { error: Qt };
  if (e.leagueProfiles && !Array.isArray(e.leagueProfiles) || e.eventProfiles && !Array.isArray(e.eventProfiles) || e.drawProfiles && !Array.isArray(e.drawProfiles))
    return { error: J };
  if (!t) {
    let D = /* @__PURE__ */ new Date();
    t = Ci(r ?? D), r = Ci(D.setDate(D.getDate() + 7));
  }
  if (!r) {
    let D = new Date(t);
    r = Ci(D.setDate(D.getDate() + 7));
  }
  let p = _m({ ...e.tournamentAttributes ?? {}, tournamentName: i, startDate: t, endDate: r, isMock: d }), l = c != null && c.length ? wy({ tournamentRecord: p, venueProfiles: c, uuids: u }) : [];
  if (a != null && a.length && Array.isArray(a)) {
    let D = a.filter((w) => pn({ extension: w }));
    D != null && D.length && Object.assign(p, { extensions: D, isMock: d });
  }
  if (typeof o == "object")
    for (let D of Object.keys(o))
      Za({ policyDefinitions: { [D]: o[D] }, tournamentRecord: p });
  if (!((y = e == null ? void 0 : e.leagueProfiles) != null && y.length) || (U = e.eventProfiles) != null && U.length || (S = e.drawProfiles) != null && S.length || e.participantsProfile) {
    let D = _N({ tournamentRecord: p, ...e });
    if (!D.success)
      return D;
  }
  let m = [], f = [], h = [];
  if (e.leagueProfiles) {
    let D = EV({ allUniqueParticipantIds: m, tournamentRecord: p, ...e, eventIds: f, venueIds: l, drawIds: h });
    if (D != null && D.error)
      return D;
  }
  if (e.drawProfiles) {
    let D = OV({ allUniqueParticipantIds: m, ratingsParameters: n, tournamentRecord: p, ...e, eventIds: f, drawIds: h });
    if (D != null && D.error)
      return D;
  }
  if (e.eventProfiles) {
    let D = kV({ allUniqueParticipantIds: m, ratingsParameters: n, tournamentRecord: p, ...e, eventIds: f, drawIds: h });
    if (D != null && D.error)
      return D;
  }
  let { scheduledRounds: g = void 0, schedulerResult: I = {} } = s ? FV({ ...e, tournamentRecord: p }) : {};
  return Wh(), me({ ...V, tournamentRecord: p, scheduledRounds: g, schedulerResult: I, eventIds: f, venueIds: l, drawIds: h });
}
function OV(e) {
  let { tournamentRecord: t, drawProfiles: r, allUniqueParticipantIds: i, eventIds: n, drawIds: a } = e, o = 0;
  for (let s of r) {
    let c = Bm({ allUniqueParticipantIds: i, tournamentRecord: t, drawProfile: s, drawIndex: o, ...e });
    if (c.error)
      return c;
    let { drawId: u, eventId: d, event: p, uniqueParticipantIds: l } = c;
    if ((s == null ? void 0 : s.addEvent) !== !1) {
      if (c = Rc({ suppressNotifications: !1, internalUse: !0, tournamentRecord: t, event: p }), c.error)
        return c;
      u && a.push(u), n.push(d);
    }
    l != null && l.length && i.push(...l), o += 1;
  }
}
function kV(e) {
  let { eventProfiles: t, allUniqueParticipantIds: r, eventIds: i, drawIds: n } = e, a = 0;
  for (let o of t) {
    let s = WN({ ...e, eventIndex: a, eventProfile: o });
    if (s.error)
      return s;
    let { eventId: c, drawIds: u, uniqueParticipantIds: d } = s;
    u && n.push(...u), i.push(c), d != null && d.length && r.push(...d), a += 1;
  }
}
function FV(e) {
  let { schedulingProfile: t, tournamentRecord: r, autoSchedule: i, periodLength: n, scheduleCompletedMatchUps: a } = e, o = RV({ schedulingProfile: t, tournamentRecord: r });
  if (o.error)
    return o;
  let s = o.scheduledRounds;
  if (i) {
    let { tournamentId: c } = r, u = { [c]: r };
    return { schedulerResult: Lm({ scheduleCompletedMatchUps: a, tournamentRecords: u, periodLength: n }), scheduledRounds: s };
  }
  return { scheduledRounds: s };
}
var KN = {};
Ae(KN, { anonymizeTournamentRecord: () => QN, modifyTournamentRecord: () => JN });
function QN({ keepExtensions: e = [], anonymizeParticipantNames: t = !0, tournamentRecord: r, tournamentName: i, personIds: n = [], tournamentId: a }) {
  var k, F, x, _, B;
  if (!r)
    return { error: ae };
  let o = Array.isArray(e) ? aS.concat(...e) : aS, s = (L) => {
    var G;
    return Array.isArray(e) ? (G = L == null ? void 0 : L.extensions) == null ? void 0 : G.filter(($) => o.includes($.name)) : L == null ? void 0 : L.extensions;
  }, c = {};
  r.extensions = s(r);
  let u = a || ze();
  c[r.tournamentId] = u, r.tournamentId = u, r.createdAt = (/* @__PURE__ */ new Date()).toISOString(), r.tournamentName = i || `Anonymized: ${Ci(/* @__PURE__ */ new Date())}`, r.isMock = !0, delete r.parentOrganisation;
  for (let L of r.participants || []) {
    L.extensions = s(L), L.onlineResources = [];
    let G = ze();
    c[L.participantId] = G, L.participantId = G;
  }
  for (let L of r.participants || [])
    Array.isArray(L.individualParticipantIds) && (L.individualParticipantIds = L.individualParticipantIds.map((G) => c[G]));
  let d = 0;
  for (let L of r.venues || []) {
    L.venueAbbreviation = `V${d}`, L.extensions = s(L), L.venueName = `Venue #${d}`, L.onlineResources = [], L.addresses = [];
    let G = ze();
    c[L.venueId] = G, L.isMock = !0, d += 1;
    let $ = 0;
    for (let W of L.courts || [])
      W.courtName = `V${d}C${$}`, W.extensions = s(W), W.onlineResources = [], W.isMock = !0, $ += 1;
  }
  let p = 1;
  for (let L of r.events || []) {
    L.extensions = s(L), L.onlineResources = [], L.isMock = !0;
    let G = ze();
    c[L.eventId] = G, L.eventId = G;
    let $ = ((k = L.category) == null ? void 0 : k.categoryName) || ((F = L.category) == null ? void 0 : F.ageCategoryCode) || ((x = L.category) == null ? void 0 : x.ratingType) || L.gender;
    if (L.eventName = `Event ${p} ${$}`, Array.isArray(L.entries))
      for (let q of L.entries)
        q.participantId = c[q.participantId];
    for (let q of L.drawDefinitions || []) {
      q.extensions = s(q);
      let K = ze();
      if (c[q.drawId] = K, q.drawId = K, q.isMock = !0, Array.isArray(q.entries))
        for (let Y of q.entries)
          Y.participantId = c[Y.participantId];
      let z = (Y) => {
        Y.extensions = s(Y);
        let X = ze();
        c[Y.structureId] = X, Y.structureId = X;
        for (let re of Y.positionAssignments || [])
          re.participantId && (re.participantId = c[re.participantId]);
        for (let re of Y.seedAssignments || [])
          re.participantId && (re.participantId = c[re.participantId]);
        for (let re of Y.matchUps || []) {
          re.isMock = !0;
          for (let Q of re.sides || [])
            Q.lineUp && (Q.lineUp = Q.lineUp.map(({ participantId: H, collectionAssignments: Z }) => ({ participantId: c[H], collectionAssignments: Z })));
        }
      };
      for (let Y of q.structures || [])
        if (z(Y), Array.isArray(Y.structures))
          for (let X of Y.structures)
            z(X);
      for (let Y of q.links || [])
        Y.source.structureId = c[Y.source.structureId], Y.target.structureId = c[Y.target.structureId];
    }
    let { extension: W } = Ne({ name: _i, element: L });
    Array.isArray((_ = W == null ? void 0 : W.value) == null ? void 0 : _.flights) && ((B = W == null ? void 0 : W.value.flights) == null || B.forEach((q) => {
      if (q.drawId = c[q.drawId], Array.isArray(q.drawEntries))
        for (let K of q.drawEntries)
          K.participantId = c[K.participantId];
    })), p += 1;
  }
  let l = r.startDate || Ci(/* @__PURE__ */ new Date()), m = (r.participants || []).filter(({ participantType: L }) => L === Oe), f = m.reduce((L, G) => {
    var W;
    let $ = (W = G.person) == null ? void 0 : W.sex;
    return [et, dt].includes($) ? L[$] += 1 : L[_a] += 1, L;
  }, { [et]: 0, [dt]: 0, [_a]: 0 }), h = Object.assign({}, ...Object.keys(f).map((L) => {
    var G;
    return { [L]: ((G = LN({ category: { ageCategoryCode: "O18" }, count: f[L], addressProps: { citiesCount: 10 }, personExtensions: [], consideredDate: l, sex: L })) == null ? void 0 : G.persons) || [] };
  })), g = { [et]: 0, [dt]: 0, [_a]: 0 }, I = m.length, y = m.reduce((L, G) => {
    var z, Y;
    let $ = ((Y = (z = G.person) == null ? void 0 : z.addresses) == null ? void 0 : Y[0]) || {}, { city: W, state: q, postalCode: K } = $;
    return L.cities.includes(W) || L.cities.push(W), L.states.includes(q) || L.states.push(q), L.postalCodes.includes(K) || L.postalCodes.push(K), L;
  }, { cities: [], postalCodes: [], states: [] }), U = y.postalCodes.length, S = y.cities.length, D = y.states.length, { cities: w } = ON({ count: S || I, participantsCount: I }), { states: v } = kN({ count: D || I, participantsCount: I }), { postalCodes: P } = FN({ count: U || I, participantsCount: I }), b = { cities: w, states: v, postalCodes: P };
  m.forEach((L, G) => {
    var Y, X;
    let $ = L == null ? void 0 : L.person, W = ($ == null ? void 0 : $.sex) || _a, q = (Y = be($ == null ? void 0 : $.birthDate)) == null ? void 0 : Y.split("-")[0], K = g[W], z = h[W][K];
    if (g[W] += 1, q) {
      let [, re, Q] = ((X = z == null ? void 0 : z.birthDate) == null ? void 0 : X.split("-")) || [], H = [q, re, Q].join("-");
      z.birthDate = H;
    }
    if ($ != null && $.addresses) {
      let re = xN({ ...b, participantIndex: G, nationalityCode: z.nationalityCode });
      z.addresses = [re];
    }
    z.personId = (n == null ? void 0 : n[G]) || ze(), t ? (z.standardFamilyName = z.lastName, z.standardGivenName = z.firstName, L.participantName = `${z.standardGivenName} ${z.standardFamilyName}`) : (z.standardFamilyName = $ == null ? void 0 : $.standardFamilyName, z.standardGivenName = $ == null ? void 0 : $.standardGivenName), delete z.firstName, delete z.lastName, z.extensions = s($), L.person = z, c[$ == null ? void 0 : $.personId] = z.personId;
  }), (r.participants || []).filter(({ participantType: L }) => L === Re).forEach((L) => {
    let { individualParticipantIds: G } = L;
    L.participantName = xV({ individualParticipantIds: G, individualParticipants: m });
  });
  let T = (r.participants || []).filter(({ participantType: L }) => L === Xe), R = T.length, M = Fl({ count: R }).names;
  T.forEach((L, G) => {
    L.participantName = M[G];
  });
  let E = (r.participants || []).filter(({ participantType: L }) => L === di), C = E.length, A = Fl({ count: C, nameRoot: "Group" }).names;
  E.forEach((L, G) => {
    L.participantName = A[G];
  });
  let { extension: N } = Ne({ element: r, name: _o });
  Array.isArray(N == null ? void 0 : N.value) && (N == null || N.value.forEach((L) => {
    L.tournamentId = c[L.tournamentId], L.structureId = c[L.structureId], L.eventId = c[L.eventId], L.drawId = c[L.drawId];
  }));
  let { extension: O } = Ne({ element: r, name: fc });
  return Array.isArray(O == null ? void 0 : O.value) && (O == null || O.value.forEach((L) => {
    L.personId = c[L.personId];
  })), { ...V };
}
function xV({ individualParticipantIds: e, individualParticipants: t }) {
  let r = t.filter(({ participantId: i }) => e.includes(i)).map(({ person: i }) => i == null ? void 0 : i.standardFamilyName).filter(Boolean).sort().join("/");
  return e.length === 1 && (r += "/Unknown"), r;
}
function JN(e) {
  var b, T, R;
  let { ratingsParameters: t = Wt, participantsProfile: r = {}, matchUpStatusProfile: i, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, schedulingProfile: c, tournamentRecord: u, autoSchedule: d, eventProfiles: p, periodLength: l, venueProfiles: m, drawProfiles: f, isMock: h, uuids: g } = e;
  if (!u)
    return { error: ae };
  let I = [], y = [], U = [];
  p == null || p.forEach((M) => {
    var C;
    let E = (C = u.events) == null ? void 0 : C.find((A, N) => M.eventIndex !== void 0 && N === M.eventIndex || M.eventName && A.eventName === M.eventName || M.eventId && A.eventId === M.eventId);
    E != null && E.gender && (M.gender = E.gender);
  });
  let S = ((b = u.participants) == null ? void 0 : b.length) || void 0;
  S && (r != null && r.idPrefix) && (r.idPrefix = `${r.idPrefix}-${S}`);
  let D = _N({ startDate: u.startDate, participantsProfile: r, tournamentRecord: u, eventProfiles: p, drawProfiles: f, uuids: g });
  if (!D.success)
    return D;
  if (p) {
    let M = ((T = u.events) == null ? void 0 : T.length) || 0;
    for (let E of p) {
      let { ratingsParameters: C } = E, A = (R = u.events) == null ? void 0 : R.find((N, O) => E.eventIndex !== void 0 && O === E.eventIndex || E.eventName && N.eventName === E.eventName || E.eventId && N.eventId === E.eventId);
      if (A) {
        let { gender: N, category: O, eventType: k } = A, { drawProfiles: F, publish: x } = E, _ = bt(dn)(k) && Oe || bt(Ui)(k) && Re || k;
        if (F) {
          let { stageParticipantsCount: B, uniqueParticipantsCount: L, uniqueParticipantStages: G } = BN({ drawProfiles: F, category: O, gender: N }), { uniqueDrawParticipants: $ = [], uniqueParticipantIds: W = [] } = G ? $N({ event: { eventType: k, category: O, gender: N }, uniqueParticipantsCount: L, participantsProfile: r, ratingsParameters: C, tournamentRecord: u, eventProfile: E, uuids: g }) : {};
          I.push(...W);
          let { stageParticipants: q } = VN({ targetParticipants: u.participants || [], allUniqueParticipantIds: I, stageParticipantsCount: B, eventParticipantType: _ }), K = qN({ uniqueDrawParticipants: $, autoEntryPositions: a, stageParticipants: q, tournamentRecord: u, drawProfiles: F, category: O, gender: N, event: A });
          if (K.error || (K = GN({ matchUpStatusProfile: i, completeAllMatchUps: n, randomWinningSide: s, tournamentRecord: u, drawProfiles: F, isMock: h, event: A }), K.error))
            return K;
          U.push(...K.drawIds);
        }
        x && Nc({ tournamentRecord: u, event: A });
      } else {
        let N = WN({ startDate: u.startDate, allUniqueParticipantIds: I, matchUpStatusProfile: i, participantsProfile: r, completeAllMatchUps: n, autoEntryPositions: a, randomWinningSide: s, ratingsParameters: C, tournamentRecord: u, eventProfile: E, eventIndex: M, uuids: g });
        if (N.error)
          return N;
        let { eventId: O, drawIds: k, uniqueParticipantIds: F } = N;
        k && U.push(...k), y.push(O), F != null && F.length && I.push(...F), M += 1;
      }
    }
  }
  if (f) {
    let M = (u.events || []).map((E) => {
      var C;
      return ((C = E.drawDefinitions) == null ? void 0 : C.map(() => 1)) || [];
    }).flat().reduce((E, C) => E + C, 0);
    for (let E of f) {
      let C = Bm({ startDate: u.startDate, allUniqueParticipantIds: I, matchUpStatusProfile: i, participantsProfile: r, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, ratingsParameters: t, tournamentRecord: u, drawProfile: E, drawIndex: M, uuids: g });
      if (C.error)
        return C;
      let { drawId: A, eventId: N, event: O, uniqueParticipantIds: k } = C;
      if (C = Rc({ tournamentRecord: u, event: O, internalUse: !0 }), C.error)
        return C;
      A && U.push(A), y.push(N), k != null && k.length && I.push(...k), M += 1;
    }
  }
  let w = m != null && m.length ? wy({ tournamentRecord: u, venueProfiles: m }) : [], v, P = {};
  if (c != null && c.length) {
    let M = { [u.tournamentId]: u }, E = Tc({ tournamentRecords: M, schedulingProfile: c });
    if (E.error)
      return E;
    if (d) {
      let { tournamentId: C } = u, A = { [C]: u };
      P = Lm({ tournamentRecords: A, periodLength: l });
    }
  }
  return { totalParticipantsCount: u.participants.length, scheduledRounds: v, schedulerResult: P, ...V, eventIds: y, venueIds: w, drawIds: U };
}
var XN = {};
Ae(XN, { addDynamicRatings: () => YI, addIndividualParticipantIds: () => Am, addParticipant: () => hn, addParticipants: () => ji, addPenalty: () => y0, addPersonRequests: () => n0, addPersons: () => S0, createGroupParticipant: () => d0, createTeamsFromParticipantAttributes: () => Iy, deleteParticipants: () => ds, filterParticipants: () => ad, findParticipant: () => u0, getCompetitionParticipants: () => cU, getPairedParticipant: () => Vi, getParticipantEventDetails: () => uU, getParticipantMembership: () => dU, getParticipantScaleItem: () => Qs, getParticipantSchedules: () => lU, getParticipantSignInStatus: () => pU, getParticipantTimeItem: () => jg, getParticipants: () => Ut, getScaleValues: () => pc, mergeParticipants: () => U0, modifyIndividualParticipantIds: () => a0, modifyParticipant: () => Em, modifyParticipantName: () => l0, modifyParticipantOtherName: () => s0, modifyParticipantsSignInStatus: () => o0, modifyPenalty: () => g0, modifyPersonRequests: () => r0, mutate: () => ZN, participantScaleItem: () => Tn, query: () => tM, regenerateParticipantNames: () => c0, removeIndividualParticipantIds: () => oI, removeParticipantIdsFromAllTeams: () => _p, removePenalty: () => f0, removePersonRequests: () => i0, removeRatings: () => m0, scaledTeamAssignment: () => p0, setParticipantScaleItem: () => wd, setParticipantScaleItems: () => Kb, validateLineUp: () => Vp });
var ZN = {};
Ae(ZN, { addDynamicRatings: () => YI, addIndividualParticipantIds: () => Am, addParticipant: () => hn, addParticipants: () => ji, addPenalty: () => y0, addPersonRequests: () => n0, addPersons: () => S0, createGroupParticipant: () => d0, createTeamsFromParticipantAttributes: () => Iy, deleteParticipants: () => ds, findParticipant: () => u0, mergeParticipants: () => U0, modifyIndividualParticipantIds: () => a0, modifyParticipant: () => Em, modifyParticipantName: () => l0, modifyParticipantOtherName: () => s0, modifyParticipantsSignInStatus: () => o0, modifyPenalty: () => g0, modifyPersonRequests: () => r0, regenerateParticipantNames: () => c0, removeIndividualParticipantIds: () => oI, removeParticipantIdsFromAllTeams: () => _p, removePenalty: () => f0, removePersonRequests: () => i0, removeRatings: () => m0, scaledTeamAssignment: () => p0, setParticipantScaleItem: () => wd, setParticipantScaleItems: () => Kb });
function e0(e = 0) {
  (typeof e != "number" || isNaN(e)) && (e = 0);
  let t = /* @__PURE__ */ new Date();
  return t.setHours(t.getHours() + e), t.getTime().toString(36).slice(-6).toUpperCase();
}
function t0({ personRequests: e, personId: t, requests: r }) {
  e[t] || (e[t] = []);
  let i = r.filter(({ requestType: n }) => n).map((n) => {
    let { date: a, startTime: o, endTime: s } = n;
    return n.requestType === kd && (a = be(a), o = mt(o), s = mt(s), a && o && s) ? { date: a, startTime: o, endTime: s, requestType: n.requestType } : n;
  }).filter(Boolean);
  for (let n of i)
    n.requestId = e0(), e[t].push(n);
  return { mergeCount: i.length };
}
function Py(e) {
  let { tournamentRecords: t, personRequests: r } = e, i = fe(e, [{ [gr]: !0 }]);
  if (i.error)
    return i;
  if (!r)
    return { ...V };
  let n = Object.values(t);
  for (let a of n) {
    let o = a.participants ?? [], s = [];
    for (let c of Object.keys(r))
      if (ga({ tournamentParticipants: o, personId: c })) {
        let u = r[c];
        u.length && s.push({ personId: c, requests: u });
      }
    Object.keys(s).length && Ve({ element: a, extension: { value: s, name: fc } });
  }
  return { ...V };
}
function r0(e) {
  let { tournamentRecords: t, requests: r, personId: i } = e, n = fe(e, [{ [gr]: !0 }, { requests: !0, [Or]: fr, [ci]: J }]);
  if (n.error)
    return n;
  let a = r.map(({ requestId: u }) => u).filter(Boolean), { personRequests: o } = Uo({ tournamentRecords: t }), s = (u) => {
    o && (o[u] = o[u].map((d) => {
      if (!a.includes(d.requestId))
        return d;
      let p = r.find((l) => l.requestId === d.requestId);
      if (p.requestType)
        return Object.assign(d, p);
    }).filter(Boolean));
  };
  if (i && (o != null && o[i]))
    s(i);
  else if (o)
    for (let u of Object.keys(o))
      s(u);
  let c = r.filter((u) => !u.requestId);
  return c.length && t0({ personRequests: o, personId: i, requests: c }), Py({ tournamentRecords: t, personRequests: o });
}
function i0(e) {
  let { tournamentRecords: t, requestType: r, requestId: i, personId: n, date: a } = e, o = fe(e, [{ [gr]: !0 }]);
  if (o.error)
    return o;
  let { personRequests: s } = Uo({ tournamentRecords: t }), c = (d) => {
    var p;
    s && (s[d] = s[d].filter((l) => (!r || l.requestType !== r) && (!i || l.requestId !== i) && (!a || l.date !== a)), (p = s == null ? void 0 : s[d]) != null && p.length || delete s[d]);
  }, u = !r && !i && !n && !a;
  if (!u) {
    if (n && (s != null && s[n]))
      c(n);
    else if (s)
      for (let d of Object.keys(s))
        c(d);
  }
  return u || !s || !Object.keys(s).length ? Sr({ name: fc, tournamentRecords: t, discover: !0 }) : Py({ tournamentRecords: t, personRequests: s });
}
function n0(e) {
  let { tournamentRecords: t, personId: r, requests: i } = e, n = fe(e, [{ [gr]: !0, [R1]: !0 }, { requests: !0, [Or]: fr, [ci]: J }]);
  if (n.error)
    return n;
  let { personRequests: a } = Uo({ tournamentRecords: t }), { mergeCount: o } = t0({ personRequests: a, personId: r, requests: i });
  return o && a ? Py({ tournamentRecords: t, personRequests: a }) : { error: J };
}
function a0({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: r }) {
  let i = "modifyIndividualParticipantIds";
  if (!r)
    return j({ result: { error: ae }, stack: i });
  if (!t || !e)
    return j({ result: { error: Ie }, stack: i });
  let n = r.participants || [], a = n.find((m) => m.participantId === t);
  if (!a)
    return j({ result: { error: Dt }, stack: i });
  if (![Xe, di].includes(a.participantType))
    return j({ result: { error: Xi }, context: { participantType: a.participantType }, stack: i });
  let o = e.filter((m) => {
    var f;
    return ((f = n.find((h) => h.participantId === m)) == null ? void 0 : f.participantType) !== Oe;
  });
  if (o.length)
    return j({ result: { error: Yr, invalidParticipantIds: o }, stack: i });
  let s = a.individualParticipantIds || [], c = e.filter((m) => !s.includes(m)), u = s.filter((m) => !e.includes(m)), d = Am({ individualParticipantIds: c, groupingParticipantId: t, tournamentRecord: r });
  if (d.error)
    return j({ result: d, stack: i });
  let p = oI({ individualParticipantIds: u, groupingParticipantId: t, tournamentRecord: r });
  if (p.error)
    return j({ result: p, stack: i });
  let { topics: l } = vi();
  if (l.includes(pr)) {
    let m = n.find(({ participantId: f }) => f === t);
    De({ topic: pr, payload: { tournamentId: r.tournamentId, participants: [m] } });
  }
  return { ...d, ...p };
}
function o0({ tournamentRecord: e, participantIds: t, signInState: r }) {
  if (!e)
    return { error: ae };
  if (!Array.isArray(t))
    return { error: Ie };
  if (![uu, AD].includes(r))
    return { error: J, signInState: r };
  let i = e.participants || [];
  if (!i.length)
    return { error: Ru };
  let n = i.map(Ce), a = t.filter((u) => !n.includes(u));
  if (a.length)
    return { error: J, context: { invalidParticipantIds: a } };
  let o = [], s = (/* @__PURE__ */ new Date()).toISOString();
  for (let u of i) {
    let { participantId: d } = u;
    if (t.includes(d)) {
      let p = xI({ duplicateValues: !1, tournamentRecord: e, participantId: d, timeItem: { itemType: ju, itemValue: r, createdAt: s } });
      if (p.error)
        return p;
      o.push(u);
    }
  }
  let { topics: c } = vi();
  return o.length && c.includes(pr) && De({ topic: pr, payload: { tournamentId: e.tournamentId, participants: o } }), { ...V };
}
function s0({ tournamentRecord: e, participantId: t, participantOtherName: r }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: _t };
  let { participant: i } = Aa({ tournamentRecord: e, participantId: t });
  if (!i)
    return { error: Dt };
  i.participantOtherName = r;
  let { topics: n } = vi();
  return n.includes(pr) && De({ topic: pr, payload: { tournamentId: e.tournamentId, participants: [i] } }), { ...V };
}
function KS({ personFormat: e, person: t }) {
  let r = (h) => h.replace(/\W/g, ""), i = (h) => /^[a-z]*$/.test(r(h)), n = (h) => /^[A-Z]*$/.test(r(h)), a = (h) => /^[LAST]{4}/.test(r(h)), o = (h) => h.toLowerCase().indexOf("l") < h.toLowerCase().indexOf("f"), s = (h) => h.indexOf(",") >= 0, c = (h) => h.toLowerCase().indexOf("f.") >= 0, u = (h) => h.toLowerCase().indexOf("f") < 0, d = (h) => h.indexOf(" ") > 0;
  if (!t)
    return;
  let p = d(e) ? " " : "", l = Gf((t == null ? void 0 : t.standardGivenName) ?? ""), m = Gf((t == null ? void 0 : t.standardFamilyName) ?? "");
  if (!e)
    return `${l}${p}${m}`;
  c(e) && !s(e) && !o(e) && (l = `${l[0]}.`), i(e) ? (l = l.toLowerCase(), m = m.toLowerCase()) : n(e) ? (l = l.toUpperCase(), m = m.toUpperCase()) : a(e) && (m = m.toUpperCase());
  let f = `${l}${p}${m}`;
  return u(e) ? f = m : o(e) && (s(e) ? f = `${m},${p}${l}` : f = `${m}${p}${l}`), f;
}
function LV({ participantMap: e, participant: t, formats: r }) {
  let { participantType: i, individualParticipantIds: n, person: a } = t, o = i && r[i];
  if (i !== Nr && o) {
    let { personFormat: s, doublesJoiner: c } = o;
    i === Oe && (t.participantName = KS({ person: a, personFormat: s })), i === Re && (t.participantName = n == null ? void 0 : n.map((u) => {
      var p;
      let d = (p = e[u]) == null ? void 0 : p.person;
      return KS({ person: d, personFormat: s });
    }).filter(Boolean).join(c ?? "/"));
  }
}
function c0({ tournamentRecord: e, formats: t }) {
  if (!e)
    return { error: ae };
  if (!Le(t))
    return { error: Ie };
  let r = e.participants ?? [], i = Mv(r, "participantId");
  for (let n of r)
    LV({ participant: n, participantMap: i, formats: t });
  return { ...V };
}
function u0(e) {
  let { tournamentRecord: t, policyDefinitions: r, contextProfile: i, participantId: n, personId: a } = e, o = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (typeof n != "string" && typeof a != "string")
    return { error: Ie, stack: "publicFindParticipant" };
  let s, c;
  for (let u of Object.values(o)) {
    c = u.tournamentId;
    let d = u.participants || [];
    if (s = ga({ tournamentParticipants: d, internalUse: !0, policyDefinitions: r, contextProfile: i, participantId: n, personId: a }), s)
      break;
  }
  return { participant: s, tournamentId: c, ...V };
}
function d0({ individualParticipantIds: e = [], participantRoleResponsibilities: t, participantRole: r = IT, tournamentRecord: i, participantId: n, groupName: a }) {
  if (!i)
    return { error: ae };
  if (!a)
    return { error: Ie, info: "Missing groupName" };
  if (!Array.isArray(e))
    return { info: "Invalid individualParticipantIds", error: J };
  let o = (Ut({ participantFilters: { participantTypes: [Oe] }, tournamentRecord: i }).participants ?? []).map((d) => d.participantId);
  for (let d of e)
    if (!o.includes(d))
      return { error: Xi, participantId: d };
  let s = me({ participantId: n || ze(), participantRoleResponsibilities: t, participantName: a, individualParticipantIds: e, participantType: di, participantRole: r }), c = hn({ participant: s, tournamentRecord: i });
  if (c.error)
    return c;
  let { topics: u } = vi();
  return u.includes(Ua) && De({ topic: Ua, payload: { tournamentId: i.tournamentId, participants: [s] } }), { ...V, participant: ce(s) };
}
function l0({ tournamentRecord: e, participantName: t, participantId: r }) {
  if (!e)
    return { error: ae };
  if (!r)
    return { error: _t };
  if (!t)
    return { error: Ie, info: "Missing participantName" };
  let { participant: i } = Aa({ tournamentRecord: e, participantId: r });
  if (!i)
    return { error: Dt };
  i.participantName = t;
  let { topics: n } = vi();
  return n.includes(pr) && De({ topic: pr, payload: { tournamentId: e.tournamentId, participants: [i] } }), { ...V };
}
function p0({ clearExistingAssignments: e = !0, individualParticipantIds: t, reverseAssignmentOrder: r, initialTeamIndex: i = 0, scaledParticipants: n = [], teamParticipantIds: a, tournamentRecord: o, scaleAttributes: s, teamNameBase: c, teamsCount: u, eventId: d, event: p }) {
  var I, y, U, S, D;
  if (!o)
    return { error: ae };
  if (!Array.isArray(a) && !Pe(u) && !d || !Pe(i) || n && !Array.isArray(n) || s && (typeof s != "object" || !Object.keys(s).length))
    return { error: J };
  if (!s && !n.length || !n && !(t && s))
    return { error: Ie, info: "Missing scaling details" };
  if (d && !a) {
    if ((p == null ? void 0 : p.eventType) !== Xr)
      return { error: Mn };
    a = (I = p == null ? void 0 : p.entries) == null ? void 0 : I.filter(({ entryStatus: w }) => w === $r).map(Ce);
  }
  if (!(a != null && a.length) && !u)
    return { info: "Missing teamParticipantIds or teamsCount", error: Ie };
  let l = t ?? n.map(({ participantId: w }) => w);
  r && (a == null || a.reverse(), i += 1), i > ((a == null ? void 0 : a.length) || 0) - 1 && (i = 0);
  let m = (a == null ? void 0 : a.slice(i).concat(...a.slice(0, i))) ?? [], f = [];
  for (let w of o.participants ?? []) {
    let { participantId: v, participantType: P } = w;
    if (m.includes(v)) {
      if (P !== Nr)
        return { error: Xi, participant: w };
      f.push(w);
    }
  }
  if (u && f.length < u) {
    let w = u - ((f == null ? void 0 : f.length) || 0), v = c ?? "Team", P = oe(0, w).map((M) => ({ participantName: `${v} ${M + 1}`, participantType: Nr, participantRole: ur })), { participants: b = [] } = ji({ participants: P, returnParticipants: !0, tournamentRecord: o }), T = b.map(Ce), R = ((y = o.participants) == null ? void 0 : y.filter(({ participantId: M }) => T.includes(M))) ?? [];
    f.push(...R);
  }
  if (!f.length)
    return { error: Bh };
  if (e)
    for (let w of f)
      w.individualParticipantIds = [];
  else {
    let w = f.map((v) => v).flat();
    t != null && t.length ? l = l.filter((v) => !w.includes(v)) : n = n == null ? void 0 : n.filter(({ participantId: v }) => !w.includes(v));
  }
  if (!(t != null && t.length) && !(n != null && n.length))
    return { error: Jl, info: "Nothing to be done" };
  if (!n.length) {
    for (let w of o.participants ?? []) {
      let { participantId: v, participantType: P } = w;
      if (!l.includes(v))
        continue;
      if (P !== Oe)
        return { error: Xi, participant: w };
      let b = (U = Tn({ scaleAttributes: s, participant: w })) == null ? void 0 : U.scaleItem, T = s != null && s.accessor ? (S = b == null ? void 0 : b.scaleValue) == null ? void 0 : S[s == null ? void 0 : s.accessor] : b == null ? void 0 : b.scaleValue, R = { participantId: v, scaleValue: T };
      n.push(R);
    }
    if (!n.length)
      return { error: Dt };
  }
  n.sort((w, v) => s != null && s.sortOrder ? ((v == null ? void 0 : v.scaleValue) || 0) - ((w == null ? void 0 : w.scaleValue) || 0) : ((w == null ? void 0 : w.scaleValue) || 1 / 0) - ((v == null ? void 0 : v.scaleValue) || 1 / 0));
  for (let w of n)
    if (!w.participantId)
      return { error: J, scaledParticipant: w };
  let h = 0;
  for (; h < n.length; ) {
    for (let w of f) {
      if (h + 1 > n.length)
        break;
      let v = n[h];
      w.individualParticipantIds.push(v.participantId), h++;
    }
    f.reverse();
  }
  let g = f.map(Ce);
  for (let w of o.events ?? []) {
    if (w.eventType !== Xr)
      continue;
    let v = (w.entries ?? []).filter((P) => g.includes(P.participantId));
    for (let P of v) {
      let b = P.participantId, T = (D = f.find((M) => M.participantId === b)) == null ? void 0 : D.individualParticipantIds;
      w.entries = (w.entries ?? []).filter((M) => !T.includes(M.participantId)), (w.drawDefinitions ?? []).forEach((M) => {
        M.entries = (M.entries ?? []).filter((E) => !T.includes(E.participantId));
      });
      let { flightProfile: R } = Pt({ event: w });
      ((R == null ? void 0 : R.flights) || []).forEach((M) => {
        M.drawEntries = (M.drawEntries || []).filter((E) => !T.includes(E.participantId));
      });
    }
  }
  return { ...V, scaledParticipants: n };
}
function m0(e) {
  let t = fe(e, [{ [Gt]: !0, [dg]: !0 }, { ratingType: !1, [cr]: (o) => Wt[o] }]);
  if (t.error)
    return t;
  let r = `${e.ratingType}.${fg}`, i = e.asDynamic ? r : e.ratingType, n = [za, la, e.eventType, i].join("."), a = e.tournamentRecord.participants ?? [];
  for (let o of a)
    o.timeItems && (o.timeItems = o.timeItems.filter((s) => s.itemType !== n));
  return { ...V };
}
function f0(e) {
  let { tournamentRecords: t } = e;
  if (typeof t != "object" || !Object.keys(t).length)
    return { error: yt };
  for (let r of Object.values(t)) {
    let i = _V({ ...e, tournamentRecord: r });
    if (i.error && i.error !== ks)
      return i;
  }
  return { ...V };
}
function _V({ tournamentRecord: e, penaltyId: t }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: kh };
  let r = (e == null ? void 0 : e.participants) ?? [], i = [], n = !1, a;
  return r.forEach((o) => {
    let s = !1;
    o.penalties = (o.penalties ?? []).filter((c) => (c.penaltyId === t && (s = !0, n || (a = c, n = !0)), s && i.push(o), c.penaltyId !== t));
  }), a && De({ topic: pr, payload: { tournamentId: e.tournamentId, participants: i } }), a ? { ...V, penalty: a } : { error: ks };
}
var BV = ({ penaltyId: e = ze() } = {}) => ({ refereeParticipantId: void 0, penaltyCode: void 0, penaltyType: void 0, extensions: void 0, matchUpId: void 0, createdAt: void 0, issuedAt: void 0, notes: void 0, penaltyId: e }), h0 = BV;
function g0(e) {
  let { tournamentRecords: t } = e;
  if (typeof t != "object" || !Object.keys(t).length)
    return { error: yt };
  for (let r of Object.values(t)) {
    let i = VV({ ...e, tournamentRecord: r });
    if (i.error && i.error !== ks || i.success)
      return i;
  }
  return { error: ks };
}
function VV({ tournamentRecord: e, modifications: t, penaltyId: r }) {
  if (!e)
    return { error: ae };
  if (!t)
    return { error: J, modifications: t };
  if (!r)
    return { error: kh };
  let i = (e == null ? void 0 : e.participants) ?? [], n = Object.keys(h0()).filter((c) => c !== "penaltyId"), a = Object.keys(t).filter((c) => n.includes(c));
  if (!a.length)
    return { error: Xl };
  let o, s = [];
  return i.forEach((c) => {
    let u = !1;
    c.penalties = (c.penalties ?? []).map((d) => (d.penaltyId === r && (u = !0, a.forEach((p) => Object.assign(d, { [p]: t[p] })), o || (o = d)), d)), u && s.push(c);
  }), o && De({ topic: pr, payload: { tournamentId: e.tournamentId, participants: s } }), o ? { ...V, penalty: o } : { error: ks };
}
function I0(e, t, r) {
  return !e && t ? t : e && !t || typeof e != "object" || typeof t != "object" ? e : Te(Object.keys(e).concat(Object.keys(t))).reduce((i, n) => {
    if (!t[n])
      i[n] = e[n];
    else if (!e[n])
      i[n] = t[n];
    else if (typeof e[n] != typeof t[n])
      i[n] = t[n];
    else if (Array.isArray(e[n]))
      if (r === !0 || Array.isArray(r) && r.includes(n)) {
        let a = Te(e[n].map((o) => JSON.stringify(o)).concat(t[n].map((o) => JSON.stringify(o)))).map((o) => JSON.parse(o));
        i[n] = a;
      } else
        i[n] = t[n];
    else
      typeof e[n] == "object" ? i[n] = I0(e[n], t[n], r) : i[n] = t[n];
    return i;
  }, {});
}
function U0({ participants: e = [], tournamentRecord: t, arraysToMerge: r }) {
  if (!t)
    return { error: ae };
  t.participants || (t.participants = []);
  let i = e.filter(ei(Cn)).map((u) => ({ [u.participantId]: u })), n = Object.assign({}, ...i), a = [];
  t.participants = t.participants.map((u) => {
    if (n[u.participantId]) {
      let d = I0(u, n[u.participantId], r);
      return a.push(d), d;
    }
    return u;
  });
  let o = t.participants.map(ei(Cn)) || [], s = e.filter(({ participantId: u }) => !o.includes(u)), { topics: c } = vi();
  return s.length && (t.participants = t.participants.concat(...s), c.includes(Ua) && De({ topic: Ua, payload: { participants: s } })), a.length && c.includes(pr) && De({ topic: pr, payload: { tournamentId: t.tournamentId, participants: a } }), { modifiedParticipantsCount: a.length, newParticipantsCount: s.length, ...V };
}
function y0(e) {
  var a;
  let { tournamentRecord: t, participantIds: r } = e, i = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, n;
  for (let o of Object.values(i)) {
    let s = (a = Ut({ tournamentRecord: o }).participants ?? []) == null ? void 0 : a.map(Ce).filter((c) => r.includes(c));
    s.length && (n = jV({ ...e, penaltyId: e.penaltyId ?? n, tournamentRecord: o, participantIds: s }).penaltyId);
  }
  return n ? { ...V, penaltyId: n } : { error: Dt };
}
function jV({ refereeParticipantId: e, tournamentRecord: t, participantIds: r, penaltyCode: i, penaltyType: n, extensions: a, penaltyId: o, matchUpId: s, issuedAt: c, notes: u }) {
  if (!t)
    return { error: ae };
  if (!r)
    return { error: _t };
  if (!n)
    return { error: yw };
  let d = ((t == null ? void 0 : t.participants) ?? []).filter((m) => r.includes(m.participantId));
  if (!d.length)
    return { error: Dt };
  let p = (/* @__PURE__ */ new Date()).toISOString(), l = Object.assign(h0({ penaltyId: o }), { refereeParticipantId: e, penaltyCode: i, penaltyType: n, matchUpId: s, createdAt: p, issuedAt: c, notes: u });
  return Array.isArray(a) && a.forEach((m) => Ve({ element: l, extension: m })), d.forEach((m) => {
    m.penalties || (m.penalties = []), m.penalties.push(l);
  }), De({ topic: pr, payload: { tournamentId: t.tournamentId, participants: d } }), { ...V, penaltyId: l.penaltyId };
}
function S0({ participantRole: e = ur, tournamentRecord: t, persons: r }) {
  var f;
  if (!t)
    return { error: ae };
  if (!Array.isArray(r))
    return { error: J };
  if (!Object.keys(aI).includes(e))
    return { error: cw };
  let i = (t.participants || []).map(({ person: h }) => h == null ? void 0 : h.personId).filter(Boolean), n = [], a = r.filter((h) => h && (!h.personId || !i.includes(h.personId))).map((h) => (h.personId || (h.personId = ze()), n.push(h.personId), h)), o = (h, g) => Object.assign({}, ...Object.keys(h).filter((I) => !g.includes(I)).map((I) => ({ [I]: h[I] }))), s = a.map((h) => me({ extensions: h.participantExtensions, timeItems: h.participantTimeItems, participantType: Oe, participantRole: e, person: o(h, ["participantExtensions", "participantTimeItems", "pairedPersons"]) })), c = 0, u = 0, d = ji({ participants: s, tournamentRecord: t });
  if (d.error)
    return d;
  u = d.addedCount || 0;
  let p = [], l = ((f = Ut({ participantFilters: { participantTypes: [Oe] }, tournamentRecord: t })) == null ? void 0 : f.participants) ?? [];
  if (e === ur && r.filter(({ pairedPersons: h }) => h).forEach(({ personId: h, pairedPersons: g }) => {
    Array.isArray(g) && g.forEach((I) => {
      let y = [h, I.personId].map((U) => ga({ tournamentParticipants: l, personId: U })).filter(Boolean);
      if (y.length === 2) {
        let U = y.map(Ce);
        p.push(me({ extensions: I.participantExtensions, timeItems: I.timeItems, participantRole: ur, individualParticipantIds: U, participantType: Re }));
      }
    });
  }), p.length) {
    if (d = ji({ participants: p, tournamentRecord: t }), d.error)
      return d;
    c = d.addedCount || 0;
  }
  let m = u + c;
  return { ...V, addedCount: m, newPersonIds: n };
}
var v0 = {};
Ae(v0, { bulkUpdatePublishedEventIds: () => SU, getAllEventData: () => vU, getCourtInfo: () => Op, getDrawData: () => lm, getEventData: () => pm, getEventPublishStatus: () => bi, getPublishState: () => us, getTournamentPublishStatus: () => nd, getVenueData: () => zs, mutate: () => w0, publishEvent: () => Nc, publishEventSeeding: () => P0, publishOrderOfPlay: () => M0, publishParticipants: () => R0, query: () => sM, setEventDisplay: () => Tm, unPublishEvent: () => N0, unPublishEventSeeding: () => D0, unPublishOrderOfPlay: () => b0, unPublishParticipants: () => T0 });
var w0 = {};
Ae(w0, { publishEvent: () => Nc, publishEventSeeding: () => P0, publishOrderOfPlay: () => M0, publishParticipants: () => R0, setEventDisplay: () => Tm, unPublishEvent: () => N0, unPublishEventSeeding: () => D0, unPublishOrderOfPlay: () => b0, unPublishParticipants: () => T0 });
function P0({ removePriorValues: e = !0, stageSeedingScaleNames: t, seedingScaleNames: r, tournamentRecord: i, status: n = li, drawIds: a = [], event: o }) {
  var p, l, m, f;
  if (!i)
    return { error: ae };
  if (!o)
    return { error: pt };
  let s = bi({ event: o, status: n }), c = (((p = s == null ? void 0 : s.seeding) == null ? void 0 : p.seedingScaleNames) || r) && { ...(l = s == null ? void 0 : s.seeding) == null ? void 0 : l.seedingScaleNames, ...r }, u = (((m = s == null ? void 0 : s.seeding) == null ? void 0 : m.stageSeedingScaleNames) || t) && { ...(f = s == null ? void 0 : s.seeding) == null ? void 0 : f.stageSeedingScaleNames, ...t }, d = me({ stageSeedingScaleNames: u, seedingScaleNames: c, published: !0, drawIds: a });
  return Mc({ statusObject: { seeding: d }, removePriorValues: e, status: n, event: o }), De({ topic: TD, payload: { tournamentId: i.tournamentId, eventId: o.eventId, drawIds: a } }), { ...V };
}
function D0({ removePriorValues: e = !0, seedingScaleNames: t, tournamentRecord: r, status: i = li, drawIds: n, stages: a, event: o }) {
  var c, u;
  if (!r)
    return { error: ae };
  if (!o)
    return { error: pt };
  let s = bi({ event: o });
  if (s) {
    let d = s.seeding;
    if (Array.isArray(a) && d.stageSeedingScaleNames)
      for (let p of a)
        d.stageSeedingScaleNames[p] && delete d.stageSeedingScaleNames[p];
    Array.isArray(t) && (d != null && d.seedingScaleNames) && (d.seedingScaleNames = d.seedingScaleNames.filter((p) => !t.includes(p))), Array.isArray(n) && (d != null && d.drawIds) && (d.drawIds = d.drawIds.filter((p) => !n.includes(p))), (!Object.values(d.stageSeedingScaleNames ?? {}).length && !((c = d.seedingScaleNames) != null && c.length) && !((u = d.drawIds) != null && u.length) || !a && !t && !(n != null && n.length)) && (delete d.stageSeedingScaleNames, delete d.seedingScaleNames, delete d.drawIds, d.published = !1), Mc({ statusObject: { seeding: d }, removePriorValues: e, status: i, event: o });
  }
  return De({ topic: xg, payload: { tournamentId: r.tournamentId, eventId: o.eventId } }), { ...V };
}
function T0(e) {
  let t = wi(e);
  if (!Object.keys(t).length)
    return { error: yt };
  for (let r of Object.values(t)) {
    let i = GV({ tournamentRecord: r, ...e });
    if (i.error)
      return i;
  }
  return { ...V };
}
function GV({ removePriorValues: e = !0, tournamentRecord: t, status: r = li }) {
  if (!t)
    return { error: ae };
  let i = `${Ea}.${Ca}`, { timeItem: n } = Pi({ element: t, itemType: i }), a = (n == null ? void 0 : n.itemValue) || { [r]: {} };
  return a[r] && delete a[r].participants, yn({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), De({ payload: { tournamentId: t.tournamentId }, topic: rO }), { ...V };
}
function b0(e) {
  let t = wi(e);
  if (!Object.keys(t).length)
    return { error: yt };
  for (let r of Object.values(t)) {
    let i = $V({ tournamentRecord: r, ...e });
    if (i.error)
      return i;
  }
  return { ...V };
}
function $V({ removePriorValues: e = !0, tournamentRecord: t, status: r = li }) {
  if (!t)
    return { error: ae };
  let i = `${Ea}.${Ca}`, { timeItem: n } = Pi({ element: t, itemType: i }), a = (n == null ? void 0 : n.itemValue) || { [r]: {} };
  return a[r] && delete a[r].orderOfPlay, yn({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), De({ topic: Lg, payload: { tournamentId: t.tournamentId } }), { ...V };
}
function R0(e) {
  let t = wi(e);
  if (!Object.keys(t).length)
    return { error: yt };
  for (let r of Object.values(t)) {
    let i = qV({ tournamentRecord: r, ...e });
    if (i.error)
      return i;
  }
  return { ...V };
}
function qV({ removePriorValues: e, tournamentRecord: t, status: r = li }) {
  if (!t)
    return { error: ae };
  let i = `${Ea}.${Ca}`, { timeItem: n } = Pi({ element: t, itemType: i }), a = (n == null ? void 0 : n.itemValue) || { [r]: {} };
  return a[r].participants = { published: !0 }, yn({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), De({ payload: { tournamentId: t.tournamentId }, topic: RD }), { ...V };
}
function M0(e) {
  let t = wi(e);
  if (!Object.keys(t).length)
    return { error: yt };
  for (let r of Object.values(t)) {
    let i = WV({ tournamentRecord: r, ...e });
    if (i.error)
      return i;
  }
  return { ...V };
}
function WV({ scheduledDates: e = [], removePriorValues: t, tournamentRecord: r, status: i = li, eventIds: n = [] }) {
  if (!r)
    return { error: ae };
  let a = `${Ea}.${Ca}`, { timeItem: o } = Pi({ element: r, itemType: a }), s = (o == null ? void 0 : o.itemValue) || { [i]: {} };
  return s[i].orderOfPlay = { published: !0, scheduledDates: e, eventIds: n }, yn({ timeItem: { itemValue: s, itemType: a }, element: r, removePriorValues: t }), De({ topic: bD, payload: { tournamentId: r.tournamentId, scheduledDates: e, eventIds: n } }), { ...V };
}
function N0({ removePriorValues: e = !0, tournamentRecord: t, status: r = li, event: i }) {
  if (!t)
    return { error: ae };
  if (!i)
    return { error: pt };
  let n = `${Ea}.${Ca}`, { timeItem: a } = Gu({ itemType: n, event: i }), o = (a == null ? void 0 : a.itemValue) || { [r]: {} };
  return delete o[r].structureIds, delete o[r].drawDetails, delete o[r].drawIds, ms({ event: i, timeItem: { itemValue: o, itemType: n }, removePriorValues: e }), Mc({ statusObject: { structureIds: void 0, drawIds: void 0, seeding: void 0 }, removePriorValues: e, status: r, event: i }), De({ topic: Fg, payload: { tournamentId: t.tournamentId, eventId: i.eventId } }), { eventId: i.eventId, ...V };
}
var A0 = {};
Ae(A0, { getEntryStatusReports: () => zV, getParticipantStats: () => HV, getStructureReports: () => KV, getVenuesReport: () => JV });
function HV({ withCompetitiveProfiles: e, opponentParticipantId: t, withIndividualStats: r, teamParticipantId: i, tournamentRecord: n, withScaleValues: a, tallyPolicy: o, matchUps: s }) {
  var v, P, b, T, R;
  if (!n)
    return { error: ae };
  if (s && !Array.isArray(s))
    return { error: jr };
  if (s = s ?? tr({ tournamentRecord: n, participantsProfile: a ? { withScaleValues: a } : void 0 }).matchUps, !(s != null && s.length))
    return { error: Zn };
  let c = [];
  t && c.push(t), i && c.push(i);
  let u = c.length ? { participantIds: c } : { participantTypes: [Nr] }, d = Ut({ participantFilters: u, tournamentRecord: n }).participants ?? [];
  if (!d.every(({ participantType: M }) => M === Nr))
    return { error: Yr };
  c.length || c.push(...d.map(Ce));
  let p = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), h = (M, E = "") => l.get(M) || l.set(M, { participantName: E, participantId: M, competitorIds: [], competitiveness: {}, matchUpStatuses: {}, tiebreaks: [0, 0], matchUps: [0, 0], points: [0, 0], games: [0, 0], sets: [0, 0] }) && l.get(M);
  for (let M of d) {
    let { participantId: E, individualParticipantIds: C } = M;
    f.set(E, C ?? []), h(E, M.participantName);
  }
  if (i && !f.get(i))
    return j({ result: { error: Dt }, context: { teamParticipantId: i } });
  if (t && !f.get(t))
    return j({ result: { error: Dt }, context: { opponentParticipantId: t } });
  let g = [], I = (M) => {
    let E = [[], []];
    for (let A of M) {
      let N = A.participant;
      if (N != null && N.participantName) {
        p.set(N.participantId, { participantName: N.participantName, ratings: N.ratings });
        let O = l.get(N.participantId);
        O && (O.participantName = N.participantName);
      }
    }
    let C = ({ side: A, individualParticipantIds: N }) => {
      var O, k, F, x, _;
      return A.participantId && (!(N != null && N.length) || N.includes(A.participantId)) && [A.participantId] || ((k = (O = A.participant) == null ? void 0 : O.individualParticipantIds) == null ? void 0 : k.length) && (!(N != null && N.length) || wt(N, (F = A.participant) == null ? void 0 : F.individualParticipantIds).length === ((_ = (x = A.participant) == null ? void 0 : x.individualParticipantIds) == null ? void 0 : _.length)) && A.participant.individualParticipantIds;
    };
    if (f.size) {
      let A = (N, O) => {
        for (let k of M) {
          if (!k.participant)
            continue;
          let F = C({ individualParticipantIds: O, side: k });
          if (F != null && F.length) {
            let x = k.sideNumber;
            if (!x)
              continue;
            let _ = [N];
            r && _.push(...F), E[x - 1] = _;
            let B = l.get(N);
            for (let L of F.filter(Boolean))
              B && !B.competitorIds.includes(L) && B.competitorIds.push(L);
          }
        }
      };
      if (i)
        (!t || M.every((N) => N.participant && (C({ individualParticipantIds: f.get(i), side: N }) || C({ individualParticipantIds: f.get(t), side: N })))) && A(i, f.get(i));
      else
        for (let [N, O] of f)
          A(N, O);
    } else if (r)
      for (let A of M) {
        if (!A.participant)
          continue;
        let N = C({ individualParticipantIds: [], side: A }), O = A.sideNumber;
        O && (E[O - 1] = N);
      }
    return E;
  };
  for (let M of s) {
    if (!Le(M))
      return { error: jr };
    let { matchUpStatus: E, matchUpFormat: C, matchUpType: A, winningSide: N, score: O, sides: k } = M;
    if (!k || !O || A === ni || E === $e)
      continue;
    let F = I(k);
    if (!F.filter(Boolean).length)
      continue;
    let x = e && N && ((v = Ju({ matchUp: M })) == null ? void 0 : v.competitiveness);
    g.push(M);
    let _ = NI({ matchUpStatus: E, matchUpFormat: C, tallyPolicy: o, winningSide: N, score: O }), B = lb({ matchUpStatus: E, matchUpFormat: C, tallyPolicy: o, winningSide: N, score: O }), { pointsTally: L, tiebreaksTally: G } = pb({ matchUpFormat: C, score: O });
    F.forEach(($, W) => {
      var q;
      for (let K of $) {
        let z = (q = p.get(K)) == null ? void 0 : q.participantName, Y = h(K, z);
        if (Y) {
          let X = (ee, te) => te.forEach((ne, se) => Y[ee][se] += ne), re = W ? [...G].reverse() : G, Q = W ? [...L].reverse() : L, H = W ? [...B].reverse() : B, Z = W ? [..._].reverse() : _;
          if (X("tiebreaks", re), X("points", Q), X("games", H), X("sets", Z), N) {
            let ee = N - 1 === W ? 0 : 1;
            Y.matchUps[ee] += 1;
          }
          if (x) {
            let ee = x.toLowerCase();
            Y.competitiveness[ee] || (Y.competitiveness[ee] = [0, 0]), Y.competitiveness[ee][W] += 1;
          }
          if (E) {
            let ee = E.toLowerCase();
            Y.matchUpStatuses[ee] || (Y.matchUpStatuses[ee] = 0), Y.matchUpStatuses[ee] += 1;
          }
        }
      }
    });
  }
  let y = ["tiebreaks", "matchUps", "points", "games", "sets"], U = ["competitive", "routine", "decisive"], S = /* @__PURE__ */ new Map(), D = (M, E) => (M ?? 0) + (E ?? 0);
  for (let [M, E] of l.entries()) {
    for (let C of y) {
      let A = E[C].reduce(D);
      if (A) {
        let N = E[C][0] / A, O = `${C}Ratio`, k = parseFloat(N.toFixed(2));
        E[O] = k, m.set(M, !0), S.has(O) || S.set(O, []), (P = S.get(O)) == null || P.push(k);
      }
    }
    for (let C of U) {
      let A = (T = (b = E.competitiveness) == null ? void 0 : b[C]) == null ? void 0 : T.reduce(D);
      if (A) {
        let N = E.competitiveness[C][0] / A, O = `${C}Ratio`, k = parseFloat(N.toFixed(2));
        E[O] = k;
      }
    }
  }
  if (!i) {
    let M = (E, C) => C - E;
    for (let E of l.values())
      for (let C of y) {
        let A = `${C}Ratio`;
        if (typeof E[A] == "number") {
          let N = (R = S.get(A)) == null ? void 0 : R.sort(M).indexOf(E[A]);
          if (typeof N == "number" && N >= 0) {
            let O = `${C}Rank`;
            E[O] = N + 1;
          }
        }
      }
  }
  let w = { relevantMatchUps: g, ...V };
  return i ? (w.teamStats = l.get(i), t && (w.opponentStats = l.get(t))) : w.participatingTeamsCount = m.size, w.allParticipantStats = [...l.values()], w;
}
function _l({ participant: e, eventType: t }) {
  var u, d, p, l, m, f;
  let r = (u = e == null ? void 0 : e.person) == null ? void 0 : u.personId, i = (p = (d = e == null ? void 0 : e.person) == null ? void 0 : d.personOtherIds) == null ? void 0 : p[0], n = (l = e == null ? void 0 : e.person) == null ? void 0 : l.tennisId, a = (f = (m = e == null ? void 0 : e.ratings) == null ? void 0 : m[t]) == null ? void 0 : f.find(({ scaleName: h }) => h === MI), o = a == null ? void 0 : a.scaleValue, { wtnRating: s, confidence: c } = o || {};
  return { timeStamp: a == null ? void 0 : a.scaleDate, personOtherId: i, confidence: c, wtnRating: s, personId: r, tennisId: n };
}
function zV({ tournamentRecord: e }) {
  if (!e)
    return { error: ae };
  let t = e.tournamentId, { participantMap: r } = Ut({ withScaleValues: !0, withEvents: !0, withSeeding: !0, tournamentRecord: e, withDraws: !0 }), i = (tr({ matchUpFilters: { matchUpTypes: [wo, Ga] }, tournamentRecord: e }).matchUps ?? []).flatMap(({ sides: m, matchUpType: f }) => m == null ? void 0 : m.flatMap((h) => {
    var g, I;
    return f === Ga ? (g = h == null ? void 0 : h.participant) == null ? void 0 : g.individualParticipantIds : ((I = h == null ? void 0 : h.participant) == null ? void 0 : I.participantId) || h.participantId;
  }).filter(Boolean)).filter(Boolean), n = [], a = {}, o = {}, s = {}, c = 0, u = ({ id: m, entry: f, eventId: h, eventType: g }) => {
    var T;
    let { qualifyingSeeding: I, mainSeeding: y, entryStatus: U, entryStage: S, drawId: D } = f;
    a[m] || (a[m] = []);
    let { participant: w, events: v } = (r == null ? void 0 : r[m]) ?? {}, P = _l({ participant: w, eventType: g }), b = (T = v == null ? void 0 : v[h]) == null ? void 0 : T.ranking;
    U === PI && n.push(m), a[m].push({ participantType: w == null ? void 0 : w.participantType, participantId: m, tournamentId: t, eventType: g, eventId: h, drawId: D, entryStatus: U, entryStage: S, ...P, ranking: b, mainSeeding: y, qualifyingSeeding: I });
  };
  for (let m of e.events ?? []) {
    let f = {}, h = (v) => {
      f[v] || (f[v] = { count: 0 }), f[v].count += 1;
    }, { drawDefinitions: g = [], eventType: I, eventId: y } = m, U = g.flatMap((v) => {
      let { drawId: P, entries: b } = v;
      c += 1;
      let T = ({ stage: C, stageSequence: A }) => C === ue && A === 1 || C === ge, R = (v.structures ?? []).filter(T).flatMap(({ positionAssignments: C }) => C).filter(Boolean).map(({ participantId: C }) => C), M = ({ participantId: C }) => R.includes(C), E = (C) => {
        var F, x, _, B, L, G, $, W;
        let { participantId: A, entryStatus: N, entryStage: O } = C;
        h(N);
        let k = (B = (_ = (x = (F = r == null ? void 0 : r[A]) == null ? void 0 : F.draws) == null ? void 0 : x[P]) == null ? void 0 : _.seedAssignments) == null ? void 0 : B[ue];
        return { qualifyingSeeding: (W = ($ = (G = (L = r == null ? void 0 : r[A]) == null ? void 0 : L.draws) == null ? void 0 : G[P]) == null ? void 0 : $.seedAssignments) == null ? void 0 : W[ge], participantId: A, mainSeeding: k, entryStatus: N, entryStage: O, drawId: P };
      };
      return b == null ? void 0 : b.filter(M).map(E);
    }), S = (v) => {
      var T;
      let P = v.participantId, b = (T = r == null ? void 0 : r[P].participant.individualParticipantIds) == null ? void 0 : T.filter((R) => i.includes(R));
      return P && { [P]: { individualParticipantIds: b } };
    };
    I === qn ? (() => {
      let v = Object.assign({}, ...U.map(S).filter(Boolean)), P = (b) => {
        v[b.participantId].individualParticipantIds.forEach((T) => {
          u({ id: T, eventType: I, eventId: y, entry: b });
        });
      };
      U.forEach(P);
    })() : U.forEach((v) => {
      u({ id: v == null ? void 0 : v.participantId, eventType: I, eventId: y, entry: v });
    });
    let D = Object.values(f).reduce((v, P) => v + P.count, 0);
    Object.keys(f).forEach((v) => {
      f[v].pct = f[v].count / D * 100;
    }), s[y] = { tournamentId: t, eventId: y, entries: U, entryStatuses: f };
    let w = Object.assign({}, ...$i.flatMap((v) => {
      var P, b;
      return [{ [v + "_count"]: (P = f[v]) == null ? void 0 : P.count }, { [v + "_pct"]: (b = f[v]) == null ? void 0 : b.pct }];
    }));
    o[y] = { tournamentId: t, eventId: y, ...w };
  }
  let d = Object.values(r ?? {}).filter(({ participant: { participantType: m, participantRole: f } }) => m === Oe && f === ur), p = d.filter(({ participant: m }) => !i.includes(m.participantId)).map(({ participant: m }) => m.participantId), l = { nonParticipatingEntriesCount: p.length, individualParticipantsCount: d.length, eventsCount: Object.values(s).length, nonParticipatingParticipantIds: p, drawDefinitionsCount: c, tournamentId: t };
  return { entryStatusReports: Object.values(o).flat(), participantEntryReports: Object.values(a).flat(), eventReports: Object.values(s).flat(), withDrawnParticipantIds: n, tournamentEntryReport: l };
}
function YV({ eventType: e, matchUps: t, eventId: r, drawId: i }) {
  let n = {}, a = (f) => {
    let h = f == null ? void 0 : f.matchUpFormat;
    h && (n[h] || (n[h] = 0), n[h] += 1);
  }, o = t.filter((f) => r ? f.eventId === r : f.drawId === i).reduce((f, h) => (a(h), (h.sides ?? []).flatMap((g) => {
    var I;
    return (((I = g == null ? void 0 : g.participant) == null ? void 0 : I.individualParticipants) || [g == null ? void 0 : g.participant]).filter(Boolean);
  }).forEach((g) => f[g.participantId] = g), f), {}), s = Object.values(o), c = s.map((f) => _l({ participant: f, eventType: e })).filter(({ wtnRating: f }) => f), u = (s.length - c.length) / s.length * 100, d = c.reduce((f, h) => {
    let { wtnRating: g, confidence: I } = h;
    return f.totalWTN += g, f.totalConfidence += I, f;
  }, { totalWTN: 0, totalConfidence: 0 }), p = c != null && c.length ? d.totalWTN / c.length : 0, l = c != null && c.length ? d.totalConfidence / c.length : 0, m = Object.values(n).reduce((f, h) => f + (h || 0), 0);
  return { matchUpFormatCounts: n, matchUpsCount: m, avgConfidence: l, pctNoRating: u, avgWTN: p };
}
function KV(e) {
  var f;
  let { tournamentRecord: t, extensionProfiles: r, firstFlightOnly: i } = e;
  if (!t)
    return { error: Cs };
  let n = [], a = {}, o = {}, s = [], c = Object.assign({}, ...(r ?? []).map(({ name: h, label: g, accessor: I }) => {
    var S, D, w;
    let y = (D = (S = Ne({ element: t, name: h })) == null ? void 0 : S.extension) == null ? void 0 : D.value, U = I ? (w = To({ element: y, accessor: I })) == null ? void 0 : w.value : y;
    return { [g || h]: U };
  })), u = t == null ? void 0 : t.tournamentId, d = tr({ participantsProfile: { withScaleValues: !0 }, tournamentRecord: t }).matchUps ?? [], p = (h) => {
    var g, I, y;
    return (y = (I = (g = Pi({ itemType: Dg, itemSubTypes: [Pn], element: { timeItems: h } })) == null ? void 0 : g.timeItem) == null ? void 0 : I.itemValue) == null ? void 0 : y.scaleBasis;
  }, l = ({ positionManipulations: h }) => {
    h == null || h.forEach((g) => {
      let { structureId: I, name: y } = g, U = g.drawPositions || [g.drawPosition];
      a[I] || (a[I] = []), a[I].push(`${y}: ${U.join("/")}`);
    });
  }, m = (f = t == null ? void 0 : t.events) == null ? void 0 : f.flatMap(({ timeItems: h, drawDefinitions: g = [], extensions: I, eventType: y, eventName: U, eventId: S, category: D }) => {
    var C, A, N, O;
    let w = (N = (A = (C = I == null ? void 0 : I.find((k) => k.name === _i)) == null ? void 0 : C.value) == null ? void 0 : A.flights) == null ? void 0 : N.map((k) => ({ [k.drawId]: k.flightNumber })), v = w && Object.assign({}, ...w), P = I == null ? void 0 : I.find((k) => k.name === Va), b = h == null ? void 0 : h.find((k) => k.itemType === Va), T = ((O = P == null ? void 0 : P.value) == null ? void 0 : O.length) || (b == null ? void 0 : b.itemValue) || 0, R = Object.values(v ?? {}), M = v && Math.min(...R), E = p(h);
    return o[S] = { seedingBasis: E ? JSON.stringify(E) : void 0, totalPositionManipulations: 0, maxPositionManipulations: 0, generatedDrawsCount: 0, drawDeletionsCount: T, tournamentId: u, eventId: S }, g.filter((k) => !i || !w || v[k.drawId] === M).flatMap((k) => {
      let { matchUpFormat: F, tieFormat: x, timeItems: _, extensions: B, structures: L, drawName: G, drawType: $, drawId: W } = k, { matchUpFormatCounts: q, matchUpsCount: K, avgConfidence: z, pctNoRating: Y, avgWTN: X } = YV({ eventType: y, matchUps: d, drawId: W }), re = p(_) || E, Q = QV({ extensions: B }), H = (Q == null ? void 0 : Q.length) || 0;
      return l({ positionManipulations: Q }), o[S].totalPositionManipulations += H, o[S].generatedDrawsCount += 1, H > o[S].maxPositionManipulations && (o[S].maxPositionManipulations = H), L == null ? void 0 : L.filter((Z) => Z.stageSequence === 1 && [ge, ue, lr, vt].includes(Z.stage)).map((Z) => {
        var Kt, At, kr;
        let ee = [ue, vt].includes(Z.stage) ? d.find((Me) => Me.structureId === Z.structureId && Me.finishingRound === 1 && Me.winningSide) : void 0;
        Z.stage === ue && n.push({ eventName: U, drawName: G, structureId: Z.structureId });
        let te = (At = (Kt = ee == null ? void 0 : ee.sides) == null ? void 0 : Kt.find((Me) => Me.sideNumber === ee.winningSide)) == null ? void 0 : At.participant, ne = (te == null ? void 0 : te.participantType) === Nr && te.participantId, se = (te == null ? void 0 : te.participantType) === Re ? te.individualParticipants : [], ie = _l({ participant: (se == null ? void 0 : se[0]) || te, eventType: y }), { personId: he, personOtherId: Ee, tennisId: de, confidence: it, wtnRating: qe } = ie || {}, ar = _l({ participant: se == null ? void 0 : se[1], eventType: y }), { personId: $t, personOtherId: Ue, tennisId: Se, confidence: pe, wtnRating: We } = ar || {}, { ageCategoryCode: Ge, categoryName: nt, subType: Ze } = D ?? {}, st = Z.matchUpFormat || F, qt = (q[st] || 0) / K * 100, { tieFormatName: Ct, tieFormatDesc: Mt } = El(x), { tieFormatName: Ye, tieFormatDesc: He } = El(Z.tieFormat), rr = Mt === He, Je = !rr && Ye, Nt = Z.tieFormat && !rr && He, Wi = ((kr = Q == null ? void 0 : Q.filter((Me) => Me.structureId === Z.structureId)) == null ? void 0 : kr.length) || 0;
        return { ...c, tournamentId: u, eventId: S, structureId: Z.structureId, drawId: W, eventType: y, category: Ze, categoryName: nt, ageCategoryCode: Ge, flightNumber: v[W], drawType: $, stage: Z.stage, seedingBasis: re ? JSON.stringify(re) : void 0, winningPersonId: he, winningPersonOtherId: Ee, winningPersonTennisId: de, winningPersonWTNrating: qe, winningPersonWTNconfidence: it, winningPerson2Id: $t, winningPerson2OtherId: Ue, winningPerson2TennisId: Se, winningPerson2WTNrating: We, winningPerson2WTNconfidence: pe, winningTeamId: ne, positionManipulations: Wi, pctNoRating: Y, matchUpFormat: st, pctInitialMatchUpFormat: qt, matchUpsCount: K, drawTieFormatName: Ct, drawTieFormatDesc: Mt, tieFormatName: Je, tieFormatDesc: Nt, avgConfidence: z, avgWTN: X };
      });
    });
  });
  return n.forEach(({ eventName: h, drawName: g, structureId: I }) => {
    var y;
    (y = a[I]) != null && y.length && s.push({ eventName: h, drawName: g, actions: a[I] });
  }), { eventStructureReports: Object.values(o), structureReports: m, flightReports: s };
}
function QV({ extensions: e }) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.find(({ name: i }) => i === Ms)) == null ? void 0 : t.value) == null ? void 0 : r.slice(1);
}
function JV({ ignoreDisabled: e = !0, tournamentRecords: t, tournamentId: r, venueIds: i = [], dates: n = [] }) {
  var d, p;
  if (!Array.isArray(n))
    return { error: J, dates: n };
  if (!Array.isArray(i))
    return { error: J, venueIds: i };
  if (!(t && Object.keys(t).filter((l) => !r || l === r) || []).length)
    return { error: yt };
  if (!n.every(Kr))
    return { error: Qt };
  let a = aa({ tournamentRecords: t, ignoreDisabled: e, dates: n });
  if (a.error)
    return a;
  let o = (d = a == null ? void 0 : a.venues) == null ? void 0 : d.filter(({ venueId: l }) => !(i != null && i.length) || i.includes(l)), s = (p = a.courts) == null ? void 0 : p.reduce((l, m) => {
    var f;
    return (f = m.dateAvailability) == null || f.forEach((h) => {
      let g = h.date;
      l.includes(g) || l.push(g);
    }), l;
  }, []).filter((l) => !n.length || n.includes(l)), c = { venueIds: o == null ? void 0 : o.map(({ venueId: l }) => l) }, { matchUps: u } = en({ afterRecoveryTimes: !0, tournamentRecords: t, matchUpFilters: c });
  return { venuesReport: o == null ? void 0 : o.map((l) => XV(s, l, u)) };
}
function XV(e, t, r) {
  let { venueId: i, courts: n, venueName: a } = t, o = {};
  return e.forEach((s) => {
    var m;
    let c = 0, u = 0, d = 0;
    for (let f of n) {
      let h = f.dateAvailability.find((I) => I.date === s), g = (m = h && Ac({ courtDate: h }).timeSlots) == null ? void 0 : m.reduce((I, y) => {
        let { startTime: U, endTime: S } = y, D = _e(S) - _e(U);
        return I + D;
      }, 0);
      g && (d += 1), c += g;
    }
    let p = r.filter(({ schedule: f }) => f.venueId === i && Nn(s, f.scheduledDate));
    p.forEach(({ schedule: f }) => {
      let h = mt(f.scheduledTime), g = Br(h, f.averageMinutes), I = _e(g) - _e(h);
      u += I;
    });
    let l = c ? (u / c * 100).toFixed(2) : "100";
    o[s] = { scheduledMatchUpsCount: p.length, availableCourts: d, availableMinutes: c, scheduledMinutes: u, percentUtilization: l };
  }), { venueId: i, venueName: a, venueReport: o };
}
var E0 = {};
Ae(E0, { addMatchUpCourtOrder: () => iy, addMatchUpEndTime: () => ay, addMatchUpOfficial: () => gN, addMatchUpResumeTime: () => sy, addMatchUpScheduleItems: () => km, addMatchUpScheduledDate: () => Cm, addMatchUpScheduledTime: () => ka, addMatchUpStartTime: () => ny, addMatchUpStopTime: () => oy, addSchedulingProfileRound: () => Sy, allocateTeamMatchUpCourts: () => Om, assignMatchUpCourt: () => Is, assignMatchUpVenue: () => Cc, bulkRescheduleMatchUps: () => B0, bulkScheduleMatchUps: () => Fd, bulkScheduleTournamentMatchUps: () => Su, bulkUpdateCourtAssignments: () => F0, calculateScheduleTimes: () => Dy, clearMatchUpSchedule: () => j0, clearScheduledMatchUps: () => xm, courtGridRows: () => Im, findMatchUpFormatTiming: () => fm, findVenue: () => xn, generateBookings: () => Fm, generateVirtualCourts: () => Rm, getMatchUpsToSchedule: () => mm, getPersonRequests: () => Uo, getProfileRounds: () => gm, getScheduledRoundsDetails: () => Dd, getSchedulingProfile: () => oa, getSchedulingProfileIssues: () => wU, matchUpScheduleChange: () => V0, modifyMatchUpFormatTiming: () => jU, mutate: () => C0, proAutoSchedule: () => k0, proConflicts: () => L0, publicFindCourt: () => Xg, query: () => pM, removeEventMatchUpFormatTiming: () => Dm, removeMatchUpCourtAssignment: () => O0, reorderUpcomingMatchUps: () => _0, scheduleMatchUps: () => x0, scheduleProfileRounds: () => Lm, setMatchUpDailyLimits: () => G0, setMatchUpHomeParticipantId: () => ry, setSchedulingProfile: () => Tc, toggleParticipantCheckInState: () => Nm, validateSchedulingProfile: () => hm });
var C0 = {};
Ae(C0, { addMatchUpCourtOrder: () => iy, addMatchUpEndTime: () => ay, addMatchUpOfficial: () => gN, addMatchUpResumeTime: () => sy, addMatchUpScheduleItems: () => km, addMatchUpScheduledDate: () => Cm, addMatchUpScheduledTime: () => ka, addMatchUpStartTime: () => ny, addMatchUpStopTime: () => oy, addSchedulingProfileRound: () => Sy, allocateTeamMatchUpCourts: () => Om, assignMatchUpCourt: () => Is, assignMatchUpVenue: () => Cc, bulkRescheduleMatchUps: () => B0, bulkScheduleMatchUps: () => Fd, bulkScheduleTournamentMatchUps: () => Su, bulkUpdateCourtAssignments: () => F0, calculateScheduleTimes: () => Dy, clearMatchUpSchedule: () => j0, clearScheduledMatchUps: () => xm, findMatchUpFormatTiming: () => fm, generateBookings: () => Fm, generateVirtualCourts: () => Rm, matchUpScheduleChange: () => V0, modifyMatchUpFormatTiming: () => jU, proAutoSchedule: () => k0, proConflicts: () => L0, removeEventMatchUpFormatTiming: () => Dm, removeMatchUpCourtAssignment: () => O0, reorderUpcomingMatchUps: () => _0, scheduleMatchUps: () => x0, scheduleProfileRounds: () => Lm, setMatchUpDailyLimits: () => G0, setMatchUpHomeParticipantId: () => ry, setSchedulingProfile: () => Tc, toggleParticipantCheckInState: () => Nm, validateSchedulingProfile: () => hm });
function Dy({ calculateStartTimeFromCourts: e = !0, defaultRecoveryMinutes: t = 0, averageMatchUpMinutes: r = 90, remainingScheduleTimes: i, clearScheduleDates: n, tournamentRecords: a, periodLength: o, scheduleDate: s, startTime: c, venueIds: u, endTime: d }) {
  if (typeof a != "object" || !Object.keys(a).length)
    return { error: yt };
  o = o ?? Mm({ recoveryMinutes: t, averageMatchUpMinutes: r });
  let { courts: p, venues: l } = aa({ dates: [s], ignoreDisabled: !0, tournamentRecords: a }), m = p == null ? void 0 : p.filter((T) => !u || u.includes(T.venueId));
  c || (c = m == null ? void 0 : m.reduce((T, R) => {
    var E, C;
    let M = ((C = (E = R.dateAvailability) == null ? void 0 : E.find((A) => !A.date || Nn(s, A.date))) == null ? void 0 : C.startTime) ?? R.startTime;
    return M && (!T || _e(M) < _e(T)) ? M : T;
  }, void 0)), d || (d = m == null ? void 0 : m.reduce((T, R) => {
    var E, C;
    let M = ((C = (E = R.dateAvailability) == null ? void 0 : E.find((A) => !A.date || Nn(s, A.date))) == null ? void 0 : C.endTime) ?? R.endTime;
    return M && (!T || _e(M) > _e(T)) ? M : T;
  }, void 0));
  let f = Object.values(a), h = Object.assign({}, ...f.map((T) => (T.events ?? []).map((R) => {
    let { scheduleTiming: M } = $u({ tournamentRecord: T, event: R });
    return { [R.eventId]: { event: R, scheduleTiming: M } };
  })).flat()), g = Rd({ sortDateMatchUps: !1, tournamentRecords: a, matchUpFilters: { scheduledDate: s, venueIds: u } }), I = (g == null ? void 0 : g.dateMatchUps) ?? [], y = (g == null ? void 0 : g.completedMatchUps) ?? [], U = [];
  U.push(...I), U.push(...y);
  let S = { averageTimes: [{ minutes: { default: r } }], recoveryTimes: [{ minutes: { default: t } }] }, D = U == null ? void 0 : U.map(({ eventId: T, schedule: R, matchUpFormat: M }) => {
    let { event: E, scheduleTiming: C } = h[T], A = E == null ? void 0 : E.eventType, N = { ...C, defaultTiming: S, matchUpFormat: M }, { averageMinutes: O, recoveryMinutes: k } = Cp({ eventType: A, timingDetails: N }), { courtId: F, venueId: x } = R, _ = mt(R.scheduledTime), B = Br(_, O);
    return { recoveryMinutes: k, averageMinutes: O, periodLength: o, startTime: _, endTime: B, courtId: F, venueId: x };
  }), w = { calculateStartTimeFromCourts: e, remainingScheduleTimes: i, averageMatchUpMinutes: r, date: s, clearScheduleDates: n, periodLength: o, startTime: c, endTime: d, bookings: D, courts: m }, { scheduleTimes: v } = QU(w), P = (u == null ? void 0 : u.length) === 1 && u[0] || (l == null ? void 0 : l.length) === 1 && l[0].venueId || void 0, b = U.map(Ht);
  return { venueId: P, scheduleTimes: v, dateScheduledMatchUpIds: b };
}
function O0(e) {
  var m;
  let t = fe(e, [{ [gr]: !0 }]);
  if (t.error)
    return t;
  let { removePriorValues: r, tournamentRecords: i, tournamentId: n, courtDayDate: a, matchUpId: o, courtId: s, drawId: c } = e, u = i[n];
  if (!u)
    return { error: ae };
  let { drawDefinition: d, event: p } = Oa({ tournamentRecord: u, drawId: c });
  if (!d)
    return { error: le };
  let l = ft({ drawDefinition: d, event: p, matchUpId: o });
  if (l.error)
    return l;
  if (((m = l == null ? void 0 : l.matchUp) == null ? void 0 : m.matchUpType) === ni) {
    let { itemValue: f } = fo({ timeItems: l.matchUp.timeItems ?? [], itemType: kn }), h = s && f.filter((g) => g.courtId !== s);
    return ti({ duplicateValues: !1, removePriorValues: r, tournamentRecord: u, drawDefinition: d, matchUpId: o, timeItem: { itemType: kn, itemValue: h } });
  } else
    return Is({ tournamentRecord: u, drawDefinition: d, courtDayDate: a, courtId: "", matchUpId: o });
}
function k0({ scheduleCompletedMatchUps: e, tournamentRecords: t, scheduledDate: r, matchUps: i }) {
  if (!Ti(i))
    return { error: J };
  if (i.some(({ hasContext: m }) => !m))
    return { info: "matchUps must have { inContext: true, nextMatchUps: true }", error: Ql };
  let n = Rd({ courtCompletedMatchUps: !0, withCourtGridRows: !0, minCourtGridRows: 10, tournamentRecords: t, matchUpFilters: { localPerspective: !0, scheduledDate: r } });
  if (n.error)
    return n;
  let { rows: a } = n, o = [], s = (m) => [(m.sides || []).map((f) => {
    var h;
    return [f.participantId, (h = f.participant) == null ? void 0 : h.individualParticipantIds];
  }), (m.potentialParticipants || []).flat().map((f) => [f.participantId, f.individualParticipantIds])].flat(1 / 0).filter(Boolean), c = a == null ? void 0 : a.reduce((m, f) => {
    let h = [], g = [];
    Object.values(f).forEach((y) => {
      if (Le(y) && (y.matchUpId && (h.push(y.matchUpId), o.push(y)), y.sides)) {
        let U = s(y);
        g.push(...U);
      }
    });
    let I = Object.values(f).filter((y) => Le(y) && !y.matchUpId);
    return m.concat({ matchUpIds: h, availableCourts: I, rowId: f.rowId, participantIds: g });
  }, []);
  i.filter(({ matchUpStatus: m }) => m && m !== $e && (e || !Vt.includes(m))).sort(cs);
  let u = qi({ matchUps: i.concat(o), includeParticipantDependencies: !0, tournamentRecords: t }).matchUpDependencies, d = [], p = [];
  for (; i.length && c.length; ) {
    let m = c.shift(), f = [];
    for (; i.length && m.availableCourts.length; ) {
      let h = i.concat(f).map((P) => P.matchUpId), g = i.shift(), I = g == null ? void 0 : g.matchUpId, y = I && u[I].matchUpIds.concat(u[I].dependentMatchUpIds), U = I && h.some((P) => u[I].matchUpIds.includes(P)), S = I && p.some((P) => u[I].dependentMatchUpIds.includes(P)), D = m.matchUpIds.some((P) => y.includes(P)), w = s(g), v = m.participantIds.some((P) => w.includes(P));
      if (g && !D && !U && !v && !S) {
        let P = m.availableCourts.shift();
        Object.assign(g.schedule, P.schedule), Object.assign(P, g), d.push(g), m.participantIds.push(...w), m.matchUpIds.push(I);
      } else
        g && f.push(g);
    }
    i.push(...f), p.push(...m.matchUpIds);
  }
  let l = d.map(({ matchUpId: m, tournamentId: f, schedule: h, drawId: g }) => ({ tournamentId: f, matchUpId: m, drawId: g, schedule: { ...h, scheduledDate: r } }));
  return n = Fd({ tournamentRecords: t, matchUpDetails: l }), { ...n, scheduled: d, notScheduled: i };
}
function F0(e) {
  let { courtDayDate: t } = e, r = fe(e, [{ courtAssignments: !0, [Or]: fr, [ci]: Ie }, { [gr]: !0 }]);
  if (r.error)
    return r;
  let i = e.courtAssignments.reduce((a, o) => {
    let { tournamentId: s } = o;
    return a[s] || (a[s] = []), a[s].push(o), a;
  }, {}), n;
  return Object.keys(i).every((a) => {
    let o = e[gr][a];
    if (!o)
      return n = { error: ae }, !1;
    let s = i[a].reduce((c, u) => {
      let { drawId: d } = u;
      return c[d] || (c[d] = []), c[d].push(u), c;
    }, {});
    Object.keys(s).every((c) => {
      let { drawDefinition: u } = Cr({ tournamentRecord: o, drawId: c });
      return u ? (s[c].every((d) => {
        let { matchUpId: p, courtId: l } = d, m = Is({ tournamentRecord: o, drawDefinition: u, courtDayDate: t, matchUpId: p, courtId: l });
        if (m.success)
          return m == null ? void 0 : m.success;
        n = { error: Nw };
      }), !0) : (n = { error: le }, !1);
    });
  }), n || V;
}
function x0(e) {
  let { tournamentRecords: t, allDateMatchUpIds: r = [], averageMatchUpMinutes: i = 90, recoveryMinutes: n = 0, recoveryMinutesMap: a, matchUpPotentialParticipantIds: o = {}, individualParticipantProfiles: s = {}, matchUpNotBeforeTimes: c = {}, matchUpDailyLimits: u = {}, checkPotentialRequestConflicts: d = !0, remainingScheduleTimes: p, clearScheduleDates: l, periodLength: m = 30, scheduleDate: f, matchUpIds: h, venueIds: g, startTime: I, endTime: y, dryRun: U } = e, S = fe(e, [{ [gr]: !0, [xu]: !0 }, { [cr]: Kr, [ci]: Qt, [D1]: !0 }, { [cr]: ($) => !$ || !isNaN($), [M1]: !1, [ci]: J, [N1]: !1, [A1]: !1 }]);
  if (S.error)
    return S;
  let D = e.competitionMatchUps ?? en({ nextMatchUps: !0, tournamentRecords: t }).matchUps ?? [], w = e.matchUpDependencies ?? qi({ includeParticipantDependencies: !0, matchUps: D, tournamentRecords: t }).matchUpDependencies;
  D.forEach(($) => {
    var W;
    (W = $.schedule) != null && W.scheduledDate && Nn(f, be($.schedule.scheduledDate)) && Xs({ matchUpPotentialParticipantIds: o, matchUpNotBeforeTimes: c, matchUp: $ });
  });
  let v = h.map(($) => D.find((W) => W.matchUpId === $)).filter(Boolean), { venueId: P, scheduleTimes: b, dateScheduledMatchUpIds: T } = Dy({ tournamentRecords: t, remainingScheduleTimes: p, startTime: mt(I), endTime: mt(y), scheduleDate: be(f), averageMatchUpMinutes: i, clearScheduleDates: l, periodLength: m, venueIds: g }), R = {}, M = [], E = {}, C = {}, A = {};
  D.filter(({ matchUpId: $ }) => T == null ? void 0 : T.includes($)).forEach(($) => {
    var q;
    lh({ matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUp: $, value: 1 });
    let W = (q = $.schedule) == null ? void 0 : q.scheduledTime;
    if (W) {
      E[$.matchUpId] = W;
      let K = a == null ? void 0 : a[$.matchUpId];
      yu({ recoveryMinutes: K || n, matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUpNotBeforeTimes: c, averageMatchUpMinutes: i, matchUpDependencies: w, scheduleTime: W, matchUp: $ });
    }
  });
  let N = v.filter(($) => {
    let W = T == null ? void 0 : T.includes($.matchUpId), q = [$e, ke, Tt, Gr, nr, Be].includes($ == null ? void 0 : $.matchUpStatus);
    return !W && !$.winningSide && !q;
  }), { matchUpMap: O, overLimitMatchUpIds: k, participantIdsAtLimit: F } = N.reduce(($, W) => {
    let { drawId: q, tournamentId: K, matchUpType: z } = W, { participantIdsAtLimit: Y, relevantParticipantIds: X } = gy({ individualParticipantProfiles: s, matchUpPotentialParticipantIds: o, matchUpDailyLimits: u, matchUp: W });
    return Y != null && Y.length ? ($.overLimitMatchUpIds.push(W.matchUpId), $.participantIdsAtLimit.push(...Y), $) : (X.forEach((re) => {
      Od({ individualParticipantProfiles: s, participantId: re });
      let Q = s[re].counters;
      Q[z] ? Q[z] += 1 : Q[z] = 1, Q[xi] ? Q[xi] += 1 : Q[xi] = 1;
    }), $.matchUpMap[K] || ($.matchUpMap[K] = {}), $.matchUpMap[K][q] ? $.matchUpMap[K][q].push(W) : $.matchUpMap[K][q] = [W], Xs({ matchUpPotentialParticipantIds: o, matchUpNotBeforeTimes: c, matchUp: W }), $);
  }, { matchUpMap: {}, overLimitMatchUpIds: [], participantIdsAtLimit: [] });
  N = N.filter(({ matchUpId: $ }) => !k.includes($));
  let x = 0, _ = (b == null ? void 0 : b.length) ?? 0, { personRequests: B } = Uo({ tournamentRecords: t, requestType: kd });
  for (; b != null && b.length && N.length && x <= _; ) {
    x++;
    let { scheduleTime: $ } = b.shift(), W = N.find((q) => {
      let { matchUpId: K } = q, { dependenciesScheduled: z, remainingDependencies: Y } = my({ matchUpScheduleTimes: E, matchUpDependencies: w, allDateMatchUpIds: r, matchUp: q });
      if (!z)
        return A[K] || (A[K] = []), A[K].push({ scheduleTime: $, remainingDependencies: Y }), !1;
      let { enoughTime: X } = hy({ individualParticipantProfiles: s, matchUpNotBeforeTimes: c, matchUpDependencies: w, scheduleTime: $, matchUp: q });
      if (!X)
        return C[K] || (C[K] = []), C[K].push({ scheduleTime: $ }), !1;
      let { conflicts: re } = fy({ potentials: d, averageMatchUpMinutes: i, requestConflicts: R, personRequests: B, scheduleTime: $, scheduleDate: f, matchUp: q });
      if (re != null && re.length)
        return !1;
      let Q = a == null ? void 0 : a[q.matchUpId];
      return yu({ recoveryMinutes: Q || n, matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUpNotBeforeTimes: c, averageMatchUpMinutes: i, matchUpDependencies: w, scheduleTime: $, matchUp: q }), E[q.matchUpId] = $, !0;
    });
    N = N.filter(({ matchUpId: q }) => q !== (W == null ? void 0 : W.matchUpId)), W || M.push($);
  }
  N.forEach(($) => {
    lh({ individualParticipantProfiles: s, matchUpPotentialParticipantIds: o, value: -1, matchUp: $ });
  });
  let L = [];
  Object.keys(O).forEach(($) => {
    let W = t[$];
    W && Object.keys(O[$]).forEach((q) => {
      let { drawDefinition: K } = Oa({ tournamentRecord: W, drawId: q });
      K && O[$][q].forEach(({ matchUpId: z }) => {
        let Y = E[z];
        if (Y) {
          let X = Y.split(":").map(hi).join(":"), re = `${be(f)}T${X}`;
          U ? L.push(z) : (ka({ drawDefinition: K, matchUpId: z, scheduledTime: re }).success && L.push(z), P && Cc({ tournamentRecords: t, tournamentRecord: W, drawDefinition: K, matchUpId: z, venueId: P }));
        }
      });
    });
  });
  let G = Sg(N);
  return { ...V, requestConflicts: Object.values(R), remainingScheduleTimes: b == null ? void 0 : b.map(({ scheduleTime: $ }) => $), individualParticipantProfiles: s, matchUpNotBeforeTimes: c, participantIdsAtLimit: F, skippedScheduleTimes: M, overLimitMatchUpIds: k, scheduledMatchUpIds: L, noTimeMatchUpIds: G, recoveryTimeDeferred: C, dependencyDeferred: A };
}
function L0({ tournamentRecords: e, matchUps: t }) {
  if (!Ti(t))
    return { error: Zn };
  if (t.some(({ matchUpId: m, hasContext: f }) => m && !f))
    return { info: "matchUps must have { inContext: true, nextMatchUps: true }", error: Ql };
  let r = Math.max(...t.map(({ schedule: m }) => (m == null ? void 0 : m.courtOrder) || 1).map((m) => ye(m))), i = oe(1, r + 1).map((m) => t.filter((f) => {
    var h;
    return ye((h = f.schedule) == null ? void 0 : h.courtOrder) === m;
  })), n = {}, a = {}, o = {};
  i.flat().filter(Boolean).sort(cs).forEach(({ schedule: m }) => delete m[Jd]);
  let s = Te(t.map(({ drawId: m }) => m)), c = qi({ includeParticipantDependencies: !0, tournamentRecords: e, drawIds: s }).matchUpDependencies, u = i.map((m, f) => m.reduce((h, g) => {
    if (!g.matchUpId)
      return h;
    let { matchUpId: I, winnerMatchUpId: y, loserMatchUpId: U, schedule: S, sides: D, potentialParticipants: w } = g, v = S == null ? void 0 : S.courtId;
    n[I] = f, a[v] = [], h.matchUpIds.push(I), o[I] = g;
    let P = c[I].matchUpIds;
    P.length && h.sourceMatchUpIds.push(...P);
    let b = (D == null ? void 0 : D.map((R) => {
      var M;
      return [(M = R.participant) == null ? void 0 : M.individualParticipantIds, R.participantId];
    }).flat().filter(Boolean)) ?? [], T = (w == null ? void 0 : w.flat().map(({ individualParticipantIds: R, participantId: M }) => [R, M]).flat().filter(Boolean)) || [];
    return h.participantIds.push(...T, ...b), y && h.targetMatchUpIds.push(y), U && h.targetMatchUpIds.push(U), h;
  }, { sourceMatchUpIds: [], targetMatchUpIds: [], participantIds: [], matchUpIds: [] })), d = (m, f) => c[m].sources.reduce((h, g, I) => g.includes(f) && I + 1 || h, 0), p = u.map(() => []), l = (m, f, h, g) => {
    if (!o[m].schedule[Jd]) {
      o[m].schedule[Jd] = f, o[m].schedule[tT] = g, p[n[m]].push({ matchUpId: m, issueType: h, issueIds: g, issue: f });
      let I = o[m].schedule.courtId;
      a[I] || (a[I] = []), a[I].push({ matchUpId: m, issue: f, issueType: h, issueIds: g });
    }
  };
  return u.forEach((m, f) => {
    let h = f ? u[f - 1] : void 0, g = u.slice(f + 1), I = {}, y = Qr(m.participantIds), U = Object.keys(y).filter((w) => y[w] > 1), S = m.matchUpIds.filter((w) => c[w].participantIds.some((v) => U.includes(v)));
    S.forEach((w) => {
      I[w] || (I[w] = {}), I[w][Fa] || (I[w][Fa] = S.filter((v) => v !== w));
    });
    let D = h && m.participantIds.filter((w) => h.participantIds.includes(w));
    D && D.forEach((w) => {
      let v = m.matchUpIds.concat(h.matchUpIds).filter((P) => c[P].participantIds.includes(w));
      v.forEach((P) => {
        I[P] || (I[P] = {}), I[P][xa] || (I[P][xa] = v.filter((b) => b !== P));
      });
    }), m.matchUpIds.forEach((w) => {
      var b, T, R, M;
      let v = c[w].matchUpIds;
      for (let E of g) {
        let C = E.matchUpIds.filter((A) => v.includes(A));
        C != null && C.length && (C.forEach((A) => l(A, _f, ca, [w])), l(w, _f, ca, C));
      }
      if ((b = I[w]) != null && b[Fa] && l(w, Fa, Lf, I[w][Fa]), m.sourceMatchUpIds.includes(w)) {
        let E = m.matchUpIds.filter((C) => c[C].matchUpIds.includes(w));
        l(w, Fa, ca, E), m.matchUpIds.filter((C) => c[C].matchUpIds.includes(w)).forEach((C) => l(C, Fa, ca, [w]));
      }
      let P = (T = h == null ? void 0 : h.matchUpIds) == null ? void 0 : T.filter((E) => d(w, E) > 1);
      if (P != null && P.length && (l(w, Bf, ca, P), P.forEach((E) => l(E, Bf, ca, [w]))), (R = I[w]) != null && R[xa] && l(w, xa, Lf, I[w][xa]), (M = h == null ? void 0 : h.targetMatchUpIds) == null ? void 0 : M.includes(w)) {
        let E = o[w].schedule.courtId, C = v.filter((A) => h.matchUpIds.includes(A));
        C.some((A) => o[A].schedule.courtId === E) || (C.forEach((A) => l(A, xa, ca, [w])), l(w, xa, ca, C));
      }
    });
  }), { courtIssues: a, rowIssues: p };
}
function _0(e) {
  let t = "reorderUpcomingMatchUps", { tournamentRecords: r } = e;
  if (typeof r != "object" || !Object.keys(r).length)
    return j({ result: { error: yt }, stack: t });
  let { matchUpsContextIds: i, firstToLast: n } = e;
  if (!i)
    return j({ result: { error: Ie }, stack: t });
  let a = i == null ? void 0 : i.length;
  if (!a)
    return { ...V };
  let o = 0;
  return i.forEach((c, u) => {
    let { tournamentId: d, drawId: p, matchUpId: l } = c, m = u + (n ? -1 : 1);
    m < 0 && (m = a - 1), m === a && (m = 0);
    let f = i[m].schedule.scheduledTime, h = s({ tournamentId: d, scheduledTime: f, matchUpId: l, drawId: p });
    if (h.success)
      o++;
    else
      return h;
  }), o === a ? V : j({ result: { error: Mw }, stack: t });
  function s({ tournamentId: c, scheduledTime: u, matchUpId: d, drawId: p }) {
    let l = r[c], { drawDefinition: m } = Oa({ tournamentRecord: l, drawId: p });
    return m ? ka({ drawDefinition: m, scheduledTime: u, matchUpId: d }) : { error: ai };
  }
}
function B0(e) {
  var c, u;
  let { scheduleChange: t, matchUpIds: r, dryRun: i } = e;
  if (!r || !Array.isArray(r))
    return { error: $o };
  if (typeof t != "object")
    return { error: J };
  let n = wi(e), a = [], o = [];
  for (let d of Object.values(n)) {
    let p = ZV({ tournamentRecord: d, scheduleChange: t, matchUpIds: r, dryRun: i });
    if (p.error)
      return p;
    Array.isArray(p.notRescheduled) && o.push(...p.notRescheduled);
    let l = Sg(p.notRescheduled), m = [];
    (c = p.rescheduled) == null || c.forEach((f) => {
      let { matchUpId: h } = f;
      l.includes(h) && m.push(h), a.push(f);
    }), m.length && (o = ((u = p == null ? void 0 : p.notRescheduled) == null ? void 0 : u.filter(({ matchUpId: f }) => !m.includes(f))) || []);
  }
  let s = !!(a.length && !o.length);
  return { ...V, rescheduled: a, notRescheduled: o, allRescheduled: s };
}
function ZV({ tournamentRecord: e, scheduleChange: t, matchUpIds: r, dryRun: i }) {
  var S;
  if (!e)
    return { error: ae };
  if (!r || !Array.isArray(r))
    return { error: $o };
  if (typeof t != "object")
    return { error: J };
  let n = [], a = [], { minutesChange: o, daysChange: s } = t;
  if (!o && !s)
    return { ...V };
  if (o && isNaN(o))
    return { error: J };
  if (s && isNaN(s))
    return { error: J };
  let { matchUps: c } = tr({ matchUpFilters: { matchUpIds: r }, tournamentRecord: e }), u = ({ matchUpStatus: D }) => !Vt.includes(D), d = c == null ? void 0 : c.filter((D) => bd({ schedule: D.schedule })).filter((D) => u({ matchUpStatus: D.matchUpStatus }));
  if (!(d != null && d.length))
    return { ...V };
  let { tournamentInfo: p } = hs({ tournamentRecord: e }), { startDate: l, endDate: m } = p, f = d == null ? void 0 : d.reduce((D, w) => {
    let { matchUpId: v, drawId: P } = w;
    return D[P] ? D[P].push(v) : D[P] = [v], D;
  }, {}), h = 1440;
  for (let D of Object.keys(f)) {
    let w = Oa({ tournamentRecord: e, drawId: D });
    if (w.error)
      return w;
    let v = w.drawDefinition, P = f[D].filter((b) => r.includes(b));
    for (let b of P)
      if (b && v) {
        let T = (S = d.find((N) => N.matchUpId === b)) == null ? void 0 : S.schedule, { scheduledTime: R, scheduledDate: M } = T, E, C, A;
        if (!E && s && M) {
          let N = be(M);
          A = Lc(N, s), E = new Date(A) < new Date(l) || new Date(A) > new Date(m);
        }
        if (o && R) {
          let N = be(R), O = _e(mt(R)) + o;
          if (E = O < 0 || O > h, !E) {
            let k = Br(R, o), F = N && A || M === N && N;
            C = F ? `${F}T${k}` : k;
          }
        }
        if (E)
          a.push(b);
        else {
          if (!i) {
            if (C) {
              let N = ka({ scheduledTime: C, drawDefinition: v, matchUpId: b });
              if (N.error)
                return N;
            }
            if (A) {
              let N = Cm({ scheduledDate: A, drawDefinition: v, matchUpId: b });
              if (N.error)
                return N;
            }
          }
          (C || A) && n.push(b);
        }
      }
  }
  let g = tr({ matchUpFilters: { matchUpIds: r }, tournamentRecord: e }).matchUps ?? [], I = g.filter(({ matchUpId: D }) => n.includes(D)), y = g.filter(({ matchUpId: D }) => a.includes(D)), U = I.length && !y.length;
  return { ...V, rescheduled: I, notRescheduled: y, allRescheduled: U };
}
function V0(e) {
  let t = "matchUpScheduleChange", { tournamentRecords: r } = e;
  if (typeof r != "object" || !Object.keys(r).length)
    return { error: yt };
  let { sourceMatchUpContextIds: i, targetMatchUpContextIds: n, sourceCourtId: a, targetCourtId: o, courtDayDate: s } = e || {}, { drawId: c, matchUpId: u, tournamentId: d } = i || {}, { drawId: p, matchUpId: l, tournamentId: m } = n || {};
  if (!u && !l)
    return j({ result: { error: Ie }, stack: t });
  let { matchUps: f } = en({ matchUpFilters: { matchUpIds: [u, l].filter(Boolean), drawIds: [c, p].filter(Boolean) }, tournamentRecords: e.tournamentRecords }), h = f == null ? void 0 : f.find(({ matchUpId: S }) => S === u), g = f == null ? void 0 : f.find(({ matchUpId: S }) => S === l), I = 0;
  if (o && u && !l) {
    let S = y({ tournamentId: d, matchUpId: u, courtId: o, matchUp: h, drawId: c, tournamentRecords: r, sourceCourtId: a, courtDayDate: s });
    if (S != null && S.success && I++, S.error)
      return j({ result: S, stack: t });
  } else if (a && o && u && l) {
    let S = y({ tournamentId: d, matchUpId: u, courtId: o, matchUp: h, drawId: c, tournamentRecords: r, sourceCourtId: a, courtDayDate: s });
    if (S.success && I++, S.error)
      return j({ result: S, stack: t, info: "source" });
    let D = y({ tournamentId: m, sourceCourtId: o, matchUpId: l, matchUp: g, courtId: a, drawId: p, tournamentRecords: r, courtDayDate: s });
    if (D.success && I++, D.error)
      return j({ result: D, stack: t, info: "target" });
  } else
    return { error: Ie };
  return I ? V : j({ result: { error: cc }, stack: t });
  function y(S) {
    let { tournamentRecords: D, tournamentId: w, matchUp: v, drawId: P } = S, b = D[w], { drawDefinition: T } = Oa({ tournamentRecord: b, drawId: P });
    return v.matchUpType === lt ? U({ ...S, tournamentRecord: b, drawDefinition: T }) : Is({ ...S, tournamentRecord: b, drawDefinition: T });
  }
  function U({ removePriorValues: S, tournamentRecords: D, tournamentRecord: w, drawDefinition: v, sourceCourtId: P, courtDayDate: b, matchUpId: T, matchUp: R, courtId: M }) {
    let E = [M].concat(R.schedule.allocatedCourts.map(({ courtId: C }) => C).filter((C) => C !== P));
    return Om({ removePriorValues: S, tournamentRecords: D, tournamentRecord: w, drawDefinition: v, courtDayDate: b, matchUpId: T, courtIds: E });
  }
}
function j0({ scheduleAttributes: e = [kn, va, rs, is, ns, Hi, Jn, Dn, Gn], tournamentRecord: t, drawDefinition: r, matchUpId: i }) {
  var s, c;
  let n = "clearMatchUpSchedule", a = r ? (s = vr({ matchUpFilters: { matchUpIds: [i] }, inContext: !1, drawDefinition: r }).matchUps) == null ? void 0 : s[0] : (c = tr({ matchUpFilters: { matchUpIds: [i] }, tournamentRecord: t, inContext: !1 }).matchUps) == null ? void 0 : c[0];
  if (!a)
    return { error: hr };
  let o = (a.timeItems ?? []).filter((u) => (u == null ? void 0 : u.itemType) && !e.includes(u == null ? void 0 : u.itemType));
  return a.timeItems = o, xe({ tournamentId: t.tournamentId, context: n, drawDefinition: r, matchUp: a }), { ...V };
}
function G0(e) {
  let { tournamentRecord: t, tournamentId: r, dailyLimits: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (typeof n != "object" || !Object.keys(n).length)
    return { error: yt };
  if (typeof i != "object")
    return { error: ea };
  let a = Object.keys(n).filter((o) => !r || r === o);
  if (r && !a.includes(r))
    return { error: J };
  for (let o of a) {
    let s = n[o], c = Ve({ extension: { name: _u, value: { dailyLimits: i } }, element: s });
    if (c.error)
      return c;
  }
  return { ...V };
}
var $0 = {};
Ae($0, { addCollectionDefinition: () => Ry, addCollectionGroup: () => K0, aggregateTieFormats: () => J0, compareTieFormats: () => Xn, getTieFormat: () => yU, modifyCollectionDefinition: () => Ty, modifyTieFormat: () => Q0, mutate: () => q0, orderCollectionDefinitions: () => z0, query: () => aM, removeCollectionDefinition: () => by, removeCollectionGroup: () => H0, tieFormatGenderValidityCheck: () => ap, validateCollectionDefinition: () => Cu });
var q0 = {};
Ae(q0, { addCollectionDefinition: () => Ry, addCollectionGroup: () => K0, aggregateTieFormats: () => J0, modifyCollectionDefinition: () => Ty, modifyTieFormat: () => Q0, orderCollectionDefinitions: () => z0, removeCollectionDefinition: () => by, removeCollectionGroup: () => H0 });
function ro({ drawDefinition: e, structureId: t, matchUpId: r, structure: i, matchUp: n, eventId: a, event: o }) {
  var u;
  let s = "getTieFormat", c;
  if (t = (i == null ? void 0 : i.structureId) ?? t, r = (n == null ? void 0 : n.matchUpId) ?? r, (r || t) && !e)
    return { error: le };
  if (a && o)
    c = rn(o);
  else if (r) {
    if (e && (!n || !i)) {
      let d = ft({ drawDefinition: e, matchUpId: r });
      if (d.error)
        return d;
      if (((u = d.matchUp) == null ? void 0 : u.matchUpType) !== ni)
        return j({ result: { error: jr }, stack: s });
      i || (i = d.structure), n || (n = d.matchUp);
    }
    c = jc({ item: n, drawDefinition: e, structure: i, event: o }) || jc({ item: i, drawDefinition: e, structure: i, event: o }) || rn(e) || rn(o);
  } else if (e && t) {
    if (!i) {
      let d = ve({ drawDefinition: e, structureId: t });
      if (d.error)
        return d;
      i = d == null ? void 0 : d.structure;
    }
    c = jc({ item: i, drawDefinition: e, structure: i, event: o }) || rn(e) || rn(o);
  } else
    c = rn(e) || rn(o);
  return c ? { ...V, structure: i, tieFormat: c, matchUp: n } : j({ result: { error: ac }, stack: s });
}
function Bl({ matchUp: e, updateInProgressMatchUps: t }) {
  return !e.winningSide && ![Vt].includes(e.matchUpStatus) && (t || e.matchUpStatus !== Gi && !jt(e));
}
function sf({ from: e, to: t }) {
  let r = Object.keys(e), i = wt(r, Object.keys(t)).length === r.length, n = r.filter((o) => e[o] !== t[o]).map((o) => ({ countChange: t[o] - e[o], collectionId: o })), a = r.every((o) => e[o] === t[o]);
  return { equivalent: i && a, matchUpsCountChanges: n };
}
function e2({ updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: r, structure: i, tieFormat: n, eventId: a, matchUp: o, event: s, uuids: c }) {
  var w, v, P, b;
  let u = "updateTieFormat", d = t == null ? void 0 : t.tournamentId, p = 0, l = 0, m = 0, f = 0, h = n == null ? void 0 : n.collectionDefinitions.reduce((T, R) => (T[R.collectionId] = (T[R.collectionId] || 0) + R.matchUpCount, T), {}), g = ({ tieFormat: T }) => {
    let R = T == null ? void 0 : T.collectionDefinitions.reduce((M, E) => (M[E.collectionId] = (M[E.collectionId] || 0) + E.matchUpCount, M), {});
    return sf({ from: R, to: h }).equivalent;
  }, I = (w = ro({ drawDefinition: r })) == null ? void 0 : w.tieFormat, y = (v = ro({ event: s })) == null ? void 0 : v.tieFormat;
  if (s && a) {
    for (let T of s.drawDefinitions ?? [])
      U({ drawDefinition: T });
    s.tieFormat = sr(n), f += 1;
  } else if (o) {
    if (!o.tieMatchUps)
      return j({ result: { error: jr }, stack: u });
    let T = Qr((P = o.tieMatchUps) == null ? void 0 : P.map(({ collectionId: A }) => A)), R = sf({ to: h, from: T }), { changes: M, changesArePossible: E, cannotChangeReaon: C } = QS({ matchUp: o, check: R });
    if (R.equivalent)
      if (Bl({ matchUp: o, updateInProgressMatchUps: e }))
        o.tieFormat = sr(n), f += 1;
      else
        return j({ result: { error: Eh }, info: "matchUp is IN_PROGRESS or COMPLETE", stack: u });
    else if (E)
      D({ tieFormat: n, matchUp: o, changes: M, uuids: c });
    else
      return j({ context: { collectionMap: h, matchUpMap: T }, result: { error: wn }, info: C || "specified changes not possible", stack: u });
    l += 1, xe({ eventId: s == null ? void 0 : s.eventId, context: u, drawDefinition: r, tournamentId: d, matchUp: o });
  } else if (i) {
    let T = (b = S({ inheritedTieFormat: I ?? y, structure: i })) == null ? void 0 : b.modifiedMatchUpsCount;
    T && (l += T, p += 1, f += 1);
    let R = !i.tieFormat || Xn({ ancestor: i.tieFormat, descendant: n }).different;
    R && (i.tieFormat = sr(n), p += 1, f += 1), (T || R) && r && ut({ structureIds: [i.structureId], eventId: s == null ? void 0 : s.eventId, drawDefinition: r });
  } else if (r)
    U({ drawDefinition: r }), r.tieFormat = sr(n), f += 1;
  else
    return { error: le };
  return { modifiedStructuresCount: p, modifiedMatchUpsCount: l, addedMatchUpsCount: m, modifiedCount: f, ...V, tieFormat: n };
  function U({ drawDefinition: T }) {
    var E;
    let R = T.structures || [], M = [];
    for (let C of R) {
      if (C.tieFormat)
        continue;
      let A = (E = S({ inheritedTieFormat: y, structure: C })) == null ? void 0 : E.modifiedMatchUpsCount;
      if (A) {
        p += 1, l += A;
        let N = C.structureId;
        M.push(N);
      }
    }
    return ut({ structureIds: M, eventId: s == null ? void 0 : s.eventId, drawDefinition: T }), M.length;
  }
  function S({ inheritedTieFormat: T, structure: R }) {
    var C, A;
    let M = 0, E = ((C = Ke({ matchUpFilters: { matchUpTypes: [lt] }, structure: R })) == null ? void 0 : C.matchUps) || [];
    for (let N of E) {
      let O = Bl({ matchUp: N, updateInProgressMatchUps: e }), k = !1, F = Qr((A = N.tieMatchUps) == null ? void 0 : A.map(({ collectionId: _ }) => _)), x = sf({ from: F, to: h });
      if (x.equivalent)
        N.tieFormat && g(N) && O && (N.tieFormat = sr(n), k = !0);
      else {
        let { changes: _, changesArePossible: B } = QS({ matchUp: N, check: x });
        if (B && !N.tieFormat)
          D({ changes: _, matchUp: N, tieFormat: n, uuids: c });
        else if (T)
          (!N.tieFormat || Xn({ ancestor: T, descendant: N.tieFormat }).different) && (N.tieFormat = T, k = !0);
        else
          return j({ result: { error: ac }, stack: u });
      }
      k && (M += 1, xe({ tournamentId: t == null ? void 0 : t.tournamentId, drawDefinition: r, context: u, eventId: a, matchUp: N }));
    }
    return { modifiedMatchUpsCount: M };
  }
  function D({ uuids: T, matchUp: R, tieFormat: M, changes: E }) {
    R.tieFormat = sr(M);
    let C = [], A = [];
    return E.forEach((N) => {
      if (N.countChange > 0) {
        let O = Math.max(0, ...R.tieMatchUps.filter((x) => x.collectionId === N.collectionId).map(ei("collectionPosition"))), k = M.collectionDefinitions.find((x) => x.collectionId === N.collectionId), F = fd({ matchUpsLimit: N.countChange, collectionPositionOffset: O, collectionDefinition: k, matchUp: R, uuids: T });
        A.push(...ce(F, !1, !0)), m += A.length, R.tieMatchUps.push(...F);
      } else {
        let O = N.toBePlayedTieMatchUpIds.slice(0, Math.abs(N.countChange));
        console.log("remove", O.length), C.push(...O), R.tieMatchUps = R.tieMatchUps.filter(({ matchUpId: k }) => !O.includes(k));
      }
    }), A.length && ya({ matchUps: A, drawDefinition: r, tournamentId: d, eventId: a }), C.length && ta({ matchUpIds: C, action: "updateTieFormat", drawDefinition: r, tournamentId: d, eventId: a }), { matchUpIdsRemoved: C, matchUpsAdded: A };
  }
}
function QS({ check: e, matchUp: t }) {
  let r = "", i = [];
  return { changesArePossible: e.matchUpsCountChanges.every(({ collectionId: n, countChange: a }) => {
    let o = t.tieMatchUps.filter((c) => c.collectionId === n && c.matchUpStatus === Rt).map(ei("matchUpId")), s = o.length + a >= 0 || a > 0;
    return !s && a < 0 && (r = "Insufficient TO_BE_PLAYED matchUps"), i.push({ toBePlayedTieMatchUpIds: o, collectionId: n, countChange: a }), s;
  }), changes: i, cannotChangeReaon: r };
}
function jm({ appliedPolicies: e, drawDefinition: t, auditData: r }) {
  var a;
  if (!((a = e == null ? void 0 : e.audit) != null && a[Bc]))
    return;
  let { extension: i } = Ne({ name: Bc, element: t }), n = { value: Array.isArray(i == null ? void 0 : i.value) ? i == null ? void 0 : i.value.concat(r) : [r], name: Bc };
  Ve({ element: t, extension: n });
}
function Ty({ updateInProgressMatchUps: e = !1, tournamentRecord: t, collectionOrder: r, collectionName: i, tieFormatName: n, drawDefinition: a, matchUpFormat: o, matchUpCount: s, collectionId: c, matchUpType: u, structureId: d, matchUpId: p, category: l, eventId: m, gender: f, event: h, collectionValueProfiles: g, collectionValue: I, matchUpValue: y, scoreValue: U, setValue: S }) {
  let D = "modifyCollectionDefinition";
  if (o && !Jr({ matchUpFormat: o }))
    return j({ result: { error: J }, context: { matchUpFormat: o }, stack: D });
  if (i && typeof i != "string")
    return j({ result: { error: J }, context: { collectionName: i }, stack: D });
  if (f && !Object.values(Yh).includes(f))
    return j({ result: { error: J }, context: { gender: f }, stack: D });
  if (l && typeof l != "object")
    return j({ result: { error: J }, context: { category: l }, stack: D });
  let w = { collectionValueProfiles: g, collectionValue: I, matchUpValue: y, scoreValue: U, setValue: S };
  if (!Object.values(w).filter(Boolean).length && !r && !i && !o && !s && !u)
    return j({ result: { error: Ie }, stack: D });
  if (Object.values(w).filter(Boolean).length > 1)
    return j({ info: "Only one value assignment allowed per collectionDefinition", result: { error: J }, stack: D });
  let v = ro({ drawDefinition: a, structureId: d, matchUpId: p, eventId: m, event: h });
  if (v.error)
    return j({ result: v, stack: D });
  let { matchUp: P, structure: b, tieFormat: T } = v, R = sr(T), M = T == null ? void 0 : T.collectionDefinitions.find((L) => L.collectionId === c), E = R == null ? void 0 : R.collectionDefinitions.find((L) => L.collectionId === c);
  if (!M)
    return j({ info: "source collectionDefinition", result: { error: Zt }, context: { collectionId: c }, stack: D });
  let C = I ?? y ?? U ?? S;
  if (g != null && g.length) {
    let L = Av({ matchUpCount: s ?? (M == null ? void 0 : M.matchUpCount) ?? 0, collectionValueProfiles: g });
    if (L.errors)
      return j({ result: { error: J }, info: L.errors, stack: D });
  } else if (C && !Pe(C))
    return j({ result: { error: J }, info: "value is not an integer", context: { value: C }, stack: D });
  let A = (L, G) => wt(Object.keys(L), Object.keys(G)).length === Object.keys(L).length && wt(Object.values(L), Object.values(G)).length === Object.values(L).length, N = g && (!M.collectionValueProfiles || !A(M.collectionValueProfiles, g)), O = Pe(I) && M.collectionValue !== I || Pe(y) && M.matchUpValue !== y || Pe(U) && M.scoreValue !== U || Pe(S) && M.setValue !== S || N, k = [];
  if (O && (E.collectionValueProfiles = void 0, E.collectionValue = void 0, E.matchUpValue = void 0, E.scoreValue = void 0, E.setValue = void 0, Object.assign(E, w), k.push({ collectionId: c, ...me(w) })), (Pe(U) || Pe(S)) && E.collectionGroupNumber) {
    let L = E.collectionGroupNumber;
    R.collectionDefinitions = R.collectionDefinitions.map((G) => {
      let { collectionGroupNumber: $, ...W } = G;
      return $ === L ? W : G;
    }), R.collectionGroups = R.collectionGroups.filter(({ groupNumber: G }) => G !== L), k.push({ collectionId: c, change: "collectionGroupNumber removed" });
  }
  let { aggregateValue: F, valueGoal: x } = gs(R), _ = me({ aggregateValue: F, valueGoal: x });
  if ((_.aggregateValue !== (T == null ? void 0 : T.winCriteria.aggregateValue) || _.valueGoal !== (T == null ? void 0 : T.winCriteria.valueGoal)) && (R.winCriteria = _, k.push({ collectionId: c, winCriteria: _ })), Pe(r) && M.collectionOrder !== r && (E.collectionOrder = r, k.push({ collectionId: c, collectionOrder: r })), i && M.collectionName !== i && (E.collectionName = i, k.push({ collectionId: c, collectionName: i })), o && M.matchUpFormat !== o && (E.matchUpFormat = o, k.push({ collectionId: c, matchUpFormat: o })), Pe(s) && M.matchUpCount !== s && (E.matchUpCount = s, k.push({ collectionId: c, matchUpCount: s })), u && M.matchUpType !== u)
    return j({ result: { error: Zl }, context: { matchUpType: u }, stack: D });
  l && M.category !== l && (E.category = l, k.push({ collectionId: c, category: l })), f && M.gender !== f && (E.gender = f, k.push({ collectionId: c, gender: f }));
  let B = me(R);
  if (v = Ar({ tieFormat: B }), v.error)
    return j({ result: v, stack: D });
  if (!k.length)
    return j({ result: { ...V, modifications: k } });
  if ((T == null ? void 0 : T.tieFormatName) !== n ? (B.tieFormatName = n, k.push({ tieFormatName: n })) : k.length && (delete B.tieFormatName, k.push("tieFormatName removed: modifications without new tieFormatName")), v = e2({ tieFormat: B, updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: a, structure: b, eventId: m, matchUp: P, event: h }), !v.error) {
    let { appliedPolicies: L } = je({ tournamentRecord: t }), G = me({ collectionDefinition: E, drawId: a == null ? void 0 : a.drawId, action: D, structureId: d, matchUpId: p, eventId: m });
    jm({ appliedPolicies: L, drawDefinition: a, auditData: G });
  }
  return j({ result: { ...v, modifications: k }, stack: D });
}
function t2({ updateInProgressMatchUps: e, drawDefinition: t, structureId: r, structure: i, matchUpId: n, matchUp: a }) {
  var s, c;
  let o = [];
  return n && a ? o = [a] : r && i ? o = ((s = Ke({ matchUpFilters: { matchUpTypes: [lt] }, structure: i })) == null ? void 0 : s.matchUps) ?? [] : t && (o = ((c = vr({ matchUpFilters: { matchUpTypes: [lt] }, drawDefinition: t })) == null ? void 0 : c.matchUps) ?? []), { targetMatchUps: o.filter((u) => !u.winningSide && u.matchUpStatus !== Tt && (e || u.matchUpStatus !== Gi && !jt(u))) };
}
function r2({ updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: r, targetMatchUps: i, tieFormat: n, event: a }) {
  for (let o of i) {
    let s = !!o.tieFormat;
    s && (o.tieFormat = sr(n));
    let c;
    if (e) {
      let u = je({ tournamentRecord: t, drawDefinition: r, event: a }).appliedPolicies, d = na({ matchUpId: o.matchUpId, exitWhenNoValues: !0, tournamentRecord: t, appliedPolicies: u, drawDefinition: r, event: a });
      if (d.error)
        return d;
      c = d.score;
    }
    s && !c && xe({ tournamentId: t == null ? void 0 : t.tournamentId, context: "updateTargetTeamMatchUps", eventId: a == null ? void 0 : a.eventId, matchUp: o, drawDefinition: r });
  }
  return { ...V };
}
function W0({ updateInProgressMatchUps: e, originalValueGoal: t, tournamentRecord: r, wasAggregateValue: i, tieFormatName: n, drawDefinition: a, structureId: o, structure: s, tieFormat: c, matchUpId: u, matchUp: d, eventId: p, event: l }) {
  let { aggregateValue: m, valueGoal: f } = gs(c);
  c.winCriteria = me({ aggregateValue: m, valueGoal: f }), (t && t !== f || m && !i) && (n ? c.tieFormatName = n : delete c.tieFormatName);
  let { targetMatchUps: h } = t2({ updateInProgressMatchUps: e, drawDefinition: a, structureId: o, structure: s, matchUpId: u, matchUp: d });
  r2({ updateInProgressMatchUps: e, tournamentRecord: r, targetMatchUps: h, drawDefinition: a, tieFormat: c, event: l });
  let g = me(c), I = Ar({ tieFormat: g });
  if (I.error)
    return I;
  if (p && l)
    l.tieFormat = g;
  else if (u && d)
    d.tieFormat = c;
  else if (s)
    s.tieFormat = g;
  else if (a)
    a.tieFormat = g;
  else if (!d || !a)
    return { error: le };
  return ut({ drawDefinition: a, eventId: l == null ? void 0 : l.eventId }), { ...V };
}
function H0({ updateInProgressMatchUps: e = !0, collectionGroupNumber: t, tournamentRecord: r, drawDefinition: i, tieFormatName: n, structureId: a, matchUpId: o, matchUp: s, eventId: c, event: u }) {
  if (!t)
    return { error: Ie };
  if (isNaN(t))
    return { error: J };
  let d = "removeCollectionGroup", p = s ? void 0 : ro({ drawDefinition: i, structureId: a, matchUpId: o, eventId: c, event: u });
  if (p != null && p.error)
    return j({ result: p, stack: d });
  let l = p == null ? void 0 : p.structure;
  s = s ?? (p == null ? void 0 : p.matchUp);
  let m = p == null ? void 0 : p.tieFormat, f = m == null ? void 0 : m.winCriteria.valueGoal, h = m == null ? void 0 : m.winCriteria.aggregateValue, g = sr(m);
  if (p = Ar({ tieFormat: g }), p.error)
    return j({ result: p, stack: d });
  let I = [];
  if (g.collectionDefinitions = g.collectionDefinitions.map((y) => {
    let { collectionGroupNumber: U, ...S } = y;
    return U !== t ? y : (I.push(y.collectionId), S);
  }), g.collectionGroups = g.collectionGroups.filter(({ groupNumber: y }) => y !== t), p = W0({ updateInProgressMatchUps: e, originalValueGoal: f, wasAggregateValue: h, tournamentRecord: r, drawDefinition: i, tieFormatName: n, structureId: a, structure: l, tieFormat: g, matchUpId: o, matchUp: s, eventId: c, event: u }), !p.error) {
    let { appliedPolicies: y } = je({ tournamentRecord: r }), U = me({ drawId: i == null ? void 0 : i.drawId, collectionGroupNumber: t, action: d, structureId: a, matchUpId: o, eventId: c });
    jm({ appliedPolicies: y, drawDefinition: i, auditData: U });
  }
  return j({ result: { ...p, modifiedCollectionIds: I }, stack: d });
}
function ec({ tieFormat: e, orderMap: t }) {
  var i;
  let r = sr(e);
  return r.collectionDefinitions.forEach((n) => {
    let a = t[n.collectionId];
    a && (n.collectionOrder = a);
  }), (i = r.collectionDefinitions) == null || i.sort((n, a) => Es(n.collectionOrder) - Es(a.collectionOrder)), r;
}
function z0({ tournamentRecord: e, drawDefinition: t, structureId: r, matchUpId: i, orderMap: n, eventId: a, matchUp: o, event: s }) {
  if (typeof n != "object" || !Object.values(n).every((c) => Pe(c)))
    return j({ result: { error: J }, context: { orderMap: n } });
  if (a && (s != null && s.tieFormat))
    JS({ tournamentRecord: e, event: s, orderMap: n });
  else if (i) {
    let c = t && ft({ drawDefinition: t, matchUpId: i });
    if (c != null && c.error)
      return c;
    if (o = c.matchUp, !o)
      return { error: Vr };
    o != null && o.tieFormat && (o.tieFormat = ec({ tieFormat: o.tieFormat, orderMap: n }), xe({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: s == null ? void 0 : s.eventId, drawDefinition: t, matchUp: o }));
  } else if (r) {
    let c = ve({ drawDefinition: t, structureId: r });
    if (c.error)
      return c;
    let u = c.structure;
    if (u != null && u.tieFormat)
      u.tieFormat = ec({ tieFormat: u.tieFormat, orderMap: n }), Y0({ eventId: s == null ? void 0 : s.eventId, tournamentRecord: e, drawDefinition: t, structure: u, orderMap: n }), ut({ drawDefinition: t, structureIds: [u.structureId] });
    else if (t.tieFormat)
      ph({ structureIds: [r], tournamentRecord: e, drawDefinition: t, orderMap: n, event: s });
    else if (s != null && s.tieFormat)
      JS({ structureIds: [r], tournamentRecord: e, orderMap: n, event: s });
    else
      return { error: Zt };
  } else if (t != null && t.tieFormat)
    ph({ tournamentRecord: e, drawDefinition: t, orderMap: n, event: s });
  else
    return { error: Zt };
  return { ...V };
}
function JS({ tournamentRecord: e, structureIds: t, orderMap: r, event: i }) {
  let n = ec({ tieFormat: i.tieFormat, orderMap: r });
  t != null && t.length || (i.tieFormat = n);
  for (let a of i.drawDefinitions ?? [])
    ph({ tournamentRecord: e, drawDefinition: a, structureIds: t, orderMap: r, event: i });
}
function ph({ tournamentRecord: e, drawDefinition: t, structureIds: r, orderMap: i, event: n }) {
  let a = t.tieFormat ?? (n == null ? void 0 : n.tieFormat), o = ec({ tieFormat: a, orderMap: i });
  r != null && r.length || (t.tieFormat = o);
  let s = [];
  for (let c of t.structures ?? [])
    r != null && r.length && !r.includes(c.structureId) || ((c.tieFormat || r != null && r.includes(c.structureId)) && (c.tieFormat = ec({ tieFormat: c.tieFormat ?? t.tieFormat ?? (n == null ? void 0 : n.tieFormat), orderMap: i })), Y0({ eventId: n == null ? void 0 : n.eventId, tournamentRecord: e, drawDefinition: t, structure: c, orderMap: i }), s.push(c.structureId));
  ut({ drawDefinition: t, structureIds: s });
}
function Y0({ tournamentRecord: e, drawDefinition: t, structure: r, orderMap: i, eventId: n }) {
  var o;
  let a = (o = Ke({ matchUpFilters: { matchUpTypes: [lt] }, structure: r })) == null ? void 0 : o.matchUps;
  for (let s of a)
    s.tieFormat && (s.tieFormat = ec({ tieFormat: s.tieFormat, orderMap: i }), xe({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t, eventId: n, matchUp: s }));
}
function by({ updateInProgressMatchUps: e = !0, tieFormatComparison: t, tournamentRecord: r, drawDefinition: i, tieFormatName: n, collectionId: a, structureId: o, matchUpId: s, eventId: c, matchUp: u, event: d }) {
  var R, M, E, C, A;
  let p = "removeCollectionDefinition", l = u ? void 0 : ro({ drawDefinition: i, structureId: o, matchUpId: s, eventId: c, event: d });
  if (l != null && l.error)
    return j({ result: l, stack: p });
  let m = l == null ? void 0 : l.structure;
  u = u ?? (l == null ? void 0 : l.matchUp);
  let f = l == null ? void 0 : l.tieFormat, h = sr(f);
  if (l = Ar({ tieFormat: h }), l.error)
    return j({ result: l, stack: p });
  let g = (R = h == null ? void 0 : h.collectionDefinitions) == null ? void 0 : R.find((N) => N.collectionId === a);
  if (!g)
    return j({ result: { error: Zt, collectionId: a } });
  h.collectionDefinitions = h.collectionDefinitions.filter((N) => N.collectionId !== a), g.collectionGroupNumber && (h.collectionDefinitions = h.collectionDefinitions.map((N) => {
    let { collectionGroupNumber: O, ...k } = N;
    return k;
  }), h.collectionGroups = h.collectionGroups.filter(({ groupNumber: N }) => N !== g.collectionGroupNumber));
  let { aggregateValue: I, valueGoal: y } = gs(h);
  h.winCriteria = me({ aggregateValue: I, valueGoal: y });
  let U = f == null ? void 0 : f.winCriteria.valueGoal, S = f == null ? void 0 : f.winCriteria.aggregateValue;
  (U && U !== y || I && !S) && (n ? h.tieFormatName = n : delete h.tieFormatName);
  let D = [];
  s && u ? D = [u] : o && m ? D = ((M = Ke({ matchUpFilters: { matchUpTypes: [lt] }, structure: m })) == null ? void 0 : M.matchUps) ?? [] : i ? D = ((E = vr({ matchUpFilters: { matchUpTypes: [lt] }, drawDefinition: i })) == null ? void 0 : E.matchUps) ?? [] : d && (D = ((C = Ln({ matchUpFilters: { matchUpTypes: [lt] }, drawDefinition: i })) == null ? void 0 : C.matchUps) ?? []);
  let w = (D || []).filter((N) => {
    var F, x, _;
    let O = (x = (F = N.tieMatchUps) == null ? void 0 : F.filter((B) => B.collectionId === a)) == null ? void 0 : x.some(jt), k = t && N.tieFormat ? (_ = Xn({ descendant: N.tieFormat, ancestor: h })) == null ? void 0 : _.different : !1;
    return e && !O || !N.winningSide && N.matchUpStatus !== Tt && (e || N.matchUpStatus !== Gi && !jt(N) && !k);
  });
  if (!w.length)
    return { error: cc };
  let { appliedPolicies: v } = je({ tournamentRecord: r });
  if (s && u && e) {
    let N = (A = u.tieMatchUps) == null ? void 0 : A.filter((O) => O.collectionId === a);
    for (let O of N ?? []) {
      let k = Ed({ matchUpId: O.matchUpId, tieMatchUpId: u == null ? void 0 : u.matchUpId, winningSide: void 0, removeScore: !0, tournamentRecord: r, appliedPolicies: v, drawDefinition: i, event: d });
      if (k.error || (k = ft({ drawDefinition: i, matchUpId: s }), k.error))
        return k;
      u = k == null ? void 0 : k.matchUp;
    }
  }
  let P = [];
  for (let N of w) {
    for (let O of (N == null ? void 0 : N.sides) ?? [])
      O.lineUp = (O.lineUp ?? []).map((k) => ({ participantId: k.participantId, collectionAssignments: ((k == null ? void 0 : k.collectionAssignments) ?? []).filter((F) => F.collectionId !== a) }));
    if (N.tieMatchUps = (N.tieMatchUps ?? []).filter((O) => {
      let k = O.collectionId === a;
      return k && P.push(O.matchUpId), !k;
    }), N.tieFormat && (N.tieFormat = sr(h)), e) {
      let O = na({ matchUpId: N.matchUpId, exitWhenNoValues: !0, tournamentRecord: r, appliedPolicies: v, drawDefinition: i, event: d });
      if (O.error)
        return O;
    }
    xe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: d == null ? void 0 : d.eventId, drawDefinition: i, context: p, matchUp: N });
  }
  P.length && ta({ tournamentId: r == null ? void 0 : r.tournamentId, matchUpIds: P, eventId: d == null ? void 0 : d.eventId, drawDefinition: i });
  let b = me(h);
  if (l = Ar({ tieFormat: b }), l.error)
    return j({ result: l, stack: p });
  if (c && d)
    d.tieFormat = b;
  else if (s && u)
    u.tieFormat = b;
  else if (m)
    m.tieFormat = b;
  else if (i)
    i.tieFormat = b;
  else if (!u || !i)
    return { error: le };
  ut({ drawDefinition: i, eventId: d == null ? void 0 : d.eventId });
  let T = me({ drawId: i == null ? void 0 : i.drawId, action: p, collectionId: a, structureId: o, matchUpId: s, eventId: c });
  return jm({ appliedPolicies: v, drawDefinition: i, auditData: T }), { tieFormat: b, deletedMatchUpIds: P, targetMatchUps: w, ...V };
}
function K0({ updateInProgressMatchUps: e = !0, tournamentRecord: t, groupDefinition: r, drawDefinition: i, collectionIds: n, tieFormatName: a, structureId: o, matchUpId: s, matchUp: c, eventId: u, event: d }) {
  let p = "addCollectionGroup";
  if (!Array.isArray(n))
    return j({ result: { error: Ie }, stack: p });
  let l = c ? void 0 : ro({ drawDefinition: i, structureId: o, matchUpId: s, eventId: u, event: d });
  if (l != null && l.error)
    return j({ result: l, stack: p });
  let m = l == null ? void 0 : l.structure;
  c = c || (l == null ? void 0 : l.matchUp);
  let f = l == null ? void 0 : l.tieFormat, h = f == null ? void 0 : f.winCriteria.valueGoal, g = sr(f);
  if (l = Ar({ tieFormat: g }), l.error)
    return j({ result: l, stack: p });
  for (let y of g.collectionDefinitions) {
    let { collectionId: U, collectionGroupNumber: S } = y;
    if (S && n.includes(U))
      return j({ info: "collectionIds cannot be part of other collectionGroups", result: { error: J }, stack: p });
  }
  let I = (g.collectionGroups || []).reduce((y, U) => U.groupNumber > y ? U.groupNumber : y, 0) + 1;
  return r.groupNumber = I, g.collectionDefinitions = g.collectionDefinitions.map((y) => n.includes(y.collectionId) ? { ...y, collectionGroupNumber: I } : y), g.collectionGroups = [...g.collecitonGroups || [], r], W0({ updateInProgressMatchUps: e, originalValueGoal: h, tournamentRecord: t, drawDefinition: i, tieFormatName: a, structureId: o, structure: m, tieFormat: g, matchUpId: s, matchUp: c, eventId: u, event: d });
}
function Ry({ updateInProgressMatchUps: e = !0, collectionDefinition: t, referenceCategory: r, tournamentRecord: i, policyDefinitions: n, enforceCategory: a, referenceGender: o, drawDefinition: s, tieFormatName: c, enforceGender: u, structureId: d, matchUpId: p, matchUp: l, eventId: m, uuids: f, event: h }) {
  var x, _;
  let g = "addCollectionDefinition", I = je({ tournamentRecord: i, drawDefinition: s, event: h }).appliedPolicies ?? {}, y = (n == null ? void 0 : n[Xt]) ?? (I == null ? void 0 : I[Xt]);
  a = a ?? ((x = y == null ? void 0 : y.participants) == null ? void 0 : x.enforceCategory);
  let U = (u ?? ((_ = y == null ? void 0 : y.participants) == null ? void 0 : _.enforceGender)) !== !1, S = !!((r ?? (h == null ? void 0 : h.category)) && a !== !1), D = !!((o ?? (h == null ? void 0 : h.gender)) && U), w = Cu({ referenceCategory: r ?? (h == null ? void 0 : h.category), collectionDefinition: t, referenceGender: o, checkCategory: S, checkGender: D, event: h });
  if (w.error)
    return j({ result: w, stack: g });
  let v = l != null && l.tieFormat ? void 0 : ro({ drawDefinition: s, structureId: d, matchUpId: p, eventId: m, event: h });
  if (v != null && v.error)
    return j({ result: { error: v.error }, stack: g });
  let P = v == null ? void 0 : v.structure;
  l = l ?? (v == null ? void 0 : v.matchUp);
  let b = (l == null ? void 0 : l.tieFormat) ?? (v == null ? void 0 : v.tieFormat), T = sr(b);
  if (v = Ar({ tieFormat: T }), v == null ? void 0 : v.error)
    return j({ result: { error: v.error }, stack: g });
  if (!t.collectionId)
    t.collectionId = ze();
  else if (T.collectionDefinitions.map(({ collectionId: B }) => B).includes(t.collectionId))
    return j({ context: { collectionId: t.collectionId }, result: { error: Cw } });
  T.collectionDefinitions.push(t), T.collectionDefinitions.sort((B, L) => (B.collectionOrder || 0) - (L.collectionOrder || 0)).forEach((B, L) => B.collectionOrder = L + 1);
  let { aggregateValue: R, valueGoal: M } = gs(T);
  T.winCriteria = me({ aggregateValue: R, valueGoal: M });
  let E = b == null ? void 0 : b.winCriteria.valueGoal, C = b == null ? void 0 : b.winCriteria.aggregateValue;
  (E && E !== M || R && !C) && (c ? T.tieFormatName = c : delete T.tieFormatName);
  let A = [], N = [], O = [], k = me(T);
  if (v = Ar({ tieFormat: k }), v == null ? void 0 : v.error)
    return j({ result: { error: v.error }, stack: g });
  if (m && h) {
    h.tieFormat = k;
    for (let B of h.drawDefinitions ?? [])
      if (!B.tieFormat)
        for (let L of B.structures ?? []) {
          if (L.tieFormat)
            continue;
          let G = cf({ updateInProgressMatchUps: e, collectionDefinition: t, structure: L, uuids: f });
          N.push(...G.newMatchUps), O.push(...G.targetMatchUps), A.push(L.structureId);
        }
    Vd({ modifiedMatchUps: O, eventId: h == null ? void 0 : h.eventId, modifiedStructureIds: A, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else if (d && P) {
    P.tieFormat = k;
    let B = cf({ updateInProgressMatchUps: e, collectionDefinition: t, structure: P, uuids: f });
    N.push(...B.newMatchUps), O = B.targetMatchUps, Vd({ modifiedMatchUps: O, eventId: h == null ? void 0 : h.eventId, modifiedStructureIds: A, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else if (p && l) {
    if (!Bl({ matchUp: l, updateInProgressMatchUps: e }))
      return j({ result: { error: Eh }, stack: g });
    l.tieFormat = k;
    let B = fd({ collectionDefinition: t, matchUp: l, uuids: f });
    Array.isArray(l.tieMatchUps) || (l.tieMatchUps = []), l.tieMatchUps.push(...B), N.push(...B), Vd({ modifiedMatchUps: [l], eventId: h == null ? void 0 : h.eventId, modifiedStructureIds: A, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else if (s) {
    s.tieFormat = k;
    for (let B of s.structures ?? []) {
      let L = cf({ updateInProgressMatchUps: e, collectionDefinition: t, structure: B, uuids: f });
      A.push(B.structureId), N.push(...L.newMatchUps), O.push(...L.targetMatchUps);
    }
    Vd({ modifiedMatchUps: O, eventId: h == null ? void 0 : h.eventId, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else
    return { error: le };
  let F = me({ drawId: s == null ? void 0 : s.drawId, collectionDefinition: t, action: g, structureId: d, matchUpId: p, eventId: m });
  return jm({ appliedPolicies: I, drawDefinition: s, auditData: F }), { tieFormat: k, targetMatchUps: O, addedMatchUps: N, ...V };
}
function cf({ updateInProgressMatchUps: e, collectionDefinition: t, structure: r, uuids: i }) {
  var o;
  let n = [], a = ((o = Ke({ matchUpFilters: { matchUpTypes: [lt] }, structure: r })) == null ? void 0 : o.matchUps).filter((s) => Bl({ matchUp: s, updateInProgressMatchUps: e }) && !s.tieFormat);
  for (let s of a) {
    let c = fd({ collectionDefinition: t, matchUp: s, uuids: i });
    Array.isArray(s.tieMatchUps) || (s.tieMatchUps = []), s.tieMatchUps.push(...c), n.push(...c);
  }
  return { newMatchUps: n, targetMatchUps: a };
}
function Vd({ modifiedStructureIds: e, tournamentRecord: t, modifiedMatchUps: r, drawDefinition: i, addedMatchUps: n, eventId: a, stack: o }) {
  ya({ tournamentId: t == null ? void 0 : t.tournamentId, matchUps: n, drawDefinition: i, eventId: a }), r == null || r.forEach((s) => {
    xe({ tournamentId: t == null ? void 0 : t.tournamentId, drawDefinition: i, context: o, matchUp: s, eventId: a });
  }), ut({ structureIds: e, drawDefinition: i, eventId: a });
}
function Q0({ updateInProgressMatchUps: e = !1, tieFormatComparison: t, modifiedTieFormat: r, tournamentRecord: i, considerations: n, drawDefinition: a, structureId: o, matchUpId: s, eventId: c, uuids: u, event: d }) {
  let p = "modifyTieFormat";
  if (!Ar({ tieFormat: r }).valid)
    return j({ result: { error: wn }, info: "falied validation", stack: p });
  let l = ro({ drawDefinition: a, structureId: o, matchUpId: s, eventId: c, event: d });
  if (l.error)
    return j({ result: l, stack: p });
  let { matchUp: m, tieFormat: f } = l, h = sr(f), g = Xn({ descendant: r, ancestor: h, considerations: n });
  if (g.invalid)
    return j({ context: { invalid: g.invalid }, result: { error: wn }, stack: p });
  if (!(g != null && g.different))
    return j({ result: { ...V }, info: "Nothing to do", stack: p });
  let I = h.collectionDefinitions.map(({ collectionId: b }) => b), y = r.collectionDefinitions.map(({ collectionId: b }) => b), U = I.filter((b) => !y.includes(b)), S = r.collectionDefinitions.filter(({ collectionId: b }) => !I.includes(b)), D = S.map(ei("collectionId")), w = [], v, P = r.tieFormatName;
  for (let b of r.collectionDefinitions) {
    if (D.includes(b.collectionId))
      continue;
    let T = Ty({ updateInProgressMatchUps: e, ...b, tournamentRecord: i, tieFormatName: P, drawDefinition: a, structureId: o, matchUpId: s, eventId: c, event: d });
    if (T.modifications && w.push(...T.modifications), T.error)
      return j({ result: T, stack: p });
    T.tieFormat && (v = T.tieFormat);
  }
  for (let b of S) {
    let T = Ry({ updateInProgressMatchUps: e, collectionDefinition: b, tournamentRecord: i, drawDefinition: a, tieFormatName: P, structureId: o, matchUpId: s, matchUp: m, eventId: c, uuids: u, event: d });
    if (T.error)
      return j({ result: T, stack: p });
    T.tieFormat && (v = T.tieFormat);
  }
  for (let b of U) {
    let T = by({ updateInProgressMatchUps: e, tieFormatComparison: t, tournamentRecord: i, drawDefinition: a, tieFormatName: P, collectionId: b, structureId: o, matchUpId: s, eventId: c, matchUp: m, event: d });
    if (T.error)
      return j({ result: T, stack: p });
    T.tieFormat && (v = T.tieFormat);
  }
  return (f == null ? void 0 : f.tieFormatName) !== P ? (v.tieFormatName = P, w.push({ tieFormatName: P })) : (w.length || D.length || U.length) && (delete v.tieFormatName, w.push("tieFormatName removed: modifications without new tieFormatName")), v.collectionDefinitions = v.collectionDefinitions.sort((b, T) => Es(b.collectionOrder) - Es(T.collectionOrder)).map((b, T) => ({ ...b, collectionOrder: T + 1 })), { processedTieFormat: sr(v), modifications: w, ...V };
}
function J0({ tournamentRecord: e }) {
  if (!e)
    return { error: ae };
  let t = 0;
  for (let r of e.events ?? []) {
    let i = r.tieFormats ?? [], n = (d) => {
      if (!d.tieFormat)
        return;
      let p;
      for (let l of i)
        Xn({ descendant: d.tieFormat, ancestor: l }).different || (p = l.tieFormatId);
      if (p)
        d.tieFormatId = p, delete d.tieFormat;
      else {
        let l = ce(d.tieFormat, void 0, !0);
        l.tieFormatId || (l.tieFormatId = ze()), d.tieFormatId = l.tieFormatId, delete d.tieFormat, i.push(l), t += 1;
      }
    }, a = r.eventType;
    n({ tieFormat: r.tieFormat, eventType: a });
    for (let d of r.drawDefinitions ?? []) {
      n({ tieFormat: d.tieFormat, eventType: a });
      for (let p of d.structures ?? [])
        n({ tieFormat: p.tieFormat, eventType: a });
    }
    let o = (d, p) => {
      var m;
      let l = (m = c.matchUps) == null ? void 0 : m.find((f) => f.matchUpId === d);
      l && (l.tieFormatId = p, delete l.tieFormat, xe({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: r.eventId, matchUp: l }));
    }, s = (d) => {
      let p = ce(d.tieFormat, void 0, !0);
      p.tieFormatId || (p.tieFormatId = ze()), i.push(p), t += 1, o(d.matchUpId, p.tieFormatId);
    }, c = Ln({ matchUpFilters: { matchUpTypes: [ni] }, event: r }), u = c.matchUps ?? [];
    for (let d of u) {
      let p;
      for (let l of i)
        d.tieFormat && Xn({ descendant: d.tieFormat, ancestor: l }).different || (p = l.tieFormatId);
      p ? o(d.matchUpId, p) : s(d);
    }
    i.length && (r.tieFormats = i);
  }
  return { ...V, addedCount: t };
}
var X0 = {};
Ae(X0, { addDrawDefinitionExtension: () => Up, addEventExtension: () => Ma, addEventTimeItem: () => ms, addExtension: () => Ve, addNotes: () => Wp, addOnlineResource: () => aA, addParticipantExtension: () => iD, addParticipantTimeItem: () => xI, addTimeItem: () => yn, addTournamentExtension: () => gg, addTournamentTimeItem: () => Ud, analyzeDraws: () => yd, analyzeTournament: () => IU, copyTournamentRecord: () => eA, createTournamentRecord: () => _m, generate: () => Z0, getAggregateTeamResults: () => gU, getAllowedDrawTypes: () => sm, getAllowedMatchUpFormats: () => mU, getAppliedPolicies: () => je, getCompetitionDateRange: () => um, getCompetitionPenalties: () => fU, getPolicyDefinitions: () => ra, getTournamentInfo: () => hs, getTournamentPenalties: () => cm, getTournamentPersons: () => hU, getTournamentPoints: () => dm, getTournamentStructures: () => II, getTournamentTimeItem: () => Mp, mutate: () => tA, query: () => rM, removeDrawDefinitionExtension: () => nD, removeEventExtension: () => yp, removeExtension: () => Sr, removeNotes: () => CI, removeOnlineResource: () => nA, removeParticipantExtension: () => aD, removeTournamentExtension: () => Ig, setTournamentCategories: () => cA, setTournamentDates: () => Gm, setTournamentEndDate: () => dA, setTournamentName: () => oA, setTournamentNotes: () => sA, setTournamentStartDate: () => uA, setTournamentStatus: () => iA });
var Z0 = {};
Ae(Z0, { copyTournamentRecord: () => eA, createTournamentRecord: () => _m });
function eA(e) {
  var l, m;
  let t = fe(e, [{ tournamentRecord: !0, startDate: !0, endDate: !1, tournamentName: !0 }]);
  if (t.error)
    return t;
  let { startDate: r, endDate: i } = e.tournamentRecord, n = 24 * 60 * 60 * 1e3, a = (r && i ? new Date(be(i)).getTime() - new Date(be(r)).getTime() : 0) / n, o = e.endDate || Xh(e.startDate, a), s = (f) => f == null ? void 0 : f.filter(({ itemType: h }) => {
    var g;
    return (g = e.itemTypeList) == null ? void 0 : g.includes(h);
  }), c = (f) => f == null ? void 0 : f.filter(({ name: h }) => {
    var g;
    return (g = e.extensionList) == null ? void 0 : g.includes(h);
  }), u = (f) => {
    let { timeItems: h, extensions: g, ...I } = f;
    return ce({ ...I, timeItems: s(h), extensions: c(g) }, !1, !0);
  }, d = (f) => {
    let { drawDefinitions: h, timeItems: g, extensions: I, startDate: y, endDate: U, ...S } = f;
    return ce({ extensions: c(I), timeItems: s(g), startDate: e.startDate, endDate: o, ...S }, !1, !0);
  }, p = { participants: e.copyParticipants ? ((l = e.tournamentRecord.participants) == null ? void 0 : l.map(u)) ?? [] : [], parentOrganisation: ce({ ...e.tournamentRecord.parentOrganisation }, !1, !0), venues: ce(e.tournamentRecord.venues ?? [], !1, !0), extensions: c(e.tournamentRecord.extensions), timeItems: s(e.tournamentRecord.timeItems), events: ((m = e.tournamentRecord.events) == null ? void 0 : m.map(d)) ?? [], weekdays: [...e.tournamentRecord.weekdays ?? []], tournamentName: e.tournamentName, startDate: e.startDate, tournamentId: ze(), endDate: o };
  return { ...V, tournamentRecord: p };
}
var tA = {};
Ae(tA, { addDrawDefinitionExtension: () => Up, addEventExtension: () => Ma, addEventTimeItem: () => ms, addExtension: () => Ve, addNotes: () => Wp, addOnlineResource: () => aA, addParticipantExtension: () => iD, addParticipantTimeItem: () => xI, addTimeItem: () => yn, addTournamentExtension: () => gg, addTournamentTimeItem: () => Ud, removeDrawDefinitionExtension: () => nD, removeEventExtension: () => yp, removeExtension: () => Sr, removeNotes: () => CI, removeOnlineResource: () => nA, removeParticipantExtension: () => aD, removeTournamentExtension: () => Ig, setTournamentCategories: () => cA, setTournamentDates: () => Gm, setTournamentEndDate: () => dA, setTournamentName: () => oA, setTournamentNotes: () => sA, setTournamentStartDate: () => uA, setTournamentStatus: () => iA });
var i2 = "ABANDONED", n2 = "ACTIVE", a2 = "CANCELLED", o2 = "COMPLETED", s2 = "IN_PROGRESS", rA = { ABANDONED: i2, ACTIVE: n2, CANCELLED: a2, COMPLETED: o2, IN_PROGRESS: s2 };
function iA({ tournamentRecord: e, status: t }) {
  return e ? t && !Object.keys(rA).includes(t) ? { error: J, info: "Unknown status" } : (e.tournamentStatus = t, { ...V }) : { error: ae };
}
function nA(e) {
  var u, d, p;
  let t = fe(e, [{ tournamentRecord: !0, onlineResource: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, onlineResource: i, organisationId: n, participantId: a, personId: o, courtId: s, venueId: c } = e;
  if (n) {
    if (((u = r.parentOrganisation) == null ? void 0 : u.parentOrganisationId) !== n)
      return j({ result: { error: Zt } });
    vs({ element: r.parentOrganisation, onlineResource: i });
  } else if (a || o) {
    let l = (r.participants ?? []).find((m) => {
      var f;
      return o && ((f = m.person) == null ? void 0 : f.personId) === o || m.participantId === a;
    });
    if (!l)
      return j(o ? { result: { error: Zt } } : { result: { error: Dt } });
    if (o) {
      if (((d = l.person) == null ? void 0 : d.personId) !== o)
        return j({ result: { error: Wo } });
      vs({ element: l.person, onlineResource: i });
    } else
      vs({ element: l, onlineResource: i });
  } else if (s) {
    let l = (p = (r.venues ?? []).filter((m) => !c || m.venueId === c).flatMap((m) => (m.courts ?? []).filter((f) => f.courtId === s))) == null ? void 0 : p[0];
    if (!l)
      return j({ result: { error: sc } });
    vs({ element: l, onlineResource: i });
  } else if (c) {
    let l = (r.venues ?? []).find((m) => m.venueId === c);
    if (!l)
      return j({ result: { error: zo } });
    vs({ element: l, onlineResource: i });
  } else
    vs({ element: r, onlineResource: i }), De({ payload: { parentOrganisation: r.parentOrganisation, onlineResources: r.onlineResources, tournamentId: r.tournamentId }, topic: co });
  return { ...V };
}
function vs({ element: e, onlineResource: t }) {
  let r = (e.onlineResources ?? []).filter((i) => !((i == null ? void 0 : i[xs]) === t[xs] && (i == null ? void 0 : i[Ls]) === t[Ls] && (i == null ? void 0 : i[_s]) === t[_s]));
  e.onlineResources = r;
}
function aA(e) {
  var u, d, p;
  let t = fe(e, [{ tournamentRecord: !0, onlineResource: !0 }]);
  if (t.error)
    return t;
  let { tournamentRecord: r, onlineResource: i, organisationId: n, participantId: a, personId: o, courtId: s, venueId: c } = e;
  if (n) {
    if (((u = r.parentOrganisation) == null ? void 0 : u.parentOrganisationId) !== n)
      return j({ result: { error: Zt } });
    ws({ element: r.parentOrganisation, onlineResource: i });
  } else if (a || o) {
    let l = (r.participants ?? []).find((m) => {
      var f;
      return o && ((f = m.person) == null ? void 0 : f.personId) === o || m.participantId === a;
    });
    if (!l)
      return j(o ? { result: { error: Zt } } : { result: { error: Dt } });
    if (o) {
      if (((d = l.person) == null ? void 0 : d.personId) !== o)
        return j({ result: { error: Wo } });
      ws({ element: l.person, onlineResource: i });
    } else
      ws({ element: l, onlineResource: i });
  } else if (s) {
    let l = (p = (r.venues ?? []).filter((m) => !c || m.venueId === c).flatMap((m) => (m.courts ?? []).filter((f) => f.courtId === s))) == null ? void 0 : p[0];
    if (!l)
      return j({ result: { error: sc } });
    ws({ element: l, onlineResource: i });
  } else if (c) {
    let l = (r.venues ?? []).find((m) => m.venueId === c);
    if (!l)
      return j({ result: { error: zo } });
    ws({ element: l, onlineResource: i });
  } else
    ws({ element: r, onlineResource: i }), De({ payload: { parentOrganisation: r.parentOrganisation, onlineResources: r.onlineResources, tournamentId: r.tournamentId }, topic: co });
  return { ...V };
}
function ws({ element: e, onlineResource: t }) {
  let r = (e.onlineResources ?? []).filter((i) => (i == null ? void 0 : i[xs]) !== t[xs] && (i == null ? void 0 : i[Ls]) !== t[Ls] && (i == null ? void 0 : i[_s]) !== t[_s]);
  return r.push(t), e.onlineResources = r, { ...V };
}
function oA({ tournamentRecord: e, promotionalName: t, tournamentName: r, formalName: i }) {
  if (!e)
    return { error: ae };
  let n = e.tournamentId, a = { tournamentId: n };
  return r && r !== e.tournamentName && (e.tournamentName = r, a.tournamentName = r), t && t !== e.promotionalName && (e.promotionalName = t, a.promotionalName = t), i && i !== e.formalName && (e.formalName = i, a.formalName = i), e.promotionalName === e.tournamentName && (delete e.promotionalName, a.promotionalName = ""), e.formalName === e.tournamentName && (delete e.formalName, a.formalName = ""), Object.keys(a).length > 1 && De({ topic: co, payload: { parentOrganisation: e.parentOrganisation, tournamentId: n, ...a } }), { ...V };
}
function sA({ tournamentRecord: e, notes: t }) {
  if (!e)
    return { error: ae };
  let r = t ? Wp({ element: e, notes: t }) : CI({ element: e });
  return r.error ? r : (De({ topic: co, payload: { parentOrganisation: e.parentOrganisation, tournamentId: e.tournamentId, notes: t ?? "" } }), { ...V });
}
function cA({ tournamentRecord: e, categories: t }) {
  return e ? (t = (t || []).filter((r) => r.categoryName && r.type), e.tournamentCategories = t, De({ topic: co, payload: { parentOrganisation: e.parentOrganisation, tournamentId: e.tournamentId, categories: t } }), { ...V }) : { error: ae };
}
function c2({ tournamentRecord: e }) {
  var a, o;
  if (!e)
    return { error: ae };
  let { startDate: t, endDate: r } = e, i = Fs(t, r), n = [];
  for (let s of e.venues || [])
    (a = s == null ? void 0 : s.courts) != null && a.length && n.push(...s.courts);
  for (let s of n) {
    let { startTime: c, endTime: u } = (s.dateAvailability ?? []).reduce((l, m) => {
      let f = _e(l.startTime), h = _e(l.endTime);
      return m.startTime && _e(m.startTime) < f && (l.startTime = m.startTime), m.endTime && _e(m.endTime) > h && (l.endTime = m.endTime), l;
    }, { startTime: "08:00", endTime: "18:00" }), d = i.map((l) => {
      var m;
      return ((m = s.dateAvailability) == null ? void 0 : m.find((f) => f.date === l)) ?? { date: l, startTime: c, endTime: u };
    }), p = (o = s.dateAvailability) == null ? void 0 : o.find((l) => !l.date);
    p && d.unshift(p), s.dateAvailability = d;
  }
  return { ...V };
}
function Gm(e) {
  var m, f;
  let { tournamentRecord: t, startDate: r, endDate: i, weekdays: n } = e, a = (m = e.activeDates) == null ? void 0 : m.filter(Boolean), o = fe(e, [{ tournamentRecord: !0 }, { [cr]: (h) => un.test(h), [ci]: Qt, startDate: !1, endDate: !1 }, { [cr]: (h) => h.filter(Boolean).every((g) => un.test(g)), [ci]: Qt, activeDates: !1 }, { [cr]: BM, weekdays: !1 }]);
  if (o.error)
    return o;
  if (i && r && new Date(i) < new Date(r))
    return { error: J };
  if (i && r && new Date(r) > new Date(i))
    return { error: J };
  if (a != null && a.length) {
    let h = r || t.startDate, g = i || t.endDate, I = !h || a.every((U) => new Date(U) >= new Date(h)), y = !g || a.every((U) => new Date(U) <= new Date(g));
    if (!I || !y)
      return { error: Qt };
  }
  let s;
  (r && t.startDate && new Date(r) > new Date(t.startDate) || i && t.endDate && new Date(i) < new Date(t.endDate)) && (s = !0);
  let c = Fs(t.startDate, t.endDate);
  r && (t.startDate = r), i && (t.endDate = i);
  let u = Fs(t.startDate, t.endDate), d = c.filter((h) => !u.includes(h)), p = u.filter((h) => !c.includes(h));
  for (let h of t.events ?? [])
    r && h.startDate && new Date(h.startDate) < new Date(r) && (h.startDate = r), i && h.startDate && new Date(h.startDate) > new Date(i) && (h.startDate = r ?? i), i && h.endDate && new Date(h.endDate) > new Date(i) && (h.endDate = i), r && h.endDate && new Date(h.endDate) < new Date(r) && (h.endDate = i ?? r);
  r && t.endDate && new Date(r) > new Date(t.endDate) && (t.endDate = r), i && t.startDate && new Date(i) < new Date(t.startDate) && (t.startDate = i), a && (t.activeDates = a), n && (t.weekdays = n);
  let l = s && ((f = u2({ tournamentRecord: t })) == null ? void 0 : f.unscheduledMatchUpIds);
  return c2({ tournamentRecord: t }), De({ payload: me({ parentOrganisation: t.parentOrganisation, tournamentId: t.tournamentId, activeDates: a, startDate: r, weekdays: n, endDate: i }), topic: co }), { ...V, unscheduledMatchUpIds: l, datesAdded: p, datesRemoved: d };
}
function uA({ tournamentRecord: e, startDate: t }) {
  return t ? Gm({ tournamentRecord: e, startDate: t }) : { error: Qt };
}
function dA({ tournamentRecord: e, endDate: t }) {
  return t ? Gm({ tournamentRecord: e, endDate: t }) : { error: Qt };
}
function u2({ tournamentRecord: e }) {
  let t = tr({ tournamentRecord: e }).matchUps ?? [], r = e.startDate && new Date(e.startDate), i = e.endDate && new Date(e.endDate), n = [], a = [];
  for (let o of t) {
    let { schedule: s, matchUpId: c } = o;
    if (s && s.scheduledDate) {
      let u = new Date(s.scheduledDate);
      (r && u < r || i && u > i) && (a.push(c), n.includes(s.scheduledDate) || n.push(s.scheduledDate));
    }
  }
  return n.length && !xm({ scheduledDates: n, tournamentRecord: e }).clearedScheduleCount ? { error: Ov } : { unscheduledMatchUpIds: a };
}
var lA = {};
Ae(lA, { addCourt: () => Vm, addCourts: () => vy, addVenue: () => Zu, deleteCourt: () => SA, deleteVenue: () => Ey, deleteVenues: () => hA, disableCourts: () => gA, disableVenues: () => IA, enableCourts: () => UA, enableVenues: () => yA, generate: () => pA, generateCourts: () => KU, getCompetitionVenues: () => Pd, getCourts: () => FU, getVenuesAndCourts: () => aa, modifyCourt: () => Cy, modifyCourtAvailability: () => Ny, modifyVenue: () => vA, mutate: () => mA, publicFindVenue: () => Jg, query: () => yM });
var pA = {};
Ae(pA, { generateCourts: () => KU });
var mA = {};
Ae(mA, { addCourt: () => Vm, addCourts: () => vy, addVenue: () => Zu, deleteCourt: () => SA, deleteVenue: () => Ey, deleteVenues: () => hA, disableCourts: () => gA, disableVenues: () => IA, enableCourts: () => UA, enableVenues: () => yA, modifyCourt: () => Cy, modifyCourtAvailability: () => Ny, modifyVenue: () => vA });
function My(e) {
  if (!(e != null && e.tournamentRecord) && !Array.isArray(e == null ? void 0 : e.venueMatchUps))
    return { error: ae };
  if (!(e != null && e.courtId))
    return { error: qo };
  let { scheduleVisibilityFilters: t, tournamentRecord: r, matchUpFilters: i, venueMatchUps: n, courtId: a } = e, { schedulingProfile: o } = oa({ tournamentRecord: r });
  if (Array.isArray(n))
    return { matchUps: c({ matchUps: n, courtId: a }) };
  let { matchUps: s } = tr({ scheduleVisibilityFilters: t, tournamentRecord: r, matchUpFilters: i });
  return { matchUps: c({ matchUps: s, courtId: a }) };
  function c({ matchUps: u, courtId: d }) {
    let p = u.filter((l) => {
      var f, h, g;
      let m = (h = (f = l.schedule) == null ? void 0 : f.allocatedCourts) == null ? void 0 : h.map(({ courtId: I }) => I);
      return ((g = l.schedule) == null ? void 0 : g.courtId) === d || (m == null ? void 0 : m.includes(d));
    });
    return Cl({ matchUps: p, schedulingProfile: o });
  }
}
function d2({ scheduleVisibilityFilters: e, tournamentRecord: t, matchUpFilters: r, venueId: i }) {
  if (!t)
    return { error: ae };
  if (!i)
    return { error: Ta };
  let { schedulingProfile: n } = oa({ tournamentRecord: t }), { matchUps: a } = tr({ scheduleVisibilityFilters: e, tournamentRecord: t, matchUpFilters: r });
  return { matchUps: o({ matchUps: a, venueId: i }) };
  function o({ matchUps: s, venueId: c }) {
    let u = s.filter((d) => {
      var l, m, f;
      let p = (m = (l = d.schedule) == null ? void 0 : l.allocatedCourts) == null ? void 0 : m.map(({ venueId: h }) => h);
      return ((f = d.schedule) == null ? void 0 : f.venueId) === c || (p == null ? void 0 : p.includes(c));
    });
    return Cl({ matchUps: u, schedulingProfile: n });
  }
}
function Ny({ tournamentRecord: e, dateAvailability: t, disableNotice: r, venueMatchUps: i, courtId: n, force: a }) {
  var m, f, h;
  if (!e)
    return { error: ae };
  if (!n)
    return { error: qo };
  let o = zN({ dateAvailability: t });
  if (o.error)
    return o;
  let { updatedDateAvailability: s, totalMergeCount: c } = l2(t);
  t = s;
  let u = ss({ tournamentRecord: e, courtId: n });
  if (u.error)
    return u;
  let { court: d, venue: p } = u, { matchUps: l } = My({ tournamentRecord: e, venueMatchUps: i, courtId: n });
  if (l != null && l.length) {
    let g = (m = je({ tournamentRecord: e })) == null ? void 0 : m.appliedPolicies, I = a ?? ((h = (f = g == null ? void 0 : g[Ra]) == null ? void 0 : f.allowDeletionWithScoresPresent) == null ? void 0 : h.courts), y = [];
    y.length && (I || console.log("throw error: scheduled court matchUps", y.length));
  }
  return d && (d.dateAvailability = t, !r && p && De({ payload: { venue: p, tournamentId: e.tournamentId }, topic: uo, key: p.venueId })), { ...V, totalMergeCount: c };
}
function l2(e) {
  let t = 0, r = e.reduce((n, a) => {
    let { date: o, startTime: s, endTime: c, bookings: u } = a;
    return n[o] || (n[o] = []), n[o].push({ startTime: s, endTime: c, bookings: u }), n;
  }, {}), i = [];
  return Object.keys(r).forEach((n) => {
    r[n].sort(NV);
    let { mergedAvailability: a, mergeCount: o } = p2(r[n]);
    i.push(...a.map((s) => ({ date: n, ...s }))), t += o;
  }), { updatedDateAvailability: i, totalMergeCount: t };
}
function p2(e) {
  let t, r, i, n = e.length, a = 0, o = [];
  for (; e.length && n; ) {
    let c = e.shift(), { startTime: u, endTime: d, bookings: p } = c;
    if (n -= 1, !t)
      t = u, i = p, r = d;
    else if (Au(Ot(r), Ot(u), !1) > 0) {
      let l = { startTime: t, endTime: r };
      i != null && i.length && (l.bookings = i), o.push(l), t = u, i = p, r = d;
    } else
      p && (i ? i.push(p) : i = p), r = d, a += 1;
  }
  let s = { startTime: t, endTime: r };
  return i != null && i.length && (s.bookings = i), o.push(s), { mergedAvailability: o, mergeCount: a };
}
function Ay({ matchUpsCount: e = 0 }) {
  let t = `Schedule would be deleted from ${e} ${e === 1 ? "matchUp" : "matchUps"}; use { force: true }`;
  return { error: Lw, info: t };
}
function fA({ tournamentRecord: e, drawDefinition: t, matchUpId: r, drawId: i }) {
  let n = "removeCourtAssignment";
  if (!r)
    return { error: Ur };
  if (!t && !i)
    return { error: tn };
  let a;
  if (!t) {
    if (!e)
      return { error: ae };
    ({ drawDefinition: t } = Cr({ tournamentRecord: e, drawId: i }));
  }
  if (t)
    ({ matchUp: a } = ft({ drawDefinition: t, matchUpId: r }));
  else {
    if (!e)
      return { error: ae };
    let o = tr({ tournamentRecord: e, inContext: !1 }).matchUps ?? [];
    ({ matchUp: a } = yb({ matchUps: o, matchUpId: r }));
  }
  return a ? (a.timeItems && a.timeItems.find((o) => [va, kn].includes(o.itemType)) && (a.timeItems = a.timeItems.filter(({ itemType: o }) => ![va, kn].includes(o)), xe({ tournamentId: e == null ? void 0 : e.tournamentId, context: n, drawDefinition: t, matchUp: a })), { ...V }) : { error: hr };
}
function Ey(e) {
  var c, u, d;
  if (typeof (e == null ? void 0 : e.venueId) != "string")
    return { error: Ta };
  let { tournamentRecord: t, venueId: r, force: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!Object.keys(n).length)
    return { error: ae };
  let a = en({ tournamentRecords: n, contextFilters: { venueIds: [r] } }).matchUps ?? [], o = (c = je({ tournamentRecord: t })) == null ? void 0 : c.appliedPolicies, s = i ?? ((d = (u = o == null ? void 0 : o[Ra]) == null ? void 0 : u.allowDeletionWithScoresPresent) == null ? void 0 : d.venues);
  if (!a.length || s)
    for (let p of Object.values(n)) {
      for (let m of a) {
        let f = fA({ matchUpId: m.matchUpId, drawId: m.drawId, tournamentRecord: p });
        if (f.error)
          return f;
      }
      let l;
      p.venues = (p.venues ?? []).filter((m) => (m == null ? void 0 : m.venueId) !== r ? !0 : (l = !0, !1)), l && De({ payload: { venueId: r, tournamentId: p.tournamentId }, topic: Mg, key: r });
    }
  else
    return Ay({ matchUpsCount: a.length });
  return Td({ tournamentRecords: n }), { ...V };
}
function hA({ tournamentRecord: e, venueIds: t, force: r }) {
  if (!e)
    return { error: ae };
  if (!Array.isArray(t))
    return { error: J };
  for (let i of e.venues || []) {
    let { venueId: n } = i;
    if (t.includes(n)) {
      let { venueId: a } = i, o = Ey({ tournamentRecord: e, venueId: a, force: r });
      if (o.error)
        return o;
    }
  }
  return { ...V };
}
function gA(e) {
  let { courtIds: t, dates: r } = e, i = wi(e), n = [{ [gr]: !0, [gp]: !0 }], a = fe(e, n);
  if (a.error)
    return a;
  for (let o of Object.values(i))
    m2({ tournamentRecord: o, courtIds: t, dates: r });
  return { ...V };
}
function m2({ tournamentRecord: e, courtIds: t, dates: r }) {
  let i = Array.isArray(r) && r.length ? { dates: r } : !0, n = (a) => Ve({ extension: { value: i, name: Yi }, creationTime: !1, element: a });
  for (let a of e.venues || [])
    for (let o of a.courts || [])
      if (t != null && t.includes(o.courtId)) {
        let s = n(o);
        if (s.error)
          return s;
      }
  return { ...V };
}
function IA(e) {
  let { tournamentRecords: t, tournamentId: r, venueIds: i } = e, n = [{ [gr]: !0, [Ip]: !0 }], a = fe(e, n);
  if (a.error)
    return a;
  let o = Object.keys(t).filter((s) => !r || s === r);
  for (let s of o) {
    let c = t[s];
    f2({ tournamentRecord: c, venueIds: i });
  }
  return { ...V };
}
function f2({ tournamentRecord: e, venueIds: t }) {
  for (let r of e.venues || [])
    if (t != null && t.includes(r.venueId)) {
      let i = Ve({ creationTime: !1, element: r, extension: { name: Yi, value: !0 } });
      if (i.error)
        return i;
    }
  return { ...V };
}
function UA(e) {
  let t = wi(e), r = [{ [gr]: !0 }];
  !e.enableAll && r.push({ [gp]: !0 });
  let i = fe(e, r);
  if (i.error)
    return i;
  let { enableAll: n, courtIds: a, dates: o } = e;
  for (let s of Object.values(t))
    h2({ tournamentRecord: s, courtIds: a, enableAll: n, dates: o });
  return { ...V };
}
function h2({ tournamentRecord: e, courtIds: t, enableAll: r, dates: i }) {
  for (let n of e.venues || [])
    for (let a of n.courts || [])
      if (r || t != null && t.includes(a.courtId))
        if (Array.isArray(i)) {
          let { extension: o } = Ne({ element: a, name: Yi });
          if (o) {
            let s = o.value;
            Array.isArray(s.dates) && (s.dates = s.dates.filter((c) => !i.includes(c))), Ve({ extension: { name: Yi, value: s }, creationTime: !1, element: a });
          }
        } else
          Sr({ element: a, name: Yi });
  return { ...V };
}
function yA(e) {
  let t = wi(e), r = [{ [gr]: !0 }];
  !e.enableAll && r.push({ [Ip]: !0 });
  let i = fe(e, r);
  if (i.error)
    return i;
  let { venueIds: n, enableAll: a } = e;
  for (let o of Object.values(t))
    for (let s of o.venues || [])
      (a || n != null && n.includes(s.venueId)) && Sr({ element: s, name: Yi });
  return { ...V };
}
function SA(e) {
  let { courtId: t, disableNotice: r, force: i } = e, n = wi(e), a = fe(e, [{ [gr]: !0, [XP]: !0 }]);
  if (a.error)
    return a;
  let o, s;
  for (let c of Object.values(n)) {
    if (s = g2({ tournamentRecord: c, disableNotice: r, courtId: t, force: i }), s.error && s.error !== sc)
      return s;
    s.success && (o = !0);
  }
  return o ? { ...V } : s;
}
function g2({ tournamentRecord: e, disableNotice: t, courtId: r, force: i }) {
  var u, d, p;
  let n = ss({ tournamentRecord: e, courtId: r });
  if (n.error)
    return n;
  let a = n.venue, { matchUps: o } = My({ tournamentRecord: e, courtId: r }), s = (u = je({ tournamentRecord: e })) == null ? void 0 : u.appliedPolicies, c = i ?? ((p = (d = s == null ? void 0 : s[Ra]) == null ? void 0 : d.allowDeletionWithScoresPresent) == null ? void 0 : p.courts);
  if (!(o != null && o.length) || c) {
    for (let l of o ?? []) {
      let m = fA({ matchUpId: l.matchUpId, drawId: l.drawId, tournamentRecord: e });
      if (m.error)
        return m;
    }
    a && (a.courts = (a.courts ?? []).filter((l) => l.courtId !== r), t || De({ payload: { venue: a, tournamentId: e.tournamentId }, topic: uo, key: a.venueId }));
  } else
    return Ay({ matchUpsCount: o.length });
  return { ...V };
}
function Cy(e) {
  let { disableNotice: t, modifications: r, courtId: i, force: n, venueMatchUps: a } = e, o = wi(e);
  if (!Object.keys(o).length)
    return { error: yt };
  let s, c;
  for (let u of Object.values(o)) {
    let d = I2({ tournamentRecord: u, disableNotice: t, venueMatchUps: a, modifications: r, courtId: i, force: n });
    if (d != null && d.error)
      return d;
    s = !0;
  }
  return s ? { ...V } : c;
}
function I2({ tournamentRecord: e, disableNotice: t, venueMatchUps: r, modifications: i, courtId: n, force: a }) {
  if (!e)
    return { error: ae };
  if (!n)
    return { error: qo };
  if (!i || typeof i != "object")
    return { error: ea };
  let o = ss({ tournamentRecord: e, courtId: n });
  if (o.error)
    return o;
  let { venue: s, court: c } = o, u = Object.keys(MV()).filter((l) => l !== "courtId");
  if (!Object.keys(i).filter((l) => u.includes(l)).length)
    return { error: Xl };
  let d = u.filter((l) => !["dateAvailability"].includes(l)), p = Object.keys(i).filter((l) => d.includes(l));
  if (c && p.forEach((l) => Object.assign(c, { [l]: i[l] })), i.dateAvailability) {
    let l = Ny({ dateAvailability: i.dateAvailability, tournamentRecord: e, venueMatchUps: r, disableNotice: t, courtId: n, force: a });
    if (l.error)
      return l;
  }
  return t || De({ payload: { venue: s, tournamentId: e.tournamentId }, topic: uo, key: s == null ? void 0 : s.venueId }), { ...V, court: ce(c) };
}
var U2 = () => ({ venueId: void 0, venueName: "", venueAbbreviation: "", onlineResources: [], venueType: void 0, addresses: [], contacts: [], courts: [], roles: [] }), y2 = U2;
function vA(e) {
  let { modifications: t, venueId: r, force: i } = e, n = wi(e);
  if (!Object.keys(n).length)
    return { error: yt };
  if (typeof r != "string")
    return { error: Ta };
  let a, o;
  for (let s of Object.values(n)) {
    let c = S2({ tournamentRecord: s, modifications: t, venueId: r, force: i });
    if (c.success && (o = !0), c.error && (a = c.error), c.error && c.error !== zo)
      return c;
  }
  return Td({ tournamentRecords: n }), o ? { ...V } : { error: a };
}
function S2({ tournamentRecord: e, modifications: t, venueId: r, force: i }) {
  var g, I, y, U, S, D, w, v;
  if (!e)
    return { error: ae };
  if (!t || typeof t != "object")
    return { error: ea };
  if (!r)
    return { error: Ta };
  let n = (g = je({ tournamentRecord: e })) == null ? void 0 : g.appliedPolicies, a = i ?? ((y = (I = n == null ? void 0 : n[Ra]) == null ? void 0 : I.allowDeletionWithScoresPresent) == null ? void 0 : y.venues), { matchUps: o } = d2({ tournamentRecord: e, venueId: r }), s = xn({ tournamentRecord: e, venueId: r });
  if (s.error)
    return s;
  let c = s.venue, u = Object.keys(y2()).filter((P) => P !== "venueId");
  if (!Object.keys(t).filter((P) => u.includes(P)).length)
    return { error: Xl };
  let d = u.filter((P) => !["courts", "onlineResources"].includes(P)), p = Object.keys(t).filter((P) => d.includes(P));
  c && p.forEach((P) => Object.assign(c, { [P]: t[P] }));
  let l = ((U = c == null ? void 0 : c.courts) == null ? void 0 : U.map((P) => P.courtId)) ?? [], m = ((S = t.courts) == null ? void 0 : S.map((P) => P.courtId)) || [], f = m.length ? l.filter((P) => !m.includes(P)) : (t == null ? void 0 : t.courts) && l, h = [];
  if (f != null && f.length) {
    let P = (w = (D = c == null ? void 0 : c.courts) == null ? void 0 : D.filter((b) => f.includes(b.courtId))) == null ? void 0 : w.map((b) => {
      var R;
      let T = My({ courtId: b.courtId, tournamentRecord: e, venueMatchUps: o });
      for (let M of T.matchUps ?? [])
        h.push({ matchUpId: M.matchUpId, drawId: M.drawId });
      return ((R = T.matchUps) == null ? void 0 : R.length) ?? 0;
    }).reduce((b, T) => b + T);
    if (c && (!P || a))
      c.courts = (v = c.courts) == null ? void 0 : v.filter((b) => m.includes(b.courtId)), Su({ schedule: { courtId: "", scheduledDate: "" }, matchUpDetails: h, removePriorValues: !0, tournamentRecord: e });
    else
      return Ay({ matchUpsCount: P });
  }
  if (t.courts)
    for (let P of t.courts) {
      let { courtId: b } = P || {}, T = Cy({ modifications: P, disableNotice: !0, tournamentRecord: e, venueMatchUps: o, courtId: b, force: i });
      if (T.error === sc && (T = Vm({ disableNotice: !0, tournamentRecord: e, venueId: r, court: P })), T.error)
        return T;
    }
  return Td({ tournamentRecord: e }), c && De({ payload: { venue: c, tournamentId: e.tournamentId }, topic: uo, key: c == null ? void 0 : c.venueId }), { ...V, venue: ce(c) };
}
var Oy = {};
Ae(Oy, { JSON2CSV: () => R2, UUID: () => ze, UUIDS: () => iP, allNumeric: () => bv, attributeFilter: () => xo, chunkArray: () => zt, chunkByNth: () => ff, chunkSizeProfile: () => Tv, constantToString: () => dr, countValues: () => LE, createMap: () => Mv, dateTime: () => rP, definedAttributes: () => me, dehydrateMatchUps: () => P2, extractAttributes: () => aT, flattenJSON: () => ky, generateDateRange: () => Fs, generateHashCode: () => WE, generateRange: () => oe, generateTimeCode: () => e0, groupValues: () => Pv, hasAttributeValues: () => qE, instanceCount: () => Qr, intersection: () => wt, isConvertableInteger: () => Pe, isNumeric: () => St, isOdd: () => vv, isPowerOf2: () => Qi, makeDeepCopy: () => ce, matchUpScheduleSort: () => w2, matchUpSort: () => cs, nearestPowerOf2: () => gh, nextPowerOf2: () => tc, noNulls: () => xE, noNumeric: () => Rv, numericSort: () => Ft, occurrences: () => BE, overlap: () => wr, randomMember: () => Wr, randomPop: () => zr, shuffleArray: () => yr, structureSort: () => Zo, subSort: () => VE, undefinedToNull: () => hf, unique: () => Te, visualizeScheduledMatchUps: () => v2 });
function v2({ scheduledMatchUps: e, showGlobalLog: t }) {
  pk();
  let r = e == null ? void 0 : e.reduce((n, { structureId: a }) => n.includes(a) ? n : n.concat(a), []), i = Array.isArray(r) && { ...r.map((n) => {
    let { structureName: a, matchUpType: o } = e.find((s) => s.structureId === n);
    return { [n]: `${a} ${o}` };
  }) };
  r == null || r.forEach((n) => {
    var s;
    ii({ color: "blue", method: "draw", structure: i[n], keyColors: { structure: "magenta" } }, !0);
    let a = e.filter((c) => c.structureId === n), o = ((s = Pr({ matchUps: a })) == null ? void 0 : s.roundMatchUps) || [];
    Object.keys(o).forEach((c) => {
      ii({ roundNumber: c, keyColors: { roundNumber: "brightcyan" } }, !0), o[c].forEach(({ matchUpId: u, schedule: d }) => {
        let p = mt(d.scheduledTime);
        ii({ matchUpId: u, time: p, date: d.scheduledDate, venue: d.venueId, keyColors: { time: "brightcyan", date: "brightcyan", matchUpId: "yellow", venue: "magenta" } }, !0);
      });
    });
  }), t && lk();
}
var { extractTime: XS, timeStringMinutes: ZS } = rP;
function w2(e, t) {
  let r = e.schedule ?? {}, i = t.schedule ?? {};
  if (r.scheduledDate && !i.scheduledDate)
    return 1;
  if (i.scheduledDate && !r.scheduledDate)
    return -1;
  if (r.scheduledDate && i.scheduledDate) {
    if (r.scheduledDate === i.scheduledDate) {
      if (r.scheduledTime && !i.scheduledTime)
        return 1;
      if (i.scheduledTime && !r.scheduledTime)
        return -1;
      if (r.scheduledTime && i.scheduledTime) {
        let n = ZS(XS(r.scheduledTime)), a = ZS(XS(i.scheduledTime));
        return n - a;
      }
    }
    return new Date(r.scheduledDate).getTime() - new Date(i.scheduledDate).getTime();
  }
  return 0;
}
function P2({ tournamentRecord: e }) {
  if (!e)
    return { error: ae };
  if (typeof e != "object" || !e.tournamentId)
    return { error: J };
  let { matchUps: t } = tr({ tournamentRecord: e, inContext: !1 });
  if (t != null && t.length) {
    let r = D2({ tournamentRecord: e });
    b2(t, r);
  }
  return { ...V };
}
function D2({ tournamentRecord: e }) {
  let t = {};
  for (let r of e.events || []) {
    r.matchUpFormat && (t[r.eventId] = r.matchUpFormat);
    for (let i of r.drawDefinitions || []) {
      i.matchUpFormat && (t[i.drawId] = i.matchUpFormat);
      for (let n of i.structures || []) {
        n.matchUpFormat && (t[n.structureId] = n.matchUpFormat);
        for (let a of n.structures || [])
          a.matchUpFormat && (t[a.structureId] = a.matchUpFormat);
      }
    }
  }
  return t;
}
var T2 = ["collectionId", "collectionPosition", "drawPositions", "extensions", "finishingPositionRange", "finishingRound", "isMock", "matchUpId", "matchUpStatus", "matchUpStatusCodes", "orderOfFinish", "processCodes", "roundNumber", "tieFormat", "tieMatchUps", "roundPosition", "score", "sides", "winnerMatchUpId", "loserMatchUpId", "matchUpDuration", "winningSide"];
function b2(e, t = {}) {
  for (let r of e) {
    let { structureId: i, drawId: n, eventId: a } = r, o = t[i] || t[n] || t[a], s = r.matchUpFormat === o ? void 0 : r.matchUpFormat;
    for (let c of Object.keys(r))
      T2.includes(c) || delete r[c];
    r.sides && r.drawPositions && !r.tieMatchUps && delete r.sides, s && (r.matchUpFormat = s);
  }
}
function R2(e, t) {
  if (t && typeof t != "object")
    return { error: J };
  let { columnTransform: r = {} } = t || {}, { includeTransformAccessors: i, includeHeaderRow: n = !0, returnTransformedJSON: a, removeEmptyColumns: o, onlyHeaderRow: s, columnAccessors: c = [], functionMap: u = {}, columnMap: d = {}, valuesMap: p = {}, context: l = {}, delimiter: m = '"', columnJoiner: f = ",", rowJoiner: h = `\r
`, keyJoiner: g = "." } = t || {};
  if (!Array.isArray(e) || !Array.isArray(c) || typeof l != "object" || typeof d != "object" || typeof r != "object" || typeof u != "object" || typeof p != "object" || typeof f != "string" || typeof h != "string" || typeof g != "string" || typeof m != "string")
    return { error: J };
  r = Object.assign({}, ...Object.keys(r).reverse().map((C) => ({ [C]: Array.isArray(r[C]) ? r[C] : [typeof r[C] == "string" && r[C]].filter(Boolean) })));
  let I = e.filter(Boolean).map((C) => ky(C, g)), y = Object.values(r).flat();
  i && c.push(...y);
  let U = I.reduce((C, A) => Object.keys(A).every((N) => !C.includes(N) && C.push(N) || !0) && C, []).filter((C) => !(c != null && c.length) || c.includes(C)), S = Object.assign({}, ...Object.keys(r).reverse().map((C) => r[C].map((A) => ({ [A]: C })).flat()).flat()), D = (C, A) => t != null && t.sortOrder ? t.sortOrder.includes(C) && t.sortOrder.includes(A) && t.sortOrder.indexOf(C) - t.sortOrder.indexOf(A) || !t.sortOrder.includes(A) && -1 : 0, w = U.reduce((C, A) => {
    let N = S[A];
    return N ? C.includes(N) || C.push(N) : C.push(A), C;
  }, []).sort(D);
  Object.keys(d).forEach((C) => !w.includes(C) && w.unshift(C)), Object.keys(r).forEach((C) => !w.includes(C) && w.unshift(C)), typeof l == "object" && Object.keys(l).forEach((C) => !w.includes(C) && w.unshift(C));
  let v = w.map((C) => d[C] || C);
  if (s)
    return [v];
  let P = (C) => `${m}${C}${m}`, b = [], T = (C) => Object.values(w.reduce((A, N, O) => {
    var B;
    let k = r[N], F = (k != null && k.length ? C[k.find((L) => C[L])] : C[N]) || (l == null ? void 0 : l[N]) || "", x = ((B = p[N]) == null ? void 0 : B[F]) || F, _ = Hr(u[N]) ? u[N](x) : x;
    return A[N] = P(_), _ && (b[O] = (b[O] || 0) + 1), A;
  }, {})), R = I.map(T), M = o && [...b].map((C, A) => !C && A).filter(St).reverse();
  if (M) {
    let C = (A) => A.filter((N, O) => !M.includes(O));
    R = R.map(C), v = C(v);
  }
  let E = R.map((C) => C.join(f));
  return a ? E.map((C) => {
    let A = C.split(f);
    return Object.assign({}, ...A.map((N, O) => ({ [v[O]]: N })));
  }) : n ? [v.map(P).join(f), ...E].join(h) : E.join(h);
}
function ky(e, t = ".", r = []) {
  return typeof e == "object" && Object.keys(e).reduce((i, n) => typeof e[n] != "object" ? (i[r.concat(n).join(t)] = e[n], i) : Object.assign(i, ky(e[n], t, r.concat(n))), {});
}
var { FACTORY: ev } = sD;
function M2({ tournamentRecord: e, value: t }) {
  let { extension: r } = Ne({ element: e, name: ev }), i = { name: ev, value: { ...r == null ? void 0 : r.value, ...t } };
  Ve({ element: e, extension: i });
}
function wA({ timeStamp: e }) {
  let t = Ko(), r = Wh();
  return r && Object.values(t).forEach((i) => {
    M2({ tournamentRecord: i, value: { version: Vl(), timeStamp: e } });
  }), r;
}
function PA({ engineType: e, methodName: t, elapsed: r, params: i, result: n }) {
  var p, l;
  let a = oi();
  if (typeof a != "object")
    return;
  let o = { method: t }, s = (n == null ? void 0 : n.error) && (a.errors === !0 || Array.isArray(a.errors) && a.errors.includes(t)), c = Array.isArray(a.params) && ((p = a.params) == null ? void 0 : p.includes(t)), u = a.params && !Array.isArray(a.params) || c, d = Array.isArray(a.exclude) && a.exclude.includes(t);
  !d && ![void 0, !1].includes(a.perf) && !isNaN(a.perf) && r >= a.perf && (o.elapsed = r), !d && (s || u) && (o.params = i), !d && (s || a.result && !Array.isArray(a.result) && (!Array.isArray(a.params) || c) || Array.isArray(a.result) && ((l = a.result) != null && l.includes(t))) && (o.result = n), Object.keys(o).length > 1 && Yw(o, e);
}
function Fy({ methodName: e, params: t, start: r }) {
  let i = { error: ep, methodName: e }, n = r ? Date.now() - r : 0;
  return PA({ result: i, methodName: e, elapsed: n, params: t, engineType: "sync" }), i;
}
function N2(e, t) {
  var a;
  if (t._middleware === !1)
    return t;
  if (t.tournamentId && !e[t.tournamentId])
    return { error: ae };
  let r = t.drawId || ((a = t.matchUp) == null ? void 0 : a.drawId);
  if (r) {
    let { event: o, drawDefinition: s, tournamentId: c } = Cr({ tournamentRecords: e, drawId: r });
    s && (t.drawDefinition = s), c && (t.tournamentId = c), o && (t.event = o);
  }
  if (t.eventId && !t.event) {
    let { event: o, tournamentId: s } = Cr({ eventId: t.eventId, tournamentRecords: e });
    if (!o)
      return { error: Ii };
    t.tournamentId = s, t.event = o;
  }
  let i = t.tournamentId ?? Yo();
  if (!i && t)
    return t;
  let n = e[i];
  return i && !n ? { error: ae } : (n && (t.tournamentRecord = n), t);
}
function xy(e, t, r, i, n) {
  delete e.success, delete e.error;
  let a = Date.now(), o = Yo();
  r && (r.activeTournamentId = o);
  let s = (r == null ? void 0 : r.tournamentRecord) || zh(o), c = typeof (r == null ? void 0 : r.tournamentRecord) == "object" && { [r == null ? void 0 : r.tournamentRecord.tournamentId]: r.tournamentRecord } || Ko(), u = r ? ce(r, void 0, !0) : void 0, d = r ? N2(c, r) : void 0;
  if (d != null && d.error)
    return d;
  let p = A2({ params: d, tournamentRecords: c, tournamentRecord: s, methodName: i, method: t }), l = Date.now() - a;
  return PA({ result: p, methodName: i, elapsed: l, params: u, engineType: n }), p;
}
function A2({ tournamentRecords: e, tournamentRecord: t, params: r, methodName: i, method: n }) {
  if (oi())
    return n({ tournamentRecords: e, tournamentRecord: t, ...r });
  try {
    return n({ tournamentRecords: e, tournamentRecord: t, ...r });
  } catch (a) {
    return np({ engineName: "engine", methodName: i, params: r, err: a });
  }
}
function $m(e) {
  let { mutationStatus: t, tournamentId: r, directives: i, timeStamp: n } = e || {}, { topics: a } = vi();
  for (let o of [...a].sort(E2)) {
    let s = Ww({ topic: o });
    s != null && s.length && bf({ topic: o, notices: s });
  }
  t && n && a.includes(Of) && bf({ notices: [{ tournamentId: r, directives: i, timeStamp: n }], topic: Of });
}
var tv = { [xg]: 5, [Fg]: 5, [Lg]: 5, [kg]: 5, [Og]: 5, [Eg]: 5, [PD]: 5, [DD]: 5, [Cg]: 1, [Dp]: 1, [pr]: 5, [uo]: 5, [Ag]: 4, [Rg]: 4, [Mg]: 4, [Ng]: 4, [Pp]: 3, [Pg]: 2 };
function E2(e, t) {
  return (tv[t] || 0) - (tv[e] || 0);
}
function C2({ convertExtensions: e, removeExtensions: t }) {
  let r = Ko();
  return { tournamentId: Yo(), tournamentRecords: ce(r, e, !1, t) };
}
function O2(e) {
  let { convertExtensions: t = !1, removeExtensions: r = !1 } = e ?? {}, i = (e == null ? void 0 : e.tournamentId) ?? Yo();
  if (typeof i != "string")
    return {};
  let n = zh(i);
  return { tournamentRecord: ce(n, t, !1, r) };
}
function k2() {
  var i;
  let e = Ko(), { extension: t } = Ne({ name: Ya, tournamentRecords: e, discover: !0 }), r = ((i = t == null ? void 0 : t.value) == null ? void 0 : i.tournamentIds) || [];
  return Object.keys(e).forEach((n) => {
    r.includes(n) || delete e[n];
  }), ip(e);
}
function rv(e, t = !0) {
  return typeof e != "object" || Array.isArray(e) ? { error: ea } : e != null && e.tournamentId ? Hw(t ? ce(e) : e) : { error: J };
}
function vu(e, t = !0) {
  if (typeof e != "object")
    return { error: ea };
  if (Jc(), Array.isArray(e)) {
    if (e.filter((r) => r == null ? void 0 : r.tournamentId).length !== e.length)
      return { error: Uf };
    e = Object.assign({}, ...e.map((r) => ({ [r.tournamentId]: r })));
  } else if (e != null && e.tournamentId)
    e = { [e.tournamentId]: e }, Jc(e.tournamentId);
  else if (!Object.keys(e).every((r) => e[r].tournamentId === r))
    return { error: Uf };
  return ip(t ? ce(e) : e);
}
function F2(e, t, r, i, n, a) {
  let o = Kw(r, i, n, a);
  if (o.error)
    return o;
  let s = o.methods ?? [];
  return Object.keys(s).filter((c) => Hr(s[c])).forEach((c) => {
    e[c] = (u) => {
      let d = () => t(e, { [c]: s[c], ...u });
      if (oi())
        return d();
      try {
        return d();
      } catch (p) {
        np({ engineName: "engine", methodName: c, params: u, err: p });
      }
    };
  }), { ...V, ...e };
}
function Ps(e, t) {
  return t != null && t.error ? (e.error = t.error, e.success = !1) : (e.error = void 0, e.success = !0), e;
}
function DA(e, t) {
  e.importMethods = (r, i, n, a) => F2(e, t, r, i, n, a), e.getTournament = (r) => O2(r), e.getState = (r) => C2({ convertExtensions: r == null ? void 0 : r.convertExtensions, removeExtensions: r == null ? void 0 : r.removeExtensions }), e.version = () => Vl(), e.reset = () => (ip({}), Ps(e)), e.devContext = (r) => (Kc(r), Ps(e)), e.getDevContext = (r) => oi(r), e.newTournamentRecord = (r = {}) => {
    let i = _m(r), n = i.tournamentId;
    return i.error ? i : (rv(i), Jc(n), { ...V, tournamentId: n });
  }, e.setState = (r, i, n) => {
    Qc(i, n);
    let a = vu(r, i);
    return Ps(e, a);
  }, e.setTournamentId = (r) => Jc(r), e.getTournamentId = () => Yo(), e.setTournamentRecord = (r, i, n) => {
    Qc(i, n);
    let a = rv(r, i);
    return Ps(e, a);
  }, e.removeTournamentRecord = (r) => {
    let i = zw(r);
    return Ps(e, i);
  }, e.removeUnlinkedTournamentRecords = () => {
    let r = k2();
    return Ps(e, r);
  };
}
function x2(e, t, r) {
  if (!Array.isArray(t))
    return { error: J, message: "directives must be an array" };
  let i = qw(), n = Date.now(), a = r && ce(Ko(), !1, !0), o = [];
  for (let u of t) {
    if (typeof u != "object")
      return { error: J, message: "directive must be an object" };
    if (u.params && typeof u.params != "object")
      return { error: J, message: "params must be an object" };
    let { method: d, pipe: p } = u, l = u.params ? { ...u.params } : {};
    if (!i[d])
      return Fy({ methodName: d, start: n, params: l });
    if (p) {
      let f = o[o.length - 1], h = Object.keys(p);
      for (let g of h)
        f[g] && (l[g] = f[g]);
    }
    let m = xy(e, i[d], l, d, "sync");
    if (m != null && m.error)
      return a && vu(a), { ...m, rolledBack: !!a };
    o.push({ ...m, methodName: d });
  }
  let s = Date.now(), c = wA({ timeStamp: s });
  return $m({ directives: t, mutationStatus: c, timeStamp: s }), Mu(), { success: o.every((u) => u.success), results: o };
}
function iv(e, t) {
  if (!Le(t))
    return { error: J, message: "args must be an object" };
  let r = Object.values(t).filter(Hr).length;
  if (r > 1)
    return { message: "there must be only one arg with typeof function", error: J };
  let i = r ? Object.keys(t).find((m) => Hr(t[m])) : ht(t.method) && t.method;
  if (!i)
    return { error: ep };
  let { [i]: n, ...a } = t, o = t != null && t.params ? { ...t.params } : { ...a }, s = o.rollbackOnError && ce(Ko(), !1, !0), c = n || e[i] || $h()[i];
  if (!c)
    return Fy({ methodName: i, params: o });
  let u = xy(e, c, o, i, "sync") ?? {};
  u != null && u.error && s && vu(s);
  let d = Date.now(), p = wA({ timeStamp: d }), l = (u == null ? void 0 : u.success) && (o == null ? void 0 : o.delayNotify) !== !0 && (o == null ? void 0 : o.doNotNotify) !== !0;
  return l && $m({ directives: [{ method: c, params: o }], mutationStatus: p, timeStamp: d }), (l || !(u != null && u.success) || o != null && o.doNotNotify) && Mu(), u;
}
var L2 = (() => {
  let e = { executionQueue: (t, r) => x2(e, t, r), execute: (t) => iv(e, t) };
  return DA(e, iv), e;
})(), Ly = L2;
function nv(e, t) {
  if (!Le(t))
    return { error: J, message: "args must be an object" };
  let r = Object.values(t).filter(Hr).length;
  if (r > 1)
    return { message: "there must be only one arg with typeof function", error: J };
  let i = r ? Object.keys(t).find((c) => Hr(t[c])) : ht(t.method) && t.method;
  if (!i)
    return { error: ep };
  let { [i]: n, ...a } = t, o = t != null && t.params ? { ...t.params } : { ...a }, s = n || e[i] || $h()[i];
  return s ? xy(e, s, o, i, "ask") : Fy({ methodName: i, params: o });
}
(() => {
  let e = { execute: (t) => nv(e, t) };
  return DA(e, nv), e;
})();
var Eo = {}, da;
function av(e, t = !0) {
  if (!e)
    return { error: Ie };
  if (typeof e != "object")
    return { error: ea };
  if (e.matchUpId)
    da = e.matchUpId, Eo[da] = t ? ce(e) : e;
  else if (Array.isArray(e))
    for (let r of e.reverse())
      r.matchUpId && (Eo[r.matchUpId] = t ? ce(r) : r, da || (da = r.matchUpId));
  else
    for (let r of Object.values(e))
      r.matchUpId && (Eo[r.matchUpId] = t ? ce(r) : r, da || (da = r.matchUpId));
  return t ? ce(e) : e;
}
function _2() {
  return Eo[da];
}
function B2() {
  return Object.values(Eo);
}
function V2() {
  da = void 0, Eo = {};
}
function j2(e) {
  return ce(Eo[da], e == null ? void 0 : e.convertExtensions, !1, e == null ? void 0 : e.removeExtensions);
}
(() => {
  let e = { getState: (n) => j2(n), version: () => Vl(), reset: () => (V2(), { ...V }), drawId: void 0, error: void 0, success: !1, devContext: (n) => (Kc(n), e), setState: (n, a, o) => {
    Qc(a, o);
    let s = av(n);
    return t(s);
  } };
  function t(n) {
    return n != null && n.error ? (e.error = n.error, e.success = !1) : (e.error = void 0, e.success = !0, e.drawId = n.drawId), e;
  }
  return r([QI]), e;
  function r(n) {
    n.forEach((a) => {
      Object.keys(a).forEach((o) => {
        e[o] = (s) => {
          if (oi())
            return i({ params: s, governor: a, methodName: o });
          try {
            return i({ params: s, governor: a, methodName: o });
          } catch (c) {
            np({ engineName: "matchUpEngine", methodName: o, params: s, err: c });
          }
        };
      });
    });
  }
  function i({ params: n, governor: a, methodName: o }) {
    e.error = void 0, e.success = !1;
    let s = (n == null ? void 0 : n.matchUp) || _2(), c = (n == null ? void 0 : n.matchUps) || B2(), u = (n == null ? void 0 : n.rollbackOnError) && ce(s, !1, !0);
    n = { ...n, matchUpId: s == null ? void 0 : s.matchUpId, matchUps: c, matchUp: s };
    let d = a[o](n);
    if (d != null && d.error)
      return u && av(u), { ...d, rolledBack: !!u };
    let p = (d == null ? void 0 : d.success) && (n == null ? void 0 : n.delayNotify) !== !0 && (n == null ? void 0 : n.doNotNotify) !== !0;
    return p && $m(), (p || !(d != null && d.success) || n != null && n.doNotNotify) && Mu(), d;
  }
})();
var uf = !1;
(() => {
  let e = { version: () => Vl(), setDeepCopy: (i, n) => (Qc(i, n), e), devContext: (i) => (Kc(i), uf = !0, e) };
  return r([ly]), e;
  function t(i, n) {
    let a = i({ ...n });
    return a != null && a.error || $m(), Mu(), uf && (Kc(!1), uf = !1), a;
  }
  function r(i) {
    i.forEach((n) => {
      Object.keys(n).forEach((a) => {
        e[a] = (o) => {
          if (oi()) {
            let s = t(n[a], o);
            return !(s != null && s.error) && (o != null && o.setState) && (s != null && s.tournamentRecord) && vu(s.tournamentRecord), s;
          } else
            try {
              let s = t(n[a], o);
              return !(s != null && s.error) && (o != null && o.setState) && (s != null && s.tournamentRecord) && vu(s.tournamentRecord), s;
            } catch (s) {
              let c;
              typeof s == "string" ? c = s.toUpperCase() : s instanceof Error && (c = s.message), console.log("ERROR", { params: JSON.stringify(o), method: a, error: c });
            }
        };
      });
    });
  }
})();
Ly.importMethods(Iv, !0, 1);
var TA = Ly, G2 = { getTournamentPoints: dm }, $2 = G2, q2 = { calculateNewRatings: Xb, generateDynamicRatings: Zb }, W2 = q2, H2 = { ...$2, ...W2 };
Ly.importMethods(H2);
var z2 = { [ou]: { roundsToSeparate: void 0, policyName: "Nationality Code", policyAttributes: [{ key: "person.nationalityCode" }, { key: "individualParticipants.person.nationalityCode" }] } }, Y2 = { [zn]: { policyName: "positionActionsUnrestricted", enabledStructures: [], otherFlightEntries: !0, disableRoundRestrictions: !0, activePositionOverrides: [Ro, qc] } }, K2 = { [zn]: { policyName: "positionActionsNoMovement", enabledStructures: [{ stages: [], stageSequences: [], enabledActions: [Ro, mu, jo], disabledActions: [] }] } }, Q2 = { [zn]: { policyName: "positionActionsDisabled", enabledStructures: !1 } }, J2 = { [mc]: { policyName: "Participant Privacy Policy", participant: { contacts: !1, individualParticipants: { onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantStatus: !0, penalties: !1, rankings: !0, ratings: !0, representing: !0, participantRoleResponsibilities: !1, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } }, individualParticipantIds: !0, onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantStatus: !0, penalties: !1, rankings: !0, ratings: !0, representing: !0, participantRoleResponsibilities: !1, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } } } }, X2 = { [yi]: { processCodes: { incompleteAssignmentsOnDefault: ["RANKING.IGNORE"] }, defaultMatchUpFormat: Oi, allowDeletionWithScoresPresent: { drawDefinitions: !1, structures: !1 }, requireParticipantsForScoring: !1, requireAllPositionsAssigned: void 0, allowChangePropagation: !1, stage: { [ue]: { stageSequence: { 1: { requireAllPositionsAssigned: !0 } } } }, matchUpFormats: [], matchUpStatusCodes: { [Gr]: [], [Un]: [], [ke]: [], [Zr]: [], [nr]: [], [Be]: [] } } }, df = "Personal circumstance", Z2 = { [yi]: { requireAllPositionsAssigned: !1, stage: { [ue]: { stageSequence: { 1: { requireAllPositionsAssigned: !0 } } } }, defaultMatchUpFormat: Oi, matchUpFormats: [{ description: "Best of 3 tiebreak sets", matchUpFormat: Oi, categoryNames: [], categoryTypes: [] }, { description: "Two tiebreak sets, 7-point match tiebreak at one set all", matchUpFormat: "SET3-S:6/TB7-F:TB7" }, { description: "Two tiebreak sets, 10-point match tiebreak at one set all", matchUpFormat: "SET3-S:6/TB7-F:TB10" }, { description: "One standard tiebreak set to 6, 7-point tiebreak at 6 games all", matchUpFormat: "SET1-S:6/TB7" }, { description: "Best of 3 sets to 4", matchUpFormat: "SET3-S:4/TB7" }, { description: "Two out of three short sets to 4 with 5-point tiebreak at 3 games all", matchUpFormat: "SET3-S:4/TB5@3" }, { description: "One short set to 4, 7-point tiebreak at 4 games all", matchUpFormat: "SET1-S:4/TB7" }, { description: "One short set to 4, 5-point tiebreak at 3 games all", matchUpFormat: "SET1-S:4/TB5@3" }, { description: "Two short sets to 4, 10-point match tiebreak at one set all", matchUpFormat: "SET3-S:4/TB7-F:TB10" }, { description: "Two short sets to 4, 7-point match tiebreak at one set all", matchUpFormat: "SET3-S:4/TB7-F:TB7" }, { description: "One no advantage set to 5, tiebreak to 9 at 4-4", matchUpFormat: "SET1-S:5/TB9@4" }, { description: "One set to 6 with deciding game at 5 games all", matchUpFormat: "SET1-S:6NOAD" }, { description: "One short set to 4, deciding game is played at 3 games all", matchUpFormat: "SET1-S:4NOAD" }, { description: "Two short sets to 4 with deciding game at 3-3, 7-point match tiebreak at one set all", matchUpFormat: "SET3-S:4NOAD-F:TB7" }, { description: "8 game pro-set with 7 point tiebreak at 8 games all", matchUpFormat: "SET1-S:8/TB7" }, { description: "8 game pro-set with 7 point tiebreak at 7 games all", matchUpFormat: "SET1-S:8/TB7@7" }, { description: "Best of 3 10-point tiebreak games", matchUpFormat: "SET3-S:TB10" }, { description: "One 10-point tiebreak game", matchUpFormat: "SET1-S:TB10" }, { description: "Timed 20 minute game - game based", matchUpFormat: "SET1-S:T20" }], matchUpStatusCodes: { [Gr]: [{ matchUpStatusCodeDisplay: "Abandoned", label: "Abandoned match", matchUpStatusCode: "OA" }], [Un]: [{ matchUpStatusCodeDisplay: "Unplayed or Cancelled", label: "Cancelled match", matchUpStatusCode: "OC" }], [Zr]: [{ matchUpStatusCodeDisplay: "Incomplete", label: "Incomplete match", matchUpStatusCode: "OI" }], [ke]: [{ description: "Disqualification for cause or ineligibility", label: "Disqualification (ineligibility)", matchUpStatusCodeDisplay: "Def [dq]", matchUpStatusCode: "DQ" }, { description: "Misconduct before or between matches", label: "Misconduct", matchUpStatusCodeDisplay: "Def [cond]", matchUpStatusCode: "DM" }, { description: "Failure to start match because of adult discipline", label: "Fail. (adult discipline)", matchUpStatusCodeDisplay: "Def [ad]", matchUpStatusCode: "D5" }, { description: "Refusal to start match for reason other than adult discipline, injury, illness, or personal circumstance. (After the Referee has conclusively confirmed that a player refuses to play a match, the Referee need not wait until the scheduled time of the match to records the result.)", label: "Refusal to start match", matchUpStatusCodeDisplay: "Def [refsl]", matchUpStatusCode: "D4" }, { label: "Not showing up", matchUpStatusCodeDisplay: "Def [ns]", matchUpStatusCode: "D6" }, { description: "Lateness for match including, but not limited to, intending to play but mistakenly arriving at the wrong time, location, or without proper equipment", label: "Lateness for match", matchUpStatusCodeDisplay: "Score + Def [late]", matchUpStatusCode: "D7" }, { label: "Double default", matchUpStatusCodeDisplay: "Def/Def", matchUpStatusCode: "DD" }, { description: "Refusal to continue playing a match for reason other than injury, illness, personal circumstance, or adult discipline", label: "Refusal to continue match", matchUpStatusCodeDisplay: "Def [refsl]", matchUpStatusCode: "D9" }, { description: "Default for receiving an injection, IV, or supplemental oxygen", label: "Default (PEDs)", matchUpStatusCodeDisplay: "Def [med]", matchUpStatusCode: "DI" }, { description: "Default under Point Penalty System", label: "Default (Point Penalty System)", matchUpStatusCodeDisplay: "Def [pps]", matchUpStatusCode: "DP" }], [Be]: [{ matchUpStatusCodeDisplay: "Wo [inj]", matchUpStatusCode: "W1", label: "Injury" }, { matchUpStatusCodeDisplay: "Wo [ill]", matchUpStatusCode: "W2", label: "Illness" }, { matchUpStatusCodeDisplay: "Wo [pc]", label: df, matchUpStatusCode: "W3" }, { matchUpStatusCodeDisplay: "Wo/Wo", matchUpStatusCode: "WOWO", label: "Double walkover" }, { matchUpStatusCodeDisplay: "Wo [Tae]", label: "Tournament Administrative Error", matchUpStatusCode: "W4" }, { matchUpStatusCodeDisplay: "Wo/Withdrawn", matchUpStatusCode: "W5", label: "Withdrawn" }], [nr]: [{ matchUpStatusCodeDisplay: "Ret [inj]", matchUpStatusCode: "RJ", label: "Injury" }, { matchUpStatusCodeDisplay: "Ret [ill]", matchUpStatusCode: "RI", label: "Illness" }, { matchUpStatusCodeDisplay: "Ret [pc]", label: df, matchUpStatusCode: "RC" }, { description: "Retirement because of adult discipline", label: "Ret. (adult discipline)", matchUpStatusCodeDisplay: "Ret [ad]", matchUpStatusCode: "RD" }, { description: "A player who retires from a match remains eligible for consolations, place playoffs, doubles and subsequent round robin matches", matchUpStatusCodeDisplay: "Ret [elg]", label: "Ret. (eligible)", matchUpStatusCode: "RU" }], [On]: [{ matchUpStatusCodeDisplay: "Wd [inj]", matchUpStatusCode: "WD.INJ", label: "Injury" }, { matchUpStatusCodeDisplay: "Wd [ill]", matchUpStatusCode: "WD.ILL", label: "Illness" }, { matchUpStatusCodeDisplay: "Wd [pc]", label: df, matchUpStatusCode: "WD.PC" }, { matchUpStatusCodeDisplay: "Wd/Wd", matchUpStatusCode: "WD.WD", label: "Double withdrawal" }, { label: "Tournament Administrative Error", matchUpStatusCodeDisplay: "Wd [Tae]", matchUpStatusCode: "WD.TAE" }] } } }, ej = { [Mi]: { seedingProfile: { positioning: cp }, validSeedPositions: { ignore: !0 }, duplicateSeedNumbers: !0, drawSizeProgression: !0, policyName: "ITF SEEDING", seedsCountThresholds: [{ drawSize: 4, minimumParticipantCount: 3, seedsCount: 2 }, { drawSize: 16, minimumParticipantCount: 12, seedsCount: 4 }, { drawSize: 32, minimumParticipantCount: 24, seedsCount: 8 }, { drawSize: 64, minimumParticipantCount: 48, seedsCount: 16 }, { drawSize: 128, minimumParticipantCount: 97, seedsCount: 32 }, { drawSize: 256, minimumParticipantCount: 192, seedsCount: 64 }] } }, tj = { POLICY_AVOIDANCE_COUNTRY: z2, POLICY_POSITION_ACTIONS_DEFAULT: kb, POLICY_POSITION_ACTIONS_DISABLED: Q2, POLICY_POSITION_ACTIONS_NO_MOVEMENT: K2, POLICY_POSITION_ACTIONS_UNRESTRICTED: Y2, POLICY_PRIVACY_DEFAULT: J2, POLICY_ROUND_NAMING_DEFAULT: zg, POLICY_SCHEDULING_DEFAULT: IM, POLICY_SCORING_DEFAULT: X2, POLICY_SCORING_USTA: Z2, POLICY_SEEDING_ITF: ej, POLICY_SEEDING_DEFAULT: ZR }, rj = { ratingsParameters: Wt, matchUpFormats: c1, countryToFlag: ED, tieFormats: CM, countries: pa, policies: tj, flagIOC: sO }, ij = {};
Ae(ij, { activeMatchUpStatuses: () => wg, auditConstants: () => nB, completedMatchUpStatuses: () => Vt, directingMatchUpStatuses: () => ID, displayConstants: () => k_, drawDefinitionConstants: () => zP, entryStatusConstants: () => gO, errorConditionConstants: () => cC, eventConstants: () => f1, extensionConstants: () => sD, flightConstants: () => wB, genderConstants: () => Yh, keyValueConstants: () => oL, matchUpActionConstants: () => Ux, matchUpStatusConstants: () => SD, matchUpTypes: () => CE, nonDirectingMatchUpStatuses: () => UD, particicipantsRequiredMatchUpStatuses: () => hD, participantConstants: () => oO, participantRoles: () => aI, participantTypes: () => Vc, penaltyConstants: () => vj, policyConstants: () => $1, positionActionConstants: () => EF, ratingConstants: () => HF, recoveryTimeRequiredMatchUpStatuses: () => tO, requestConstants: () => dV, resourceContants: () => t1, resultConstants: () => HE, scaleConstants: () => B1, scheduleConstants: () => GO, sortingConstants: () => AB, surfaceConstants: () => Rj, tieFormatConstants: () => u1, timeItemConstants: () => BO, topicConstants: () => iO, tournamentConstants: () => rA, upcomingMatchUpStatuses: () => yD, validMatchUpStatuses: () => gD, venueConstants: () => Aj, weekdayConstants: () => _M });
var nj = "Coaching", aj = "Ball Abuse", oj = "Racket Abuse", sj = "Verbal Abuse", cj = "INELIGIBILITY", uj = "Physical Abuse", dj = "Unsportmanlike Conduct", lj = "Dress Code Violation", pj = "Equipment Violation", mj = "Leaving the court", fj = "Failure to complete", hj = "No Show", gj = "Other", Ij = "REFUSAL_TO_PLAY", Uj = "PROHIBITED_SUBSTANCE", yj = "Puncuality", Sj = "Failure to sign in", vj = { COACHING: nj, BALL_ABUSE: aj, RACKET_ABUSE: oj, VERBAL_ABUSE: sj, PHYSICAL_ABUSE: uj, INELIGIBILITY: cj, UNSPORTSMANLIKE_CONDUCT: dj, PROHIBITED_SUBSTANCE: Uj, DRESS_CODE_VIOLATION: lj, EQUIMENT_VIOLATION: pj, LEAVING_THE_COURT: mj, REFUSAL_TO_PLAY: Ij, FAILURE_TO_COMPLETE: fj, NO_SHOW: hj, OTHER: gj, PUNCTUALITY: yj, FAILUIRE_TO_SIGN_IN: Sj }, wj = "CLAY", Pj = "HARD", Dj = "GRASS", Tj = "CARPET", bj = "ARTIFICIAL", Rj = { CLAY: wj, HARD: Pj, GRASS: Dj, CARPET: Tj, ARTIFICIAL: bj }, Mj = "INDOOR", Nj = "OUTDOOR", Aj = { INDOOR: Mj, OUTDOOR: Nj };
const Ej = Qe({
  WebkitBoxSizing: "border-box",
  marginInlineEnd: ".3em",
  display: "inline-block",
  boxSizing: "border-box",
  position: "relative",
  borderRadius: 2,
  variants: {
    variant: {
      doubles: {
        width: ".75rem"
      },
      singles: {
        width: "1rem"
      }
    }
  }
});
function Cj({ matchUp: e, individualParticipant: t, spacer: r }) {
  var s, c, u;
  const i = ((s = t == null ? void 0 : t.person) == null ? void 0 : s.iso2NationalityCode) || "", n = i ? (c = rj.countryToFlag(i)) == null ? void 0 : c.slice(0, 4) : "", a = document.createElement("span"), o = (u = e == null ? void 0 : e.matchUpType) == null ? void 0 : u.toLowerCase();
  return r || (a.className = Ej({ variant: o })), a.innerHTML = r ? "" : n, a;
}
function lf({ individualParticipant: e, composition: t, className: r, matchUp: i, spacer: n, side: a, type: o }) {
  if (o === "scale")
    return AE({
      individualParticipant: e,
      composition: t,
      className: r,
      matchUp: i,
      spacer: n
    });
  const s = (t == null ? void 0 : t.configuration) || {}, c = document.createElement("div");
  return o === "flag" && s.flags && Cj({ className: r, matchUp: i, individualParticipant: e, spacer: n }) || o === "seeding" && ME({ className: r, composition: t, matchUp: i, side: a }) || c;
}
const Oj = "Qualifier", kj = "BYE", Fj = "TBD";
function ov(e) {
  var S, D, w, v;
  const { isWinningSide: t, side: r, sideNumber: i, individualParticipant: n, matchUp: a, composition: o } = e || {}, s = t ? "winner" : void 0, c = e.eventHandlers || {}, u = o == null ? void 0 : o.configuration, d = {
    QUALIFIER: ((S = u == null ? void 0 : u.placeHolders) == null ? void 0 : S.qualifier) || Oj,
    BYE: ((D = u == null ? void 0 : u.placeHolders) == null ? void 0 : D.bye) || kj,
    TBD: ((w = u == null ? void 0 : u.placeHolders) == null ? void 0 : w.tbd) || Fj
  }, p = n == null ? void 0 : n.participantName, l = (P) => {
    zi(c == null ? void 0 : c.participantClick) && (P.stopPropagation(), c.participantClick({
      individualParticipant: n,
      pointerEvent: P,
      matchUp: a,
      side: r
    }));
  }, m = document.createElement("div");
  m.classList.add("tmx-i"), m.setAttribute("sideNumber", i), m.setAttribute("id", n == null ? void 0 : n.participantId), m.onclick = l;
  const f = document.createElement("div");
  f.className = cE({ variant: s });
  const g = (u == null ? void 0 : u.flags) && lf({ ...e, type: "flag" });
  if (g)
    f.appendChild(g);
  else {
    const P = lf({
      type: "scale",
      ...e
    });
    P && f.appendChild(P);
  }
  const I = document.createElement("div");
  if (I.className = uE({ variant: s }), p) {
    const P = document.createElement("span");
    if (t && (u != null && u.winnerColor))
      P.style.color = typeof u.winnerColor == "string" ? u.winnerColor : "green";
    else if (u != null && u.genderColor) {
      const b = (v = n == null ? void 0 : n.person) == null ? void 0 : v.sex, T = b === "MALE" && "#2E86C1" || b === "FEMALE" && "#AA336A" || "";
      P.style.color = typeof u.genderColor == "string" ? u.genderColor : T;
    }
    P.innerHTML = p, I.appendChild(P);
  } else {
    const P = document.createElement("abbr");
    P.className = sE({ variant: u.showAddress ? "showAddress" : "" }), P.innerHTML = (r == null ? void 0 : r.bye) && d.BYE || (r == null ? void 0 : r.qualifier) && d.QUALIFIER || d.TBD, I.appendChild(P);
  }
  const y = lf({
    ...e,
    className: RE(),
    type: "seeding"
  });
  y && I.appendChild(y), f.appendChild(I), m.appendChild(f);
  const U = bE(e);
  return m.appendChild(U), { element: m };
}
const xj = Qe({
  width: "auto",
  display: "inline-block",
  textTransform: "uppercase",
  fontFamily: "Sharp Sans, Arial, sans-serif",
  fontSize: "0.625rem",
  lineHeight: "1rem",
  marginInline: "0.25rem 0.25rem",
  paddingInline: "0.25rem 0.25rem",
  fontWeight: 700,
  borderRadius: "4px",
  color: "#fff",
  textAlign: "center",
  whiteSpace: "nowrap",
  variants: {
    variant: {
      defaulted: {
        backgroundColor: "#df164c"
      },
      retired: {
        backgroundColor: "#df164c"
      },
      walkover: {
        backgroundColor: "black"
      },
      double_walkover: {
        backgroundColor: "black"
      }
    }
  }
});
function Lj({ matchUpStatus: e }) {
  const t = e == null ? void 0 : e.toLowerCase(), r = ["WALKOVER", "DOUBLE_WALKOVER"].includes(e) ? "WO" : (e == null ? void 0 : e.slice(0, 3)) || "", i = document.createElement("div");
  i.className = xj({ variant: t });
  const n = document.createElement("abbr");
  return n.setAttribute("title", e), n.style.textDecoration = "none", n.style.borderBottom = "none", n.innerHTML = r, i.appendChild(n), i;
}
function _j(e) {
  return e instanceof Element || e;
}
const Bj = Qe({
  marginInlineEnd: ".5rem",
  backgroundColor: "pink",
  marginInlineStart: 2,
  height: 40,
  width: 40
});
function Vj({ teamLogo: e }) {
  console.log({ teamLogo: e });
  const t = document.createElement("div");
  return t.className = Bj(), t;
}
const jj = Qe({
  flexDirection: "column",
  position: "relative",
  display: "flex"
}), Gj = Qe({
  alignItems: "stretch",
  display: "flex"
}), $j = Qe({
  marginInlineEnd: ".25rem",
  color: "green"
});
function qj({ dim: e = "20px" } = {}) {
  const t = $j();
  return `
    <div style="line-height: 0;">
      <svg height="${e}" viewBox="0 0 18 24" width="${e}" xmlns="http://www.w3.org/2000/svg" class="${t}" style="fill: currentcolor;">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
      </svg>
    </div>
  `;
}
function Wj({
  initialRoundNumber: e = 1,
  eventHandlers: t,
  sideContainer: r,
  composition: i,
  participant: n,
  placeholder: a,
  sideNumber: o,
  matchUp: s
}) {
  var R, M, E;
  const { winningSide: c, matchUpType: u, isRoundRobin: d, matchUpStatus: p } = s || {}, l = i == null ? void 0 : i.configuration;
  let m;
  const f = o ? (R = s == null ? void 0 : s.sides) == null ? void 0 : R.find((C) => C.sideNumber === o) : void 0;
  n || (n = f == null ? void 0 : f.participant, m = l != null && l.allDrawPositions || l != null && l.drawPositions && (f != null && f.drawPosition) && ((s == null ? void 0 : s.roundNumber) === e || f != null && f.participantFed || d) ? f == null ? void 0 : f.drawPosition : "");
  const h = u === "DOUBLES", g = h ? (M = n == null ? void 0 : n.individualParticipants) == null ? void 0 : M[0] : n, I = h && ((E = n == null ? void 0 : n.individualParticipants) == null ? void 0 : E[1]), y = o === c || p === "BYE" && n, U = (l == null ? void 0 : l.winnerChevron) && y, S = l == null ? void 0 : l.teamLogo, D = ["RETIRED", "DOUBLE_WALKOVER", "WALKOVER", "DEFAULTED"].includes(p) && !y, w = l == null ? void 0 : l.gameScoreOnly, v = document.createElement("div");
  if (v.className = r && lE({
    drawPosition: m,
    sideNumber: o
  }), v.classList.add("tmx-p"), v.setAttribute("id", n == null ? void 0 : n.participantId), S) {
    const C = Vj({ teamLogo: S });
    v.appendChild(C);
  }
  const P = document.createElement("div");
  P.className = dE({
    variant: h ? "doubles" : "singles"
  });
  const b = document.createElement("div");
  b.className = pE({
    winnerChevron: U,
    isDoubles: h
  });
  const T = ov({
    individualParticipant: g,
    eventHandlers: t,
    isWinningSide: y,
    composition: i,
    sideNumber: o,
    matchUp: s,
    side: f
  }).element;
  if (b.appendChild(T), I) {
    const C = ov({
      individualParticipant: I,
      eventHandlers: t,
      isWinningSide: y,
      composition: i,
      sideNumber: o,
      matchUp: s,
      side: f
    }).element;
    b.appendChild(C);
  } else
    h && a && _j(a) && b.appendChild(a);
  if (P.appendChild(b), v.appendChild(P), r) {
    const C = document.createElement("div");
    if (y && !w) {
      const A = qj();
      typeof A == "string" ? C.innerHTML = A : C.appendChild(A);
    } else if (D) {
      const A = Lj({ matchUpStatus: p });
      C.appendChild(A);
    }
    v.appendChild(C);
  }
  return v;
}
const Hj = Qe({
  borderBottom: "solid 1px black",
  marginInlineStart: "16px",
  marginInlineEnd: "16px",
  fontWeight: "bold",
  // width: '370px',
  height: "1.5em"
});
function zj({ eventHandlers: e, roundMatchUps: t, roundProfile: r, roundNumber: i, context: n }) {
  var d;
  const a = document.createElement("div");
  a.className = Hj(), a.classList.add("tmx-rh"), a.setAttribute("roundNumber", i);
  const o = zi(e == null ? void 0 : e.roundHeaderClick);
  o && (a.onclick = (p) => e.roundHeaderClick({ roundNumber: i, roundProfile: r, roundMatchUps: t, context: n, pointerEvent: p }));
  const s = o ? "⋮" : "", c = (d = r == null ? void 0 : r[i]) == null ? void 0 : d.roundName, u = c && ` <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div>${c}</div>
        <div style="font-weight: bold">${s}</div>
      </div>
  `;
  return a.innerHTML = u || "", a;
}
const bA = Qe({
  flexDirection: "column",
  display: "flex"
}), Yj = Qe({
  flexDirection: "row",
  display: "flex"
}), RA = Qe({
  justifyContent: "space-around",
  marginInlineStart: "16px",
  marginInlineEnd: "16px",
  flexDirection: "column",
  height: "100%",
  display: "flex",
  // width: '370px',
  variants: {
    variant: {
      adHoc: {
        justifyContent: "flex-start"
      }
    }
  }
}), Kj = Qe({
  borderTop: "solid 1px black",
  marginRight: "-1em",
  marginLeft: "-1em",
  paddingTop: ".5em",
  marginTop: ".2em",
  variants: {
    variant: {
      0: {
        marginTop: "1em",
        borderTop: "none",
        paddingTop: "0px"
      }
    },
    roundOrder: {
      first: {
        marginLeft: "0em"
      },
      last: {
        marginRight: "0em"
      }
    }
  }
}), Qj = Qe({
  fontWeight: "bold",
  color: "blue",
  height: "1em"
}), sv = Qe({
  width: "$score$setWidth",
  display: "inline-block",
  fontSize: 9,
  variants: {
    variant: {
      set: {
        textAlign: "center"
      },
      points: {
        marginInlineEnd: 3
      }
    }
  }
}), Jj = Qe({
  transform: "translateY(-50%)",
  textTransform: "uppercase",
  backgroundColor: "#fff",
  position: "absolute",
  textAlign: "center",
  top: "calc(50%)",
  color: "#bbb",
  fontSize: 0,
  right: 4
});
function Xj() {
  return Qe({
    backgroundColor: "magenta",
    position: "absolute",
    opacity: "0.2",
    height: "100%",
    width: "100%",
    top: 0
  });
}
const Zj = Qe({});
function eG({ configuration: e }) {
  const t = {
    backgroundColor: "$matchUpBackgroundColor",
    WebkitTransition: "all 0.30s linear",
    boxShadow: "$matchUp$boxShadow",
    transition: "all 0.30s linear",
    border: "solid $border",
    marginBottom: "$space$1",
    marginTop: "$space$1",
    position: "relative",
    display: "grid",
    width: "100%",
    // IMPORTANT: must come last
    borderInlineStartWidth: "$borderWidths$borderInlineStart"
  };
  if (e != null && e.matchUpHover) {
    const r = typeof e.matchUpHover == "string" ? e.matchUpHover : "cyan";
    t["&:hover"] = { backgroundColor: r };
  } else
    t["&:hover"] = {
      borderColor: "$borderHover"
    };
  return Qe(t);
}
function tG({ variant: e }) {
  return Qe({
    borderBottom: "solid 1px lightgray",
    backgroundColor: "$matchUp",
    position: "relative",
    width: "100%",
    height: "$lineHeights$centerInfo",
    variants: {
      variant: {
        1: {
          borderBottom: "solid 1px black"
        },
        2: {
          borderBottom: "solid 1px lightgray"
        }
      }
    }
  })({ variant: e });
}
const rG = Qe({
  justifyContent: "center",
  alignContent: "center",
  flexDirection: "column",
  height: "100%",
  display: "flex"
}), iG = Qe({
  fontFamily: "Lato,Arial,Helvetica,sans-serif",
  WebkitFontSmooting: "antialiased",
  marginInlineStart: "calc(20%)",
  WebkitBoxOrient: "horizontal",
  WebKitBoxDirection: "normal",
  WebkitBoxPack: "center",
  boxSizing: "inherit",
  flexDirection: "row",
  display: "flex"
}), cv = Qe({
  alignContent: "center",
  boxSizing: "inherit",
  fontFamily: "Lato",
  fontWeight: 900,
  fontSize: 9
});
function nG({ eventHandlers: e, entryStatus: t, sideNumber: r, className: i, matchUp: n }) {
  const a = document.createElement("div");
  zi(e == null ? void 0 : e.centerInfoClick) && (a.onclick = (d) => e.centerInfoClick({ matchUp: n, sideNumber: r, pointerEvent: d })), a.className = io(tG({ variant: r }), i), a.classList.add("tmx-ci"), a.setAttribute("sideNumber", r);
  const o = document.createElement("div");
  o.className = rG();
  const s = document.createElement("div");
  s.className = iG();
  const c = document.createElement("div");
  c.className = cv(), c.innerHTML = t ? "Entry status:&nbsp;" : "", s.appendChild(c);
  const u = document.createElement("div");
  return u.className = cv(), u.innerHTML = t || "", s.appendChild(u), o.appendChild(s), a.appendChild(o), { element: a };
}
const Hc = {
  scheduleInfo: 1.8,
  centerInfo: 1.5,
  gameScore: 2
};
function aG({ composition: e, isDoubles: t, roundFactor: r = 1 }) {
  const i = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size")), n = (e == null ? void 0 : e.configuration) || {}, a = (n == null ? void 0 : n.connectorWidth) || 16, o = n.centerInfo ? Hc.centerInfo * i : 0, s = n.scheduleInfo ? Hc.scheduleInfo * i : 0, u = (60 + (n.showAddress ? i : 0)) * (t ? 1.3 : 1) + o, d = u * r, p = (u + s) * r;
  return Qe({
    "&::before": {
      borderBlockStart: "$borderWidths$matchUp solid #999",
      left: -a,
      width: a,
      position: "absolute",
      borderRadius: 2,
      top: -1
    },
    "&::after": {
      width: a,
      position: "absolute",
      borderRadius: 2,
      left: "100%"
    },
    "&::after, &::before": {
      borderWidth: "$borderWidths$matchUp",
      borderColor: "$connector",
      display: "block",
      content: ""
    },
    variants: {
      isFirstRound: {
        true: { "&::before": { height: 0, width: 0, borderWidth: 0 } }
      },
      link: {
        m1: {
          "&::after": {
            borderInlineEnd: "$borderWidths$matchUp solid $connector",
            borderTopStyle: "solid",
            height: d,
            top: -1
          }
        },
        m2: {
          "&::after": {
            bottom: "calc(100%)",
            borderInlineEnd: "$borderWidths$matchUp solid $connector",
            borderBottomStyle: "solid",
            height: p
          }
        },
        m0: {
          "&::after": {
            borderTopStyle: "solid",
            borderColor: "$connector",
            top: -1
          }
        },
        mr: {
          "&::before": { height: 0, width: 0, borderWidth: 0 },
          "&::after": { height: 0, width: 0, borderWidth: 0 }
        },
        noProgression: {
          true: { "&::after": { height: 0, width: 0, borderWidth: 0 } }
        }
      }
    }
  });
}
const MA = (e) => Qe({
  display: "flex",
  alignItems: "center",
  height: e,
  justifyContent: "flex-end",
  backgroundColor: "$matchUp",
  variants: {
    sideNumber: {
      1: {
        borderBottom: "1px solid $internalDividers"
      }
    },
    fontSize: {
      small: {
        fontSize: "smaller",
        paddingRight: "1em",
        color: "blue"
      }
    }
  }
}), oG = Qe({
  lineHeight: "0.75rem",
  fontSize: "0.625rem",
  left: "1.1rem",
  top: ".4rem"
}), NA = Qe({
  lineHeight: "$lineHeights$gameScore",
  justifyContent: "center",
  width: "$score$setWidth",
  position: "relative",
  textAlign: "center",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: "$1",
  display: "flex",
  margin: 0,
  variants: {
    variant: {
      winner: {
        color: "$winner!important",
        fontWeight: 700
      },
      loser: {
        color: "$loser!important"
      }
    }
  }
}), sG = Qe({
  marginInlineEnd: "$space$gameMarginInlineEnd",
  justifyContent: "flex-end",
  alignItems: "center",
  display: "flex"
});
function cG({ value: e } = {}) {
  const t = document.createElement("input");
  return t.onclick = (r) => r.target.select(), t.className = NA(), t.value = e, t;
}
function uG({ gameScoreOnly: e, scoreStripes: t, set: r, sideNumber: i }) {
  const a = i === (r == null ? void 0 : r.winningSide) || r != null && r.winningSide ? "loser" : void 0, o = i === 2 ? r.side2Score : r.side1Score, s = r.side2TiebreakScore || r.side1TiebreakScore, c = i === 2 ? r.side2TiebreakScore : r.side1TiebreakScore, u = o === void 0 && c, d = u || o, p = t && r.setNumber % 2 ? "lightgray" : "transparent", m = r.editing ? r.editing === i : void 0;
  let f;
  if (m)
    f = cG({ value: d });
  else if (f = document.createElement("p"), f.className = NA({ variant: a }), f.classList.add("tmx-st"), f.setAttribute("setNumber", r.setNumber), f.style.backgroundColor = p, f.innerHTML = isNaN(d) ? "" : d, !e) {
    const h = document.createElement("span");
    h.className = oG(), h.innerHTML = s && !u ? c : "", f.appendChild(h);
  }
  return f;
}
function dG({ participantHeight: e, eventHandlers: t, composition: r, sideNumber: i, matchUp: n }) {
  var f, h, g, I;
  const a = (f = r == null ? void 0 : r.configuration) == null ? void 0 : f.winnerChevron, o = (h = r == null ? void 0 : r.configuration) == null ? void 0 : h.gameScoreOnly, s = ((g = n == null ? void 0 : n.score) == null ? void 0 : g.sets) || [], c = (I = r == null ? void 0 : r.configuration) == null ? void 0 : I.scoreBox, u = i === 2 ? e : e - 1, d = MA(u), p = (y) => {
    zi(t == null ? void 0 : t.scoreClick) && (y.stopPropagation(), t.scoreClick({ pointerEvent: y, matchUp: n }));
  }, l = document.createElement("div");
  l.className = d({
    sideNumber: !c && i,
    fontSize: "5px"
  }), l.classList.add("sideScore"), l.classList.add("tmx-scr"), l.onclick = p;
  const m = document.createElement("div");
  m.className = sG();
  for (const y of s || []) {
    const U = uG({
      gameScoreOnly: o,
      scoreStripes: a,
      sideNumber: i,
      set: y
    });
    m.appendChild(U);
  }
  return l.appendChild(m), l;
}
const lG = Qe({
  height: "$lineHeights$scheduleInfo",
  borderBottom: "1px solid darkgray",
  justifyContent: "space-between",
  backgroundColor: "#F8F9F9",
  boxSizing: "border-box",
  paddingRight: "0.2rem",
  paddingLeft: "0.5rem",
  alignItems: "center",
  cursor: "pointer",
  color: "#7F8080",
  display: "flex",
  width: "100%"
});
var AA = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(mE, function() {
    var r = 1e3, i = 6e4, n = 36e5, a = "millisecond", o = "second", s = "minute", c = "hour", u = "day", d = "week", p = "month", l = "quarter", m = "year", f = "date", h = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(C) {
      var A = ["th", "st", "nd", "rd"], N = C % 100;
      return "[" + C + (A[(N - 20) % 10] || A[N] || A[0]) + "]";
    } }, U = function(C, A, N) {
      var O = String(C);
      return !O || O.length >= A ? C : "" + Array(A + 1 - O.length).join(N) + C;
    }, S = { s: U, z: function(C) {
      var A = -C.utcOffset(), N = Math.abs(A), O = Math.floor(N / 60), k = N % 60;
      return (A <= 0 ? "+" : "-") + U(O, 2, "0") + ":" + U(k, 2, "0");
    }, m: function C(A, N) {
      if (A.date() < N.date())
        return -C(N, A);
      var O = 12 * (N.year() - A.year()) + (N.month() - A.month()), k = A.clone().add(O, p), F = N - k < 0, x = A.clone().add(O + (F ? -1 : 1), p);
      return +(-(O + (N - k) / (F ? k - x : x - k)) || 0);
    }, a: function(C) {
      return C < 0 ? Math.ceil(C) || 0 : Math.floor(C);
    }, p: function(C) {
      return { M: p, y: m, w: d, d: u, D: f, h: c, m: s, s: o, ms: a, Q: l }[C] || String(C || "").toLowerCase().replace(/s$/, "");
    }, u: function(C) {
      return C === void 0;
    } }, D = "en", w = {};
    w[D] = y;
    var v = "$isDayjsObject", P = function(C) {
      return C instanceof M || !(!C || !C[v]);
    }, b = function C(A, N, O) {
      var k;
      if (!A)
        return D;
      if (typeof A == "string") {
        var F = A.toLowerCase();
        w[F] && (k = F), N && (w[F] = N, k = F);
        var x = A.split("-");
        if (!k && x.length > 1)
          return C(x[0]);
      } else {
        var _ = A.name;
        w[_] = A, k = _;
      }
      return !O && k && (D = k), k || !O && D;
    }, T = function(C, A) {
      if (P(C))
        return C.clone();
      var N = typeof A == "object" ? A : {};
      return N.date = C, N.args = arguments, new M(N);
    }, R = S;
    R.l = b, R.i = P, R.w = function(C, A) {
      return T(C, { locale: A.$L, utc: A.$u, x: A.$x, $offset: A.$offset });
    };
    var M = function() {
      function C(N) {
        this.$L = b(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[v] = !0;
      }
      var A = C.prototype;
      return A.parse = function(N) {
        this.$d = function(O) {
          var k = O.date, F = O.utc;
          if (k === null)
            return /* @__PURE__ */ new Date(NaN);
          if (R.u(k))
            return /* @__PURE__ */ new Date();
          if (k instanceof Date)
            return new Date(k);
          if (typeof k == "string" && !/Z$/i.test(k)) {
            var x = k.match(g);
            if (x) {
              var _ = x[2] - 1 || 0, B = (x[7] || "0").substring(0, 3);
              return F ? new Date(Date.UTC(x[1], _, x[3] || 1, x[4] || 0, x[5] || 0, x[6] || 0, B)) : new Date(x[1], _, x[3] || 1, x[4] || 0, x[5] || 0, x[6] || 0, B);
            }
          }
          return new Date(k);
        }(N), this.init();
      }, A.init = function() {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, A.$utils = function() {
        return R;
      }, A.isValid = function() {
        return this.$d.toString() !== h;
      }, A.isSame = function(N, O) {
        var k = T(N);
        return this.startOf(O) <= k && k <= this.endOf(O);
      }, A.isAfter = function(N, O) {
        return T(N) < this.startOf(O);
      }, A.isBefore = function(N, O) {
        return this.endOf(O) < T(N);
      }, A.$g = function(N, O, k) {
        return R.u(N) ? this[O] : this.set(k, N);
      }, A.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, A.valueOf = function() {
        return this.$d.getTime();
      }, A.startOf = function(N, O) {
        var k = this, F = !!R.u(O) || O, x = R.p(N), _ = function(z, Y) {
          var X = R.w(k.$u ? Date.UTC(k.$y, Y, z) : new Date(k.$y, Y, z), k);
          return F ? X : X.endOf(u);
        }, B = function(z, Y) {
          return R.w(k.toDate()[z].apply(k.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Y)), k);
        }, L = this.$W, G = this.$M, $ = this.$D, W = "set" + (this.$u ? "UTC" : "");
        switch (x) {
          case m:
            return F ? _(1, 0) : _(31, 11);
          case p:
            return F ? _(1, G) : _(0, G + 1);
          case d:
            var q = this.$locale().weekStart || 0, K = (L < q ? L + 7 : L) - q;
            return _(F ? $ - K : $ + (6 - K), G);
          case u:
          case f:
            return B(W + "Hours", 0);
          case c:
            return B(W + "Minutes", 1);
          case s:
            return B(W + "Seconds", 2);
          case o:
            return B(W + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, A.endOf = function(N) {
        return this.startOf(N, !1);
      }, A.$set = function(N, O) {
        var k, F = R.p(N), x = "set" + (this.$u ? "UTC" : ""), _ = (k = {}, k[u] = x + "Date", k[f] = x + "Date", k[p] = x + "Month", k[m] = x + "FullYear", k[c] = x + "Hours", k[s] = x + "Minutes", k[o] = x + "Seconds", k[a] = x + "Milliseconds", k)[F], B = F === u ? this.$D + (O - this.$W) : O;
        if (F === p || F === m) {
          var L = this.clone().set(f, 1);
          L.$d[_](B), L.init(), this.$d = L.set(f, Math.min(this.$D, L.daysInMonth())).$d;
        } else
          _ && this.$d[_](B);
        return this.init(), this;
      }, A.set = function(N, O) {
        return this.clone().$set(N, O);
      }, A.get = function(N) {
        return this[R.p(N)]();
      }, A.add = function(N, O) {
        var k, F = this;
        N = Number(N);
        var x = R.p(O), _ = function(G) {
          var $ = T(F);
          return R.w($.date($.date() + Math.round(G * N)), F);
        };
        if (x === p)
          return this.set(p, this.$M + N);
        if (x === m)
          return this.set(m, this.$y + N);
        if (x === u)
          return _(1);
        if (x === d)
          return _(7);
        var B = (k = {}, k[s] = i, k[c] = n, k[o] = r, k)[x] || 1, L = this.$d.getTime() + N * B;
        return R.w(L, this);
      }, A.subtract = function(N, O) {
        return this.add(-1 * N, O);
      }, A.format = function(N) {
        var O = this, k = this.$locale();
        if (!this.isValid())
          return k.invalidDate || h;
        var F = N || "YYYY-MM-DDTHH:mm:ssZ", x = R.z(this), _ = this.$H, B = this.$m, L = this.$M, G = k.weekdays, $ = k.months, W = k.meridiem, q = function(Y, X, re, Q) {
          return Y && (Y[X] || Y(O, F)) || re[X].slice(0, Q);
        }, K = function(Y) {
          return R.s(_ % 12 || 12, Y, "0");
        }, z = W || function(Y, X, re) {
          var Q = Y < 12 ? "AM" : "PM";
          return re ? Q.toLowerCase() : Q;
        };
        return F.replace(I, function(Y, X) {
          return X || function(re) {
            switch (re) {
              case "YY":
                return String(O.$y).slice(-2);
              case "YYYY":
                return R.s(O.$y, 4, "0");
              case "M":
                return L + 1;
              case "MM":
                return R.s(L + 1, 2, "0");
              case "MMM":
                return q(k.monthsShort, L, $, 3);
              case "MMMM":
                return q($, L);
              case "D":
                return O.$D;
              case "DD":
                return R.s(O.$D, 2, "0");
              case "d":
                return String(O.$W);
              case "dd":
                return q(k.weekdaysMin, O.$W, G, 2);
              case "ddd":
                return q(k.weekdaysShort, O.$W, G, 3);
              case "dddd":
                return G[O.$W];
              case "H":
                return String(_);
              case "HH":
                return R.s(_, 2, "0");
              case "h":
                return K(1);
              case "hh":
                return K(2);
              case "a":
                return z(_, B, !0);
              case "A":
                return z(_, B, !1);
              case "m":
                return String(B);
              case "mm":
                return R.s(B, 2, "0");
              case "s":
                return String(O.$s);
              case "ss":
                return R.s(O.$s, 2, "0");
              case "SSS":
                return R.s(O.$ms, 3, "0");
              case "Z":
                return x;
            }
            return null;
          }(Y) || x.replace(":", "");
        });
      }, A.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, A.diff = function(N, O, k) {
        var F, x = this, _ = R.p(O), B = T(N), L = (B.utcOffset() - this.utcOffset()) * i, G = this - B, $ = function() {
          return R.m(x, B);
        };
        switch (_) {
          case m:
            F = $() / 12;
            break;
          case p:
            F = $();
            break;
          case l:
            F = $() / 3;
            break;
          case d:
            F = (G - L) / 6048e5;
            break;
          case u:
            F = (G - L) / 864e5;
            break;
          case c:
            F = G / n;
            break;
          case s:
            F = G / i;
            break;
          case o:
            F = G / r;
            break;
          default:
            F = G;
        }
        return k ? F : R.a(F);
      }, A.daysInMonth = function() {
        return this.endOf(p).$D;
      }, A.$locale = function() {
        return w[this.$L];
      }, A.locale = function(N, O) {
        if (!N)
          return this.$L;
        var k = this.clone(), F = b(N, O, !0);
        return F && (k.$L = F), k;
      }, A.clone = function() {
        return R.w(this.$d, this);
      }, A.toDate = function() {
        return new Date(this.valueOf());
      }, A.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, A.toISOString = function() {
        return this.$d.toISOString();
      }, A.toString = function() {
        return this.$d.toUTCString();
      }, C;
    }(), E = M.prototype;
    return T.prototype = E, [["$ms", a], ["$s", o], ["$m", s], ["$H", c], ["$W", u], ["$M", p], ["$y", m], ["$D", f]].forEach(function(C) {
      E[C[1]] = function(A) {
        return this.$g(A, C[0], C[1]);
      };
    }), T.extend = function(C, A) {
      return C.$i || (C(A, M, T), C.$i = !0), T;
    }, T.locale = b, T.isDayjs = P, T.unix = function(C) {
      return T(1e3 * C);
    }, T.en = w[D], T.Ls = w, T.p = {}, T;
  });
})(AA);
var pG = AA.exports;
const mG = /* @__PURE__ */ hv(pG);
function fG({ matchUp: e, eventHandlers: t }) {
  const { scheduledTime: r, scheduledDate: i, venueAbbreviation: n, courtName: a } = (e == null ? void 0 : e.schedule) || {}, {
    dateTime: { extractDate: o, extractTime: s }
  } = Oy, c = s(r);
  let d = o(i), p = "ddd D MMMM";
  c && (p += ", hh:mm A", d += `T${c}`);
  const l = i ? mG(d).format(p) : "Not scheduled", m = n && (a == null ? void 0 : a.toString().startsWith(n)) && a || // ensure no duplication of venuAbbreviation
  n && a && `${n} ${a}` || a || n || "", f = document.createElement("div");
  f.className = lG(), f.classList.add("tmx-sch"), zi(t == null ? void 0 : t.scheduleClick) && (f.onclick = (U) => t.scheduleClick({ matchUp: e, pointerEvent: U }));
  const h = document.createElement("div");
  h.innerHTML = l, f.append(h);
  const g = (U) => {
    zi(t == null ? void 0 : t.venueClick) && (U.stopPropagation(), t.venueClick({
      pointerEvent: U,
      matchUp: e
    }));
  }, I = document.createElement("div");
  I.style = "display: flex; flex-direction: row";
  const y = document.createElement("div");
  if (y.style.paddingRight = ".2rem", y.onclick = g, y.innerHTML = m, I.append(y), f.append(I), f.onclick) {
    const U = document.createElement("div");
    U.innerHTML = "⋮", I.append(U);
  }
  return f;
}
function uv({ initialRoundNumber: e = 1, eventHandlers: t, composition: r, sideNumber: i, className: n, matchUp: a }) {
  var f, h;
  const o = (r == null ? void 0 : r.configuration) || {}, s = o == null ? void 0 : o.scheduleInfo, c = (f = a == null ? void 0 : a.score) == null ? void 0 : f.scoreStringSide1, u = ((h = r == null ? void 0 : r.configuration) == null ? void 0 : h.scoreBox) && c, d = (a == null ? void 0 : a.readyToScore) && (t == null ? void 0 : t.scoreClick) && !TA.checkScoreHasValue({ matchUp: a }), p = document.createElement("div");
  if (p.className = io(jj(), n), p.classList.add("tmx-sd"), p.setAttribute("sideNumber", i), s && i === 1) {
    const g = fG({ matchUp: a, eventHandlers: t });
    p.appendChild(g);
  }
  const l = document.createElement("div");
  l.className = Gj();
  const m = Wj({
    sideContainer: !0,
    initialRoundNumber: e,
    eventHandlers: t,
    composition: r,
    sideNumber: i,
    matchUp: a
  });
  if (l.appendChild(m), u) {
    const g = document.createElement("div");
    g.style.border = "1px solid lightgray", l.appendChild(g);
  }
  if (c) {
    const g = dG({
      eventHandlers: t,
      composition: r,
      sideNumber: i,
      matchUp: a
    });
    l.appendChild(g);
  }
  if (d) {
    const g = MA(), I = (U) => {
      zi(t == null ? void 0 : t.scoreClick) && (event.stopPropagation(), t.scoreClick({ pointerEvent: U, matchUp: a }));
    }, y = document.createElement("div");
    y.className = g({
      sideNumber: !u && i,
      fontSize: "small"
    }), y.onclick = I, y.innerHTML = "[Score]", l.appendChild(y);
  }
  return p.appendChild(l), p;
}
function hG(e) {
  const { composition: t, initialRoundNumber: r = 1, matchUp: i, moiety: n, selectedMatchUpId: a, searchActive: o } = e, { roundFactor: s, roundNumber: c, finishingRound: u, matchUpType: d, preFeedRound: p, stage: l } = i, m = e.isFinalRound || parseInt(u) === 1, f = l === "QUALIFYING" && m, h = m, g = parseInt(c) === r, I = d === "DOUBLES", y = (o || i.isRoundRobin || i.collectionId || e.isLucky || e.isAdHoc) && "mr" || h && "noProgression" || (f || p) && "m0" || n && "m1" || "m2", U = aG({ composition: t, isDoubles: I, roundFactor: s })({
    isFirstRound: g,
    link: y
  }), S = (t == null ? void 0 : t.configuration) || {}, { resultsInfo: D, centerInfo: w } = S || {}, v = e.eventHandlers || {}, P = (C) => {
    zi(v == null ? void 0 : v.matchUpClick) && v.matchUpClick({ pointerEvent: C, matchUp: i });
  }, b = document.createElement("div");
  b.className = io(t.theme, e == null ? void 0 : e.className, "matchup", Zj()), b.classList.add("tmx-m"), b.setAttribute("id", i == null ? void 0 : i.matchUpId), b.onclick = P;
  const T = document.createElement("div");
  T.className = eG({ configuration: S });
  const R = ({ sideNumber: C }) => {
    var O, k, F;
    const A = (F = (k = (O = i == null ? void 0 : i.sides.find((x) => x.sideNumber === C)) == null ? void 0 : O.participant) == null ? void 0 : k.entryStatus) == null ? void 0 : F.replace("_", " ");
    return nG({
      eventHandlers: v,
      entryStatus: A,
      sideNumber: C,
      className: C === 2 && U,
      matchUp: i
    });
  }, M = uv({
    initialRoundNumber: r,
    eventHandlers: v,
    sideNumber: 1,
    composition: t,
    matchUp: i
  }), E = uv({
    className: !w && U,
    initialRoundNumber: r,
    eventHandlers: v,
    sideNumber: 2,
    composition: t,
    matchUp: i
  });
  if (T.appendChild(M), w) {
    const C = R({ sideNumber: 1 }), A = R({ sideNumber: 2 });
    T.appendChild(C.element), T.appendChild(A.element);
  }
  if (T.appendChild(E), D) {
    const C = gG({ score: i.score });
    T.appendChild(C);
  }
  if (b.appendChild(T), a === i.matchUpId) {
    const C = document.createElement("div");
    C.className = Xj(), b.appendChild(C);
  }
  return b;
}
function gG({ score: e }) {
  var a;
  const t = (a = e == null ? void 0 : e.sets) == null ? void 0 : a.filter(Boolean).sort((o, s) => (o.setNumber || 0) - (s.setNumber || 0)), r = t == null ? void 0 : t[t.length - 1], i = (r == null ? void 0 : r.side1PointsScore) || (r == null ? void 0 : r.side2PointsScore), n = document.createElement("div");
  if (n.className = Jj(), i) {
    const o = document.createElement("div");
    o.className = sv({ variant: "points" }), o.innerHTML = "PTS", n.appendChild(o);
  }
  for (const o of t || []) {
    const s = document.createElement("div");
    s.setAttribute("key", o.setNumber), s.className = sv({ variant: "set" }), s.innerHTML = o.setNumber, n.appendChild(s);
  }
  return n;
}
function IG({
  initialRoundNumber: e = 1,
  selectedMatchUpId: t,
  eventHandlers: r,
  isFinalRound: i,
  isRoundRobin: n,
  searchActive: a,
  composition: o,
  roundFactor: s,
  roundNumber: c,
  roundProfile: u,
  minWidth: d,
  matchUps: p,
  context: l,
  isLucky: m
}) {
  const f = p.filter((T) => T.roundNumber === c).sort((T, R) => (T.roundPosition || 0) - (R.roundPosition || 0)), h = f.every(({ roundPosition: T, drawPositions: R }) => !T && !R), g = (o == null ? void 0 : o.configuration) || {}, I = document.createElement("div");
  if (I.className = bA(), I.classList.add("tmx-rd"), I.setAttribute("roundNumber", c), g.roundHeader) {
    const T = zj({ roundProfile: u, roundMatchUps: f, roundNumber: c, eventHandlers: r, context: l });
    I.appendChild(T);
  }
  const y = document.createElement("div");
  y.className = RA({ variant: h ? "adHoc" : void 0 }), d && (y.style.minWidth = d);
  let U, S, D;
  if (n) {
    const T = (M) => M.reduce((E, C) => C + E, 0);
    f.sort((M, E) => {
      const C = T(M.drawPositions) - T(E.drawPositions), A = Math.min(...M.drawPositions ?? []) - Math.min(...E.drawPositions ?? []);
      return C || A;
    });
    const R = f.reduce((M, E) => (M[E.structureId] = E.structureName, M), {});
    U = Object.values(R), S = Object.keys(R), D = Object.keys(Oy.instanceCount(f.map(({ structureId: M }) => M))).length;
  } else
    h && f.sort((T, R) => (T.roundOrder ?? 0) - (R.roundOrder ?? 0));
  const w = D && f.length / D, v = Object.keys(u).map((T) => parseInt(T)), P = v.indexOf(c), b = P === 0 && "first" || P === v.length - 1 && "last";
  return f.forEach((T, R) => {
    const M = w && !(R % w), E = w && Math.floor(R / w), C = w && U[E];
    if (M) {
      const O = document.createElement("div");
      O.className = Kj({ variant: E, roundOrder: b }), y.appendChild(O);
      const k = document.createElement("div");
      if (k.className = Qj(), zi(r == null ? void 0 : r.groupHeaderClick)) {
        const { drawId: F, containerStructureId: x } = f[0];
        y.onclick = (_) => r.groupHeaderClick({
          structureId: S[E],
          containerStructureId: x,
          pointerEvent: _,
          drawId: F
        });
      }
      c === e && (k.innerHTML = C), y.appendChild(k);
    }
    const A = R % 2 === 0;
    s ? T.roundFactor = s : e > 1 && (T.roundFactor = Math.pow(2, c - e));
    const N = hG({
      initialRoundNumber: e,
      selectedMatchUpId: t,
      eventHandlers: r,
      isFinalRound: i,
      searchActive: a,
      composition: o,
      isAdHoc: h,
      isLucky: m,
      matchUp: T,
      moiety: A
    });
    y.appendChild(N);
  }), I.appendChild(y), I;
}
function PG({
  initialRoundNumber: e = 1,
  selectedMatchUpId: t,
  eventHandlers: r,
  searchActive: i,
  composition: n,
  structureId: a,
  finalColumn: o,
  matchUps: s,
  minWidth: c,
  context: u
}) {
  var y;
  const { roundNumbers: d, roundProfile: p, hasOddMatchUpsCount: l, isNotEliminationStructure: m } = TA.getRoundMatchUps({ matchUps: s });
  a = a || (u == null ? void 0 : u.structureId) || ((y = s == null ? void 0 : s[0]) == null ? void 0 : y.structureId);
  const f = s.some(({ isRoundRobin: U }) => U), h = l || m, g = document.createElement("div");
  g.className = Yj(), g.classList.add("tmx-str"), g.setAttribute("id", a);
  const I = Math.max(...d);
  for (const U of d) {
    if (U < e)
      continue;
    const D = IG({
      initialRoundNumber: e,
      selectedMatchUpId: t,
      eventHandlers: r,
      isFinalRound: U === I,
      isRoundRobin: f,
      searchActive: i,
      composition: n,
      roundNumber: U,
      roundProfile: p,
      matchUps: s,
      minWidth: c,
      context: u,
      isLucky: h
    });
    g.appendChild(D);
  }
  if (o) {
    const U = document.createElement("div");
    U.className = bA();
    const S = document.createElement("div");
    S.className = RA(), S.appendChild(o), U.appendChild(S), g.appendChild(U);
  }
  return g;
}
const dv = Qe({
  backgroundColor: "$colors$backgroundColor",
  color: "$colors$color",
  overflowX: "auto",
  height: 1e3
});
function DG({ content: e, theme: t }) {
  const r = document.createElement("div");
  return r.className = t ? io(dv(), t) : dv(), t && r.classList.add(t), typeof e == "string" ? r.innerHTML = e : r.appendChild(e), r;
}
const { createTheme: Us } = fv({
  theme: {
    lineHeights: {
      scheduleInfo: `${Hc.scheduleInfo}rem`,
      centerInfo: `${Hc.centerInfo}rem`,
      gameScore: `${Hc.gameScore}rem`
    },
    borderWidths: {
      matchUpInline: "1px 1px",
      matchUp: "1px"
    },
    space: {
      1: "10px",
      2: "0.375rem",
      // start/end spacing for individual
      gameMarginInlineEnd: "0.25rem"
    },
    fontSizes: {
      1: "0.875rem"
    },
    colors: {
      internalDividers: "lightgray",
      backgroundColor: "white",
      connector: "lightgray",
      border: "darkgray",
      color: "black"
    },
    participant: {
      textTransform: "capitalize",
      minHeight: "2rem",
      seed: "gray"
    },
    score: {
      setWidth: "1.3rem"
    }
  }
}), lv = Us("australian-theme", {
  colors: {
    borderHover: "#0091d2",
    connector: "#999"
  }
}), UG = Us("wimbledon-theme", {
  borderWidths: {
    borderInlineStart: "10px"
  },
  colors: {
    connector: "transparent",
    borderHover: "darkgrey",
    border: "#00703c",
    matchUp: "#fff"
  },
  participant: {
    textTransform: "uppercase"
  }
}), yG = Us("french-theme", {
  colors: {
    winnerName: "#01503d!important",
    winner: "#01503d!important",
    borderHover: "#0091d2",
    border: "#F8F9F9"
  },
  matchUp: {
    boxShadow: "0 0 30px 0 hsla(0,0%,89%,9)"
  }
}), SG = Us("usopen-theme", {
  colors: {
    matchUpBackgroundColor: "#F8F9F9",
    internalDividers: "darkgray",
    borderHover: "#0091d2",
    connector: "#999"
  }
}), pv = Us("basic-theme", {
  colors: {
    internalDividers: "transparent",
    winner: "#50B649!important",
    loser: "#E61A1A!important",
    connector: "#999"
  },
  space: {
    gameMarginInlineEnd: "0.75rem"
  },
  participant: {
    seed: "transparent"
  },
  fontSizes: {
    1: "1.5rem"
  }
}), vG = Us("dark-theme", {
  colors: {
    backgroundColor: "#333333",
    borderHover: "#0091d2",
    color: "white"
  },
  participant: {
    seed: "cyan"
  }
}), wG = Us("itf-theme", {
  colors: {
    borderHover: "#0091d2",
    connector: "#999",
    matchUp: "#fff"
  },
  participant: {
    textTransform: "uppercase",
    seed: "gray"
  }
}), TG = {
  Australian: {
    configuration: { flags: !0 },
    theme: lv
  },
  Basic: {
    configuration: { gameScoreOnly: !0, teamLogo: !1, roundHeader: !0, placeHolders: { tbd: "-", bye: "Bye" } },
    theme: pv
  },
  DrawPositions: {
    configuration: {
      gameScoreOnly: !0,
      drawPositions: !0,
      teamLogo: !1
    },
    theme: pv
  },
  French: {
    configuration: { bracketedSeeds: !0, flags: !0 },
    theme: yG
  },
  Wimbledon: {
    configuration: { resultsInfo: !0, flags: !0 },
    theme: UG
  },
  "US Open": {
    configuration: { scoreBox: !0, flags: !0 },
    theme: SG
  },
  ITF: {
    configuration: { winnerChevron: !0, centerInfo: !0, flags: !0, roundHeader: !0 },
    theme: wG
  },
  National: {
    configuration: {
      bracketedSeeds: "square",
      allDrawPositions: !0,
      drawPositions: !0,
      scheduleInfo: !0,
      roundHeader: !0,
      showAddress: !0,
      scaleAttributes: {
        scaleColor: "red",
        scaleType: "RATING",
        scaleName: "WTN",
        accessor: "wtnRating"
      }
    },
    theme: lv
  },
  Night: {
    configuration: { flags: !0 },
    theme: vG
  }
};
export {
  Yy as cModal,
  TG as compositions,
  DG as renderContainer,
  hG as renderMatchUp,
  Wj as renderParticipant,
  IG as renderRound,
  zj as renderRoundHeader,
  PG as renderStructure
};
